const signs = [
  [-2208869470,-2208693979,'Capricorn'],
  [-2208693979,-2208516683,'Aquarius'],
  [-2208516683,-2208332776,'Pisces'],
  [-2208332776,-2208139997,'Aries'],
  [-2208139997,-2207938593,'Taurus'],
  [-2207938593,-2207729918,'Gemini'],
  [-2207729918,-2207515354,'Cancer'],
  [-2207515354,-2207297190,'Leo'],
  [-2207297190,-2207080457,'Virgo'],
  [-2207080457,-2206872359,'Libra'],
  [-2206872359,-2206678066,'Scorpio'],
  [-2206678066,-2206497375,'Sagittarius'],
  [-2206497375,-2206325139,'Capricorn'],
  [-2206325139,-2206153867,'Aquarius'],
  [-2206153867,-2205976187,'Pisces'],
  [-2205976187,-2205787037,'Aries'],
  [-2205787037,-2205585589,'Taurus'],
  [-2205585589,-2205374896,'Gemini'],
  [-2205374896,-2205159028,'Cancer'],
  [-2205159028,-2204940979,'Leo'],
  [-2204940979,-2204723653,'Virgo'],
  [-2204723653,-2204511932,'Libra'],
  [-2204511932,-2204311644,'Scorpio'],
  [-2204311644,-2204125675,'Sagittarius'],
  [-2204125675,-2203951522,'Capricorn'],
  [-2203951522,-2203782479,'Aquarius'],
  [-2203782479,-2203610338,'Pisces'],
  [-2203610338,-2203427748,'Aries'],
  [-2203427748,-2203230848,'Taurus'],
  [-2203230848,-2203021249,'Gemini'],
  [-2203021249,-2202804552,'Cancer'],
  [-2202804552,-2202586269,'Leo'],
  [-2202586269,-2202369701,'Virgo'],
  [-2202369701,-2202157540,'Libra'],
  [-2202157540,-2201953602,'Scorpio'],
  [-2201953602,-2201761490,'Sagittarius'],
  [-2201761490,-2201581540,'Capricorn'],
  [-2201581540,-2201409578,'Aquarius'],
  [-2201409578,-2201238485,'Pisces'],
  [-2201238485,-2201060504,'Aries'],
  [-2201060504,-2200869626,'Taurus'],
  [-2200869626,-2200664361,'Gemini'],
  [-2200664361,-2200448920,'Cancer'],
  [-2200448920,-2200230493,'Leo'],
  [-2200230493,-2200014702,'Virgo'],
  [-2200014702,-2199804269,'Libra'],
  [-2199804269,-2199600772,'Scorpio'],
  [-2199600772,-2199405885,'Sagittarius'],
  [-2199405885,-2199220439,'Capricorn'],
  [-2199220439,-2199042702,'Aquarius'],
  [-2199042702,-2198868049,'Pisces'],
  [-2198868049,-2198690144,'Aries'],
  [-2198690144,-2198502789,'Taurus'],
  [-2198502789,-2198302306,'Gemini'],
  [-2198302306,-2198089935,'Cancer'],
  [-2198089935,-2197872022,'Leo'],
  [-2197872022,-2197656269,'Virgo'],
  [-2197656269,-2197447447,'Libra'],
  [-2197447447,-2197246771,'Scorpio'],
  [-2197246771,-2197053593,'Sagittarius'],
  [-2197053593,-2196866776,'Capricorn'],
  [-2196866776,-2196684721,'Aquarius'],
  [-2196684721,-2196504811,'Pisces'],
  [-2196504811,-2196323202,'Aries'],
  [-2196323202,-2196135324,'Taurus'],
  [-2196135324,-2195937258,'Gemini'],
  [-2195937258,-2195727927,'Cancer'],
  [-2195727927,-2195511104,'Leo'],
  [-2195511104,-2195294598,'Virgo'],
  [-2195294598,-2195085656,'Libra'],
  [-2195085656,-2194887182,'Scorpio'],
  [-2194887182,-2194697807,'Sagittarius'],
  [-2194697807,-2194514047,'Capricorn'],
  [-2194514047,-2194332244,'Aquarius'],
  [-2194332244,-2194149471,'Pisces'],
  [-2194149471,-2193963496,'Aries'],
  [-2193963496,-2193772228,'Taurus'],
  [-2193772228,-2193573388,'Gemini'],
  [-2193573388,-2193365401,'Cancer'],
  [-2193365401,-2193149610,'Leo'],
  [-2193149610,-2192931955,'Virgo'],
  [-2192931955,-2192720855,'Libra'],
  [-2192720855,-2192521894,'Scorpio'],
  [-2192521894,-2192334991,'Sagittarius'],
  [-2192334991,-2192155741,'Capricorn'],
  [-2192155741,-2191978233,'Aquarius'],
  [-2191978233,-2191797331,'Pisces'],
  [-2191797331,-2191610023,'Aries'],
  [-2191610023,-2191415509,'Taurus'],
  [-2191415509,-2191213933,'Gemini'],
  [-2191213933,-2191005198,'Cancer'],
  [-2191005198,-2190789779,'Leo'],
  [-2190789779,-2190571181,'Virgo'],
  [-2190571181,-2190356854,'Libra'],
  [-2190356854,-2190154421,'Scorpio'],
  [-2190154421,-2189966473,'Sagittarius'],
  [-2189966473,-2189789586,'Capricorn'],
  [-2189789586,-2189616961,'Aquarius'],
  [-2189616961,-2189441362,'Pisces'],
  [-2189441362,-2189257355,'Aries'],
  [-2189257355,-2189062929,'Taurus'],
  [-2189062929,-2188859289,'Gemini'],
  [-2188859289,-2188648683,'Cancer'],
  [-2188648683,-2188432803,'Leo'],
  [-2188432803,-2188213867,'Virgo'],
  [-2188213867,-2187997018,'Libra'],
  [-2187997018,-2187789739,'Scorpio'],
  [-2187789739,-2187597168,'Sagittarius'],
  [-2187597168,-2187418455,'Capricorn'],
  [-2187418455,-2187247707,'Aquarius'],
  [-2187247707,-2187077026,'Pisces'],
  [-2187077026,-2186898999,'Aries'],
  [-2186898999,-2186708924,'Taurus'],
  [-2186708924,-2186506461,'Gemini'],
  [-2186506461,-2186294827,'Cancer'],
  [-2186294827,-2186078055,'Leo'],
  [-2186078055,-2185859258,'Virgo'],
  [-2185859258,-2185641887,'Libra'],
  [-2185641887,-2185431260,'Scorpio'],
  [-2185431260,-2185232870,'Sagittarius'],
  [-2185232870,-2185048577,'Capricorn'],
  [-2185048577,-2184875033,'Aquarius'],
  [-2184875033,-2184705444,'Pisces'],
  [-2184705444,-2184532038,'Aries'],
  [-2184532038,-2184348149,'Taurus'],
  [-2184348149,-2184150471,'Gemini'],
  [-2184150471,-2183940495,'Cancer'],
  [-2183940495,-2183723390,'Leo'],
  [-2183723390,-2183504721,'Virgo'],
  [-2183504721,-2183288465,'Libra'],
  [-2183288465,-2183077882,'Scorpio'],
  [-2183077882,-2182876299,'Sagittarius'],
  [-2182876299,-2182685994,'Capricorn'],
  [-2182685994,-2182506230,'Aquarius'],
  [-2182506230,-2182332869,'Pisces'],
  [-2182332869,-2182159625,'Aries'],
  [-2182159625,-2181979725,'Taurus'],
  [-2181979725,-2181787794,'Gemini'],
  [-2181787794,-2181582153,'Cancer'],
  [-2181582153,-2181366350,'Leo'],
  [-2181366350,-2181147589,'Virgo'],
  [-2181147589,-2180932400,'Libra'],
  [-2180932400,-2180724201,'Scorpio'],
  [-2180724201,-2180523953,'Sagittarius'],
  [-2180523953,-2180331623,'Capricorn'],
  [-2180331623,-2180146553,'Aquarius'],
  [-2180146553,-2179966897,'Pisces'],
  [-2179966897,-2179789201,'Aries'],
  [-2179789201,-2179608579,'Taurus'],
  [-2179608579,-2179419680,'Gemini'],
  [-2179419680,-2179218607,'Cancer'],
  [-2179218607,-2179005689,'Leo'],
  [-2179005689,-2178787039,'Virgo'],
  [-2178787039,-2178571497,'Libra'],
  [-2178571497,-2178365009,'Scorpio'],
  [-2178365009,-2178168382,'Sagittarius'],
  [-2178168382,-2177979093,'Capricorn'],
  [-2177979093,-2177793966,'Aquarius'],
  [-2177793966,-2177610598,'Pisces'],
  [-2177610598,-2177427317,'Aries'],
  [-2177427317,-2177242127,'Taurus'],
  [-2177242127,-2177051844,'Gemini'],
  [-2177051844,-2176852651,'Cancer'],
  [-2176852651,-2176642528,'Leo'],
  [-2176642528,-2176424568,'Virgo'],
  [-2176424568,-2176207396,'Libra'],
  [-2176207396,-2175999829,'Scorpio'],
  [-2175999829,-2175805030,'Sagittarius'],
  [-2175805030,-2175620165,'Capricorn'],
  [-2175620165,-2175439713,'Aquarius'],
  [-2175439713,-2175258575,'Pisces'],
  [-2175258575,-2175073777,'Aries'],
  [-2175073777,-2174884435,'Taurus'],
  [-2174884435,-2174690102,'Gemini'],
  [-2174690102,-2174489259,'Cancer'],
  [-2174489259,-2174279963,'Leo'],
  [-2174279963,-2174062857,'Virgo'],
  [-2174062857,-2173844023,'Libra'],
  [-2173844023,-2173632998,'Scorpio'],
  [-2173632998,-2173436092,'Sagittarius'],
  [-2173436092,-2173252581,'Capricorn'],
  [-2173252581,-2173076702,'Aquarius'],
  [-2173076702,-2172901360,'Pisces'],
  [-2172901360,-2172720793,'Aries'],
  [-2172720793,-2172532161,'Taurus'],
  [-2172532161,-2172335438,'Gemini'],
  [-2172335438,-2172131548,'Cancer'],
  [-2172131548,-2171920849,'Leo'],
  [-2171920849,-2171703927,'Virgo'],
  [-2171703927,-2171484371,'Libra'],
  [-2171484371,-2171269811,'Scorpio'],
  [-2171269811,-2171067973,'Sagittarius'],
  [-2171067973,-2170881265,'Capricorn'],
  [-2170881265,-2170705857,'Aquarius'],
  [-2170705857,-2170534662,'Pisces'],
  [-2170534662,-2170360305,'Aries'],
  [-2170360305,-2170177165,'Taurus'],
  [-2170177165,-2169982815,'Gemini'],
  [-2169982815,-2169778080,'Cancer'],
  [-2169778080,-2169565538,'Leo'],
  [-2169565538,-2169347928,'Virgo'],
  [-2169347928,-2169128484,'Libra'],
  [-2169128484,-2168912372,'Scorpio'],
  [-2168912372,-2168705987,'Sagittarius'],
  [-2168705987,-2168513476,'Capricorn'],
  [-2168513476,-2168333959,'Aquarius'],
  [-2168333959,-2168162260,'Pisces'],
  [-2168162260,-2167991309,'Aries'],
  [-2167991309,-2167814155,'Taurus'],
  [-2167814155,-2167625637,'Gemini'],
  [-2167625637,-2167423994,'Cancer'],
  [-2167423994,-2167211538,'Leo'],
  [-2167211538,-2166993206,'Virgo'],
  [-2166993206,-2166774076,'Libra'],
  [-2166774076,-2166558554,'Scorpio'],
  [-2166558554,-2166350612,'Sagittarius'],
  [-2166350612,-2166153439,'Capricorn'],
  [-2166153439,-2165967883,'Aquarius'],
  [-2165967883,-2165791519,'Pisces'],
  [-2165791519,-2165619265,'Aries'],
  [-2165619265,-2165444691,'Taurus'],
  [-2165444691,-2165261447,'Gemini'],
  [-2165261447,-2165065094,'Cancer'],
  [-2165065094,-2164855419,'Leo'],
  [-2164855419,-2164637400,'Virgo'],
  [-2164637400,-2164418424,'Libra'],
  [-2164418424,-2164204307,'Scorpio'],
  [-2164204307,-2163997823,'Sagittarius'],
  [-2163997823,-2163799779,'Capricorn'],
  [-2163799779,-2163610185,'Aquarius'],
  [-2163610185,-2163428103,'Pisces'],
  [-2163428103,-2163251037,'Aries'],
  [-2163251037,-2163074630,'Taurus'],
  [-2163074630,-2162893160,'Gemini'],
  [-2162893160,-2162701021,'Cancer'],
  [-2162701021,-2162495343,'Leo'],
  [-2162495343,-2162278941,'Virgo'],
  [-2162278941,-2162059941,'Libra'],
  [-2162059941,-2161846559,'Scorpio'],
  [-2161846559,-2161642480,'Sagittarius'],
  [-2161642480,-2161446970,'Capricorn'],
  [-2161446970,-2161257696,'Aquarius'],
  [-2161257696,-2161072733,'Pisces'],
  [-2161072733,-2160890720,'Aries'],
  [-2160890720,-2160709717,'Taurus'],
  [-2160709717,-2160526127,'Gemini'],
  [-2160526127,-2160335020,'Cancer'],
  [-2160335020,-2160132258,'Leo'],
  [-2160132258,-2159917994,'Virgo'],
  [-2159917994,-2159698907,'Libra'],
  [-2159698907,-2159484792,'Scorpio'],
  [-2159484792,-2159281711,'Sagittarius'],
  [-2159281711,-2159089380,'Capricorn'],
  [-2159089380,-2158903784,'Aquarius'],
  [-2158903784,-2158720637,'Pisces'],
  [-2158720637,-2158537253,'Aries'],
  [-2158537253,-2158352404,'Taurus'],
  [-2158352404,-2158164723,'Gemini'],
  [-2158164723,-2157971455,'Cancer'],
  [-2157971455,-2157769115,'Leo'],
  [-2157769115,-2157556320,'Virgo'],
  [-2157556320,-2157337200,'Libra'],
  [-2157337200,-2157121068,'Scorpio'],
  [-2157121068,-2156916307,'Sagittarius'],
  [-2156916307,-2156724870,'Capricorn'],
  [-2156724870,-2156542932,'Aquarius'],
  [-2156542932,-2156364553,'Pisces'],
  [-2156364553,-2156184582,'Aries'],
  [-2156184582,-2156000039,'Taurus'],
  [-2156000039,-2155809814,'Gemini'],
  [-2155809814,-2155613201,'Cancer'],
  [-2155613201,-2155408956,'Leo'],
  [-2155408956,-2155196190,'Virgo'],
  [-2155196190,-2154977114,'Libra'],
  [-2154977114,-2154758793,'Scorpio'],
  [-2154758793,-2154550128,'Sagittarius'],
  [-2154550128,-2154355890,'Capricorn'],
  [-2154355890,-2154174363,'Aquarius'],
  [-2154174363,-2153999783,'Pisces'],
  [-2153999783,-2153825459,'Aries'],
  [-2153825459,-2153645804,'Taurus'],
  [-2153645804,-2153457510,'Gemini'],
  [-2153457510,-2153259679,'Cancer'],
  [-2153259679,-2153053026,'Leo'],
  [-2153053026,-2152838965,'Virgo'],
  [-2152838965,-2152619855,'Libra'],
  [-2152619855,-2152400478,'Scorpio'],
  [-2152400478,-2152187889,'Sagittarius'],
  [-2152187889,-2151988156,'Capricorn'],
  [-2151988156,-2151802618,'Aquarius'],
  [-2151802618,-2151627639,'Pisces'],
  [-2151627639,-2151456859,'Aries'],
  [-2151456859,-2151283307,'Taurus'],
  [-2151283307,-2151100973,'Gemini'],
  [-2151100973,-2150906344,'Cancer'],
  [-2150906344,-2150699587,'Leo'],
  [-2150699587,-2150484152,'Virgo'],
  [-2150484152,-2150264691,'Libra'],
  [-2150264691,-2150045683,'Scorpio'],
  [-2150045683,-2149831628,'Sagittarius'],
  [-2149831628,-2149627081,'Capricorn'],
  [-2149627081,-2149435013,'Aquarius'],
  [-2149435013,-2149254919,'Pisces'],
  [-2149254919,-2149082725,'Aries'],
  [-2149082725,-2148912025,'Taurus'],
  [-2148912025,-2148735627,'Gemini'],
  [-2148735627,-2148547303,'Cancer'],
  [-2148547303,-2148344289,'Leo'],
  [-2148344289,-2148129371,'Virgo'],
  [-2148129371,-2147909472,'Libra'],
  [-2147909472,-2147691244,'Scorpio'],
  [-2147691244,-2147478468,'Sagittarius'],
  [-2147478468,-2147272989,'Capricorn'],
  [-2147272989,-2147076347,'Aquarius'],
  [-2147076347,-2146889512,'Pisces'],
  [-2146889512,-2146711477,'Aries'],
  [-2146711477,-2146538322,'Taurus'],
  [-2146538322,-2146363714,'Gemini'],
  [-2146363714,-2146180498,'Cancer'],
  [-2146180498,-2145983200,'Leo'],
  [-2145983200,-2145771540,'Virgo'],
  [-2145771540,-2145552048,'Libra'],
  [-2145552048,-2145333956,'Scorpio'],
  [-2145333956,-2145123012,'Sagittarius'],
  [-2145123012,-2144920059,'Capricorn'],
  [-2144920059,-2144723906,'Aquarius'],
  [-2144723906,-2144533856,'Pisces'],
  [-2144533856,-2144349841,'Aries'],
  [-2144349841,-2144170737,'Taurus'],
  [-2144170737,-2143992851,'Gemini'],
  [-2143992851,-2143810252,'Cancer'],
  [-2143810252,-2143616758,'Leo'],
  [-2143616758,-2143409323,'Virgo'],
  [-2143409323,-2143191584,'Libra'],
  [-2143191584,-2142973029,'Scorpio'],
  [-2142973029,-2142762259,'Sagittarius'],
  [-2142762259,-2142561828,'Capricorn'],
  [-2142561828,-2142369460,'Aquarius'],
  [-2142369460,-2142181780,'Pisces'],
  [-2142181780,-2141996655,'Aries'],
  [-2141996655,-2141813169,'Taurus'],
  [-2141813169,-2141629935,'Gemini'],
  [-2141629935,-2141443730,'Cancer'],
  [-2141443730,-2141249929,'Leo'],
  [-2141249929,-2141044834,'Virgo'],
  [-2141044834,-2140829239,'Libra'],
  [-2140829239,-2140610294,'Scorpio'],
  [-2140610294,-2140397704,'Sagittarius'],
  [-2140397704,-2140196993,'Capricorn'],
  [-2140196993,-2140007348,'Aquarius'],
  [-2140007348,-2139824388,'Pisces'],
  [-2139824388,-2139643404,'Aries'],
  [-2139643404,-2139461064,'Taurus'],
  [-2139461064,-2139275457,'Gemini'],
  [-2139275457,-2139085077,'Cancer'],
  [-2139085077,-2138887976,'Leo'],
  [-2138887976,-2138682154,'Virgo'],
  [-2138682154,-2138467586,'Libra'],
  [-2138467586,-2138248619,'Scorpio'],
  [-2138248619,-2138033458,'Sagittarius'],
  [-2138033458,-2137829502,'Capricorn'],
  [-2137829502,-2137638843,'Aquarius'],
  [-2137638843,-2137458388,'Pisces'],
  [-2137458388,-2137282556,'Aries'],
  [-2137282556,-2137105604,'Taurus'],
  [-2137105604,-2136923008,'Gemini'],
  [-2136923008,-2136732141,'Cancer'],
  [-2136732141,-2136532276,'Leo'],
  [-2136532276,-2136323999,'Virgo'],
  [-2136323999,-2136108825,'Libra'],
  [-2136108825,-2135889950,'Scorpio'],
  [-2135889950,-2135672993,'Sagittarius'],
  [-2135672993,-2135464764,'Capricorn'],
  [-2135464764,-2135269704,'Aquarius'],
  [-2135269704,-2135087467,'Pisces'],
  [-2135087467,-2134913647,'Aries'],
  [-2134913647,-2134741773,'Taurus'],
  [-2134741773,-2134565145,'Gemini'],
  [-2134565145,-2134378458,'Cancer'],
  [-2134378458,-2134179465,'Leo'],
  [-2134179465,-2133969730,'Virgo'],
  [-2133969730,-2133753225,'Libra'],
  [-2133753225,-2133534264,'Scorpio'],
  [-2133534264,-2133316962,'Sagittarius'],
  [-2133316962,-2133105882,'Capricorn'],
  [-2133105882,-2132905574,'Aquarius'],
  [-2132905574,-2132718192,'Pisces'],
  [-2132718192,-2132541924,'Aries'],
  [-2132541924,-2132371402,'Taurus'],
  [-2132371402,-2132199384,'Gemini'],
  [-2132199384,-2132018631,'Cancer'],
  [-2132018631,-2131824190,'Leo'],
  [-2131824190,-2131615969,'Virgo'],
  [-2131615969,-2131398975,'Libra'],
  [-2131398975,-2131179807,'Scorpio'],
  [-2131179807,-2130963194,'Sagittarius'],
  [-2130963194,-2130751898,'Capricorn'],
  [-2130751898,-2130548531,'Aquarius'],
  [-2130548531,-2130355658,'Pisces'],
  [-2130355658,-2130173906,'Aries'],
  [-2130173906,-2130000376,'Taurus'],
  [-2130000376,-2129828966,'Gemini'],
  [-2129828966,-2129652119,'Cancer'],
  [-2129652119,-2129463069,'Leo'],
  [-2129463069,-2129258972,'Virgo'],
  [-2129258972,-2129043369,'Libra'],
  [-2129043369,-2128824221,'Scorpio'],
  [-2128824221,-2128608384,'Sagittarius'],
  [-2128608384,-2128398738,'Capricorn'],
  [-2128398738,-2128195877,'Aquarius'],
  [-2128195877,-2128000529,'Pisces'],
  [-2128000529,-2127813670,'Aries'],
  [-2127813670,-2127634658,'Taurus'],
  [-2127634658,-2127459793,'Gemini'],
  [-2127459793,-2127282838,'Cancer'],
  [-2127282838,-2127096880,'Leo'],
  [-2127096880,-2126897170,'Virgo'],
  [-2126897170,-2126684493,'Libra'],
  [-2126684493,-2126465903,'Scorpio'],
  [-2126465903,-2126250147,'Sagittarius'],
  [-2126250147,-2126042074,'Capricorn'],
  [-2126042074,-2125841959,'Aquarius'],
  [-2125841959,-2125648338,'Pisces'],
  [-2125648338,-2125460223,'Aries'],
  [-2125460223,-2125277017,'Taurus'],
  [-2125277017,-2125096992,'Gemini'],
  [-2125096992,-2124916334,'Cancer'],
  [-2124916334,-2124729707,'Leo'],
  [-2124729707,-2124532221,'Virgo'],
  [-2124532221,-2124322471,'Libra'],
  [-2124322471,-2124104939,'Scorpio'],
  [-2124104939,-2123888363,'Sagittarius'],
  [-2123888363,-2123680057,'Capricorn'],
  [-2123680057,-2123482065,'Aquarius'],
  [-2123482065,-2123292304,'Pisces'],
  [-2123292304,-2123107442,'Aries'],
  [-2123107442,-2122924655,'Taurus'],
  [-2122924655,-2122741795,'Gemini'],
  [-2122741795,-2122556653,'Cancer'],
  [-2122556653,-2122366405,'Leo'],
  [-2122366405,-2122167954,'Virgo'],
  [-2122167954,-2121959532,'Libra'],
  [-2121959532,-2121743100,'Scorpio'],
  [-2121743100,-2121525293,'Sagittarius'],
  [-2121525293,-2121314482,'Capricorn'],
  [-2121314482,-2121115606,'Aquarius'],
  [-2121115606,-2120928172,'Pisces'],
  [-2120928172,-2120748087,'Aries'],
  [-2120748087,-2120570119,'Taurus'],
  [-2120570119,-2120389596,'Gemini'],
  [-2120389596,-2120203297,'Cancer'],
  [-2120203297,-2120009613,'Leo'],
  [-2120009613,-2119808054,'Virgo'],
  [-2119808054,-2119598704,'Libra'],
  [-2119598704,-2119382775,'Scorpio'],
  [-2119382775,-2119164173,'Sagittarius'],
  [-2119164173,-2118949856,'Capricorn'],
  [-2118949856,-2118746757,'Aquarius'],
  [-2118746757,-2118557504,'Pisces'],
  [-2118557504,-2118379480,'Aries'],
  [-2118379480,-2118206724,'Taurus'],
  [-2118206724,-2118032281,'Gemini'],
  [-2118032281,-2117850151,'Cancer'],
  [-2117850151,-2117657069,'Leo'],
  [-2117657069,-2117453385,'Virgo'],
  [-2117453385,-2117241839,'Libra'],
  [-2117241839,-2117025381,'Scorpio'],
  [-2117025381,-2116806773,'Sagittarius'],
  [-2116806773,-2116590209,'Capricorn'],
  [-2116590209,-2116381887,'Aquarius'],
  [-2116381887,-2116186964,'Pisces'],
  [-2116186964,-2116006007,'Aries'],
  [-2116006007,-2115834506,'Taurus'],
  [-2115834506,-2115665022,'Gemini'],
  [-2115665022,-2115489588,'Cancer'],
  [-2115489588,-2115301982,'Leo'],
  [-2115301982,-2115100330,'Virgo'],
  [-2115100330,-2114887924,'Libra'],
  [-2114887924,-2114670371,'Scorpio'],
  [-2114670371,-2114451986,'Sagittarius'],
  [-2114451986,-2114235511,'Capricorn'],
  [-2114235511,-2114024464,'Aquarius'],
  [-2114024464,-2113823604,'Pisces'],
  [-2113823604,-2113636089,'Aries'],
  [-2113636089,-2113460531,'Taurus'],
  [-2113460531,-2113291080,'Gemini'],
  [-2113291080,-2113119726,'Cancer'],
  [-2113119726,-2112938626,'Leo'],
  [-2112938626,-2112742822,'Virgo'],
  [-2112742822,-2112533055,'Libra'],
  [-2112533055,-2112315427,'Scorpio'],
  [-2112315427,-2112096956,'Sagittarius'],
  [-2112096956,-2111881716,'Capricorn'],
  [-2111881716,-2111671573,'Aquarius'],
  [-2111671573,-2111468669,'Pisces'],
  [-2111468669,-2111275655,'Aries'],
  [-2111275655,-2111093400,'Taurus'],
  [-2111093400,-2110919035,'Gemini'],
  [-2110919035,-2110746451,'Cancer'],
  [-2110746451,-2110568242,'Leo'],
  [-2110568242,-2110378020,'Virgo'],
  [-2110378020,-2110173348,'Libra'],
  [-2110173348,-2109957836,'Scorpio'],
  [-2109957836,-2109739345,'Sagittarius'],
  [-2109739345,-2109524719,'Capricorn'],
  [-2109524719,-2109316876,'Aquarius'],
  [-2109316876,-2109116192,'Pisces'],
  [-2109116192,-2108922670,'Aries'],
  [-2108922670,-2108736309,'Taurus'],
  [-2108736309,-2108555907,'Gemini'],
  [-2108555907,-2108378128,'Cancer'],
  [-2108378128,-2108197807,'Leo'],
  [-2108197807,-2108009322,'Virgo'],
  [-2108009322,-2107808773,'Libra'],
  [-2107808773,-2107596609,'Scorpio'],
  [-2107596609,-2107378740,'Sagittarius'],
  [-2107378740,-2107163521,'Capricorn'],
  [-2107163521,-2106956606,'Aquarius'],
  [-2106956606,-2106759105,'Pisces'],
  [-2106759105,-2106569178,'Aries'],
  [-2106569178,-2106384158,'Taurus'],
  [-2106384158,-2106201564,'Gemini'],
  [-2106201564,-2106019046,'Cancer'],
  [-2106019046,-2105833939,'Leo'],
  [-2105833939,-2105643056,'Virgo'],
  [-2105643056,-2105443325,'Libra'],
  [-2105443325,-2105233564,'Scorpio'],
  [-2105233564,-2105016739,'Sagittarius'],
  [-2105016739,-2104800208,'Capricorn'],
  [-2104800208,-2104591814,'Aquarius'],
  [-2104591814,-2104395214,'Pisces'],
  [-2104395214,-2104208977,'Aries'],
  [-2104208977,-2104028623,'Taurus'],
  [-2104028623,-2103849082,'Gemini'],
  [-2103849082,-2103666337,'Cancer'],
  [-2103666337,-2103478085,'Leo'],
  [-2103478085,-2103283354,'Virgo'],
  [-2103283354,-2103081487,'Libra'],
  [-2103081487,-2102871936,'Scorpio'],
  [-2102871936,-2102655831,'Sagittarius'],
  [-2102655831,-2102438046,'Capricorn'],
  [-2102438046,-2102226509,'Aquarius'],
  [-2102226509,-2102027512,'Pisces'],
  [-2102027512,-2101841870,'Aries'],
  [-2101841870,-2101665274,'Taurus'],
  [-2101665274,-2101491028,'Gemini'],
  [-2101491028,-2101312658,'Cancer'],
  [-2101312658,-2101125848,'Leo'],
  [-2101125848,-2100929513,'Virgo'],
  [-2100929513,-2100724974,'Libra'],
  [-2100724974,-2100513916,'Scorpio'],
  [-2100513916,-2100297745,'Sagittarius'],
  [-2100297745,-2100079317,'Capricorn'],
  [-2100079317,-2099864695,'Aquarius'],
  [-2099864695,-2099661148,'Pisces'],
  [-2099661148,-2099472281,'Aries'],
  [-2099472281,-2099295734,'Taurus'],
  [-2099295734,-2099124939,'Gemini'],
  [-2099124939,-2098952083,'Cancer'],
  [-2098952083,-2098770480,'Leo'],
  [-2098770480,-2098576751,'Virgo'],
  [-2098576751,-2098371829,'Libra'],
  [-2098371829,-2098159249,'Scorpio'],
  [-2098159249,-2097942407,'Sagittarius'],
  [-2097942407,-2097723996,'Capricorn'],
  [-2097723996,-2097507943,'Aquarius'],
  [-2097507943,-2097300209,'Pisces'],
  [-2097300209,-2097105884,'Aries'],
  [-2097105884,-2096925373,'Taurus'],
  [-2096925373,-2096753908,'Gemini'],
  [-2096753908,-2096583964,'Cancer'],
  [-2096583964,-2096407764,'Leo'],
  [-2096407764,-2096219528,'Virgo'],
  [-2096219528,-2096017719,'Libra'],
  [-2096017719,-2095805453,'Scorpio'],
  [-2095805453,-2095588048,'Sagittarius'],
  [-2095588048,-2095369939,'Capricorn'],
  [-2095369939,-2095154423,'Aquarius'],
  [-2095154423,-2094945216,'Pisces'],
  [-2094945216,-2094746398,'Aries'],
  [-2094746398,-2094559998,'Taurus'],
  [-2094559998,-2094383927,'Gemini'],
  [-2094383927,-2094212539,'Cancer'],
  [-2094212539,-2094038614,'Leo'],
  [-2094038614,-2093855371,'Virgo'],
  [-2093855371,-2093658720,'Libra'],
  [-2093658720,-2093449275,'Scorpio'],
  [-2093449275,-2093232251,'Sagittarius'],
  [-2093232251,-2093014297,'Capricorn'],
  [-2093014297,-2092800172,'Aquarius'],
  [-2092800172,-2092592494,'Pisces'],
  [-2092592494,-2092392928,'Aries'],
  [-2092392928,-2092202501,'Taurus'],
  [-2092202501,-2092020593,'Gemini'],
  [-2092020593,-2091844161,'Cancer'],
  [-2091844161,-2091668117,'Leo'],
  [-2091668117,-2091486483,'Virgo'],
  [-2091486483,-2091294067,'Libra'],
  [-2091294067,-2091088730,'Scorpio'],
  [-2091088730,-2090873377,'Sagittarius'],
  [-2090873377,-2090655285,'Capricorn'],
  [-2090655285,-2090441774,'Aquarius'],
  [-2090441774,-2090236592,'Pisces'],
  [-2090236592,-2090039890,'Aries'],
  [-2090039890,-2089850106,'Taurus'],
  [-2089850106,-2089665376,'Gemini'],
  [-2089665376,-2089483719,'Cancer'],
  [-2089483719,-2089302573,'Leo'],
  [-2089302573,-2089118380,'Virgo'],
  [-2089118380,-2088926887,'Libra'],
  [-2088926887,-2088724639,'Scorpio'],
  [-2088724639,-2088511629,'Sagittarius'],
  [-2088511629,-2088293356,'Capricorn'],
  [-2088293356,-2088078716,'Aquarius'],
  [-2088078716,-2087874254,'Pisces'],
  [-2087874254,-2087680915,'Aries'],
  [-2087680915,-2087495411,'Taurus'],
  [-2087495411,-2087313183,'Gemini'],
  [-2087313183,-2087130543,'Cancer'],
  [-2087130543,-2086945402,'Leo'],
  [-2086945402,-2086756572,'Virgo'],
  [-2086756572,-2086562409,'Libra'],
  [-2086562409,-2086360441,'Scorpio'],
  [-2086360441,-2086149104,'Sagittarius'],
  [-2086149104,-2085930952,'Capricorn'],
  [-2085930952,-2085713932,'Aquarius'],
  [-2085713932,-2085507031,'Pisces'],
  [-2085507031,-2085314029,'Aries'],
  [-2085314029,-2085132218,'Taurus'],
  [-2085132218,-2084955413,'Gemini'],
  [-2084955413,-2084777232,'Cancer'],
  [-2084777232,-2084593310,'Leo'],
  [-2084593310,-2084402220,'Virgo'],
  [-2084402220,-2084204396,'Libra'],
  [-2084204396,-2084000047,'Scorpio'],
  [-2084000047,-2083788582,'Sagittarius'],
  [-2083788582,-2083570747,'Capricorn'],
  [-2083570747,-2083351708,'Aquarius'],
  [-2083351708,-2083140372,'Pisces'],
  [-2083140372,-2082943506,'Aries'],
  [-2082943506,-2082761139,'Taurus'],
  [-2082761139,-2082587677,'Gemini'],
  [-2082587677,-2082415468,'Cancer'],
  [-2082415468,-2082237562,'Leo'],
  [-2082237562,-2082049747,'Virgo'],
  [-2082049747,-2081851513,'Libra'],
  [-2081851513,-2081644775,'Scorpio'],
  [-2081644775,-2081431637,'Sagittarius'],
  [-2081431637,-2081213721,'Capricorn'],
  [-2081213721,-2080994157,'Aquarius'],
  [-2080994157,-2080779360,'Pisces'],
  [-2080779360,-2080576631,'Aries'],
  [-2080576631,-2080389128,'Taurus'],
  [-2080389128,-2080213900,'Gemini'],
  [-2080213900,-2080044126,'Cancer'],
  [-2080044126,-2079872031,'Leo'],
  [-2079872031,-2079690981,'Virgo'],
  [-2079690981,-2079497353,'Libra'],
  [-2079497353,-2079291592,'Scorpio'],
  [-2079291592,-2079077275,'Sagittarius'],
  [-2079077275,-2078858703,'Capricorn'],
  [-2078858703,-2078639640,'Aquarius'],
  [-2078639640,-2078424297,'Pisces'],
  [-2078424297,-2078217740,'Aries'],
  [-2078217740,-2078023858,'Taurus'],
  [-2078023858,-2077842655,'Gemini'],
  [-2077842655,-2077669956,'Cancer'],
  [-2077669956,-2077499172,'Leo'],
  [-2077499172,-2077323198,'Virgo'],
  [-2077323198,-2077136115,'Libra'],
  [-2077136115,-2076935157,'Scorpio'],
  [-2076935157,-2076722286,'Sagittarius'],
  [-2076722286,-2076503370,'Capricorn'],
  [-2076503370,-2076284744,'Aquarius'],
  [-2076284744,-2076070885,'Pisces'],
  [-2076070885,-2075864530,'Aries'],
  [-2075864530,-2075667489,'Taurus'],
  [-2075667489,-2075480323,'Gemini'],
  [-2075480323,-2075301459,'Cancer'],
  [-2075301459,-2075126996,'Leo'],
  [-2075126996,-2074951310,'Virgo'],
  [-2074951310,-2074768212,'Libra'],
  [-2074768212,-2074572722,'Scorpio'],
  [-2074572722,-2074363678,'Sagittarius'],
  [-2074363678,-2074145706,'Capricorn'],
  [-2074145706,-2073927077,'Aquarius'],
  [-2073927077,-2073714590,'Pisces'],
  [-2073714590,-2073510812,'Aries'],
  [-2073510812,-2073315176,'Taurus'],
  [-2073315176,-2073126223,'Gemini'],
  [-2073126223,-2072942539,'Cancer'],
  [-2072942539,-2072762388,'Leo'],
  [-2072762388,-2072582804,'Virgo'],
  [-2072582804,-2072399238,'Libra'],
  [-2072399238,-2072206513,'Scorpio'],
  [-2072206513,-2072001263,'Sagittarius'],
  [-2072001263,-2071785287,'Capricorn'],
  [-2071785287,-2071566438,'Aquarius'],
  [-2071566438,-2071353860,'Pisces'],
  [-2071353860,-2071152063,'Aries'],
  [-2071152063,-2070959942,'Taurus'],
  [-2070959942,-2070773734,'Gemini'],
  [-2070773734,-2070589948,'Cancer'],
  [-2070589948,-2070406525,'Leo'],
  [-2070406525,-2070222211,'Virgo'],
  [-2070222211,-2070034984,'Libra'],
  [-2070034984,-2069841358,'Scorpio'],
  [-2069841358,-2069637717,'Sagittarius'],
  [-2069637717,-2069423575,'Capricorn'],
  [-2069423575,-2069204518,'Aquarius'],
  [-2069204518,-2068990291,'Pisces'],
  [-2068990291,-2068788009,'Aries'],
  [-2068788009,-2068598089,'Taurus'],
  [-2068598089,-2068416067,'Gemini'],
  [-2068416067,-2068236285,'Cancer'],
  [-2068236285,-2068054449,'Leo'],
  [-2068054449,-2067868510,'Virgo'],
  [-2067868510,-2067677734,'Libra'],
  [-2067677734,-2067481013,'Scorpio'],
  [-2067481013,-2067276389,'Sagittarius'],
  [-2067276389,-2067062882,'Capricorn'],
  [-2067062882,-2066843715,'Aquarius'],
  [-2066843715,-2066627143,'Pisces'],
  [-2066627143,-2066421811,'Aries'],
  [-2066421811,-2066230792,'Taurus'],
  [-2066230792,-2066050844,'Gemini'],
  [-2066050844,-2065875640,'Cancer'],
  [-2065875640,-2065698839,'Leo'],
  [-2065698839,-2065515963,'Virgo'],
  [-2065515963,-2065325070,'Libra'],
  [-2065325070,-2065125996,'Scorpio'],
  [-2065125996,-2064919084,'Sagittarius'],
  [-2064919084,-2064704859,'Capricorn'],
  [-2064704859,-2064485634,'Aquarius'],
  [-2064485634,-2064267316,'Pisces'],
  [-2064267316,-2064057878,'Aries'],
  [-2064057878,-2063862572,'Taurus'],
  [-2063862572,-2063680760,'Gemini'],
  [-2063680760,-2063507246,'Cancer'],
  [-2063507246,-2063335149,'Leo'],
  [-2063335149,-2063158007,'Virgo'],
  [-2063158007,-2062971264,'Libra'],
  [-2062971264,-2062773221,'Scorpio'],
  [-2062773221,-2062565009,'Sagittarius'],
  [-2062565009,-2062349480,'Capricorn'],
  [-2062349480,-2062130132,'Aquarius'],
  [-2062130132,-2061911487,'Pisces'],
  [-2061911487,-2061699254,'Aries'],
  [-2061699254,-2061498659,'Taurus'],
  [-2061498659,-2061311552,'Gemini'],
  [-2061311552,-2061135339,'Cancer'],
  [-2061135339,-2060964362,'Leo'],
  [-2060964362,-2060791758,'Virgo'],
  [-2060791758,-2060611006,'Libra'],
  [-2060611006,-2060417630,'Scorpio'],
  [-2060417630,-2060211032,'Sagittarius'],
  [-2060211032,-2059994989,'Capricorn'],
  [-2059994989,-2059775407,'Aquarius'],
  [-2059775407,-2059557556,'Pisces'],
  [-2059557556,-2059345308,'Aries'],
  [-2059345308,-2059141702,'Taurus'],
  [-2059141702,-2058948842,'Gemini'],
  [-2058948842,-2058766654,'Cancer'],
  [-2058766654,-2058592176,'Leo'],
  [-2058592176,-2058419959,'Virgo'],
  [-2058419959,-2058243226,'Libra'],
  [-2058243226,-2058055541,'Scorpio'],
  [-2058055541,-2057853366,'Sagittarius'],
  [-2057853366,-2057638794,'Capricorn'],
  [-2057638794,-2057419106,'Aquarius'],
  [-2057419106,-2057202032,'Pisces'],
  [-2057202032,-2056991745,'Aries'],
  [-2056991745,-2056789094,'Taurus'],
  [-2056789094,-2056593975,'Gemini'],
  [-2056593975,-2056406410,'Cancer'],
  [-2056406410,-2056225771,'Leo'],
  [-2056225771,-2056049408,'Virgo'],
  [-2056049408,-2055872207,'Libra'],
  [-2055872207,-2055687665,'Scorpio'],
  [-2055687665,-2055490244,'Sagittarius'],
  [-2055490244,-2055278964,'Capricorn'],
  [-2055278964,-2055059821,'Aquarius'],
  [-2055059821,-2054842553,'Pisces'],
  [-2054842553,-2054633778,'Aries'],
  [-2054633778,-2054434296,'Taurus'],
  [-2054434296,-2054241664,'Gemini'],
  [-2054241664,-2054053499,'Cancer'],
  [-2054053499,-2053868749,'Leo'],
  [-2053868749,-2053686689,'Virgo'],
  [-2053686689,-2053505019,'Libra'],
  [-2053505019,-2053319205,'Scorpio'],
  [-2053319205,-2053123840,'Sagittarius'],
  [-2053123840,-2052915794,'Capricorn'],
  [-2052915794,-2052698009,'Aquarius'],
  [-2052698009,-2052479688,'Pisces'],
  [-2052479688,-2052270082,'Aries'],
  [-2052270082,-2052072349,'Taurus'],
  [-2052072349,-2051883846,'Gemini'],
  [-2051883846,-2051699902,'Cancer'],
  [-2051699902,-2051516773,'Leo'],
  [-2051516773,-2051332601,'Virgo'],
  [-2051332601,-2051146387,'Libra'],
  [-2051146387,-2050956296,'Scorpio'],
  [-2050956296,-2050759190,'Sagittarius'],
  [-2050759190,-2050552161,'Capricorn'],
  [-2050552161,-2050335777,'Aquarius'],
  [-2050335777,-2050116475,'Pisces'],
  [-2050116475,-2049903896,'Aries'],
  [-2049903896,-2049704265,'Taurus'],
  [-2049704265,-2049517173,'Gemini'],
  [-2049517173,-2049337813,'Cancer'],
  [-2049337813,-2049160338,'Leo'],
  [-2049160338,-2048979993,'Virgo'],
  [-2048979993,-2048793952,'Libra'],
  [-2048793952,-2048600947,'Scorpio'],
  [-2048600947,-2048400340,'Sagittarius'],
  [-2048400340,-2048191662,'Capricorn'],
  [-2048191662,-2047975587,'Aquarius'],
  [-2047975587,-2047755999,'Pisces'],
  [-2047755999,-2047540307,'Aries'],
  [-2047540307,-2047335953,'Taurus'],
  [-2047335953,-2047145750,'Gemini'],
  [-2047145750,-2046967039,'Cancer'],
  [-2046967039,-2046793999,'Leo'],
  [-2046793999,-2046620039,'Virgo'],
  [-2046620039,-2046439429,'Libra'],
  [-2046439429,-2046248552,'Scorpio'],
  [-2046248552,-2046046695,'Sagittarius'],
  [-2046046695,-2045835703,'Capricorn'],
  [-2045835703,-2045618630,'Aquarius'],
  [-2045618630,-2045399155,'Pisces'],
  [-2045399155,-2045182085,'Aries'],
  [-2045182085,-2044973251,'Taurus'],
  [-2044973251,-2044777156,'Gemini'],
  [-2044777156,-2044594306,'Cancer'],
  [-2044594306,-2044420982,'Leo'],
  [-2044420982,-2044250792,'Virgo'],
  [-2044250792,-2044076494,'Libra'],
  [-2044076494,-2043891719,'Scorpio'],
  [-2043891719,-2043693106,'Sagittarius'],
  [-2043693106,-2043482093,'Capricorn'],
  [-2043482093,-2043263956,'Aquarius'],
  [-2043263956,-2043044465,'Pisces'],
  [-2043044465,-2042827834,'Aries'],
  [-2042827834,-2042617365,'Taurus'],
  [-2042617365,-2042416432,'Gemini'],
  [-2042416432,-2042227283,'Cancer'],
  [-2042227283,-2042049184,'Leo'],
  [-2042049184,-2041877809,'Virgo'],
  [-2041877809,-2041706313,'Libra'],
  [-2041706313,-2041527153,'Scorpio'],
  [-2041527153,-2041334362,'Sagittarius'],
  [-2041334362,-2041126658,'Capricorn'],
  [-2041126658,-2040909014,'Aquarius'],
  [-2040909014,-2040689445,'Pisces'],
  [-2040689445,-2040473850,'Aries'],
  [-2040473850,-2040264561,'Taurus'],
  [-2040264561,-2040062553,'Gemini'],
  [-2040062553,-2039869101,'Cancer'],
  [-2039869101,-2039684989,'Leo'],
  [-2039684989,-2039508619,'Virgo'],
  [-2039508619,-2039335203,'Libra'],
  [-2039335203,-2039157841,'Scorpio'],
  [-2039157841,-2038969610,'Sagittarius'],
  [-2038969610,-2038766648,'Capricorn'],
  [-2038766648,-2038551406,'Aquarius'],
  [-2038551406,-2038332120,'Pisces'],
  [-2038332120,-2038117038,'Aries'],
  [-2038117038,-2037909742,'Taurus'],
  [-2037909742,-2037709938,'Gemini'],
  [-2037709938,-2037516559,'Cancer'],
  [-2037516559,-2037329295,'Leo'],
  [-2037329295,-2037147697,'Virgo'],
  [-2037147697,-2036969420,'Libra'],
  [-2036969420,-2036789678,'Scorpio'],
  [-2036789678,-2036602408,'Sagittarius'],
  [-2036602408,-2036402774,'Capricorn'],
  [-2036402774,-2036190577,'Aquarius'],
  [-2036190577,-2035972073,'Pisces'],
  [-2035972073,-2035756546,'Aries'],
  [-2035756546,-2035550004,'Taurus'],
  [-2035550004,-2035352978,'Gemini'],
  [-2035352978,-2035162946,'Cancer'],
  [-2035162946,-2034977209,'Leo'],
  [-2034977209,-2034793956,'Virgo'],
  [-2034793956,-2034611555,'Libra'],
  [-2034611555,-2034427394,'Scorpio'],
  [-2034427394,-2034237635,'Sagittarius'],
  [-2034237635,-2034038373,'Capricorn'],
  [-2034038373,-2033828165,'Aquarius'],
  [-2033828165,-2033610614,'Pisces'],
  [-2033610614,-2033393896,'Aries'],
  [-2033393896,-2033185914,'Taurus'],
  [-2033185914,-2032989590,'Gemini'],
  [-2032989590,-2032802904,'Cancer'],
  [-2032802904,-2032621597,'Leo'],
  [-2032621597,-2032441392,'Virgo'],
  [-2032441392,-2032258970,'Libra'],
  [-2032258970,-2032071962,'Scorpio'],
  [-2032071962,-2031878512,'Sagittarius'],
  [-2031878512,-2031677041,'Capricorn'],
  [-2031677041,-2031466867,'Aquarius'],
  [-2031466867,-2031249931,'Pisces'],
  [-2031249931,-2031031966,'Aries'],
  [-2031031966,-2030820815,'Taurus'],
  [-2030820815,-2030621961,'Gemini'],
  [-2030621961,-2030435666,'Cancer'],
  [-2030435666,-2030257983,'Leo'],
  [-2030257983,-2030083067,'Virgo'],
  [-2030083067,-2029905087,'Libra'],
  [-2029905087,-2029719632,'Scorpio'],
  [-2029719632,-2029524651,'Sagittarius'],
  [-2029524651,-2029320461,'Capricorn'],
  [-2029320461,-2029108717,'Aquarius'],
  [-2029108717,-2028891729,'Pisces'],
  [-2028891729,-2028673173,'Aries'],
  [-2028673173,-2028458853,'Taurus'],
  [-2028458853,-2028255131,'Gemini'],
  [-2028255131,-2028065209,'Cancer'],
  [-2028065209,-2027887339,'Leo'],
  [-2027887339,-2027715929,'Virgo'],
  [-2027715929,-2027543716,'Libra'],
  [-2027543716,-2027363782,'Scorpio'],
  [-2027363782,-2027171651,'Sagittarius'],
  [-2027171651,-2026967112,'Capricorn'],
  [-2026967112,-2026753743,'Aquarius'],
  [-2026753743,-2026536083,'Pisces'],
  [-2026536083,-2026317721,'Aries'],
  [-2026317721,-2026102121,'Taurus'],
  [-2026102121,-2025894023,'Gemini'],
  [-2025894023,-2025698045,'Cancer'],
  [-2025698045,-2025515523,'Leo'],
  [-2025515523,-2025343046,'Virgo'],
  [-2025343046,-2025173744,'Libra'],
  [-2025173744,-2024999550,'Scorpio'],
  [-2024999550,-2024813478,'Sagittarius'],
  [-2024813478,-2024612533,'Capricorn'],
  [-2024612533,-2024399608,'Aquarius'],
  [-2024399608,-2024181303,'Pisces'],
  [-2024181303,-2023963318,'Aries'],
  [-2023963318,-2023748621,'Taurus'],
  [-2023748621,-2023539432,'Gemini'],
  [-2023539432,-2023338913,'Cancer'],
  [-2023338913,-2023149856,'Leo'],
  [-2023149856,-2022971886,'Virgo'],
  [-2022971886,-2022800420,'Libra'],
  [-2022800420,-2022628142,'Scorpio'],
  [-2022628142,-2022447242,'Sagittarius'],
  [-2022447242,-2022252127,'Capricorn'],
  [-2022252127,-2022042666,'Aquarius'],
  [-2022042666,-2021824905,'Pisces'],
  [-2021824905,-2021606903,'Aries'],
  [-2021606903,-2021393641,'Taurus'],
  [-2021393641,-2021186535,'Gemini'],
  [-2021186535,-2020986094,'Cancer'],
  [-2020986094,-2020793461,'Leo'],
  [-2020793461,-2020609339,'Virgo'],
  [-2020609339,-2020431949,'Libra'],
  [-2020431949,-2020256491,'Scorpio'],
  [-2020256491,-2020076382,'Sagittarius'],
  [-2020076382,-2019885402,'Capricorn'],
  [-2019885402,-2019680649,'Aquarius'],
  [-2019680649,-2019465163,'Pisces'],
  [-2019465163,-2019246980,'Aries'],
  [-2019246980,-2019033839,'Taurus'],
  [-2019033839,-2018829026,'Gemini'],
  [-2018829026,-2018632066,'Cancer'],
  [-2018632066,-2018441341,'Leo'],
  [-2018441341,-2018255526,'Virgo'],
  [-2018255526,-2018073253,'Libra'],
  [-2018073253,-2017892118,'Scorpio'],
  [-2017892118,-2017708285,'Sagittarius'],
  [-2017708285,-2017517160,'Capricorn'],
  [-2017517160,-2017315206,'Aquarius'],
  [-2017315206,-2017102536,'Pisces'],
  [-2017102536,-2016884586,'Aries'],
  [-2016884586,-2016669926,'Taurus'],
  [-2016669926,-2016464892,'Gemini'],
  [-2016464892,-2016270679,'Cancer'],
  [-2016270679,-2016084610,'Leo'],
  [-2016084610,-2015902616,'Virgo'],
  [-2015902616,-2015720954,'Libra'],
  [-2015720954,-2015536854,'Scorpio'],
  [-2015536854,-2015348338,'Sagittarius'],
  [-2015348338,-2015153640,'Capricorn'],
  [-2015153640,-2014951011,'Aquarius'],
  [-2014951011,-2014739763,'Pisces'],
  [-2014739763,-2014522405,'Aries'],
  [-2014522405,-2014305670,'Taurus'],
  [-2014305670,-2014097597,'Gemini'],
  [-2014097597,-2013902498,'Cancer'],
  [-2013902498,-2013719120,'Leo'],
  [-2013719120,-2013542377,'Virgo'],
  [-2013542377,-2013366004,'Libra'],
  [-2013366004,-2013184646,'Scorpio'],
  [-2013184646,-2012995237,'Sagittarius'],
  [-2012995237,-2012797330,'Capricorn'],
  [-2012797330,-2012591892,'Aquarius'],
  [-2012591892,-2012379914,'Pisces'],
  [-2012379914,-2012162868,'Aries'],
  [-2012162868,-2011944752,'Taurus'],
  [-2011944752,-2011732676,'Gemini'],
  [-2011732676,-2011533250,'Cancer'],
  [-2011533250,-2011348190,'Leo'],
  [-2011348190,-2011173605,'Virgo'],
  [-2011173605,-2011002425,'Libra'],
  [-2011002425,-2010827134,'Scorpio'],
  [-2010827134,-2010641970,'Sagittarius'],
  [-2010641970,-2010444871,'Capricorn'],
  [-2010444871,-2010237719,'Aquarius'],
  [-2010237719,-2010024017,'Pisces'],
  [-2010024017,-2009806614,'Aries'],
  [-2009806614,-2009588205,'Taurus'],
  [-2009588205,-2009373491,'Gemini'],
  [-2009373491,-2009168898,'Cancer'],
  [-2009168898,-2008978655,'Leo'],
  [-2008978655,-2008801586,'Virgo'],
  [-2008801586,-2008631734,'Libra'],
  [-2008631734,-2008461114,'Scorpio'],
  [-2008461114,-2008282133,'Sagittarius'],
  [-2008282133,-2008089953,'Capricorn'],
  [-2008089953,-2007884579,'Aquarius'],
  [-2007884579,-2007670283,'Pisces'],
  [-2007670283,-2007452266,'Aries'],
  [-2007452266,-2007234201,'Taurus'],
  [-2007234201,-2007019218,'Gemini'],
  [-2007019218,-2006811632,'Cancer'],
  [-2006811632,-2006615860,'Leo'],
  [-2006615860,-2006433177,'Virgo'],
  [-2006433177,-2006260128,'Libra'],
  [-2006260128,-2006089957,'Scorpio'],
  [-2006089957,-2005914926,'Sagittarius'],
  [-2005914926,-2005728505,'Capricorn'],
  [-2005728505,-2005527857,'Aquarius'],
  [-2005527857,-2005315421,'Pisces'],
  [-2005315421,-2005097387,'Aries'],
  [-2005097387,-2004879699,'Taurus'],
  [-2004879699,-2004666008,'Gemini'],
  [-2004666008,-2004458793,'Cancer'],
  [-2004458793,-2004260478,'Leo'],
  [-2004260478,-2004072568,'Virgo'],
  [-2004072568,-2003893844,'Libra'],
  [-2003893844,-2003719965,'Scorpio'],
  [-2003719965,-2003544656,'Sagittarius'],
  [-2003544656,-2003361418,'Capricorn'],
  [-2003361418,-2003165634,'Aquarius'],
  [-2003165634,-2002956890,'Pisces'],
  [-2002956890,-2002739968,'Aries'],
  [-2002739968,-2002522360,'Taurus'],
  [-2002522360,-2002309887,'Gemini'],
  [-2002309887,-2002105068,'Cancer'],
  [-2002105068,-2001908221,'Leo'],
  [-2001908221,-2001718832,'Virgo'],
  [-2001718832,-2001535709,'Libra'],
  [-2001535709,-2001356449,'Scorpio'],
  [-2001356449,-2001177225,'Sagittarius'],
  [-2001177225,-2000993222,'Capricorn'],
  [-2000993222,-2000799818,'Aquarius'],
  [-2000799818,-2000594587,'Pisces'],
  [-2000594587,-2000379595,'Aries'],
  [-2000379595,-2000161769,'Taurus'],
  [-2000161769,-1999949138,'Gemini'],
  [-1999949138,-1999746187,'Cancer'],
  [-1999746187,-1999552822,'Leo'],
  [-1999552822,-1999366251,'Virgo'],
  [-1999366251,-1999183149,'Libra'],
  [-1999183149,-1999000742,'Scorpio'],
  [-1999000742,-1998816808,'Sagittarius'],
  [-1998816808,-1998629043,'Capricorn'],
  [-1998629043,-1998434622,'Aquarius'],
  [-1998434622,-1998230912,'Pisces'],
  [-1998230912,-1998017696,'Aries'],
  [-1998017696,-1997799577,'Taurus'],
  [-1997799577,-1997585107,'Gemini'],
  [-1997585107,-1997381489,'Cancer'],
  [-1997381489,-1997190318,'Leo'],
  [-1997190318,-1997008105,'Virgo'],
  [-1997008105,-1996829241,'Libra'],
  [-1996829241,-1996648613,'Scorpio'],
  [-1996648613,-1996463098,'Sagittarius'],
  [-1996463098,-1996271652,'Capricorn'],
  [-1996271652,-1996073975,'Aquarius'],
  [-1996073975,-1995869229,'Pisces'],
  [-1995869229,-1995656694,'Aries'],
  [-1995656694,-1995438466,'Taurus'],
  [-1995438466,-1995221408,'Gemini'],
  [-1995221408,-1995014275,'Cancer'],
  [-1995014275,-1994821639,'Leo'],
  [-1994821639,-1994641466,'Virgo'],
  [-1994641466,-1994467450,'Libra'],
  [-1994467450,-1994292336,'Scorpio'],
  [-1994292336,-1994110380,'Sagittarius'],
  [-1994110380,-1993919054,'Capricorn'],
  [-1993919054,-1993718960,'Aquarius'],
  [-1993718960,-1993511755,'Pisces'],
  [-1993511755,-1993298456,'Aries'],
  [-1993298456,-1993080307,'Taurus'],
  [-1993080307,-1992861547,'Gemini'],
  [-1992861547,-1992649920,'Cancer'],
  [-1992649920,-1992452239,'Leo'],
  [-1992452239,-1992269513,'Virgo'],
  [-1992269513,-1992096841,'Libra'],
  [-1992096841,-1991926540,'Scorpio'],
  [-1991926540,-1991750952,'Sagittarius'],
  [-1991750952,-1991564646,'Capricorn'],
  [-1991564646,-1991366185,'Aquarius'],
  [-1991366185,-1991157800,'Pisces'],
  [-1991157800,-1990943026,'Aries'],
  [-1990943026,-1990724759,'Taurus'],
  [-1990724759,-1990506020,'Gemini'],
  [-1990506020,-1990291897,'Cancer'],
  [-1990291897,-1990088627,'Leo'],
  [-1990088627,-1989899699,'Virgo'],
  [-1989899699,-1989723241,'Libra'],
  [-1989723241,-1989553175,'Scorpio'],
  [-1989553175,-1989381832,'Sagittarius'],
  [-1989381832,-1989202073,'Capricorn'],
  [-1989202073,-1989009348,'Aquarius'],
  [-1989009348,-1988803451,'Pisces'],
  [-1988803451,-1988588362,'Aries'],
  [-1988588362,-1988369638,'Taurus'],
  [-1988369638,-1988151788,'Gemini'],
  [-1988151788,-1987938360,'Cancer'],
  [-1987938360,-1987732896,'Leo'],
  [-1987732896,-1987538359,'Virgo'],
  [-1987538359,-1987355174,'Libra'],
  [-1987355174,-1987180277,'Scorpio'],
  [-1987180277,-1987007970,'Sagittarius'],
  [-1987007970,-1986831493,'Capricorn'],
  [-1986831493,-1986644702,'Aquarius'],
  [-1986644702,-1986444180,'Pisces'],
  [-1986444180,-1986231385,'Aries'],
  [-1986231385,-1986012586,'Taurus'],
  [-1986012586,-1985795124,'Gemini'],
  [-1985795124,-1985583758,'Cancer'],
  [-1985583758,-1985380239,'Leo'],
  [-1985380239,-1985184797,'Virgo'],
  [-1985184797,-1984997064,'Libra'],
  [-1984997064,-1984815771,'Scorpio'],
  [-1984815771,-1984638155,'Sagittarius'],
  [-1984638155,-1984459768,'Capricorn'],
  [-1984459768,-1984275106,'Aquarius'],
  [-1984275106,-1984079204,'Pisces'],
  [-1984079204,-1983870330,'Aries'],
  [-1983870330,-1983652590,'Taurus'],
  [-1983652590,-1983434654,'Gemini'],
  [-1983434654,-1983224152,'Cancer'],
  [-1983224152,-1983023689,'Leo'],
  [-1983023689,-1982831595,'Virgo'],
  [-1982831595,-1982644807,'Libra'],
  [-1982644807,-1982460813,'Scorpio'],
  [-1982460813,-1982277972,'Sagittarius'],
  [-1982277972,-1982094533,'Capricorn'],
  [-1982094533,-1981907468,'Aquarius'],
  [-1981907468,-1981712594,'Pisces'],
  [-1981712594,-1981506623,'Aries'],
  [-1981506623,-1981290625,'Taurus'],
  [-1981290625,-1981071893,'Gemini'],
  [-1981071893,-1980860079,'Cancer'],
  [-1980860079,-1980660503,'Leo'],
  [-1980660503,-1980472006,'Virgo'],
  [-1980472006,-1980289733,'Libra'],
  [-1980289733,-1980108567,'Scorpio'],
  [-1980108567,-1979925153,'Sagittarius'],
  [-1979925153,-1979738169,'Capricorn'],
  [-1979738169,-1979546904,'Aquarius'],
  [-1979546904,-1979349641,'Pisces'],
  [-1979349641,-1979143895,'Aries'],
  [-1979143895,-1978929064,'Taurus'],
  [-1978929064,-1978709743,'Gemini'],
  [-1978709743,-1978495212,'Cancer'],
  [-1978495212,-1978293323,'Leo'],
  [-1978293323,-1978105329,'Virgo'],
  [-1978105329,-1977926704,'Libra'],
  [-1977926704,-1977750795,'Scorpio'],
  [-1977750795,-1977571738,'Sagittarius'],
  [-1977571738,-1977386099,'Capricorn'],
  [-1977386099,-1977193010,'Aquarius'],
  [-1977193010,-1976992696,'Pisces'],
  [-1976992696,-1976785039,'Aries'],
  [-1976785039,-1976570057,'Taurus'],
  [-1976570057,-1976350480,'Gemini'],
  [-1976350480,-1976133394,'Cancer'],
  [-1976133394,-1975927211,'Leo'],
  [-1975927211,-1975735943,'Virgo'],
  [-1975735943,-1975557185,'Libra'],
  [-1975557185,-1975384623,'Scorpio'],
  [-1975384623,-1975211133,'Sagittarius'],
  [-1975211133,-1975030840,'Capricorn'],
  [-1975030840,-1974840485,'Aquarius'],
  [-1974840485,-1974639731,'Pisces'],
  [-1974639731,-1974430193,'Aries'],
  [-1974430193,-1974214116,'Taurus'],
  [-1974214116,-1973994451,'Gemini'],
  [-1973994451,-1973776223,'Cancer'],
  [-1973776223,-1973566188,'Leo'],
  [-1973566188,-1973369567,'Virgo'],
  [-1973369567,-1973186716,'Libra'],
  [-1973186716,-1973013310,'Scorpio'],
  [-1973013310,-1972842684,'Sagittarius'],
  [-1972842684,-1972667895,'Capricorn'],
  [-1972667895,-1972483273,'Aquarius'],
  [-1972483273,-1972285934,'Pisces'],
  [-1972285934,-1972076784,'Aries'],
  [-1972076784,-1971859856,'Taurus'],
  [-1971859856,-1971640107,'Gemini'],
  [-1971640107,-1971422268,'Cancer'],
  [-1971422268,-1971210861,'Leo'],
  [-1971210861,-1971009871,'Virgo'],
  [-1971009871,-1970821135,'Libra'],
  [-1970821135,-1970643027,'Scorpio'],
  [-1970643027,-1970470898,'Sagittarius'],
  [-1970470898,-1970298401,'Capricorn'],
  [-1970298401,-1970118880,'Aquarius'],
  [-1970118880,-1969927029,'Pisces'],
  [-1969927029,-1969721166,'Aries'],
  [-1969721166,-1969504837,'Taurus'],
  [-1969504837,-1969285051,'Gemini'],
  [-1969285051,-1969068224,'Cancer'],
  [-1969068224,-1968858051,'Leo'],
  [-1968858051,-1968656152,'Virgo'],
  [-1968656152,-1968463309,'Libra'],
  [-1968463309,-1968279308,'Scorpio'],
  [-1968279308,-1968102134,'Sagittarius'],
  [-1968102134,-1967927572,'Capricorn'],
  [-1967927572,-1967749690,'Aquarius'],
  [-1967749690,-1967562208,'Pisces'],
  [-1967562208,-1967360934,'Aries'],
  [-1967360934,-1967146946,'Taurus'],
  [-1967146946,-1966927398,'Gemini'],
  [-1966927398,-1966711076,'Cancer'],
  [-1966711076,-1966502980,'Leo'],
  [-1966502980,-1966303448,'Virgo'],
  [-1966303448,-1966110818,'Libra'],
  [-1966110818,-1965923691,'Scorpio'],
  [-1965923691,-1965741154,'Sagittarius'],
  [-1965741154,-1965561523,'Capricorn'],
  [-1965561523,-1965381134,'Aquarius'],
  [-1965381134,-1965194579,'Pisces'],
  [-1965194579,-1964996635,'Aries'],
  [-1964996635,-1964785695,'Taurus'],
  [-1964785695,-1964566842,'Gemini'],
  [-1964566842,-1964349902,'Cancer'],
  [-1964349902,-1964142493,'Leo'],
  [-1964142493,-1963945894,'Virgo'],
  [-1963945894,-1963756930,'Libra'],
  [-1963756930,-1963571663,'Scorpio'],
  [-1963571663,-1963387603,'Sagittarius'],
  [-1963387603,-1963203679,'Capricorn'],
  [-1963203679,-1963018562,'Aquarius'],
  [-1963018562,-1962829264,'Pisces'],
  [-1962829264,-1962631593,'Aries'],
  [-1962631593,-1962422711,'Taurus'],
  [-1962422711,-1962204868,'Gemini'],
  [-1962204868,-1961986519,'Cancer'],
  [-1961986519,-1961777237,'Leo'],
  [-1961777237,-1961581035,'Virgo'],
  [-1961581035,-1961395469,'Libra'],
  [-1961395469,-1961215109,'Scorpio'],
  [-1961215109,-1961034811,'Sagittarius'],
  [-1961034811,-1960851393,'Capricorn'],
  [-1960851393,-1960663514,'Aquarius'],
  [-1960663514,-1960470236,'Pisces'],
  [-1960470236,-1960269944,'Aries'],
  [-1960269944,-1960060919,'Taurus'],
  [-1960060919,-1959843842,'Gemini'],
  [-1959843842,-1959624336,'Cancer'],
  [-1959624336,-1959411462,'Leo'],
  [-1959411462,-1959211899,'Virgo'],
  [-1959211899,-1959025956,'Libra'],
  [-1959025956,-1958848940,'Scorpio'],
  [-1958848940,-1958674405,'Sagittarius'],
  [-1958674405,-1958496473,'Capricorn'],
  [-1958496473,-1958311181,'Aquarius'],
  [-1958311181,-1958116887,'Pisces'],
  [-1958116887,-1957913718,'Aries'],
  [-1957913718,-1957702673,'Taurus'],
  [-1957702673,-1957485452,'Gemini'],
  [-1957485452,-1957265751,'Cancer'],
  [-1957265751,-1957049974,'Leo'],
  [-1957049974,-1956845044,'Virgo'],
  [-1956845044,-1956654294,'Libra'],
  [-1956654294,-1956475805,'Scorpio'],
  [-1956475805,-1956304026,'Sagittarius'],
  [-1956304026,-1956132042,'Capricorn'],
  [-1956132042,-1955953304,'Aquarius'],
  [-1955953304,-1955763194,'Pisces'],
  [-1955763194,-1955560532,'Aries'],
  [-1955560532,-1955347851,'Taurus'],
  [-1955347851,-1955129616,'Gemini'],
  [-1955129616,-1954910265,'Cancer'],
  [-1954910265,-1954694004,'Leo'],
  [-1954694004,-1954485368,'Virgo'],
  [-1954485368,-1954288314,'Libra'],
  [-1954288314,-1954103961,'Scorpio'],
  [-1954103961,-1953929576,'Sagittarius'],
  [-1953929576,-1953759344,'Capricorn'],
  [-1953759344,-1953585994,'Aquarius'],
  [-1953585994,-1953402554,'Pisces'],
  [-1953402554,-1953204703,'Aries'],
  [-1953204703,-1952993350,'Taurus'],
  [-1952993350,-1952774508,'Gemini'],
  [-1952774508,-1952555281,'Cancer'],
  [-1952555281,-1952340260,'Leo'],
  [-1952340260,-1952131650,'Virgo'],
  [-1952131650,-1951931241,'Libra'],
  [-1951931241,-1951740685,'Scorpio'],
  [-1951740685,-1951560036,'Sagittarius'],
  [-1951560036,-1951386292,'Capricorn'],
  [-1951386292,-1951213515,'Aquarius'],
  [-1951213515,-1951034362,'Pisces'],
  [-1951034362,-1950842371,'Aries'],
  [-1950842371,-1950635284,'Taurus'],
  [-1950635284,-1950417630,'Gemini'],
  [-1950417630,-1950198310,'Cancer'],
  [-1950198310,-1949984377,'Leo'],
  [-1949984377,-1949778059,'Virgo'],
  [-1949778059,-1949578820,'Libra'],
  [-1949578820,-1949386195,'Scorpio'],
  [-1949386195,-1949200368,'Sagittarius'],
  [-1949200368,-1949020674,'Capricorn'],
  [-1949020674,-1948843891,'Aquarius'],
  [-1948843891,-1948664273,'Pisces'],
  [-1948664273,-1948475277,'Aries'],
  [-1948475277,-1948272556,'Taurus'],
  [-1948272556,-1948057612,'Gemini'],
  [-1948057612,-1947838481,'Cancer'],
  [-1947838481,-1947624406,'Leo'],
  [-1947624406,-1947419789,'Virgo'],
  [-1947419789,-1947223825,'Libra'],
  [-1947223825,-1947033790,'Scorpio'],
  [-1947033790,-1946847648,'Sagittarius'],
  [-1946847648,-1946664366,'Capricorn'],
  [-1946664366,-1946482509,'Aquarius'],
  [-1946482509,-1946298898,'Pisces'],
  [-1946298898,-1946108801,'Aries'],
  [-1946108801,-1945907877,'Taurus'],
  [-1945907877,-1945695421,'Gemini'],
  [-1945695421,-1945476846,'Cancer'],
  [-1945476846,-1945261484,'Leo'],
  [-1945261484,-1945056283,'Virgo'],
  [-1945056283,-1944862272,'Libra'],
  [-1944862272,-1944676279,'Scorpio'],
  [-1944676279,-1944494078,'Sagittarius'],
  [-1944494078,-1944312273,'Capricorn'],
  [-1944312273,-1944128586,'Aquarius'],
  [-1944128586,-1943941091,'Pisces'],
  [-1943941091,-1943747481,'Aries'],
  [-1943747481,-1943545311,'Taurus'],
  [-1943545311,-1943333675,'Gemini'],
  [-1943333675,-1943115631,'Cancer'],
  [-1943115631,-1942898571,'Leo'],
  [-1942898571,-1942690552,'Virgo'],
  [-1942690552,-1942495323,'Libra'],
  [-1942495323,-1942311246,'Scorpio'],
  [-1942311246,-1942133559,'Sagittarius'],
  [-1942133559,-1941956758,'Capricorn'],
  [-1941956758,-1941776105,'Aquarius'],
  [-1941776105,-1941588399,'Pisces'],
  [-1941588399,-1941392173,'Aries'],
  [-1941392173,-1941187328,'Taurus'],
  [-1941187328,-1940974726,'Gemini'],
  [-1940974726,-1940756790,'Cancer'],
  [-1940756790,-1940538507,'Leo'],
  [-1940538507,-1940326850,'Virgo'],
  [-1940326850,-1940127486,'Libra'],
  [-1940127486,-1939941503,'Scorpio'],
  [-1939941503,-1939765461,'Sagittarius'],
  [-1939765461,-1939593308,'Capricorn'],
  [-1939593308,-1939418332,'Aquarius'],
  [-1939418332,-1939234811,'Pisces'],
  [-1939234811,-1939039648,'Aries'],
  [-1939039648,-1938833361,'Taurus'],
  [-1938833361,-1938619136,'Gemini'],
  [-1938619136,-1938400811,'Cancer'],
  [-1938400811,-1938182249,'Leo'],
  [-1938182249,-1937968114,'Virgo'],
  [-1937968114,-1937763766,'Libra'],
  [-1937763766,-1937572650,'Scorpio'],
  [-1937572650,-1937394006,'Sagittarius'],
  [-1937394006,-1937222994,'Capricorn'],
  [-1937222994,-1937052450,'Aquarius'],
  [-1937052450,-1936874857,'Pisces'],
  [-1936874857,-1936684499,'Aries'],
  [-1936684499,-1936480032,'Taurus'],
  [-1936480032,-1936265295,'Gemini'],
  [-1936265295,-1936046430,'Cancer'],
  [-1936046430,-1935828284,'Leo'],
  [-1935828284,-1935613963,'Virgo'],
  [-1935613963,-1935406661,'Libra'],
  [-1935406661,-1935209941,'Scorpio'],
  [-1935209941,-1935025514,'Sagittarius'],
  [-1935025514,-1934851180,'Capricorn'],
  [-1934851180,-1934681041,'Aquarius'],
  [-1934681041,-1934507358,'Pisces'],
  [-1934507358,-1934322731,'Aries'],
  [-1934322731,-1934123026,'Taurus'],
  [-1934123026,-1933910190,'Gemini'],
  [-1933910190,-1933691323,'Cancer'],
  [-1933691323,-1933473614,'Leo'],
  [-1933473614,-1933260736,'Virgo'],
  [-1933260736,-1933053978,'Libra'],
  [-1933053978,-1932854759,'Scorpio'],
  [-1932854759,-1932664886,'Sagittarius'],
  [-1932664886,-1932484499,'Capricorn'],
  [-1932484499,-1932310338,'Aquarius'],
  [-1932310338,-1932136187,'Pisces'],
  [-1932136187,-1931954715,'Aries'],
  [-1931954715,-1931760046,'Taurus'],
  [-1931760046,-1931551126,'Gemini'],
  [-1931551126,-1931333437,'Cancer'],
  [-1931333437,-1931115709,'Leo'],
  [-1931115709,-1930904033,'Virgo'],
  [-1930904033,-1930699906,'Libra'],
  [-1930699906,-1930502590,'Scorpio'],
  [-1930502590,-1930311558,'Sagittarius'],
  [-1930311558,-1930126680,'Capricorn'],
  [-1930126680,-1929946683,'Aquarius'],
  [-1929946683,-1929768023,'Pisces'],
  [-1929768023,-1929585288,'Aries'],
  [-1929585288,-1929392878,'Taurus'],
  [-1929392878,-1929187749,'Gemini'],
  [-1929187749,-1928972286,'Cancer'],
  [-1928972286,-1928754248,'Leo'],
  [-1928754248,-1928542005,'Virgo'],
  [-1928542005,-1928339493,'Libra'],
  [-1928339493,-1928145943,'Scorpio'],
  [-1928145943,-1927958531,'Sagittarius'],
  [-1927958531,-1927774498,'Capricorn'],
  [-1927774498,-1927591701,'Aquarius'],
  [-1927591701,-1927408040,'Pisces'],
  [-1927408040,-1927220793,'Aries'],
  [-1927220793,-1927026649,'Taurus'],
  [-1927026649,-1926822857,'Gemini'],
  [-1926822857,-1926609491,'Cancer'],
  [-1926609491,-1926391386,'Leo'],
  [-1926391386,-1926176879,'Virgo'],
  [-1926176879,-1925972819,'Libra'],
  [-1925972819,-1925780822,'Scorpio'],
  [-1925780822,-1925597927,'Sagittarius'],
  [-1925597927,-1925419105,'Capricorn'],
  [-1925419105,-1925239380,'Aquarius'],
  [-1925239380,-1925055087,'Pisces'],
  [-1925055087,-1924864276,'Aries'],
  [-1924864276,-1924666253,'Taurus'],
  [-1924666253,-1924460739,'Gemini'],
  [-1924460739,-1924247942,'Cancer'],
  [-1924247942,-1924030157,'Leo'],
  [-1924030157,-1923813255,'Virgo'],
  [-1923813255,-1923604997,'Libra'],
  [-1923604997,-1923410264,'Scorpio'],
  [-1923410264,-1923228360,'Sagittarius'],
  [-1923228360,-1923054133,'Capricorn'],
  [-1923054133,-1922880605,'Aquarius'],
  [-1922880605,-1922701264,'Pisces'],
  [-1922701264,-1922511958,'Aries'],
  [-1922511958,-1922312101,'Taurus'],
  [-1922312101,-1922103849,'Gemini'],
  [-1922103849,-1921889830,'Cancer'],
  [-1921889830,-1921672229,'Leo'],
  [-1921672229,-1921454308,'Virgo'],
  [-1921454308,-1921241962,'Libra'],
  [-1921241962,-1921041599,'Scorpio'],
  [-1921041599,-1920855831,'Sagittarius'],
  [-1920855831,-1920681631,'Capricorn'],
  [-1920681631,-1920512072,'Aquarius'],
  [-1920512072,-1920339093,'Pisces'],
  [-1920339093,-1920155809,'Aries'],
  [-1920155809,-1919958981,'Taurus'],
  [-1919958981,-1919750394,'Gemini'],
  [-1919750394,-1919534911,'Cancer'],
  [-1919534911,-1919316941,'Leo'],
  [-1919316941,-1919099360,'Virgo'],
  [-1919099360,-1918885515,'Libra'],
  [-1918885515,-1918680418,'Scorpio'],
  [-1918680418,-1918488361,'Sagittarius'],
  [-1918488361,-1918309434,'Capricorn'],
  [-1918309434,-1918138770,'Aquarius'],
  [-1918138770,-1917968708,'Pisces'],
  [-1917968708,-1917791256,'Aries'],
  [-1917791256,-1917600535,'Taurus'],
  [-1917600535,-1917395475,'Gemini'],
  [-1917395475,-1917180446,'Cancer'],
  [-1917180446,-1916962051,'Leo'],
  [-1916962051,-1916745117,'Virgo'],
  [-1916745117,-1916532298,'Libra'],
  [-1916532298,-1916326149,'Scorpio'],
  [-1916326149,-1916129730,'Sagittarius'],
  [-1916129730,-1915944622,'Capricorn'],
  [-1915944622,-1915768771,'Aquarius'],
  [-1915768771,-1915596638,'Pisces'],
  [-1915596638,-1915421016,'Aries'],
  [-1915421016,-1915235166,'Taurus'],
  [-1915235166,-1915035373,'Gemini'],
  [-1915035373,-1914823244,'Cancer'],
  [-1914823244,-1914605241,'Leo'],
  [-1914605241,-1914388534,'Virgo'],
  [-1914388534,-1914177372,'Libra'],
  [-1914177372,-1913973300,'Scorpio'],
  [-1913973300,-1913776925,'Sagittarius'],
  [-1913776925,-1913588546,'Capricorn'],
  [-1913588546,-1913407228,'Aquarius'],
  [-1913407228,-1913229920,'Pisces'],
  [-1913229920,-1913051670,'Aries'],
  [-1913051670,-1912866780,'Taurus'],
  [-1912866780,-1912670659,'Gemini'],
  [-1912670659,-1912462215,'Cancer'],
  [-1912462215,-1912245583,'Leo'],
  [-1912245583,-1912028576,'Virgo'],
  [-1912028576,-1911817948,'Libra'],
  [-1911817948,-1911616415,'Scorpio'],
  [-1911616415,-1911423267,'Sagittarius'],
  [-1911423267,-1911236331,'Capricorn'],
  [-1911236331,-1911053232,'Aquarius'],
  [-1911053232,-1910871574,'Pisces'],
  [-1910871574,-1910688610,'Aries'],
  [-1910688610,-1910501000,'Taurus'],
  [-1910501000,-1910305231,'Gemini'],
  [-1910305231,-1910099116,'Cancer'],
  [-1910099116,-1909884102,'Leo'],
  [-1909884102,-1909666477,'Virgo'],
  [-1909666477,-1909454565,'Libra'],
  [-1909454565,-1909253606,'Scorpio'],
  [-1909253606,-1909063619,'Sagittarius'],
  [-1909063619,-1908880930,'Capricorn'],
  [-1908880930,-1908700729,'Aquarius'],
  [-1908700729,-1908518931,'Pisces'],
  [-1908518931,-1908332959,'Aries'],
  [-1908332959,-1908141445,'Taurus'],
  [-1908141445,-1907943252,'Gemini'],
  [-1907943252,-1907737106,'Cancer'],
  [-1907737106,-1907523031,'Leo'],
  [-1907523031,-1907304804,'Virgo'],
  [-1907304804,-1907090258,'Libra'],
  [-1907090258,-1906886969,'Scorpio'],
  [-1906886969,-1906697332,'Sagittarius'],
  [-1906697332,-1906518062,'Capricorn'],
  [-1906518062,-1906342879,'Aquarius'],
  [-1906342879,-1906165324,'Pisces'],
  [-1906165324,-1905980806,'Aries'],
  [-1905980806,-1905787685,'Taurus'],
  [-1905787685,-1905586616,'Gemini'],
  [-1905586616,-1905378627,'Cancer'],
  [-1905378627,-1905164360,'Leo'],
  [-1905164360,-1904945815,'Virgo'],
  [-1904945815,-1904728673,'Libra'],
  [-1904728673,-1904521011,'Scorpio'],
  [-1904521011,-1904328007,'Sagittarius'],
  [-1904328007,-1904148556,'Capricorn'],
  [-1904148556,-1903976656,'Aquarius'],
  [-1903976656,-1903804581,'Pisces'],
  [-1903804581,-1903625395,'Aries'],
  [-1903625395,-1903435082,'Taurus'],
  [-1903435082,-1903233672,'Gemini'],
  [-1903233672,-1903023882,'Cancer'],
  [-1903023882,-1902808572,'Leo'],
  [-1902808572,-1902589977,'Virgo'],
  [-1902589977,-1902371693,'Libra'],
  [-1902371693,-1902160044,'Scorpio'],
  [-1902160044,-1901961381,'Sagittarius'],
  [-1901961381,-1901777540,'Capricorn'],
  [-1901777540,-1901604613,'Aquarius'],
  [-1901604613,-1901435322,'Pisces'],
  [-1901435322,-1901261727,'Aries'],
  [-1901261727,-1901077409,'Taurus'],
  [-1901077409,-1900879682,'Gemini'],
  [-1900879682,-1900670426,'Cancer'],
  [-1900670426,-1900454264,'Leo'],
  [-1900454264,-1900235608,'Virgo'],
  [-1900235608,-1900017865,'Libra'],
  [-1900017865,-1899805008,'Scorpio'],
  [-1899805008,-1899601859,'Sagittarius'],
  [-1899601859,-1899411648,'Capricorn'],
  [-1899411648,-1899233396,'Aquarius'],
  [-1899233396,-1899062043,'Pisces'],
  [-1899062043,-1898890456,'Aries'],
  [-1898890456,-1898711426,'Taurus'],
  [-1898711426,-1898519716,'Gemini'],
  [-1898519716,-1898314241,'Cancer'],
  [-1898314241,-1898098830,'Leo'],
  [-1898098830,-1897880011,'Virgo'],
  [-1897880011,-1897663305,'Libra'],
  [-1897663305,-1897452086,'Scorpio'],
  [-1897452086,-1897248570,'Sagittarius'],
  [-1897248570,-1897054408,'Capricorn'],
  [-1897054408,-1896869810,'Aquarius'],
  [-1896869810,-1896692516,'Pisces'],
  [-1896692516,-1896517904,'Aries'],
  [-1896517904,-1896339966,'Taurus'],
  [-1896339966,-1896152762,'Gemini'],
  [-1896152762,-1895952486,'Cancer'],
  [-1895952486,-1895739944,'Leo'],
  [-1895739944,-1895521329,'Virgo'],
  [-1895521329,-1895304770,'Libra'],
  [-1895304770,-1895095613,'Scorpio'],
  [-1895095613,-1894895128,'Sagittarius'],
  [-1894895128,-1894702195,'Capricorn'],
  [-1894702195,-1894515173,'Aquarius'],
  [-1894515173,-1894332433,'Pisces'],
  [-1894332433,-1894151894,'Aries'],
  [-1894151894,-1893970335,'Taurus'],
  [-1893970335,-1893783316,'Gemini'],
  [-1893783316,-1893586328,'Cancer'],
  [-1893586328,-1893377334,'Leo'],
  [-1893377334,-1893159753,'Virgo'],
  [-1893159753,-1892942204,'Libra'],
  [-1892942204,-1892733034,'Scorpio'],
  [-1892733034,-1892535251,'Sagittarius'],
  [-1892535251,-1892346619,'Capricorn'],
  [-1892346619,-1892162755,'Aquarius'],
  [-1892162755,-1891979800,'Pisces'],
  [-1891979800,-1891795535,'Aries'],
  [-1891795535,-1891608841,'Taurus'],
  [-1891608841,-1891418149,'Gemini'],
  [-1891418149,-1891220637,'Cancer'],
  [-1891220637,-1891013529,'Leo'],
  [-1891013529,-1890797353,'Virgo'],
  [-1890797353,-1890578552,'Libra'],
  [-1890578552,-1890366864,'Scorpio'],
  [-1890366864,-1890168450,'Sagittarius'],
  [-1890168450,-1889982548,'Capricorn'],
  [-1889982548,-1889803749,'Aquarius'],
  [-1889803749,-1889625670,'Pisces'],
  [-1889625670,-1889443516,'Aries'],
  [-1889443516,-1889255241,'Taurus'],
  [-1889255241,-1889060801,'Gemini'],
  [-1889060801,-1888860130,'Cancer'],
  [-1888860130,-1888652206,'Leo'],
  [-1888652206,-1888436703,'Virgo'],
  [-1888436703,-1888217251,'Libra'],
  [-1888217251,-1888002207,'Scorpio'],
  [-1888002207,-1887799805,'Sagittarius'],
  [-1887799805,-1887612344,'Capricorn'],
  [-1887612344,-1887435723,'Aquarius'],
  [-1887435723,-1887262831,'Pisces'],
  [-1887262831,-1887086653,'Aries'],
  [-1887086653,-1886902340,'Taurus'],
  [-1886902340,-1886708291,'Gemini'],
  [-1886708291,-1886505416,'Cancer'],
  [-1886505416,-1886295274,'Leo'],
  [-1886295274,-1886079188,'Virgo'],
  [-1886079188,-1885859703,'Libra'],
  [-1885859703,-1885642568,'Scorpio'],
  [-1885642568,-1885435377,'Sagittarius'],
  [-1885435377,-1885242819,'Capricorn'],
  [-1885242819,-1885063647,'Aquarius'],
  [-1885063647,-1884892067,'Pisces'],
  [-1884892067,-1884720683,'Aries'],
  [-1884720683,-1884542698,'Taurus'],
  [-1884542698,-1884353612,'Gemini'],
  [-1884353612,-1884152405,'Cancer'],
  [-1884152405,-1883941318,'Leo'],
  [-1883941318,-1883724142,'Virgo'],
  [-1883724142,-1883504757,'Libra'],
  [-1883504757,-1883287527,'Scorpio'],
  [-1883287527,-1883077673,'Sagittarius'],
  [-1883077673,-1882879732,'Capricorn'],
  [-1882879732,-1882694848,'Aquarius'],
  [-1882694848,-1882519906,'Pisces'],
  [-1882519906,-1882348957,'Aries'],
  [-1882348957,-1882175086,'Taurus'],
  [-1882175086,-1881992002,'Gemini'],
  [-1881992002,-1881795794,'Cancer'],
  [-1881795794,-1881586708,'Leo'],
  [-1881586708,-1881369332,'Virgo'],
  [-1881369332,-1881149949,'Libra'],
  [-1881149949,-1880933786,'Scorpio'],
  [-1880933786,-1880724353,'Sagittarius'],
  [-1880724353,-1880524005,'Capricorn'],
  [-1880524005,-1880333910,'Aquarius'],
  [-1880333910,-1880153144,'Pisces'],
  [-1880153144,-1879978350,'Aries'],
  [-1879978350,-1879804197,'Taurus'],
  [-1879804197,-1879624406,'Gemini'],
  [-1879624406,-1879433329,'Cancer'],
  [-1879433329,-1879228373,'Leo'],
  [-1879228373,-1879012439,'Virgo'],
  [-1879012439,-1878793093,'Libra'],
  [-1878793093,-1878577850,'Scorpio'],
  [-1878577850,-1878370549,'Sagittarius'],
  [-1878370549,-1878171560,'Capricorn'],
  [-1878171560,-1877979974,'Aquarius'],
  [-1877979974,-1877794769,'Pisces'],
  [-1877794769,-1877614496,'Aries'],
  [-1877614496,-1877436354,'Taurus'],
  [-1877436354,-1877255745,'Gemini'],
  [-1877255745,-1877067074,'Cancer'],
  [-1877067074,-1876865952,'Leo'],
  [-1876865952,-1876652544,'Virgo'],
  [-1876652544,-1876433440,'Libra'],
  [-1876433440,-1876218070,'Scorpio'],
  [-1876218070,-1876012351,'Sagittarius'],
  [-1876012351,-1875816489,'Capricorn'],
  [-1875816489,-1875627469,'Aquarius'],
  [-1875627469,-1875442158,'Pisces'],
  [-1875442158,-1875258664,'Aries'],
  [-1875258664,-1875075762,'Taurus'],
  [-1875075762,-1874891308,'Gemini'],
  [-1874891308,-1874701468,'Cancer'],
  [-1874701468,-1874501867,'Leo'],
  [-1874501867,-1874290672,'Virgo'],
  [-1874290672,-1874072007,'Libra'],
  [-1874072007,-1873855325,'Scorpio'],
  [-1873855325,-1873649003,'Sagittarius'],
  [-1873649003,-1873455042,'Capricorn'],
  [-1873455042,-1873269970,'Aquarius'],
  [-1873269970,-1873088550,'Pisces'],
  [-1873088550,-1872906599,'Aries'],
  [-1872906599,-1872721992,'Taurus'],
  [-1872721992,-1872533781,'Gemini'],
  [-1872533781,-1872340505,'Cancer'],
  [-1872340505,-1872139630,'Leo'],
  [-1872139630,-1871929151,'Virgo'],
  [-1871929151,-1871710916,'Libra'],
  [-1871710916,-1871492421,'Scorpio'],
  [-1871492421,-1871283106,'Sagittarius'],
  [-1871283106,-1871087777,'Capricorn'],
  [-1871087777,-1870904529,'Aquarius'],
  [-1870904529,-1870727626,'Pisces'],
  [-1870727626,-1870550835,'Aries'],
  [-1870550835,-1870369472,'Taurus'],
  [-1870369472,-1870181189,'Gemini'],
  [-1870181189,-1869985327,'Cancer'],
  [-1869985327,-1869781699,'Leo'],
  [-1869781699,-1869570176,'Virgo'],
  [-1869570176,-1869352064,'Libra'],
  [-1869352064,-1869132352,'Scorpio'],
  [-1869132352,-1868919172,'Sagittarius'],
  [-1868919172,-1868719238,'Capricorn'],
  [-1868719238,-1868533601,'Aquarius'],
  [-1868533601,-1868358048,'Pisces'],
  [-1868358048,-1868185984,'Aries'],
  [-1868185984,-1868010755,'Taurus'],
  [-1868010755,-1867827204,'Gemini'],
  [-1867827204,-1867632768,'Cancer'],
  [-1867632768,-1867427730,'Leo'],
  [-1867427730,-1867214394,'Virgo'],
  [-1867214394,-1866995854,'Libra'],
  [-1866995854,-1866776089,'Scorpio'],
  [-1866776089,-1866560599,'Sagittarius'],
  [-1866560599,-1866355360,'Capricorn'],
  [-1866355360,-1866163784,'Aquarius'],
  [-1866163784,-1865984699,'Pisces'],
  [-1865984699,-1865813166,'Aries'],
  [-1865813166,-1865642390,'Taurus'],
  [-1865642390,-1865465378,'Gemini'],
  [-1865465378,-1865276595,'Cancer'],
  [-1865276595,-1865073990,'Leo'],
  [-1865073990,-1864860200,'Virgo'],
  [-1864860200,-1864640921,'Libra'],
  [-1864640921,-1864421699,'Scorpio'],
  [-1864421699,-1864206588,'Sagittarius'],
  [-1864206588,-1863998892,'Capricorn'],
  [-1863998892,-1863801540,'Aquarius'],
  [-1863801540,-1863615733,'Pisces'],
  [-1863615733,-1863439638,'Aries'],
  [-1863439638,-1863268343,'Taurus'],
  [-1863268343,-1863094981,'Gemini'],
  [-1863094981,-1862912385,'Cancer'],
  [-1862912385,-1862715447,'Leo'],
  [-1862715447,-1862504242,'Virgo'],
  [-1862504242,-1862284979,'Libra'],
  [-1862284979,-1862065969,'Scorpio'],
  [-1862065969,-1861852548,'Sagittarius'],
  [-1861852548,-1861646279,'Capricorn'],
  [-1861646279,-1861447417,'Aquarius'],
  [-1861447417,-1861256499,'Pisces'],
  [-1861256499,-1861073713,'Aries'],
  [-1861073713,-1860897203,'Taurus'],
  [-1860897203,-1860722239,'Gemini'],
  [-1860722239,-1860542120,'Cancer'],
  [-1860542120,-1860350297,'Leo'],
  [-1860350297,-1860143718,'Virgo'],
  [-1860143718,-1859926165,'Libra'],
  [-1859926165,-1859706966,'Scorpio'],
  [-1859706966,-1859494318,'Sagittarius'],
  [-1859494318,-1859290769,'Capricorn'],
  [-1859290769,-1859094747,'Aquarius'],
  [-1859094747,-1858904100,'Pisces'],
  [-1858904100,-1858717863,'Aries'],
  [-1858717863,-1858535577,'Taurus'],
  [-1858535577,-1858355333,'Gemini'],
  [-1858355333,-1858172801,'Cancer'],
  [-1858172801,-1857982247,'Leo'],
  [-1857982247,-1857779230,'Virgo'],
  [-1857779230,-1857564390,'Libra'],
  [-1857564390,-1857345195,'Scorpio'],
  [-1857345195,-1857131543,'Sagittarius'],
  [-1857131543,-1856928810,'Capricorn'],
  [-1856928810,-1856736168,'Aquarius'],
  [-1856736168,-1856549732,'Pisces'],
  [-1856549732,-1856365815,'Aries'],
  [-1856365815,-1856182269,'Taurus'],
  [-1856182269,-1855997831,'Gemini'],
  [-1855997831,-1855810602,'Cancer'],
  [-1855810602,-1855617377,'Leo'],
  [-1855617377,-1855414718,'Virgo'],
  [-1855414718,-1855201744,'Libra'],
  [-1855201744,-1854982949,'Scorpio'],
  [-1854982949,-1854767270,'Sagittarius'],
  [-1854767270,-1854562407,'Capricorn'],
  [-1854562407,-1854370192,'Aquarius'],
  [-1854370192,-1854187344,'Pisces'],
  [-1854187344,-1854008612,'Aries'],
  [-1854008612,-1853829153,'Taurus'],
  [-1853829153,-1853645593,'Gemini'],
  [-1853645593,-1853455981,'Cancer'],
  [-1853455981,-1853259132,'Leo'],
  [-1853259132,-1853054167,'Virgo'],
  [-1853054167,-1852841107,'Libra'],
  [-1852841107,-1852622681,'Scorpio'],
  [-1852622681,-1852405251,'Sagittarius'],
  [-1852405251,-1852196550,'Capricorn'],
  [-1852196550,-1852001103,'Aquarius'],
  [-1852001103,-1851818072,'Pisces'],
  [-1851818072,-1851642744,'Aries'],
  [-1851642744,-1851468897,'Taurus'],
  [-1851468897,-1851290591,'Gemini'],
  [-1851290591,-1851103495,'Cancer'],
  [-1851103495,-1850905847,'Leo'],
  [-1850905847,-1850698530,'Virgo'],
  [-1850698530,-1850483998,'Libra'],
  [-1850483998,-1850265494,'Scorpio'],
  [-1850265494,-1850047387,'Sagittarius'],
  [-1850047387,-1849835388,'Capricorn'],
  [-1849835388,-1849634846,'Aquarius'],
  [-1849634846,-1849447719,'Pisces'],
  [-1849447719,-1849271553,'Aries'],
  [-1849271553,-1849100631,'Taurus'],
  [-1849100631,-1848927849,'Gemini'],
  [-1848927849,-1848746496,'Cancer'],
  [-1848746496,-1848552271,'Leo'],
  [-1848552271,-1848345229,'Virgo'],
  [-1848345229,-1848129538,'Libra'],
  [-1848129538,-1847910602,'Scorpio'],
  [-1847910602,-1847692794,'Sagittarius'],
  [-1847692794,-1847479682,'Capricorn'],
  [-1847479682,-1847275120,'Aquarius'],
  [-1847275120,-1847082279,'Pisces'],
  [-1847082279,-1846901452,'Aries'],
  [-1846901452,-1846729045,'Taurus'],
  [-1846729045,-1846558510,'Gemini'],
  [-1846558510,-1846382209,'Cancer'],
  [-1846382209,-1846193583,'Leo'],
  [-1846193583,-1845990064,'Virgo'],
  [-1845990064,-1845775086,'Libra'],
  [-1845775086,-1845555898,'Scorpio'],
  [-1845555898,-1845338713,'Sagittarius'],
  [-1845338713,-1845126609,'Capricorn'],
  [-1845126609,-1844921208,'Aquarius'],
  [-1844921208,-1844724453,'Pisces'],
  [-1844724453,-1844537874,'Aries'],
  [-1844537874,-1844360497,'Taurus'],
  [-1844360497,-1844187855,'Gemini'],
  [-1844187855,-1844013041,'Cancer'],
  [-1844013041,-1843828741,'Leo'],
  [-1843828741,-1843630080,'Virgo'],
  [-1843630080,-1843417911,'Libra'],
  [-1843417911,-1843199212,'Scorpio'],
  [-1843199212,-1842982322,'Sagittarius'],
  [-1842982322,-1842771840,'Capricorn'],
  [-1842771840,-1842568466,'Aquarius'],
  [-1842568466,-1842371821,'Pisces'],
  [-1842371821,-1842182147,'Aries'],
  [-1842182147,-1841999484,'Taurus'],
  [-1841999484,-1841821801,'Gemini'],
  [-1841821801,-1841644363,'Cancer'],
  [-1841644363,-1841460833,'Leo'],
  [-1841460833,-1841265576,'Virgo'],
  [-1841265576,-1841056930,'Libra'],
  [-1841056930,-1840839571,'Scorpio'],
  [-1840839571,-1840622369,'Sagittarius'],
  [-1840622369,-1840412382,'Capricorn'],
  [-1840412382,-1840211511,'Aquarius'],
  [-1840211511,-1840018136,'Pisces'],
  [-1840018136,-1839830032,'Aries'],
  [-1839830032,-1839645669,'Taurus'],
  [-1839645669,-1839463623,'Gemini'],
  [-1839463623,-1839281374,'Cancer'],
  [-1839281374,-1839094949,'Leo'],
  [-1839094949,-1838899889,'Virgo'],
  [-1838899889,-1838693534,'Libra'],
  [-1838693534,-1838477824,'Scorpio'],
  [-1838477824,-1838259927,'Sagittarius'],
  [-1838259927,-1838048414,'Capricorn'],
  [-1838048414,-1837847884,'Aquarius'],
  [-1837847884,-1837657657,'Pisces'],
  [-1837657657,-1837474091,'Aries'],
  [-1837474091,-1837293038,'Taurus'],
  [-1837293038,-1837111108,'Gemini'],
  [-1837111108,-1836925831,'Cancer'],
  [-1836925831,-1836735217,'Leo'],
  [-1836735217,-1836537379,'Virgo'],
  [-1836537379,-1836330867,'Libra'],
  [-1836330867,-1836116219,'Scorpio'],
  [-1836116219,-1835897798,'Sagittarius'],
  [-1835897798,-1835683337,'Capricorn'],
  [-1835683337,-1835479839,'Aquarius'],
  [-1835479839,-1835289426,'Pisces'],
  [-1835289426,-1835109239,'Aries'],
  [-1835109239,-1834933712,'Taurus'],
  [-1834933712,-1834756800,'Gemini'],
  [-1834756800,-1834573625,'Cancer'],
  [-1834573625,-1834381604,'Leo'],
  [-1834381604,-1834180605,'Virgo'],
  [-1834180605,-1833971878,'Libra'],
  [-1833971878,-1833757010,'Scorpio'],
  [-1833757010,-1833538560,'Sagittarius'],
  [-1833538560,-1833321590,'Capricorn'],
  [-1833321590,-1833113145,'Aquarius'],
  [-1833113145,-1832918319,'Pisces'],
  [-1832918319,-1832737067,'Aries'],
  [-1832737067,-1832564565,'Taurus'],
  [-1832564565,-1832393563,'Gemini'],
  [-1832393563,-1832216679,'Cancer'],
  [-1832216679,-1832028517,'Leo'],
  [-1832028517,-1831827723,'Virgo'],
  [-1831827723,-1831617095,'Libra'],
  [-1831617095,-1831400927,'Scorpio'],
  [-1831400927,-1831182579,'Sagittarius'],
  [-1831182579,-1830965016,'Capricorn'],
  [-1830965016,-1830752872,'Aquarius'],
  [-1830752872,-1830551825,'Pisces'],
  [-1830551825,-1830364975,'Aries'],
  [-1830364975,-1830190271,'Taurus'],
  [-1830190271,-1830021338,'Gemini'],
  [-1830021338,-1829850011,'Cancer'],
  [-1829850011,-1829668634,'Leo'],
  [-1829668634,-1829472733,'Virgo'],
  [-1829472733,-1829263439,'Libra'],
  [-1829263439,-1829046485,'Scorpio'],
  [-1829046485,-1828827901,'Sagittarius'],
  [-1828827901,-1828611191,'Capricorn'],
  [-1828611191,-1828398733,'Aquarius'],
  [-1828398733,-1828193982,'Pisces'],
  [-1828193982,-1828000650,'Aries'],
  [-1828000650,-1827819653,'Taurus'],
  [-1827819653,-1827647358,'Gemini'],
  [-1827647358,-1827476815,'Cancer'],
  [-1827476815,-1827300064,'Leo'],
  [-1827300064,-1827110537,'Virgo'],
  [-1827110537,-1826906068,'Libra'],
  [-1826906068,-1826690644,'Scorpio'],
  [-1826690644,-1826471888,'Sagittarius'],
  [-1826471888,-1826255921,'Capricorn'],
  [-1826255921,-1826045381,'Aquarius'],
  [-1826045381,-1825841407,'Pisces'],
  [-1825841407,-1825645472,'Aries'],
  [-1825645472,-1825458751,'Taurus'],
  [-1825458751,-1825280135,'Gemini'],
  [-1825280135,-1825105412,'Cancer'],
  [-1825105412,-1824928269,'Leo'],
  [-1824928269,-1824742170,'Virgo'],
  [-1824742170,-1824542846,'Libra'],
  [-1824542846,-1824331010,'Scorpio'],
  [-1824331010,-1824112963,'Sagittarius'],
  [-1824112963,-1823896850,'Capricorn'],
  [-1823896850,-1823687766,'Aquarius'],
  [-1823687766,-1823486832,'Pisces'],
  [-1823486832,-1823293170,'Aries'],
  [-1823293170,-1823105606,'Taurus'],
  [-1823105606,-1822922780,'Gemini'],
  [-1822922780,-1822742419,'Cancer'],
  [-1822742419,-1822560903,'Leo'],
  [-1822560903,-1822373670,'Virgo'],
  [-1822373670,-1822176564,'Libra'],
  [-1822176564,-1821968077,'Scorpio'],
  [-1821968077,-1821751540,'Sagittarius'],
  [-1821751540,-1821534660,'Capricorn'],
  [-1821534660,-1821325021,'Aquarius'],
  [-1821325021,-1821125922,'Pisces'],
  [-1821125922,-1820936189,'Aries'],
  [-1820936189,-1820752331,'Taurus'],
  [-1820752331,-1820570571,'Gemini'],
  [-1820570571,-1820387853,'Cancer'],
  [-1820387853,-1820201907,'Leo'],
  [-1820201907,-1820010750,'Virgo'],
  [-1820010750,-1819812282,'Libra'],
  [-1819812282,-1819604949,'Scorpio'],
  [-1819604949,-1819389746,'Sagittarius'],
  [-1819389746,-1819172030,'Capricorn'],
  [-1819172030,-1818960008,'Aquarius'],
  [-1818960008,-1818759742,'Pisces'],
  [-1818759742,-1818571873,'Aries'],
  [-1818571873,-1818392421,'Taurus'],
  [-1818392421,-1818215463,'Gemini'],
  [-1818215463,-1818035501,'Cancer'],
  [-1818035501,-1817848995,'Leo'],
  [-1817848995,-1817654830,'Virgo'],
  [-1817654830,-1817453322,'Libra'],
  [-1817453322,-1817244822,'Scorpio'],
  [-1817244822,-1817029957,'Sagittarius'],
  [-1817029957,-1816811715,'Capricorn'],
  [-1816811715,-1816596780,'Aquarius'],
  [-1816596780,-1816392736,'Pisces'],
  [-1816392736,-1816203023,'Aries'],
  [-1816203023,-1816025127,'Taurus'],
  [-1816025127,-1815852630,'Gemini'],
  [-1815852630,-1815678150,'Cancer'],
  [-1815678150,-1815495672,'Leo'],
  [-1815495672,-1815302412,'Virgo'],
  [-1815302412,-1815099238,'Libra'],
  [-1815099238,-1814888760,'Scorpio'],
  [-1814888760,-1814673224,'Sagittarius'],
  [-1814673224,-1814454847,'Capricorn'],
  [-1814454847,-1814238017,'Aquarius'],
  [-1814238017,-1814029582,'Pisces'],
  [-1814029582,-1813835046,'Aries'],
  [-1813835046,-1813654588,'Taurus'],
  [-1813654588,-1813483065,'Gemini'],
  [-1813483065,-1813312778,'Cancer'],
  [-1813312778,-1813136064,'Leo'],
  [-1813136064,-1812947570,'Virgo'],
  [-1812947570,-1812746241,'Libra'],
  [-1812746241,-1812535126,'Scorpio'],
  [-1812535126,-1812318666,'Sagittarius'],
  [-1812318666,-1812100355,'Capricorn'],
  [-1812100355,-1811883390,'Aquarius'],
  [-1811883390,-1811672427,'Pisces'],
  [-1811672427,-1811472734,'Aries'],
  [-1811472734,-1811286749,'Taurus'],
  [-1811286749,-1811111914,'Gemini'],
  [-1811111914,-1810941863,'Cancer'],
  [-1810941863,-1810768875,'Leo'],
  [-1810768875,-1810586038,'Virgo'],
  [-1810586038,-1810389573,'Libra'],
  [-1810389573,-1810180542,'Scorpio'],
  [-1810180542,-1809964005,'Sagittarius'],
  [-1809964005,-1809745732,'Capricorn'],
  [-1809745732,-1809529813,'Aquarius'],
  [-1809529813,-1809319305,'Pisces'],
  [-1809319305,-1809117284,'Aries'],
  [-1809117284,-1808926093,'Taurus'],
  [-1808926093,-1808745367,'Gemini'],
  [-1808745367,-1808571315,'Cancer'],
  [-1808571315,-1808397811,'Leo'],
  [-1808397811,-1808218100,'Virgo'],
  [-1808218100,-1808026743,'Libra'],
  [-1808026743,-1807821913,'Scorpio'],
  [-1807821913,-1807606879,'Sagittarius'],
  [-1807606879,-1807388591,'Capricorn'],
  [-1807388591,-1807173545,'Aquarius'],
  [-1807173545,-1806965272,'Pisces'],
  [-1806965272,-1806764859,'Aries'],
  [-1806764859,-1806572339,'Taurus'],
  [-1806572339,-1806387076,'Gemini'],
  [-1806387076,-1806207204,'Cancer'],
  [-1806207204,-1806029248,'Leo'],
  [-1806029248,-1805848378,'Virgo'],
  [-1805848378,-1805659402,'Libra'],
  [-1805659402,-1805458609,'Scorpio'],
  [-1805458609,-1805246289,'Sagittarius'],
  [-1805246289,-1805028166,'Capricorn'],
  [-1805028166,-1804812713,'Aquarius'],
  [-1804812713,-1804605914,'Pisces'],
  [-1804605914,-1804408926,'Aries'],
  [-1804408926,-1804219540,'Taurus'],
  [-1804219540,-1804034634,'Gemini'],
  [-1804034634,-1803851605,'Cancer'],
  [-1803851605,-1803668475,'Leo'],
  [-1803668475,-1803483125,'Virgo'],
  [-1803483125,-1803292550,'Libra'],
  [-1803292550,-1803093265,'Scorpio'],
  [-1803093265,-1802883422,'Sagittarius'],
  [-1802883422,-1802665859,'Capricorn'],
  [-1802665859,-1802448725,'Aquarius'],
  [-1802448725,-1802240718,'Pisces'],
  [-1802240718,-1802045361,'Aries'],
  [-1802045361,-1801860265,'Taurus'],
  [-1801860265,-1801680072,'Gemini'],
  [-1801680072,-1801499505,'Cancer'],
  [-1801499505,-1801315187,'Leo'],
  [-1801315187,-1801125928,'Virgo'],
  [-1801125928,-1800931359,'Libra'],
  [-1800931359,-1800730329,'Scorpio'],
  [-1800730329,-1800521156,'Sagittarius'],
  [-1800521156,-1800304304,'Capricorn'],
  [-1800304304,-1800085367,'Aquarius'],
  [-1800085367,-1799873701,'Pisces'],
  [-1799873701,-1799676010,'Aries'],
  [-1799676010,-1799492104,'Taurus'],
  [-1799492104,-1799316453,'Gemini'],
  [-1799316453,-1799141817,'Cancer'],
  [-1799141817,-1798962014,'Leo'],
  [-1798962014,-1798773757,'Virgo'],
  [-1798773757,-1798576949,'Libra'],
  [-1798576949,-1798372864,'Scorpio'],
  [-1798372864,-1798162220,'Sagittarius'],
  [-1798162220,-1797945520,'Capricorn'],
  [-1797945520,-1797725817,'Aquarius'],
  [-1797725817,-1797510403,'Pisces'],
  [-1797510403,-1797307380,'Aries'],
  [-1797307380,-1797119869,'Taurus'],
  [-1797119869,-1796944430,'Gemini'],
  [-1796944430,-1796773908,'Cancer'],
  [-1796773908,-1796600567,'Leo'],
  [-1796600567,-1796418286,'Virgo'],
  [-1796418286,-1796224314,'Libra'],
  [-1796224314,-1796019593,'Scorpio'],
  [-1796019593,-1795807062,'Sagittarius'],
  [-1795807062,-1795589613,'Capricorn'],
  [-1795589613,-1795370105,'Aquarius'],
  [-1795370105,-1795153220,'Pisces'],
  [-1795153220,-1794945440,'Aries'],
  [-1794945440,-1794751581,'Taurus'],
  [-1794751581,-1794571400,'Gemini'],
  [-1794571400,-1794399879,'Cancer'],
  [-1794399879,-1794229751,'Leo'],
  [-1794229751,-1794053707,'Virgo'],
  [-1794053707,-1793866200,'Libra'],
  [-1793866200,-1793665226,'Scorpio'],
  [-1793665226,-1793453077,'Sagittarius'],
  [-1793453077,-1793234842,'Capricorn'],
  [-1793234842,-1793015613,'Aquarius'],
  [-1793015613,-1792799561,'Pisces'],
  [-1792799561,-1792590549,'Aries'],
  [-1792590549,-1792392014,'Taurus'],
  [-1792392014,-1792205292,'Gemini'],
  [-1792205292,-1792028328,'Cancer'],
  [-1792028328,-1791856150,'Leo'],
  [-1791856150,-1791682264,'Virgo'],
  [-1791682264,-1791500154,'Libra'],
  [-1791500154,-1791305087,'Scorpio'],
  [-1791305087,-1791096405,'Sagittarius'],
  [-1791096405,-1790878732,'Capricorn'],
  [-1790878732,-1790659516,'Aquarius'],
  [-1790659516,-1790444837,'Pisces'],
  [-1790444837,-1790237676,'Aries'],
  [-1790237676,-1790038886,'Taurus'],
  [-1790038886,-1789848465,'Gemini'],
  [-1789848465,-1789665550,'Cancer'],
  [-1789665550,-1789487845,'Leo'],
  [-1789487845,-1789311270,'Virgo'],
  [-1789311270,-1789130335,'Libra'],
  [-1789130335,-1788939430,'Scorpio'],
  [-1788939430,-1788735228,'Sagittarius'],
  [-1788735228,-1788519706,'Capricorn'],
  [-1788519706,-1788300516,'Aquarius'],
  [-1788300516,-1788086263,'Pisces'],
  [-1788086263,-1787881390,'Aries'],
  [-1787881390,-1787685547,'Taurus'],
  [-1787685547,-1787496245,'Gemini'],
  [-1787496245,-1787311149,'Cancer'],
  [-1787311149,-1787128653,'Leo'],
  [-1787128653,-1786947027,'Virgo'],
  [-1786947027,-1786763205,'Libra'],
  [-1786763205,-1786572690,'Scorpio'],
  [-1786572690,-1786371254,'Sagittarius'],
  [-1786371254,-1786158233,'Capricorn'],
  [-1786158233,-1785939281,'Aquarius'],
  [-1785939281,-1785724100,'Pisces'],
  [-1785724100,-1785519703,'Aries'],
  [-1785519703,-1785326727,'Taurus'],
  [-1785326727,-1785141349,'Gemini'],
  [-1785141349,-1784958845,'Cancer'],
  [-1784958845,-1784775884,'Leo'],
  [-1784775884,-1784590918,'Virgo'],
  [-1784590918,-1784402885,'Libra'],
  [-1784402885,-1784209655,'Scorpio'],
  [-1784209655,-1784008102,'Sagittarius'],
  [-1784008102,-1783796468,'Capricorn'],
  [-1783796468,-1783577845,'Aquarius'],
  [-1783577845,-1783360857,'Pisces'],
  [-1783360857,-1783154430,'Aries'],
  [-1783154430,-1782961659,'Taurus'],
  [-1782961659,-1782779368,'Gemini'],
  [-1782779368,-1782601553,'Cancer'],
  [-1782601553,-1782422548,'Leo'],
  [-1782422548,-1782238773,'Virgo'],
  [-1782238773,-1782048888,'Libra'],
  [-1782048888,-1781852461,'Scorpio'],
  [-1781852461,-1781648683,'Sagittarius'],
  [-1781648683,-1781436742,'Capricorn'],
  [-1781436742,-1781218288,'Aquarius'],
  [-1781218288,-1780999609,'Pisces'],
  [-1780999609,-1780789531,'Aries'],
  [-1780789531,-1780593628,'Taurus'],
  [-1780593628,-1780411007,'Gemini'],
  [-1780411007,-1780236199,'Cancer'],
  [-1780236199,-1780062391,'Leo'],
  [-1780062391,-1779883670,'Virgo'],
  [-1779883670,-1779696370,'Libra'],
  [-1779696370,-1779499402,'Scorpio'],
  [-1779499402,-1779293480,'Sagittarius'],
  [-1779293480,-1779080087,'Capricorn'],
  [-1779080087,-1778861469,'Aquarius'],
  [-1778861469,-1778642089,'Pisces'],
  [-1778642089,-1778428765,'Aries'],
  [-1778428765,-1778227772,'Taurus'],
  [-1778227772,-1778040975,'Gemini'],
  [-1778040975,-1777865119,'Cancer'],
  [-1777865119,-1777693995,'Leo'],
  [-1777693995,-1777520672,'Virgo'],
  [-1777520672,-1777339115,'Libra'],
  [-1777339115,-1777145663,'Scorpio'],
  [-1777145663,-1776940126,'Sagittarius'],
  [-1776940126,-1776725575,'Capricorn'],
  [-1776725575,-1776506507,'Aquarius'],
  [-1776506507,-1776287488,'Pisces'],
  [-1776287488,-1776073166,'Aries'],
  [-1776073166,-1775868111,'Taurus'],
  [-1775868111,-1775675323,'Gemini'],
  [-1775675323,-1775494390,'Cancer'],
  [-1775494390,-1775321404,'Leo'],
  [-1775321404,-1775150205,'Virgo'],
  [-1775150205,-1774973855,'Libra'],
  [-1774973855,-1774786276,'Scorpio'],
  [-1774786276,-1774584502,'Sagittarius'],
  [-1774584502,-1774370703,'Capricorn'],
  [-1774370703,-1774151283,'Aquarius'],
  [-1774151283,-1773932937,'Pisces'],
  [-1773932937,-1773719912,'Aries'],
  [-1773719912,-1773514327,'Taurus'],
  [-1773514327,-1773317603,'Gemini'],
  [-1773317603,-1773130453,'Cancer'],
  [-1773130453,-1772951781,'Leo'],
  [-1772951781,-1772777902,'Virgo'],
  [-1772777902,-1772602872,'Libra'],
  [-1772602872,-1772419845,'Scorpio'],
  [-1772419845,-1772223367,'Sagittarius'],
  [-1772223367,-1772012707,'Capricorn'],
  [-1772012707,-1771793732,'Aquarius'],
  [-1771793732,-1771575499,'Pisces'],
  [-1771575499,-1771364210,'Aries'],
  [-1771364210,-1771161170,'Taurus'],
  [-1771161170,-1770965190,'Gemini'],
  [-1770965190,-1770775237,'Cancer'],
  [-1770775237,-1770590941,'Leo'],
  [-1770590941,-1770411245,'Virgo'],
  [-1770411245,-1770232845,'Libra'],
  [-1770232845,-1770050187,'Scorpio'],
  [-1770050187,-1769857191,'Sagittarius'],
  [-1769857191,-1769650487,'Capricorn'],
  [-1769650487,-1769433124,'Aquarius'],
  [-1769433124,-1769214339,'Pisces'],
  [-1769214339,-1769003131,'Aries'],
  [-1769003131,-1768802561,'Taurus'],
  [-1768802561,-1768610438,'Gemini'],
  [-1768610438,-1768423074,'Cancer'],
  [-1768423074,-1768237950,'Leo'],
  [-1768237950,-1768054064,'Virgo'],
  [-1768054064,-1767870341,'Libra'],
  [-1767870341,-1767683974,'Scorpio'],
  [-1767683974,-1767490509,'Sagittarius'],
  [-1767490509,-1767285994,'Capricorn'],
  [-1767285994,-1767070655,'Aquarius'],
  [-1767070655,-1766851314,'Pisces'],
  [-1766851314,-1766638040,'Aries'],
  [-1766638040,-1766436977,'Taurus'],
  [-1766436977,-1766247518,'Gemini'],
  [-1766247518,-1766065037,'Cancer'],
  [-1766065037,-1765884416,'Leo'],
  [-1765884416,-1765702066,'Virgo'],
  [-1765702066,-1765516185,'Libra'],
  [-1765516185,-1765325614,'Scorpio'],
  [-1765325614,-1765128664,'Sagittarius'],
  [-1765128664,-1764923251,'Capricorn'],
  [-1764923251,-1764708890,'Aquarius'],
  [-1764708890,-1764489488,'Pisces'],
  [-1764489488,-1764273386,'Aries'],
  [-1764273386,-1764068605,'Taurus'],
  [-1764068605,-1763877692,'Gemini'],
  [-1763877692,-1763697522,'Cancer'],
  [-1763697522,-1763522236,'Leo'],
  [-1763522236,-1763345817,'Virgo'],
  [-1763345817,-1763163601,'Libra'],
  [-1763163601,-1762972983,'Scorpio'],
  [-1762972983,-1762773319,'Sagittarius'],
  [-1762773319,-1762565232,'Capricorn'],
  [-1762565232,-1762350106,'Aquarius'],
  [-1762350106,-1762130862,'Pisces'],
  [-1762130862,-1761913014,'Aries'],
  [-1761913014,-1761703634,'Taurus'],
  [-1761703634,-1761507634,'Gemini'],
  [-1761507634,-1761324962,'Cancer'],
  [-1761324962,-1761151251,'Leo'],
  [-1761151251,-1760979968,'Virgo'],
  [-1760979968,-1760804298,'Libra'],
  [-1760804298,-1760618712,'Scorpio'],
  [-1760618712,-1760420605,'Sagittarius'],
  [-1760420605,-1760211240,'Capricorn'],
  [-1760211240,-1759994608,'Aquarius'],
  [-1759994608,-1759775219,'Pisces'],
  [-1759775219,-1759557281,'Aries'],
  [-1759557281,-1759345286,'Taurus'],
  [-1759345286,-1759143801,'Gemini'],
  [-1759143801,-1758955237,'Cancer'],
  [-1758955237,-1758778164,'Leo'],
  [-1758778164,-1758607546,'Virgo'],
  [-1758607546,-1758436294,'Libra'],
  [-1758436294,-1758257057,'Scorpio'],
  [-1758257057,-1758064355,'Sagittarius'],
  [-1758064355,-1757857263,'Capricorn'],
  [-1757857263,-1757640360,'Aquarius'],
  [-1757640360,-1757420638,'Pisces'],
  [-1757420638,-1757203453,'Aries'],
  [-1757203453,-1756991707,'Taurus'],
  [-1756991707,-1756787673,'Gemini'],
  [-1756787673,-1756593657,'Cancer'],
  [-1756593657,-1756410517,'Leo'],
  [-1756410517,-1756235974,'Virgo'],
  [-1756235974,-1756064481,'Libra'],
  [-1756064481,-1755888687,'Scorpio'],
  [-1755888687,-1755701538,'Sagittarius'],
  [-1755701538,-1755499260,'Capricorn'],
  [-1755499260,-1755284374,'Aquarius'],
  [-1755284374,-1755064779,'Pisces'],
  [-1755064779,-1754848197,'Aries'],
  [-1754848197,-1754638196,'Taurus'],
  [-1754638196,-1754435250,'Gemini'],
  [-1754435250,-1754239528,'Cancer'],
  [-1754239528,-1754051686,'Leo'],
  [-1754051686,-1753871417,'Virgo'],
  [-1753871417,-1753695738,'Libra'],
  [-1753695738,-1753518963,'Scorpio'],
  [-1753518963,-1753334271,'Sagittarius'],
  [-1753334271,-1753136346,'Capricorn'],
  [-1753136346,-1752924878,'Aquarius'],
  [-1752924878,-1752706234,'Pisces'],
  [-1752706234,-1752489629,'Aries'],
  [-1752489629,-1752280867,'Taurus'],
  [-1752280867,-1752080636,'Gemini'],
  [-1752080636,-1751887174,'Cancer'],
  [-1751887174,-1751698965,'Leo'],
  [-1751698965,-1751515214,'Virgo'],
  [-1751515214,-1751334517,'Libra'],
  [-1751334517,-1751153599,'Scorpio'],
  [-1751153599,-1750967475,'Sagittarius'],
  [-1750967475,-1750771141,'Capricorn'],
  [-1750771141,-1750562533,'Aquarius'],
  [-1750562533,-1750345330,'Pisces'],
  [-1750345330,-1750128106,'Aries'],
  [-1750128106,-1749918808,'Taurus'],
  [-1749918808,-1749720162,'Gemini'],
  [-1749720162,-1749530277,'Cancer'],
  [-1749530277,-1749345619,'Leo'],
  [-1749345619,-1749163079,'Virgo'],
  [-1749163079,-1748980387,'Libra'],
  [-1748980387,-1748795420,'Scorpio'],
  [-1748795420,-1748605518,'Sagittarius'],
  [-1748605518,-1748407657,'Capricorn'],
  [-1748407657,-1748199915,'Aquarius'],
  [-1748199915,-1747983882,'Pisces'],
  [-1747983882,-1747765839,'Aries'],
  [-1747765839,-1747554177,'Taurus'],
  [-1747554177,-1747354265,'Gemini'],
  [-1747354265,-1747166028,'Cancer'],
  [-1747166028,-1746985598,'Leo'],
  [-1746985598,-1746807816,'Virgo'],
  [-1746807816,-1746627944,'Libra'],
  [-1746627944,-1746442558,'Scorpio'],
  [-1746442558,-1746249749,'Sagittarius'],
  [-1746249749,-1746048811,'Capricorn'],
  [-1746048811,-1745839811,'Aquarius'],
  [-1745839811,-1745624074,'Pisces'],
  [-1745624074,-1745405513,'Aries'],
  [-1745405513,-1745190854,'Taurus'],
  [-1745190854,-1744986917,'Gemini'],
  [-1744986917,-1744796539,'Cancer'],
  [-1744796539,-1744617509,'Leo'],
  [-1744617509,-1744444266,'Virgo'],
  [-1744444266,-1744270094,'Libra'],
  [-1744270094,-1744088964,'Scorpio'],
  [-1744088964,-1743897206,'Sagittarius'],
  [-1743897206,-1743694565,'Capricorn'],
  [-1743694565,-1743483465,'Aquarius'],
  [-1743483465,-1743267056,'Pisces'],
  [-1743267056,-1743048490,'Aries'],
  [-1743048490,-1742831988,'Taurus'],
  [-1742831988,-1742623373,'Gemini'],
  [-1742623373,-1742427586,'Cancer'],
  [-1742427586,-1742245444,'Leo'],
  [-1742245444,-1742072975,'Virgo'],
  [-1742072975,-1741903173,'Libra'],
  [-1741903173,-1741728240,'Scorpio'],
  [-1741728240,-1741541762,'Sagittarius'],
  [-1741541762,-1741341288,'Capricorn'],
  [-1741341288,-1741129550,'Aquarius'],
  [-1741129550,-1740912121,'Pisces'],
  [-1740912121,-1740693737,'Aries'],
  [-1740693737,-1740477422,'Taurus'],
  [-1740477422,-1740266450,'Gemini'],
  [-1740266450,-1740065167,'Cancer'],
  [-1740065167,-1739876694,'Leo'],
  [-1739876694,-1739700102,'Virgo'],
  [-1739700102,-1739530066,'Libra'],
  [-1739530066,-1739358822,'Scorpio'],
  [-1739358822,-1739178447,'Sagittarius'],
  [-1739178447,-1738983575,'Capricorn'],
  [-1738983575,-1738774443,'Aquarius'],
  [-1738774443,-1738556997,'Pisces'],
  [-1738556997,-1738338548,'Aries'],
  [-1738338548,-1738123480,'Taurus'],
  [-1738123480,-1737913544,'Gemini'],
  [-1737913544,-1737710487,'Cancer'],
  [-1737710487,-1737516773,'Leo'],
  [-1737516773,-1737333575,'Virgo'],
  [-1737333575,-1737158546,'Libra'],
  [-1737158546,-1736985887,'Scorpio'],
  [-1736985887,-1736808163,'Sagittarius'],
  [-1736808163,-1736618658,'Capricorn'],
  [-1736618658,-1736414497,'Aquarius'],
  [-1736414497,-1736199111,'Pisces'],
  [-1736199111,-1735980578,'Aries'],
  [-1735980578,-1735766077,'Taurus'],
  [-1735766077,-1735558504,'Gemini'],
  [-1735558504,-1735357890,'Cancer'],
  [-1735357890,-1735163965,'Leo'],
  [-1735163965,-1734976839,'Virgo'],
  [-1734976839,-1734795733,'Libra'],
  [-1734795733,-1734617672,'Scorpio'],
  [-1734617672,-1734437570,'Sagittarius'],
  [-1734437570,-1734249596,'Capricorn'],
  [-1734249596,-1734049497,'Aquarius'],
  [-1734049497,-1733837467,'Pisces'],
  [-1733837467,-1733619466,'Aries'],
  [-1733619466,-1733404143,'Taurus'],
  [-1733404143,-1733197324,'Gemini'],
  [-1733197324,-1732999971,'Cancer'],
  [-1732999971,-1732810027,'Leo'],
  [-1732810027,-1732624754,'Virgo'],
  [-1732624754,-1732441790,'Libra'],
  [-1732441790,-1732258984,'Scorpio'],
  [-1732258984,-1732073795,'Sagittarius'],
  [-1732073795,-1731883035,'Capricorn'],
  [-1731883035,-1731683522,'Aquarius'],
  [-1731683522,-1731473905,'Pisces'],
  [-1731473905,-1731256994,'Aries'],
  [-1731256994,-1731040131,'Taurus'],
  [-1731040131,-1730831351,'Gemini'],
  [-1730831351,-1730634509,'Cancer'],
  [-1730634509,-1730448263,'Leo'],
  [-1730448263,-1730268143,'Virgo'],
  [-1730268143,-1730088993,'Libra'],
  [-1730088993,-1729906616,'Scorpio'],
  [-1729906616,-1729718516,'Sagittarius'],
  [-1729718516,-1729523674,'Capricorn'],
  [-1729523674,-1729321612,'Aquarius'],
  [-1729321612,-1729111984,'Pisces'],
  [-1729111984,-1728895861,'Aries'],
  [-1728895861,-1728677779,'Taurus'],
  [-1728677779,-1728465465,'Gemini'],
  [-1728465465,-1728265492,'Cancer'],
  [-1728265492,-1728079198,'Leo'],
  [-1728079198,-1727902646,'Virgo'],
  [-1727902646,-1727729182,'Libra'],
  [-1727729182,-1727552034,'Scorpio'],
  [-1727552034,-1727366312,'Sagittarius'],
  [-1727366312,-1727170395,'Capricorn'],
  [-1727170395,-1726965611,'Aquarius'],
  [-1726965611,-1726754164,'Pisces'],
  [-1726754164,-1726537862,'Aries'],
  [-1726537862,-1726319337,'Taurus'],
  [-1726319337,-1726104041,'Gemini'],
  [-1726104041,-1725899091,'Cancer'],
  [-1725899091,-1725708714,'Leo'],
  [-1725708714,-1725531365,'Virgo'],
  [-1725531365,-1725360875,'Libra'],
  [-1725360875,-1725189344,'Scorpio'],
  [-1725189344,-1725009559,'Sagittarius'],
  [-1725009559,-1724817264,'Capricorn'],
  [-1724817264,-1724612789,'Aquarius'],
  [-1724612789,-1724399918,'Pisces'],
  [-1724399918,-1724182772,'Aries'],
  [-1724182772,-1723964327,'Taurus'],
  [-1723964327,-1723748009,'Gemini'],
  [-1723748009,-1723539180,'Cancer'],
  [-1723539180,-1723343084,'Leo'],
  [-1723343084,-1723160987,'Virgo'],
  [-1723160987,-1722988886,'Libra'],
  [-1722988886,-1722819512,'Scorpio'],
  [-1722819512,-1722644884,'Sagittarius'],
  [-1722644884,-1722458554,'Capricorn'],
  [-1722458554,-1722258083,'Aquarius'],
  [-1722258083,-1722046180,'Pisces'],
  [-1722046180,-1721828572,'Aries'],
  [-1721828572,-1721610316,'Taurus'],
  [-1721610316,-1721394733,'Gemini'],
  [-1721394733,-1721185045,'Cancer'],
  [-1721185045,-1720985042,'Leo'],
  [-1720985042,-1720797110,'Virgo'],
  [-1720797110,-1720619864,'Libra'],
  [-1720619864,-1720448155,'Scorpio'],
  [-1720448155,-1720274883,'Sagittarius'],
  [-1720274883,-1720093035,'Capricorn'],
  [-1720093035,-1719897933,'Aquarius'],
  [-1719897933,-1719689517,'Pisces'],
  [-1719689517,-1719472750,'Aries'],
  [-1719472750,-1719254608,'Taurus'],
  [-1719254608,-1719040229,'Gemini'],
  [-1719040229,-1718832269,'Cancer'],
  [-1718832269,-1718632219,'Leo'],
  [-1718632219,-1718441061,'Virgo'],
  [-1718441061,-1718258377,'Libra'],
  [-1718258377,-1718081416,'Scorpio'],
  [-1718081416,-1717905310,'Sagittarius'],
  [-1717905310,-1717724163,'Capricorn'],
  [-1717724163,-1717532697,'Aquarius'],
  [-1717532697,-1717328448,'Pisces'],
  [-1717328448,-1717113817,'Aries'],
  [-1717113817,-1716895763,'Taurus'],
  [-1716895763,-1716681759,'Gemini'],
  [-1716681759,-1716475947,'Cancer'],
  [-1716475947,-1716278802,'Leo'],
  [-1716278802,-1716088867,'Virgo'],
  [-1716088867,-1715904192,'Libra'],
  [-1715904192,-1715722633,'Scorpio'],
  [-1715722633,-1715541519,'Sagittarius'],
  [-1715541519,-1715357351,'Capricorn'],
  [-1715357351,-1715166085,'Aquarius'],
  [-1715166085,-1714964435,'Pisces'],
  [-1714964435,-1714752214,'Aries'],
  [-1714752214,-1714534339,'Taurus'],
  [-1714534339,-1714319285,'Gemini'],
  [-1714319285,-1714113829,'Cancer'],
  [-1714113829,-1713919559,'Leo'],
  [-1713919559,-1713733694,'Virgo'],
  [-1713733694,-1713551785,'Libra'],
  [-1713551785,-1713369873,'Scorpio'],
  [-1713369873,-1713185398,'Sagittarius'],
  [-1713185398,-1712996858,'Capricorn'],
  [-1712996858,-1712802720,'Aquarius'],
  [-1712802720,-1712600907,'Pisces'],
  [-1712600907,-1712390098,'Aries'],
  [-1712390098,-1712172525,'Taurus'],
  [-1712172525,-1711955432,'Gemini'],
  [-1711955432,-1711747583,'Cancer'],
  [-1711747583,-1711553311,'Leo'],
  [-1711553311,-1711370640,'Virgo'],
  [-1711370640,-1711193759,'Libra'],
  [-1711193759,-1711016224,'Scorpio'],
  [-1711016224,-1710833250,'Sagittarius'],
  [-1710833250,-1710642882,'Capricorn'],
  [-1710642882,-1710445357,'Aquarius'],
  [-1710445357,-1710241141,'Pisces'],
  [-1710241141,-1710030017,'Aries'],
  [-1710030017,-1709812722,'Taurus'],
  [-1709812722,-1709593876,'Gemini'],
  [-1709593876,-1709381908,'Cancer'],
  [-1709381908,-1709183830,'Leo'],
  [-1709183830,-1709000379,'Virgo'],
  [-1709000379,-1708826458,'Libra'],
  [-1708826458,-1708654492,'Scorpio'],
  [-1708654492,-1708477286,'Sagittarius'],
  [-1708477286,-1708290202,'Capricorn'],
  [-1708290202,-1708092450,'Aquarius'],
  [-1708092450,-1707886017,'Pisces'],
  [-1707886017,-1707673255,'Aries'],
  [-1707673255,-1707455846,'Taurus'],
  [-1707455846,-1707236564,'Gemini'],
  [-1707236564,-1707021382,'Cancer'],
  [-1707021382,-1706817638,'Leo'],
  [-1706817638,-1706629055,'Virgo'],
  [-1706629055,-1706453209,'Libra'],
  [-1706453209,-1706283420,'Scorpio'],
  [-1706283420,-1706111751,'Sagittarius'],
  [-1706111751,-1705931253,'Capricorn'],
  [-1705931253,-1705738068,'Aquarius'],
  [-1705738068,-1705532668,'Pisces'],
  [-1705532668,-1705318775,'Aries'],
  [-1705318775,-1705100722,'Taurus'],
  [-1705100722,-1704882000,'Gemini'],
  [-1704882000,-1704666448,'Cancer'],
  [-1704666448,-1704459069,'Leo'],
  [-1704459069,-1704264134,'Virgo'],
  [-1704264134,-1704082157,'Libra'],
  [-1704082157,-1703909194,'Scorpio'],
  [-1703909194,-1703738583,'Sagittarius'],
  [-1703738583,-1703563014,'Capricorn'],
  [-1703563014,-1703376381,'Aquarius'],
  [-1703376381,-1703175870,'Pisces'],
  [-1703175870,-1702963465,'Aries'],
  [-1702963465,-1702745009,'Taurus'],
  [-1702745009,-1702526700,'Gemini'],
  [-1702526700,-1702312795,'Cancer'],
  [-1702312795,-1702105954,'Leo'],
  [-1702105954,-1701908116,'Virgo'],
  [-1701908116,-1701720132,'Libra'],
  [-1701720132,-1701540674,'Scorpio'],
  [-1701540674,-1701365938,'Sagittarius'],
  [-1701365938,-1701190296,'Capricorn'],
  [-1701190296,-1701007534,'Aquarius'],
  [-1701007534,-1700812621,'Pisces'],
  [-1700812621,-1700604237,'Aries'],
  [-1700604237,-1700386723,'Taurus'],
  [-1700386723,-1700168217,'Gemini'],
  [-1700168217,-1699955602,'Cancer'],
  [-1699955602,-1699751612,'Leo'],
  [-1699751612,-1699555746,'Virgo'],
  [-1699555746,-1699366478,'Libra'],
  [-1699366478,-1699182313,'Scorpio'],
  [-1699182313,-1699001548,'Sagittarius'],
  [-1699001548,-1698821434,'Capricorn'],
  [-1698821434,-1698637715,'Aquarius'],
  [-1698637715,-1698445388,'Pisces'],
  [-1698445388,-1698240927,'Aries'],
  [-1698240927,-1698025572,'Taurus'],
  [-1698025572,-1697806689,'Gemini'],
  [-1697806689,-1697593586,'Cancer'],
  [-1697593586,-1697391366,'Leo'],
  [-1697391366,-1697199294,'Virgo'],
  [-1697199294,-1697013503,'Libra'],
  [-1697013503,-1696830059,'Scorpio'],
  [-1696830059,-1696646486,'Sagittarius'],
  [-1696646486,-1696461523,'Capricorn'],
  [-1696461523,-1696273626,'Aquarius'],
  [-1696273626,-1696079860,'Pisces'],
  [-1696079860,-1695876761,'Aries'],
  [-1695876761,-1695663326,'Taurus'],
  [-1695663326,-1695444289,'Gemini'],
  [-1695444289,-1695229174,'Cancer'],
  [-1695229174,-1695025837,'Leo'],
  [-1695025837,-1694835538,'Virgo'],
  [-1694835538,-1694654037,'Libra'],
  [-1694654037,-1694475299,'Scorpio'],
  [-1694475299,-1694294342,'Sagittarius'],
  [-1694294342,-1694108576,'Capricorn'],
  [-1694108576,-1693917350,'Aquarius'],
  [-1693917350,-1693720169,'Pisces'],
  [-1693720169,-1693515620,'Aries'],
  [-1693515620,-1693302622,'Taurus'],
  [-1693302622,-1693083600,'Gemini'],
  [-1693083600,-1692866148,'Cancer'],
  [-1692866148,-1692659273,'Leo'],
  [-1692659273,-1692467071,'Virgo'],
  [-1692467071,-1692286957,'Libra'],
  [-1692286957,-1692112586,'Scorpio'],
  [-1692112586,-1691937138,'Sagittarius'],
  [-1691937138,-1691755452,'Capricorn'],
  [-1691755452,-1691565117,'Aquarius'],
  [-1691565117,-1691366066,'Pisces'],
  [-1691366066,-1691159116,'Aries'],
  [-1691159116,-1690945091,'Taurus'],
  [-1690945091,-1690725994,'Gemini'],
  [-1690725994,-1690507094,'Cancer'],
  [-1690507094,-1690296226,'Leo'],
  [-1690296226,-1690099296,'Virgo'],
  [-1690099296,-1689916468,'Libra'],
  [-1689916468,-1689742890,'Scorpio'],
  [-1689742890,-1689571591,'Sagittarius'],
  [-1689571591,-1689395772,'Capricorn'],
  [-1689395772,-1689210399,'Aquarius'],
  [-1689210399,-1689013362,'Pisces'],
  [-1689013362,-1688805666,'Aries'],
  [-1688805666,-1688590322,'Taurus'],
  [-1688590322,-1688370948,'Gemini'],
  [-1688370948,-1688151927,'Cancer'],
  [-1688151927,-1687938800,'Leo'],
  [-1687938800,-1687736921,'Virgo'],
  [-1687736921,-1687548570,'Libra'],
  [-1687548570,-1687371546,'Scorpio'],
  [-1687371546,-1687200393,'Sagittarius'],
  [-1687200393,-1687028313,'Capricorn'],
  [-1687028313,-1686848729,'Aquarius'],
  [-1686848729,-1686656869,'Pisces'],
  [-1686656869,-1686451579,'Aries'],
  [-1686451579,-1686236160,'Taurus'],
  [-1686236160,-1686016501,'Gemini'],
  [-1686016501,-1685798179,'Cancer'],
  [-1685798179,-1685585373,'Leo'],
  [-1685585373,-1685381182,'Virgo'],
  [-1685381182,-1685187656,'Libra'],
  [-1685187656,-1685004719,'Scorpio'],
  [-1685004719,-1684829549,'Sagittarius'],
  [-1684829549,-1684656986,'Capricorn'],
  [-1684656986,-1684480565,'Aquarius'],
  [-1684480565,-1684293980,'Pisces'],
  [-1684293980,-1684093353,'Aries'],
  [-1684093353,-1683879939,'Taurus'],
  [-1683879939,-1683660407,'Gemini'],
  [-1683660407,-1683442697,'Cancer'],
  [-1683442697,-1683231705,'Leo'],
  [-1683231705,-1683028745,'Virgo'],
  [-1683028745,-1682833627,'Libra'],
  [-1682833627,-1682645998,'Scorpio'],
  [-1682645998,-1682464973,'Sagittarius'],
  [-1682464973,-1682288041,'Capricorn'],
  [-1682288041,-1682110536,'Aquarius'],
  [-1682110536,-1681926371,'Pisces'],
  [-1681926371,-1681730064,'Aries'],
  [-1681730064,-1681520047,'Taurus'],
  [-1681520047,-1681301391,'Gemini'],
  [-1681301391,-1681083554,'Cancer'],
  [-1681083554,-1680873822,'Leo'],
  [-1680873822,-1680673779,'Virgo'],
  [-1680673779,-1680481202,'Libra'],
  [-1680481202,-1680293398,'Scorpio'],
  [-1680293398,-1680108840,'Sagittarius'],
  [-1680108840,-1679926606,'Capricorn'],
  [-1679926606,-1679744653,'Aquarius'],
  [-1679744653,-1679558890,'Pisces'],
  [-1679558890,-1679364162,'Aries'],
  [-1679364162,-1679157098,'Taurus'],
  [-1679157098,-1678939910,'Gemini'],
  [-1678939910,-1678721250,'Cancer'],
  [-1678721250,-1678510689,'Leo'],
  [-1678510689,-1678312146,'Virgo'],
  [-1678312146,-1678123390,'Libra'],
  [-1678123390,-1677939653,'Scorpio'],
  [-1677939653,-1677756839,'Sagittarius'],
  [-1677756839,-1677572814,'Capricorn'],
  [-1677572814,-1677386620,'Aquarius'],
  [-1677386620,-1677196690,'Pisces'],
  [-1677196690,-1677000095,'Aries'],
  [-1677000095,-1676793821,'Taurus'],
  [-1676793821,-1676577957,'Gemini'],
  [-1676577957,-1676358470,'Cancer'],
  [-1676358470,-1676145087,'Leo'],
  [-1676145087,-1675944613,'Virgo'],
  [-1675944613,-1675757065,'Libra'],
  [-1675757065,-1675577650,'Scorpio'],
  [-1675577650,-1675400306,'Sagittarius'],
  [-1675400306,-1675220090,'Capricorn'],
  [-1675220090,-1675034180,'Aquarius'],
  [-1675034180,-1674841474,'Pisces'],
  [-1674841474,-1674641426,'Aries'],
  [-1674641426,-1674433446,'Taurus'],
  [-1674433446,-1674217847,'Gemini'],
  [-1674217847,-1673998155,'Cancer'],
  [-1673998155,-1673781790,'Leo'],
  [-1673781790,-1673576590,'Virgo'],
  [-1673576590,-1673385778,'Libra'],
  [-1673385778,-1673206789,'Scorpio'],
  [-1673206789,-1673033703,'Sagittarius'],
  [-1673033703,-1672859826,'Capricorn'],
  [-1672859826,-1672679423,'Aquarius'],
  [-1672679423,-1672488952,'Pisces'],
  [-1672488952,-1672287702,'Aries'],
  [-1672287702,-1672077355,'Taurus'],
  [-1672077355,-1671860715,'Gemini'],
  [-1671860715,-1671641232,'Cancer'],
  [-1671641232,-1671423689,'Leo'],
  [-1671423689,-1671214072,'Virgo'],
  [-1671214072,-1671017156,'Libra'],
  [-1671017156,-1670833647,'Scorpio'],
  [-1670833647,-1670659922,'Sagittarius'],
  [-1670659922,-1670489653,'Capricorn'],
  [-1670489653,-1670315654,'Aquarius'],
  [-1670315654,-1670131547,'Pisces'],
  [-1670131547,-1669933792,'Aries'],
  [-1669933792,-1669723483,'Taurus'],
  [-1669723483,-1669505672,'Gemini'],
  [-1669505672,-1669286167,'Cancer'],
  [-1669286167,-1669069322,'Leo'],
  [-1669069322,-1668858441,'Virgo'],
  [-1668858441,-1668656786,'Libra'],
  [-1668656786,-1668466639,'Scorpio'],
  [-1668466639,-1668287540,'Sagittarius'],
  [-1668287540,-1668115538,'Capricorn'],
  [-1668115538,-1667944069,'Aquarius'],
  [-1667944069,-1667765654,'Pisces'],
  [-1667765654,-1667574072,'Aries'],
  [-1667574072,-1667367429,'Taurus'],
  [-1667367429,-1667150177,'Gemini'],
  [-1667150177,-1666930450,'Cancer'],
  [-1666930450,-1666714675,'Leo'],
  [-1666714675,-1666505401,'Virgo'],
  [-1666505401,-1666303289,'Libra'],
  [-1666303289,-1666109178,'Scorpio'],
  [-1666109178,-1665923835,'Sagittarius'],
  [-1665923835,-1665746190,'Capricorn'],
  [-1665746190,-1665572104,'Aquarius'],
  [-1665572104,-1665395021,'Pisces'],
  [-1665395021,-1665207923,'Aries'],
  [-1665207923,-1665006311,'Taurus'],
  [-1665006311,-1664791770,'Gemini'],
  [-1664791770,-1664572288,'Cancer'],
  [-1664572288,-1664356773,'Leo'],
  [-1664356773,-1664149479,'Virgo'],
  [-1664149479,-1663950071,'Libra'],
  [-1663950071,-1663756892,'Scorpio'],
  [-1663756892,-1663569099,'Sagittarius'],
  [-1663569099,-1663386333,'Capricorn'],
  [-1663386333,-1663206917,'Aquarius'],
  [-1663206917,-1663026736,'Pisces'],
  [-1663026736,-1662839979,'Aries'],
  [-1662839979,-1662641463,'Taurus'],
  [-1662641463,-1662430136,'Gemini'],
  [-1662430136,-1662211588,'Cancer'],
  [-1662211588,-1661995382,'Leo'],
  [-1661995382,-1661788381,'Virgo'],
  [-1661788381,-1661591560,'Libra'],
  [-1661591560,-1661402144,'Scorpio'],
  [-1661402144,-1661216840,'Sagittarius'],
  [-1661216840,-1661033428,'Capricorn'],
  [-1661033428,-1660850399,'Aquarius'],
  [-1660850399,-1660665650,'Pisces'],
  [-1660665650,-1660475807,'Aries'],
  [-1660475807,-1660277036,'Taurus'],
  [-1660277036,-1660067442,'Gemini'],
  [-1660067442,-1659849966,'Cancer'],
  [-1659849966,-1659632579,'Leo'],
  [-1659632579,-1659423692,'Virgo'],
  [-1659423692,-1659226885,'Libra'],
  [-1659226885,-1659040358,'Scorpio'],
  [-1659040358,-1658859660,'Sagittarius'],
  [-1658859660,-1658680154,'Capricorn'],
  [-1658680154,-1658498230,'Aquarius'],
  [-1658498230,-1658311443,'Pisces'],
  [-1658311443,-1658118057,'Aries'],
  [-1658118057,-1657916670,'Taurus'],
  [-1657916670,-1657706631,'Gemini'],
  [-1657706631,-1657489669,'Cancer'],
  [-1657489669,-1657271244,'Leo'],
  [-1657271244,-1657059177,'Virgo'],
  [-1657059177,-1656859313,'Libra'],
  [-1656859313,-1656672338,'Scorpio'],
  [-1656672338,-1656494554,'Sagittarius'],
  [-1656494554,-1656320179,'Capricorn'],
  [-1656320179,-1656143258,'Aquarius'],
  [-1656143258,-1655959049,'Pisces'],
  [-1655959049,-1655765035,'Aries'],
  [-1655765035,-1655561237,'Taurus'],
  [-1655561237,-1655349402,'Gemini'],
  [-1655349402,-1655132134,'Cancer'],
  [-1655132134,-1654913264,'Leo'],
  [-1654913264,-1654698421,'Virgo'],
  [-1654698421,-1654493800,'Libra'],
  [-1654493800,-1654302757,'Scorpio'],
  [-1654302757,-1654123952,'Sagittarius'],
  [-1654123952,-1653952231,'Capricorn'],
  [-1653952231,-1653780597,'Aquarius'],
  [-1653780597,-1653602077,'Pisces'],
  [-1653602077,-1653411664,'Aries'],
  [-1653411664,-1653208308,'Taurus'],
  [-1653208308,-1652995161,'Gemini'],
  [-1652995161,-1652777104,'Cancer'],
  [-1652777104,-1652558351,'Leo'],
  [-1652558351,-1652342561,'Virgo'],
  [-1652342561,-1652134117,'Libra'],
  [-1652134117,-1651937317,'Scorpio'],
  [-1651937317,-1651753632,'Sagittarius'],
  [-1651753632,-1651580193,'Capricorn'],
  [-1651580193,-1651410657,'Aquarius'],
  [-1651410657,-1651237213,'Pisces'],
  [-1651237213,-1651052698,'Aries'],
  [-1651052698,-1650853357,'Taurus'],
  [-1650853357,-1650641211,'Gemini'],
  [-1650641211,-1650422726,'Cancer'],
  [-1650422726,-1650204245,'Leo'],
  [-1650204245,-1649989327,'Virgo'],
  [-1649989327,-1649780130,'Libra'],
  [-1649780130,-1649579359,'Scorpio'],
  [-1649579359,-1649389560,'Sagittarius'],
  [-1649389560,-1649210646,'Capricorn'],
  [-1649210646,-1649038578,'Aquarius'],
  [-1649038578,-1648866429,'Pisces'],
  [-1648866429,-1648686443,'Aries'],
  [-1648686443,-1648492639,'Taurus'],
  [-1648492639,-1648284148,'Gemini'],
  [-1648284148,-1648066543,'Cancer'],
  [-1648066543,-1647848142,'Leo'],
  [-1647848142,-1647634518,'Virgo'],
  [-1647634518,-1647427309,'Libra'],
  [-1647427309,-1647226793,'Scorpio'],
  [-1647226793,-1647033826,'Sagittarius'],
  [-1647033826,-1646849145,'Capricorn'],
  [-1646849145,-1646671307,'Aquarius'],
  [-1646671307,-1646495838,'Pisces'],
  [-1646495838,-1646316252,'Aries'],
  [-1646316252,-1646126132,'Taurus'],
  [-1646126132,-1645922142,'Gemini'],
  [-1645922142,-1645706935,'Cancer'],
  [-1645706935,-1645488543,'Leo'],
  [-1645488543,-1645275047,'Virgo'],
  [-1645275047,-1645069974,'Libra'],
  [-1645069974,-1644872797,'Scorpio'],
  [-1644872797,-1644681759,'Sagittarius'],
  [-1644681759,-1644495566,'Capricorn'],
  [-1644495566,-1644313058,'Aquarius'],
  [-1644313058,-1644132020,'Pisces'],
  [-1644132020,-1643948634,'Aries'],
  [-1643948634,-1643758147,'Taurus'],
  [-1643758147,-1643556752,'Gemini'],
  [-1643556752,-1643344344,'Cancer'],
  [-1643344344,-1643126306,'Leo'],
  [-1643126306,-1642911345,'Virgo'],
  [-1642911345,-1642705965,'Libra'],
  [-1642705965,-1642511389,'Scorpio'],
  [-1642511389,-1642324932,'Sagittarius'],
  [-1642324932,-1642142600,'Capricorn'],
  [-1642142600,-1641960799,'Aquarius'],
  [-1641960799,-1641776862,'Pisces'],
  [-1641776862,-1641588757,'Aries'],
  [-1641588757,-1641394557,'Taurus'],
  [-1641394557,-1641192354,'Gemini'],
  [-1641192354,-1640981368,'Cancer'],
  [-1640981368,-1640764050,'Leo'],
  [-1640764050,-1640547066,'Virgo'],
  [-1640547066,-1640338492,'Libra'],
  [-1640338492,-1640142778,'Scorpio'],
  [-1640142778,-1639958852,'Sagittarius'],
  [-1639958852,-1639781818,'Capricorn'],
  [-1639781818,-1639605519,'Aquarius'],
  [-1639605519,-1639424553,'Pisces'],
  [-1639424553,-1639235658,'Aries'],
  [-1639235658,-1639038150,'Taurus'],
  [-1639038150,-1638832939,'Gemini'],
  [-1638832939,-1638621142,'Cancer'],
  [-1638621142,-1638404280,'Leo'],
  [-1638404280,-1638186118,'Virgo'],
  [-1638186118,-1637973467,'Libra'],
  [-1637973467,-1637773011,'Scorpio'],
  [-1637773011,-1637586920,'Sagittarius'],
  [-1637586920,-1637411779,'Capricorn'],
  [-1637411779,-1637240734,'Aquarius'],
  [-1637240734,-1637066182,'Pisces'],
  [-1637066182,-1636881987,'Aries'],
  [-1636881987,-1636685582,'Taurus'],
  [-1636685582,-1636478637,'Gemini'],
  [-1636478637,-1636264936,'Cancer'],
  [-1636264936,-1636047707,'Leo'],
  [-1636047707,-1635829547,'Virgo'],
  [-1635829547,-1635614574,'Libra'],
  [-1635614574,-1635408844,'Scorpio'],
  [-1635408844,-1635216984,'Sagittarius'],
  [-1635216984,-1635038659,'Capricorn'],
  [-1635038659,-1634868459,'Aquarius'],
  [-1634868459,-1634698464,'Pisces'],
  [-1634698464,-1634520755,'Aries'],
  [-1634520755,-1634329844,'Taurus'],
  [-1634329844,-1634125138,'Gemini'],
  [-1634125138,-1633910925,'Cancer'],
  [-1633910925,-1633692950,'Leo'],
  [-1633692950,-1633475220,'Virgo'],
  [-1633475220,-1633260462,'Libra'],
  [-1633260462,-1633052288,'Scorpio'],
  [-1633052288,-1632854967,'Sagittarius'],
  [-1632854967,-1632670488,'Capricorn'],
  [-1632670488,-1632496283,'Aquarius'],
  [-1632496283,-1632326009,'Pisces'],
  [-1632326009,-1632151854,'Aries'],
  [-1632151854,-1631966813,'Taurus'],
  [-1631966813,-1631767346,'Gemini'],
  [-1631767346,-1631555452,'Cancer'],
  [-1631555452,-1631337516,'Leo'],
  [-1631337516,-1631120008,'Virgo'],
  [-1631120008,-1630906676,'Libra'],
  [-1630906676,-1630699530,'Scorpio'],
  [-1630699530,-1630500513,'Sagittarius'],
  [-1630500513,-1630311219,'Capricorn'],
  [-1630311219,-1630131065,'Aquarius'],
  [-1630131065,-1629956339,'Pisces'],
  [-1629956339,-1629781034,'Aries'],
  [-1629781034,-1629598547,'Taurus'],
  [-1629598547,-1629403846,'Gemini'],
  [-1629403846,-1629195987,'Cancer'],
  [-1629195987,-1628979451,'Leo'],
  [-1628979451,-1628761898,'Virgo'],
  [-1628761898,-1628549489,'Libra'],
  [-1628549489,-1628344811,'Scorpio'],
  [-1628344811,-1628147980,'Sagittarius'],
  [-1628147980,-1627958265,'Capricorn'],
  [-1627958265,-1627774490,'Aquarius'],
  [-1627774490,-1627594491,'Pisces'],
  [-1627594491,-1627414739,'Aries'],
  [-1627414739,-1627230637,'Taurus'],
  [-1627230637,-1627037615,'Gemini'],
  [-1627037615,-1626833067,'Cancer'],
  [-1626833067,-1626618656,'Leo'],
  [-1626618656,-1626400948,'Virgo'],
  [-1626400948,-1626188014,'Libra'],
  [-1626188014,-1625984701,'Scorpio'],
  [-1625984701,-1625791250,'Sagittarius'],
  [-1625791250,-1625604944,'Capricorn'],
  [-1625604944,-1625422268,'Aquarius'],
  [-1625422268,-1625240139,'Pisces'],
  [-1625240139,-1625056128,'Aries'],
  [-1625056128,-1624868008,'Taurus'],
  [-1624868008,-1624673290,'Gemini'],
  [-1624673290,-1624469669,'Cancer'],
  [-1624469669,-1624256891,'Leo'],
  [-1624256891,-1624039045,'Virgo'],
  [-1624039045,-1623824194,'Libra'],
  [-1623824194,-1623619689,'Scorpio'],
  [-1623619689,-1623427755,'Sagittarius'],
  [-1623427755,-1623245454,'Capricorn'],
  [-1623245454,-1623067293,'Aquarius'],
  [-1623067293,-1622887819,'Pisces'],
  [-1622887819,-1622703273,'Aries'],
  [-1622703273,-1622512116,'Taurus'],
  [-1622512116,-1622314131,'Gemini'],
  [-1622314131,-1622109040,'Cancer'],
  [-1622109040,-1621896573,'Leo'],
  [-1621896573,-1621678654,'Virgo'],
  [-1621678654,-1621461447,'Libra'],
  [-1621461447,-1621253361,'Scorpio'],
  [-1621253361,-1621059449,'Sagittarius'],
  [-1621059449,-1620878463,'Capricorn'],
  [-1620878463,-1620704567,'Aquarius'],
  [-1620704567,-1620530492,'Pisces'],
  [-1620530492,-1620350016,'Aries'],
  [-1620350016,-1620159836,'Taurus'],
  [-1620159836,-1619960088,'Gemini'],
  [-1619960088,-1619752680,'Cancer'],
  [-1619752680,-1619539227,'Leo'],
  [-1619539227,-1619321236,'Virgo'],
  [-1619321236,-1619102537,'Libra'],
  [-1619102537,-1618890300,'Scorpio'],
  [-1618890300,-1618691406,'Sagittarius'],
  [-1618691406,-1618507522,'Capricorn'],
  [-1618507522,-1618334352,'Aquarius'],
  [-1618334352,-1618164420,'Pisces'],
  [-1618164420,-1617989909,'Aries'],
  [-1617989909,-1617804885,'Taurus'],
  [-1617804885,-1617607321,'Gemini'],
  [-1617607321,-1617399252,'Cancer'],
  [-1617399252,-1617184490,'Leo'],
  [-1617184490,-1616966268,'Virgo'],
  [-1616966268,-1616747551,'Libra'],
  [-1616747551,-1616533077,'Scorpio'],
  [-1616533077,-1616328964,'Sagittarius'],
  [-1616328964,-1616139052,'Capricorn'],
  [-1616139052,-1615961954,'Aquarius'],
  [-1615961954,-1615791831,'Pisces'],
  [-1615791831,-1615620987,'Aries'],
  [-1615620987,-1615442056,'Taurus'],
  [-1615442056,-1615250168,'Gemini'],
  [-1615250168,-1615044886,'Cancer'],
  [-1615044886,-1614830136,'Leo'],
  [-1614830136,-1614611551,'Virgo'],
  [-1614611551,-1614393633,'Libra'],
  [-1614393633,-1614179827,'Scorpio'],
  [-1614179827,-1613973693,'Sagittarius'],
  [-1613973693,-1613778425,'Capricorn'],
  [-1613778425,-1613594753,'Aquarius'],
  [-1613594753,-1613419743,'Pisces'],
  [-1613419743,-1613247660,'Aries'],
  [-1613247660,-1613071627,'Taurus'],
  [-1613071627,-1612885387,'Gemini'],
  [-1612885387,-1612685455,'Cancer'],
  [-1612685455,-1612473186,'Leo'],
  [-1612473186,-1612254680,'Virgo'],
  [-1612254680,-1612037153,'Libra'],
  [-1612037153,-1611825342,'Scorpio'],
  [-1611825342,-1611621155,'Sagittarius'],
  [-1611621155,-1611425070,'Capricorn'],
  [-1611425070,-1611236930,'Aquarius'],
  [-1611236930,-1611055520,'Pisces'],
  [-1611055520,-1610877987,'Aries'],
  [-1610877987,-1610699810,'Taurus'],
  [-1610699810,-1610515500,'Gemini'],
  [-1610515500,-1610320138,'Cancer'],
  [-1610320138,-1610111909,'Leo'],
  [-1610111909,-1609894594,'Virgo'],
  [-1609894594,-1609676583,'Libra'],
  [-1609676583,-1609465555,'Scorpio'],
  [-1609465555,-1609264421,'Sagittarius'],
  [-1609264421,-1609071813,'Capricorn'],
  [-1609071813,-1608884769,'Aquarius'],
  [-1608884769,-1608700697,'Pisces'],
  [-1608700697,-1608517803,'Aries'],
  [-1608517803,-1608334296,'Taurus'],
  [-1608334296,-1608147308,'Gemini'],
  [-1608147308,-1607952864,'Cancer'],
  [-1607952864,-1607747651,'Leo'],
  [-1607747651,-1607532285,'Virgo'],
  [-1607532285,-1607313498,'Libra'],
  [-1607313498,-1607100936,'Scorpio'],
  [-1607100936,-1606900478,'Sagittarius'],
  [-1606900478,-1606711491,'Capricorn'],
  [-1606711491,-1606529238,'Aquarius'],
  [-1606529238,-1606348361,'Pisces'],
  [-1606348361,-1606165122,'Aries'],
  [-1606165122,-1605978005,'Taurus'],
  [-1605978005,-1605786513,'Gemini'],
  [-1605786513,-1605589364,'Cancer'],
  [-1605589364,-1605384276,'Leo'],
  [-1605384276,-1605170266,'Virgo'],
  [-1605170266,-1604951103,'Libra'],
  [-1604951103,-1604735675,'Scorpio'],
  [-1604735675,-1604532428,'Sagittarius'],
  [-1604532428,-1604343520,'Capricorn'],
  [-1604343520,-1604164817,'Aquarius'],
  [-1604164817,-1603989489,'Pisces'],
  [-1603989489,-1603811173,'Aries'],
  [-1603811173,-1603625932,'Taurus'],
  [-1603625932,-1603432810,'Gemini'],
  [-1603432810,-1603232431,'Cancer'],
  [-1603232431,-1603025137,'Leo'],
  [-1603025137,-1602810917,'Virgo'],
  [-1602810917,-1602591782,'Libra'],
  [-1602591782,-1602374046,'Scorpio'],
  [-1602374046,-1602166250,'Sagittarius'],
  [-1602166250,-1601973387,'Capricorn'],
  [-1601973387,-1601793865,'Aquarius'],
  [-1601793865,-1601621512,'Pisces'],
  [-1601621512,-1601448876,'Aries'],
  [-1601448876,-1601269570,'Taurus'],
  [-1601269570,-1601079914,'Gemini'],
  [-1601079914,-1600879540,'Cancer'],
  [-1600879540,-1600670348,'Leo'],
  [-1600670348,-1600454824,'Virgo'],
  [-1600454824,-1600235671,'Libra'],
  [-1600235671,-1600017270,'Scorpio'],
  [-1600017270,-1599806036,'Sagittarius'],
  [-1599806036,-1599607635,'Capricorn'],
  [-1599607635,-1599423286,'Aquarius'],
  [-1599423286,-1599249193,'Pisces'],
  [-1599249193,-1599078738,'Aries'],
  [-1599078738,-1598904756,'Taurus'],
  [-1598904756,-1598721251,'Gemini'],
  [-1598721251,-1598525012,'Cancer'],
  [-1598525012,-1598316723,'Leo'],
  [-1598316723,-1598100385,'Virgo'],
  [-1598100385,-1597881016,'Libra'],
  [-1597881016,-1597663239,'Scorpio'],
  [-1597663239,-1597451357,'Sagittarius'],
  [-1597451357,-1597249274,'Capricorn'],
  [-1597249274,-1597059112,'Aquarius'],
  [-1597059112,-1596879714,'Pisces'],
  [-1596879714,-1596706799,'Aries'],
  [-1596706799,-1596534215,'Taurus'],
  [-1596534215,-1596355352,'Gemini'],
  [-1596355352,-1596164757,'Cancer'],
  [-1596164757,-1595960293,'Leo'],
  [-1595960293,-1595744927,'Virgo'],
  [-1595744927,-1595525457,'Libra'],
  [-1595525457,-1595308551,'Scorpio'],
  [-1595308551,-1595098231,'Sagittarius'],
  [-1595098231,-1594896130,'Capricorn'],
  [-1594896130,-1594702811,'Aquarius'],
  [-1594702811,-1594517937,'Pisces'],
  [-1594517937,-1594339654,'Aries'],
  [-1594339654,-1594164171,'Taurus'],
  [-1594164171,-1593986009,'Gemini'],
  [-1593986009,-1593799153,'Cancer'],
  [-1593799153,-1593599214,'Leo'],
  [-1593599214,-1593386496,'Virgo'],
  [-1593386496,-1593167393,'Libra'],
  [-1593167393,-1592950737,'Scorpio'],
  [-1592950737,-1592742240,'Sagittarius'],
  [-1592742240,-1592542762,'Capricorn'],
  [-1592542762,-1592350524,'Aquarius'],
  [-1592350524,-1592163610,'Pisces'],
  [-1592163610,-1591980681,'Aries'],
  [-1591980681,-1591800146,'Taurus'],
  [-1591800146,-1591618904,'Gemini'],
  [-1591618904,-1591432157,'Cancer'],
  [-1591432157,-1591234907,'Leo'],
  [-1591234907,-1591025091,'Virgo'],
  [-1591025091,-1590806832,'Libra'],
  [-1590806832,-1590589492,'Scorpio'],
  [-1590589492,-1590381267,'Sagittarius'],
  [-1590381267,-1590184304,'Capricorn'],
  [-1590184304,-1589995744,'Aquarius'],
  [-1589995744,-1589811317,'Pisces'],
  [-1589811317,-1589627875,'Aries'],
  [-1589627875,-1589443907,'Taurus'],
  [-1589443907,-1589258246,'Gemini'],
  [-1589258246,-1589068482,'Cancer'],
  [-1589068482,-1588870906,'Leo'],
  [-1588870906,-1588662656,'Virgo'],
  [-1588662656,-1588445330,'Libra'],
  [-1588445330,-1588226703,'Scorpio'],
  [-1588226703,-1588016487,'Sagittarius'],
  [-1588016487,-1587819473,'Capricorn'],
  [-1587819473,-1587633771,'Aquarius'],
  [-1587633771,-1587453967,'Pisces'],
  [-1587453967,-1587274537,'Aries'],
  [-1587274537,-1587091801,'Taurus'],
  [-1587091801,-1586904172,'Gemini'],
  [-1586904172,-1586710876,'Cancer'],
  [-1586710876,-1586510635,'Leo'],
  [-1586510635,-1586301879,'Virgo'],
  [-1586301879,-1586085043,'Libra'],
  [-1586085043,-1585865317,'Scorpio'],
  [-1585865317,-1585651679,'Sagittarius'],
  [-1585651679,-1585451246,'Capricorn'],
  [-1585451246,-1585264803,'Aquarius'],
  [-1585264803,-1585087802,'Pisces'],
  [-1585087802,-1584913686,'Aries'],
  [-1584913686,-1584736371,'Taurus'],
  [-1584736371,-1584551706,'Gemini'],
  [-1584551706,-1584357965,'Cancer'],
  [-1584357965,-1584155249,'Leo'],
  [-1584155249,-1583944516,'Virgo'],
  [-1583944516,-1583727352,'Libra'],
  [-1583727352,-1583507326,'Scorpio'],
  [-1583507326,-1583290909,'Sagittarius'],
  [-1583290909,-1583085272,'Capricorn'],
  [-1583085272,-1582894012,'Aquarius'],
  [-1582894012,-1582715281,'Pisces'],
  [-1582715281,-1582543498,'Aries'],
  [-1582543498,-1582371739,'Taurus'],
  [-1582371739,-1582193478,'Gemini'],
  [-1582193478,-1582004087,'Cancer'],
  [-1582004087,-1581802217,'Leo'],
  [-1581802217,-1581590092,'Virgo'],
  [-1581590092,-1581371944,'Libra'],
  [-1581371944,-1581152194,'Scorpio'],
  [-1581152194,-1580935282,'Sagittarius'],
  [-1580935282,-1580726010,'Capricorn'],
  [-1580726010,-1580528478,'Aquarius'],
  [-1580528478,-1580343788,'Pisces'],
  [-1580343788,-1580169166,'Aries'],
  [-1580169166,-1579998881,'Taurus'],
  [-1579998881,-1579825812,'Gemini'],
  [-1579825812,-1579643072,'Cancer'],
  [-1579643072,-1579446184,'Leo'],
  [-1579446184,-1579235599,'Virgo'],
  [-1579235599,-1579016934,'Libra'],
  [-1579016934,-1578797313,'Scorpio'],
  [-1578797313,-1578581671,'Sagittarius'],
  [-1578581671,-1578372497,'Capricorn'],
  [-1578372497,-1578171615,'Aquarius'],
  [-1578171615,-1577980582,'Pisces'],
  [-1577980582,-1577799419,'Aries'],
  [-1577799419,-1577625304,'Taurus'],
  [-1577625304,-1577452584,'Gemini'],
  [-1577452584,-1577274087,'Cancer'],
  [-1577274087,-1577083223,'Leo'],
  [-1577083223,-1576877186,'Virgo'],
  [-1576877186,-1576659869,'Libra'],
  [-1576659869,-1576440128,'Scorpio'],
  [-1576440128,-1576225558,'Sagittarius'],
  [-1576225558,-1576018818,'Capricorn'],
  [-1576018818,-1575819334,'Aquarius'],
  [-1575819334,-1575626333,'Pisces'],
  [-1575626333,-1575439824,'Aries'],
  [-1575439824,-1575259359,'Taurus'],
  [-1575259359,-1575082189,'Gemini'],
  [-1575082189,-1574902927,'Cancer'],
  [-1574902927,-1574715024,'Leo'],
  [-1574715024,-1574513616,'Virgo'],
  [-1574513616,-1574299345,'Libra'],
  [-1574299345,-1574079858,'Scorpio'],
  [-1574079858,-1573864960,'Sagittarius'],
  [-1573864960,-1573659819,'Capricorn'],
  [-1573659819,-1573463802,'Aquarius'],
  [-1573463802,-1573273820,'Pisces'],
  [-1573273820,-1573087382,'Aries'],
  [-1573087382,-1572903387,'Taurus'],
  [-1572903387,-1572720824,'Gemini'],
  [-1572720824,-1572537066,'Cancer'],
  [-1572537066,-1572347642,'Leo'],
  [-1572347642,-1572147931,'Virgo'],
  [-1572147931,-1571936423,'Libra'],
  [-1571936423,-1571717785,'Scorpio'],
  [-1571717785,-1571501483,'Sagittarius'],
  [-1571501483,-1571295330,'Capricorn'],
  [-1571295330,-1571100952,'Aquarius'],
  [-1571100952,-1570915110,'Pisces'],
  [-1570915110,-1570733151,'Aries'],
  [-1570733151,-1570551325,'Taurus'],
  [-1570551325,-1570367362,'Gemini'],
  [-1570367362,-1570179675,'Cancer'],
  [-1570179675,-1569986320,'Leo'],
  [-1569986320,-1569784911,'Virgo'],
  [-1569784911,-1569574122,'Libra'],
  [-1569574122,-1569356319,'Scorpio'],
  [-1569356319,-1569138552,'Sagittarius'],
  [-1569138552,-1568929281,'Capricorn'],
  [-1568929281,-1568732999,'Aquarius'],
  [-1568732999,-1568548470,'Pisces'],
  [-1568548470,-1568370887,'Aries'],
  [-1568370887,-1568194519,'Taurus'],
  [-1568194519,-1568014407,'Gemini'],
  [-1568014407,-1567827237,'Cancer'],
  [-1567827237,-1567631520,'Leo'],
  [-1567631520,-1567427192,'Virgo'],
  [-1567427192,-1567215092,'Libra'],
  [-1567215092,-1566997436,'Scorpio'],
  [-1566997436,-1566778890,'Sagittarius'],
  [-1566778890,-1566566254,'Capricorn'],
  [-1566566254,-1566365473,'Aquarius'],
  [-1566365473,-1566178191,'Pisces'],
  [-1566178191,-1566001399,'Aries'],
  [-1566001399,-1565829240,'Taurus'],
  [-1565829240,-1565654992,'Gemini'],
  [-1565654992,-1565472716,'Cancer'],
  [-1565472716,-1565278870,'Leo'],
  [-1565278870,-1565073504,'Virgo'],
  [-1565073504,-1564859680,'Libra'],
  [-1564859680,-1564641468,'Scorpio'],
  [-1564641468,-1564422919,'Sagittarius'],
  [-1564422919,-1564208479,'Capricorn'],
  [-1564208479,-1564003162,'Aquarius'],
  [-1564003162,-1563810496,'Pisces'],
  [-1563810496,-1563630271,'Aries'],
  [-1563630271,-1563458281,'Taurus'],
  [-1563458281,-1563287754,'Gemini'],
  [-1563287754,-1563111239,'Cancer'],
  [-1563111239,-1562922635,'Leo'],
  [-1562922635,-1562719765,'Virgo'],
  [-1562719765,-1562505790,'Libra'],
  [-1562505790,-1562286976,'Scorpio'],
  [-1562286976,-1562068802,'Sagittarius'],
  [-1562068802,-1561854642,'Capricorn'],
  [-1561854642,-1561647258,'Aquarius'],
  [-1561647258,-1561449684,'Pisces'],
  [-1561449684,-1561263686,'Aries'],
  [-1561263686,-1561087744,'Taurus'],
  [-1561087744,-1560916699,'Gemini'],
  [-1560916699,-1560743219,'Cancer'],
  [-1560743219,-1560559875,'Leo'],
  [-1560559875,-1560361900,'Virgo'],
  [-1560361900,-1560150258,'Libra'],
  [-1560150258,-1559931638,'Scorpio'],
  [-1559931638,-1559713758,'Sagittarius'],
  [-1559713758,-1559500991,'Capricorn'],
  [-1559500991,-1559294638,'Aquarius'],
  [-1559294638,-1559095527,'Pisces'],
  [-1559095527,-1558904977,'Aries'],
  [-1558904977,-1558723310,'Taurus'],
  [-1558723310,-1558547939,'Gemini'],
  [-1558547939,-1558373258,'Cancer'],
  [-1558373258,-1558192188,'Leo'],
  [-1558192188,-1557998633,'Virgo'],
  [-1557998633,-1557790837,'Libra'],
  [-1557790837,-1557573608,'Scorpio'],
  [-1557573608,-1557355720,'Sagittarius'],
  [-1557355720,-1557143882,'Capricorn'],
  [-1557143882,-1556939978,'Aquarius'],
  [-1556939978,-1556743081,'Pisces'],
  [-1556743081,-1556552199,'Aries'],
  [-1556552199,-1556366965,'Taurus'],
  [-1556366965,-1556186323,'Gemini'],
  [-1556186323,-1556007152,'Cancer'],
  [-1556007152,-1555824341,'Leo'],
  [-1555824341,-1555632312,'Virgo'],
  [-1555632312,-1555427751,'Libra'],
  [-1555427751,-1555212642,'Scorpio'],
  [-1555212642,-1554994546,'Sagittarius'],
  [-1554994546,-1554782043,'Capricorn'],
  [-1554782043,-1554579401,'Aquarius'],
  [-1554579401,-1554385940,'Pisces'],
  [-1554385940,-1554198717,'Aries'],
  [-1554198717,-1554014844,'Taurus'],
  [-1554014844,-1553832150,'Gemini'],
  [-1553832150,-1553648585,'Cancer'],
  [-1553648585,-1553461461,'Leo'],
  [-1553461461,-1553267446,'Virgo'],
  [-1553267446,-1553063735,'Libra'],
  [-1553063735,-1552850369,'Scorpio'],
  [-1552850369,-1552632169,'Sagittarius'],
  [-1552632169,-1552417461,'Capricorn'],
  [-1552417461,-1552213147,'Aquarius'],
  [-1552213147,-1552020899,'Pisces'],
  [-1552020899,-1551837832,'Aries'],
  [-1551837832,-1551659042,'Taurus'],
  [-1551659042,-1551479638,'Gemini'],
  [-1551479638,-1551295906,'Cancer'],
  [-1551295906,-1551105673,'Leo'],
  [-1551105673,-1550907973,'Virgo'],
  [-1550907973,-1550702435,'Libra'],
  [-1550702435,-1550489397,'Scorpio'],
  [-1550489397,-1550271361,'Sagittarius'],
  [-1550271361,-1550054246,'Capricorn'],
  [-1550054246,-1549845709,'Aquarius'],
  [-1549845709,-1549650566,'Pisces'],
  [-1549650566,-1549468222,'Aries'],
  [-1549468222,-1549293782,'Taurus'],
  [-1549293782,-1549120484,'Gemini'],
  [-1549120484,-1548941825,'Cancer'],
  [-1548941825,-1548753378,'Leo'],
  [-1548753378,-1548554107,'Virgo'],
  [-1548554107,-1548345927,'Libra'],
  [-1548345927,-1548131633,'Scorpio'],
  [-1548131633,-1547913716,'Sagittarius'],
  [-1547913716,-1547695538,'Capricorn'],
  [-1547695538,-1547482818,'Aquarius'],
  [-1547482818,-1547281841,'Pisces'],
  [-1547281841,-1547095359,'Aries'],
  [-1547095359,-1546920708,'Taurus'],
  [-1546920708,-1546751267,'Gemini'],
  [-1546751267,-1546579029,'Cancer'],
  [-1546579029,-1546396842,'Leo'],
  [-1546396842,-1546200902,'Virgo'],
  [-1546200902,-1545992567,'Libra'],
  [-1545992567,-1545776827,'Scorpio'],
  [-1545776827,-1545558544,'Sagittarius'],
  [-1545558544,-1545340774,'Capricorn'],
  [-1545340774,-1545126590,'Aquarius'],
  [-1545126590,-1544920706,'Pisces'],
  [-1544920706,-1544727541,'Aries'],
  [-1544727541,-1544547711,'Taurus'],
  [-1544547711,-1544376833,'Gemini'],
  [-1544376833,-1544207386,'Cancer'],
  [-1544207386,-1544031176,'Leo'],
  [-1544031176,-1543841753,'Virgo'],
  [-1543841753,-1543637387,'Libra'],
  [-1543637387,-1543422291,'Scorpio'],
  [-1543422291,-1543203550,'Sagittarius'],
  [-1543203550,-1542986451,'Capricorn'],
  [-1542986451,-1542773500,'Aquarius'],
  [-1542773500,-1542566777,'Pisces'],
  [-1542566777,-1542369183,'Aries'],
  [-1542369183,-1542182740,'Taurus'],
  [-1542182740,-1542006072,'Gemini'],
  [-1542006072,-1541834022,'Cancer'],
  [-1541834022,-1541659346,'Leo'],
  [-1541659346,-1541474897,'Virgo'],
  [-1541474897,-1541276286,'Libra'],
  [-1541276286,-1541064600,'Scorpio'],
  [-1541064600,-1540846394,'Sagittarius'],
  [-1540846394,-1540629387,'Capricorn'],
  [-1540629387,-1540418083,'Aquarius'],
  [-1540418083,-1540213765,'Pisces'],
  [-1540213765,-1540016709,'Aries'],
  [-1540016709,-1539827249,'Taurus'],
  [-1539827249,-1539644890,'Gemini'],
  [-1539644890,-1539467073,'Cancer'],
  [-1539467073,-1539289075,'Leo'],
  [-1539289075,-1539105099,'Virgo'],
  [-1539105099,-1538910154,'Libra'],
  [-1538910154,-1538702602,'Scorpio'],
  [-1538702602,-1538486194,'Sagittarius'],
  [-1538486194,-1538268847,'Capricorn'],
  [-1538268847,-1538057735,'Aquarius'],
  [-1538057735,-1537855810,'Pisces'],
  [-1537855810,-1537662337,'Aries'],
  [-1537662337,-1537475042,'Taurus'],
  [-1537475042,-1537291534,'Gemini'],
  [-1537291534,-1537109522,'Cancer'],
  [-1537109522,-1536926424,'Leo'],
  [-1536926424,-1536739042,'Virgo'],
  [-1536739042,-1536543895,'Libra'],
  [-1536543895,-1536338612,'Scorpio'],
  [-1536338612,-1536124204,'Sagittarius'],
  [-1536124204,-1535906501,'Capricorn'],
  [-1535906501,-1535693817,'Aquarius'],
  [-1535693817,-1535491866,'Pisces'],
  [-1535491866,-1535301189,'Aries'],
  [-1535301189,-1535118362,'Taurus'],
  [-1535118362,-1534938500,'Gemini'],
  [-1534938500,-1534757225,'Cancer'],
  [-1534757225,-1534571638,'Leo'],
  [-1534571638,-1534380262,'Virgo'],
  [-1534380262,-1534182174,'Libra'],
  [-1534182174,-1533976406,'Scorpio'],
  [-1533976406,-1533762961,'Sagittarius'],
  [-1533762961,-1533545058,'Capricorn'],
  [-1533545058,-1533329899,'Aquarius'],
  [-1533329899,-1533125156,'Pisces'],
  [-1533125156,-1532934033,'Aries'],
  [-1532934033,-1532754017,'Taurus'],
  [-1532754017,-1532579099,'Gemini'],
  [-1532579099,-1532402607,'Cancer'],
  [-1532402607,-1532219365,'Leo'],
  [-1532219365,-1532027094,'Virgo'],
  [-1532027094,-1531826281,'Libra'],
  [-1531826281,-1531618376,'Scorpio'],
  [-1531618376,-1531404494,'Sagittarius'],
  [-1531404494,-1531186509,'Capricorn'],
  [-1531186509,-1530969299,'Aquarius'],
  [-1530969299,-1530760388,'Pisces'],
  [-1530760388,-1530565441,'Aries'],
  [-1530565441,-1530384394,'Taurus'],
  [-1530384394,-1530211946,'Gemini'],
  [-1530211946,-1530040497,'Cancer'],
  [-1530040497,-1529862766,'Leo'],
  [-1529862766,-1529673995,'Virgo'],
  [-1529673995,-1529473536,'Libra'],
  [-1529473536,-1529264085,'Scorpio'],
  [-1529264085,-1529049024,'Sagittarius'],
  [-1529049024,-1528830947,'Capricorn'],
  [-1528830947,-1528613060,'Aquarius'],
  [-1528613060,-1528400911,'Pisces'],
  [-1528400911,-1528200691,'Aries'],
  [-1528200691,-1528014985,'Taurus'],
  [-1528014985,-1527840774,'Gemini'],
  [-1527840774,-1527671204,'Cancer'],
  [-1527671204,-1527498327,'Leo'],
  [-1527498327,-1527315349,'Virgo'],
  [-1527315349,-1527118949,'Libra'],
  [-1527118949,-1526910558,'Scorpio'],
  [-1526910558,-1526694856,'Sagittarius'],
  [-1526694856,-1526476612,'Capricorn'],
  [-1526476612,-1526259312,'Aquarius'],
  [-1526259312,-1526046535,'Pisces'],
  [-1526046535,-1525842710,'Aries'],
  [-1525842710,-1525651234,'Taurus'],
  [-1525651234,-1525471718,'Gemini'],
  [-1525471718,-1525299586,'Cancer'],
  [-1525299586,-1525127881,'Leo'],
  [-1525127881,-1524949337,'Virgo'],
  [-1524949337,-1524758500,'Libra'],
  [-1524758500,-1524553980,'Scorpio'],
  [-1524553980,-1524339330,'Sagittarius'],
  [-1524339330,-1524120991,'Capricorn'],
  [-1524120991,-1523904558,'Aquarius'],
  [-1523904558,-1523693419,'Pisces'],
  [-1523693419,-1523489732,'Aries'],
  [-1523489732,-1523295133,'Taurus'],
  [-1523295133,-1523109970,'Gemini'],
  [-1523109970,-1522932161,'Cancer'],
  [-1522932161,-1522757186,'Leo'],
  [-1522757186,-1522579100,'Virgo'],
  [-1522579100,-1522392025,'Libra'],
  [-1522392025,-1522192218,'Scorpio'],
  [-1522192218,-1521980381,'Sagittarius'],
  [-1521980381,-1521762358,'Capricorn'],
  [-1521762358,-1521546004,'Aquarius'],
  [-1521546004,-1521336695,'Pisces'],
  [-1521336695,-1521135952,'Aries'],
  [-1521135952,-1520942879,'Taurus'],
  [-1520942879,-1520755887,'Gemini'],
  [-1520755887,-1520573235,'Cancer'],
  [-1520573235,-1520392661,'Leo'],
  [-1520392661,-1520210883,'Virgo'],
  [-1520210883,-1520023612,'Libra'],
  [-1520023612,-1519826605,'Scorpio'],
  [-1519826605,-1519617973,'Sagittarius'],
  [-1519617973,-1519400896,'Capricorn'],
  [-1519400896,-1519183532,'Aquarius'],
  [-1519183532,-1518974075,'Pisces'],
  [-1518974075,-1518775829,'Aries'],
  [-1518775829,-1518586962,'Taurus'],
  [-1518586962,-1518403266,'Gemini'],
  [-1518403266,-1518220740,'Cancer'],
  [-1518220740,-1518036824,'Leo'],
  [-1518036824,-1517850134,'Virgo'],
  [-1517850134,-1517659178,'Libra'],
  [-1517659178,-1517461466,'Scorpio'],
  [-1517461466,-1517254483,'Sagittarius'],
  [-1517254483,-1517038630,'Capricorn'],
  [-1517038630,-1516819888,'Aquarius'],
  [-1516819888,-1516607758,'Pisces'],
  [-1516607758,-1516408695,'Aries'],
  [-1516408695,-1516222429,'Taurus'],
  [-1516222429,-1516043799,'Gemini'],
  [-1516043799,-1515866312,'Cancer'],
  [-1515866312,-1515684783,'Leo'],
  [-1515684783,-1515496762,'Virgo'],
  [-1515496762,-1515302156,'Libra'],
  [-1515302156,-1515101244,'Scorpio'],
  [-1515101244,-1514893356,'Sagittarius'],
  [-1514893356,-1514678104,'Capricorn'],
  [-1514678104,-1514458611,'Aquarius'],
  [-1514458611,-1514242887,'Pisces'],
  [-1514242887,-1514039486,'Aries'],
  [-1514039486,-1513851356,'Taurus'],
  [-1513851356,-1513674768,'Gemini'],
  [-1513674768,-1513502547,'Cancer'],
  [-1513502547,-1513327307,'Leo'],
  [-1513327307,-1513143685,'Virgo'],
  [-1513143685,-1512949800,'Libra'],
  [-1512949800,-1512746769,'Scorpio'],
  [-1512746769,-1512536578,'Sagittarius'],
  [-1512536578,-1512320689,'Capricorn'],
  [-1512320689,-1512101211,'Aquarius'],
  [-1512101211,-1511883360,'Pisces'],
  [-1511883360,-1511674833,'Aries'],
  [-1511674833,-1511481048,'Taurus'],
  [-1511481048,-1511301387,'Gemini'],
  [-1511301387,-1511130169,'Cancer'],
  [-1511130169,-1510959740,'Leo'],
  [-1510959740,-1510782861,'Virgo'],
  [-1510782861,-1510594594,'Libra'],
  [-1510594594,-1510393760,'Scorpio'],
  [-1510393760,-1510182776,'Sagittarius'],
  [-1510182776,-1509965698,'Capricorn'],
  [-1509965698,-1509746321,'Aquarius'],
  [-1509746321,-1509528588,'Pisces'],
  [-1509528588,-1509317539,'Aries'],
  [-1509317539,-1509118096,'Taurus'],
  [-1509118096,-1508932065,'Gemini'],
  [-1508932065,-1508756732,'Cancer'],
  [-1508756732,-1508586157,'Leo'],
  [-1508586157,-1508413217,'Virgo'],
  [-1508413217,-1508231324,'Libra'],
  [-1508231324,-1508036231,'Scorpio'],
  [-1508036231,-1507827884,'Sagittarius'],
  [-1507827884,-1507610761,'Capricorn'],
  [-1507610761,-1507391261,'Aquarius'],
  [-1507391261,-1507174666,'Pisces'],
  [-1507174666,-1506964464,'Aries'],
  [-1506964464,-1506763056,'Taurus'],
  [-1506763056,-1506571813,'Gemini'],
  [-1506571813,-1506390113,'Cancer'],
  [-1506390113,-1506214845,'Leo'],
  [-1506214845,-1506040831,'Virgo'],
  [-1506040831,-1505861839,'Libra'],
  [-1505861839,-1505672090,'Scorpio'],
  [-1505672090,-1505468529,'Sagittarius'],
  [-1505468529,-1505253387,'Capricorn'],
  [-1505253387,-1505033942,'Aquarius'],
  [-1505033942,-1504818043,'Pisces'],
  [-1504818043,-1504610051,'Aries'],
  [-1504610051,-1504410570,'Taurus'],
  [-1504410570,-1504218574,'Gemini'],
  [-1504218574,-1504032826,'Cancer'],
  [-1504032826,-1503851846,'Leo'],
  [-1503851846,-1503673116,'Virgo'],
  [-1503673116,-1503492473,'Libra'],
  [-1503492473,-1503304604,'Scorpio'],
  [-1503304604,-1503104934,'Sagittarius'],
  [-1503104934,-1502892811,'Capricorn'],
  [-1502892811,-1502673920,'Aquarius'],
  [-1502673920,-1502457678,'Pisces'],
  [-1502457678,-1502250865,'Aries'],
  [-1502250865,-1502054467,'Taurus'],
  [-1502054467,-1501865567,'Gemini'],
  [-1501865567,-1501680595,'Cancer'],
  [-1501680595,-1501497122,'Leo'],
  [-1501497122,-1501313779,'Virgo'],
  [-1501313779,-1501128842,'Libra'],
  [-1501128842,-1500939092,'Scorpio'],
  [-1500939092,-1500740429,'Sagittarius'],
  [-1500740429,-1500530549,'Capricorn'],
  [-1500530549,-1500312487,'Aquarius'],
  [-1500312487,-1500095043,'Pisces'],
  [-1500095043,-1499887202,'Aries'],
  [-1499887202,-1499692101,'Taurus'],
  [-1499692101,-1499506853,'Gemini'],
  [-1499506853,-1499326064,'Cancer'],
  [-1499326064,-1499144945,'Leo'],
  [-1499144945,-1498960779,'Virgo'],
  [-1498960779,-1498772533,'Libra'],
  [-1498772533,-1498579200,'Scorpio'],
  [-1498579200,-1498378762,'Sagittarius'],
  [-1498378762,-1498169243,'Capricorn'],
  [-1498169243,-1497951774,'Aquarius'],
  [-1497951774,-1497732941,'Pisces'],
  [-1497732941,-1497522164,'Aries'],
  [-1497522164,-1497325197,'Taurus'],
  [-1497325197,-1497141023,'Gemini'],
  [-1497141023,-1496964157,'Cancer'],
  [-1496964157,-1496788115,'Leo'],
  [-1496788115,-1496607724,'Virgo'],
  [-1496607724,-1496420219,'Libra'],
  [-1496420219,-1496224879,'Scorpio'],
  [-1496224879,-1496021750,'Sagittarius'],
  [-1496021750,-1495810895,'Capricorn'],
  [-1495810895,-1495593423,'Aquarius'],
  [-1495593423,-1495373759,'Pisces'],
  [-1495373759,-1495159684,'Aries'],
  [-1495159684,-1494958273,'Taurus'],
  [-1494958273,-1494771304,'Gemini'],
  [-1494771304,-1494595017,'Cancer'],
  [-1494595017,-1494422899,'Leo'],
  [-1494422899,-1494248194,'Virgo'],
  [-1494248194,-1494065557,'Libra'],
  [-1494065557,-1493872202,'Scorpio'],
  [-1493872202,-1493668181,'Sagittarius'],
  [-1493668181,-1493455634,'Capricorn'],
  [-1493455634,-1493237578,'Aquarius'],
  [-1493237578,-1493017919,'Pisces'],
  [-1493017919,-1492802087,'Aries'],
  [-1492802087,-1492596064,'Taurus'],
  [-1492596064,-1492403485,'Gemini'],
  [-1492403485,-1492223451,'Cancer'],
  [-1492223451,-1492051223,'Leo'],
  [-1492051223,-1491880163,'Virgo'],
  [-1491880163,-1491703424,'Libra'],
  [-1491703424,-1491515525,'Scorpio'],
  [-1491515525,-1491314181,'Sagittarius'],
  [-1491314181,-1491101500,'Capricorn'],
  [-1491101500,-1490882764,'Aquarius'],
  [-1490882764,-1490663539,'Pisces'],
  [-1490663539,-1490448213,'Aries'],
  [-1490448213,-1490240278,'Taurus'],
  [-1490240278,-1490042597,'Gemini'],
  [-1490042597,-1489856255,'Cancer'],
  [-1489856255,-1489679429,'Leo'],
  [-1489679429,-1489507434,'Virgo'],
  [-1489507434,-1489333733,'Libra'],
  [-1489333733,-1489151426,'Scorpio'],
  [-1489151426,-1488955419,'Sagittarius'],
  [-1488955419,-1488745333,'Capricorn'],
  [-1488745333,-1488526721,'Aquarius'],
  [-1488526721,-1488307686,'Pisces'],
  [-1488307686,-1488093964,'Aries'],
  [-1488093964,-1487887565,'Taurus'],
  [-1487887565,-1487688761,'Gemini'],
  [-1487688761,-1487497800,'Cancer'],
  [-1487497800,-1487314617,'Leo'],
  [-1487314617,-1487137446,'Virgo'],
  [-1487137446,-1486961934,'Libra'],
  [-1486961934,-1486781746,'Scorpio'],
  [-1486781746,-1486590456,'Sagittarius'],
  [-1486590456,-1486384729,'Capricorn'],
  [-1486384729,-1486167736,'Aquarius'],
  [-1486167736,-1485948473,'Pisces'],
  [-1485948473,-1485735457,'Aries'],
  [-1485735457,-1485531747,'Taurus'],
  [-1485531747,-1485335897,'Gemini'],
  [-1485335897,-1485145468,'Cancer'],
  [-1485145468,-1484959127,'Leo'],
  [-1484959127,-1484776347,'Virgo'],
  [-1484776347,-1484595543,'Libra'],
  [-1484595543,-1484412808,'Scorpio'],
  [-1484412808,-1484222593,'Sagittarius'],
  [-1484222593,-1484020234,'Capricorn'],
  [-1484020234,-1483805806,'Aquarius'],
  [-1483805806,-1483586398,'Pisces'],
  [-1483586398,-1483372201,'Aries'],
  [-1483372201,-1483169185,'Taurus'],
  [-1483169185,-1482976738,'Gemini'],
  [-1482976738,-1482790728,'Cancer'],
  [-1482790728,-1482607039,'Leo'],
  [-1482607039,-1482423282,'Virgo'],
  [-1482423282,-1482238374,'Libra'],
  [-1482238374,-1482050841,'Scorpio'],
  [-1482050841,-1481857767,'Sagittarius'],
  [-1481857767,-1481655616,'Capricorn'],
  [-1481655616,-1481442994,'Aquarius'],
  [-1481442994,-1481223900,'Pisces'],
  [-1481223900,-1481007409,'Aries'],
  [-1481007409,-1480801877,'Taurus'],
  [-1480801877,-1480609576,'Gemini'],
  [-1480609576,-1480427137,'Cancer'],
  [-1480427137,-1480248949,'Leo'],
  [-1480248949,-1480069830,'Virgo'],
  [-1480069830,-1479886307,'Libra'],
  [-1479886307,-1479696609,'Scorpio'],
  [-1479696609,-1479499803,'Sagittarius'],
  [-1479499803,-1479295092,'Capricorn'],
  [-1479295092,-1479082249,'Aquarius'],
  [-1479082249,-1478863565,'Pisces'],
  [-1478863565,-1478645266,'Aries'],
  [-1478645266,-1478435477,'Taurus'],
  [-1478435477,-1478239300,'Gemini'],
  [-1478239300,-1478056132,'Cancer'],
  [-1478056132,-1477881157,'Leo'],
  [-1477881157,-1477707954,'Virgo'],
  [-1477707954,-1477530400,'Libra'],
  [-1477530400,-1477344006,'Scorpio'],
  [-1477344006,-1477146867,'Sagittarius'],
  [-1477146867,-1476939786,'Capricorn'],
  [-1476939786,-1476725235,'Aquarius'],
  [-1476725235,-1476506429,'Pisces'],
  [-1476506429,-1476287651,'Aries'],
  [-1476287651,-1476074607,'Taurus'],
  [-1476074607,-1475872875,'Gemini'],
  [-1475872875,-1475684784,'Cancer'],
  [-1475684784,-1475508160,'Leo'],
  [-1475508160,-1475337436,'Virgo'],
  [-1475337436,-1475165526,'Libra'],
  [-1475165526,-1474985556,'Scorpio'],
  [-1474985556,-1474792762,'Sagittarius'],
  [-1474792762,-1474586583,'Capricorn'],
  [-1474586583,-1474370937,'Aquarius'],
  [-1474370937,-1474151544,'Pisces'],
  [-1474151544,-1473933183,'Aries'],
  [-1473933183,-1473719455,'Taurus'],
  [-1473719455,-1473513976,'Gemini'],
  [-1473513976,-1473319871,'Cancer'],
  [-1473319871,-1473137768,'Leo'],
  [-1473137768,-1472964613,'Virgo'],
  [-1472964613,-1472794261,'Libra'],
  [-1472794261,-1472619179,'Scorpio'],
  [-1472619179,-1472432462,'Sagittarius'],
  [-1472432462,-1472230651,'Capricorn'],
  [-1472230651,-1472016301,'Aquarius'],
  [-1472016301,-1471796695,'Pisces'],
  [-1471796695,-1471578842,'Aries'],
  [-1471578842,-1471366358,'Taurus'],
  [-1471366358,-1471160676,'Gemini'],
  [-1471160676,-1470963235,'Cancer'],
  [-1470963235,-1470775408,'Leo'],
  [-1470775408,-1470596691,'Virgo'],
  [-1470596691,-1470423335,'Libra'],
  [-1470423335,-1470248904,'Scorpio'],
  [-1470248904,-1470066096,'Sagittarius'],
  [-1470066096,-1469869388,'Capricorn'],
  [-1469869388,-1469658488,'Aquarius'],
  [-1469658488,-1469439752,'Pisces'],
  [-1469439752,-1469222080,'Aries'],
  [-1469222080,-1469011020,'Taurus'],
  [-1469011020,-1468807577,'Gemini'],
  [-1468807577,-1468610962,'Cancer'],
  [-1468610962,-1468420868,'Leo'],
  [-1468420868,-1468237264,'Virgo'],
  [-1468237264,-1468058632,'Libra'],
  [-1468058632,-1467880874,'Scorpio'],
  [-1467880874,-1467697998,'Sagittarius'],
  [-1467697998,-1467504171,'Capricorn'],
  [-1467504171,-1467296907,'Aquarius'],
  [-1467296907,-1467079963,'Pisces'],
  [-1467079963,-1466862126,'Aries'],
  [-1466862126,-1466651241,'Taurus'],
  [-1466651241,-1466449912,'Gemini'],
  [-1466449912,-1466256588,'Cancer'],
  [-1466256588,-1466068669,'Leo'],
  [-1466068669,-1465884267,'Virgo'],
  [-1465884267,-1465701947,'Libra'],
  [-1465701947,-1465519498,'Scorpio'],
  [-1465519498,-1465333284,'Sagittarius'],
  [-1465333284,-1465138952,'Capricorn'],
  [-1465138952,-1464933541,'Aquarius'],
  [-1464933541,-1464718391,'Pisces'],
  [-1464718391,-1464500235,'Aries'],
  [-1464500235,-1464287833,'Taurus'],
  [-1464287833,-1464086380,'Gemini'],
  [-1464086380,-1463895607,'Cancer'],
  [-1463895607,-1463711951,'Leo'],
  [-1463711951,-1463531161,'Virgo'],
  [-1463531161,-1463349699,'Libra'],
  [-1463349699,-1463164973,'Scorpio'],
  [-1463164973,-1462974913,'Sagittarius'],
  [-1462974913,-1462777597,'Capricorn'],
  [-1462777597,-1462571557,'Aquarius'],
  [-1462571557,-1462357257,'Pisces'],
  [-1462357257,-1462138878,'Aries'],
  [-1462138878,-1461923945,'Taurus'],
  [-1461923945,-1461719534,'Gemini'],
  [-1461719534,-1461528097,'Cancer'],
  [-1461528097,-1461347126,'Leo'],
  [-1461347126,-1461171333,'Virgo'],
  [-1461171333,-1460994807,'Libra'],
  [-1460994807,-1460812582,'Scorpio'],
  [-1460812582,-1460621713,'Sagittarius'],
  [-1460621713,-1460421608,'Capricorn'],
  [-1460421608,-1460213305,'Aquarius'],
  [-1460213305,-1459998550,'Pisces'],
  [-1459998550,-1459780166,'Aries'],
  [-1459780166,-1459563167,'Taurus'],
  [-1459563167,-1459354282,'Gemini'],
  [-1459354282,-1459158520,'Cancer'],
  [-1459158520,-1458976122,'Leo'],
  [-1458976122,-1458802751,'Virgo'],
  [-1458802751,-1458631542,'Libra'],
  [-1458631542,-1458455256,'Scorpio'],
  [-1458455256,-1458268285,'Sagittarius'],
  [-1458268285,-1458068694,'Capricorn'],
  [-1458068694,-1457858743,'Aquarius'],
  [-1457858743,-1457642708,'Pisces'],
  [-1457642708,-1457424355,'Aries'],
  [-1457424355,-1457206917,'Taurus'],
  [-1457206917,-1456994775,'Gemini'],
  [-1456994775,-1456793219,'Cancer'],
  [-1456793219,-1456605347,'Leo'],
  [-1456605347,-1456429575,'Virgo'],
  [-1456429575,-1456260045,'Libra'],
  [-1456260045,-1456088851,'Scorpio'],
  [-1456088851,-1455908277,'Sagittarius'],
  [-1455908277,-1455713431,'Capricorn'],
  [-1455713431,-1455504885,'Aquarius'],
  [-1455504885,-1455288167,'Pisces'],
  [-1455288167,-1455069599,'Aries'],
  [-1455069599,-1454853032,'Taurus'],
  [-1454853032,-1454640755,'Gemini'],
  [-1454640755,-1454435814,'Cancer'],
  [-1454435814,-1454241722,'Leo'],
  [-1454241722,-1454059712,'Virgo'],
  [-1454059712,-1453886698,'Libra'],
  [-1453886698,-1453716060,'Scorpio'],
  [-1453716060,-1453539830,'Sagittarius'],
  [-1453539830,-1453351114,'Capricorn'],
  [-1453351114,-1453147272,'Aquarius'],
  [-1453147272,-1452932058,'Pisces'],
  [-1452932058,-1452713304,'Aries'],
  [-1452713304,-1452497478,'Taurus'],
  [-1452497478,-1452287210,'Gemini'],
  [-1452287210,-1452083269,'Cancer'],
  [-1452083269,-1451886824,'Leo'],
  [-1451886824,-1451699197,'Virgo'],
  [-1451699197,-1451519776,'Libra'],
  [-1451519776,-1451344756,'Scorpio'],
  [-1451344756,-1451167903,'Sagittarius'],
  [-1451167903,-1450982441,'Capricorn'],
  [-1450982441,-1450783681,'Aquarius'],
  [-1450783681,-1450572046,'Pisces'],
  [-1450572046,-1450353920,'Aries'],
  [-1450353920,-1450137798,'Taurus'],
  [-1450137798,-1449928928,'Gemini'],
  [-1449928928,-1449728196,'Cancer'],
  [-1449728196,-1449534409,'Leo'],
  [-1449534409,-1449346321,'Virgo'],
  [-1449346321,-1449162825,'Libra'],
  [-1449162825,-1448982005,'Scorpio'],
  [-1448982005,-1448800434,'Sagittarius'],
  [-1448800434,-1448613496,'Capricorn'],
  [-1448613496,-1448416797,'Aquarius'],
  [-1448416797,-1448208554,'Pisces'],
  [-1448208554,-1447991966,'Aries'],
  [-1447991966,-1447774856,'Taurus'],
  [-1447774856,-1447565062,'Gemini'],
  [-1447565062,-1447365963,'Cancer'],
  [-1447365963,-1447176304,'Leo'],
  [-1447176304,-1446992502,'Virgo'],
  [-1446992502,-1446810741,'Libra'],
  [-1446810741,-1446627961,'Scorpio'],
  [-1446627961,-1446441913,'Sagittarius'],
  [-1446441913,-1446250663,'Capricorn'],
  [-1446250663,-1446052184,'Aquarius'],
  [-1446052184,-1445844935,'Pisces'],
  [-1445844935,-1445629767,'Aries'],
  [-1445629767,-1445411792,'Taurus'],
  [-1445411792,-1445199181,'Gemini'],
  [-1445199181,-1444998272,'Cancer'],
  [-1444998272,-1444810052,'Leo'],
  [-1444810052,-1444630752,'Virgo'],
  [-1444630752,-1444454423,'Libra'],
  [-1444454423,-1444275306,'Scorpio'],
  [-1444275306,-1444089441,'Sagittarius'],
  [-1444089441,-1443895402,'Capricorn'],
  [-1443895402,-1443693606,'Aquarius'],
  [-1443693606,-1443484818,'Pisces'],
  [-1443484818,-1443269899,'Aries'],
  [-1443269899,-1443051560,'Taurus'],
  [-1443051560,-1442835979,'Gemini'],
  [-1442835979,-1442630712,'Cancer'],
  [-1442630712,-1442439793,'Leo'],
  [-1442439793,-1442261382,'Virgo'],
  [-1442261382,-1442089351,'Libra'],
  [-1442089351,-1441916172,'Scorpio'],
  [-1441916172,-1441735280,'Sagittarius'],
  [-1441735280,-1441543108,'Capricorn'],
  [-1441543108,-1441340102,'Aquarius'],
  [-1441340102,-1441129232,'Pisces'],
  [-1441129232,-1440913412,'Aries'],
  [-1440913412,-1440695019,'Taurus'],
  [-1440695019,-1440477873,'Gemini'],
  [-1440477873,-1440268274,'Cancer'],
  [-1440268274,-1440071994,'Leo'],
  [-1440071994,-1439890111,'Virgo'],
  [-1439890111,-1439718192,'Libra'],
  [-1439718192,-1439548713,'Scorpio'],
  [-1439548713,-1439373720,'Sagittarius'],
  [-1439373720,-1439187097,'Capricorn'],
  [-1439187097,-1438986896,'Aquarius'],
  [-1438986896,-1438775915,'Pisces'],
  [-1438775915,-1438559160,'Aries'],
  [-1438559160,-1438340736,'Taurus'],
  [-1438340736,-1438123727,'Gemini'],
  [-1438123727,-1437912162,'Cancer'],
  [-1437912162,-1437711040,'Leo'],
  [-1437711040,-1437523330,'Virgo'],
  [-1437523330,-1437347311,'Libra'],
  [-1437347311,-1437177121,'Scorpio'],
  [-1437177121,-1437005086,'Sagittarius'],
  [-1437005086,-1436823930,'Capricorn'],
  [-1436823930,-1436629120,'Aquarius'],
  [-1436629120,-1436421009,'Pisces'],
  [-1436421009,-1436204588,'Aries'],
  [-1436204588,-1435986139,'Taurus'],
  [-1435986139,-1435770104,'Gemini'],
  [-1435770104,-1435559368,'Cancer'],
  [-1435559368,-1435356666,'Leo'],
  [-1435356666,-1435164350,'Virgo'],
  [-1435164350,-1434982488,'Libra'],
  [-1434982488,-1434807767,'Scorpio'],
  [-1434807767,-1434634325,'Sagittarius'],
  [-1434634325,-1434455409,'Capricorn'],
  [-1434455409,-1434265315,'Aquarius'],
  [-1434265315,-1434061706,'Pisces'],
  [-1434061706,-1433847342,'Aries'],
  [-1433847342,-1433629072,'Taurus'],
  [-1433629072,-1433413684,'Gemini'],
  [-1433413684,-1433205000,'Cancer'],
  [-1433205000,-1433004214,'Leo'],
  [-1433004214,-1432811335,'Virgo'],
  [-1432811335,-1432625718,'Libra'],
  [-1432625718,-1432445546,'Scorpio'],
  [-1432445546,-1432267427,'Sagittarius'],
  [-1432267427,-1432086649,'Capricorn'],
  [-1432086649,-1431898131,'Aquarius'],
  [-1431898131,-1431698155,'Pisces'],
  [-1431698155,-1431486705,'Aries'],
  [-1431486705,-1431268972,'Taurus'],
  [-1431268972,-1431053178,'Gemini'],
  [-1431053178,-1430845583,'Cancer'],
  [-1430845583,-1430647868,'Leo'],
  [-1430647868,-1430458197,'Virgo'],
  [-1430458197,-1430273491,'Libra'],
  [-1430273491,-1430090913,'Scorpio'],
  [-1430090913,-1429908152,'Sagittarius'],
  [-1429908152,-1429722921,'Capricorn'],
  [-1429722921,-1429532367,'Aquarius'],
  [-1429532367,-1429333331,'Pisces'],
  [-1429333331,-1429124111,'Aries'],
  [-1429124111,-1428907167,'Taurus'],
  [-1428907167,-1428689984,'Gemini'],
  [-1428689984,-1428481105,'Cancer'],
  [-1428481105,-1428284597,'Leo'],
  [-1428284597,-1428098751,'Virgo'],
  [-1428098751,-1427918555,'Libra'],
  [-1427918555,-1427738637,'Scorpio'],
  [-1427738637,-1427555185,'Sagittarius'],
  [-1427555185,-1427366518,'Capricorn'],
  [-1427366518,-1427172126,'Aquarius'],
  [-1427172126,-1426971163,'Pisces'],
  [-1426971163,-1426762328,'Aries'],
  [-1426762328,-1426546059,'Taurus'],
  [-1426546059,-1426327363,'Gemini'],
  [-1426327363,-1426115085,'Cancer'],
  [-1426115085,-1425916187,'Leo'],
  [-1425916187,-1425731200,'Virgo'],
  [-1425731200,-1425555115,'Libra'],
  [-1425555115,-1425380784,'Scorpio'],
  [-1425380784,-1425201757,'Sagittarius'],
  [-1425201757,-1425014275,'Capricorn'],
  [-1425014275,-1424817919,'Aquarius'],
  [-1424817919,-1424614052,'Pisces'],
  [-1424614052,-1424403713,'Aries'],
  [-1424403713,-1424187522,'Taurus'],
  [-1424187522,-1423968164,'Gemini'],
  [-1423968164,-1423752409,'Cancer'],
  [-1423752409,-1423548356,'Leo'],
  [-1423548356,-1423359718,'Virgo'],
  [-1423359718,-1423183630,'Libra'],
  [-1423183630,-1423013111,'Scorpio'],
  [-1423013111,-1422840261,'Sagittarius'],
  [-1422840261,-1422658606,'Capricorn'],
  [-1422658606,-1422465102,'Aquarius'],
  [-1422465102,-1422260702,'Pisces'],
  [-1422260702,-1422048544,'Aries'],
  [-1422048544,-1421831613,'Taurus'],
  [-1421831613,-1421612501,'Gemini'],
  [-1421612501,-1421395444,'Cancer'],
  [-1421395444,-1421186804,'Leo'],
  [-1421186804,-1420991827,'Virgo'],
  [-1420991827,-1420810852,'Libra'],
  [-1420810852,-1420639114,'Scorpio'],
  [-1420639114,-1420469256,'Sagittarius'],
  [-1420469256,-1420293707,'Capricorn'],
  [-1420293707,-1420106666,'Aquarius'],
  [-1420106666,-1419906074,'Pisces'],
  [-1419906074,-1419694331,'Aries'],
  [-1419694331,-1419476584,'Taurus'],
  [-1419476584,-1419257770,'Gemini'],
  [-1419257770,-1419041717,'Cancer'],
  [-1419041717,-1418832115,'Leo'],
  [-1418832115,-1418632590,'Virgo'],
  [-1418632590,-1418444925,'Libra'],
  [-1418444925,-1418267405,'Scorpio'],
  [-1418267405,-1418095120,'Sagittarius'],
  [-1418095120,-1417921469,'Capricorn'],
  [-1417921469,-1417739798,'Aquarius'],
  [-1417739798,-1417545279,'Pisces'],
  [-1417545279,-1417337172,'Aries'],
  [-1417337172,-1417119973,'Taurus'],
  [-1417119973,-1416901040,'Gemini'],
  [-1416901040,-1416686382,'Cancer'],
  [-1416686382,-1416478965,'Leo'],
  [-1416478965,-1416279675,'Virgo'],
  [-1416279675,-1416088590,'Libra'],
  [-1416088590,-1415904980,'Scorpio'],
  [-1415904980,-1415726690,'Sagittarius'],
  [-1415726690,-1415549788,'Capricorn'],
  [-1415549788,-1415368917,'Aquarius'],
  [-1415368917,-1415178519,'Pisces'],
  [-1415178519,-1414975108,'Aries'],
  [-1414975108,-1414760228,'Taurus'],
  [-1414760228,-1414541172,'Gemini'],
  [-1414541172,-1414326652,'Cancer'],
  [-1414326652,-1414121501,'Leo'],
  [-1414121501,-1413925610,'Virgo'],
  [-1413925610,-1413736388,'Libra'],
  [-1413736388,-1413551202,'Scorpio'],
  [-1413551202,-1413368233,'Sagittarius'],
  [-1413368233,-1413185877,'Capricorn'],
  [-1413185877,-1413001496,'Aquarius'],
  [-1413001496,-1412811009,'Pisces'],
  [-1412811009,-1412610243,'Aries'],
  [-1412610243,-1412398026,'Taurus'],
  [-1412398026,-1412179246,'Gemini'],
  [-1412179246,-1411963431,'Cancer'],
  [-1411963431,-1411758251,'Leo'],
  [-1411758251,-1411565053,'Virgo'],
  [-1411565053,-1411380155,'Libra'],
  [-1411380155,-1411198438,'Scorpio'],
  [-1411198438,-1411015939,'Sagittarius'],
  [-1411015939,-1410830734,'Capricorn'],
  [-1410830734,-1410642008,'Aquarius'],
  [-1410642008,-1410448288,'Pisces'],
  [-1410448288,-1410246920,'Aries'],
  [-1410246920,-1410035953,'Taurus'],
  [-1410035953,-1409817628,'Gemini'],
  [-1409817628,-1409599913,'Cancer'],
  [-1409599913,-1409392141,'Leo'],
  [-1409392141,-1409198423,'Virgo'],
  [-1409198423,-1409016180,'Libra'],
  [-1409016180,-1408839308,'Scorpio'],
  [-1408839308,-1408661564,'Sagittarius'],
  [-1408661564,-1408478645,'Capricorn'],
  [-1408478645,-1408288870,'Aquarius'],
  [-1408288870,-1408092121,'Pisces'],
  [-1408092121,-1407888200,'Aries'],
  [-1407888200,-1407676562,'Taurus'],
  [-1407676562,-1407458396,'Gemini'],
  [-1407458396,-1407239203,'Cancer'],
  [-1407239203,-1407027685,'Leo'],
  [-1407027685,-1406830213,'Virgo'],
  [-1406830213,-1406646771,'Libra'],
  [-1406646771,-1406472190,'Scorpio'],
  [-1406472190,-1406299446,'Sagittarius'],
  [-1406299446,-1406122117,'Capricorn'],
  [-1406122117,-1405935960,'Aquarius'],
  [-1405935960,-1405739590,'Pisces'],
  [-1405739590,-1405533869,'Aries'],
  [-1405533869,-1405320612,'Taurus'],
  [-1405320612,-1405102108,'Gemini'],
  [-1405102108,-1404882432,'Cancer'],
  [-1404882432,-1404668086,'Leo'],
  [-1404668086,-1404465591,'Virgo'],
  [-1404465591,-1404277468,'Libra'],
  [-1404277468,-1404100951,'Scorpio'],
  [-1404100951,-1403929972,'Sagittarius'],
  [-1403929972,-1403757510,'Capricorn'],
  [-1403757510,-1403577283,'Aquarius'],
  [-1403577283,-1403385229,'Pisces'],
  [-1403385229,-1403180729,'Aries'],
  [-1403180729,-1402966649,'Taurus'],
  [-1402966649,-1402747583,'Gemini'],
  [-1402747583,-1402528239,'Cancer'],
  [-1402528239,-1402313319,'Leo'],
  [-1402313319,-1402107397,'Virgo'],
  [-1402107397,-1401913605,'Libra'],
  [-1401913605,-1401731752,'Scorpio'],
  [-1401731752,-1401558154,'Sagittarius'],
  [-1401558154,-1401386862,'Capricorn'],
  [-1401386862,-1401211110,'Aquarius'],
  [-1401211110,-1401024809,'Pisces'],
  [-1401024809,-1400824581,'Aries'],
  [-1400824581,-1400611865,'Taurus'],
  [-1400611865,-1400392633,'Gemini'],
  [-1400392633,-1400173800,'Cancer'],
  [-1400173800,-1399960169,'Leo'],
  [-1399960169,-1399754183,'Virgo'],
  [-1399754183,-1399557182,'Libra'],
  [-1399557182,-1399369649,'Scorpio'],
  [-1399369649,-1399190385,'Sagittarius'],
  [-1399190385,-1399015912,'Capricorn'],
  [-1399015912,-1398840685,'Aquarius'],
  [-1398840685,-1398658202,'Pisces'],
  [-1398658202,-1398462996,'Aries'],
  [-1398462996,-1398253700,'Taurus'],
  [-1398253700,-1398035286,'Gemini'],
  [-1398035286,-1397816586,'Cancer'],
  [-1397816586,-1397604442,'Leo'],
  [-1397604442,-1397400896,'Virgo'],
  [-1397400896,-1397204934,'Libra'],
  [-1397204934,-1397015202,'Scorpio'],
  [-1397015202,-1396830894,'Sagittarius'],
  [-1396830894,-1396650827,'Capricorn'],
  [-1396650827,-1396472020,'Aquarius'],
  [-1396472020,-1396289386,'Pisces'],
  [-1396289386,-1396097102,'Aries'],
  [-1396097102,-1395891530,'Taurus'],
  [-1395891530,-1395674914,'Gemini'],
  [-1395674914,-1395455881,'Cancer'],
  [-1395455881,-1395243753,'Leo'],
  [-1395243753,-1395042396,'Virgo'],
  [-1395042396,-1394850064,'Libra'],
  [-1394850064,-1394662954,'Scorpio'],
  [-1394662954,-1394478140,'Sagittarius'],
  [-1394478140,-1394294305,'Capricorn'],
  [-1394294305,-1394110440,'Aquarius'],
  [-1394110440,-1393924082,'Pisces'],
  [-1393924082,-1393731068,'Aries'],
  [-1393731068,-1393527378,'Taurus'],
  [-1393527378,-1393312711,'Gemini'],
  [-1393312711,-1393093296,'Cancer'],
  [-1393093296,-1392879235,'Leo'],
  [-1392879235,-1392677305,'Virgo'],
  [-1392677305,-1392487398,'Libra'],
  [-1392487398,-1392304920,'Scorpio'],
  [-1392304920,-1392124497,'Sagittarius'],
  [-1392124497,-1391942279,'Capricorn'],
  [-1391942279,-1391756448,'Aquarius'],
  [-1391756448,-1391566047,'Pisces'],
  [-1391566047,-1391369566,'Aries'],
  [-1391369566,-1391164870,'Taurus'],
  [-1391164870,-1390951095,'Gemini'],
  [-1390951095,-1390731689,'Cancer'],
  [-1390731689,-1390514929,'Leo'],
  [-1390514929,-1390309288,'Virgo'],
  [-1390309288,-1390117793,'Libra'],
  [-1390117793,-1389937424,'Scorpio'],
  [-1389937424,-1389762171,'Sagittarius'],
  [-1389762171,-1389585844,'Capricorn'],
  [-1389585844,-1389403741,'Aquarius'],
  [-1389403741,-1389213380,'Pisces'],
  [-1389213380,-1389014220,'Aries'],
  [-1389014220,-1388806800,'Taurus'],
  [-1388806800,-1388592218,'Gemini'],
  [-1388592218,-1388373046,'Cancer'],
  [-1388373046,-1388154694,'Leo'],
  [-1388154694,-1387944468,'Virgo'],
  [-1387944468,-1387747678,'Libra'],
  [-1387747678,-1387564498,'Scorpio'],
  [-1387564498,-1387390563,'Sagittarius'],
  [-1387390563,-1387219296,'Capricorn'],
  [-1387219296,-1387043872,'Aquarius'],
  [-1387043872,-1386858775,'Pisces'],
  [-1386858775,-1386661340,'Aries'],
  [-1386661340,-1386452633,'Taurus'],
  [-1386452633,-1386236437,'Gemini'],
  [-1386236437,-1386017143,'Cancer'],
  [-1386017143,-1385798945,'Leo'],
  [-1385798945,-1385586357,'Virgo'],
  [-1385586357,-1385384016,'Libra'],
  [-1385384016,-1385194521,'Scorpio'],
  [-1385194521,-1385016671,'Sagittarius'],
  [-1385016671,-1384845658,'Capricorn'],
  [-1384845658,-1384674547,'Aquarius'],
  [-1384674547,-1384496017,'Pisces'],
  [-1384496017,-1384304380,'Aries'],
  [-1384304380,-1384098240,'Taurus'],
  [-1384098240,-1383881770,'Gemini'],
  [-1383881770,-1383662021,'Cancer'],
  [-1383662021,-1383444691,'Leo'],
  [-1383444691,-1383232800,'Virgo'],
  [-1383232800,-1383028374,'Libra'],
  [-1383028374,-1382833472,'Scorpio'],
  [-1382833472,-1382649079,'Sagittarius'],
  [-1382649079,-1382473426,'Capricorn'],
  [-1382473426,-1382301473,'Aquarius'],
  [-1382301473,-1382126112,'Pisces'],
  [-1382126112,-1381940158,'Aries'],
  [-1381940158,-1381739241,'Taurus'],
  [-1381739241,-1381525091,'Gemini'],
  [-1381525091,-1381305411,'Cancer'],
  [-1381305411,-1381088516,'Leo'],
  [-1381088516,-1380878529,'Virgo'],
  [-1380878529,-1380675813,'Libra'],
  [-1380675813,-1380479962,'Scorpio'],
  [-1380479962,-1380291233,'Sagittarius'],
  [-1380291233,-1380109581,'Capricorn'],
  [-1380109581,-1379932757,'Aquarius'],
  [-1379932757,-1379755686,'Pisces'],
  [-1379755686,-1379571712,'Aries'],
  [-1379571712,-1379375111,'Taurus'],
  [-1379375111,-1379164672,'Gemini'],
  [-1379164672,-1378946106,'Cancer'],
  [-1378946106,-1378728959,'Leo'],
  [-1378728959,-1378519894,'Virgo'],
  [-1378519894,-1378319964,'Libra'],
  [-1378319964,-1378127040,'Scorpio'],
  [-1378127040,-1377938944,'Sagittarius'],
  [-1377938944,-1377754560,'Capricorn'],
  [-1377754560,-1377572823,'Aquarius'],
  [-1377572823,-1377391137,'Pisces'],
  [-1377391137,-1377205007,'Aries'],
  [-1377205007,-1377009418,'Taurus'],
  [-1377009418,-1376801705,'Gemini'],
  [-1376801705,-1376584752,'Cancer'],
  [-1376584752,-1376366955,'Leo'],
  [-1376366955,-1376156900,'Virgo'],
  [-1376156900,-1375958011,'Libra'],
  [-1375958011,-1375768514,'Scorpio'],
  [-1375768514,-1375584504,'Sagittarius'],
  [-1375584504,-1375402390,'Capricorn'],
  [-1375402390,-1375219683,'Aquarius'],
  [-1375219683,-1375034429,'Pisces'],
  [-1375034429,-1374844334,'Aries'],
  [-1374844334,-1374646627,'Taurus'],
  [-1374646627,-1374439273,'Gemini'],
  [-1374439273,-1374223421,'Cancer'],
  [-1374223421,-1374004962,'Leo'],
  [-1374004962,-1373792396,'Virgo'],
  [-1373792396,-1373591625,'Libra'],
  [-1373591625,-1373403011,'Scorpio'],
  [-1373403011,-1373222793,'Sagittarius'],
  [-1373222793,-1373045683,'Capricorn'],
  [-1373045683,-1372866694,'Aquarius'],
  [-1372866694,-1372682114,'Pisces'],
  [-1372682114,-1372489822,'Aries'],
  [-1372489822,-1372289074,'Taurus'],
  [-1372289074,-1372080064,'Gemini'],
  [-1372080064,-1371864215,'Cancer'],
  [-1371864215,-1371645375,'Leo'],
  [-1371645375,-1371430084,'Virgo'],
  [-1371430084,-1371225176,'Libra'],
  [-1371225176,-1371033793,'Scorpio'],
  [-1371033793,-1370854100,'Sagittarius'],
  [-1370854100,-1370680841,'Capricorn'],
  [-1370680841,-1370507425,'Aquarius'],
  [-1370507425,-1370327667,'Pisces'],
  [-1370327667,-1370137376,'Aries'],
  [-1370137376,-1369935652,'Taurus'],
  [-1369935652,-1369724684,'Gemini'],
  [-1369724684,-1369507939,'Cancer'],
  [-1369507939,-1369289034,'Leo'],
  [-1369289034,-1369072258,'Virgo'],
  [-1369072258,-1368863115,'Libra'],
  [-1368863115,-1368666374,'Scorpio'],
  [-1368666374,-1368483085,'Sagittarius'],
  [-1368483085,-1368309794,'Capricorn'],
  [-1368309794,-1368139950,'Aquarius'],
  [-1368139950,-1367965946,'Pisces'],
  [-1367965946,-1367781119,'Aries'],
  [-1367781119,-1367582226,'Taurus'],
  [-1367582226,-1367371195,'Gemini'],
  [-1367371195,-1367153562,'Cancer'],
  [-1367153562,-1366934704,'Leo'],
  [-1366934704,-1366718174,'Virgo'],
  [-1366718174,-1366507119,'Libra'],
  [-1366507119,-1366305426,'Scorpio'],
  [-1366305426,-1366116040,'Sagittarius'],
  [-1366116040,-1365938395,'Capricorn'],
  [-1365938395,-1365767740,'Aquarius'],
  [-1365767740,-1365596702,'Pisces'],
  [-1365596702,-1365417407,'Aries'],
  [-1365417407,-1365224035,'Taurus'],
  [-1365224035,-1365015983,'Gemini'],
  [-1365015983,-1364798703,'Cancer'],
  [-1364798703,-1364579835,'Leo'],
  [-1364579835,-1364364418,'Virgo'],
  [-1364364418,-1364154423,'Libra'],
  [-1364154423,-1363951295,'Scorpio'],
  [-1363951295,-1363757148,'Sagittarius'],
  [-1363757148,-1363573210,'Capricorn'],
  [-1363573210,-1363397556,'Aquarius'],
  [-1363397556,-1363224791,'Pisces'],
  [-1363224791,-1363047626,'Aries'],
  [-1363047626,-1362859140,'Taurus'],
  [-1362859140,-1362655930,'Gemini'],
  [-1362655930,-1362440917,'Cancer'],
  [-1362440917,-1362222169,'Leo'],
  [-1362222169,-1362007300,'Virgo'],
  [-1362007300,-1361799513,'Libra'],
  [-1361799513,-1361598760,'Scorpio'],
  [-1361598760,-1361404546,'Sagittarius'],
  [-1361404546,-1361216958,'Capricorn'],
  [-1361216958,-1361035459,'Aquarius'],
  [-1361035459,-1360857350,'Pisces'],
  [-1360857350,-1360677648,'Aries'],
  [-1360677648,-1360490387,'Taurus'],
  [-1360490387,-1360290985,'Gemini'],
  [-1360290985,-1360079314,'Cancer'],
  [-1360079314,-1359861244,'Leo'],
  [-1359861244,-1359645623,'Virgo'],
  [-1359645623,-1359438515,'Libra'],
  [-1359438515,-1359240888,'Scorpio'],
  [-1359240888,-1359050594,'Sagittarius'],
  [-1359050594,-1358864916,'Capricorn'],
  [-1358864916,-1358681667,'Aquarius'],
  [-1358681667,-1358498882,'Pisces'],
  [-1358498882,-1358314051,'Aries'],
  [-1358314051,-1358123852,'Taurus'],
  [-1358123852,-1357924884,'Gemini'],
  [-1357924884,-1357715607,'Cancer'],
  [-1357715607,-1357498736,'Leo'],
  [-1357498736,-1357281629,'Virgo'],
  [-1357281629,-1357072451,'Libra'],
  [-1357072451,-1356875158,'Scorpio'],
  [-1356875158,-1356688469,'Sagittarius'],
  [-1356688469,-1356508017,'Capricorn'],
  [-1356508017,-1356328757,'Aquarius'],
  [-1356328757,-1356146541,'Pisces'],
  [-1356146541,-1355958803,'Aries'],
  [-1355958803,-1355764366,'Taurus'],
  [-1355764366,-1355562650,'Gemini'],
  [-1355562650,-1355353302,'Cancer'],
  [-1355353302,-1355137360,'Leo'],
  [-1355137360,-1354919187,'Virgo'],
  [-1354919187,-1354706357,'Libra'],
  [-1354706357,-1354505563,'Scorpio'],
  [-1354505563,-1354318469,'Sagittarius'],
  [-1354318469,-1354141471,'Capricorn'],
  [-1354141471,-1353968082,'Aquarius'],
  [-1353968082,-1353791471,'Pisces'],
  [-1353791471,-1353606466,'Aries'],
  [-1353606466,-1353411078,'Taurus'],
  [-1353411078,-1353206491,'Gemini'],
  [-1353206491,-1352995124,'Cancer'],
  [-1352995124,-1352779028,'Leo'],
  [-1352779028,-1352560689,'Virgo'],
  [-1352560689,-1352345060,'Libra'],
  [-1352345060,-1352139023,'Scorpio'],
  [-1352139023,-1351947230,'Sagittarius'],
  [-1351947230,-1351768853,'Capricorn'],
  [-1351768853,-1351598164,'Aquarius'],
  [-1351598164,-1351427287,'Pisces'],
  [-1351427287,-1351248682,'Aries'],
  [-1351248682,-1351057482,'Taurus'],
  [-1351057482,-1350853522,'Gemini'],
  [-1350853522,-1350640679,'Cancer'],
  [-1350640679,-1350423595,'Leo'],
  [-1350423595,-1350205482,'Virgo'],
  [-1350205482,-1349989292,'Libra'],
  [-1349989292,-1349779712,'Scorpio'],
  [-1349779712,-1349581968,'Sagittarius'],
  [-1349581968,-1349398130,'Capricorn'],
  [-1349398130,-1349225053,'Aquarius'],
  [-1349225053,-1349055793,'Pisces'],
  [-1349055793,-1348882221,'Aries'],
  [-1348882221,-1348697351,'Taurus'],
  [-1348697351,-1348498008,'Gemini'],
  [-1348498008,-1348286533,'Cancer'],
  [-1348286533,-1348068976,'Leo'],
  [-1348068976,-1347850949,'Virgo'],
  [-1347850949,-1347635759,'Libra'],
  [-1347635759,-1347426009,'Scorpio'],
  [-1347426009,-1347224983,'Sagittarius'],
  [-1347224983,-1347035335,'Capricorn'],
  [-1347035335,-1346856524,'Aquarius'],
  [-1346856524,-1346684073,'Pisces'],
  [-1346684073,-1346511074,'Aries'],
  [-1346511074,-1346330286,'Taurus'],
  [-1346330286,-1346136473,'Gemini'],
  [-1346136473,-1345928973,'Cancer'],
  [-1345928973,-1345712551,'Leo'],
  [-1345712551,-1345494521,'Virgo'],
  [-1345494521,-1345280376,'Libra'],
  [-1345280376,-1345072654,'Scorpio'],
  [-1345072654,-1344872441,'Sagittarius'],
  [-1344872441,-1344680498,'Capricorn'],
  [-1344680498,-1344496655,'Aquarius'],
  [-1344496655,-1344318665,'Pisces'],
  [-1344318665,-1344142059,'Aries'],
  [-1344142059,-1343961087,'Taurus'],
  [-1343961087,-1343770342,'Gemini'],
  [-1343770342,-1343566997,'Cancer'],
  [-1343566997,-1343353010,'Leo'],
  [-1343353010,-1343135132,'Virgo'],
  [-1343135132,-1342921028,'Libra'],
  [-1342921028,-1342715129,'Scorpio'],
  [-1342715129,-1342518029,'Sagittarius'],
  [-1342518029,-1342328175,'Capricorn'],
  [-1342328175,-1342143449,'Aquarius'],
  [-1342143449,-1341961618,'Pisces'],
  [-1341961618,-1341780072,'Aries'],
  [-1341780072,-1341595516,'Taurus'],
  [-1341595516,-1341404160,'Gemini'],
  [-1341404160,-1341202852,'Cancer'],
  [-1341202852,-1340991222,'Leo'],
  [-1340991222,-1340773687,'Virgo'],
  [-1340773687,-1340558384,'Libra'],
  [-1340558384,-1340352301,'Scorpio'],
  [-1340352301,-1340157549,'Sagittarius'],
  [-1340157549,-1339971742,'Capricorn'],
  [-1339971742,-1339790437,'Aquarius'],
  [-1339790437,-1339609330,'Pisces'],
  [-1339609330,-1339425372,'Aries'],
  [-1339425372,-1339236793,'Taurus'],
  [-1339236793,-1339042259,'Gemini'],
  [-1339042259,-1338840189,'Cancer'],
  [-1338840189,-1338629578,'Leo'],
  [-1338629578,-1338412394,'Virgo'],
  [-1338412394,-1338195203,'Libra'],
  [-1338195203,-1337986506,'Scorpio'],
  [-1337986506,-1337791133,'Sagittarius'],
  [-1337791133,-1337607847,'Capricorn'],
  [-1337607847,-1337431244,'Aquarius'],
  [-1337431244,-1337254793,'Pisces'],
  [-1337254793,-1337073166,'Aries'],
  [-1337073166,-1336883680,'Taurus'],
  [-1336883680,-1336686245,'Gemini'],
  [-1336686245,-1336481691,'Cancer'],
  [-1336481691,-1336270412,'Leo'],
  [-1336270412,-1336053343,'Virgo'],
  [-1336053343,-1335834610,'Libra'],
  [-1335834610,-1335622027,'Scorpio'],
  [-1335622027,-1335422715,'Sagittarius'],
  [-1335422715,-1335238127,'Capricorn'],
  [-1335238127,-1335063800,'Aquarius'],
  [-1335063800,-1334892363,'Pisces'],
  [-1334892363,-1334716396,'Aries'],
  [-1334716396,-1334530653,'Taurus'],
  [-1334530653,-1334333695,'Gemini'],
  [-1334333695,-1334127393,'Cancer'],
  [-1334127393,-1333914517,'Leo'],
  [-1333914517,-1333697159,'Virgo'],
  [-1333697159,-1333477990,'Libra'],
  [-1333477990,-1333262495,'Scorpio'],
  [-1333262495,-1333057824,'Sagittarius'],
  [-1333057824,-1332868119,'Capricorn'],
  [-1332868119,-1332691548,'Aquarius'],
  [-1332691548,-1332521736,'Pisces'],
  [-1332521736,-1332350714,'Aries'],
  [-1332350714,-1332171240,'Taurus'],
  [-1332171240,-1331979002,'Gemini'],
  [-1331979002,-1331774170,'Cancer'],
  [-1331774170,-1331560502,'Leo'],
  [-1331560502,-1331342546,'Virgo'],
  [-1331342546,-1331123833,'Libra'],
  [-1331123833,-1330908001,'Scorpio'],
  [-1330908001,-1330699944,'Sagittarius'],
  [-1330699944,-1330504152,'Capricorn'],
  [-1330504152,-1330321536,'Aquarius'],
  [-1330321536,-1330148389,'Pisces'],
  [-1330148389,-1329978048,'Aries'],
  [-1329978048,-1329803056,'Taurus'],
  [-1329803056,-1329617101,'Gemini'],
  [-1329617101,-1329417212,'Cancer'],
  [-1329417212,-1329205285,'Leo'],
  [-1329205285,-1328987101,'Virgo'],
  [-1328987101,-1328768798,'Libra'],
  [-1328768798,-1328554544,'Scorpio'],
  [-1328554544,-1328347048,'Sagittarius'],
  [-1328347048,-1328148474,'Capricorn'],
  [-1328148474,-1327959955,'Aquarius'],
  [-1327959955,-1327780309,'Pisces'],
  [-1327780309,-1327605685,'Aries'],
  [-1327605685,-1327430357,'Taurus'],
  [-1327430357,-1327248042,'Gemini'],
  [-1327248042,-1327053689,'Cancer'],
  [-1327053689,-1326845908,'Leo'],
  [-1326845908,-1326628814,'Virgo'],
  [-1326628814,-1326410337,'Libra'],
  [-1326410337,-1326197326,'Scorpio'],
  [-1326197326,-1325992691,'Sagittarius'],
  [-1325992691,-1325796189,'Capricorn'],
  [-1325796189,-1325606473,'Aquarius'],
  [-1325606473,-1325422091,'Pisces'],
  [-1325422091,-1325241265,'Aries'],
  [-1325241265,-1325061189,'Taurus'],
  [-1325061189,-1324877675,'Gemini'],
  [-1324877675,-1324685834,'Cancer'],
  [-1324685834,-1324482107,'Leo'],
  [-1324482107,-1324267371,'Virgo'],
  [-1324267371,-1324048537,'Libra'],
  [-1324048537,-1323834883,'Scorpio'],
  [-1323834883,-1323631913,'Sagittarius'],
  [-1323631913,-1323439315,'Capricorn'],
  [-1323439315,-1323253352,'Aquarius'],
  [-1323253352,-1323069942,'Pisces'],
  [-1323069942,-1322886349,'Aries'],
  [-1322886349,-1322701201,'Taurus'],
  [-1322701201,-1322513142,'Gemini'],
  [-1322513142,-1322319583,'Cancer'],
  [-1322319583,-1322117196,'Leo'],
  [-1322117196,-1321904605,'Virgo'],
  [-1321904605,-1321685793,'Libra'],
  [-1321685793,-1321469949,'Scorpio'],
  [-1321469949,-1321265470,'Sagittarius'],
  [-1321265470,-1321074397,'Capricorn'],
  [-1321074397,-1320892824,'Aquarius'],
  [-1320892824,-1320714535,'Pisces'],
  [-1320714535,-1320534078,'Aries'],
  [-1320534078,-1320348444,'Taurus'],
  [-1320348444,-1320156998,'Gemini'],
  [-1320156998,-1319959699,'Cancer'],
  [-1319959699,-1319755564,'Leo'],
  [-1319755564,-1319543416,'Virgo'],
  [-1319543416,-1319324906,'Libra'],
  [-1319324906,-1319106853,'Scorpio'],
  [-1319106853,-1318898466,'Sagittarius'],
  [-1318898466,-1318704847,'Capricorn'],
  [-1318704847,-1318524168,'Aquarius'],
  [-1318524168,-1318350148,'Pisces'],
  [-1318350148,-1318175575,'Aries'],
  [-1318175575,-1317994715,'Taurus'],
  [-1317994715,-1317804776,'Gemini'],
  [-1317804776,-1317605815,'Cancer'],
  [-1317605815,-1317399089,'Leo'],
  [-1317399089,-1317185679,'Virgo'],
  [-1317185679,-1316967209,'Libra'],
  [-1316967209,-1316748133,'Scorpio'],
  [-1316748133,-1316535941,'Sagittarius'],
  [-1316535941,-1316337169,'Capricorn'],
  [-1316337169,-1316152967,'Aquarius'],
  [-1316152967,-1315978971,'Pisces'],
  [-1315978971,-1315808134,'Aries'],
  [-1315808134,-1315633293,'Taurus'],
  [-1315633293,-1315448971,'Gemini'],
  [-1315448971,-1315252767,'Cancer'],
  [-1315252767,-1315045672,'Leo'],
  [-1315045672,-1314830862,'Virgo'],
  [-1314830862,-1314611994,'Libra'],
  [-1314611994,-1314393105,'Scorpio'],
  [-1314393105,-1314179320,'Sagittarius'],
  [-1314179320,-1313976002,'Capricorn'],
  [-1313976002,-1313785994,'Aquarius'],
  [-1313785994,-1313607737,'Pisces'],
  [-1313607737,-1313436089,'Aries'],
  [-1313436089,-1313264280,'Taurus'],
  [-1313264280,-1313085601,'Gemini'],
  [-1313085601,-1312895019,'Cancer'],
  [-1312895019,-1312690984,'Leo'],
  [-1312690984,-1312476435,'Virgo'],
  [-1312476435,-1312257192,'Libra'],
  [-1312257192,-1312038959,'Scorpio'],
  [-1312038959,-1311825980,'Sagittarius'],
  [-1311825980,-1311621255,'Capricorn'],
  [-1311621255,-1311426771,'Aquarius'],
  [-1311426771,-1311242617,'Pisces'],
  [-1311242617,-1311066302,'Aries'],
  [-1311066302,-1310893037,'Taurus'],
  [-1310893037,-1310716647,'Gemini'],
  [-1310716647,-1310530939,'Cancer'],
  [-1310530939,-1310331756,'Leo'],
  [-1310331756,-1310119645,'Virgo'],
  [-1310119645,-1309900662,'Libra'],
  [-1309900662,-1309682824,'Scorpio'],
  [-1309682824,-1309471583,'Sagittarius'],
  [-1309471583,-1309268608,'Capricorn'],
  [-1309268608,-1309073546,'Aquarius'],
  [-1309073546,-1308885652,'Pisces'],
  [-1308885652,-1308703841,'Aries'],
  [-1308703841,-1308525851,'Taurus'],
  [-1308525851,-1308347564,'Gemini'],
  [-1308347564,-1308163402,'Cancer'],
  [-1308163402,-1307968018,'Leo'],
  [-1307968018,-1307759317,'Virgo'],
  [-1307759317,-1307541417,'Libra'],
  [-1307541417,-1307323358,'Scorpio'],
  [-1307323358,-1307112995,'Sagittarius'],
  [-1307112995,-1306912718,'Capricorn'],
  [-1306912718,-1306720544,'Aquarius'],
  [-1306720544,-1306533384,'Pisces'],
  [-1306533384,-1306349084,'Aries'],
  [-1306349084,-1306166419,'Taurus'],
  [-1306166419,-1305983658,'Gemini'],
  [-1305983658,-1305797353,'Cancer'],
  [-1305797353,-1305602821,'Leo'],
  [-1305602821,-1305396604,'Virgo'],
  [-1305396604,-1305180156,'Libra'],
  [-1305180156,-1304961367,'Scorpio'],
  [-1304961367,-1304749962,'Sagittarius'],
  [-1304749962,-1304550703,'Capricorn'],
  [-1304550703,-1304361943,'Aquarius'],
  [-1304361943,-1304178880,'Pisces'],
  [-1304178880,-1303996926,'Aries'],
  [-1303996926,-1303813378,'Taurus'],
  [-1303813378,-1303627101,'Gemini'],
  [-1303627101,-1303436854,'Cancer'],
  [-1303436854,-1303240180,'Leo'],
  [-1303240180,-1303034257,'Virgo'],
  [-1303034257,-1302818842,'Libra'],
  [-1302818842,-1302599291,'Scorpio'],
  [-1302599291,-1302385163,'Sagittarius'],
  [-1302385163,-1302183787,'Capricorn'],
  [-1302183787,-1301995775,'Aquarius'],
  [-1301995775,-1301816517,'Pisces'],
  [-1301816517,-1301639776,'Aries'],
  [-1301639776,-1301460263,'Taurus'],
  [-1301460263,-1301274878,'Gemini'],
  [-1301274878,-1301082480,'Cancer'],
  [-1301082480,-1300882659,'Leo'],
  [-1300882659,-1300674935,'Virgo'],
  [-1300674935,-1300459510,'Libra'],
  [-1300459510,-1300239645,'Scorpio'],
  [-1300239645,-1300022671,'Sagittarius'],
  [-1300022671,-1299816687,'Capricorn'],
  [-1299816687,-1299625305,'Aquarius'],
  [-1299625305,-1299446117,'Pisces'],
  [-1299446117,-1299273161,'Aries'],
  [-1299273161,-1299099648,'Taurus'],
  [-1299099648,-1298919766,'Gemini'],
  [-1298919766,-1298729925,'Cancer'],
  [-1298729925,-1298529319,'Leo'],
  [-1298529319,-1298319455,'Virgo'],
  [-1298319455,-1298102961,'Libra'],
  [-1298102961,-1297883184,'Scorpio'],
  [-1297883184,-1297665023,'Sagittarius'],
  [-1297665023,-1297454716,'Capricorn'],
  [-1297454716,-1297257268,'Aquarius'],
  [-1297257268,-1297073445,'Pisces'],
  [-1297073445,-1296899576,'Aries'],
  [-1296899576,-1296729353,'Taurus'],
  [-1296729353,-1296555671,'Gemini'],
  [-1296555671,-1296372208,'Cancer'],
  [-1296372208,-1296175310,'Leo'],
  [-1296175310,-1295965720,'Virgo'],
  [-1295965720,-1295748150,'Libra'],
  [-1295748150,-1295528344,'Scorpio'],
  [-1295528344,-1295310878,'Sagittarius'],
  [-1295310878,-1295099342,'Capricorn'],
  [-1295099342,-1294897131,'Aquarius'],
  [-1294897131,-1294706526,'Pisces'],
  [-1294706526,-1294527028,'Aries'],
  [-1294527028,-1294354789,'Taurus'],
  [-1294354789,-1294183448,'Gemini'],
  [-1294183448,-1294005664,'Cancer'],
  [-1294005664,-1293815119,'Leo'],
  [-1293815119,-1293609460,'Virgo'],
  [-1293609460,-1293392586,'Libra'],
  [-1293392586,-1293172549,'Scorpio'],
  [-1293172549,-1292956174,'Sagittarius'],
  [-1292956174,-1292746382,'Capricorn'],
  [-1292746382,-1292543852,'Aquarius'],
  [-1292543852,-1292349240,'Pisces'],
  [-1292349240,-1292163216,'Aries'],
  [-1292163216,-1291984908,'Taurus'],
  [-1291984908,-1291810563,'Gemini'],
  [-1291810563,-1291633915,'Cancer'],
  [-1291633915,-1291447928,'Leo'],
  [-1291447928,-1291247621,'Virgo'],
  [-1291247621,-1291033776,'Libra'],
  [-1291033776,-1290814029,'Scorpio'],
  [-1290814029,-1290597793,'Sagittarius'],
  [-1290597793,-1290389998,'Capricorn'],
  [-1290389998,-1290190442,'Aquarius'],
  [-1290190442,-1289997120,'Pisces'],
  [-1289997120,-1289808809,'Aries'],
  [-1289808809,-1289625179,'Taurus'],
  [-1289625179,-1289445029,'Gemini'],
  [-1289445029,-1289264778,'Cancer'],
  [-1289264778,-1289078821,'Leo'],
  [-1289078821,-1288881653,'Virgo'],
  [-1288881653,-1288671378,'Libra'],
  [-1288671378,-1288452835,'Scorpio'],
  [-1288452835,-1288235779,'Sagittarius'],
  [-1288235779,-1288027960,'Capricorn'],
  [-1288027960,-1287830886,'Aquarius'],
  [-1287830886,-1287641625,'Pisces'],
  [-1287641625,-1287456392,'Aries'],
  [-1287456392,-1287272632,'Taurus'],
  [-1287272632,-1287088983,'Gemini'],
  [-1287088983,-1286903843,'Cancer'],
  [-1286903843,-1286714270,'Leo'],
  [-1286714270,-1286516444,'Virgo'],
  [-1286516444,-1286307912,'Libra'],
  [-1286307912,-1286090785,'Scorpio'],
  [-1286090785,-1285872701,'Sagittarius'],
  [-1285872701,-1285662639,'Capricorn'],
  [-1285662639,-1285464993,'Aquarius'],
  [-1285464993,-1285278268,'Pisces'],
  [-1285278268,-1285097808,'Aries'],
  [-1285097808,-1284918617,'Taurus'],
  [-1284918617,-1284736871,'Gemini'],
  [-1284736871,-1284550176,'Cancer'],
  [-1284550176,-1284357016,'Leo'],
  [-1284357016,-1284156151,'Virgo'],
  [-1284156151,-1283946817,'Libra'],
  [-1283946817,-1283730295,'Scorpio'],
  [-1283730295,-1283511572,'Sagittarius'],
  [-1283511572,-1283298420,'Capricorn'],
  [-1283298420,-1283097198,'Aquarius'],
  [-1283097198,-1282909199,'Pisces'],
  [-1282909199,-1282731008,'Aries'],
  [-1282731008,-1282556846,'Taurus'],
  [-1282556846,-1282380621,'Gemini'],
  [-1282380621,-1282197362,'Cancer'],
  [-1282197362,-1282004282,'Leo'],
  [-1282004282,-1281801186,'Virgo'],
  [-1281801186,-1281589796,'Libra'],
  [-1281589796,-1281372785,'Scorpio'],
  [-1281372785,-1281153924,'Sagittarius'],
  [-1281153924,-1280938567,'Capricorn'],
  [-1280938567,-1280732759,'Aquarius'],
  [-1280732759,-1280540169,'Pisces'],
  [-1280540169,-1280360023,'Aries'],
  [-1280360023,-1280187648,'Taurus'],
  [-1280187648,-1280016284,'Gemini'],
  [-1280016284,-1279838918,'Cancer'],
  [-1279838918,-1279650139,'Leo'],
  [-1279650139,-1279448187,'Virgo'],
  [-1279448187,-1279235729,'Libra'],
  [-1279235729,-1279017791,'Scorpio'],
  [-1279017791,-1278799060,'Sagittarius'],
  [-1278799060,-1278583305,'Capricorn'],
  [-1278583305,-1278374472,'Aquarius'],
  [-1278374472,-1278176510,'Pisces'],
  [-1278176510,-1277991138,'Aries'],
  [-1277991138,-1277816191,'Taurus'],
  [-1277816191,-1277645968,'Gemini'],
  [-1277645968,-1277472976,'Cancer'],
  [-1277472976,-1277289943,'Leo'],
  [-1277289943,-1277092426,'Virgo'],
  [-1277092426,-1276881491,'Libra'],
  [-1276881491,-1276663283,'Scorpio'],
  [-1276663283,-1276444694,'Sagittarius'],
  [-1276444694,-1276229911,'Capricorn'],
  [-1276229911,-1276020999,'Aquarius'],
  [-1276020999,-1275820036,'Pisces'],
  [-1275820036,-1275629192,'Aries'],
  [-1275629192,-1275448726,'Taurus'],
  [-1275448726,-1275275364,'Gemini'],
  [-1275275364,-1275102779,'Cancer'],
  [-1275102779,-1274923432,'Leo'],
  [-1274923432,-1274731043,'Virgo'],
  [-1274731043,-1274523912,'Libra'],
  [-1274523912,-1274306874,'Scorpio'],
  [-1274306874,-1274088360,'Sagittarius'],
  [-1274088360,-1273874648,'Capricorn'],
  [-1273874648,-1273667751,'Aquarius'],
  [-1273667751,-1273467636,'Pisces'],
  [-1273467636,-1273274593,'Aries'],
  [-1273274593,-1273089171,'Taurus'],
  [-1273089171,-1272910316,'Gemini'],
  [-1272910316,-1272734126,'Cancer'],
  [-1272734126,-1272554484,'Leo'],
  [-1272554484,-1272364976,'Virgo'],
  [-1272364976,-1272161870,'Libra'],
  [-1272161870,-1271947236,'Scorpio'],
  [-1271947236,-1271728853,'Sagittarius'],
  [-1271728853,-1271515130,'Capricorn'],
  [-1271515130,-1271310037,'Aquarius'],
  [-1271310037,-1271113109,'Pisces'],
  [-1271113109,-1270922331,'Aries'],
  [-1270922331,-1270736154,'Taurus'],
  [-1270736154,-1270553420,'Gemini'],
  [-1270553420,-1270372125,'Cancer'],
  [-1270372125,-1270188658,'Leo'],
  [-1270188658,-1269998326,'Virgo'],
  [-1269998326,-1269797214,'Libra'],
  [-1269797214,-1269585022,'Scorpio'],
  [-1269585022,-1269366991,'Sagittarius'],
  [-1269366991,-1269151844,'Capricorn'],
  [-1269151844,-1268946258,'Aquarius'],
  [-1268946258,-1268751565,'Pisces'],
  [-1268751565,-1268565089,'Aries'],
  [-1268565089,-1268382841,'Taurus'],
  [-1268382841,-1268201251,'Gemini'],
  [-1268201251,-1268017644,'Cancer'],
  [-1268017644,-1267829896,'Leo'],
  [-1267829896,-1267635932,'Virgo'],
  [-1267635932,-1267433765,'Libra'],
  [-1267433765,-1267222655,'Scorpio'],
  [-1267222655,-1267005166,'Sagittarius'],
  [-1267005166,-1266788002,'Capricorn'],
  [-1266788002,-1266579197,'Aquarius'],
  [-1266579197,-1266383176,'Pisces'],
  [-1266383176,-1266198928,'Aries'],
  [-1266198928,-1266021740,'Taurus'],
  [-1266021740,-1265845628,'Gemini'],
  [-1265845628,-1265665215,'Cancer'],
  [-1265665215,-1265477031,'Leo'],
  [-1265477031,-1265280031,'Virgo'],
  [-1265280031,-1265074913,'Libra'],
  [-1265074913,-1264862890,'Scorpio'],
  [-1264862890,-1264645730,'Sagittarius'],
  [-1264645730,-1264427315,'Capricorn'],
  [-1264427315,-1264214347,'Aquarius'],
  [-1264214347,-1264013413,'Pisces'],
  [-1264013413,-1263826758,'Aries'],
  [-1263826758,-1263651247,'Taurus'],
  [-1263651247,-1263480300,'Gemini'],
  [-1263480300,-1263306384,'Cancer'],
  [-1263306384,-1263123141,'Leo'],
  [-1263123141,-1262927516,'Virgo'],
  [-1262927516,-1262720803,'Libra'],
  [-1262720803,-1262506876,'Scorpio'],
  [-1262506876,-1262289334,'Sagittarius'],
  [-1262289334,-1262070942,'Capricorn'],
  [-1262070942,-1261855611,'Aquarius'],
  [-1261855611,-1261649170,'Pisces'],
  [-1261649170,-1261456363,'Aries'],
  [-1261456363,-1261277291,'Taurus'],
  [-1261277291,-1261106961,'Gemini'],
  [-1261106961,-1260937588,'Cancer'],
  [-1260937588,-1260761061,'Leo'],
  [-1260761061,-1260571344,'Virgo'],
  [-1260571344,-1260367227,'Libra'],
  [-1260367227,-1260152897,'Scorpio'],
  [-1260152897,-1259934575,'Sagittarius'],
  [-1259934575,-1259716666,'Capricorn'],
  [-1259716666,-1259501720,'Aquarius'],
  [-1259501720,-1259292895,'Pisces'],
  [-1259292895,-1259094365,'Aries'],
  [-1259094365,-1258908606,'Taurus'],
  [-1258908606,-1258733712,'Gemini'],
  [-1258733712,-1258563667,'Cancer'],
  [-1258563667,-1258390583,'Leo'],
  [-1258390583,-1258207010,'Virgo'],
  [-1258207010,-1258008687,'Libra'],
  [-1258008687,-1257797129,'Scorpio'],
  [-1257797129,-1257578929,'Sagittarius'],
  [-1257578929,-1257361155,'Capricorn'],
  [-1257361155,-1257147733,'Aquarius'],
  [-1257147733,-1256940285,'Pisces'],
  [-1256940285,-1256740383,'Aries'],
  [-1256740383,-1256549756,'Taurus'],
  [-1256549756,-1256368430,'Gemini'],
  [-1256368430,-1256193254,'Cancer'],
  [-1256193254,-1256018406,'Leo'],
  [-1256018406,-1255837085,'Virgo'],
  [-1255837085,-1255643732,'Libra'],
  [-1255643732,-1255436771,'Scorpio'],
  [-1255436771,-1255220379,'Sagittarius'],
  [-1255220379,-1255002506,'Capricorn'],
  [-1255002506,-1254789778,'Aquarius'],
  [-1254789778,-1254584855,'Pisces'],
  [-1254584855,-1254387632,'Aries'],
  [-1254387632,-1254197232,'Taurus'],
  [-1254197232,-1254012616,'Gemini'],
  [-1254012616,-1253831961,'Cancer'],
  [-1253831961,-1253652044,'Leo'],
  [-1253652044,-1253468382,'Virgo'],
  [-1253468382,-1253276271,'Libra'],
  [-1253276271,-1253072734,'Scorpio'],
  [-1253072734,-1252858935,'Sagittarius'],
  [-1252858935,-1252641134,'Capricorn'],
  [-1252641134,-1252427583,'Aquarius'],
  [-1252427583,-1252223566,'Pisces'],
  [-1252223566,-1252029630,'Aries'],
  [-1252029630,-1251843130,'Taurus'],
  [-1251843130,-1251660451,'Gemini'],
  [-1251660451,-1251478368,'Cancer'],
  [-1251478368,-1251294366,'Leo'],
  [-1251294366,-1251106283,'Virgo'],
  [-1251106283,-1250911819,'Libra'],
  [-1250911819,-1250708789,'Scorpio'],
  [-1250708789,-1250496741,'Sagittarius'],
  [-1250496741,-1250279199,'Capricorn'],
  [-1250279199,-1250063771,'Aquarius'],
  [-1250063771,-1249858028,'Pisces'],
  [-1249858028,-1249664914,'Aries'],
  [-1249664914,-1249482087,'Taurus'],
  [-1249482087,-1249304211,'Gemini'],
  [-1249304211,-1249125581,'Cancer'],
  [-1249125581,-1248941934,'Leo'],
  [-1248941934,-1248751289,'Virgo'],
  [-1248751289,-1248553422,'Libra'],
  [-1248553422,-1248348462,'Scorpio'],
  [-1248348462,-1248136472,'Sagittarius'],
  [-1248136472,-1247919122,'Capricorn'],
  [-1247919122,-1247701780,'Aquarius'],
  [-1247701780,-1247492437,'Pisces'],
  [-1247492437,-1247296714,'Aries'],
  [-1247296714,-1247114356,'Taurus'],
  [-1247114356,-1246940139,'Gemini'],
  [-1246940139,-1246766838,'Cancer'],
  [-1246766838,-1246587806,'Leo'],
  [-1246587806,-1246398985,'Virgo'],
  [-1246398985,-1246199949,'Libra'],
  [-1246199949,-1245992727,'Scorpio'],
  [-1245992727,-1245779503,'Sagittarius'],
  [-1245779503,-1245562062,'Capricorn'],
  [-1245562062,-1245343722,'Aquarius'],
  [-1245343722,-1245130830,'Pisces'],
  [-1245130830,-1244930215,'Aries'],
  [-1244930215,-1244744422,'Taurus'],
  [-1244744422,-1244570074,'Gemini'],
  [-1244570074,-1244400092,'Cancer'],
  [-1244400092,-1244226571,'Leo'],
  [-1244226571,-1244043077,'Virgo'],
  [-1244043077,-1243846842,'Libra'],
  [-1243846842,-1243639496,'Scorpio'],
  [-1243639496,-1243425076,'Sagittarius'],
  [-1243425076,-1243207275,'Capricorn'],
  [-1243207275,-1242989069,'Aquarius'],
  [-1242989069,-1242774615,'Pisces'],
  [-1242774615,-1242569562,'Aries'],
  [-1242569562,-1242378054,'Taurus'],
  [-1242378054,-1242199489,'Gemini'],
  [-1242199489,-1242028599,'Cancer'],
  [-1242028599,-1241857848,'Leo'],
  [-1241857848,-1241679733,'Virgo'],
  [-1241679733,-1241488997,'Libra'],
  [-1241488997,-1241284759,'Scorpio'],
  [-1241284759,-1241070714,'Sagittarius'],
  [-1241070714,-1240852590,'Capricorn'],
  [-1240852590,-1240635050,'Aquarius'],
  [-1240635050,-1240421439,'Pisces'],
  [-1240421439,-1240215055,'Aries'],
  [-1240215055,-1240019036,'Taurus'],
  [-1240019036,-1239834413,'Gemini'],
  [-1239834413,-1239658630,'Cancer'],
  [-1239658630,-1239486154,'Leo'],
  [-1239486154,-1239310149,'Virgo'],
  [-1239310149,-1239124312,'Libra'],
  [-1239124312,-1238925075,'Scorpio'],
  [-1238925075,-1238713605,'Sagittarius'],
  [-1238713605,-1238495722,'Capricorn'],
  [-1238495722,-1238278495,'Aquarius'],
  [-1238278495,-1238066686,'Pisces'],
  [-1238066686,-1237862328,'Aries'],
  [-1237862328,-1237666005,'Taurus'],
  [-1237666005,-1237477630,'Gemini'],
  [-1237477630,-1237296005,'Cancer'],
  [-1237296005,-1237118247,'Leo'],
  [-1237118247,-1236939835,'Virgo'],
  [-1236939835,-1236755379,'Libra'],
  [-1236755379,-1236560139,'Scorpio'],
  [-1236560139,-1236352393,'Sagittarius'],
  [-1236352393,-1236135682,'Capricorn'],
  [-1236135682,-1235917978,'Aquarius'],
  [-1235917978,-1235706804,'Pisces'],
  [-1235706804,-1235505304,'Aries'],
  [-1235505304,-1235312454,'Taurus'],
  [-1235312454,-1235125459,'Gemini'],
  [-1235125459,-1234941635,'Cancer'],
  [-1234941635,-1234758929,'Leo'],
  [-1234758929,-1234575350,'Virgo'],
  [-1234575350,-1234388097,'Libra'],
  [-1234388097,-1234193481,'Scorpio'],
  [-1234193481,-1233988430,'Sagittarius'],
  [-1233988430,-1233773472,'Capricorn'],
  [-1233773472,-1233554900,'Aquarius'],
  [-1233554900,-1233342076,'Pisces'],
  [-1233342076,-1233141088,'Aries'],
  [-1233141088,-1232951744,'Taurus'],
  [-1232951744,-1232769575,'Gemini'],
  [-1232769575,-1232589148,'Cancer'],
  [-1232589148,-1232406390,'Leo'],
  [-1232406390,-1232219432,'Virgo'],
  [-1232219432,-1232027737,'Libra'],
  [-1232027737,-1231830335,'Scorpio'],
  [-1231830335,-1231625280,'Sagittarius'],
  [-1231625280,-1231411555,'Capricorn'],
  [-1231411555,-1231192474,'Aquarius'],
  [-1231192474,-1230976561,'Pisces'],
  [-1230976561,-1230772503,'Aries'],
  [-1230772503,-1230583026,'Taurus'],
  [-1230583026,-1230404357,'Gemini'],
  [-1230404357,-1230229628,'Cancer'],
  [-1230229628,-1230052114,'Leo'],
  [-1230052114,-1229867390,'Virgo'],
  [-1229867390,-1229674270,'Libra'],
  [-1229674270,-1229473636,'Scorpio'],
  [-1229473636,-1229266271,'Sagittarius'],
  [-1229266271,-1229052281,'Capricorn'],
  [-1229052281,-1228833228,'Aquarius'],
  [-1228833228,-1228614878,'Pisces'],
  [-1228614878,-1228405882,'Aries'],
  [-1228405882,-1228211950,'Taurus'],
  [-1228211950,-1228032086,'Gemini'],
  [-1228032086,-1227860202,'Cancer'],
  [-1227860202,-1227688559,'Leo'],
  [-1227688559,-1227510270,'Virgo'],
  [-1227510270,-1227321204,'Libra'],
  [-1227321204,-1227120934,'Scorpio'],
  [-1227120934,-1226911691,'Sagittarius'],
  [-1226911691,-1226696278,'Capricorn'],
  [-1226696278,-1226477225,'Aquarius'],
  [-1226477225,-1226258355,'Pisces'],
  [-1226258355,-1226045870,'Aries'],
  [-1226045870,-1225845941,'Taurus'],
  [-1225845941,-1225660556,'Gemini'],
  [-1225660556,-1225486300,'Cancer'],
  [-1225486300,-1225316472,'Leo'],
  [-1225316472,-1225143587,'Virgo'],
  [-1225143587,-1224961239,'Libra'],
  [-1224961239,-1224765874,'Scorpio'],
  [-1224765874,-1224558048,'Sagittarius'],
  [-1224558048,-1224341869,'Capricorn'],
  [-1224341869,-1224122490,'Aquarius'],
  [-1224122490,-1223904376,'Pisces'],
  [-1223904376,-1223691617,'Aries'],
  [-1223691617,-1223488199,'Taurus'],
  [-1223488199,-1223296682,'Gemini'],
  [-1223296682,-1223116382,'Cancer'],
  [-1223116382,-1222943249,'Leo'],
  [-1222943249,-1222771132,'Virgo'],
  [-1222771132,-1222593300,'Libra'],
  [-1222593300,-1222404049,'Scorpio'],
  [-1222404049,-1222200817,'Sagittarius'],
  [-1222200817,-1221986104,'Capricorn'],
  [-1221986104,-1221766603,'Aquarius'],
  [-1221766603,-1221549223,'Pisces'],
  [-1221549223,-1221338254,'Aries'],
  [-1221338254,-1221135428,'Taurus'],
  [-1221135428,-1220941290,'Gemini'],
  [-1220941290,-1220755530,'Cancer'],
  [-1220755530,-1220576461,'Leo'],
  [-1220576461,-1220400567,'Virgo'],
  [-1220400567,-1220222653,'Libra'],
  [-1220222653,-1220036821,'Scorpio'],
  [-1220036821,-1219838410,'Sagittarius'],
  [-1219838410,-1219626957,'Capricorn'],
  [-1219626957,-1219408116,'Aquarius'],
  [-1219408116,-1219190780,'Pisces'],
  [-1219190780,-1218981384,'Aries'],
  [-1218981384,-1218781388,'Taurus'],
  [-1218781388,-1218589042,'Gemini'],
  [-1218589042,-1218402063,'Cancer'],
  [-1218402063,-1218218759,'Leo'],
  [-1218218759,-1218037574,'Virgo'],
  [-1218037574,-1217855870,'Libra'],
  [-1217855870,-1217669373,'Scorpio'],
  [-1217669373,-1217473248,'Sagittarius'],
  [-1217473248,-1217264883,'Capricorn'],
  [-1217264883,-1217047316,'Aquarius'],
  [-1217047316,-1216829341,'Pisces'],
  [-1216829341,-1216619787,'Aries'],
  [-1216619787,-1216421867,'Taurus'],
  [-1216421867,-1216233217,'Gemini'],
  [-1216233217,-1216049333,'Cancer'],
  [-1216049333,-1215866440,'Leo'],
  [-1215866440,-1215682530,'Virgo'],
  [-1215682530,-1215496521,'Libra'],
  [-1215496521,-1215306569,'Scorpio'],
  [-1215306569,-1215109491,'Sagittarius'],
  [-1215109491,-1214902370,'Capricorn'],
  [-1214902370,-1214685958,'Aquarius'],
  [-1214685958,-1214467050,'Pisces'],
  [-1214467050,-1214255403,'Aries'],
  [-1214255403,-1214056853,'Taurus'],
  [-1214056853,-1213870412,'Gemini'],
  [-1213870412,-1213690855,'Cancer'],
  [-1213690855,-1213512282,'Leo'],
  [-1213512282,-1213330404,'Virgo'],
  [-1213330404,-1213143236,'Libra'],
  [-1213143236,-1212950116,'Scorpio'],
  [-1212950116,-1212750192,'Sagittarius'],
  [-1212750192,-1212542153,'Capricorn'],
  [-1212542153,-1212326120,'Aquarius'],
  [-1212326120,-1212106504,'Pisces'],
  [-1212106504,-1211891856,'Aries'],
  [-1211891856,-1211689812,'Taurus'],
  [-1211689812,-1211502051,'Gemini'],
  [-1211502051,-1211324510,'Cancer'],
  [-1211324510,-1211150638,'Leo'],
  [-1211150638,-1210974087,'Virgo'],
  [-1210974087,-1210790363,'Libra'],
  [-1210790363,-1210597499,'Scorpio'],
  [-1210597499,-1210395539,'Sagittarius'],
  [-1210395539,-1210185496,'Capricorn'],
  [-1210185496,-1209968918,'Aquarius'],
  [-1209968918,-1209749115,'Pisces'],
  [-1209749115,-1209532268,'Aries'],
  [-1209532268,-1209325575,'Taurus'],
  [-1209325575,-1209133076,'Gemini'],
  [-1209133076,-1208953362,'Cancer'],
  [-1208953362,-1208781053,'Leo'],
  [-1208781053,-1208609284,'Virgo'],
  [-1208609284,-1208431538,'Libra'],
  [-1208431538,-1208243124,'Scorpio'],
  [-1208243124,-1208042452,'Sagittarius'],
  [-1208042452,-1207831355,'Capricorn'],
  [-1207831355,-1207613793,'Aquarius'],
  [-1207613793,-1207394163,'Pisces'],
  [-1207394163,-1207177057,'Aries'],
  [-1207177057,-1206967366,'Taurus'],
  [-1206967366,-1206769217,'Gemini'],
  [-1206769217,-1206583776,'Cancer'],
  [-1206583776,-1206408378,'Leo'],
  [-1206408378,-1206237489,'Virgo'],
  [-1206237489,-1206064234,'Libra'],
  [-1206064234,-1205881930,'Scorpio'],
  [-1205881930,-1205686079,'Sagittarius'],
  [-1205686079,-1205476689,'Capricorn'],
  [-1205476689,-1205258766,'Aquarius'],
  [-1205258766,-1205039227,'Pisces'],
  [-1205039227,-1204823333,'Aries'],
  [-1204823333,-1204613967,'Taurus'],
  [-1204613967,-1204412981,'Gemini'],
  [-1204412981,-1204221720,'Cancer'],
  [-1204221720,-1204040034,'Leo'],
  [-1204040034,-1203865217,'Virgo'],
  [-1203865217,-1203691961,'Libra'],
  [-1203691961,-1203513428,'Scorpio'],
  [-1203513428,-1203323165,'Sagittarius'],
  [-1203323165,-1203118102,'Capricorn'],
  [-1203118102,-1202901514,'Aquarius'],
  [-1202901514,-1202681860,'Pisces'],
  [-1202681860,-1202466981,'Aries'],
  [-1202466981,-1202260042,'Taurus'],
  [-1202260042,-1202060631,'Gemini'],
  [-1202060631,-1201867731,'Cancer'],
  [-1201867731,-1201681018,'Leo'],
  [-1201681018,-1201499989,'Virgo'],
  [-1201499989,-1201322219,'Libra'],
  [-1201322219,-1201142731,'Scorpio'],
  [-1201142731,-1200955176,'Sagittarius'],
  [-1200955176,-1200754503,'Capricorn'],
  [-1200754503,-1200540805,'Aquarius'],
  [-1200540805,-1200321292,'Pisces'],
  [-1200321292,-1200105973,'Aries'],
  [-1200105973,-1199900573,'Taurus'],
  [-1199900573,-1199704702,'Gemini'],
  [-1199704702,-1199515046,'Cancer'],
  [-1199515046,-1199328697,'Leo'],
  [-1199328697,-1199144340,'Virgo'],
  [-1199144340,-1198961189,'Libra'],
  [-1198961189,-1198777071,'Scorpio'],
  [-1198777071,-1198587815,'Sagittarius'],
  [-1198587815,-1198388696,'Capricorn'],
  [-1198388696,-1198177681,'Aquarius'],
  [-1198177681,-1197958905,'Pisces'],
  [-1197958905,-1197741940,'Aries'],
  [-1197741940,-1197535247,'Taurus'],
  [-1197535247,-1197340878,'Gemini'],
  [-1197340878,-1197155480,'Cancer'],
  [-1197155480,-1196973986,'Leo'],
  [-1196973986,-1196792276,'Virgo'],
  [-1196792276,-1196608046,'Libra'],
  [-1196608046,-1196420029,'Scorpio'],
  [-1196420029,-1196226640,'Sagittarius'],
  [-1196226640,-1196025577,'Capricorn'],
  [-1196025577,-1195815176,'Aquarius'],
  [-1195815176,-1195597248,'Pisces'],
  [-1195597248,-1195378684,'Aries'],
  [-1195378684,-1195168437,'Taurus'],
  [-1195168437,-1194971631,'Gemini'],
  [-1194971631,-1194787202,'Cancer'],
  [-1194787202,-1194610126,'Leo'],
  [-1194610126,-1194434356,'Virgo'],
  [-1194434356,-1194254710,'Libra'],
  [-1194254710,-1194067824,'Scorpio'],
  [-1194067824,-1193872288,'Sagittarius'],
  [-1193872288,-1193668127,'Capricorn'],
  [-1193668127,-1193456155,'Aquarius'],
  [-1193456155,-1193238344,'Pisces'],
  [-1193238344,-1193019128,'Aries'],
  [-1193019128,-1192805384,'Taurus'],
  [-1192805384,-1192603491,'Gemini'],
  [-1192603491,-1192415517,'Cancer'],
  [-1192415517,-1192238609,'Leo'],
  [-1192238609,-1192066882,'Virgo'],
  [-1192066882,-1191893512,'Libra'],
  [-1191893512,-1191712366,'Scorpio'],
  [-1191712366,-1191519561,'Sagittarius'],
  [-1191519561,-1191314781,'Capricorn'],
  [-1191314781,-1191100990,'Aquarius'],
  [-1191100990,-1190882447,'Pisces'],
  [-1190882447,-1190663364,'Aries'],
  [-1190663364,-1190448144,'Taurus'],
  [-1190448144,-1190241722,'Gemini'],
  [-1190241722,-1190047794,'Cancer'],
  [-1190047794,-1189866531,'Leo'],
  [-1189866531,-1189694121,'Virgo'],
  [-1189694121,-1189524036,'Libra'],
  [-1189524036,-1189348822,'Scorpio'],
  [-1189348822,-1189162009,'Sagittarius'],
  [-1189162009,-1188960626,'Capricorn'],
  [-1188960626,-1188747152,'Aquarius'],
  [-1188747152,-1188527960,'Pisces'],
  [-1188527960,-1188309181,'Aries'],
  [-1188309181,-1188094565,'Taurus'],
  [-1188094565,-1187886651,'Gemini'],
  [-1187886651,-1187688106,'Cancer'],
  [-1187688106,-1187500725,'Leo'],
  [-1187500725,-1187323525,'Virgo'],
  [-1187323525,-1187151980,'Libra'],
  [-1187151980,-1186979123,'Scorpio'],
  [-1186979123,-1186797451,'Sagittarius'],
  [-1186797451,-1186601494,'Capricorn'],
  [-1186601494,-1186391100,'Aquarius'],
  [-1186391100,-1186172438,'Pisces'],
  [-1186172438,-1185953838,'Aries'],
  [-1185953838,-1185740555,'Taurus'],
  [-1185740555,-1185534079,'Gemini'],
  [-1185534079,-1185334764,'Cancer'],
  [-1185334764,-1185143445,'Leo'],
  [-1185143445,-1184960534,'Virgo'],
  [-1184960534,-1184784090,'Libra'],
  [-1184784090,-1184609163,'Scorpio'],
  [-1184609163,-1184428962,'Sagittarius'],
  [-1184428962,-1184237107,'Capricorn'],
  [-1184237107,-1184030889,'Aquarius'],
  [-1184030889,-1183814136,'Pisces'],
  [-1183814136,-1183595637,'Aries'],
  [-1183595637,-1183382996,'Taurus'],
  [-1183382996,-1183178777,'Gemini'],
  [-1183178777,-1182981992,'Cancer'],
  [-1182981992,-1182791143,'Leo'],
  [-1182791143,-1182605502,'Virgo'],
  [-1182605502,-1182424165,'Libra'],
  [-1182424165,-1182244519,'Scorpio'],
  [-1182244519,-1182061896,'Sagittarius'],
  [-1182061896,-1181870803,'Capricorn'],
  [-1181870803,-1181667481,'Aquarius'],
  [-1181667481,-1181453101,'Pisces'],
  [-1181453101,-1181234746,'Aries'],
  [-1181234746,-1181021355,'Taurus'],
  [-1181021355,-1180817925,'Gemini'],
  [-1180817925,-1180624158,'Cancer'],
  [-1180624158,-1180437025,'Leo'],
  [-1180437025,-1180253367,'Virgo'],
  [-1180253367,-1180070834,'Libra'],
  [-1180070834,-1179887405,'Scorpio'],
  [-1179887405,-1179700539,'Sagittarius'],
  [-1179700539,-1179507014,'Capricorn'],
  [-1179507014,-1179303965,'Aquarius'],
  [-1179303965,-1179091147,'Pisces'],
  [-1179091147,-1178873009,'Aries'],
  [-1178873009,-1178657724,'Taurus'],
  [-1178657724,-1178452472,'Gemini'],
  [-1178452472,-1178259353,'Cancer'],
  [-1178259353,-1178075759,'Leo'],
  [-1178075759,-1177896914,'Virgo'],
  [-1177896914,-1177717935,'Libra'],
  [-1177717935,-1177534984,'Scorpio'],
  [-1177534984,-1177345631,'Sagittarius'],
  [-1177345631,-1177148644,'Capricorn'],
  [-1177148644,-1176943540,'Aquarius'],
  [-1176943540,-1176730729,'Pisces'],
  [-1176730729,-1176512805,'Aries'],
  [-1176512805,-1176295559,'Taurus'],
  [-1176295559,-1176086438,'Gemini'],
  [-1176086438,-1175890326,'Cancer'],
  [-1175890326,-1175706943,'Leo'],
  [-1175706943,-1175531798,'Virgo'],
  [-1175531798,-1175358437,'Libra'],
  [-1175358437,-1175180453,'Scorpio'],
  [-1175180453,-1174993184,'Sagittarius'],
  [-1174993184,-1174795056,'Capricorn'],
  [-1174795056,-1174587524,'Aquarius'],
  [-1174587524,-1174373381,'Pisces'],
  [-1174373381,-1174155475,'Aries'],
  [-1174155475,-1173937376,'Taurus'],
  [-1173937376,-1173724551,'Gemini'],
  [-1173724551,-1173522963,'Cancer'],
  [-1173522963,-1173335424,'Leo'],
  [-1173335424,-1173159723,'Virgo'],
  [-1173159723,-1172989721,'Libra'],
  [-1172989721,-1172817671,'Scorpio'],
  [-1172817671,-1172636368,'Sagittarius'],
  [-1172636368,-1172441581,'Capricorn'],
  [-1172441581,-1172234075,'Aquarius'],
  [-1172234075,-1172018609,'Pisces'],
  [-1172018609,-1171800330,'Aries'],
  [-1171800330,-1171582663,'Taurus'],
  [-1171582663,-1171368613,'Gemini'],
  [-1171368613,-1171162487,'Cancer'],
  [-1171162487,-1170968510,'Leo'],
  [-1170968510,-1170787622,'Virgo'],
  [-1170787622,-1170615989,'Libra'],
  [-1170615989,-1170446433,'Scorpio'],
  [-1170446433,-1170270777,'Sagittarius'],
  [-1170270777,-1170082259,'Capricorn'],
  [-1170082259,-1169878639,'Aquarius'],
  [-1169878639,-1169663841,'Pisces'],
  [-1169663841,-1169445129,'Aries'],
  [-1169445129,-1169228154,'Taurus'],
  [-1169228154,-1169015441,'Gemini'],
  [-1169015441,-1168808704,'Cancer'],
  [-1168808704,-1168610526,'Leo'],
  [-1168610526,-1168423092,'Virgo'],
  [-1168423092,-1168245566,'Libra'],
  [-1168245566,-1168073216,'Scorpio'],
  [-1168073216,-1167898881,'Sagittarius'],
  [-1167898881,-1167715167,'Capricorn'],
  [-1167715167,-1167517225,'Aquarius'],
  [-1167517225,-1167305814,'Pisces'],
  [-1167305814,-1167087578,'Aries'],
  [-1167087578,-1166870616,'Taurus'],
  [-1166870616,-1166659576,'Gemini'],
  [-1166659576,-1166455455,'Cancer'],
  [-1166455455,-1166258151,'Leo'],
  [-1166258151,-1166067945,'Virgo'],
  [-1166067945,-1165884711,'Libra'],
  [-1165884711,-1165706354,'Scorpio'],
  [-1165706354,-1165528372,'Sagittarius'],
  [-1165528372,-1165344860,'Capricorn'],
  [-1165344860,-1165150492,'Aquarius'],
  [-1165150492,-1164943274,'Pisces'],
  [-1164943274,-1164726849,'Aries'],
  [-1164726849,-1164509357,'Taurus'],
  [-1164509357,-1164298263,'Gemini'],
  [-1164298263,-1164096502,'Cancer'],
  [-1164096502,-1163903106,'Leo'],
  [-1163903106,-1163715634,'Virgo'],
  [-1163715634,-1163531734,'Libra'],
  [-1163531734,-1163349310,'Scorpio'],
  [-1163349310,-1163165971,'Sagittarius'],
  [-1163165971,-1162978602,'Capricorn'],
  [-1162978602,-1162783668,'Aquarius'],
  [-1162783668,-1162578638,'Pisces'],
  [-1162578638,-1162364318,'Aries'],
  [-1162364318,-1162146404,'Taurus'],
  [-1162146404,-1161933322,'Gemini'],
  [-1161933322,-1161731036,'Cancer'],
  [-1161731036,-1161540251,'Leo'],
  [-1161540251,-1161357586,'Virgo'],
  [-1161357586,-1161178088,'Libra'],
  [-1161178088,-1160997208,'Scorpio'],
  [-1160997208,-1160811833,'Sagittarius'],
  [-1160811833,-1160620386,'Capricorn'],
  [-1160620386,-1160422076,'Aquarius'],
  [-1160422076,-1160216187,'Pisces'],
  [-1160216187,-1160002784,'Aries'],
  [-1160002784,-1159784793,'Taurus'],
  [-1159784793,-1159569060,'Gemini'],
  [-1159569060,-1159363342,'Cancer'],
  [-1159363342,-1159171355,'Leo'],
  [-1159171355,-1158991085,'Virgo'],
  [-1158991085,-1158816699,'Libra'],
  [-1158816699,-1158641339,'Scorpio'],
  [-1158641339,-1158459319,'Sagittarius'],
  [-1158459319,-1158267742,'Capricorn'],
  [-1158267742,-1158066872,'Aquarius'],
  [-1158066872,-1157858556,'Pisces'],
  [-1157858556,-1157644454,'Aries'],
  [-1157644454,-1157426469,'Taurus'],
  [-1157426469,-1157208905,'Gemini'],
  [-1157208905,-1156998848,'Cancer'],
  [-1156998848,-1156802315,'Leo'],
  [-1156802315,-1156620100,'Virgo'],
  [-1156620100,-1156447511,'Libra'],
  [-1156447511,-1156277040,'Scorpio'],
  [-1156277040,-1156101040,'Sagittarius'],
  [-1156101040,-1155913957,'Capricorn'],
  [-1155913957,-1155714338,'Aquarius'],
  [-1155714338,-1155504803,'Pisces'],
  [-1155504803,-1155289381,'Aries'],
  [-1155289381,-1155071213,'Taurus'],
  [-1155071213,-1154853269,'Gemini'],
  [-1154853269,-1154640399,'Cancer'],
  [-1154640399,-1154438601,'Leo'],
  [-1154438601,-1154251129,'Virgo'],
  [-1154251129,-1154075857,'Libra'],
  [-1154075857,-1153906389,'Scorpio'],
  [-1153906389,-1153734743,'Sagittarius'],
  [-1153734743,-1153553639,'Capricorn'],
  [-1153553639,-1153358880,'Aquarius'],
  [-1153358880,-1153151223,'Pisces'],
  [-1153151223,-1152935474,'Aries'],
  [-1152935474,-1152717045,'Taurus'],
  [-1152717045,-1152499713,'Gemini'],
  [-1152499713,-1152286691,'Cancer'],
  [-1152286691,-1152081955,'Leo'],
  [-1152081955,-1151889014,'Virgo'],
  [-1151889014,-1151708127,'Libra'],
  [-1151708127,-1151535322,'Scorpio'],
  [-1151535322,-1151363894,'Sagittarius'],
  [-1151363894,-1151186486,'Capricorn'],
  [-1151186486,-1150997196,'Aquarius'],
  [-1150997196,-1150793959,'Pisces'],
  [-1150793959,-1150579874,'Aries'],
  [-1150579874,-1150361503,'Taurus'],
  [-1150361503,-1150144850,'Gemini'],
  [-1150144850,-1149933469,'Cancer'],
  [-1149933469,-1149729390,'Leo'],
  [-1149729390,-1149534139,'Virgo'],
  [-1149534139,-1149348193,'Libra'],
  [-1149348193,-1149169747,'Scorpio'],
  [-1149169747,-1148994524,'Sagittarius'],
  [-1148994524,-1148816701,'Capricorn'],
  [-1148816701,-1148630387,'Aquarius'],
  [-1148630387,-1148431637,'Pisces'],
  [-1148431637,-1148220724,'Aries'],
  [-1148220724,-1148003055,'Taurus'],
  [-1148003055,-1147786431,'Gemini'],
  [-1147786431,-1147576534,'Cancer'],
  [-1147576534,-1147375251,'Leo'],
  [-1147375251,-1147181889,'Virgo'],
  [-1147181889,-1146994861,'Libra'],
  [-1146994861,-1146812295,'Scorpio'],
  [-1146812295,-1146631782,'Sagittarius'],
  [-1146631782,-1146450016,'Capricorn'],
  [-1146450016,-1146262856,'Aquarius'],
  [-1146262856,-1146066273,'Pisces'],
  [-1146066273,-1145858389,'Aries'],
  [-1145858389,-1145641956,'Taurus'],
  [-1145641956,-1145424563,'Gemini'],
  [-1145424563,-1145214344,'Cancer'],
  [-1145214344,-1145015110,'Leo'],
  [-1145015110,-1144825625,'Virgo'],
  [-1144825625,-1144641956,'Libra'],
  [-1144641956,-1144459985,'Scorpio'],
  [-1144459985,-1144276751,'Sagittarius'],
  [-1144276751,-1144090472,'Capricorn'],
  [-1144090472,-1143899595,'Aquarius'],
  [-1143899595,-1143701941,'Pisces'],
  [-1143701941,-1143495338,'Aries'],
  [-1143495338,-1143280117,'Taurus'],
  [-1143280117,-1143061648,'Gemini'],
  [-1143061648,-1142848938,'Cancer'],
  [-1142848938,-1142648717,'Leo'],
  [-1142648717,-1142461420,'Virgo'],
  [-1142461420,-1142282408,'Libra'],
  [-1142282408,-1142105280,'Scorpio'],
  [-1142105280,-1141924558,'Sagittarius'],
  [-1141924558,-1141737296,'Capricorn'],
  [-1141737296,-1141543076,'Aquarius'],
  [-1141543076,-1141342295,'Pisces'],
  [-1141342295,-1141134652,'Aries'],
  [-1141134652,-1140919911,'Taurus'],
  [-1140919911,-1140700818,'Gemini'],
  [-1140700818,-1140484795,'Cancer'],
  [-1140484795,-1140280366,'Leo'],
  [-1140280366,-1140091086,'Virgo'],
  [-1140091086,-1139913832,'Libra'],
  [-1139913832,-1139741633,'Scorpio'],
  [-1139741633,-1139566943,'Sagittarius'],
  [-1139566943,-1139384016,'Capricorn'],
  [-1139384016,-1139190623,'Aquarius'],
  [-1139190623,-1138987870,'Pisces'],
  [-1138987870,-1138777988,'Aries'],
  [-1138777988,-1138562593,'Taurus'],
  [-1138562593,-1138343552,'Gemini'],
  [-1138343552,-1138125574,'Cancer'],
  [-1138125574,-1137916185,'Leo'],
  [-1137916185,-1137721250,'Virgo'],
  [-1137721250,-1137540780,'Libra'],
  [-1137540780,-1137369372,'Scorpio'],
  [-1137369372,-1137199279,'Sagittarius'],
  [-1137199279,-1137022963,'Capricorn'],
  [-1137022963,-1136835176,'Aquarius'],
  [-1136835176,-1136634673,'Pisces'],
  [-1136634673,-1136424036,'Aries'],
  [-1136424036,-1136207447,'Taurus'],
  [-1136207447,-1135988545,'Gemini'],
  [-1135988545,-1135770843,'Cancer'],
  [-1135770843,-1135559136,'Leo'],
  [-1135559136,-1135358584,'Virgo'],
  [-1135358584,-1135171557,'Libra'],
  [-1135171557,-1134995733,'Scorpio'],
  [-1134995733,-1134825200,'Sagittarius'],
  [-1134825200,-1134652651,'Capricorn'],
  [-1134652651,-1134471264,'Aquarius'],
  [-1134471264,-1134276664,'Pisces'],
  [-1134276664,-1134068792,'Aries'],
  [-1134068792,-1133852134,'Taurus'],
  [-1133852134,-1133633031,'Gemini'],
  [-1133633031,-1133416561,'Cancer'],
  [-1133416561,-1133206035,'Leo'],
  [-1133206035,-1133003876,'Virgo'],
  [-1133003876,-1132811700,'Libra'],
  [-1132811700,-1132629205,'Scorpio'],
  [-1132629205,-1132453473,'Sagittarius'],
  [-1132453473,-1132279371,'Capricorn'],
  [-1132279371,-1132100648,'Aquarius'],
  [-1132100648,-1131911474,'Pisces'],
  [-1131911474,-1131708655,'Aries'],
  [-1131708655,-1131494130,'Taurus'],
  [-1131494130,-1131274948,'Gemini'],
  [-1131274948,-1131058997,'Cancer'],
  [-1131058997,-1130850814,'Leo'],
  [-1130850814,-1130651116,'Virgo'],
  [-1130651116,-1130458823,'Libra'],
  [-1130458823,-1130272593,'Scorpio'],
  [-1130272593,-1130090945,'Sagittarius'],
  [-1130090945,-1129911547,'Capricorn'],
  [-1129911547,-1129730554,'Aquarius'],
  [-1129730554,-1129542904,'Pisces'],
  [-1129542904,-1129343999,'Aries'],
  [-1129343999,-1129132727,'Taurus'],
  [-1129132727,-1128914131,'Gemini'],
  [-1128914131,-1128697503,'Cancer'],
  [-1128697503,-1128490155,'Leo'],
  [-1128490155,-1128293614,'Virgo'],
  [-1128293614,-1128105036,'Libra'],
  [-1128105036,-1127920480,'Scorpio'],
  [-1127920480,-1127737028,'Sagittarius'],
  [-1127737028,-1127553129,'Capricorn'],
  [-1127553129,-1127367409,'Aquarius'],
  [-1127367409,-1127177256,'Pisces'],
  [-1127177256,-1126978929,'Aries'],
  [-1126978929,-1126769859,'Taurus'],
  [-1126769859,-1126552234,'Gemini'],
  [-1126552234,-1126334252,'Cancer'],
  [-1126334252,-1126125313,'Leo'],
  [-1126125313,-1125929504,'Virgo'],
  [-1125929504,-1125744447,'Libra'],
  [-1125744447,-1125564574,'Scorpio'],
  [-1125564574,-1125384467,'Sagittarius'],
  [-1125384467,-1125200739,'Capricorn'],
  [-1125200739,-1125012188,'Aquarius'],
  [-1125012188,-1124818295,'Pisces'],
  [-1124818295,-1124617699,'Aries'],
  [-1124617699,-1124408618,'Taurus'],
  [-1124408618,-1124191598,'Gemini'],
  [-1124191598,-1123972356,'Cancer'],
  [-1123972356,-1123760224,'Leo'],
  [-1123760224,-1123561840,'Virgo'],
  [-1123561840,-1123377078,'Libra'],
  [-1123377078,-1123200692,'Scorpio'],
  [-1123200692,-1123025866,'Sagittarius'],
  [-1123025866,-1122846782,'Capricorn'],
  [-1122846782,-1122660068,'Aquarius'],
  [-1122660068,-1122464890,'Pisces'],
  [-1122464890,-1122261684,'Aries'],
  [-1122261684,-1122050952,'Taurus'],
  [-1122050952,-1121833737,'Gemini'],
  [-1121833737,-1121613866,'Cancer'],
  [-1121613866,-1121398695,'Leo'],
  [-1121398695,-1121195674,'Virgo'],
  [-1121195674,-1121007416,'Libra'],
  [-1121007416,-1120830698,'Scorpio'],
  [-1120830698,-1120659061,'Sagittarius'],
  [-1120659061,-1120485498,'Capricorn'],
  [-1120485498,-1120304234,'Aquarius'],
  [-1120304234,-1120112028,'Pisces'],
  [-1120112028,-1119908696,'Aries'],
  [-1119908696,-1119696446,'Taurus'],
  [-1119696446,-1119478466,'Gemini'],
  [-1119478466,-1119258612,'Cancer'],
  [-1119258612,-1119042123,'Leo'],
  [-1119042123,-1118834969,'Virgo'],
  [-1118834969,-1118641125,'Libra'],
  [-1118641125,-1118460120,'Scorpio'],
  [-1118460120,-1118287468,'Sagittarius'],
  [-1118287468,-1118116642,'Capricorn'],
  [-1118116642,-1117940798,'Aquarius'],
  [-1117940798,-1117754285,'Pisces'],
  [-1117754285,-1117554371,'Aries'],
  [-1117554371,-1117342610,'Taurus'],
  [-1117342610,-1117124065,'Gemini'],
  [-1117124065,-1116904495,'Cancer'],
  [-1116904495,-1116688634,'Leo'],
  [-1116688634,-1116480144,'Virgo'],
  [-1116480144,-1116281859,'Libra'],
  [-1116281859,-1116094832,'Scorpio'],
  [-1116094832,-1115917301,'Sagittarius'],
  [-1115917301,-1115744804,'Capricorn'],
  [-1115744804,-1115571114,'Aquarius'],
  [-1115571114,-1115389567,'Pisces'],
  [-1115389567,-1115194962,'Aries'],
  [-1115194962,-1114986267,'Taurus'],
  [-1114986267,-1114768238,'Gemini'],
  [-1114768238,-1114548836,'Cancer'],
  [-1114548836,-1114334376,'Leo'],
  [-1114334376,-1114127495,'Virgo'],
  [-1114127495,-1113928590,'Libra'],
  [-1113928590,-1113737622,'Scorpio'],
  [-1113737622,-1113554187,'Sagittarius'],
  [-1113554187,-1113376495,'Capricorn'],
  [-1113376495,-1113200540,'Aquarius'],
  [-1113200540,-1113020434,'Pisces'],
  [-1113020434,-1112829977,'Aries'],
  [-1112829977,-1112625525,'Taurus'],
  [-1112625525,-1112409397,'Gemini'],
  [-1112409397,-1112189971,'Cancer'],
  [-1112189971,-1111976096,'Leo'],
  [-1111976096,-1111771643,'Virgo'],
  [-1111771643,-1111575612,'Libra'],
  [-1111575612,-1111385427,'Scorpio'],
  [-1111385427,-1111199321,'Sagittarius'],
  [-1111199321,-1111016452,'Capricorn'],
  [-1111016452,-1110835348,'Aquarius'],
  [-1110835348,-1110652508,'Pisces'],
  [-1110652508,-1110462721,'Aries'],
  [-1110462721,-1110261273,'Taurus'],
  [-1110261273,-1110047668,'Gemini'],
  [-1110047668,-1109828299,'Cancer'],
  [-1109828299,-1109613346,'Leo'],
  [-1109613346,-1109409453,'Virgo'],
  [-1109409453,-1109216569,'Libra'],
  [-1109216569,-1109030613,'Scorpio'],
  [-1109030613,-1108847171,'Sagittarius'],
  [-1108847171,-1108663539,'Capricorn'],
  [-1108663539,-1108478590,'Aquarius'],
  [-1108478590,-1108291093,'Pisces'],
  [-1108291093,-1108098394,'Aries'],
  [-1108098394,-1107896969,'Taurus'],
  [-1107896969,-1107685042,'Gemini'],
  [-1107685042,-1107466057,'Cancer'],
  [-1107466057,-1107248945,'Leo'],
  [-1107248945,-1107042544,'Virgo'],
  [-1107042544,-1106849669,'Libra'],
  [-1106849669,-1106667085,'Scorpio'],
  [-1106667085,-1106488994,'Sagittarius'],
  [-1106488994,-1106309974,'Capricorn'],
  [-1106309974,-1106126487,'Aquarius'],
  [-1106126487,-1105936921,'Pisces'],
  [-1105936921,-1105740524,'Aries'],
  [-1105740524,-1105536483,'Taurus'],
  [-1105536483,-1105324279,'Gemini'],
  [-1105324279,-1105105756,'Cancer'],
  [-1105105756,-1104886957,'Leo'],
  [-1104886957,-1104676297,'Virgo'],
  [-1104676297,-1104479375,'Libra'],
  [-1104479375,-1104295825,'Scorpio'],
  [-1104295825,-1104120765,'Sagittarius'],
  [-1104120765,-1103947637,'Capricorn'],
  [-1103947637,-1103770251,'Aquarius'],
  [-1103770251,-1103584159,'Pisces'],
  [-1103584159,-1103387518,'Aries'],
  [-1103387518,-1103181055,'Taurus'],
  [-1103181055,-1102967043,'Gemini'],
  [-1102967043,-1102748436,'Cancer'],
  [-1102748436,-1102529365,'Leo'],
  [-1102529365,-1102315596,'Virgo'],
  [-1102315596,-1102112953,'Libra'],
  [-1102112953,-1101924059,'Scorpio'],
  [-1101924059,-1101746900,'Sagittarius'],
  [-1101746900,-1101575985,'Capricorn'],
  [-1101575985,-1101404280,'Aquarius'],
  [-1101404280,-1101224908,'Pisces'],
  [-1101224908,-1101032977,'Aries'],
  [-1101032977,-1100827609,'Taurus'],
  [-1100827609,-1100612431,'Gemini'],
  [-1100612431,-1100393138,'Cancer'],
  [-1100393138,-1100174647,'Leo'],
  [-1100174647,-1099960600,'Virgo'],
  [-1099960600,-1099754479,'Libra'],
  [-1099754479,-1099559371,'Scorpio'],
  [-1099559371,-1099376132,'Sagittarius'],
  [-1099376132,-1099202117,'Capricorn'],
  [-1099202117,-1099031528,'Aquarius'],
  [-1099031528,-1098856980,'Pisces'],
  [-1098856980,-1098671432,'Aries'],
  [-1098671432,-1098470896,'Taurus'],
  [-1098470896,-1098257263,'Gemini'],
  [-1098257263,-1098037669,'Cancer'],
  [-1098037669,-1097819597,'Leo'],
  [-1097819597,-1097607079,'Virgo'],
  [-1097607079,-1097401391,'Libra'],
  [-1097401391,-1097203491,'Scorpio'],
  [-1097203491,-1097014531,'Sagittarius'],
  [-1097014531,-1096834393,'Capricorn'],
  [-1096834393,-1096660027,'Aquarius'],
  [-1096660027,-1096485497,'Pisces'],
  [-1096485497,-1096303585,'Aries'],
  [-1096303585,-1096108324,'Taurus'],
  [-1096108324,-1095898537,'Gemini'],
  [-1095898537,-1095679968,'Cancer'],
  [-1095679968,-1095461876,'Leo'],
  [-1095461876,-1095250622,'Virgo'],
  [-1095250622,-1095047479,'Libra'],
  [-1095047479,-1094851207,'Scorpio'],
  [-1094851207,-1094660851,'Sagittarius'],
  [-1094660851,-1094476206,'Capricorn'],
  [-1094476206,-1094296279,'Aquarius'],
  [-1094296279,-1094117727,'Pisces'],
  [-1094117727,-1093935006,'Aries'],
  [-1093935006,-1093742180,'Taurus'],
  [-1093742180,-1093536054,'Gemini'],
  [-1093536054,-1093319515,'Cancer'],
  [-1093319515,-1093101211,'Leo'],
  [-1093101211,-1092889724,'Virgo'],
  [-1092889724,-1092688348,'Libra'],
  [-1092688348,-1092495539,'Scorpio'],
  [-1092495539,-1092308169,'Sagittarius'],
  [-1092308169,-1092123813,'Capricorn'],
  [-1092123813,-1091940956,'Aquarius'],
  [-1091940956,-1091757805,'Pisces'],
  [-1091757805,-1091571264,'Aries'],
  [-1091571264,-1091377230,'Taurus'],
  [-1091377230,-1091172493,'Gemini'],
  [-1091172493,-1090957742,'Cancer'],
  [-1090957742,-1090739248,'Leo'],
  [-1090739248,-1090526007,'Virgo'],
  [-1090526007,-1090323889,'Libra'],
  [-1090323889,-1090133039,'Scorpio'],
  [-1090133039,-1089949842,'Sagittarius'],
  [-1089949842,-1089769726,'Capricorn'],
  [-1089769726,-1089588822,'Aquarius'],
  [-1089588822,-1089404383,'Pisces'],
  [-1089404383,-1089214402,'Aries'],
  [-1089214402,-1089017138,'Taurus'],
  [-1089017138,-1088811230,'Gemini'],
  [-1088811230,-1088597026,'Cancer'],
  [-1088597026,-1088378431,'Leo'],
  [-1088378431,-1088162804,'Virgo'],
  [-1088162804,-1087957432,'Libra'],
  [-1087957432,-1087765189,'Scorpio'],
  [-1087765189,-1087583882,'Sagittarius'],
  [-1087583882,-1087408361,'Capricorn'],
  [-1087408361,-1087232679,'Aquarius'],
  [-1087232679,-1087051630,'Pisces'],
  [-1087051630,-1086861844,'Aries'],
  [-1086861844,-1086662341,'Taurus'],
  [-1086662341,-1086454099,'Gemini'],
  [-1086454099,-1086239111,'Cancer'],
  [-1086239111,-1086020454,'Leo'],
  [-1086020454,-1085803092,'Virgo'],
  [-1085803092,-1085593524,'Libra'],
  [-1085593524,-1085396759,'Scorpio'],
  [-1085396759,-1085213346,'Sagittarius'],
  [-1085213346,-1085039390,'Capricorn'],
  [-1085039390,-1084868375,'Aquarius'],
  [-1084868375,-1084693160,'Pisces'],
  [-1084693160,-1084507814,'Aries'],
  [-1084507814,-1084309646,'Taurus'],
  [-1084309646,-1084100266,'Gemini'],
  [-1084100266,-1083884006,'Cancer'],
  [-1083884006,-1083665214,'Leo'],
  [-1083665214,-1083447544,'Virgo'],
  [-1083447544,-1083235198,'Libra'],
  [-1083235198,-1083033065,'Scorpio'],
  [-1083033065,-1082844172,'Sagittarius'],
  [-1082844172,-1082667342,'Capricorn'],
  [-1082667342,-1082497276,'Aquarius'],
  [-1082497276,-1082326429,'Pisces'],
  [-1082326429,-1082147101,'Aries'],
  [-1082147101,-1081953876,'Taurus'],
  [-1081953876,-1081746437,'Gemini'],
  [-1081746437,-1081529858,'Cancer'],
  [-1081529858,-1081310849,'Leo'],
  [-1081310849,-1081093939,'Virgo'],
  [-1081093939,-1080881610,'Libra'],
  [-1080881610,-1080676546,'Scorpio'],
  [-1080676546,-1080481898,'Sagittarius'],
  [-1080481898,-1080298991,'Capricorn'],
  [-1080298991,-1080125232,'Aquarius'],
  [-1080125232,-1079954455,'Pisces'],
  [-1079954455,-1079778860,'Aries'],
  [-1079778860,-1079591337,'Taurus'],
  [-1079591337,-1079388616,'Gemini'],
  [-1079388616,-1079173844,'Cancer'],
  [-1079173844,-1078954854,'Leo'],
  [-1078954854,-1078738639,'Virgo'],
  [-1078738639,-1078528192,'Libra'],
  [-1078528192,-1078324172,'Scorpio'],
  [-1078324172,-1078127444,'Sagittarius'],
  [-1078127444,-1077939260,'Capricorn'],
  [-1077939260,-1077759289,'Aquarius'],
  [-1077759289,-1077584088,'Pisces'],
  [-1077584088,-1077407598,'Aries'],
  [-1077407598,-1077222932,'Taurus'],
  [-1077222932,-1077025021,'Gemini'],
  [-1077025021,-1076813851,'Cancer'],
  [-1076813851,-1076595668,'Leo'],
  [-1076595668,-1076379234,'Virgo'],
  [-1076379234,-1076170106,'Libra'],
  [-1076170106,-1075969173,'Scorpio'],
  [-1075969173,-1075775081,'Sagittarius'],
  [-1075775081,-1075586539,'Capricorn'],
  [-1075586539,-1075402638,'Aquarius'],
  [-1075402638,-1075221714,'Pisces'],
  [-1075221714,-1075040449,'Aries'],
  [-1075040449,-1074854125,'Taurus'],
  [-1074854125,-1074658086,'Gemini'],
  [-1074658086,-1074450264,'Cancer'],
  [-1074450264,-1074233723,'Leo'],
  [-1074233723,-1074016370,'Virgo'],
  [-1074016370,-1073806253,'Libra'],
  [-1073806253,-1073606831,'Scorpio'],
  [-1073606831,-1073416809,'Sagittarius'],
  [-1073416809,-1073232625,'Capricorn'],
  [-1073232625,-1073050580,'Aquarius'],
  [-1073050580,-1072867764,'Pisces'],
  [-1072867764,-1072681970,'Aries'],
  [-1072681970,-1072491160,'Taurus'],
  [-1072491160,-1072293155,'Gemini'],
  [-1072293155,-1072086284,'Cancer'],
  [-1072086284,-1071871294,'Leo'],
  [-1071871294,-1071653193,'Virgo'],
  [-1071653193,-1071440139,'Libra'],
  [-1071440139,-1071238617,'Scorpio'],
  [-1071238617,-1071049805,'Sagittarius'],
  [-1071049805,-1070870125,'Capricorn'],
  [-1070870125,-1070693754,'Aquarius'],
  [-1070693754,-1070514925,'Pisces'],
  [-1070514925,-1070329522,'Aries'],
  [-1070329522,-1070135888,'Taurus'],
  [-1070135888,-1069934337,'Gemini'],
  [-1069934337,-1069725736,'Cancer'],
  [-1069725736,-1069511054,'Leo'],
  [-1069511054,-1069292835,'Virgo'],
  [-1069292835,-1069076884,'Libra'],
  [-1069076884,-1068870662,'Scorpio'],
  [-1068870662,-1068678590,'Sagittarius'],
  [-1068678590,-1068499383,'Capricorn'],
  [-1068499383,-1068327244,'Aquarius'],
  [-1068327244,-1068154651,'Pisces'],
  [-1068154651,-1067974742,'Aries'],
  [-1067974742,-1067783433,'Taurus'],
  [-1067783433,-1067580800,'Gemini'],
  [-1067580800,-1067369945,'Cancer'],
  [-1067369945,-1067154223,'Leo'],
  [-1067154223,-1066936135,'Virgo'],
  [-1066936135,-1066719013,'Libra'],
  [-1066719013,-1066508573,'Scorpio'],
  [-1066508573,-1066310692,'Sagittarius'],
  [-1066310692,-1066127256,'Capricorn'],
  [-1066127256,-1065954584,'Aquarius'],
  [-1065954584,-1065785392,'Pisces'],
  [-1065785392,-1065611532,'Aries'],
  [-1065611532,-1065426324,'Taurus'],
  [-1065426324,-1065227107,'Gemini'],
  [-1065227107,-1065016415,'Cancer'],
  [-1065016415,-1064799664,'Leo'],
  [-1064799664,-1064581488,'Virgo'],
  [-1064581488,-1064364851,'Libra'],
  [-1064364851,-1064153066,'Scorpio'],
  [-1064153066,-1063950675,'Sagittarius'],
  [-1063950675,-1063761084,'Capricorn'],
  [-1063761084,-1063583533,'Aquarius'],
  [-1063583533,-1063412796,'Pisces'],
  [-1063412796,-1063241301,'Aries'],
  [-1063241301,-1063061445,'Taurus'],
  [-1063061445,-1062868029,'Gemini'],
  [-1062868029,-1062660778,'Cancer'],
  [-1062660778,-1062444616,'Leo'],
  [-1062444616,-1062226298,'Virgo'],
  [-1062226298,-1062010604,'Libra'],
  [-1062010604,-1061800122,'Scorpio'],
  [-1061800122,-1061597021,'Sagittarius'],
  [-1061597021,-1061403489,'Capricorn'],
  [-1061403489,-1061220088,'Aquarius'],
  [-1061220088,-1061044211,'Pisces'],
  [-1061044211,-1060870419,'Aries'],
  [-1060870419,-1060691998,'Taurus'],
  [-1060691998,-1060502946,'Gemini'],
  [-1060502946,-1060300406,'Cancer'],
  [-1060300406,-1060086693,'Leo'],
  [-1060086693,-1059868619,'Virgo'],
  [-1059868619,-1059653300,'Libra'],
  [-1059653300,-1059444753,'Scorpio'],
  [-1059444753,-1059244052,'Sagittarius'],
  [-1059244052,-1059050965,'Capricorn'],
  [-1059050965,-1058864770,'Aquarius'],
  [-1058864770,-1058683828,'Pisces'],
  [-1058683828,-1058505047,'Aries'],
  [-1058505047,-1058323973,'Taurus'],
  [-1058323973,-1058135655,'Gemini'],
  [-1058135655,-1057936301,'Cancer'],
  [-1057936301,-1057725577,'Leo'],
  [-1057725577,-1057508232,'Virgo'],
  [-1057508232,-1057292329,'Libra'],
  [-1057292329,-1057084383,'Scorpio'],
  [-1057084383,-1056886455,'Sagittarius'],
  [-1056886455,-1056696905,'Capricorn'],
  [-1056696905,-1056512563,'Aquarius'],
  [-1056512563,-1056330316,'Pisces'],
  [-1056330316,-1056147593,'Aries'],
  [-1056147593,-1055962064,'Taurus'],
  [-1055962064,-1055771132,'Gemini'],
  [-1055771132,-1055572012,'Cancer'],
  [-1055572012,-1055363154,'Leo'],
  [-1055363154,-1055146678,'Virgo'],
  [-1055146678,-1054929466,'Libra'],
  [-1054929466,-1054719905,'Scorpio'],
  [-1054719905,-1054522546,'Sagittarius'],
  [-1054522546,-1054336315,'Capricorn'],
  [-1054336315,-1054156503,'Aquarius'],
  [-1054156503,-1053977578,'Pisces'],
  [-1053977578,-1053795185,'Aries'],
  [-1053795185,-1053607048,'Taurus'],
  [-1053607048,-1053412508,'Gemini'],
  [-1053412508,-1053211139,'Cancer'],
  [-1053211139,-1053002197,'Leo'],
  [-1053002197,-1052786232,'Virgo'],
  [-1052786232,-1052567696,'Libra'],
  [-1052567696,-1052354839,'Scorpio'],
  [-1052354839,-1052154776,'Sagittarius'],
  [-1052154776,-1051968770,'Capricorn'],
  [-1051968770,-1051792430,'Aquarius'],
  [-1051792430,-1051618779,'Pisces'],
  [-1051618779,-1051441067,'Aries'],
  [-1051441067,-1051254854,'Taurus'],
  [-1051254854,-1051059097,'Gemini'],
  [-1051059097,-1050855156,'Cancer'],
  [-1050855156,-1050644592,'Leo'],
  [-1050644592,-1050428462,'Virgo'],
  [-1050428462,-1050209292,'Libra'],
  [-1050209292,-1049993254,'Scorpio'],
  [-1049993254,-1049788227,'Sagittarius'],
  [-1049788227,-1049598401,'Capricorn'],
  [-1049598401,-1049421579,'Aquarius'],
  [-1049421579,-1049251119,'Pisces'],
  [-1049251119,-1049079083,'Aries'],
  [-1049079083,-1048898620,'Taurus'],
  [-1048898620,-1048706111,'Gemini'],
  [-1048706111,-1048502172,'Cancer'],
  [-1048502172,-1048290086,'Leo'],
  [-1048290086,-1048073189,'Virgo'],
  [-1048073189,-1047854149,'Libra'],
  [-1047854149,-1047636905,'Scorpio'],
  [-1047636905,-1047427582,'Sagittarius'],
  [-1047427582,-1047231638,'Capricorn'],
  [-1047231638,-1047049901,'Aquarius'],
  [-1047049901,-1046877934,'Pisces'],
  [-1046877934,-1046708416,'Aries'],
  [-1046708416,-1046533597,'Taurus'],
  [-1046533597,-1046347368,'Gemini'],
  [-1046347368,-1046147416,'Cancer'],
  [-1046147416,-1045936069,'Leo'],
  [-1045936069,-1045718533,'Virgo'],
  [-1045718533,-1045499766,'Libra'],
  [-1045499766,-1045283459,'Scorpio'],
  [-1045283459,-1045073239,'Sagittarius'],
  [-1045073239,-1044872911,'Capricorn'],
  [-1044872911,-1044684602,'Aquarius'],
  [-1044684602,-1044506827,'Pisces'],
  [-1044506827,-1044334681,'Aries'],
  [-1044334681,-1044161447,'Taurus'],
  [-1044161447,-1043980324,'Gemini'],
  [-1043980324,-1043786387,'Cancer'],
  [-1043786387,-1043578828,'Leo'],
  [-1043578828,-1043362013,'Virgo'],
  [-1043362013,-1043143173,'Libra'],
  [-1043143173,-1042928228,'Scorpio'],
  [-1042928228,-1042720198,'Sagittarius'],
  [-1042720198,-1042520177,'Capricorn'],
  [-1042520177,-1042328496,'Aquarius'],
  [-1042328496,-1042144579,'Pisces'],
  [-1042144579,-1041966254,'Aries'],
  [-1041966254,-1041789511,'Taurus'],
  [-1041789511,-1041608969,'Gemini'],
  [-1041608969,-1041419098,'Cancer'],
  [-1041419098,-1041216370,'Leo'],
  [-1041216370,-1041002063,'Virgo'],
  [-1041002063,-1040783133,'Libra'],
  [-1040783133,-1040568234,'Scorpio'],
  [-1040568234,-1040362440,'Sagittarius'],
  [-1040362440,-1040165959,'Capricorn'],
  [-1040165959,-1039976358,'Aquarius'],
  [-1039976358,-1039790975,'Pisces'],
  [-1039790975,-1039607863,'Aries'],
  [-1039607863,-1039425355,'Taurus'],
  [-1039425355,-1039240940,'Gemini'],
  [-1039240940,-1039050766,'Cancer'],
  [-1039050766,-1038850733,'Leo'],
  [-1038850733,-1038639340,'Virgo'],
  [-1038639340,-1038420835,'Libra'],
  [-1038420835,-1038204475,'Scorpio'],
  [-1038204475,-1037998369,'Sagittarius'],
  [-1037998369,-1037804496,'Capricorn'],
  [-1037804496,-1037619454,'Aquarius'],
  [-1037619454,-1037437971,'Pisces'],
  [-1037437971,-1037255700,'Aries'],
  [-1037255700,-1037070414,'Taurus'],
  [-1037070414,-1036881388,'Gemini'],
  [-1036881388,-1036687581,'Cancer'],
  [-1036687581,-1036486700,'Leo'],
  [-1036486700,-1036276640,'Virgo'],
  [-1036276640,-1036058876,'Libra'],
  [-1036058876,-1035840655,'Scorpio'],
  [-1035840655,-1035631552,'Sagittarius'],
  [-1035631552,-1035436631,'Capricorn'],
  [-1035436631,-1035253976,'Aquarius'],
  [-1035253976,-1035077499,'Pisces'],
  [-1035077499,-1034900523,'Aries'],
  [-1034900523,-1034718179,'Taurus'],
  [-1034718179,-1034528493,'Gemini'],
  [-1034528493,-1034331609,'Cancer'],
  [-1034331609,-1034127851,'Leo'],
  [-1034127851,-1033916899,'Virgo'],
  [-1033916899,-1033699454,'Libra'],
  [-1033699454,-1033480108,'Scorpio'],
  [-1033480108,-1033267248,'Sagittarius'],
  [-1033267248,-1033068004,'Capricorn'],
  [-1033068004,-1032883388,'Aquarius'],
  [-1032883388,-1032708645,'Pisces'],
  [-1032708645,-1032536572,'Aries'],
  [-1032536572,-1032360265,'Taurus'],
  [-1032360265,-1032174972,'Gemini'],
  [-1032174972,-1031979101,'Cancer'],
  [-1031979101,-1031773715,'Leo'],
  [-1031773715,-1031560943,'Virgo'],
  [-1031560943,-1031343057,'Libra'],
  [-1031343057,-1031123570,'Scorpio'],
  [-1031123570,-1030908421,'Sagittarius'],
  [-1030908421,-1030704256,'Capricorn'],
  [-1030704256,-1030514403,'Aquarius'],
  [-1030514403,-1030336828,'Pisces'],
  [-1030336828,-1030165685,'Aries'],
  [-1030165685,-1029993820,'Taurus'],
  [-1029993820,-1029814653,'Gemini'],
  [-1029814653,-1029623773,'Cancer'],
  [-1029623773,-1029420279,'Leo'],
  [-1029420279,-1029206918,'Virgo'],
  [-1029206918,-1028988338,'Libra'],
  [-1028988338,-1028769222,'Scorpio'],
  [-1028769222,-1028554068,'Sagittarius'],
  [-1028554068,-1028347276,'Capricorn'],
  [-1028347276,-1028152118,'Aquarius'],
  [-1028152118,-1027968852,'Pisces'],
  [-1027968852,-1027794223,'Aries'],
  [-1027794223,-1027622544,'Taurus'],
  [-1027622544,-1027447161,'Gemini'],
  [-1027447161,-1027261934,'Cancer'],
  [-1027261934,-1027063154,'Leo'],
  [-1027063154,-1026851669,'Virgo'],
  [-1026851669,-1026633034,'Libra'],
  [-1026633034,-1026414257,'Scorpio'],
  [-1026414257,-1026200494,'Sagittarius'],
  [-1026200494,-1025994347,'Capricorn'],
  [-1025994347,-1025796988,'Aquarius'],
  [-1025796988,-1025608717,'Pisces'],
  [-1025608717,-1025428385,'Aries'],
  [-1025428385,-1025252852,'Taurus'],
  [-1025252852,-1025077042,'Gemini'],
  [-1025077042,-1024894819,'Cancer'],
  [-1024894819,-1024700742,'Leo'],
  [-1024700742,-1024492884,'Virgo'],
  [-1024492884,-1024275333,'Libra'],
  [-1024275333,-1024056586,'Scorpio'],
  [-1024056586,-1023844008,'Sagittarius'],
  [-1023844008,-1023640323,'Capricorn'],
  [-1023640323,-1023444655,'Aquarius'],
  [-1023444655,-1023255240,'Pisces'],
  [-1023255240,-1023070766,'Aries'],
  [-1023070766,-1022889931,'Taurus'],
  [-1022889931,-1022710172,'Gemini'],
  [-1022710172,-1022527035,'Cancer'],
  [-1022527035,-1022335107,'Leo'],
  [-1022335107,-1022130597,'Virgo'],
  [-1022130597,-1021914919,'Libra'],
  [-1021914919,-1021695916,'Scorpio'],
  [-1021695916,-1021483086,'Sagittarius'],
  [-1021483086,-1021281153,'Capricorn'],
  [-1021281153,-1021088934,'Aquarius'],
  [-1021088934,-1020902523,'Pisces'],
  [-1020902523,-1020718423,'Aries'],
  [-1020718423,-1020534759,'Taurus'],
  [-1020534759,-1020350465,'Gemini'],
  [-1020350465,-1020163545,'Cancer'],
  [-1020163545,-1019970387,'Leo'],
  [-1019970387,-1019767165,'Virgo'],
  [-1019767165,-1019553163,'Libra'],
  [-1019553163,-1019333854,'Scorpio'],
  [-1019333854,-1019119111,'Sagittarius'],
  [-1019119111,-1018916310,'Capricorn'],
  [-1018916310,-1018726025,'Aquarius'],
  [-1018726025,-1018543858,'Pisces'],
  [-1018543858,-1018364179,'Aries'],
  [-1018364179,-1018182668,'Taurus'],
  [-1018182668,-1017997169,'Gemini'],
  [-1017997169,-1017806778,'Cancer'],
  [-1017806778,-1017610290,'Leo'],
  [-1017610290,-1017405799,'Virgo'],
  [-1017405799,-1017192329,'Libra'],
  [-1017192329,-1016972921,'Scorpio'],
  [-1016972921,-1016755609,'Sagittarius'],
  [-1016755609,-1016549141,'Capricorn'],
  [-1016549141,-1016357049,'Aquarius'],
  [-1016357049,-1016176555,'Pisces'],
  [-1016176555,-1016001592,'Aries'],
  [-1016001592,-1015825774,'Taurus'],
  [-1015825774,-1015644212,'Gemini'],
  [-1015644212,-1015454344,'Cancer'],
  [-1015454344,-1015255625,'Leo'],
  [-1015255625,-1015048573,'Virgo'],
  [-1015048573,-1014834180,'Libra'],
  [-1014834180,-1014614837,'Scorpio'],
  [-1014614837,-1014395931,'Sagittarius'],
  [-1014395931,-1014184984,'Capricorn'],
  [-1014184984,-1013987619,'Aquarius'],
  [-1013987619,-1013804149,'Pisces'],
  [-1013804149,-1013630174,'Aries'],
  [-1013630174,-1013459069,'Taurus'],
  [-1013459069,-1013284008,'Gemini'],
  [-1013284008,-1013099491,'Cancer'],
  [-1013099491,-1012902783,'Leo'],
  [-1012902783,-1012694708,'Virgo'],
  [-1012694708,-1012478785,'Libra'],
  [-1012478785,-1012259277,'Scorpio'],
  [-1012259277,-1012040485,'Sagittarius'],
  [-1012040485,-1011827191,'Capricorn'],
  [-1011827191,-1011624251,'Aquarius'],
  [-1011624251,-1011434339,'Pisces'],
  [-1011434339,-1011256216,'Aries'],
  [-1011256216,-1011085098,'Taurus'],
  [-1011085098,-1010914174,'Gemini'],
  [-1010914174,-1010736226,'Cancer'],
  [-1010736226,-1010545502,'Leo'],
  [-1010545502,-1010340243,'Virgo'],
  [-1010340243,-1010124169,'Libra'],
  [-1010124169,-1009904212,'Scorpio'],
  [-1009904212,-1009686314,'Sagittarius'],
  [-1009686314,-1009473814,'Capricorn'],
  [-1009473814,-1009268832,'Aquarius'],
  [-1009268832,-1009073373,'Pisces'],
  [-1009073373,-1008888384,'Aries'],
  [-1008888384,-1008712231,'Taurus'],
  [-1008712231,-1008540158,'Gemini'],
  [-1008540158,-1008365280,'Cancer'],
  [-1008365280,-1008180392,'Leo'],
  [-1008180392,-1007980699,'Virgo'],
  [-1007980699,-1007767226,'Libra'],
  [-1007767226,-1007547363,'Scorpio'],
  [-1007547363,-1007329839,'Sagittarius'],
  [-1007329839,-1007119336,'Capricorn'],
  [-1007119336,-1006916331,'Aquarius'],
  [-1006916331,-1006720141,'Pisces'],
  [-1006720141,-1006530751,'Aries'],
  [-1006530751,-1006348214,'Taurus'],
  [-1006348214,-1006170744,'Gemini'],
  [-1006170744,-1005993721,'Cancer'],
  [-1005993721,-1005810643,'Leo'],
  [-1005810643,-1005615449,'Virgo'],
  [-1005615449,-1005406100,'Libra'],
  [-1005406100,-1005187590,'Scorpio'],
  [-1005187590,-1004969692,'Sagittarius'],
  [-1004969692,-1004759919,'Capricorn'],
  [-1004759919,-1004559778,'Aquarius'],
  [-1004559778,-1004366921,'Pisces'],
  [-1004366921,-1004178670,'Aries'],
  [-1004178670,-1003993646,'Taurus'],
  [-1003993646,-1003811066,'Gemini'],
  [-1003811066,-1003628921,'Cancer'],
  [-1003628921,-1003443146,'Leo'],
  [-1003443146,-1003248675,'Virgo'],
  [-1003248675,-1003042196,'Libra'],
  [-1003042196,-1002825681,'Scorpio'],
  [-1002825681,-1002607230,'Sagittarius'],
  [-1002607230,-1002396116,'Capricorn'],
  [-1002396116,-1002196587,'Aquarius'],
  [-1002196587,-1002007070,'Pisces'],
  [-1002007070,-1001823317,'Aries'],
  [-1001823317,-1001641298,'Taurus'],
  [-1001641298,-1001458366,'Gemini'],
  [-1001458366,-1001272813,'Cancer'],
  [-1001272813,-1001082753,'Leo'],
  [-1001082753,-1000885636,'Virgo'],
  [-1000885636,-1000679207,'Libra'],
  [-1000679207,-1000463957,'Scorpio'],
  [-1000463957,-1000245199,'Sagittarius'],
  [-1000245199,-1000031523,'Capricorn'],
  [-1000031523,-999829533,'Aquarius'],
  [-999829533,-999640196,'Pisces'],
  [-999640196,-999459873,'Aries'],
  [-999459873,-999283096,'Taurus'],
  [-999283096,-999104634,'Gemini'],
  [-999104634,-998920602,'Cancer'],
  [-998920602,-998728825,'Leo'],
  [-998728825,-998528586,'Virgo'],
  [-998528586,-998320107,'Libra'],
  [-998320107,-998104687,'Scorpio'],
  [-998104687,-997885869,'Sagittarius'],
  [-997885869,-997669903,'Capricorn'],
  [-997669903,-997463698,'Aquarius'],
  [-997463698,-997270897,'Pisces'],
  [-997270897,-997090188,'Aries'],
  [-997090188,-996916613,'Taurus'],
  [-996916613,-996743653,'Gemini'],
  [-996743653,-996564989,'Cancer'],
  [-996564989,-996376057,'Leo'],
  [-996376057,-996175452,'Virgo'],
  [-996175452,-995965080,'Libra'],
  [-995965080,-995748542,'Scorpio'],
  [-995748542,-995529712,'Sagittarius'],
  [-995529712,-995312828,'Capricorn'],
  [-995312828,-995103012,'Aquarius'],
  [-995103012,-994904911,'Pisces'],
  [-994904911,-994719976,'Aries'],
  [-994719976,-994545407,'Taurus'],
  [-994545407,-994375161,'Gemini'],
  [-994375161,-994201834,'Cancer'],
  [-994201834,-994018576,'Leo'],
  [-994018576,-993821448,'Virgo'],
  [-993821448,-993611546,'Libra'],
  [-993611546,-993394195,'Scorpio'],
  [-993394195,-993175290,'Sagittarius'],
  [-993175290,-992958881,'Capricorn'],
  [-992958881,-992747922,'Aquarius'],
  [-992747922,-992545712,'Pisces'],
  [-992545712,-992354987,'Aries'],
  [-992354987,-992175669,'Taurus'],
  [-992175669,-992003781,'Gemini'],
  [-992003781,-991832492,'Cancer'],
  [-991832492,-991654084,'Leo'],
  [-991654084,-991462359,'Virgo'],
  [-991462359,-991255802,'Libra'],
  [-991255802,-991039140,'Scorpio'],
  [-991039140,-990820199,'Sagittarius'],
  [-990820199,-990604757,'Capricorn'],
  [-990604757,-990395103,'Aquarius'],
  [-990395103,-990192259,'Pisces'],
  [-990192259,-989997740,'Aries'],
  [-989997740,-989812694,'Taurus'],
  [-989812694,-989635744,'Gemini'],
  [-989635744,-989462163,'Cancer'],
  [-989462163,-989285041,'Leo'],
  [-989285041,-989097430,'Virgo'],
  [-989097430,-988895406,'Libra'],
  [-988895406,-988681154,'Scorpio'],
  [-988681154,-988462472,'Sagittarius'],
  [-988462472,-988247420,'Capricorn'],
  [-988247420,-988039723,'Aquarius'],
  [-988039723,-987839342,'Pisces'],
  [-987839342,-987645376,'Aries'],
  [-987645376,-987457573,'Taurus'],
  [-987457573,-987275478,'Gemini'],
  [-987275478,-987096779,'Cancer'],
  [-987096779,-986916843,'Leo'],
  [-986916843,-986729813,'Virgo'],
  [-986729813,-986530934,'Libra'],
  [-986530934,-986319721,'Scorpio'],
  [-986319721,-986101767,'Sagittarius'],
  [-986101767,-985885983,'Capricorn'],
  [-985885983,-985678732,'Aquarius'],
  [-985678732,-985481140,'Pisces'],
  [-985481140,-985290983,'Aries'],
  [-985290983,-985105409,'Taurus'],
  [-985105409,-984922200,'Gemini'],
  [-984922200,-984739456,'Cancer'],
  [-984739456,-984554727,'Leo'],
  [-984554727,-984364676,'Virgo'],
  [-984364676,-984165829,'Libra'],
  [-984165829,-983956582,'Scorpio'],
  [-983956582,-983739650,'Sagittarius'],
  [-983739650,-983522403,'Capricorn'],
  [-983522403,-983313039,'Aquarius'],
  [-983313039,-983115549,'Pisces'],
  [-983115549,-982928678,'Aries'],
  [-982928678,-982748151,'Taurus'],
  [-982748151,-982569035,'Gemini'],
  [-982569035,-982387218,'Cancer'],
  [-982387218,-982200005,'Leo'],
  [-982200005,-982005970,'Virgo'],
  [-982005970,-981804357,'Libra'],
  [-981804357,-981594846,'Scorpio'],
  [-981594846,-981378649,'Sagittarius'],
  [-981378649,-981160250,'Capricorn'],
  [-981160250,-980947172,'Aquarius'],
  [-980947172,-980746035,'Pisces'],
  [-980746035,-980558529,'Aries'],
  [-980558529,-980381244,'Taurus'],
  [-980381244,-980207925,'Gemini'],
  [-980207925,-980031825,'Cancer'],
  [-980031825,-979847605,'Leo'],
  [-979847605,-979652879,'Virgo'],
  [-979652879,-979448508,'Libra'],
  [-979448508,-979236954,'Scorpio'],
  [-979236954,-979020550,'Sagittarius'],
  [-979020550,-978801949,'Capricorn'],
  [-978801949,-978585980,'Aquarius'],
  [-978585980,-978379363,'Pisces'],
  [-978379363,-978186823,'Aries'],
  [-978186823,-978007862,'Taurus'],
  [-978007862,-977837100,'Gemini'],
  [-977837100,-977666796,'Cancer'],
  [-977666796,-977489244,'Leo'],
  [-977489244,-977299082,'Virgo'],
  [-977299082,-977095601,'Libra'],
  [-977095601,-976882615,'Scorpio'],
  [-976882615,-976665187,'Sagittarius'],
  [-976665187,-976446865,'Capricorn'],
  [-976446865,-976230433,'Aquarius'],
  [-976230433,-976020189,'Pisces'],
  [-976020189,-975821318,'Aries'],
  [-975821318,-975636358,'Taurus'],
  [-975636358,-975462751,'Gemini'],
  [-975462751,-975293829,'Cancer'],
  [-975293829,-975121372,'Leo'],
  [-975121372,-974937936,'Virgo'],
  [-974937936,-974739626,'Libra'],
  [-974739626,-974528360,'Scorpio'],
  [-974528360,-974310482,'Sagittarius'],
  [-974310482,-974092201,'Capricorn'],
  [-974092201,-973876922,'Aquarius'],
  [-973876922,-973666795,'Pisces'],
  [-973666795,-973464741,'Aries'],
  [-973464741,-973273650,'Taurus'],
  [-973273650,-973093683,'Gemini'],
  [-973093683,-972920921,'Cancer'],
  [-972920921,-972748579,'Leo'],
  [-972748579,-972569144,'Virgo'],
  [-972569144,-972376761,'Libra'],
  [-972376761,-972170091,'Scorpio'],
  [-972170091,-971953701,'Sagittarius'],
  [-971953701,-971735353,'Capricorn'],
  [-971735353,-971521008,'Aquarius'],
  [-971521008,-971313118,'Pisces'],
  [-971313118,-971112393,'Aries'],
  [-971112393,-970919447,'Taurus'],
  [-970919447,-970734427,'Gemini'],
  [-970734427,-970555625,'Cancer'],
  [-970555625,-970378941,'Leo'],
  [-970378941,-970198664,'Virgo'],
  [-970198664,-970009100,'Libra'],
  [-970009100,-969806893,'Scorpio'],
  [-969806893,-969593478,'Sagittarius'],
  [-969593478,-969375475,'Capricorn'],
  [-969375475,-969160902,'Aquarius'],
  [-969160902,-968954554,'Pisces'],
  [-968954554,-968757101,'Aries'],
  [-968757101,-968566898,'Taurus'],
  [-968566898,-968381760,'Gemini'],
  [-968381760,-968199509,'Cancer'],
  [-968199509,-968017692,'Leo'],
  [-968017692,-967833190,'Virgo'],
  [-967833190,-967642316,'Libra'],
  [-967642316,-967441835,'Scorpio'],
  [-967441835,-967231020,'Sagittarius'],
  [-967231020,-967013764,'Capricorn'],
  [-967013764,-966797953,'Aquarius'],
  [-966797953,-966590896,'Pisces'],
  [-966590896,-966395278,'Aries'],
  [-966395278,-966209104,'Taurus'],
  [-966209104,-966027976,'Gemini'],
  [-966027976,-965847353,'Cancer'],
  [-965847353,-965663846,'Leo'],
  [-965663846,-965475469,'Virgo'],
  [-965475469,-965281002,'Libra'],
  [-965281002,-965079189,'Scorpio'],
  [-965079189,-964869179,'Sagittarius'],
  [-964869179,-964652573,'Capricorn'],
  [-964652573,-964435216,'Aquarius'],
  [-964435216,-964225350,'Pisces'],
  [-964225350,-964028407,'Aries'],
  [-964028407,-963844026,'Taurus'],
  [-963844026,-963667294,'Gemini'],
  [-963667294,-963491642,'Cancer'],
  [-963491642,-963311277,'Leo'],
  [-963311277,-963122837,'Virgo'],
  [-963122837,-962925846,'Libra'],
  [-962925846,-962721372,'Scorpio'],
  [-962721372,-962510343,'Sagittarius'],
  [-962510343,-962293859,'Capricorn'],
  [-962293859,-962075439,'Aquarius'],
  [-962075439,-961862105,'Pisces'],
  [-961862105,-961661041,'Aries'],
  [-961661041,-961474640,'Taurus'],
  [-961474640,-961299330,'Gemini'],
  [-961299330,-961128075,'Cancer'],
  [-961128075,-960953287,'Leo'],
  [-960953287,-960769115,'Virgo'],
  [-960769115,-960573349,'Libra'],
  [-960573349,-960367568,'Scorpio'],
  [-960367568,-960154916,'Sagittarius'],
  [-960154916,-959937983,'Capricorn'],
  [-959937983,-959719358,'Aquarius'],
  [-959719358,-959503798,'Pisces'],
  [-959503798,-959297965,'Aries'],
  [-959297965,-959106449,'Taurus'],
  [-959106449,-958928342,'Gemini'],
  [-958928342,-958757869,'Cancer'],
  [-958757869,-958587194,'Leo'],
  [-958587194,-958408839,'Virgo'],
  [-958408839,-958217948,'Libra'],
  [-958217948,-958014147,'Scorpio'],
  [-958014147,-957801062,'Sagittarius'],
  [-957801062,-957583519,'Capricorn'],
  [-957583519,-957365269,'Aquarius'],
  [-957365269,-957149706,'Pisces'],
  [-957149706,-956941275,'Aries'],
  [-956941275,-956744408,'Taurus'],
  [-956744408,-956560508,'Gemini'],
  [-956560508,-956386416,'Cancer'],
  [-956386416,-956215733,'Leo'],
  [-956215733,-956041003,'Virgo'],
  [-956041003,-955855753,'Libra'],
  [-955855753,-955656764,'Scorpio'],
  [-955656764,-955445672,'Sagittarius'],
  [-955445672,-955228091,'Capricorn'],
  [-955228091,-955010161,'Aquarius'],
  [-955010161,-954796064,'Pisces'],
  [-954796064,-954588469,'Aries'],
  [-954588469,-954389511,'Taurus'],
  [-954389511,-954200442,'Gemini'],
  [-954200442,-954020267,'Cancer'],
  [-954020267,-953845254,'Leo'],
  [-953845254,-953669724,'Virgo'],
  [-953669724,-953487426,'Libra'],
  [-953487426,-953293381,'Scorpio'],
  [-953293381,-953086209,'Sagittarius'],
  [-953086209,-952869788,'Capricorn'],
  [-952869788,-952651711,'Aquarius'],
  [-952651711,-952438699,'Pisces'],
  [-952438699,-952233818,'Aries'],
  [-952233818,-952037074,'Taurus'],
  [-952037074,-951847261,'Gemini'],
  [-951847261,-951662905,'Cancer'],
  [-951662905,-951482076,'Leo'],
  [-951482076,-951301850,'Virgo'],
  [-951301850,-951118095,'Libra'],
  [-951118095,-950926141,'Scorpio'],
  [-950926141,-950722639,'Sagittarius'],
  [-950722639,-950508395,'Capricorn'],
  [-950508395,-950289915,'Aquarius'],
  [-950289915,-950076171,'Pisces'],
  [-950076171,-949872794,'Aries'],
  [-949872794,-949679858,'Taurus'],
  [-949679858,-949493890,'Gemini'],
  [-949493890,-949310776,'Cancer'],
  [-949310776,-949127514,'Leo'],
  [-949127514,-948942437,'Virgo'],
  [-948942437,-948754155,'Libra'],
  [-948754155,-948560345,'Scorpio'],
  [-948560345,-948357987,'Sagittarius'],
  [-948357987,-948145713,'Capricorn'],
  [-948145713,-947927110,'Aquarius'],
  [-947927110,-947710994,'Pisces'],
  [-947710994,-947505896,'Aries'],
  [-947505896,-947314338,'Taurus'],
  [-947314338,-947132766,'Gemini'],
  [-947132766,-946954956,'Cancer'],
  [-946954956,-946775133,'Leo'],
  [-946775133,-946589851,'Virgo'],
  [-946589851,-946398296,'Libra'],
  [-946398296,-946200690,'Scorpio'],
  [-946200690,-945996471,'Sagittarius'],
  [-945996471,-945784570,'Capricorn'],
  [-945784570,-945566217,'Aquarius'],
  [-945566217,-945347707,'Pisces'],
  [-945347707,-945138323,'Aries'],
  [-945138323,-944943819,'Taurus'],
  [-944943819,-944762910,'Gemini'],
  [-944762910,-944589393,'Cancer'],
  [-944589393,-944415756,'Leo'],
  [-944415756,-944235751,'Virgo'],
  [-944235751,-944046158,'Libra'],
  [-944046158,-943847075,'Scorpio'],
  [-943847075,-943640186,'Sagittarius'],
  [-943640186,-943426902,'Capricorn'],
  [-943426902,-943208608,'Aquarius'],
  [-943208608,-942989129,'Pisces'],
  [-942989129,-942775733,'Aries'],
  [-942775733,-942575529,'Taurus'],
  [-942575529,-942390467,'Gemini'],
  [-942390467,-942216517,'Cancer'],
  [-942216517,-942046485,'Leo'],
  [-942046485,-941872804,'Virgo'],
  [-941872804,-941689504,'Libra'],
  [-941689504,-941493870,'Scorpio'],
  [-941493870,-941286952,'Sagittarius'],
  [-941286952,-941072213,'Capricorn'],
  [-941072213,-940853427,'Aquarius'],
  [-940853427,-940634285,'Pisces'],
  [-940634285,-940419548,'Aries'],
  [-940419548,-940214727,'Taurus'],
  [-940214727,-940023303,'Gemini'],
  [-940023303,-939844292,'Cancer'],
  [-939844292,-939672718,'Leo'],
  [-939672718,-939501674,'Virgo'],
  [-939501674,-939324177,'Libra'],
  [-939324177,-939134847,'Scorpio'],
  [-939134847,-938931782,'Sagittarius'],
  [-938931782,-938717695,'Capricorn'],
  [-938717695,-938498466,'Aquarius'],
  [-938498466,-938279921,'Pisces'],
  [-938279921,-938066303,'Aries'],
  [-938066303,-937860606,'Taurus'],
  [-937860606,-937664944,'Gemini'],
  [-937664944,-937479694,'Cancer'],
  [-937479694,-937302661,'Leo'],
  [-937302661,-937129263,'Virgo'],
  [-937129263,-936953431,'Libra'],
  [-936953431,-936768924,'Scorpio'],
  [-936768924,-936571250,'Sagittarius'],
  [-936571250,-936360290,'Capricorn'],
  [-936360290,-936141574,'Aquarius'],
  [-936141574,-935923241,'Pisces'],
  [-935923241,-935711273,'Aries'],
  [-935711273,-935507728,'Taurus'],
  [-935507728,-935312243,'Gemini'],
  [-935312243,-935123854,'Cancer'],
  [-935123854,-934941350,'Leo'],
  [-934941350,-934762648,'Virgo'],
  [-934762648,-934584051,'Libra'],
  [-934584051,-934400365,'Scorpio'],
  [-934400365,-934206278,'Sagittarius'],
  [-934206278,-933999100,'Capricorn'],
  [-933999100,-933781942,'Aquarius'],
  [-933781942,-933563393,'Pisces'],
  [-933563393,-933351922,'Aries'],
  [-933351922,-933150851,'Taurus'],
  [-933150851,-932958573,'Gemini'],
  [-932958573,-932771725,'Cancer'],
  [-932771725,-932587592,'Leo'],
  [-932587592,-932404614,'Virgo'],
  [-932404614,-932221294,'Libra'],
  [-932221294,-932034791,'Scorpio'],
  [-932034791,-931840883,'Sagittarius'],
  [-931840883,-931635964,'Capricorn'],
  [-931635964,-931420562,'Aquarius'],
  [-931420562,-931201583,'Pisces'],
  [-931201583,-930988865,'Aries'],
  [-930988865,-930788240,'Taurus'],
  [-930788240,-930598928,'Gemini'],
  [-930598928,-930416231,'Cancer'],
  [-930416231,-930235086,'Leo'],
  [-930235086,-930052138,'Virgo'],
  [-930052138,-929865949,'Libra'],
  [-929865949,-929675570,'Scorpio'],
  [-929675570,-929479099,'Sagittarius'],
  [-929479099,-929273979,'Capricorn'],
  [-929273979,-929059536,'Aquarius'],
  [-929059536,-928840178,'Pisces'],
  [-928840178,-928625005,'Aries'],
  [-928625005,-928421996,'Taurus'],
  [-928421996,-928232768,'Gemini'],
  [-928232768,-928053197,'Cancer'],
  [-928053197,-927876955,'Leo'],
  [-927876955,-927698337,'Virgo'],
  [-927698337,-927513777,'Libra'],
  [-927513777,-927321947,'Scorpio'],
  [-927321947,-927122589,'Sagittarius'],
  [-927122589,-926915463,'Capricorn'],
  [-926915463,-926700739,'Aquarius'],
  [-926700739,-926481222,'Pisces'],
  [-926481222,-926263750,'Aries'],
  [-926263750,-926056501,'Taurus'],
  [-926056501,-925863737,'Gemini'],
  [-925863737,-925683620,'Cancer'],
  [-925683620,-925510368,'Leo'],
  [-925510368,-925337141,'Virgo'],
  [-925337141,-925157976,'Libra'],
  [-925157976,-924969104,'Scorpio'],
  [-924969104,-924769519,'Sagittarius'],
  [-924769519,-924560532,'Capricorn'],
  [-924560532,-924344648,'Aquarius'],
  [-924344648,-924125122,'Pisces'],
  [-924125122,-923906791,'Aries'],
  [-923906791,-923695876,'Taurus'],
  [-923695876,-923497531,'Gemini'],
  [-923497531,-923312786,'Cancer'],
  [-923312786,-923138166,'Leo'],
  [-923138166,-922967507,'Virgo'],
  [-922967507,-922793847,'Libra'],
  [-922793847,-922610975,'Scorpio'],
  [-922610975,-922415168,'Sagittarius'],
  [-922415168,-922206761,'Capricorn'],
  [-922206761,-921989968,'Aquarius'],
  [-921989968,-921770346,'Pisces'],
  [-921770346,-921552700,'Aries'],
  [-921552700,-921340906,'Taurus'],
  [-921340906,-921138397,'Gemini'],
  [-921138397,-920947354,'Cancer'],
  [-920947354,-920767219,'Leo'],
  [-920767219,-920594280,'Virgo'],
  [-920594280,-920422463,'Libra'],
  [-920422463,-920244715,'Scorpio'],
  [-920244715,-920054849,'Sagittarius'],
  [-920054849,-919850262,'Capricorn'],
  [-919850262,-919634244,'Aquarius'],
  [-919634244,-919414426,'Pisces'],
  [-919414426,-919197810,'Aries'],
  [-919197810,-918987793,'Taurus'],
  [-918987793,-918785233,'Gemini'],
  [-918785233,-918590591,'Cancer'],
  [-918590591,-918404259,'Leo'],
  [-918404259,-918225335,'Virgo'],
  [-918225335,-918050372,'Libra'],
  [-918050372,-917873488,'Scorpio'],
  [-917873488,-917687853,'Sagittarius'],
  [-917687853,-917488345,'Capricorn'],
  [-917488345,-917275223,'Aquarius'],
  [-917275223,-917055632,'Pisces'],
  [-917055632,-916839094,'Aries'],
  [-916839094,-916631048,'Taurus'],
  [-916631048,-916431565,'Gemini'],
  [-916431565,-916238453,'Cancer'],
  [-916238453,-916050108,'Leo'],
  [-916050108,-915866014,'Virgo'],
  [-915866014,-915685214,'Libra'],
  [-915685214,-915504577,'Scorpio'],
  [-915504577,-915318791,'Sagittarius'],
  [-915318791,-915122267,'Capricorn'],
  [-915122267,-914912606,'Aquarius'],
  [-914912606,-914694098,'Pisces'],
  [-914694098,-914476545,'Aries'],
  [-914476545,-914268298,'Taurus'],
  [-914268298,-914071274,'Gemini'],
  [-914071274,-913882422,'Cancer'],
  [-913882422,-913697526,'Leo'],
  [-913697526,-913513665,'Virgo'],
  [-913513665,-913329516,'Libra'],
  [-913329516,-913143889,'Scorpio'],
  [-913143889,-912954253,'Sagittarius'],
  [-912954253,-912756859,'Capricorn'],
  [-912756859,-912548863,'Aquarius'],
  [-912548863,-912331756,'Pisces'],
  [-912331756,-912113000,'Aries'],
  [-912113000,-911902114,'Taurus'],
  [-911902114,-911704130,'Gemini'],
  [-911704130,-911517673,'Cancer'],
  [-911517673,-911337779,'Leo'],
  [-911337779,-911159052,'Virgo'],
  [-911159052,-910977440,'Libra'],
  [-910977440,-910790637,'Scorpio'],
  [-910790637,-910597400,'Sagittarius'],
  [-910597400,-910396689,'Capricorn'],
  [-910396689,-910187643,'Aquarius'],
  [-910187643,-909971127,'Pisces'],
  [-909971127,-909751784,'Aries'],
  [-909751784,-909537552,'Taurus'],
  [-909537552,-909335372,'Gemini'],
  [-909335372,-909146974,'Cancer'],
  [-909146974,-908968965,'Leo'],
  [-908968965,-908795384,'Virgo'],
  [-908795384,-908619927,'Libra'],
  [-908619927,-908437436,'Scorpio'],
  [-908437436,-908244956,'Sagittarius'],
  [-908244956,-908042186,'Capricorn'],
  [-908042186,-907830856,'Aquarius'],
  [-907830856,-907613670,'Pisces'],
  [-907613670,-907394319,'Aries'],
  [-907394319,-907178070,'Taurus'],
  [-907178070,-906971072,'Gemini'],
  [-906971072,-906777348,'Cancer'],
  [-906777348,-906596485,'Leo'],
  [-906596485,-906424034,'Virgo'],
  [-906424034,-906253309,'Libra'],
  [-906253309,-906077208,'Scorpio'],
  [-906077208,-905889954,'Sagittarius'],
  [-905889954,-905689165,'Capricorn'],
  [-905689165,-905477058,'Aquarius'],
  [-905477058,-905258804,'Pisces'],
  [-905258804,-905039543,'Aries'],
  [-905039543,-904823240,'Taurus'],
  [-904823240,-904613639,'Gemini'],
  [-904613639,-904414513,'Cancer'],
  [-904414513,-904227777,'Leo'],
  [-904227777,-904051792,'Virgo'],
  [-904051792,-903881354,'Libra'],
  [-903881354,-903709205,'Scorpio'],
  [-903709205,-903527921,'Sagittarius'],
  [-903527921,-903332347,'Capricorn'],
  [-903332347,-903122538,'Aquarius'],
  [-903122538,-902904263,'Pisces'],
  [-902904263,-902685023,'Aries'],
  [-902685023,-902469753,'Taurus'],
  [-902469753,-902260592,'Gemini'],
  [-902260592,-902059145,'Cancer'],
  [-902059145,-901867231,'Leo'],
  [-901867231,-901685360,'Virgo'],
  [-901685360,-901510959,'Libra'],
  [-901510959,-901338299,'Scorpio'],
  [-901338299,-901160052,'Sagittarius'],
  [-901160052,-900969569,'Capricorn'],
  [-900969569,-900764119,'Aquarius'],
  [-900764119,-900547575,'Pisces'],
  [-900547575,-900328484,'Aries'],
  [-900328484,-900114063,'Taurus'],
  [-900114063,-899906937,'Gemini'],
  [-899906937,-899706885,'Cancer'],
  [-899706885,-899513623,'Leo'],
  [-899513623,-899327410,'Virgo'],
  [-899327410,-899147523,'Libra'],
  [-899147523,-898970711,'Scorpio'],
  [-898970711,-898791330,'Sagittarius'],
  [-898791330,-898603004,'Capricorn'],
  [-898603004,-898401417,'Aquarius'],
  [-898401417,-898187662,'Pisces'],
  [-898187662,-897969037,'Aries'],
  [-897969037,-897754467,'Taurus'],
  [-897754467,-897548741,'Gemini'],
  [-897548741,-897351704,'Cancer'],
  [-897351704,-897161092,'Leo'],
  [-897161092,-896974950,'Virgo'],
  [-896974950,-896791985,'Libra'],
  [-896791985,-896610411,'Scorpio'],
  [-896610411,-896426967,'Sagittarius'],
  [-896426967,-896237165,'Capricorn'],
  [-896237165,-896036952,'Aquarius'],
  [-896036952,-895825535,'Pisces'],
  [-895825535,-895607612,'Aries'],
  [-895607612,-895391831,'Taurus'],
  [-895391831,-895185344,'Gemini'],
  [-895185344,-894989978,'Cancer'],
  [-894989978,-894803239,'Leo'],
  [-894803239,-894621091,'Virgo'],
  [-894621091,-894439847,'Libra'],
  [-894439847,-894256725,'Scorpio'],
  [-894256725,-894069513,'Sagittarius'],
  [-894069513,-893876076,'Capricorn'],
  [-893876076,-893674392,'Aquarius'],
  [-893674392,-893463675,'Pisces'],
  [-893463675,-893246377,'Aries'],
  [-893246377,-893028997,'Taurus'],
  [-893028997,-892819503,'Gemini'],
  [-892819503,-892622544,'Cancer'],
  [-892622544,-892437430,'Leo'],
  [-892437430,-892259749,'Virgo'],
  [-892259749,-892083718,'Libra'],
  [-892083718,-891903988,'Scorpio'],
  [-891903988,-891716855,'Sagittarius'],
  [-891716855,-891520841,'Capricorn'],
  [-891520841,-891316308,'Aquarius'],
  [-891316308,-891104480,'Pisces'],
  [-891104480,-890887379,'Aries'],
  [-890887379,-890669007,'Taurus'],
  [-890669007,-890455819,'Gemini'],
  [-890455819,-890254189,'Cancer'],
  [-890254189,-890066491,'Leo'],
  [-890066491,-889890006,'Virgo'],
  [-889890006,-889718584,'Libra'],
  [-889718584,-889544930,'Scorpio'],
  [-889544930,-889362625,'Sagittarius'],
  [-889362625,-889168183,'Capricorn'],
  [-889168183,-888962318,'Aquarius'],
  [-888962318,-888748682,'Pisces'],
  [-888748682,-888531144,'Aries'],
  [-888531144,-888312828,'Taurus'],
  [-888312828,-888097579,'Gemini'],
  [-888097579,-887890837,'Cancer'],
  [-887890837,-887697180,'Leo'],
  [-887697180,-887517034,'Virgo'],
  [-887517034,-887345938,'Libra'],
  [-887345938,-887176452,'Scorpio'],
  [-887176452,-887000508,'Sagittarius'],
  [-887000508,-886811772,'Capricorn'],
  [-886811772,-886608502,'Aquarius'],
  [-886608502,-886394544,'Pisces'],
  [-886394544,-886176268,'Aries'],
  [-886176268,-885958455,'Taurus'],
  [-885958455,-885743711,'Gemini'],
  [-885743711,-885534835,'Cancer'],
  [-885534835,-885335681,'Leo'],
  [-885335681,-885148892,'Virgo'],
  [-885148892,-884973110,'Libra'],
  [-884973110,-884802753,'Scorpio'],
  [-884802753,-884630031,'Sagittarius'],
  [-884630031,-884447255,'Capricorn'],
  [-884447255,-884249688,'Aquarius'],
  [-884249688,-884038478,'Pisces'],
  [-884038478,-883820297,'Aries'],
  [-883820297,-883602597,'Taurus'],
  [-883602597,-883389449,'Gemini'],
  [-883389449,-883182169,'Cancer'],
  [-883182169,-882981916,'Leo'],
  [-882981916,-882790392,'Virgo'],
  [-882790392,-882608072,'Libra'],
  [-882608072,-882432332,'Scorpio'],
  [-882432332,-882257569,'Sagittarius'],
  [-882257569,-882076843,'Capricorn'],
  [-882076843,-881884196,'Aquarius'],
  [-881884196,-881677640,'Pisces'],
  [-881677640,-881461266,'Aries'],
  [-881461266,-881243320,'Taurus'],
  [-881243320,-881030738,'Gemini'],
  [-881030738,-880826077,'Cancer'],
  [-880826077,-880628881,'Leo'],
  [-880628881,-880438058,'Virgo'],
  [-880438058,-880252712,'Libra'],
  [-880252712,-880071395,'Scorpio'],
  [-880071395,-879891196,'Sagittarius'],
  [-879891196,-879707695,'Capricorn'],
  [-879707695,-879516016,'Aquarius'],
  [-879516016,-879312883,'Pisces'],
  [-879312883,-879099220,'Aries'],
  [-879099220,-878881262,'Taurus'],
  [-878881262,-878667501,'Gemini'],
  [-878667501,-878463420,'Cancer'],
  [-878463420,-878269545,'Leo'],
  [-878269545,-878083128,'Virgo'],
  [-878083128,-877900469,'Libra'],
  [-877900469,-877718310,'Scorpio'],
  [-877718310,-877534157,'Sagittarius'],
  [-877534157,-877345911,'Capricorn'],
  [-877345911,-877151375,'Aquarius'],
  [-877151375,-876948428,'Pisces'],
  [-876948428,-876736527,'Aries'],
  [-876736527,-876518927,'Taurus'],
  [-876518927,-876303042,'Gemini'],
  [-876303042,-876096617,'Cancer'],
  [-876096617,-875902983,'Leo'],
  [-875902983,-875720103,'Virgo'],
  [-875720103,-875542709,'Libra'],
  [-875542709,-875364900,'Scorpio'],
  [-875364900,-875182013,'Sagittarius'],
  [-875182013,-874991671,'Capricorn'],
  [-874991671,-874793602,'Aquarius'],
  [-874793602,-874588300,'Pisces'],
  [-874588300,-874376199,'Aries'],
  [-874376199,-874158882,'Taurus'],
  [-874158882,-873941194,'Gemini'],
  [-873941194,-873730819,'Cancer'],
  [-873730819,-873533776,'Leo'],
  [-873533776,-873350560,'Virgo'],
  [-873350560,-873176424,'Libra'],
  [-873176424,-873004158,'Scorpio'],
  [-873004158,-872826702,'Sagittarius'],
  [-872826702,-872639240,'Capricorn'],
  [-872639240,-872440708,'Aquarius'],
  [-872440708,-872233222,'Pisces'],
  [-872233222,-872019624,'Aries'],
  [-872019624,-871802130,'Taurus'],
  [-871802130,-871583717,'Gemini'],
  [-871583717,-871370037,'Cancer'],
  [-871370037,-871167822,'Leo'],
  [-871167822,-870980370,'Virgo'],
  [-870980370,-870805175,'Libra'],
  [-870805175,-870635543,'Scorpio'],
  [-870635543,-870463452,'Sagittarius'],
  [-870463452,-870281880,'Capricorn'],
  [-870281880,-870087129,'Aquarius'],
  [-870087129,-869880266,'Pisces'],
  [-869880266,-869665639,'Aries'],
  [-869665639,-869447645,'Taurus'],
  [-869447645,-869229460,'Gemini'],
  [-869229460,-869014712,'Cancer'],
  [-869014712,-868808543,'Leo'],
  [-868808543,-868615340,'Virgo'],
  [-868615340,-868435314,'Libra'],
  [-868435314,-868263859,'Scorpio'],
  [-868263859,-868093648,'Sagittarius'],
  [-868093648,-867916982,'Capricorn'],
  [-867916982,-867727988,'Aquarius'],
  [-867727988,-867524996,'Pisces'],
  [-867524996,-867311354,'Aries'],
  [-867311354,-867093132,'Taurus'],
  [-867093132,-866875476,'Gemini'],
  [-866875476,-866661739,'Cancer'],
  [-866661739,-866454878,'Leo'],
  [-866454878,-866257879,'Virgo'],
  [-866257879,-866072081,'Libra'],
  [-866072081,-865895429,'Scorpio'],
  [-865895429,-865722727,'Sagittarius'],
  [-865722727,-865547232,'Capricorn'],
  [-865547232,-865362489,'Aquarius'],
  [-865362489,-865164525,'Pisces'],
  [-865164525,-864953983,'Aries'],
  [-864953983,-864736389,'Taurus'],
  [-864736389,-864518965,'Gemini'],
  [-864518965,-864306777,'Cancer'],
  [-864306777,-864102027,'Leo'],
  [-864102027,-863905324,'Virgo'],
  [-863905324,-863716578,'Libra'],
  [-863716578,-863534632,'Scorpio'],
  [-863534632,-863356661,'Sagittarius'],
  [-863356661,-863178234,'Capricorn'],
  [-863178234,-862994065,'Aquarius'],
  [-862994065,-862799484,'Pisces'],
  [-862799484,-862592623,'Aries'],
  [-862592623,-862376568,'Taurus'],
  [-862376568,-862158861,'Gemini'],
  [-862158861,-861947071,'Cancer'],
  [-861947071,-861744786,'Leo'],
  [-861744786,-861551441,'Virgo'],
  [-861551441,-861364428,'Libra'],
  [-861364428,-861180950,'Scorpio'],
  [-861180950,-860998646,'Sagittarius'],
  [-860998646,-860815271,'Capricorn'],
  [-860815271,-860628041,'Aquarius'],
  [-860628041,-860433543,'Pisces'],
  [-860433543,-860228968,'Aries'],
  [-860228968,-860014704,'Taurus'],
  [-860014704,-859796435,'Gemini'],
  [-859796435,-859583094,'Cancer'],
  [-859583094,-859381047,'Leo'],
  [-859381047,-859190772,'Virgo'],
  [-859190772,-859008287,'Libra'],
  [-859008287,-858828234,'Scorpio'],
  [-858828234,-858646234,'Sagittarius'],
  [-858646234,-858459937,'Capricorn'],
  [-858459937,-858268521,'Aquarius'],
  [-858268521,-858071173,'Pisces'],
  [-858071173,-857866334,'Aries'],
  [-857866334,-857653144,'Taurus'],
  [-857653144,-857434519,'Gemini'],
  [-857434519,-857218361,'Cancer'],
  [-857218361,-857013306,'Leo'],
  [-857013306,-856822688,'Virgo'],
  [-856822688,-856643355,'Libra'],
  [-856643355,-856468670,'Scorpio'],
  [-856468670,-856291751,'Sagittarius'],
  [-856291751,-856107760,'Capricorn'],
  [-856107760,-855915129,'Aquarius'],
  [-855915129,-855714715,'Pisces'],
  [-855714715,-855507585,'Aries'],
  [-855507585,-855294062,'Taurus'],
  [-855294062,-855075489,'Gemini'],
  [-855075489,-854857081,'Cancer'],
  [-854857081,-854647253,'Leo'],
  [-854647253,-854452164,'Virgo'],
  [-854452164,-854271474,'Libra'],
  [-854271474,-854099403,'Scorpio'],
  [-854099403,-853928132,'Sagittarius'],
  [-853928132,-853750451,'Capricorn'],
  [-853750451,-853561874,'Aquarius'],
  [-853561874,-853361893,'Pisces'],
  [-853361893,-853152938,'Aries'],
  [-853152938,-852937997,'Taurus'],
  [-852937997,-852719462,'Gemini'],
  [-852719462,-852500672,'Cancer'],
  [-852500672,-852287516,'Leo'],
  [-852287516,-852086427,'Virgo'],
  [-852086427,-851900033,'Libra'],
  [-851900033,-851725342,'Scorpio'],
  [-851725342,-851555661,'Sagittarius'],
  [-851555661,-851383269,'Capricorn'],
  [-851383269,-851201457,'Aquarius'],
  [-851201457,-851006510,'Pisces'],
  [-851006510,-850799056,'Aries'],
  [-850799056,-850583321,'Taurus'],
  [-850583321,-850364427,'Gemini'],
  [-850364427,-850146521,'Cancer'],
  [-850146521,-849933382,'Leo'],
  [-849933382,-849729020,'Virgo'],
  [-849729020,-849536396,'Libra'],
  [-849536396,-849355290,'Scorpio'],
  [-849355290,-849181846,'Sagittarius'],
  [-849181846,-849009862,'Capricorn'],
  [-849009862,-848832460,'Aquarius'],
  [-848832460,-848643801,'Pisces'],
  [-848643801,-848441214,'Aries'],
  [-848441214,-848227061,'Taurus'],
  [-848227061,-848007928,'Gemini'],
  [-848007928,-847790679,'Cancer'],
  [-847790679,-847579565,'Leo'],
  [-847579565,-847376318,'Virgo'],
  [-847376318,-847181515,'Libra'],
  [-847181515,-846994968,'Scorpio'],
  [-846994968,-846815162,'Sagittarius'],
  [-846815162,-846638767,'Capricorn'],
  [-846638767,-846460752,'Aquarius'],
  [-846460752,-846275314,'Pisces'],
  [-846275314,-846077712,'Aries'],
  [-846077712,-845867103,'Taurus'],
  [-845867103,-845648651,'Gemini'],
  [-845648651,-845431170,'Cancer'],
  [-845431170,-845221454,'Leo'],
  [-845221454,-845021320,'Virgo'],
  [-845021320,-844829034,'Libra'],
  [-844829034,-844642036,'Scorpio'],
  [-844642036,-844458347,'Sagittarius'],
  [-844458347,-844276415,'Capricorn'],
  [-844276415,-844093980,'Aquarius'],
  [-844093980,-843907253,'Pisces'],
  [-843907253,-843711628,'Aries'],
  [-843711628,-843504185,'Taurus'],
  [-843504185,-843287180,'Gemini'],
  [-843287180,-843068880,'Cancer'],
  [-843068880,-842858506,'Leo'],
  [-842858506,-842660091,'Virgo'],
  [-842660091,-842471677,'Libra'],
  [-842471677,-842288530,'Scorpio'],
  [-842288530,-842106269,'Sagittarius'],
  [-842106269,-841922350,'Capricorn'],
  [-841922350,-841735707,'Aquarius'],
  [-841735707,-841545085,'Pisces'],
  [-841545085,-841347922,'Aries'],
  [-841347922,-841141397,'Taurus'],
  [-841141397,-840925603,'Gemini'],
  [-840925603,-840706440,'Cancer'],
  [-840706440,-840493611,'Leo'],
  [-840493611,-840293862,'Virgo'],
  [-840293862,-840107063,'Libra'],
  [-840107063,-839928149,'Scorpio'],
  [-839928149,-839750788,'Sagittarius'],
  [-839750788,-839569966,'Capricorn'],
  [-839569966,-839383155,'Aquarius'],
  [-839383155,-839189785,'Pisces'],
  [-839189785,-838989582,'Aries'],
  [-838989582,-838781704,'Taurus'],
  [-838781704,-838566095,'Gemini'],
  [-838566095,-838346394,'Cancer'],
  [-838346394,-838130661,'Leo'],
  [-838130661,-837927018,'Virgo'],
  [-837927018,-837738100,'Libra'],
  [-837738100,-837560388,'Scorpio'],
  [-837560388,-837387290,'Sagittarius'],
  [-837387290,-837212047,'Capricorn'],
  [-837212047,-837029582,'Aquarius'],
  [-837029582,-836837499,'Pisces'],
  [-836837499,-836635845,'Aries'],
  [-836635845,-836425941,'Taurus'],
  [-836425941,-836209531,'Gemini'],
  [-836209531,-835989675,'Cancer'],
  [-835989675,-835772133,'Leo'],
  [-835772133,-835564106,'Virgo'],
  [-835564106,-835370188,'Libra'],
  [-835370188,-835189557,'Scorpio'],
  [-835189557,-835017086,'Sagittarius'],
  [-835017086,-834845896,'Capricorn'],
  [-834845896,-834669292,'Aquarius'],
  [-834669292,-834482257,'Pisces'],
  [-834482257,-834282776,'Aries'],
  [-834282776,-834072371,'Taurus'],
  [-834072371,-833854990,'Gemini'],
  [-833854990,-833635166,'Cancer'],
  [-833635166,-833417584,'Leo'],
  [-833417584,-833207152,'Virgo'],
  [-833207152,-833008071,'Libra'],
  [-833008071,-832821702,'Scorpio'],
  [-832821702,-832645584,'Sagittarius'],
  [-832645584,-832474384,'Capricorn'],
  [-832474384,-832301418,'Aquarius'],
  [-832301418,-832120098,'Pisces'],
  [-832120098,-831925713,'Aries'],
  [-831925713,-831717646,'Taurus'],
  [-831717646,-831500282,'Gemini'],
  [-831500282,-831280487,'Cancer'],
  [-831280487,-831063984,'Leo'],
  [-831063984,-830854129,'Virgo'],
  [-830854129,-830652843,'Libra'],
  [-830652843,-830461278,'Scorpio'],
  [-830461278,-830279103,'Sagittarius'],
  [-830279103,-830103682,'Capricorn'],
  [-830103682,-829930041,'Aquarius'],
  [-829930041,-829751725,'Pisces'],
  [-829751725,-829562446,'Aries'],
  [-829562446,-829358777,'Taurus'],
  [-829358777,-829143133,'Gemini'],
  [-829143133,-828923405,'Cancer'],
  [-828923405,-828707762,'Leo'],
  [-828707762,-828500142,'Virgo'],
  [-828500142,-828300543,'Libra'],
  [-828300543,-828107795,'Scorpio'],
  [-828107795,-827921158,'Sagittarius'],
  [-827921158,-827739866,'Capricorn'],
  [-827739866,-827561662,'Aquarius'],
  [-827561662,-827382008,'Pisces'],
  [-827382008,-827194903,'Aries'],
  [-827194903,-826995252,'Taurus'],
  [-826995252,-826782531,'Gemini'],
  [-826782531,-826563178,'Cancer'],
  [-826563178,-826347159,'Leo'],
  [-826347159,-826140896,'Virgo'],
  [-826140896,-825944603,'Libra'],
  [-825944603,-825755030,'Scorpio'],
  [-825755030,-825568939,'Sagittarius'],
  [-825568939,-825384657,'Capricorn'],
  [-825384657,-825201348,'Aquarius'],
  [-825201348,-825017127,'Pisces'],
  [-825017127,-824828159,'Aries'],
  [-824828159,-824629784,'Taurus'],
  [-824629784,-824419586,'Gemini'],
  [-824419586,-824201056,'Cancer'],
  [-824201056,-823983534,'Leo'],
  [-823983534,-823775972,'Virgo'],
  [-823775972,-823581025,'Libra'],
  [-823581025,-823395510,'Scorpio'],
  [-823395510,-823214154,'Sagittarius'],
  [-823214154,-823032545,'Capricorn'],
  [-823032545,-822848283,'Aquarius'],
  [-822848283,-822660284,'Pisces'],
  [-822660284,-822467207,'Aries'],
  [-822467207,-822266805,'Taurus'],
  [-822266805,-822057132,'Gemini'],
  [-822057132,-821839479,'Cancer'],
  [-821839479,-821620465,'Leo'],
  [-821620465,-821409353,'Virgo'],
  [-821409353,-821211837,'Libra'],
  [-821211837,-821027108,'Scorpio'],
  [-821027108,-820850036,'Sagittarius'],
  [-820850036,-820674362,'Capricorn'],
  [-820674362,-820494789,'Aquarius'],
  [-820494789,-820308032,'Pisces'],
  [-820308032,-820112844,'Aries'],
  [-820112844,-819909273,'Taurus'],
  [-819909273,-819697940,'Gemini'],
  [-819697940,-819480443,'Cancer'],
  [-819480443,-819260942,'Leo'],
  [-819260942,-819046404,'Virgo'],
  [-819046404,-818843599,'Libra'],
  [-818843599,-818654962,'Scorpio'],
  [-818654962,-818477728,'Sagittarius'],
  [-818477728,-818305962,'Capricorn'],
  [-818305962,-818132797,'Aquarius'],
  [-818132797,-817952085,'Pisces'],
  [-817952085,-817759908,'Aries'],
  [-817759908,-817555799,'Taurus'],
  [-817555799,-817342528,'Gemini'],
  [-817342528,-817124225,'Cancer'],
  [-817124225,-816905037,'Leo'],
  [-816905037,-816689348,'Virgo'],
  [-816689348,-816482098,'Libra'],
  [-816482098,-816287152,'Scorpio'],
  [-816287152,-816104949,'Sagittarius'],
  [-816104949,-815931947,'Capricorn'],
  [-815931947,-815761812,'Aquarius'],
  [-815761812,-815587160,'Pisces'],
  [-815587160,-815401394,'Aries'],
  [-815401394,-815201126,'Taurus'],
  [-815201126,-814988327,'Gemini'],
  [-814988327,-814769252,'Cancer'],
  [-814769252,-814550347,'Leo'],
  [-814550347,-814335614,'Virgo'],
  [-814335614,-814127431,'Libra'],
  [-814127431,-813928139,'Scorpio'],
  [-813928139,-813739509,'Sagittarius'],
  [-813739509,-813560996,'Capricorn'],
  [-813560996,-813388663,'Aquarius'],
  [-813388663,-813215906,'Pisces'],
  [-813215906,-813035242,'Aries'],
  [-813035242,-812840762,'Taurus'],
  [-812840762,-812631488,'Gemini'],
  [-812631488,-812413063,'Cancer'],
  [-812413063,-812194165,'Leo'],
  [-812194165,-811980755,'Virgo'],
  [-811980755,-811774486,'Libra'],
  [-811774486,-811575232,'Scorpio'],
  [-811575232,-811383271,'Sagittarius'],
  [-811383271,-811199023,'Capricorn'],
  [-811199023,-811021196,'Aquarius'],
  [-811021196,-810845575,'Pisces'],
  [-810845575,-810665730,'Aries'],
  [-810665730,-810475101,'Taurus'],
  [-810475101,-810270211,'Gemini'],
  [-810270211,-810053994,'Cancer'],
  [-810053994,-809835145,'Leo'],
  [-809835145,-809622048,'Virgo'],
  [-809622048,-809417916,'Libra'],
  [-809417916,-809221647,'Scorpio'],
  [-809221647,-809031115,'Sagittarius'],
  [-809031115,-808845076,'Capricorn'],
  [-808845076,-808662735,'Aquarius'],
  [-808662735,-808482106,'Pisces'],
  [-808482106,-808299142,'Aries'],
  [-808299142,-808108556,'Taurus'],
  [-808108556,-807906207,'Gemini'],
  [-807906207,-807692458,'Cancer'],
  [-807692458,-807473876,'Leo'],
  [-807473876,-807259754,'Virgo'],
  [-807259754,-807055862,'Libra'],
  [-807055862,-806862267,'Scorpio'],
  [-806862267,-806675724,'Sagittarius'],
  [-806675724,-806492589,'Capricorn'],
  [-806492589,-806310169,'Aquarius'],
  [-806310169,-806126484,'Pisces'],
  [-806126484,-805939327,'Aries'],
  [-805939327,-805745806,'Taurus'],
  [-805745806,-805543102,'Gemini'],
  [-805543102,-805330637,'Cancer'],
  [-805330637,-805112393,'Leo'],
  [-805112393,-804896415,'Virgo'],
  [-804896415,-804690282,'Libra'],
  [-804690282,-804496602,'Scorpio'],
  [-804496602,-804312996,'Sagittarius'],
  [-804312996,-804134640,'Capricorn'],
  [-804134640,-803956452,'Aquarius'],
  [-803956452,-803774323,'Pisces'],
  [-803774323,-803585580,'Aries'],
  [-803585580,-803388883,'Taurus'],
  [-803388883,-803183826,'Gemini'],
  [-803183826,-802970948,'Cancer'],
  [-802970948,-802752861,'Leo'],
  [-802752861,-802535195,'Virgo'],
  [-802535195,-802325287,'Libra'],
  [-802325287,-802128206,'Scorpio'],
  [-802128206,-801944021,'Sagittarius'],
  [-801944021,-801768580,'Capricorn'],
  [-801768580,-801595640,'Aquarius'],
  [-801595640,-801418774,'Pisces'],
  [-801418774,-801232953,'Aries'],
  [-801232953,-801035971,'Taurus'],
  [-801035971,-800828847,'Gemini'],
  [-800828847,-800614495,'Cancer'],
  [-800614495,-800396223,'Leo'],
  [-800396223,-800177876,'Virgo'],
  [-800177876,-799964707,'Libra'],
  [-799964707,-799762392,'Scorpio'],
  [-799762392,-799573797,'Sagittarius'],
  [-799573797,-799397128,'Capricorn'],
  [-799397128,-799226750,'Aquarius'],
  [-799226750,-799055221,'Pisces'],
  [-799055221,-798875287,'Aries'],
  [-798875287,-798682142,'Taurus'],
  [-798682142,-798475685,'Gemini'],
  [-798475685,-798260311,'Cancer'],
  [-798260311,-798041594,'Leo'],
  [-798041594,-797823600,'Virgo'],
  [-797823600,-797609468,'Libra'],
  [-797609468,-797403115,'Scorpio'],
  [-797403115,-797208437,'Sagittarius'],
  [-797208437,-797026534,'Capricorn'],
  [-797026534,-796854104,'Aquarius'],
  [-796854104,-796684437,'Pisces'],
  [-796684437,-796509530,'Aries'],
  [-796509530,-796322375,'Taurus'],
  [-796322375,-796120014,'Gemini'],
  [-796120014,-795905703,'Cancer'],
  [-795905703,-795686736,'Leo'],
  [-795686736,-795469357,'Virgo'],
  [-795469357,-795256492,'Libra'],
  [-795256492,-795049704,'Scorpio'],
  [-795049704,-794851207,'Sagittarius'],
  [-794851207,-794663095,'Capricorn'],
  [-794663095,-794484860,'Aquarius'],
  [-794484860,-794312215,'Pisces'],
  [-794312215,-794138227,'Aries'],
  [-794138227,-793955410,'Taurus'],
  [-793955410,-793758485,'Gemini'],
  [-793758485,-793547660,'Cancer'],
  [-793547660,-793329390,'Leo'],
  [-793329390,-793112097,'Virgo'],
  [-793112097,-792900814,'Libra'],
  [-792900814,-792696551,'Scorpio'],
  [-792696551,-792498977,'Sagittarius'],
  [-792498977,-792308272,'Capricorn'],
  [-792308272,-792124511,'Aquarius'],
  [-792124511,-791945922,'Pisces'],
  [-791945922,-791768185,'Aries'],
  [-791768185,-791585332,'Taurus'],
  [-791585332,-791391743,'Gemini'],
  [-791391743,-791185053,'Cancer'],
  [-791185053,-790968708,'Leo'],
  [-790968708,-790750976,'Virgo'],
  [-790750976,-790539606,'Libra'],
  [-790539606,-790337608,'Scorpio'],
  [-790337608,-790143903,'Sagittarius'],
  [-790143903,-789955991,'Capricorn'],
  [-789955991,-789771656,'Aquarius'],
  [-789771656,-789589033,'Pisces'],
  [-789589033,-789405867,'Aries'],
  [-789405867,-789218983,'Taurus'],
  [-789218983,-789024653,'Gemini'],
  [-789024653,-788820108,'Cancer'],
  [-788820108,-788605986,'Leo'],
  [-788605986,-788387932,'Virgo'],
  [-788387932,-788174482,'Libra'],
  [-788174482,-787971757,'Scorpio'],
  [-787971757,-787780535,'Sagittarius'],
  [-787780535,-787597503,'Capricorn'],
  [-787597503,-787417801,'Aquarius'],
  [-787417801,-787236945,'Pisces'],
  [-787236945,-787051806,'Aries'],
  [-787051806,-786860698,'Taurus'],
  [-786860698,-786662730,'Gemini'],
  [-786662730,-786457167,'Cancer'],
  [-786457167,-786244047,'Leo'],
  [-786244047,-786026133,'Virgo'],
  [-786026133,-785810033,'Libra'],
  [-785810033,-785603531,'Scorpio'],
  [-785603531,-785410655,'Sagittarius'],
  [-785410655,-785229775,'Capricorn'],
  [-785229775,-785055292,'Aquarius'],
  [-785055292,-784880353,'Pisces'],
  [-784880353,-784699042,'Aries'],
  [-784699042,-784508084,'Taurus'],
  [-784508084,-784307496,'Gemini'],
  [-784307496,-784099252,'Cancer'],
  [-784099252,-783885319,'Leo'],
  [-783885319,-783667618,'Virgo'],
  [-783667618,-783449993,'Libra'],
  [-783449993,-783239081,'Scorpio'],
  [-783239081,-783041101,'Sagittarius'],
  [-783041101,-782857580,'Capricorn'],
  [-782857580,-782684442,'Aquarius'],
  [-782684442,-782514349,'Pisces'],
  [-782514349,-782339438,'Aries'],
  [-782339438,-782153607,'Taurus'],
  [-782153607,-781954776,'Gemini'],
  [-781954776,-781745413,'Cancer'],
  [-781745413,-781529990,'Leo'],
  [-781529990,-781312091,'Virgo'],
  [-781312091,-781094466,'Libra'],
  [-781094466,-780881228,'Scorpio'],
  [-780881228,-780678012,'Sagittarius'],
  [-780678012,-780488647,'Capricorn'],
  [-780488647,-780311988,'Aquarius'],
  [-780311988,-780142196,'Pisces'],
  [-780142196,-779971306,'Aries'],
  [-779971306,-779791637,'Taurus'],
  [-779791637,-779598266,'Gemini'],
  [-779598266,-779391354,'Cancer'],
  [-779391354,-779175766,'Leo'],
  [-779175766,-778957480,'Virgo'],
  [-778957480,-778740548,'Libra'],
  [-778740548,-778527727,'Scorpio'],
  [-778527727,-778322332,'Sagittarius'],
  [-778322332,-778127813,'Capricorn'],
  [-778127813,-777945155,'Aquarius'],
  [-777945155,-777771212,'Pisces'],
  [-777771212,-777599657,'Aries'],
  [-777599657,-777423064,'Taurus'],
  [-777423064,-777235088,'Gemini'],
  [-777235088,-777033019,'Cancer'],
  [-777033019,-776819545,'Leo'],
  [-776819545,-776601367,'Virgo'],
  [-776601367,-776384917,'Libra'],
  [-776384917,-776173823,'Scorpio'],
  [-776173823,-775969771,'Sagittarius'],
  [-775969771,-775773942,'Capricorn'],
  [-775773942,-775586893,'Aquarius'],
  [-775586893,-775407282,'Pisces'],
  [-775407282,-775231305,'Aries'],
  [-775231305,-775053385,'Taurus'],
  [-775053385,-774867613,'Gemini'],
  [-774867613,-774669776,'Cancer'],
  [-774669776,-774459707,'Leo'],
  [-774459707,-774242458,'Virgo'],
  [-774242458,-774025858,'Libra'],
  [-774025858,-773815871,'Scorpio'],
  [-773815871,-773614583,'Sagittarius'],
  [-773614583,-773421287,'Capricorn'],
  [-773421287,-773234244,'Aquarius'],
  [-773234244,-773051461,'Pisces'],
  [-773051461,-772870538,'Aries'],
  [-772870538,-772688321,'Taurus'],
  [-772688321,-772500919,'Gemini'],
  [-772500919,-772304511,'Cancer'],
  [-772304511,-772097194,'Leo'],
  [-772097194,-771881320,'Virgo'],
  [-771881320,-771663987,'Libra'],
  [-771663987,-771453292,'Scorpio'],
  [-771453292,-771253485,'Sagittarius'],
  [-771253485,-771063819,'Capricorn'],
  [-771063819,-770880535,'Aquarius'],
  [-770880535,-770699301,'Pisces'],
  [-770699301,-770516701,'Aries'],
  [-770516701,-770330569,'Taurus'],
  [-770330569,-770139369,'Gemini'],
  [-770139369,-769941342,'Cancer'],
  [-769941342,-769734760,'Leo'],
  [-769734760,-769519953,'Virgo'],
  [-769519953,-769301707,'Libra'],
  [-769301707,-769088498,'Scorpio'],
  [-769088498,-768887254,'Sagittarius'],
  [-768887254,-768699116,'Capricorn'],
  [-768699116,-768520013,'Aquarius'],
  [-768520013,-768343652,'Pisces'],
  [-768343652,-768164187,'Aries'],
  [-768164187,-767977984,'Taurus'],
  [-767977984,-767784105,'Gemini'],
  [-767784105,-767583070,'Cancer'],
  [-767583070,-767375150,'Leo'],
  [-767375150,-767160520,'Virgo'],
  [-767160520,-766941693,'Libra'],
  [-766941693,-766725423,'Scorpio'],
  [-766725423,-766520012,'Sagittarius'],
  [-766520012,-766329543,'Capricorn'],
  [-766329543,-766151603,'Aquarius'],
  [-766151603,-765979578,'Pisces'],
  [-765979578,-765805854,'Aries'],
  [-765805854,-765624218,'Taurus'],
  [-765624218,-765431783,'Gemini'],
  [-765431783,-765229337,'Cancer'],
  [-765229337,-765019371,'Leo'],
  [-765019371,-764803960,'Virgo'],
  [-764803960,-764585060,'Libra'],
  [-764585060,-764366982,'Scorpio'],
  [-764366982,-764156899,'Sagittarius'],
  [-764156899,-763960897,'Capricorn'],
  [-763960897,-763779565,'Aquarius'],
  [-763779565,-763607910,'Pisces'],
  [-763607910,-763438248,'Aries'],
  [-763438248,-763262824,'Taurus'],
  [-763262824,-763075979,'Gemini'],
  [-763075979,-762876116,'Cancer'],
  [-762876116,-762665772,'Leo'],
  [-762665772,-762449316,'Virgo'],
  [-762449316,-762230493,'Libra'],
  [-762230493,-762012638,'Scorpio'],
  [-762012638,-761800359,'Sagittarius'],
  [-761800359,-761598939,'Capricorn'],
  [-761598939,-761411151,'Aquarius'],
  [-761411151,-761234993,'Pisces'],
  [-761234993,-761064617,'Aries'],
  [-761064617,-760892586,'Taurus'],
  [-760892586,-760711866,'Gemini'],
  [-760711866,-760517887,'Cancer'],
  [-760517887,-760310513,'Leo'],
  [-760310513,-760094192,'Virgo'],
  [-760094192,-759875223,'Libra'],
  [-759875223,-759658561,'Scorpio'],
  [-759658561,-759447460,'Sagittarius'],
  [-759447460,-759244499,'Capricorn'],
  [-759244499,-759051606,'Aquarius'],
  [-759051606,-758868730,'Pisces'],
  [-758868730,-758692989,'Aries'],
  [-758692989,-758519155,'Taurus'],
  [-758519155,-758340880,'Gemini'],
  [-758340880,-758152274,'Cancer'],
  [-758152274,-757950088,'Leo'],
  [-757950088,-757736085,'Virgo'],
  [-757736085,-757517090,'Libra'],
  [-757517090,-757300906,'Scorpio'],
  [-757300906,-757092156,'Sagittarius'],
  [-757092156,-756891782,'Capricorn'],
  [-756891782,-756698904,'Aquarius'],
  [-756698904,-756512285,'Pisces'],
  [-756512285,-756330434,'Aries'],
  [-756330434,-756150975,'Taurus'],
  [-756150975,-755970105,'Gemini'],
  [-755970105,-755782876,'Cancer'],
  [-755782876,-755584710,'Leo'],
  [-755584710,-755374222,'Virgo'],
  [-755374222,-755155944,'Libra'],
  [-755155944,-754938951,'Scorpio'],
  [-754938951,-754730864,'Sagittarius'],
  [-754730864,-754533688,'Capricorn'],
  [-754533688,-754344816,'Aquarius'],
  [-754344816,-754160225,'Pisces'],
  [-754160225,-753976738,'Aries'],
  [-753976738,-753792626,'Taurus'],
  [-753792626,-753606634,'Gemini'],
  [-753606634,-753416503,'Cancer'],
  [-753416503,-753218754,'Leo'],
  [-753218754,-753010631,'Virgo'],
  [-753010631,-752793609,'Libra'],
  [-752793609,-752575247,'Scorpio'],
  [-752575247,-752365194,'Sagittarius'],
  [-752365194,-752168374,'Capricorn'],
  [-752168374,-751982977,'Aquarius'],
  [-751982977,-751803418,'Pisces'],
  [-751803418,-751623859,'Aries'],
  [-751623859,-751440410,'Taurus'],
  [-751440410,-751251698,'Gemini'],
  [-751251698,-751057550,'Cancer'],
  [-751057550,-750857139,'Leo'],
  [-750857139,-750648839,'Virgo'],
  [-750648839,-750432632,'Libra'],
  [-750432632,-750213293,'Scorpio'],
  [-750213293,-749999888,'Sagittarius'],
  [-749999888,-749799886,'Capricorn'],
  [-749799886,-749614156,'Aquarius'],
  [-749614156,-749437792,'Pisces'],
  [-749437792,-749263720,'Aries'],
  [-749263720,-749085565,'Taurus'],
  [-749085565,-748899438,'Gemini'],
  [-748899438,-748704425,'Cancer'],
  [-748704425,-748501343,'Leo'],
  [-748501343,-748291095,'Virgo'],
  [-748291095,-748074620,'Libra'],
  [-748074620,-747855002,'Scorpio'],
  [-747855002,-747638937,'Sagittarius'],
  [-747638937,-747434132,'Capricorn'],
  [-747434132,-747244191,'Aquarius'],
  [-747244191,-747066641,'Pisces'],
  [-747066641,-746895148,'Aries'],
  [-746895148,-746722425,'Taurus'],
  [-746722425,-746542254,'Gemini'],
  [-746542254,-746351009,'Cancer'],
  [-746351009,-746148380,'Leo'],
  [-746148380,-745936694,'Virgo'],
  [-745936694,-745719274,'Libra'],
  [-745719274,-745499774,'Scorpio'],
  [-745499774,-745282977,'Sagittarius'],
  [-745282977,-745074641,'Capricorn'],
  [-745074641,-744879125,'Aquarius'],
  [-744879125,-744696646,'Pisces'],
  [-744696646,-744523178,'Aries'],
  [-744523178,-744352321,'Taurus'],
  [-744352321,-744177162,'Gemini'],
  [-744177162,-743991842,'Cancer'],
  [-743991842,-743793276,'Leo'],
  [-743793276,-743582598,'Virgo'],
  [-743582598,-743364668,'Libra'],
  [-743364668,-743145321,'Scorpio'],
  [-743145321,-742929403,'Sagittarius'],
  [-742929403,-742720535,'Capricorn'],
  [-742720535,-742521441,'Aquarius'],
  [-742521441,-742333255,'Pisces'],
  [-742333255,-742154498,'Aries'],
  [-742154498,-741981076,'Taurus'],
  [-741981076,-741807097,'Gemini'],
  [-741807097,-741626101,'Cancer'],
  [-741626101,-741432798,'Leo'],
  [-741432798,-741225588,'Virgo'],
  [-741225588,-741008479,'Libra'],
  [-741008479,-740789198,'Scorpio'],
  [-740789198,-740574489,'Sagittarius'],
  [-740574489,-740367499,'Capricorn'],
  [-740367499,-740168652,'Aquarius'],
  [-740168652,-739977564,'Pisces'],
  [-739977564,-739793526,'Aries'],
  [-739793526,-739614821,'Taurus'],
  [-739614821,-739437908,'Gemini'],
  [-739437908,-739257453,'Cancer'],
  [-739257453,-739067576,'Leo'],
  [-739067576,-738864399,'Virgo'],
  [-738864399,-738649382,'Libra'],
  [-738649382,-738430150,'Scorpio'],
  [-738430150,-738215746,'Sagittarius'],
  [-738215746,-738010860,'Capricorn'],
  [-738010860,-737814994,'Aquarius'],
  [-737814994,-737625394,'Pisces'],
  [-737625394,-737439711,'Aries'],
  [-737439711,-737256640,'Taurus'],
  [-737256640,-737074799,'Gemini'],
  [-737074799,-736891250,'Cancer'],
  [-736891250,-736701349,'Leo'],
  [-736701349,-736500547,'Virgo'],
  [-736500547,-736287844,'Libra'],
  [-736287844,-736068768,'Scorpio'],
  [-736068768,-735853237,'Sagittarius'],
  [-735853237,-735648546,'Capricorn'],
  [-735648546,-735455383,'Aquarius'],
  [-735455383,-735269856,'Pisces'],
  [-735269856,-735087207,'Aries'],
  [-735087207,-734904163,'Taurus'],
  [-734904163,-734719273,'Gemini'],
  [-734719273,-734531476,'Cancer'],
  [-734531476,-734338574,'Leo'],
  [-734338574,-734137355,'Virgo'],
  [-734137355,-733925906,'Libra'],
  [-733925906,-733707121,'Scorpio'],
  [-733707121,-733489541,'Sagittarius'],
  [-733489541,-733282293,'Capricorn'],
  [-733282293,-733088818,'Aquarius'],
  [-733088818,-732906196,'Pisces'],
  [-732906196,-732728549,'Aries'],
  [-732728549,-732550155,'Taurus'],
  [-732550155,-732367176,'Gemini'],
  [-732367176,-732177910,'Cancer'],
  [-732177910,-731981722,'Leo'],
  [-731981722,-731777932,'Virgo'],
  [-731777932,-731565976,'Libra'],
  [-731565976,-731347439,'Scorpio'],
  [-731347439,-731128181,'Sagittarius'],
  [-731128181,-730916779,'Capricorn'],
  [-730916779,-730719228,'Aquarius'],
  [-730719228,-730535400,'Pisces'],
  [-730535400,-730360400,'Aries'],
  [-730360400,-730187558,'Taurus'],
  [-730187558,-730010590,'Gemini'],
  [-730010590,-729825010,'Cancer'],
  [-729825010,-729628947,'Leo'],
  [-729628947,-729423010,'Virgo'],
  [-729423010,-729209293,'Libra'],
  [-729209293,-728990574,'Scorpio'],
  [-728990574,-728770974,'Sagittarius'],
  [-728770974,-728556477,'Capricorn'],
  [-728556477,-728353196,'Aquarius'],
  [-728353196,-728163911,'Pisces'],
  [-728163911,-727986579,'Aries'],
  [-727986579,-727815675,'Taurus'],
  [-727815675,-727644210,'Gemini'],
  [-727644210,-727465368,'Cancer'],
  [-727465368,-727274217,'Leo'],
  [-727274217,-727069624,'Virgo'],
  [-727069624,-726854862,'Libra'],
  [-726854862,-726635464,'Scorpio'],
  [-726635464,-726416447,'Sagittarius'],
  [-726416447,-726201715,'Capricorn'],
  [-726201715,-725994931,'Aquarius'],
  [-725994931,-725799252,'Pisces'],
  [-725799252,-725615531,'Aries'],
  [-725615531,-725441186,'Taurus'],
  [-725441186,-725270600,'Gemini'],
  [-725270600,-725096550,'Cancer'],
  [-725096550,-724911982,'Leo'],
  [-724911982,-724712556,'Virgo'],
  [-724712556,-724499572,'Libra'],
  [-724499572,-724279886,'Scorpio'],
  [-724279886,-724061270,'Sagittarius'],
  [-724061270,-723848189,'Capricorn'],
  [-723848189,-723642042,'Aquarius'],
  [-723642042,-723443624,'Pisces'],
  [-723443624,-723253943,'Aries'],
  [-723253943,-723073003,'Taurus'],
  [-723073003,-722898144,'Gemini'],
  [-722898144,-722723790,'Cancer'],
  [-722723790,-722542830,'Leo'],
  [-722542830,-722348975,'Virgo'],
  [-722348975,-722140270,'Libra'],
  [-722140270,-721921807,'Scorpio'],
  [-721921807,-721703070,'Sagittarius'],
  [-721703070,-721491176,'Capricorn'],
  [-721491176,-721287774,'Aquarius'],
  [-721287774,-721091396,'Pisces'],
  [-721091396,-720900639,'Aries'],
  [-720900639,-720715143,'Taurus'],
  [-720715143,-720534286,'Gemini'],
  [-720534286,-720355326,'Cancer'],
  [-720355326,-720173090,'Leo'],
  [-720173090,-719981537,'Virgo'],
  [-719981537,-719776776,'Libra'],
  [-719776776,-719560751,'Scorpio'],
  [-719560751,-719341860,'Sagittarius'],
  [-719341860,-719129431,'Capricorn'],
  [-719129431,-718927556,'Aquarius'],
  [-718927556,-718734789,'Pisces'],
  [-718734789,-718547573,'Aries'],
  [-718547573,-718363016,'Taurus'],
  [-718363016,-718179555,'Gemini'],
  [-718179555,-717995822,'Cancer'],
  [-717995822,-717809245,'Leo'],
  [-717809245,-717615942,'Virgo'],
  [-717615942,-717412365,'Libra'],
  [-717412365,-717198387,'Scorpio'],
  [-717198387,-716979628,'Sagittarius'],
  [-716979628,-716765306,'Capricorn'],
  [-716765306,-716562132,'Aquarius'],
  [-716562132,-716370819,'Pisces'],
  [-716370819,-716187721,'Aries'],
  [-716187721,-716007927,'Taurus'],
  [-716007927,-715827260,'Gemini'],
  [-715827260,-715642917,'Cancer'],
  [-715642917,-715453072,'Leo'],
  [-715453072,-715256206,'Virgo'],
  [-715256206,-715050983,'Libra'],
  [-715050983,-714837420,'Scorpio'],
  [-714837420,-714618895,'Sagittarius'],
  [-714618895,-714402488,'Capricorn'],
  [-714402488,-714195792,'Aquarius'],
  [-714195792,-714002329,'Pisces'],
  [-714002329,-713820344,'Aries'],
  [-713820344,-713644797,'Taurus'],
  [-713644797,-713469646,'Gemini'],
  [-713469646,-713289487,'Cancer'],
  [-713289487,-713100678,'Leo'],
  [-713100678,-712901981,'Virgo'],
  [-712901981,-712694281,'Libra'],
  [-712694281,-712479636,'Scorpio'],
  [-712479636,-712261133,'Sagittarius'],
  [-712261133,-712043527,'Capricorn'],
  [-712043527,-711833044,'Aquarius'],
  [-711833044,-711634821,'Pisces'],
  [-711634821,-711449919,'Aries'],
  [-711449919,-711274991,'Taurus'],
  [-711274991,-711103869,'Gemini'],
  [-711103869,-710929487,'Cancer'],
  [-710929487,-710745663,'Leo'],
  [-710745663,-710549074,'Virgo'],
  [-710549074,-710340684,'Libra'],
  [-710340684,-710124725,'Scorpio'],
  [-710124725,-709905964,'Sagittarius'],
  [-709905964,-709688372,'Capricorn'],
  [-709688372,-709475880,'Aquarius'],
  [-709475880,-709272905,'Pisces'],
  [-709272905,-709082476,'Aries'],
  [-709082476,-708903994,'Taurus'],
  [-708903994,-708732871,'Gemini'],
  [-708732871,-708562016,'Cancer'],
  [-708562016,-708383802,'Leo'],
  [-708383802,-708192367,'Virgo'],
  [-708192367,-707986463,'Libra'],
  [-707986463,-707770512,'Scorpio'],
  [-707770512,-707551474,'Sagittarius'],
  [-707551474,-707334585,'Capricorn'],
  [-707334585,-707122546,'Aquarius'],
  [-707122546,-706917544,'Pisces'],
  [-706917544,-706722180,'Aries'],
  [-706722180,-706537853,'Taurus'],
  [-706537853,-706362643,'Gemini'],
  [-706362643,-706191071,'Cancer'],
  [-706191071,-706015698,'Leo'],
  [-706015698,-705829333,'Virgo'],
  [-705829333,-705628076,'Libra'],
  [-705628076,-705414221,'Scorpio'],
  [-705414221,-705195347,'Sagittarius'],
  [-705195347,-704978992,'Capricorn'],
  [-704978992,-704768715,'Aquarius'],
  [-704768715,-704565106,'Pisces'],
  [-704565106,-704368500,'Aries'],
  [-704368500,-704179786,'Taurus'],
  [-704179786,-703998845,'Gemini'],
  [-703998845,-703822785,'Cancer'],
  [-703822785,-703645990,'Leo'],
  [-703645990,-703461702,'Virgo'],
  [-703461702,-703264607,'Libra'],
  [-703264607,-703054165,'Scorpio'],
  [-703054165,-702836219,'Sagittarius'],
  [-702836219,-702619644,'Capricorn'],
  [-702619644,-702410434,'Aquarius'],
  [-702410434,-702209672,'Pisces'],
  [-702209672,-702015827,'Aries'],
  [-702015827,-701827336,'Taurus'],
  [-701827336,-701643223,'Gemini'],
  [-701643223,-701462006,'Cancer'],
  [-701462006,-701280593,'Leo'],
  [-701280593,-701094364,'Virgo'],
  [-701094364,-700898587,'Libra'],
  [-700898587,-700691014,'Scorpio'],
  [-700691014,-700474564,'Sagittarius'],
  [-700474564,-700257115,'Capricorn'],
  [-700257115,-700046842,'Aquarius'],
  [-700046842,-699847320,'Pisces'],
  [-699847320,-699657255,'Aries'],
  [-699657255,-699473070,'Taurus'],
  [-699473070,-699291102,'Gemini'],
  [-699291102,-699108491,'Cancer'],
  [-699108491,-698923003,'Leo'],
  [-698923003,-698732474,'Virgo'],
  [-698732474,-698534598,'Libra'],
  [-698534598,-698327671,'Scorpio'],
  [-698327671,-698112520,'Sagittarius'],
  [-698112520,-697894243,'Capricorn'],
  [-697894243,-697680996,'Aquarius'],
  [-697680996,-697479236,'Pisces'],
  [-697479236,-697290140,'Aries'],
  [-697290140,-697110248,'Taurus'],
  [-697110248,-696933914,'Gemini'],
  [-696933914,-696755461,'Cancer'],
  [-696755461,-696570668,'Leo'],
  [-696570668,-696377584,'Virgo'],
  [-696377584,-696176250,'Libra'],
  [-696176250,-695967524,'Scorpio'],
  [-695967524,-695752568,'Sagittarius'],
  [-695752568,-695534086,'Capricorn'],
  [-695534086,-695317832,'Aquarius'],
  [-695317832,-695111163,'Pisces'],
  [-695111163,-694918531,'Aries'],
  [-694918531,-694738874,'Taurus'],
  [-694738874,-694566682,'Gemini'],
  [-694566682,-694394569,'Cancer'],
  [-694394569,-694215545,'Leo'],
  [-694215545,-694025106,'Virgo'],
  [-694025106,-693822876,'Libra'],
  [-693822876,-693611897,'Scorpio'],
  [-693611897,-693395859,'Sagittarius'],
  [-693395859,-693177533,'Capricorn'],
  [-693177533,-692960125,'Aquarius'],
  [-692960125,-692749054,'Pisces'],
  [-692749054,-692550196,'Aries'],
  [-692550196,-692365833,'Taurus'],
  [-692365833,-692192773,'Gemini'],
  [-692192773,-692023971,'Cancer'],
  [-692023971,-691851193,'Leo'],
  [-691851193,-691667310,'Virgo'],
  [-691667310,-691468983,'Libra'],
  [-691468983,-691258399,'Scorpio'],
  [-691258399,-691041304,'Sagittarius'],
  [-691041304,-690822875,'Capricorn'],
  [-690822875,-690606112,'Aquarius'],
  [-690606112,-690393868,'Pisces'],
  [-690393868,-690190377,'Aries'],
  [-690190377,-689999357,'Taurus'],
  [-689999357,-689820767,'Gemini'],
  [-689820767,-689649885,'Cancer'],
  [-689649885,-689479207,'Leo'],
  [-689479207,-689300812,'Virgo'],
  [-689300812,-689108828,'Libra'],
  [-689108828,-688902299,'Scorpio'],
  [-688902299,-688686058,'Sagittarius'],
  [-688686058,-688467416,'Capricorn'],
  [-688467416,-688251584,'Aquarius'],
  [-688251584,-688040933,'Pisces'],
  [-688040933,-687837159,'Aries'],
  [-687837159,-687642353,'Taurus'],
  [-687642353,-687457568,'Gemini'],
  [-687457568,-687280866,'Cancer'],
  [-687280866,-687107165,'Leo'],
  [-687107165,-686929703,'Virgo'],
  [-686929703,-686742067,'Libra'],
  [-686742067,-686540742,'Scorpio'],
  [-686540742,-686327527,'Sagittarius'],
  [-686327527,-686109282,'Capricorn'],
  [-686109282,-685893610,'Aquarius'],
  [-685893610,-685684795,'Pisces'],
  [-685684795,-685483774,'Aries'],
  [-685483774,-685290096,'Taurus'],
  [-685290096,-685103056,'Gemini'],
  [-685103056,-684921306,'Cancer'],
  [-684921306,-684742110,'Leo'],
  [-684742110,-684561226,'Virgo'],
  [-684561226,-684373682,'Libra'],
  [-684373682,-684175406,'Scorpio'],
  [-684175406,-683965571,'Sagittarius'],
  [-683965571,-683748470,'Capricorn'],
  [-683748470,-683532131,'Aquarius'],
  [-683532131,-683323465,'Pisces'],
  [-683323465,-683124934,'Aries'],
  [-683124934,-682935071,'Taurus'],
  [-682935071,-682750662,'Gemini'],
  [-682750662,-682568445,'Cancer'],
  [-682568445,-682385723,'Leo'],
  [-682385723,-682200182,'Virgo'],
  [-682200182,-682009386,'Libra'],
  [-682009386,-681810741,'Scorpio'],
  [-681810741,-681602648,'Sagittarius'],
  [-681602648,-681386769,'Capricorn'],
  [-681386769,-681169383,'Aquarius'],
  [-681169383,-680958796,'Pisces'],
  [-680958796,-680760150,'Aries'],
  [-680760150,-680573091,'Taurus'],
  [-680573091,-680393255,'Gemini'],
  [-680393255,-680215001,'Cancer'],
  [-680215001,-680033535,'Leo'],
  [-680033535,-679846068,'Virgo'],
  [-679846068,-679651749,'Libra'],
  [-679651749,-679450446,'Scorpio'],
  [-679450446,-679241852,'Sagittarius'],
  [-679241852,-679026526,'Capricorn'],
  [-679026526,-678808262,'Aquarius'],
  [-678808262,-678594610,'Pisces'],
  [-678594610,-678392869,'Aries'],
  [-678392869,-678205238,'Taurus'],
  [-678205238,-678028142,'Gemini'],
  [-678028142,-677854858,'Cancer'],
  [-677854858,-677678388,'Leo'],
  [-677678388,-677493629,'Virgo'],
  [-677493629,-677298831,'Libra'],
  [-677298831,-677095213,'Scorpio'],
  [-677095213,-676884801,'Sagittarius'],
  [-676884801,-676669122,'Capricorn'],
  [-676669122,-676450506,'Aquarius'],
  [-676450506,-676234301,'Pisces'],
  [-676234301,-676027942,'Aries'],
  [-676027942,-675836205,'Taurus'],
  [-675836205,-675657886,'Gemini'],
  [-675657886,-675486941,'Cancer'],
  [-675486941,-675315511,'Leo'],
  [-675315511,-675136406,'Virgo'],
  [-675136406,-674945330,'Libra'],
  [-674945330,-674742324,'Scorpio'],
  [-674742324,-674530672,'Sagittarius'],
  [-674530672,-674314138,'Capricorn'],
  [-674314138,-674095621,'Aquarius'],
  [-674095621,-673878667,'Pisces'],
  [-673878667,-673668798,'Aries'],
  [-673668798,-673471471,'Taurus'],
  [-673471471,-673288191,'Gemini'],
  [-673288191,-673115202,'Cancer'],
  [-673115202,-672945469,'Leo'],
  [-672945469,-672771196,'Virgo'],
  [-672771196,-672585982,'Libra'],
  [-672585982,-672387098,'Scorpio'],
  [-672387098,-672176569,'Sagittarius'],
  [-672176569,-671959579,'Capricorn'],
  [-671959579,-671741236,'Aquarius'],
  [-671741236,-671525213,'Pisces'],
  [-671525213,-671314911,'Aries'],
  [-671314911,-671113989,'Taurus'],
  [-671113989,-670924777,'Gemini'],
  [-670924777,-670746175,'Cancer'],
  [-670746175,-670573530,'Leo'],
  [-670573530,-670400192,'Virgo'],
  [-670400192,-670219321,'Libra'],
  [-670219321,-670025932,'Scorpio'],
  [-670025932,-669819116,'Sagittarius'],
  [-669819116,-669603013,'Capricorn'],
  [-669603013,-669384632,'Aquarius'],
  [-669384632,-669169817,'Pisces'],
  [-669169817,-668961652,'Aries'],
  [-668961652,-668761361,'Taurus'],
  [-668761361,-668569383,'Gemini'],
  [-668569383,-668385217,'Cancer'],
  [-668385217,-668206679,'Leo'],
  [-668206679,-668029728,'Virgo'],
  [-668029728,-667849018,'Libra'],
  [-667849018,-667659157,'Scorpio'],
  [-667659157,-667456765,'Sagittarius'],
  [-667456765,-667243045,'Capricorn'],
  [-667243045,-667024582,'Aquarius'],
  [-667024582,-666809738,'Pisces'],
  [-666809738,-666603651,'Aries'],
  [-666603651,-666406846,'Taurus'],
  [-666406846,-666217135,'Gemini'],
  [-666217135,-666031873,'Cancer'],
  [-666031873,-665848926,'Leo'],
  [-665848926,-665666405,'Virgo'],
  [-665666405,-665481769,'Libra'],
  [-665481769,-665291380,'Scorpio'],
  [-665291380,-665091405,'Sagittarius'],
  [-665091405,-664880380,'Capricorn'],
  [-664880380,-664662212,'Aquarius'],
  [-664662212,-664445773,'Pisces'],
  [-664445773,-664239213,'Aries'],
  [-664239213,-664044909,'Taurus'],
  [-664044909,-663859798,'Gemini'],
  [-663859798,-663678640,'Cancer'],
  [-663678640,-663496822,'Leo'],
  [-663496822,-663311753,'Virgo'],
  [-663311753,-663122565,'Libra'],
  [-663122565,-662928453,'Scorpio'],
  [-662928453,-662727498,'Sagittarius'],
  [-662727498,-662517704,'Capricorn'],
  [-662517704,-662300181,'Aquarius'],
  [-662300181,-662081679,'Pisces'],
  [-662081679,-661871798,'Aries'],
  [-661871798,-661676152,'Taurus'],
  [-661676152,-661493320,'Gemini'],
  [-661493320,-661317298,'Cancer'],
  [-661317298,-661141127,'Leo'],
  [-661141127,-660959440,'Virgo'],
  [-660959440,-660769893,'Libra'],
  [-660769893,-660572743,'Scorpio'],
  [-660572743,-660368776,'Sagittarius'],
  [-660368776,-660157976,'Capricorn'],
  [-660157976,-659940777,'Aquarius'],
  [-659940777,-659721119,'Pisces'],
  [-659721119,-659507175,'Aries'],
  [-659507175,-659306663,'Taurus'],
  [-659306663,-659121362,'Gemini'],
  [-659121362,-658946814,'Cancer'],
  [-658946814,-658775628,'Leo'],
  [-658775628,-658600442,'Virgo'],
  [-658600442,-658415965,'Libra'],
  [-658415965,-658220362,'Scorpio'],
  [-658220362,-658014918,'Sagittarius'],
  [-658014918,-657802166,'Capricorn'],
  [-657802166,-657584447,'Aquarius'],
  [-657584447,-657364782,'Pisces'],
  [-657364782,-657148647,'Aries'],
  [-657148647,-656942916,'Taurus'],
  [-656942916,-656751700,'Gemini'],
  [-656751700,-656573575,'Cancer'],
  [-656573575,-656402780,'Leo'],
  [-656402780,-656231911,'Virgo'],
  [-656231911,-656053984,'Libra'],
  [-656053984,-655864176,'Scorpio'],
  [-655864176,-655661341,'Sagittarius'],
  [-655661341,-655448243,'Capricorn'],
  [-655448243,-655229717,'Aquarius'],
  [-655229717,-655010421,'Pisces'],
  [-655010421,-654794611,'Aries'],
  [-654794611,-654586610,'Taurus'],
  [-654586610,-654390002,'Gemini'],
  [-654390002,-654205566,'Cancer'],
  [-654205566,-654030405,'Leo'],
  [-654030405,-653858924,'Virgo'],
  [-653858924,-653684398,'Libra'],
  [-653684398,-653500489,'Scorpio'],
  [-653500489,-653303109,'Sagittarius'],
  [-653303109,-653092588,'Capricorn'],
  [-653092588,-652874191,'Aquarius'],
  [-652874191,-652655079,'Pisces'],
  [-652655079,-652440712,'Aries'],
  [-652440712,-652233868,'Taurus'],
  [-652233868,-652035717,'Gemini'],
  [-652035717,-651846549,'Cancer'],
  [-651846549,-651665329,'Leo'],
  [-651665329,-651489174,'Virgo'],
  [-651489174,-651313320,'Libra'],
  [-651313320,-651131842,'Scorpio'],
  [-651131842,-650939208,'Sagittarius'],
  [-650939208,-650732878,'Capricorn'],
  [-650732878,-650516067,'Aquarius'],
  [-650516067,-650296967,'Pisces'],
  [-650296967,-650083492,'Aries'],
  [-650083492,-649879112,'Taurus'],
  [-649879112,-649683205,'Gemini'],
  [-649683205,-649493749,'Cancer'],
  [-649493749,-649309019,'Leo'],
  [-649309019,-649127579,'Virgo'],
  [-649127579,-648947199,'Libra'],
  [-648947199,-648763984,'Scorpio'],
  [-648763984,-648572874,'Sagittarius'],
  [-648572874,-648369830,'Capricorn'],
  [-648369830,-648155302,'Aquarius'],
  [-648155302,-647936210,'Pisces'],
  [-647936210,-647722227,'Aries'],
  [-647722227,-647519114,'Taurus'],
  [-647519114,-647326471,'Gemini'],
  [-647326471,-647140414,'Cancer'],
  [-647140414,-646956915,'Leo'],
  [-646956915,-646773495,'Virgo'],
  [-646773495,-646588936,'Libra'],
  [-646588936,-646401679,'Scorpio'],
  [-646401679,-646208716,'Sagittarius'],
  [-646208716,-646006441,'Capricorn'],
  [-646006441,-645793587,'Aquarius'],
  [-645793587,-645574569,'Pisces'],
  [-645574569,-645358807,'Aries'],
  [-645358807,-645154431,'Taurus'],
  [-645154431,-644963074,'Gemini'],
  [-644963074,-644780798,'Cancer'],
  [-644780798,-644601781,'Leo'],
  [-644601781,-644421149,'Virgo'],
  [-644421149,-644236235,'Libra'],
  [-644236235,-644046062,'Scorpio'],
  [-644046062,-643849780,'Sagittarius'],
  [-643849780,-643645848,'Capricorn'],
  [-643645848,-643433221,'Aquarius'],
  [-643433221,-643214292,'Pisces'],
  [-643214292,-642996438,'Aries'],
  [-642996438,-642788560,'Taurus'],
  [-642788560,-642595026,'Gemini'],
  [-642595026,-642413718,'Cancer'],
  [-642413718,-642238717,'Leo'],
  [-642238717,-642063457,'Virgo'],
  [-642063457,-641882733,'Libra'],
  [-641882733,-641693717,'Scorpio'],
  [-641693717,-641495765,'Sagittarius'],
  [-641495765,-641289416,'Capricorn'],
  [-641289416,-641075665,'Aquarius'],
  [-641075665,-640856714,'Pisces'],
  [-640856714,-640637654,'Aries'],
  [-640637654,-640425898,'Taurus'],
  [-640425898,-640227380,'Gemini'],
  [-640227380,-640042876,'Cancer'],
  [-640042876,-639868240,'Leo'],
  [-639868240,-639696928,'Virgo'],
  [-639696928,-639522136,'Libra'],
  [-639522136,-639338356,'Scorpio'],
  [-639338356,-639142726,'Sagittarius'],
  [-639142726,-638935747,'Capricorn'],
  [-638935747,-638720593,'Aquarius'],
  [-638720593,-638501372,'Pisces'],
  [-638501372,-638282474,'Aries'],
  [-638282474,-638068830,'Taurus'],
  [-638068830,-637865353,'Gemini'],
  [-637865353,-637674776,'Cancer'],
  [-637674776,-637495927,'Leo'],
  [-637495927,-637324165,'Virgo'],
  [-637324165,-637152889,'Libra'],
  [-637152889,-636975105,'Scorpio'],
  [-636975105,-636785157,'Sagittarius'],
  [-636785157,-636581041,'Capricorn'],
  [-636581041,-636365903,'Aquarius'],
  [-636365903,-636146272,'Pisces'],
  [-636146272,-635928204,'Aries'],
  [-635928204,-635715449,'Taurus'],
  [-635715449,-635510307,'Gemini'],
  [-635510307,-635314651,'Cancer'],
  [-635314651,-635129235,'Leo'],
  [-635129235,-634952430,'Virgo'],
  [-634952430,-634779755,'Libra'],
  [-634779755,-634604663,'Scorpio'],
  [-634604663,-634420159,'Sagittarius'],
  [-634420159,-634221341,'Capricorn'],
  [-634221341,-634008730,'Aquarius'],
  [-634008730,-633789188,'Pisces'],
  [-633789188,-633571463,'Aries'],
  [-633571463,-633360697,'Taurus'],
  [-633360697,-633157666,'Gemini'],
  [-633157666,-632961553,'Cancer'],
  [-632961553,-632772016,'Leo'],
  [-632772016,-632588952,'Virgo'],
  [-632588952,-632410811,'Libra'],
  [-632410811,-632233401,'Scorpio'],
  [-632233401,-632050500,'Sagittarius'],
  [-632050500,-631855992,'Capricorn'],
  [-631855992,-631647373,'Aquarius'],
  [-631647373,-631429075,'Pisces'],
  [-631429075,-631210839,'Aries'],
  [-631210839,-631000709,'Taurus'],
  [-631000709,-630800592,'Gemini'],
  [-630800592,-630608047,'Cancer'],
  [-630608047,-630419978,'Leo'],
  [-630419978,-630234675,'Virgo'],
  [-630234675,-630051450,'Libra'],
  [-630051450,-629868749,'Scorpio'],
  [-629868749,-629682923,'Sagittarius'],
  [-629682923,-629488964,'Capricorn'],
  [-629488964,-629283150,'Aquarius'],
  [-629283150,-629066808,'Pisces'],
  [-629066808,-628847835,'Aries'],
  [-628847835,-628636043,'Taurus'],
  [-628636043,-628436304,'Gemini'],
  [-628436304,-628247128,'Cancer'],
  [-628247128,-628063907,'Leo'],
  [-628063907,-627882156,'Virgo'],
  [-627882156,-627699037,'Libra'],
  [-627699037,-627513066,'Scorpio'],
  [-627513066,-627322775,'Sagittarius'],
  [-627322775,-627125857,'Capricorn'],
  [-627125857,-626919889,'Aquarius'],
  [-626919889,-626704814,'Pisces'],
  [-626704814,-626485524,'Aries'],
  [-626485524,-626270849,'Taurus'],
  [-626270849,-626068080,'Gemini'],
  [-626068080,-625878597,'Cancer'],
  [-625878597,-625698672,'Leo'],
  [-625698672,-625522520,'Virgo'],
  [-625522520,-625344615,'Libra'],
  [-625344615,-625160936,'Scorpio'],
  [-625160936,-624969346,'Sagittarius'],
  [-624969346,-624769243,'Capricorn'],
  [-624769243,-624560909,'Aquarius'],
  [-624560909,-624345496,'Pisces'],
  [-624345496,-624126256,'Aries'],
  [-624126256,-623909338,'Taurus'],
  [-623909338,-623701943,'Gemini'],
  [-623701943,-623508214,'Cancer'],
  [-623508214,-623327134,'Leo'],
  [-623327134,-623153788,'Virgo'],
  [-623153788,-622981579,'Libra'],
  [-622981579,-622804020,'Scorpio'],
  [-622804020,-622616239,'Sagittarius'],
  [-622616239,-622416432,'Capricorn'],
  [-622416432,-622206286,'Aquarius'],
  [-622206286,-621989529,'Pisces'],
  [-621989529,-621770255,'Aries'],
  [-621770255,-621552729,'Taurus'],
  [-621552729,-621341939,'Gemini'],
  [-621341939,-621142581,'Cancer'],
  [-621142581,-620956436,'Leo'],
  [-620956436,-620781144,'Virgo'],
  [-620781144,-620610989,'Libra'],
  [-620610989,-620438672,'Scorpio'],
  [-620438672,-620257125,'Sagittarius'],
  [-620257125,-620061735,'Capricorn'],
  [-620061735,-619852766,'Aquarius'],
  [-619852766,-619635323,'Pisces'],
  [-619635323,-619415839,'Aries'],
  [-619415839,-619198934,'Taurus'],
  [-619198934,-618987540,'Gemini'],
  [-618987540,-618784555,'Cancer'],
  [-618784555,-618592551,'Leo'],
  [-618592551,-618411827,'Virgo'],
  [-618411827,-618239074,'Libra'],
  [-618239074,-618067954,'Scorpio'],
  [-618067954,-617890863,'Sagittarius'],
  [-617890863,-617701165,'Capricorn'],
  [-617701165,-617496292,'Aquarius'],
  [-617496292,-617280092,'Pisces'],
  [-617280092,-617060603,'Aries'],
  [-617060603,-616844522,'Taurus'],
  [-616844522,-616634641,'Gemini'],
  [-616634641,-616431699,'Cancer'],
  [-616431699,-616236647,'Leo'],
  [-616236647,-616050474,'Virgo'],
  [-616050474,-615872294,'Libra'],
  [-615872294,-615698089,'Scorpio'],
  [-615698089,-615521397,'Sagittarius'],
  [-615521397,-615335235,'Capricorn'],
  [-615335235,-615134974,'Aquarius'],
  [-615134974,-614921712,'Pisces'],
  [-614921712,-614702802,'Aries'],
  [-614702802,-614486952,'Taurus'],
  [-614486952,-614278750,'Gemini'],
  [-614278750,-614078369,'Cancer'],
  [-614078369,-613884512,'Leo'],
  [-613884512,-613696459,'Virgo'],
  [-613696459,-613513720,'Libra'],
  [-613513720,-613334400,'Scorpio'],
  [-613334400,-613154364,'Sagittarius'],
  [-613154364,-612967991,'Capricorn'],
  [-612967991,-612770298,'Aquarius'],
  [-612770298,-612560100,'Pisces'],
  [-612560100,-612342309,'Aries'],
  [-612342309,-612125860,'Taurus'],
  [-612125860,-611917774,'Gemini'],
  [-611917774,-611719711,'Cancer'],
  [-611719711,-611529508,'Leo'],
  [-611529508,-611344089,'Virgo'],
  [-611344089,-611161022,'Libra'],
  [-611161022,-610978383,'Scorpio'],
  [-610978383,-610793841,'Sagittarius'],
  [-610793841,-610604182,'Capricorn'],
  [-610604182,-610405937,'Aquarius'],
  [-610405937,-610197304,'Pisces'],
  [-610197304,-609980667,'Aries'],
  [-609980667,-609763134,'Taurus'],
  [-609763134,-609553006,'Gemini'],
  [-609553006,-609354653,'Cancer'],
  [-609354653,-609167132,'Leo'],
  [-609167132,-608986339,'Virgo'],
  [-608986339,-608807409,'Libra'],
  [-608807409,-608626186,'Scorpio'],
  [-608626186,-608439792,'Sagittarius'],
  [-608439792,-608246529,'Capricorn'],
  [-608246529,-608045445,'Aquarius'],
  [-608045445,-607836217,'Pisces'],
  [-607836217,-607620168,'Aries'],
  [-607620168,-607401772,'Taurus'],
  [-607401772,-607188346,'Gemini'],
  [-607188346,-606986445,'Cancer'],
  [-606986445,-606797956,'Leo'],
  [-606797956,-606619834,'Virgo'],
  [-606619834,-606446173,'Libra'],
  [-606446173,-606270416,'Scorpio'],
  [-606270416,-606087143,'Sagittarius'],
  [-606087143,-605893557,'Capricorn'],
  [-605893557,-605690001,'Aquarius'],
  [-605690001,-605478748,'Pisces'],
  [-605478748,-605262368,'Aries'],
  [-605262368,-605043822,'Taurus'],
  [-605043822,-604827859,'Gemini'],
  [-604827859,-604620857,'Cancer'],
  [-604620857,-604427439,'Leo'],
  [-604427439,-604247422,'Virgo'],
  [-604247422,-604075920,'Libra'],
  [-604075920,-603905529,'Scorpio'],
  [-603905529,-603728600,'Sagittarius'],
  [-603728600,-603539487,'Capricorn'],
  [-603539487,-603336931,'Aquarius'],
  [-603336931,-603124374,'Pisces'],
  [-603124374,-602907003,'Aries'],
  [-602907003,-602688739,'Taurus'],
  [-602688739,-602472456,'Gemini'],
  [-602472456,-602262115,'Cancer'],
  [-602262115,-602062592,'Leo'],
  [-602062592,-601876590,'Virgo'],
  [-601876590,-601702085,'Libra'],
  [-601702085,-601532841,'Scorpio'],
  [-601532841,-601360753,'Sagittarius'],
  [-601360753,-601178163,'Capricorn'],
  [-601178163,-600980692,'Aquarius'],
  [-600980692,-600769856,'Pisces'],
  [-600769856,-600552043,'Aries'],
  [-600552043,-600333833,'Taurus'],
  [-600333833,-600118795,'Gemini'],
  [-600118795,-599908783,'Cancer'],
  [-599908783,-599706300,'Leo'],
  [-599706300,-599514228,'Virgo'],
  [-599514228,-599333222,'Libra'],
  [-599333222,-599159905,'Scorpio'],
  [-599159905,-598987705,'Sagittarius'],
  [-598987705,-598808959,'Capricorn'],
  [-598808959,-598617382,'Aquarius'],
  [-598617382,-598411182,'Pisces'],
  [-598411182,-598194845,'Aries'],
  [-598194845,-597976471,'Taurus'],
  [-597976471,-597762334,'Gemini'],
  [-597762334,-597554729,'Cancer'],
  [-597554729,-597353941,'Leo'],
  [-597353941,-597160351,'Virgo'],
  [-597160351,-596974353,'Libra'],
  [-596974353,-596794756,'Scorpio'],
  [-596794756,-596617824,'Sagittarius'],
  [-596617824,-596437874,'Capricorn'],
  [-596437874,-596248943,'Aquarius'],
  [-596248943,-596047269,'Pisces'],
  [-596047269,-595834026,'Aries'],
  [-595834026,-595615911,'Taurus'],
  [-595615911,-595401275,'Gemini'],
  [-595401275,-595195057,'Cancer'],
  [-595195057,-594997751,'Leo'],
  [-594997751,-594807475,'Virgo'],
  [-594807475,-594621981,'Libra'],
  [-594621981,-594439237,'Scorpio'],
  [-594439237,-594257023,'Sagittarius'],
  [-594257023,-594072382,'Capricorn'],
  [-594072382,-593881650,'Aquarius'],
  [-593881650,-593681474,'Pisces'],
  [-593681474,-593470911,'Aries'],
  [-593470911,-593253625,'Taurus'],
  [-593253625,-593037480,'Gemini'],
  [-593037480,-592830024,'Cancer'],
  [-592830024,-592634186,'Leo'],
  [-592634186,-592448076,'Virgo'],
  [-592448076,-592267264,'Libra'],
  [-592267264,-592087050,'Scorpio'],
  [-592087050,-591903816,'Sagittarius'],
  [-591903816,-591715426,'Capricorn'],
  [-591715426,-591520728,'Aquarius'],
  [-591520728,-591318730,'Pisces'],
  [-591318730,-591108755,'Aries'],
  [-591108755,-590892226,'Taurus'],
  [-590892226,-590674553,'Gemini'],
  [-590674553,-590463830,'Cancer'],
  [-590463830,-590265891,'Leo'],
  [-590265891,-590080963,'Virgo'],
  [-590080963,-589904468,'Libra'],
  [-589904468,-589729777,'Scorpio'],
  [-589729777,-589550681,'Sagittarius'],
  [-589550681,-589363181,'Capricorn'],
  [-589363181,-589166378,'Aquarius'],
  [-589166378,-588961545,'Pisces'],
  [-588961545,-588750194,'Aries'],
  [-588750194,-588533705,'Taurus'],
  [-588533705,-588315197,'Gemini'],
  [-588315197,-588101059,'Cancer'],
  [-588101059,-587898495,'Leo'],
  [-587898495,-587710659,'Virgo'],
  [-587710659,-587534767,'Libra'],
  [-587534767,-587364076,'Scorpio'],
  [-587364076,-587190805,'Sagittarius'],
  [-587190805,-587008444,'Capricorn'],
  [-587008444,-586813890,'Aquarius'],
  [-586813890,-586608322,'Pisces'],
  [-586608322,-586395333,'Aries'],
  [-586395333,-586178210,'Taurus'],
  [-586178210,-585959624,'Gemini'],
  [-585959624,-585743699,'Cancer'],
  [-585743699,-585536602,'Leo'],
  [-585536602,-585343295,'Virgo'],
  [-585343295,-585163782,'Libra'],
  [-585163782,-584992942,'Scorpio'],
  [-584992942,-584823084,'Sagittarius'],
  [-584823084,-584646426,'Capricorn'],
  [-584646426,-584457354,'Aquarius'],
  [-584457354,-584254659,'Pisces'],
  [-584254659,-584041775,'Aries'],
  [-584041775,-583824054,'Taurus'],
  [-583824054,-583605752,'Gemini'],
  [-583605752,-583390113,'Cancer'],
  [-583390113,-583181067,'Leo'],
  [-583181067,-582982909,'Virgo'],
  [-582982909,-582797543,'Libra'],
  [-582797543,-582622481,'Scorpio'],
  [-582622481,-582451705,'Sagittarius'],
  [-582451705,-582277790,'Capricorn'],
  [-582277790,-582093964,'Aquarius'],
  [-582093964,-581896407,'Pisces'],
  [-581896407,-581686179,'Aries'],
  [-581686179,-581468782,'Taurus'],
  [-581468782,-581250705,'Gemini'],
  [-581250705,-581036399,'Cancer'],
  [-581036399,-580828491,'Leo'],
  [-580828491,-580628975,'Virgo'],
  [-580628975,-580439149,'Libra'],
  [-580439149,-580258271,'Scorpio'],
  [-580258271,-580082863,'Sagittarius'],
  [-580082863,-579907393,'Capricorn'],
  [-579907393,-579725648,'Aquarius'],
  [-579725648,-579532541,'Pisces'],
  [-579532541,-579326381,'Aries'],
  [-579326381,-579110591,'Taurus'],
  [-579110591,-578892517,'Gemini'],
  [-578892517,-578679044,'Cancer'],
  [-578679044,-578473580,'Leo'],
  [-578473580,-578276420,'Virgo'],
  [-578276420,-578086449,'Libra'],
  [-578086449,-577902127,'Scorpio'],
  [-577902127,-577721377,'Sagittarius'],
  [-577721377,-577541180,'Capricorn'],
  [-577541180,-577357473,'Aquarius'],
  [-577357473,-577165784,'Pisces'],
  [-577165784,-576962902,'Aries'],
  [-576962902,-576749412,'Taurus'],
  [-576749412,-576531248,'Gemini'],
  [-576531248,-576317059,'Cancer'],
  [-576317059,-576112763,'Leo'],
  [-576112763,-575919029,'Virgo'],
  [-575919029,-575732801,'Libra'],
  [-575732801,-575550011,'Scorpio'],
  [-575550011,-575367367,'Sagittarius'],
  [-575367367,-575182785,'Capricorn'],
  [-575182785,-574994671,'Aquarius'],
  [-574994671,-574800882,'Pisces'],
  [-574800882,-574598760,'Aries'],
  [-574598760,-574387064,'Taurus'],
  [-574387064,-574168962,'Gemini'],
  [-574168962,-573952647,'Cancer'],
  [-573952647,-573746607,'Leo'],
  [-573746607,-573553955,'Virgo'],
  [-573553955,-573371749,'Libra'],
  [-573371749,-573194009,'Scorpio'],
  [-573194009,-573014801,'Sagittarius'],
  [-573014801,-572830252,'Capricorn'],
  [-572830252,-572639152,'Aquarius'],
  [-572639152,-572441699,'Pisces'],
  [-572441699,-572237650,'Aries'],
  [-572237650,-572026190,'Taurus'],
  [-572026190,-571808356,'Gemini'],
  [-571808356,-571589850,'Cancer'],
  [-571589850,-571379679,'Leo'],
  [-571379679,-571184029,'Virgo'],
  [-571184029,-571002281,'Libra'],
  [-571002281,-570828573,'Scorpio'],
  [-570828573,-570655330,'Sagittarius'],
  [-570655330,-570475969,'Capricorn'],
  [-570475969,-570286882,'Aquarius'],
  [-570286882,-570088059,'Pisces'],
  [-570088059,-569881399,'Aries'],
  [-569881399,-569668552,'Taurus'],
  [-569668552,-569450794,'Gemini'],
  [-569450794,-569231444,'Cancer'],
  [-569231444,-569017400,'Leo'],
  [-569017400,-568816034,'Virgo'],
  [-568816034,-568629972,'Libra'],
  [-568629972,-568455624,'Scorpio'],
  [-568455624,-568285804,'Sagittarius'],
  [-568285804,-568112679,'Capricorn'],
  [-568112679,-567929923,'Aquarius'],
  [-567929923,-567734641,'Pisces'],
  [-567734641,-567528004,'Aries'],
  [-567528004,-567313678,'Taurus'],
  [-567313678,-567095426,'Gemini'],
  [-567095426,-566876548,'Cancer'],
  [-566876548,-566661394,'Leo'],
  [-566661394,-566455506,'Virgo'],
  [-566455506,-566262894,'Libra'],
  [-566262894,-566083124,'Scorpio'],
  [-566083124,-565911394,'Sagittarius'],
  [-565911394,-565740669,'Capricorn'],
  [-565740669,-565563718,'Aquarius'],
  [-565563718,-565374953,'Pisces'],
  [-565374953,-565172408,'Aries'],
  [-565172408,-564958800,'Taurus'],
  [-564958800,-564740007,'Gemini'],
  [-564740007,-564521727,'Cancer'],
  [-564521727,-564307974,'Leo'],
  [-564307974,-564101648,'Virgo'],
  [-564101648,-563905014,'Libra'],
  [-563905014,-563718789,'Scorpio'],
  [-563718789,-563541072,'Sagittarius'],
  [-563541072,-563367403,'Capricorn'],
  [-563367403,-563191726,'Aquarius'],
  [-563191726,-563007753,'Pisces'],
  [-563007753,-562810874,'Aries'],
  [-562810874,-562600691,'Taurus'],
  [-562600691,-562382416,'Gemini'],
  [-562382416,-562164137,'Cancer'],
  [-562164137,-561952012,'Leo'],
  [-561952012,-561748264,'Virgo'],
  [-561748264,-561552512,'Libra'],
  [-561552512,-561363670,'Scorpio'],
  [-561363670,-561180477,'Sagittarius'],
  [-561180477,-561000994,'Capricorn'],
  [-561000994,-560821848,'Aquarius'],
  [-560821848,-560638160,'Pisces'],
  [-560638160,-560444720,'Aries'],
  [-560444720,-560238527,'Taurus'],
  [-560238527,-560022007,'Gemini'],
  [-560022007,-559803333,'Cancer'],
  [-559803333,-559591308,'Leo'],
  [-559591308,-559389903,'Virgo'],
  [-559389903,-559197798,'Libra'],
  [-559197798,-559011382,'Scorpio'],
  [-559011382,-558827431,'Sagittarius'],
  [-558827431,-558644046,'Capricorn'],
  [-558644046,-558459908,'Aquarius'],
  [-558459908,-558272766,'Pisces'],
  [-558272766,-558078920,'Aries'],
  [-558078920,-557874758,'Taurus'],
  [-557874758,-557660119,'Gemini'],
  [-557660119,-557441050,'Cancer'],
  [-557441050,-557227374,'Leo'],
  [-557227374,-557025799,'Virgo'],
  [-557025799,-556836317,'Libra'],
  [-556836317,-556654312,'Scorpio'],
  [-556654312,-556474216,'Sagittarius'],
  [-556474216,-556291950,'Capricorn'],
  [-556291950,-556105672,'Aquarius'],
  [-556105672,-555914719,'Pisces'],
  [-555914719,-555717872,'Aries'],
  [-555717872,-555513007,'Taurus'],
  [-555513007,-555299161,'Gemini'],
  [-555299161,-555079856,'Cancer'],
  [-555079856,-554863682,'Leo'],
  [-554863682,-554659187,'Virgo'],
  [-554659187,-554469001,'Libra'],
  [-554469001,-554289511,'Scorpio'],
  [-554289511,-554114253,'Sagittarius'],
  [-554114253,-553936962,'Capricorn'],
  [-553936962,-553753401,'Aquarius'],
  [-553753401,-553561917,'Pisces'],
  [-553561917,-553362501,'Aries'],
  [-553362501,-553155399,'Taurus'],
  [-553155399,-552940952,'Gemini'],
  [-552940952,-552721522,'Cancer'],
  [-552721522,-552503349,'Leo'],
  [-552503349,-552294652,'Virgo'],
  [-552294652,-552100434,'Libra'],
  [-552100434,-551919550,'Scorpio'],
  [-551919550,-551746440,'Sagittarius'],
  [-551746440,-551574114,'Capricorn'],
  [-551574114,-551396244,'Aquarius'],
  [-551396244,-551208608,'Pisces'],
  [-551208608,-551009871,'Aries'],
  [-551009871,-550801310,'Taurus'],
  [-550801310,-550585592,'Gemini'],
  [-550585592,-550366015,'Cancer'],
  [-550366015,-550147249,'Leo'],
  [-550147249,-549935404,'Virgo'],
  [-549935404,-549735848,'Libra'],
  [-549735848,-549550033,'Scorpio'],
  [-549550033,-549374790,'Sagittarius'],
  [-549374790,-549204099,'Capricorn'],
  [-549204099,-549031046,'Aquarius'],
  [-549031046,-548849349,'Pisces'],
  [-548849349,-548654972,'Aries'],
  [-548654972,-548447717,'Taurus'],
  [-548447717,-548231404,'Gemini'],
  [-548231404,-548011626,'Cancer'],
  [-548011626,-547793493,'Leo'],
  [-547793493,-547581157,'Virgo'],
  [-547581157,-547378090,'Libra'],
  [-547378090,-547186433,'Scorpio'],
  [-547186433,-547005629,'Sagittarius'],
  [-547005629,-546832106,'Capricorn'],
  [-546832106,-546660068,'Aquarius'],
  [-546660068,-546482745,'Pisces'],
  [-546482745,-546294022,'Aries'],
  [-546294022,-546090886,'Taurus'],
  [-546090886,-545875820,'Gemini'],
  [-545875820,-545655994,'Cancer'],
  [-545655994,-545438725,'Leo'],
  [-545438725,-545228086,'Virgo'],
  [-545228086,-545025278,'Libra'],
  [-545025278,-544830615,'Scorpio'],
  [-544830615,-544644145,'Sagittarius'],
  [-544644145,-544464794,'Capricorn'],
  [-544464794,-544289331,'Aquarius'],
  [-544289331,-544112299,'Pisces'],
  [-544112299,-543927196,'Aries'],
  [-543927196,-543728835,'Taurus'],
  [-543728835,-543516813,'Gemini'],
  [-543516813,-543297482,'Cancer'],
  [-543297482,-543080311,'Leo'],
  [-543080311,-542871438,'Virgo'],
  [-542871438,-542671549,'Libra'],
  [-542671549,-542478517,'Scorpio'],
  [-542478517,-542290389,'Sagittarius'],
  [-542290389,-542106278,'Capricorn'],
  [-542106278,-541925194,'Aquarius'],
  [-541925194,-541744339,'Pisces'],
  [-541744339,-541558783,'Aries'],
  [-541558783,-541363037,'Taurus'],
  [-541363037,-541154316,'Gemini'],
  [-541154316,-540936189,'Cancer'],
  [-540936189,-540718151,'Leo'],
  [-540718151,-540509039,'Virgo'],
  [-540509039,-540311429,'Libra'],
  [-540311429,-540122478,'Scorpio'],
  [-540122478,-539937751,'Sagittarius'],
  [-539937751,-539753993,'Capricorn'],
  [-539753993,-539569752,'Aquarius'],
  [-539569752,-539384036,'Pisces'],
  [-539384036,-539194616,'Aries'],
  [-539194616,-538997863,'Taurus'],
  [-538997863,-538790670,'Gemini'],
  [-538790670,-538573956,'Cancer'],
  [-538573956,-538354823,'Leo'],
  [-538354823,-538143093,'Virgo'],
  [-538143093,-537944417,'Libra'],
  [-537944417,-537757706,'Scorpio'],
  [-537757706,-537577873,'Sagittarius'],
  [-537577873,-537399248,'Capricorn'],
  [-537399248,-537217626,'Aquarius'],
  [-537217626,-537030813,'Pisces'],
  [-537030813,-536837803,'Aries'],
  [-536837803,-536637656,'Taurus'],
  [-536637656,-536429331,'Gemini'],
  [-536429331,-536213236,'Cancer'],
  [-536213236,-535993644,'Leo'],
  [-535993644,-535778595,'Virgo'],
  [-535778595,-535575537,'Libra'],
  [-535575537,-535386605,'Scorpio'],
  [-535386605,-535208437,'Sagittarius'],
  [-535208437,-535034919,'Capricorn'],
  [-535034919,-534859623,'Aquarius'],
  [-534859623,-534677377,'Pisces'],
  [-534677377,-534485295,'Aries'],
  [-534485295,-534283075,'Taurus'],
  [-534283075,-534072323,'Gemini'],
  [-534072323,-533855509,'Cancer'],
  [-533855509,-533636083,'Leo'],
  [-533636083,-533419248,'Virgo'],
  [-533419248,-533211315,'Libra'],
  [-533211315,-533016642,'Scorpio'],
  [-533016642,-532835078,'Sagittarius'],
  [-532835078,-532662294,'Capricorn'],
  [-532662294,-532491658,'Aquarius'],
  [-532491658,-532316073,'Pisces'],
  [-532316073,-532129665,'Aries'],
  [-532129665,-531929780,'Taurus'],
  [-531929780,-531718290,'Gemini'],
  [-531718290,-531500260,'Cancer'],
  [-531500260,-531280955,'Leo'],
  [-531280955,-531064432,'Virgo'],
  [-531064432,-530854311,'Libra'],
  [-530854311,-530654237,'Scorpio'],
  [-530654237,-530466280,'Sagittarius'],
  [-530466280,-530289210,'Capricorn'],
  [-530289210,-530118250,'Aquarius'],
  [-530118250,-529946372,'Pisces'],
  [-529946372,-529766124,'Aries'],
  [-529766124,-529571947,'Taurus'],
  [-529571947,-529363186,'Gemini'],
  [-529363186,-529145189,'Cancer'],
  [-529145189,-528925759,'Leo'],
  [-528925759,-528710383,'Virgo'],
  [-528710383,-528501263,'Libra'],
  [-528501263,-528299557,'Scorpio'],
  [-528299557,-528106690,'Sagittarius'],
  [-528106690,-527923351,'Capricorn'],
  [-527923351,-527747649,'Aquarius'],
  [-527747649,-527574491,'Pisces'],
  [-527574491,-527396803,'Aries'],
  [-527396803,-527207705,'Taurus'],
  [-527207705,-527003682,'Gemini'],
  [-527003682,-526787748,'Cancer'],
  [-526787748,-526568407,'Leo'],
  [-526568407,-526353649,'Virgo'],
  [-526353649,-526146663,'Libra'],
  [-526146663,-525947013,'Scorpio'],
  [-525947013,-525753747,'Sagittarius'],
  [-525753747,-525566709,'Capricorn'],
  [-525566709,-525385481,'Aquarius'],
  [-525385481,-525207572,'Pisces'],
  [-525207572,-525027952,'Aries'],
  [-525027952,-524840372,'Taurus'],
  [-524840372,-524640030,'Gemini'],
  [-524640030,-524427104,'Cancer'],
  [-524427104,-524208361,'Leo'],
  [-524208361,-523993180,'Virgo'],
  [-523993180,-523787176,'Libra'],
  [-523787176,-523590482,'Scorpio'],
  [-523590482,-523400462,'Sagittarius'],
  [-523400462,-523214564,'Capricorn'],
  [-523214564,-523031214,'Aquarius'],
  [-523031214,-522848901,'Pisces'],
  [-522848901,-522664916,'Aries'],
  [-522664916,-522475166,'Taurus'],
  [-522475166,-522275558,'Gemini'],
  [-522275558,-522064767,'Cancer'],
  [-522064767,-521846869,'Leo'],
  [-521846869,-521630441,'Virgo'],
  [-521630441,-521423201,'Libra'],
  [-521423201,-521227538,'Scorpio'],
  [-521227538,-521041072,'Sagittarius'],
  [-521041072,-520859528,'Capricorn'],
  [-520859528,-520678874,'Aquarius'],
  [-520678874,-520496105,'Pisces'],
  [-520496105,-520309006,'Aries'],
  [-520309006,-520115597,'Taurus'],
  [-520115597,-519914013,'Gemini'],
  [-519914013,-519703445,'Cancer'],
  [-519703445,-519486121,'Leo'],
  [-519486121,-519268298,'Virgo'],
  [-519268298,-519057977,'Libra'],
  [-519057977,-518860166,'Scorpio'],
  [-518860166,-518674534,'Sagittarius'],
  [-518674534,-518496868,'Capricorn'],
  [-518496868,-518321434,'Aquarius'],
  [-518321434,-518142737,'Pisces'],
  [-518142737,-517956725,'Aries'],
  [-517956725,-517761496,'Taurus'],
  [-517761496,-517557204,'Gemini'],
  [-517557204,-517345221,'Cancer'],
  [-517345221,-517127859,'Leo'],
  [-517127859,-516909222,'Virgo'],
  [-516909222,-516695556,'Libra'],
  [-516695556,-516493105,'Scorpio'],
  [-516493105,-516304412,'Sagittarius'],
  [-516304412,-516127155,'Capricorn'],
  [-516127155,-515955587,'Aquarius'],
  [-515955587,-515782627,'Pisces'],
  [-515782627,-515601730,'Aries'],
  [-515601730,-515408817,'Taurus'],
  [-515408817,-515203849,'Gemini'],
  [-515203849,-514990240,'Cancer'],
  [-514990240,-514772283,'Leo'],
  [-514772283,-514553653,'Virgo'],
  [-514553653,-514338256,'Libra'],
  [-514338256,-514131153,'Scorpio'],
  [-514131153,-513936681,'Sagittarius'],
  [-513936681,-513755485,'Capricorn'],
  [-513755485,-513583636,'Aquarius'],
  [-513583636,-513414140,'Pisces'],
  [-513414140,-513239083,'Aries'],
  [-513239083,-513051841,'Taurus'],
  [-513051841,-512849893,'Gemini'],
  [-512849893,-512636410,'Cancer'],
  [-512636410,-512417849,'Leo'],
  [-512417849,-512199618,'Virgo'],
  [-512199618,-511984729,'Libra'],
  [-511984729,-511775791,'Scorpio'],
  [-511775791,-511576251,'Sagittarius'],
  [-511576251,-511388666,'Capricorn'],
  [-511388666,-511212060,'Aquarius'],
  [-511212060,-511041344,'Pisces'],
  [-511041344,-510868989,'Aries'],
  [-510868989,-510687229,'Taurus'],
  [-510687229,-510490840,'Gemini'],
  [-510490840,-510280318,'Cancer'],
  [-510280318,-510062107,'Leo'],
  [-510062107,-509844043,'Virgo'],
  [-509844043,-509630653,'Libra'],
  [-509630653,-509423276,'Scorpio'],
  [-509423276,-509222785,'Sagittarius'],
  [-509222785,-509030720,'Capricorn'],
  [-509030720,-508847762,'Aquarius'],
  [-508847762,-508671672,'Pisces'],
  [-508671672,-508497096,'Aries'],
  [-508497096,-508317070,'Taurus'],
  [-508317070,-508125323,'Gemini'],
  [-508125323,-507919406,'Cancer'],
  [-507919406,-507703145,'Leo'],
  [-507703145,-507484949,'Virgo'],
  [-507484949,-507272107,'Libra'],
  [-507272107,-507067268,'Scorpio'],
  [-507067268,-506869807,'Sagittarius'],
  [-506869807,-506678509,'Capricorn'],
  [-506678509,-506492614,'Aquarius'],
  [-506492614,-506310977,'Pisces'],
  [-506310977,-506130888,'Aries'],
  [-506130888,-505947913,'Taurus'],
  [-505947913,-505756952,'Gemini'],
  [-505756952,-505554405,'Cancer'],
  [-505554405,-505340960,'Leo'],
  [-505340960,-505122850,'Virgo'],
  [-505122850,-504908778,'Libra'],
  [-504908778,-504704392,'Scorpio'],
  [-504704392,-504510196,'Sagittarius'],
  [-504510196,-504323397,'Capricorn'],
  [-504323397,-504140367,'Aquarius'],
  [-504140367,-503958000,'Pisces'],
  [-503958000,-503773914,'Aries'],
  [-503773914,-503585992,'Taurus'],
  [-503585992,-503391919,'Gemini'],
  [-503391919,-503189436,'Cancer'],
  [-503189436,-502977861,'Leo'],
  [-502977861,-502760295,'Virgo'],
  [-502760295,-502544066,'Libra'],
  [-502544066,-502337039,'Scorpio'],
  [-502337039,-502142766,'Sagittarius'],
  [-502142766,-501959419,'Capricorn'],
  [-501959419,-501781876,'Aquarius'],
  [-501781876,-501604256,'Pisces'],
  [-501604256,-501421774,'Aries'],
  [-501421774,-501231836,'Taurus'],
  [-501231836,-501034023,'Gemini'],
  [-501034023,-500828898,'Cancer'],
  [-500828898,-500617050,'Leo'],
  [-500617050,-500399989,'Virgo'],
  [-500399989,-500182173,'Libra'],
  [-500182173,-499971002,'Scorpio'],
  [-499971002,-499772751,'Sagittarius'],
  [-499772751,-499588507,'Capricorn'],
  [-499588507,-499413989,'Aquarius'],
  [-499413989,-499242102,'Pisces'],
  [-499242102,-499065575,'Aries'],
  [-499065575,-498879109,'Taurus'],
  [-498879109,-498681150,'Gemini'],
  [-498681150,-498473760,'Cancer'],
  [-498473760,-498260190,'Leo'],
  [-498260190,-498042976,'Virgo'],
  [-498042976,-497824809,'Libra'],
  [-497824809,-497610648,'Scorpio'],
  [-497610648,-497406997,'Sagittarius'],
  [-497406997,-497217795,'Capricorn'],
  [-497217795,-497041442,'Aquarius'],
  [-497041442,-496871698,'Pisces'],
  [-496871698,-496700495,'Aries'],
  [-496700495,-496520366,'Taurus'],
  [-496520366,-496326879,'Gemini'],
  [-496326879,-496120588,'Cancer'],
  [-496120588,-495906022,'Leo'],
  [-495906022,-495688172,'Virgo'],
  [-495688172,-495470398,'Libra'],
  [-495470398,-495255754,'Scorpio'],
  [-495255754,-495048696,'Sagittarius'],
  [-495048696,-494853691,'Capricorn'],
  [-494853691,-494671844,'Aquarius'],
  [-494671844,-494499395,'Pisces'],
  [-494499395,-494329316,'Aries'],
  [-494329316,-494153739,'Taurus'],
  [-494153739,-493966233,'Gemini'],
  [-493966233,-493764405,'Cancer'],
  [-493764405,-493551269,'Leo'],
  [-493551269,-493333202,'Virgo'],
  [-493333202,-493115833,'Libra'],
  [-493115833,-492902459,'Scorpio'],
  [-492902459,-492695495,'Sagittarius'],
  [-492695495,-492497538,'Capricorn'],
  [-492497538,-492310204,'Aquarius'],
  [-492310204,-492132150,'Pisces'],
  [-492132150,-491958745,'Aries'],
  [-491958745,-491783427,'Taurus'],
  [-491783427,-491599577,'Gemini'],
  [-491599577,-491402769,'Cancer'],
  [-491402769,-491193125,'Leo'],
  [-491193125,-490975937,'Virgo'],
  [-490975937,-490758639,'Libra'],
  [-490758639,-490546581,'Scorpio'],
  [-490546581,-490341963,'Sagittarius'],
  [-490341963,-490145167,'Capricorn'],
  [-490145167,-489955947,'Aquarius'],
  [-489955947,-489773246,'Pisces'],
  [-489773246,-489594519,'Aries'],
  [-489594519,-489415618,'Taurus'],
  [-489415618,-489231443,'Gemini'],
  [-489231443,-489037346,'Cancer'],
  [-489037346,-488831255,'Leo'],
  [-488831255,-488615822,'Virgo'],
  [-488615822,-488398256,'Libra'],
  [-488398256,-488186214,'Scorpio'],
  [-488186214,-487983642,'Sagittarius'],
  [-487983642,-487790272,'Capricorn'],
  [-487790272,-487603522,'Aquarius'],
  [-487603522,-487420386,'Pisces'],
  [-487420386,-487238221,'Aries'],
  [-487238221,-487054642,'Taurus'],
  [-487054642,-486867011,'Gemini'],
  [-486867011,-486672269,'Cancer'],
  [-486672269,-486467898,'Leo'],
  [-486467898,-486254165,'Virgo'],
  [-486254165,-486036184,'Libra'],
  [-486036184,-485822465,'Scorpio'],
  [-485822465,-485619610,'Sagittarius'],
  [-485619610,-485428729,'Capricorn'],
  [-485428729,-485246305,'Aquarius'],
  [-485246305,-485067006,'Pisces'],
  [-485067006,-484886052,'Aries'],
  [-484886052,-484700483,'Taurus'],
  [-484700483,-484509128,'Gemini'],
  [-484509128,-484311397,'Cancer'],
  [-484311397,-484106289,'Leo'],
  [-484106289,-483893286,'Virgo'],
  [-483893286,-483675000,'Libra'],
  [-483675000,-483458646,'Scorpio'],
  [-483458646,-483252667,'Sagittarius'],
  [-483252667,-483060951,'Capricorn'],
  [-483060951,-482881053,'Aquarius'],
  [-482881053,-482706678,'Pisces'],
  [-482706678,-482530826,'Aries'],
  [-482530826,-482348117,'Taurus'],
  [-482348117,-482156300,'Gemini'],
  [-482156300,-481955991,'Cancer'],
  [-481955991,-481748627,'Leo'],
  [-481748627,-481535049,'Virgo'],
  [-481535049,-481316681,'Libra'],
  [-481316681,-481098249,'Scorpio'],
  [-481098249,-480887735,'Sagittarius'],
  [-480887735,-480691530,'Capricorn'],
  [-480691530,-480509943,'Aquarius'],
  [-480509943,-480337657,'Pisces'],
  [-480337657,-480166932,'Aries'],
  [-480166932,-479990297,'Taurus'],
  [-479990297,-479802751,'Gemini'],
  [-479802751,-479603355,'Cancer'],
  [-479603355,-479394549,'Leo'],
  [-479394549,-479179636,'Virgo'],
  [-479179636,-478961194,'Libra'],
  [-478961194,-478742349,'Scorpio'],
  [-478742349,-478528679,'Sagittarius'],
  [-478528679,-478326676,'Capricorn'],
  [-478326676,-478139423,'Aquarius'],
  [-478139423,-477964338,'Pisces'],
  [-477964338,-477794842,'Aries'],
  [-477794842,-477623081,'Taurus'],
  [-477623081,-477442058,'Gemini'],
  [-477442058,-477247770,'Cancer'],
  [-477247770,-477040744,'Leo'],
  [-477040744,-476825262,'Virgo'],
  [-476825262,-476606505,'Libra'],
  [-476606505,-476388490,'Scorpio'],
  [-476388490,-476174836,'Sagittarius'],
  [-476174836,-475969643,'Capricorn'],
  [-475969643,-475776218,'Aquarius'],
  [-475776218,-475594675,'Pisces'],
  [-475594675,-475421245,'Aries'],
  [-475421245,-475249628,'Taurus'],
  [-475249628,-475072783,'Gemini'],
  [-475072783,-474884726,'Cancer'],
  [-474884726,-474682708,'Leo'],
  [-474682708,-474469001,'Virgo'],
  [-474469001,-474250080,'Libra'],
  [-474250080,-474032710,'Scorpio'],
  [-474032710,-473821097,'Sagittarius'],
  [-473821097,-473617106,'Capricorn'],
  [-473617106,-473421556,'Aquarius'],
  [-473421556,-473234494,'Pisces'],
  [-473234494,-473054484,'Aries'],
  [-473054484,-472878149,'Taurus'],
  [-472878149,-472700417,'Gemini'],
  [-472700417,-472515487,'Cancer'],
  [-472515487,-472318596,'Leo'],
  [-472318596,-472108690,'Virgo'],
  [-472108690,-471890569,'Libra'],
  [-471890569,-471672880,'Scorpio'],
  [-471672880,-471462586,'Sagittarius'],
  [-471462586,-471261821,'Capricorn'],
  [-471261821,-471069061,'Aquarius'],
  [-471069061,-470881759,'Pisces'],
  [-470881759,-470697835,'Aries'],
  [-470697835,-470515662,'Taurus'],
  [-470515662,-470333070,'Gemini'],
  [-470333070,-470146509,'Cancer'],
  [-470146509,-469951532,'Leo'],
  [-469951532,-469745029,'Virgo'],
  [-469745029,-469528632,'Libra'],
  [-469528632,-469310086,'Scorpio'],
  [-469310086,-469098827,'Sagittarius'],
  [-469098827,-468899572,'Capricorn'],
  [-468899572,-468710818,'Aquarius'],
  [-468710818,-468527811,'Pisces'],
  [-468527811,-468345812,'Aries'],
  [-468345812,-468161894,'Taurus'],
  [-468161894,-467974933,'Gemini'],
  [-467974933,-467784049,'Cancer'],
  [-467784049,-467587147,'Leo'],
  [-467587147,-467381484,'Virgo'],
  [-467381484,-467166561,'Libra'],
  [-467166561,-466947372,'Scorpio'],
  [-466947372,-466733418,'Sagittarius'],
  [-466733418,-466532267,'Capricorn'],
  [-466532267,-466344697,'Aquarius'],
  [-466344697,-466165905,'Pisces'],
  [-466165905,-465989254,'Aries'],
  [-465989254,-465809148,'Taurus'],
  [-465809148,-465622602,'Gemini'],
  [-465622602,-465429105,'Cancer'],
  [-465429105,-465228889,'Leo'],
  [-465228889,-465021529,'Virgo'],
  [-465021529,-464806770,'Libra'],
  [-464806770,-464587386,'Scorpio'],
  [-464587386,-464370743,'Sagittarius'],
  [-464370743,-464165338,'Capricorn'],
  [-464165338,-463974890,'Aquarius'],
  [-463974890,-463796598,'Pisces'],
  [-463796598,-463623892,'Aries'],
  [-463623892,-463449615,'Taurus'],
  [-463449615,-463268142,'Gemini'],
  [-463268142,-463076711,'Cancer'],
  [-463076711,-462875428,'Leo'],
  [-462875428,-462665941,'Virgo'],
  [-462665941,-462450161,'Libra'],
  [-462450161,-462230770,'Scorpio'],
  [-462230770,-462012860,'Sagittarius'],
  [-462012860,-461803427,'Capricorn'],
  [-461803427,-461607678,'Aquarius'],
  [-461607678,-461425654,'Pisces'],
  [-461425654,-461252655,'Aries'],
  [-461252655,-461081787,'Taurus'],
  [-461081787,-460906111,'Gemini'],
  [-460906111,-460720266,'Cancer'],
  [-460720266,-460521909,'Leo'],
  [-460521909,-460312363,'Virgo'],
  [-460312363,-460095579,'Libra'],
  [-460095579,-459876120,'Scorpio'],
  [-459876120,-459658525,'Sagittarius'],
  [-459658525,-459447479,'Capricorn'],
  [-459447479,-459247177,'Aquarius'],
  [-459247177,-459059349,'Pisces'],
  [-459059349,-458882003,'Aries'],
  [-458882003,-458710133,'Taurus'],
  [-458710133,-458537226,'Gemini'],
  [-458537226,-458356727,'Cancer'],
  [-458356727,-458163724,'Leo'],
  [-458163724,-457957074,'Virgo'],
  [-457957074,-457740608,'Libra'],
  [-457740608,-457521073,'Scorpio'],
  [-457521073,-457304489,'Sagittarius'],
  [-457304489,-457094494,'Capricorn'],
  [-457094494,-456892947,'Aquarius'],
  [-456892947,-456700792,'Pisces'],
  [-456700792,-456517645,'Aries'],
  [-456517645,-456341107,'Taurus'],
  [-456341107,-456166640,'Gemini'],
  [-456166640,-455988219,'Cancer'],
  [-455988219,-455799757,'Leo'],
  [-455799757,-455597519,'Virgo'],
  [-455597519,-455383085,'Libra'],
  [-455383085,-455163690,'Scorpio'],
  [-455163690,-454947707,'Sagittarius'],
  [-454947707,-454739794,'Capricorn'],
  [-454739794,-454540336,'Aquarius'],
  [-454540336,-454347934,'Pisces'],
  [-454347934,-454161331,'Aries'],
  [-454161331,-453979465,'Taurus'],
  [-453979465,-453800311,'Gemini'],
  [-453800311,-453619918,'Cancer'],
  [-453619918,-453432814,'Leo'],
  [-453432814,-453234007,'Virgo'],
  [-453234007,-453022401,'Libra'],
  [-453022401,-452803518,'Scorpio'],
  [-452803518,-452587060,'Sagittarius'],
  [-452587060,-452380123,'Capricorn'],
  [-452380123,-452183666,'Aquarius'],
  [-452183666,-451994585,'Pisces'],
  [-451994585,-451809217,'Aries'],
  [-451809217,-451625291,'Taurus'],
  [-451625291,-451441716,'Gemini'],
  [-451441716,-451256916,'Cancer'],
  [-451256916,-451067608,'Leo'],
  [-451067608,-450869483,'Virgo'],
  [-450869483,-450659952,'Libra'],
  [-450659952,-450441832,'Scorpio'],
  [-450441832,-450223953,'Sagittarius'],
  [-450223953,-450015578,'Capricorn'],
  [-450015578,-449820074,'Aquarius'],
  [-449820074,-449634632,'Pisces'],
  [-449634632,-449453861,'Aries'],
  [-449453861,-449272936,'Taurus'],
  [-449272936,-449089070,'Gemini'],
  [-449089070,-448901117,'Cancer'],
  [-448901117,-448707992,'Leo'],
  [-448707992,-448507721,'Virgo'],
  [-448507721,-448298364,'Libra'],
  [-448298364,-448080872,'Scorpio'],
  [-448080872,-447861523,'Sagittarius'],
  [-447861523,-447649675,'Capricorn'],
  [-447649675,-447451499,'Aquarius'],
  [-447451499,-447266526,'Pisces'],
  [-447266526,-447089631,'Aries'],
  [-447089631,-446914378,'Taurus'],
  [-446914378,-446735270,'Gemini'],
  [-446735270,-446548928,'Cancer'],
  [-446548928,-446354129,'Leo'],
  [-446354129,-446150937,'Virgo'],
  [-446150937,-445939892,'Libra'],
  [-445939892,-445722390,'Scorpio'],
  [-445722390,-445502458,'Sagittarius'],
  [-445502458,-445287207,'Capricorn'],
  [-445287207,-445083745,'Aquarius'],
  [-445083745,-444894743,'Pisces'],
  [-444894743,-444717430,'Aries'],
  [-444717430,-444545792,'Taurus'],
  [-444545792,-444372923,'Gemini'],
  [-444372923,-444192680,'Cancer'],
  [-444192680,-444001135,'Leo'],
  [-444001135,-443797670,'Virgo'],
  [-443797670,-443584806,'Libra'],
  [-443584806,-443366484,'Scorpio'],
  [-443366484,-443146829,'Sagittarius'],
  [-443146829,-442930421,'Capricorn'],
  [-442930421,-442722454,'Aquarius'],
  [-442722454,-442526968,'Pisces'],
  [-442526968,-442344417,'Aries'],
  [-442344417,-442171254,'Taurus'],
  [-442171254,-442001226,'Gemini'],
  [-442001226,-441827056,'Cancer'],
  [-441827056,-441642138,'Leo'],
  [-441642138,-441442821,'Virgo'],
  [-441442821,-441230616,'Libra'],
  [-441230616,-441011533,'Scorpio'],
  [-441011533,-440792163,'Sagittarius'],
  [-440792163,-440576816,'Capricorn'],
  [-440576816,-440368026,'Aquarius'],
  [-440368026,-440168104,'Pisces'],
  [-440168104,-439978789,'Aries'],
  [-439978789,-439799641,'Taurus'],
  [-439799641,-439627001,'Gemini'],
  [-439627001,-439454526,'Cancer'],
  [-439454526,-439274807,'Leo'],
  [-439274807,-439081647,'Virgo'],
  [-439081647,-438873381,'Libra'],
  [-438873381,-438655092,'Scorpio'],
  [-438655092,-438435653,'Sagittarius'],
  [-438435653,-438221642,'Capricorn'],
  [-438221642,-438015018,'Aquarius'],
  [-438015018,-437815455,'Pisces'],
  [-437815455,-437622896,'Aries'],
  [-437622896,-437437710,'Taurus'],
  [-437437710,-437259009,'Gemini'],
  [-437259009,-437083109,'Cancer'],
  [-437083109,-436903878,'Leo'],
  [-436903878,-436714611,'Virgo'],
  [-436714611,-436511132,'Libra'],
  [-436511132,-436295462,'Scorpio'],
  [-436295462,-436076099,'Sagittarius'],
  [-436076099,-435862176,'Capricorn'],
  [-435862176,-435657628,'Aquarius'],
  [-435657628,-435461370,'Pisces'],
  [-435461370,-435270805,'Aries'],
  [-435270805,-435084264,'Taurus'],
  [-435084264,-434901032,'Gemini'],
  [-434901032,-434719679,'Cancer'],
  [-434719679,-434536715,'Leo'],
  [-434536715,-434347022,'Virgo'],
  [-434347022,-434146032,'Libra'],
  [-434146032,-433933190,'Scorpio'],
  [-433933190,-433714389,'Sagittarius'],
  [-433714389,-433499259,'Capricorn'],
  [-433499259,-433294489,'Aquarius'],
  [-433294489,-433100638,'Pisces'],
  [-433100638,-432914294,'Aries'],
  [-432914294,-432731348,'Taurus'],
  [-432731348,-432548801,'Gemini'],
  [-432548801,-432364774,'Cancer'],
  [-432364774,-432177459,'Leo'],
  [-432177459,-431984309,'Virgo'],
  [-431984309,-431782479,'Libra'],
  [-431782479,-431570874,'Scorpio'],
  [-431570874,-431352767,'Sagittarius'],
  [-431352767,-431135968,'Capricorn'],
  [-431135968,-430928572,'Aquarius'],
  [-430928572,-430733921,'Pisces'],
  [-430733921,-430549964,'Aries'],
  [-430549964,-430371792,'Taurus'],
  [-430371792,-430194081,'Gemini'],
  [-430194081,-430012504,'Cancer'],
  [-430012504,-429824286,'Leo'],
  [-429824286,-429628089,'Virgo'],
  [-429628089,-429423562,'Libra'],
  [-429423562,-429211200,'Scorpio'],
  [-429211200,-428993368,'Sagittarius'],
  [-428993368,-428775354,'Capricorn'],
  [-428775354,-428564373,'Aquarius'],
  [-428564373,-428365862,'Pisces'],
  [-428365862,-428180450,'Aries'],
  [-428180450,-428004389,'Taurus'],
  [-428004389,-427831602,'Gemini'],
  [-427831602,-427655611,'Cancer'],
  [-427655611,-427471106,'Leo'],
  [-427471106,-427275388,'Virgo'],
  [-427275388,-427069070,'Libra'],
  [-427069070,-426855052,'Scorpio'],
  [-426855052,-426636905,'Sagittarius'],
  [-426636905,-426418583,'Capricorn'],
  [-426418583,-426205026,'Aquarius'],
  [-426205026,-426001619,'Pisces'],
  [-426001619,-425811432,'Aries'],
  [-425811432,-425633277,'Taurus'],
  [-425633277,-425462113,'Gemini'],
  [-425462113,-425290830,'Cancer'],
  [-425290830,-425112160,'Leo'],
  [-425112160,-424920798,'Virgo'],
  [-424920798,-424715785,'Libra'],
  [-424715785,-424501001,'Scorpio'],
  [-424501001,-424282301,'Sagittarius'],
  [-424282301,-424064357,'Capricorn'],
  [-424064357,-423850406,'Aquarius'],
  [-423850406,-423643841,'Pisces'],
  [-423643841,-423448136,'Aries'],
  [-423448136,-423264625,'Taurus'],
  [-423264625,-423090736,'Gemini'],
  [-423090736,-422920406,'Cancer'],
  [-422920406,-422745941,'Leo'],
  [-422745941,-422560192,'Virgo'],
  [-422560192,-422359477,'Libra'],
  [-422359477,-422146157,'Scorpio'],
  [-422146157,-421927335,'Sagittarius'],
  [-421927335,-421709861,'Capricorn'],
  [-421709861,-421497215,'Aquarius'],
  [-421497215,-421290795,'Pisces'],
  [-421290795,-421092208,'Aries'],
  [-421092208,-420903232,'Taurus'],
  [-420903232,-420723717,'Gemini'],
  [-420723717,-420550044,'Cancer'],
  [-420550044,-420375767,'Leo'],
  [-420375767,-420193524,'Virgo'],
  [-420193524,-419997712,'Libra'],
  [-419997712,-419787858,'Scorpio'],
  [-419787858,-419569922,'Sagittarius'],
  [-419569922,-419352515,'Capricorn'],
  [-419352515,-419141218,'Aquarius'],
  [-419141218,-418937245,'Pisces'],
  [-418937245,-418739974,'Aries'],
  [-418739974,-418549188,'Taurus'],
  [-418549188,-418364910,'Gemini'],
  [-418364910,-418185689,'Cancer'],
  [-418185689,-418007586,'Leo'],
  [-418007586,-417824816,'Virgo'],
  [-417824816,-417631668,'Libra'],
  [-417631668,-417425477,'Scorpio'],
  [-417425477,-417209387,'Sagittarius'],
  [-417209387,-416991605,'Capricorn'],
  [-416991605,-416780114,'Aquarius'],
  [-416780114,-416578126,'Pisces'],
  [-416578126,-416384526,'Aries'],
  [-416384526,-416196680,'Taurus'],
  [-416196680,-416012318,'Gemini'],
  [-416012318,-415829658,'Cancer'],
  [-415829658,-415646540,'Leo'],
  [-415646540,-415459802,'Virgo'],
  [-415459802,-415265634,'Libra'],
  [-415265634,-415061168,'Scorpio'],
  [-415061168,-414847013,'Sagittarius'],
  [-414847013,-414628850,'Capricorn'],
  [-414628850,-414415259,'Aquarius'],
  [-414415259,-414212394,'Pisces'],
  [-414212394,-414021022,'Aries'],
  [-414021022,-413837868,'Taurus'],
  [-413837868,-413658177,'Gemini'],
  [-413658177,-413477551,'Cancer'],
  [-413477551,-413292829,'Leo'],
  [-413292829,-413102138,'Virgo'],
  [-413102138,-412904375,'Libra'],
  [-412904375,-412698752,'Scorpio'],
  [-412698752,-412485413,'Sagittarius'],
  [-412485413,-412267262,'Capricorn'],
  [-412267262,-412050917,'Aquarius'],
  [-412050917,-411844107,'Pisces'],
  [-411844107,-411650855,'Aries'],
  [-411650855,-411469651,'Taurus'],
  [-411469651,-411295120,'Gemini'],
  [-411295120,-411120539,'Cancer'],
  [-411120539,-410939914,'Leo'],
  [-410939914,-410749651,'Virgo'],
  [-410749651,-410549402,'Libra'],
  [-410549402,-410341069,'Scorpio'],
  [-410341069,-410126855,'Sagittarius'],
  [-410126855,-409908895,'Capricorn'],
  [-409908895,-409690972,'Aquarius'],
  [-409690972,-409479523,'Pisces'],
  [-409479523,-409280775,'Aries'],
  [-409280775,-409096544,'Taurus'],
  [-409096544,-408923139,'Gemini'],
  [-408923139,-408753431,'Cancer'],
  [-408753431,-408579487,'Leo'],
  [-408579487,-408394796,'Virgo'],
  [-408394796,-408196686,'Libra'],
  [-408196686,-407987352,'Scorpio'],
  [-407987352,-407771584,'Sagittarius'],
  [-407771584,-407553426,'Capricorn'],
  [-407553426,-407335626,'Aquarius'],
  [-407335626,-407121885,'Pisces'],
  [-407121885,-406917606,'Aries'],
  [-406917606,-406726957,'Taurus'],
  [-406726957,-406549445,'Gemini'],
  [-406549445,-406379663,'Cancer'],
  [-406379663,-406209677,'Leo'],
  [-406209677,-406031471,'Virgo'],
  [-406031471,-405839433,'Libra'],
  [-405839433,-405633082,'Scorpio'],
  [-405633082,-405417307,'Sagittarius'],
  [-405417307,-405198686,'Capricorn'],
  [-405198686,-404981638,'Aquarius'],
  [-404981638,-404768609,'Pisces'],
  [-404768609,-404562404,'Aries'],
  [-404562404,-404366457,'Taurus'],
  [-404366457,-404182371,'Gemini'],
  [-404182371,-404007708,'Cancer'],
  [-404007708,-403836446,'Leo'],
  [-403836446,-403661032,'Virgo'],
  [-403661032,-403474614,'Libra'],
  [-403474614,-403273744,'Scorpio'],
  [-403273744,-403060642,'Sagittarius'],
  [-403060642,-402842227,'Capricorn'],
  [-402842227,-402625508,'Aquarius'],
  [-402625508,-402414267,'Pisces'],
  [-402414267,-402209861,'Aries'],
  [-402209861,-402013175,'Taurus'],
  [-402013175,-401824910,'Gemini'],
  [-401824910,-401644240,'Cancer'],
  [-401644240,-401467843,'Leo'],
  [-401467843,-401290325,'Virgo'],
  [-401290325,-401105625,'Libra'],
  [-401105625,-400909071,'Scorpio'],
  [-400909071,-400699910,'Sagittarius'],
  [-400699910,-400482838,'Capricorn'],
  [-400482838,-400265870,'Aquarius'],
  [-400265870,-400055398,'Pisces'],
  [-400055398,-399853714,'Aries'],
  [-399853714,-399660069,'Taurus'],
  [-399660069,-399472623,'Gemini'],
  [-399472623,-399289386,'Cancer'],
  [-399289386,-399108086,'Leo'],
  [-399108086,-398925757,'Virgo'],
  [-398925757,-398738661,'Libra'],
  [-398738661,-398542992,'Scorpio'],
  [-398542992,-398336601,'Sagittarius'],
  [-398336601,-398121327,'Capricorn'],
  [-398121327,-397903829,'Aquarius'],
  [-397903829,-397692297,'Pisces'],
  [-397692297,-397491519,'Aries'],
  [-397491519,-397301260,'Taurus'],
  [-397301260,-397117951,'Gemini'],
  [-397117951,-396937114,'Cancer'],
  [-396937114,-396754998,'Leo'],
  [-396754998,-396569149,'Virgo'],
  [-396569149,-396378018,'Libra'],
  [-396378018,-396180134,'Scorpio'],
  [-396180134,-395974048,'Sagittarius'],
  [-395974048,-395759944,'Capricorn'],
  [-395759944,-395541944,'Aquarius'],
  [-395541944,-395327968,'Pisces'],
  [-395327968,-395125229,'Aries'],
  [-395125229,-394935737,'Taurus'],
  [-394935737,-394756109,'Gemini'],
  [-394756109,-394580212,'Cancer'],
  [-394580212,-394401888,'Leo'],
  [-394401888,-394216861,'Virgo'],
  [-394216861,-394023640,'Libra'],
  [-394023640,-393822752,'Scorpio'],
  [-393822752,-393614966,'Sagittarius'],
  [-393614966,-393400835,'Capricorn'],
  [-393400835,-393182561,'Aquarius'],
  [-393182561,-392966047,'Pisces'],
  [-392966047,-392759240,'Aries'],
  [-392759240,-392566901,'Taurus'],
  [-392566901,-392387614,'Gemini'],
  [-392387614,-392215318,'Cancer'],
  [-392215318,-392042414,'Leo'],
  [-392042414,-391862248,'Virgo'],
  [-391862248,-391671177,'Libra'],
  [-391671177,-391469471,'Scorpio'],
  [-391469471,-391259775,'Sagittarius'],
  [-391259775,-391044684,'Capricorn'],
  [-391044684,-390826350,'Aquarius'],
  [-390826350,-390608549,'Pisces'],
  [-390608549,-390397760,'Aries'],
  [-390397760,-390200149,'Taurus'],
  [-390200149,-390017140,'Gemini'],
  [-390017140,-389844492,'Cancer'],
  [-389844492,-389674803,'Leo'],
  [-389674803,-389500213,'Virgo'],
  [-389500213,-389314634,'Libra'],
  [-389314634,-389115908,'Scorpio'],
  [-389115908,-388906283,'Sagittarius'],
  [-388906283,-388690276,'Capricorn'],
  [-388690276,-388471908,'Aquarius'],
  [-388471908,-388254442,'Pisces'],
  [-388254442,-388042062,'Aries'],
  [-388042062,-387839812,'Taurus'],
  [-387839812,-387650792,'Gemini'],
  [-387650792,-387473575,'Cancer'],
  [-387473575,-387302663,'Leo'],
  [-387302663,-387130687,'Virgo'],
  [-387130687,-386950492,'Libra'],
  [-386950492,-386757302,'Scorpio'],
  [-386757302,-386550764,'Sagittarius'],
  [-386550764,-386335137,'Capricorn'],
  [-386335137,-386116651,'Aquarius'],
  [-386116651,-385900244,'Pisces'],
  [-385900244,-385689125,'Aries'],
  [-385689125,-385485842,'Taurus'],
  [-385485842,-385292410,'Gemini'],
  [-385292410,-385108984,'Cancer'],
  [-385108984,-384932827,'Leo'],
  [-384932827,-384758758,'Virgo'],
  [-384758758,-384580434,'Libra'],
  [-384580434,-384392004,'Scorpio'],
  [-384392004,-384190286,'Sagittarius'],
  [-384190286,-383976947,'Capricorn'],
  [-383976947,-383758498,'Aquarius'],
  [-383758498,-383542497,'Pisces'],
  [-383542497,-383333583,'Aries'],
  [-383333583,-383132919,'Taurus'],
  [-383132919,-382939823,'Gemini'],
  [-382939823,-382753126,'Cancer'],
  [-382753126,-382571251,'Leo'],
  [-382571251,-382391687,'Virgo'],
  [-382391687,-382210612,'Libra'],
  [-382210612,-382023225,'Scorpio'],
  [-382023225,-381825164,'Sagittarius'],
  [-381825164,-381615100,'Capricorn'],
  [-381615100,-381397274,'Aquarius'],
  [-381397274,-381180381,'Pisces'],
  [-381180381,-380972002,'Aries'],
  [-380972002,-380774449,'Taurus'],
  [-380774449,-380585433,'Gemini'],
  [-380585433,-380400999,'Cancer'],
  [-380400999,-380217787,'Leo'],
  [-380217787,-380033778,'Virgo'],
  [-380033778,-379847601,'Libra'],
  [-379847601,-379657186,'Scorpio'],
  [-379657186,-379459373,'Sagittarius'],
  [-379459373,-379251526,'Capricorn'],
  [-379251526,-379034827,'Aquarius'],
  [-379034827,-378816378,'Pisces'],
  [-378816378,-378605779,'Aries'],
  [-378605779,-378408386,'Taurus'],
  [-378408386,-378222825,'Gemini'],
  [-378222825,-378043616,'Cancer'],
  [-378043616,-377864677,'Leo'],
  [-377864677,-377681676,'Virgo'],
  [-377681676,-377492942,'Libra'],
  [-377492942,-377298453,'Scorpio'],
  [-377298453,-377097820,'Sagittarius'],
  [-377097820,-376889691,'Capricorn'],
  [-376889691,-376673786,'Aquarius'],
  [-376673786,-376454262,'Pisces'],
  [-376454262,-376239970,'Aries'],
  [-376239970,-376038916,'Taurus'],
  [-376038916,-375852667,'Gemini'],
  [-375852667,-375676578,'Cancer'],
  [-375676578,-375503375,'Leo'],
  [-375503375,-375326201,'Virgo'],
  [-375326201,-375140636,'Libra'],
  [-375140636,-374945611,'Scorpio'],
  [-374945611,-374742292,'Sagittarius'],
  [-374742292,-374532038,'Capricorn'],
  [-374532038,-374315804,'Aquarius'],
  [-374315804,-374096091,'Pisces'],
  [-374096091,-373879087,'Aries'],
  [-373879087,-373672782,'Taurus'],
  [-373672782,-373481633,'Gemini'],
  [-373481633,-373303754,'Cancer'],
  [-373303754,-373132828,'Leo'],
  [-373132828,-372961229,'Virgo'],
  [-372961229,-372782239,'Libra'],
  [-372782239,-372591791,'Scorpio'],
  [-372591791,-372389477,'Sagittarius'],
  [-372389477,-372177864,'Capricorn'],
  [-372177864,-371960535,'Aquarius'],
  [-371960535,-371740975,'Pisces'],
  [-371740975,-371523517,'Aries'],
  [-371523517,-371313813,'Taurus'],
  [-371313813,-371116715,'Gemini'],
  [-371116715,-370933132,'Cancer'],
  [-370933132,-370759392,'Leo'],
  [-370759392,-370589060,'Virgo'],
  [-370589060,-370414993,'Libra'],
  [-370414993,-370230999,'Scorpio'],
  [-370230999,-370033607,'Sagittarius'],
  [-370033607,-369823632,'Capricorn'],
  [-369823632,-369605881,'Aquarius'],
  [-369605881,-369386345,'Pisces'],
  [-369386345,-369169920,'Aries'],
  [-369169920,-368960204,'Taurus'],
  [-368960204,-368759967,'Gemini'],
  [-368759967,-368570583,'Cancer'],
  [-368570583,-368390895,'Leo'],
  [-368390895,-368217069,'Virgo'],
  [-368217069,-368043370,'Libra'],
  [-368043370,-367863372,'Scorpio'],
  [-367863372,-367671571,'Sagittarius'],
  [-367671571,-367465790,'Capricorn'],
  [-367465790,-367249352,'Aquarius'],
  [-367249352,-367029838,'Pisces'],
  [-367029838,-366814436,'Aries'],
  [-366814436,-366606799,'Taurus'],
  [-366606799,-366407493,'Gemini'],
  [-366407493,-366215950,'Cancer'],
  [-366215950,-366031270,'Leo'],
  [-366031270,-365851793,'Virgo'],
  [-365851793,-365674343,'Libra'],
  [-365674343,-365494026,'Scorpio'],
  [-365494026,-365305176,'Sagittarius'],
  [-365305176,-365103581,'Capricorn'],
  [-365103581,-364889759,'Aquarius'],
  [-364889759,-364670535,'Pisces'],
  [-364670535,-364455176,'Aries'],
  [-364455176,-364249306,'Taurus'],
  [-364249306,-364053077,'Gemini'],
  [-364053077,-363863684,'Cancer'],
  [-363863684,-363678266,'Leo'],
  [-363678266,-363495045,'Virgo'],
  [-363495045,-363312660,'Libra'],
  [-363312660,-363128689,'Scorpio'],
  [-363128689,-362939067,'Sagittarius'],
  [-362939067,-362739379,'Capricorn'],
  [-362739379,-362527984,'Aquarius'],
  [-362527984,-362309302,'Pisces'],
  [-362309302,-362092849,'Aries'],
  [-362092849,-361886723,'Taurus'],
  [-361886723,-361692665,'Gemini'],
  [-361692665,-361507182,'Cancer'],
  [-361507182,-361325224,'Leo'],
  [-361325224,-361142886,'Virgo'],
  [-361142886,-360958241,'Libra'],
  [-360958241,-360770317,'Scorpio'],
  [-360770317,-360577424,'Sagittarius'],
  [-360577424,-360376780,'Capricorn'],
  [-360376780,-360166333,'Aquarius'],
  [-360166333,-359948169,'Pisces'],
  [-359948169,-359730055,'Aries'],
  [-359730055,-359521352,'Taurus'],
  [-359521352,-359326472,'Gemini'],
  [-359326472,-359143204,'Cancer'],
  [-359143204,-358965769,'Leo'],
  [-358965769,-358788127,'Virgo'],
  [-358788127,-358605975,'Libra'],
  [-358605975,-358417321,'Scorpio'],
  [-358417321,-358221584,'Sagittarius'],
  [-358221584,-358018317,'Capricorn'],
  [-358018317,-357807049,'Aquarius'],
  [-357807049,-357589059,'Pisces'],
  [-357589059,-357369679,'Aries'],
  [-357369679,-357157309,'Taurus'],
  [-357157309,-356958424,'Gemini'],
  [-356958424,-356773531,'Cancer'],
  [-356773531,-356598027,'Leo'],
  [-356598027,-356425245,'Virgo'],
  [-356425245,-356248783,'Libra'],
  [-356248783,-356064013,'Scorpio'],
  [-356064013,-355868908,'Sagittarius'],
  [-355868908,-355663892,'Capricorn'],
  [-355663892,-355450897,'Aquarius'],
  [-355450897,-355232573,'Pisces'],
  [-355232573,-355012958,'Aries'],
  [-355012958,-354798018,'Taurus'],
  [-354798018,-354593960,'Gemini'],
  [-354593960,-354403806,'Cancer'],
  [-354403806,-354225711,'Leo'],
  [-354225711,-354054278,'Virgo'],
  [-354054278,-353882641,'Libra'],
  [-353882641,-353704117,'Scorpio'],
  [-353704117,-353513815,'Sagittarius'],
  [-353513815,-353310364,'Capricorn'],
  [-353310364,-353096550,'Aquarius'],
  [-353096550,-352877562,'Pisces'],
  [-352877562,-352658465,'Aries'],
  [-352658465,-352443466,'Taurus'],
  [-352443466,-352236378,'Gemini'],
  [-352236378,-352040316,'Cancer'],
  [-352040316,-351856048,'Leo'],
  [-351856048,-351681039,'Virgo'],
  [-351681039,-351509901,'Libra'],
  [-351509901,-351335693,'Scorpio'],
  [-351335693,-351151554,'Sagittarius'],
  [-351151554,-350953065,'Capricorn'],
  [-350953065,-350741045,'Aquarius'],
  [-350741045,-350521819,'Pisces'],
  [-350521819,-350303102,'Aries'],
  [-350303102,-350089756,'Taurus'],
  [-350089756,-349883489,'Gemini'],
  [-349883489,-349685015,'Cancer'],
  [-349685015,-349495082,'Leo'],
  [-349495082,-349313575,'Virgo'],
  [-349313575,-349138050,'Libra'],
  [-349138050,-348963316,'Scorpio'],
  [-348963316,-348782529,'Sagittarius'],
  [-348782529,-348589381,'Capricorn'],
  [-348589381,-348381502,'Aquarius'],
  [-348381502,-348163419,'Pisces'],
  [-348163419,-347944502,'Aries'],
  [-347944502,-347732306,'Taurus'],
  [-347732306,-347528876,'Gemini'],
  [-347528876,-347332685,'Cancer'],
  [-347332685,-347141960,'Leo'],
  [-347141960,-346956058,'Virgo'],
  [-346956058,-346774486,'Libra'],
  [-346774486,-346594954,'Scorpio'],
  [-346594954,-346412683,'Sagittarius'],
  [-346412683,-346221687,'Capricorn'],
  [-346221687,-346017684,'Aquarius'],
  [-346017684,-345801982,'Pisces'],
  [-345801982,-345582740,'Aries'],
  [-345582740,-345369781,'Taurus'],
  [-345369781,-345167776,'Gemini'],
  [-345167776,-344975349,'Cancer'],
  [-344975349,-344788557,'Leo'],
  [-344788557,-344604049,'Virgo'],
  [-344604049,-344420130,'Libra'],
  [-344420130,-344235769,'Scorpio'],
  [-344235769,-344048887,'Sagittarius'],
  [-344048887,-343855848,'Capricorn'],
  [-343855848,-343652882,'Aquarius'],
  [-343652882,-343439239,'Pisces'],
  [-343439239,-343220077,'Aries'],
  [-343220077,-343004892,'Taurus'],
  [-343004892,-342801127,'Gemini'],
  [-342801127,-342609868,'Cancer'],
  [-342609868,-342427291,'Leo'],
  [-342427291,-342248061,'Virgo'],
  [-342248061,-342067663,'Libra'],
  [-342067663,-341883249,'Scorpio'],
  [-341883249,-341693238,'Sagittarius'],
  [-341693238,-341496392,'Capricorn'],
  [-341496392,-341291435,'Aquarius'],
  [-341291435,-341078076,'Pisces'],
  [-341078076,-340859231,'Aries'],
  [-340859231,-340641887,'Taurus'],
  [-340641887,-340434097,'Gemini'],
  [-340434097,-340239961,'Cancer'],
  [-340239961,-340057932,'Leo'],
  [-340057932,-339882846,'Virgo'],
  [-339882846,-339708445,'Libra'],
  [-339708445,-339529102,'Scorpio'],
  [-339529102,-339340985,'Sagittarius'],
  [-339340985,-339142713,'Capricorn'],
  [-339142713,-338935152,'Aquarius'],
  [-338935152,-338720427,'Pisces'],
  [-338720427,-338501594,'Aries'],
  [-338501594,-338283289,'Taurus'],
  [-338283289,-338071710,'Gemini'],
  [-338071710,-337872262,'Cancer'],
  [-337872262,-337686413,'Leo'],
  [-337686413,-337511122,'Virgo'],
  [-337511122,-337340367,'Libra'],
  [-337340367,-337167061,'Scorpio'],
  [-337167061,-336984759,'Sagittarius'],
  [-336984759,-336789568,'Capricorn'],
  [-336789568,-336581864,'Aquarius'],
  [-336581864,-336365800,'Pisces'],
  [-336365800,-336146556,'Aries'],
  [-336146556,-335928455,'Taurus'],
  [-335928455,-335715336,'Gemini'],
  [-335715336,-335511352,'Cancer'],
  [-335511352,-335319570,'Leo'],
  [-335319570,-335139834,'Virgo'],
  [-335139834,-334968121,'Libra'],
  [-334968121,-334797693,'Scorpio'],
  [-334797693,-334620943,'Sagittarius'],
  [-334620943,-334431516,'Capricorn'],
  [-334431516,-334227169,'Aquarius'],
  [-334227169,-334011602,'Pisces'],
  [-334011602,-333792054,'Aries'],
  [-333792054,-333574585,'Taurus'],
  [-333574585,-333362264,'Gemini'],
  [-333362264,-333156938,'Cancer'],
  [-333156938,-332960733,'Leo'],
  [-332960733,-332775053,'Virgo'],
  [-332775053,-332598571,'Libra'],
  [-332598571,-332426499,'Scorpio'],
  [-332426499,-332251772,'Sagittarius'],
  [-332251772,-332067088,'Capricorn'],
  [-332067088,-331867747,'Aquarius'],
  [-331867747,-331654921,'Pisces'],
  [-331654921,-331435829,'Aries'],
  [-331435829,-331218741,'Taurus'],
  [-331218741,-331008057,'Gemini'],
  [-331008057,-330804466,'Cancer'],
  [-330804466,-330607802,'Leo'],
  [-330607802,-330418497,'Virgo'],
  [-330418497,-330236542,'Libra'],
  [-330236542,-330059635,'Scorpio'],
  [-330059635,-329882727,'Sagittarius'],
  [-329882727,-329699284,'Capricorn'],
  [-329699284,-329503664,'Aquarius'],
  [-329503664,-329294454,'Pisces'],
  [-329294454,-329076725,'Aries'],
  [-329076725,-328859491,'Taurus'],
  [-328859491,-328649544,'Gemini'],
  [-328649544,-328448499,'Cancer'],
  [-328448499,-328254748,'Leo'],
  [-328254748,-328066344,'Virgo'],
  [-328066344,-327882062,'Libra'],
  [-327882062,-327700534,'Scorpio'],
  [-327700534,-327518995,'Sagittarius'],
  [-327518995,-327333092,'Capricorn'],
  [-327333092,-327138092,'Aquarius'],
  [-327138092,-326931393,'Pisces'],
  [-326931393,-326715362,'Aries'],
  [-326715362,-326497590,'Taurus'],
  [-326497590,-326286532,'Gemini'],
  [-326286532,-326086273,'Cancer'],
  [-326086273,-325895799,'Leo'],
  [-325895799,-325711552,'Virgo'],
  [-325711552,-325529788,'Libra'],
  [-325529788,-325347560,'Scorpio'],
  [-325347560,-325162562,'Sagittarius'],
  [-325162562,-324972557,'Capricorn'],
  [-324972557,-324775178,'Aquarius'],
  [-324775178,-324568671,'Pisces'],
  [-324568671,-324353798,'Aries'],
  [-324353798,-324135507,'Taurus'],
  [-324135507,-323921809,'Gemini'],
  [-323921809,-323719260,'Cancer'],
  [-323719260,-323529301,'Leo'],
  [-323529301,-323348761,'Virgo'],
  [-323348761,-323172240,'Libra'],
  [-323172240,-322994176,'Scorpio'],
  [-322994176,-322810250,'Sagittarius'],
  [-322810250,-322618161,'Capricorn'],
  [-322618161,-322417551,'Aquarius'],
  [-322417551,-322209142,'Pisces'],
  [-322209142,-321994266,'Aries'],
  [-321994266,-321775841,'Taurus'],
  [-321775841,-321559517,'Gemini'],
  [-321559517,-321352384,'Cancer'],
  [-321352384,-321158873,'Leo'],
  [-321158873,-320978225,'Virgo'],
  [-320978225,-320805364,'Libra'],
  [-320805364,-320633213,'Scorpio'],
  [-320633213,-320454841,'Sagittarius'],
  [-320454841,-320265472,'Capricorn'],
  [-320265472,-320064189,'Aquarius'],
  [-320064189,-319853666,'Pisces'],
  [-319853666,-319637697,'Aries'],
  [-319637697,-319419407,'Taurus'],
  [-319419407,-319202105,'Gemini'],
  [-319202105,-318990893,'Cancer'],
  [-318990893,-318791369,'Leo'],
  [-318791369,-318605976,'Virgo'],
  [-318605976,-318432026,'Libra'],
  [-318432026,-318262894,'Scorpio'],
  [-318262894,-318090478,'Sagittarius'],
  [-318090478,-317907467,'Capricorn'],
  [-317907467,-317710044,'Aquarius'],
  [-317710044,-317499963,'Pisces'],
  [-317499963,-317282975,'Aries'],
  [-317282975,-317064605,'Taurus'],
  [-317064605,-316848041,'Gemini'],
  [-316848041,-316635864,'Cancer'],
  [-316635864,-316431906,'Leo'],
  [-316431906,-316239883,'Virgo'],
  [-316239883,-316060252,'Libra'],
  [-316060252,-315888827,'Scorpio'],
  [-315888827,-315718314,'Sagittarius'],
  [-315718314,-315540653,'Capricorn'],
  [-315540653,-315349534,'Aquarius'],
  [-315349534,-315143528,'Pisces'],
  [-315143528,-314927380,'Aries'],
  [-314927380,-314708747,'Taurus'],
  [-314708747,-314493147,'Gemini'],
  [-314493147,-314282766,'Cancer'],
  [-314282766,-314078837,'Leo'],
  [-314078837,-313883225,'Virgo'],
  [-313883225,-313697314,'Libra'],
  [-313697314,-313519770,'Scorpio'],
  [-313519770,-313345885,'Sagittarius'],
  [-313345885,-313168889,'Capricorn'],
  [-313168889,-312982035,'Aquarius'],
  [-312982035,-312781333,'Pisces'],
  [-312781333,-312568316,'Aries'],
  [-312568316,-312349998,'Taurus'],
  [-312349998,-312134377,'Gemini'],
  [-312134377,-311925825,'Cancer'],
  [-311925825,-311724966,'Leo'],
  [-311724966,-311531022,'Virgo'],
  [-311531022,-311343273,'Libra'],
  [-311343273,-311160706,'Scorpio'],
  [-311160706,-310980983,'Sagittarius'],
  [-310980983,-310800059,'Capricorn'],
  [-310800059,-310612887,'Aquarius'],
  [-310612887,-310415121,'Pisces'],
  [-310415121,-310205625,'Aries'],
  [-310205625,-309988524,'Taurus'],
  [-309988524,-309771980,'Gemini'],
  [-309771980,-309563175,'Cancer'],
  [-309563175,-309364663,'Leo'],
  [-309364663,-309174894,'Virgo'],
  [-309174894,-308990537,'Libra'],
  [-308990537,-308808258,'Scorpio'],
  [-308808258,-308625357,'Sagittarius'],
  [-308625357,-308439586,'Capricorn'],
  [-308439586,-308248635,'Aquarius'],
  [-308248635,-308050023,'Pisces'],
  [-308050023,-307842132,'Aries'],
  [-307842132,-307626383,'Taurus'],
  [-307626383,-307408746,'Gemini'],
  [-307408746,-307197527,'Cancer'],
  [-307197527,-306998235,'Leo'],
  [-306998235,-306810910,'Virgo'],
  [-306810910,-306631367,'Libra'],
  [-306631367,-306453854,'Scorpio'],
  [-306453854,-306273220,'Sagittarius'],
  [-306273220,-306086232,'Capricorn'],
  [-306086232,-305891843,'Aquarius'],
  [-305891843,-305690181,'Pisces'],
  [-305690181,-305481383,'Aries'],
  [-305481383,-305266131,'Taurus'],
  [-305266131,-305047790,'Gemini'],
  [-305047790,-304833395,'Cancer'],
  [-304833395,-304630364,'Leo'],
  [-304630364,-304441603,'Virgo'],
  [-304441603,-304264193,'Libra'],
  [-304264193,-304091607,'Scorpio'],
  [-304091607,-303916584,'Sagittarius'],
  [-303916584,-303733355,'Capricorn'],
  [-303733355,-303539405,'Aquarius'],
  [-303539405,-303335743,'Pisces'],
  [-303335743,-303124924,'Aries'],
  [-303124924,-302909090,'Taurus'],
  [-302909090,-302690532,'Gemini'],
  [-302690532,-302473915,'Cancer'],
  [-302473915,-302266244,'Leo'],
  [-302266244,-302072766,'Virgo'],
  [-302072766,-301893214,'Libra'],
  [-301893214,-301722143,'Scorpio'],
  [-301722143,-301551762,'Sagittarius'],
  [-301551762,-301374475,'Capricorn'],
  [-301374475,-301185136,'Aquarius'],
  [-301185136,-300982996,'Pisces'],
  [-300982996,-300771327,'Aries'],
  [-300771327,-300554550,'Taurus'],
  [-300554550,-300336031,'Gemini'],
  [-300336031,-300119013,'Cancer'],
  [-300119013,-299908388,'Leo'],
  [-299908388,-299709533,'Virgo'],
  [-299709533,-299524629,'Libra'],
  [-299524629,-299350698,'Scorpio'],
  [-299350698,-299181078,'Sagittarius'],
  [-299181078,-299007928,'Capricorn'],
  [-299007928,-298824403,'Aquarius'],
  [-298824403,-298627005,'Pisces'],
  [-298627005,-298417198,'Aries'],
  [-298417198,-298200263,'Taurus'],
  [-298200263,-297981810,'Gemini'],
  [-297981810,-297765716,'Cancer'],
  [-297765716,-297555120,'Leo'],
  [-297555120,-297353406,'Virgo'],
  [-297353406,-297163058,'Libra'],
  [-297163058,-296983448,'Scorpio'],
  [-296983448,-296810329,'Sagittarius'],
  [-296810329,-296637216,'Capricorn'],
  [-296637216,-296457212,'Aquarius'],
  [-296457212,-296265039,'Pisces'],
  [-296265039,-296059318,'Aries'],
  [-296059318,-295843778,'Taurus'],
  [-295843778,-295625399,'Gemini'],
  [-295625399,-295410283,'Cancer'],
  [-295410283,-295201727,'Leo'],
  [-295201727,-295001035,'Virgo'],
  [-295001035,-294808662,'Libra'],
  [-294808662,-294624149,'Scorpio'],
  [-294624149,-294445367,'Sagittarius'],
  [-294445367,-294268329,'Capricorn'],
  [-294268329,-294087773,'Aquarius'],
  [-294087773,-293898396,'Pisces'],
  [-293898396,-293696803,'Aries'],
  [-293696803,-293483888,'Taurus'],
  [-293483888,-293265744,'Gemini'],
  [-293265744,-293050549,'Cancer'],
  [-293050549,-292843723,'Leo'],
  [-292843723,-292646270,'Virgo'],
  [-292646270,-292456316,'Libra'],
  [-292456316,-292271233,'Scorpio'],
  [-292271233,-292088662,'Sagittarius'],
  [-292088662,-291906417,'Capricorn'],
  [-291906417,-291721852,'Aquarius'],
  [-291721852,-291531508,'Pisces'],
  [-291531508,-291331848,'Aries'],
  [-291331848,-291121471,'Taurus'],
  [-291121471,-290903848,'Gemini'],
  [-290903848,-290687267,'Cancer'],
  [-290687267,-290479858,'Leo'],
  [-290479858,-290284550,'Virgo'],
  [-290284550,-290098863,'Libra'],
  [-290098863,-289917786,'Scorpio'],
  [-289917786,-289736549,'Sagittarius'],
  [-289736549,-289552141,'Capricorn'],
  [-289552141,-289363323,'Aquarius'],
  [-289363323,-289169293,'Pisces'],
  [-289169293,-288968464,'Aries'],
  [-288968464,-288759110,'Taurus'],
  [-288759110,-288542152,'Gemini'],
  [-288542152,-288323728,'Cancer'],
  [-288323728,-288113124,'Leo'],
  [-288113124,-287916367,'Virgo'],
  [-287916367,-287732697,'Libra'],
  [-287732697,-287556476,'Scorpio'],
  [-287556476,-287380705,'Sagittarius'],
  [-287380705,-287199676,'Capricorn'],
  [-287199676,-287010636,'Aquarius'],
  [-287010636,-286813711,'Pisces'],
  [-286813711,-286609912,'Aries'],
  [-286609912,-286399507,'Taurus'],
  [-286399507,-286182861,'Gemini'],
  [-286182861,-285963401,'Cancer'],
  [-285963401,-285748872,'Leo'],
  [-285748872,-285547232,'Virgo'],
  [-285547232,-285360944,'Libra'],
  [-285360944,-285186005,'Scorpio'],
  [-285186005,-285015052,'Sagittarius'],
  [-285015052,-284840444,'Capricorn'],
  [-284840444,-284656503,'Aquarius'],
  [-284656503,-284461194,'Pisces'],
  [-284461194,-284255956,'Aries'],
  [-284255956,-284043583,'Taurus'],
  [-284043583,-283826428,'Gemini'],
  [-283826428,-283607083,'Cancer'],
  [-283607083,-283390536,'Leo'],
  [-283390536,-283183695,'Virgo'],
  [-283183695,-282991279,'Libra'],
  [-282991279,-282812457,'Scorpio'],
  [-282812457,-282641625,'Sagittarius'],
  [-282641625,-282471198,'Capricorn'],
  [-282471198,-282293873,'Aquarius'],
  [-282293873,-282104565,'Pisces'],
  [-282104565,-281902111,'Aries'],
  [-281902111,-281689410,'Taurus'],
  [-281689410,-281471371,'Gemini'],
  [-281471371,-281252450,'Cancer'],
  [-281252450,-281036508,'Leo'],
  [-281036508,-280827709,'Virgo'],
  [-280827709,-280629913,'Libra'],
  [-280629913,-280444423,'Scorpio'],
  [-280444423,-280268696,'Sagittarius'],
  [-280268696,-280097181,'Capricorn'],
  [-280097181,-279923028,'Aquarius'],
  [-279923028,-279739734,'Pisces'],
  [-279739734,-279543073,'Aries'],
  [-279543073,-279333217,'Taurus'],
  [-279333217,-279115285,'Gemini'],
  [-279115285,-278896403,'Cancer'],
  [-278896403,-278682004,'Leo'],
  [-278682004,-278474845,'Virgo'],
  [-278474845,-278276085,'Libra'],
  [-278276085,-278086086,'Scorpio'],
  [-278086086,-277903998,'Sagittarius'],
  [-277903998,-277727157,'Capricorn'],
  [-277727157,-277551006,'Aquarius'],
  [-277551006,-277369759,'Pisces'],
  [-277369759,-277177878,'Aries'],
  [-277177878,-276972533,'Taurus'],
  [-276972533,-276756394,'Gemini'],
  [-276756394,-276537354,'Cancer'],
  [-276537354,-276323574,'Leo'],
  [-276323574,-276118964,'Virgo'],
  [-276118964,-275923066,'Libra'],
  [-275923066,-275733642,'Scorpio'],
  [-275733642,-275548635,'Sagittarius'],
  [-275548635,-275366488,'Capricorn'],
  [-275366488,-275185256,'Aquarius'],
  [-275185256,-275001553,'Pisces'],
  [-275001553,-274810693,'Aries'],
  [-274810693,-274608550,'Taurus'],
  [-274608550,-274394903,'Gemini'],
  [-274394903,-274175894,'Cancer'],
  [-274175894,-273961210,'Leo'],
  [-273961210,-273757398,'Virgo'],
  [-273757398,-273564705,'Libra'],
  [-273564705,-273379249,'Scorpio'],
  [-273379249,-273196481,'Sagittarius'],
  [-273196481,-273013290,'Capricorn'],
  [-273013290,-272828242,'Aquarius'],
  [-272828242,-272640212,'Pisces'],
  [-272640212,-272446887,'Aries'],
  [-272446887,-272245011,'Taurus'],
  [-272245011,-272032937,'Gemini'],
  [-272032937,-271814137,'Cancer'],
  [-271814137,-271597532,'Leo'],
  [-271597532,-271391865,'Virgo'],
  [-271391865,-271199776,'Libra'],
  [-271199776,-271017781,'Scorpio'],
  [-271017781,-270839821,'Sagittarius'],
  [-270839821,-270660362,'Capricorn'],
  [-270660362,-270476061,'Aquarius'],
  [-270476061,-270285784,'Pisces'],
  [-270285784,-270089146,'Aries'],
  [-270089146,-269885193,'Taurus'],
  [-269885193,-269672986,'Gemini'],
  [-269672986,-269454310,'Cancer'],
  [-269454310,-269235811,'Leo'],
  [-269235811,-269026477,'Virgo'],
  [-269026477,-268831559,'Libra'],
  [-268831559,-268649692,'Scorpio'],
  [-268649692,-268475124,'Sagittarius'],
  [-268475124,-268301001,'Capricorn'],
  [-268301001,-268121578,'Aquarius'],
  [-268121578,-267933510,'Pisces'],
  [-267933510,-267735997,'Aries'],
  [-267735997,-267529811,'Taurus'],
  [-267529811,-267316235,'Gemini'],
  [-267316235,-267097390,'Cancer'],
  [-267097390,-266877951,'Leo'],
  [-266877951,-266665119,'Virgo'],
  [-266665119,-266465197,'Libra'],
  [-266465197,-266279584,'Scorpio'],
  [-266279584,-266104507,'Sagittarius'],
  [-266104507,-265933485,'Capricorn'],
  [-265933485,-265759601,'Aquarius'],
  [-265759601,-265577096,'Pisces'],
  [-265577096,-265382732,'Aries'],
  [-265382732,-265176642,'Taurus'],
  [-265176642,-264961863,'Gemini'],
  [-264961863,-264742594,'Cancer'],
  [-264742594,-264523335,'Leo'],
  [-264523335,-264309072,'Virgo'],
  [-264309072,-264104759,'Libra'],
  [-264104759,-263913285,'Scorpio'],
  [-263913285,-263733665,'Sagittarius'],
  [-263733665,-263561434,'Capricorn'],
  [-263561434,-263390183,'Aquarius'],
  [-263390183,-263213067,'Pisces'],
  [-263213067,-263024387,'Aries'],
  [-263024387,-262821692,'Taurus'],
  [-262821692,-262607448,'Gemini'],
  [-262607448,-262387866,'Cancer'],
  [-262387866,-262169276,'Leo'],
  [-262169276,-261955954,'Virgo'],
  [-261955954,-261750446,'Libra'],
  [-261750446,-261554521,'Scorpio'],
  [-261554521,-261368722,'Sagittarius'],
  [-261368722,-261191364,'Capricorn'],
  [-261191364,-261018201,'Aquarius'],
  [-261018201,-260843059,'Pisces'],
  [-260843059,-260659217,'Aries'],
  [-260659217,-260461666,'Taurus'],
  [-260461666,-260250243,'Gemini'],
  [-260250243,-260031043,'Cancer'],
  [-260031043,-259812776,'Leo'],
  [-259812776,-259601245,'Virgo'],
  [-259601245,-259397817,'Libra'],
  [-259397817,-259201725,'Scorpio'],
  [-259201725,-259012290,'Sagittarius'],
  [-259012290,-258829069,'Capricorn'],
  [-258829069,-258650519,'Aquarius'],
  [-258650519,-258472813,'Pisces'],
  [-258472813,-258290127,'Aries'],
  [-258290127,-258096460,'Taurus'],
  [-258096460,-257888910,'Gemini'],
  [-257888910,-257671132,'Cancer'],
  [-257671132,-257452498,'Leo'],
  [-257452498,-257241529,'Virgo'],
  [-257241529,-257040823,'Libra'],
  [-257040823,-256848181,'Scorpio'],
  [-256848181,-256660286,'Sagittarius'],
  [-256660286,-256475060,'Capricorn'],
  [-256475060,-256291667,'Aquarius'],
  [-256291667,-256108766,'Pisces'],
  [-256108766,-255923064,'Aries'],
  [-255923064,-255729728,'Taurus'],
  [-255729728,-255524797,'Gemini'],
  [-255524797,-255308985,'Cancer'],
  [-255308985,-255089735,'Leo'],
  [-255089735,-254877134,'Virgo'],
  [-254877134,-254676707,'Libra'],
  [-254676707,-254487290,'Scorpio'],
  [-254487290,-254304150,'Sagittarius'],
  [-254304150,-254122491,'Capricorn'],
  [-254122491,-253939292,'Aquarius'],
  [-253939292,-253753199,'Pisces'],
  [-253753199,-253563033,'Aries'],
  [-253563033,-253366652,'Taurus'],
  [-253366652,-253161473,'Gemini'],
  [-253161473,-252946936,'Cancer'],
  [-252946936,-252727474,'Leo'],
  [-252727474,-252512006,'Virgo'],
  [-252512006,-252308402,'Libra'],
  [-252308402,-252118476,'Scorpio'],
  [-252118476,-251938497,'Sagittarius'],
  [-251938497,-251762454,'Capricorn'],
  [-251762454,-251584631,'Aquarius'],
  [-251584631,-251401005,'Pisces'],
  [-251401005,-251209611,'Aries'],
  [-251209611,-251009967,'Taurus'],
  [-251009967,-250802280,'Gemini'],
  [-250802280,-250587377,'Cancer'],
  [-250587377,-250368121,'Leo'],
  [-250368121,-250150558,'Virgo'],
  [-250150558,-249942191,'Libra'],
  [-249942191,-249747622,'Scorpio'],
  [-249747622,-249566064,'Sagittarius'],
  [-249566064,-249392592,'Capricorn'],
  [-249392592,-249220541,'Aquarius'],
  [-249220541,-249043377,'Pisces'],
  [-249043377,-248856188,'Aries'],
  [-248856188,-248657058,'Taurus'],
  [-248657058,-248447490,'Gemini'],
  [-248447490,-248231086,'Cancer'],
  [-248231086,-248011863,'Leo'],
  [-248011863,-247794029,'Virgo'],
  [-247794029,-247582513,'Libra'],
  [-247582513,-247382104,'Scorpio'],
  [-247382104,-247194870,'Sagittarius'],
  [-247194870,-247018774,'Capricorn'],
  [-247018774,-246848347,'Aquarius'],
  [-246848347,-246676407,'Pisces'],
  [-246676407,-246495826,'Aries'],
  [-246495826,-246301657,'Taurus'],
  [-246301657,-246093612,'Gemini'],
  [-246093612,-245876489,'Cancer'],
  [-245876489,-245656934,'Leo'],
  [-245656934,-245439922,'Virgo'],
  [-245439922,-245228364,'Libra'],
  [-245228364,-245024807,'Scorpio'],
  [-245024807,-244831640,'Sagittarius'],
  [-244831640,-244649474,'Capricorn'],
  [-244649474,-244475622,'Aquarius'],
  [-244475622,-244304235,'Pisces'],
  [-244304235,-244127869,'Aries'],
  [-244127869,-243939622,'Taurus'],
  [-243939622,-243736180,'Gemini'],
  [-243736180,-243520620,'Cancer'],
  [-243520620,-243300982,'Leo'],
  [-243300982,-243084662,'Virgo'],
  [-243084662,-242874900,'Libra'],
  [-242874900,-242672144,'Scorpio'],
  [-242672144,-242476721,'Sagittarius'],
  [-242476721,-242289364,'Capricorn'],
  [-242289364,-242109666,'Aquarius'],
  [-242109666,-241934403,'Pisces'],
  [-241934403,-241757649,'Aries'],
  [-241757649,-241572469,'Taurus'],
  [-241572469,-241373673,'Gemini'],
  [-241373673,-241161393,'Cancer'],
  [-241161393,-240942475,'Leo'],
  [-240942475,-240726141,'Virgo'],
  [-240726141,-240517805,'Libra'],
  [-240517805,-240317834,'Scorpio'],
  [-240317834,-240124432,'Sagittarius'],
  [-240124432,-239936241,'Capricorn'],
  [-239936241,-239752627,'Aquarius'],
  [-239752627,-239572198,'Pisces'],
  [-239572198,-239391506,'Aries'],
  [-239391506,-239205324,'Taurus'],
  [-239205324,-239008527,'Gemini'],
  [-239008527,-238799236,'Cancer'],
  [-238799236,-238581623,'Leo'],
  [-238581623,-238364615,'Virgo'],
  [-238364615,-238155930,'Libra'],
  [-238155930,-237957810,'Scorpio'],
  [-237957810,-237768076,'Sagittarius'],
  [-237768076,-237583230,'Capricorn'],
  [-237583230,-237400407,'Aquarius'],
  [-237400407,-237217587,'Pisces'],
  [-237217587,-237032699,'Aries'],
  [-237032699,-236842896,'Taurus'],
  [-236842896,-236644883,'Gemini'],
  [-236644883,-236436674,'Cancer'],
  [-236436674,-236220196,'Leo'],
  [-236220196,-236002247,'Virgo'],
  [-236002247,-235791318,'Libra'],
  [-235791318,-235592287,'Scorpio'],
  [-235592287,-235404548,'Sagittarius'],
  [-235404548,-235224046,'Capricorn'],
  [-235224046,-235045774,'Aquarius'],
  [-235045774,-234865341,'Pisces'],
  [-234865341,-234679618,'Aries'],
  [-234679618,-234486745,'Taurus'],
  [-234486745,-234285778,'Gemini'],
  [-234285778,-234076517,'Cancer'],
  [-234076517,-233860367,'Leo'],
  [-233860367,-233641721,'Virgo'],
  [-233641721,-233427720,'Libra'],
  [-233427720,-233224965,'Scorpio'],
  [-233224965,-233035624,'Sagittarius'],
  [-233035624,-232856990,'Capricorn'],
  [-232856990,-232683433,'Aquarius'],
  [-232683433,-232508489,'Pisces'],
  [-232508489,-232326532,'Aries'],
  [-232326532,-232134223,'Taurus'],
  [-232134223,-231931349,'Gemini'],
  [-231931349,-231720077,'Cancer'],
  [-231720077,-231503346,'Leo'],
  [-231503346,-231284520,'Virgo'],
  [-231284520,-231068327,'Libra'],
  [-231068327,-230860825,'Scorpio'],
  [-230860825,-230666518,'Sagittarius'],
  [-230666518,-230485497,'Capricorn'],
  [-230485497,-230313368,'Aquarius'],
  [-230313368,-230143118,'Pisces'],
  [-230143118,-229967207,'Aries'],
  [-229967207,-229779644,'Taurus'],
  [-229779644,-229578379,'Gemini'],
  [-229578379,-229366245,'Cancer'],
  [-229366245,-229148571,'Leo'],
  [-229148571,-228929897,'Virgo'],
  [-228929897,-228713466,'Libra'],
  [-228713466,-228503006,'Scorpio'],
  [-228503006,-228302995,'Sagittarius'],
  [-228302995,-228116092,'Capricorn'],
  [-228116092,-227940696,'Aquarius'],
  [-227940696,-227771082,'Pisces'],
  [-227771082,-227599422,'Aries'],
  [-227599422,-227417977,'Taurus'],
  [-227417977,-227221827,'Gemini'],
  [-227221827,-227011754,'Cancer'],
  [-227011754,-226793911,'Leo'],
  [-226793911,-226575310,'Virgo'],
  [-226575310,-226360030,'Libra'],
  [-226360030,-226149948,'Scorpio'],
  [-226149948,-225947232,'Sagittarius'],
  [-225947232,-225754557,'Capricorn'],
  [-225754557,-225572796,'Aquarius'],
  [-225572796,-225399017,'Pisces'],
  [-225399017,-225226956,'Aries'],
  [-225226956,-225048959,'Taurus'],
  [-225048959,-224858412,'Gemini'],
  [-224858412,-224652978,'Cancer'],
  [-224652978,-224436803,'Leo'],
  [-224436803,-224218168,'Virgo'],
  [-224218168,-224003768,'Libra'],
  [-224003768,-223796020,'Scorpio'],
  [-223796020,-223595001,'Sagittarius'],
  [-223595001,-223400911,'Capricorn'],
  [-223400911,-223214272,'Aquarius'],
  [-223214272,-223034243,'Pisces'],
  [-223034243,-222857361,'Aries'],
  [-222857361,-222677965,'Taurus'],
  [-222677965,-222489856,'Gemini'],
  [-222489856,-222288876,'Cancer'],
  [-222288876,-222075896,'Leo'],
  [-222075896,-221857629,'Virgo'],
  [-221857629,-221642718,'Libra'],
  [-221642718,-221436284,'Scorpio'],
  [-221436284,-221238727,'Sagittarius'],
  [-221238727,-221048036,'Capricorn'],
  [-221048036,-220862014,'Aquarius'],
  [-220862014,-220678869,'Pisces'],
  [-220678869,-220496603,'Aries'],
  [-220496603,-220312303,'Taurus'],
  [-220312303,-220122165,'Gemini'],
  [-220122165,-219922595,'Cancer'],
  [-219922595,-219712410,'Leo'],
  [-219712410,-219495137,'Virgo'],
  [-219495137,-219278683,'Libra'],
  [-219278683,-219070788,'Scorpio'],
  [-219070788,-218874508,'Sagittarius'],
  [-218874508,-218688011,'Capricorn'],
  [-218688011,-218506935,'Aquarius'],
  [-218506935,-218326639,'Pisces'],
  [-218326639,-218143520,'Aries'],
  [-218143520,-217955378,'Taurus'],
  [-217955378,-217760979,'Gemini'],
  [-217760979,-217559314,'Cancer'],
  [-217559314,-217349697,'Leo'],
  [-217349697,-217133409,'Virgo'],
  [-217133409,-216915572,'Libra'],
  [-216915572,-216704161,'Scorpio'],
  [-216704161,-216505277,'Sagittarius'],
  [-216505277,-216319574,'Capricorn'],
  [-216319574,-216142790,'Aquarius'],
  [-216142790,-215968374,'Pisces'],
  [-215968374,-215789944,'Aries'],
  [-215789944,-215603138,'Taurus'],
  [-215603138,-215406727,'Gemini'],
  [-215406727,-215201987,'Cancer'],
  [-215201987,-214990750,'Leo'],
  [-214990750,-214774574,'Virgo'],
  [-214774574,-214556244,'Libra'],
  [-214556244,-214341564,'Scorpio'],
  [-214341564,-214137650,'Sagittarius'],
  [-214137650,-213948298,'Capricorn'],
  [-213948298,-213771493,'Aquarius'],
  [-213771493,-213600844,'Pisces'],
  [-213600844,-213428478,'Aries'],
  [-213428478,-213247433,'Taurus'],
  [-213247433,-213053930,'Gemini'],
  [-213053930,-212848757,'Cancer'],
  [-212848757,-212635773,'Leo'],
  [-212635773,-212418816,'Virgo'],
  [-212418816,-212200632,'Libra'],
  [-212200632,-211984698,'Scorpio'],
  [-211984698,-211776541,'Sagittarius'],
  [-211776541,-211581352,'Capricorn'],
  [-211581352,-211400109,'Aquarius'],
  [-211400109,-211228483,'Pisces'],
  [-211228483,-211058995,'Aries'],
  [-211058995,-210883613,'Taurus'],
  [-210883613,-210696085,'Gemini'],
  [-210696085,-210494461,'Cancer'],
  [-210494461,-210281949,'Leo'],
  [-210281949,-210064343,'Virgo'],
  [-210064343,-209846382,'Libra'],
  [-209846382,-209631119,'Scorpio'],
  [-209631119,-209421788,'Sagittarius'],
  [-209421788,-209222321,'Capricorn'],
  [-209222321,-209035110,'Aquarius'],
  [-209035110,-208858567,'Pisces'],
  [-208858567,-208687243,'Aries'],
  [-208687243,-208513810,'Taurus'],
  [-208513810,-208331195,'Gemini'],
  [-208331195,-208134971,'Cancer'],
  [-208134971,-207925636,'Leo'],
  [-207925636,-207708599,'Virgo'],
  [-207708599,-207490722,'Libra'],
  [-207490722,-207276714,'Scorpio'],
  [-207276714,-207068982,'Sagittarius'],
  [-207068982,-206869118,'Capricorn'],
  [-206869118,-206678322,'Aquarius'],
  [-206678322,-206496218,'Pisces'],
  [-206496218,-206319840,'Aries'],
  [-206319840,-206143996,'Taurus'],
  [-206143996,-205962557,'Gemini'],
  [-205962557,-205770271,'Cancer'],
  [-205770271,-205565071,'Leo'],
  [-205565071,-205349946,'Virgo'],
  [-205349946,-205132085,'Libra'],
  [-205132085,-204918573,'Scorpio'],
  [-204918573,-204713072,'Sagittarius'],
  [-204713072,-204515949,'Capricorn'],
  [-204515949,-204325982,'Aquarius'],
  [-204325982,-204141497,'Pisces'],
  [-204141497,-203960380,'Aries'],
  [-203960380,-203779710,'Taurus'],
  [-203779710,-203595640,'Gemini'],
  [-203595640,-203403942,'Cancer'],
  [-203403942,-203201508,'Leo'],
  [-203201508,-202988685,'Virgo'],
  [-202988685,-202770880,'Libra'],
  [-202770880,-202556461,'Scorpio'],
  [-202556461,-202351609,'Sagittarius'],
  [-202351609,-202157505,'Capricorn'],
  [-202157505,-201971421,'Aquarius'],
  [-201971421,-201789230,'Pisces'],
  [-201789230,-201607267,'Aries'],
  [-201607267,-201423008,'Taurus'],
  [-201423008,-201234703,'Gemini'],
  [-201234703,-201040494,'Cancer'],
  [-201040494,-200838206,'Leo'],
  [-200838206,-200626824,'Virgo'],
  [-200626824,-200409150,'Libra'],
  [-200409150,-200192710,'Scorpio'],
  [-200192710,-199985860,'Sagittarius'],
  [-199985860,-199792265,'Capricorn'],
  [-199792265,-199609650,'Aquarius'],
  [-199609650,-199432328,'Pisces'],
  [-199432328,-199254187,'Aries'],
  [-199254187,-199070772,'Taurus'],
  [-199070772,-198880252,'Gemini'],
  [-198880252,-198682700,'Cancer'],
  [-198682700,-198478317,'Leo'],
  [-198478317,-198266814,'Virgo'],
  [-198266814,-198049266,'Libra'],
  [-198049266,-197830812,'Scorpio'],
  [-197830812,-197619979,'Sagittarius'],
  [-197619979,-197423211,'Capricorn'],
  [-197423211,-197240583,'Aquarius'],
  [-197240583,-197066729,'Pisces'],
  [-197066729,-196894152,'Aries'],
  [-196894152,-196715949,'Taurus'],
  [-196715949,-196527909,'Gemini'],
  [-196527909,-196329563,'Cancer'],
  [-196329563,-196122894,'Leo'],
  [-196122894,-195909980,'Virgo'],
  [-195909980,-195692340,'Libra'],
  [-195692340,-195473036,'Scorpio'],
  [-195473036,-195258533,'Sagittarius'],
  [-195258533,-195056212,'Capricorn'],
  [-195056212,-194869205,'Aquarius'],
  [-194869205,-194694415,'Pisces'],
  [-194694415,-194524818,'Aries'],
  [-194524818,-194352443,'Taurus'],
  [-194352443,-194170600,'Gemini'],
  [-194170600,-193976009,'Cancer'],
  [-193976009,-193769719,'Leo'],
  [-193769719,-193555550,'Virgo'],
  [-193555550,-193337425,'Libra'],
  [-193337425,-193118518,'Scorpio'],
  [-193118518,-192902925,'Sagittarius'],
  [-192902925,-192696195,'Capricorn'],
  [-192696195,-192502704,'Aquarius'],
  [-192502704,-192322430,'Pisces'],
  [-192322430,-192150720,'Aries'],
  [-192150720,-191980444,'Taurus'],
  [-191980444,-191804157,'Gemini'],
  [-191804157,-191616039,'Cancer'],
  [-191616039,-191414011,'Leo'],
  [-191414011,-191200773,'Virgo'],
  [-191200773,-190982199,'Libra'],
  [-190982199,-190763887,'Scorpio'],
  [-190763887,-190549696,'Sagittarius'],
  [-190549696,-190342578,'Capricorn'],
  [-190342578,-190145076,'Aquarius'],
  [-190145076,-189958247,'Pisces'],
  [-189958247,-189780342,'Aries'],
  [-189780342,-189606851,'Taurus'],
  [-189606851,-189431602,'Gemini'],
  [-189431602,-189248215,'Cancer'],
  [-189248215,-189052008,'Leo'],
  [-189052008,-188842440,'Virgo'],
  [-188842440,-188624496,'Libra'],
  [-188624496,-188406142,'Scorpio'],
  [-188406142,-188193565,'Sagittarius'],
  [-188193565,-187989156,'Capricorn'],
  [-187989156,-187792733,'Aquarius'],
  [-187792733,-187603348,'Pisces'],
  [-187603348,-187419792,'Aries'],
  [-187419792,-187240115,'Taurus'],
  [-187240115,-187060980,'Gemini'],
  [-187060980,-186877619,'Cancer'],
  [-186877619,-186684883,'Leo'],
  [-186684883,-186479594,'Virgo'],
  [-186479594,-186263668,'Libra'],
  [-186263668,-186044878,'Scorpio'],
  [-186044878,-185832183,'Sagittarius'],
  [-185832183,-185630055,'Capricorn'],
  [-185630055,-185437529,'Aquarius'],
  [-185437529,-185250998,'Pisces'],
  [-185250998,-185067000,'Aries'],
  [-185067000,-184883399,'Taurus'],
  [-184883399,-184698906,'Gemini'],
  [-184698906,-184511599,'Cancer'],
  [-184511599,-184318136,'Leo'],
  [-184318136,-184114910,'Virgo'],
  [-184114910,-183901181,'Libra'],
  [-183901181,-183682170,'Scorpio'],
  [-183682170,-183467558,'Sagittarius'],
  [-183467558,-183264805,'Capricorn'],
  [-183264805,-183074687,'Aquarius'],
  [-183074687,-182892789,'Pisces'],
  [-182892789,-182713226,'Aries'],
  [-182713226,-182531379,'Taurus'],
  [-182531379,-182345058,'Gemini'],
  [-182345058,-182153787,'Cancer'],
  [-182153787,-181956896,'Leo'],
  [-181956896,-181752635,'Virgo'],
  [-181752635,-181539753,'Libra'],
  [-181539753,-181320842,'Scorpio'],
  [-181320842,-181103811,'Sagittarius'],
  [-181103811,-180897668,'Capricorn'],
  [-180897668,-180706148,'Aquarius'],
  [-180706148,-180526288,'Pisces'],
  [-180526288,-180351563,'Aries'],
  [-180351563,-180175221,'Taurus'],
  [-180175221,-179992428,'Gemini'],
  [-179992428,-179801246,'Cancer'],
  [-179801246,-179601914,'Leo'],
  [-179601914,-179395143,'Virgo'],
  [-179395143,-179181423,'Libra'],
  [-179181423,-178962573,'Scorpio'],
  [-178962573,-178744002,'Sagittarius'],
  [-178744002,-178533768,'Capricorn'],
  [-178533768,-178337687,'Aquarius'],
  [-178337687,-178155572,'Pisces'],
  [-178155572,-177982230,'Aries'],
  [-177982230,-177810519,'Taurus'],
  [-177810519,-177633710,'Gemini'],
  [-177633710,-177447135,'Cancer'],
  [-177447135,-177249218,'Leo'],
  [-177249218,-177041273,'Virgo'],
  [-177041273,-176826140,'Libra'],
  [-176826140,-176607067,'Scorpio'],
  [-176607067,-176388316,'Sagittarius'],
  [-176388316,-176175624,'Capricorn'],
  [-176175624,-175974505,'Aquarius'],
  [-175974505,-175787059,'Pisces'],
  [-175787059,-175610704,'Aries'],
  [-175610704,-175439666,'Taurus'],
  [-175439666,-175267027,'Gemini'],
  [-175267027,-175086364,'Cancer'],
  [-175086364,-174893344,'Leo'],
  [-174893344,-174687345,'Virgo'],
  [-174687345,-174471863,'Libra'],
  [-174471863,-174252469,'Scorpio'],
  [-174252469,-174034395,'Sagittarius'],
  [-174034395,-173821827,'Capricorn'],
  [-173821827,-173618119,'Aquarius'],
  [-173618119,-173425412,'Pisces'],
  [-173425412,-173243368,'Aries'],
  [-173243368,-173068760,'Taurus'],
  [-173068760,-172896145,'Gemini'],
  [-172896145,-172719023,'Cancer'],
  [-172719023,-172531346,'Leo'],
  [-172531346,-172329732,'Virgo'],
  [-172329732,-172115908,'Libra'],
  [-172115908,-171896531,'Scorpio'],
  [-171896531,-171679111,'Sagittarius'],
  [-171679111,-171468282,'Capricorn'],
  [-171468282,-171265486,'Aquarius'],
  [-171265486,-171070802,'Pisces'],
  [-171070802,-170883921,'Aries'],
  [-170883921,-170703677,'Taurus'],
  [-170703677,-170527174,'Gemini'],
  [-170527174,-170349501,'Cancer'],
  [-170349501,-170164597,'Leo'],
  [-170164597,-169967304,'Virgo'],
  [-169967304,-169756590,'Libra'],
  [-169756590,-169537889,'Scorpio'],
  [-169537889,-169320440,'Sagittarius'],
  [-169320440,-169111037,'Capricorn'],
  [-169111037,-168911067,'Aquarius'],
  [-168911067,-168718482,'Pisces'],
  [-168718482,-168530865,'Aries'],
  [-168530865,-168346777,'Taurus'],
  [-168346777,-168165101,'Gemini'],
  [-168165101,-167983462,'Cancer'],
  [-167983462,-167797527,'Leo'],
  [-167797527,-167602149,'Virgo'],
  [-167602149,-167394320,'Libra'],
  [-167394320,-167176825,'Scorpio'],
  [-167176825,-166958566,'Sagittarius'],
  [-166958566,-166748709,'Capricorn'],
  [-166748709,-166550610,'Aquarius'],
  [-166550610,-166361829,'Pisces'],
  [-166361829,-166177763,'Aries'],
  [-166177763,-165994645,'Taurus'],
  [-165994645,-165810597,'Gemini'],
  [-165810597,-165624640,'Cancer'],
  [-165624640,-165434937,'Leo'],
  [-165434937,-165238239,'Virgo'],
  [-165238239,-165031472,'Libra'],
  [-165031472,-164815132,'Scorpio'],
  [-164815132,-164595812,'Sagittarius'],
  [-164595812,-164383369,'Capricorn'],
  [-164383369,-164184014,'Aquarius'],
  [-164184014,-163997097,'Pisces'],
  [-163997097,-163817556,'Aries'],
  [-163817556,-163639471,'Taurus'],
  [-163639471,-163458328,'Gemini'],
  [-163458328,-163271793,'Cancer'],
  [-163271793,-163078955,'Leo'],
  [-163078955,-162879030,'Virgo'],
  [-162879030,-162670994,'Libra'],
  [-162670994,-162455029,'Scorpio'],
  [-162455029,-162235141,'Sagittarius'],
  [-162235141,-162019416,'Capricorn'],
  [-162019416,-161815674,'Aquarius'],
  [-161815674,-161626378,'Pisces'],
  [-161626378,-161448207,'Aries'],
  [-161448207,-161274926,'Taurus'],
  [-161274926,-161099984,'Gemini'],
  [-161099984,-160918152,'Cancer'],
  [-160918152,-160726551,'Leo'],
  [-160726551,-160524839,'Virgo'],
  [-160524839,-160314476,'Libra'],
  [-160314476,-160097736,'Scorpio'],
  [-160097736,-159877928,'Sagittarius'],
  [-159877928,-159660381,'Capricorn'],
  [-159660381,-159451701,'Aquarius'],
  [-159451701,-159256516,'Pisces'],
  [-159256516,-159074715,'Aries'],
  [-159074715,-158901908,'Taurus'],
  [-158901908,-158731463,'Gemini'],
  [-158731463,-158556325,'Cancer'],
  [-158556325,-158370620,'Leo'],
  [-158370620,-158171524,'Virgo'],
  [-158171524,-157960582,'Libra'],
  [-157960582,-157742633,'Scorpio'],
  [-157742633,-157522945,'Sagittarius'],
  [-157522945,-157305769,'Capricorn'],
  [-157305769,-157094918,'Aquarius'],
  [-157094918,-156894153,'Pisces'],
  [-156894153,-156705600,'Aries'],
  [-156705600,-156528088,'Taurus'],
  [-156528088,-156356997,'Gemini'],
  [-156356997,-156185474,'Cancer'],
  [-156185474,-156006117,'Leo'],
  [-156006117,-155813123,'Virgo'],
  [-155813123,-155605270,'Libra'],
  [-155605270,-155387446,'Scorpio'],
  [-155387446,-155167581,'Sagittarius'],
  [-155167581,-154951617,'Capricorn'],
  [-154951617,-154742004,'Aquarius'],
  [-154742004,-154539781,'Pisces'],
  [-154539781,-154346181,'Aries'],
  [-154346181,-154161936,'Taurus'],
  [-154161936,-153985512,'Gemini'],
  [-153985512,-153812243,'Cancer'],
  [-153812243,-153635276,'Leo'],
  [-153635276,-153447567,'Virgo'],
  [-153447567,-153244938,'Libra'],
  [-153244938,-153029558,'Scorpio'],
  [-153029558,-152809783,'Sagittarius'],
  [-152809783,-152594295,'Capricorn'],
  [-152594295,-152386902,'Aquarius'],
  [-152386902,-152187133,'Pisces'],
  [-152187133,-151993588,'Aries'],
  [-151993588,-151805786,'Taurus'],
  [-151805786,-151623513,'Gemini'],
  [-151623513,-151444881,'Cancer'],
  [-151444881,-151265380,'Leo'],
  [-151265380,-151078863,'Virgo'],
  [-151078863,-150880040,'Libra'],
  [-150880040,-150668122,'Scorpio'],
  [-150668122,-150449216,'Sagittarius'],
  [-150449216,-150233117,'Capricorn'],
  [-150233117,-150026377,'Aquarius'],
  [-150026377,-149829538,'Pisces'],
  [-149829538,-149639685,'Aries'],
  [-149639685,-149453738,'Taurus'],
  [-149453738,-149269876,'Gemini'],
  [-149269876,-149086867,'Cancer'],
  [-149086867,-148902561,'Leo'],
  [-148902561,-148713254,'Virgo'],
  [-148713254,-148514749,'Libra'],
  [-148514749,-148305043,'Scorpio'],
  [-148305043,-148087369,'Sagittarius'],
  [-148087369,-147870125,'Capricorn'],
  [-147870125,-147661724,'Aquarius'],
  [-147661724,-147465327,'Pisces'],
  [-147465327,-147278759,'Aries'],
  [-147278759,-147097487,'Taurus'],
  [-147097487,-146917118,'Gemini'],
  [-146917118,-146734479,'Cancer'],
  [-146734479,-146547459,'Leo'],
  [-146547459,-146354322,'Virgo'],
  [-146354322,-146153336,'Libra'],
  [-146153336,-145943510,'Scorpio'],
  [-145943510,-145726576,'Sagittarius'],
  [-145726576,-145508343,'Capricorn'],
  [-145508343,-145296864,'Aquarius'],
  [-145296864,-145097727,'Pisces'],
  [-145097727,-144911168,'Aries'],
  [-144911168,-144733214,'Taurus'],
  [-144733214,-144558107,'Gemini'],
  [-144558107,-144380188,'Cancer'],
  [-144380188,-144195151,'Leo'],
  [-144195151,-144000813,'Virgo'],
  [-144000813,-143797163,'Libra'],
  [-143797163,-143585600,'Scorpio'],
  [-143585600,-143368497,'Sagittarius'],
  [-143368497,-143149838,'Capricorn'],
  [-143149838,-142935563,'Aquarius'],
  [-142935563,-142731844,'Pisces'],
  [-142731844,-142541619,'Aries'],
  [-142541619,-142363137,'Taurus'],
  [-142363137,-142191093,'Gemini'],
  [-142191093,-142018601,'Cancer'],
  [-142018601,-141839005,'Leo'],
  [-141839005,-141647729,'Virgo'],
  [-141647729,-141444024,'Libra'],
  [-141444024,-141230960,'Scorpio'],
  [-141230960,-141013091,'Sagittarius'],
  [-141013091,-140794533,'Capricorn'],
  [-140794533,-140579157,'Aquarius'],
  [-140579157,-140371538,'Pisces'],
  [-140371538,-140175783,'Aries'],
  [-140175783,-139992917,'Taurus'],
  [-139992917,-139819728,'Gemini'],
  [-139819728,-139649785,'Cancer'],
  [-139649785,-139475408,'Leo'],
  [-139475408,-139289758,'Virgo'],
  [-139289758,-139089535,'Libra'],
  [-139089535,-138877054,'Scorpio'],
  [-138877054,-138658658,'Sagittarius'],
  [-138658658,-138440376,'Capricorn'],
  [-138440376,-138225704,'Aquarius'],
  [-138225704,-138016992,'Pisces'],
  [-138016992,-137817072,'Aries'],
  [-137817072,-137628301,'Taurus'],
  [-137628301,-137450200,'Gemini'],
  [-137450200,-137278407,'Cancer'],
  [-137278407,-137105872,'Leo'],
  [-137105872,-136924927,'Virgo'],
  [-136924927,-136729944,'Libra'],
  [-136729944,-136520603,'Scorpio'],
  [-136520603,-136302804,'Sagittarius'],
  [-136302804,-136084650,'Capricorn'],
  [-136084650,-135871300,'Aquarius'],
  [-135871300,-135664275,'Pisces'],
  [-135664275,-135464044,'Aries'],
  [-135464044,-135271674,'Taurus'],
  [-135271674,-135087857,'Gemini'],
  [-135087857,-134910831,'Cancer'],
  [-134910831,-134735743,'Leo'],
  [-134735743,-134555858,'Virgo'],
  [-134555858,-134364790,'Libra'],
  [-134364790,-134159662,'Scorpio'],
  [-134159662,-133943835,'Sagittarius'],
  [-133943835,-133725634,'Capricorn'],
  [-133725634,-133512697,'Aquarius'],
  [-133512697,-133307961,'Pisces'],
  [-133307961,-133110726,'Aries'],
  [-133110726,-132919508,'Taurus'],
  [-132919508,-132733419,'Gemini'],
  [-132733419,-132551452,'Cancer'],
  [-132551452,-132371143,'Leo'],
  [-132371143,-132188198,'Virgo'],
  [-132188198,-131997474,'Libra'],
  [-131997474,-131795199,'Scorpio'],
  [-131795199,-131581902,'Sagittarius'],
  [-131581902,-131363766,'Capricorn'],
  [-131363766,-131149585,'Aquarius'],
  [-131149585,-130945131,'Pisces'],
  [-130945131,-130750905,'Aries'],
  [-130750905,-130564070,'Taurus'],
  [-130564070,-130381015,'Gemini'],
  [-130381015,-130198713,'Cancer'],
  [-130198713,-130014831,'Leo'],
  [-130014831,-129827182,'Virgo'],
  [-129827182,-129633310,'Libra'],
  [-129633310,-129430861,'Scorpio'],
  [-129430861,-129219167,'Sagittarius'],
  [-129219167,-129001425,'Capricorn'],
  [-129001425,-128785008,'Aquarius'],
  [-128785008,-128577783,'Pisces'],
  [-128577783,-128383277,'Aries'],
  [-128383277,-128199709,'Taurus'],
  [-128199709,-128022106,'Gemini'],
  [-128022106,-127844709,'Cancer'],
  [-127844709,-127662712,'Leo'],
  [-127662712,-127473307,'Virgo'],
  [-127473307,-127275798,'Libra'],
  [-127275798,-127070650,'Scorpio'],
  [-127070650,-126858581,'Sagittarius'],
  [-126858581,-126641268,'Capricorn'],
  [-126641268,-126423164,'Aquarius'],
  [-126423164,-126211566,'Pisces'],
  [-126211566,-126012753,'Aries'],
  [-126012753,-125827992,'Taurus'],
  [-125827992,-125653285,'Gemini'],
  [-125653285,-125481724,'Cancer'],
  [-125481724,-125305991,'Leo'],
  [-125305991,-125120453,'Virgo'],
  [-125120453,-124923066,'Libra'],
  [-124923066,-124715682,'Scorpio'],
  [-124715682,-124501809,'Sagittarius'],
  [-124501809,-124284336,'Capricorn'],
  [-124284336,-124065947,'Aquarius'],
  [-124065947,-123851271,'Pisces'],
  [-123851271,-123646669,'Aries'],
  [-123646669,-123456390,'Taurus'],
  [-123456390,-123279381,'Gemini'],
  [-123279381,-123109756,'Cancer'],
  [-123109756,-122939466,'Leo'],
  [-122939466,-122760709,'Virgo'],
  [-122760709,-122568393,'Libra'],
  [-122568393,-122362510,'Scorpio'],
  [-122362510,-122147688,'Sagittarius'],
  [-122147688,-121929501,'Capricorn'],
  [-121929501,-121711599,'Aquarius'],
  [-121711599,-121496677,'Pisces'],
  [-121496677,-121288713,'Aries'],
  [-121288713,-121092245,'Taurus'],
  [-121092245,-120909054,'Gemini'],
  [-120909054,-120736054,'Cancer'],
  [-120736054,-120566456,'Leo'],
  [-120566456,-120392210,'Virgo'],
  [-120392210,-120206317,'Libra'],
  [-120206317,-120005604,'Scorpio'],
  [-120005604,-119792695,'Sagittarius'],
  [-119792695,-119574326,'Capricorn'],
  [-119574326,-119356736,'Aquarius'],
  [-119356736,-119143259,'Pisces'],
  [-119143259,-118935842,'Aries'],
  [-118935842,-118736770,'Taurus'],
  [-118736770,-118547952,'Gemini'],
  [-118547952,-118368740,'Cancer'],
  [-118368740,-118195027,'Leo'],
  [-118195027,-118020367,'Virgo'],
  [-118020367,-117837867,'Libra'],
  [-117837867,-117642498,'Scorpio'],
  [-117642498,-117433731,'Sagittarius'],
  [-117433731,-117216630,'Capricorn'],
  [-117216630,-116999007,'Aquarius'],
  [-116999007,-116786643,'Pisces'],
  [-116786643,-116581744,'Aries'],
  [-116581744,-116384461,'Taurus'],
  [-116384461,-116194447,'Gemini'],
  [-116194447,-116010849,'Cancer'],
  [-116010849,-115831489,'Leo'],
  [-115831489,-115652511,'Virgo'],
  [-115652511,-115468903,'Libra'],
  [-115468903,-115275844,'Scorpio'],
  [-115275844,-115070834,'Sagittarius'],
  [-115070834,-114855989,'Capricorn'],
  [-114855989,-114638262,'Aquarius'],
  [-114638262,-114425570,'Pisces'],
  [-114425570,-114222310,'Aries'],
  [-114222310,-114028501,'Taurus'],
  [-114028501,-113841596,'Gemini'],
  [-113841596,-113658457,'Cancer'],
  [-113658457,-113476295,'Leo'],
  [-113476295,-113292675,'Virgo'],
  [-113292675,-113105081,'Libra'],
  [-113105081,-112910671,'Scorpio'],
  [-112910671,-112707006,'Sagittarius'],
  [-112707006,-112494055,'Capricorn'],
  [-112494055,-112276301,'Aquarius'],
  [-112276301,-112061884,'Pisces'],
  [-112061884,-111857772,'Aries'],
  [-111857772,-111665822,'Taurus'],
  [-111665822,-111483048,'Gemini'],
  [-111483048,-111304181,'Cancer'],
  [-111304181,-111124104,'Leo'],
  [-111124104,-110939330,'Virgo'],
  [-110939330,-110748335,'Libra'],
  [-110748335,-110550663,'Scorpio'],
  [-110550663,-110345761,'Sagittarius'],
  [-110345761,-110133346,'Capricorn'],
  [-110133346,-109915615,'Aquarius'],
  [-109915615,-109698963,'Pisces'],
  [-109698963,-109491607,'Aries'],
  [-109491607,-109298163,'Taurus'],
  [-109298163,-109117127,'Gemini'],
  [-109117127,-108942686,'Cancer'],
  [-108942686,-108767774,'Leo'],
  [-108767774,-108586493,'Virgo'],
  [-108586493,-108395846,'Libra'],
  [-108395846,-108196052,'Scorpio'],
  [-108196052,-107988831,'Sagittarius'],
  [-107988831,-107775570,'Capricorn'],
  [-107775570,-107557804,'Aquarius'],
  [-107557804,-107339607,'Pisces'],
  [-107339607,-107128240,'Aries'],
  [-107128240,-106930292,'Taurus'],
  [-106930292,-106747003,'Gemini'],
  [-106747003,-106573838,'Cancer'],
  [-106573838,-106403308,'Leo'],
  [-106403308,-106227764,'Virgo'],
  [-106227764,-106041644,'Libra'],
  [-106041644,-105843356,'Scorpio'],
  [-105843356,-105635122,'Sagittarius'],
  [-105635122,-105420555,'Capricorn'],
  [-105420555,-105202591,'Aquarius'],
  [-105202591,-104984197,'Pisces'],
  [-104984197,-104770353,'Aries'],
  [-104770353,-104567270,'Taurus'],
  [-104567270,-104378505,'Gemini'],
  [-104378505,-104202209,'Cancer'],
  [-104202209,-104032219,'Leo'],
  [-104032219,-103860729,'Virgo'],
  [-103860729,-103680534,'Libra'],
  [-103680534,-103487265,'Scorpio'],
  [-103487265,-103281120,'Sagittarius'],
  [-103281120,-103066271,'Capricorn'],
  [-103066271,-102847990,'Aquarius'],
  [-102847990,-102630334,'Pisces'],
  [-102630334,-102416743,'Aries'],
  [-102416743,-102211122,'Taurus'],
  [-102211122,-102016870,'Gemini'],
  [-102016870,-101834468,'Cancer'],
  [-101834468,-101660453,'Leo'],
  [-101660453,-101488626,'Virgo'],
  [-101488626,-101311912,'Libra'],
  [-101311912,-101124260,'Scorpio'],
  [-101124260,-100922874,'Sagittarius'],
  [-100922874,-100709891,'Capricorn'],
  [-100709891,-100491554,'Aquarius'],
  [-100491554,-100274467,'Pisces'],
  [-100274467,-100062810,'Aries'],
  [-100062810,-99858550,'Taurus'],
  [-99858550,-99662643,'Gemini'],
  [-99662643,-99475263,'Cancer'],
  [-99475263,-99295016,'Leo'],
  [-99295016,-99118489,'Virgo'],
  [-99118489,-98940598,'Libra'],
  [-98940598,-98755618,'Scorpio'],
  [-98755618,-98558930,'Sagittarius'],
  [-98558930,-98349529,'Capricorn'],
  [-98349529,-98131958,'Aquarius'],
  [-98131958,-97914513,'Pisces'],
  [-97914513,-97704061,'Aries'],
  [-97704061,-97502962,'Taurus'],
  [-97502962,-97309971,'Gemini'],
  [-97309971,-97122650,'Cancer'],
  [-97122650,-96938819,'Leo'],
  [-96938819,-96756648,'Virgo'],
  [-96756648,-96573874,'Libra'],
  [-96573874,-96387082,'Scorpio'],
  [-96387082,-96192078,'Sagittarius'],
  [-96192078,-95985878,'Capricorn'],
  [-95985878,-95769891,'Aquarius'],
  [-95769891,-95551438,'Pisces'],
  [-95551438,-95339839,'Aries'],
  [-95339839,-95140122,'Taurus'],
  [-95140122,-94951173,'Gemini'],
  [-94951173,-94768365,'Cancer'],
  [-94768365,-94586774,'Leo'],
  [-94586774,-94403118,'Virgo'],
  [-94403118,-94216045,'Libra'],
  [-94216045,-94024816,'Scorpio'],
  [-94024816,-93827721,'Sagittarius'],
  [-93827721,-93622254,'Capricorn'],
  [-93622254,-93407688,'Aquarius'],
  [-93407688,-93188454,'Pisces'],
  [-93188454,-92973834,'Aries'],
  [-92973834,-92771844,'Taurus'],
  [-92771844,-92583870,'Gemini'],
  [-92583870,-92405349,'Cancer'],
  [-92405349,-92229457,'Leo'],
  [-92229457,-92050127,'Virgo'],
  [-92050127,-91863894,'Libra'],
  [-91863894,-91670185,'Scorpio'],
  [-91670185,-91469642,'Sagittarius'],
  [-91469642,-91262290,'Capricorn'],
  [-91262290,-91047841,'Aquarius'],
  [-91047841,-90828452,'Pisces'],
  [-90828452,-90610974,'Aries'],
  [-90610974,-90404218,'Taurus'],
  [-90404218,-90212753,'Gemini'],
  [-90212753,-90034316,'Cancer'],
  [-90034316,-89862306,'Leo'],
  [-89862306,-89689171,'Virgo'],
  [-89689171,-89508722,'Libra'],
  [-89508722,-89317779,'Scorpio'],
  [-89317779,-89116505,'Sagittarius'],
  [-89116505,-88906954,'Capricorn'],
  [-88906954,-88691315,'Aquarius'],
  [-88691315,-88471969,'Pisces'],
  [-88471969,-88253409,'Aries'],
  [-88253409,-88042531,'Taurus'],
  [-88042531,-87845192,'Gemini'],
  [-87845192,-87662220,'Cancer'],
  [-87662220,-87489222,'Leo'],
  [-87489222,-87319157,'Virgo'],
  [-87319157,-87144722,'Libra'],
  [-87144722,-86960109,'Scorpio'],
  [-86960109,-86762626,'Sagittarius'],
  [-86762626,-86553498,'Capricorn'],
  [-86553498,-86336834,'Aquarius'],
  [-86336834,-86117311,'Pisces'],
  [-86117311,-85899275,'Aries'],
  [-85899275,-85687218,'Taurus'],
  [-85687218,-85485478,'Gemini'],
  [-85485478,-85296278,'Cancer'],
  [-85296278,-85118092,'Leo'],
  [-85118092,-84946117,'Virgo'],
  [-84946117,-84773833,'Libra'],
  [-84773833,-84594542,'Scorpio'],
  [-84594542,-84403017,'Sagittarius'],
  [-84403017,-84197606,'Capricorn'],
  [-84197606,-83981692,'Aquarius'],
  [-83981692,-83762021,'Pisces'],
  [-83762021,-83544910,'Aries'],
  [-83544910,-83334251,'Taurus'],
  [-83334251,-83131950,'Gemini'],
  [-83131950,-82938919,'Cancer'],
  [-82938919,-82754833,'Leo'],
  [-82754833,-82577508,'Virgo'],
  [-82577508,-82402723,'Libra'],
  [-82402723,-82224732,'Scorpio'],
  [-82224732,-82037506,'Sagittarius'],
  [-82037506,-81836908,'Capricorn'],
  [-81836908,-81623647,'Aquarius'],
  [-81623647,-81404331,'Pisces'],
  [-81404331,-81187586,'Aries'],
  [-81187586,-80978847,'Taurus'],
  [-80978847,-80778988,'Gemini'],
  [-80778988,-80586512,'Cancer'],
  [-80586512,-80399758,'Leo'],
  [-80399758,-80217385,'Virgo'],
  [-80217385,-80037537,'Libra'],
  [-80037537,-79856784,'Scorpio'],
  [-79856784,-79670138,'Sagittarius'],
  [-79670138,-79472638,'Capricorn'],
  [-79472638,-79262473,'Aquarius'],
  [-79262473,-79044075,'Pisces'],
  [-79044075,-78826823,'Aries'],
  [-78826823,-78618625,'Taurus'],
  [-78618625,-78421427,'Gemini'],
  [-78421427,-78232437,'Cancer'],
  [-78232437,-78047634,'Leo'],
  [-78047634,-77864110,'Virgo'],
  [-77864110,-77680416,'Libra'],
  [-77680416,-77495219,'Scorpio'],
  [-77495219,-77305837,'Sagittarius'],
  [-77305837,-77108382,'Capricorn'],
  [-77108382,-76900038,'Aquarius'],
  [-76900038,-76682681,'Pisces'],
  [-76682681,-76464314,'Aries'],
  [-76464314,-76254509,'Taurus'],
  [-76254509,-76057697,'Gemini'],
  [-76057697,-75871787,'Cancer'],
  [-75871787,-75691416,'Leo'],
  [-75691416,-75511312,'Virgo'],
  [-75511312,-75328126,'Libra'],
  [-75328126,-75140469,'Scorpio'],
  [-75140469,-74947489,'Sagittarius'],
  [-74947489,-74747614,'Capricorn'],
  [-74747614,-74539030,'Aquarius'],
  [-74539030,-74322253,'Pisces'],
  [-74322253,-74102822,'Aries'],
  [-74102822,-73889888,'Taurus'],
  [-73889888,-73690267,'Gemini'],
  [-73690267,-73504262,'Cancer'],
  [-73504262,-73327060,'Leo'],
  [-73327060,-73152137,'Virgo'],
  [-73152137,-72973725,'Libra'],
  [-72973725,-72788172,'Scorpio'],
  [-72788172,-72594121,'Sagittarius'],
  [-72594121,-72391632,'Capricorn'],
  [-72391632,-72181260,'Aquarius'],
  [-72181260,-71964273,'Pisces'],
  [-71964273,-71744420,'Aries'],
  [-71744420,-71528621,'Taurus'],
  [-71528621,-71324145,'Gemini'],
  [-71324145,-71134106,'Cancer'],
  [-71134106,-70956044,'Leo'],
  [-70956044,-70784048,'Virgo'],
  [-70784048,-70611238,'Libra'],
  [-70611238,-70431486,'Scorpio'],
  [-70431486,-70240827,'Sagittarius'],
  [-70240827,-70038435,'Capricorn'],
  [-70038435,-69826474,'Aquarius'],
  [-69826474,-69608630,'Pisces'],
  [-69608630,-69388992,'Aries'],
  [-69388992,-69172298,'Taurus'],
  [-69172298,-68963853,'Gemini'],
  [-68963853,-68767766,'Cancer'],
  [-68767766,-68584552,'Leo'],
  [-68584552,-68410748,'Virgo'],
  [-68410748,-68240269,'Libra'],
  [-68240269,-68066048,'Scorpio'],
  [-68066048,-67881639,'Sagittarius'],
  [-67881639,-67683315,'Capricorn'],
  [-67683315,-67472140,'Aquarius'],
  [-67472140,-67253619,'Pisces'],
  [-67253619,-67034238,'Aries'],
  [-67034238,-66818627,'Taurus'],
  [-66818627,-66609610,'Gemini'],
  [-66609610,-66409479,'Cancer'],
  [-66409479,-66219798,'Leo'],
  [-66219798,-66040054,'Virgo'],
  [-66040054,-65866778,'Libra'],
  [-65866778,-65693954,'Scorpio'],
  [-65693954,-65514423,'Sagittarius'],
  [-65514423,-65322000,'Capricorn'],
  [-65322000,-65114651,'Aquarius'],
  [-65114651,-64896896,'Pisces'],
  [-64896896,-64677414,'Aries'],
  [-64677414,-64463131,'Taurus'],
  [-64463131,-64256394,'Gemini'],
  [-64256394,-64056871,'Cancer'],
  [-64056871,-63864204,'Leo'],
  [-63864204,-63678536,'Virgo'],
  [-63678536,-63499109,'Libra'],
  [-63499109,-63322662,'Scorpio'],
  [-63322662,-63143419,'Sagittarius'],
  [-63143419,-62954737,'Capricorn'],
  [-62954737,-62752092,'Aquarius'],
  [-62752092,-62536888,'Pisces'],
  [-62536888,-62317345,'Aries'],
  [-62317345,-62103008,'Taurus'],
  [-62103008,-61898348,'Gemini'],
  [-61898348,-61702351,'Cancer'],
  [-61702351,-61512052,'Leo'],
  [-61512052,-61325353,'Virgo'],
  [-61325353,-61141479,'Libra'],
  [-61141479,-60959398,'Scorpio'],
  [-60959398,-60776130,'Sagittarius'],
  [-60776130,-60586779,'Capricorn'],
  [-60586779,-60386528,'Aquarius'],
  [-60386528,-60174171,'Pisces'],
  [-60174171,-59955112,'Aries'],
  [-59955112,-59739268,'Taurus'],
  [-59739268,-59534057,'Gemini'],
  [-59534057,-59340374,'Cancer'],
  [-59340374,-59154566,'Leo'],
  [-59154566,-58972038,'Virgo'],
  [-58972038,-58789443,'Libra'],
  [-58789443,-58604983,'Scorpio'],
  [-58604983,-58417263,'Sagittarius'],
  [-58417263,-58224107,'Capricorn'],
  [-58224107,-58022698,'Aquarius'],
  [-58022698,-57811494,'Pisces'],
  [-57811494,-57593193,'Aries'],
  [-57593193,-57375524,'Taurus'],
  [-57375524,-57167169,'Gemini'],
  [-57167169,-56972090,'Cancer'],
  [-56972090,-56788348,'Leo'],
  [-56788348,-56610771,'Virgo'],
  [-56610771,-56433693,'Libra'],
  [-56433693,-56252561,'Scorpio'],
  [-56252561,-56064567,'Sagittarius'],
  [-56064567,-55868485,'Capricorn'],
  [-55868485,-55664082,'Aquarius'],
  [-55664082,-55451820,'Pisces'],
  [-55451820,-55233796,'Aries'],
  [-55233796,-55015062,'Taurus'],
  [-55015062,-54802936,'Gemini'],
  [-54802936,-54603321,'Cancer'],
  [-54603321,-54417274,'Leo'],
  [-54417274,-54241200,'Virgo'],
  [-54241200,-54068990,'Libra'],
  [-54068990,-53894024,'Scorpio'],
  [-53894024,-53710724,'Sagittarius'],
  [-53710724,-53515991,'Capricorn'],
  [-53515991,-53310114,'Aquarius'],
  [-53310114,-53096017,'Pisces'],
  [-53096017,-52877510,'Aries'],
  [-52877510,-52658664,'Taurus'],
  [-52658664,-52444300,'Gemini'],
  [-52444300,-52239722,'Cancer'],
  [-52239722,-52048237,'Leo'],
  [-52048237,-51869099,'Virgo'],
  [-51869099,-51697674,'Libra'],
  [-51697674,-51527056,'Scorpio'],
  [-51527056,-51349901,'Sagittarius'],
  [-51349901,-51160392,'Capricorn'],
  [-51160392,-50956708,'Aquarius'],
  [-50956708,-50742203,'Pisces'],
  [-50742203,-50523042,'Aries'],
  [-50523042,-50304557,'Taurus'],
  [-50304557,-50090211,'Gemini'],
  [-50090211,-49883058,'Cancer'],
  [-49883058,-49686254,'Leo'],
  [-49686254,-49501304,'Virgo'],
  [-49501304,-49326258,'Libra'],
  [-49326258,-49155655,'Scorpio'],
  [-49155655,-48982077,'Sagittarius'],
  [-48982077,-48798180,'Capricorn'],
  [-48798180,-48599428,'Aquarius'],
  [-48599428,-48387100,'Pisces'],
  [-48387100,-48168052,'Aries'],
  [-48168052,-47949901,'Taurus'],
  [-47949901,-47736888,'Gemini'],
  [-47736888,-47530399,'Cancer'],
  [-47530399,-47331497,'Leo'],
  [-47331497,-47141591,'Virgo'],
  [-47141591,-46960802,'Libra'],
  [-46960802,-46786203,'Scorpio'],
  [-46786203,-46611919,'Sagittarius'],
  [-46611919,-46430760,'Capricorn'],
  [-46430760,-46236698,'Aquarius'],
  [-46236698,-46028246,'Pisces'],
  [-46028246,-45810559,'Aries'],
  [-45810559,-45592506,'Taurus'],
  [-45592506,-45380564,'Gemini'],
  [-45380564,-45176434,'Cancer'],
  [-45176434,-44979285,'Leo'],
  [-44979285,-44788397,'Virgo'],
  [-44788397,-44603579,'Libra'],
  [-44603579,-44423668,'Scorpio'],
  [-44423668,-44245226,'Sagittarius'],
  [-44245226,-44062814,'Capricorn'],
  [-44062814,-43870684,'Aquarius'],
  [-43870684,-43665649,'Pisces'],
  [-43665649,-43450109,'Aries'],
  [-43450109,-43231982,'Taurus'],
  [-43231982,-43019710,'Gemini'],
  [-43019710,-42817126,'Cancer'],
  [-42817126,-42623336,'Leo'],
  [-42623336,-42435561,'Virgo'],
  [-42435561,-42251307,'Libra'],
  [-42251307,-42068720,'Scorpio'],
  [-42068720,-41885727,'Sagittarius'],
  [-41885727,-41699294,'Capricorn'],
  [-41699294,-41505651,'Aquarius'],
  [-41505651,-41301807,'Pisces'],
  [-41301807,-41088098,'Aries'],
  [-41088098,-40869915,'Taurus'],
  [-40869915,-40655782,'Gemini'],
  [-40655782,-40452135,'Cancer'],
  [-40452135,-40260058,'Leo'],
  [-40260058,-40076475,'Virgo'],
  [-40076475,-39896743,'Libra'],
  [-39896743,-39716490,'Scorpio'],
  [-39716490,-39532459,'Sagittarius'],
  [-39532459,-39342545,'Capricorn'],
  [-39342545,-39145399,'Aquarius'],
  [-39145399,-38940138,'Pisces'],
  [-38940138,-38726979,'Aries'],
  [-38726979,-38508903,'Taurus'],
  [-38508903,-38292397,'Gemini'],
  [-38292397,-38085040,'Cancer'],
  [-38085040,-37890932,'Leo'],
  [-37890932,-37708847,'Virgo'],
  [-37708847,-37533764,'Libra'],
  [-37533764,-37359221,'Scorpio'],
  [-37359221,-37179264,'Sagittarius'],
  [-37179264,-36990036,'Capricorn'],
  [-36990036,-36790704,'Aquarius'],
  [-36790704,-36582835,'Pisces'],
  [-36582835,-36368713,'Aries'],
  [-36368713,-36150783,'Taurus'],
  [-36150783,-35932911,'Gemini'],
  [-35932911,-35721255,'Cancer'],
  [-35721255,-35521824,'Leo'],
  [-35521824,-35336596,'Virgo'],
  [-35336596,-35162334,'Libra'],
  [-35162334,-34992308,'Scorpio'],
  [-34992308,-34818731,'Sagittarius'],
  [-34818731,-34634936,'Capricorn'],
  [-34634936,-34437782,'Aquarius'],
  [-34437782,-34229014,'Pisces'],
  [-34229014,-34013387,'Aries'],
  [-34013387,-33795267,'Taurus'],
  [-33795267,-33577610,'Gemini'],
  [-33577610,-33363881,'Cancer'],
  [-33363881,-33159113,'Leo'],
  [-33159113,-32967475,'Virgo'],
  [-32967475,-32788949,'Libra'],
  [-32788949,-32618635,'Scorpio'],
  [-32618635,-32448818,'Sagittarius'],
  [-32448818,-32271363,'Capricorn'],
  [-32271363,-32080234,'Aquarius'],
  [-32080234,-31874463,'Pisces'],
  [-31874463,-31658827,'Aries'],
  [-31658827,-31440230,'Taurus'],
  [-31440230,-31223391,'Gemini'],
  [-31223391,-31010580,'Cancer'],
  [-31010580,-30804135,'Leo'],
  [-30804135,-30607287,'Virgo'],
  [-30607287,-30422023,'Libra'],
  [-30422023,-30246534,'Scorpio'],
  [-30246534,-30075157,'Sagittarius'],
  [-30075157,-29900310,'Capricorn'],
  [-29900310,-29714780,'Aquarius'],
  [-29714780,-29514598,'Pisces'],
  [-29514598,-29301712,'Aries'],
  [-29301712,-29083251,'Taurus'],
  [-29083251,-28866647,'Gemini'],
  [-28866647,-28655721,'Cancer'],
  [-28655721,-28451431,'Leo'],
  [-28451431,-28254279,'Virgo'],
  [-28254279,-28065022,'Libra'],
  [-28065022,-27883336,'Scorpio'],
  [-27883336,-27706395,'Sagittarius'],
  [-27706395,-27528984,'Capricorn'],
  [-27528984,-27344878,'Aquarius'],
  [-27344878,-27149013,'Pisces'],
  [-27149013,-26940254,'Aries'],
  [-26940254,-26723196,'Taurus'],
  [-26723196,-26506121,'Gemini'],
  [-26506121,-26295710,'Cancer'],
  [-26295710,-26094199,'Leo'],
  [-26094199,-25900588,'Virgo'],
  [-25900588,-25712870,'Libra'],
  [-25712870,-25529117,'Scorpio'],
  [-25529117,-25347288,'Sagittarius'],
  [-25347288,-25164647,'Capricorn'],
  [-25164647,-24977565,'Aquarius'],
  [-24977565,-24782185,'Pisces'],
  [-24782185,-24576164,'Aries'],
  [-24576164,-24361068,'Taurus'],
  [-24361068,-24143382,'Gemini'],
  [-24143382,-23931446,'Cancer'],
  [-23931446,-23730343,'Leo'],
  [-23730343,-23540031,'Virgo'],
  [-23540031,-23356962,'Libra'],
  [-23356962,-23176524,'Scorpio'],
  [-23176524,-22994738,'Sagittarius'],
  [-22994738,-22808946,'Capricorn'],
  [-22808946,-22617600,'Aquarius'],
  [-22617600,-22419467,'Pisces'],
  [-22419467,-22213357,'Aries'],
  [-22213357,-21999419,'Taurus'],
  [-21999419,-21781364,'Gemini'],
  [-21781364,-21566753,'Cancer'],
  [-21566753,-21362999,'Leo'],
  [-21362999,-21172713,'Virgo'],
  [-21172713,-20993000,'Libra'],
  [-20993000,-20817824,'Scorpio'],
  [-20817824,-20640722,'Sagittarius'],
  [-20640722,-20456819,'Capricorn'],
  [-20456819,-20264059,'Aquarius'],
  [-20264059,-20062941,'Pisces'],
  [-20062941,-19854759,'Aries'],
  [-19854759,-19640542,'Taurus'],
  [-19640542,-19422343,'Gemini'],
  [-19422343,-19205395,'Cancer'],
  [-19205395,-18997322,'Leo'],
  [-18997322,-18803419,'Virgo'],
  [-18803419,-18623153,'Libra'],
  [-18623153,-18450974,'Scorpio'],
  [-18450974,-18279269,'Sagittarius'],
  [-18279269,-18100893,'Capricorn'],
  [-18100893,-17911334,'Aquarius'],
  [-17911334,-17710196,'Pisces'],
  [-17710196,-17500286,'Aries'],
  [-17500286,-17284911,'Taurus'],
  [-17284911,-17066606,'Gemini'],
  [-17066606,-16848720,'Cancer'],
  [-16848720,-16637053,'Leo'],
  [-16637053,-16437786,'Virgo'],
  [-16437786,-16253141,'Libra'],
  [-16253141,-16079692,'Scorpio'],
  [-16079692,-15910368,'Sagittarius'],
  [-15910368,-15737178,'Capricorn'],
  [-15737178,-15553450,'Aquarius'],
  [-15553450,-15356146,'Pisces'],
  [-15356146,-15147035,'Aries'],
  [-15147035,-14930936,'Taurus'],
  [-14930936,-14712474,'Gemini'],
  [-14712474,-14495019,'Cancer'],
  [-14495019,-14282299,'Leo'],
  [-14282299,-14079010,'Virgo'],
  [-14079010,-13888539,'Libra'],
  [-13888539,-13710131,'Scorpio'],
  [-13710131,-13538785,'Sagittarius'],
  [-13538785,-13367278,'Capricorn'],
  [-13367278,-13188288,'Aquarius'],
  [-13188288,-12996559,'Pisces'],
  [-12996559,-12791127,'Aries'],
  [-12791127,-12575942,'Taurus'],
  [-12575942,-12357428,'Gemini'],
  [-12357428,-12140854,'Cancer'],
  [-12140854,-11929485,'Leo'],
  [-11929485,-11725738,'Virgo'],
  [-11725738,-11531605,'Libra'],
  [-11531605,-11347444,'Scorpio'],
  [-11347444,-11170781,'Sagittarius'],
  [-11170781,-10996605,'Capricorn'],
  [-10996605,-10818634,'Aquarius'],
  [-10818634,-10630973,'Pisces'],
  [-10630973,-10430245,'Aries'],
  [-10430245,-10217729,'Taurus'],
  [-10217729,-9999569,'Gemini'],
  [-9999569,-9783304,'Cancer'],
  [-9783304,-9573841,'Leo'],
  [-9573841,-9372662,'Virgo'],
  [-9372662,-9179272,'Libra'],
  [-9179272,-8992516,'Scorpio'],
  [-8992516,-8810707,'Sagittarius'],
  [-8810707,-8631201,'Capricorn'],
  [-8631201,-8450158,'Aquarius'],
  [-8450158,-8262921,'Pisces'],
  [-8262921,-8065320,'Aries'],
  [-8065320,-7855992,'Taurus'],
  [-7855992,-7638732,'Gemini'],
  [-7638732,-7421744,'Cancer'],
  [-7421744,-7212630,'Leo'],
  [-7212630,-7014199,'Virgo'],
  [-7014199,-6824676,'Libra'],
  [-6824676,-6640303,'Scorpio'],
  [-6640303,-6457568,'Sagittarius'],
  [-6457568,-6274080,'Capricorn'],
  [-6274080,-6088163,'Aquarius'],
  [-6088163,-5897784,'Pisces'],
  [-5897784,-5700099,'Aries'],
  [-5700099,-5492719,'Taurus'],
  [-5492719,-5276627,'Gemini'],
  [-5276627,-5058314,'Cancer'],
  [-5058314,-4847063,'Leo'],
  [-4847063,-4648615,'Virgo'],
  [-4648615,-4462240,'Libra'],
  [-4462240,-4282835,'Scorpio'],
  [-4282835,-4104291,'Sagittarius'],
  [-4104291,-3921939,'Capricorn'],
  [-3921939,-3733695,'Aquarius'],
  [-3733695,-3539391,'Pisces'],
  [-3539391,-3338872,'Aries'],
  [-3338872,-3131098,'Taurus'],
  [-3131098,-2915756,'Gemini'],
  [-2915756,-2696492,'Cancer'],
  [-2696492,-2481689,'Leo'],
  [-2481689,-2279560,'Virgo'],
  [-2279560,-2092339,'Libra'],
  [-2092339,-1915852,'Scorpio'],
  [-1915852,-1742878,'Sagittarius'],
  [-1742878,-1566285,'Capricorn'],
  [-1566285,-1381247,'Aquarius'],
  [-1381247,-1186483,'Pisces'],
  [-1186483,-983315,'Aries'],
  [-983315,-773400,'Taurus'],
  [-773400,-557733,'Gemini'],
  [-557733,-338383,'Cancer'],
  [-338383,-121002,'Leo'],
  [-121002,86396,'Virgo'],
  [86396,278715,'Libra'],
  [278715,457235,'Scorpio'],
  [457235,628122,'Sagittarius'],
  [628122,799208,'Capricorn'],
  [799208,977582,'Aquarius'],
  [977582,1167605,'Pisces'],
  [1167605,1369662,'Aries'],
  [1369662,1580955,'Taurus'],
  [1580955,1797770,'Gemini'],
  [1797770,2016884,'Cancer'],
  [2016884,2234474,'Leo'],
  [2234474,2445089,'Virgo'],
  [2445089,2643491,'Libra'],
  [2643491,2828115,'Scorpio'],
  [2828115,3002271,'Sagittarius'],
  [3002271,3172426,'Capricorn'],
  [3172426,3345954,'Aquarius'],
  [3345954,3529307,'Pisces'],
  [3529307,3726102,'Aries'],
  [3726102,3935553,'Taurus'],
  [3935553,4152844,'Gemini'],
  [4152844,4372020,'Cancer'],
  [4372020,4588396,'Leo'],
  [4588396,4798561,'Virgo'],
  [4798561,4999719,'Libra'],
  [4999719,5190205,'Scorpio'],
  [5190205,5370803,'Sagittarius'],
  [5370803,5545122,'Capricorn'],
  [5545122,5718832,'Aquarius'],
  [5718832,5898386,'Pisces'],
  [5898386,6089384,'Aries'],
  [6089384,6294253,'Taurus'],
  [6294253,6510042,'Gemini'],
  [6510042,6729349,'Cancer'],
  [6729349,6944851,'Leo'],
  [6944851,7152679,'Virgo'],
  [7152679,7352219,'Libra'],
  [7352219,7544163,'Scorpio'],
  [7544163,7729516,'Sagittarius'],
  [7729516,7909848,'Capricorn'],
  [7909848,8088033,'Aquarius'],
  [8088033,8268599,'Pisces'],
  [8268599,8456997,'Aries'],
  [8456997,8657590,'Taurus'],
  [8657590,8870473,'Gemini'],
  [8870473,9089472,'Cancer'],
  [9089472,9305280,'Leo'],
  [9305280,9511630,'Virgo'],
  [9511630,9707877,'Libra'],
  [9707877,9896889,'Scorpio'],
  [9896889,10081997,'Sagittarius'],
  [10081997,10265441,'Capricorn'],
  [10265441,10448599,'Aquarius'],
  [10448599,10633385,'Pisces'],
  [10633385,10823249,'Aries'],
  [10823249,11022363,'Taurus'],
  [11022363,11232818,'Gemini'],
  [11232818,11451125,'Cancer'],
  [11451125,11668225,'Leo'],
  [11668225,11875402,'Virgo'],
  [11875402,12069974,'Libra'],
  [12069974,12255065,'Scorpio'],
  [12255065,12436042,'Sagittarius'],
  [12436042,12617511,'Capricorn'],
  [12617511,12801989,'Aquarius'],
  [12801989,12990409,'Pisces'],
  [12990409,13183845,'Aries'],
  [13183845,13384478,'Taurus'],
  [13384478,13594340,'Gemini'],
  [13594340,13812080,'Cancer'],
  [13812080,14030737,'Leo'],
  [14030737,14240809,'Virgo'],
  [14240809,14436917,'Libra'],
  [14436917,14620509,'Scorpio'],
  [14620509,14797272,'Sagittarius'],
  [14797272,14973666,'Capricorn'],
  [14973666,15154669,'Aquarius'],
  [15154669,15342767,'Pisces'],
  [15342767,15538485,'Aries'],
  [15538485,15741808,'Taurus'],
  [15741808,15952863,'Gemini'],
  [15952863,16170585,'Cancer'],
  [16170585,16390274,'Leo'],
  [16390274,16603804,'Virgo'],
  [16603804,16804181,'Libra'],
  [16804181,16990115,'Scorpio'],
  [16990115,17165814,'Sagittarius'],
  [17165814,17337977,'Capricorn'],
  [17337977,17513292,'Aquarius'],
  [17513292,17696811,'Pisces'],
  [17696811,17890938,'Aries'],
  [17890938,18095391,'Taurus'],
  [18095391,18308129,'Gemini'],
  [18308129,18526394,'Cancer'],
  [18526394,18746256,'Leo'],
  [18746256,18961904,'Virgo'],
  [18961904,19167054,'Libra'],
  [19167054,19358312,'Scorpio'],
  [19358312,19537177,'Sagittarius'],
  [19537177,19708867,'Capricorn'],
  [19708867,19880171,'Aquarius'],
  [19880171,20057779,'Pisces'],
  [20057779,20246761,'Aries'],
  [20246761,20448930,'Taurus'],
  [20448930,20661987,'Gemini'],
  [20661987,20880893,'Cancer'],
  [20880893,21100379,'Leo'],
  [21100379,21315912,'Virgo'],
  [21315912,21523536,'Libra'],
  [21523536,21720153,'Scorpio'],
  [21720153,21905026,'Sagittarius'],
  [21905026,22080635,'Capricorn'],
  [22080635,22252150,'Aquarius'],
  [22252150,22426225,'Pisces'],
  [22426225,22609533,'Aries'],
  [22609533,22806669,'Taurus'],
  [22806669,23017487,'Gemini'],
  [23017487,23236333,'Cancer'],
  [23236333,23455498,'Leo'],
  [23455498,23669533,'Virgo'],
  [23669533,23876212,'Libra'],
  [23876212,24074787,'Scorpio'],
  [24074787,24264794,'Sagittarius'],
  [24264794,24446616,'Capricorn'],
  [24446616,24622631,'Aquarius'],
  [24622631,24797670,'Pisces'],
  [24797670,24978199,'Aries'],
  [24978199,25170417,'Taurus'],
  [25170417,25377112,'Gemini'],
  [25377112,25594567,'Cancer'],
  [25594567,25813798,'Leo'],
  [25813798,26026794,'Virgo'],
  [26026794,26230808,'Libra'],
  [26230808,26427108,'Scorpio'],
  [26427108,26617687,'Sagittarius'],
  [26617687,26803566,'Capricorn'],
  [26803566,26985393,'Aquarius'],
  [26985393,27165221,'Pisces'],
  [27165221,27347437,'Aries'],
  [27347437,27537819,'Taurus'],
  [27537819,27740860,'Gemini'],
  [27740860,27955902,'Cancer'],
  [27955902,28175315,'Leo'],
  [28175315,28389045,'Virgo'],
  [28389045,28591744,'Libra'],
  [28591744,28784418,'Scorpio'],
  [28784418,28971124,'Sagittarius'],
  [28971124,29155549,'Capricorn'],
  [29155549,29339595,'Aquarius'],
  [29339595,29524164,'Pisces'],
  [29524164,29711006,'Aries'],
  [29711006,29903542,'Taurus'],
  [29903542,30105671,'Gemini'],
  [30105671,30318667,'Cancer'],
  [30318667,30537910,'Leo'],
  [30537910,30753842,'Virgo'],
  [30753842,30958404,'Libra'],
  [30958404,31150052,'Scorpio'],
  [31150052,31332626,'Sagittarius'],
  [31332626,31511736,'Capricorn'],
  [31511736,31692137,'Aquarius'],
  [31692137,31876658,'Pisces'],
  [31876658,32066627,'Aries'],
  [32066627,32263075,'Taurus'],
  [32263075,32467325,'Gemini'],
  [32467325,32680053,'Cancer'],
  [32680053,32898844,'Leo'],
  [32898844,33116846,'Virgo'],
  [33116846,33325597,'Libra'],
  [33325597,33520451,'Scorpio'],
  [33520451,33702768,'Sagittarius'],
  [33702768,33877828,'Capricorn'],
  [33877828,34052062,'Aquarius'],
  [34052062,34231177,'Pisces'],
  [34231177,34418970,'Aries'],
  [34418970,34616772,'Taurus'],
  [34616772,34823773,'Gemini'],
  [34823773,35038013,'Cancer'],
  [35038013,35256700,'Leo'],
  [35256700,35475384,'Virgo'],
  [35475384,35687831,'Libra'],
  [35687831,35888335,'Scorpio'],
  [35888335,36075070,'Sagittarius'],
  [36075070,36250872,'Capricorn'],
  [36250872,36421684,'Aquarius'],
  [36421684,36594580,'Pisces'],
  [36594580,36776078,'Aries'],
  [36776078,36970300,'Taurus'],
  [36970300,37177234,'Gemini'],
  [37177234,37392933,'Cancer'],
  [37392933,37612129,'Leo'],
  [37612129,37830358,'Virgo'],
  [37830358,38043855,'Libra'],
  [38043855,38248667,'Scorpio'],
  [38248667,38441687,'Sagittarius'],
  [38441687,38622694,'Capricorn'],
  [38622694,38795223,'Aquarius'],
  [38795223,38965685,'Pisces'],
  [38965685,39141614,'Aries'],
  [39141614,39329634,'Taurus'],
  [39329634,39532649,'Gemini'],
  [39532649,39747601,'Cancer'],
  [39747601,39967210,'Leo'],
  [39967210,40184848,'Virgo'],
  [40184848,40397138,'Libra'],
  [40397138,40602553,'Scorpio'],
  [40602553,40799476,'Sagittarius'],
  [40799476,40986561,'Capricorn'],
  [40986561,41164557,'Aquarius'],
  [41164557,41337517,'Pisces'],
  [41337517,41512086,'Aries'],
  [41512086,41695595,'Taurus'],
  [41695595,41893342,'Gemini'],
  [41893342,42105111,'Cancer'],
  [42105111,42324135,'Leo'],
  [42324135,42541597,'Virgo'],
  [42541597,42752325,'Libra'],
  [42752325,42955546,'Scorpio'],
  [42955546,43152001,'Sagittarius'],
  [43152001,43341856,'Capricorn'],
  [43341856,43525084,'Aquarius'],
  [43525084,43703307,'Pisces'],
  [43703307,43880844,'Aries'],
  [43880844,44063893,'Taurus'],
  [44063893,44258334,'Gemini'],
  [44258334,44466395,'Cancer'],
  [44466395,44683811,'Leo'],
  [44683811,44901508,'Virgo'],
  [44901508,45111899,'Libra'],
  [45111899,45312814,'Scorpio'],
  [45312814,45506010,'Sagittarius'],
  [45506010,45694009,'Capricorn'],
  [45694009,45878483,'Aquarius'],
  [45878483,46060709,'Pisces'],
  [46060709,46242948,'Aries'],
  [46242948,46429058,'Taurus'],
  [46429058,46623624,'Gemini'],
  [46623624,46829601,'Cancer'],
  [46829601,47045274,'Leo'],
  [47045274,47263402,'Virgo'],
  [47263402,47475188,'Libra'],
  [47475188,47675918,'Scorpio'],
  [47675918,47866319,'Sagittarius'],
  [47866319,48050075,'Capricorn'],
  [48050075,48231254,'Aquarius'],
  [48231254,48413072,'Pisces'],
  [48413072,48597911,'Aries'],
  [48597911,48787894,'Taurus'],
  [48787894,48985217,'Gemini'],
  [48985217,49191575,'Cancer'],
  [49191575,49406352,'Leo'],
  [49406352,49624852,'Virgo'],
  [49624852,49839179,'Libra'],
  [49839179,50042541,'Scorpio'],
  [50042541,50233135,'Sagittarius'],
  [50233135,50413879,'Capricorn'],
  [50413879,50590060,'Aquarius'],
  [50590060,50767290,'Pisces'],
  [50767290,50950141,'Aries'],
  [50950141,51141317,'Taurus'],
  [51141317,51341495,'Gemini'],
  [51341495,51549942,'Cancer'],
  [51549942,51765062,'Leo'],
  [51765062,51983719,'Virgo'],
  [51983719,52200357,'Libra'],
  [52200357,52408104,'Scorpio'],
  [52408104,52602502,'Sagittarius'],
  [52602502,52784010,'Capricorn'],
  [52784010,52957291,'Aquarius'],
  [52957291,53129115,'Pisces'],
  [53129115,53306381,'Aries'],
  [53306381,53494260,'Taurus'],
  [53494260,53694396,'Gemini'],
  [53694396,53904594,'Cancer'],
  [53904594,54120874,'Leo'],
  [54120874,54339552,'Virgo'],
  [54339552,54557026,'Libra'],
  [54557026,54768447,'Scorpio'],
  [54768447,54968560,'Sagittarius'],
  [54968560,55154903,'Capricorn'],
  [55154903,55329729,'Aquarius'],
  [55329729,55499166,'Pisces'],
  [55499166,55671052,'Aries'],
  [55671052,55852800,'Taurus'],
  [55852800,56048820,'Gemini'],
  [56048820,56258123,'Cancer'],
  [56258123,56475169,'Leo'],
  [56475169,56693957,'Virgo'],
  [56693957,56910771,'Libra'],
  [56910771,57123012,'Scorpio'],
  [57123012,57327225,'Sagittarius'],
  [57327225,57519916,'Capricorn'],
  [57519916,57700395,'Aquarius'],
  [57700395,57872355,'Pisces'],
  [57872355,58042746,'Aries'],
  [58042746,58219595,'Taurus'],
  [58219595,58409554,'Gemini'],
  [58409554,58614683,'Cancer'],
  [58614683,58830637,'Leo'],
  [58830637,59049557,'Virgo'],
  [59049557,59265442,'Libra'],
  [59265442,59475946,'Scorpio'],
  [59475946,59680071,'Sagittarius'],
  [59680071,59876191,'Capricorn'],
  [59876191,60062810,'Aquarius'],
  [60062810,60240877,'Pisces'],
  [60240877,60414770,'Aries'],
  [60414770,60591197,'Taurus'],
  [60591197,60777138,'Gemini'],
  [60777138,60977042,'Cancer'],
  [60977042,61189752,'Leo'],
  [61189752,61408229,'Virgo'],
  [61408229,61624115,'Libra'],
  [61624115,61832835,'Scorpio'],
  [61832835,62033898,'Sagittarius'],
  [62033898,62228284,'Capricorn'],
  [62228284,62416672,'Aquarius'],
  [62416672,62599772,'Pisces'],
  [62599772,62779620,'Aries'],
  [62779620,62960175,'Taurus'],
  [62960175,63146638,'Gemini'],
  [63146638,63343676,'Cancer'],
  [63343676,63552751,'Leo'],
  [63552751,63769861,'Virgo'],
  [63769861,63986689,'Libra'],
  [63986689,64195803,'Scorpio'],
  [64195803,64394607,'Sagittarius'],
  [64394607,64584725,'Capricorn'],
  [64584725,64769485,'Aquarius'],
  [64769485,64952103,'Pisces'],
  [64952103,65135122,'Aries'],
  [65135122,65320729,'Taurus'],
  [65320729,65511290,'Gemini'],
  [65511290,65709403,'Cancer'],
  [65709403,65916839,'Leo'],
  [65916839,66132367,'Virgo'],
  [66132367,66350192,'Libra'],
  [66350192,66561967,'Scorpio'],
  [66561967,66761942,'Sagittarius'],
  [66761942,66949827,'Capricorn'],
  [66949827,67129628,'Aquarius'],
  [67129628,67307050,'Pisces'],
  [67307050,67487339,'Aries'],
  [67487339,67673930,'Taurus'],
  [67673930,67868050,'Gemini'],
  [67868050,68069550,'Cancer'],
  [68069550,68278114,'Leo'],
  [68278114,68493028,'Virgo'],
  [68493028,68711255,'Libra'],
  [68711255,68926199,'Scorpio'],
  [68926199,69130398,'Sagittarius'],
  [69130398,69320379,'Capricorn'],
  [69320379,69498467,'Aquarius'],
  [69498467,69670934,'Pisces'],
  [69670934,69845153,'Aries'],
  [69845153,70027312,'Taurus'],
  [70027312,70220481,'Gemini'],
  [70220481,70423902,'Cancer'],
  [70423902,70634725,'Leo'],
  [70634725,70850356,'Virgo'],
  [70850356,71068543,'Libra'],
  [71068543,71285275,'Scorpio'],
  [71285275,71494080,'Sagittarius'],
  [71494080,71689360,'Capricorn'],
  [71689360,71870431,'Aquarius'],
  [71870431,72042051,'Pisces'],
  [72042051,72211881,'Aries'],
  [72211881,72387824,'Taurus'],
  [72387824,72575701,'Gemini'],
  [72575701,72776951,'Cancer'],
  [72776951,72988400,'Leo'],
  [72988400,73205104,'Virgo'],
  [73205104,73423259,'Libra'],
  [73423259,73639940,'Scorpio'],
  [73639940,73851035,'Sagittarius'],
  [73851035,74051451,'Capricorn'],
  [74051451,74238332,'Aquarius'],
  [74238332,74413671,'Pisces'],
  [74413671,74583609,'Aries'],
  [74583609,74755988,'Taurus'],
  [74755988,74938068,'Gemini'],
  [74938068,75134065,'Cancer'],
  [75134065,75343070,'Leo'],
  [75343070,75559737,'Virgo'],
  [75559737,75777952,'Libra'],
  [75777952,75993645,'Scorpio'],
  [75993645,76204095,'Sagittarius'],
  [76204095,76406451,'Capricorn'],
  [76406451,76598216,'Aquarius'],
  [76598216,76779385,'Pisces'],
  [76779385,76953532,'Aries'],
  [76953532,77126817,'Taurus'],
  [77126817,77306169,'Gemini'],
  [77306169,77497210,'Cancer'],
  [77497210,77701844,'Leo'],
  [77701844,77916734,'Virgo'],
  [77916734,78134868,'Libra'],
  [78134868,78349838,'Scorpio'],
  [78349838,78558235,'Sagittarius'],
  [78558235,78758921,'Capricorn'],
  [78758921,78951647,'Aquarius'],
  [78951647,79136858,'Pisces'],
  [79136858,79316444,'Aries'],
  [79316444,79494101,'Taurus'],
  [79494101,79674867,'Gemini'],
  [79674867,79863949,'Cancer'],
  [79863949,80064832,'Leo'],
  [80064832,80276969,'Virgo'],
  [80276969,80494704,'Libra'],
  [80494704,80709972,'Scorpio'],
  [80709972,80917084,'Sagittarius'],
  [80917084,81114686,'Capricorn'],
  [81114686,81304504,'Aquarius'],
  [81304504,81489282,'Pisces'],
  [81489282,81671642,'Aries'],
  [81671642,81853980,'Taurus'],
  [81853980,82038912,'Gemini'],
  [82038912,82229613,'Cancer'],
  [82229613,82429263,'Leo'],
  [82429263,82639173,'Virgo'],
  [82639173,82856288,'Libra'],
  [82856288,83072903,'Scorpio'],
  [83072903,83280948,'Sagittarius'],
  [83280948,83476978,'Capricorn'],
  [83476978,83662897,'Aquarius'],
  [83662897,83843505,'Pisces'],
  [83843505,84023807,'Aries'],
  [84023807,84207363,'Taurus'],
  [84207363,84395897,'Gemini'],
  [84395897,84590207,'Cancer'],
  [84590207,84791410,'Leo'],
  [84791410,85000753,'Virgo'],
  [85000753,85217339,'Libra'],
  [85217339,85435637,'Scorpio'],
  [85435637,85646839,'Sagittarius'],
  [85646839,85844639,'Capricorn'],
  [85844639,86029094,'Aquarius'],
  [86029094,86205351,'Pisces'],
  [86205351,86380355,'Aries'],
  [86380355,86560194,'Taurus'],
  [86560194,86748274,'Gemini'],
  [86748274,86944895,'Cancer'],
  [86944895,87148872,'Leo'],
  [87148872,87359428,'Virgo'],
  [87359428,87575929,'Libra'],
  [87575929,87795249,'Scorpio'],
  [87795249,88010175,'Sagittarius'],
  [88010175,88212776,'Capricorn'],
  [88212776,88400045,'Aquarius'],
  [88400045,88575429,'Pisces'],
  [88575429,88746094,'Aries'],
  [88746094,88919833,'Taurus'],
  [88919833,89102762,'Gemini'],
  [89102762,89297390,'Cancer'],
  [89297390,89502398,'Leo'],
  [89502398,89714739,'Virgo'],
  [89714739,89931801,'Libra'],
  [89931801,90151101,'Scorpio'],
  [90151101,90367993,'Sagittarius'],
  [90367993,90575659,'Capricorn'],
  [90575659,90769007,'Aquarius'],
  [90769007,90948387,'Pisces'],
  [90948387,91119195,'Aries'],
  [91119195,91289095,'Taurus'],
  [91289095,91465653,'Gemini'],
  [91465653,91654270,'Cancer'],
  [91654270,91856269,'Leo'],
  [91856269,92068700,'Virgo'],
  [92068700,92286550,'Libra'],
  [92286550,92505442,'Scorpio'],
  [92505442,92721750,'Sagittarius'],
  [92721750,92931343,'Capricorn'],
  [92931343,93130072,'Aquarius'],
  [93130072,93316212,'Pisces'],
  [93316212,93492100,'Aries'],
  [93492100,93663336,'Taurus'],
  [93663336,93836938,'Gemini'],
  [93836938,94019589,'Cancer'],
  [94019589,94215638,'Leo'],
  [94215638,94424992,'Virgo'],
  [94424992,94642623,'Libra'],
  [94642623,94861482,'Scorpio'],
  [94861482,95076230,'Sagittarius'],
  [95076230,95284077,'Capricorn'],
  [95284077,95483670,'Aquarius'],
  [95483670,95674381,'Pisces'],
  [95674381,95856880,'Aries'],
  [95856880,96033810,'Taurus'],
  [96033810,96209764,'Gemini'],
  [96209764,96390540,'Cancer'],
  [96390540,96581700,'Leo'],
  [96581700,96786231,'Virgo'],
  [96786231,97001828,'Libra'],
  [97001828,97220878,'Scorpio'],
  [97220878,97435136,'Sagittarius'],
  [97435136,97640387,'Capricorn'],
  [97640387,97836832,'Aquarius'],
  [97836832,98026647,'Pisces'],
  [98026647,98211971,'Aries'],
  [98211971,98394448,'Taurus'],
  [98394448,98575963,'Gemini'],
  [98575963,98759666,'Cancer'],
  [98759666,98950019,'Leo'],
  [98950019,99151197,'Virgo'],
  [99151197,99363948,'Libra'],
  [99363948,99582827,'Scorpio'],
  [99582827,99798237,'Sagittarius'],
  [99798237,100003006,'Capricorn'],
  [100003006,100196254,'Aquarius'],
  [100196254,100381715,'Pisces'],
  [100381715,100564220,'Aries'],
  [100564220,100747315,'Taurus'],
  [100747315,100932641,'Gemini'],
  [100932641,101121060,'Cancer'],
  [101121060,101314371,'Leo'],
  [101314371,101515544,'Virgo'],
  [101515544,101726574,'Libra'],
  [101726574,101944915,'Scorpio'],
  [101944915,102162265,'Sagittarius'],
  [102162265,102369382,'Capricorn'],
  [102369382,102562584,'Aquarius'],
  [102562584,102744796,'Pisces'],
  [102744796,102922202,'Aries'],
  [102922202,103100867,'Taurus'],
  [103100867,103284711,'Gemini'],
  [103284711,103475025,'Cancer'],
  [103475025,103671798,'Leo'],
  [103671798,103875447,'Virgo'],
  [103875447,104086823,'Libra'],
  [104086823,104304814,'Scorpio'],
  [104304814,104523697,'Sagittarius'],
  [104523697,104734580,'Capricorn'],
  [104734580,104931264,'Aquarius'],
  [104931264,105114138,'Pisces'],
  [105114138,105288669,'Aries'],
  [105288669,105461982,'Taurus'],
  [105461982,105640352,'Gemini'],
  [105640352,105827611,'Cancer'],
  [105827611,106024666,'Leo'],
  [106024666,106230477,'Virgo'],
  [106230477,106443474,'Libra'],
  [106443474,106661685,'Scorpio'],
  [106661685,106881081,'Sagittarius'],
  [106881081,107094937,'Capricorn'],
  [107094937,107296636,'Aquarius'],
  [107296636,107483902,'Pisces'],
  [107483902,107659872,'Aries'],
  [107659872,107830893,'Taurus'],
  [107830893,108004051,'Gemini'],
  [108004051,108185419,'Cancer'],
  [108185419,108378585,'Leo'],
  [108378585,108583680,'Virgo'],
  [108583680,108797744,'Libra'],
  [108797744,109016528,'Scorpio'],
  [109016528,109235610,'Sagittarius'],
  [109235610,109450225,'Capricorn'],
  [109450225,109655546,'Aquarius'],
  [109655546,109848441,'Pisces'],
  [109848441,110029423,'Aries'],
  [110029423,110202571,'Taurus'],
  [110202571,110374070,'Gemini'],
  [110374070,110550665,'Cancer'],
  [110550665,110738138,'Leo'],
  [110738138,110939337,'Virgo'],
  [110939337,111152407,'Libra'],
  [111152407,111371468,'Scorpio'],
  [111371468,111590032,'Sagittarius'],
  [111590032,111803478,'Capricorn'],
  [111803478,112009178,'Aquarius'],
  [112009178,112205552,'Pisces'],
  [112205552,112392185,'Aries'],
  [112392185,112570641,'Taurus'],
  [112570641,112744794,'Gemini'],
  [112744794,112920368,'Cancer'],
  [112920368,113103765,'Leo'],
  [113103765,113300055,'Virgo'],
  [113300055,113510056,'Libra'],
  [113510056,113728514,'Scorpio'],
  [113728514,113946893,'Sagittarius'],
  [113946893,114158793,'Capricorn'],
  [114158793,114362257,'Aquarius'],
  [114362257,114558053,'Pisces'],
  [114558053,114747306,'Aries'],
  [114747306,114930880,'Taurus'],
  [114930880,115110289,'Gemini'],
  [115110289,115288874,'Cancer'],
  [115288874,115471886,'Leo'],
  [115471886,115665020,'Virgo'],
  [115665020,115871462,'Libra'],
  [115871462,116088411,'Scorpio'],
  [116088411,116307115,'Sagittarius'],
  [116307115,116518715,'Capricorn'],
  [116518715,116719808,'Aquarius'],
  [116719808,116912203,'Pisces'],
  [116912203,117099450,'Aries'],
  [117099450,117284190,'Taurus'],
  [117284190,117467667,'Gemini'],
  [117467667,117651096,'Cancer'],
  [117651096,117837272,'Leo'],
  [117837272,118030584,'Virgo'],
  [118030584,118234954,'Libra'],
  [118234954,118450173,'Scorpio'],
  [118450173,118669443,'Sagittarius'],
  [118669443,118882696,'Capricorn'],
  [118882696,119083778,'Aquarius'],
  [119083778,119273335,'Pisces'],
  [119273335,119456068,'Aries'],
  [119456068,119637102,'Taurus'],
  [119637102,119819867,'Gemini'],
  [119819867,120005876,'Cancer'],
  [120005876,120196120,'Leo'],
  [120196120,120392447,'Virgo'],
  [120392447,120597338,'Libra'],
  [120597338,120811600,'Scorpio'],
  [120811600,121031194,'Sagittarius'],
  [121031194,121247271,'Capricorn'],
  [121247271,121451566,'Aquarius'],
  [121451566,121641843,'Pisces'],
  [121641843,121821745,'Aries'],
  [121821745,121997436,'Taurus'],
  [121997436,122174849,'Gemini'],
  [122174849,122358130,'Cancer'],
  [122358130,122549215,'Leo'],
  [122549215,122748517,'Virgo'],
  [122748517,122955864,'Libra'],
  [122955864,123170615,'Scorpio'],
  [123170615,123390140,'Sagittarius'],
  [123390140,123608363,'Capricorn'],
  [123608363,123817470,'Aquarius'],
  [123817470,124012516,'Pisces'],
  [124012516,124194213,'Aries'],
  [124194213,124367582,'Taurus'],
  [124367582,124539370,'Gemini'],
  [124539370,124716135,'Cancer'],
  [124716135,124902783,'Leo'],
  [124902783,125101302,'Virgo'],
  [125101302,125310387,'Libra'],
  [125310387,125526639,'Scorpio'],
  [125526639,125746157,'Sagittarius'],
  [125746157,125964652,'Capricorn'],
  [125964652,126176961,'Aquarius'],
  [126176961,126378058,'Pisces'],
  [126378058,126565758,'Aries'],
  [126565758,126742097,'Taurus'],
  [126742097,126912496,'Gemini'],
  [126912496,127084047,'Cancer'],
  [127084047,127263850,'Leo'],
  [127263850,127457031,'Virgo'],
  [127457031,127664303,'Libra'],
  [127664303,127881225,'Scorpio'],
  [127881225,128101110,'Sagittarius'],
  [128101110,128318703,'Capricorn'],
  [128318703,128530887,'Aquarius'],
  [128530887,128735120,'Pisces'],
  [128735120,128929049,'Aries'],
  [128929049,129111983,'Taurus'],
  [129111983,129286341,'Gemini'],
  [129286341,129457671,'Cancer'],
  [129457671,129633268,'Leo'],
  [129633268,129820188,'Virgo'],
  [129820188,130022343,'Libra'],
  [130022343,130237384,'Scorpio'],
  [130237384,130457377,'Sagittarius'],
  [130457377,130674344,'Capricorn'],
  [130674344,130884552,'Aquarius'],
  [130884552,131087605,'Pisces'],
  [131087605,131283541,'Aries'],
  [131283541,131471819,'Taurus'],
  [131471819,131652565,'Gemini'],
  [131652565,131828430,'Cancer'],
  [131828430,132004911,'Leo'],
  [132004911,132188905,'Virgo'],
  [132188905,132386110,'Libra'],
  [132386110,132597352,'Scorpio'],
  [132597352,132816391,'Sagittarius'],
  [132816391,133033542,'Capricorn'],
  [133033542,133242503,'Aquarius'],
  [133242503,133442593,'Pisces'],
  [133442593,133635959,'Aries'],
  [133635959,133824483,'Taurus'],
  [133824483,134008940,'Gemini'],
  [134008940,134190284,'Cancer'],
  [134190284,134371329,'Leo'],
  [134371329,134556938,'Virgo'],
  [134556938,134752420,'Libra'],
  [134752420,134960445,'Scorpio'],
  [134960445,135177759,'Sagittarius'],
  [135177759,135395540,'Capricorn'],
  [135395540,135605250,'Aquarius'],
  [135605250,135803892,'Pisces'],
  [135803892,135993565,'Aries'],
  [135993565,136178176,'Taurus'],
  [136178176,136361008,'Gemini'],
  [136361008,136544147,'Cancer'],
  [136544147,136729335,'Leo'],
  [136729335,136919004,'Virgo'],
  [136919004,137116292,'Libra'],
  [137116292,137323516,'Scorpio'],
  [137323516,137539460,'Sagittarius'],
  [137539460,137757836,'Capricorn'],
  [137757836,137969924,'Aquarius'],
  [137969924,138170105,'Pisces'],
  [138170105,138358454,'Aries'],
  [138358454,138538968,'Taurus'],
  [138538968,138716854,'Gemini'],
  [138716854,138896751,'Cancer'],
  [138896751,139081941,'Leo'],
  [139081941,139274317,'Virgo'],
  [139274317,139474771,'Libra'],
  [139474771,139683482,'Scorpio'],
  [139683482,139899211,'Sagittarius'],
  [139899211,140117898,'Capricorn'],
  [140117898,140332670,'Aquarius'],
  [140332670,140536757,'Pisces'],
  [140536757,140727454,'Aries'],
  [140727454,140906980,'Taurus'],
  [140906980,141080700,'Gemini'],
  [141080700,141255039,'Cancer'],
  [141255039,141435811,'Leo'],
  [141435811,141626782,'Virgo'],
  [141626782,141828651,'Libra'],
  [141828651,142039427,'Scorpio'],
  [142039427,142255973,'Sagittarius'],
  [142255973,142474701,'Capricorn'],
  [142474701,142691043,'Aquarius'],
  [142691043,142899328,'Pisces'],
  [142899328,143095058,'Aries'],
  [143095058,143277662,'Taurus'],
  [143277662,143450897,'Gemini'],
  [143450897,143621329,'Cancer'],
  [143621329,143796362,'Leo'],
  [143796362,143982276,'Virgo'],
  [143982276,144181886,'Libra'],
  [144181886,144393092,'Scorpio'],
  [144393092,144610588,'Sagittarius'],
  [144610588,144829266,'Capricorn'],
  [144829266,145045520,'Aquarius'],
  [145045520,145255957,'Pisces'],
  [145255957,145456647,'Aries'],
  [145456647,145644971,'Taurus'],
  [145644971,145821939,'Gemini'],
  [145821939,145992556,'Cancer'],
  [145992556,146164218,'Leo'],
  [146164218,146344609,'Virgo'],
  [146344609,146539136,'Libra'],
  [146539136,146747911,'Scorpio'],
  [146747911,146965309,'Sagittarius'],
  [146965309,147183976,'Capricorn'],
  [147183976,147399171,'Aquarius'],
  [147399171,147608893,'Pisces'],
  [147608893,147811476,'Aries'],
  [147811476,148004731,'Taurus'],
  [148004731,148187665,'Gemini'],
  [148187665,148362598,'Cancer'],
  [148362598,148535232,'Leo'],
  [148535232,148712973,'Virgo'],
  [148712973,148902583,'Libra'],
  [148902583,149106953,'Scorpio'],
  [149106953,149322540,'Sagittarius'],
  [149322540,149541144,'Capricorn'],
  [149541144,149755607,'Aquarius'],
  [149755607,149963160,'Pisces'],
  [149963160,150163865,'Aries'],
  [150163865,150357919,'Taurus'],
  [150357919,150544979,'Gemini'],
  [150544979,150725651,'Cancer'],
  [150725651,150903007,'Leo'],
  [150903007,151082460,'Virgo'],
  [151082460,151270226,'Libra'],
  [151270226,151470708,'Scorpio'],
  [151470708,151683340,'Sagittarius'],
  [151683340,151901546,'Capricorn'],
  [151901546,152116535,'Aquarius'],
  [152116535,152322965,'Pisces'],
  [152322965,152520426,'Aries'],
  [152520426,152711064,'Taurus'],
  [152711064,152897162,'Gemini'],
  [152897162,153080434,'Cancer'],
  [153080434,153262740,'Leo'],
  [153262740,153446932,'Virgo'],
  [153446932,153636880,'Libra'],
  [153636880,153836309,'Scorpio'],
  [153836309,154046481,'Sagittarius'],
  [154046481,154263843,'Capricorn'],
  [154263843,154480423,'Aquarius'],
  [154480423,154688421,'Pisces'],
  [154688421,154884799,'Aries'],
  [154884799,155071412,'Taurus'],
  [155071412,155252556,'Gemini'],
  [155252556,155432767,'Cancer'],
  [155432767,155615608,'Leo'],
  [155615608,155803382,'Virgo'],
  [155803382,155997517,'Libra'],
  [155997517,156199143,'Scorpio'],
  [156199143,156408908,'Sagittarius'],
  [156408908,156625419,'Capricorn'],
  [156625419,156843504,'Aquarius'],
  [156843504,157055214,'Pisces'],
  [157055214,157254455,'Aries'],
  [157254455,157440497,'Taurus'],
  [157440497,157617415,'Gemini'],
  [157617415,157791602,'Cancer'],
  [157791602,157969450,'Leo'],
  [157969450,158155563,'Virgo'],
  [158155563,158351535,'Libra'],
  [158351535,158556262,'Scorpio'],
  [158556262,158767743,'Sagittarius'],
  [158767743,158984171,'Capricorn'],
  [158984171,159202751,'Aquarius'],
  [159202751,159417900,'Pisces'],
  [159417900,159622580,'Aries'],
  [159622580,159812753,'Taurus'],
  [159812753,159990025,'Gemini'],
  [159990025,160160499,'Cancer'],
  [160160499,160332031,'Leo'],
  [160332031,160511890,'Virgo'],
  [160511890,160704443,'Libra'],
  [160704443,160909355,'Scorpio'],
  [160909355,161122628,'Sagittarius'],
  [161122628,161339910,'Capricorn'],
  [161339910,161558249,'Aquarius'],
  [161558249,161774518,'Pisces'],
  [161774518,161983590,'Aries'],
  [161983590,162180138,'Taurus'],
  [162180138,162362534,'Gemini'],
  [162362534,162534515,'Cancer'],
  [162534515,162703387,'Leo'],
  [162703387,162877390,'Virgo'],
  [162877390,163063373,'Libra'],
  [163063373,163264049,'Scorpio'],
  [163264049,163476496,'Sagittarius'],
  [163476496,163694460,'Capricorn'],
  [163694460,163912619,'Aquarius'],
  [163912619,164127987,'Pisces'],
  [164127987,164337876,'Aries'],
  [164337876,164538634,'Taurus'],
  [164538634,164727439,'Gemini'],
  [164727439,164905090,'Cancer'],
  [164905090,165076537,'Leo'],
  [165076537,165249074,'Virgo'],
  [165249074,165430141,'Libra'],
  [165430141,165624872,'Scorpio'],
  [165624872,165833439,'Sagittarius'],
  [165833439,166050510,'Capricorn'],
  [166050510,166268688,'Aquarius'],
  [166268688,166482871,'Pisces'],
  [166482871,166690838,'Aries'],
  [166690838,166891374,'Taurus'],
  [166891374,167083332,'Gemini'],
  [167083332,167266665,'Cancer'],
  [167266665,167443784,'Leo'],
  [167443784,167619560,'Virgo'],
  [167619560,167800139,'Libra'],
  [167800139,167991114,'Scorpio'],
  [167991114,168195136,'Sagittarius'],
  [168195136,168409732,'Capricorn'],
  [168409732,168627764,'Aquarius'],
  [168627764,168841746,'Pisces'],
  [168841746,169047688,'Aries'],
  [169047688,169245177,'Taurus'],
  [169245177,169435532,'Gemini'],
  [169435532,169620478,'Cancer'],
  [169620478,169802045,'Leo'],
  [169802045,169982974,'Virgo'],
  [169982974,170166924,'Libra'],
  [170166924,170358034,'Scorpio'],
  [170358034,170559536,'Sagittarius'],
  [170559536,170771514,'Capricorn'],
  [170771514,170989111,'Aquarius'],
  [170989111,171204119,'Pisces'],
  [171204119,171409947,'Aries'],
  [171409947,171604834,'Taurus'],
  [171604834,171791168,'Gemini'],
  [171791168,171973103,'Cancer'],
  [171973103,172154589,'Leo'],
  [172154589,172338489,'Virgo'],
  [172338489,172526683,'Libra'],
  [172526683,172720831,'Scorpio'],
  [172720831,172922769,'Sagittarius'],
  [172922769,173133448,'Capricorn'],
  [173133448,173350564,'Aquarius'],
  [173350564,173567310,'Pisces'],
  [173567310,173775417,'Aries'],
  [173775417,173970499,'Taurus'],
  [173970499,174154003,'Gemini'],
  [174154003,174331236,'Cancer'],
  [174331236,174508456,'Leo'],
  [174508456,174690658,'Virgo'],
  [174690658,174880316,'Libra'],
  [174880316,175077586,'Scorpio'],
  [175077586,175281901,'Sagittarius'],
  [175281901,175493050,'Capricorn'],
  [175493050,175709961,'Aquarius'],
  [175709961,175928220,'Pisces'],
  [175928220,176139980,'Aries'],
  [176139980,176338498,'Taurus'],
  [176338498,176522727,'Gemini'],
  [176522727,176697280,'Cancer'],
  [176697280,176869447,'Leo'],
  [176869447,177046397,'Virgo'],
  [177046397,177233001,'Libra'],
  [177233001,177430391,'Scorpio'],
  [177430391,177636677,'Sagittarius'],
  [177636677,177849344,'Capricorn'],
  [177849344,178066485,'Aquarius'],
  [178066485,178285300,'Pisces'],
  [178285300,178500062,'Aries'],
  [178500062,178703663,'Taurus'],
  [178703663,178892359,'Gemini'],
  [178892359,179068403,'Cancer'],
  [179068403,179238378,'Leo'],
  [179238378,179410240,'Virgo'],
  [179410240,179590981,'Libra'],
  [179590981,179784408,'Scorpio'],
  [179784408,179989859,'Sagittarius'],
  [179989859,180203514,'Capricorn'],
  [180203514,180421192,'Aquarius'],
  [180421192,180639649,'Pisces'],
  [180639649,180855121,'Aries'],
  [180855121,181062412,'Taurus'],
  [181062412,181257015,'Gemini'],
  [181257015,181438412,'Cancer'],
  [181438412,181610816,'Leo'],
  [181610816,181781223,'Virgo'],
  [181781223,181957158,'Libra'],
  [181957158,182144621,'Scorpio'],
  [182144621,182345877,'Sagittarius'],
  [182345877,182558382,'Capricorn'],
  [182558382,182776380,'Aquarius'],
  [182776380,182994325,'Pisces'],
  [182994325,183208431,'Aries'],
  [183208431,183415798,'Taurus'],
  [183415798,183613819,'Gemini'],
  [183613819,183801232,'Cancer'],
  [183801232,183979593,'Leo'],
  [183979593,184153348,'Virgo'],
  [184153348,184328681,'Libra'],
  [184328681,184511976,'Scorpio'],
  [184511976,184707853,'Sagittarius'],
  [184707853,184916839,'Capricorn'],
  [184916839,185134166,'Aquarius'],
  [185134166,185352161,'Pisces'],
  [185352161,185564761,'Aries'],
  [185564761,185769445,'Taurus'],
  [185769445,185966173,'Gemini'],
  [185966173,186155759,'Cancer'],
  [186155759,186339411,'Leo'],
  [186339411,186519188,'Virgo'],
  [186519188,186698496,'Libra'],
  [186698496,186882025,'Scorpio'],
  [186882025,187074739,'Sagittarius'],
  [187074739,187279694,'Capricorn'],
  [187279694,187495132,'Aquarius'],
  [187495132,187713664,'Pisces'],
  [187713664,187926506,'Aries'],
  [187926506,188128991,'Taurus'],
  [188128991,188321757,'Gemini'],
  [188321757,188508256,'Cancer'],
  [188508256,188692059,'Leo'],
  [188692059,188875555,'Virgo'],
  [188875555,189060208,'Libra'],
  [189060208,189247825,'Scorpio'],
  [189247825,189441444,'Sagittarius'],
  [189441444,189644462,'Capricorn'],
  [189644462,189857791,'Aquarius'],
  [189857791,190076695,'Pisces'],
  [190076695,190291730,'Aries'],
  [190291730,190495109,'Taurus'],
  [190495109,190685552,'Gemini'],
  [190685552,190867246,'Cancer'],
  [190867246,191046232,'Leo'],
  [191046232,191227547,'Virgo'],
  [191227547,191413772,'Libra'],
  [191413772,191605378,'Scorpio'],
  [191605378,191802622,'Sagittarius'],
  [191802622,192006849,'Capricorn'],
  [192006849,192219371,'Aquarius'],
  [192219371,192438186,'Pisces'],
  [192438186,192655881,'Aries'],
  [192655881,192863147,'Taurus'],
  [192863147,193055473,'Gemini'],
  [193055473,193235345,'Cancer'],
  [193235345,193409343,'Leo'],
  [193409343,193584641,'Virgo'],
  [193584641,193766654,'Libra'],
  [193766654,193957666,'Scorpio'],
  [193957666,194157243,'Sagittarius'],
  [194157243,194364165,'Capricorn'],
  [194364165,194577689,'Aquarius'],
  [194577689,194796392,'Pisces'],
  [194796392,195015551,'Aries'],
  [195015551,195227187,'Taurus'],
  [195227187,195424740,'Gemini'],
  [195424740,195607589,'Cancer'],
  [195607589,195780685,'Leo'],
  [195780685,195951404,'Virgo'],
  [195951404,196126948,'Libra'],
  [196126948,196312502,'Scorpio'],
  [196312502,196509910,'Sagittarius'],
  [196509910,196717726,'Capricorn'],
  [196717726,196932790,'Aquarius'],
  [196932790,197151808,'Pisces'],
  [197151808,197370933,'Aries'],
  [197370933,197584749,'Taurus'],
  [197584749,197787481,'Gemini'],
  [197787481,197976323,'Cancer'],
  [197976323,198153320,'Leo'],
  [198153320,198324136,'Virgo'],
  [198324136,198495851,'Libra'],
  [198495851,198675194,'Scorpio'],
  [198675194,198866886,'Sagittarius'],
  [198866886,199071935,'Capricorn'],
  [199071935,199287031,'Aquarius'],
  [199287031,199506479,'Pisces'],
  [199506479,199724930,'Aries'],
  [199724930,199938207,'Taurus'],
  [199938207,200142964,'Gemini'],
  [200142964,200336903,'Cancer'],
  [200336903,200520043,'Leo'],
  [200520043,200695310,'Virgo'],
  [200695310,200867936,'Libra'],
  [200867936,201044324,'Scorpio'],
  [201044324,201230615,'Sagittarius'],
  [201230615,201430639,'Capricorn'],
  [201430639,201643402,'Aquarius'],
  [201643402,201862662,'Pisces'],
  [201862662,202080651,'Aries'],
  [202080651,202292177,'Taurus'],
  [202292177,202495489,'Gemini'],
  [202495489,202690607,'Cancer'],
  [202690607,202878063,'Leo'],
  [202878063,203059076,'Virgo'],
  [203059076,203236278,'Libra'],
  [203236278,203414128,'Scorpio'],
  [203414128,203598345,'Sagittarius'],
  [203598345,203794168,'Capricorn'],
  [203794168,204003376,'Aquarius'],
  [204003376,204221531,'Pisces'],
  [204221531,204439617,'Aries'],
  [204439617,204650077,'Taurus'],
  [204650077,204850667,'Gemini'],
  [204850667,205043223,'Cancer'],
  [205043223,205230546,'Leo'],
  [205230546,205414616,'Virgo'],
  [205414616,205596743,'Libra'],
  [205596743,205778938,'Scorpio'],
  [205778938,205964923,'Sagittarius'],
  [205964923,206159484,'Capricorn'],
  [206159484,206365948,'Aquarius'],
  [206365948,206582549,'Pisces'],
  [206582549,206801207,'Aries'],
  [206801207,207012382,'Taurus'],
  [207012382,207211635,'Gemini'],
  [207211635,207400721,'Cancer'],
  [207400721,207584301,'Leo'],
  [207584301,207766683,'Virgo'],
  [207766683,207950327,'Libra'],
  [207950327,208136339,'Scorpio'],
  [208136339,208326161,'Sagittarius'],
  [208326161,208522531,'Capricorn'],
  [208522531,208728405,'Aquarius'],
  [208728405,208943855,'Pisces'],
  [208943855,209163186,'Aries'],
  [209163186,209376752,'Taurus'],
  [209376752,209577566,'Gemini'],
  [209577566,209765411,'Cancer'],
  [209765411,209945045,'Leo'],
  [209945045,210122576,'Virgo'],
  [210122576,210302942,'Libra'],
  [210302942,210488838,'Scorpio'],
  [210488838,210681224,'Sagittarius'],
  [210681224,210880689,'Capricorn'],
  [210880689,211088092,'Aquarius'],
  [211088092,211303406,'Pisces'],
  [211303406,211523104,'Aries'],
  [211523104,211739455,'Taurus'],
  [211739455,211944390,'Gemini'],
  [211944390,212134821,'Cancer'],
  [212134821,212313664,'Leo'],
  [212313664,212487084,'Virgo'],
  [212487084,212661724,'Libra'],
  [212661724,212842933,'Scorpio'],
  [212842933,213033698,'Sagittarius'],
  [213033698,213234504,'Capricorn'],
  [213234504,213444065,'Aquarius'],
  [213444065,213660270,'Pisces'],
  [213660270,213879940,'Aries'],
  [213879940,214097778,'Taurus'],
  [214097778,214307112,'Gemini'],
  [214307112,214503103,'Cancer'],
  [214503103,214685653,'Leo'],
  [214685653,214859035,'Virgo'],
  [214859035,215029782,'Libra'],
  [215029782,215204827,'Scorpio'],
  [215204827,215389945,'Sagittarius'],
  [215389945,215588042,'Capricorn'],
  [215588042,215797957,'Aquarius'],
  [215797957,216015281,'Pisces'],
  [216015281,216234883,'Aries'],
  [216234883,216452297,'Taurus'],
  [216452297,216663470,'Gemini'],
  [216663470,216864608,'Cancer'],
  [216864608,217053645,'Leo'],
  [217053645,217231769,'Virgo'],
  [217231769,217403443,'Libra'],
  [217403443,217575262,'Scorpio'],
  [217575262,217754407,'Sagittarius'],
  [217754407,217946644,'Capricorn'],
  [217946644,218153518,'Aquarius'],
  [218153518,218370684,'Pisces'],
  [218370684,218590463,'Aries'],
  [218590463,218806662,'Taurus'],
  [218806662,219016467,'Gemini'],
  [219016467,219218791,'Cancer'],
  [219218791,219412618,'Leo'],
  [219412618,219597389,'Virgo'],
  [219597389,219774512,'Libra'],
  [219774512,219948290,'Scorpio'],
  [219948290,220125261,'Sagittarius'],
  [220125261,220312386,'Capricorn'],
  [220312386,220514138,'Aquarius'],
  [220514138,220728925,'Pisces'],
  [220728925,220948708,'Aries'],
  [220948708,221164503,'Taurus'],
  [221164503,221372023,'Gemini'],
  [221372023,221571647,'Cancer'],
  [221571647,221765098,'Leo'],
  [221765098,221953220,'Virgo'],
  [221953220,222136234,'Libra'],
  [222136234,222315611,'Scorpio'],
  [222315611,222495385,'Sagittarius'],
  [222495385,222681507,'Capricorn'],
  [222681507,222879511,'Aquarius'],
  [222879511,223090821,'Pisces'],
  [223090821,223309825,'Aries'],
  [223309825,223526474,'Taurus'],
  [223526474,223733534,'Gemini'],
  [223733534,223930164,'Cancer'],
  [223930164,224119551,'Leo'],
  [224119551,224305285,'Virgo'],
  [224305285,224489492,'Libra'],
  [224489492,224673203,'Scorpio'],
  [224673203,224858048,'Sagittarius'],
  [224858048,225047330,'Capricorn'],
  [225047330,225245270,'Aquarius'],
  [225245270,225454395,'Pisces'],
  [225454395,225672122,'Aries'],
  [225672122,225890114,'Taurus'],
  [225890114,226099302,'Gemini'],
  [226099302,226295908,'Cancer'],
  [226295908,226482084,'Leo'],
  [226482084,226662740,'Virgo'],
  [226662740,226842695,'Libra'],
  [226842695,227025310,'Scorpio'],
  [227025310,227212535,'Sagittarius'],
  [227212535,227405788,'Capricorn'],
  [227405788,227606603,'Aquarius'],
  [227606603,227816125,'Pisces'],
  [227816125,228033089,'Aries'],
  [228033089,228252004,'Taurus'],
  [228252004,228464585,'Gemini'],
  [228464585,228664630,'Cancer'],
  [228664630,228851499,'Leo'],
  [228851499,229029168,'Virgo'],
  [229029168,229203593,'Libra'],
  [229203593,229380673,'Scorpio'],
  [229380673,229564938,'Sagittarius'],
  [229564938,229758747,'Capricorn'],
  [229758747,229962171,'Aquarius'],
  [229962171,230173739,'Pisces'],
  [230173739,230391044,'Aries'],
  [230391044,230610207,'Taurus'],
  [230610207,230825408,'Gemini'],
  [230825408,231030348,'Cancer'],
  [231030348,231221694,'Leo'],
  [231221694,231400815,'Virgo'],
  [231400815,231572789,'Libra'],
  [231572789,231744451,'Scorpio'],
  [231744451,231922624,'Sagittarius'],
  [231922624,232112359,'Capricorn'],
  [232112359,232315054,'Aquarius'],
  [232315054,232527949,'Pisces'],
  [232527949,232746201,'Aries'],
  [232746201,232965248,'Taurus'],
  [232965248,233181141,'Gemini'],
  [233181141,233389586,'Cancer'],
  [233389586,233586594,'Leo'],
  [233586594,233770831,'Virgo'],
  [233770831,233944937,'Libra'],
  [233944937,234114875,'Scorpio'],
  [234114875,234288161,'Sagittarius'],
  [234288161,234471908,'Capricorn'],
  [234471908,234670269,'Aquarius'],
  [234670269,234881878,'Pisces'],
  [234881878,235100510,'Aries'],
  [235100510,235319406,'Taurus'],
  [235319406,235534441,'Gemini'],
  [235534441,235743380,'Cancer'],
  [235743380,235943903,'Leo'],
  [235943903,236133874,'Virgo'],
  [236133874,236313364,'Libra'],
  [236313364,236486020,'Scorpio'],
  [236486020,236658375,'Sagittarius'],
  [236658375,236837999,'Capricorn'],
  [236837999,237031033,'Aquarius'],
  [237031033,237238893,'Pisces'],
  [237238893,237456440,'Aries'],
  [237456440,237675210,'Taurus'],
  [237675210,237889118,'Gemini'],
  [237889118,238096235,'Cancer'],
  [238096235,238296428,'Leo'],
  [238296428,238489174,'Virgo'],
  [238489174,238673899,'Libra'],
  [238673899,238851903,'Scorpio'],
  [238851903,239027429,'Sagittarius'],
  [239027429,239206844,'Capricorn'],
  [239206844,239396629,'Aquarius'],
  [239396629,239600334,'Pisces'],
  [239600334,239815495,'Aries'],
  [239815495,240034042,'Taurus'],
  [240034042,240247718,'Gemini'],
  [240247718,240452899,'Cancer'],
  [240452899,240650151,'Leo'],
  [240650151,240841268,'Virgo'],
  [240841268,241027460,'Libra'],
  [241027460,241209735,'Scorpio'],
  [241209735,241390276,'Sagittarius'],
  [241390276,241573081,'Capricorn'],
  [241573081,241763191,'Aquarius'],
  [241763191,241964597,'Pisces'],
  [241964597,242177253,'Aries'],
  [242177253,242395391,'Taurus'],
  [242395391,242610163,'Gemini'],
  [242610163,242815346,'Cancer'],
  [242815346,243010084,'Leo'],
  [243010084,243197126,'Virgo'],
  [243197126,243380130,'Libra'],
  [243380130,243562178,'Scorpio'],
  [243562178,243745650,'Sagittarius'],
  [243745650,243932801,'Capricorn'],
  [243932801,244126164,'Aquarius'],
  [244126164,244328164,'Pisces'],
  [244328164,244539529,'Aries'],
  [244539529,244757148,'Taurus'],
  [244757148,244973798,'Gemini'],
  [244973798,245181627,'Cancer'],
  [245181627,245376922,'Leo'],
  [245376922,245561211,'Virgo'],
  [245561211,245739214,'Libra'],
  [245739214,245916506,'Scorpio'],
  [245916506,246097879,'Sagittarius'],
  [246097879,246286370,'Capricorn'],
  [246286370,246483066,'Aquarius'],
  [246483066,246687761,'Pisces'],
  [246687761,246899685,'Aries'],
  [246899685,247116943,'Taurus'],
  [247116943,247335036,'Gemini'],
  [247335036,247546906,'Cancer'],
  [247546906,247746406,'Leo'],
  [247746406,247932103,'Virgo'],
  [247932103,248107598,'Libra'],
  [248107598,248279444,'Scorpio'],
  [248279444,248454806,'Sagittarius'],
  [248454806,248639457,'Capricorn'],
  [248639457,248835878,'Aquarius'],
  [248835878,249042663,'Pisces'],
  [249042663,249256366,'Aries'],
  [249256366,249473809,'Taurus'],
  [249473809,249692099,'Gemini'],
  [249692099,249906804,'Cancer'],
  [249906804,250111899,'Leo'],
  [250111899,250303124,'Virgo'],
  [250303124,250481107,'Libra'],
  [250481107,250651254,'Scorpio'],
  [250651254,250821396,'Sagittarius'],
  [250821396,250999417,'Capricorn'],
  [250999417,251190808,'Aquarius'],
  [251190808,251396064,'Pisces'],
  [251396064,251610697,'Aries'],
  [251610697,251828845,'Taurus'],
  [251828845,252046572,'Gemini'],
  [252046572,252261333,'Cancer'],
  [252261333,252469591,'Leo'],
  [252469591,252666982,'Virgo'],
  [252666982,252851335,'Libra'],
  [252851335,253025121,'Scorpio'],
  [253025121,253194790,'Sagittarius'],
  [253194790,253368424,'Capricorn'],
  [253368424,253553384,'Aquarius'],
  [253553384,253753377,'Pisces'],
  [253753377,253966053,'Aries'],
  [253966053,254184440,'Taurus'],
  [254184440,254401881,'Gemini'],
  [254401881,254615036,'Cancer'],
  [254615036,254822408,'Leo'],
  [254822408,255022113,'Virgo'],
  [255022113,255212102,'Libra'],
  [255212102,255392417,'Scorpio'],
  [255392417,255566627,'Sagittarius'],
  [255566627,255741039,'Capricorn'],
  [255741039,255922773,'Aquarius'],
  [255922773,256117329,'Pisces'],
  [256117329,256325661,'Aries'],
  [256325661,256542740,'Taurus'],
  [256542740,256760388,'Gemini'],
  [256760388,256972545,'Cancer'],
  [256972545,257177190,'Leo'],
  [257177190,257374560,'Virgo'],
  [257374560,257565181,'Libra'],
  [257565181,257749681,'Scorpio'],
  [257749681,257929796,'Sagittarius'],
  [257929796,258109062,'Capricorn'],
  [258109062,258292442,'Aquarius'],
  [258292442,258484962,'Pisces'],
  [258484962,258689455,'Aries'],
  [258689455,258904088,'Taurus'],
  [258904088,259121933,'Gemini'],
  [259121933,259334811,'Cancer'],
  [259334811,259538118,'Leo'],
  [259538118,259731849,'Virgo'],
  [259731849,259918672,'Libra'],
  [259918672,260101840,'Scorpio'],
  [260101840,260284183,'Sagittarius'],
  [260284183,260468082,'Capricorn'],
  [260468082,260655921,'Aquarius'],
  [260655921,260850386,'Pisces'],
  [260850386,261053859,'Aries'],
  [261053859,261266540,'Taurus'],
  [261266540,261484306,'Gemini'],
  [261484306,261699204,'Cancer'],
  [261699204,261904015,'Leo'],
  [261904015,262096427,'Virgo'],
  [262096427,262279127,'Libra'],
  [262279127,262457389,'Scorpio'],
  [262457389,262636621,'Sagittarius'],
  [262636621,262820764,'Capricorn'],
  [262820764,263011660,'Aquarius'],
  [263011660,263209657,'Pisces'],
  [263209657,263414857,'Aries'],
  [263414857,263627244,'Taurus'],
  [263627244,263844861,'Gemini'],
  [263844861,264061918,'Cancer'],
  [264061918,264270391,'Leo'],
  [264270391,264465122,'Virgo'],
  [264465122,264646844,'Libra'],
  [264646844,264820974,'Scorpio'],
  [264820974,264994670,'Sagittarius'],
  [264994670,265174367,'Capricorn'],
  [265174367,265363862,'Aquarius'],
  [265363862,265563408,'Pisces'],
  [265563408,265770986,'Aries'],
  [265770986,265984521,'Taurus'],
  [265984521,266202217,'Gemini'],
  [266202217,266420512,'Cancer'],
  [266420512,266632810,'Leo'],
  [266632810,266832412,'Virgo'],
  [266832412,267017214,'Libra'],
  [267017214,267190965,'Scorpio'],
  [267190965,267360886,'Sagittarius'],
  [267360886,267534849,'Capricorn'],
  [267534849,267719115,'Aquarius'],
  [267719115,267916176,'Pisces'],
  [267916176,268124149,'Aries'],
  [268124149,268338942,'Taurus'],
  [268338942,268556984,'Gemini'],
  [268556984,268775313,'Cancer'],
  [268775313,268989564,'Leo'],
  [268989564,269193894,'Virgo'],
  [269193894,269384313,'Libra'],
  [269384313,269561852,'Scorpio'],
  [269561852,269732142,'Sagittarius'],
  [269732142,269902887,'Capricorn'],
  [269902887,270081575,'Aquarius'],
  [270081575,270273234,'Pisces'],
  [270273234,270478356,'Aries'],
  [270478356,270692929,'Taurus'],
  [270692929,270911277,'Gemini'],
  [270911277,271128984,'Cancer'],
  [271128984,271342730,'Leo'],
  [271342730,271548937,'Virgo'],
  [271548937,271744219,'Libra'],
  [271744219,271927699,'Scorpio'],
  [271927699,272102390,'Sagittarius'],
  [272102390,272274254,'Capricorn'],
  [272274254,272450353,'Aquarius'],
  [272450353,272636927,'Pisces'],
  [272636927,272837160,'Aries'],
  [272837160,273049350,'Taurus'],
  [273049350,273267453,'Gemini'],
  [273267453,273484710,'Cancer'],
  [273484710,273696725,'Leo'],
  [273696725,273901400,'Virgo'],
  [273901400,274097732,'Libra'],
  [274097732,274285492,'Scorpio'],
  [274285492,274466013,'Sagittarius'],
  [274466013,274642671,'Capricorn'],
  [274642671,274820501,'Aquarius'],
  [274820501,275005150,'Pisces'],
  [275005150,275201184,'Aries'],
  [275201184,275409753,'Taurus'],
  [275409753,275626751,'Gemini'],
  [275626751,275844243,'Cancer'],
  [275844243,276055284,'Leo'],
  [276055284,276257103,'Virgo'],
  [276257103,276450541,'Libra'],
  [276450541,276637887,'Scorpio'],
  [276637887,276821437,'Sagittarius'],
  [276821437,277003297,'Capricorn'],
  [277003297,277185933,'Aquarius'],
  [277185933,277372696,'Pisces'],
  [277372696,277567515,'Aries'],
  [277567515,277773182,'Taurus'],
  [277773182,277988513,'Gemini'],
  [277988513,278206773,'Cancer'],
  [278206773,278418933,'Leo'],
  [278418933,278619613,'Virgo'],
  [278619613,278809324,'Libra'],
  [278809324,278992327,'Scorpio'],
  [278992327,279173560,'Sagittarius'],
  [279173560,279356627,'Capricorn'],
  [279356627,279543274,'Aquarius'],
  [279543274,279734372,'Pisces'],
  [279734372,279931394,'Aries'],
  [279931394,280136527,'Taurus'],
  [280136527,280350508,'Gemini'],
  [280350508,280569409,'Cancer'],
  [280569409,280784447,'Leo'],
  [280784447,280987440,'Virgo'],
  [280987440,281176367,'Libra'],
  [281176367,281355302,'Scorpio'],
  [281355302,281530992,'Sagittarius'],
  [281530992,281709763,'Capricorn'],
  [281709763,281895486,'Aquarius'],
  [281895486,282088961,'Pisces'],
  [282088961,282289398,'Aries'],
  [282289398,282496452,'Taurus'],
  [282496452,282710337,'Gemini'],
  [282710337,282929312,'Cancer'],
  [282929312,283147092,'Leo'],
  [283147092,283354873,'Virgo'],
  [283354873,283547458,'Libra'],
  [283547458,283726504,'Scorpio'],
  [283726504,283898451,'Sagittarius'],
  [283898451,284071062,'Capricorn'],
  [284071062,284250920,'Aquarius'],
  [284250920,284441518,'Pisces'],
  [284441518,284642635,'Aries'],
  [284642635,284851926,'Taurus'],
  [284851926,285067036,'Gemini'],
  [285067036,285285877,'Cancer'],
  [285285877,285504542,'Leo'],
  [285504542,285716368,'Virgo'],
  [285716368,285915035,'Libra'],
  [285915035,286098989,'Scorpio'],
  [286098989,286272272,'Sagittarius'],
  [286272272,286442010,'Capricorn'],
  [286442010,286615813,'Aquarius'],
  [286615813,286799819,'Pisces'],
  [286799819,286996859,'Aries'],
  [286996859,287205610,'Taurus'],
  [287205610,287421824,'Gemini'],
  [287421824,287640876,'Cancer'],
  [287640876,287858799,'Leo'],
  [287858799,288071423,'Virgo'],
  [288071423,288274324,'Libra'],
  [288274324,288464779,'Scorpio'],
  [288464779,288643816,'Sagittarius'],
  [288643816,288816054,'Capricorn'],
  [288816054,288988088,'Aquarius'],
  [288988088,289166780,'Pisces'],
  [289166780,289357526,'Aries'],
  [289357526,289562158,'Taurus'],
  [289562158,289777483,'Gemini'],
  [289777483,289996824,'Cancer'],
  [289996824,290213859,'Leo'],
  [290213859,290424717,'Virgo'],
  [290424717,290627530,'Libra'],
  [290627530,290821376,'Scorpio'],
  [290821376,291006423,'Sagittarius'],
  [291006423,291184609,'Capricorn'],
  [291184609,291359906,'Aquarius'],
  [291359906,291537872,'Pisces'],
  [291537872,291724471,'Aries'],
  [291724471,291924029,'Taurus'],
  [291924029,292136354,'Gemini'],
  [292136354,292355330,'Cancer'],
  [292355330,292572280,'Leo'],
  [292572280,292781317,'Virgo'],
  [292781317,292981251,'Libra'],
  [292981251,293173675,'Scorpio'],
  [293173675,293360595,'Sagittarius'],
  [293360595,293543584,'Capricorn'],
  [293543584,293724344,'Aquarius'],
  [293724344,293905815,'Pisces'],
  [293905815,294092506,'Aries'],
  [294092506,294289255,'Taurus'],
  [294289255,294498349,'Gemini'],
  [294498349,294716229,'Cancer'],
  [294716229,294933903,'Leo'],
  [294933903,295142890,'Virgo'],
  [295142890,295340422,'Libra'],
  [295340422,295529023,'Scorpio'],
  [295529023,295713082,'Sagittarius'],
  [295713082,295896163,'Capricorn'],
  [295896163,296080139,'Aquarius'],
  [296080139,296266119,'Pisces'],
  [296266119,296456104,'Aries'],
  [296456104,296653437,'Taurus'],
  [296653437,296861010,'Gemini'],
  [296861010,297077761,'Cancer'],
  [297077761,297296513,'Leo'],
  [297296513,297507514,'Virgo'],
  [297507514,297705345,'Libra'],
  [297705345,297891366,'Scorpio'],
  [297891366,298070928,'Sagittarius'],
  [298070928,298249842,'Capricorn'],
  [298249842,298432188,'Aquarius'],
  [298432188,298619742,'Pisces'],
  [298619742,298813078,'Aries'],
  [298813078,299013153,'Taurus'],
  [299013153,299221434,'Gemini'],
  [299221434,299437756,'Cancer'],
  [299437756,299657384,'Leo'],
  [299657384,299871474,'Virgo'],
  [299871474,300072566,'Libra'],
  [300072566,300259466,'Scorpio'],
  [300259466,300436600,'Sagittarius'],
  [300436600,300610629,'Capricorn'],
  [300610629,300787782,'Aquarius'],
  [300787782,300972263,'Pisces'],
  [300972263,301165727,'Aries'],
  [301165727,301367996,'Taurus'],
  [301367996,301578206,'Gemini'],
  [301578206,301795006,'Cancer'],
  [301795006,302014975,'Leo'],
  [302014975,302231545,'Virgo'],
  [302231545,302437305,'Libra'],
  [302437305,302628563,'Scorpio'],
  [302628563,302807303,'Sagittarius'],
  [302807303,302979284,'Capricorn'],
  [302979284,303151442,'Aquarius'],
  [303151442,303330088,'Pisces'],
  [303330088,303519493,'Aries'],
  [303519493,303720854,'Taurus'],
  [303720854,303932243,'Gemini'],
  [303932243,304149971,'Cancer'],
  [304149971,304369850,'Leo'],
  [304369850,304587054,'Virgo'],
  [304587054,304796232,'Libra'],
  [304796232,304993158,'Scorpio'],
  [304993158,305177149,'Sagittarius'],
  [305177149,305351517,'Capricorn'],
  [305351517,305522177,'Aquarius'],
  [305522177,305696025,'Pisces'],
  [305696025,305879437,'Aries'],
  [305879437,306076388,'Taurus'],
  [306076388,306286426,'Gemini'],
  [306286426,306504562,'Cancer'],
  [306504562,306724281,'Leo'],
  [306724281,306940489,'Virgo'],
  [306940489,307149962,'Libra'],
  [307149962,307350382,'Scorpio'],
  [307350382,307540366,'Sagittarius'],
  [307540366,307720576,'Capricorn'],
  [307720576,307894370,'Aquarius'],
  [307894370,308067434,'Pisces'],
  [308067434,308246605,'Aries'],
  [308246605,308437991,'Taurus'],
  [308437991,308644068,'Gemini'],
  [308644068,308861114,'Cancer'],
  [308861114,309080820,'Leo'],
  [309080820,309295837,'Virgo'],
  [309295837,309503144,'Libra'],
  [309503144,309702817,'Scorpio'],
  [309702817,309895421,'Sagittarius'],
  [309895421,310081173,'Capricorn'],
  [310081173,310260954,'Aquarius'],
  [310260954,310437771,'Pisces'],
  [310437771,310616997,'Aries'],
  [310616997,310805046,'Taurus'],
  [310805046,311006640,'Gemini'],
  [311006640,311221051,'Cancer'],
  [311221051,311440650,'Leo'],
  [311440650,311655706,'Virgo'],
  [311655706,311861064,'Libra'],
  [311861064,312057328,'Scorpio'],
  [312057328,312247559,'Sagittarius'],
  [312247559,312434197,'Capricorn'],
  [312434197,312618247,'Aquarius'],
  [312618247,312800613,'Pisces'],
  [312800613,312983921,'Aries'],
  [312983921,313172805,'Taurus'],
  [313172805,313372177,'Gemini'],
  [313372177,313583775,'Cancer'],
  [313583775,313802794,'Leo'],
  [313802794,314019315,'Virgo'],
  [314019315,314225296,'Libra'],
  [314225296,314419354,'Scorpio'],
  [314419354,314605149,'Sagittarius'],
  [314605149,314787579,'Capricorn'],
  [314787579,314970258,'Aquarius'],
  [314970258,315154946,'Pisces'],
  [315154946,315342738,'Aries'],
  [315342738,315535540,'Taurus'],
  [315535540,315736191,'Gemini'],
  [315736191,315946647,'Cancer'],
  [315946647,316164798,'Leo'],
  [316164798,316383087,'Virgo'],
  [316383087,316592358,'Libra'],
  [316592358,316788055,'Scorpio'],
  [316788055,316971957,'Sagittarius'],
  [316971957,317149431,'Capricorn'],
  [317149431,317326390,'Aquarius'],
  [317326390,317507487,'Pisces'],
  [317507487,317695404,'Aries'],
  [317695404,317891180,'Taurus'],
  [317891180,318095009,'Gemini'],
  [318095009,318306645,'Cancer'],
  [318306645,318524412,'Leo'],
  [318524412,318743550,'Virgo'],
  [318743550,318956612,'Libra'],
  [318956612,319157225,'Scorpio'],
  [319157225,319343941,'Sagittarius'],
  [319343941,319520273,'Capricorn'],
  [319520273,319692397,'Aquarius'],
  [319692397,319867007,'Pisces'],
  [319867007,320049741,'Aries'],
  [320049741,320243795,'Taurus'],
  [320243795,320449046,'Gemini'],
  [320449046,320662704,'Cancer'],
  [320662704,320881023,'Leo'],
  [320881023,321100006,'Virgo'],
  [321100006,321314934,'Libra'],
  [321314934,321520516,'Scorpio'],
  [321520516,321713198,'Sagittarius'],
  [321713198,321893352,'Capricorn'],
  [321893352,322065295,'Aquarius'],
  [322065295,322235761,'Pisces'],
  [322235761,322412093,'Aries'],
  [322412093,322600351,'Taurus'],
  [322600351,322802885,'Gemini'],
  [322802885,323016814,'Cancer'],
  [323016814,323235934,'Leo'],
  [323235934,323454522,'Virgo'],
  [323454522,323668962,'Libra'],
  [323668962,323876502,'Scorpio'],
  [323876502,324074307,'Sagittarius'],
  [324074307,324260735,'Capricorn'],
  [324260735,324437143,'Aquarius'],
  [324437143,324608390,'Pisces'],
  [324608390,324781600,'Aries'],
  [324781600,324964206,'Taurus'],
  [324964206,325161340,'Gemini'],
  [325161340,325372609,'Cancer'],
  [325372609,325591524,'Leo'],
  [325591524,325809944,'Virgo'],
  [325809944,326022965,'Libra'],
  [326022965,326229221,'Scorpio'],
  [326229221,326428241,'Sagittarius'],
  [326428241,326619088,'Capricorn'],
  [326619088,326801414,'Aquarius'],
  [326801414,326977369,'Pisces'],
  [326977369,327152144,'Aries'],
  [327152144,327332678,'Taurus'],
  [327332678,327525315,'Gemini'],
  [327525315,327732430,'Cancer'],
  [327732430,327949688,'Leo'],
  [327949688,328168099,'Virgo'],
  [328168099,328380348,'Libra'],
  [328380348,328584239,'Scorpio'],
  [328584239,328780880,'Sagittarius'],
  [328780880,328971659,'Capricorn'],
  [328971659,329157144,'Aquarius'],
  [329157144,329338192,'Pisces'],
  [329338192,329517552,'Aries'],
  [329517552,329700120,'Taurus'],
  [329700120,329891562,'Gemini'],
  [329891562,330095561,'Cancer'],
  [330095561,330310532,'Leo'],
  [330310532,330528923,'Virgo'],
  [330528923,330741813,'Libra'],
  [330741813,330944663,'Scorpio'],
  [330944663,331138151,'Sagittarius'],
  [331138151,331325361,'Capricorn'],
  [331325361,331509255,'Aquarius'],
  [331509255,331691918,'Pisces'],
  [331691918,331875263,'Aries'],
  [331875263,332061965,'Taurus'],
  [332061965,332255525,'Gemini'],
  [332255525,332458970,'Cancer'],
  [332458970,332672336,'Leo'],
  [332672336,332890643,'Virgo'],
  [332890643,333105403,'Libra'],
  [333105403,333309764,'Scorpio'],
  [333309764,333502223,'Sagittarius'],
  [333502223,333685713,'Capricorn'],
  [333685713,333864948,'Aquarius'],
  [333864948,334044490,'Pisces'],
  [334044490,334227830,'Aries'],
  [334227830,334417267,'Taurus'],
  [334417267,334614213,'Gemini'],
  [334614213,334819467,'Cancer'],
  [334819467,335032697,'Leo'],
  [335032697,335250917,'Virgo'],
  [335250917,335467795,'Libra'],
  [335467795,335675837,'Scorpio'],
  [335675837,335870762,'Sagittarius'],
  [335870762,336053493,'Capricorn'],
  [336053493,336228744,'Aquarius'],
  [336228744,336402794,'Pisces'],
  [336402794,336581658,'Aries'],
  [336581658,336769591,'Taurus'],
  [336769591,336968013,'Gemini'],
  [336968013,337175665,'Cancer'],
  [337175665,337390063,'Leo'],
  [337390063,337608320,'Virgo'],
  [337608320,337826387,'Libra'],
  [337826387,338038359,'Scorpio'],
  [338038359,338238468,'Sagittarius'],
  [338238468,338424638,'Capricorn'],
  [338424638,338599684,'Aquarius'],
  [338599684,338769891,'Pisces'],
  [338769891,338942818,'Aries'],
  [338942818,339125276,'Taurus'],
  [339125276,339321029,'Gemini'],
  [339321029,339529063,'Cancer'],
  [339529063,339744776,'Leo'],
  [339744776,339963320,'Virgo'],
  [339963320,340181226,'Libra'],
  [340181226,340395043,'Scorpio'],
  [340395043,340600123,'Sagittarius'],
  [340600123,340792503,'Capricorn'],
  [340792503,340971939,'Aquarius'],
  [340971939,341142817,'Pisces'],
  [341142817,341312496,'Aries'],
  [341312496,341489058,'Taurus'],
  [341489058,341678909,'Gemini'],
  [341678909,341883710,'Cancer'],
  [341883710,342099128,'Leo'],
  [342099128,342318034,'Virgo'],
  [342318034,342535179,'Libra'],
  [342535179,342748105,'Scorpio'],
  [342748105,342954728,'Sagittarius'],
  [342954728,343152098,'Capricorn'],
  [343152098,343338139,'Aquarius'],
  [343338139,343514237,'Pisces'],
  [343514237,343685679,'Aries'],
  [343685679,343859945,'Taurus'],
  [343859945,344044474,'Gemini'],
  [344044474,344243745,'Cancer'],
  [344243745,344456263,'Leo'],
  [344456263,344674881,'Virgo'],
  [344674881,344891759,'Libra'],
  [344891759,345102835,'Scorpio'],
  [345102835,345307304,'Sagittarius'],
  [345307304,345504916,'Capricorn'],
  [345504916,345694889,'Aquarius'],
  [345694889,345877205,'Pisces'],
  [345877205,346054328,'Aries'],
  [346054328,346231349,'Taurus'],
  [346231349,346414649,'Gemini'],
  [346414649,346609674,'Cancer'],
  [346609674,346817957,'Leo'],
  [346817957,347035027,'Virgo'],
  [347035027,347252366,'Libra'],
  [347252366,347463001,'Scorpio'],
  [347463001,347664712,'Sagittarius'],
  [347664712,347858675,'Capricorn'],
  [347858675,348046942,'Aquarius'],
  [348046942,348231254,'Pisces'],
  [348231254,348413370,'Aries'],
  [348413370,348595874,'Taurus'],
  [348595874,348782447,'Gemini'],
  [348782447,348977157,'Cancer'],
  [348977157,349182624,'Leo'],
  [349182624,349397508,'Virgo'],
  [349397508,349615388,'Libra'],
  [349615388,349827755,'Scorpio'],
  [349827755,350029319,'Sagittarius'],
  [350029319,350220040,'Capricorn'],
  [350220040,350403414,'Aquarius'],
  [350403414,350584007,'Pisces'],
  [350584007,350765783,'Aries'],
  [350765783,350951424,'Taurus'],
  [350951424,351142541,'Gemini'],
  [351142541,351340374,'Cancer'],
  [351340374,351546096,'Leo'],
  [351546096,351759656,'Virgo'],
  [351759656,351977644,'Libra'],
  [351977644,352192765,'Scorpio'],
  [352192765,352397462,'Sagittarius'],
  [352397462,352588675,'Capricorn'],
  [352588675,352768887,'Aquarius'],
  [352768887,352943969,'Pisces'],
  [352943969,353120487,'Aries'],
  [353120487,353303648,'Taurus'],
  [353303648,353495896,'Gemini'],
  [353495896,353696858,'Cancer'],
  [353696858,353904975,'Leo'],
  [353904975,354118916,'Virgo'],
  [354118916,354336769,'Libra'],
  [354336769,354553913,'Scorpio'],
  [354553913,354763102,'Sagittarius'],
  [354763102,354958618,'Capricorn'],
  [354958618,355140140,'Aquarius'],
  [355140140,355312659,'Pisces'],
  [355312659,355483731,'Aries'],
  [355483731,355660833,'Taurus'],
  [355660833,355849132,'Gemini'],
  [355849132,356049603,'Cancer'],
  [356049603,356259413,'Leo'],
  [356259413,356474715,'Virgo'],
  [356474715,356692638,'Libra'],
  [356692638,356910251,'Scorpio'],
  [356910251,357122550,'Sagittarius'],
  [357122550,357323513,'Capricorn'],
  [357323513,357510115,'Aquarius'],
  [357510115,357684797,'Pisces'],
  [357684797,357854197,'Aries'],
  [357854197,358026389,'Taurus'],
  [358026389,358208551,'Gemini'],
  [358208551,358404498,'Cancer'],
  [358404498,358612952,'Leo'],
  [358612952,358828879,'Virgo'],
  [358828879,359047082,'Libra'],
  [359047082,359264084,'Scorpio'],
  [359264084,359476752,'Sagittarius'],
  [359476752,359680987,'Capricorn'],
  [359680987,359873228,'Aquarius'],
  [359873228,360053375,'Pisces'],
  [360053375,360225678,'Aries'],
  [360225678,360397094,'Taurus'],
  [360397094,360575093,'Gemini'],
  [360575093,360765437,'Cancer'],
  [360765437,360969723,'Leo'],
  [360969723,361184321,'Virgo'],
  [361184321,361402579,'Libra'],
  [361402579,361618864,'Scorpio'],
  [361618864,361829955,'Sagittarius'],
  [361829955,362033825,'Capricorn'],
  [362033825,362228735,'Aquarius'],
  [362228735,362414104,'Pisces'],
  [362414104,362591895,'Aries'],
  [362591895,362766705,'Taurus'],
  [362766705,362944638,'Gemini'],
  [362944638,363131649,'Cancer'],
  [363131649,363331403,'Leo'],
  [363331403,363543053,'Virgo'],
  [363543053,363760774,'Libra'],
  [363760774,363976963,'Scorpio'],
  [363976963,364186461,'Sagittarius'],
  [364186461,364387635,'Capricorn'],
  [364387635,364581019,'Aquarius'],
  [364581019,364767895,'Pisces'],
  [364767895,364950016,'Aries'],
  [364950016,365129982,'Taurus'],
  [365129982,365311465,'Gemini'],
  [365311465,365498882,'Cancer'],
  [365498882,365696214,'Leo'],
  [365696214,365904889,'Virgo'],
  [365904889,366121557,'Libra'],
  [366121557,366338476,'Scorpio'],
  [366338476,366548020,'Sagittarius'],
  [366548020,366746927,'Capricorn'],
  [366746927,366936537,'Aquarius'],
  [366936537,367120503,'Pisces'],
  [367120503,367302588,'Aries'],
  [367302588,367485618,'Taurus'],
  [367485618,367671558,'Gemini'],
  [367671558,367862326,'Cancer'],
  [367862326,368060328,'Leo'],
  [368060328,368267571,'Virgo'],
  [368267571,368483180,'Libra'],
  [368483180,368701286,'Scorpio'],
  [368701286,368913037,'Sagittarius'],
  [368913037,369112395,'Capricorn'],
  [369112395,369299416,'Aquarius'],
  [369299416,369478745,'Pisces'],
  [369478745,369656485,'Aries'],
  [369656485,369837734,'Taurus'],
  [369837734,370025210,'Gemini'],
  [370025210,370219417,'Cancer'],
  [370219417,370420250,'Leo'],
  [370420250,370628209,'Virgo'],
  [370628209,370843345,'Libra'],
  [370843345,371062371,'Scorpio'],
  [371062371,371277504,'Sagittarius'],
  [371277504,371480574,'Capricorn'],
  [371480574,371668771,'Aquarius'],
  [371668771,371845671,'Pisces'],
  [371845671,372018279,'Aries'],
  [372018279,372193904,'Taurus'],
  [372193904,372377882,'Gemini'],
  [372377882,372572026,'Cancer'],
  [372572026,372775101,'Leo'],
  [372775101,372985106,'Virgo'],
  [372985106,373200705,'Libra'],
  [373200705,373419928,'Scorpio'],
  [373419928,373637556,'Sagittarius'],
  [373637556,373845755,'Capricorn'],
  [373845755,374039053,'Aquarius'],
  [374039053,374218182,'Pisces'],
  [374218182,374389043,'Aries'],
  [374389043,374559529,'Taurus'],
  [374559529,374737033,'Gemini'],
  [374737033,374926323,'Cancer'],
  [374926323,375127984,'Leo'],
  [375127984,375339108,'Virgo'],
  [375339108,375555780,'Libra'],
  [375555780,375774816,'Scorpio'],
  [375774816,375992686,'Sagittarius'],
  [375992686,376204068,'Capricorn'],
  [376204068,376403441,'Aquarius'],
  [376403441,376588759,'Pisces'],
  [376588759,376763069,'Aries'],
  [376763069,376932873,'Taurus'],
  [376932873,377105746,'Gemini'],
  [377105746,377288403,'Cancer'],
  [377288403,377484638,'Leo'],
  [377484638,377693692,'Virgo'],
  [377693692,377910720,'Libra'],
  [377910720,378129802,'Scorpio'],
  [378129802,378346443,'Sagittarius'],
  [378346443,378557314,'Capricorn'],
  [378557314,378759425,'Aquarius'],
  [378759425,378950735,'Pisces'],
  [378950735,379131748,'Aries'],
  [379131748,379306039,'Taurus'],
  [379306039,379479380,'Gemini'],
  [379479380,379658341,'Cancer'],
  [379658341,379848623,'Leo'],
  [379848623,380052782,'Virgo'],
  [380052782,380268097,'Libra'],
  [380268097,380487326,'Scorpio'],
  [380487326,380703148,'Sagittarius'],
  [380703148,380911579,'Capricorn'],
  [380911579,381111823,'Aquarius'],
  [381111823,381304427,'Pisces'],
  [381304427,381490301,'Aries'],
  [381490301,381670982,'Taurus'],
  [381670982,381849296,'Gemini'],
  [381849296,382029661,'Cancer'],
  [382029661,382217434,'Leo'],
  [382217434,382417067,'Virgo'],
  [382417067,382629100,'Libra'],
  [382629100,382847908,'Scorpio'],
  [382847908,383064239,'Sagittarius'],
  [383064239,383271363,'Capricorn'],
  [383271363,383468163,'Aquarius'],
  [383468163,383657387,'Pisces'],
  [383657387,383842560,'Aries'],
  [383842560,384026201,'Taurus'],
  [384026201,384209760,'Gemini'],
  [384209760,384394880,'Cancer'],
  [384394880,384584592,'Leo'],
  [384584592,384782891,'Virgo'],
  [384782891,384992245,'Libra'],
  [384992245,385210035,'Scorpio'],
  [385210035,385427734,'Sagittarius'],
  [385427734,385636135,'Capricorn'],
  [385636135,385831631,'Aquarius'],
  [385831631,386016885,'Pisces'],
  [386016885,386197423,'Aries'],
  [386197423,386378373,'Taurus'],
  [386378373,386562734,'Gemini'],
  [386562734,386751456,'Cancer'],
  [386751456,386945124,'Leo'],
  [386945124,387145397,'Virgo'],
  [387145397,387354305,'Libra'],
  [387354305,387571256,'Scorpio'],
  [387571256,387790240,'Sagittarius'],
  [387790240,388001781,'Capricorn'],
  [388001781,388199488,'Aquarius'],
  [388199488,388383870,'Pisces'],
  [388383870,388560410,'Aries'],
  [388560410,388735936,'Taurus'],
  [388735936,388916036,'Gemini'],
  [388916036,389103656,'Cancer'],
  [389103656,389299263,'Leo'],
  [389299263,389502389,'Virgo'],
  [389502389,389712823,'Libra'],
  [389712823,389929774,'Scorpio'],
  [389929774,390149377,'Sagittarius'],
  [390149377,390364042,'Capricorn'],
  [390364042,390566289,'Aquarius'],
  [390566289,390753791,'Pisces'],
  [390753791,390930127,'Aries'],
  [390930127,391101973,'Taurus'],
  [391101973,391276345,'Gemini'],
  [391276345,391458752,'Cancer'],
  [391458752,391651945,'Leo'],
  [391651945,391855705,'Virgo'],
  [391855705,392067841,'Libra'],
  [392067841,392285516,'Scorpio'],
  [392285516,392505096,'Sagittarius'],
  [392505096,392721225,'Capricorn'],
  [392721225,392927712,'Aquarius'],
  [392927712,393120653,'Pisces'],
  [393120653,393300876,'Aries'],
  [393300876,393473226,'Taurus'],
  [393473226,393644414,'Gemini'],
  [393644414,393821212,'Cancer'],
  [393821212,394008915,'Leo'],
  [394008915,394209722,'Virgo'],
  [394209722,394421738,'Libra'],
  [394421738,394640073,'Scorpio'],
  [394640073,394859371,'Sagittarius'],
  [394859371,395075009,'Capricorn'],
  [395075009,395283099,'Aquarius'],
  [395283099,395480618,'Pisces'],
  [395480618,395666683,'Aries'],
  [395666683,395843468,'Taurus'],
  [395843468,396015795,'Gemini'],
  [396015795,396190006,'Cancer'],
  [396190006,396372599,'Leo'],
  [396372599,396568326,'Virgo'],
  [396568326,396777683,'Libra'],
  [396777683,396995722,'Scorpio'],
  [396995722,397214836,'Sagittarius'],
  [397214836,397429093,'Capricorn'],
  [397429093,397635837,'Aquarius'],
  [397635837,397834390,'Pisces'],
  [397834390,398024636,'Aries'],
  [398024636,398207179,'Taurus'],
  [398207179,398384224,'Gemini'],
  [398384224,398560111,'Cancer'],
  [398560111,398740805,'Leo'],
  [398740805,398932274,'Virgo'],
  [398932274,399137652,'Libra'],
  [399137652,399354106,'Scorpio'],
  [399354106,399573256,'Sagittarius'],
  [399573256,399786744,'Capricorn'],
  [399786744,399991048,'Aquarius'],
  [399991048,400187095,'Pisces'],
  [400187095,400377164,'Aries'],
  [400377164,400562833,'Taurus'],
  [400562833,400745059,'Gemini'],
  [400745059,400925657,'Cancer'],
  [400925657,401108449,'Leo'],
  [401108449,401298756,'Virgo'],
  [401298756,401501052,'Libra'],
  [401501052,401715262,'Scorpio'],
  [401715262,401934517,'Sagittarius'],
  [401934517,402148814,'Capricorn'],
  [402148814,402352121,'Aquarius'],
  [402352121,402544869,'Pisces'],
  [402544869,402731091,'Aries'],
  [402731091,402914885,'Taurus'],
  [402914885,403098627,'Gemini'],
  [403098627,403283353,'Cancer'],
  [403283353,403470519,'Leo'],
  [403470519,403663137,'Virgo'],
  [403663137,403864941,'Libra'],
  [403864941,404077478,'Scorpio'],
  [404077478,404296658,'Sagittarius'],
  [404296658,404513115,'Capricorn'],
  [404513115,404718373,'Aquarius'],
  [404718373,404910366,'Pisces'],
  [404910366,405092790,'Aries'],
  [405092790,405271446,'Taurus'],
  [405271446,405451399,'Gemini'],
  [405451399,405635665,'Cancer'],
  [405635665,405825514,'Leo'],
  [405825514,406021797,'Virgo'],
  [406021797,406225757,'Libra'],
  [406225757,406438238,'Scorpio'],
  [406438238,406657149,'Sagittarius'],
  [406657149,406875725,'Capricorn'],
  [406875725,407085203,'Aquarius'],
  [407085203,407280524,'Pisces'],
  [407280524,407462917,'Aries'],
  [407462917,407637776,'Taurus'],
  [407637776,407811685,'Gemini'],
  [407811685,407990447,'Cancer'],
  [407990447,408177853,'Leo'],
  [408177853,408375211,'Virgo'],
  [408375211,408581791,'Libra'],
  [408581791,408795809,'Scorpio'],
  [408795809,409014689,'Sagittarius'],
  [409014689,409234001,'Capricorn'],
  [409234001,409447264,'Aquarius'],
  [409447264,409648433,'Pisces'],
  [409648433,409835518,'Aries'],
  [409835518,410011396,'Taurus'],
  [410011396,410182057,'Gemini'],
  [410182057,410354562,'Cancer'],
  [410354562,410535420,'Leo'],
  [410535420,410728861,'Virgo'],
  [410728861,410935149,'Libra'],
  [410935149,411150605,'Scorpio'],
  [411150605,411370021,'Sagittarius'],
  [411370021,411588819,'Capricorn'],
  [411588819,411803057,'Aquarius'],
  [411803057,412008654,'Pisces'],
  [412008654,412202400,'Aries'],
  [412202400,412383984,'Taurus'],
  [412383984,412556793,'Gemini'],
  [412556793,412727060,'Cancer'],
  [412727060,412902221,'Leo'],
  [412902221,413089042,'Virgo'],
  [413089042,413290925,'Libra'],
  [413290925,413505399,'Scorpio'],
  [413505399,413725272,'Sagittarius'],
  [413725272,413943490,'Capricorn'],
  [413943490,414156309,'Aquarius'],
  [414156309,414362231,'Pisces'],
  [414362231,414559863,'Aries'],
  [414559863,414747913,'Taurus'],
  [414747913,414926833,'Gemini'],
  [414926833,415100203,'Cancer'],
  [415100203,415274343,'Leo'],
  [415274343,415456595,'Virgo'],
  [415456595,415652753,'Libra'],
  [415652753,415863507,'Scorpio'],
  [415863507,416082613,'Sagittarius'],
  [416082613,416300795,'Capricorn'],
  [416300795,416512093,'Aquarius'],
  [416512093,416715505,'Pisces'],
  [416715505,416912142,'Aries'],
  [416912142,417102619,'Taurus'],
  [417102619,417286915,'Gemini'],
  [417286915,417466118,'Cancer'],
  [417466118,417643918,'Leo'],
  [417643918,417826222,'Virgo'],
  [417826222,418019161,'Libra'],
  [418019161,418225820,'Scorpio'],
  [418225820,418442874,'Sagittarius'],
  [418442874,418661283,'Capricorn'],
  [418661283,418872575,'Aquarius'],
  [418872575,419073872,'Pisces'],
  [419073872,419266969,'Aries'],
  [419266969,419454896,'Taurus'],
  [419454896,419639737,'Gemini'],
  [419639737,419822684,'Cancer'],
  [419822684,420005479,'Leo'],
  [420005479,420191468,'Virgo'],
  [420191468,420385118,'Libra'],
  [420385118,420589852,'Scorpio'],
  [420589852,420804837,'Sagittarius'],
  [420804837,421023375,'Capricorn'],
  [421023375,421236276,'Aquarius'],
  [421236276,421437966,'Pisces'],
  [421437966,421628713,'Aries'],
  [421628713,421812310,'Taurus'],
  [421812310,421993184,'Gemini'],
  [421993184,422174823,'Cancer'],
  [422174823,422359602,'Leo'],
  [422359602,422549424,'Virgo'],
  [422549424,422746275,'Libra'],
  [422746275,422951886,'Scorpio'],
  [422951886,423166039,'Sagittarius'],
  [423166039,423384568,'Capricorn'],
  [423384568,423599771,'Aquarius'],
  [423599771,423804449,'Pisces'],
  [423804449,423996167,'Aries'],
  [423996167,424177465,'Taurus'],
  [424177465,424353556,'Gemini'],
  [424353556,424530166,'Cancer'],
  [424530166,424712092,'Leo'],
  [424712092,424902325,'Virgo'],
  [424902325,425101763,'Libra'],
  [425101763,425309712,'Scorpio'],
  [425309712,425524500,'Sagittarius'],
  [425524500,425743015,'Capricorn'],
  [425743015,425959966,'Aquarius'],
  [425959966,426168714,'Pisces'],
  [426168714,426364575,'Aries'],
  [426364575,426547475,'Taurus'],
  [426547475,426721560,'Gemini'],
  [426721560,426893300,'Cancer'],
  [426893300,427069571,'Leo'],
  [427069571,427255881,'Virgo'],
  [427255881,427454550,'Libra'],
  [427454550,427663929,'Scorpio'],
  [427663929,427879996,'Sagittarius'],
  [427879996,428098618,'Capricorn'],
  [428098618,428315992,'Aquarius'],
  [428315992,428527642,'Pisces'],
  [428527642,428728719,'Aries'],
  [428728719,428916620,'Taurus'],
  [428916620,429092964,'Gemini'],
  [429092964,429263230,'Cancer'],
  [429263230,429434889,'Leo'],
  [429434889,429615371,'Virgo'],
  [429615371,429809641,'Libra'],
  [429809641,430017617,'Scorpio'],
  [430017617,430234212,'Sagittarius'],
  [430234212,430453038,'Capricorn'],
  [430453038,430669745,'Aquarius'],
  [430669745,430881699,'Pisces'],
  [430881699,431086001,'Aries'],
  [431086001,431279573,'Taurus'],
  [431279573,431461474,'Gemini'],
  [431461474,431634701,'Cancer'],
  [431634701,431805627,'Leo'],
  [431805627,431982040,'Virgo'],
  [431982040,432170785,'Libra'],
  [432170785,432374598,'Scorpio'],
  [432374598,432589839,'Sagittarius'],
  [432589839,432808701,'Capricorn'],
  [432808701,433024626,'Aquarius'],
  [433024626,433234877,'Pisces'],
  [433234877,433438677,'Aries'],
  [433438677,433634895,'Taurus'],
  [433634895,433822216,'Gemini'],
  [433822216,434001232,'Cancer'],
  [434001232,434175799,'Leo'],
  [434175799,434352308,'Virgo'],
  [434352308,434537743,'Libra'],
  [434537743,434736875,'Scorpio'],
  [434736875,434949009,'Sagittarius'],
  [434949009,435167336,'Capricorn'],
  [435167336,435383286,'Aquarius'],
  [435383286,435591950,'Pisces'],
  [435591950,435792812,'Aries'],
  [435792812,435987090,'Taurus'],
  [435987090,436175649,'Gemini'],
  [436175649,436359112,'Cancer'],
  [436359112,436539263,'Leo'],
  [436539263,436719867,'Virgo'],
  [436719867,436906126,'Libra'],
  [436906126,437102868,'Scorpio'],
  [437102868,437311745,'Sagittarius'],
  [437311745,437528828,'Capricorn'],
  [437528828,437745731,'Aquarius'],
  [437745731,437954889,'Pisces'],
  [437954889,438153688,'Aries'],
  [438153688,438343831,'Taurus'],
  [438343831,438528673,'Gemini'],
  [438528673,438711349,'Cancer'],
  [438711349,438894298,'Leo'],
  [438894298,439079700,'Virgo'],
  [439079700,439270030,'Libra'],
  [439270030,439468021,'Scorpio'],
  [439468021,439675499,'Sagittarius'],
  [439675499,439891181,'Capricorn'],
  [439891181,440109199,'Aquarius'],
  [440109199,440321168,'Pisces'],
  [440321168,440521338,'Aries'],
  [440521338,440709424,'Taurus'],
  [440709424,440889336,'Gemini'],
  [440889336,441066650,'Cancer'],
  [441066650,441246579,'Leo'],
  [441246579,441432692,'Virgo'],
  [441432692,441626465,'Libra'],
  [441626465,441827904,'Scorpio'],
  [441827904,442036624,'Sagittarius'],
  [442036624,442251760,'Capricorn'],
  [442251760,442470242,'Aquarius'],
  [442470242,442685585,'Pisces'],
  [442685585,442890351,'Aries'],
  [442890351,443080913,'Taurus'],
  [443080913,443259320,'Gemini'],
  [443259320,443431616,'Cancer'],
  [443431616,443605150,'Leo'],
  [443605150,443786363,'Virgo'],
  [443786363,443978801,'Libra'],
  [443978801,444182054,'Scorpio'],
  [444182054,444393139,'Sagittarius'],
  [444393139,444609063,'Capricorn'],
  [444609063,444827435,'Aquarius'],
  [444827435,445044542,'Pisces'],
  [445044542,445254205,'Aries'],
  [445254205,445450654,'Taurus'],
  [445450654,445632643,'Gemini'],
  [445632643,445804450,'Cancer'],
  [445804450,445973601,'Leo'],
  [445973601,446148217,'Virgo'],
  [446148217,446334704,'Libra'],
  [446334704,446535204,'Scorpio'],
  [446535204,446746718,'Sagittarius'],
  [446746718,446963805,'Capricorn'],
  [446963805,447182153,'Aquarius'],
  [447182153,447398981,'Pisces'],
  [447398981,447610735,'Aries'],
  [447610735,447812523,'Taurus'],
  [447812523,448000965,'Gemini'],
  [448000965,448177259,'Cancer'],
  [448177259,448347116,'Leo'],
  [448347116,448518408,'Virgo'],
  [448518408,448698829,'Libra'],
  [448698829,448893367,'Scorpio'],
  [448893367,449101758,'Sagittarius'],
  [449101758,449318582,'Capricorn'],
  [449318582,449537094,'Aquarius'],
  [449537094,449752896,'Pisces'],
  [449752896,449963611,'Aries'],
  [449963611,450166853,'Taurus'],
  [450166853,450360079,'Gemini'],
  [450360079,450542663,'Cancer'],
  [450542663,450717516,'Leo'],
  [450717516,450890513,'Virgo'],
  [450890513,451068705,'Libra'],
  [451068705,451258206,'Scorpio'],
  [451258206,451461621,'Sagittarius'],
  [451461621,451676082,'Capricorn'],
  [451676082,451894417,'Aquarius'],
  [451894417,452109720,'Pisces'],
  [452109720,452318391,'Aries'],
  [452318391,452519470,'Taurus'],
  [452519470,452712897,'Gemini'],
  [452712897,452899030,'Cancer'],
  [452899030,453079421,'Leo'],
  [453079421,453257413,'Virgo'],
  [453257413,453437865,'Libra'],
  [453437865,453626042,'Scorpio'],
  [453626042,453825758,'Sagittarius'],
  [453825758,454037007,'Capricorn'],
  [454037007,454254566,'Aquarius'],
  [454254566,454470318,'Pisces'],
  [454470318,454678141,'Aries'],
  [454678141,454876301,'Taurus'],
  [454876301,455066383,'Gemini'],
  [455066383,455251215,'Cancer'],
  [455251215,455433577,'Leo'],
  [455433577,455615963,'Virgo'],
  [455615963,455800929,'Libra'],
  [455800929,455991445,'Scorpio'],
  [455991445,456190516,'Sagittarius'],
  [456190516,456399579,'Capricorn'],
  [456399579,456616130,'Aquarius'],
  [456616130,456833036,'Pisces'],
  [456833036,457042167,'Aries'],
  [457042167,457239406,'Taurus'],
  [457239406,457425986,'Gemini'],
  [457425986,457606453,'Cancer'],
  [457606453,457786010,'Leo'],
  [457786010,457968705,'Virgo'],
  [457968705,458156722,'Libra'],
  [458156722,458350919,'Scorpio'],
  [458350919,458552032,'Sagittarius'],
  [458552032,458760920,'Capricorn'],
  [458760920,458976822,'Aquarius'],
  [458976822,459194964,'Pisces'],
  [459194964,459407111,'Aries'],
  [459407111,459606571,'Taurus'],
  [459606571,459792449,'Gemini'],
  [459792449,459969200,'Cancer'],
  [459969200,460143635,'Leo'],
  [460143635,460322190,'Virgo'],
  [460322190,460508969,'Libra'],
  [460508969,460704856,'Scorpio'],
  [460704856,460908625,'Sagittarius'],
  [460908625,461118983,'Capricorn'],
  [461118983,461334951,'Aquarius'],
  [461334951,461553772,'Pisces'],
  [461553772,461769053,'Aries'],
  [461769053,461973078,'Taurus'],
  [461973078,462162111,'Gemini'],
  [462162111,462338701,'Cancer'],
  [462338701,462509575,'Leo'],
  [462509575,462682555,'Virgo'],
  [462682555,462864173,'Libra'],
  [462864173,463057584,'Scorpio'],
  [463057584,463261866,'Sagittarius'],
  [463261866,463473831,'Capricorn'],
  [463473831,463690478,'Aquarius'],
  [463690478,463909262,'Pisces'],
  [463909262,464126024,'Aries'],
  [464126024,464334417,'Taurus'],
  [464334417,464529143,'Gemini'],
  [464529143,464709847,'Cancer'],
  [464709847,464881387,'Leo'],
  [464881387,465051280,'Virgo'],
  [465051280,465227220,'Libra'],
  [465227220,465414923,'Scorpio'],
  [465414923,465616036,'Sagittarius'],
  [465616036,465827772,'Capricorn'],
  [465827772,466045091,'Aquarius'],
  [466045091,466263557,'Pisces'],
  [466263557,466479676,'Aries'],
  [466479676,466689533,'Taurus'],
  [466689533,466888988,'Gemini'],
  [466888988,467075998,'Cancer'],
  [467075998,467252548,'Leo'],
  [467252548,467424085,'Virgo'],
  [467424085,467597650,'Libra'],
  [467597650,467780006,'Scorpio'],
  [467780006,467975553,'Sagittarius'],
  [467975553,468184242,'Capricorn'],
  [468184242,468401224,'Aquarius'],
  [468401224,468619652,'Pisces'],
  [468619652,468834308,'Aries'],
  [468834308,469042374,'Taurus'],
  [469042374,469242361,'Gemini'],
  [469242361,469433476,'Cancer'],
  [469433476,469616278,'Leo'],
  [469616278,469793412,'Virgo'],
  [469793412,469969513,'Libra'],
  [469969513,470150359,'Scorpio'],
  [470150359,470341406,'Sagittarius'],
  [470341406,470545539,'Capricorn'],
  [470545539,470760576,'Aquarius'],
  [470760576,470979236,'Pisces'],
  [470979236,471193485,'Aries'],
  [471193485,471399016,'Taurus'],
  [471399016,471595759,'Gemini'],
  [471595759,471785719,'Cancer'],
  [471785719,471971053,'Leo'],
  [471971053,472153555,'Virgo'],
  [472153555,472335238,'Libra'],
  [472335238,472519183,'Scorpio'],
  [472519183,472709629,'Sagittarius'],
  [472709629,472910576,'Capricorn'],
  [472910576,473122883,'Aquarius'],
  [473122883,473341512,'Pisces'],
  [473341512,473557123,'Aries'],
  [473557123,473762345,'Taurus'],
  [473762345,473955891,'Gemini'],
  [473955891,474141274,'Cancer'],
  [474141274,474323428,'Leo'],
  [474323428,474506228,'Virgo'],
  [474506228,474691608,'Libra'],
  [474691608,474880392,'Scorpio'],
  [474880392,475074015,'Sagittarius'],
  [475074015,475275111,'Capricorn'],
  [475275111,475485736,'Aquarius'],
  [475485736,475703879,'Pisces'],
  [475703879,475921694,'Aries'],
  [475921694,476129693,'Taurus'],
  [476129693,476323525,'Gemini'],
  [476323525,476505694,'Cancer'],
  [476505694,476682443,'Leo'],
  [476682443,476860255,'Virgo'],
  [476860255,477043593,'Libra'],
  [477043593,477233997,'Scorpio'],
  [477233997,477431164,'Sagittarius'],
  [477431164,477634981,'Capricorn'],
  [477634981,477846094,'Aquarius'],
  [477846094,478063845,'Pisces'],
  [478063845,478283219,'Aries'],
  [478283219,478495377,'Taurus'],
  [478495377,478693347,'Gemini'],
  [478693347,478876747,'Cancer'],
  [478876747,479050859,'Leo'],
  [479050859,479223101,'Virgo'],
  [479223101,479400296,'Libra'],
  [479400296,479586818,'Scorpio'],
  [479586818,479783721,'Sagittarius'],
  [479783721,479989635,'Capricorn'],
  [479989635,480202577,'Aquarius'],
  [480202577,480420623,'Pisces'],
  [480420623,480640327,'Aries'],
  [480640327,480855365,'Taurus'],
  [480855365,481058737,'Gemini'],
  [481058737,481247309,'Cancer'],
  [481247309,481423674,'Leo'],
  [481423674,481594168,'Virgo'],
  [481594168,481766175,'Libra'],
  [481766175,481946214,'Scorpio'],
  [481946214,482138300,'Sagittarius'],
  [482138300,482342782,'Capricorn'],
  [482342782,482556629,'Aquarius'],
  [482556629,482775395,'Pisces'],
  [482775395,482994732,'Aries'],
  [482994732,483210123,'Taurus'],
  [483210123,483416767,'Gemini'],
  [483416767,483611146,'Cancer'],
  [483611146,483793242,'Leo'],
  [483793242,483966813,'Virgo'],
  [483966813,484137969,'Libra'],
  [484137969,484313541,'Scorpio'],
  [484313541,484499552,'Sagittarius'],
  [484499552,484699311,'Capricorn'],
  [484699311,484911502,'Aquarius'],
  [484911502,485130441,'Pisces'],
  [485130441,485349407,'Aries'],
  [485349407,485563473,'Taurus'],
  [485563473,485769883,'Gemini'],
  [485769883,485967090,'Cancer'],
  [485967090,486154668,'Leo'],
  [486154668,486334022,'Virgo'],
  [486334022,486508730,'Libra'],
  [486508730,486684197,'Scorpio'],
  [486684197,486866645,'Sagittarius'],
  [486866645,487061342,'Capricorn'],
  [487061342,487269845,'Aquarius'],
  [487269845,487487744,'Pisces'],
  [487487744,487706611,'Aries'],
  [487706611,487919380,'Taurus'],
  [487919380,488123417,'Gemini'],
  [488123417,488319374,'Cancer'],
  [488319374,488508710,'Leo'],
  [488508710,488692663,'Virgo'],
  [488692663,488872758,'Libra'],
  [488872758,489051910,'Scorpio'],
  [489051910,489234825,'Sagittarius'],
  [489234825,489426943,'Capricorn'],
  [489426943,489631853,'Aquarius'],
  [489631853,489847808,'Pisces'],
  [489847808,490066809,'Aries'],
  [490066809,490279577,'Taurus'],
  [490279577,490481664,'Gemini'],
  [490481664,490674271,'Cancer'],
  [490674271,490861081,'Leo'],
  [490861081,491045319,'Virgo'],
  [491045319,491228739,'Libra'],
  [491228739,491412536,'Scorpio'],
  [491412536,491598987,'Sagittarius'],
  [491598987,491791941,'Capricorn'],
  [491791941,491995254,'Aquarius'],
  [491995254,492209403,'Pisces'],
  [492209403,492428600,'Aries'],
  [492428600,492642959,'Taurus'],
  [492642959,492845449,'Gemini'],
  [492845449,493035800,'Cancer'],
  [493035800,493218439,'Leo'],
  [493218439,493398789,'Virgo'],
  [493398789,493580828,'Libra'],
  [493580828,493766448,'Scorpio'],
  [493766448,493956558,'Sagittarius'],
  [493956558,494152630,'Capricorn'],
  [494152630,494356882,'Aquarius'],
  [494356882,494570332,'Pisces'],
  [494570332,494789619,'Aries'],
  [494789619,495006378,'Taurus'],
  [495006378,495211996,'Gemini'],
  [495211996,495403446,'Cancer'],
  [495403446,495583895,'Leo'],
  [495583895,495759488,'Virgo'],
  [495759488,495936373,'Libra'],
  [495936373,496118965,'Scorpio'],
  [496118965,496309354,'Sagittarius'],
  [496309354,496507974,'Capricorn'],
  [496507974,496714639,'Aquarius'],
  [496714639,496928789,'Pisces'],
  [496928789,497148045,'Aries'],
  [497148045,497366569,'Taurus'],
  [497366569,497576511,'Gemini'],
  [497576511,497772556,'Cancer'],
  [497772556,497955053,'Leo'],
  [497955053,498128886,'Virgo'],
  [498128886,498300777,'Libra'],
  [498300777,498477272,'Scorpio'],
  [498477272,498663259,'Sagittarius'],
  [498663259,498860820,'Capricorn'],
  [498860820,499068941,'Aquarius'],
  [499068941,499284538,'Pisces'],
  [499284538,499503873,'Aries'],
  [499503873,499722571,'Taurus'],
  [499722571,499935313,'Gemini'],
  [499935313,500136971,'Cancer'],
  [500136971,500325284,'Leo'],
  [500325284,500502237,'Virgo'],
  [500502237,500673134,'Libra'],
  [500673134,500844886,'Scorpio'],
  [500844886,501024416,'Sagittarius'],
  [501024416,501216808,'Capricorn'],
  [501216808,501423060,'Aquarius'],
  [501423060,501639235,'Pisces'],
  [501639235,501858927,'Aries'],
  [501858927,502076724,'Taurus'],
  [502076724,502289179,'Gemini'],
  [502289179,502493662,'Cancer'],
  [502493662,502687938,'Leo'],
  [502687938,502871425,'Virgo'],
  [502871425,503046433,'Libra'],
  [503046433,503218218,'Scorpio'],
  [503218218,503393798,'Sagittarius'],
  [503393798,503580135,'Capricorn'],
  [503580135,503781376,'Aquarius'],
  [503781376,503995709,'Pisces'],
  [503995709,504215555,'Aries'],
  [504215555,504432750,'Taurus'],
  [504432750,504643135,'Gemini'],
  [504643135,504846193,'Cancer'],
  [504846193,505042205,'Leo'],
  [505042205,505230914,'Virgo'],
  [505230914,505412421,'Libra'],
  [505412421,505588987,'Scorpio'],
  [505588987,505765690,'Sagittarius'],
  [505765690,505949251,'Capricorn'],
  [505949251,506145585,'Aquarius'],
  [506145585,506356116,'Pisces'],
  [506356116,506575097,'Aries'],
  [506575097,506792651,'Taurus'],
  [506792651,507001866,'Gemini'],
  [507001866,507201789,'Cancer'],
  [507201789,507394833,'Leo'],
  [507394833,507583367,'Virgo'],
  [507583367,507768397,'Libra'],
  [507768397,507950591,'Scorpio'],
  [507950591,508132200,'Sagittarius'],
  [508132200,508317711,'Capricorn'],
  [508317711,508512496,'Aquarius'],
  [508512496,508719787,'Pisces'],
  [508719787,508937008,'Aries'],
  [508937008,509155398,'Taurus'],
  [509155398,509365737,'Gemini'],
  [509365737,509564442,'Cancer'],
  [509564442,509753652,'Leo'],
  [509753652,509937732,'Virgo'],
  [509937732,510120434,'Libra'],
  [510120434,510303943,'Scorpio'],
  [510303943,510489661,'Sagittarius'],
  [510489661,510679558,'Capricorn'],
  [510679558,510876568,'Aquarius'],
  [510876568,511083274,'Pisces'],
  [511083274,511299075,'Aries'],
  [511299075,511518057,'Taurus'],
  [511518057,511731154,'Gemini'],
  [511731154,511932031,'Cancer'],
  [511932031,512120410,'Leo'],
  [512120410,512300430,'Virgo'],
  [512300430,512477644,'Libra'],
  [512477644,512656998,'Scorpio'],
  [512656998,512841896,'Sagittarius'],
  [512841896,513034158,'Capricorn'],
  [513034158,513234523,'Aquarius'],
  [513234523,513443105,'Pisces'],
  [513443105,513658847,'Aries'],
  [513658847,513877993,'Taurus'],
  [513877993,514093754,'Gemini'],
  [514093754,514299023,'Cancer'],
  [514299023,514490593,'Leo'],
  [514490593,514670396,'Virgo'],
  [514670396,514843759,'Libra'],
  [514843759,515017205,'Scorpio'],
  [515017205,515196781,'Sagittarius'],
  [515196781,515386626,'Capricorn'],
  [515386626,515587832,'Aquarius'],
  [515587832,515798515,'Pisces'],
  [515798515,516015330,'Aries'],
  [516015330,516234488,'Taurus'],
  [516234488,516451470,'Gemini'],
  [516451470,516660773,'Cancer'],
  [516660773,516857798,'Leo'],
  [516857798,517041577,'Virgo'],
  [517041577,517215404,'Libra'],
  [517215404,517385541,'Scorpio'],
  [517385541,517559346,'Sagittarius'],
  [517559346,517743437,'Capricorn'],
  [517743437,517941411,'Aquarius'],
  [517941411,518151921,'Pisces'],
  [518151921,518369658,'Aries'],
  [518369658,518588888,'Taurus'],
  [518588888,518805547,'Gemini'],
  [518805547,519016422,'Cancer'],
  [519016422,519217991,'Leo'],
  [519217991,519407676,'Virgo'],
  [519407676,519585992,'Libra'],
  [519585992,519757282,'Scorpio'],
  [519757282,519928519,'Sagittarius'],
  [519928519,520107377,'Capricorn'],
  [520107377,520299853,'Aquarius'],
  [520299853,520507164,'Pisces'],
  [520507164,520724348,'Aries'],
  [520724348,520943604,'Taurus'],
  [520943604,521159303,'Gemini'],
  [521159303,521369142,'Cancer'],
  [521369142,521571874,'Leo'],
  [521571874,521765816,'Virgo'],
  [521765816,521949957,'Libra'],
  [521949957,522126021,'Scorpio'],
  [522126021,522299058,'Sagittarius'],
  [522299058,522476138,'Capricorn'],
  [522476138,522664187,'Aquarius'],
  [522664187,522866907,'Pisces'],
  [522866907,523081752,'Aries'],
  [523081752,523300707,'Taurus'],
  [523300707,523515865,'Gemini'],
  [523515865,523723745,'Cancer'],
  [523723745,523924382,'Leo'],
  [523924382,524118426,'Virgo'],
  [524118426,524305886,'Libra'],
  [524305886,524487247,'Scorpio'],
  [524487247,524665117,'Sagittarius'],
  [524665117,524844496,'Capricorn'],
  [524844496,525031483,'Aquarius'],
  [525031483,525230808,'Pisces'],
  [525230808,525442594,'Aries'],
  [525442594,525660780,'Taurus'],
  [525660780,525876394,'Gemini'],
  [525876394,526083481,'Cancer'],
  [526083481,526281263,'Leo'],
  [526281263,526471930,'Virgo'],
  [526471930,526657972,'Libra'],
  [526657972,526841213,'Scorpio'],
  [526841213,527023452,'Sagittarius'],
  [527023452,527207420,'Capricorn'],
  [527207420,527396921,'Aquarius'],
  [527396921,527595755,'Pisces'],
  [527595755,527805399,'Aries'],
  [527805399,528022571,'Taurus'],
  [528022571,528239454,'Gemini'],
  [528239454,528448099,'Cancer'],
  [528448099,528645170,'Leo'],
  [528645170,528832313,'Virgo'],
  [528832313,529013691,'Libra'],
  [529013691,529193759,'Scorpio'],
  [529193759,529376093,'Sagittarius'],
  [529376093,529563150,'Capricorn'],
  [529563150,529756613,'Aquarius'],
  [529756613,529957783,'Pisces'],
  [529957783,530167314,'Aries'],
  [530167314,530383713,'Taurus'],
  [530383713,530601833,'Gemini'],
  [530601833,530813894,'Cancer'],
  [530813894,531013824,'Leo'],
  [531013824,531200712,'Virgo'],
  [531200712,531378313,'Libra'],
  [531378313,531552720,'Scorpio'],
  [531552720,531730189,'Sagittarius'],
  [531730189,531915448,'Capricorn'],
  [531915448,532110488,'Aquarius'],
  [532110488,532314610,'Pisces'],
  [532314610,532525890,'Aries'],
  [532525890,532742283,'Taurus'],
  [532742283,532960803,'Gemini'],
  [532960803,533176038,'Cancer'],
  [533176038,533381218,'Leo'],
  [533381218,533572287,'Virgo'],
  [533572287,533750475,'Libra'],
  [533750475,533921454,'Scorpio'],
  [533921454,534092854,'Sagittarius'],
  [534092854,534271997,'Capricorn'],
  [534271997,534463615,'Aquarius'],
  [534463615,534667853,'Pisces'],
  [534667853,534880886,'Aries'],
  [534880886,535098126,'Taurus'],
  [535098126,535316341,'Gemini'],
  [535316341,535532514,'Cancer'],
  [535532514,535741914,'Leo'],
  [535741914,535939361,'Virgo'],
  [535939361,536122860,'Libra'],
  [536122860,536295580,'Scorpio'],
  [536295580,536464503,'Sagittarius'],
  [536464503,536637888,'Capricorn'],
  [536637888,536822926,'Aquarius'],
  [536822926,537022861,'Pisces'],
  [537022861,537235047,'Aries'],
  [537235047,537453006,'Taurus'],
  [537453006,537671021,'Gemini'],
  [537671021,537886109,'Cancer'],
  [537886109,538096041,'Leo'],
  [538096041,538297542,'Virgo'],
  [538297542,538487594,'Libra'],
  [538487594,538666339,'Scorpio'],
  [538666339,538838203,'Sagittarius'],
  [538838203,539010374,'Capricorn'],
  [539010374,539190554,'Aquarius'],
  [539190554,539384395,'Pisces'],
  [539384395,539592515,'Aries'],
  [539592515,539809566,'Taurus'],
  [539809566,540027724,'Gemini'],
  [540027724,540241627,'Cancer'],
  [540241627,540449337,'Leo'],
  [540449337,540650119,'Virgo'],
  [540650119,540842977,'Libra'],
  [540842977,541027477,'Scorpio'],
  [541027477,541205441,'Sagittarius'],
  [541205441,541381397,'Capricorn'],
  [541381397,541561520,'Aquarius'],
  [541561520,541751730,'Pisces'],
  [541751730,541955123,'Aries'],
  [541955123,542169497,'Taurus'],
  [542169497,542387601,'Gemini'],
  [542387601,542601598,'Cancer'],
  [542601598,542807387,'Leo'],
  [542807387,543004758,'Virgo'],
  [543004758,543195272,'Libra'],
  [543195272,543380699,'Scorpio'],
  [543380699,543562882,'Sagittarius'],
  [543562882,543744292,'Capricorn'],
  [543744292,543928397,'Aquarius'],
  [543928397,544119303,'Pisces'],
  [544119303,544320383,'Aries'],
  [544320383,544531996,'Taurus'],
  [544531996,544749569,'Gemini'],
  [544749569,544964905,'Cancer'],
  [544964905,545171126,'Leo'],
  [545171126,545366193,'Virgo'],
  [545366193,545552392,'Libra'],
  [545552392,545733963,'Scorpio'],
  [545733963,545915082,'Sagittarius'],
  [545915082,546098843,'Capricorn'],
  [546098843,546287210,'Aquarius'],
  [546287210,546481655,'Pisces'],
  [546481655,546683710,'Aries'],
  [546683710,546894217,'Taurus'],
  [546894217,547111175,'Gemini'],
  [547111175,547328265,'Cancer'],
  [547328265,547537280,'Leo'],
  [547537280,547733320,'Virgo'],
  [547733320,547917224,'Libra'],
  [547917224,548094034,'Scorpio'],
  [548094034,548270167,'Sagittarius'],
  [548270167,548451143,'Capricorn'],
  [548451143,548640076,'Aquarius'],
  [548640076,548837377,'Pisces'],
  [548837377,549042105,'Aries'],
  [549042105,549253461,'Taurus'],
  [549253461,549470251,'Gemini'],
  [549470251,549688616,'Cancer'],
  [549688616,549901297,'Leo'],
  [549901297,550101345,'Virgo'],
  [550101345,550286861,'Libra'],
  [550286861,550461747,'Scorpio'],
  [550461747,550633108,'Sagittarius'],
  [550633108,550808424,'Capricorn'],
  [550808424,550993329,'Aquarius'],
  [550993329,551189786,'Pisces'],
  [551189786,551396067,'Aries'],
  [551396067,551609059,'Taurus'],
  [551609059,551826260,'Gemini'],
  [551826260,552044991,'Cancer'],
  [552044991,552260236,'Leo'],
  [552260236,552465218,'Virgo'],
  [552465218,552655636,'Libra'],
  [552655636,552832848,'Scorpio'],
  [552832848,553002914,'Sagittarius'],
  [553002914,553173752,'Capricorn'],
  [553173752,553352759,'Aquarius'],
  [553352759,553544546,'Pisces'],
  [553544546,553749150,'Aries'],
  [553749150,553962726,'Taurus'],
  [553962726,554180524,'Gemini'],
  [554180524,554398955,'Cancer'],
  [554398955,554614550,'Leo'],
  [554614550,554822587,'Virgo'],
  [554822587,555018518,'Libra'],
  [555018518,555201238,'Scorpio'],
  [555201238,555374370,'Sagittarius'],
  [555374370,555544651,'Capricorn'],
  [555544651,555719658,'Aquarius'],
  [555719658,555905744,'Pisces'],
  [555905744,556105742,'Aries'],
  [556105742,556317551,'Taurus'],
  [556317551,556535407,'Gemini'],
  [556535407,556753455,'Cancer'],
  [556753455,556967758,'Leo'],
  [556967758,557175500,'Virgo'],
  [557175500,557374151,'Libra'],
  [557374151,557562301,'Scorpio'],
  [557562301,557741246,'Sagittarius'],
  [557741246,557915243,'Capricorn'],
  [557915243,558090398,'Aquarius'],
  [558090398,558273103,'Pisces'],
  [558273103,558468093,'Aries'],
  [558468093,558676170,'Taurus'],
  [558676170,558892960,'Gemini'],
  [558892960,559110974,'Cancer'],
  [559110974,559324012,'Leo'],
  [559324012,559529255,'Virgo'],
  [559529255,559726407,'Libra'],
  [559726407,559916179,'Scorpio'],
  [559916179,560099820,'Sagittarius'],
  [560099820,560279525,'Capricorn'],
  [560279525,560458786,'Aquarius'],
  [560458786,560642226,'Pisces'],
  [560642226,560834628,'Aries'],
  [560834628,561038949,'Taurus'],
  [561038949,561253692,'Gemini'],
  [561253692,561471998,'Cancer'],
  [561471998,561685308,'Leo'],
  [561685308,561888637,'Virgo'],
  [561888637,562082091,'Libra'],
  [562082091,562268791,'Scorpio'],
  [562268791,562452315,'Sagittarius'],
  [562452315,562635338,'Capricorn'],
  [562635338,562819664,'Aquarius'],
  [562819664,563007196,'Pisces'],
  [563007196,563200748,'Aries'],
  [563200748,563403422,'Taurus'],
  [563403422,563616138,'Gemini'],
  [563616138,563834653,'Cancer'],
  [563834653,564050020,'Leo'],
  [564050020,564254322,'Virgo'],
  [564254322,564445682,'Libra'],
  [564445682,564627803,'Scorpio'],
  [564627803,564806620,'Sagittarius'],
  [564806620,564987408,'Capricorn'],
  [564987408,565173145,'Aquarius'],
  [565173145,565364539,'Pisces'],
  [565364539,565561710,'Aries'],
  [565561710,565765678,'Taurus'],
  [565765678,565977649,'Gemini'],
  [565977649,566196006,'Cancer'],
  [566196006,566413917,'Leo'],
  [566413917,566622120,'Virgo'],
  [566622120,566815510,'Libra'],
  [566815510,566995979,'Scorpio'],
  [566995979,567169927,'Sagittarius'],
  [567169927,567344724,'Capricorn'],
  [567344724,567526184,'Aquarius'],
  [567526184,567716906,'Pisces'],
  [567716906,567916390,'Aries'],
  [567916390,568123097,'Taurus'],
  [568123097,568336096,'Gemini'],
  [568336096,568554259,'Cancer'],
  [568554259,568773484,'Leo'],
  [568773484,568986044,'Virgo'],
  [568986044,569184882,'Libra'],
  [569184882,569368636,'Scorpio'],
  [569368636,569541921,'Sagittarius'],
  [569541921,569712225,'Capricorn'],
  [569712225,569887104,'Aquarius'],
  [569887104,570072122,'Pisces'],
  [570072122,570269238,'Aries'],
  [570269238,570476808,'Taurus'],
  [570476808,570691437,'Gemini'],
  [570691437,570909911,'Cancer'],
  [570909911,571128881,'Leo'],
  [571128881,571343350,'Virgo'],
  [571343350,571547385,'Libra'],
  [571547385,571737523,'Scorpio'],
  [571737523,571915244,'Sagittarius'],
  [571915244,572086099,'Capricorn'],
  [572086099,572257349,'Aquarius'],
  [572257349,572435999,'Pisces'],
  [572435999,572626999,'Aries'],
  [572626999,572831448,'Taurus'],
  [572831448,573046044,'Gemini'],
  [573046044,573265074,'Cancer'],
  [573265074,573483319,'Leo'],
  [573483319,573696838,'Virgo'],
  [573696838,573902384,'Libra'],
  [573902384,574097470,'Scorpio'],
  [574097470,574281720,'Sagittarius'],
  [574281720,574457725,'Capricorn'],
  [574457725,574630576,'Aquarius'],
  [574630576,574806664,'Pisces'],
  [574806664,574992201,'Aries'],
  [574992201,575191225,'Taurus'],
  [575191225,575403125,'Gemini'],
  [575403125,575621977,'Cancer'],
  [575621977,575839966,'Leo'],
  [575839966,576051664,'Virgo'],
  [576051664,576255184,'Libra'],
  [576255184,576450642,'Scorpio'],
  [576450642,576638717,'Sagittarius'],
  [576638717,576820615,'Capricorn'],
  [576820615,576998703,'Aquarius'],
  [576998703,577177051,'Pisces'],
  [577177051,577361071,'Aries'],
  [577361071,577555992,'Taurus'],
  [577555992,577764061,'Gemini'],
  [577764061,577981604,'Cancer'],
  [577981604,578199900,'Leo'],
  [578199900,578410899,'Virgo'],
  [578410899,578611706,'Libra'],
  [578611706,578803997,'Scorpio'],
  [578803997,578990937,'Sagittarius'],
  [578990937,579175038,'Capricorn'],
  [579175038,579357819,'Aquarius'],
  [579357819,579540931,'Pisces'],
  [579540931,579727446,'Aries'],
  [579727446,579921713,'Taurus'],
  [579921713,580127227,'Gemini'],
  [580127227,580343061,'Cancer'],
  [580343061,580561928,'Leo'],
  [580561928,580774079,'Virgo'],
  [580774079,580974122,'Libra'],
  [580974122,581163158,'Scorpio'],
  [581163158,581345924,'Sagittarius'],
  [581345924,581527336,'Capricorn'],
  [581527336,581710553,'Aquarius'],
  [581710553,581896899,'Pisces'],
  [581896899,582087352,'Aries'],
  [582087352,582283966,'Taurus'],
  [582283966,582489404,'Gemini'],
  [582489404,582704209,'Cancer'],
  [582704209,582923600,'Leo'],
  [582923600,583138242,'Virgo'],
  [583138242,583340411,'Libra'],
  [583340411,583528953,'Scorpio'],
  [583528953,583708274,'Sagittarius'],
  [583708274,583884732,'Capricorn'],
  [583884732,584063880,'Aquarius'],
  [584063880,584249017,'Pisces'],
  [584249017,584441252,'Aries'],
  [584441252,584640811,'Taurus'],
  [584640811,584848107,'Gemini'],
  [584848107,585063091,'Cancer'],
  [585063091,585282769,'Leo'],
  [585282769,585499914,'Virgo'],
  [585499914,585706240,'Libra'],
  [585706240,585897897,'Scorpio'],
  [585897897,586077247,'Sagittarius'],
  [586077247,586250349,'Capricorn'],
  [586250349,586424046,'Aquarius'],
  [586424046,586604058,'Pisces'],
  [586604058,586793768,'Aries'],
  [586793768,586993880,'Taurus'],
  [586993880,587203084,'Gemini'],
  [587203084,587419142,'Cancer'],
  [587419142,587638907,'Leo'],
  [587638907,587857242,'Virgo'],
  [587857242,588067501,'Libra'],
  [588067501,588264569,'Scorpio'],
  [588264569,588447980,'Sagittarius'],
  [588447980,588621795,'Capricorn'],
  [588621795,588792452,'Aquarius'],
  [588792452,588966851,'Pisces'],
  [588966851,589150843,'Aries'],
  [589150843,589347643,'Taurus'],
  [589347643,589556581,'Gemini'],
  [589556581,589773559,'Cancer'],
  [589773559,589993390,'Leo'],
  [589993390,590211312,'Virgo'],
  [590211312,590423021,'Libra'],
  [590423021,590624679,'Scorpio'],
  [590624679,590814255,'Sagittarius'],
  [590814255,590992947,'Capricorn'],
  [590992947,591165080,'Aquarius'],
  [591165080,591336991,'Pisces'],
  [591336991,591515617,'Aries'],
  [591515617,591706712,'Taurus'],
  [591706712,591912285,'Gemini'],
  [591912285,592128722,'Cancer'],
  [592128722,592348651,'Leo'],
  [592348651,592565504,'Virgo'],
  [592565504,592775864,'Libra'],
  [592775864,592978418,'Scorpio'],
  [592978418,593172320,'Sagittarius'],
  [593172320,593357310,'Capricorn'],
  [593357310,593534871,'Aquarius'],
  [593534871,593709042,'Pisces'],
  [593709042,593885977,'Aries'],
  [593885977,594072418,'Taurus'],
  [594072418,594273033,'Gemini'],
  [594273033,594486922,'Cancer'],
  [594486922,594706663,'Leo'],
  [594706663,594923119,'Virgo'],
  [594923119,595131334,'Libra'],
  [595131334,595331253,'Scorpio'],
  [595331253,595524668,'Sagittarius'],
  [595524668,595712768,'Capricorn'],
  [595712768,595896009,'Aquarius'],
  [595896009,596075736,'Pisces'],
  [596075736,596255611,'Aries'],
  [596255611,596441295,'Taurus'],
  [596441295,596638384,'Gemini'],
  [596638384,596848831,'Cancer'],
  [596848831,597067678,'Leo'],
  [597067678,597284929,'Virgo'],
  [597284929,597492742,'Libra'],
  [597492742,597689761,'Scorpio'],
  [597689761,597879153,'Sagittarius'],
  [597879153,598064818,'Capricorn'],
  [598064818,598249163,'Aquarius'],
  [598249163,598433178,'Pisces'],
  [598433178,598618171,'Aries'],
  [598618171,598807136,'Taurus'],
  [598807136,599004286,'Gemini'],
  [599004286,599212571,'Cancer'],
  [599212571,599430046,'Leo'],
  [599430046,599648594,'Virgo'],
  [599648594,599858643,'Libra'],
  [599858643,600055800,'Scorpio'],
  [600055800,600242065,'Sagittarius'],
  [600242065,600422592,'Capricorn'],
  [600422592,600602505,'Aquarius'],
  [600602505,600785261,'Pisces'],
  [600785261,600972603,'Aries'],
  [600972603,601165660,'Taurus'],
  [601165660,601365874,'Gemini'],
  [601365874,601574644,'Cancer'],
  [601574644,601791244,'Leo'],
  [601791244,602010554,'Virgo'],
  [602010554,602224081,'Libra'],
  [602224081,602425027,'Scorpio'],
  [602425027,602612366,'Sagittarius'],
  [602612366,602790095,'Capricorn'],
  [602790095,602964360,'Aquarius'],
  [602964360,603141203,'Pisces'],
  [603141203,603325179,'Aries'],
  [603325179,603518590,'Taurus'],
  [603518590,603721504,'Gemini'],
  [603721504,603932540,'Cancer'],
  [603932540,604149516,'Leo'],
  [604149516,604368815,'Virgo'],
  [604368815,604584722,'Libra'],
  [604584722,604790747,'Scorpio'],
  [604790747,604983152,'Sagittarius'],
  [604983152,605162991,'Capricorn'],
  [605162991,605335204,'Aquarius'],
  [605335204,605506596,'Pisces'],
  [605506596,605684039,'Aries'],
  [605684039,605872775,'Taurus'],
  [605872775,606074557,'Gemini'],
  [606074557,606286924,'Cancer'],
  [606286924,606505022,'Leo'],
  [606505022,606724117,'Virgo'],
  [606724117,606940249,'Libra'],
  [606940249,607149353,'Scorpio'],
  [607149353,607347534,'Sagittarius'],
  [607347534,607533166,'Capricorn'],
  [607533166,607708366,'Aquarius'],
  [607708366,607878670,'Pisces'],
  [607878670,608051420,'Aries'],
  [608051420,608233863,'Taurus'],
  [608233863,608430703,'Gemini'],
  [608430703,608641332,'Cancer'],
  [608641332,608859791,'Leo'],
  [608859791,609078864,'Virgo'],
  [609078864,609293922,'Libra'],
  [609293922,609502836,'Scorpio'],
  [609502836,609703822,'Sagittarius'],
  [609703822,609895030,'Capricorn'],
  [609895030,610076144,'Aquarius'],
  [610076144,610250036,'Pisces'],
  [610250036,610422665,'Aries'],
  [610422665,610601443,'Taurus'],
  [610601443,610792887,'Gemini'],
  [610792887,610999317,'Cancer'],
  [610999317,611216373,'Leo'],
  [611216373,611435411,'Virgo'],
  [611435411,611649523,'Libra'],
  [611649523,611856378,'Scorpio'],
  [611856378,612056226,'Sagittarius'],
  [612056226,612249229,'Capricorn'],
  [612249229,612435050,'Aquarius'],
  [612435050,612614487,'Pisces'],
  [612614487,612790990,'Aries'],
  [612790990,612970414,'Taurus'],
  [612970414,613159237,'Gemini'],
  [613159237,613361627,'Cancer'],
  [613361627,613576041,'Leo'],
  [613576041,613794760,'Virgo'],
  [613794760,614008937,'Libra'],
  [614008937,614214204,'Scorpio'],
  [614214204,614411011,'Sagittarius'],
  [614411011,614601622,'Capricorn'],
  [614601622,614787798,'Aquarius'],
  [614787798,614970660,'Pisces'],
  [614970660,615151990,'Aries'],
  [615151990,615335240,'Taurus'],
  [615335240,615525153,'Gemini'],
  [615525153,615725870,'Cancer'],
  [615725870,615937921,'Leo'],
  [615937921,616156079,'Virgo'],
  [616156079,616371435,'Libra'],
  [616371435,616577190,'Scorpio'],
  [616577190,616772047,'Sagittarius'],
  [616772047,616958743,'Capricorn'],
  [616958743,617141203,'Aquarius'],
  [617141203,617322807,'Pisces'],
  [617322807,617506070,'Aries'],
  [617506070,617693185,'Taurus'],
  [617693185,617886529,'Gemini'],
  [617886529,618088415,'Cancer'],
  [618088415,618299629,'Leo'],
  [618299629,618517274,'Virgo'],
  [618517274,618734327,'Libra'],
  [618734327,618942855,'Scorpio'],
  [618942855,619138825,'Sagittarius'],
  [619138825,619323486,'Capricorn'],
  [619323486,619501389,'Aquarius'],
  [619501389,619678080,'Pisces'],
  [619678080,619858500,'Aries'],
  [619858500,620046025,'Taurus'],
  [620046025,620242114,'Gemini'],
  [620242114,620446693,'Cancer'],
  [620446693,620658817,'Leo'],
  [620658817,620876312,'Virgo'],
  [620876312,621094623,'Libra'],
  [621094623,621306910,'Scorpio'],
  [621306910,621507129,'Sagittarius'],
  [621507129,621693676,'Capricorn'],
  [621693676,621869778,'Aquarius'],
  [621869778,622041626,'Pisces'],
  [622041626,622216225,'Aries'],
  [622216225,622399547,'Taurus'],
  [622399547,622594683,'Gemini'],
  [622594683,622800850,'Cancer'],
  [622800850,623014677,'Leo'],
  [623014677,623232529,'Virgo'],
  [623232529,623451066,'Libra'],
  [623451066,623665908,'Scorpio'],
  [623665908,623871388,'Sagittarius'],
  [623871388,624063402,'Capricorn'],
  [624063402,624242292,'Aquarius'],
  [624242292,624412967,'Pisces'],
  [624412967,624582904,'Aries'],
  [624582904,624759945,'Taurus'],
  [624759945,624949975,'Gemini'],
  [624949975,625154226,'Cancer'],
  [625154226,625368653,'Leo'],
  [625368653,625587142,'Virgo'],
  [625587142,625805201,'Libra'],
  [625805201,626020075,'Scorpio'],
  [626020075,626228506,'Sagittarius'],
  [626228506,626426438,'Capricorn'],
  [626426438,626611617,'Aquarius'],
  [626611617,626786071,'Pisces'],
  [626786071,626955840,'Aries'],
  [626955840,627128875,'Taurus'],
  [627128875,627312750,'Gemini'],
  [627312750,627511733,'Cancer'],
  [627511733,627723991,'Leo'],
  [627723991,627942546,'Virgo'],
  [627942546,628160290,'Libra'],
  [628160290,628373598,'Scorpio'],
  [628373598,628581130,'Sagittarius'],
  [628581130,628781288,'Capricorn'],
  [628781288,628972029,'Aquarius'],
  [628972029,629153033,'Pisces'],
  [629153033,629327469,'Aries'],
  [629327469,629501483,'Taurus'],
  [629501483,629682342,'Gemini'],
  [629682342,629875964,'Cancer'],
  [629875964,630083772,'Leo'],
  [630083772,630300871,'Virgo'],
  [630300871,630518783,'Libra'],
  [630518783,630731120,'Scorpio'],
  [630731120,630935913,'Sagittarius'],
  [630935913,631133646,'Capricorn'],
  [631133646,631324928,'Aquarius'],
  [631324928,631510137,'Pisces'],
  [631510137,631690638,'Aries'],
  [631690638,631869755,'Taurus'],
  [631869755,632052513,'Gemini'],
  [632052513,632244217,'Cancer'],
  [632244217,632448079,'Leo'],
  [632448079,632662518,'Virgo'],
  [632662518,632880567,'Libra'],
  [632880567,633093771,'Scorpio'],
  [633093771,633297367,'Sagittarius'],
  [633297367,633491408,'Capricorn'],
  [633491408,633678624,'Aquarius'],
  [633678624,633862206,'Pisces'],
  [633862206,634044829,'Aries'],
  [634044829,634228745,'Taurus'],
  [634228745,634416321,'Gemini'],
  [634416321,634610315,'Cancer'],
  [634610315,634813246,'Leo'],
  [634813246,635025521,'Virgo'],
  [635025521,635243265,'Libra'],
  [635243265,635458611,'Scorpio'],
  [635458611,635664124,'Sagittarius'],
  [635664124,635857192,'Capricorn'],
  [635857192,636040272,'Aquarius'],
  [636040272,636218550,'Pisces'],
  [636218550,636397502,'Aries'],
  [636397502,636581258,'Taurus'],
  [636581258,636771867,'Gemini'],
  [636771867,636969712,'Cancer'],
  [636969712,637174722,'Leo'],
  [637174722,637386749,'Virgo'],
  [637386749,637604053,'Libra'],
  [637604053,637821353,'Scorpio'],
  [637821353,638030837,'Sagittarius'],
  [638030837,638226904,'Capricorn'],
  [638226904,638409596,'Aquarius'],
  [638409596,638583912,'Pisces'],
  [638583912,638757002,'Aries'],
  [638757002,638935632,'Taurus'],
  [638935632,639124163,'Gemini'],
  [639124163,639323273,'Cancer'],
  [639323273,639530821,'Leo'],
  [639530821,639744250,'Virgo'],
  [639744250,639961551,'Libra'],
  [639961551,640179651,'Scorpio'],
  [640179651,640392683,'Sagittarius'],
  [640392683,640593971,'Capricorn'],
  [640593971,640780561,'Aquarius'],
  [640780561,640955303,'Pisces'],
  [640955303,641125081,'Aries'],
  [641125081,641297919,'Taurus'],
  [641297919,641480640,'Gemini'],
  [641480640,641676508,'Cancer'],
  [641676508,641884017,'Leo'],
  [641884017,642098732,'Virgo'],
  [642098732,642316506,'Libra'],
  [642316506,642534378,'Scorpio'],
  [642534378,642748701,'Sagittarius'],
  [642748701,642954221,'Capricorn'],
  [642954221,643146611,'Aquarius'],
  [643146611,643325898,'Pisces'],
  [643325898,643496966,'Aries'],
  [643496966,643667338,'Taurus'],
  [643667338,643844755,'Gemini'],
  [643844755,644034883,'Cancer'],
  [644034883,644238906,'Leo'],
  [644238906,644453012,'Virgo'],
  [644453012,644671129,'Libra'],
  [644671129,644888452,'Scorpio'],
  [644888452,645101873,'Sagittarius'],
  [645101873,645308392,'Capricorn'],
  [645308392,645504864,'Aquarius'],
  [645504864,645689955,'Pisces'],
  [645689955,645865945,'Aries'],
  [645865945,646038333,'Taurus'],
  [646038333,646214084,'Gemini'],
  [646214084,646399657,'Cancer'],
  [646399657,646598705,'Leo'],
  [646598705,646810011,'Virgo'],
  [646810011,647027688,'Libra'],
  [647027688,647244748,'Scorpio'],
  [647244748,647456585,'Sagittarius'],
  [647456585,647661174,'Capricorn'],
  [647661174,647857731,'Aquarius'],
  [647857731,648046100,'Pisces'],
  [648046100,648227429,'Aries'],
  [648227429,648404809,'Taurus'],
  [648404809,648583031,'Gemini'],
  [648583031,648767595,'Cancer'],
  [648767595,648963061,'Leo'],
  [648963061,649170803,'Virgo'],
  [649170803,649387156,'Libra'],
  [649387156,649604483,'Scorpio'],
  [649604483,649815725,'Sagittarius'],
  [649815725,650017770,'Capricorn'],
  [650017770,650211205,'Aquarius'],
  [650211205,650398327,'Pisces'],
  [650398327,650581636,'Aries'],
  [650581636,650763482,'Taurus'],
  [650763482,650946407,'Gemini'],
  [650946407,651133579,'Cancer'],
  [651133579,651328570,'Leo'],
  [651328570,651533929,'Virgo'],
  [651533929,651748665,'Libra'],
  [651748665,651966638,'Scorpio'],
  [651966638,652179161,'Sagittarius'],
  [652179161,652380553,'Capricorn'],
  [652380553,652570725,'Aquarius'],
  [652570725,652753559,'Pisces'],
  [652753559,652934049,'Aries'],
  [652934049,653116234,'Taurus'],
  [653116234,653302398,'Gemini'],
  [653302398,653493614,'Cancer'],
  [653493614,653691038,'Leo'],
  [653691038,653896337,'Virgo'],
  [653896337,654110032,'Libra'],
  [654110032,654328601,'Scorpio'],
  [654328601,654543887,'Sagittarius'],
  [654543887,654747746,'Capricorn'],
  [654747746,654937571,'Aquarius'],
  [654937571,655116838,'Pisces'],
  [655116838,655292077,'Aries'],
  [655292077,655469831,'Taurus'],
  [655469831,655654534,'Gemini'],
  [655654534,655847520,'Cancer'],
  [655847520,656048029,'Leo'],
  [656048029,656255291,'Virgo'],
  [656255291,656469127,'Libra'],
  [656469127,656687892,'Scorpio'],
  [656687892,656905816,'Sagittarius'],
  [656905816,657114352,'Capricorn'],
  [657114352,657307925,'Aquarius'],
  [657307925,657487598,'Pisces'],
  [657487598,657659495,'Aries'],
  [657659495,657831428,'Taurus'],
  [657831428,658010331,'Gemini'],
  [658010331,658200180,'Cancer'],
  [658200180,658400988,'Leo'],
  [658400988,658610237,'Virgo'],
  [658610237,658825274,'Libra'],
  [658825274,659044000,'Scorpio'],
  [659044000,659262847,'Sagittarius'],
  [659262847,659475375,'Capricorn'],
  [659475375,659675014,'Aquarius'],
  [659675014,659859689,'Pisces'],
  [659859689,660033125,'Aries'],
  [660033125,660202456,'Taurus'],
  [660202456,660375520,'Gemini'],
  [660375520,660558789,'Cancer'],
  [660558789,660755328,'Leo'],
  [660755328,660963797,'Virgo'],
  [660963797,661179812,'Libra'],
  [661179812,661398735,'Scorpio'],
  [661398735,661616845,'Sagittarius'],
  [661616845,661830156,'Capricorn'],
  [661830156,662034061,'Aquarius'],
  [662034061,662225387,'Pisces'],
  [662225387,662404811,'Aries'],
  [662404811,662576913,'Taurus'],
  [662576913,662748435,'Gemini'],
  [662748435,662926444,'Cancer'],
  [662926444,663116511,'Leo'],
  [663116511,663320569,'Virgo'],
  [663320569,663535515,'Libra'],
  [663535515,663754722,'Scorpio'],
  [663754722,663971950,'Sagittarius'],
  [663971950,664183383,'Capricorn'],
  [664183383,664387039,'Aquarius'],
  [664387039,664581750,'Pisces'],
  [664581750,664767429,'Aries'],
  [664767429,664945898,'Taurus'],
  [664945898,665121131,'Gemini'],
  [665121131,665298702,'Cancer'],
  [665298702,665484595,'Leo'],
  [665484595,665683256,'Virgo'],
  [665683256,665894831,'Libra'],
  [665894831,666113585,'Scorpio'],
  [666113585,666330873,'Sagittarius'],
  [666330873,666540533,'Capricorn'],
  [666540533,666741067,'Aquarius'],
  [666741067,666933953,'Pisces'],
  [666933953,667121257,'Aries'],
  [667121257,667304650,'Taurus'],
  [667304650,667485811,'Gemini'],
  [667485811,667667458,'Cancer'],
  [667667458,667853829,'Leo'],
  [667853829,668049681,'Virgo'],
  [668049681,668257678,'Libra'],
  [668257678,668475019,'Scorpio'],
  [668475019,668693132,'Sagittarius'],
  [668693132,668903101,'Capricorn'],
  [668903101,669101403,'Aquarius'],
  [669101403,669290201,'Pisces'],
  [669290201,669474047,'Aries'],
  [669474047,669656947,'Taurus'],
  [669656947,669841111,'Gemini'],
  [669841111,670027544,'Cancer'],
  [670027544,670217746,'Leo'],
  [670217746,670414616,'Virgo'],
  [670414616,670621129,'Libra'],
  [670621129,670837013,'Scorpio'],
  [670837013,671056005,'Sagittarius'],
  [671056005,671268312,'Capricorn'],
  [671268312,671467519,'Aquarius'],
  [671467519,671654136,'Pisces'],
  [671654136,671833391,'Aries'],
  [671833391,672011522,'Taurus'],
  [672011522,672193237,'Gemini'],
  [672193237,672380676,'Cancer'],
  [672380676,672574192,'Leo'],
  [672574192,672774174,'Virgo'],
  [672774174,672981763,'Libra'],
  [672981763,673197184,'Scorpio'],
  [673197184,673416666,'Sagittarius'],
  [673416666,673631908,'Capricorn'],
  [673631908,673834829,'Aquarius'],
  [673834829,674023120,'Pisces'],
  [674023120,674200625,'Aries'],
  [674200625,674374093,'Taurus'],
  [674374093,674550217,'Gemini'],
  [674550217,674733755,'Cancer'],
  [674733755,674926638,'Leo'],
  [674926638,675128534,'Virgo'],
  [675128534,675338241,'Libra'],
  [675338241,675554347,'Scorpio'],
  [675554347,675773936,'Sagittarius'],
  [675773936,675991085,'Capricorn'],
  [675991085,676198409,'Aquarius'],
  [676198409,676391464,'Pisces'],
  [676391464,676571434,'Aries'],
  [676571434,676743762,'Taurus'],
  [676743762,676915456,'Gemini'],
  [676915456,677093088,'Cancer'],
  [677093088,677281279,'Leo'],
  [677281279,677481531,'Virgo'],
  [677481531,677692080,'Libra'],
  [677692080,677909214,'Scorpio'],
  [677909214,678128759,'Sagittarius'],
  [678128759,678346071,'Capricorn'],
  [678346071,678555999,'Aquarius'],
  [678555999,678754225,'Pisces'],
  [678754225,678939639,'Aries'],
  [678939639,679115123,'Taurus'],
  [679115123,679286314,'Gemini'],
  [679286314,679459959,'Cancer'],
  [679459959,679642419,'Leo'],
  [679642419,679837920,'Virgo'],
  [679837920,680046575,'Libra'],
  [680046575,680263901,'Scorpio'],
  [680263901,680483421,'Sagittarius'],
  [680483421,680699718,'Capricorn'],
  [680699718,680909345,'Aquarius'],
  [680909345,681110093,'Pisces'],
  [681110093,681300754,'Aries'],
  [681300754,681481977,'Taurus'],
  [681481977,681656839,'Gemini'],
  [681656839,681830599,'Cancer'],
  [681830599,682009701,'Leo'],
  [682009701,682200121,'Virgo'],
  [682200121,682404736,'Libra'],
  [682404736,682620681,'Scorpio'],
  [682620681,682840167,'Sagittarius'],
  [682840167,683055514,'Capricorn'],
  [683055514,683263020,'Aquarius'],
  [683263020,683462510,'Pisces'],
  [683462510,683654859,'Aries'],
  [683654859,683840750,'Taurus'],
  [683840750,684021231,'Gemini'],
  [684021231,684198972,'Cancer'],
  [684198972,684378779,'Leo'],
  [684378779,684566638,'Virgo'],
  [684566638,684767290,'Libra'],
  [684767290,684980656,'Scorpio'],
  [684980656,685199926,'Sagittarius'],
  [685199926,685415429,'Capricorn'],
  [685415429,685621308,'Aquarius'],
  [685621308,685817573,'Pisces'],
  [685817573,686007298,'Aries'],
  [686007298,686193394,'Taurus'],
  [686193394,686377355,'Gemini'],
  [686377355,686560147,'Cancer'],
  [686560147,686743999,'Leo'],
  [686743999,686933059,'Virgo'],
  [686933059,687132040,'Libra'],
  [687132040,687342982,'Scorpio'],
  [687342982,687561732,'Sagittarius'],
  [687561732,687778669,'Capricorn'],
  [687778669,687985316,'Aquarius'],
  [687985316,688179687,'Pisces'],
  [688179687,688365253,'Aries'],
  [688365253,688547145,'Taurus'],
  [688547145,688729376,'Gemini'],
  [688729376,688913946,'Cancer'],
  [688913946,689101839,'Leo'],
  [689101839,689294667,'Virgo'],
  [689294667,689495088,'Libra'],
  [689495088,689705201,'Scorpio'],
  [689705201,689923298,'Sagittarius'],
  [689923298,690142041,'Capricorn'],
  [690142041,690352003,'Aquarius'],
  [690352003,690548154,'Pisces'],
  [690548154,690732077,'Aries'],
  [690732077,690909255,'Taurus'],
  [690909255,691085832,'Gemini'],
  [691085832,691266628,'Cancer'],
  [691266628,691454319,'Leo'],
  [691454319,691649831,'Virgo'],
  [691649831,691853326,'Libra'],
  [691853326,692064692,'Scorpio'],
  [692064692,692282537,'Sagittarius'],
  [692282537,692502224,'Capricorn'],
  [692502224,692716073,'Aquarius'],
  [692716073,692917305,'Pisces'],
  [692917305,693104265,'Aries'],
  [693104265,693280534,'Taurus'],
  [693280534,693452409,'Gemini'],
  [693452409,693626649,'Cancer'],
  [693626649,693808907,'Leo'],
  [693808907,694002401,'Virgo'],
  [694002401,694207141,'Libra'],
  [694207141,694420524,'Scorpio'],
  [694420524,694638957,'Sagittarius'],
  [694638957,694858475,'Capricorn'],
  [694858475,695074205,'Aquarius'],
  [695074205,695280606,'Pisces'],
  [695280606,695473909,'Aries'],
  [695473909,695654425,'Taurus'],
  [695654425,695826438,'Gemini'],
  [695826438,695996611,'Cancer'],
  [695996611,696172241,'Leo'],
  [696172241,696359500,'Virgo'],
  [696359500,696561109,'Libra'],
  [696561109,696774618,'Scorpio'],
  [696774618,696993907,'Sagittarius'],
  [696993907,697213011,'Capricorn'],
  [697213011,697428066,'Aquarius'],
  [697428066,697636293,'Pisces'],
  [697636293,697834913,'Aries'],
  [697834913,698022226,'Taurus'],
  [698022226,698199339,'Gemini'],
  [698199339,698370776,'Cancer'],
  [698370776,698543441,'Leo'],
  [698543441,698724805,'Virgo'],
  [698724805,698920460,'Libra'],
  [698920460,699130807,'Scorpio'],
  [699130807,699349778,'Sagittarius'],
  [699349778,699568822,'Capricorn'],
  [699568822,699782390,'Aquarius'],
  [699782390,699988968,'Pisces'],
  [699988968,700188410,'Aries'],
  [700188410,700380099,'Taurus'],
  [700380099,700563570,'Gemini'],
  [700563570,700740419,'Cancer'],
  [700740419,700915295,'Leo'],
  [700915295,701094928,'Virgo'],
  [701094928,701285955,'Libra'],
  [701285955,701491623,'Scorpio'],
  [701491623,701708496,'Sagittarius'],
  [701708496,701927549,'Capricorn'],
  [701927549,702140584,'Aquarius'],
  [702140584,702344781,'Pisces'],
  [702344781,702541389,'Aries'],
  [702541389,702732337,'Taurus'],
  [702732337,702918538,'Gemini'],
  [702918538,703100598,'Cancer'],
  [703100598,703280624,'Leo'],
  [703280624,703462992,'Virgo'],
  [703462992,703653313,'Libra'],
  [703653313,703855849,'Scorpio'],
  [703855849,704070009,'Sagittarius'],
  [704070009,704288773,'Capricorn'],
  [704288773,704502691,'Aquarius'],
  [704502691,704706310,'Pisces'],
  [704706310,704899941,'Aries'],
  [704899941,705086937,'Taurus'],
  [705086937,705270731,'Gemini'],
  [705270731,705453637,'Cancer'],
  [705453637,705637362,'Leo'],
  [705637362,705824149,'Virgo'],
  [705824149,706017200,'Libra'],
  [706017200,706219669,'Scorpio'],
  [706219669,706432198,'Sagittarius'],
  [706432198,706650493,'Capricorn'],
  [706650493,706866163,'Aquarius'],
  [706866163,707071744,'Pisces'],
  [707071744,707265054,'Aries'],
  [707265054,707448783,'Taurus'],
  [707448783,707627768,'Gemini'],
  [707627768,707806819,'Cancer'],
  [707806819,707989626,'Leo'],
  [707989626,708178566,'Virgo'],
  [708178566,708375018,'Libra'],
  [708375018,708579727,'Scorpio'],
  [708579727,708792437,'Sagittarius'],
  [708792437,709010445,'Capricorn'],
  [709010445,709227760,'Aquarius'],
  [709227760,709436928,'Pisces'],
  [709436928,709633240,'Aries'],
  [709633240,709817078,'Taurus'],
  [709817078,709992800,'Gemini'],
  [709992800,710166549,'Cancer'],
  [710166549,710344431,'Leo'],
  [710344431,710531040,'Virgo'],
  [710531040,710728297,'Libra'],
  [710728297,710935268,'Scorpio'],
  [710935268,711149391,'Sagittarius'],
  [711149391,711367513,'Capricorn'],
  [711367513,711585564,'Aquarius'],
  [711585564,711798007,'Pisces'],
  [711798007,711999282,'Aries'],
  [711999282,712187011,'Taurus'],
  [712187011,712363394,'Gemini'],
  [712363394,712534176,'Cancer'],
  [712534176,712706650,'Leo'],
  [712706650,712887724,'Virgo'],
  [712887724,713081752,'Libra'],
  [713081752,713288544,'Scorpio'],
  [713288544,713503832,'Sagittarius'],
  [713503832,713722374,'Capricorn'],
  [713722374,713940166,'Aquarius'],
  [713940166,714153822,'Pisces'],
  [714153822,714359248,'Aries'],
  [714359248,714552767,'Taurus'],
  [714552767,714733761,'Gemini'],
  [714733761,714905894,'Cancer'],
  [714905894,715075980,'Leo'],
  [715075980,715251899,'Virgo'],
  [715251899,715440303,'Libra'],
  [715440303,715643626,'Scorpio'],
  [715643626,715858274,'Sagittarius'],
  [715858274,716077109,'Capricorn'],
  [716077109,716294267,'Aquarius'],
  [716294267,716506911,'Pisces'],
  [716506911,716713264,'Aries'],
  [716713264,716910930,'Taurus'],
  [716910930,717097958,'Gemini'],
  [717097958,717275254,'Cancer'],
  [717275254,717447492,'Leo'],
  [717447492,717621804,'Virgo'],
  [717621804,717805633,'Libra'],
  [717805633,718003859,'Scorpio'],
  [718003859,718215596,'Sagittarius'],
  [718215596,718433993,'Capricorn'],
  [718433993,718650920,'Aquarius'],
  [718650920,718861886,'Pisces'],
  [718861886,719066064,'Aries'],
  [719066064,719263550,'Taurus'],
  [719263550,719453836,'Gemini'],
  [719453836,719636783,'Cancer'],
  [719636783,719814469,'Leo'],
  [719814469,719991681,'Virgo'],
  [719991681,720174743,'Libra'],
  [720174743,720369293,'Scorpio'],
  [720369293,720577168,'Sagittarius'],
  [720577168,720794082,'Capricorn'],
  [720794082,721011450,'Aquarius'],
  [721011450,721222079,'Pisces'],
  [721222079,721423685,'Aries'],
  [721423685,721617578,'Taurus'],
  [721617578,721805939,'Gemini'],
  [721805939,721990462,'Cancer'],
  [721990462,722172732,'Leo'],
  [722172732,722355210,'Virgo'],
  [722355210,722541599,'Libra'],
  [722541599,722736105,'Scorpio'],
  [722736105,722941488,'Sagittarius'],
  [722941488,723156429,'Capricorn'],
  [723156429,723374432,'Aquarius'],
  [723374432,723586897,'Pisces'],
  [723586897,723788517,'Aries'],
  [723788517,723979314,'Taurus'],
  [723979314,724162780,'Gemini'],
  [724162780,724343392,'Cancer'],
  [724343392,724525029,'Leo'],
  [724525029,724710397,'Virgo'],
  [724710397,724901248,'Libra'],
  [724901248,725098967,'Scorpio'],
  [725098967,725304753,'Sagittarius'],
  [725304753,725518487,'Capricorn'],
  [725518487,725736707,'Aquarius'],
  [725736707,725952128,'Pisces'],
  [725952128,726157184,'Aries'],
  [726157184,726348750,'Taurus'],
  [726348750,726529163,'Gemini'],
  [726529163,726704125,'Cancer'],
  [726704125,726880162,'Leo'],
  [726880162,727062654,'Virgo'],
  [727062654,727254384,'Libra'],
  [727254384,727455230,'Scorpio'],
  [727455230,727663548,'Sagittarius'],
  [727663548,727877737,'Capricorn'],
  [727877737,728095794,'Aquarius'],
  [728095794,728313311,'Pisces'],
  [728313311,728523222,'Aries'],
  [728523222,728719643,'Taurus'],
  [728719643,728901832,'Gemini'],
  [728901832,729074411,'Cancer'],
  [729074411,729244825,'Leo'],
  [729244825,729420763,'Virgo'],
  [729420763,729607920,'Libra'],
  [729607920,729807857,'Scorpio'],
  [729807857,730017825,'Sagittarius'],
  [730017825,730233505,'Capricorn'],
  [730233505,730451620,'Aquarius'],
  [730451620,730669427,'Pisces'],
  [730669427,730882429,'Aries'],
  [730882429,731084713,'Taurus'],
  [731084713,731272705,'Gemini'],
  [731272705,731448125,'Cancer'],
  [731448125,731617261,'Leo'],
  [731617261,731788267,'Virgo'],
  [731788267,731968787,'Libra'],
  [731968787,732163426,'Scorpio'],
  [732163426,732371468,'Sagittarius'],
  [732371468,732587669,'Capricorn'],
  [732587669,732806167,'Aquarius'],
  [732806167,733023252,'Pisces'],
  [733023252,733236246,'Aries'],
  [733236246,733441535,'Taurus'],
  [733441535,733635403,'Gemini'],
  [733635403,733816984,'Cancer'],
  [733816984,733989847,'Leo'],
  [733989847,734160735,'Virgo'],
  [734160735,734337334,'Libra'],
  [734337334,734526009,'Scorpio'],
  [734526009,734729135,'Sagittarius'],
  [734729135,734943452,'Capricorn'],
  [734943452,735161962,'Aquarius'],
  [735161962,735378474,'Pisces'],
  [735378474,735589733,'Aries'],
  [735589733,735794087,'Taurus'],
  [735794087,735990024,'Gemini'],
  [735990024,736176698,'Cancer'],
  [736176698,736355504,'Leo'],
  [736355504,736530596,'Virgo'],
  [736530596,736707955,'Libra'],
  [736707955,736893749,'Scorpio'],
  [736893749,737092153,'Sagittarius'],
  [737092153,737302929,'Capricorn'],
  [737302929,737520535,'Aquarius'],
  [737520535,737737104,'Pisces'],
  [737737104,737947070,'Aries'],
  [737947070,738148636,'Taurus'],
  [738148636,738342400,'Gemini'],
  [738342400,738529727,'Cancer'],
  [738529727,738712339,'Leo'],
  [738712339,738892679,'Virgo'],
  [738892679,739074223,'Libra'],
  [739074223,739261239,'Scorpio'],
  [739261239,739457726,'Sagittarius'],
  [739457726,739665418,'Capricorn'],
  [739665418,739881528,'Aquarius'],
  [739881528,740098702,'Pisces'],
  [740098702,740309111,'Aries'],
  [740309111,740508927,'Taurus'],
  [740508927,740699013,'Gemini'],
  [740699013,740882906,'Cancer'],
  [740882906,741064574,'Leo'],
  [741064574,741247187,'Virgo'],
  [741247187,741432947,'Libra'],
  [741432947,741623690,'Scorpio'],
  [741623690,741821492,'Sagittarius'],
  [741821492,742028134,'Capricorn'],
  [742028134,742243006,'Aquarius'],
  [742243006,742460973,'Pisces'],
  [742460973,742673608,'Aries'],
  [742673608,742874432,'Taurus'],
  [742874432,743062627,'Gemini'],
  [743062627,743242259,'Cancer'],
  [743242259,743419375,'Leo'],
  [743419375,743599477,'Virgo'],
  [743599477,743785935,'Libra'],
  [743785935,743979679,'Scorpio'],
  [743979679,744180439,'Sagittarius'],
  [744180439,744388197,'Capricorn'],
  [744388197,744602748,'Aquarius'],
  [744602748,744821272,'Pisces'],
  [744821272,745036820,'Aries'],
  [745036820,745241353,'Taurus'],
  [745241353,745431263,'Gemini'],
  [745431263,745609231,'Cancer'],
  [745609231,745781854,'Leo'],
  [745781854,745956533,'Virgo'],
  [745956533,746139120,'Libra'],
  [746139120,746332134,'Scorpio'],
  [746332134,746534669,'Sagittarius'],
  [746534669,746744441,'Capricorn'],
  [746744441,746959647,'Aquarius'],
  [746959647,747178302,'Pisces'],
  [747178302,747395810,'Aries'],
  [747395810,747604882,'Taurus'],
  [747604882,747799745,'Gemini'],
  [747799745,747980300,'Cancer'],
  [747980300,748151852,'Leo'],
  [748151852,748322148,'Virgo'],
  [748322148,748498776,'Libra'],
  [748498776,748686949,'Scorpio'],
  [748686949,748887697,'Sagittarius'],
  [748887697,749098231,'Capricorn'],
  [749098231,749314450,'Aquarius'],
  [749314450,749533012,'Pisces'],
  [749533012,749750599,'Aries'],
  [749750599,749962280,'Taurus'],
  [749962280,750162591,'Gemini'],
  [750162591,750349042,'Cancer'],
  [750349042,750524175,'Leo'],
  [750524175,750694272,'Virgo'],
  [750694272,750866949,'Libra'],
  [750866949,751049084,'Scorpio'],
  [751049084,751244645,'Sagittarius'],
  [751244645,751452990,'Capricorn'],
  [751452990,751669385,'Aquarius'],
  [751669385,751887993,'Pisces'],
  [751887993,752104427,'Aries'],
  [752104427,752315448,'Taurus'],
  [752315448,752518043,'Gemini'],
  [752518043,752709975,'Cancer'],
  [752709975,752891507,'Leo'],
  [752891507,753066105,'Virgo'],
  [753066105,753239554,'Libra'],
  [753239554,753418465,'Scorpio'],
  [753418465,753608517,'Sagittarius'],
  [753608517,753812208,'Capricorn'],
  [753812208,754026910,'Aquarius'],
  [754026910,754245651,'Pisces'],
  [754245651,754461327,'Aries'],
  [754461327,754669949,'Taurus'],
  [754669949,754870535,'Gemini'],
  [754870535,755063452,'Cancer'],
  [755063452,755249530,'Leo'],
  [755249530,755430356,'Virgo'],
  [755430356,755608836,'Libra'],
  [755608836,755789368,'Scorpio'],
  [755789368,755977170,'Sagittarius'],
  [755977170,756176549,'Capricorn'],
  [756176549,756388102,'Aquarius'],
  [756388102,756606530,'Pisces'],
  [756606530,756822855,'Aries'],
  [756822855,757030273,'Taurus'],
  [757030273,757227363,'Gemini'],
  [757227363,757416660,'Cancer'],
  [757416660,757601720,'Leo'],
  [757601720,757785278,'Virgo'],
  [757785278,757968983,'Libra'],
  [757968983,758154440,'Scorpio'],
  [758154440,758344399,'Sagittarius'],
  [758344399,758542586,'Capricorn'],
  [758542586,758751512,'Aquarius'],
  [758751512,758969003,'Pisces'],
  [758969003,759186945,'Aries'],
  [759186945,759395973,'Taurus'],
  [759395973,759591946,'Gemini'],
  [759591946,759777166,'Cancer'],
  [759777166,759957203,'Leo'],
  [759957203,760137557,'Virgo'],
  [760137557,760321684,'Libra'],
  [760321684,760510683,'Scorpio'],
  [760510683,760704807,'Sagittarius'],
  [760704807,760905224,'Capricorn'],
  [760905224,761113811,'Aquarius'],
  [761113811,761330435,'Pisces'],
  [761330435,761549765,'Aries'],
  [761549765,761762369,'Taurus'],
  [761762369,761961126,'Gemini'],
  [761961126,762145848,'Cancer'],
  [762145848,762321882,'Leo'],
  [762321882,762496382,'Virgo'],
  [762496382,762675515,'Libra'],
  [762675515,762862733,'Scorpio'],
  [762862733,763058508,'Sagittarius'],
  [763058508,763261904,'Capricorn'],
  [763261904,763472268,'Aquarius'],
  [763472268,763688944,'Pisces'],
  [763688944,763908767,'Aries'],
  [763908767,764124576,'Taurus'],
  [764124576,764328418,'Gemini'],
  [764328418,764517042,'Cancer'],
  [764517042,764693518,'Leo'],
  [764693518,764864601,'Virgo'],
  [764864601,765037714,'Libra'],
  [765037714,765218918,'Scorpio'],
  [765218918,765411376,'Sagittarius'],
  [765411376,765614888,'Capricorn'],
  [765614888,765826964,'Aquarius'],
  [765826964,766044545,'Pisces'],
  [766044545,766264260,'Aries'],
  [766264260,766481206,'Taurus'],
  [766481206,766689194,'Gemini'],
  [766689194,766883727,'Cancer'],
  [766883727,767064950,'Leo'],
  [767064950,767237424,'Virgo'],
  [767237424,767407930,'Libra'],
  [767407930,767583495,'Scorpio'],
  [767583495,767769786,'Sagittarius'],
  [767769786,767969423,'Capricorn'],
  [767969423,768180812,'Aquarius'],
  [768180812,768399040,'Pisces'],
  [768399040,768618584,'Aries'],
  [768618584,768834786,'Taurus'],
  [768834786,769043795,'Gemini'],
  [769043795,769242513,'Cancer'],
  [769242513,769429780,'Leo'],
  [769429780,769607444,'Virgo'],
  [769607444,769780068,'Libra'],
  [769780068,769953841,'Scorpio'],
  [769953841,770135257,'Sagittarius'],
  [770135257,770329366,'Capricorn'],
  [770329366,770537341,'Aquarius'],
  [770537341,770754862,'Pisces'],
  [770754862,770974318,'Aries'],
  [770974318,771189266,'Taurus'],
  [771189266,771396594,'Gemini'],
  [771396594,771595585,'Cancer'],
  [771595585,771786337,'Leo'],
  [771786337,771969600,'Virgo'],
  [771969600,772147432,'Libra'],
  [772147432,772323763,'Scorpio'],
  [772323763,772504134,'Sagittarius'],
  [772504134,772694384,'Capricorn'],
  [772694384,772898126,'Aquarius'],
  [772898126,773113539,'Pisces'],
  [773113539,773332875,'Aries'],
  [773332875,773547341,'Taurus'],
  [773547341,773752479,'Gemini'],
  [773752479,773948724,'Cancer'],
  [773948724,774138546,'Leo'],
  [774138546,774324060,'Virgo'],
  [774324060,774506591,'Libra'],
  [774506591,774687784,'Scorpio'],
  [774687784,774870895,'Sagittarius'],
  [774870895,775060737,'Capricorn'],
  [775060737,775261795,'Aquarius'],
  [775261795,775474777,'Pisces'],
  [775474777,775693857,'Aries'],
  [775693857,775909171,'Taurus'],
  [775909171,776113760,'Gemini'],
  [776113760,776307148,'Cancer'],
  [776307148,776493154,'Leo'],
  [776493154,776676270,'Virgo'],
  [776676270,776859482,'Libra'],
  [776859482,777044145,'Scorpio'],
  [777044145,777231481,'Sagittarius'],
  [777231481,777423992,'Capricorn'],
  [777423992,777625102,'Aquarius'],
  [777625102,777836652,'Pisces'],
  [777836652,778055391,'Aries'],
  [778055391,778272531,'Taurus'],
  [778272531,778479153,'Gemini'],
  [778479153,778672278,'Cancer'],
  [778672278,778855089,'Leo'],
  [778855089,779033424,'Virgo'],
  [779033424,779212703,'Libra'],
  [779212703,779396334,'Scorpio'],
  [779396334,779585729,'Sagittarius'],
  [779585729,779781601,'Capricorn'],
  [779781601,779985001,'Aquarius'],
  [779985001,780196800,'Pisces'],
  [780196800,780415291,'Aries'],
  [780415291,780634152,'Taurus'],
  [780634152,780844608,'Gemini'],
  [780844608,781041064,'Cancer'],
  [781041064,781224253,'Leo'],
  [781224253,781399417,'Virgo'],
  [781399417,781573206,'Libra'],
  [781573206,781751532,'Scorpio'],
  [781751532,781938266,'Sagittarius'],
  [781938266,782134797,'Capricorn'],
  [782134797,782340544,'Aquarius'],
  [782340544,782553906,'Pisces'],
  [782553906,782772488,'Aries'],
  [782772488,782991942,'Taurus'],
  [782991942,783205738,'Gemini'],
  [783205738,783407652,'Cancer'],
  [783407652,783595463,'Leo'],
  [783595463,783771930,'Virgo'],
  [783771930,783942969,'Libra'],
  [783942969,784115548,'Scorpio'],
  [784115548,784296059,'Sagittarius'],
  [784296059,784488705,'Capricorn'],
  [784488705,784693989,'Aquarius'],
  [784693989,784908659,'Pisces'],
  [784908659,785127784,'Aries'],
  [785127784,785346729,'Taurus'],
  [785346729,785561294,'Gemini'],
  [785561294,785767282,'Cancer'],
  [785767282,785961489,'Leo'],
  [785961489,786143643,'Virgo'],
  [786143643,786317042,'Libra'],
  [786317042,786487697,'Scorpio'],
  [786487697,786662821,'Sagittarius'],
  [786662821,786849071,'Capricorn'],
  [786849071,787050030,'Aquarius'],
  [787050030,787263707,'Pisces'],
  [787263707,787483294,'Aries'],
  [787483294,787701659,'Taurus'],
  [787701659,787914702,'Gemini'],
  [787914702,788120772,'Cancer'],
  [788120772,788318627,'Leo'],
  [788318627,788507173,'Virgo'],
  [788507173,788686819,'Libra'],
  [788686819,788860820,'Scorpio'],
  [788860820,789035140,'Sagittarius'],
  [789035140,789216957,'Capricorn'],
  [789216957,789412241,'Aquarius'],
  [789412241,789622210,'Pisces'],
  [789622210,789841105,'Aries'],
  [789841105,790059544,'Taurus'],
  [790059544,790271056,'Gemini'],
  [790271056,790474389,'Cancer'],
  [790474389,790670884,'Leo'],
  [790670884,790861572,'Virgo'],
  [790861572,791046583,'Libra'],
  [791046583,791226676,'Scorpio'],
  [791226676,791405003,'Sagittarius'],
  [791405003,791587139,'Capricorn'],
  [791587139,791779297,'Aquarius'],
  [791779297,791985114,'Pisces'],
  [791985114,792201937,'Aries'],
  [792201937,792420793,'Taurus'],
  [792420793,792632564,'Gemini'],
  [792632564,792833838,'Cancer'],
  [792833838,793026494,'Leo'],
  [793026494,793214060,'Virgo'],
  [793214060,793399073,'Libra'],
  [793399073,793582714,'Scorpio'],
  [793582714,793766244,'Sagittarius'],
  [793766244,793952485,'Capricorn'],
  [793952485,794145730,'Aquarius'],
  [794145730,794349752,'Pisces'],
  [794349752,794564424,'Aries'],
  [794564424,794783448,'Taurus'],
  [794783448,794997213,'Gemini'],
  [794997213,795199386,'Cancer'],
  [795199386,795389945,'Leo'],
  [795389945,795572947,'Virgo'],
  [795572947,795753281,'Libra'],
  [795753281,795934759,'Scorpio'],
  [795934759,796119722,'Sagittarius'],
  [796119722,796309770,'Capricorn'],
  [796309770,796506590,'Aquarius'],
  [796506590,796711898,'Pisces'],
  [796711898,796925852,'Aries'],
  [796925852,797144749,'Taurus'],
  [797144749,797360922,'Gemini'],
  [797360922,797566657,'Cancer'],
  [797566657,797758958,'Leo'],
  [797758958,797940197,'Virgo'],
  [797940197,798115727,'Libra'],
  [798115727,798291516,'Scorpio'],
  [798291516,798472611,'Sagittarius'],
  [798472611,798662213,'Capricorn'],
  [798662213,798861328,'Aquarius'],
  [798861328,799069213,'Pisces'],
  [799069213,799284107,'Aries'],
  [799284107,799502955,'Taurus'],
  [799502955,799720623,'Gemini'],
  [799720623,799930491,'Cancer'],
  [799930491,800127566,'Leo'],
  [800127566,800311346,'Virgo'],
  [800311346,800485665,'Libra'],
  [800485665,800656865,'Scorpio'],
  [800656865,800831893,'Sagittarius'],
  [800831893,801016623,'Capricorn'],
  [801016623,801214010,'Aquarius'],
  [801214010,801422903,'Pisces'],
  [801422903,801639189,'Aries'],
  [801639189,801858275,'Taurus'],
  [801858275,802076100,'Gemini'],
  [802076100,802288394,'Cancer'],
  [802288394,802490555,'Leo'],
  [802490555,802679840,'Virgo'],
  [802679840,802857349,'Libra'],
  [802857349,803028012,'Scorpio'],
  [803028012,803199004,'Sagittarius'],
  [803199004,803377832,'Capricorn'],
  [803377832,803570099,'Aquarius'],
  [803570099,803776746,'Pisces'],
  [803776746,803993191,'Aries'],
  [803993191,804212564,'Taurus'],
  [804212564,804429734,'Gemini'],
  [804429734,804641891,'Cancer'],
  [804641891,804846582,'Leo'],
  [804846582,805041129,'Virgo'],
  [805041129,805224418,'Libra'],
  [805224418,805398781,'Scorpio'],
  [805398781,805569969,'Sagittarius'],
  [805569969,805745496,'Capricorn'],
  [805745496,805932452,'Aquarius'],
  [805932452,806134482,'Pisces'],
  [806134482,806348964,'Aries'],
  [806348964,806568177,'Taurus'],
  [806568177,806784736,'Gemini'],
  [806784736,806995231,'Cancer'],
  [806995231,807198973,'Leo'],
  [807198973,807395371,'Virgo'],
  [807395371,807583427,'Libra'],
  [807583427,807763458,'Scorpio'],
  [807763458,807938716,'Sagittarius'],
  [807938716,808115122,'Capricorn'],
  [808115122,808299566,'Aquarius'],
  [808299566,808497254,'Pisces'],
  [808497254,808708358,'Aries'],
  [808708358,808926641,'Taurus'],
  [808926641,809143215,'Gemini'],
  [809143215,809352437,'Cancer'],
  [809352437,809553450,'Leo'],
  [809553450,809747654,'Virgo'],
  [809747654,809936262,'Libra'],
  [809936262,810120006,'Scorpio'],
  [810120006,810300457,'Sagittarius'],
  [810300457,810481078,'Capricorn'],
  [810481078,810666897,'Aquarius'],
  [810666897,810862847,'Pisces'],
  [810862847,811070961,'Aries'],
  [811070961,811287764,'Taurus'],
  [811287764,811505013,'Gemini'],
  [811505013,811714821,'Cancer'],
  [811714821,811914182,'Leo'],
  [811914182,812104646,'Virgo'],
  [812104646,812289579,'Libra'],
  [812289579,812472149,'Scorpio'],
  [812472149,812654806,'Sagittarius'],
  [812654806,812839766,'Capricorn'],
  [812839766,813029588,'Aquarius'],
  [813029588,813227101,'Pisces'],
  [813227101,813434206,'Aries'],
  [813434206,813649679,'Taurus'],
  [813649679,813867759,'Gemini'],
  [813867759,814080141,'Cancer'],
  [814080141,814280976,'Leo'],
  [814280976,814469781,'Virgo'],
  [814469781,814650233,'Libra'],
  [814650233,814827691,'Scorpio'],
  [814827691,815007264,'Sagittarius'],
  [815007264,815192624,'Capricorn'],
  [815192624,815385568,'Aquarius'],
  [815385568,815586431,'Pisces'],
  [815586431,815794907,'Aries'],
  [815794907,816009967,'Taurus'],
  [816009967,816228406,'Gemini'],
  [816228406,816443882,'Cancer'],
  [816443882,816649152,'Leo'],
  [816649152,816840541,'Virgo'],
  [816840541,817019788,'Libra'],
  [817019788,817192557,'Scorpio'],
  [817192557,817365976,'Sagittarius'],
  [817365976,817546514,'Capricorn'],
  [817546514,817738039,'Aquarius'],
  [817738039,817940596,'Pisces'],
  [817940596,818151397,'Aries'],
  [818151397,818367264,'Taurus'],
  [818367264,818585548,'Gemini'],
  [818585548,818802610,'Cancer'],
  [818802610,819012609,'Leo'],
  [819012609,819209897,'Virgo'],
  [819209897,819392908,'Libra'],
  [819392908,819565411,'Scorpio'],
  [819565411,819734622,'Sagittarius'],
  [819734622,819908658,'Capricorn'],
  [819908658,820094231,'Aquarius'],
  [820094231,820293986,'Pisces'],
  [820293986,820505203,'Aries'],
  [820505203,820722254,'Taurus'],
  [820722254,820940471,'Gemini'],
  [820940471,821157075,'Cancer'],
  [821157075,821368940,'Leo'],
  [821368940,821571513,'Virgo'],
  [821571513,821761185,'Libra'],
  [821761185,821938509,'Scorpio'],
  [821938509,822108711,'Sagittarius'],
  [822108711,822279576,'Capricorn'],
  [822279576,822459063,'Aquarius'],
  [822459063,822652692,'Pisces'],
  [822652692,822860644,'Aries'],
  [822860644,823077445,'Taurus'],
  [823077445,823295902,'Gemini'],
  [823295902,823511395,'Cancer'],
  [823511395,823721895,'Leo'],
  [823721895,823925534,'Virgo'],
  [823925534,824119871,'Libra'],
  [824119871,824303761,'Scorpio'],
  [824303761,824479446,'Sagittarius'],
  [824479446,824652487,'Capricorn'],
  [824652487,824830032,'Aquarius'],
  [824830032,825018605,'Pisces'],
  [825018605,825221329,'Aries'],
  [825221329,825435576,'Taurus'],
  [825435576,825653949,'Gemini'],
  [825653949,825869133,'Cancer'],
  [825869133,826077520,'Leo'],
  [826077520,826278517,'Virgo'],
  [826278517,826472385,'Libra'],
  [826472385,826659417,'Scorpio'],
  [826659417,826840746,'Sagittarius'],
  [826840746,827019291,'Capricorn'],
  [827019291,827199730,'Aquarius'],
  [827199730,827387430,'Pisces'],
  [827387430,827586513,'Aries'],
  [827586513,827797324,'Taurus'],
  [827797324,828014829,'Gemini'],
  [828014829,828230753,'Cancer'],
  [828230753,828438691,'Leo'],
  [828438691,828636814,'Virgo'],
  [828636814,828826802,'Libra'],
  [828826802,829011623,'Scorpio'],
  [829011623,829194141,'Sagittarius'],
  [829194141,829376832,'Capricorn'],
  [829376832,829562125,'Aquarius'],
  [829562125,829752805,'Pisces'],
  [829752805,829951752,'Aries'],
  [829951752,830160478,'Taurus'],
  [830160478,830376814,'Gemini'],
  [830376814,830593972,'Cancer'],
  [830593972,830803753,'Leo'],
  [830803753,831001603,'Virgo'],
  [831001603,831188340,'Libra'],
  [831188340,831368387,'Scorpio'],
  [831368387,831547148,'Sagittarius'],
  [831547148,831729100,'Capricorn'],
  [831729100,831916838,'Aquarius'],
  [831916838,832111270,'Pisces'],
  [832111270,832312750,'Aries'],
  [832312750,832521714,'Taurus'],
  [832521714,832737418,'Gemini'],
  [832737418,832955640,'Cancer'],
  [832955640,833168613,'Leo'],
  [833168613,833369373,'Virgo'],
  [833369373,833556243,'Libra'],
  [833556243,833733087,'Scorpio'],
  [833733087,833906620,'Sagittarius'],
  [833906620,834083661,'Capricorn'],
  [834083661,834269062,'Aquarius'],
  [834269062,834464378,'Pisces'],
  [834464378,834668359,'Aries'],
  [834668359,834879083,'Taurus'],
  [834879083,835095062,'Gemini'],
  [835095062,835313778,'Cancer'],
  [835313778,835529580,'Leo'],
  [835529580,835735014,'Virgo'],
  [835735014,835925700,'Libra'],
  [835925700,836103280,'Scorpio'],
  [836103280,836274009,'Sagittarius'],
  [836274009,836445749,'Capricorn'],
  [836445749,836625545,'Aquarius'],
  [836625545,836817443,'Pisces'],
  [836817443,837021133,'Aries'],
  [837021133,837233215,'Taurus'],
  [837233215,837450019,'Gemini'],
  [837450019,837668716,'Cancer'],
  [837668716,837885598,'Leo'],
  [837885598,838094887,'Virgo'],
  [838094887,838291158,'Libra'],
  [838291158,838473307,'Scorpio'],
  [838473307,838645519,'Sagittarius'],
  [838645519,838815064,'Capricorn'],
  [838815064,838989773,'Aquarius'],
  [838989773,839175871,'Pisces'],
  [839175871,839375723,'Aries'],
  [839375723,839586924,'Taurus'],
  [839586924,839804212,'Gemini'],
  [839804212,840022720,'Cancer'],
  [840022720,840238905,'Leo'],
  [840238905,840449152,'Virgo'],
  [840449152,840649480,'Libra'],
  [840649480,840837572,'Scorpio'],
  [840837572,841014947,'Sagittarius'],
  [841014947,841186750,'Capricorn'],
  [841186750,841359947,'Aquarius'],
  [841359947,841541415,'Pisces'],
  [841541415,841735847,'Aries'],
  [841735847,841943594,'Taurus'],
  [841943594,842160110,'Gemini'],
  [842160110,842378536,'Cancer'],
  [842378536,842593470,'Leo'],
  [842593470,842801944,'Virgo'],
  [842801944,843002386,'Libra'],
  [843002386,843193928,'Scorpio'],
  [843193928,843377043,'Sagittarius'],
  [843377043,843554342,'Capricorn'],
  [843554342,843730440,'Aquarius'],
  [843730440,843911069,'Pisces'],
  [843911069,844101616,'Aries'],
  [844101616,844304987,'Taurus'],
  [844304987,844519303,'Gemini'],
  [844519303,844737716,'Cancer'],
  [844737716,844952325,'Leo'],
  [844952325,845158548,'Virgo'],
  [845158548,845355892,'Libra'],
  [845355892,845546093,'Scorpio'],
  [845546093,845731299,'Sagittarius'],
  [845731299,845913516,'Capricorn'],
  [845913516,846095002,'Aquarius'],
  [846095002,846278893,'Pisces'],
  [846278893,846469234,'Aries'],
  [846469234,846669783,'Taurus'],
  [846669783,846881431,'Gemini'],
  [846881431,847099617,'Cancer'],
  [847099617,847315468,'Leo'],
  [847315468,847521510,'Virgo'],
  [847521510,847715917,'Libra'],
  [847715917,847901732,'Scorpio'],
  [847901732,848083767,'Sagittarius'],
  [848083767,848266108,'Capricorn'],
  [848266108,848451055,'Aquarius'],
  [848451055,848639662,'Pisces'],
  [848639662,848833238,'Aries'],
  [848833238,849034097,'Taurus'],
  [849034097,849244173,'Gemini'],
  [849244173,849461807,'Cancer'],
  [849461807,849679736,'Leo'],
  [849679736,849888563,'Virgo'],
  [849888563,850083399,'Libra'],
  [850083399,850266171,'Scorpio'],
  [850266171,850442914,'Sagittarius'],
  [850442914,850620280,'Capricorn'],
  [850620280,850803118,'Aquarius'],
  [850803118,850993272,'Pisces'],
  [850993272,851190384,'Aries'],
  [851190384,851394018,'Taurus'],
  [851394018,851604618,'Gemini'],
  [851604618,851821795,'Cancer'],
  [851821795,852041165,'Leo'],
  [852041165,852254164,'Virgo'],
  [852254164,852453336,'Libra'],
  [852453336,852637574,'Scorpio'],
  [852637574,852811831,'Sagittarius'],
  [852811831,852983642,'Capricorn'],
  [852983642,853160203,'Aquarius'],
  [853160203,853346286,'Pisces'],
  [853346286,853543030,'Aries'],
  [853543030,853748795,'Taurus'],
  [853748795,853961311,'Gemini'],
  [853961311,854178754,'Cancer'],
  [854178754,854398255,'Leo'],
  [854398255,854613971,'Virgo'],
  [854613971,854818687,'Libra'],
  [854818687,855008512,'Scorpio'],
  [855008512,855185465,'Sagittarius'],
  [855185465,855355823,'Capricorn'],
  [855355823,855527228,'Aquarius'],
  [855527228,855706563,'Pisces'],
  [855706563,855898099,'Aries'],
  [855898099,856102178,'Taurus'],
  [856102178,856315614,'Gemini'],
  [856315614,856533885,'Cancer'],
  [856533885,856752907,'Leo'],
  [856752907,856968586,'Virgo'],
  [856968586,857176245,'Libra'],
  [857176245,857371994,'Scorpio'],
  [857371994,857555221,'Sagittarius'],
  [857555221,857729336,'Capricorn'],
  [857729336,857900430,'Aquarius'],
  [857900430,858075476,'Pisces'],
  [858075476,858260682,'Aries'],
  [858260682,858459557,'Taurus'],
  [858459557,858671013,'Gemini'],
  [858671013,858889502,'Cancer'],
  [858889502,859108287,'Leo'],
  [859108287,859322437,'Virgo'],
  [859322437,859529238,'Libra'],
  [859529238,859727189,'Scorpio'],
  [859727189,859915765,'Sagittarius'],
  [859915765,860096127,'Capricorn'],
  [860096127,860271564,'Aquarius'],
  [860271564,860447241,'Pisces'],
  [860447241,860629253,'Aries'],
  [860629253,860822950,'Taurus'],
  [860822950,861030319,'Gemini'],
  [861030319,861247555,'Cancer'],
  [861247555,861466431,'Leo'],
  [861466431,861679513,'Virgo'],
  [861679513,861883719,'Libra'],
  [861883719,862079644,'Scorpio'],
  [862079644,862269050,'Sagittarius'],
  [862269050,862453494,'Capricorn'],
  [862453494,862634492,'Aquarius'],
  [862634492,862814542,'Pisces'],
  [862814542,862997806,'Aries'],
  [862997806,863189426,'Taurus'],
  [863189426,863393230,'Gemini'],
  [863393230,863608285,'Cancer'],
  [863608285,863827307,'Leo'],
  [863827307,864040799,'Virgo'],
  [864040799,864243455,'Libra'],
  [864243455,864435938,'Scorpio'],
  [864435938,864622081,'Sagittarius'],
  [864622081,864805718,'Capricorn'],
  [864805718,864989178,'Aquarius'],
  [864989178,865173674,'Pisces'],
  [865173674,865360902,'Aries'],
  [865360902,865554042,'Taurus'],
  [865554042,865756744,'Gemini'],
  [865756744,865970049,'Cancer'],
  [865970049,866189135,'Leo'],
  [866189135,866404413,'Virgo'],
  [866404413,866608072,'Libra'],
  [866608072,866798908,'Scorpio'],
  [866798908,866981058,'Sagittarius'],
  [866981058,867160306,'Capricorn'],
  [867160306,867341341,'Aquarius'],
  [867341341,867526620,'Pisces'],
  [867526620,867717006,'Aries'],
  [867717006,867913413,'Taurus'],
  [867913413,868117546,'Gemini'],
  [868117546,868330490,'Cancer'],
  [868330490,868549592,'Leo'],
  [868549592,868767103,'Virgo'],
  [868767103,868974116,'Libra'],
  [868974116,869166710,'Scorpio'],
  [869166710,869347452,'Sagittarius'],
  [869347452,869522445,'Capricorn'],
  [869522445,869698195,'Aquarius'],
  [869698195,869879649,'Pisces'],
  [869879649,870069308,'Aries'],
  [870069308,870267623,'Taurus'],
  [870267623,870474132,'Gemini'],
  [870474132,870688074,'Cancer'],
  [870688074,870907260,'Leo'],
  [870907260,871126247,'Virgo'],
  [871126247,871337266,'Libra'],
  [871337266,871534549,'Scorpio'],
  [871534549,871717905,'Sagittarius'],
  [871717905,871891970,'Capricorn'],
  [871891970,872063466,'Aquarius'],
  [872063466,872239064,'Pisces'],
  [872239064,872423890,'Aries'],
  [872423890,872620351,'Taurus'],
  [872620351,872827726,'Gemini'],
  [872827726,873043032,'Cancer'],
  [873043032,873262471,'Leo'],
  [873262471,873481578,'Virgo'],
  [873481578,873694955,'Libra'],
  [873694955,873897383,'Scorpio'],
  [873897383,874086448,'Sagittarius'],
  [874086448,874264006,'Capricorn'],
  [874264006,874435226,'Aquarius'],
  [874435226,874606853,'Pisces'],
  [874606853,874785679,'Aries'],
  [874785679,874976862,'Taurus'],
  [874976862,875181861,'Gemini'],
  [875181861,875397340,'Cancer'],
  [875397340,875617108,'Leo'],
  [875617108,875835453,'Virgo'],
  [875835453,876048452,'Libra'],
  [876048452,876253289,'Scorpio'],
  [876253289,876447836,'Sagittarius'],
  [876447836,876631697,'Capricorn'],
  [876631697,876807196,'Aquarius'],
  [876807196,876979336,'Pisces'],
  [876979336,877154807,'Aries'],
  [877154807,877340377,'Taurus'],
  [877340377,877540404,'Gemini'],
  [877540404,877753764,'Cancer'],
  [877753764,877973479,'Leo'],
  [877973479,878191260,'Virgo'],
  [878191260,878402320,'Libra'],
  [878402320,878605707,'Scorpio'],
  [878605707,878801754,'Sagittarius'],
  [878801754,878990518,'Capricorn'],
  [878990518,879172322,'Aquarius'],
  [879172322,879349293,'Pisces'],
  [879349293,879526133,'Aries'],
  [879526133,879709268,'Taurus'],
  [879709268,879904645,'Gemini'],
  [879904645,880114208,'Cancer'],
  [880114208,880332908,'Leo'],
  [880332908,880550978,'Virgo'],
  [880550978,880760930,'Libra'],
  [880760930,880961272,'Scorpio'],
  [880961272,881154363,'Sagittarius'],
  [881154363,881342868,'Capricorn'],
  [881342868,881528079,'Aquarius'],
  [881528079,881710630,'Pisces'],
  [881710630,881892443,'Aries'],
  [881892443,882077670,'Taurus'],
  [882077670,882271648,'Gemini'],
  [882271648,882478015,'Cancer'],
  [882478015,882694868,'Leo'],
  [882694868,882913720,'Virgo'],
  [882913720,883124863,'Libra'],
  [883124863,883324088,'Scorpio'],
  [883324088,883513376,'Sagittarius'],
  [883513376,883697354,'Capricorn'],
  [883697354,883880105,'Aquarius'],
  [883880105,884063896,'Pisces'],
  [884063896,884249866,'Aries'],
  [884249866,884439634,'Taurus'],
  [884439634,884636007,'Gemini'],
  [884636007,884841848,'Cancer'],
  [884841848,885057170,'Leo'],
  [885057170,885276492,'Virgo'],
  [885276492,885490496,'Libra'],
  [885490496,885692175,'Scorpio'],
  [885692175,885880877,'Sagittarius'],
  [885880877,886060838,'Capricorn'],
  [886060838,886237895,'Aquarius'],
  [886237895,886417184,'Pisces'],
  [886417184,886602071,'Aries'],
  [886602071,886794174,'Taurus'],
  [886794174,886994093,'Gemini'],
  [886994093,887202027,'Cancer'],
  [887202027,887417285,'Leo'],
  [887417285,887636536,'Virgo'],
  [887636536,887853079,'Libra'],
  [887853079,888059436,'Scorpio'],
  [888059436,888251884,'Sagittarius'],
  [888251884,888432127,'Capricorn'],
  [888432127,888605513,'Aquarius'],
  [888605513,888778659,'Pisces'],
  [888778659,888957694,'Aries'],
  [888957694,889146859,'Taurus'],
  [889146859,889347397,'Gemini'],
  [889347397,889557569,'Cancer'],
  [889557569,889774087,'Leo'],
  [889774087,889993219,'Virgo'],
  [889993219,890210569,'Libra'],
  [890210569,890420747,'Scorpio'],
  [890420747,890619004,'Sagittarius'],
  [890619004,890803985,'Capricorn'],
  [890803985,890978590,'Aquarius'],
  [890978590,891148838,'Pisces'],
  [891148838,891322020,'Aries'],
  [891322020,891504910,'Taurus'],
  [891504910,891701569,'Gemini'],
  [891701569,891911222,'Cancer'],
  [891911222,892128736,'Leo'],
  [892128736,892348041,'Virgo'],
  [892348041,892564765,'Libra'],
  [892564765,892775860,'Scorpio'],
  [892775860,892978213,'Sagittarius'],
  [892978213,893169310,'Capricorn'],
  [893169310,893349173,'Aquarius'],
  [893349173,893521469,'Pisces'],
  [893521469,893692737,'Aries'],
  [893692737,893870581,'Taurus'],
  [893870581,894061405,'Gemini'],
  [894061405,894267291,'Cancer'],
  [894267291,894483959,'Leo'],
  [894483959,894703392,'Virgo'],
  [894703392,894919222,'Libra'],
  [894919222,895128860,'Scorpio'],
  [895128860,895331508,'Sagittarius'],
  [895331508,895526098,'Capricorn'],
  [895526098,895711670,'Aquarius'],
  [895711670,895889294,'Pisces'],
  [895889294,896063228,'Aries'],
  [896063228,896240107,'Taurus'],
  [896240107,896426936,'Gemini'],
  [896426936,896628117,'Cancer'],
  [896628117,896842077,'Leo'],
  [896842077,897061110,'Virgo'],
  [897061110,897276652,'Libra'],
  [897276652,897484490,'Scorpio'],
  [897484490,897684655,'Sagittarius'],
  [897684655,897878389,'Capricorn'],
  [897878389,898066259,'Aquarius'],
  [898066259,898248685,'Pisces'],
  [898248685,898427656,'Aries'],
  [898427656,898607530,'Taurus'],
  [898607530,898794128,'Gemini'],
  [898794128,898992446,'Cancer'],
  [898992446,899203357,'Leo'],
  [899203357,899421437,'Virgo'],
  [899421437,899637557,'Libra'],
  [899637557,899845058,'Scorpio'],
  [899845058,900042729,'Sagittarius'],
  [900042729,900232897,'Capricorn'],
  [900232897,900418497,'Aquarius'],
  [900418497,900601692,'Pisces'],
  [900601692,900784245,'Aries'],
  [900784245,900968568,'Taurus'],
  [900968568,901158141,'Gemini'],
  [901158141,901356673,'Cancer'],
  [901356673,901565888,'Leo'],
  [901565888,901782927,'Virgo'],
  [901782927,902000198,'Libra'],
  [902000198,902209502,'Scorpio'],
  [902209502,902407064,'Sagittarius'],
  [902407064,902594291,'Capricorn'],
  [902594291,902775347,'Aquarius'],
  [902775347,902954821,'Pisces'],
  [902954821,903136491,'Aries'],
  [903136491,903323013,'Taurus'],
  [903323013,903516188,'Gemini'],
  [903516188,903717296,'Cancer'],
  [903717296,903926879,'Leo'],
  [903926879,904143371,'Virgo'],
  [904143371,904361707,'Libra'],
  [904361707,904574259,'Scorpio'],
  [904574259,904774901,'Sagittarius'],
  [904774901,904962482,'Capricorn'],
  [904962482,905140457,'Aquarius'],
  [905140457,905314673,'Pisces'],
  [905314673,905491327,'Aries'],
  [905491327,905675386,'Taurus'],
  [905675386,905869368,'Gemini'],
  [905869368,906073028,'Cancer'],
  [906073028,906284440,'Leo'],
  [906284440,906501181,'Virgo'],
  [906501181,906719929,'Libra'],
  [906719929,906935362,'Scorpio'],
  [906935362,907141011,'Sagittarius'],
  [907141011,907332881,'Capricorn'],
  [907332881,907511913,'Aquarius'],
  [907511913,907683321,'Pisces'],
  [907683321,907854417,'Aries'],
  [907854417,908032508,'Taurus'],
  [908032508,908222749,'Gemini'],
  [908222749,908426011,'Cancer'],
  [908426011,908638870,'Leo'],
  [908638870,908856463,'Virgo'],
  [908856463,909075015,'Libra'],
  [909075015,909291312,'Scorpio'],
  [909291312,909500909,'Sagittarius'],
  [909500909,909698930,'Capricorn'],
  [909698930,909883293,'Aquarius'],
  [909883293,910056711,'Pisces'],
  [910056711,910225743,'Aries'],
  [910225743,910398494,'Taurus'],
  [910398494,910582368,'Gemini'],
  [910582368,910781206,'Cancer'],
  [910781206,910992933,'Leo'],
  [910992933,911211067,'Virgo'],
  [911211067,911429414,'Libra'],
  [911429414,911644670,'Scorpio'],
  [911644670,911854749,'Sagittarius'],
  [911854749,912056694,'Capricorn'],
  [912056694,912247519,'Aquarius'],
  [912247519,912427003,'Pisces'],
  [912427003,912599137,'Aries'],
  [912599137,912770917,'Taurus'],
  [912770917,912950167,'Gemini'],
  [912950167,913142987,'Cancer'],
  [913142987,913350524,'Leo'],
  [913350524,913567587,'Virgo'],
  [913567587,913786015,'Libra'],
  [913786015,914000090,'Scorpio'],
  [914000090,914207930,'Sagittarius'],
  [914207930,914409093,'Capricorn'],
  [914409093,914602686,'Aquarius'],
  [914602686,914787990,'Pisces'],
  [914787990,914966392,'Aries'],
  [914966392,915142180,'Taurus'],
  [915142180,915321586,'Gemini'],
  [915321586,915510859,'Cancer'],
  [915510859,915713549,'Leo'],
  [915713549,915927735,'Virgo'],
  [915927735,916146049,'Libra'],
  [916146049,916360299,'Scorpio'],
  [916360299,916566264,'Sagittarius'],
  [916566264,916763908,'Capricorn'],
  [916763908,916954932,'Aquarius'],
  [916954932,917141011,'Pisces'],
  [917141011,917323697,'Aries'],
  [917323697,917505211,'Taurus'],
  [917505211,917688966,'Gemini'],
  [917688966,917879213,'Cancer'],
  [917879213,918079599,'Leo'],
  [918079599,918290780,'Virgo'],
  [918290780,918508364,'Libra'],
  [918508364,918724076,'Scorpio'],
  [918724076,918930785,'Sagittarius'],
  [918930785,919126296,'Capricorn'],
  [919126296,919312835,'Aquarius'],
  [919312835,919494616,'Pisces'],
  [919494616,919675802,'Aries'],
  [919675802,919859507,'Taurus'],
  [919859507,920047727,'Gemini'],
  [920047727,920241935,'Cancer'],
  [920241935,920443618,'Leo'],
  [920443618,920653659,'Virgo'],
  [920653659,920870327,'Libra'],
  [920870327,921087678,'Scorpio'],
  [921087678,921297546,'Sagittarius'],
  [921297546,921494624,'Capricorn'],
  [921494624,921679245,'Aquarius'],
  [921679245,921856175,'Pisces'],
  [921856175,922031855,'Aries'],
  [922031855,922212083,'Taurus'],
  [922212083,922400387,'Gemini'],
  [922400387,922597431,'Cancer'],
  [922597431,922802113,'Leo'],
  [922802113,923013268,'Virgo'],
  [923013268,923229638,'Libra'],
  [923229638,923447877,'Scorpio'],
  [923447877,923661329,'Sagittarius'],
  [923661329,923862938,'Capricorn'],
  [923862938,924049987,'Aquarius'],
  [924049987,924225618,'Pisces'],
  [924225618,924396688,'Aries'],
  [924396688,924570883,'Taurus'],
  [924570883,924754409,'Gemini'],
  [924754409,924949917,'Cancer'],
  [924949917,925155916,'Leo'],
  [925155916,925368879,'Virgo'],
  [925368879,925585785,'Libra'],
  [925585785,925804078,'Scorpio'],
  [925804078,926019522,'Sagittarius'],
  [926019522,926225861,'Capricorn'],
  [926225861,926418300,'Aquarius'],
  [926418300,926597138,'Pisces'],
  [926597138,926767753,'Aries'],
  [926767753,926937967,'Taurus'],
  [926937967,927115523,'Gemini'],
  [927115523,927305757,'Cancer'],
  [927305757,927509393,'Leo'],
  [927509393,927722642,'Virgo'],
  [927722642,927940237,'Libra'],
  [927940237,928158226,'Scorpio'],
  [928158226,928373513,'Sagittarius'],
  [928373513,928582088,'Capricorn'],
  [928582088,928779571,'Aquarius'],
  [928779571,928964166,'Pisces'],
  [928964166,929138623,'Aries'],
  [929138623,929309228,'Taurus'],
  [929309228,929483557,'Gemini'],
  [929483557,929668330,'Cancer'],
  [929668330,929867004,'Leo'],
  [929867004,930077968,'Virgo'],
  [930077968,930295445,'Libra'],
  [930295445,930513204,'Scorpio'],
  [930513204,930727175,'Sagittarius'],
  [930727175,930934844,'Capricorn'],
  [930934844,931134039,'Aquarius'],
  [931134039,931323300,'Pisces'],
  [931323300,931503466,'Aries'],
  [931503466,931678319,'Taurus'],
  [931678319,931853707,'Gemini'],
  [931853707,932035992,'Cancer'],
  [932035992,932230093,'Leo'],
  [932230093,932437188,'Virgo'],
  [932437188,932653306,'Libra'],
  [932653306,932871072,'Scorpio'],
  [932871072,933084095,'Sagittarius'],
  [933084095,933289352,'Capricorn'],
  [933289352,933486510,'Aquarius'],
  [933486510,933676373,'Pisces'],
  [933676373,933860273,'Aries'],
  [933860273,934040399,'Taurus'],
  [934040399,934220131,'Gemini'],
  [934220131,934403885,'Cancer'],
  [934403885,934596217,'Leo'],
  [934596217,934800004,'Virgo'],
  [934800004,935014034,'Libra'],
  [935014034,935231973,'Scorpio'],
  [935231973,935445489,'Sagittarius'],
  [935445489,935649302,'Capricorn'],
  [935649302,935843032,'Aquarius'],
  [935843032,936029545,'Pisces'],
  [936029545,936212523,'Aries'],
  [936212523,936395014,'Taurus'],
  [936395014,936579192,'Gemini'],
  [936579192,936767017,'Cancer'],
  [936767017,936960969,'Leo'],
  [936960969,937163706,'Virgo'],
  [937163706,937376015,'Libra'],
  [937376015,937594098,'Scorpio'],
  [937594098,937809617,'Sagittarius'],
  [937809617,938014667,'Capricorn'],
  [938014667,938206802,'Aquarius'],
  [938206802,938389150,'Pisces'],
  [938389150,938567463,'Aries'],
  [938567463,938747277,'Taurus'],
  [938747277,938932139,'Gemini'],
  [938932139,939123232,'Cancer'],
  [939123232,939320629,'Leo'],
  [939320629,939524875,'Virgo'],
  [939524875,939736774,'Libra'],
  [939736774,939954827,'Scorpio'],
  [939954827,940172779,'Sagittarius'],
  [940172779,940381678,'Capricorn'],
  [940381678,940576039,'Aquarius'],
  [940576039,940757125,'Pisces'],
  [940757125,940930985,'Aries'],
  [940930985,941105035,'Taurus'],
  [941105035,941285488,'Gemini'],
  [941285488,941475484,'Cancer'],
  [941475484,941674766,'Leo'],
  [941674766,941881557,'Virgo'],
  [941881557,942094547,'Libra'],
  [942094547,942312553,'Scorpio'],
  [942312553,942531849,'Sagittarius'],
  [942531849,942745033,'Capricorn'],
  [942745033,942944837,'Aquarius'],
  [942944837,943129343,'Pisces'],
  [943129343,943302793,'Aries'],
  [943302793,943472651,'Taurus'],
  [943472651,943646717,'Gemini'],
  [943646717,943830960,'Cancer'],
  [943830960,944027624,'Leo'],
  [944027624,944235016,'Virgo'],
  [944235016,944449517,'Libra'],
  [944449517,944667843,'Scorpio'],
  [944667843,944886923,'Sagittarius'],
  [944886923,945102027,'Capricorn'],
  [945102027,945307075,'Aquarius'],
  [945307075,945498102,'Pisces'],
  [945498102,945676192,'Aries'],
  [945676192,945846835,'Taurus'],
  [945846835,946017466,'Gemini'],
  [946017466,946195367,'Cancer'],
  [946195367,946385730,'Leo'],
  [946385730,946589735,'Virgo'],
  [946589735,946804042,'Libra'],
  [946804042,947022903,'Scorpio'],
  [947022903,947241242,'Sagittarius'],
  [947241242,947455317,'Capricorn'],
  [947455317,947661814,'Aquarius'],
  [947661814,947857905,'Pisces'],
  [947857905,948042826,'Aries'],
  [948042826,948219012,'Taurus'],
  [948219012,948391608,'Gemini'],
  [948391608,948567127,'Cancer'],
  [948567127,948751910,'Leo'],
  [948751910,948950130,'Virgo'],
  [948950130,949161404,'Libra'],
  [949161404,949380020,'Scorpio'],
  [949380020,949598191,'Sagittarius'],
  [949598191,949810403,'Capricorn'],
  [949810403,950014615,'Aquarius'],
  [950014615,950210801,'Pisces'],
  [950210801,950399533,'Aries'],
  [950399533,950581940,'Taurus'],
  [950581940,950760321,'Gemini'],
  [950760321,950938628,'Cancer'],
  [950938628,951122147,'Leo'],
  [951122147,951316119,'Virgo'],
  [951316119,951523137,'Libra'],
  [951523137,951740145,'Scorpio'],
  [951740145,951958726,'Sagittarius'],
  [951958726,952170489,'Capricorn'],
  [952170489,952371977,'Aquarius'],
  [952371977,952564598,'Pisces'],
  [952564598,952751639,'Aries'],
  [952751639,952935907,'Taurus'],
  [952935907,953119093,'Gemini'],
  [953119093,953302668,'Cancer'],
  [953302668,953489272,'Leo'],
  [953489272,953682932,'Virgo'],
  [953682932,953887295,'Libra'],
  [953887295,954102210,'Scorpio'],
  [954102210,954321214,'Sagittarius'],
  [954321214,954534469,'Capricorn'],
  [954534469,954735667,'Aquarius'],
  [954735667,954925180,'Pisces'],
  [954925180,955107684,'Aries'],
  [955107684,955288538,'Taurus'],
  [955288538,955471469,'Gemini'],
  [955471469,955658026,'Cancer'],
  [955658026,955848835,'Leo'],
  [955848835,956045351,'Virgo'],
  [956045351,956249981,'Libra'],
  [956249981,956463753,'Scorpio'],
  [956463753,956682920,'Sagittarius'],
  [956682920,956898657,'Capricorn'],
  [956898657,957102526,'Aquarius'],
  [957102526,957292254,'Pisces'],
  [957292254,957471732,'Aries'],
  [957471732,957647505,'Taurus'],
  [957647505,957825689,'Gemini'],
  [957825689,958010165,'Cancer'],
  [958010165,958202195,'Leo'],
  [958202195,958401646,'Virgo'],
  [958401646,958608478,'Libra'],
  [958608478,958822641,'Scorpio'],
  [958822641,959041834,'Sagittarius'],
  [959041834,959259614,'Capricorn'],
  [959259614,959467629,'Aquarius'],
  [959467629,959661080,'Pisces'],
  [959661080,959841464,'Aries'],
  [959841464,960014602,'Taurus'],
  [960014602,960187555,'Gemini'],
  [960187555,960366472,'Cancer'],
  [960366472,960555155,'Leo'],
  [960555155,960754483,'Virgo'],
  [960754483,960963055,'Libra'],
  [960963055,961178487,'Scorpio'],
  [961178487,961397778,'Sagittarius'],
  [961397778,961616239,'Capricorn'],
  [961616239,961827519,'Aquarius'],
  [961827519,962026203,'Pisces'],
  [962026203,962211145,'Aries'],
  [962211145,962385908,'Taurus'],
  [962385908,962556757,'Gemini'],
  [962556757,962730613,'Cancer'],
  [962730613,962913485,'Leo'],
  [962913485,963108903,'Virgo'],
  [963108903,963316623,'Libra'],
  [963316623,963532828,'Scorpio'],
  [963532828,963752321,'Sagittarius'],
  [963752321,963970228,'Capricorn'],
  [963970228,964182243,'Aquarius'],
  [964182243,964384631,'Pisces'],
  [964384631,964575296,'Aries'],
  [964575296,964755187,'Taurus'],
  [964755187,964928301,'Gemini'],
  [964928301,965100648,'Cancer'],
  [965100648,965278916,'Leo'],
  [965278916,965468844,'Virgo'],
  [965468844,965672883,'Libra'],
  [965672883,965888182,'Scorpio'],
  [965888182,966107770,'Sagittarius'],
  [966107770,966324793,'Capricorn'],
  [966324793,966535302,'Aquarius'],
  [966535302,966737847,'Pisces'],
  [966737847,966931859,'Aries'],
  [966931859,967117375,'Taurus'],
  [967117375,967295874,'Gemini'],
  [967295874,967471006,'Cancer'],
  [967471006,967648415,'Leo'],
  [967648415,967834476,'Virgo'],
  [967834476,968033934,'Libra'],
  [968033934,968246591,'Scorpio'],
  [968246591,968465847,'Sagittarius'],
  [968465847,968682618,'Capricorn'],
  [968682618,968891253,'Aquarius'],
  [968891253,969091137,'Pisces'],
  [969091137,969284125,'Aries'],
  [969284125,969471891,'Taurus'],
  [969471891,969655326,'Gemini'],
  [969655326,969835734,'Cancer'],
  [969835734,970016302,'Leo'],
  [970016302,970202176,'Virgo'],
  [970202176,970398749,'Libra'],
  [970398749,970608316,'Scorpio'],
  [970608316,970826678,'Sagittarius'],
  [970826678,971044224,'Capricorn'],
  [971044224,971252658,'Aquarius'],
  [971252658,971449952,'Pisces'],
  [971449952,971639058,'Aries'],
  [971639058,971824154,'Taurus'],
  [971824154,972008121,'Gemini'],
  [972008121,972192204,'Cancer'],
  [972192204,972377528,'Leo'],
  [972377528,972566689,'Virgo'],
  [972566689,972763638,'Libra'],
  [972763638,972971451,'Scorpio'],
  [972971451,973188665,'Sagittarius'],
  [973188665,973407524,'Capricorn'],
  [973407524,973618229,'Aquarius'],
  [973618229,973815840,'Pisces'],
  [973815840,974002090,'Aries'],
  [974002090,974182245,'Taurus'],
  [974182245,974361732,'Gemini'],
  [974361732,974544248,'Cancer'],
  [974544248,974731526,'Leo'],
  [974731526,974924498,'Virgo'],
  [974924498,975124466,'Libra'],
  [975124466,975332915,'Scorpio'],
  [975332915,975549452,'Sagittarius'],
  [975549452,975769191,'Capricorn'],
  [975769191,975983455,'Aquarius'],
  [975983455,976184988,'Pisces'],
  [976184988,976372506,'Aries'],
  [976372506,976550074,'Taurus'],
  [976550074,976724018,'Gemini'],
  [976724018,976900527,'Cancer'],
  [976900527,977084184,'Leo'],
  [977084184,977277235,'Virgo'],
  [977277235,977479752,'Libra'],
  [977479752,977690478,'Scorpio'],
  [977690478,977907453,'Sagittarius'],
  [977907453,978127226,'Capricorn'],
  [978127226,978343948,'Aquarius'],
  [978343948,978550786,'Pisces'],
  [978550786,978743703,'Aries'],
  [978743703,978923715,'Taurus'],
  [978923715,979095827,'Gemini'],
  [979095827,979266870,'Cancer'],
  [979266870,979443719,'Leo'],
  [979443719,979631687,'Virgo'],
  [979631687,979832750,'Libra'],
  [979832750,980044733,'Scorpio'],
  [980044733,980262893,'Sagittarius'],
  [980262893,980482437,'Capricorn'],
  [980482437,980699264,'Aquarius'],
  [980699264,980909197,'Pisces'],
  [980909197,981108222,'Aries'],
  [981108222,981294582,'Taurus'],
  [981294582,981470234,'Gemini'],
  [981470234,981640523,'Cancer'],
  [981640523,981812661,'Leo'],
  [981812661,981993950,'Virgo'],
  [981993950,982189490,'Libra'],
  [982189490,982399319,'Scorpio'],
  [982399319,982617798,'Sagittarius'],
  [982617798,982837398,'Capricorn'],
  [982837398,983053020,'Aquarius'],
  [983053020,983262433,'Pisces'],
  [983262433,983464076,'Aries'],
  [983464076,983656253,'Taurus'],
  [983656253,983838447,'Gemini'],
  [983838447,984013042,'Cancer'],
  [984013042,984185575,'Leo'],
  [984185575,984363327,'Virgo'],
  [984363327,984553130,'Libra'],
  [984553130,984758140,'Scorpio'],
  [984758140,984974817,'Sagittarius'],
  [984974817,985194426,'Capricorn'],
  [985194426,985409239,'Aquarius'],
  [985409239,985616413,'Pisces'],
  [985616413,985816397,'Aries'],
  [985816397,986009856,'Taurus'],
  [986009856,986196675,'Gemini'],
  [986196675,986377264,'Cancer'],
  [986377264,986554395,'Leo'],
  [986554395,986733461,'Virgo'],
  [986733461,986920959,'Libra'],
  [986920959,987121711,'Scorpio'],
  [987121711,987335224,'Sagittarius'],
  [987335224,987554274,'Capricorn'],
  [987554274,987769387,'Aquarius'],
  [987769387,987975277,'Pisces'],
  [987975277,988172133,'Aries'],
  [988172133,988362608,'Taurus'],
  [988362608,988548986,'Gemini'],
  [988548986,988732511,'Cancer'],
  [988732511,988914558,'Leo'],
  [988914558,989098004,'Virgo'],
  [989098004,989287280,'Libra'],
  [989287280,989486757,'Scorpio'],
  [989486757,989697753,'Sagittarius'],
  [989697753,989915837,'Capricorn'],
  [989915837,990132096,'Aquarius'],
  [990132096,990338945,'Pisces'],
  [990338945,990534402,'Aries'],
  [990534402,990721108,'Taurus'],
  [990721108,990903291,'Gemini'],
  [990903291,991084667,'Cancer'],
  [991084667,991267858,'Leo'],
  [991267858,991454893,'Virgo'],
  [991454893,991647904,'Libra'],
  [991647904,991849116,'Scorpio'],
  [991849116,992059574,'Sagittarius'],
  [992059574,992276906,'Capricorn'],
  [992276906,992494478,'Aquarius'],
  [992494478,992704189,'Pisces'],
  [992704189,992901399,'Aries'],
  [992901399,993086855,'Taurus'],
  [993086855,993264923,'Gemini'],
  [993264923,993441193,'Cancer'],
  [993441193,993620790,'Leo'],
  [993620790,993807360,'Virgo'],
  [993807360,994002625,'Libra'],
  [994002625,994206625,'Scorpio'],
  [994206625,994418357,'Sagittarius'],
  [994418357,994635603,'Capricorn'],
  [994635603,994853979,'Aquarius'],
  [994853979,995066955,'Pisces'],
  [995066955,995268466,'Aries'],
  [995268466,995456467,'Taurus'],
  [995456467,995633639,'Gemini'],
  [995633639,995805776,'Cancer'],
  [995805776,995979738,'Leo'],
  [995979738,996161677,'Virgo'],
  [996161677,996355247,'Libra'],
  [996355247,996560330,'Scorpio'],
  [996560330,996773751,'Sagittarius'],
  [996773751,996991535,'Capricorn'],
  [996991535,997209965,'Aquarius'],
  [997209965,997424825,'Pisces'],
  [997424825,997630929,'Aries'],
  [997630929,997824277,'Taurus'],
  [997824277,998004740,'Gemini'],
  [998004740,998176546,'Cancer'],
  [998176546,998346691,'Leo'],
  [998346691,998522870,'Virgo'],
  [998522870,998711288,'Libra'],
  [998711288,998913994,'Scorpio'],
  [998913994,999127644,'Sagittarius'],
  [999127644,999346051,'Capricorn'],
  [999346051,999564101,'Aquarius'],
  [999564101,999778719,'Pisces'],
  [999778719,999987026,'Aries'],
  [999987026,1000185510,'Taurus'],
  [1000185510,1000371935,'Gemini'],
  [1000371935,1000547747,'Cancer'],
  [1000547747,1000718339,'Leo'],
  [1000718339,1000891308,'Virgo'],
  [1000891308,1001074250,'Libra'],
  [1001074250,1001271919,'Scorpio'],
  [1001271919,1001483220,'Sagittarius'],
  [1001483220,1001701502,'Capricorn'],
  [1001701502,1001919291,'Aquarius'],
  [1001919291,1002132457,'Pisces'],
  [1002132457,1002339659,'Aries'],
  [1002339659,1002539750,'Taurus'],
  [1002539750,1002731009,'Gemini'],
  [1002731009,1002912923,'Cancer'],
  [1002912923,1003088151,'Leo'],
  [1003088151,1003262446,'Virgo'],
  [1003262446,1003442982,'Libra'],
  [1003442982,1003635903,'Scorpio'],
  [1003635903,1003843055,'Sagittarius'],
  [1003843055,1004059861,'Capricorn'],
  [1004059861,1004277771,'Aquarius'],
  [1004277771,1004490078,'Pisces'],
  [1004490078,1004694691,'Aries'],
  [1004694691,1004892285,'Taurus'],
  [1004892285,1005083701,'Gemini'],
  [1005083701,1005269300,'Cancer'],
  [1005269300,1005450192,'Leo'],
  [1005450192,1005629461,'Virgo'],
  [1005629461,1005812069,'Libra'],
  [1005812069,1006003459,'Scorpio'],
  [1006003459,1006207064,'Sagittarius'],
  [1006207064,1006421423,'Capricorn'],
  [1006421423,1006639525,'Aquarius'],
  [1006639525,1006852766,'Pisces'],
  [1006852766,1007056324,'Aries'],
  [1007056324,1007250347,'Taurus'],
  [1007250347,1007437647,'Gemini'],
  [1007437647,1007621373,'Cancer'],
  [1007621373,1007804067,'Leo'],
  [1007804067,1007987895,'Virgo'],
  [1007987895,1008175269,'Libra'],
  [1008175269,1008369080,'Scorpio'],
  [1008369080,1008571959,'Sagittarius'],
  [1008571959,1008784329,'Capricorn'],
  [1008784329,1009002256,'Aquarius'],
  [1009002256,1009217810,'Pisces'],
  [1009217810,1009423513,'Aries'],
  [1009423513,1009616757,'Taurus'],
  [1009616757,1009799963,'Gemini'],
  [1009799963,1009978209,'Cancer'],
  [1009978209,1010156908,'Leo'],
  [1010156908,1010340260,'Virgo'],
  [1010340260,1010530517,'Libra'],
  [1010530517,1010728241,'Scorpio'],
  [1010728241,1010933350,'Sagittarius'],
  [1010933350,1011145557,'Capricorn'],
  [1011145557,1011363066,'Aquarius'],
  [1011363066,1011580711,'Pisces'],
  [1011580711,1011790754,'Aries'],
  [1011790754,1011987462,'Taurus'],
  [1011987462,1012170603,'Gemini'],
  [1012170603,1012344909,'Cancer'],
  [1012344909,1012517444,'Leo'],
  [1012517444,1012695147,'Virgo'],
  [1012695147,1012882813,'Libra'],
  [1012882813,1013081566,'Scorpio'],
  [1013081566,1013289293,'Sagittarius'],
  [1013289293,1013503049,'Capricorn'],
  [1013503049,1013720540,'Aquarius'],
  [1013720540,1013938881,'Pisces'],
  [1013938881,1014152612,'Aries'],
  [1014152612,1014355075,'Taurus'],
  [1014355075,1014542810,'Gemini'],
  [1014542810,1014718068,'Cancer'],
  [1014718068,1014887457,'Leo'],
  [1014887457,1015059107,'Virgo'],
  [1015059107,1015240314,'Libra'],
  [1015240314,1015435090,'Scorpio'],
  [1015435090,1015642378,'Sagittarius'],
  [1015642378,1015857443,'Capricorn'],
  [1015857443,1016075507,'Aquarius'],
  [1016075507,1016293474,'Pisces'],
  [1016293474,1016508205,'Aries'],
  [1016508205,1016714891,'Taurus'],
  [1016714891,1016908933,'Gemini'],
  [1016908933,1017089540,'Cancer'],
  [1017089540,1017260963,'Leo'],
  [1017260963,1017430586,'Virgo'],
  [1017430586,1017606439,'Libra'],
  [1017606439,1017794870,'Scorpio'],
  [1017794870,1017997864,'Sagittarius'],
  [1017997864,1018211860,'Capricorn'],
  [1018211860,1018430284,'Aquarius'],
  [1018430284,1018647775,'Pisces'],
  [1018647775,1018861336,'Aries'],
  [1018861336,1019068484,'Taurus'],
  [1019068484,1019266280,'Gemini'],
  [1019266280,1019452935,'Cancer'],
  [1019452935,1019629995,'Leo'],
  [1019629995,1019802501,'Virgo'],
  [1019802501,1019977384,'Libra'],
  [1019977384,1020161452,'Scorpio'],
  [1020161452,1020359026,'Sagittarius'],
  [1020359026,1020569524,'Capricorn'],
  [1020569524,1020787177,'Aquarius'],
  [1020787177,1021004548,'Pisces'],
  [1021004548,1021216671,'Aries'],
  [1021216671,1021421584,'Taurus'],
  [1021421584,1021618730,'Gemini'],
  [1021618730,1021807986,'Cancer'],
  [1021807986,1021990231,'Leo'],
  [1021990231,1022168178,'Virgo'],
  [1022168178,1022346358,'Libra'],
  [1022346358,1022530223,'Scorpio'],
  [1022530223,1022724548,'Sagittarius'],
  [1022724548,1022931185,'Capricorn'],
  [1022931185,1023147011,'Aquarius'],
  [1023147011,1023364563,'Pisces'],
  [1023364563,1023576460,'Aries'],
  [1023576460,1023779148,'Taurus'],
  [1023779148,1023972967,'Gemini'],
  [1023972967,1024160218,'Cancer'],
  [1024160218,1024343547,'Leo'],
  [1024343547,1024525437,'Virgo'],
  [1024525437,1024708436,'Libra'],
  [1024708436,1024895547,'Scorpio'],
  [1024895547,1025090125,'Sagittarius'],
  [1025090125,1025294685,'Capricorn'],
  [1025294685,1025508627,'Aquarius'],
  [1025508627,1025726471,'Pisces'],
  [1025726471,1025939780,'Aries'],
  [1025939780,1026142393,'Taurus'],
  [1026142393,1026333484,'Gemini'],
  [1026333484,1026516493,'Cancer'],
  [1026516493,1026696444,'Leo'],
  [1026696444,1026877775,'Virgo'],
  [1026877775,1027063283,'Libra'],
  [1027063283,1027254278,'Scorpio'],
  [1027254278,1027451674,'Sagittarius'],
  [1027451674,1027656685,'Capricorn'],
  [1027656685,1027869712,'Aquarius'],
  [1027869712,1028087783,'Pisces'],
  [1028087783,1028303518,'Aries'],
  [1028303518,1028508797,'Taurus'],
  [1028508797,1028700197,'Gemini'],
  [1028700197,1028880344,'Cancer'],
  [1028880344,1029055421,'Leo'],
  [1029055421,1029232139,'Virgo'],
  [1029232139,1029415516,'Libra'],
  [1029415516,1029607564,'Scorpio'],
  [1029607564,1029807732,'Sagittarius'],
  [1029807732,1030014862,'Capricorn'],
  [1030014862,1030228298,'Aquarius'],
  [1030228298,1030446456,'Pisces'],
  [1030446456,1030664298,'Aries'],
  [1030664298,1030873828,'Taurus'],
  [1030873828,1031069073,'Gemini'],
  [1031069073,1031250182,'Cancer'],
  [1031250182,1031422661,'Leo'],
  [1031422661,1031594197,'Virgo'],
  [1031594197,1031771995,'Libra'],
  [1031771995,1031960604,'Scorpio'],
  [1031960604,1032160549,'Sagittarius'],
  [1032160549,1032369350,'Capricorn'],
  [1032369350,1032584018,'Aquarius'],
  [1032584018,1032802237,'Pisces'],
  [1032802237,1033020741,'Aries'],
  [1033020741,1033233642,'Taurus'],
  [1033233642,1033434436,'Gemini'],
  [1033434436,1033620467,'Cancer'],
  [1033620467,1033794827,'Leo'],
  [1033794827,1033964390,'Virgo'],
  [1033964390,1034137051,'Libra'],
  [1034137051,1034319542,'Scorpio'],
  [1034319542,1034515241,'Sagittarius'],
  [1034515241,1034722993,'Capricorn'],
  [1034722993,1034938435,'Aquarius'],
  [1034938435,1035156873,'Pisces'],
  [1035156873,1035374682,'Aries'],
  [1035374682,1035588095,'Taurus'],
  [1035588095,1035792604,'Gemini'],
  [1035792604,1035984794,'Cancer'],
  [1035984794,1036164953,'Leo'],
  [1036164953,1036337445,'Virgo'],
  [1036337445,1036509006,'Libra'],
  [1036509006,1036686798,'Scorpio'],
  [1036686798,1036876471,'Sagittarius'],
  [1036876471,1037079966,'Capricorn'],
  [1037079966,1037294265,'Aquarius'],
  [1037294265,1037512933,'Pisces'],
  [1037512933,1037729911,'Aries'],
  [1037729911,1037941459,'Taurus'],
  [1037941459,1038145502,'Gemini'],
  [1038145502,1038340697,'Cancer'],
  [1038340697,1038526779,'Leo'],
  [1038526779,1038705510,'Virgo'],
  [1038705510,1038880897,'Libra'],
  [1038880897,1039058537,'Scorpio'],
  [1039058537,1039244365,'Sagittarius'],
  [1039244365,1039442721,'Capricorn'],
  [1039442721,1039653772,'Aquarius'],
  [1039653772,1039872045,'Pisces'],
  [1039872045,1040089164,'Aries'],
  [1040089164,1040298996,'Taurus'],
  [1040298996,1040499838,'Gemini'],
  [1040499838,1040692962,'Cancer'],
  [1040692962,1040880383,'Leo'],
  [1040880383,1041063866,'Virgo'],
  [1041063866,1041245211,'Libra'],
  [1041245211,1041427121,'Scorpio'],
  [1041427121,1041613644,'Sagittarius'],
  [1041613644,1041809342,'Capricorn'],
  [1041809342,1042016889,'Aquarius'],
  [1042016889,1042233840,'Pisces'],
  [1042233840,1042451991,'Aries'],
  [1042451991,1042662365,'Taurus'],
  [1042662365,1042861045,'Gemini'],
  [1042861045,1043049885,'Cancer'],
  [1043049885,1043233448,'Leo'],
  [1043233448,1043416029,'Virgo'],
  [1043416029,1043600179,'Libra'],
  [1043600179,1043786970,'Scorpio'],
  [1043786970,1043977597,'Sagittarius'],
  [1043977597,1044174545,'Capricorn'],
  [1044174545,1044380684,'Aquarius'],
  [1044380684,1044596164,'Pisces'],
  [1044596164,1044815343,'Aries'],
  [1044815343,1045028471,'Taurus'],
  [1045028471,1045228499,'Gemini'],
  [1045228499,1045415337,'Cancer'],
  [1045415337,1045594102,'Leo'],
  [1045594102,1045771362,'Virgo'],
  [1045771362,1045952387,'Libra'],
  [1045952387,1046139733,'Scorpio'],
  [1046139733,1046333640,'Sagittarius'],
  [1046333640,1046533958,'Capricorn'],
  [1046533958,1046741425,'Aquarius'],
  [1046741425,1046956470,'Pisces'],
  [1046956470,1047176070,'Aries'],
  [1047176070,1047392349,'Taurus'],
  [1047392349,1047596702,'Gemini'],
  [1047596702,1047785900,'Cancer'],
  [1047785900,1047963336,'Leo'],
  [1047963336,1048135903,'Virgo'],
  [1048135903,1048310785,'Libra'],
  [1048310785,1048493349,'Scorpio'],
  [1048493349,1048685871,'Sagittarius'],
  [1048685871,1048887839,'Capricorn'],
  [1048887839,1049097590,'Aquarius'],
  [1049097590,1049313516,'Pisces'],
  [1049313516,1049533130,'Aries'],
  [1049533130,1049751106,'Taurus'],
  [1049751106,1049960017,'Gemini'],
  [1049960017,1050154646,'Cancer'],
  [1050154646,1050335420,'Leo'],
  [1050335420,1050507565,'Virgo'],
  [1050507565,1050678291,'Libra'],
  [1050678291,1050854578,'Scorpio'],
  [1050854578,1051041517,'Sagittarius'],
  [1051041517,1051240945,'Capricorn'],
  [1051240945,1051451137,'Aquarius'],
  [1051451137,1051668181,'Pisces'],
  [1051668181,1051887837,'Aries'],
  [1051887837,1052105686,'Taurus'],
  [1052105686,1052316742,'Gemini'],
  [1052316742,1052516460,'Cancer'],
  [1052516460,1052703202,'Leo'],
  [1052703202,1052879416,'Virgo'],
  [1052879416,1053050572,'Libra'],
  [1053050572,1053223438,'Scorpio'],
  [1053223438,1053404545,'Sagittarius'],
  [1053404545,1053598500,'Capricorn'],
  [1053598500,1053805979,'Aquarius'],
  [1053805979,1054022878,'Pisces'],
  [1054022878,1054242619,'Aries'],
  [1054242619,1054459467,'Taurus'],
  [1054459467,1054669758,'Gemini'],
  [1054669758,1054871283,'Cancer'],
  [1054871283,1055062860,'Leo'],
  [1055062860,1055245037,'Virgo'],
  [1055245037,1055420638,'Libra'],
  [1055420638,1055594592,'Scorpio'],
  [1055594592,1055773081,'Sagittarius'],
  [1055773081,1055962092,'Capricorn'],
  [1055962092,1056165037,'Aquarius'],
  [1056165037,1056379961,'Pisces'],
  [1056379961,1056599543,'Aries'],
  [1056599543,1056815683,'Taurus'],
  [1056815683,1057023908,'Gemini'],
  [1057023908,1057223691,'Cancer'],
  [1057223691,1057416107,'Leo'],
  [1057416107,1057602247,'Virgo'],
  [1057602247,1057783336,'Libra'],
  [1057783336,1057961764,'Scorpio'],
  [1057961764,1058141795,'Sagittarius'],
  [1058141795,1058329000,'Capricorn'],
  [1058329000,1058528224,'Aquarius'],
  [1058528224,1058740235,'Pisces'],
  [1058740235,1058959240,'Aries'],
  [1058959240,1059175638,'Taurus'],
  [1059175638,1059382649,'Gemini'],
  [1059382649,1059579434,'Cancer'],
  [1059579434,1059768929,'Leo'],
  [1059768929,1059954502,'Virgo'],
  [1059954502,1060138235,'Libra'],
  [1060138235,1060321292,'Scorpio'],
  [1060321292,1060505534,'Sagittarius'],
  [1060505534,1060694529,'Capricorn'],
  [1060694529,1060892698,'Aquarius'],
  [1060892698,1061102460,'Pisces'],
  [1061102460,1061320638,'Aries'],
  [1061320638,1061538223,'Taurus'],
  [1061538223,1061746215,'Gemini'],
  [1061746215,1061941633,'Cancer'],
  [1061941633,1062127425,'Leo'],
  [1062127425,1062308836,'Virgo'],
  [1062308836,1062490360,'Libra'],
  [1062490360,1062674458,'Scorpio'],
  [1062674458,1062862191,'Sagittarius'],
  [1062862191,1063054865,'Capricorn'],
  [1063054865,1063254803,'Aquarius'],
  [1063254803,1063464121,'Pisces'],
  [1063464121,1063681634,'Aries'],
  [1063681634,1063900638,'Taurus'],
  [1063900638,1064111688,'Gemini'],
  [1064111688,1064309060,'Cancer'],
  [1064309060,1064493729,'Leo'],
  [1064493729,1064671028,'Virgo'],
  [1064671028,1064847257,'Libra'],
  [1064847257,1065027488,'Scorpio'],
  [1065027488,1065214568,'Sagittarius'],
  [1065214568,1065409449,'Capricorn'],
  [1065409449,1065612277,'Aquarius'],
  [1065612277,1065822988,'Pisces'],
  [1065822988,1066040410,'Aries'],
  [1066040410,1066260171,'Taurus'],
  [1066260171,1066474660,'Gemini'],
  [1066474660,1066676818,'Cancer'],
  [1066676818,1066864601,'Leo'],
  [1066864601,1067041403,'Virgo'],
  [1067041403,1067213497,'Libra'],
  [1067213497,1067387643,'Scorpio'],
  [1067387643,1067569464,'Sagittarius'],
  [1067569464,1067762180,'Capricorn'],
  [1067762180,1067965980,'Aquarius'],
  [1067965980,1068178580,'Pisces'],
  [1068178580,1068396639,'Aries'],
  [1068396639,1068616237,'Taurus'],
  [1068616237,1068832349,'Gemini'],
  [1068832349,1069039292,'Cancer'],
  [1069039292,1069233186,'Leo'],
  [1069233186,1069414287,'Virgo'],
  [1069414287,1069586812,'Libra'],
  [1069586812,1069757281,'Scorpio'],
  [1069757281,1069932823,'Sagittarius'],
  [1069932823,1070119505,'Capricorn'],
  [1070119505,1070320184,'Aquarius'],
  [1070320184,1070532837,'Pisces'],
  [1070532837,1070751728,'Aries'],
  [1070751728,1070970910,'Taurus'],
  [1070970910,1071186239,'Gemini'],
  [1071186239,1071394757,'Cancer'],
  [1071394757,1071593735,'Leo'],
  [1071593735,1071781581,'Virgo'],
  [1071781581,1071959358,'Libra'],
  [1071959358,1072131339,'Scorpio'],
  [1072131339,1072304137,'Sagittarius'],
  [1072304137,1072485075,'Capricorn'],
  [1072485075,1072679864,'Aquarius'],
  [1072679864,1072889367,'Pisces'],
  [1072889367,1073107990,'Aries'],
  [1073107990,1073327167,'Taurus'],
  [1073327167,1073540950,'Gemini'],
  [1073540950,1073747579,'Cancer'],
  [1073747579,1073947072,'Leo'],
  [1073947072,1074139129,'Virgo'],
  [1074139129,1074323367,'Libra'],
  [1074323367,1074501059,'Scorpio'],
  [1074501059,1074676381,'Sagittarius'],
  [1074676381,1074855782,'Capricorn'],
  [1074855782,1075045981,'Aquarius'],
  [1075045981,1075250735,'Pisces'],
  [1075250735,1075467253,'Aries'],
  [1075467253,1075686599,'Taurus'],
  [1075686599,1075900003,'Gemini'],
  [1075900003,1076104170,'Cancer'],
  [1076104170,1076300450,'Leo'],
  [1076300450,1076491258,'Virgo'],
  [1076491258,1076677897,'Libra'],
  [1076677897,1076860857,'Scorpio'],
  [1076860857,1077041688,'Sagittarius'],
  [1077041688,1077224251,'Capricorn'],
  [1077224251,1077414033,'Aquarius'],
  [1077414033,1077615693,'Pisces'],
  [1077615693,1077829388,'Aries'],
  [1077829388,1078048506,'Taurus'],
  [1078048506,1078263140,'Gemini'],
  [1078263140,1078467075,'Cancer'],
  [1078467075,1078660398,'Leo'],
  [1078660398,1078846814,'Virgo'],
  [1078846814,1079030293,'Libra'],
  [1079030293,1079213434,'Scorpio'],
  [1079213434,1079397740,'Sagittarius'],
  [1079397740,1079584966,'Capricorn'],
  [1079584966,1079777950,'Aquarius'],
  [1079777950,1079979911,'Pisces'],
  [1079979911,1080192024,'Aries'],
  [1080192024,1080410575,'Taurus'],
  [1080410575,1080627148,'Gemini'],
  [1080627148,1080833624,'Cancer'],
  [1080833624,1081027243,'Leo'],
  [1081027243,1081210649,'Virgo'],
  [1081210649,1081388982,'Libra'],
  [1081388982,1081567406,'Scorpio'],
  [1081567406,1081749831,'Sagittarius'],
  [1081749831,1081938627,'Capricorn'],
  [1081938627,1082135022,'Aquarius'],
  [1082135022,1082339621,'Pisces'],
  [1082339621,1082552234,'Aries'],
  [1082552234,1082770454,'Taurus'],
  [1082770454,1082988521,'Gemini'],
  [1082988521,1083198835,'Cancer'],
  [1083198835,1083396195,'Leo'],
  [1083396195,1083580575,'Virgo'],
  [1083580575,1083756189,'Libra'],
  [1083756189,1083929230,'Scorpio'],
  [1083929230,1084105985,'Sagittarius'],
  [1084105985,1084291388,'Capricorn'],
  [1084291388,1084487778,'Aquarius'],
  [1084487778,1084694457,'Pisces'],
  [1084694457,1084908736,'Aries'],
  [1084908736,1085127212,'Taurus'],
  [1085127212,1085345760,'Gemini'],
  [1085345760,1085559031,'Cancer'],
  [1085559031,1085761510,'Leo'],
  [1085761510,1085950517,'Virgo'],
  [1085950517,1086127775,'Libra'],
  [1086127775,1086298636,'Scorpio'],
  [1086298636,1086470232,'Sagittarius'],
  [1086470232,1086649641,'Capricorn'],
  [1086649641,1086841856,'Aquarius'],
  [1086841856,1087047544,'Pisces'],
  [1087047544,1087262759,'Aries'],
  [1087262759,1087481794,'Taurus'],
  [1087481794,1087700034,'Gemini'],
  [1087700034,1087914035,'Cancer'],
  [1087914035,1088120113,'Leo'],
  [1088120113,1088314825,'Virgo'],
  [1088314825,1088497242,'Libra'],
  [1088497242,1088670374,'Scorpio'],
  [1088670374,1088840493,'Sagittarius'],
  [1088840493,1089015291,'Capricorn'],
  [1089015291,1089201750,'Aquarius'],
  [1089201750,1089403266,'Pisces'],
  [1089403266,1089617203,'Aries'],
  [1089617203,1089836398,'Taurus'],
  [1089836398,1090054145,'Gemini'],
  [1090054145,1090267014,'Cancer'],
  [1090267014,1090473421,'Leo'],
  [1090473421,1090671529,'Virgo'],
  [1090671529,1090859601,'Libra'],
  [1090859601,1091038124,'Scorpio'],
  [1091038124,1091211093,'Sagittarius'],
  [1091211093,1091385174,'Capricorn'],
  [1091385174,1091567758,'Aquarius'],
  [1091567758,1091764275,'Pisces'],
  [1091764275,1091974846,'Aries'],
  [1091974846,1092193193,'Taurus'],
  [1092193193,1092410741,'Gemini'],
  [1092410741,1092622182,'Cancer'],
  [1092622182,1092826400,'Leo'],
  [1092826400,1093023816,'Virgo'],
  [1093023816,1093214356,'Libra'],
  [1093214356,1093397931,'Scorpio'],
  [1093397931,1093576241,'Sagittarius'],
  [1093576241,1093753621,'Capricorn'],
  [1093753621,1093936169,'Aquarius'],
  [1093936169,1094129674,'Pisces'],
  [1094129674,1094336531,'Aries'],
  [1094336531,1094553076,'Taurus'],
  [1094553076,1094770826,'Gemini'],
  [1094770826,1094982093,'Cancer'],
  [1094982093,1095184123,'Leo'],
  [1095184123,1095378149,'Virgo'],
  [1095378149,1095566519,'Libra'],
  [1095566519,1095751061,'Scorpio'],
  [1095751061,1095933330,'Sagittarius'],
  [1095933330,1096115663,'Capricorn'],
  [1096115663,1096301683,'Aquarius'],
  [1096301683,1096495637,'Pisces'],
  [1096495637,1096700454,'Aries'],
  [1096700454,1096915059,'Taurus'],
  [1096915059,1097133147,'Gemini'],
  [1097133147,1097346088,'Cancer'],
  [1097346088,1097548335,'Leo'],
  [1097548335,1097739700,'Virgo'],
  [1097739700,1097923539,'Libra'],
  [1097923539,1098104221,'Scorpio'],
  [1098104221,1098285568,'Sagittarius'],
  [1098285568,1098470348,'Capricorn'],
  [1098470348,1098660523,'Aquarius'],
  [1098660523,1098857703,'Pisces'],
  [1098857703,1099063174,'Aries'],
  [1099063174,1099276759,'Taurus'],
  [1099276759,1099494941,'Gemini'],
  [1099494941,1099710556,'Cancer'],
  [1099710556,1099916128,'Leo'],
  [1099916128,1100108448,'Virgo'],
  [1100108448,1100289598,'Libra'],
  [1100289598,1100464973,'Scorpio'],
  [1100464973,1100640899,'Sagittarius'],
  [1100640899,1100822764,'Capricorn'],
  [1100822764,1101013628,'Aquarius'],
  [1101013628,1101213778,'Pisces'],
  [1101213778,1101421774,'Aries'],
  [1101421774,1101635882,'Taurus'],
  [1101635882,1101853880,'Gemini'],
  [1101853880,1102071404,'Cancer'],
  [1102071404,1102281661,'Leo'],
  [1102281661,1102478854,'Virgo'],
  [1102478854,1102661976,'Libra'],
  [1102661976,1102835207,'Scorpio'],
  [1102835207,1103005700,'Sagittarius'],
  [1103005700,1103181108,'Capricorn'],
  [1103181108,1103367392,'Aquarius'],
  [1103367392,1103566576,'Pisces'],
  [1103566576,1103776201,'Aries'],
  [1103776201,1103991813,'Taurus'],
  [1103991813,1104209826,'Gemini'],
  [1104209826,1104427481,'Cancer'],
  [1104427481,1104640650,'Leo'],
  [1104640650,1104843707,'Virgo'],
  [1104843707,1105032850,'Libra'],
  [1105032850,1105209213,'Scorpio'],
  [1105209213,1105378641,'Sagittarius'],
  [1105378641,1105549203,'Capricorn'],
  [1105549203,1105728794,'Aquarius'],
  [1105728794,1105922535,'Pisces'],
  [1105922535,1106130144,'Aries'],
  [1106130144,1106346310,'Taurus'],
  [1106346310,1106564743,'Gemini'],
  [1106564743,1106781544,'Cancer'],
  [1106781544,1106994399,'Leo'],
  [1106994399,1107200210,'Virgo'],
  [1107200210,1107395297,'Libra'],
  [1107395297,1107578199,'Scorpio'],
  [1107578199,1107751813,'Sagittarius'],
  [1107751813,1107922612,'Capricorn'],
  [1107922612,1108098420,'Aquarius'],
  [1108098420,1108286065,'Pisces'],
  [1108286065,1108488480,'Aries'],
  [1108488480,1108702612,'Taurus'],
  [1108702612,1108921145,'Gemini'],
  [1108921145,1109137464,'Cancer'],
  [1109137464,1109348392,'Leo'],
  [1109348392,1109552762,'Virgo'],
  [1109552762,1109749416,'Libra'],
  [1109749416,1109937310,'Scorpio'],
  [1109937310,1110117229,'Sagittarius'],
  [1110117229,1110292827,'Capricorn'],
  [1110292827,1110469959,'Aquarius'],
  [1110469959,1110655015,'Pisces'],
  [1110655015,1110852611,'Aries'],
  [1110852611,1111062913,'Taurus'],
  [1111062913,1111280460,'Gemini'],
  [1111280460,1111497084,'Cancer'],
  [1111497084,1111706950,'Leo'],
  [1111706950,1111908355,'Virgo'],
  [1111908355,1112102158,'Libra'],
  [1112102158,1112289882,'Scorpio'],
  [1112289882,1112473142,'Sagittarius'],
  [1112473142,1112654107,'Capricorn'],
  [1112654107,1112835993,'Aquarius'],
  [1112835993,1113022948,'Pisces'],
  [1113022948,1113219036,'Aries'],
  [1113219036,1113426231,'Taurus'],
  [1113426231,1113642084,'Gemini'],
  [1113642084,1113859420,'Cancer'],
  [1113859420,1114070224,'Leo'],
  [1114070224,1114270333,'Virgo'],
  [1114270333,1114460411,'Libra'],
  [1114460411,1114644011,'Scorpio'],
  [1114644011,1114825296,'Sagittarius'],
  [1114825296,1115007695,'Capricorn'],
  [1115007695,1115193559,'Aquarius'],
  [1115193559,1115384620,'Pisces'],
  [1115384620,1115582641,'Aries'],
  [1115582641,1115789175,'Taurus'],
  [1115789175,1116003760,'Gemini'],
  [1116003760,1116221768,'Cancer'],
  [1116221768,1116435088,'Leo'],
  [1116435088,1116636917,'Virgo'],
  [1116636917,1116825788,'Libra'],
  [1116825788,1117005322,'Scorpio'],
  [1117005322,1117181569,'Sagittarius'],
  [1117181569,1117360438,'Capricorn'],
  [1117360438,1117545948,'Aquarius'],
  [1117545948,1117739479,'Pisces'],
  [1117739479,1117940592,'Aries'],
  [1117940592,1118148677,'Taurus'],
  [1118148677,1118363164,'Gemini'],
  [1118363164,1118581563,'Cancer'],
  [1118581563,1118797636,'Leo'],
  [1118797636,1119003503,'Virgo'],
  [1119003503,1119194879,'Libra'],
  [1119194879,1119373595,'Scorpio'],
  [1119373595,1119545847,'Sagittarius'],
  [1119545847,1119719164,'Capricorn'],
  [1119719164,1119900001,'Aquarius'],
  [1119900001,1120091758,'Pisces'],
  [1120091758,1120293993,'Aries'],
  [1120293993,1120504050,'Taurus'],
  [1120504050,1120719432,'Gemini'],
  [1120719432,1120937959,'Cancer'],
  [1120937959,1121155610,'Leo'],
  [1121155610,1121365692,'Virgo'],
  [1121365692,1121562206,'Libra'],
  [1121562206,1121744194,'Scorpio'],
  [1121744194,1121916265,'Sagittarius'],
  [1121916265,1122085960,'Capricorn'],
  [1122085960,1122261092,'Aquarius'],
  [1122261092,1122447540,'Pisces'],
  [1122447540,1122647134,'Aries'],
  [1122647134,1122857349,'Taurus'],
  [1122857349,1123073661,'Gemini'],
  [1123073661,1123292229,'Cancer'],
  [1123292229,1123509801,'Leo'],
  [1123509801,1123721936,'Virgo'],
  [1123721936,1123923366,'Libra'],
  [1123923366,1124111174,'Scorpio'],
  [1124111174,1124287265,'Sagittarius'],
  [1124287265,1124457554,'Capricorn'],
  [1124457554,1124629607,'Aquarius'],
  [1124629607,1124810536,'Pisces'],
  [1124810536,1125004791,'Aries'],
  [1125004791,1125212228,'Taurus'],
  [1125212228,1125428281,'Gemini'],
  [1125428281,1125646895,'Cancer'],
  [1125646895,1125863469,'Leo'],
  [1125863469,1126074789,'Virgo'],
  [1126074789,1126277932,'Libra'],
  [1126277932,1126470583,'Scorpio'],
  [1126470583,1126652753,'Sagittarius'],
  [1126652753,1126827698,'Capricorn'],
  [1126827698,1127001111,'Aquarius'],
  [1127001111,1127179599,'Pisces'],
  [1127179599,1127368907,'Aries'],
  [1127368907,1127571704,'Taurus'],
  [1127571704,1127785694,'Gemini'],
  [1127785694,1128004204,'Cancer'],
  [1128004204,1128220138,'Leo'],
  [1128220138,1128429293,'Virgo'],
  [1128429293,1128630402,'Libra'],
  [1128630402,1128823648,'Scorpio'],
  [1128823648,1129009817,'Sagittarius'],
  [1129009817,1129190590,'Capricorn'],
  [1129190590,1129369001,'Aquarius'],
  [1129369001,1129549460,'Pisces'],
  [1129549460,1129737054,'Aries'],
  [1129737054,1129935934,'Taurus'],
  [1129935934,1130146779,'Gemini'],
  [1130146779,1130364737,'Cancer'],
  [1130364737,1130581226,'Leo'],
  [1130581226,1130789350,'Virgo'],
  [1130789350,1130987221,'Libra'],
  [1130987221,1131176948,'Scorpio'],
  [1131176948,1131361960,'Sagittarius'],
  [1131361960,1131545160,'Capricorn'],
  [1131545160,1131728519,'Aquarius'],
  [1131728519,1131913838,'Pisces'],
  [1131913838,1132103752,'Aries'],
  [1132103752,1132301698,'Taurus'],
  [1132301698,1132510065,'Gemini'],
  [1132510065,1132727007,'Cancer'],
  [1132727007,1132944974,'Leo'],
  [1132944974,1133154721,'Virgo'],
  [1133154721,1133351636,'Libra'],
  [1133351636,1133537466,'Scorpio'],
  [1133537466,1133717551,'Sagittarius'],
  [1133717551,1133897526,'Capricorn'],
  [1133897526,1134081200,'Aquarius'],
  [1134081200,1134269970,'Pisces'],
  [1134269970,1134464054,'Aries'],
  [1134464054,1134664310,'Taurus'],
  [1134664310,1134872404,'Gemini'],
  [1134872404,1135088436,'Cancer'],
  [1135088436,1135307687,'Leo'],
  [1135307687,1135521022,'Virgo'],
  [1135521022,1135720881,'Libra'],
  [1135720881,1135906393,'Scorpio'],
  [1135906393,1136082573,'Sagittarius'],
  [1136082573,1136256675,'Capricorn'],
  [1136256675,1136435238,'Aquarius'],
  [1136435238,1136622103,'Pisces'],
  [1136622103,1136817807,'Aries'],
  [1136817807,1137021113,'Taurus'],
  [1137021113,1137231063,'Gemini'],
  [1137231063,1137447106,'Cancer'],
  [1137447106,1137666682,'Leo'],
  [1137666682,1137883142,'Virgo'],
  [1137883142,1138088288,'Libra'],
  [1138088288,1138278076,'Scorpio'],
  [1138278076,1138455022,'Sagittarius'],
  [1138455022,1138625854,'Capricorn'],
  [1138625854,1138798303,'Aquarius'],
  [1138798303,1138978850,'Pisces'],
  [1138978850,1139170922,'Aries'],
  [1139170922,1139374213,'Taurus'],
  [1139374213,1139585956,'Gemini'],
  [1139585956,1139802989,'Cancer'],
  [1139802989,1140022312,'Leo'],
  [1140022312,1140239583,'Virgo'],
  [1140239583,1140448737,'Libra'],
  [1140448737,1140644738,'Scorpio'],
  [1140644738,1140827015,'Sagittarius'],
  [1140827015,1140999812,'Capricorn'],
  [1140999812,1141170001,'Aquarius'],
  [1141170001,1141344877,'Pisces'],
  [1141344877,1141530387,'Aries'],
  [1141530387,1141729321,'Taurus'],
  [1141729321,1141940140,'Gemini'],
  [1141940140,1142157906,'Cancer'],
  [1142157906,1142377127,'Leo'],
  [1142377127,1142593368,'Virgo'],
  [1142593368,1142802970,'Libra'],
  [1142802970,1143002787,'Scorpio'],
  [1143002787,1143191304,'Sagittarius'],
  [1143191304,1143369952,'Capricorn'],
  [1143369952,1143543050,'Aquarius'],
  [1143543050,1143716720,'Pisces'],
  [1143716720,1143897492,'Aries'],
  [1143897492,1144090577,'Taurus'],
  [1144090577,1144297504,'Gemini'],
  [1144297504,1144514375,'Cancer'],
  [1144514375,1144733680,'Leo'],
  [1144733680,1144948754,'Virgo'],
  [1144948754,1145156273,'Libra'],
  [1145156273,1145355544,'Scorpio'],
  [1145355544,1145546838,'Sagittarius'],
  [1145546838,1145730963,'Capricorn'],
  [1145730963,1145909787,'Aquarius'],
  [1145909787,1146086846,'Pisces'],
  [1146086846,1146267308,'Aries'],
  [1146267308,1146456856,'Taurus'],
  [1146456856,1146659390,'Gemini'],
  [1146659390,1146873834,'Cancer'],
  [1146873834,1147093031,'Leo'],
  [1147093031,1147307974,'Virgo'],
  [1147307974,1147513499,'Libra'],
  [1147513499,1147709644,'Scorpio'],
  [1147709644,1147899080,'Sagittarius'],
  [1147899080,1148084453,'Capricorn'],
  [1148084453,1148267461,'Aquarius'],
  [1148267461,1148449585,'Pisces'],
  [1148449585,1148633467,'Aries'],
  [1148633467,1148823344,'Taurus'],
  [1148823344,1149023599,'Gemini'],
  [1149023599,1149235561,'Cancer'],
  [1149235561,1149454365,'Leo'],
  [1149454365,1149670399,'Virgo'],
  [1149670399,1149875933,'Libra'],
  [1149875933,1150069615,'Scorpio'],
  [1150069615,1150255058,'Sagittarius'],
  [1150255058,1150437201,'Capricorn'],
  [1150437201,1150619760,'Aquarius'],
  [1150619760,1150804533,'Pisces'],
  [1150804533,1150992497,'Aries'],
  [1150992497,1151185473,'Taurus'],
  [1151185473,1151386388,'Gemini'],
  [1151386388,1151597240,'Cancer'],
  [1151597240,1151815620,'Leo'],
  [1151815620,1152033414,'Virgo'],
  [1152033414,1152241346,'Libra'],
  [1152241346,1152435461,'Scorpio'],
  [1152435461,1152618337,'Sagittarius'],
  [1152618337,1152795855,'Capricorn'],
  [1152795855,1152973937,'Aquarius'],
  [1152973937,1153156641,'Pisces'],
  [1153156641,1153345716,'Aries'],
  [1153345716,1153541665,'Taurus'],
  [1153541665,1153745067,'Gemini'],
  [1153745067,1153956574,'Cancer'],
  [1153956574,1154174821,'Leo'],
  [1154174821,1154394092,'Virgo'],
  [1154394092,1154605711,'Libra'],
  [1154605711,1154803470,'Scorpio'],
  [1154803470,1154987427,'Sagittarius'],
  [1154987427,1155162573,'Capricorn'],
  [1155162573,1155335659,'Aquarius'],
  [1155335659,1155512906,'Pisces'],
  [1155512906,1155698565,'Aries'],
  [1155698565,1155894300,'Taurus'],
  [1155894300,1156099585,'Gemini'],
  [1156099585,1156312719,'Cancer'],
  [1156312719,1156531277,'Leo'],
  [1156531277,1156751043,'Virgo'],
  [1156751043,1156965577,'Libra'],
  [1156965577,1157168488,'Scorpio'],
  [1157168488,1157357200,'Sagittarius'],
  [1157357200,1157534225,'Capricorn'],
  [1157534225,1157705372,'Aquarius'],
  [1157705372,1157877555,'Pisces'],
  [1157877555,1158057179,'Aries'],
  [1158057179,1158248623,'Taurus'],
  [1158248623,1158452799,'Gemini'],
  [1158452799,1158666870,'Cancer'],
  [1158666870,1158886013,'Leo'],
  [1158886013,1159105393,'Virgo'],
  [1159105393,1159320502,'Libra'],
  [1159320502,1159527006,'Scorpio'],
  [1159527006,1159721706,'Sagittarius'],
  [1159721706,1159904370,'Capricorn'],
  [1159904370,1160078249,'Aquarius'],
  [1160078249,1160249146,'Pisces'],
  [1160249146,1160424021,'Aries'],
  [1160424021,1160609399,'Taurus'],
  [1160609399,1160809101,'Gemini'],
  [1160809101,1161021795,'Cancer'],
  [1161021795,1161241195,'Leo'],
  [1161241195,1161460067,'Virgo'],
  [1161460067,1161673752,'Libra'],
  [1161673752,1161880199,'Scorpio'],
  [1161880199,1162078196,'Sagittarius'],
  [1162078196,1162266906,'Capricorn'],
  [1162266906,1162446920,'Aquarius'],
  [1162446920,1162621347,'Pisces'],
  [1162621347,1162795799,'Aries'],
  [1162795799,1162977169,'Taurus'],
  [1162977169,1163171445,'Gemini'],
  [1163171445,1163380364,'Cancer'],
  [1163380364,1163598875,'Leo'],
  [1163598875,1163817750,'Virgo'],
  [1163817750,1164029983,'Libra'],
  [1164029983,1164233769,'Scorpio'],
  [1164233769,1164430362,'Sagittarius'],
  [1164430362,1164621063,'Capricorn'],
  [1164621063,1164806286,'Aquarius'],
  [1164806286,1164986770,'Pisces'],
  [1164986770,1165165337,'Aries'],
  [1165165337,1165347219,'Taurus'],
  [1165347219,1165538564,'Gemini'],
  [1165538564,1165743390,'Cancer'],
  [1165743390,1165959737,'Leo'],
  [1165959737,1166178956,'Virgo'],
  [1166178956,1166391482,'Libra'],
  [1166391482,1166593276,'Scorpio'],
  [1166593276,1166786039,'Sagittarius'],
  [1166786039,1166973550,'Capricorn'],
  [1166973550,1167158686,'Aquarius'],
  [1167158686,1167342695,'Pisces'],
  [1167342695,1167526551,'Aries'],
  [1167526551,1167712698,'Taurus'],
  [1167712698,1167905282,'Gemini'],
  [1167905282,1168108356,'Cancer'],
  [1168108356,1168322448,'Leo'],
  [1168322448,1168541738,'Virgo'],
  [1168541738,1168756347,'Libra'],
  [1168756347,1168959238,'Scorpio'],
  [1168959238,1169150029,'Sagittarius'],
  [1169150029,1169332923,'Capricorn'],
  [1169332923,1169513153,'Aquarius'],
  [1169513153,1169694745,'Pisces'],
  [1169694745,1169879931,'Aries'],
  [1169879931,1170069988,'Taurus'],
  [1170069988,1170266384,'Gemini'],
  [1170266384,1170470929,'Cancer'],
  [1170470929,1170684259,'Leo'],
  [1170684259,1170903213,'Virgo'],
  [1170903213,1171120189,'Libra'],
  [1171120189,1171326955,'Scorpio'],
  [1171326955,1171519944,'Sagittarius'],
  [1171519944,1171701389,'Capricorn'],
  [1171701389,1171876799,'Aquarius'],
  [1171876799,1172052338,'Pisces'],
  [1172052338,1172233147,'Aries'],
  [1172233147,1172422400,'Taurus'],
  [1172422400,1172621064,'Gemini'],
  [1172621064,1172828424,'Cancer'],
  [1172828424,1173042866,'Leo'],
  [1173042866,1173261612,'Virgo'],
  [1173261612,1173479749,'Libra'],
  [1173479749,1173690627,'Scorpio'],
  [1173690627,1173888884,'Sagittarius'],
  [1173888884,1174073600,'Capricorn'],
  [1174073600,1174248376,'Aquarius'],
  [1174248376,1174419481,'Pisces'],
  [1174419481,1174593893,'Aries'],
  [1174593893,1174777637,'Taurus'],
  [1174777637,1174973995,'Gemini'],
  [1174973995,1175182183,'Cancer'],
  [1175182183,1175398185,'Leo'],
  [1175398185,1175617241,'Virgo'],
  [1175617241,1175835188,'Libra'],
  [1175835188,1176047947,'Scorpio'],
  [1176047947,1176251136,'Sagittarius'],
  [1176251136,1176441855,'Capricorn'],
  [1176441855,1176620695,'Aquarius'],
  [1176620695,1176792065,'Pisces'],
  [1176792065,1176962857,'Aries'],
  [1176962857,1177140587,'Taurus'],
  [1177140587,1177331266,'Gemini'],
  [1177331266,1177536600,'Cancer'],
  [1177536600,1177752549,'Leo'],
  [1177752549,1177972018,'Virgo'],
  [1177972018,1178189277,'Libra'],
  [1178189277,1178401361,'Scorpio'],
  [1178401361,1178606278,'Sagittarius'],
  [1178606278,1178801816,'Capricorn'],
  [1178801816,1178986717,'Aquarius'],
  [1178986717,1179162591,'Pisces'],
  [1179162591,1179334481,'Aries'],
  [1179334481,1179509572,'Taurus'],
  [1179509572,1179695106,'Gemini'],
  [1179695106,1179895471,'Cancer'],
  [1179895471,1180109006,'Leo'],
  [1180109006,1180328231,'Virgo'],
  [1180328231,1180545077,'Libra'],
  [1180545077,1180755465,'Scorpio'],
  [1180755465,1180958815,'Sagittarius'],
  [1180958815,1181155200,'Capricorn'],
  [1181155200,1181344094,'Aquarius'],
  [1181344094,1181525555,'Pisces'],
  [1181525555,1181702066,'Aries'],
  [1181702066,1181878892,'Taurus'],
  [1181878892,1182062706,'Gemini'],
  [1182062706,1182259086,'Cancer'],
  [1182259086,1182469087,'Leo'],
  [1182469087,1182687151,'Virgo'],
  [1182687151,1182904144,'Libra'],
  [1182904144,1183113630,'Scorpio'],
  [1183113630,1183314361,'Sagittarius'],
  [1183314361,1183508029,'Capricorn'],
  [1183508029,1183696429,'Aquarius'],
  [1183696429,1183880594,'Pisces'],
  [1183880594,1184061846,'Aries'],
  [1184061846,1184243106,'Taurus'],
  [1184243106,1184428989,'Gemini'],
  [1184428989,1184624393,'Cancer'],
  [1184624393,1184831775,'Leo'],
  [1184831775,1185048274,'Virgo'],
  [1185048274,1185265866,'Libra'],
  [1185265866,1185476252,'Scorpio'],
  [1185476252,1185675891,'Sagittarius'],
  [1185675891,1185866169,'Capricorn'],
  [1185866169,1186050637,'Aquarius'],
  [1186050637,1186232756,'Pisces'],
  [1186232756,1186415160,'Aries'],
  [1186415160,1186600060,'Taurus'],
  [1186600060,1186789881,'Gemini'],
  [1186789881,1186987323,'Cancer'],
  [1186987323,1187194277,'Leo'],
  [1187194277,1187409662,'Virgo'],
  [1187409662,1187627932,'Libra'],
  [1187627932,1187840843,'Scorpio'],
  [1187840843,1188042320,'Sagittarius'],
  [1188042320,1188231597,'Capricorn'],
  [1188231597,1188412153,'Aquarius'],
  [1188412153,1188589249,'Pisces'],
  [1188589249,1188768050,'Aries'],
  [1188768050,1188952472,'Taurus'],
  [1188952472,1189144680,'Gemini'],
  [1189144680,1189345257,'Cancer'],
  [1189345257,1189553844,'Leo'],
  [1189553844,1189769150,'Virgo'],
  [1189769150,1189987781,'Libra'],
  [1189987781,1190203520,'Scorpio'],
  [1190203520,1190409318,'Sagittarius'],
  [1190409318,1190601464,'Capricorn'],
  [1190601464,1190781411,'Aquarius'],
  [1190781411,1190954446,'Pisces'],
  [1190954446,1191127441,'Aries'],
  [1191127441,1191306901,'Taurus'],
  [1191306901,1191497130,'Gemini'],
  [1191497130,1191698827,'Cancer'],
  [1191698827,1191909513,'Leo'],
  [1191909513,1192125734,'Virgo'],
  [1192125734,1192344348,'Libra'],
  [1192344348,1192561551,'Scorpio'],
  [1192561551,1192771789,'Sagittarius'],
  [1192771789,1192969679,'Capricorn'],
  [1192969679,1193153549,'Aquarius'],
  [1193153549,1193326724,'Pisces'],
  [1193326724,1193496008,'Aries'],
  [1193496008,1193669358,'Taurus'],
  [1193669358,1193853707,'Gemini'],
  [1193853707,1194052324,'Cancer'],
  [1194052324,1194263078,'Leo'],
  [1194263078,1194480326,'Virgo'],
  [1194480326,1194698909,'Libra'],
  [1194698909,1194915697,'Scorpio'],
  [1194915697,1195127702,'Sagittarius'],
  [1195127702,1195330703,'Capricorn'],
  [1195330703,1195521152,'Aquarius'],
  [1195521152,1195699241,'Pisces'],
  [1195699241,1195869744,'Aries'],
  [1195869744,1196040223,'Taurus'],
  [1196040223,1196218740,'Gemini'],
  [1196218740,1196411276,'Cancer'],
  [1196411276,1196618598,'Leo'],
  [1196618598,1196835409,'Virgo'],
  [1196835409,1197054161,'Libra'],
  [1197054161,1197269843,'Scorpio'],
  [1197269843,1197480471,'Sagittarius'],
  [1197480471,1197684489,'Capricorn'],
  [1197684489,1197879581,'Aquarius'],
  [1197879581,1198064310,'Pisces'],
  [1198064310,1198240457,'Aries'],
  [1198240457,1198413317,'Taurus'],
  [1198413317,1198590082,'Gemini'],
  [1198590082,1198777630,'Cancer'],
  [1198777630,1198979602,'Leo'],
  [1198979602,1199193673,'Virgo'],
  [1199193673,1199412270,'Libra'],
  [1199412270,1199627671,'Scorpio'],
  [1199627671,1199836173,'Sagittarius'],
  [1199836173,1200037435,'Capricorn'],
  [1200037435,1200231916,'Aquarius'],
  [1200231916,1200419770,'Pisces'],
  [1200419770,1200601736,'Aries'],
  [1200601736,1200780404,'Taurus'],
  [1200780404,1200960388,'Gemini'],
  [1200960388,1201147263,'Cancer'],
  [1201147263,1201345533,'Leo'],
  [1201345533,1201555905,'Virgo'],
  [1201555905,1201773460,'Libra'],
  [1201773460,1201989701,'Scorpio'],
  [1201989701,1202197951,'Sagittarius'],
  [1202197951,1202396364,'Capricorn'],
  [1202396364,1202586710,'Aquarius'],
  [1202586710,1202771969,'Pisces'],
  [1202771969,1202954885,'Aries'],
  [1202954885,1203137772,'Taurus'],
  [1203137772,1203322967,'Gemini'],
  [1203322967,1203513264,'Cancer'],
  [1203513264,1203711643,'Leo'],
  [1203711643,1203919812,'Virgo'],
  [1203919812,1204135889,'Libra'],
  [1204135889,1204353308,'Scorpio'],
  [1204353308,1204563758,'Sagittarius'],
  [1204563758,1204762348,'Capricorn'],
  [1204762348,1204949598,'Aquarius'],
  [1204949598,1205129785,'Pisces'],
  [1205129785,1205308347,'Aries'],
  [1205308347,1205489930,'Taurus'],
  [1205489930,1205677358,'Gemini'],
  [1205677358,1205871634,'Cancer'],
  [1205871634,1206072975,'Leo'],
  [1206072975,1206281610,'Virgo'],
  [1206281610,1206496872,'Libra'],
  [1206496872,1206715024,'Scorpio'],
  [1206715024,1206928738,'Sagittarius'],
  [1206928738,1207130835,'Capricorn'],
  [1207130835,1207318931,'Aquarius'],
  [1207318931,1207496295,'Pisces'],
  [1207496295,1207669485,'Aries'],
  [1207669485,1207845548,'Taurus'],
  [1207845548,1208029860,'Gemini'],
  [1208029860,1208224517,'Cancer'],
  [1208224517,1208428365,'Leo'],
  [1208428365,1208639054,'Virgo'],
  [1208639054,1208854699,'Libra'],
  [1208854699,1209073012,'Scorpio'],
  [1209073012,1209289116,'Sagittarius'],
  [1209289116,1209495955,'Capricorn'],
  [1209495955,1209688553,'Aquarius'],
  [1209688553,1209867535,'Pisces'],
  [1209867535,1210038572,'Aries'],
  [1210038572,1210209507,'Taurus'],
  [1210209507,1210387808,'Gemini'],
  [1210387808,1210578273,'Cancer'],
  [1210578273,1210781204,'Leo'],
  [1210781204,1210993111,'Virgo'],
  [1210993111,1211209740,'Libra'],
  [1211209740,1211427969,'Scorpio'],
  [1211427969,1211644601,'Sagittarius'],
  [1211644601,1211854637,'Capricorn'],
  [1211854637,1212052701,'Aquarius'],
  [1212052701,1212236818,'Pisces'],
  [1212236818,1212410245,'Aries'],
  [1212410245,1212579860,'Taurus'],
  [1212579860,1212753588,'Gemini'],
  [1212753588,1212938155,'Cancer'],
  [1212938155,1213136660,'Leo'],
  [1213136660,1213347137,'Virgo'],
  [1213347137,1213564129,'Libra'],
  [1213564129,1213782294,'Scorpio'],
  [1213782294,1213998052,'Sagittarius'],
  [1213998052,1214208307,'Capricorn'],
  [1214208307,1214409521,'Aquarius'],
  [1214409521,1214599158,'Pisces'],
  [1214599158,1214778028,'Aries'],
  [1214778028,1214950684,'Taurus'],
  [1214950684,1215123868,'Gemini'],
  [1215123868,1215304556,'Cancer'],
  [1215304556,1215497812,'Leo'],
  [1215497812,1215704490,'Virgo'],
  [1215704490,1215920366,'Libra'],
  [1215920366,1216138495,'Scorpio'],
  [1216138495,1216353223,'Sagittarius'],
  [1216353223,1216561554,'Capricorn'],
  [1216561554,1216762100,'Aquarius'],
  [1216762100,1216954135,'Pisces'],
  [1216954135,1217138023,'Aries'],
  [1217138023,1217316104,'Taurus'],
  [1217316104,1217492739,'Gemini'],
  [1217492739,1217673487,'Cancer'],
  [1217673487,1217863660,'Leo'],
  [1217863660,1218066263,'Virgo'],
  [1218066263,1218279774,'Libra'],
  [1218279774,1218497765,'Scorpio'],
  [1218497765,1218712411,'Sagittarius'],
  [1218712411,1218918869,'Capricorn'],
  [1218918869,1219116328,'Aquarius'],
  [1219116328,1219306414,'Pisces'],
  [1219306414,1219491399,'Aries'],
  [1219491399,1219673519,'Taurus'],
  [1219673519,1219855191,'Gemini'],
  [1219855191,1220039478,'Cancer'],
  [1220039478,1220230127,'Leo'],
  [1220230127,1220430571,'Virgo'],
  [1220430571,1220641672,'Libra'],
  [1220641672,1220859337,'Scorpio'],
  [1220859337,1221075229,'Sagittarius'],
  [1221075229,1221281850,'Capricorn'],
  [1221281850,1221476850,'Aquarius'],
  [1221476850,1221662776,'Pisces'],
  [1221662776,1221844315,'Aries'],
  [1221844315,1222025837,'Taurus'],
  [1222025837,1222210162,'Gemini'],
  [1222210162,1222398697,'Cancer'],
  [1222398697,1222592625,'Leo'],
  [1222592625,1222793783,'Virgo'],
  [1222793783,1223003731,'Libra'],
  [1223003731,1223220962,'Scorpio'],
  [1223220962,1223438827,'Sagittarius'],
  [1223438827,1223648258,'Capricorn'],
  [1223648258,1223843991,'Aquarius'],
  [1223843991,1224027318,'Pisces'],
  [1224027318,1224203913,'Aries'],
  [1224203913,1224380489,'Taurus'],
  [1224380489,1224562332,'Gemini'],
  [1224562332,1224751852,'Cancer'],
  [1224751852,1224948904,'Leo'],
  [1224948904,1225152752,'Virgo'],
  [1225152752,1225363403,'Libra'],
  [1225363403,1225580377,'Scorpio'],
  [1225580377,1225799702,'Sagittarius'],
  [1225799702,1226013227,'Capricorn'],
  [1226013227,1226213327,'Aquarius'],
  [1226213327,1226398324,'Pisces'],
  [1226398324,1226572747,'Aries'],
  [1226572747,1226744073,'Taurus'],
  [1226744073,1226919764,'Gemini'],
  [1226919764,1227105052,'Cancer'],
  [1227105052,1227301408,'Leo'],
  [1227301408,1227507115,'Virgo'],
  [1227507115,1227719594,'Libra'],
  [1227719594,1227936890,'Scorpio'],
  [1227936890,1228156419,'Sagittarius'],
  [1228156419,1228372679,'Capricorn'],
  [1228372679,1228578364,'Aquarius'],
  [1228578364,1228769069,'Pisces'],
  [1228769069,1228946376,'Aries'],
  [1228946376,1229116473,'Taurus'],
  [1229116473,1229287186,'Gemini'],
  [1229287186,1229465730,'Cancer'],
  [1229465730,1229656687,'Leo'],
  [1229656687,1229860455,'Virgo'],
  [1229860455,1230073705,'Libra'],
  [1230073705,1230291801,'Scorpio'],
  [1230291801,1230510841,'Sagittarius'],
  [1230510841,1230727034,'Capricorn'],
  [1230727034,1230935685,'Aquarius'],
  [1230935685,1231132494,'Pisces'],
  [1231132494,1231316374,'Aries'],
  [1231316374,1231490557,'Taurus'],
  [1231490557,1231661232,'Gemini'],
  [1231661232,1231835580,'Cancer'],
  [1231835580,1232020027,'Leo'],
  [1232020027,1232218236,'Virgo'],
  [1232218236,1232429219,'Libra'],
  [1232429219,1232647484,'Scorpio'],
  [1232647484,1232866326,'Sagittarius'],
  [1232866326,1233080906,'Capricorn'],
  [1233080906,1233288489,'Aquarius'],
  [1233288489,1233487390,'Pisces'],
  [1233487390,1233676800,'Aries'],
  [1233676800,1233857671,'Taurus'],
  [1233857671,1234033224,'Gemini'],
  [1234033224,1234208626,'Cancer'],
  [1234208626,1234389987,'Leo'],
  [1234389987,1234582744,'Virgo'],
  [1234582744,1234789176,'Libra'],
  [1234789176,1235005926,'Scorpio'],
  [1235005926,1235224952,'Sagittarius'],
  [1235224952,1235438599,'Capricorn'],
  [1235438599,1235643443,'Aquarius'],
  [1235643443,1235839890,'Pisces'],
  [1235839890,1236029732,'Aries'],
  [1236029732,1236214634,'Taurus'],
  [1236214634,1236396130,'Gemini'],
  [1236396130,1236576530,'Cancer'],
  [1236576530,1236759689,'Leo'],
  [1236759689,1236950564,'Virgo'],
  [1236950564,1237153183,'Libra'],
  [1237153183,1237367321,'Scorpio'],
  [1237367321,1237586383,'Sagittarius'],
  [1237586383,1237800752,'Capricorn'],
  [1237800752,1238004353,'Aquarius'],
  [1238004353,1238197262,'Pisces'],
  [1238197262,1238383304,'Aries'],
  [1238383304,1238566707,'Taurus'],
  [1238566707,1238750237,'Gemini'],
  [1238750237,1238935177,'Cancer'],
  [1238935177,1239122808,'Leo'],
  [1239122808,1239315765,'Virgo'],
  [1239315765,1239517534,'Libra'],
  [1239517534,1239729706,'Scorpio'],
  [1239729706,1239948488,'Sagittarius'],
  [1239948488,1240164732,'Capricorn'],
  [1240164732,1240369887,'Aquarius'],
  [1240369887,1240561692,'Pisces'],
  [1240561692,1240743861,'Aries'],
  [1240743861,1240922435,'Taurus'],
  [1240922435,1241102717,'Gemini'],
  [1241102717,1241287692,'Cancer'],
  [1241287692,1241478222,'Leo'],
  [1241478222,1241674708,'Virgo'],
  [1241674708,1241878362,'Libra'],
  [1241878362,1242090353,'Scorpio'],
  [1242090353,1242308861,'Sagittarius'],
  [1242308861,1242527001,'Capricorn'],
  [1242527001,1242735704,'Aquarius'],
  [1242735704,1242929973,'Pisces'],
  [1242929973,1243111510,'Aries'],
  [1243111510,1243286270,'Taurus'],
  [1243286270,1243461109,'Gemini'],
  [1243461109,1243641537,'Cancer'],
  [1243641537,1243830477,'Leo'],
  [1243830477,1244028374,'Virgo'],
  [1244028374,1244234451,'Libra'],
  [1244234451,1244447725,'Scorpio'],
  [1244447725,1244666299,'Sagittarius'],
  [1244666299,1244885419,'Capricorn'],
  [1244885419,1245097656,'Aquarius'],
  [1245097656,1245296738,'Pisces'],
  [1245296738,1245481598,'Aries'],
  [1245481598,1245656361,'Taurus'],
  [1245656361,1245827695,'Gemini'],
  [1245827695,1246002469,'Cancer'],
  [1246002469,1246186128,'Leo'],
  [1246186128,1246381410,'Virgo'],
  [1246381410,1246587824,'Libra'],
  [1246587824,1246802428,'Scorpio'],
  [1246802428,1247021403,'Sagittarius'],
  [1247021403,1247240408,'Capricorn'],
  [1247240408,1247454263,'Aquarius'],
  [1247454263,1247657798,'Pisces'],
  [1247657798,1247848267,'Aries'],
  [1247848267,1248027078,'Taurus'],
  [1248027078,1248199074,'Gemini'],
  [1248199074,1248370808,'Cancer'],
  [1248370808,1248548986,'Leo'],
  [1248548986,1248738880,'Virgo'],
  [1248738880,1248942394,'Libra'],
  [1248942394,1249156788,'Scorpio'],
  [1249156788,1249376122,'Sagittarius'],
  [1249376122,1249594478,'Capricorn'],
  [1249594478,1249807611,'Aquarius'],
  [1249807611,1250012688,'Pisces'],
  [1250012688,1250207757,'Aries'],
  [1250207757,1250392497,'Taurus'],
  [1250392497,1250569063,'Gemini'],
  [1250569063,1250742080,'Cancer'],
  [1250742080,1250917822,'Leo'],
  [1250917822,1251102789,'Virgo'],
  [1251102789,1251301484,'Libra'],
  [1251301484,1251513502,'Scorpio'],
  [1251513502,1251732617,'Sagittarius'],
  [1251732617,1251950563,'Capricorn'],
  [1251950563,1252161927,'Aquarius'],
  [1252161927,1252365284,'Pisces'],
  [1252365284,1252561080,'Aries'],
  [1252561080,1252749813,'Taurus'],
  [1252749813,1252932117,'Gemini'],
  [1252932117,1253109967,'Cancer'],
  [1253109967,1253287560,'Leo'],
  [1253287560,1253470825,'Virgo'],
  [1253470825,1253665528,'Libra'],
  [1253665528,1253873999,'Scorpio'],
  [1253873999,1254092018,'Sagittarius'],
  [1254092018,1254310246,'Capricorn'],
  [1254310246,1254520736,'Aquarius'],
  [1254520736,1254721294,'Pisces'],
  [1254721294,1254914067,'Aries'],
  [1254914067,1255102045,'Taurus'],
  [1255102045,1255287029,'Gemini'],
  [1255287029,1255469878,'Cancer'],
  [1255469878,1255652246,'Leo'],
  [1255652246,1255837808,'Virgo'],
  [1255837808,1256031586,'Libra'],
  [1256031586,1256237336,'Scorpio'],
  [1256237336,1256453710,'Sagittarius'],
  [1256453710,1256672711,'Capricorn'],
  [1256672711,1256884450,'Aquarius'],
  [1256884450,1257084111,'Pisces'],
  [1257084111,1257273340,'Aries'],
  [1257273340,1257456881,'Taurus'],
  [1257456881,1257639187,'Gemini'],
  [1257639187,1257822828,'Cancer'],
  [1257822828,1258008918,'Leo'],
  [1258008918,1258198795,'Virgo'],
  [1258198795,1258395021,'Libra'],
  [1258395021,1258600498,'Scorpio'],
  [1258600498,1258815603,'Sagittarius'],
  [1258815603,1259035198,'Capricorn'],
  [1259035198,1259249857,'Aquarius'],
  [1259249857,1259452087,'Pisces'],
  [1259452087,1259640920,'Aries'],
  [1259640920,1259820642,'Taurus'],
  [1259820642,1259997324,'Gemini'],
  [1259997324,1260176321,'Cancer'],
  [1260176321,1260361043,'Leo'],
  [1260361043,1260552981,'Virgo'],
  [1260552981,1260752626,'Libra'],
  [1260752626,1260960235,'Scorpio'],
  [1260960235,1261175385,'Sagittarius'],
  [1261175385,1261395010,'Capricorn'],
  [1261395010,1261612323,'Aquarius'],
  [1261612323,1261819440,'Pisces'],
  [1261819440,1262012286,'Aries'],
  [1262012286,1262192542,'Taurus'],
  [1262192542,1262365696,'Gemini'],
  [1262365696,1262538478,'Cancer'],
  [1262538478,1262717065,'Leo'],
  [1262717065,1262905713,'Virgo'],
  [1262905713,1263105741,'Libra'],
  [1263105741,1263315565,'Scorpio'],
  [1263315565,1263532038,'Sagittarius'],
  [1263532038,1263751541,'Capricorn'],
  [1263751541,1263969624,'Aquarius'],
  [1263969624,1264180697,'Pisces'],
  [1264180697,1264379744,'Aries'],
  [1264379744,1264565244,'Taurus'],
  [1264565244,1264740046,'Gemini'],
  [1264740046,1264910111,'Cancer'],
  [1264910111,1265082681,'Leo'],
  [1265082681,1265264590,'Virgo'],
  [1265264590,1265460202,'Libra'],
  [1265460202,1265669209,'Scorpio'],
  [1265669209,1265886702,'Sagittarius'],
  [1265886702,1266106431,'Capricorn'],
  [1266106431,1266323741,'Aquarius'],
  [1266323741,1266535503,'Pisces'],
  [1266535503,1266738681,'Aries'],
  [1266738681,1266930747,'Taurus'],
  [1266930747,1267111502,'Gemini'],
  [1267111502,1267284248,'Cancer'],
  [1267284248,1267455238,'Leo'],
  [1267455238,1267632008,'Virgo'],
  [1267632008,1267821272,'Libra'],
  [1267821272,1268025867,'Scorpio'],
  [1268025867,1268242196,'Sagittarius'],
  [1268242196,1268462123,'Capricorn'],
  [1268462123,1268678586,'Aquarius'],
  [1268678586,1268888611,'Pisces'],
  [1268888611,1269091611,'Aries'],
  [1269091611,1269286918,'Taurus'],
  [1269286918,1269473643,'Gemini'],
  [1269473643,1269652397,'Cancer'],
  [1269652397,1269826808,'Leo'],
  [1269826808,1270003147,'Virgo'],
  [1270003147,1270188505,'Libra'],
  [1270188505,1270387971,'Scorpio'],
  [1270387971,1270601009,'Sagittarius'],
  [1270601009,1270820336,'Capricorn'],
  [1270820336,1271036713,'Aquarius'],
  [1271036713,1271245070,'Pisces'],
  [1271245070,1271445284,'Aries'],
  [1271445284,1271639064,'Taurus'],
  [1271639064,1271827470,'Gemini'],
  [1271827470,1272010904,'Cancer'],
  [1272010904,1272190787,'Leo'],
  [1272190787,1272370843,'Virgo'],
  [1272370843,1272556628,'Libra'],
  [1272556628,1272753466,'Scorpio'],
  [1272753466,1272963144,'Sagittarius'],
  [1272963144,1273181091,'Capricorn'],
  [1273181091,1273398066,'Aquarius'],
  [1273398066,1273606510,'Pisces'],
  [1273606510,1273804567,'Aries'],
  [1273804567,1273994615,'Taurus'],
  [1273994615,1274180039,'Gemini'],
  [1274180039,1274363369,'Cancer'],
  [1274363369,1274546317,'Leo'],
  [1274546317,1274730903,'Virgo'],
  [1274730903,1274920213,'Libra'],
  [1274920213,1275117891,'Scorpio'],
  [1275117891,1275326095,'Sagittarius'],
  [1275326095,1275542703,'Capricorn'],
  [1275542703,1275760521,'Aquarius'],
  [1275760521,1275970984,'Pisces'],
  [1275970984,1276169578,'Aries'],
  [1276169578,1276357285,'Taurus'],
  [1276357285,1276538266,'Gemini'],
  [1276538266,1276717331,'Cancer'],
  [1276717331,1276898485,'Leo'],
  [1276898485,1277084509,'Virgo'],
  [1277084509,1277277206,'Libra'],
  [1277277206,1277477793,'Scorpio'],
  [1277477793,1277686819,'Sagittarius'],
  [1277686819,1277902917,'Capricorn'],
  [1277902917,1278121369,'Aquarius'],
  [1278121369,1278334761,'Pisces'],
  [1278334761,1278536710,'Aries'],
  [1278536710,1278725536,'Taurus'],
  [1278725536,1278904256,'Gemini'],
  [1278904256,1279078488,'Cancer'],
  [1279078488,1279254420,'Leo'],
  [1279254420,1279437258,'Virgo'],
  [1279437258,1279629979,'Libra'],
  [1279629979,1279832769,'Scorpio'],
  [1279832769,1280043782,'Sagittarius'],
  [1280043782,1280260356,'Capricorn'],
  [1280260356,1280478999,'Aquarius'],
  [1280478999,1280694633,'Pisces'],
  [1280694633,1280901138,'Aries'],
  [1280901138,1281094426,'Taurus'],
  [1281094426,1281274917,'Gemini'],
  [1281274917,1281447232,'Cancer'],
  [1281447232,1281618301,'Leo'],
  [1281618301,1281795365,'Virgo'],
  [1281795365,1281983962,'Libra'],
  [1281983962,1282185750,'Scorpio'],
  [1282185750,1282397889,'Sagittarius'],
  [1282397889,1282615385,'Capricorn'],
  [1282615385,1282833899,'Aquarius'],
  [1282833899,1283049997,'Pisces'],
  [1283049997,1283259666,'Aries'],
  [1283259666,1283458492,'Taurus'],
  [1283458492,1283644277,'Gemini'],
  [1283644277,1283819097,'Cancer'],
  [1283819097,1283988880,'Leo'],
  [1283988880,1284161403,'Virgo'],
  [1284161403,1284344124,'Libra'],
  [1284344124,1284541453,'Scorpio'],
  [1284541453,1284752125,'Sagittarius'],
  [1284752125,1284969966,'Capricorn'],
  [1284969966,1285188351,'Aquarius'],
  [1285188351,1285403437,'Pisces'],
  [1285403437,1285613196,'Aries'],
  [1285613196,1285815196,'Taurus'],
  [1285815196,1286006771,'Gemini'],
  [1286006771,1286187414,'Cancer'],
  [1286187414,1286360504,'Leo'],
  [1286360504,1286532597,'Virgo'],
  [1286532597,1286711406,'Libra'],
  [1286711406,1286903285,'Scorpio'],
  [1286903285,1287109932,'Sagittarius'],
  [1287109932,1287326582,'Capricorn'],
  [1287326582,1287544988,'Aquarius'],
  [1287544988,1287759010,'Pisces'],
  [1287759010,1287966601,'Aries'],
  [1287966601,1288167575,'Taurus'],
  [1288167575,1288361372,'Gemini'],
  [1288361372,1288547271,'Cancer'],
  [1288547271,1288726312,'Leo'],
  [1288726312,1288902422,'Virgo'],
  [1288902422,1289081703,'Libra'],
  [1289081703,1289270539,'Scorpio'],
  [1289270539,1289472778,'Sagittarius'],
  [1289472778,1289686727,'Capricorn'],
  [1289686727,1289905022,'Aquarius'],
  [1289905022,1290119263,'Pisces'],
  [1290119263,1290325113,'Aries'],
  [1290325113,1290522648,'Taurus'],
  [1290522648,1290713745,'Gemini'],
  [1290713745,1290900089,'Cancer'],
  [1290900089,1291083052,'Leo'],
  [1291083052,1291264662,'Virgo'],
  [1291264662,1291448289,'Libra'],
  [1291448289,1291638296,'Scorpio'],
  [1291638296,1291838508,'Sagittarius'],
  [1291838508,1292049680,'Capricorn'],
  [1292049680,1292267377,'Aquarius'],
  [1292267377,1292483205,'Pisces'],
  [1292483205,1292689959,'Aries'],
  [1292689959,1292885498,'Taurus'],
  [1292885498,1293072108,'Gemini'],
  [1293072108,1293253959,'Cancer'],
  [1293253959,1293435123,'Leo'],
  [1293435123,1293618672,'Virgo'],
  [1293618672,1293806676,'Libra'],
  [1293806676,1294000739,'Scorpio'],
  [1294000739,1294202412,'Sagittarius'],
  [1294202412,1294412557,'Capricorn'],
  [1294412557,1294629407,'Aquarius'],
  [1294629407,1294847042,'Pisces'],
  [1294847042,1295057281,'Aries'],
  [1295057281,1295254739,'Taurus'],
  [1295254739,1295439622,'Gemini'],
  [1295439622,1295616527,'Cancer'],
  [1295616527,1295791822,'Leo'],
  [1295791822,1295971418,'Virgo'],
  [1295971418,1296159144,'Libra'],
  [1296159144,1296355968,'Scorpio'],
  [1296355968,1296560797,'Sagittarius'],
  [1296560797,1296772204,'Capricorn'],
  [1296772204,1296988752,'Aquarius'],
  [1296988752,1297207250,'Pisces'],
  [1297207250,1297421325,'Aries'],
  [1297421325,1297623875,'Taurus'],
  [1297623875,1297811778,'Gemini'],
  [1297811778,1297987722,'Cancer'],
  [1297987722,1298158358,'Leo'],
  [1298158358,1298331477,'Virgo'],
  [1298331477,1298513733,'Libra'],
  [1298513733,1298708422,'Scorpio'],
  [1298708422,1298914369,'Sagittarius'],
  [1298914369,1299127712,'Capricorn'],
  [1299127712,1299344888,'Aquarius'],
  [1299344888,1299563298,'Pisces'],
  [1299563298,1299779206,'Aries'],
  [1299779206,1299986711,'Taurus'],
  [1299986711,1300180676,'Gemini'],
  [1300180676,1300360617,'Cancer'],
  [1300360617,1300531370,'Leo'],
  [1300531370,1300700684,'Virgo'],
  [1300700684,1300876635,'Libra'],
  [1300876635,1301065279,'Scorpio'],
  [1301065279,1301268100,'Sagittarius'],
  [1301268100,1301481419,'Capricorn'],
  [1301481419,1301699367,'Aquarius'],
  [1301699367,1301917491,'Pisces'],
  [1301917491,1302132930,'Aries'],
  [1302132930,1302342271,'Taurus'],
  [1302342271,1302541272,'Gemini'],
  [1302541272,1302727526,'Cancer'],
  [1302727526,1302902965,'Leo'],
  [1302902965,1303073467,'Virgo'],
  [1303073467,1303246663,'Libra'],
  [1303246663,1303429734,'Scorpio'],
  [1303429734,1303626918,'Sagittarius'],
  [1303626918,1303837219,'Capricorn'],
  [1303837219,1304054787,'Aquarius'],
  [1304054787,1304272808,'Pisces'],
  [1304272808,1304486934,'Aries'],
  [1304486934,1304694924,'Taurus'],
  [1304694924,1304894957,'Gemini'],
  [1304894957,1305085502,'Cancer'],
  [1305085502,1305266886,'Leo'],
  [1305266886,1305442355,'Virgo'],
  [1305442355,1305617504,'Libra'],
  [1305617504,1305798768,'Scorpio'],
  [1305798768,1305991468,'Sagittarius'],
  [1305991468,1306197398,'Capricorn'],
  [1306197398,1306413061,'Aquarius'],
  [1306413061,1306631034,'Pisces'],
  [1306631034,1306844507,'Aries'],
  [1306844507,1307050186,'Taurus'],
  [1307050186,1307247723,'Gemini'],
  [1307247723,1307438020,'Cancer'],
  [1307438020,1307622424,'Leo'],
  [1307622424,1307803006,'Virgo'],
  [1307803006,1307982956,'Libra'],
  [1307982956,1308166509,'Scorpio'],
  [1308166509,1308358152,'Sagittarius'],
  [1308358152,1308560933,'Capricorn'],
  [1308560933,1308774129,'Aquarius'],
  [1308774129,1308991947,'Pisces'],
  [1308991947,1309206105,'Aries'],
  [1309206105,1309410856,'Taurus'],
  [1309410856,1309605262,'Gemini'],
  [1309605262,1309791915,'Cancer'],
  [1309791915,1309974588,'Leo'],
  [1309974588,1310156643,'Virgo'],
  [1310156643,1310340560,'Libra'],
  [1310340560,1310528348,'Scorpio'],
  [1310528348,1310722223,'Sagittarius'],
  [1310722223,1310924519,'Capricorn'],
  [1310924519,1311136057,'Aquarius'],
  [1311136057,1311353638,'Pisces'],
  [1311353638,1311569590,'Aries'],
  [1311569590,1311775921,'Taurus'],
  [1311775921,1311969403,'Gemini'],
  [1311969403,1312152419,'Cancer'],
  [1312152419,1312330460,'Leo'],
  [1312330460,1312509296,'Virgo'],
  [1312509296,1312693060,'Libra'],
  [1312693060,1312883497,'Scorpio'],
  [1312883497,1313080743,'Sagittarius'],
  [1313080743,1313284904,'Capricorn'],
  [1313284904,1313496356,'Aquarius'],
  [1313496356,1313713763,'Pisces'],
  [1313713763,1313931660,'Aries'],
  [1313931660,1314141602,'Taurus'],
  [1314141602,1314337627,'Gemini'],
  [1314337627,1314520057,'Cancer'],
  [1314520057,1314694340,'Leo'],
  [1314694340,1314867806,'Virgo'],
  [1314867806,1315047024,'Libra'],
  [1315047024,1315235795,'Scorpio'],
  [1315235795,1315434363,'Sagittarius'],
  [1315434363,1315640876,'Capricorn'],
  [1315640876,1315853572,'Aquarius'],
  [1315853572,1316071035,'Pisces'],
  [1316071035,1316289946,'Aries'],
  [1316289946,1316503576,'Taurus'],
  [1316503576,1316704700,'Gemini'],
  [1316704700,1316890700,'Cancer'],
  [1316890700,1317065098,'Leo'],
  [1317065098,1317235075,'Virgo'],
  [1317235075,1317408520,'Libra'],
  [1317408520,1317591760,'Scorpio'],
  [1317591760,1317787488,'Sagittarius'],
  [1317787488,1317994227,'Capricorn'],
  [1317994227,1318208257,'Aquarius'],
  [1318208257,1318426105,'Pisces'],
  [1318426105,1318644791,'Aries'],
  [1318644791,1318859959,'Taurus'],
  [1318859959,1319065736,'Gemini'],
  [1319065736,1319257857,'Cancer'],
  [1319257857,1319436870,'Leo'],
  [1319436870,1319607953,'Virgo'],
  [1319607953,1319778526,'Libra'],
  [1319778526,1319956020,'Scorpio'],
  [1319956020,1320145812,'Sagittarius'],
  [1320145812,1320349178,'Capricorn'],
  [1320349178,1320562848,'Aquarius'],
  [1320562848,1320781156,'Pisces'],
  [1320781156,1320999155,'Aries'],
  [1320999155,1321213253,'Taurus'],
  [1321213253,1321420167,'Gemini'],
  [1321420167,1321616910,'Cancer'],
  [1321616910,1321802435,'Leo'],
  [1321802435,1321978999,'Virgo'],
  [1321978999,1322151737,'Libra'],
  [1322151737,1322327224,'Scorpio'],
  [1322327224,1322511832,'Sagittarius'],
  [1322511832,1322709687,'Capricorn'],
  [1322709687,1322920403,'Aquarius'],
  [1322920403,1323138465,'Pisces'],
  [1323138465,1323356331,'Aries'],
  [1323356331,1323568600,'Taurus'],
  [1323568600,1323773128,'Gemini'],
  [1323773128,1323969702,'Cancer'],
  [1323969702,1324158759,'Leo'],
  [1324158759,1324341400,'Virgo'],
  [1324341400,1324519981,'Libra'],
  [1324519981,1324698464,'Scorpio'],
  [1324698464,1324882043,'Sagittarius'],
  [1324882043,1325075826,'Capricorn'],
  [1325075826,1325282388,'Aquarius'],
  [1325282388,1325498930,'Pisces'],
  [1325498930,1325717357,'Aries'],
  [1325717357,1325929319,'Taurus'],
  [1325929319,1326131110,'Gemini'],
  [1326131110,1326323883,'Cancer'],
  [1326323883,1326510887,'Leo'],
  [1326510887,1326695101,'Virgo'],
  [1326695101,1326878429,'Libra'],
  [1326878429,1327062369,'Scorpio'],
  [1327062369,1327249316,'Sagittarius'],
  [1327249316,1327442983,'Capricorn'],
  [1327442983,1327646943,'Aquarius'],
  [1327646943,1327861394,'Pisces'],
  [1327861394,1328080409,'Aries'],
  [1328080409,1328294218,'Taurus'],
  [1328294218,1328496018,'Gemini'],
  [1328496018,1328685686,'Cancer'],
  [1328685686,1328867807,'Leo'],
  [1328867807,1329048037,'Virgo'],
  [1329048037,1329230591,'Libra'],
  [1329230591,1329417313,'Scorpio'],
  [1329417313,1329608631,'Sagittarius'],
  [1329608631,1329805480,'Capricorn'],
  [1329805480,1330009922,'Aquarius'],
  [1330009922,1330223231,'Pisces'],
  [1330223231,1330442392,'Aries'],
  [1330442392,1330658979,'Taurus'],
  [1330658979,1330864040,'Gemini'],
  [1330864040,1331054449,'Cancer'],
  [1331054449,1331233717,'Leo'],
  [1331233717,1331408572,'Virgo'],
  [1331408572,1331585667,'Libra'],
  [1331585667,1331769490,'Scorpio'],
  [1331769490,1331961530,'Sagittarius'],
  [1331961530,1332161306,'Capricorn'],
  [1332161306,1332368232,'Aquarius'],
  [1332368232,1332582118,'Pisces'],
  [1332582118,1332801217,'Aries'],
  [1332801217,1333019769,'Taurus'],
  [1333019769,1333229326,'Gemini'],
  [1333229326,1333424211,'Cancer'],
  [1333424211,1333605157,'Leo'],
  [1333605157,1333777846,'Virgo'],
  [1333777846,1333949650,'Libra'],
  [1333949650,1334127250,'Scorpio'],
  [1334127250,1334314968,'Sagittarius'],
  [1334314968,1334513875,'Capricorn'],
  [1334513875,1334722356,'Aquarius'],
  [1334722356,1334937700,'Pisces'],
  [1334937700,1335156965,'Aries'],
  [1335156965,1335375924,'Taurus'],
  [1335375924,1335588474,'Gemini'],
  [1335588474,1335788816,'Cancer'],
  [1335788816,1335975067,'Leo'],
  [1335975067,1336150320,'Virgo'],
  [1336150320,1336320785,'Libra'],
  [1336320785,1336493576,'Scorpio'],
  [1336493576,1336675031,'Sagittarius'],
  [1336675031,1336869112,'Capricorn'],
  [1336869112,1337075956,'Aquarius'],
  [1337075956,1337291856,'Pisces'],
  [1337291856,1337511457,'Aries'],
  [1337511457,1337729789,'Taurus'],
  [1337729789,1337942571,'Gemini'],
  [1337942571,1338146066,'Cancer'],
  [1338146066,1338337975,'Leo'],
  [1338337975,1338518915,'Virgo'],
  [1338518915,1338692589,'Libra'],
  [1338692589,1338864805,'Scorpio'],
  [1338864805,1339042171,'Sagittarius'],
  [1339042171,1339230576,'Capricorn'],
  [1339230576,1339433025,'Aquarius'],
  [1339433025,1339647403,'Pisces'],
  [1339647403,1339867017,'Aries'],
  [1339867017,1340084644,'Taurus'],
  [1340084644,1340295792,'Gemini'],
  [1340295792,1340498806,'Cancer'],
  [1340498806,1340693271,'Leo'],
  [1340693271,1340879428,'Virgo'],
  [1340879428,1341058732,'Libra'],
  [1341058732,1341234504,'Scorpio'],
  [1341234504,1341411937,'Sagittarius'],
  [1341411937,1341597119,'Capricorn'],
  [1341597119,1341794999,'Aquarius'],
  [1341794999,1342006241,'Pisces'],
  [1342006241,1342225162,'Aries'],
  [1342225162,1342442668,'Taurus'],
  [1342442668,1342652259,'Gemini'],
  [1342652259,1342852587,'Cancer'],
  [1342852587,1343045453,'Leo'],
  [1343045453,1343232984,'Virgo'],
  [1343232984,1343416553,'Libra'],
  [1343416553,1343597508,'Scorpio'],
  [1343597508,1343778577,'Sagittarius'],
  [1343778577,1343964335,'Capricorn'],
  [1343964335,1344159936,'Aquarius'],
  [1344159936,1344368141,'Pisces'],
  [1344368141,1344585804,'Aries'],
  [1344585804,1344803914,'Taurus'],
  [1344803914,1345013596,'Gemini'],
  [1345013596,1345211806,'Cancer'],
  [1345211806,1345401005,'Leo'],
  [1345401005,1345585566,'Virgo'],
  [1345585566,1345768936,'Libra'],
  [1345768936,1345952818,'Scorpio'],
  [1345952818,1346138296,'Sagittarius'],
  [1346138296,1346327515,'Capricorn'],
  [1346327515,1346524007,'Aquarius'],
  [1346524007,1346730882,'Pisces'],
  [1346730882,1346947338,'Aries'],
  [1346947338,1347166399,'Taurus'],
  [1347166399,1347378230,'Gemini'],
  [1347378230,1347577072,'Cancer'],
  [1347577072,1347763968,'Leo'],
  [1347763968,1347944052,'Virgo'],
  [1347944052,1348123012,'Libra'],
  [1348123012,1348304931,'Scorpio'],
  [1348304931,1348491762,'Sagittarius'],
  [1348491762,1348684367,'Capricorn'],
  [1348684367,1348883851,'Aquarius'],
  [1348883851,1349091638,'Pisces'],
  [1349091638,1349307605,'Aries'],
  [1349307605,1349527325,'Taurus'],
  [1349527325,1349742303,'Gemini'],
  [1349742303,1349944903,'Cancer'],
  [1349944903,1350133297,'Leo'],
  [1350133297,1350311304,'Virgo'],
  [1350311304,1350485280,'Libra'],
  [1350485280,1350661521,'Scorpio'],
  [1350661521,1350844683,'Sagittarius'],
  [1350844683,1351037042,'Capricorn'],
  [1351037042,1351238757,'Aquarius'],
  [1351238757,1351448746,'Pisces'],
  [1351448746,1351665263,'Aries'],
  [1351665263,1351885018,'Taurus'],
  [1351885018,1352102150,'Gemini'],
  [1352102150,1352309672,'Cancer'],
  [1352309672,1352503300,'Leo'],
  [1352503300,1352683901,'Virgo'],
  [1352683901,1352856430,'Libra'],
  [1352856430,1353027654,'Scorpio'],
  [1353027654,1353204350,'Sagittarius'],
  [1353204350,1353391744,'Capricorn'],
  [1353391744,1353591911,'Aquarius'],
  [1353591911,1353803025,'Pisces'],
  [1353803025,1354020697,'Aries'],
  [1354020697,1354240236,'Taurus'],
  [1354240236,1354457357,'Gemini'],
  [1354457357,1354667700,'Cancer'],
  [1354667700,1354867202,'Leo'],
  [1354867202,1355054115,'Virgo'],
  [1355054115,1355230358,'Libra'],
  [1355230358,1355401100,'Scorpio'],
  [1355401100,1355573336,'Sagittarius'],
  [1355573336,1355754225,'Capricorn'],
  [1355754225,1355948935,'Aquarius'],
  [1355948935,1356157890,'Pisces'],
  [1356157890,1356375897,'Aries'],
  [1356375897,1356595510,'Taurus'],
  [1356595510,1356811347,'Gemini'],
  [1356811347,1357020939,'Cancer'],
  [1357020939,1357222808,'Leo'],
  [1357222808,1357415457,'Virgo'],
  [1357415457,1357598399,'Libra'],
  [1357598399,1357773741,'Scorpio'],
  [1357773741,1357946636,'Sagittarius'],
  [1357946636,1358124130,'Capricorn'],
  [1358124130,1358313113,'Aquarius'],
  [1358313113,1358517186,'Pisces'],
  [1358517186,1358733399,'Aries'],
  [1358733399,1358953142,'Taurus'],
  [1358953142,1359168232,'Gemini'],
  [1359168232,1359375416,'Cancer'],
  [1359375416,1359575236,'Leo'],
  [1359575236,1359768783,'Virgo'],
  [1359768783,1359956237,'Libra'],
  [1359956237,1360137811,'Scorpio'],
  [1360137811,1360315719,'Sagittarius'],
  [1360315719,1360494895,'Capricorn'],
  [1360494895,1360681755,'Aquarius'],
  [1360681755,1360881524,'Pisces'],
  [1360881524,1361094450,'Aries'],
  [1361094450,1361313708,'Taurus'],
  [1361313708,1361529376,'Gemini'],
  [1361529376,1361735457,'Cancer'],
  [1361735457,1361931975,'Leo'],
  [1361931975,1362121988,'Virgo'],
  [1362121988,1362308335,'Libra'],
  [1362308335,1362492457,'Scorpio'],
  [1362492457,1362675366,'Sagittarius'],
  [1362675366,1362859345,'Capricorn'],
  [1362859345,1363048464,'Aquarius'],
  [1363048464,1363247235,'Pisces'],
  [1363247235,1363457614,'Aries'],
  [1363457614,1363675817,'Taurus'],
  [1363675817,1363892859,'Gemini'],
  [1363892859,1364100413,'Cancer'],
  [1364100413,1364295943,'Leo'],
  [1364295943,1364482157,'Virgo'],
  [1364482157,1364663721,'Libra'],
  [1364663721,1364844781,'Scorpio'],
  [1364844781,1365028077,'Sagittarius'],
  [1365028077,1365215403,'Capricorn'],
  [1365215403,1365408533,'Aquarius'],
  [1365408533,1365609527,'Pisces'],
  [1365609527,1365819654,'Aries'],
  [1365819654,1366037043,'Taurus'],
  [1366037043,1366255335,'Gemini'],
  [1366255335,1366466127,'Cancer'],
  [1366466127,1366664156,'Leo'],
  [1366664156,1366849813,'Virgo'],
  [1366849813,1367027494,'Libra'],
  [1367027494,1367203009,'Scorpio'],
  [1367203009,1367381747,'Sagittarius'],
  [1367381747,1367567596,'Capricorn'],
  [1367567596,1367762434,'Aquarius'],
  [1367762434,1367966295,'Pisces'],
  [1367966295,1368178064,'Aries'],
  [1368178064,1368395510,'Taurus'],
  [1368395510,1368614391,'Gemini'],
  [1368614391,1368828310,'Cancer'],
  [1368828310,1369031032,'Leo'],
  [1369031032,1369220092,'Virgo'],
  [1369220092,1369397787,'Libra'],
  [1369397787,1369569695,'Scorpio'],
  [1369569695,1369742662,'Sagittarius'],
  [1369742662,1369923086,'Capricorn'],
  [1369923086,1370115188,'Aquarius'],
  [1370115188,1370319460,'Pisces'],
  [1370319460,1370532872,'Aries'],
  [1370532872,1370751060,'Taurus'],
  [1370751060,1370969914,'Gemini'],
  [1370969914,1371185265,'Cancer'],
  [1371185265,1371392246,'Leo'],
  [1371392246,1371586890,'Virgo'],
  [1371586890,1371768669,'Libra'],
  [1371768669,1371941224,'Scorpio'],
  [1371941224,1372111138,'Sagittarius'],
  [1372111138,1372286017,'Capricorn'],
  [1372286017,1372472468,'Aquarius'],
  [1372472468,1372673487,'Pisces'],
  [1372673487,1372886537,'Aries'],
  [1372886537,1373105302,'Taurus'],
  [1373105302,1373323887,'Gemini'],
  [1373323887,1373538752,'Cancer'],
  [1373538752,1373747291,'Leo'],
  [1373747291,1373946492,'Virgo'],
  [1373946492,1374134190,'Libra'],
  [1374134190,1374311303,'Scorpio'],
  [1374311303,1374482542,'Sagittarius'],
  [1374482542,1374655087,'Capricorn'],
  [1374655087,1374836547,'Aquarius'],
  [1374836547,1375032324,'Pisces'],
  [1375032324,1375242403,'Aries'],
  [1375242403,1375460647,'Taurus'],
  [1375460647,1375679033,'Gemini'],
  [1375679033,1375892597,'Cancer'],
  [1375892597,1376099799,'Leo'],
  [1376099799,1376299923,'Virgo'],
  [1376299923,1376491710,'Libra'],
  [1376491710,1376674584,'Scorpio'],
  [1376674584,1376850672,'Sagittarius'],
  [1376850672,1377025191,'Capricorn'],
  [1377025191,1377205074,'Aquarius'],
  [1377205074,1377396679,'Pisces'],
  [1377396679,1377602572,'Aries'],
  [1377602572,1377818929,'Taurus'],
  [1377818929,1378037237,'Gemini'],
  [1378037237,1378250142,'Cancer'],
  [1378250142,1378455039,'Leo'],
  [1378455039,1378652623,'Virgo'],
  [1378652623,1378844056,'Libra'],
  [1378844056,1379029897,'Scorpio'],
  [1379029897,1379211129,'Sagittarius'],
  [1379211129,1379390540,'Capricorn'],
  [1379390540,1379572876,'Aquarius'],
  [1379572876,1379763589,'Pisces'],
  [1379763589,1379966395,'Aries'],
  [1379966395,1380180262,'Taurus'],
  [1380180262,1380398452,'Gemini'],
  [1380398452,1380612204,'Cancer'],
  [1380612204,1380816319,'Leo'],
  [1380816319,1381010736,'Virgo'],
  [1381010736,1381198245,'Libra'],
  [1381198245,1381382013,'Scorpio'],
  [1381382013,1381564561,'Sagittarius'],
  [1381564561,1381748045,'Capricorn'],
  [1381748045,1381934940,'Aquarius'],
  [1381934940,1382128247,'Pisces'],
  [1382128247,1382330705,'Aries'],
  [1382330705,1382542805,'Taurus'],
  [1382542805,1382760671,'Gemini'],
  [1382760671,1382976468,'Cancer'],
  [1382976468,1383182689,'Leo'],
  [1383182689,1383376591,'Virgo'],
  [1383376591,1383560403,'Libra'],
  [1383560403,1383738984,'Scorpio'],
  [1383738984,1383917585,'Sagittarius'],
  [1383917585,1384100400,'Capricorn'],
  [1384100400,1384289894,'Aquarius'],
  [1384289894,1384486964,'Pisces'],
  [1384486964,1384691715,'Aries'],
  [1384691715,1384903791,'Taurus'],
  [1384903791,1385121239,'Gemini'],
  [1385121239,1385338926,'Cancer'],
  [1385338926,1385549317,'Leo'],
  [1385549317,1385746722,'Virgo'],
  [1385746722,1385930696,'Libra'],
  [1385930696,1386105608,'Scorpio'],
  [1386105608,1386278245,'Sagittarius'],
  [1386278245,1386455490,'Capricorn'],
  [1386455490,1386642349,'Aquarius'],
  [1386642349,1386840359,'Pisces'],
  [1386840359,1387047698,'Aries'],
  [1387047698,1387261346,'Taurus'],
  [1387261346,1387478752,'Gemini'],
  [1387478752,1387696995,'Cancer'],
  [1387696995,1387910921,'Leo'],
  [1387910921,1388114100,'Virgo'],
  [1388114100,1388302872,'Libra'],
  [1388302872,1388478982,'Scorpio'],
  [1388478982,1388648643,'Sagittarius'],
  [1388648643,1388819886,'Capricorn'],
  [1388819886,1389000226,'Aquarius'],
  [1389000226,1389194151,'Pisces'],
  [1389194151,1389401006,'Aries'],
  [1389401006,1389616006,'Taurus'],
  [1389616006,1389833994,'Gemini'],
  [1389833994,1390051717,'Cancer'],
  [1390051717,1390266386,'Leo'],
  [1390266386,1390473661,'Virgo'],
  [1390473661,1390668925,'Libra'],
  [1390668925,1390850782,'Scorpio'],
  [1390850782,1391022856,'Sagittarius'],
  [1391022856,1391192300,'Capricorn'],
  [1391192300,1391367298,'Aquarius'],
  [1391367298,1391554676,'Pisces'],
  [1391554676,1391756983,'Aries'],
  [1391756983,1391970824,'Taurus'],
  [1391970824,1392189257,'Gemini'],
  [1392189257,1392406515,'Cancer'],
  [1392406515,1392619749,'Leo'],
  [1392619749,1392827035,'Virgo'],
  [1392827035,1393025771,'Libra'],
  [1393025771,1393213840,'Scorpio'],
  [1393213840,1393392054,'Sagittarius'],
  [1393392054,1393564953,'Capricorn'],
  [1393564953,1393739407,'Aquarius'],
  [1393739407,1393922536,'Pisces'],
  [1393922536,1394119193,'Aries'],
  [1394119193,1394329220,'Taurus'],
  [1394329220,1394546823,'Gemini'],
  [1394546823,1394764154,'Cancer'],
  [1394764154,1394976022,'Leo'],
  [1394976022,1395180726,'Virgo'],
  [1395180726,1395378113,'Libra'],
  [1395378113,1395568176,'Scorpio'],
  [1395568176,1395751472,'Sagittarius'],
  [1395751472,1395930225,'Capricorn'],
  [1395930225,1396108654,'Aquarius'],
  [1396108654,1396292191,'Pisces'],
  [1396292191,1396485850,'Aries'],
  [1396485850,1396691856,'Taurus'],
  [1396691856,1396907398,'Gemini'],
  [1396907398,1397125025,'Cancer'],
  [1397125025,1397337074,'Leo'],
  [1397337074,1397539787,'Virgo'],
  [1397539787,1397733523,'Libra'],
  [1397733523,1397920725,'Scorpio'],
  [1397920725,1398104169,'Sagittarius'],
  [1398104169,1398286362,'Capricorn'],
  [1398286362,1398469749,'Aquarius'],
  [1398469749,1398657139,'Pisces'],
  [1398657139,1398851704,'Aries'],
  [1398851704,1399055937,'Taurus'],
  [1399055937,1399269494,'Gemini'],
  [1399269494,1399487320,'Cancer'],
  [1399487320,1399701125,'Leo'],
  [1399701125,1399904416,'Virgo'],
  [1399904416,1400095880,'Libra'],
  [1400095880,1400278691,'Scorpio'],
  [1400278691,1400457957,'Sagittarius'],
  [1400457957,1400638489,'Capricorn'],
  [1400638489,1400823545,'Aquarius'],
  [1400823545,1401014638,'Pisces'],
  [1401014638,1401212424,'Aries'],
  [1401212424,1401417640,'Taurus'],
  [1401417640,1401630489,'Gemini'],
  [1401630489,1401848390,'Cancer'],
  [1401848390,1402064593,'Leo'],
  [1402064593,1402271032,'Virgo'],
  [1402271032,1402463622,'Libra'],
  [1402463622,1402644249,'Scorpio'],
  [1402644249,1402818796,'Sagittarius'],
  [1402818796,1402994181,'Capricorn'],
  [1402994181,1403176062,'Aquarius'],
  [1403176062,1403367224,'Pisces'],
  [1403367224,1403567380,'Aries'],
  [1403567380,1403774899,'Taurus'],
  [1403774899,1403988479,'Gemini'],
  [1403988479,1404206460,'Cancer'],
  [1404206460,1404424454,'Leo'],
  [1404424454,1404635032,'Virgo'],
  [1404635032,1404831903,'Libra'],
  [1404831903,1405014317,'Scorpio'],
  [1405014317,1405187106,'Sagittarius'],
  [1405187106,1405357808,'Capricorn'],
  [1405357808,1405533957,'Aquarius'],
  [1405533957,1405720879,'Pisces'],
  [1405720879,1405919894,'Aries'],
  [1405919894,1406128617,'Taurus'],
  [1406128617,1406343482,'Gemini'],
  [1406343482,1406561668,'Cancer'],
  [1406561668,1406780105,'Leo'],
  [1406780105,1406993536,'Virgo'],
  [1406993536,1407195646,'Libra'],
  [1407195646,1407383203,'Scorpio'],
  [1407383203,1407558543,'Sagittarius'],
  [1407558543,1407728146,'Capricorn'],
  [1407728146,1407899907,'Aquarius'],
  [1407899907,1408080917,'Pisces'],
  [1408080917,1408275213,'Aries'],
  [1408275213,1408482175,'Taurus'],
  [1408482175,1408697431,'Gemini'],
  [1408697431,1408915888,'Cancer'],
  [1408915888,1409133713,'Leo'],
  [1409133713,1409347354,'Virgo'],
  [1409347354,1409552552,'Libra'],
  [1409552552,1409745765,'Scorpio'],
  [1409745765,1409926846,'Sagittarius'],
  [1409926846,1410099794,'Capricorn'],
  [1410099794,1410271214,'Aquarius'],
  [1410271214,1410448324,'Pisces'],
  [1410448324,1410636990,'Aries'],
  [1410636990,1410839487,'Taurus'],
  [1410839487,1411053129,'Gemini'],
  [1411053129,1411271600,'Cancer'],
  [1411271600,1411488732,'Leo'],
  [1411488732,1411700648,'Virgo'],
  [1411700648,1411905164,'Libra'],
  [1411905164,1412100839,'Scorpio'],
  [1412100839,1412287292,'Sagittarius'],
  [1412287292,1412466226,'Capricorn'],
  [1412466226,1412641648,'Aquarius'],
  [1412641648,1412819144,'Pisces'],
  [1412819144,1413004600,'Aries'],
  [1413004600,1413202317,'Taurus'],
  [1413202317,1413412608,'Gemini'],
  [1413412608,1413630400,'Cancer'],
  [1413630400,1413847609,'Leo'],
  [1413847609,1414058012,'Virgo'],
  [1414058012,1414259532,'Libra'],
  [1414259532,1414453093,'Scorpio'],
  [1414453093,1414640579,'Sagittarius'],
  [1414640579,1414823866,'Capricorn'],
  [1414823866,1415004994,'Aquarius'],
  [1415004994,1415186807,'Pisces'],
  [1415186807,1415373256,'Aries'],
  [1415373256,1415568670,'Taurus'],
  [1415568670,1415775626,'Gemini'],
  [1415775626,1415991985,'Cancer'],
  [1415991985,1416210073,'Leo'],
  [1416210073,1416421049,'Virgo'],
  [1416421049,1416620595,'Libra'],
  [1416620595,1416810047,'Scorpio'],
  [1416810047,1416993725,'Sagittarius'],
  [1416993725,1417176013,'Capricorn'],
  [1417176013,1417359776,'Aquarius'],
  [1417359776,1417546365,'Pisces'],
  [1417546365,1417736955,'Aries'],
  [1417736955,1417933751,'Taurus'],
  [1417933751,1418139410,'Gemini'],
  [1418139410,1418354277,'Cancer'],
  [1418354277,1418573287,'Leo'],
  [1418573287,1418787014,'Virgo'],
  [1418787014,1418988038,'Libra'],
  [1418988038,1419175636,'Scorpio'],
  [1419175636,1419354588,'Sagittarius'],
  [1419354588,1419531529,'Capricorn'],
  [1419531529,1419712075,'Aquarius'],
  [1419712075,1419899143,'Pisces'],
  [1419899143,1420093025,'Aries'],
  [1420093025,1420293282,'Taurus'],
  [1420293282,1420500341,'Gemini'],
  [1420500341,1420714732,'Cancer'],
  [1420714732,1420934028,'Leo'],
  [1420934028,1421150876,'Virgo'],
  [1421150876,1421356430,'Libra'],
  [1421356430,1421546688,'Scorpio'],
  [1421546688,1421724519,'Sagittarius'],
  [1421724519,1421896799,'Capricorn'],
  [1421896799,1422071038,'Aquarius'],
  [1422071038,1422253049,'Pisces'],
  [1422253049,1422445347,'Aries'],
  [1422445347,1422647239,'Taurus'],
  [1422647239,1422856705,'Gemini'],
  [1422856705,1423072034,'Cancer'],
  [1423072034,1423291186,'Leo'],
  [1423291186,1423509489,'Virgo'],
  [1423509489,1423719621,'Libra'],
  [1423719621,1423915707,'Scorpio'],
  [1423915707,1424097408,'Sagittarius'],
  [1424097408,1424269683,'Capricorn'],
  [1424269683,1424439914,'Aquarius'],
  [1424439914,1424615440,'Pisces'],
  [1424615440,1424801701,'Aries'],
  [1424801701,1425000648,'Taurus'],
  [1425000648,1425210440,'Gemini'],
  [1425210440,1425427012,'Cancer'],
  [1425427012,1425646220,'Leo'],
  [1425646220,1425864075,'Virgo'],
  [1425864075,1426075901,'Libra'],
  [1426075901,1426276985,'Scorpio'],
  [1426276985,1426465093,'Sagittarius'],
  [1426465093,1426642160,'Capricorn'],
  [1426642160,1426813505,'Aquarius'],
  [1426813505,1426985983,'Pisces'],
  [1426985983,1427166310,'Aries'],
  [1427166310,1427359306,'Taurus'],
  [1427359306,1427565898,'Gemini'],
  [1427565898,1427782196,'Cancer'],
  [1427782196,1428001643,'Leo'],
  [1428001643,1428218465,'Virgo'],
  [1428218465,1428429018,'Libra'],
  [1428429018,1428631171,'Scorpio'],
  [1428631171,1428823722,'Sagittarius'],
  [1428823722,1429007007,'Capricorn'],
  [1429007007,1429183538,'Aquarius'],
  [1429183538,1429357953,'Pisces'],
  [1429357953,1429536247,'Aries'],
  [1429536247,1429724389,'Taurus'],
  [1429724389,1429926098,'Gemini'],
  [1429926098,1430140047,'Cancer'],
  [1430140047,1430359355,'Leo'],
  [1430359355,1430575735,'Virgo'],
  [1430575735,1430784211,'Libra'],
  [1430784211,1430984020,'Scorpio'],
  [1430984020,1431176442,'Sagittarius'],
  [1431176442,1431362932,'Capricorn'],
  [1431362932,1431544851,'Aquarius'],
  [1431544851,1431724288,'Pisces'],
  [1431724288,1431904951,'Aries'],
  [1431904951,1432091976,'Taurus'],
  [1432091976,1432290209,'Gemini'],
  [1432290209,1432501059,'Cancer'],
  [1432501059,1432719631,'Leo'],
  [1432719631,1432936522,'Virgo'],
  [1432936522,1433144238,'Libra'],
  [1433144238,1433341178,'Scorpio'],
  [1433341178,1433530169,'Sagittarius'],
  [1433530169,1433715061,'Capricorn'],
  [1433715061,1433898594,'Aquarius'],
  [1433898594,1434082185,'Pisces'],
  [1434082185,1434267287,'Aries'],
  [1434267287,1434456758,'Taurus'],
  [1434456758,1434654585,'Gemini'],
  [1434654585,1434863442,'Cancer'],
  [1434863442,1435081071,'Leo'],
  [1435081071,1435299155,'Virgo'],
  [1435299155,1435508293,'Libra'],
  [1435508293,1435704505,'Scorpio'],
  [1435704505,1435890169,'Sagittarius'],
  [1435890169,1436070664,'Capricorn'],
  [1436070664,1436251104,'Aquarius'],
  [1436251104,1436434627,'Pisces'],
  [1436434627,1436622485,'Aries'],
  [1436622485,1436815559,'Taurus'],
  [1436815559,1437015583,'Gemini'],
  [1437015583,1437224475,'Cancer'],
  [1437224475,1437441546,'Leo'],
  [1437441546,1437660859,'Virgo'],
  [1437660859,1437873075,'Libra'],
  [1437873075,1438071720,'Scorpio'],
  [1438071720,1438257005,'Sagittarius'],
  [1438257005,1438434027,'Capricorn'],
  [1438434027,1438609311,'Aquarius'],
  [1438609311,1438788411,'Pisces'],
  [1438788411,1438974645,'Aries'],
  [1438974645,1439169116,'Taurus'],
  [1439169116,1439371772,'Gemini'],
  [1439371772,1439582290,'Cancer'],
  [1439582290,1439799533,'Leo'],
  [1439799533,1440019490,'Virgo'],
  [1440019490,1440234793,'Libra'],
  [1440234793,1440438118,'Scorpio'],
  [1440438118,1440626875,'Sagittarius'],
  [1440626875,1440804117,'Capricorn'],
  [1440804117,1440976055,'Aquarius'],
  [1440976055,1441149530,'Pisces'],
  [1441149530,1441330341,'Aries'],
  [1441330341,1441521968,'Taurus'],
  [1441521968,1441724900,'Gemini'],
  [1441724900,1441937035,'Cancer'],
  [1441937035,1442155042,'Leo'],
  [1442155042,1442374941,'Virgo'],
  [1442374941,1442591600,'Libra'],
  [1442591600,1442799245,'Scorpio'],
  [1442799245,1442993853,'Sagittarius'],
  [1442993853,1443175561,'Capricorn'],
  [1443175561,1443348491,'Aquarius'],
  [1443348491,1443519022,'Pisces'],
  [1443519022,1443694130,'Aries'],
  [1443694130,1443879843,'Taurus'],
  [1443879843,1444079285,'Gemini'],
  [1444079285,1444291005,'Cancer'],
  [1444291005,1444509675,'Leo'],
  [1444509675,1444729263,'Virgo'],
  [1444729263,1444945185,'Libra'],
  [1444945185,1445154150,'Scorpio'],
  [1445154150,1445353424,'Sagittarius'],
  [1445353424,1445541578,'Capricorn'],
  [1445541578,1445719786,'Aquarius'],
  [1445719786,1445892173,'Pisces'],
  [1445892173,1446065049,'Aries'],
  [1446065049,1446245481,'Taurus'],
  [1446245481,1446439209,'Gemini'],
  [1446439209,1446647604,'Cancer'],
  [1446647604,1446865759,'Leo'],
  [1446865759,1447085284,'Virgo'],
  [1447085284,1447299754,'Libra'],
  [1447299754,1447506869,'Scorpio'],
  [1447506869,1447706531,'Sagittarius'],
  [1447706531,1447898667,'Capricorn'],
  [1447898667,1448083160,'Aquarius'],
  [1448083160,1448261270,'Pisces'],
  [1448261270,1448436851,'Aries'],
  [1448436851,1448616017,'Taurus'],
  [1448616017,1448805397,'Gemini'],
  [1448805397,1449009099,'Cancer'],
  [1449009099,1449225030,'Leo'],
  [1449225030,1449444630,'Virgo'],
  [1449444630,1449658739,'Libra'],
  [1449658739,1449863447,'Scorpio'],
  [1449863447,1450059892,'Sagittarius'],
  [1450059892,1450250712,'Capricorn'],
  [1450250712,1450437530,'Aquarius'],
  [1450437530,1450620904,'Pisces'],
  [1450620904,1450802097,'Aries'],
  [1450802097,1450984585,'Taurus'],
  [1450984585,1451173694,'Gemini'],
  [1451173694,1451374346,'Cancer'],
  [1451374346,1451587360,'Leo'],
  [1451587360,1451806643,'Virgo'],
  [1451806643,1452022040,'Libra'],
  [1452022040,1452226636,'Scorpio'],
  [1452226636,1452420165,'Sagittarius'],
  [1452420165,1452606492,'Capricorn'],
  [1452606492,1452789962,'Aquarius'],
  [1452789962,1452973379,'Pisces'],
  [1452973379,1453158075,'Aries'],
  [1453158075,1453345409,'Taurus'],
  [1453345409,1453537957,'Gemini'],
  [1453537957,1453739047,'Cancer'],
  [1453739047,1453950402,'Leo'],
  [1453950402,1454168932,'Virgo'],
  [1454168932,1454386277,'Libra'],
  [1454386277,1454593698,'Scorpio'],
  [1454593698,1454787849,'Sagittarius'],
  [1454787849,1454971302,'Capricorn'],
  [1454971302,1455149461,'Aquarius'],
  [1455149461,1455327763,'Pisces'],
  [1455327763,1455510186,'Aries'],
  [1455510186,1455698938,'Taurus'],
  [1455698938,1455895038,'Gemini'],
  [1455895038,1456099052,'Cancer'],
  [1456099052,1456311039,'Leo'],
  [1456311039,1456529059,'Virgo'],
  [1456529059,1456747647,'Libra'],
  [1456747647,1456959025,'Scorpio'],
  [1456959025,1457157449,'Sagittarius'],
  [1457157449,1457342490,'Capricorn'],
  [1457342490,1457518285,'Aquarius'],
  [1457518285,1457691112,'Pisces'],
  [1457691112,1457867365,'Aries'],
  [1457867365,1458052089,'Taurus'],
  [1458052089,1458247772,'Gemini'],
  [1458247772,1458453874,'Cancer'],
  [1458453874,1458667769,'Leo'],
  [1458667769,1458886083,'Virgo'],
  [1458886083,1459104800,'Libra'],
  [1459104800,1459318747,'Scorpio'],
  [1459318747,1459522403,'Sagittarius'],
  [1459522403,1459712741,'Capricorn'],
  [1459712741,1459891032,'Aquarius'],
  [1459891032,1460062292,'Pisces'],
  [1460062292,1460233517,'Aries'],
  [1460233517,1460411858,'Taurus'],
  [1460411858,1460602674,'Gemini'],
  [1460602674,1460807238,'Cancer'],
  [1460807238,1461021984,'Leo'],
  [1461021984,1461241017,'Virgo'],
  [1461241017,1461459313,'Libra'],
  [1461459313,1461673411,'Scorpio'],
  [1461673411,1461880034,'Sagittarius'],
  [1461880034,1462075992,'Capricorn'],
  [1462075992,1462260043,'Aquarius'],
  [1462260043,1462434497,'Pisces'],
  [1462434497,1462605061,'Aries'],
  [1462605061,1462779210,'Taurus'],
  [1462779210,1462964135,'Gemini'],
  [1462964135,1463163974,'Cancer'],
  [1463163974,1463376968,'Leo'],
  [1463376968,1463596116,'Virgo'],
  [1463596116,1463814061,'Libra'],
  [1463814061,1464026820,'Scorpio'],
  [1464026820,1464233020,'Sagittarius'],
  [1464233020,1464431472,'Capricorn'],
  [1464431472,1464620762,'Aquarius'],
  [1464620762,1464800931,'Pisces'],
  [1464800931,1464975146,'Aries'],
  [1464975146,1465149475,'Taurus'],
  [1465149475,1465331173,'Gemini'],
  [1465331173,1465526128,'Cancer'],
  [1465526128,1465735421,'Leo'],
  [1465735421,1465953454,'Virgo'],
  [1465953454,1466171328,'Libra'],
  [1466171328,1466382907,'Scorpio'],
  [1466382907,1466586763,'Sagittarius'],
  [1466586763,1466783743,'Capricorn'],
  [1466783743,1466974421,'Aquarius'],
  [1466974421,1467158897,'Pisces'],
  [1467158897,1467338398,'Aries'],
  [1467338398,1467516569,'Taurus'],
  [1467516569,1467699072,'Gemini'],
  [1467699072,1467891740,'Cancer'],
  [1467891740,1468097551,'Leo'],
  [1468097551,1468313610,'Virgo'],
  [1468313610,1468531631,'Libra'],
  [1468531631,1468743369,'Scorpio'],
  [1468743369,1468945474,'Sagittarius'],
  [1468945474,1469139114,'Capricorn'],
  [1469139114,1469327006,'Aquarius'],
  [1469327006,1469511384,'Pisces'],
  [1469511384,1469693892,'Aries'],
  [1469693892,1469876620,'Taurus'],
  [1469876620,1470062850,'Gemini'],
  [1470062850,1470256639,'Cancer'],
  [1470256639,1470461034,'Leo'],
  [1470461034,1470675324,'Virgo'],
  [1470675324,1470893540,'Libra'],
  [1470893540,1471107004,'Scorpio'],
  [1471107004,1471309779,'Sagittarius'],
  [1471309779,1471501368,'Capricorn'],
  [1471501368,1471685055,'Aquarius'],
  [1471685055,1471865287,'Pisces'],
  [1471865287,1472046041,'Aries'],
  [1472046041,1472230269,'Taurus'],
  [1472230269,1472420078,'Gemini'],
  [1472420078,1472617123,'Cancer'],
  [1472617123,1472822618,'Leo'],
  [1472822618,1473036280,'Virgo'],
  [1473036280,1473254585,'Libra'],
  [1473254585,1473470512,'Scorpio'],
  [1473470512,1473676644,'Sagittarius'],
  [1473676644,1473869622,'Capricorn'],
  [1473869622,1474051273,'Aquarius'],
  [1474051273,1474226716,'Pisces'],
  [1474226716,1474402122,'Aries'],
  [1474402122,1474582973,'Taurus'],
  [1474582973,1474772736,'Gemini'],
  [1474772736,1474972207,'Cancer'],
  [1474972207,1475180143,'Leo'],
  [1475180143,1475394561,'Virgo'],
  [1475394561,1475612845,'Libra'],
  [1475612845,1475830529,'Scorpio'],
  [1475830529,1476041083,'Sagittarius'],
  [1476041083,1476238900,'Capricorn'],
  [1476238900,1476422833,'Aquarius'],
  [1476422833,1476596657,'Pisces'],
  [1476596657,1476767146,'Aries'],
  [1476767146,1476941811,'Taurus'],
  [1476941811,1477126852,'Gemini'],
  [1477126852,1477324918,'Cancer'],
  [1477324918,1477534105,'Leo'],
  [1477534105,1477749929,'Virgo'],
  [1477749929,1477968322,'Libra'],
  [1477968322,1478186172,'Scorpio'],
  [1478186172,1478399487,'Sagittarius'],
  [1478399487,1478602972,'Capricorn'],
  [1478602972,1478792892,'Aquarius'],
  [1478792892,1478970029,'Pisces'],
  [1478970029,1479139772,'Aries'],
  [1479139772,1479309947,'Taurus'],
  [1479309947,1479488532,'Gemini'],
  [1479488532,1479681122,'Cancer'],
  [1479681122,1479888056,'Leo'],
  [1479888056,1480104226,'Virgo'],
  [1480104226,1480322977,'Libra'],
  [1480322977,1480539996,'Scorpio'],
  [1480539996,1480752985,'Sagittarius'],
  [1480752985,1480959165,'Capricorn'],
  [1480959165,1481154998,'Aquarius'],
  [1481154998,1481338749,'Pisces'],
  [1481338749,1481512842,'Aries'],
  [1481512842,1481683461,'Taurus'],
  [1481683461,1481858456,'Gemini'],
  [1481858456,1482045012,'Cancer'],
  [1482045012,1482246627,'Leo'],
  [1482246627,1482460579,'Virgo'],
  [1482460579,1482679348,'Libra'],
  [1482679348,1482895876,'Scorpio'],
  [1482895876,1483106904,'Sagittarius'],
  [1483106904,1483311554,'Capricorn'],
  [1483311554,1483508896,'Aquarius'],
  [1483508896,1483697716,'Pisces'],
  [1483697716,1483878335,'Aries'],
  [1483878335,1484054037,'Taurus'],
  [1484054037,1484230619,'Gemini'],
  [1484230619,1484414714,'Cancer'],
  [1484414714,1484611402,'Leo'],
  [1484611402,1484821261,'Virgo'],
  [1484821261,1485038890,'Libra'],
  [1485038890,1485255788,'Scorpio'],
  [1485255788,1485465847,'Sagittarius'],
  [1485465847,1485667456,'Capricorn'],
  [1485667456,1485861688,'Aquarius'],
  [1485861688,1486050083,'Pisces'],
  [1486050083,1486234015,'Aries'],
  [1486234015,1486415334,'Taurus'],
  [1486415334,1486597089,'Gemini'],
  [1486597089,1486783480,'Cancer'],
  [1486783480,1486978801,'Leo'],
  [1486978801,1487185353,'Virgo'],
  [1487185353,1487400978,'Libra'],
  [1487400978,1487618564,'Scorpio'],
  [1487618564,1487829863,'Sagittarius'],
  [1487829863,1488030462,'Capricorn'],
  [1488030462,1488220926,'Aquarius'],
  [1488220926,1488404778,'Pisces'],
  [1488404778,1488586189,'Aries'],
  [1488586189,1488768607,'Taurus'],
  [1488768607,1488954408,'Gemini'],
  [1488954408,1489145313,'Cancer'],
  [1489145313,1489343021,'Leo'],
  [1489343021,1489549063,'Virgo'],
  [1489549063,1489763176,'Libra'],
  [1489763176,1489981154,'Scorpio'],
  [1489981154,1490195135,'Sagittarius'],
  [1490195135,1490398037,'Capricorn'],
  [1490398037,1490587830,'Aquarius'],
  [1490587830,1490767729,'Pisces'],
  [1490767729,1490943700,'Aries'],
  [1490943700,1491121868,'Taurus'],
  [1491121868,1491306657,'Gemini'],
  [1491306657,1491499801,'Cancer'],
  [1491499801,1491700843,'Leo'],
  [1491700843,1491908810,'Virgo'],
  [1491908810,1492122892,'Libra'],
  [1492122892,1492340919,'Scorpio'],
  [1492340919,1492557360,'Sagittarius'],
  [1492557360,1492764579,'Capricorn'],
  [1492764579,1492957650,'Aquarius'],
  [1492957650,1493137500,'Pisces'],
  [1493137500,1493309859,'Aries'],
  [1493309859,1493482306,'Taurus'],
  [1493482306,1493661754,'Gemini'],
  [1493661754,1493852318,'Cancer'],
  [1493852318,1494054026,'Leo'],
  [1494054026,1494264017,'Virgo'],
  [1494264017,1494479214,'Libra'],
  [1494479214,1494697258,'Scorpio'],
  [1494697258,1494914740,'Sagittarius'],
  [1494914740,1495125734,'Capricorn'],
  [1495125734,1495324150,'Aquarius'],
  [1495324150,1495508053,'Pisces'],
  [1495508053,1495681143,'Aries'],
  [1495681143,1495850650,'Taurus'],
  [1495850650,1496024574,'Gemini'],
  [1496024574,1496209396,'Cancer'],
  [1496209396,1496407730,'Leo'],
  [1496407730,1496617386,'Virgo'],
  [1496617386,1496833488,'Libra'],
  [1496833488,1497051677,'Scorpio'],
  [1497051677,1497268788,'Sagittarius'],
  [1497268788,1497481067,'Capricorn'],
  [1497481067,1497683711,'Aquarius'],
  [1497683711,1497873389,'Pisces'],
  [1497873389,1498051099,'Aries'],
  [1498051099,1498222121,'Taurus'],
  [1498222121,1498393867,'Gemini'],
  [1498393867,1498573671,'Cancer'],
  [1498573671,1498766528,'Leo'],
  [1498766528,1498972882,'Virgo'],
  [1498972882,1499188370,'Libra'],
  [1499188370,1499406661,'Scorpio'],
  [1499406661,1499622883,'Sagittarius'],
  [1499622883,1499833979,'Capricorn'],
  [1499833979,1500037421,'Aquarius'],
  [1500037421,1500231017,'Pisces'],
  [1500231017,1500414427,'Aries'],
  [1500414427,1500590401,'Taurus'],
  [1500590401,1500764299,'Gemini'],
  [1500764299,1500942622,'Cancer'],
  [1500942622,1501131207,'Leo'],
  [1501131207,1501333006,'Virgo'],
  [1501333006,1501546134,'Libra'],
  [1501546134,1501764188,'Scorpio'],
  [1501764188,1501980001,'Sagittarius'],
  [1501980001,1502189162,'Capricorn'],
  [1502189162,1502390293,'Aquarius'],
  [1502390293,1502583617,'Pisces'],
  [1502583617,1502770002,'Aries'],
  [1502770002,1502951146,'Taurus'],
  [1502951146,1503130020,'Gemini'],
  [1503130020,1503310876,'Cancer'],
  [1503310876,1503498582,'Leo'],
  [1503498582,1503697116,'Virgo'],
  [1503697116,1503907250,'Libra'],
  [1503907250,1504124606,'Scorpio'],
  [1504124606,1504341020,'Sagittarius'],
  [1504341020,1504549526,'Capricorn'],
  [1504549526,1504747792,'Aquarius'],
  [1504747792,1504937550,'Pisces'],
  [1504937550,1505122179,'Aries'],
  [1505122179,1505304848,'Taurus'],
  [1505304848,1505487918,'Gemini'],
  [1505487918,1505673388,'Cancer'],
  [1505673388,1505863708,'Leo'],
  [1505863708,1506061888,'Virgo'],
  [1506061888,1506270012,'Libra'],
  [1506270012,1506486437,'Scorpio'],
  [1506486437,1506704235,'Sagittarius'],
  [1506704235,1506914473,'Capricorn'],
  [1506914473,1507112171,'Aquarius'],
  [1507112171,1507298463,'Pisces'],
  [1507298463,1507478347,'Aries'],
  [1507478347,1507657547,'Taurus'],
  [1507657547,1507840330,'Gemini'],
  [1507840330,1508028625,'Cancer'],
  [1508028625,1508222800,'Leo'],
  [1508222800,1508423367,'Virgo'],
  [1508423367,1508631529,'Libra'],
  [1508631529,1508847289,'Scorpio'],
  [1508847289,1509066375,'Sagittarius'],
  [1509066375,1509280133,'Capricorn'],
  [1509280133,1509480871,'Aquarius'],
  [1509480871,1509667131,'Pisces'],
  [1509667131,1509843467,'Aries'],
  [1509843467,1510017053,'Taurus'],
  [1510017053,1510194709,'Gemini'],
  [1510194709,1510380789,'Cancer'],
  [1510380789,1510576181,'Leo'],
  [1510576181,1510779545,'Virgo'],
  [1510779545,1510989543,'Libra'],
  [1510989543,1511205440,'Scorpio'],
  [1511205440,1511424951,'Sagittarius'],
  [1511424951,1511641844,'Capricorn'],
  [1511641844,1511847896,'Aquarius'],
  [1511847896,1512038555,'Pisces'],
  [1512038555,1512215859,'Aries'],
  [1512215859,1512386409,'Taurus'],
  [1512386409,1512558118,'Gemini'],
  [1512558118,1512737849,'Cancer'],
  [1512737849,1512929391,'Leo'],
  [1512929391,1513132484,'Virgo'],
  [1513132484,1513344133,'Libra'],
  [1513344133,1513561000,'Scorpio'],
  [1513561000,1513780278,'Sagittarius'],
  [1513780278,1513998001,'Capricorn'],
  [1513998001,1514208136,'Aquarius'],
  [1514208136,1514405199,'Pisces'],
  [1514405199,1514588095,'Aries'],
  [1514588095,1514760872,'Taurus'],
  [1514760872,1514930524,'Gemini'],
  [1514930524,1515104613,'Cancer'],
  [1515104613,1515289386,'Leo'],
  [1515289386,1515487794,'Virgo'],
  [1515487794,1515698286,'Libra'],
  [1515698286,1515915848,'Scorpio'],
  [1515915848,1516135031,'Sagittarius'],
  [1516135031,1516351639,'Capricorn'],
  [1516351639,1516562101,'Aquarius'],
  [1516562101,1516763029,'Pisces'],
  [1516763029,1516952471,'Aries'],
  [1516952471,1517131557,'Taurus'],
  [1517131557,1517304575,'Gemini'],
  [1517304575,1517477753,'Cancer'],
  [1517477753,1517657758,'Leo'],
  [1517657758,1517849956,'Virgo'],
  [1517849956,1518056098,'Libra'],
  [1518056098,1518272553,'Scorpio'],
  [1518272553,1518491893,'Sagittarius'],
  [1518491893,1518707377,'Capricorn'],
  [1518707377,1518915542,'Aquarius'],
  [1518915542,1519115563,'Pisces'],
  [1519115563,1519307608,'Aries'],
  [1519307608,1519492391,'Taurus'],
  [1519492391,1519671682,'Gemini'],
  [1519671682,1519848883,'Cancer'],
  [1519848883,1520029011,'Leo'],
  [1520029011,1520217693,'Virgo'],
  [1520217693,1520419057,'Libra'],
  [1520419057,1520632630,'Scorpio'],
  [1520632630,1520851784,'Sagittarius'],
  [1520851784,1521067387,'Capricorn'],
  [1521067387,1521273693,'Aquarius'],
  [1521273693,1521470310,'Pisces'],
  [1521470310,1521659910,'Aries'],
  [1521659910,1521845421,'Taurus'],
  [1521845421,1522028802,'Gemini'],
  [1522028802,1522211468,'Cancer'],
  [1522211468,1522395664,'Leo'],
  [1522395664,1522585197,'Virgo'],
  [1522585197,1522784390,'Libra'],
  [1522784390,1522995149,'Scorpio'],
  [1522995149,1523213576,'Sagittarius'],
  [1523213576,1523430414,'Capricorn'],
  [1523430414,1523637217,'Aquarius'],
  [1523637217,1523831695,'Pisces'],
  [1523831695,1524017130,'Aries'],
  [1524017130,1524198759,'Taurus'],
  [1524198759,1524380888,'Gemini'],
  [1524380888,1524565722,'Cancer'],
  [1524565722,1524754082,'Leo'],
  [1524754082,1524947202,'Virgo'],
  [1524947202,1525147548,'Libra'],
  [1525147548,1525357300,'Scorpio'],
  [1525357300,1525574977,'Sagittarius'],
  [1525574977,1525793343,'Capricorn'],
  [1525793343,1526002874,'Aquarius'],
  [1526002874,1526198487,'Pisces'],
  [1526198487,1526381937,'Aries'],
  [1526381937,1526559046,'Taurus'],
  [1526559046,1526736199,'Gemini'],
  [1526736199,1526918085,'Cancer'],
  [1526918085,1527106811,'Leo'],
  [1527106811,1527302678,'Virgo'],
  [1527302678,1527505779,'Libra'],
  [1527505779,1527716535,'Scorpio'],
  [1527716535,1527934026,'Sagittarius'],
  [1527934026,1528153414,'Capricorn'],
  [1528153414,1528366370,'Aquarius'],
  [1528366370,1528565995,'Pisces'],
  [1528565995,1528751337,'Aries'],
  [1528751337,1528926902,'Taurus'],
  [1528926902,1529099513,'Gemini'],
  [1529099513,1529275758,'Cancer'],
  [1529275758,1529460337,'Leo'],
  [1529460337,1529655195,'Virgo'],
  [1529655195,1529859803,'Libra'],
  [1529859803,1530072298,'Scorpio'],
  [1530072298,1530290264,'Sagittarius'],
  [1530290264,1530509853,'Capricorn'],
  [1530509853,1530725041,'Aquarius'],
  [1530725041,1530929384,'Pisces'],
  [1530929384,1531119707,'Aries'],
  [1531119707,1531297922,'Taurus'],
  [1531297922,1531469560,'Gemini'],
  [1531469560,1531641492,'Cancer'],
  [1531641492,1531820217,'Leo'],
  [1531820217,1532010348,'Virgo'],
  [1532010348,1532213195,'Libra'],
  [1532213195,1532426291,'Scorpio'],
  [1532426291,1532644923,'Sagittarius'],
  [1532644923,1532864168,'Capricorn'],
  [1532864168,1533079445,'Aquarius'],
  [1533079445,1533286500,'Pisces'],
  [1533286500,1533482147,'Aries'],
  [1533482147,1533665969,'Taurus'],
  [1533665969,1533840926,'Gemini'],
  [1533840926,1534012500,'Cancer'],
  [1534012500,1534187363,'Leo'],
  [1534187363,1534371897,'Virgo'],
  [1534371897,1534570148,'Libra'],
  [1534570148,1534781465,'Scorpio'],
  [1534781465,1535000189,'Sagittarius'],
  [1535000189,1535219077,'Capricorn'],
  [1535219077,1535432965,'Aquarius'],
  [1535432965,1535639463,'Pisces'],
  [1535639463,1535837496,'Aries'],
  [1535837496,1536026548,'Taurus'],
  [1536026548,1536207347,'Gemini'],
  [1536207347,1536382757,'Cancer'],
  [1536382757,1536557908,'Leo'],
  [1536557908,1536739259,'Virgo'],
  [1536739259,1536932660,'Libra'],
  [1536932660,1537140289,'Scorpio'],
  [1537140289,1537357954,'Sagittarius'],
  [1537357954,1537576850,'Capricorn'],
  [1537576850,1537789521,'Aquarius'],
  [1537789521,1537993475,'Pisces'],
  [1537993475,1538189786,'Aries'],
  [1538189786,1538380106,'Taurus'],
  [1538380106,1538565338,'Gemini'],
  [1538565338,1538746364,'Cancer'],
  [1538746364,1538925663,'Leo'],
  [1538925663,1539107946,'Virgo'],
  [1539107946,1539299031,'Libra'],
  [1539299031,1539503057,'Scorpio'],
  [1539503057,1539718695,'Sagittarius'],
  [1539718695,1539937897,'Capricorn'],
  [1539937897,1540150950,'Aquarius'],
  [1540150950,1540353159,'Pisces'],
  [1540353159,1540545833,'Aries'],
  [1540545833,1540732878,'Taurus'],
  [1540732878,1540917601,'Gemini'],
  [1540917601,1541101592,'Cancer'],
  [1541101592,1541285765,'Leo'],
  [1541285765,1541472200,'Virgo'],
  [1541472200,1541664715,'Libra'],
  [1541664715,1541867358,'Scorpio'],
  [1541867358,1542081048,'Sagittarius'],
  [1542081048,1542300429,'Capricorn'],
  [1542300429,1542515603,'Aquarius'],
  [1542515603,1542719029,'Pisces'],
  [1542719029,1542909932,'Aries'],
  [1542909932,1543092537,'Taurus'],
  [1543092537,1543272356,'Gemini'],
  [1543272356,1543453702,'Cancer'],
  [1543453702,1543638866,'Leo'],
  [1543638866,1543828936,'Virgo'],
  [1543828936,1544025171,'Libra'],
  [1544025171,1544229377,'Scorpio'],
  [1544229377,1544442480,'Sagittarius'],
  [1544442480,1544661672,'Capricorn'],
  [1544661672,1544879337,'Aquarius'],
  [1544879337,1545086808,'Pisces'],
  [1545086808,1545280118,'Aries'],
  [1545280118,1545461468,'Taurus'],
  [1545461468,1545636560,'Gemini'],
  [1545636560,1545811747,'Cancer'],
  [1545811747,1545992260,'Leo'],
  [1545992260,1546181229,'Virgo'],
  [1546181229,1546379558,'Libra'],
  [1546379558,1546586583,'Scorpio'],
  [1546586583,1546800872,'Sagittarius'],
  [1546800872,1547019891,'Capricorn'],
  [1547019891,1547238758,'Aquarius'],
  [1547238758,1547450544,'Pisces'],
  [1547450544,1547649503,'Aries'],
  [1547649503,1547834539,'Taurus'],
  [1547834539,1548009296,'Gemini'],
  [1548009296,1548180100,'Cancer'],
  [1548180100,1548353954,'Leo'],
  [1548353954,1548536941,'Virgo'],
  [1548536941,1548732521,'Libra'],
  [1548732521,1548940197,'Scorpio'],
  [1548940197,1549156115,'Sagittarius'],
  [1549156115,1549375485,'Capricorn'],
  [1549375485,1549594040,'Aquarius'],
  [1549594040,1549807611,'Pisces'],
  [1549807611,1550011724,'Aries'],
  [1550011724,1550203318,'Taurus'],
  [1550203318,1550382796,'Gemini'],
  [1550382796,1550554355,'Cancer'],
  [1550554355,1550724724,'Leo'],
  [1550724724,1550901406,'Virgo'],
  [1550901406,1551090693,'Libra'],
  [1551090693,1551294921,'Scorpio'],
  [1551294921,1551510578,'Sagittarius'],
  [1551510578,1551730452,'Capricorn'],
  [1551730452,1551948300,'Aquarius'],
  [1551948300,1552160890,'Pisces'],
  [1552160890,1552366398,'Aries'],
  [1552366398,1552562853,'Taurus'],
  [1552562853,1552748923,'Gemini'],
  [1552748923,1552925765,'Cancer'],
  [1552925765,1553097911,'Leo'],
  [1553097911,1553272289,'Virgo'],
  [1553272289,1553456272,'Libra'],
  [1553456272,1553654932,'Scorpio'],
  [1553654932,1553867581,'Sagittarius'],
  [1553867581,1554087069,'Capricorn'],
  [1554087069,1554304663,'Aquarius'],
  [1554304663,1554515531,'Pisces'],
  [1554515531,1554719037,'Aries'],
  [1554719037,1554915725,'Taurus'],
  [1554915725,1555105471,'Gemini'],
  [1555105471,1555288157,'Cancer'],
  [1555288157,1555465609,'Leo'],
  [1555465609,1555642491,'Virgo'],
  [1555642491,1555825285,'Libra'],
  [1555825285,1556019977,'Scorpio'],
  [1556019977,1556228615,'Sagittarius'],
  [1556228615,1556446500,'Capricorn'],
  [1556446500,1556664291,'Aquarius'],
  [1556664291,1556874592,'Pisces'],
  [1556874592,1557075578,'Aries'],
  [1557075578,1557269125,'Taurus'],
  [1557269125,1557457573,'Gemini'],
  [1557457573,1557642276,'Cancer'],
  [1557642276,1557824320,'Leo'],
  [1557824320,1558006051,'Virgo'],
  [1558006051,1558191626,'Libra'],
  [1558191626,1558385939,'Scorpio'],
  [1558385939,1558592045,'Sagittarius'],
  [1558592045,1558807986,'Capricorn'],
  [1558807986,1559026122,'Aquarius'],
  [1559026122,1559237603,'Pisces'],
  [1559237603,1559438067,'Aries'],
  [1559438067,1559628566,'Taurus'],
  [1559628566,1559812836,'Gemini'],
  [1559812836,1559994698,'Cancer'],
  [1559994698,1560176996,'Leo'],
  [1560176996,1560361862,'Virgo'],
  [1560361862,1560551481,'Libra'],
  [1560551481,1560748373,'Scorpio'],
  [1560748373,1560954541,'Sagittarius'],
  [1560954541,1561169351,'Capricorn'],
  [1561169351,1561387758,'Aquarius'],
  [1561387758,1561601604,'Pisces'],
  [1561601604,1561804333,'Aries'],
  [1561804333,1561994599,'Taurus'],
  [1561994599,1562175573,'Gemini'],
  [1562175573,1562352478,'Cancer'],
  [1562352478,1562530605,'Leo'],
  [1562530605,1562714111,'Virgo'],
  [1562714111,1562905437,'Libra'],
  [1562905437,1563105350,'Scorpio'],
  [1563105350,1563313487,'Sagittarius'],
  [1563313487,1563528480,'Capricorn'],
  [1563528480,1563746996,'Aquarius'],
  [1563746996,1563963115,'Pisces'],
  [1563963115,1564169950,'Aries'],
  [1564169950,1564363501,'Taurus'],
  [1564363501,1564544697,'Gemini'],
  [1564544697,1564718355,'Cancer'],
  [1564718355,1564891095,'Leo'],
  [1564891095,1565069451,'Virgo'],
  [1565069451,1565258141,'Libra'],
  [1565258141,1565458537,'Scorpio'],
  [1565458537,1565668581,'Sagittarius'],
  [1565668581,1565884662,'Capricorn'],
  [1565884662,1566103199,'Aquarius'],
  [1566103199,1566320304,'Pisces'],
  [1566320304,1566530854,'Aries'],
  [1566530854,1566729777,'Taurus'],
  [1566729777,1566915150,'Gemini'],
  [1566915150,1567089657,'Cancer'],
  [1567089657,1567259530,'Leo'],
  [1567259530,1567432449,'Virgo'],
  [1567432449,1567615457,'Libra'],
  [1567615457,1567812456,'Scorpio'],
  [1567812456,1568022130,'Sagittarius'],
  [1568022130,1568239085,'Capricorn'],
  [1568239085,1568457695,'Aquarius'],
  [1568457695,1568674315,'Pisces'],
  [1568674315,1568886082,'Aries'],
  [1568886082,1569089333,'Taurus'],
  [1569089333,1569280774,'Gemini'],
  [1569280774,1569460210,'Cancer'],
  [1569460210,1569631747,'Leo'],
  [1569631747,1569802494,'Virgo'],
  [1569802494,1569980398,'Libra'],
  [1569980398,1570171742,'Scorpio'],
  [1570171742,1570377955,'Sagittarius'],
  [1570377955,1570594260,'Capricorn'],
  [1570594260,1570812984,'Aquarius'],
  [1570812984,1571028609,'Pisces'],
  [1571028609,1571238953,'Aries'],
  [1571238953,1571442790,'Taurus'],
  [1571442790,1571638214,'Gemini'],
  [1571638214,1571823769,'Cancer'],
  [1571823769,1572000784,'Leo'],
  [1572000784,1572174098,'Virgo'],
  [1572174098,1572350724,'Libra'],
  [1572350724,1572537672,'Scorpio'],
  [1572537672,1572738956,'Sagittarius'],
  [1572738956,1572952615,'Capricorn'],
  [1572952615,1573171130,'Aquarius'],
  [1573171130,1573386508,'Pisces'],
  [1573386508,1573594849,'Aries'],
  [1573594849,1573795937,'Taurus'],
  [1573795937,1573990495,'Gemini'],
  [1573990495,1574178744,'Cancer'],
  [1574178744,1574361194,'Leo'],
  [1574361194,1574540140,'Virgo'],
  [1574540140,1574720062,'Libra'],
  [1574720062,1574906625,'Scorpio'],
  [1574906625,1575104570,'Sagittarius'],
  [1575104570,1575314790,'Capricorn'],
  [1575314790,1575532372,'Aquarius'],
  [1575532372,1575748664,'Pisces'],
  [1575748664,1575956866,'Aries'],
  [1575956866,1576155206,'Taurus'],
  [1576155206,1576345592,'Gemini'],
  [1576345592,1576531027,'Cancer'],
  [1576531027,1576714135,'Leo'],
  [1576714135,1576897078,'Virgo'],
  [1576897078,1577082158,'Libra'],
  [1577082158,1577272262,'Scorpio'],
  [1577272262,1577470505,'Sagittarius'],
  [1577470505,1577678677,'Capricorn'],
  [1577678677,1577894890,'Aquarius'],
  [1577894890,1578112524,'Pisces'],
  [1578112524,1578323184,'Aries'],
  [1578323184,1578521946,'Taurus'],
  [1578521946,1578709323,'Gemini'],
  [1578709323,1578889520,'Cancer'],
  [1578889520,1579067907,'Leo'],
  [1579067907,1579249162,'Virgo'],
  [1579249162,1579436256,'Libra'],
  [1579436256,1579630378,'Scorpio'],
  [1579630378,1579831776,'Sagittarius'],
  [1579831776,1580040557,'Capricorn'],
  [1580040557,1580255969,'Aquarius'],
  [1580255969,1580474380,'Pisces'],
  [1580474380,1580688608,'Aries'],
  [1580688608,1580891390,'Taurus'],
  [1580891390,1581080063,'Gemini'],
  [1581080063,1581257592,'Cancer'],
  [1581257592,1581430381,'Leo'],
  [1581430381,1581605575,'Virgo'],
  [1581605575,1581788923,'Libra'],
  [1581788923,1581983021,'Scorpio'],
  [1581983021,1582186914,'Sagittarius'],
  [1582186914,1582397946,'Capricorn'],
  [1582397946,1582613825,'Aquarius'],
  [1582613825,1582832283,'Pisces'],
  [1582832283,1583048881,'Aries'],
  [1583048881,1583256801,'Taurus'],
  [1583256801,1583450700,'Gemini'],
  [1583450700,1583630527,'Cancer'],
  [1583630527,1583801517,'Leo'],
  [1583801517,1583971488,'Virgo'],
  [1583971488,1584148261,'Libra'],
  [1584148261,1584337344,'Scorpio'],
  [1584337344,1584539699,'Sagittarius'],
  [1584539699,1584751817,'Capricorn'],
  [1584751817,1584968821,'Aquarius'],
  [1584968821,1585187174,'Pisces'],
  [1585187174,1585404009,'Aries'],
  [1585404009,1585614923,'Taurus'],
  [1585614923,1585814584,'Gemini'],
  [1585814584,1586000303,'Cancer'],
  [1586000303,1586174527,'Leo'],
  [1586174527,1586343805,'Virgo'],
  [1586343805,1586516190,'Libra'],
  [1586516190,1586698959,'Scorpio'],
  [1586698959,1586896054,'Sagittarius'],
  [1586896054,1587106057,'Capricorn'],
  [1587106057,1587323263,'Aquarius'],
  [1587323263,1587541670,'Pisces'],
  [1587541670,1587757519,'Aries'],
  [1587757519,1587968163,'Taurus'],
  [1587968163,1588170471,'Gemini'],
  [1588170471,1588361698,'Cancer'],
  [1588361698,1588541933,'Leo'],
  [1588541933,1588715119,'Virgo'],
  [1588715119,1588887800,'Libra'],
  [1588887800,1589067149,'Scorpio'],
  [1589067149,1589258794,'Sagittarius'],
  [1589258794,1589464311,'Capricorn'],
  [1589464311,1589679848,'Aquarius'],
  [1589679848,1589898192,'Pisces'],
  [1589898192,1590113216,'Aries'],
  [1590113216,1590321828,'Taurus'],
  [1590321828,1590522849,'Gemini'],
  [1590522849,1590715690,'Cancer'],
  [1590715690,1590900542,'Leo'],
  [1590900542,1591079378,'Virgo'],
  [1591079378,1591256237,'Libra'],
  [1591256237,1591436538,'Scorpio'],
  [1591436538,1591625694,'Sagittarius'],
  [1591625694,1591827087,'Capricorn'],
  [1591827087,1592039754,'Aquarius'],
  [1592039754,1592257646,'Pisces'],
  [1592257646,1592472798,'Aries'],
  [1592472798,1592679931,'Taurus'],
  [1592679931,1592877886,'Gemini'],
  [1592877886,1593068198,'Cancer'],
  [1593068198,1593253240,'Leo'],
  [1593253240,1593435399,'Virgo'],
  [1593435399,1593617158,'Libra'],
  [1593617158,1593801477,'Scorpio'],
  [1593801477,1593991883,'Sagittarius'],
  [1593991883,1594191660,'Capricorn'],
  [1594191660,1594401870,'Aquarius'],
  [1594401870,1594619035,'Pisces'],
  [1594619035,1594835321,'Aries'],
  [1594835321,1595043034,'Taurus'],
  [1595043034,1595239124,'Gemini'],
  [1595239124,1595425535,'Cancer'],
  [1595425535,1595606799,'Leo'],
  [1595606799,1595787557,'Virgo'],
  [1595787557,1595971130,'Libra'],
  [1595971130,1596159305,'Scorpio'],
  [1596159305,1596353198,'Sagittarius'],
  [1596353198,1596554224,'Capricorn'],
  [1596554224,1596763627,'Aquarius'],
  [1596763627,1596980171,'Pisces'],
  [1596980171,1597198008,'Aries'],
  [1597198008,1597408477,'Taurus'],
  [1597408477,1597605776,'Gemini'],
  [1597605776,1597790288,'Cancer'],
  [1597790288,1597967132,'Leo'],
  [1597967132,1598142997,'Virgo'],
  [1598142997,1598323601,'Libra'],
  [1598323601,1598512034,'Scorpio'],
  [1598512034,1598708571,'Sagittarius'],
  [1598708571,1598912286,'Capricorn'],
  [1598912286,1599122677,'Aquarius'],
  [1599122677,1599339068,'Pisces'],
  [1599339068,1599557993,'Aries'],
  [1599557993,1599772040,'Taurus'],
  [1599772040,1599973574,'Gemini'],
  [1599973574,1600160118,'Cancer'],
  [1600160118,1600335440,'Leo'],
  [1600335440,1600506732,'Virgo'],
  [1600506732,1600681585,'Libra'],
  [1600681585,1600865700,'Scorpio'],
  [1600865700,1601061099,'Sagittarius'],
  [1601061099,1601266267,'Capricorn'],
  [1601266267,1601478394,'Aquarius'],
  [1601478394,1601695228,'Pisces'],
  [1601695228,1601914294,'Aries'],
  [1601914294,1602130612,'Taurus'],
  [1602130612,1602337170,'Gemini'],
  [1602337170,1602529179,'Cancer'],
  [1602529179,1602707552,'Leo'],
  [1602707552,1602878094,'Virgo'],
  [1602878094,1603048610,'Libra'],
  [1603048610,1603226523,'Scorpio'],
  [1603226523,1603416716,'Sagittarius'],
  [1603416716,1603619789,'Capricorn'],
  [1603619789,1603832450,'Aquarius'],
  [1603832450,1604050021,'Pisces'],
  [1604050021,1604268656,'Aries'],
  [1604268656,1604484794,'Taurus'],
  [1604484794,1604693907,'Gemini'],
  [1604693907,1604891550,'Cancer'],
  [1604891550,1605076239,'Leo'],
  [1605076239,1605250910,'Virgo'],
  [1605250910,1605421699,'Libra'],
  [1605421699,1605595883,'Scorpio'],
  [1605595883,1605780005,'Sagittarius'],
  [1605780005,1605977754,'Capricorn'],
  [1605977754,1606188148,'Aquarius'],
  [1606188148,1606405824,'Pisces'],
  [1606405824,1606624272,'Aries'],
  [1606624272,1606838818,'Taurus'],
  [1606838818,1607046725,'Gemini'],
  [1607046725,1607246156,'Cancer'],
  [1607246156,1607436086,'Leo'],
  [1607436086,1607617320,'Virgo'],
  [1607617320,1607793073,'Libra'],
  [1607793073,1607968552,'Scorpio'],
  [1607968552,1608149864,'Sagittarius'],
  [1608149864,1608342379,'Capricorn'],
  [1608342379,1608548339,'Aquarius'],
  [1608548339,1608764563,'Pisces'],
  [1608764563,1608983284,'Aries'],
  [1608983284,1609196972,'Taurus'],
  [1609196972,1609402082,'Gemini'],
  [1609402082,1609598815,'Cancer'],
  [1609598815,1609788866,'Leo'],
  [1609788866,1609973939,'Virgo'],
  [1609973939,1610155666,'Libra'],
  [1610155666,1610336367,'Scorpio'],
  [1610336367,1610519746,'Sagittarius'],
  [1610519746,1610710548,'Capricorn'],
  [1610710548,1610912743,'Aquarius'],
  [1610912743,1611126372,'Pisces'],
  [1611126372,1611345284,'Aries'],
  [1611345284,1611559966,'Taurus'],
  [1611559966,1611763997,'Gemini'],
  [1611763997,1611957068,'Cancer'],
  [1611957068,1612142910,'Leo'],
  [1612142910,1612325984,'Virgo'],
  [1612325984,1612509421,'Libra'],
  [1612509421,1612694682,'Scorpio'],
  [1612694682,1612882826,'Sagittarius'],
  [1612882826,1613076038,'Capricorn'],
  [1613076038,1613277543,'Aquarius'],
  [1613277543,1613489183,'Pisces'],
  [1613489183,1613707835,'Aries'],
  [1613707835,1613924714,'Taurus'],
  [1613924714,1614130806,'Gemini'],
  [1614130806,1614323109,'Cancer'],
  [1614323109,1614505018,'Leo'],
  [1614505018,1614682777,'Virgo'],
  [1614682777,1614862224,'Libra'],
  [1614862224,1615046887,'Scorpio'],
  [1615046887,1615237720,'Sagittarius'],
  [1615237720,1615434669,'Capricorn'],
  [1615434669,1615638397,'Aquarius'],
  [1615638397,1615850009,'Pisces'],
  [1615850009,1616068308,'Aries'],
  [1616068308,1616287119,'Taurus'],
  [1616287119,1616497229,'Gemini'],
  [1616497229,1616692729,'Cancer'],
  [1616692729,1616874598,'Leo'],
  [1616874598,1617048721,'Virgo'],
  [1617048721,1617222352,'Libra'],
  [1617222352,1617401616,'Scorpio'],
  [1617401616,1617589948,'Sagittarius'],
  [1617589948,1617787809,'Capricorn'],
  [1617787809,1617994001,'Aquarius'],
  [1617994001,1618207160,'Pisces'],
  [1618207160,1618425578,'Aries'],
  [1618425578,1618645145,'Taurus'],
  [1618645145,1618858727,'Gemini'],
  [1618858727,1619059510,'Cancer'],
  [1619059510,1619245552,'Leo'],
  [1619245552,1619420523,'Virgo'],
  [1619420523,1619591154,'Libra'],
  [1619591154,1619764658,'Scorpio'],
  [1619764658,1619946955,'Sagittarius'],
  [1619946955,1620141207,'Capricorn'],
  [1620141207,1620347086,'Aquarius'],
  [1620347086,1620561513,'Pisces'],
  [1620561513,1620780494,'Aries'],
  [1620780494,1620999822,'Taurus'],
  [1620999822,1621214561,'Gemini'],
  [1621214561,1621419492,'Cancer'],
  [1621419492,1621611420,'Leo'],
  [1621611420,1621791237,'Virgo'],
  [1621791237,1621963514,'Libra'],
  [1621963514,1622134756,'Scorpio'],
  [1622134756,1622311767,'Sagittarius'],
  [1622311767,1622500115,'Capricorn'],
  [1622500115,1622702223,'Aquarius'],
  [1622702223,1622915864,'Pisces'],
  [1622915864,1623135182,'Aries'],
  [1623135182,1623353979,'Taurus'],
  [1623353979,1623567728,'Gemini'],
  [1623567728,1623773520,'Cancer'],
  [1623773520,1623969451,'Leo'],
  [1623969451,1624155150,'Virgo'],
  [1624155150,1624332580,'Libra'],
  [1624332580,1624506050,'Scorpio'],
  [1624506050,1624681523,'Sagittarius'],
  [1624681523,1624865368,'Capricorn'],
  [1624865368,1625062389,'Aquarius'],
  [1625062389,1625273013,'Pisces'],
  [1625273013,1625491763,'Aries'],
  [1625491763,1625710290,'Taurus'],
  [1625710290,1625922455,'Gemini'],
  [1625922455,1626126260,'Cancer'],
  [1626126260,1626322166,'Leo'],
  [1626322166,1626511042,'Virgo'],
  [1626511042,1626693830,'Libra'],
  [1626693830,1626872398,'Scorpio'],
  [1626872398,1627050464,'Sagittarius'],
  [1627050464,1627233453,'Capricorn'],
  [1627233453,1627426983,'Aquarius'],
  [1627426983,1627633935,'Pisces'],
  [1627633935,1627851159,'Aries'],
  [1627851159,1628069853,'Taurus'],
  [1628069853,1628281460,'Gemini'],
  [1628281460,1628482805,'Cancer'],
  [1628482805,1628675611,'Leo'],
  [1628675611,1628863134,'Virgo'],
  [1628863134,1629047758,'Libra'],
  [1629047758,1629230723,'Scorpio'],
  [1629230723,1629413507,'Sagittarius'],
  [1629413507,1629599240,'Capricorn'],
  [1629599240,1629792505,'Aquarius'],
  [1629792505,1629997141,'Pisces'],
  [1629997141,1630212584,'Aries'],
  [1630212584,1630431714,'Taurus'],
  [1630431714,1630644571,'Gemini'],
  [1630644571,1630845421,'Cancer'],
  [1630845421,1631035179,'Leo'],
  [1631035179,1631218487,'Virgo'],
  [1631218487,1631400171,'Libra'],
  [1631400171,1631583290,'Scorpio'],
  [1631583290,1631769172,'Sagittarius'],
  [1631769172,1631958954,'Capricorn'],
  [1631958954,1632154849,'Aquarius'],
  [1632154849,1632359621,'Pisces'],
  [1632359621,1632573989,'Aries'],
  [1632573989,1632793464,'Taurus'],
  [1632793464,1633008894,'Gemini'],
  [1633008894,1633212297,'Cancer'],
  [1633212297,1633402019,'Leo'],
  [1633402019,1633582059,'Virgo'],
  [1633582059,1633758569,'Libra'],
  [1633758569,1633937136,'Scorpio'],
  [1633937136,1634121354,'Sagittarius'],
  [1634121354,1634312745,'Capricorn'],
  [1634312745,1634511768,'Aquarius'],
  [1634511768,1634718704,'Pisces'],
  [1634718704,1634933306,'Aries'],
  [1634933306,1635152801,'Taurus'],
  [1635152801,1635370551,'Gemini'],
  [1635370551,1635578497,'Cancer'],
  [1635578497,1635772171,'Leo'],
  [1635772171,1635953008,'Virgo'],
  [1635953008,1636126458,'Libra'],
  [1636126458,1636299271,'Scorpio'],
  [1636299271,1636477611,'Sagittarius'],
  [1636477611,1636665688,'Capricorn'],
  [1636665688,1636864883,'Aquarius'],
  [1636864883,1637073866,'Pisces'],
  [1637073866,1637289790,'Aries'],
  [1637289790,1637509203,'Taurus'],
  [1637509203,1637727587,'Gemini'],
  [1637727587,1637939185,'Cancer'],
  [1637939185,1638138830,'Leo'],
  [1638138830,1638324908,'Virgo'],
  [1638324908,1638500225,'Libra'],
  [1638500225,1638670641,'Scorpio'],
  [1638670641,1638843255,'Sagittarius'],
  [1638843255,1639024777,'Capricorn'],
  [1639024777,1639219594,'Aquarius'],
  [1639219594,1639427711,'Pisces'],
  [1639427711,1639644634,'Aries'],
  [1639644634,1639864276,'Taurus'],
  [1639864276,1640081808,'Gemini'],
  [1640081808,1640293878,'Cancer'],
  [1640293878,1640497439,'Leo'],
  [1640497439,1640690041,'Virgo'],
  [1640690041,1640871482,'Libra'],
  [1640871482,1641044855,'Scorpio'],
  [1641044855,1641216121,'Sagittarius'],
  [1641216121,1641392622,'Capricorn'],
  [1641392622,1641581100,'Aquarius'],
  [1641581100,1641784758,'Pisces'],
  [1641784758,1642000530,'Aries'],
  [1642000530,1642220451,'Taurus'],
  [1642220451,1642437133,'Gemini'],
  [1642437133,1642647256,'Cancer'],
  [1642647256,1642850289,'Leo'],
  [1642850289,1643045887,'Virgo'],
  [1643045887,1643233352,'Libra'],
  [1643233352,1643413063,'Scorpio'],
  [1643413063,1643588151,'Sagittarius'],
  [1643588151,1643764505,'Capricorn'],
  [1643764505,1643949159,'Aquarius'],
  [1643949159,1644147585,'Pisces'],
  [1644147585,1644359946,'Aries'],
  [1644359946,1644579345,'Taurus'],
  [1644579345,1644796142,'Gemini'],
  [1644796142,1645004631,'Cancer'],
  [1645004631,1645204571,'Leo'],
  [1645204571,1645398086,'Virgo'],
  [1645398086,1645586747,'Libra'],
  [1645586747,1645771044,'Scorpio'],
  [1645771044,1645951923,'Sagittarius'],
  [1645951923,1646132489,'Capricorn'],
  [1646132489,1646317988,'Aquarius'],
  [1646317988,1646513943,'Pisces'],
  [1646513943,1646722835,'Aries'],
  [1646722835,1646940767,'Taurus'],
  [1646940767,1647158394,'Gemini'],
  [1647158394,1647367376,'Cancer'],
  [1647367376,1647565349,'Leo'],
  [1647565349,1647754851,'Virgo'],
  [1647754851,1647939805,'Libra'],
  [1647939805,1648123184,'Scorpio'],
  [1648123184,1648306682,'Sagittarius'],
  [1648306682,1648491870,'Capricorn'],
  [1648491870,1648681358,'Aquarius'],
  [1648681358,1648878651,'Pisces'],
  [1648878651,1649086279,'Aries'],
  [1649086279,1649302777,'Taurus'],
  [1649302777,1649521249,'Gemini'],
  [1649521249,1649732682,'Cancer'],
  [1649732682,1649931856,'Leo'],
  [1649931856,1650119470,'Virgo'],
  [1650119470,1650299883,'Libra'],
  [1650299883,1650478274,'Scorpio'],
  [1650478274,1650658947,'Sagittarius'],
  [1650658947,1650844769,'Capricorn'],
  [1650844769,1651037423,'Aquarius'],
  [1651037423,1651237942,'Pisces'],
  [1651237942,1651446830,'Aries'],
  [1651446830,1651662944,'Taurus'],
  [1651662944,1651881877,'Gemini'],
  [1651881877,1652096265,'Cancer'],
  [1652096265,1652299347,'Leo'],
  [1652299347,1652488950,'Virgo'],
  [1652488950,1652667829,'Libra'],
  [1652667829,1652841577,'Scorpio'],
  [1652841577,1653016513,'Sagittarius'],
  [1653016513,1653198129,'Capricorn'],
  [1653198129,1653389820,'Aquarius'],
  [1653389820,1653592105,'Pisces'],
  [1653592105,1653803133,'Aries'],
  [1653803133,1654019987,'Taurus'],
  [1654019987,1654239022,'Gemini'],
  [1654239022,1654455290,'Cancer'],
  [1654455290,1654662836,'Leo'],
  [1654662836,1654857409,'Virgo'],
  [1654857409,1655038986,'Libra'],
  [1655038986,1655211730,'Scorpio'],
  [1655211730,1655382302,'Sagittarius'],
  [1655382302,1655557968,'Capricorn'],
  [1655557968,1655744719,'Aquarius'],
  [1655744719,1655945059,'Pisces'],
  [1655945059,1656156747,'Aries'],
  [1656156747,1656374587,'Taurus'],
  [1656374587,1656593587,'Gemini'],
  [1656593587,1656810004,'Cancer'],
  [1656810004,1657020126,'Leo'],
  [1657020126,1657219914,'Virgo'],
  [1657219914,1657407081,'Libra'],
  [1657407081,1657583128,'Scorpio'],
  [1657583128,1657753362,'Sagittarius'],
  [1657753362,1657925224,'Capricorn'],
  [1657925224,1658106264,'Aquarius'],
  [1658106264,1658301623,'Pisces'],
  [1658301623,1658511108,'Aries'],
  [1658511108,1658728952,'Taurus'],
  [1658728952,1658947912,'Gemini'],
  [1658947912,1659163358,'Cancer'],
  [1659163358,1659373162,'Leo'],
  [1659373162,1659575390,'Virgo'],
  [1659575390,1659767783,'Libra'],
  [1659767783,1659949638,'Scorpio'],
  [1659949638,1660123699,'Sagittarius'],
  [1660123699,1660295957,'Capricorn'],
  [1660295957,1660473908,'Aquarius'],
  [1660473908,1660664197,'Pisces'],
  [1660664197,1660869387,'Aries'],
  [1660869387,1661085546,'Taurus'],
  [1661085546,1661304369,'Gemini'],
  [1661304369,1661518951,'Cancer'],
  [1661518951,1661726721,'Leo'],
  [1661726721,1661927625,'Virgo'],
  [1661927625,1662121548,'Libra'],
  [1662121548,1662307973,'Scorpio'],
  [1662307973,1662487685,'Sagittarius'],
  [1662487685,1662664157,'Capricorn'],
  [1662664157,1662843182,'Aquarius'],
  [1662843182,1663031154,'Pisces'],
  [1663031154,1663232323,'Aries'],
  [1663232323,1663445621,'Taurus'],
  [1663445621,1663664008,'Gemini'],
  [1663664008,1663878790,'Cancer'],
  [1663878790,1664085121,'Leo'],
  [1664085121,1664282881,'Virgo'],
  [1664282881,1664474055,'Libra'],
  [1664474055,1664660478,'Scorpio'],
  [1664660478,1664843514,'Sagittarius'],
  [1664843514,1665025066,'Capricorn'],
  [1665025066,1665208407,'Aquarius'],
  [1665208407,1665397910,'Pisces'],
  [1665397910,1665597545,'Aries'],
  [1665597545,1665808284,'Taurus'],
  [1665808284,1666025887,'Gemini'],
  [1666025887,1666242014,'Cancer'],
  [1666242014,1666449289,'Leo'],
  [1666449289,1666645378,'Virgo'],
  [1666645378,1666832440,'Libra'],
  [1666832440,1667014535,'Scorpio'],
  [1667014535,1667195630,'Sagittarius'],
  [1667195630,1667378773,'Capricorn'],
  [1667378773,1667566164,'Aquarius'],
  [1667566164,1667759637,'Pisces'],
  [1667759637,1667960905,'Aries'],
  [1667960905,1668170838,'Taurus'],
  [1668170838,1668387603,'Gemini'],
  [1668387603,1668605320,'Cancer'],
  [1668605320,1668815924,'Leo'],
  [1668815924,1669014013,'Virgo'],
  [1669014013,1669199622,'Libra'],
  [1669199622,1669377067,'Scorpio'],
  [1669377067,1669552477,'Sagittarius'],
  [1669552477,1669731683,'Capricorn'],
  [1669731683,1669918676,'Aquarius'],
  [1669918676,1670114776,'Pisces'],
  [1670114776,1670319177,'Aries'],
  [1670319177,1670530430,'Taurus'],
  [1670530430,1670746903,'Gemini'],
  [1670746903,1670965356,'Cancer'],
  [1670965356,1671179648,'Leo'],
  [1671179648,1671382845,'Virgo'],
  [1671382845,1671571661,'Libra'],
  [1671571661,1671748373,'Scorpio'],
  [1671748373,1671919276,'Sagittarius'],
  [1671919276,1672092052,'Capricorn'],
  [1672092052,1672273524,'Aquarius'],
  [1672273524,1672467410,'Pisces'],
  [1672467410,1672672909,'Aries'],
  [1672672909,1672886141,'Taurus'],
  [1672886141,1673103241,'Gemini'],
  [1673103241,1673321467,'Cancer'],
  [1673321467,1673537388,'Leo'],
  [1673537388,1673745501,'Virgo'],
  [1673745501,1673940612,'Libra'],
  [1673940612,1674121682,'Scorpio'],
  [1674121682,1674292990,'Sagittarius'],
  [1674292990,1674462080,'Capricorn'],
  [1674462080,1674637175,'Aquarius'],
  [1674637175,1674824799,'Pisces'],
  [1674824799,1675026975,'Aries'],
  [1675026975,1675240157,'Taurus'],
  [1675240157,1675458107,'Gemini'],
  [1675458107,1675675999,'Cancer'],
  [1675675999,1675891166,'Leo'],
  [1675891166,1676100768,'Virgo'],
  [1676100768,1676300850,'Libra'],
  [1676300850,1676488575,'Scorpio'],
  [1676488575,1676665106,'Sagittarius'],
  [1676665106,1676835856,'Capricorn'],
  [1676835856,1677008457,'Aquarius'],
  [1677008457,1677190453,'Pisces'],
  [1677190453,1677386673,'Aries'],
  [1677386673,1677596540,'Taurus'],
  [1677596540,1677814086,'Gemini'],
  [1677814086,1678032015,'Cancer'],
  [1678032015,1678245808,'Leo'],
  [1678245808,1678453620,'Virgo'],
  [1678453620,1678654123,'Libra'],
  [1678654123,1678845824,'Scorpio'],
  [1678845824,1679028520,'Sagittarius'],
  [1679028520,1679204830,'Capricorn'],
  [1679204830,1679380052,'Aquarius'],
  [1679380052,1679560712,'Pisces'],
  [1679560712,1679752511,'Aries'],
  [1679752511,1679957719,'Taurus'],
  [1679957719,1680173109,'Gemini'],
  [1680173109,1680391101,'Cancer'],
  [1680391101,1680604536,'Leo'],
  [1680604536,1680810050,'Virgo'],
  [1680810050,1681007527,'Libra'],
  [1681007527,1681198101,'Scorpio'],
  [1681198101,1681383127,'Sagittarius'],
  [1681383127,1681564435,'Capricorn'],
  [1681564435,1681744911,'Aquarius'],
  [1681744911,1681928587,'Pisces'],
  [1681928587,1682119927,'Aries'],
  [1682119927,1682322153,'Taurus'],
  [1682322153,1682534882,'Gemini'],
  [1682534882,1682752634,'Cancer'],
  [1682752634,1682967102,'Leo'],
  [1682967102,1683172217,'Virgo'],
  [1683172217,1683366748,'Libra'],
  [1683366748,1683553209,'Scorpio'],
  [1683553209,1683735517,'Sagittarius'],
  [1683735517,1683917295,'Capricorn'],
  [1683917295,1684101234,'Aquarius'],
  [1684101234,1684289324,'Pisces'],
  [1684289324,1684483507,'Aries'],
  [1684483507,1684685809,'Taurus'],
  [1684685809,1684897031,'Gemini'],
  [1684897031,1685114394,'Cancer'],
  [1685114394,1685330724,'Leo'],
  [1685330724,1685537978,'Virgo'],
  [1685537978,1685732329,'Libra'],
  [1685732329,1685915575,'Scorpio'],
  [1685915575,1686093025,'Sagittarius'],
  [1686093025,1686270717,'Capricorn'],
  [1686270717,1686453381,'Aquarius'],
  [1686453381,1686643343,'Pisces'],
  [1686643343,1686840807,'Aries'],
  [1686840807,1687045374,'Taurus'],
  [1687045374,1687256891,'Gemini'],
  [1687256891,1687474069,'Cancer'],
  [1687474069,1687692113,'Leo'],
  [1687692113,1687903065,'Virgo'],
  [1687903065,1688100576,'Libra'],
  [1688100576,1688284091,'Scorpio'],
  [1688284091,1688458449,'Sagittarius'],
  [1688458449,1688630910,'Capricorn'],
  [1688630910,1688808466,'Aquarius'],
  [1688808466,1688995743,'Pisces'],
  [1688995743,1689193680,'Aries'],
  [1689193680,1689400343,'Taurus'],
  [1689400343,1689613309,'Gemini'],
  [1689613309,1689830704,'Cancer'],
  [1689830704,1690049525,'Leo'],
  [1690049525,1690263756,'Virgo'],
  [1690263756,1690466311,'Libra'],
  [1690466311,1690653881,'Scorpio'],
  [1690653881,1690829171,'Sagittarius'],
  [1690829171,1690998978,'Capricorn'],
  [1690998978,1691171253,'Aquarius'],
  [1691171253,1691352818,'Pisces'],
  [1691352818,1691547162,'Aries'],
  [1691547162,1691753306,'Taurus'],
  [1691753306,1691967332,'Gemini'],
  [1691967332,1692185225,'Cancer'],
  [1692185225,1692403842,'Leo'],
  [1692403842,1692619215,'Virgo'],
  [1692619215,1692825846,'Libra'],
  [1692825846,1693019259,'Scorpio'],
  [1693019259,1693199387,'Sagittarius'],
  [1693199387,1693370939,'Capricorn'],
  [1693370939,1693541189,'Aquarius'],
  [1693541189,1693717703,'Pisces'],
  [1693717703,1693906237,'Aries'],
  [1693906237,1694108558,'Taurus'],
  [1694108558,1694321684,'Gemini'],
  [1694321684,1694539869,'Cancer'],
  [1694539869,1694757939,'Leo'],
  [1694757939,1694972262,'Virgo'],
  [1694972262,1695179643,'Libra'],
  [1695179643,1695377070,'Scorpio'],
  [1695377070,1695563271,'Sagittarius'],
  [1695563271,1695740268,'Capricorn'],
  [1695740268,1695913084,'Aquarius'],
  [1695913084,1696088286,'Pisces'],
  [1696088286,1696272294,'Aries'],
  [1696272294,1696469340,'Taurus'],
  [1696469340,1696679267,'Gemini'],
  [1696679267,1696896880,'Cancer'],
  [1696896880,1697114786,'Leo'],
  [1697114786,1697327487,'Virgo'],
  [1697327487,1697532584,'Libra'],
  [1697532584,1697729621,'Scorpio'],
  [1697729621,1697918908,'Sagittarius'],
  [1697918908,1698101563,'Capricorn'],
  [1698101563,1698280071,'Aquarius'],
  [1698280071,1698458471,'Pisces'],
  [1698458471,1698641897,'Aries'],
  [1698641897,1698835305,'Taurus'],
  [1698835305,1699041223,'Gemini'],
  [1699041223,1699257149,'Cancer'],
  [1699257149,1699475452,'Leo'],
  [1699475452,1699687905,'Virgo'],
  [1699687905,1699890473,'Libra'],
  [1699890473,1700083848,'Scorpio'],
  [1700083848,1700271035,'Sagittarius'],
  [1700271035,1700455059,'Capricorn'],
  [1700455059,1700638083,'Aquarius'],
  [1700638083,1700821850,'Pisces'],
  [1700821850,1701008749,'Aries'],
  [1701008749,1701202253,'Taurus'],
  [1701202253,1701405734,'Gemini'],
  [1701405734,1701619555,'Cancer'],
  [1701619555,1701838327,'Leo'],
  [1701838327,1702052608,'Virgo'],
  [1702052608,1702255302,'Libra'],
  [1702255302,1702445713,'Scorpio'],
  [1702445713,1702628080,'Sagittarius'],
  [1702628080,1702808088,'Capricorn'],
  [1702808088,1702990249,'Aquarius'],
  [1702990249,1703176737,'Pisces'],
  [1703176737,1703368040,'Aries'],
  [1703368040,1703564829,'Taurus'],
  [1703564829,1703768874,'Gemini'],
  [1703768874,1703981526,'Cancer'],
  [1703981526,1704200331,'Leo'],
  [1704200331,1704417379,'Virgo'],
  [1704417379,1704623509,'Libra'],
  [1704623509,1704814883,'Scorpio'],
  [1704814883,1704994515,'Sagittarius'],
  [1704994515,1705169110,'Capricorn'],
  [1705169110,1705345637,'Aquarius'],
  [1705345637,1705529024,'Pisces'],
  [1705529024,1705720964,'Aries'],
  [1705720964,1705920752,'Taurus'],
  [1705920752,1706127418,'Gemini'],
  [1706127418,1706340679,'Cancer'],
  [1706340679,1706559267,'Leo'],
  [1706559267,1706778117,'Virgo'],
  [1706778117,1706988864,'Libra'],
  [1706988864,1707185121,'Scorpio'],
  [1707185121,1707366857,'Sagittarius'],
  [1707366857,1707539532,'Capricorn'],
  [1707539532,1707710741,'Aquarius'],
  [1707710741,1707887590,'Pisces'],
  [1707887590,1708074783,'Aries'],
  [1708074783,1708273432,'Taurus'],
  [1708273432,1708481663,'Gemini'],
  [1708481663,1708696527,'Cancer'],
  [1708696527,1708915251,'Leo'],
  [1708915251,1709134195,'Virgo'],
  [1709134195,1709347645,'Libra'],
  [1709347645,1709549500,'Scorpio'],
  [1709549500,1709737107,'Sagittarius'],
  [1709737107,1709913020,'Capricorn'],
  [1709913020,1710083398,'Aquarius'],
  [1710083398,1710255573,'Pisces'],
  [1710255573,1710436192,'Aries'],
  [1710436192,1710629459,'Taurus'],
  [1710629459,1710835631,'Gemini'],
  [1710835631,1711051013,'Cancer'],
  [1711051013,1711270211,'Leo'],
  [1711270211,1711488402,'Virgo'],
  [1711488402,1711701549,'Libra'],
  [1711701549,1711906005,'Scorpio'],
  [1711906005,1712099222,'Sagittarius'],
  [1712099222,1712281361,'Capricorn'],
  [1712281361,1712455776,'Aquarius'],
  [1712455776,1712628130,'Pisces'],
  [1712628130,1712805022,'Aries'],
  [1712805022,1712992454,'Taurus'],
  [1712992454,1713193730,'Gemini'],
  [1713193730,1713407205,'Cancer'],
  [1713407205,1713626455,'Leo'],
  [1713626455,1713844121,'Virgo'],
  [1713844121,1714055442,'Libra'],
  [1714055442,1714258688,'Scorpio'],
  [1714258688,1714453602,'Sagittarius'],
  [1714453602,1714640556,'Capricorn'],
  [1714640556,1714820900,'Aquarius'],
  [1714820900,1714997595,'Pisces'],
  [1714997595,1715175411,'Aries'],
  [1715175411,1715360167,'Taurus'],
  [1715360167,1715556907,'Gemini'],
  [1715556907,1715766917,'Cancer'],
  [1715766917,1715985292,'Leo'],
  [1715985292,1716203074,'Virgo'],
  [1716203074,1716413148,'Libra'],
  [1716413148,1716613566,'Scorpio'],
  [1716613566,1716806113,'Sagittarius'],
  [1716806113,1716993375,'Capricorn'],
  [1716993375,1717177216,'Aquarius'],
  [1717177216,1717359028,'Pisces'],
  [1717359028,1717541036,'Aries'],
  [1717541036,1717727161,'Taurus'],
  [1717727161,1717922227,'Gemini'],
  [1717922227,1718129335,'Cancer'],
  [1718129335,1718346278,'Leo'],
  [1718346278,1718564708,'Virgo'],
  [1718564708,1718775326,'Libra'],
  [1718775326,1718974126,'Scorpio'],
  [1718974126,1719163070,'Sagittarius'],
  [1719163070,1719346758,'Capricorn'],
  [1719346758,1719529315,'Aquarius'],
  [1719529315,1719713053,'Pisces'],
  [1719713053,1719899062,'Aries'],
  [1719899062,1720088902,'Taurus'],
  [1720088902,1720285473,'Gemini'],
  [1720285473,1720491756,'Cancer'],
  [1720491756,1720707566,'Leo'],
  [1720707566,1720926805,'Virgo'],
  [1720926805,1721139727,'Libra'],
  [1721139727,1721339731,'Scorpio'],
  [1721339731,1721527050,'Sagittarius'],
  [1721527050,1721706628,'Capricorn'],
  [1721706628,1721884505,'Aquarius'],
  [1721884505,1722065391,'Pisces'],
  [1722065391,1722251721,'Aries'],
  [1722251721,1722444330,'Taurus'],
  [1722444330,1722643897,'Gemini'],
  [1722643897,1722851491,'Cancer'],
  [1722851491,1723067109,'Leo'],
  [1723067109,1723286897,'Virgo'],
  [1723286897,1723502722,'Libra'],
  [1723502722,1723706581,'Scorpio'],
  [1723706581,1723895934,'Sagittarius'],
  [1723895934,1724074200,'Capricorn'],
  [1724074200,1724247730,'Aquarius'],
  [1724247730,1724423058,'Pisces'],
  [1724423058,1724605185,'Aries'],
  [1724605185,1724796688,'Taurus'],
  [1724796688,1724997846,'Gemini'],
  [1724997846,1725207526,'Cancer'],
  [1725207526,1725423922,'Leo'],
  [1725423922,1725643835,'Virgo'],
  [1725643835,1725861521,'Libra'],
  [1725861521,1726069921,'Scorpio'],
  [1726069921,1726264446,'Sagittarius'],
  [1726264446,1726445685,'Capricorn'],
  [1726445685,1726618469,'Aquarius'],
  [1726618469,1726789511,'Pisces'],
  [1726789511,1726965564,'Aries'],
  [1726965564,1727151929,'Taurus'],
  [1727151929,1727350965,'Gemini'],
  [1727350965,1727561277,'Cancer'],
  [1727561277,1727778728,'Leo'],
  [1727778728,1727998567,'Virgo'],
  [1727998567,1728216224,'Libra'],
  [1728216224,1728427104,'Scorpio'],
  [1728427104,1728627085,'Sagittarius'],
  [1728627085,1728814456,'Capricorn'],
  [1728814456,1728991155,'Aquarius'],
  [1728991155,1729162223,'Pisces'],
  [1729162223,1729334418,'Aries'],
  [1729334418,1729514706,'Taurus'],
  [1729514706,1729708313,'Gemini'],
  [1729708313,1729916152,'Cancer'],
  [1729916152,1730133656,'Leo'],
  [1730133656,1730353539,'Virgo'],
  [1730353539,1730570017,'Libra'],
  [1730570017,1730780124,'Scorpio'],
  [1730780124,1730982247,'Sagittarius'],
  [1730982247,1731175064,'Capricorn'],
  [1731175064,1731358313,'Aquarius'],
  [1731358313,1731534080,'Pisces'],
  [1731534080,1731707224,'Aries'],
  [1731707224,1731884475,'Taurus'],
  [1731884475,1732072623,'Gemini'],
  [1732072623,1732275598,'Cancer'],
  [1732275598,1732491138,'Leo'],
  [1732491138,1732711037,'Virgo'],
  [1732711037,1732926787,'Libra'],
  [1732926787,1733134541,'Scorpio'],
  [1733134541,1733334594,'Sagittarius'],
  [1733334594,1733528217,'Capricorn'],
  [1733528217,1733715883,'Aquarius'],
  [1733715883,1733897882,'Pisces'],
  [1733897882,1734076158,'Aries'],
  [1734076158,1734255270,'Taurus'],
  [1734255270,1734441460,'Gemini'],
  [1734441460,1734640188,'Cancer'],
  [1734640188,1734852349,'Leo'],
  [1734852349,1735071670,'Virgo'],
  [1735071670,1735288022,'Libra'],
  [1735288022,1735494737,'Scorpio'],
  [1735494737,1735691480,'Sagittarius'],
  [1735691480,1735881464,'Capricorn'],
  [1735881464,1736067896,'Aquarius'],
  [1736067896,1736252404,'Pisces'],
  [1736252404,1736435792,'Aries'],
  [1736435792,1736619918,'Taurus'],
  [1736619918,1736808578,'Gemini'],
  [1736808578,1737006399,'Cancer'],
  [1737006399,1737215916,'Leo'],
  [1737215916,1737434017,'Virgo'],
  [1737434017,1737651767,'Libra'],
  [1737651767,1737860176,'Scorpio'],
  [1737860176,1738056126,'Sagittarius'],
  [1738056126,1738242306,'Capricorn'],
  [1738242306,1738423715,'Aquarius'],
  [1738423715,1738604816,'Pisces'],
  [1738604816,1738788371,'Aries'],
  [1738788371,1738975884,'Taurus'],
  [1738975884,1739168808,'Gemini'],
  [1739168808,1739369134,'Cancer'],
  [1739369134,1739578471,'Leo'],
  [1739578471,1739795561,'Virgo'],
  [1739795561,1740014386,'Libra'],
  [1740014386,1740226229,'Scorpio'],
  [1740226229,1740425166,'Sagittarius'],
  [1740425166,1740611231,'Capricorn'],
  [1740611231,1740788887,'Aquarius'],
  [1740788887,1740964155,'Pisces'],
  [1740964155,1741142590,'Aries'],
  [1741142590,1741328112,'Taurus'],
  [1741328112,1741522553,'Gemini'],
  [1741522553,1741725926,'Cancer'],
  [1741725926,1741937184,'Leo'],
  [1741937184,1742154329,'Virgo'],
  [1742154329,1742373409,'Libra'],
  [1742373409,1742588155,'Scorpio'],
  [1742588155,1742792095,'Sagittarius'],
  [1742792095,1742982288,'Capricorn'],
  [1742982288,1743160681,'Aquarius'],
  [1743160681,1743332710,'Pisces'],
  [1743332710,1743505218,'Aries'],
  [1743505218,1743684720,'Taurus'],
  [1743684720,1743875719,'Gemini'],
  [1743875719,1744079108,'Cancer'],
  [1744079108,1744292076,'Leo'],
  [1744292076,1744510147,'Virgo'],
  [1744510147,1744729032,'Libra'],
  [1744729032,1744944663,'Scorpio'],
  [1744944663,1745152464,'Sagittarius'],
  [1745152464,1745348483,'Capricorn'],
  [1745348483,1745531758,'Aquarius'],
  [1745531758,1745705345,'Pisces'],
  [1745705345,1745875427,'Aries'],
  [1745875427,1746049500,'Taurus'],
  [1746049500,1746234426,'Gemini'],
  [1746234426,1746433882,'Cancer'],
  [1746433882,1746646066,'Leo'],
  [1746646066,1746864740,'Virgo'],
  [1746864740,1747083451,'Libra'],
  [1747083451,1747298258,'Scorpio'],
  [1747298258,1747506837,'Sagittarius'],
  [1747506837,1747706737,'Capricorn'],
  [1747706737,1747895915,'Aquarius'],
  [1747895915,1748074712,'Pisces'],
  [1748074712,1748247046,'Aries'],
  [1748247046,1748419605,'Taurus'],
  [1748419605,1748599950,'Gemini'],
  [1748599950,1748793999,'Cancer'],
  [1748793999,1749002720,'Leo'],
  [1749002720,1749220601,'Virgo'],
  [1749220601,1749439233,'Libra'],
  [1749439233,1749652849,'Scorpio'],
  [1749652849,1749859700,'Sagittarius'],
  [1749859700,1750059600,'Capricorn'],
  [1750059600,1750251920,'Aquarius'],
  [1750251920,1750436106,'Pisces'],
  [1750436106,1750613626,'Aries'],
  [1750613626,1750788944,'Taurus'],
  [1750788944,1750968595,'Gemini'],
  [1750968595,1751159063,'Cancer'],
  [1751159063,1751363634,'Leo'],
  [1751363634,1751579354,'Virgo'],
  [1751579354,1751797858,'Libra'],
  [1751797858,1752011121,'Scorpio'],
  [1752011121,1752215924,'Sagittarius'],
  [1752215924,1752413015,'Capricorn'],
  [1752413015,1752604088,'Aquarius'],
  [1752604088,1752790152,'Pisces'],
  [1752790152,1752972123,'Aries'],
  [1752972123,1753152304,'Taurus'],
  [1753152304,1753334953,'Gemini'],
  [1753334953,1753525335,'Cancer'],
  [1753525335,1753727410,'Leo'],
  [1753727410,1753940721,'Virgo'],
  [1753940721,1754158958,'Libra'],
  [1754158958,1754373192,'Scorpio'],
  [1754373192,1754577687,'Sagittarius'],
  [1754577687,1754772076,'Capricorn'],
  [1754772076,1754959225,'Aquarius'],
  [1754959225,1755142564,'Pisces'],
  [1755142564,1755324832,'Aries'],
  [1755324832,1755508226,'Taurus'],
  [1755508226,1755695124,'Gemini'],
  [1755695124,1755888397,'Cancer'],
  [1755888397,1756090731,'Leo'],
  [1756090731,1756302693,'Virgo'],
  [1756302693,1756520587,'Libra'],
  [1756520587,1756736720,'Scorpio'],
  [1756736720,1756943486,'Sagittarius'],
  [1756943486,1757137891,'Capricorn'],
  [1757137891,1757321954,'Aquarius'],
  [1757321954,1757500397,'Pisces'],
  [1757500397,1757678440,'Aries'],
  [1757678440,1757860423,'Taurus'],
  [1757860423,1758049119,'Gemini'],
  [1758049119,1758245742,'Cancer'],
  [1758245742,1758450475,'Leo'],
  [1758450475,1758662775,'Virgo'],
  [1758662775,1758880433,'Libra'],
  [1758880433,1759098298,'Scorpio'],
  [1759098298,1759309039,'Sagittarius'],
  [1759309039,1759507054,'Capricorn'],
  [1759507054,1759691730,'Aquarius'],
  [1759691730,1759867092,'Pisces'],
  [1759867092,1760039610,'Aries'],
  [1760039610,1760216070,'Taurus'],
  [1760216070,1760401738,'Gemini'],
  [1760401738,1760598734,'Cancer'],
  [1760598734,1760805708,'Leo'],
  [1760805708,1761019582,'Virgo'],
  [1761019582,1761237363,'Libra'],
  [1761237363,1761455806,'Scorpio'],
  [1761455806,1761669893,'Sagittarius'],
  [1761669893,1761873503,'Capricorn'],
  [1761873503,1762063030,'Aquarius'],
  [1762063030,1762239885,'Pisces'],
  [1762239885,1762409837,'Aries'],
  [1762409837,1762580673,'Taurus'],
  [1762580673,1762759980,'Gemini'],
  [1762759980,1762952727,'Cancer'],
  [1762952727,1763158898,'Leo'],
  [1763158898,1763373910,'Virgo'],
  [1763373910,1763592246,'Libra'],
  [1763592246,1763810219,'Scorpio'],
  [1763810219,1764025027,'Sagittarius'],
  [1764025027,1764232645,'Capricorn'],
  [1764232645,1764428620,'Aquarius'],
  [1764428620,1764611311,'Pisces'],
  [1764611311,1764783869,'Aries'],
  [1764783869,1764953143,'Taurus'],
  [1764953143,1765127316,'Gemini'],
  [1765127316,1765313568,'Cancer'],
  [1765313568,1765515044,'Leo'],
  [1765515044,1765728704,'Virgo'],
  [1765728704,1765947390,'Libra'],
  [1765947390,1766164877,'Scorpio'],
  [1766164877,1766378221,'Sagittarius'],
  [1766378221,1766585796,'Capricorn'],
  [1766585796,1766785243,'Aquarius'],
  [1766785243,1766974265,'Pisces'],
  [1766974265,1767153186,'Aries'],
  [1767153186,1767326161,'Taurus'],
  [1767326161,1767499997,'Gemini'],
  [1767499997,1767682076,'Cancer'],
  [1767682076,1767877766,'Leo'],
  [1767877766,1768087364,'Virgo'],
  [1768087364,1768305085,'Libra'],
  [1768305085,1768522672,'Scorpio'],
  [1768522672,1768734664,'Sagittarius'],
  [1768734664,1768939538,'Capricorn'],
  [1768939538,1769137434,'Aquarius'],
  [1769137434,1769328353,'Pisces'],
  [1769328353,1769512498,'Aries'],
  [1769512498,1769691669,'Taurus'],
  [1769691669,1769869884,'Gemini'],
  [1769869884,1770052679,'Cancer'],
  [1770052679,1770245407,'Leo'],
  [1770245407,1770450720,'Virgo'],
  [1770450720,1770666081,'Libra'],
  [1770666081,1770883954,'Scorpio'],
  [1770883954,1771096346,'Sagittarius'],
  [1771096346,1771299355,'Capricorn'],
  [1771299355,1771493415,'Aquarius'],
  [1771493415,1771681040,'Pisces'],
  [1771681040,1771864949,'Aries'],
  [1771864949,1772047491,'Taurus'],
  [1772047491,1772230961,'Gemini'],
  [1772230961,1772418110,'Cancer'],
  [1772418110,1772612149,'Leo'],
  [1772612149,1772815730,'Virgo'],
  [1772815730,1773028800,'Libra'],
  [1773028800,1773246633,'Scorpio'],
  [1773246633,1773460991,'Sagittarius'],
  [1773460991,1773665072,'Capricorn'],
  [1773665072,1773857187,'Aquarius'],
  [1773857187,1774040283,'Pisces'],
  [1774040283,1774219450,'Aries'],
  [1774219450,1774399648,'Taurus'],
  [1774399648,1774584370,'Gemini'],
  [1774584370,1774775287,'Cancer'],
  [1774775287,1774972975,'Leo'],
  [1774972975,1775177930,'Virgo'],
  [1775177930,1775390292,'Libra'],
  [1775390292,1775607852,'Scorpio'],
  [1775607852,1775824445,'Sagittarius'],
  [1775824445,1776032086,'Capricorn'],
  [1776032086,1776226074,'Aquarius'],
  [1776226074,1776407559,'Pisces'],
  [1776407559,1776582083,'Aries'],
  [1776582083,1776756664,'Taurus'],
  [1776756664,1776937407,'Gemini'],
  [1776937407,1777127699,'Cancer'],
  [1777127699,1777327555,'Leo'],
  [1777327555,1777535059,'Virgo'],
  [1777535059,1777748411,'Libra'],
  [1777748411,1777965901,'Scorpio'],
  [1777965901,1778183803,'Sagittarius'],
  [1778183803,1778395377,'Capricorn'],
  [1778395377,1778594110,'Aquarius'],
  [1778594110,1778778251,'Pisces'],
  [1778778251,1778951813,'Aries'],
  [1778951813,1779122110,'Taurus'],
  [1779122110,1779296941,'Gemini'],
  [1779296941,1779482296,'Cancer'],
  [1779482296,1779680248,'Leo'],
  [1779680248,1779888610,'Virgo'],
  [1779888610,1780103345,'Libra'],
  [1780103345,1780321131,'Scorpio'],
  [1780321131,1780539111,'Sagittarius'],
  [1780539111,1780752835,'Capricorn'],
  [1780752835,1780956406,'Aquarius'],
  [1780956406,1781146002,'Pisces'],
  [1781146002,1781322930,'Aries'],
  [1781322930,1781493061,'Taurus'],
  [1781493061,1781664216,'Gemini'],
  [1781664216,1781843828,'Cancer'],
  [1781843828,1782036618,'Leo'],
  [1782036618,1782242584,'Virgo'],
  [1782242584,1782457401,'Libra'],
  [1782457401,1782675540,'Scorpio'],
  [1782675540,1782892912,'Sagittarius'],
  [1782892912,1783106316,'Capricorn'],
  [1783106316,1783312055,'Aquarius'],
  [1783312055,1783506635,'Pisces'],
  [1783506635,1783689309,'Aries'],
  [1783689309,1783863393,'Taurus'],
  [1783863393,1784035139,'Gemini'],
  [1784035139,1784211752,'Cancer'],
  [1784211752,1784399355,'Leo'],
  [1784399355,1784600685,'Virgo'],
  [1784600685,1784813474,'Libra'],
  [1784813474,1785031498,'Scorpio'],
  [1785031498,1785248373,'Sagittarius'],
  [1785248373,1785460100,'Capricorn'],
  [1785460100,1785664616,'Aquarius'],
  [1785664616,1785860657,'Pisces'],
  [1785860657,1786047813,'Aries'],
  [1786047813,1786227548,'Taurus'],
  [1786227548,1786403612,'Gemini'],
  [1786403612,1786581403,'Cancer'],
  [1786581403,1786766693,'Leo'],
  [1786766693,1786963788,'Virgo'],
  [1786963788,1787173225,'Libra'],
  [1787173225,1787390364,'Scorpio'],
  [1787390364,1787607388,'Sagittarius'],
  [1787607388,1787817955,'Capricorn'],
  [1787817955,1788019667,'Aquarius'],
  [1788019667,1788213235,'Pisces'],
  [1788213235,1788400565,'Aries'],
  [1788400565,1788583714,'Taurus'],
  [1788583714,1788764922,'Gemini'],
  [1788764922,1788947067,'Cancer'],
  [1788947067,1789133896,'Leo'],
  [1789133896,1789329401,'Virgo'],
  [1789329401,1789535960,'Libra'],
  [1789535960,1789751693,'Scorpio'],
  [1789751693,1789969512,'Sagittarius'],
  [1789969512,1790180832,'Capricorn'],
  [1790180832,1790380992,'Aquarius'],
  [1790380992,1790570780,'Pisces'],
  [1790570780,1790754229,'Aries'],
  [1790754229,1790935844,'Taurus'],
  [1790935844,1791118924,'Gemini'],
  [1791118924,1791305261,'Cancer'],
  [1791305261,1791496091,'Leo'],
  [1791496091,1791693254,'Virgo'],
  [1791693254,1791898957,'Libra'],
  [1791898957,1792113467,'Scorpio'],
  [1792113467,1792332193,'Sagittarius'],
  [1792332193,1792546226,'Capricorn'],
  [1792546226,1792748040,'Aquarius'],
  [1792748040,1792936332,'Pisces'],
  [1792936332,1793115403,'Aries'],
  [1793115403,1793291803,'Taurus'],
  [1793291803,1793471450,'Gemini'],
  [1793471450,1793657796,'Cancer'],
  [1793657796,1793851481,'Leo'],
  [1793851481,1794051919,'Virgo'],
  [1794051919,1794259111,'Libra'],
  [1794259111,1794473353,'Scorpio'],
  [1794473353,1794692483,'Sagittarius'],
  [1794692483,1794909632,'Capricorn'],
  [1794909632,1795116002,'Aquarius'],
  [1795116002,1795307104,'Pisces'],
  [1795307104,1795485294,'Aries'],
  [1795485294,1795657283,'Taurus'],
  [1795657283,1795830755,'Gemini'],
  [1795830755,1796011943,'Cancer'],
  [1796011943,1796203769,'Leo'],
  [1796203769,1796405574,'Virgo'],
  [1796405574,1796615048,'Libra'],
  [1796615048,1796830244,'Scorpio'],
  [1796830244,1797049295,'Sagittarius'],
  [1797049295,1797267953,'Capricorn'],
  [1797267953,1797478991,'Aquarius'],
  [1797478991,1797676094,'Pisces'],
  [1797676094,1797858373,'Aries'],
  [1797858373,1798030571,'Taurus'],
  [1798030571,1798200189,'Gemini'],
  [1798200189,1798374884,'Cancer'],
  [1798374884,1798560458,'Leo'],
  [1798560458,1798759028,'Virgo'],
  [1798759028,1798968640,'Libra'],
  [1798968640,1799185043,'Scorpio'],
  [1799185043,1799404146,'Sagittarius'],
  [1799404146,1799622306,'Capricorn'],
  [1799622306,1799835016,'Aquarius'],
  [1799835016,1800037278,'Pisces'],
  [1800037278,1800226314,'Aries'],
  [1800226314,1800403713,'Taurus'],
  [1800403713,1800574796,'Gemini'],
  [1800574796,1800746610,'Cancer'],
  [1800746610,1800926111,'Leo'],
  [1800926111,1801118328,'Virgo'],
  [1801118328,1801324329,'Libra'],
  [1801324329,1801540307,'Scorpio'],
  [1801540307,1801759702,'Sagittarius'],
  [1801759702,1801976804,'Capricorn'],
  [1801976804,1802188026,'Aquarius'],
  [1802188026,1802391135,'Pisces'],
  [1802391135,1802584674,'Aries'],
  [1802584674,1802768698,'Taurus'],
  [1802768698,1802945566,'Gemini'],
  [1802945566,1803119873,'Cancer'],
  [1803119873,1803297617,'Leo'],
  [1803297617,1803484828,'Virgo'],
  [1803484828,1803685458,'Libra'],
  [1803685458,1803898642,'Scorpio'],
  [1803898642,1804117852,'Sagittarius'],
  [1804117852,1804334692,'Capricorn'],
  [1804334692,1804543823,'Aquarius'],
  [1804543823,1804744208,'Pisces'],
  [1804744208,1804937107,'Aries'],
  [1804937107,1805124089,'Taurus'],
  [1805124089,1805306576,'Gemini'],
  [1805306576,1805486515,'Cancer'],
  [1805486515,1805667302,'Leo'],
  [1805667302,1805853797,'Virgo'],
  [1805853797,1806050881,'Libra'],
  [1806050881,1806260523,'Scorpio'],
  [1806260523,1806478674,'Sagittarius'],
  [1806478674,1806696187,'Capricorn'],
  [1806696187,1806904934,'Aquarius'],
  [1806904934,1807102545,'Pisces'],
  [1807102545,1807291606,'Aries'],
  [1807291606,1807476264,'Taurus'],
  [1807476264,1807659743,'Gemini'],
  [1807659743,1807843706,'Cancer'],
  [1807843706,1808029330,'Leo'],
  [1808029330,1808218898,'Virgo'],
  [1808218898,1808416027,'Libra'],
  [1808416027,1808623659,'Scorpio'],
  [1808623659,1808840492,'Sagittarius'],
  [1808840492,1809059046,'Capricorn'],
  [1809059046,1809269610,'Aquarius'],
  [1809269610,1809467101,'Pisces'],
  [1809467101,1809653159,'Aries'],
  [1809653159,1809833188,'Taurus'],
  [1809833188,1810012833,'Gemini'],
  [1810012833,1810195862,'Cancer'],
  [1810195862,1810383753,'Leo'],
  [1810383753,1810577013,'Virgo'],
  [1810577013,1810776794,'Libra'],
  [1810776794,1810984826,'Scorpio'],
  [1810984826,1811201000,'Sagittarius'],
  [1811201000,1811420379,'Capricorn'],
  [1811420379,1811633947,'Aquarius'],
  [1811633947,1811834399,'Pisces'],
  [1811834399,1812020875,'Aries'],
  [1812020875,1812198045,'Taurus'],
  [1812198045,1812372629,'Gemini'],
  [1812372629,1812550693,'Cancer'],
  [1812550693,1812736077,'Leo'],
  [1812736077,1812930049,'Virgo'],
  [1812930049,1813132314,'Libra'],
  [1813132314,1813342238,'Scorpio'],
  [1813342238,1813558757,'Sagittarius'],
  [1813558757,1813778459,'Capricorn'],
  [1813778459,1813994546,'Aquarius'],
  [1813994546,1814199519,'Pisces'],
  [1814199519,1814389956,'Aries'],
  [1814389956,1814568223,'Taurus'],
  [1814568223,1814740324,'Gemini'],
  [1814740324,1814913218,'Cancer'],
  [1814913218,1815092977,'Leo'],
  [1815092977,1815283411,'Virgo'],
  [1815283411,1815485280,'Libra'],
  [1815485280,1815696604,'Scorpio'],
  [1815696604,1815914037,'Sagittarius'],
  [1815914037,1816133662,'Capricorn'],
  [1816133662,1816350541,'Aquarius'],
  [1816350541,1816559048,'Pisces'],
  [1816559048,1816754965,'Aries'],
  [1816754965,1816937994,'Taurus'],
  [1816937994,1817111891,'Gemini'],
  [1817111891,1817282808,'Cancer'],
  [1817282808,1817457590,'Leo'],
  [1817457590,1817642263,'Virgo'],
  [1817642263,1817840245,'Libra'],
  [1817840245,1818050663,'Scorpio'],
  [1818050663,1818268630,'Sagittarius'],
  [1818268630,1818488086,'Capricorn'],
  [1818488086,1818704121,'Aquarius'],
  [1818704121,1818913273,'Pisces'],
  [1818913273,1819112936,'Aries'],
  [1819112936,1819301812,'Taurus'],
  [1819301812,1819481015,'Gemini'],
  [1819481015,1819654375,'Cancer'],
  [1819654375,1819827794,'Leo'],
  [1819827794,1820007997,'Virgo'],
  [1820007997,1820200658,'Libra'],
  [1820200658,1820407630,'Scorpio'],
  [1820407630,1820624833,'Sagittarius'],
  [1820624833,1820844247,'Capricorn'],
  [1820844247,1821059031,'Aquarius'],
  [1821059031,1821266274,'Pisces'],
  [1821266274,1821465759,'Aries'],
  [1821465759,1821657758,'Taurus'],
  [1821657758,1821842548,'Gemini'],
  [1821842548,1822021423,'Cancer'],
  [1822021423,1822197839,'Leo'],
  [1822197839,1822377398,'Virgo'],
  [1822377398,1822566410,'Libra'],
  [1822566410,1822769124,'Scorpio'],
  [1822769124,1822984138,'Sagittarius'],
  [1822984138,1823203556,'Capricorn'],
  [1823203556,1823418098,'Aquarius'],
  [1823418098,1823623172,'Pisces'],
  [1823623172,1823819503,'Aries'],
  [1823819503,1824009874,'Taurus'],
  [1824009874,1824196378,'Gemini'],
  [1824196378,1824379915,'Cancer'],
  [1824379915,1824561632,'Leo'],
  [1824561632,1824744568,'Virgo'],
  [1824744568,1824933663,'Libra'],
  [1824933663,1825133802,'Scorpio'],
  [1825133802,1825346218,'Sagittarius'],
  [1825346218,1825565392,'Capricorn'],
  [1825565392,1825781246,'Aquarius'],
  [1825781246,1825986348,'Pisces'],
  [1825986348,1826179971,'Aries'],
  [1826179971,1826365970,'Taurus'],
  [1826365970,1826549010,'Gemini'],
  [1826549010,1826732244,'Cancer'],
  [1826732244,1826917069,'Leo'],
  [1826917069,1827104597,'Virgo'],
  [1827104597,1827297106,'Libra'],
  [1827297106,1827497859,'Scorpio'],
  [1827497859,1827708866,'Sagittarius'],
  [1827708866,1827927469,'Capricorn'],
  [1827927469,1828145379,'Aquarius'],
  [1828145379,1828353436,'Pisces'],
  [1828353436,1828547850,'Aries'],
  [1828547850,1828731137,'Taurus'],
  [1828731137,1828908921,'Gemini'],
  [1828908921,1829086905,'Cancer'],
  [1829086905,1829269185,'Leo'],
  [1829269185,1829457864,'Virgo'],
  [1829457864,1829653791,'Libra'],
  [1829653791,1829857494,'Scorpio'],
  [1829857494,1830069231,'Sagittarius'],
  [1830069231,1830287408,'Capricorn'],
  [1830287408,1830506665,'Aquarius'],
  [1830506665,1830718901,'Pisces'],
  [1830718901,1830917913,'Aries'],
  [1830917913,1831103096,'Taurus'],
  [1831103096,1831278704,'Gemini'],
  [1831278704,1831451164,'Cancer'],
  [1831451164,1831626967,'Leo'],
  [1831626967,1831811194,'Virgo'],
  [1831811194,1832006378,'Libra'],
  [1832006378,1832212091,'Scorpio'],
  [1832212091,1832425829,'Sagittarius'],
  [1832425829,1832644341,'Capricorn'],
  [1832644341,1832863659,'Aquarius'],
  [1832863659,1833078498,'Pisces'],
  [1833078498,1833283082,'Aries'],
  [1833283082,1833474125,'Taurus'],
  [1833474125,1833652775,'Gemini'],
  [1833652775,1833823989,'Cancer'],
  [1833823989,1833994710,'Leo'],
  [1833994710,1834172121,'Virgo'],
  [1834172121,1834361807,'Libra'],
  [1834361807,1834565503,'Scorpio'],
  [1834565503,1834780005,'Sagittarius'],
  [1834780005,1834999340,'Capricorn'],
  [1834999340,1835218181,'Aquarius'],
  [1835218181,1835432906,'Pisces'],
  [1835432906,1835640322,'Aries'],
  [1835640322,1835837286,'Taurus'],
  [1835837286,1836022381,'Gemini'],
  [1836022381,1836197545,'Cancer'],
  [1836197545,1836368128,'Leo'],
  [1836368128,1836541443,'Virgo'],
  [1836541443,1836724847,'Libra'],
  [1836724847,1836923111,'Scorpio'],
  [1836923111,1837135321,'Sagittarius'],
  [1837135321,1837354705,'Capricorn'],
  [1837354705,1837573311,'Aquarius'],
  [1837573311,1837786554,'Pisces'],
  [1837786554,1837993075,'Aries'],
  [1837993075,1838192102,'Taurus'],
  [1838192102,1838382469,'Gemini'],
  [1838382469,1838563917,'Cancer'],
  [1838563917,1838738958,'Leo'],
  [1838738958,1838913154,'Virgo'],
  [1838913154,1839093655,'Libra'],
  [1839093655,1839286802,'Scorpio'],
  [1839286802,1839494691,'Sagittarius'],
  [1839494691,1839712532,'Capricorn'],
  [1839712532,1839931135,'Aquarius'],
  [1839931135,1840143416,'Pisces'],
  [1840143416,1840347474,'Aries'],
  [1840347474,1840544440,'Taurus'],
  [1840544440,1840735461,'Gemini'],
  [1840735461,1840920848,'Cancer'],
  [1840920848,1841101415,'Leo'],
  [1841101415,1841280123,'Virgo'],
  [1841280123,1841462192,'Libra'],
  [1841462192,1841653528,'Scorpio'],
  [1841653528,1841857836,'Sagittarius'],
  [1841857836,1842073232,'Capricorn'],
  [1842073232,1842291766,'Aquarius'],
  [1842291766,1842504500,'Pisces'],
  [1842504500,1842707230,'Aries'],
  [1842707230,1842900910,'Taurus'],
  [1842900910,1843088605,'Gemini'],
  [1843088605,1843273001,'Cancer'],
  [1843273001,1843455861,'Leo'],
  [1843455861,1843638973,'Virgo'],
  [1843638973,1843825181,'Libra'],
  [1843825181,1844018320,'Scorpio'],
  [1844018320,1844221668,'Sagittarius'],
  [1844221668,1844435188,'Capricorn'],
  [1844435188,1844653526,'Aquarius'],
  [1844653526,1844867947,'Pisces'],
  [1844867947,1845071847,'Aries'],
  [1845071847,1845264139,'Taurus'],
  [1845264139,1845447956,'Gemini'],
  [1845447956,1845627898,'Cancer'],
  [1845627898,1845808178,'Leo'],
  [1845808178,1845991914,'Virgo'],
  [1845991914,1846181256,'Libra'],
  [1846181256,1846377811,'Scorpio'],
  [1846377811,1846582754,'Sagittarius'],
  [1846582754,1846795915,'Capricorn'],
  [1846795915,1847014067,'Aquarius'],
  [1847014067,1847230506,'Pisces'],
  [1847230506,1847437764,'Aries'],
  [1847437764,1847632030,'Taurus'],
  [1847632030,1847814641,'Gemini'],
  [1847814641,1847990405,'Cancer'],
  [1847990405,1848165390,'Leo'],
  [1848165390,1848345202,'Virgo'],
  [1848345202,1848533690,'Libra'],
  [1848533690,1848732128,'Scorpio'],
  [1848732128,1848939507,'Sagittarius'],
  [1848939507,1849153706,'Capricorn'],
  [1849153706,1849371853,'Aquarius'],
  [1849371853,1849589545,'Pisces'],
  [1849589545,1849800634,'Aries'],
  [1849800634,1849999631,'Taurus'],
  [1849999631,1850185027,'Gemini'],
  [1850185027,1850360004,'Cancer'],
  [1850360004,1850530859,'Leo'],
  [1850530859,1850704904,'Virgo'],
  [1850704904,1850888517,'Libra'],
  [1850888517,1851084998,'Scorpio'],
  [1851084998,1851293175,'Sagittarius'],
  [1851293175,1851508720,'Capricorn'],
  [1851508720,1851727110,'Aquarius'],
  [1851727110,1851944804,'Pisces'],
  [1851944804,1852158010,'Aries'],
  [1852158010,1852361965,'Taurus'],
  [1852361965,1852553072,'Gemini'],
  [1852553072,1852731645,'Cancer'],
  [1852731645,1852902402,'Leo'],
  [1852902402,1853072734,'Virgo'],
  [1853072734,1853250522,'Libra'],
  [1853250522,1853441713,'Scorpio'],
  [1853441713,1853647400,'Sagittarius'],
  [1853647400,1853863018,'Capricorn'],
  [1853863018,1854081742,'Aquarius'],
  [1854081742,1854298694,'Pisces'],
  [1854298694,1854511389,'Aries'],
  [1854511389,1854717446,'Taurus'],
  [1854717446,1854913778,'Gemini'],
  [1854913778,1855098578,'Cancer'],
  [1855098578,1855273723,'Leo'],
  [1855273723,1855444880,'Virgo'],
  [1855444880,1855619688,'Libra'],
  [1855619688,1855805462,'Scorpio'],
  [1855805462,1856006156,'Sagittarius'],
  [1856006156,1856219534,'Capricorn'],
  [1856219534,1856438171,'Aquarius'],
  [1856438171,1856654670,'Pisces'],
  [1856654670,1856865497,'Aries'],
  [1856865497,1857069918,'Taurus'],
  [1857069918,1857267358,'Gemini'],
  [1857267358,1857456716,'Cancer'],
  [1857456716,1857638033,'Leo'],
  [1857638033,1857814191,'Virgo'],
  [1857814191,1857990777,'Libra'],
  [1857990777,1858174489,'Scorpio'],
  [1858174489,1858370687,'Sagittarius'],
  [1858370687,1858580232,'Capricorn'],
  [1858580232,1858797790,'Aquarius'],
  [1858797790,1859014686,'Pisces'],
  [1859014686,1859224630,'Aries'],
  [1859224630,1859426083,'Taurus'],
  [1859426083,1859620328,'Gemini'],
  [1859620328,1859808996,'Cancer'],
  [1859808996,1859993312,'Leo'],
  [1859993312,1860174881,'Virgo'],
  [1860174881,1860356616,'Libra'],
  [1860356616,1860542777,'Scorpio'],
  [1860542777,1860737843,'Sagittarius'],
  [1860737843,1860944288,'Capricorn'],
  [1860944288,1861159979,'Aquarius'],
  [1861159979,1861377701,'Pisces'],
  [1861377701,1861589066,'Aries'],
  [1861589066,1861789665,'Taurus'],
  [1861789665,1861980155,'Gemini'],
  [1861980155,1862164081,'Cancer'],
  [1862164081,1862345545,'Leo'],
  [1862345545,1862527921,'Virgo'],
  [1862527921,1862713592,'Libra'],
  [1862713592,1862904369,'Scorpio'],
  [1862904369,1863102023,'Sagittarius'],
  [1863102023,1863308097,'Capricorn'],
  [1863308097,1863522320,'Aquarius'],
  [1863522320,1863740526,'Pisces'],
  [1863740526,1863954877,'Aries'],
  [1863954877,1864158196,'Taurus'],
  [1864158196,1864348316,'Gemini'],
  [1864348316,1864528284,'Cancer'],
  [1864528284,1864703966,'Leo'],
  [1864703966,1864881549,'Virgo'],
  [1864881549,1865065718,'Libra'],
  [1865065718,1865258535,'Scorpio'],
  [1865258535,1865459655,'Sagittarius'],
  [1865459655,1865667881,'Capricorn'],
  [1865667881,1865882142,'Aquarius'],
  [1865882142,1866100326,'Pisces'],
  [1866100326,1866317237,'Aries'],
  [1866317237,1866525359,'Taurus'],
  [1866525359,1866719432,'Gemini'],
  [1866719432,1866899861,'Cancer'],
  [1866899861,1867072049,'Leo'],
  [1867072049,1867243579,'Virgo'],
  [1867243579,1867421710,'Libra'],
  [1867421710,1867611193,'Scorpio'],
  [1867611193,1867812573,'Sagittarius'],
  [1867812573,1868022867,'Capricorn'],
  [1868022867,1868238422,'Aquarius'],
  [1868238422,1868456584,'Pisces'],
  [1868456584,1868674312,'Aries'],
  [1868674312,1868886223,'Taurus'],
  [1868886223,1869086168,'Gemini'],
  [1869086168,1869271479,'Cancer'],
  [1869271479,1869445131,'Leo'],
  [1869445131,1869614104,'Virgo'],
  [1869614104,1869786584,'Libra'],
  [1869786584,1869969655,'Scorpio'],
  [1869969655,1870166777,'Sagittarius'],
  [1870166777,1870376186,'Capricorn'],
  [1870376186,1870592612,'Aquarius'],
  [1870592612,1870811028,'Pisces'],
  [1870811028,1871028204,'Aries'],
  [1871028204,1871240957,'Taurus'],
  [1871240957,1871444890,'Gemini'],
  [1871444890,1871636316,'Cancer'],
  [1871636316,1871815378,'Leo'],
  [1871815378,1871986749,'Virgo'],
  [1871986749,1872157723,'Libra'],
  [1872157723,1872335937,'Scorpio'],
  [1872335937,1872527084,'Sagittarius'],
  [1872527084,1872732379,'Capricorn'],
  [1872732379,1872947688,'Aquarius'],
  [1872947688,1873166219,'Pisces'],
  [1873166219,1873382616,'Aries'],
  [1873382616,1873593917,'Taurus'],
  [1873593917,1873797986,'Gemini'],
  [1873797986,1873992755,'Cancer'],
  [1873992755,1874177498,'Leo'],
  [1874177498,1874354383,'Virgo'],
  [1874354383,1874528393,'Libra'],
  [1874528393,1874705972,'Scorpio'],
  [1874705972,1874893226,'Sagittarius'],
  [1874893226,1875093665,'Capricorn'],
  [1875093665,1875305993,'Aquarius'],
  [1875305993,1875523995,'Pisces'],
  [1875523995,1875740181,'Aries'],
  [1875740181,1875949777,'Taurus'],
  [1875949777,1876151296,'Gemini'],
  [1876151296,1876345036,'Cancer'],
  [1876345036,1876531919,'Leo'],
  [1876531919,1876713567,'Virgo'],
  [1876713567,1876892785,'Libra'],
  [1876892785,1877073631,'Scorpio'],
  [1877073631,1877260843,'Sagittarius'],
  [1877260843,1877458451,'Capricorn'],
  [1877458451,1877667587,'Aquarius'],
  [1877667587,1877884455,'Pisces'],
  [1877884455,1878101197,'Aries'],
  [1878101197,1878310560,'Taurus'],
  [1878310560,1878509642,'Gemini'],
  [1878509642,1878699761,'Cancer'],
  [1878699761,1878884246,'Leo'],
  [1878884246,1879066509,'Virgo'],
  [1879066509,1879249248,'Libra'],
  [1879249248,1879434628,'Scorpio'],
  [1879434628,1879624943,'Sagittarius'],
  [1879624943,1879822860,'Capricorn'],
  [1879822860,1880030300,'Aquarius'],
  [1880030300,1880245995,'Pisces'],
  [1880245995,1880463765,'Aries'],
  [1880463765,1880674956,'Taurus'],
  [1880674956,1880874030,'Gemini'],
  [1880874030,1881061293,'Cancer'],
  [1881061293,1881241278,'Leo'],
  [1881241278,1881419755,'Virgo'],
  [1881419755,1881601458,'Libra'],
  [1881601458,1881788930,'Scorpio'],
  [1881788930,1881982816,'Sagittarius'],
  [1881982816,1882183349,'Capricorn'],
  [1882183349,1882391233,'Aquarius'],
  [1882391233,1882606353,'Pisces'],
  [1882606353,1882825028,'Aries'],
  [1882825028,1883039346,'Taurus'],
  [1883039346,1883241533,'Gemini'],
  [1883241533,1883429292,'Cancer'],
  [1883429292,1883606412,'Leo'],
  [1883606412,1883779798,'Virgo'],
  [1883779798,1883956464,'Libra'],
  [1883956464,1884141319,'Scorpio'],
  [1884141319,1884335847,'Sagittarius'],
  [1884335847,1884538839,'Capricorn'],
  [1884538839,1884748603,'Aquarius'],
  [1884748603,1884964043,'Pisces'],
  [1884964043,1885183029,'Aries'],
  [1885183029,1885399982,'Taurus'],
  [1885399982,1885607023,'Gemini'],
  [1885607023,1885799131,'Cancer'],
  [1885799131,1885977573,'Leo'],
  [1885977573,1886148523,'Virgo'],
  [1886148523,1886319874,'Libra'],
  [1886319874,1886498759,'Scorpio'],
  [1886498759,1886689394,'Sagittarius'],
  [1886689394,1886891799,'Capricorn'],
  [1886891799,1887102957,'Aquarius'],
  [1887102957,1887319351,'Pisces'],
  [1887319351,1887538166,'Aries'],
  [1887538166,1887755753,'Taurus'],
  [1887755753,1887966392,'Gemini'],
  [1887966392,1888164464,'Cancer'],
  [1888164464,1888348355,'Leo'],
  [1888348355,1888521710,'Virgo'],
  [1888521710,1888691433,'Libra'],
  [1888691433,1888865213,'Scorpio'],
  [1888865213,1889049496,'Sagittarius'],
  [1889049496,1889247352,'Capricorn'],
  [1889247352,1889457251,'Aquarius'],
  [1889457251,1889674230,'Pisces'],
  [1889674230,1889892955,'Aries'],
  [1889892955,1890109433,'Taurus'],
  [1890109433,1890320204,'Gemini'],
  [1890320204,1890521784,'Cancer'],
  [1890521784,1890711926,'Leo'],
  [1890711926,1890891498,'Virgo'],
  [1890891498,1891064719,'Libra'],
  [1891064719,1891237882,'Scorpio'],
  [1891237882,1891417730,'Sagittarius'],
  [1891417730,1891609628,'Capricorn'],
  [1891609628,1891815287,'Aquarius'],
  [1891815287,1892031177,'Pisces'],
  [1892031177,1892250093,'Aries'],
  [1892250093,1892465477,'Taurus'],
  [1892465477,1892673872,'Gemini'],
  [1892673872,1892874303,'Cancer'],
  [1892874303,1893066779,'Leo'],
  [1893066779,1893251914,'Virgo'],
  [1893251914,1893431480,'Libra'],
  [1893431480,1893608896,'Scorpio'],
  [1893608896,1893789118,'Sagittarius'],
  [1893789118,1893977662,'Capricorn'],
  [1893977662,1894178602,'Aquarius'],
  [1894178602,1894391641,'Pisces'],
  [1894391641,1894610500,'Aries'],
  [1894610500,1894826188,'Taurus'],
  [1894826188,1895032779,'Gemini'],
  [1895032779,1895229603,'Cancer'],
  [1895229603,1895419230,'Leo'],
  [1895419230,1895604717,'Virgo'],
  [1895604717,1895788238,'Libra'],
  [1895788238,1895971290,'Scorpio'],
  [1895971290,1896155923,'Sagittarius'],
  [1896155923,1896345607,'Capricorn'],
  [1896345607,1896544478,'Aquarius'],
  [1896544478,1896754662,'Pisces'],
  [1896754662,1896972837,'Aries'],
  [1896972837,1897190065,'Taurus'],
  [1897190065,1897397540,'Gemini'],
  [1897397540,1897592374,'Cancer'],
  [1897592374,1897777587,'Leo'],
  [1897777587,1897958613,'Virgo'],
  [1897958613,1898140233,'Libra'],
  [1898140233,1898325077,'Scorpio'],
  [1898325077,1898513936,'Sagittarius'],
  [1898513936,1898707556,'Capricorn'],
  [1898707556,1898907913,'Aquarius'],
  [1898907913,1899117189,'Pisces'],
  [1899117189,1899334541,'Aries'],
  [1899334541,1899553418,'Taurus'],
  [1899553418,1899764133,'Gemini'],
  [1899764133,1899960731,'Cancer'],
  [1899960731,1900144322,'Leo'],
  [1900144322,1900320714,'Virgo'],
  [1900320714,1900496742,'Libra'],
  [1900496742,1900677744,'Scorpio'],
  [1900677744,1900866258,'Sagittarius'],
  [1900866258,1901062423,'Capricorn'],
  [1901062423,1901265772,'Aquarius'],
  [1901265772,1901476354,'Pisces'],
  [1901476354,1901693552,'Aries'],
  [1901693552,1901913297,'Taurus'],
  [1901913297,1902127565,'Gemini'],
  [1902127565,1902328801,'Cancer'],
  [1902328801,1902515116,'Leo'],
  [1902515116,1902690614,'Virgo'],
  [1902690614,1902862284,'Libra'],
  [1902862284,1903037188,'Scorpio'],
  [1903037188,1903220605,'Sagittarius'],
  [1903220605,1903414833,'Capricorn'],
  [1903414833,1903619262,'Aquarius'],
  [1903619262,1903831688,'Pisces'],
  [1903831688,1904049547,'Aries'],
  [1904049547,1904269352,'Taurus'],
  [1904269352,1904485499,'Gemini'],
  [1904485499,1904691425,'Cancer'],
  [1904691425,1904883278,'Leo'],
  [1904883278,1905062340,'Virgo'],
  [1905062340,1905233933,'Libra'],
  [1905233933,1905405035,'Scorpio'],
  [1905405035,1905582424,'Sagittarius'],
  [1905582424,1905771121,'Capricorn'],
  [1905771121,1905972864,'Aquarius'],
  [1905972864,1906185429,'Pisces'],
  [1906185429,1906404013,'Aries'],
  [1906404013,1906623543,'Taurus'],
  [1906623543,1906839431,'Gemini'],
  [1906839431,1907047460,'Cancer'],
  [1907047460,1907244326,'Leo'],
  [1907244326,1907429309,'Virgo'],
  [1907429309,1907605049,'Libra'],
  [1907605049,1907776789,'Scorpio'],
  [1907776789,1907951060,'Sagittarius'],
  [1907951060,1908134274,'Capricorn'],
  [1908134274,1908330863,'Aquarius'],
  [1908330863,1908540908,'Pisces'],
  [1908540908,1908759279,'Aries'],
  [1908759279,1908978588,'Taurus'],
  [1908978588,1909193133,'Gemini'],
  [1909193133,1909400150,'Cancer'],
  [1909400150,1909598609,'Leo'],
  [1909598609,1909788212,'Virgo'],
  [1909788212,1909969775,'Libra'],
  [1909969775,1910145943,'Scorpio'],
  [1910145943,1910321415,'Sagittarius'],
  [1910321415,1910502264,'Capricorn'],
  [1910502264,1910694304,'Aquarius'],
  [1910694304,1910900321,'Pisces'],
  [1910900321,1911117140,'Aries'],
  [1911117140,1911336384,'Taurus'],
  [1911336384,1911550002,'Gemini'],
  [1911550002,1911754624,'Cancer'],
  [1911754624,1911950999,'Leo'],
  [1911950999,1912141080,'Virgo'],
  [1912141080,1912326286,'Libra'],
  [1912326286,1912507741,'Scorpio'],
  [1912507741,1912687630,'Sagittarius'],
  [1912687630,1912870094,'Capricorn'],
  [1912870094,1913060544,'Aquarius'],
  [1913060544,1913263273,'Pisces'],
  [1913263273,1913477822,'Aries'],
  [1913477822,1913697058,'Taurus'],
  [1913697058,1913911151,'Gemini'],
  [1913911151,1914114448,'Cancer'],
  [1914114448,1914307527,'Leo'],
  [1914307527,1914494250,'Virgo'],
  [1914494250,1914678384,'Libra'],
  [1914678384,1914862050,'Scorpio'],
  [1914862050,1915046308,'Sagittarius'],
  [1915046308,1915232901,'Capricorn'],
  [1915232901,1915425184,'Aquarius'],
  [1915425184,1915627042,'Pisces'],
  [1915627042,1915839811,'Aries'],
  [1915839811,1916058951,'Taurus'],
  [1916058951,1916274900,'Gemini'],
  [1916274900,1916479535,'Cancer'],
  [1916479535,1916671289,'Leo'],
  [1916671289,1916854068,'Virgo'],
  [1916854068,1917033535,'Libra'],
  [1917033535,1917214357,'Scorpio'],
  [1917214357,1917399099,'Sagittarius'],
  [1917399099,1917588846,'Capricorn'],
  [1917588846,1917784675,'Aquarius'],
  [1917784675,1917988273,'Pisces'],
  [1917988273,1918200720,'Aries'],
  [1918200720,1918419643,'Taurus'],
  [1918419643,1918637740,'Gemini'],
  [1918637740,1918846153,'Cancer'],
  [1918846153,1919040376,'Leo'],
  [1919040376,1919222272,'Virgo'],
  [1919222272,1919397516,'Libra'],
  [1919397516,1919572572,'Scorpio'],
  [1919572572,1919752756,'Sagittarius'],
  [1919752756,1919941199,'Capricorn'],
  [1919941199,1920138820,'Aquarius'],
  [1920138820,1920345085,'Pisces'],
  [1920345085,1920558778,'Aries'],
  [1920558778,1920777599,'Taurus'],
  [1920777599,1920996737,'Gemini'],
  [1920996737,1921209142,'Cancer'],
  [1921209142,1921408811,'Leo'],
  [1921408811,1921594446,'Virgo'],
  [1921594446,1921769637,'Libra'],
  [1921769637,1921940683,'Scorpio'],
  [1921940683,1922114520,'Sagittarius'],
  [1922114520,1922297134,'Capricorn'],
  [1922297134,1922491978,'Aquarius'],
  [1922491978,1922698785,'Pisces'],
  [1922698785,1922914063,'Aries'],
  [1922914063,1923133243,'Taurus'],
  [1923133243,1923352001,'Gemini'],
  [1923352001,1923565978,'Cancer'],
  [1923565978,1923770598,'Leo'],
  [1923770598,1923962765,'Virgo'],
  [1923962765,1924142848,'Libra'],
  [1924142848,1924314913,'Scorpio'],
  [1924314913,1924485489,'Sagittarius'],
  [1924485489,1924661920,'Capricorn'],
  [1924661920,1924850490,'Aquarius'],
  [1924850490,1925053813,'Pisces'],
  [1925053813,1925268837,'Aries'],
  [1925268837,1925488567,'Taurus'],
  [1925488567,1925706578,'Gemini'],
  [1925706578,1925919360,'Cancer'],
  [1925919360,1926125090,'Leo'],
  [1926125090,1926321990,'Virgo'],
  [1926321990,1926508819,'Libra'],
  [1926508819,1926686518,'Scorpio'],
  [1926686518,1926859217,'Sagittarius'],
  [1926859217,1927033538,'Capricorn'],
  [1927033538,1927216812,'Aquarius'],
  [1927216812,1927414440,'Pisces'],
  [1927414440,1927626358,'Aries'],
  [1927626358,1927845780,'Taurus'],
  [1927845780,1928063662,'Gemini'],
  [1928063662,1928274646,'Cancer'],
  [1928274646,1928478004,'Leo'],
  [1928478004,1928674661,'Virgo'],
  [1928674661,1928864907,'Libra'],
  [1928864907,1929048603,'Scorpio'],
  [1929048603,1929227057,'Sagittarius'],
  [1929227057,1929404360,'Capricorn'],
  [1929404360,1929586749,'Aquarius'],
  [1929586749,1929780439,'Pisces'],
  [1929780439,1929988173,'Aries'],
  [1929988173,1930205916,'Taurus'],
  [1930205916,1930424207,'Gemini'],
  [1930424207,1930634897,'Cancer'],
  [1930634897,1930835717,'Leo'],
  [1930835717,1931028774,'Virgo'],
  [1931028774,1931216992,'Libra'],
  [1931216992,1931402119,'Scorpio'],
  [1931402119,1931585064,'Sagittarius'],
  [1931585064,1931767576,'Capricorn'],
  [1931767576,1931953295,'Aquarius'],
  [1931953295,1932147039,'Pisces'],
  [1932147039,1932352340,'Aries'],
  [1932352340,1932568001,'Taurus'],
  [1932568001,1932786679,'Gemini'],
  [1932786679,1932998976,'Cancer'],
  [1932998976,1933199789,'Leo'],
  [1933199789,1933389979,'Virgo'],
  [1933389979,1933573620,'Libra'],
  [1933573620,1933755021,'Scorpio'],
  [1933755021,1933937297,'Sagittarius'],
  [1933937297,1934122461,'Capricorn'],
  [1934122461,1934312334,'Aquarius'],
  [1934312334,1934509148,'Pisces'],
  [1934509148,1934714957,'Aries'],
  [1934714957,1934929568,'Taurus'],
  [1934929568,1935148380,'Gemini'],
  [1935148380,1935363195,'Cancer'],
  [1935363195,1935566898,'Leo'],
  [1935566898,1935757628,'Virgo'],
  [1935757628,1935938434,'Libra'],
  [1935938434,1936114700,'Scorpio'],
  [1936114700,1936291981,'Sagittarius'],
  [1936291981,1936474698,'Capricorn'],
  [1936474698,1936665493,'Aquarius'],
  [1936665493,1936865183,'Pisces'],
  [1936865183,1937073301,'Aries'],
  [1937073301,1937288399,'Taurus'],
  [1937288399,1937507236,'Gemini'],
  [1937507236,1937724076,'Cancer'],
  [1937724076,1937932024,'Leo'],
  [1937932024,1938126732,'Virgo'],
  [1938126732,1938308700,'Libra'],
  [1938308700,1938482445,'Scorpio'],
  [1938482445,1938654483,'Sagittarius'],
  [1938654483,1938831484,'Capricorn'],
  [1938831484,1939018619,'Aquarius'],
  [1939018619,1939217914,'Pisces'],
  [1939217914,1939427668,'Aries'],
  [1939427668,1939644041,'Taurus'],
  [1939644041,1939862991,'Gemini'],
  [1939862991,1940080488,'Cancer'],
  [1940080488,1940291700,'Leo'],
  [1940291700,1940491749,'Virgo'],
  [1940491749,1940678478,'Libra'],
  [1940678478,1940854011,'Scorpio'],
  [1940854011,1941024072,'Sagittarius'],
  [1941024072,1941196106,'Capricorn'],
  [1941196106,1941377344,'Aquarius'],
  [1941377344,1941572446,'Pisces'],
  [1941572446,1941781068,'Aries'],
  [1941781068,1941998073,'Taurus'],
  [1941998073,1942217217,'Gemini'],
  [1942217217,1942434176,'Cancer'],
  [1942434176,1942646096,'Leo'],
  [1942646096,1942849813,'Virgo'],
  [1942849813,1943042321,'Libra'],
  [1943042321,1943223104,'Scorpio'],
  [1943223104,1943395590,'Sagittarius'],
  [1943395590,1943566356,'Capricorn'],
  [1943566356,1943743179,'Aquarius'],
  [1943743179,1943932715,'Pisces'],
  [1943932715,1944137364,'Aries'],
  [1944137364,1944353178,'Taurus'],
  [1944353178,1944572326,'Gemini'],
  [1944572326,1944788461,'Cancer'],
  [1944788461,1944998919,'Leo'],
  [1944998919,1945202716,'Virgo'],
  [1945202716,1945398460,'Libra'],
  [1945398460,1945584846,'Scorpio'],
  [1945584846,1945762805,'Sagittarius'],
  [1945762805,1945936610,'Capricorn'],
  [1945936610,1946112923,'Aquarius'],
  [1946112923,1946298783,'Pisces'],
  [1946298783,1946498730,'Aries'],
  [1946498730,1946711593,'Taurus'],
  [1946711593,1946930198,'Gemini'],
  [1946930198,1947146121,'Cancer'],
  [1947146121,1947354853,'Leo'],
  [1947354853,1947556018,'Virgo'],
  [1947556018,1947750589,'Libra'],
  [1947750589,1947939042,'Scorpio'],
  [1947939042,1948121851,'Sagittarius'],
  [1948121851,1948301041,'Capricorn'],
  [1948301041,1948480842,'Aquarius'],
  [1948480842,1948666860,'Pisces'],
  [1948666860,1948864028,'Aries'],
  [1948864028,1949073619,'Taurus'],
  [1949073619,1949291052,'Gemini'],
  [1949291052,1949507680,'Cancer'],
  [1949507680,1949716386,'Leo'],
  [1949716386,1949915148,'Virgo'],
  [1949915148,1950105824,'Libra'],
  [1950105824,1950291430,'Scorpio'],
  [1950291430,1950474551,'Sagittarius'],
  [1950474551,1950657287,'Capricorn'],
  [1950657287,1950841957,'Aquarius'],
  [1950841957,1951031553,'Pisces'],
  [1951031553,1951229323,'Aries'],
  [1951229323,1951437161,'Taurus'],
  [1951437161,1951653228,'Gemini'],
  [1951653228,1951870968,'Cancer'],
  [1951870968,1952082005,'Leo'],
  [1952082005,1952281325,'Virgo'],
  [1952281325,1952469307,'Libra'],
  [1952469307,1952649964,'Scorpio'],
  [1952649964,1952828475,'Sagittarius'],
  [1952828475,1953009429,'Capricorn'],
  [1953009429,1953195899,'Aquarius'],
  [1953195899,1953389355,'Pisces'],
  [1953389355,1953590295,'Aries'],
  [1953590295,1953798860,'Taurus'],
  [1953798860,1954014177,'Gemini'],
  [1954014177,1954232571,'Cancer'],
  [1954232571,1954447023,'Leo'],
  [1954447023,1954650375,'Virgo'],
  [1954650375,1954839836,'Libra'],
  [1954839836,1955018053,'Scorpio'],
  [1955018053,1955191123,'Sagittarius'],
  [1955191123,1955366062,'Capricorn'],
  [1955366062,1955548738,'Aquarius'],
  [1955548738,1955742093,'Pisces'],
  [1955742093,1955945514,'Aries'],
  [1955945514,1956156378,'Taurus'],
  [1956156378,1956372164,'Gemini'],
  [1956372164,1956590487,'Cancer'],
  [1956590487,1956807149,'Leo'],
  [1956807149,1957015644,'Virgo'],
  [1957015644,1957210561,'Libra'],
  [1957210561,1957391378,'Scorpio'],
  [1957391378,1957562854,'Sagittarius'],
  [1957562854,1957732615,'Capricorn'],
  [1957732615,1957908605,'Aquarius'],
  [1957908605,1958096756,'Pisces'],
  [1958096756,1958298518,'Aries'],
  [1958298518,1958510496,'Taurus'],
  [1958510496,1958727475,'Gemini'],
  [1958727475,1958945612,'Cancer'],
  [1958945612,1959162244,'Leo'],
  [1959162244,1959373509,'Virgo'],
  [1959373509,1959574290,'Libra'],
  [1959574290,1959761423,'Scorpio'],
  [1959761423,1959936619,'Sagittarius'],
  [1959936619,1960106022,'Capricorn'],
  [1960106022,1960277720,'Aquarius'],
  [1960277720,1960459371,'Pisces'],
  [1960459371,1960655527,'Aries'],
  [1960655527,1960865157,'Taurus'],
  [1960865157,1961082363,'Gemini'],
  [1961082363,1961300641,'Cancer'],
  [1961300641,1961516131,'Leo'],
  [1961516131,1961726672,'Virgo'],
  [1961726672,1961929662,'Libra'],
  [1961929662,1962122288,'Scorpio'],
  [1962122288,1962303947,'Sagittarius'],
  [1962303947,1962477901,'Capricorn'],
  [1962477901,1962650458,'Aquarius'],
  [1962650458,1962828970,'Pisces'],
  [1962828970,1963019550,'Aries'],
  [1963019550,1963224315,'Taurus'],
  [1963224315,1963439614,'Gemini'],
  [1963439614,1963657938,'Cancer'],
  [1963657938,1963872776,'Leo'],
  [1963872776,1964081110,'Virgo'],
  [1964081110,1964282173,'Libra'],
  [1964282173,1964475655,'Scorpio'],
  [1964475655,1964661583,'Sagittarius'],
  [1964661583,1964841436,'Capricorn'],
  [1964841436,1965018826,'Aquarius'],
  [1965018826,1965199021,'Pisces'],
  [1965199021,1965387573,'Aries'],
  [1965387573,1965588205,'Taurus'],
  [1965588205,1965800347,'Gemini'],
  [1965800347,1966018136,'Cancer'],
  [1966018136,1966233419,'Leo'],
  [1966233419,1966440632,'Virgo'],
  [1966440632,1966638540,'Libra'],
  [1966638540,1966828782,'Scorpio'],
  [1966828782,1967013889,'Sagittarius'],
  [1967013889,1967196324,'Capricorn'],
  [1967196324,1967378504,'Aquarius'],
  [1967378504,1967563205,'Pisces'],
  [1967563205,1967753734,'Aries'],
  [1967753734,1967953263,'Taurus'],
  [1967953263,1968163001,'Gemini'],
  [1968163001,1968379888,'Cancer'],
  [1968379888,1968596430,'Leo'],
  [1968596430,1968804785,'Virgo'],
  [1968804785,1969001414,'Libra'],
  [1969001414,1969187863,'Scorpio'],
  [1969187863,1969368609,'Sagittarius'],
  [1969368609,1969548578,'Capricorn'],
  [1969548578,1969731556,'Aquarius'],
  [1969731556,1969919660,'Pisces'],
  [1969919660,1970113909,'Aries'],
  [1970113909,1970315257,'Taurus'],
  [1970315257,1970524586,'Gemini'],
  [1970524586,1970740825,'Cancer'],
  [1970740825,1970958766,'Leo'],
  [1970958766,1971170122,'Virgo'],
  [1971170122,1971368669,'Libra'],
  [1971368669,1971553991,'Scorpio'],
  [1971553991,1971730704,'Sagittarius'],
  [1971730704,1971905512,'Capricorn'],
  [1971905512,1972084622,'Aquarius'],
  [1972084622,1972271906,'Pisces'],
  [1972271906,1972468149,'Aries'],
  [1972468149,1972672191,'Taurus'],
  [1972672191,1972882860,'Gemini'],
  [1972882860,1973099124,'Cancer'],
  [1973099124,1973317932,'Leo'],
  [1973317932,1973532607,'Virgo'],
  [1973532607,1973735579,'Libra'],
  [1973735579,1973923614,'Scorpio'],
  [1973923614,1974099656,'Sagittarius'],
  [1974099656,1974270553,'Capricorn'],
  [1974270553,1974444042,'Aquarius'],
  [1974444042,1974626434,'Pisces'],
  [1974626434,1974820607,'Aries'],
  [1974820607,1975025435,'Taurus'],
  [1975025435,1975237727,'Gemini'],
  [1975237727,1975454618,'Cancer'],
  [1975454618,1975673542,'Leo'],
  [1975673542,1975890068,'Virgo'],
  [1975890068,1976097625,'Libra'],
  [1976097625,1976291113,'Scorpio'],
  [1976291113,1976470690,'Sagittarius'],
  [1976470690,1976641625,'Capricorn'],
  [1976641625,1976811595,'Aquarius'],
  [1976811595,1976988243,'Pisces'],
  [1976988243,1977176998,'Aries'],
  [1977176998,1977379069,'Taurus'],
  [1977379069,1977591353,'Gemini'],
  [1977591353,1977808885,'Cancer'],
  [1977808885,1978027514,'Leo'],
  [1978027514,1978243759,'Virgo'],
  [1978243759,1978453375,'Libra'],
  [1978453375,1978651934,'Scorpio'],
  [1978651934,1978837588,'Sagittarius'],
  [1978837588,1979012866,'Capricorn'],
  [1979012866,1979183712,'Aquarius'],
  [1979183712,1979357415,'Pisces'],
  [1979357415,1979540676,'Aries'],
  [1979540676,1979737452,'Taurus'],
  [1979737452,1979947065,'Gemini'],
  [1979947065,1980164358,'Cancer'],
  [1980164358,1980382803,'Leo'],
  [1980382803,1980597632,'Virgo'],
  [1980597632,1980806005,'Libra'],
  [1980806005,1981005965,'Scorpio'],
  [1981005965,1981196344,'Sagittarius'],
  [1981196344,1981377839,'Capricorn'],
  [1981377839,1981553662,'Aquarius'],
  [1981553662,1981729041,'Pisces'],
  [1981729041,1981910069,'Aries'],
  [1981910069,1982102070,'Taurus'],
  [1982102070,1982307316,'Gemini'],
  [1982307316,1982522915,'Cancer'],
  [1982522915,1982741466,'Leo'],
  [1982741466,1982955527,'Virgo'],
  [1982955527,1983161304,'Libra'],
  [1983161304,1983358620,'Scorpio'],
  [1983358620,1983548943,'Sagittarius'],
  [1983548943,1983733968,'Capricorn'],
  [1983733968,1983915511,'Aquarius'],
  [1983915511,1984096082,'Pisces'],
  [1984096082,1984279386,'Aries'],
  [1984279386,1984469983,'Taurus'],
  [1984469983,1984671678,'Gemini'],
  [1984671678,1984884655,'Cancer'],
  [1984884655,1985103253,'Leo'],
  [1985103253,1985318279,'Virgo'],
  [1985318279,1985523098,'Libra'],
  [1985523098,1985716894,'Scorpio'],
  [1985716894,1985903055,'Sagittarius'],
  [1985903055,1986086021,'Capricorn'],
  [1986086021,1986269158,'Aquarius'],
  [1986269158,1986454221,'Pisces'],
  [1986454221,1986642338,'Aries'],
  [1986642338,1986835475,'Taurus'],
  [1986835475,1987036589,'Gemini'],
  [1987036589,1987247571,'Cancer'],
  [1987247571,1987465809,'Leo'],
  [1987465809,1987683016,'Virgo'],
  [1987683016,1987890029,'Libra'],
  [1987890029,1988083218,'Scorpio'],
  [1988083218,1988265506,'Sagittarius'],
  [1988265506,1988443090,'Capricorn'],
  [1988443090,1988622091,'Aquarius'],
  [1988622091,1988806435,'Pisces'],
  [1988806435,1988997247,'Aries'],
  [1988997247,1989194243,'Taurus'],
  [1989194243,1989397714,'Gemini'],
  [1989397714,1989608678,'Cancer'],
  [1989608678,1989826419,'Leo'],
  [1989826419,1990045456,'Virgo'],
  [1990045456,1990256653,'Libra'],
  [1990256653,1990453396,'Scorpio'],
  [1990453396,1990635941,'Sagittarius'],
  [1990635941,1990809983,'Capricorn'],
  [1990809983,1990983015,'Aquarius'],
  [1990983015,1991161621,'Pisces'],
  [1991161621,1991349609,'Aries'],
  [1991349609,1991547406,'Taurus'],
  [1991547406,1991753451,'Gemini'],
  [1991753451,1991966109,'Cancer'],
  [1991966109,1992183902,'Leo'],
  [1992183902,1992403421,'Virgo'],
  [1992403421,1992617955,'Libra'],
  [1992617955,1992820282,'Scorpio'],
  [1992820282,1993007583,'Sagittarius'],
  [1993007583,1993183016,'Capricorn'],
  [1993183016,1993353342,'Aquarius'],
  [1993353342,1993526098,'Pisces'],
  [1993526098,1993707599,'Aries'],
  [1993707599,1993901251,'Taurus'],
  [1993901251,1994106695,'Gemini'],
  [1994106695,1994320680,'Cancer'],
  [1994320680,1994539157,'Leo'],
  [1994539157,1994758249,'Virgo'],
  [1994758249,1994973452,'Libra'],
  [1994973452,1995179615,'Scorpio'],
  [1995179615,1995373055,'Sagittarius'],
  [1995373055,1995554031,'Capricorn'],
  [1995554031,1995726793,'Aquarius'],
  [1995726793,1995897853,'Pisces'],
  [1995897853,1996074171,'Aries'],
  [1996074171,1996261531,'Taurus'],
  [1996261531,1996462620,'Gemini'],
  [1996462620,1996675485,'Cancer'],
  [1996675485,1996894374,'Leo'],
  [1996894374,1997113033,'Virgo'],
  [1997113033,1997326919,'Libra'],
  [1997326919,1997533198,'Scorpio'],
  [1997533198,1997730020,'Sagittarius'],
  [1997730020,1997916868,'Capricorn'],
  [1997916868,1998095392,'Aquarius'],
  [1998095392,1998269573,'Pisces'],
  [1998269573,1998445121,'Aries'],
  [1998445121,1998628306,'Taurus'],
  [1998628306,1998824104,'Gemini'],
  [1998824104,1999033501,'Cancer'],
  [1999033501,1999251637,'Leo'],
  [1999251637,1999470231,'Virgo'],
  [1999470231,1999682684,'Libra'],
  [1999682684,1999886597,'Scorpio'],
  [1999886597,2000082485,'Sagittarius'],
  [2000082485,2000271578,'Capricorn'],
  [2000271578,2000455071,'Aquarius'],
  [2000455071,2000634682,'Pisces'],
  [2000634682,2000813613,'Aries'],
  [2000813613,2000996764,'Taurus'],
  [2000996764,2001189547,'Gemini'],
  [2001189547,2001395238,'Cancer'],
  [2001395238,2001611599,'Leo'],
  [2001611599,2001830418,'Virgo'],
  [2001830418,2002042724,'Libra'],
  [2002042724,2002244476,'Scorpio'],
  [2002244476,2002437002,'Sagittarius'],
  [2002437002,2002623855,'Capricorn'],
  [2002623855,2002808073,'Aquarius'],
  [2002808073,2002991349,'Pisces'],
  [2002991349,2003174978,'Aries'],
  [2003174978,2003361422,'Taurus'],
  [2003361422,2003554669,'Gemini'],
  [2003554669,2003758511,'Cancer'],
  [2003758511,2003973098,'Leo'],
  [2003973098,2004192239,'Virgo'],
  [2004192239,2004406037,'Libra'],
  [2004406037,2004607878,'Scorpio'],
  [2004607878,2004797868,'Sagittarius'],
  [2004797868,2004980525,'Capricorn'],
  [2004980525,2005161144,'Aquarius'],
  [2005161144,2005343492,'Pisces'],
  [2005343492,2005529298,'Aries'],
  [2005529298,2005719469,'Taurus'],
  [2005719469,2005915625,'Gemini'],
  [2005915625,2006120142,'Cancer'],
  [2006120142,2006333961,'Leo'],
  [2006333961,2006553345,'Virgo'],
  [2006553345,2006769591,'Libra'],
  [2006769591,2006974255,'Scorpio'],
  [2006974255,2007164848,'Sagittarius'],
  [2007164848,2007344933,'Capricorn'],
  [2007344933,2007520740,'Aquarius'],
  [2007520740,2007698253,'Pisces'],
  [2007698253,2007881553,'Aries'],
  [2007881553,2008072427,'Taurus'],
  [2008072427,2008271238,'Gemini'],
  [2008271238,2008478001,'Cancer'],
  [2008478001,2008692382,'Leo'],
  [2008692382,2008911871,'Virgo'],
  [2008911871,2009130158,'Libra'],
  [2009130158,2009339122,'Scorpio'],
  [2009339122,2009533815,'Sagittarius'],
  [2009533815,2009715253,'Capricorn'],
  [2009715253,2009888754,'Aquarius'],
  [2009888754,2010061115,'Pisces'],
  [2010061115,2010238629,'Aries'],
  [2010238629,2010425704,'Taurus'],
  [2010425704,2010623975,'Gemini'],
  [2010623975,2010832344,'Cancer'],
  [2010832344,2011048051,'Leo'],
  [2011048051,2011267635,'Virgo'],
  [2011267635,2011486484,'Libra'],
  [2011486484,2011698723,'Scorpio'],
  [2011698723,2011899046,'Sagittarius'],
  [2011899046,2012085715,'Capricorn'],
  [2012085715,2012261468,'Aquarius'],
  [2012261468,2012432070,'Pisces'],
  [2012432070,2012604474,'Aries'],
  [2012604474,2012785283,'Taurus'],
  [2012785283,2012978990,'Gemini'],
  [2012978990,2013186047,'Cancer'],
  [2013186047,2013402467,'Leo'],
  [2013402467,2013622296,'Virgo'],
  [2013622296,2013840399,'Libra'],
  [2013840399,2014053009,'Scorpio'],
  [2014053009,2014256937,'Sagittarius'],
  [2014256937,2014449831,'Capricorn'],
  [2014449831,2014631640,'Aquarius'],
  [2014631640,2014805423,'Pisces'],
  [2014805423,2014976890,'Aries'],
  [2014976890,2015153108,'Taurus'],
  [2015153108,2015340725,'Gemini'],
  [2015340725,2015543253,'Cancer'],
  [2015543253,2015758289,'Leo'],
  [2015758289,2015978270,'Virgo'],
  [2015978270,2016195556,'Libra'],
  [2016195556,2016406273,'Scorpio'],
  [2016406273,2016609616,'Sagittarius'],
  [2016609616,2016805363,'Capricorn'],
  [2016805363,2016993073,'Aquarius'],
  [2016993073,2017173207,'Pisces'],
  [2017173207,2017348653,'Aries'],
  [2017348653,2017524947,'Taurus'],
  [2017524947,2017708942,'Gemini'],
  [2017708942,2017906306,'Cancer'],
  [2017906306,2018117828,'Leo'],
  [2018117828,2018337178,'Virgo'],
  [2018337178,2018554574,'Libra'],
  [2018554574,2018763691,'Scorpio'],
  [2018763691,2018963916,'Sagittarius'],
  [2018963916,2019157491,'Capricorn'],
  [2019157491,2019346323,'Aquarius'],
  [2019346323,2019531065,'Pisces'],
  [2019531065,2019712449,'Aries'],
  [2019712449,2019893164,'Taurus'],
  [2019893164,2020078183,'Gemini'],
  [2020078183,2020273138,'Cancer'],
  [2020273138,2020481083,'Leo'],
  [2020481083,2020698818,'Virgo'],
  [2020698818,2020917063,'Libra'],
  [2020917063,2021126820,'Scorpio'],
  [2021126820,2021325160,'Sagittarius'],
  [2021325160,2021514627,'Capricorn'],
  [2021514627,2021699510,'Aquarius'],
  [2021699510,2021883104,'Pisces'],
  [2021883104,2022067066,'Aries'],
  [2022067066,2022252585,'Taurus'],
  [2022252585,2022441889,'Gemini'],
  [2022441889,2022638419,'Cancer'],
  [2022638419,2022845108,'Leo'],
  [2022845108,2023061199,'Virgo'],
  [2023061199,2023280168,'Libra'],
  [2023280168,2023492592,'Scorpio'],
  [2023492592,2023692523,'Sagittarius'],
  [2023692523,2023880358,'Capricorn'],
  [2023880358,2024060630,'Aquarius'],
  [2024060630,2024238838,'Pisces'],
  [2024238838,2024419470,'Aries'],
  [2024419470,2024605314,'Taurus'],
  [2024605314,2024797820,'Gemini'],
  [2024797820,2024997877,'Cancer'],
  [2024997877,2025206094,'Leo'],
  [2025206094,2025421748,'Virgo'],
  [2025421748,2025640876,'Libra'],
  [2025640876,2025856175,'Scorpio'],
  [2025856175,2026060432,'Sagittarius'],
  [2026060432,2026250927,'Capricorn'],
  [2026250927,2026430193,'Aquarius'],
  [2026430193,2026603856,'Pisces'],
  [2026603856,2026778353,'Aries'],
  [2026778353,2026959305,'Taurus'],
  [2026959305,2027150257,'Gemini'],
  [2027150257,2027351900,'Cancer'],
  [2027351900,2027562468,'Leo'],
  [2027562468,2027779053,'Virgo'],
  [2027779053,2027998078,'Libra'],
  [2027998078,2028214788,'Scorpio'],
  [2028214788,2028423361,'Sagittarius'],
  [2028423361,2028619312,'Capricorn'],
  [2028619312,2028802142,'Aquarius'],
  [2028802142,2028975584,'Pisces'],
  [2028975584,2029146079,'Aries'],
  [2029146079,2029320882,'Taurus'],
  [2029320882,2029506248,'Gemini'],
  [2029506248,2029705248,'Cancer'],
  [2029705248,2029916182,'Leo'],
  [2029916182,2030133871,'Virgo'],
  [2030133871,2030352917,'Libra'],
  [2030352917,2030569360,'Scorpio'],
  [2030569360,2030779800,'Sagittarius'],
  [2030779800,2030980596,'Capricorn'],
  [2030980596,2031169365,'Aquarius'],
  [2031169365,2031346975,'Pisces'],
  [2031346975,2031518056,'Aries'],
  [2031518056,2031689685,'Taurus'],
  [2031689685,2031869447,'Gemini'],
  [2031869447,2032063027,'Cancer'],
  [2032063027,2032271169,'Leo'],
  [2032271169,2032488628,'Virgo'],
  [2032488628,2032707754,'Libra'],
  [2032707754,2032923206,'Scorpio'],
  [2032923206,2033132763,'Sagittarius'],
  [2033132763,2033335067,'Capricorn'],
  [2033335067,2033528385,'Aquarius'],
  [2033528385,2033711844,'Pisces'],
  [2033711844,2033887413,'Aries'],
  [2033887413,2034060353,'Taurus'],
  [2034060353,2034237837,'Gemini'],
  [2034237837,2034426715,'Cancer'],
  [2034426715,2034630366,'Leo'],
  [2034630366,2034845772,'Virgo'],
  [2034845772,2035064716,'Libra'],
  [2035064716,2035279550,'Scorpio'],
  [2035279550,2035487118,'Sagittarius'],
  [2035487118,2035687545,'Capricorn'],
  [2035687545,2035881358,'Aquarius'],
  [2035881358,2036068451,'Pisces'],
  [2036068451,2036249342,'Aries'],
  [2036249342,2036426832,'Taurus'],
  [2036426832,2036606159,'Gemini'],
  [2036606159,2036793565,'Cancer'],
  [2036793565,2036993671,'Leo'],
  [2036993671,2037206167,'Virgo'],
  [2037206167,2037424505,'Libra'],
  [2037424505,2037639700,'Scorpio'],
  [2037639700,2037846255,'Sagittarius'],
  [2037846255,2038043775,'Capricorn'],
  [2038043775,2038234485,'Aquarius'],
  [2038234485,2038420643,'Pisces'],
  [2038420643,2038603821,'Aries'],
  [2038603821,2038785767,'Taurus'],
  [2038785767,2038969421,'Gemini'],
  [2038969421,2039158907,'Cancer'],
  [2039158907,2039358196,'Leo'],
  [2039358196,2039568528,'Virgo'],
  [2039568528,2039786027,'Libra'],
  [2039786027,2040002483,'Scorpio'],
  [2040002483,2040210250,'Sagittarius'],
  [2040210250,2040406653,'Capricorn'],
  [2040406653,2040593710,'Aquarius'],
  [2040593710,2040775505,'Pisces'],
  [2040775505,2040956117,'Aries'],
  [2040956117,2041138736,'Taurus'],
  [2041138736,2041325711,'Gemini'],
  [2041325711,2041518971,'Cancer'],
  [2041518971,2041720212,'Leo'],
  [2041720212,2041930215,'Virgo'],
  [2041930215,2042147068,'Libra'],
  [2042147068,2042364962,'Scorpio'],
  [2042364962,2042575958,'Sagittarius'],
  [2042575958,2042774609,'Capricorn'],
  [2042774609,2042960761,'Aquarius'],
  [2042960761,2043138468,'Pisces'],
  [2043138468,2043313638,'Aries'],
  [2043313638,2043492074,'Taurus'],
  [2043492074,2043678026,'Gemini'],
  [2043678026,2043873298,'Cancer'],
  [2043873298,2044077427,'Leo'],
  [2044077427,2044288888,'Virgo'],
  [2044288888,2044505686,'Libra'],
  [2044505686,2044724327,'Scorpio'],
  [2044724327,2044938809,'Sagittarius'],
  [2044938809,2045142449,'Capricorn'],
  [2045142449,2045331978,'Aquarius'],
  [2045331978,2045509363,'Pisces'],
  [2045509363,2045680497,'Aries'],
  [2045680497,2045852830,'Taurus'],
  [2045852830,2046033263,'Gemini'],
  [2046033263,2046225992,'Cancer'],
  [2046225992,2046430829,'Leo'],
  [2046430829,2046644085,'Virgo'],
  [2046644085,2046861545,'Libra'],
  [2046861545,2047080041,'Scorpio'],
  [2047080041,2047296108,'Sagittarius'],
  [2047296108,2047504543,'Capricorn'],
  [2047504543,2047700328,'Aquarius'],
  [2047700328,2047882204,'Pisces'],
  [2047882204,2048053994,'Aries'],
  [2048053994,2048222925,'Taurus'],
  [2048222925,2048397197,'Gemini'],
  [2048397197,2048583673,'Cancer'],
  [2048583673,2048784993,'Leo'],
  [2048784993,2048997985,'Virgo'],
  [2048997985,2049216198,'Libra'],
  [2049216198,2049434350,'Scorpio'],
  [2049434350,2049649653,'Sagittarius'],
  [2049649653,2049859548,'Capricorn'],
  [2049859548,2050060324,'Aquarius'],
  [2050060324,2050248982,'Pisces'],
  [2050248982,2050426201,'Aries'],
  [2050426201,2050597008,'Taurus'],
  [2050597008,2050768958,'Gemini'],
  [2050768958,2050949855,'Cancer'],
  [2050949855,2051145073,'Leo'],
  [2051145073,2051354521,'Virgo'],
  [2051354521,2051572208,'Libra'],
  [2051572208,2051790391,'Scorpio'],
  [2051790391,2052004288,'Sagittarius'],
  [2052004288,2052212278,'Capricorn'],
  [2052212278,2052413363,'Aquarius'],
  [2052413363,2052606040,'Pisces'],
  [2052606040,2052789671,'Aries'],
  [2052789671,2052966393,'Taurus'],
  [2052966393,2053141305,'Gemini'],
  [2053141305,2053321073,'Cancer'],
  [2053321073,2053511812,'Leo'],
  [2053511812,2053716298,'Virgo'],
  [2053716298,2053931555,'Libra'],
  [2053931555,2054149793,'Scorpio'],
  [2054149793,2054363465,'Sagittarius'],
  [2054363465,2054569152,'Capricorn'],
  [2054569152,2054766961,'Aquarius'],
  [2054766961,2054958160,'Pisces'],
  [2054958160,2055143957,'Aries'],
  [2055143957,2055325850,'Taurus'],
  [2055325850,2055506450,'Gemini'],
  [2055506450,2055689732,'Cancer'],
  [2055689732,2055880316,'Leo'],
  [2055880316,2056081740,'Virgo'],
  [2056081740,2056293978,'Libra'],
  [2056293978,2056511770,'Scorpio'],
  [2056511770,2056726682,'Sagittarius'],
  [2056726682,2056932334,'Capricorn'],
  [2056932334,2057127310,'Aquarius'],
  [2057127310,2057314072,'Pisces'],
  [2057314072,2057496551,'Aries'],
  [2057496551,2057678405,'Taurus'],
  [2057678405,2057862353,'Gemini'],
  [2057862353,2058050374,'Cancer'],
  [2058050374,2058244331,'Leo'],
  [2058244331,2058446173,'Virgo'],
  [2058446173,2058656809,'Libra'],
  [2058656809,2058873858,'Scorpio'],
  [2058873858,2059090567,'Sagittarius'],
  [2059090567,2059298820,'Capricorn'],
  [2059298820,2059494253,'Aquarius'],
  [2059494253,2059678123,'Pisces'],
  [2059678123,2059855522,'Aries'],
  [2059855522,2060032616,'Taurus'],
  [2060032616,2060214509,'Gemini'],
  [2060214509,2060403947,'Cancer'],
  [2060403947,2060601267,'Leo'],
  [2060601267,2060805779,'Virgo'],
  [2060805779,2061016969,'Libra'],
  [2061016969,2061233638,'Scorpio'],
  [2061233638,2061451654,'Sagittarius'],
  [2061451654,2061663609,'Capricorn'],
  [2061663609,2061862823,'Aquarius'],
  [2061862823,2062047804,'Pisces'],
  [2062047804,2062222695,'Aries'],
  [2062222695,2062394620,'Taurus'],
  [2062394620,2062570892,'Gemini'],
  [2062570892,2062756807,'Cancer'],
  [2062756807,2062953944,'Leo'],
  [2062953944,2063160419,'Virgo'],
  [2063160419,2063373285,'Libra'],
  [2063373285,2063590252,'Scorpio'],
  [2063590252,2063808647,'Sagittarius'],
  [2063808647,2064023309,'Capricorn'],
  [2064023309,2064227474,'Aquarius'],
  [2064227474,2064417097,'Pisces'],
  [2064417097,2064593830,'Aries'],
  [2064593830,2064763921,'Taurus'],
  [2064763921,2064935334,'Gemini'],
  [2064935334,2065115338,'Cancer'],
  [2065115338,2065308196,'Leo'],
  [2065308196,2065513505,'Virgo'],
  [2065513505,2065727230,'Libra'],
  [2065727230,2065944817,'Scorpio'],
  [2065944817,2066162922,'Sagittarius'],
  [2066162922,2066378109,'Capricorn'],
  [2066378109,2066585541,'Aquarius'],
  [2066585541,2066780671,'Pisces'],
  [2066780671,2066962606,'Aries'],
  [2066962606,2067135267,'Taurus'],
  [2067135267,2067305609,'Gemini'],
  [2067305609,2067481280,'Cancer'],
  [2067481280,2067668457,'Leo'],
  [2067668457,2067869517,'Virgo'],
  [2067869517,2068081861,'Libra'],
  [2068081861,2068299638,'Scorpio'],
  [2068299638,2068517345,'Sagittarius'],
  [2068517345,2068731346,'Capricorn'],
  [2068731346,2068938797,'Aquarius'],
  [2068938797,2069136951,'Pisces'],
  [2069136951,2069324334,'Aries'],
  [2069324334,2069502474,'Taurus'],
  [2069502474,2069675993,'Gemini'],
  [2069675993,2069851285,'Cancer'],
  [2069851285,2070034787,'Leo'],
  [2070034787,2070230918,'Virgo'],
  [2070230918,2070439872,'Libra'],
  [2070439872,2070656819,'Scorpio'],
  [2070656819,2070874447,'Sagittarius'],
  [2070874447,2071087102,'Capricorn'],
  [2071087102,2071292228,'Aquarius'],
  [2071292228,2071489346,'Pisces'],
  [2071489346,2071678820,'Aries'],
  [2071678820,2071861798,'Taurus'],
  [2071861798,2072040735,'Gemini'],
  [2072040735,2072219566,'Cancer'],
  [2072219566,2072403242,'Leo'],
  [2072403242,2072596508,'Virgo'],
  [2072596508,2072801833,'Libra'],
  [2072801833,2073017027,'Scorpio'],
  [2073017027,2073234971,'Sagittarius'],
  [2073234971,2073447609,'Capricorn'],
  [2073447609,2073650598,'Aquarius'],
  [2073650598,2073844188,'Pisces'],
  [2073844188,2074031188,'Aries'],
  [2074031188,2074214756,'Taurus'],
  [2074214756,2074397404,'Gemini'],
  [2074397404,2074581170,'Cancer'],
  [2074581170,2074768412,'Leo'],
  [2074768412,2074962258,'Virgo'],
  [2074962258,2075165691,'Libra'],
  [2075165691,2075379041,'Scorpio'],
  [2075379041,2075597413,'Sagittarius'],
  [2075597413,2075811880,'Capricorn'],
  [2075811880,2076015248,'Aquarius'],
  [2076015248,2076206267,'Pisces'],
  [2076206267,2076388708,'Aries'],
  [2076388708,2076568182,'Taurus'],
  [2076568182,2076749521,'Gemini'],
  [2076749521,2076935415,'Cancer'],
  [2076935415,2077126658,'Leo'],
  [2077126658,2077323732,'Virgo'],
  [2077323732,2077527958,'Libra'],
  [2077527958,2077740431,'Scorpio'],
  [2077740431,2077958960,'Sagittarius'],
  [2077958960,2078176173,'Capricorn'],
  [2078176173,2078383025,'Aquarius'],
  [2078383025,2078575207,'Pisces'],
  [2078575207,2078755198,'Aries'],
  [2078755198,2078929499,'Taurus'],
  [2078929499,2079105252,'Gemini'],
  [2079105252,2079287832,'Cancer'],
  [2079287832,2079479362,'Leo'],
  [2079479362,2079679163,'Virgo'],
  [2079679163,2079885929,'Libra'],
  [2079885929,2080099088,'Scorpio'],
  [2080099088,2080317516,'Sagittarius'],
  [2080317516,2080536603,'Capricorn'],
  [2080536603,2080748152,'Aquarius'],
  [2080748152,2080945367,'Pisces'],
  [2080945367,2081127656,'Aries'],
  [2081127656,2081300233,'Taurus'],
  [2081300233,2081470797,'Gemini'],
  [2081470797,2081646801,'Cancer'],
  [2081646801,2081833362,'Leo'],
  [2081833362,2082031760,'Virgo'],
  [2082031760,2082239930,'Libra'],
  [2082239930,2082454665,'Scorpio'],
  [2082454665,2082673237,'Sagittarius'],
  [2082673237,2082892417,'Capricorn'],
  [2082892417,2083106726,'Aquarius'],
  [2083106726,2083309759,'Pisces'],
  [2083309759,2083498251,'Aries'],
  [2083498251,2083674394,'Taurus'],
  [2083674394,2083844372,'Gemini'],
  [2083844372,2084015766,'Cancer'],
  [2084015766,2084195545,'Leo'],
  [2084195545,2084388166,'Virgo'],
  [2084388166,2084593941,'Libra'],
  [2084593941,2084809094,'Scorpio'],
  [2084809094,2085028175,'Sagittarius'],
  [2085028175,2085246548,'Capricorn'],
  [2085246548,2085460392,'Aquarius'],
  [2085460392,2085665966,'Pisces'],
  [2085665966,2085860315,'Aries'],
  [2085860315,2086043178,'Taurus'],
  [2086043178,2086217749,'Gemini'],
  [2086217749,2086389745,'Cancer'],
  [2086389745,2086565904,'Leo'],
  [2086565904,2086752391,'Virgo'],
  [2086752391,2086952732,'Libra'],
  [2086952732,2087165586,'Scorpio'],
  [2087165586,2087384702,'Sagittarius'],
  [2087384702,2087602659,'Capricorn'],
  [2087602659,2087814558,'Aquarius'],
  [2087814558,2088018537,'Pisces'],
  [2088018537,2088214253,'Aries'],
  [2088214253,2088401983,'Taurus'],
  [2088401983,2088582961,'Gemini'],
  [2088582961,2088759996,'Cancer'],
  [2088759996,2088937680,'Leo'],
  [2088937680,2089121718,'Virgo'],
  [2089121718,2089317265,'Libra'],
  [2089317265,2089526120,'Scorpio'],
  [2089526120,2089744064,'Sagittarius'],
  [2089744064,2089962293,'Capricorn'],
  [2089962293,2090173189,'Aquarius'],
  [2090173189,2090374228,'Pisces'],
  [2090374228,2090567035,'Aries'],
  [2090567035,2090754425,'Taurus'],
  [2090754425,2090938580,'Gemini'],
  [2090938580,2091120960,'Cancer'],
  [2091120960,2091303465,'Leo'],
  [2091303465,2091489532,'Virgo'],
  [2091489532,2091683739,'Libra'],
  [2091683739,2091889518,'Scorpio'],
  [2091889518,2092105602,'Sagittarius'],
  [2092105602,2092324383,'Capricorn'],
  [2092324383,2092536218,'Aquarius'],
  [2092536218,2092736089,'Pisces'],
  [2092736089,2092925334,'Aries'],
  [2092925334,2093108641,'Taurus'],
  [2093108641,2093290677,'Gemini'],
  [2093290677,2093474298,'Cancer'],
  [2093474298,2093660660,'Leo'],
  [2093660660,2093850827,'Virgo'],
  [2093850827,2094047115,'Libra'],
  [2094047115,2094252393,'Scorpio'],
  [2094252393,2094467164,'Sagittarius'],
  [2094467164,2094686394,'Capricorn'],
  [2094686394,2094900604,'Aquarius'],
  [2094900604,2095102275,'Pisces'],
  [2095102275,2095290576,'Aries'],
  [2095290576,2095470096,'Taurus'],
  [2095470096,2095647177,'Gemini'],
  [2095647177,2095827147,'Cancer'],
  [2095827147,2096012959,'Leo'],
  [2096012959,2096205447,'Virgo'],
  [2096205447,2096404848,'Libra'],
  [2096404848,2096611838,'Scorpio'],
  [2096611838,2096826582,'Sagittarius'],
  [2096826582,2097046027,'Capricorn'],
  [2097046027,2097262714,'Aquarius'],
  [2097262714,2097468332,'Pisces'],
  [2097468332,2097659328,'Aries'],
  [2097659328,2097838395,'Taurus'],
  [2097838395,2098011772,'Gemini'],
  [2098011772,2098186266,'Cancer'],
  [2098186266,2098367318,'Leo'],
  [2098367318,2098557866,'Virgo'],
  [2098557866,2098758286,'Libra'],
  [2098758286,2098967318,'Scorpio'],
  [2098967318,2099183066,'Sagittarius'],
  [2099183066,2099402574,'Capricorn'],
  [2099402574,2099620544,'Aquarius'],
  [2099620544,2099830095,'Pisces'],
  [2099830095,2100026203,'Aries'],
  [2100026203,2100208809,'Taurus'],
  [2100208809,2100382354,'Gemini'],
  [2100382354,2100553441,'Cancer'],
  [2100553441,2100728857,'Leo'],
  [2100728857,2100914064,'Virgo'],
  [2100914064,2101111743,'Libra'],
  [2101111743,2101320909,'Scorpio'],
  [2101320909,2101537659,'Sagittarius'],
  [2101537659,2101757225,'Capricorn'],
  [2101757225,2101974932,'Aquarius'],
  [2101974932,2102186197,'Pisces'],
  [2102186197,2102386960,'Aries'],
  [2102386960,2102575396,'Taurus'],
  [2102575396,2102753200,'Gemini'],
  [2102753200,2102925114,'Cancer'],
  [2102925114,2103097600,'Leo'],
  [2103097600,2103277401,'Virgo'],
  [2103277401,2103469774,'Libra'],
  [2103469774,2103676134,'Scorpio'],
  [2103676134,2103892640,'Sagittarius'],
  [2103892640,2104112294,'Capricorn'],
  [2104112294,2104328961,'Aquarius'],
  [2104328961,2104539198,'Pisces'],
  [2104539198,2104741344,'Aries'],
  [2104741344,2104934356,'Taurus'],
  [2104934356,2105118209,'Gemini'],
  [2105118209,2105294898,'Cancer'],
  [2105294898,2105468878,'Leo'],
  [2105468878,2105646419,'Virgo'],
  [2105646419,2105834032,'Libra'],
  [2105834032,2106035824,'Scorpio'],
  [2106035824,2106250268,'Sagittarius'],
  [2106250268,2106469838,'Capricorn'],
  [2106469838,2106685917,'Aquarius'],
  [2106685917,2106893986,'Pisces'],
  [2106893986,2107093935,'Aries'],
  [2107093935,2107287208,'Taurus'],
  [2107287208,2107474744,'Gemini'],
  [2107474744,2107657122,'Cancer'],
  [2107657122,2107836104,'Leo'],
  [2107836104,2108015765,'Virgo'],
  [2108015765,2108201940,'Libra'],
  [2108201940,2108400031,'Scorpio'],
  [2108400031,2108611380,'Sagittarius'],
  [2108611380,2108830389,'Capricorn'],
  [2108830389,2109047089,'Aquarius'],
  [2109047089,2109254282,'Pisces'],
  [2109254282,2109451113,'Aries'],
  [2109451113,2109640758,'Taurus'],
  [2109640758,2109826778,'Gemini'],
  [2109826778,2110011192,'Cancer'],
  [2110011192,2110194869,'Leo'],
  [2110194869,2110379358,'Virgo'],
  [2110379358,2110568084,'Libra'],
  [2110568084,2110765555,'Scorpio'],
  [2110765555,2110974584,'Sagittarius'],
  [2110974584,2111192563,'Capricorn'],
  [2111192563,2111410741,'Aquarius'],
  [2111410741,2111619731,'Pisces'],
  [2111619731,2111815923,'Aries'],
  [2111815923,2112001904,'Taurus'],
  [2112001904,2112182913,'Gemini'],
  [2112182913,2112363737,'Cancer'],
  [2112363737,2112547285,'Leo'],
  [2112547285,2112734905,'Virgo'],
  [2112734905,2112927789,'Libra'],
  [2112927789,2113127822,'Scorpio'],
  [2113127822,2113336815,'Sagittarius'],
  [2113336815,2113553923,'Capricorn'],
  [2113553923,2113773312,'Aquarius'],
  [2113773312,2113985941,'Pisces'],
  [2113985941,2114185372,'Aries'],
  [2114185372,2114371457,'Taurus'],
  [2114371457,2114548813,'Gemini'],
  [2114548813,2114723696,'Cancer'],
  [2114723696,2114901815,'Leo'],
  [2114901815,2115087093,'Virgo'],
  [2115087093,2115281272,'Libra'],
  [2115281272,2115484341,'Scorpio'],
  [2115484341,2115695357,'Sagittarius'],
  [2115695357,2115912572,'Capricorn'],
  [2115912572,2116132216,'Aquarius'],
  [2116132216,2116347880,'Pisces'],
  [2116347880,2116552698,'Aries'],
  [2116552698,2116743406,'Taurus'],
  [2116743406,2116921907,'Gemini'],
  [2116921907,2117093705,'Cancer'],
  [2117093705,2117265694,'Leo'],
  [2117265694,2117444449,'Virgo'],
  [2117444449,2117634622,'Libra'],
  [2117634622,2117837379,'Scorpio'],
  [2117837379,2118050121,'Sagittarius'],
  [2118050121,2118268374,'Capricorn'],
  [2118268374,2118487758,'Aquarius'],
  [2118487758,2118704131,'Pisces'],
  [2118704131,2118912873,'Aries'],
  [2118912873,2119109886,'Taurus'],
  [2119109886,2119293988,'Gemini'],
  [2119293988,2119467988,'Cancer'],
  [2119467988,2119637869,'Leo'],
  [2119637869,2119811057,'Virgo'],
  [2119811057,2119994586,'Libra'],
  [2119994586,2120192682,'Scorpio'],
  [2120192682,2120404215,'Sagittarius'],
  [2120404215,2120623086,'Capricorn'],
  [2120623086,2120842376,'Aquarius'],
  [2120842376,2121057715,'Pisces'],
  [2121057715,2121266826,'Aries'],
  [2121266826,2121467547,'Taurus'],
  [2121467547,2121657907,'Gemini'],
  [2121657907,2121837881,'Cancer'],
  [2121837881,2122010820,'Leo'],
  [2122010820,2122183032,'Virgo'],
  [2122183032,2122362045,'Libra'],
  [2122362045,2122554259,'Scorpio'],
  [2122554259,2122761619,'Sagittarius'],
  [2122761619,2122979321,'Capricorn'],
  [2122979321,2123198616,'Aquarius'],
  [2123198616,2123412865,'Pisces'],
  [2123412865,2123619959,'Aries'],
  [2123619959,2123820054,'Taurus'],
  [2123820054,2124013033,'Gemini'],
  [2124013033,2124198410,'Cancer'],
  [2124198410,2124377104,'Leo'],
  [2124377104,2124552884,'Virgo'],
  [2124552884,2124731907,'Libra'],
  [2124731907,2124920815,'Scorpio'],
  [2124920815,2125123708,'Sagittarius'],
  [2125123708,2125338693,'Capricorn'],
  [2125338693,2125557679,'Aquarius'],
  [2125557679,2125771840,'Pisces'],
  [2125771840,2125977126,'Aries'],
  [2125977126,2126174190,'Taurus'],
  [2126174190,2126365201,'Gemini'],
  [2126365201,2126551638,'Cancer'],
  [2126551638,2126734389,'Leo'],
  [2126734389,2126915251,'Virgo'],
  [2126915251,2127097929,'Libra'],
  [2127097929,2127287479,'Scorpio'],
  [2127287479,2127488223,'Sagittarius'],
  [2127488223,2127700566,'Capricorn'],
  [2127700566,2127918891,'Aquarius'],
  [2127918891,2128134068,'Pisces'],
  [2128134068,2128339540,'Aries'],
  [2128339540,2128534378,'Taurus'],
  [2128534378,2128721459,'Gemini'],
  [2128721459,2128904546,'Cancer'],
  [2128904546,2129086666,'Leo'],
  [2129086666,2129270041,'Virgo'],
  [2129270041,2129456840,'Libra'],
  [2129456840,2129649710,'Scorpio'],
  [2129649710,2129851314,'Sagittarius'],
  [2129851314,2130062541,'Capricorn'],
  [2130062541,2130280220,'Aquarius'],
  [2130280220,2130496956,'Pisces'],
  [2130496956,2130704874,'Aries'],
  [2130704874,2130900386,'Taurus'],
  [2130900386,2131085097,'Gemini'],
  [2131085097,2131263592,'Cancer'],
  [2131263592,2131441154,'Leo'],
  [2131441154,2131622310,'Virgo'],
  [2131622310,2131810104,'Libra'],
  [2131810104,2132005984,'Scorpio'],
  [2132005984,2132210204,'Sagittarius'],
  [2132210204,2132422148,'Capricorn'],
  [2132422148,2132639582,'Aquarius'],
  [2132639582,2132857561,'Pisces'],
  [2132857561,2133069036,'Aries'],
  [2133069036,2133268303,'Taurus'],
  [2133268303,2133454305,'Gemini'],
  [2133454305,2133630561,'Cancer'],
  [2133630561,2133803196,'Leo'],
  [2133803196,2133978895,'Virgo'],
  [2133978895,2134163170,'Libra'],
  [2134163170,2134358738,'Scorpio'],
  [2134358738,2134564825,'Sagittarius'],
  [2134564825,2134778419,'Capricorn'],
  [2134778419,2134996144,'Aquarius'],
  [2134996144,2135214462,'Pisces'],
  [2135214462,2135428619,'Aries'],
  [2135428619,2135632929,'Taurus'],
  [2135632929,2135823774,'Gemini'],
  [2135823774,2136002048,'Cancer'],
  [2136002048,2136172898,'Leo'],
  [2136172898,2136343719,'Virgo'],
  [2136343719,2136522042,'Libra'],
  [2136522042,2136713249,'Scorpio'],
  [2136713249,2136918116,'Sagittarius'],
  [2136918116,2137132572,'Capricorn'],
  [2137132572,2137350882,'Aquarius'],
  [2137350882,2137568787,'Pisces'],
  [2137568787,2137783341,'Aries'],
  [2137783341,2137990967,'Taurus'],
  [2137990967,2138187642,'Gemini'],
  [2138187642,2138371572,'Cancer'],
  [2138371572,2138545294,'Leo'],
  [2138545294,2138715117,'Virgo'],
  [2138715117,2138889000,'Libra'],
  [2138889000,2139074262,'Scorpio'],
  [2139074262,2139274586,'Sagittarius'],
  [2139274586,2139487533,'Capricorn'],
  [2139487533,2139706059,'Aquarius'],
  [2139706059,2139923528,'Pisces'],
  [2139923528,2140136658,'Aries'],
  [2140136658,2140343991,'Taurus'],
  [2140343991,2140543599,'Gemini'],
  [2140543599,2140733329,'Cancer'],
  [2140733329,2140913155,'Leo'],
  [2140913155,2141086738,'Virgo'],
  [2141086738,2141260615,'Libra'],
  [2141260615,2141442212,'Scorpio'],
  [2141442212,2141637213,'Sagittarius'],
  [2141637213,2141846307,'Capricorn'],
  [2141846307,2142063860,'Aquarius'],
  [2142063860,2142281419,'Pisces'],
  [2142281419,2142493270,'Aries'],
  [2142493270,2142697938,'Taurus'],
  [2142697938,2142895832,'Gemini'],
  [2142895832,2143087118,'Cancer'],
  [2143087118,2143271828,'Leo'],
  [2143271828,2143451423,'Virgo'],
  [2143451423,2143629704,'Libra'],
  [2143629704,2143812227,'Scorpio'],
  [2143812227,2144004567,'Sagittarius'],
  [2144004567,2144209633,'Capricorn'],
  [2144209633,2144424967,'Aquarius'],
  [2144424967,2144642907,'Pisces'],
  [2144642907,2144855273,'Aries'],
  [2144855273,2145058170,'Taurus'],
  [2145058170,2145252198,'Gemini'],
  [2145252198,2145439975,'Cancer'],
  [2145439975,2145624151,'Leo'],
  [2145624151,2145806895,'Virgo'],
  [2145806895,2145990383,'Libra'],
  [2145990383,2146177389,'Scorpio'],
  [2146177389,2146371243,'Sagittarius'],
  [2146371243,2146574728,'Capricorn'],
  [2146574728,2146787849,'Aquarius'],
  [2146787849,2147005866,'Pisces'],
  [2147005866,2147220461,'Aries'],
  [2147220461,2147424736,'Taurus'],
  [2147424736,2147616982,'Gemini'],
  [2147616982,2147800112,'Cancer'],
  [2147800112,2147979158,'Leo'],
  [2147979158,2148159088,'Virgo'],
  [2148159088,2148343507,'Libra'],
  [2148343507,2148534255,'Scorpio'],
  [2148534255,2148731975,'Sagittarius'],
  [2148731975,2148937058,'Capricorn'],
  [2148937058,2149149528,'Aquarius'],
  [2149149528,2149367247,'Pisces'],
  [2149367247,2149584255,'Aries'],
  [2149584255,2149792585,'Taurus'],
  [2149792585,2149987267,'Gemini'],
  [2149987267,2150169103,'Cancer'],
  [2150169103,2150343408,'Leo'],
  [2150343408,2150517222,'Virgo'],
  [2150517222,2150696950,'Libra'],
  [2150696950,2150886488,'Scorpio'],
  [2150886488,2151086205,'Sagittarius'],
  [2151086205,2151294023,'Capricorn'],
  [2151294023,2151507676,'Aquarius'],
  [2151507676,2151725277,'Pisces'],
  [2151725277,2151943464,'Aries'],
  [2151943464,2152155929,'Taurus'],
  [2152155929,2152356012,'Gemini'],
  [2152356012,2152541293,'Cancer'],
  [2152541293,2152715182,'Leo'],
  [2152715182,2152884816,'Virgo'],
  [2152884816,2153058217,'Libra'],
  [2153058217,2153241993,'Scorpio'],
  [2153241993,2153438995,'Sagittarius'],
  [2153438995,2153647320,'Capricorn'],
  [2153647320,2153862450,'Aquarius'],
  [2153862450,2154080451,'Pisces'],
  [2154080451,2154298510,'Aries'],
  [2154298510,2154512802,'Taurus'],
  [2154512802,2154717774,'Gemini'],
  [2154717774,2154909122,'Cancer'],
  [2154909122,2155087261,'Leo'],
  [2155087261,2155257508,'Virgo'],
  [2155257508,2155427650,'Libra'],
  [2155427650,2155605511,'Scorpio'],
  [2155605511,2155796601,'Sagittarius'],
  [2155796601,2156001683,'Capricorn'],
  [2156001683,2156216501,'Aquarius'],
  [2156216501,2156434920,'Pisces'],
  [2156434920,2156652400,'Aries'],
  [2156652400,2156866006,'Taurus'],
  [2156866006,2157072560,'Gemini'],
  [2157072560,2157268630,'Cancer'],
  [2157268630,2157452867,'Leo'],
  [2157452867,2157627865,'Virgo'],
  [2157627865,2157799514,'Libra'],
  [2157799514,2157975060,'Scorpio'],
  [2157975060,2158161053,'Sagittarius'],
  [2158161053,2158360940,'Capricorn'],
  [2158360940,2158573032,'Aquarius'],
  [2158573032,2158791084,'Pisces'],
  [2158791084,2159008236,'Aries'],
  [2159008236,2159220224,'Taurus'],
  [2159220224,2159425115,'Gemini'],
  [2159425115,2159621847,'Cancer'],
  [2159621847,2159809956,'Leo'],
  [2159809956,2159990579,'Virgo'],
  [2159990579,2160167107,'Libra'],
  [2160167107,2160344723,'Scorpio'],
  [2160344723,2160529198,'Sagittarius'],
  [2160529198,2160725090,'Capricorn'],
  [2160725090,2160933446,'Aquarius'],
  [2160933446,2161150141,'Pisces'],
  [2161150141,2161367436,'Aries'],
  [2161367436,2161578633,'Taurus'],
  [2161578633,2161780927,'Gemini'],
  [2161780927,2161974829,'Cancer'],
  [2161974829,2162162278,'Leo'],
  [2162162278,2162345472,'Virgo'],
  [2162345472,2162526761,'Libra'],
  [2162526761,2162708993,'Scorpio'],
  [2162708993,2162895727,'Sagittarius'],
  [2162895727,2163090743,'Capricorn'],
  [2163090743,2163296442,'Aquarius'],
  [2163296442,2163511408,'Pisces'],
  [2163511408,2163729197,'Aries'],
  [2163729197,2163941348,'Taurus'],
  [2163941348,2164142648,'Gemini'],
  [2164142648,2164333191,'Cancer'],
  [2164333191,2164516663,'Leo'],
  [2164516663,2164697683,'Virgo'],
  [2164697683,2164879981,'Libra'],
  [2164879981,2165065815,'Scorpio'],
  [2165065815,2165256541,'Sagittarius'],
  [2165256541,2165453678,'Capricorn'],
  [2165453678,2165659014,'Aquarius'],
  [2165659014,2165872810,'Pisces'],
  [2165872810,2166091122,'Aries'],
  [2166091122,2166305726,'Taurus'],
  [2166305726,2166508933,'Gemini'],
  [2166508933,2166698597,'Cancer'],
  [2166698597,2166878295,'Leo'],
  [2166878295,2167054354,'Virgo'],
  [2167054354,2167232952,'Libra'],
  [2167232952,2167418149,'Scorpio'],
  [2167418149,2167611142,'Sagittarius'],
  [2167611142,2167811376,'Capricorn'],
  [2167811376,2168018415,'Aquarius'],
  [2168018415,2168232183,'Pisces'],
  [2168232183,2168450744,'Aries'],
  [2168450744,2168667974,'Taurus'],
  [2168667974,2168875424,'Gemini'],
  [2168875424,2169068052,'Cancer'],
  [2169068052,2169247383,'Leo'],
  [2169247383,2169419676,'Virgo'],
  [2169419676,2169592610,'Libra'],
  [2169592610,2169772766,'Scorpio'],
  [2169772766,2169963601,'Sagittarius'],
  [2169963601,2170164782,'Capricorn'],
  [2170164782,2170373893,'Aquarius'],
  [2170373893,2170588679,'Pisces'],
  [2170588679,2170807223,'Aries'],
  [2170807223,2171025690,'Taurus'],
  [2171025690,2171237294,'Gemini'],
  [2171237294,2171435573,'Cancer'],
  [2171435573,2171619005,'Leo'],
  [2171619005,2171791835,'Virgo'],
  [2171791835,2171961450,'Libra'],
  [2171961450,2172135659,'Scorpio'],
  [2172135659,2172320554,'Sagittarius'],
  [2172320554,2172518478,'Capricorn'],
  [2172518478,2172727520,'Aquarius'],
  [2172727520,2172943386,'Pisces'],
  [2172943386,2173162004,'Aries'],
  [2173162004,2173379952,'Taurus'],
  [2173379952,2173592961,'Gemini'],
  [2173592961,2173795996,'Cancer'],
  [2173795996,2173985910,'Leo'],
  [2173985910,2174163912,'Virgo'],
  [2174163912,2174335200,'Libra'],
  [2174335200,2174506897,'Scorpio'],
  [2174506897,2174686105,'Sagittarius'],
  [2174686105,2174877934,'Capricorn'],
  [2174877934,2175083428,'Aquarius'],
  [2175083428,2175298826,'Pisces'],
  [2175298826,2175517726,'Aries'],
  [2175517726,2175734627,'Taurus'],
  [2175734627,2175946053,'Gemini'],
  [2175946053,2176149684,'Cancer'],
  [2176149684,2176343847,'Leo'],
  [2176343847,2176528369,'Virgo'],
  [2176528369,2176705531,'Libra'],
  [2176705531,2176879952,'Scorpio'],
  [2176879952,2177057658,'Sagittarius'],
  [2177057658,2177244658,'Capricorn'],
  [2177244658,2177444860,'Aquarius'],
  [2177444860,2177657499,'Pisces'],
  [2177657499,2177876301,'Aries'],
  [2177876301,2178093046,'Taurus'],
  [2178093046,2178302364,'Gemini'],
  [2178302364,2178503038,'Cancer'],
  [2178503038,2178696208,'Leo'],
  [2178696208,2178883439,'Virgo'],
  [2178883439,2179066221,'Libra'],
  [2179066221,2179246521,'Scorpio'],
  [2179246521,2179427609,'Sagittarius'],
  [2179427609,2179614130,'Capricorn'],
  [2179614130,2179810844,'Aquarius'],
  [2179810844,2180019893,'Pisces'],
  [2180019893,2180237689,'Aries'],
  [2180237689,2180455366,'Taurus'],
  [2180455366,2180664558,'Gemini'],
  [2180664558,2180862447,'Cancer'],
  [2180862447,2181051411,'Leo'],
  [2181051411,2181235750,'Virgo'],
  [2181235750,2181419056,'Libra'],
  [2181419056,2181603268,'Scorpio'],
  [2181603268,2181789454,'Sagittarius'],
  [2181789454,2181979457,'Capricorn'],
  [2181979457,2182176498,'Aquarius'],
  [2182176498,2182383571,'Pisces'],
  [2182383571,2182599980,'Aries'],
  [2182599980,2182818866,'Taurus'],
  [2182818866,2183030361,'Gemini'],
  [2183030361,2183228605,'Cancer'],
  [2183228605,2183414686,'Leo'],
  [2183414686,2183594036,'Virgo'],
  [2183594036,2183772765,'Libra'],
  [2183772765,2183955254,'Scorpio'],
  [2183955254,2184143286,'Sagittarius'],
  [2184143286,2184337064,'Capricorn'],
  [2184337064,2184537129,'Aquarius'],
  [2184537129,2184744896,'Pisces'],
  [2184744896,2184960646,'Aries'],
  [2184960646,2185180272,'Taurus'],
  [2185180272,2185395040,'Gemini'],
  [2185395040,2185596926,'Cancer'],
  [2185596926,2185784143,'Leo'],
  [2185784143,2185961024,'Virgo'],
  [2185961024,2186134537,'Libra'],
  [2186134537,2186311328,'Scorpio'],
  [2186311328,2186495852,'Sagittarius'],
  [2186495852,2186689612,'Capricorn'],
  [2186689612,2186892004,'Aquarius'],
  [2186892004,2187101918,'Pisces'],
  [2187101918,2187318213,'Aries'],
  [2187318213,2187538023,'Taurus'],
  [2187538023,2187755101,'Gemini'],
  [2187755101,2187961737,'Cancer'],
  [2187961737,2188153653,'Leo'],
  [2188153653,2188332535,'Virgo'],
  [2188332535,2188504264,'Libra'],
  [2188504264,2188676053,'Scorpio'],
  [2188676053,2188854417,'Sagittarius'],
  [2188854417,2189043646,'Capricorn'],
  [2189043646,2189244783,'Aquarius'],
  [2189244783,2189455812,'Pisces'],
  [2189455812,2189673170,'Aries'],
  [2189673170,2189892944,'Taurus'],
  [2189892944,2190110451,'Gemini'],
  [2190110451,2190320172,'Cancer'],
  [2190320172,2190517580,'Leo'],
  [2190517580,2190701835,'Virgo'],
  [2190701835,2190876317,'Libra'],
  [2190876317,2191047050,'Scorpio'],
  [2191047050,2191220914,'Sagittarius'],
  [2191220914,2191404137,'Capricorn'],
  [2191404137,2191600579,'Aquarius'],
  [2191600579,2191809937,'Pisces'],
  [2191809937,2192027603,'Aries'],
  [2192027603,2192247343,'Taurus'],
  [2192247343,2192463930,'Gemini'],
  [2192463930,2192673738,'Cancer'],
  [2192673738,2192874192,'Leo'],
  [2192874192,2193063992,'Virgo'],
  [2193063992,2193244122,'Libra'],
  [2193244122,2193418137,'Scorpio'],
  [2193418137,2193591611,'Sagittarius'],
  [2193591611,2193771035,'Capricorn'],
  [2193771035,2193962173,'Aquarius'],
  [2193962173,2194167523,'Pisces'],
  [2194167523,2194383893,'Aries'],
  [2194383893,2194603552,'Taurus'],
  [2194603552,2194819117,'Gemini'],
  [2194819117,2195026959,'Cancer'],
  [2195026959,2195226648,'Leo'],
  [2195226648,2195418734,'Virgo'],
  [2195418734,2195603865,'Libra'],
  [2195603865,2195783407,'Scorpio'],
  [2195783407,2195960455,'Sagittarius'],
  [2195960455,2196140083,'Capricorn'],
  [2196140083,2196328272,'Aquarius'],
  [2196328272,2196529506,'Pisces'],
  [2196529506,2196743314,'Aries'],
  [2196743314,2196962679,'Taurus'],
  [2196962679,2197178152,'Gemini'],
  [2197178152,2197384193,'Cancer'],
  [2197384193,2197580842,'Leo'],
  [2197580842,2197770908,'Virgo'],
  [2197770908,2197956988,'Libra'],
  [2197956988,2198140477,'Scorpio'],
  [2198140477,2198322558,'Sagittarius'],
  [2198322558,2198505823,'Capricorn'],
  [2198505823,2198694700,'Aquarius'],
  [2198694700,2198893920,'Pisces'],
  [2198893920,2199105226,'Aries'],
  [2199105226,2199324037,'Taurus'],
  [2199324037,2199540643,'Gemini'],
  [2199540643,2199746943,'Cancer'],
  [2199746943,2199941345,'Leo'],
  [2199941345,2200127382,'Virgo'],
  [2200127382,2200309943,'Libra'],
  [2200309943,2200492650,'Scorpio'],
  [2200492650,2200677218,'Sagittarius'],
  [2200677218,2200864678,'Capricorn'],
  [2200864678,2201056982,'Aquarius'],
  [2201056982,2201257159,'Pisces'],
  [2201257159,2201467383,'Aries'],
  [2201467383,2201685565,'Taurus'],
  [2201685565,2201903893,'Gemini'],
  [2201903893,2202112982,'Cancer'],
  [2202112982,2202308366,'Leo'],
  [2202308366,2202492138,'Virgo'],
  [2202492138,2202669914,'Libra'],
  [2202669914,2202847599,'Scorpio'],
  [2202847599,2203029488,'Sagittarius'],
  [2203029488,2203217733,'Capricorn'],
  [2203217733,2203413121,'Aquarius'],
  [2203413121,2203616170,'Pisces'],
  [2203616170,2203827271,'Aries'],
  [2203827271,2204045129,'Taurus'],
  [2204045129,2204264616,'Gemini'],
  [2204264616,2204477561,'Cancer'],
  [2204477561,2204677397,'Leo'],
  [2204677397,2204863201,'Virgo'],
  [2204863201,2205039155,'Libra'],
  [2205039155,2205211728,'Scorpio'],
  [2205211728,2205387424,'Sagittarius'],
  [2205387424,2205571277,'Capricorn'],
  [2205571277,2205765790,'Aquarius'],
  [2205765790,2205970687,'Pisces'],
  [2205970687,2206183748,'Aries'],
  [2206183748,2206401977,'Taurus'],
  [2206401977,2206621467,'Gemini'],
  [2206621467,2206836792,'Cancer'],
  [2206836792,2207041998,'Leo'],
  [2207041998,2207233644,'Virgo'],
  [2207233644,2207412820,'Libra'],
  [2207412820,2207584421,'Scorpio'],
  [2207584421,2207755278,'Sagittarius'],
  [2207755278,2207932450,'Capricorn'],
  [2207932450,2208121489,'Aquarius'],
  [2208121489,2208324322,'Pisces'],
  [2208324322,2208538134,'Aries'],
  [2208538134,2208757207,'Taurus'],
  [2208757207,2208976167,'Gemini'],
  [2208976167,2209191183,'Cancer'],
  [2209191183,2209398993,'Leo'],
  [2209398993,2209596509,'Virgo'],
  [2209596509,2209782322,'Libra'],
  [2209782322,2209958200,'Scorpio'],
  [2209958200,2210129203,'Sagittarius'],
  [2210129203,2210302412,'Capricorn'],
  [2210302412,2210485137,'Aquarius'],
  [2210485137,2210682414,'Pisces'],
  [2210682414,2210893864,'Aries'],
  [2210893864,2211113059,'Taurus'],
  [2211113059,2211331848,'Gemini'],
  [2211331848,2211545235,'Cancer'],
  [2211545235,2211751782,'Leo'],
  [2211751782,2211951015,'Virgo'],
  [2211951015,2212142050,'Libra'],
  [2212142050,2212324529,'Scorpio'],
  [2212324529,2212500472,'Sagittarius'],
  [2212500472,2212674961,'Capricorn'],
  [2212674961,2212854960,'Aquarius'],
  [2212854960,2213047041,'Pisces'],
  [2213047041,2213253960,'Aries'],
  [2213253960,2213471553,'Taurus'],
  [2213471553,2213690519,'Gemini'],
  [2213690519,2213903088,'Cancer'],
  [2213903088,2214106988,'Leo'],
  [2214106988,2214303618,'Virgo'],
  [2214303618,2214494690,'Libra'],
  [2214494690,2214680816,'Scorpio'],
  [2214680816,2214862491,'Sagittarius'],
  [2214862491,2215042012,'Capricorn'],
  [2215042012,2215224115,'Aquarius'],
  [2215224115,2215414698,'Pisces'],
  [2215414698,2215618010,'Aries'],
  [2215618010,2215832977,'Taurus'],
  [2215832977,2216051934,'Gemini'],
  [2216051934,2216265333,'Cancer'],
  [2216265333,2216468237,'Leo'],
  [2216468237,2216661494,'Virgo'],
  [2216661494,2216848624,'Libra'],
  [2216848624,2217032864,'Scorpio'],
  [2217032864,2217216161,'Sagittarius'],
  [2217216161,2217399970,'Capricorn'],
  [2217399970,2217586597,'Aquarius'],
  [2217586597,2217779560,'Pisces'],
  [2217779560,2217982302,'Aries'],
  [2217982302,2218195400,'Taurus'],
  [2218195400,2218414044,'Gemini'],
  [2218414044,2218629361,'Cancer'],
  [2218629361,2218834048,'Leo'],
  [2218834048,2219026514,'Virgo'],
  [2219026514,2219209912,'Libra'],
  [2219209912,2219389182,'Scorpio'],
  [2219389182,2219568894,'Sagittarius'],
  [2219568894,2219752347,'Capricorn'],
  [2219752347,2219941635,'Aquarius'],
  [2219941635,2220138169,'Pisces'],
  [2220138169,2220342987,'Aries'],
  [2220342987,2220556037,'Taurus'],
  [2220556037,2220774411,'Gemini'],
  [2220774411,2220991614,'Cancer'],
  [2220991614,2221199978,'Leo'],
  [2221199978,2221395194,'Virgo'],
  [2221395194,2221578226,'Libra'],
  [2221578226,2221753759,'Scorpio'],
  [2221753759,2221927929,'Sagittarius'],
  [2221927929,2222106573,'Capricorn'],
  [2222106573,2222293923,'Aquarius'],
  [2222293923,2222491651,'Pisces'],
  [2222491651,2222698875,'Aries'],
  [2222698875,2222913271,'Taurus'],
  [2222913271,2223131737,'Gemini'],
  [2223131737,2223349894,'Cancer'],
  [2223349894,2223561819,'Leo'],
  [2223561819,2223762014,'Virgo'],
  [2223762014,2223948616,'Libra'],
  [2223948616,2224124322,'Scorpio'],
  [2224124322,2224295066,'Sagittarius'],
  [2224295066,2224468052,'Capricorn'],
  [2224468052,2224649929,'Aquarius'],
  [2224649929,2224844730,'Pisces'],
  [2224844730,2225052061,'Aries'],
  [2225052061,2225267705,'Taurus'],
  [2225267705,2225486577,'Gemini'],
  [2225486577,2225704617,'Cancer'],
  [2225704617,2225918135,'Leo'],
  [2225918135,2226122800,'Virgo'],
  [2226122800,2226315141,'Libra'],
  [2226315141,2226495056,'Scorpio'],
  [2226495056,2226666614,'Sagittarius'],
  [2226666614,2226836744,'Capricorn'],
  [2226836744,2227013230,'Aquarius'],
  [2227013230,2227202479,'Pisces'],
  [2227202479,2227406600,'Aries'],
  [2227406600,2227621783,'Taurus'],
  [2227621783,2227840942,'Gemini'],
  [2227840942,2228058369,'Cancer'],
  [2228058369,2228271176,'Leo'],
  [2228271176,2228477315,'Virgo'],
  [2228477315,2228674211,'Libra'],
  [2228674211,2228860108,'Scorpio'],
  [2228860108,2229036363,'Sagittarius'],
  [2229036363,2229208023,'Capricorn'],
  [2229208023,2229382377,'Aquarius'],
  [2229382377,2229566812,'Pisces'],
  [2229566812,2229765927,'Aries'],
  [2229765927,2229978409,'Taurus'],
  [2229978409,2230197152,'Gemini'],
  [2230197152,2230414200,'Cancer'],
  [2230414200,2230625343,'Leo'],
  [2230625343,2230829751,'Virgo'],
  [2230829751,2231027226,'Libra'],
  [2231027226,2231216990,'Scorpio'],
  [2231216990,2231398970,'Sagittarius'],
  [2231398970,2231575631,'Capricorn'],
  [2231575631,2231752193,'Aquarius'],
  [2231752193,2231935255,'Pisces'],
  [2231935255,2232130431,'Aries'],
  [2232130431,2232339134,'Taurus'],
  [2232339134,2232556493,'Gemini'],
  [2232556493,2232773765,'Cancer'],
  [2232773765,2232984193,'Leo'],
  [2232984193,2233185941,'Virgo'],
  [2233185941,2233380327,'Libra'],
  [2233380327,2233569133,'Scorpio'],
  [2233569133,2233753603,'Sagittarius'],
  [2233753603,2233935215,'Capricorn'],
  [2233935215,2234116758,'Aquarius'],
  [2234116758,2234302473,'Pisces'],
  [2234302473,2234496962,'Aries'],
  [2234496962,2234702907,'Taurus'],
  [2234702907,2234918368,'Gemini'],
  [2234918368,2235136224,'Cancer'],
  [2235136224,2235347990,'Leo'],
  [2235347990,2235549079,'Virgo'],
  [2235549079,2235740040,'Libra'],
  [2235740040,2235924327,'Scorpio'],
  [2235924327,2236105921,'Sagittarius'],
  [2236105921,2236288104,'Capricorn'],
  [2236288104,2236473293,'Aquarius'],
  [2236473293,2236663483,'Pisces'],
  [2236663483,2236860652,'Aries'],
  [2236860652,2237066429,'Taurus'],
  [2237066429,2237280512,'Gemini'],
  [2237280512,2237498723,'Cancer'],
  [2237498723,2237713316,'Leo'],
  [2237713316,2237917142,'Virgo'],
  [2237917142,2238107933,'Libra'],
  [2238107933,2238288506,'Scorpio'],
  [2238288506,2238464476,'Sagittarius'],
  [2238464476,2238641891,'Capricorn'],
  [2238641891,2238825497,'Aquarius'],
  [2238825497,2239017628,'Pisces'],
  [2239017628,2239218248,'Aries'],
  [2239218248,2239426240,'Taurus'],
  [2239426240,2239640389,'Gemini'],
  [2239640389,2239858484,'Cancer'],
  [2239858484,2240075499,'Leo'],
  [2240075499,2240284143,'Virgo'],
  [2240284143,2240479089,'Libra'],
  [2240479089,2240660374,'Scorpio'],
  [2240660374,2240833003,'Sagittarius'],
  [2240833003,2241004373,'Capricorn'],
  [2241004373,2241181832,'Aquarius'],
  [2241181832,2241370487,'Pisces'],
  [2241370487,2241571310,'Aries'],
  [2241571310,2241781433,'Taurus'],
  [2241781433,2241996934,'Gemini'],
  [2241996934,2242214912,'Cancer'],
  [2242214912,2242432518,'Leo'],
  [2242432518,2242644833,'Virgo'],
  [2242644833,2242845850,'Libra'],
  [2242845850,2243032441,'Scorpio'],
  [2243032441,2243206925,'Sagittarius'],
  [2243206925,2243375938,'Capricorn'],
  [2243375938,2243547706,'Aquarius'],
  [2243547706,2243729692,'Pisces'],
  [2243729692,2243925944,'Aries'],
  [2243925944,2244135041,'Taurus'],
  [2244135041,2244351481,'Gemini'],
  [2244351481,2244569758,'Cancer'],
  [2244569758,2244786600,'Leo'],
  [2244786600,2244999355,'Virgo'],
  [2244999355,2245204130,'Libra'],
  [2245204130,2245397065,'Scorpio'],
  [2245397065,2245577525,'Sagittarius'],
  [2245577525,2245749525,'Capricorn'],
  [2245749525,2245920189,'Aquarius'],
  [2245920189,2246097396,'Pisces'],
  [2246097396,2246287389,'Aries'],
  [2246287389,2246491956,'Taurus'],
  [2246491956,2246707091,'Gemini'],
  [2246707091,2246925592,'Cancer'],
  [2246925592,2247141719,'Leo'],
  [2247141719,2247352710,'Virgo'],
  [2247352710,2247556979,'Libra'],
  [2247556979,2247752732,'Scorpio'],
  [2247752732,2247938886,'Sagittarius'],
  [2247938886,2248116919,'Capricorn'],
  [2248116919,2248291348,'Aquarius'],
  [2248291348,2248468552,'Pisces'],
  [2248468552,2248654918,'Aries'],
  [2248654918,2248854439,'Taurus'],
  [2248854439,2249066231,'Gemini'],
  [2249066231,2249284126,'Cancer'],
  [2249284126,2249500304,'Leo'],
  [2249500304,2249709765,'Virgo'],
  [2249709765,2249911155,'Libra'],
  [2249911155,2250105042,'Scorpio'],
  [2250105042,2250292467,'Sagittarius'],
  [2250292467,2250474889,'Capricorn'],
  [2250474889,2250654792,'Aquarius'],
  [2250654792,2250835964,'Pisces'],
  [2250835964,2251023029,'Aries'],
  [2251023029,2251220108,'Taurus'],
  [2251220108,2251428626,'Gemini'],
  [2251428626,2251645176,'Cancer'],
  [2251645176,2251862058,'Leo'],
  [2251862058,2252071787,'Virgo'],
  [2252071787,2252271110,'Libra'],
  [2252271110,2252461161,'Scorpio'],
  [2252461161,2252645334,'Sagittarius'],
  [2252645334,2252827282,'Capricorn'],
  [2252827282,2253009954,'Aquarius'],
  [2253009954,2253195586,'Pisces'],
  [2253195586,2253386271,'Aries'],
  [2253386271,2253584330,'Taurus'],
  [2253584330,2253791514,'Gemini'],
  [2253791514,2254006819,'Cancer'],
  [2254006819,2254224636,'Leo'],
  [2254224636,2254436540,'Virgo'],
  [2254436540,2254636564,'Libra'],
  [2254636564,2254824350,'Scorpio'],
  [2254824350,2255004061,'Sagittarius'],
  [2255004061,2255181570,'Capricorn'],
  [2255181570,2255362111,'Aquarius'],
  [2255362111,2255548865,'Pisces'],
  [2255548865,2255742770,'Aries'],
  [2255742770,2255943721,'Taurus'],
  [2255943721,2256151823,'Gemini'],
  [2256151823,2256366737,'Cancer'],
  [2256366737,2256585266,'Leo'],
  [2256585266,2256800193,'Virgo'],
  [2256800193,2257003723,'Libra'],
  [2257003723,2257192788,'Scorpio'],
  [2257192788,2257370402,'Sagittarius'],
  [2257370402,2257543192,'Capricorn'],
  [2257543192,2257718407,'Aquarius'],
  [2257718407,2257901652,'Pisces'],
  [2257901652,2258095227,'Aries'],
  [2258095227,2258298150,'Taurus'],
  [2258298150,2258508215,'Gemini'],
  [2258508215,2258723707,'Cancer'],
  [2258723707,2258942501,'Leo'],
  [2258942501,2259159679,'Virgo'],
  [2259159679,2259367818,'Libra'],
  [2259367818,2259561485,'Scorpio'],
  [2259561485,2259741106,'Sagittarius'],
  [2259741106,2259912295,'Capricorn'],
  [2259912295,2260082853,'Aquarius'],
  [2260082853,2260260236,'Pisces'],
  [2260260236,2260449360,'Aries'],
  [2260449360,2260650902,'Taurus'],
  [2260650902,2260861893,'Gemini'],
  [2260861893,2261078347,'Cancer'],
  [2261078347,2261297097,'Leo'],
  [2261297097,2261514714,'Virgo'],
  [2261514714,2261725925,'Libra'],
  [2261725925,2261925137,'Scorpio'],
  [2261925137,2262110220,'Sagittarius'],
  [2262110220,2262284271,'Capricorn'],
  [2262284271,2262453952,'Aquarius'],
  [2262453952,2262627000,'Pisces'],
  [2262627000,2262810146,'Aries'],
  [2262810146,2263006902,'Taurus'],
  [2263006902,2263216092,'Gemini'],
  [2263216092,2263432799,'Cancer'],
  [2263432799,2263651506,'Leo'],
  [2263651506,2263868133,'Virgo'],
  [2263868133,2264079290,'Libra'],
  [2264079290,2264281507,'Scorpio'],
  [2264281507,2264472351,'Sagittarius'],
  [2264472351,2264652432,'Capricorn'],
  [2264652432,2264825828,'Aquarius'],
  [2264825828,2264998816,'Pisces'],
  [2264998816,2265178189,'Aries'],
  [2265178189,2265369389,'Taurus'],
  [2265369389,2265574267,'Gemini'],
  [2265574267,2265789559,'Cancer'],
  [2265789559,2266008295,'Leo'],
  [2266008295,2266223946,'Virgo'],
  [2266223946,2266432886,'Libra'],
  [2266432886,2266633882,'Scorpio'],
  [2266633882,2266826742,'Sagittarius'],
  [2266826742,2267012008,'Capricorn'],
  [2267012008,2267191535,'Aquarius'],
  [2267191535,2267368859,'Pisces'],
  [2267368859,2267548945,'Aries'],
  [2267548945,2267737200,'Taurus'],
  [2267737200,2267937590,'Gemini'],
  [2267937590,2268149961,'Cancer'],
  [2268149961,2268368463,'Leo'],
  [2268368463,2268584389,'Virgo'],
  [2268584389,2268791663,'Libra'],
  [2268791663,2268989187,'Scorpio'],
  [2268989187,2269179201,'Sagittarius'],
  [2269179201,2269364694,'Capricorn'],
  [2269364694,2269548008,'Aquarius'],
  [2269548008,2269730891,'Pisces'],
  [2269730891,2269915471,'Aries'],
  [2269915471,2270105047,'Taurus'],
  [2270105047,2270303524,'Gemini'],
  [2270303524,2270513058,'Cancer'],
  [2270513058,2270730773,'Leo'],
  [2270730773,2270948204,'Virgo'],
  [2270948204,2271156459,'Libra'],
  [2271156459,2271352117,'Scorpio'],
  [2271352117,2271537753,'Sagittarius'],
  [2271537753,2271718716,'Capricorn'],
  [2271718716,2271900020,'Aquarius'],
  [2271900020,2272084633,'Pisces'],
  [2272084633,2272273494,'Aries'],
  [2272273494,2272467151,'Taurus'],
  [2272467151,2272667240,'Gemini'],
  [2272667240,2272875867,'Cancer'],
  [2272875867,2273092632,'Leo'],
  [2273092632,2273311644,'Virgo'],
  [2273311644,2273523303,'Libra'],
  [2273523303,2273721004,'Scorpio'],
  [2273721004,2273905196,'Sagittarius'],
  [2273905196,2274081507,'Capricorn'],
  [2274081507,2274257008,'Aquarius'],
  [2274257008,2274437487,'Pisces'],
  [2274437487,2274625819,'Aries'],
  [2274625819,2274822051,'Taurus'],
  [2274822051,2275025309,'Gemini'],
  [2275025309,2275235366,'Cancer'],
  [2275235366,2275451882,'Leo'],
  [2275451882,2275671539,'Virgo'],
  [2275671539,2275886739,'Libra'],
  [2275886739,2276089450,'Scorpio'],
  [2276089450,2276276883,'Sagittarius'],
  [2276276883,2276452674,'Capricorn'],
  [2276452674,2276623900,'Aquarius'],
  [2276623900,2276798016,'Pisces'],
  [2276798016,2276980755,'Aries'],
  [2276980755,2277174624,'Taurus'],
  [2277174624,2277378840,'Gemini'],
  [2277378840,2277590886,'Cancer'],
  [2277590886,2277808159,'Leo'],
  [2277808159,2278027653,'Virgo'],
  [2278027653,2278244343,'Libra'],
  [2278244343,2278451673,'Scorpio'],
  [2278451673,2278645105,'Sagittarius'],
  [2278645105,2278825187,'Capricorn'],
  [2278825187,2278996990,'Aquarius'],
  [2278996990,2279167632,'Pisces'],
  [2279167632,2279344185,'Aries'],
  [2279344185,2279531973,'Taurus'],
  [2279531973,2279732925,'Gemini'],
  [2279732925,2279944885,'Cancer'],
  [2279944885,2280163003,'Leo'],
  [2280163003,2280382251,'Virgo'],
  [2280382251,2280598275,'Libra'],
  [2280598275,2280807056,'Scorpio'],
  [2280807056,2281005189,'Sagittarius'],
  [2281005189,2281191529,'Capricorn'],
  [2281191529,2281368273,'Aquarius'],
  [2281368273,2281540422,'Pisces'],
  [2281540422,2281714443,'Aries'],
  [2281714443,2281896806,'Taurus'],
  [2281896806,2282092178,'Gemini'],
  [2282092178,2282301095,'Cancer'],
  [2282301095,2282518843,'Leo'],
  [2282518843,2282738046,'Virgo'],
  [2282738046,2282952727,'Libra'],
  [2282952727,2283159939,'Scorpio'],
  [2283159939,2283358757,'Sagittarius'],
  [2283358757,2283549060,'Capricorn'],
  [2283549060,2283731651,'Aquarius'],
  [2283731651,2283908882,'Pisces'],
  [2283908882,2284085012,'Aries'],
  [2284085012,2284265753,'Taurus'],
  [2284265753,2284456844,'Gemini'],
  [2284456844,2284661502,'Cancer'],
  [2284661502,2284877379,'Leo'],
  [2284877379,2285096574,'Virgo'],
  [2285096574,2285310658,'Libra'],
  [2285310658,2285515549,'Scorpio'],
  [2285515549,2285711731,'Sagittarius'],
  [2285711731,2285901479,'Capricorn'],
  [2285901479,2286086753,'Aquarius'],
  [2286086753,2286268917,'Pisces'],
  [2286268917,2286449822,'Aries'],
  [2286449822,2286632949,'Taurus'],
  [2286632949,2286823206,'Gemini'],
  [2286823206,2287024934,'Cancer'],
  [2287024934,2287238443,'Leo'],
  [2287238443,2287457518,'Virgo'],
  [2287457518,2287672362,'Libra'],
  [2287672362,2287876447,'Scorpio'],
  [2287876447,2288069598,'Sagittarius'],
  [2288069598,2288255638,'Capricorn'],
  [2288255638,2288438887,'Aquarius'],
  [2288438887,2288622163,'Pisces'],
  [2288622163,2288806777,'Aries'],
  [2288806777,2288994058,'Taurus'],
  [2288994058,2289186683,'Gemini'],
  [2289186683,2289388166,'Cancer'],
  [2289388166,2289600174,'Leo'],
  [2289600174,2289819048,'Virgo'],
  [2289819048,2290035725,'Libra'],
  [2290035725,2290241543,'Scorpio'],
  [2290241543,2290434020,'Sagittarius'],
  [2290434020,2290616630,'Capricorn'],
  [2290616630,2290795207,'Aquarius'],
  [2290795207,2290974968,'Pisces'],
  [2290974968,2291159045,'Aries'],
  [2291159045,2291348679,'Taurus'],
  [2291348679,2291544625,'Gemini'],
  [2291544625,2291748148,'Cancer'],
  [2291748148,2291960250,'Leo'],
  [2291960250,2292178988,'Virgo'],
  [2292178988,2292397580,'Libra'],
  [2292397580,2292607092,'Scorpio'],
  [2292607092,2292802378,'Sagittarius'],
  [2292802378,2292984769,'Capricorn'],
  [2292984769,2293159821,'Aquarius'],
  [2293159821,2293334159,'Pisces'],
  [2293334159,2293513401,'Aries'],
  [2293513401,2293700979,'Taurus'],
  [2293700979,2293897972,'Gemini'],
  [2293897972,2294103850,'Cancer'],
  [2294103850,2294317337,'Leo'],
  [2294317337,2294536188,'Virgo'],
  [2294536188,2294755714,'Libra'],
  [2294755714,2294968859,'Scorpio'],
  [2294968859,2295169386,'Sagittarius'],
  [2295169386,2295355700,'Capricorn'],
  [2295355700,2295531247,'Aquarius'],
  [2295531247,2295702277,'Pisces'],
  [2295702277,2295875692,'Aries'],
  [2295875692,2296057489,'Taurus'],
  [2296057489,2296251281,'Gemini'],
  [2296251281,2296457163,'Cancer'],
  [2296457163,2296671990,'Leo'],
  [2296671990,2296891279,'Virgo'],
  [2296891279,2297110521,'Libra'],
  [2297110521,2297325062,'Scorpio'],
  [2297325062,2297530186,'Sagittarius'],
  [2297530186,2297722784,'Capricorn'],
  [2297722784,2297903283,'Aquarius'],
  [2297903283,2298075702,'Pisces'],
  [2298075702,2298246379,'Aries'],
  [2298246379,2298422445,'Taurus'],
  [2298422445,2298610120,'Gemini'],
  [2298610120,2298812317,'Cancer'],
  [2298812317,2299026588,'Leo'],
  [2299026588,2299246307,'Virgo'],
  [2299246307,2299464861,'Libra'],
  [2299464861,2299678249,'Scorpio'],
  [2299678249,2299884364,'Sagittarius'],
  [2299884364,2300081492,'Capricorn'],
  [2300081492,2300268602,'Aquarius'],
  [2300268602,2300446710,'Pisces'],
  [2300446710,2300619737,'Aries'],
  [2300619737,2300793986,'Taurus'],
  [2300793986,2300976607,'Gemini'],
  [2300976607,2301173167,'Cancer'],
  [2301173167,2301384194,'Leo'],
  [2301384194,2301603471,'Virgo'],
  [2301603471,2301821876,'Libra'],
  [2301821876,2302033491,'Scorpio'],
  [2302033491,2302237208,'Sagittarius'],
  [2302237208,2302434017,'Capricorn'],
  [2302434017,2302624490,'Aquarius'],
  [2302624490,2302808639,'Pisces'],
  [2302808639,2302987578,'Aries'],
  [2302987578,2303165013,'Taurus'],
  [2303165013,2303346915,'Gemini'],
  [2303346915,2303539587,'Cancer'],
  [2303539587,2303746322,'Leo'],
  [2303746322,2303963781,'Virgo'],
  [2303963781,2304182595,'Libra'],
  [2304182595,2304393998,'Scorpio'],
  [2304393998,2304595182,'Sagittarius'],
  [2304595182,2304788260,'Capricorn'],
  [2304788260,2304976515,'Aquarius'],
  [2304976515,2305161997,'Pisces'],
  [2305161997,2305345525,'Aries'],
  [2305345525,2305528424,'Taurus'],
  [2305528424,2305713942,'Gemini'],
  [2305713942,2305906842,'Cancer'],
  [2305906842,2306111094,'Leo'],
  [2306111094,2306326254,'Virgo'],
  [2306326254,2306545368,'Libra'],
  [2306545368,2306758574,'Scorpio'],
  [2306758574,2306960018,'Sagittarius'],
  [2306960018,2307150313,'Capricorn'],
  [2307150313,2307333786,'Aquarius'],
  [2307333786,2307515133,'Pisces'],
  [2307515133,2307697638,'Aries'],
  [2307697638,2307883112,'Taurus'],
  [2307883112,2308073003,'Gemini'],
  [2308073003,2308269327,'Cancer'],
  [2308269327,2308474301,'Leo'],
  [2308474301,2308688301,'Virgo'],
  [2308688301,2308907282,'Libra'],
  [2308907282,2309123025,'Scorpio'],
  [2309123025,2309327802,'Sagittarius'],
  [2309327802,2309519180,'Capricorn'],
  [2309519180,2309700115,'Aquarius'],
  [2309700115,2309876179,'Pisces'],
  [2309876179,2310053140,'Aries'],
  [2310053140,2310235526,'Taurus'],
  [2310235526,2310425959,'Gemini'],
  [2310425959,2310625210,'Cancer'],
  [2310625210,2310832813,'Leo'],
  [2310832813,2311047470,'Virgo'],
  [2311047470,2311266244,'Libra'],
  [2311266244,2311483650,'Scorpio'],
  [2311483650,2311692738,'Sagittarius'],
  [2311692738,2311888718,'Capricorn'],
  [2311888718,2312071627,'Aquarius'],
  [2312071627,2312245742,'Pisces'],
  [2312245742,2312417521,'Aries'],
  [2312417521,2312593714,'Taurus'],
  [2312593714,2312779730,'Gemini'],
  [2312779730,2312977989,'Cancer'],
  [2312977989,2313187116,'Leo'],
  [2313187116,2313403260,'Virgo'],
  [2313403260,2313622168,'Libra'],
  [2313622168,2313839788,'Scorpio'],
  [2313839788,2314051581,'Sagittarius'],
  [2314051581,2314252851,'Capricorn'],
  [2314252851,2314441147,'Aquarius'],
  [2314441147,2314617992,'Pisces'],
  [2314617992,2314788597,'Aries'],
  [2314788597,2314960182,'Taurus'],
  [2314960182,2315140077,'Gemini'],
  [2315140077,2315333489,'Cancer'],
  [2315333489,2315540884,'Leo'],
  [2315540884,2315757515,'Virgo'],
  [2315757515,2315976750,'Libra'],
  [2315976750,2316193704,'Scorpio'],
  [2316193704,2316405546,'Sagittarius'],
  [2316405546,2316609670,'Capricorn'],
  [2316609670,2316803424,'Aquarius'],
  [2316803424,2316985940,'Pisces'],
  [2316985940,2317159847,'Aries'],
  [2317159847,2317331083,'Taurus'],
  [2317331083,2317507194,'Gemini'],
  [2317507194,2317695114,'Cancer'],
  [2317695114,2317898111,'Leo'],
  [2317898111,2318113126,'Virgo'],
  [2318113126,2318332338,'Libra'],
  [2318332338,2318548639,'Scorpio'],
  [2318548639,2318758856,'Sagittarius'],
  [2318758856,2318962301,'Capricorn'],
  [2318962301,2319158267,'Aquarius'],
  [2319158267,2319345745,'Pisces'],
  [2319345745,2319525201,'Aries'],
  [2319525201,2319700122,'Taurus'],
  [2319700122,2319876620,'Gemini'],
  [2319876620,2320061643,'Cancer'],
  [2320061643,2320260218,'Leo'],
  [2320260218,2320472072,'Virgo'],
  [2320472072,2320690542,'Libra'],
  [2320690542,2320906801,'Scorpio'],
  [2320906801,2321115612,'Sagittarius'],
  [2321115612,2321316391,'Capricorn'],
  [2321316391,2321510511,'Aquarius'],
  [2321510511,2321698985,'Pisces'],
  [2321698985,2321882407,'Aries'],
  [2321882407,2322062425,'Taurus'],
  [2322062425,2322242752,'Gemini'],
  [2322242752,2322428685,'Cancer'],
  [2322428685,2322625231,'Leo'],
  [2322625231,2322834123,'Virgo'],
  [2322834123,2323051310,'Libra'],
  [2323051310,2323268233,'Scorpio'],
  [2323268233,2323477345,'Sagittarius'],
  [2323477345,2323676213,'Capricorn'],
  [2323676213,2323866648,'Aquarius'],
  [2323866648,2324051874,'Pisces'],
  [2324051874,2324234709,'Aries'],
  [2324234709,2324417334,'Taurus'],
  [2324417334,2324602001,'Gemini'],
  [2324602001,2324791585,'Cancer'],
  [2324791585,2324989265,'Leo'],
  [2324989265,2325196962,'Virgo'],
  [2325196962,2325412957,'Libra'],
  [2325412957,2325630855,'Scorpio'],
  [2325630855,2325842298,'Sagittarius'],
  [2325842298,2326042087,'Capricorn'],
  [2326042087,2326230403,'Aquarius'],
  [2326230403,2326411104,'Pisces'],
  [2326411104,2326589280,'Aries'],
  [2326589280,2326769565,'Taurus'],
  [2326769565,2326955254,'Gemini'],
  [2326955254,2327148138,'Cancer'],
  [2327148138,2327348909,'Leo'],
  [2327348909,2327557633,'Virgo'],
  [2327557633,2327773185,'Libra'],
  [2327773185,2327991738,'Scorpio'],
  [2327991738,2328206410,'Sagittarius'],
  [2328206410,2328410204,'Capricorn'],
  [2328410204,2328600295,'Aquarius'],
  [2328600295,2328779059,'Pisces'],
  [2328779059,2328952255,'Aries'],
  [2328952255,2329126707,'Taurus'],
  [2329126707,2329308381,'Gemini'],
  [2329308381,2329500672,'Cancer'],
  [2329500672,2329703510,'Leo'],
  [2329703510,2329914420,'Virgo'],
  [2329914420,2330130565,'Libra'],
  [2330130565,2330349160,'Scorpio'],
  [2330349160,2330565971,'Sagittarius'],
  [2330565971,2330774771,'Capricorn'],
  [2330774771,2330970313,'Aquarius'],
  [2330970313,2331151885,'Pisces'],
  [2331151885,2331323816,'Aries'],
  [2331323816,2331493416,'Taurus'],
  [2331493416,2331668589,'Gemini'],
  [2331668589,2331855597,'Cancer'],
  [2331855597,2332056505,'Leo'],
  [2332056505,2332268295,'Virgo'],
  [2332268295,2332485553,'Libra'],
  [2332485553,2332703987,'Scorpio'],
  [2332703987,2332920778,'Sagittarius'],
  [2332920778,2333132321,'Capricorn'],
  [2333132321,2333333742,'Aquarius'],
  [2333333742,2333521750,'Pisces'],
  [2333521750,2333697601,'Aries'],
  [2333697601,2333867053,'Taurus'],
  [2333867053,2334038100,'Gemini'],
  [2334038100,2334218641,'Cancer'],
  [2334218641,2334413788,'Leo'],
  [2334413788,2334623013,'Virgo'],
  [2334623013,2334840382,'Libra'],
  [2334840382,2335058930,'Scorpio'],
  [2335058930,2335274537,'Sagittarius'],
  [2335274537,2335485275,'Capricorn'],
  [2335485275,2335688881,'Aquarius'],
  [2335688881,2335882516,'Pisces'],
  [2335882516,2336065112,'Aries'],
  [2336065112,2336239435,'Taurus'],
  [2336239435,2336411602,'Gemini'],
  [2336411602,2336589121,'Cancer'],
  [2336589121,2336778567,'Leo'],
  [2336778567,2336982616,'Virgo'],
  [2336982616,2337197840,'Libra'],
  [2337197840,2337416423,'Scorpio'],
  [2337416423,2337631433,'Sagittarius'],
  [2337631433,2337839877,'Capricorn'],
  [2337839877,2338041314,'Aquarius'],
  [2338041314,2338235602,'Pisces'],
  [2338235602,2338422522,'Aries'],
  [2338422522,2338603081,'Taurus'],
  [2338603081,2338780554,'Gemini'],
  [2338780554,2338960182,'Cancer'],
  [2338960182,2339147774,'Leo'],
  [2339147774,2339347494,'Virgo'],
  [2339347494,2339559172,'Libra'],
  [2339559172,2339777044,'Scorpio'],
  [2339777044,2339992673,'Sagittarius'],
  [2339992673,2340200216,'Capricorn'],
  [2340200216,2340398431,'Aquarius'],
  [2340398431,2340589061,'Pisces'],
  [2340589061,2340774653,'Aries'],
  [2340774653,2340957548,'Taurus'],
  [2340957548,2341139986,'Gemini'],
  [2341139986,2341324620,'Cancer'],
  [2341324620,2341514728,'Leo'],
  [2341514728,2341713582,'Virgo'],
  [2341713582,2341922652,'Libra'],
  [2341922652,2342139260,'Scorpio'],
  [2342139260,2342356147,'Sagittarius'],
  [2342356147,2342565272,'Capricorn'],
  [2342565272,2342762673,'Aquarius'],
  [2342762673,2342949572,'Pisces'],
  [2342949572,2343130348,'Aries'],
  [2343130348,2343310040,'Taurus'],
  [2343310040,2343492668,'Gemini'],
  [2343492668,2343680561,'Cancer'],
  [2343680561,2343874732,'Leo'],
  [2343874732,2344075904,'Virgo'],
  [2344075904,2344284775,'Libra'],
  [2344284775,2344500486,'Scorpio'],
  [2344500486,2344718441,'Sagittarius'],
  [2344718441,2344930728,'Capricorn'],
  [2344930728,2345130724,'Aquarius'],
  [2345130724,2345317208,'Pisces'],
  [2345317208,2345494253,'Aries'],
  [2345494253,2345668509,'Taurus'],
  [2345668509,2345846525,'Gemini'],
  [2345846525,2346032772,'Cancer'],
  [2346032772,2346228506,'Leo'],
  [2346228506,2346432484,'Virgo'],
  [2346432484,2346643032,'Libra'],
  [2346643032,2346858827,'Scorpio'],
  [2346858827,2347077247,'Sagittarius'],
  [2347077247,2347292446,'Capricorn'],
  [2347292446,2347497046,'Aquarius'],
  [2347497046,2347687002,'Pisces'],
  [2347687002,2347864258,'Aries'],
  [2347864258,2348035201,'Taurus'],
  [2348035201,2348207660,'Gemini'],
  [2348207660,2348388478,'Cancer'],
  [2348388478,2348581325,'Leo'],
  [2348581325,2348785540,'Virgo'],
  [2348785540,2348997669,'Libra'],
  [2348997669,2349214263,'Scorpio'],
  [2349214263,2349432648,'Sagittarius'],
  [2349432648,2349649068,'Capricorn'],
  [2349649068,2349857647,'Aquarius'],
  [2349857647,2350053070,'Pisces'],
  [2350053070,2350234509,'Aries'],
  [2350234509,2350406414,'Taurus'],
  [2350406414,2350576203,'Gemini'],
  [2350576203,2350751702,'Cancer'],
  [2350751702,2350938912,'Leo'],
  [2350938912,2351139743,'Virgo'],
  [2351139743,2351351385,'Libra'],
  [2351351385,2351568577,'Scorpio'],
  [2351568577,2351786771,'Sagittarius'],
  [2351786771,2352002617,'Capricorn'],
  [2352002617,2352212432,'Aquarius'],
  [2352212432,2352412087,'Pisces'],
  [2352412087,2352599325,'Aries'],
  [2352599325,2352775955,'Taurus'],
  [2352775955,2352947447,'Gemini'],
  [2352947447,2353120964,'Cancer'],
  [2353120964,2353303360,'Leo'],
  [2353303360,2353498970,'Virgo'],
  [2353498970,2353707564,'Libra'],
  [2353707564,2353924228,'Scorpio'],
  [2353924228,2354142328,'Sagittarius'],
  [2354142328,2354356924,'Capricorn'],
  [2354356924,2354565213,'Aquarius'],
  [2354565213,2354765413,'Pisces'],
  [2354765413,2354956398,'Aries'],
  [2354956398,2355138679,'Taurus'],
  [2355138679,2355315208,'Gemini'],
  [2355315208,2355491018,'Cancer'],
  [2355491018,2355672076,'Leo'],
  [2355672076,2355863647,'Virgo'],
  [2355863647,2356068100,'Libra'],
  [2356068100,2356282893,'Scorpio'],
  [2356282893,2356501017,'Sagittarius'],
  [2356501017,2356715092,'Capricorn'],
  [2356715092,2356921076,'Aquarius'],
  [2356921076,2357118511,'Pisces'],
  [2357118511,2357308775,'Aries'],
  [2357308775,2357493671,'Taurus'],
  [2357493671,2357675211,'Gemini'],
  [2357675211,2357856022,'Cancer'],
  [2357856022,2358039710,'Leo'],
  [2358039710,2358230546,'Virgo'],
  [2358230546,2358432044,'Libra'],
  [2358432044,2358644423,'Scorpio'],
  [2358644423,2358862518,'Sagittarius'],
  [2358862518,2359077599,'Capricorn'],
  [2359077599,2359282938,'Aquarius'],
  [2359282938,2359477213,'Pisces'],
  [2359477213,2359663399,'Aries'],
  [2359663399,2359845894,'Taurus'],
  [2359845894,2360028374,'Gemini'],
  [2360028374,2360213047,'Cancer'],
  [2360213047,2360401260,'Leo'],
  [2360401260,2360594760,'Virgo'],
  [2360594760,2360796062,'Libra'],
  [2360796062,2361006810,'Scorpio'],
  [2361006810,2361224656,'Sagittarius'],
  [2361224656,2361441889,'Capricorn'],
  [2361441889,2361649505,'Aquarius'],
  [2361649505,2361843436,'Pisces'],
  [2361843436,2362026059,'Aries'],
  [2362026059,2362203348,'Taurus'],
  [2362203348,2362381594,'Gemini'],
  [2362381594,2362565188,'Cancer'],
  [2362565188,2362755680,'Leo'],
  [2362755680,2362952797,'Virgo'],
  [2362952797,2363156458,'Libra'],
  [2363156458,2363367353,'Scorpio'],
  [2363367353,2363584870,'Sagittarius'],
  [2363584870,2363804005,'Capricorn'],
  [2363804005,2364015867,'Aquarius'],
  [2364015867,2364213490,'Pisces'],
  [2364213490,2364396569,'Aries'],
  [2364396569,2364570511,'Taurus'],
  [2364570511,2364742897,'Gemini'],
  [2364742897,2364920672,'Cancer'],
  [2364920672,2365108094,'Leo'],
  [2365108094,2365305753,'Virgo'],
  [2365305753,2365511849,'Libra'],
  [2365511849,2365724430,'Scorpio'],
  [2365724430,2365942042,'Sagittarius'],
  [2365942042,2366161709,'Capricorn'],
  [2366161709,2366377015,'Aquarius'],
  [2366377015,2366580446,'Pisces'],
  [2366580446,2366768562,'Aries'],
  [2366768562,2366944147,'Taurus'],
  [2366944147,2367113988,'Gemini'],
  [2367113988,2367285903,'Cancer'],
  [2367285903,2367466598,'Leo'],
  [2367466598,2367659759,'Virgo'],
  [2367659759,2367864996,'Libra'],
  [2367864996,2368078845,'Scorpio'],
  [2368078845,2368297162,'Sagittarius'],
  [2368297162,2368516352,'Capricorn'],
  [2368516352,2368732249,'Aquarius'],
  [2368732249,2368939605,'Pisces'],
  [2368939605,2369134216,'Aries'],
  [2369134216,2369315830,'Taurus'],
  [2369315830,2369488559,'Gemini'],
  [2369488559,2369659051,'Cancer'],
  [2369659051,2369834515,'Leo'],
  [2369834515,2370020983,'Virgo'],
  [2370020983,2370221340,'Libra'],
  [2370221340,2370433760,'Scorpio'],
  [2370433760,2370652501,'Sagittarius'],
  [2370652501,2370871307,'Capricorn'],
  [2370871307,2371085718,'Aquarius'],
  [2371085718,2371292888,'Pisces'],
  [2371292888,2371490780,'Aries'],
  [2371490780,2371678574,'Taurus'],
  [2371678574,2371857677,'Gemini'],
  [2371857677,2372031962,'Cancer'],
  [2372031962,2372207112,'Leo'],
  [2372207112,2372389431,'Virgo'],
  [2372389431,2372584071,'Libra'],
  [2372584071,2372792445,'Scorpio'],
  [2372792445,2373010182,'Sagittarius'],
  [2373010182,2373229062,'Capricorn'],
  [2373229062,2373442151,'Aquarius'],
  [2373442151,2373646692,'Pisces'],
  [2373646692,2373843097,'Aries'],
  [2373843097,2374032698,'Taurus'],
  [2374032698,2374216796,'Gemini'],
  [2374216796,2374397030,'Cancer'],
  [2374397030,2374576306,'Leo'],
  [2374576306,2374759185,'Virgo'],
  [2374759185,2374950962,'Libra'],
  [2374950962,2375155287,'Scorpio'],
  [2375155287,2375370775,'Sagittarius'],
  [2375370775,2375589822,'Capricorn'],
  [2375589822,2375803112,'Aquarius'],
  [2375803112,2376005750,'Pisces'],
  [2376005750,2376198571,'Aries'],
  [2376198571,2376385256,'Taurus'],
  [2376385256,2376569321,'Gemini'],
  [2376569321,2376752847,'Cancer'],
  [2376752847,2376937039,'Leo'],
  [2376937039,2377123825,'Virgo'],
  [2377123825,2377316672,'Libra'],
  [2377316672,2377519363,'Scorpio'],
  [2377519363,2377732796,'Sagittarius'],
  [2377732796,2377951835,'Capricorn'],
  [2377951835,2378166783,'Aquarius'],
  [2378166783,2378370087,'Pisces'],
  [2378370087,2378560855,'Aries'],
  [2378560855,2378743339,'Taurus'],
  [2378743339,2378923218,'Gemini'],
  [2378923218,2379104914,'Cancer'],
  [2379104914,2379290589,'Leo'],
  [2379290589,2379480972,'Virgo'],
  [2379480972,2379677105,'Libra'],
  [2379677105,2379880958,'Scorpio'],
  [2379880958,2380093746,'Sagittarius'],
  [2380093746,2380312684,'Capricorn'],
  [2380312684,2380529794,'Aquarius'],
  [2380529794,2380736205,'Pisces'],
  [2380736205,2380928305,'Aries'],
  [2380928305,2381108946,'Taurus'],
  [2381108946,2381284340,'Gemini'],
  [2381284340,2381460893,'Cancer'],
  [2381460893,2381643247,'Leo'],
  [2381643247,2381833514,'Virgo'],
  [2381833514,2382031938,'Libra'],
  [2382031938,2382238198,'Scorpio'],
  [2382238198,2382451844,'Sagittarius'],
  [2382451844,2382670790,'Capricorn'],
  [2382670790,2382889403,'Aquarius'],
  [2382889403,2383099723,'Pisces'],
  [2383099723,2383296148,'Aries'],
  [2383296148,2383478883,'Taurus'],
  [2383478883,2383652875,'Gemini'],
  [2383652875,2383824934,'Cancer'],
  [2383824934,2384001572,'Leo'],
  [2384001572,2384187500,'Virgo'],
  [2384187500,2384384648,'Libra'],
  [2384384648,2384592101,'Scorpio'],
  [2384592101,2384807132,'Sagittarius'],
  [2384807132,2385026303,'Capricorn'],
  [2385026303,2385245150,'Aquarius'],
  [2385245150,2385457985,'Pisces'],
  [2385457985,2385659452,'Aries'],
  [2385659452,2385847437,'Taurus'],
  [2385847437,2386024289,'Gemini'],
  [2386024289,2386195511,'Cancer'],
  [2386195511,2386367895,'Leo'],
  [2386367895,2386547968,'Virgo'],
  [2386547968,2386740360,'Libra'],
  [2386740360,2386945999,'Scorpio'],
  [2386945999,2387161450,'Sagittarius'],
  [2387161450,2387380941,'Capricorn'],
  [2387380941,2387599102,'Aquarius'],
  [2387599102,2387811876,'Pisces'],
  [2387811876,2388016095,'Aries'],
  [2388016095,2388209555,'Taurus'],
  [2388209555,2388392236,'Gemini'],
  [2388392236,2388567006,'Cancer'],
  [2388567006,2388739208,'Leo'],
  [2388739208,2388915535,'Virgo'],
  [2388915535,2389102425,'Libra'],
  [2389102425,2389303619,'Scorpio'],
  [2389303619,2389517447,'Sagittarius'],
  [2389517447,2389736981,'Capricorn'],
  [2389736981,2389954473,'Aquarius'],
  [2389954473,2390165438,'Pisces'],
  [2390165438,2390368727,'Aries'],
  [2390368727,2390564306,'Taurus'],
  [2390564306,2390752138,'Gemini'],
  [2390752138,2390932879,'Cancer'],
  [2390932879,2391109163,'Leo'],
  [2391109163,2391286038,'Virgo'],
  [2391286038,2391469964,'Libra'],
  [2391469964,2391666546,'Scorpio'],
  [2391666546,2391877054,'Sagittarius'],
  [2391877054,2392095902,'Capricorn'],
  [2392095902,2392313525,'Aquarius'],
  [2392313525,2392523070,'Pisces'],
  [2392523070,2392723369,'Aries'],
  [2392723369,2392916618,'Taurus'],
  [2392916618,2393105105,'Gemini'],
  [2393105105,2393289888,'Cancer'],
  [2393289888,2393471736,'Leo'],
  [2393471736,2393652973,'Virgo'],
  [2393652973,2393838147,'Libra'],
  [2393838147,2394032728,'Scorpio'],
  [2394032728,2394240037,'Sagittarius'],
  [2394240037,2394457441,'Capricorn'],
  [2394457441,2394675958,'Aquarius'],
  [2394675958,2394886232,'Pisces'],
  [2394886232,2395084800,'Aries'],
  [2395084800,2395274053,'Taurus'],
  [2395274053,2395458530,'Gemini'],
  [2395458530,2395641901,'Cancer'],
  [2395641901,2395825985,'Leo'],
  [2395825985,2396011778,'Virgo'],
  [2396011778,2396201174,'Libra'],
  [2396201174,2396397443,'Scorpio'],
  [2396397443,2396603704,'Sagittarius'],
  [2396603704,2396819656,'Capricorn'],
  [2396819656,2397039042,'Aquarius'],
  [2397039042,2397252149,'Pisces'],
  [2397252149,2397452495,'Aries'],
  [2397452495,2397640269,'Taurus'],
  [2397640269,2397820178,'Gemini'],
  [2397820178,2397998020,'Cancer'],
  [2397998020,2398178482,'Leo'],
  [2398178482,2398364315,'Virgo'],
  [2398364315,2398556765,'Libra'],
  [2398556765,2398756588,'Scorpio'],
  [2398756588,2398964487,'Sagittarius'],
  [2398964487,2399180081,'Capricorn'],
  [2399180081,2399399690,'Aquarius'],
  [2399399690,2399615862,'Pisces'],
  [2399615862,2399820895,'Aries'],
  [2399820895,2400011721,'Taurus'],
  [2400011721,2400190888,'Gemini'],
  [2400190888,2400364198,'Cancer'],
  [2400364198,2400538227,'Leo'],
  [2400538227,2400718675,'Virgo'],
  [2400718675,2400909128,'Libra'],
  [2400909128,2401110359,'Scorpio'],
  [2401110359,2401320699,'Sagittarius'],
  [2401320699,2401537334,'Capricorn'],
  [2401537334,2401756793,'Aquarius'],
  [2401756793,2401974310,'Pisces'],
  [2401974310,2402183882,'Aries'],
  [2402183882,2402380719,'Taurus'],
  [2402380719,2402564104,'Gemini'],
  [2402564104,2402737670,'Cancer'],
  [2402737670,2402907801,'Leo'],
  [2402907801,2403081756,'Virgo'],
  [2403081756,2403265958,'Libra'],
  [2403265958,2403463894,'Scorpio'],
  [2403463894,2403674329,'Sagittarius'],
  [2403674329,2403892159,'Capricorn'],
  [2403892159,2404111691,'Aquarius'],
  [2404111691,2404328720,'Pisces'],
  [2404328720,2404539887,'Aries'],
  [2404539887,2404741669,'Taurus'],
  [2404741669,2404931582,'Gemini'],
  [2404931582,2405110141,'Cancer'],
  [2405110141,2405281553,'Leo'],
  [2405281553,2405452647,'Virgo'],
  [2405452647,2405631037,'Libra'],
  [2405631037,2405822884,'Scorpio'],
  [2405822884,2406029806,'Sagittarius'],
  [2406029806,2406247124,'Capricorn'],
  [2406247124,2406466839,'Aquarius'],
  [2406466839,2406682877,'Pisces'],
  [2406682877,2406892777,'Aries'],
  [2406892777,2407095525,'Taurus'],
  [2407095525,2407289776,'Gemini'],
  [2407289776,2407474564,'Cancer'],
  [2407474564,2407651252,'Leo'],
  [2407651252,2407824477,'Virgo'],
  [2407824477,2408001131,'Libra'],
  [2408001131,2408188288,'Scorpio'],
  [2408188288,2408390185,'Sagittarius'],
  [2408390185,2408604847,'Capricorn'],
  [2408604847,2408824238,'Aquarius'],
  [2408824238,2409039873,'Pisces'],
  [2409039873,2409247834,'Aries'],
  [2409247834,2409448270,'Taurus'],
  [2409448270,2409642252,'Gemini'],
  [2409642252,2409830088,'Cancer'],
  [2409830088,2410012096,'Leo'],
  [2410012096,2410190419,'Virgo'],
  [2410190419,2410369714,'Libra'],
  [2410369714,2410556071,'Scorpio'],
  [2410556071,2410754587,'Sagittarius'],
  [2410754587,2410965951,'Capricorn'],
  [2410965951,2411184334,'Aquarius'],
  [2411184334,2411400420,'Pisces'],
  [2411400420,2411607790,'Aries'],
  [2411607790,2411805554,'Taurus'],
  [2411805554,2411996111,'Gemini'],
  [2411996111,2412182189,'Cancer'],
  [2412182189,2412365631,'Leo'],
  [2412365631,2412548017,'Virgo'],
  [2412548017,2412731858,'Libra'],
  [2412731858,2412920942,'Scorpio'],
  [2412920942,2413119272,'Sagittarius'],
  [2413119272,2413328617,'Capricorn'],
  [2413328617,2413545813,'Aquarius'],
  [2413545813,2413762907,'Pisces'],
  [2413762907,2413971776,'Aries'],
  [2413971776,2414169060,'Taurus'],
  [2414169060,2414356461,'Gemini'],
  [2414356461,2414538120,'Cancer'],
  [2414538120,2414718331,'Leo'],
  [2414718331,2414900478,'Virgo'],
  [2414900478,2415086996,'Libra'],
  [2415086996,2415279793,'Scorpio'],
  [2415279793,2415480512,'Sagittarius'],
  [2415480512,2415689970,'Capricorn'],
  [2415689970,2415906478,'Aquarius'],
  [2415906478,2416124561,'Pisces'],
  [2416124561,2416336420,'Aries'],
  [2416336420,2416536297,'Taurus'],
  [2416536297,2416723549,'Gemini'],
  [2416723549,2416901848,'Cancer'],
  [2416901848,2417076909,'Leo'],
  [2417076909,2417254555,'Virgo'],
  [2417254555,2417439308,'Libra'],
  [2417439308,2417633435,'Scorpio'],
  [2417633435,2417836838,'Sagittarius'],
  [2417836838,2418047990,'Capricorn'],
  [2418047990,2418264641,'Aquarius'],
  [2418264641,2418483183,'Pisces'],
  [2418483183,2418697914,'Aries'],
  [2418697914,2418902439,'Taurus'],
  [2418902439,2419093318,'Gemini'],
  [2419093318,2419271997,'Cancer'],
  [2419271997,2419443832,'Leo'],
  [2419443832,2419615955,'Virgo'],
  [2419615955,2419795278,'Libra'],
  [2419795278,2419986454,'Scorpio'],
  [2419986454,2420190046,'Sagittarius'],
  [2420190046,2420402783,'Capricorn'],
  [2420402783,2420620201,'Aquarius'],
  [2420620201,2420838619,'Pisces'],
  [2420838619,2421054500,'Aries'],
  [2421054500,2421263114,'Taurus'],
  [2421263114,2421459789,'Gemini'],
  [2421459789,2421643023,'Cancer'],
  [2421643023,2421816000,'Leo'],
  [2421816000,2421985420,'Virgo'],
  [2421985420,2422159265,'Libra'],
  [2422159265,2422344563,'Scorpio'],
  [2422344563,2422544563,'Sagittarius'],
  [2422544563,2422756761,'Capricorn'],
  [2422756761,2422974804,'Aquarius'],
  [2422974804,2423192945,'Pisces'],
  [2423192945,2423408026,'Aries'],
  [2423408026,2423617698,'Taurus'],
  [2423617698,2423818738,'Gemini'],
  [2423818738,2424008282,'Cancer'],
  [2424008282,2424186585,'Leo'],
  [2424186585,2424358114,'Virgo'],
  [2424358114,2424530115,'Libra'],
  [2424530115,2424710415,'Scorpio'],
  [2424710415,2424904742,'Sagittarius'],
  [2424904742,2425113499,'Capricorn'],
  [2425113499,2425330931,'Aquarius'],
  [2425330931,2425549074,'Pisces'],
  [2425549074,2425762816,'Aries'],
  [2425762816,2425970557,'Taurus'],
  [2425970557,2426171635,'Gemini'],
  [2426171635,2426364771,'Cancer'],
  [2426364771,2426549141,'Leo'],
  [2426549141,2426726457,'Virgo'],
  [2426726457,2426901522,'Libra'],
  [2426901522,2427080987,'Scorpio'],
  [2427080987,2427271210,'Sagittarius'],
  [2427271210,2427475295,'Capricorn'],
  [2427475295,2427690414,'Aquarius'],
  [2427690414,2427908655,'Pisces'],
  [2427908655,2428122234,'Aries'],
  [2428122234,2428327729,'Taurus'],
  [2428327729,2428525465,'Gemini'],
  [2428525465,2428716891,'Cancer'],
  [2428716891,2428903142,'Leo'],
  [2428903142,2429085444,'Virgo'],
  [2429085444,2429266183,'Libra'],
  [2429266183,2429449305,'Scorpio'],
  [2429449305,2429639587,'Sagittarius'],
  [2429639587,2429840789,'Capricorn'],
  [2429840789,2430053002,'Aquarius'],
  [2430053002,2430270917,'Pisces'],
  [2430270917,2430485938,'Aries'],
  [2430485938,2430691597,'Taurus'],
  [2430691597,2430886556,'Gemini'],
  [2430886556,2431073359,'Cancer'],
  [2431073359,2431255919,'Leo'],
  [2431255919,2431437820,'Virgo'],
  [2431437820,2431621740,'Libra'],
  [2431621740,2431809691,'Scorpio'],
  [2431809691,2432003593,'Sagittarius'],
  [2432003593,2432205416,'Capricorn'],
  [2432205416,2432416080,'Aquarius'],
  [2432416080,2432633267,'Pisces'],
  [2432633267,2432850301,'Aries'],
  [2432850301,2433059002,'Taurus'],
  [2433059002,2433254834,'Gemini'],
  [2433254834,2433438873,'Cancer'],
  [2433438873,2433616086,'Leo'],
  [2433616086,2433792656,'Virgo'],
  [2433792656,2433973905,'Libra'],
  [2433973905,2434162913,'Scorpio'],
  [2434162913,2434360218,'Sagittarius'],
  [2434360218,2434564986,'Capricorn'],
  [2434564986,2434776386,'Aquarius'],
  [2434776386,2434993147,'Pisces'],
  [2434993147,2435211452,'Aries'],
  [2435211452,2435424187,'Taurus'],
  [2435424187,2435624480,'Gemini'],
  [2435624480,2435810292,'Cancer'],
  [2435810292,2435985310,'Leo'],
  [2435985310,2436156542,'Virgo'],
  [2436156542,2436331539,'Libra'],
  [2436331539,2436516172,'Scorpio'],
  [2436516172,2436712668,'Sagittarius'],
  [2436712668,2436919279,'Capricorn'],
  [2436919279,2437132557,'Aquarius'],
  [2437132557,2437349710,'Pisces'],
  [2437349710,2437568201,'Aries'],
  [2437568201,2437783481,'Taurus'],
  [2437783481,2437989034,'Gemini'],
  [2437989034,2438180265,'Cancer'],
  [2438180265,2438357975,'Leo'],
  [2438357975,2438527953,'Virgo'],
  [2438527953,2438698196,'Libra'],
  [2438698196,2438876428,'Scorpio'],
  [2438876428,2439067739,'Sagittarius'],
  [2439067739,2439272413,'Capricorn'],
  [2439272413,2439486317,'Aquarius'],
  [2439486317,2439704211,'Pisces'],
  [2439704211,2439922384,'Aries'],
  [2439922384,2440137801,'Taurus'],
  [2440137801,2440346213,'Gemini'],
  [2440346213,2440543030,'Cancer'],
  [2440543030,2440726596,'Leo'],
  [2440726596,2440900049,'Virgo'],
  [2440900049,2441070042,'Libra'],
  [2441070042,2441244364,'Scorpio'],
  [2441244364,2441429751,'Sagittarius'],
  [2441429751,2441629399,'Capricorn'],
  [2441629399,2441841216,'Aquarius'],
  [2441841216,2442059119,'Pisces'],
  [2442059119,2442277029,'Aries'],
  [2442277029,2442491170,'Taurus'],
  [2442491170,2442699046,'Gemini'],
  [2442699046,2442898194,'Cancer'],
  [2442898194,2443086931,'Leo'],
  [2443086931,2443266213,'Virgo'],
  [2443266213,2443440184,'Libra'],
  [2443440184,2443615058,'Scorpio'],
  [2443615058,2443797407,'Sagittarius'],
  [2443797407,2443992101,'Capricorn'],
  [2443992101,2444199954,'Aquarius'],
  [2444199954,2444416534,'Pisces'],
  [2444416534,2444634384,'Aries'],
  [2444634384,2444847453,'Taurus'],
  [2444847453,2445052978,'Gemini'],
  [2445052978,2445250498,'Cancer'],
  [2445250498,2445440452,'Leo'],
  [2445440452,2445623956,'Virgo'],
  [2445623956,2445803326,'Libra'],
  [2445803326,2445982312,'Scorpio'],
  [2445982312,2446165703,'Sagittarius'],
  [2446165703,2446358200,'Capricorn'],
  [2446358200,2446562484,'Aquarius'],
  [2446562484,2446776891,'Pisces'],
  [2446776891,2446994796,'Aries'],
  [2446994796,2447208099,'Taurus'],
  [2447208099,2447411957,'Gemini'],
  [2447411957,2447606110,'Cancer'],
  [2447606110,2447793162,'Leo'],
  [2447793162,2447976411,'Virgo'],
  [2447976411,2448158686,'Libra'],
  [2448158686,2448342283,'Scorpio'],
  [2448342283,2448529538,'Sagittarius'],
  [2448529538,2448723274,'Capricorn'],
  [2448723274,2448926189,'Aquarius'],
  [2448926189,2449138735,'Pisces'],
  [2449138735,2449356684,'Aries'],
  [2449356684,2449571681,'Taurus'],
  [2449571681,2449776297,'Gemini'],
  [2449776297,2449968489,'Cancer'],
  [2449968489,2450151390,'Leo'],
  [2450151390,2450330458,'Virgo'],
  [2450330458,2450510836,'Libra'],
  [2450510836,2450695800,'Scorpio'],
  [2450695800,2450886588,'Sagittarius'],
  [2450886588,2451083605,'Capricorn'],
  [2451083605,2451287701,'Aquarius'],
  [2451287701,2451499649,'Pisces'],
  [2451499649,2451717563,'Aries'],
  [2451717563,2451934866,'Taurus'],
  [2451934866,2452142820,'Gemini'],
  [2452142820,2452336512,'Cancer'],
  [2452336512,2452517571,'Leo'],
  [2452517571,2452692048,'Virgo'],
  [2452692048,2452867114,'Libra'],
  [2452867114,2453048566,'Scorpio'],
  [2453048566,2453239133,'Sagittarius'],
  [2453239133,2453438446,'Capricorn'],
  [2453438446,2453644991,'Aquarius'],
  [2453644991,2453857792,'Pisces'],
  [2453857792,2454075665,'Aries'],
  [2454075665,2454294512,'Taurus'],
  [2454294512,2454506678,'Gemini'],
  [2454506678,2454705191,'Cancer'],
  [2454705191,2454888733,'Leo'],
  [2454888733,2455061952,'Virgo'],
  [2455061952,2455232413,'Libra'],
  [2455232413,2455407753,'Scorpio'],
  [2455407753,2455593472,'Sagittarius'],
  [2455593472,2455791179,'Capricorn'],
  [2455791179,2455998852,'Aquarius'],
  [2455998852,2456213127,'Pisces'],
  [2456213127,2456431198,'Aries'],
  [2456431198,2456650081,'Taurus'],
  [2456650081,2456864666,'Gemini'],
  [2456864666,2457068579,'Cancer'],
  [2457068579,2457258113,'Leo'],
  [2457258113,2457434966,'Virgo'],
  [2457434966,2457605146,'Libra'],
  [2457605146,2457776319,'Scorpio'],
  [2457776319,2457955663,'Sagittarius'],
  [2457955663,2458147801,'Capricorn'],
  [2458147801,2458353057,'Aquarius'],
  [2458353057,2458567647,'Pisces'],
  [2458567647,2458786194,'Aries'],
  [2458786194,2459004275,'Taurus'],
  [2459004275,2459218278,'Gemini'],
  [2459218278,2459424456,'Cancer'],
  [2459424456,2459619590,'Leo'],
  [2459619590,2459803078,'Virgo'],
  [2459803078,2459977956,'Libra'],
  [2459977956,2460149978,'Scorpio'],
  [2460149978,2460325982,'Sagittarius'],
  [2460325982,2460512192,'Capricorn'],
  [2460512192,2460712109,'Aquarius'],
  [2460712109,2460924419,'Pisces'],
  [2460924419,2461143043,'Aries'],
  [2461143043,2461360752,'Taurus'],
  [2461360752,2461572753,'Gemini'],
  [2461572753,2461777104,'Cancer'],
  [2461777104,2461973313,'Leo'],
  [2461973313,2462161518,'Virgo'],
  [2462161518,2462342884,'Libra'],
  [2462342884,2462520210,'Scorpio'],
  [2462520210,2462698043,'Sagittarius'],
  [2462698043,2462881994,'Capricorn'],
  [2462881994,2463077152,'Aquarius'],
  [2463077152,2463285425,'Pisces'],
  [2463285425,2463502931,'Aries'],
  [2463502931,2463721110,'Taurus'],
  [2463721110,2463932246,'Gemini'],
  [2463932246,2464133529,'Cancer'],
  [2464133529,2464326419,'Leo'],
  [2464326419,2464513810,'Virgo'],
  [2464513810,2464698097,'Libra'],
  [2464698097,2464880871,'Scorpio'],
  [2464880871,2465063900,'Sagittarius'],
  [2465063900,2465250276,'Capricorn'],
  [2465250276,2465444296,'Aquarius'],
  [2465444296,2465649467,'Pisces'],
  [2465649467,2465865045,'Aries'],
  [2465865045,2466083959,'Taurus'],
  [2466083959,2466296447,'Gemini'],
  [2466296447,2466496860,'Cancer'],
  [2466496860,2466686087,'Leo'],
  [2466686087,2466868868,'Virgo'],
  [2466868868,2467050301,'Libra'],
  [2467050301,2467233751,'Scorpio'],
  [2467233751,2467420529,'Sagittarius'],
  [2467420529,2467611316,'Capricorn'],
  [2467611316,2467807846,'Aquarius'],
  [2467807846,2468012755,'Pisces'],
  [2468012755,2468226981,'Aries'],
  [2468226981,2468446314,'Taurus'],
  [2468446314,2468661527,'Gemini'],
  [2468661527,2468864389,'Cancer'],
  [2468864389,2469053204,'Leo'],
  [2469053204,2469232295,'Virgo'],
  [2469232295,2469408316,'Libra'],
  [2469408316,2469587228,'Scorpio'],
  [2469587228,2469772569,'Sagittarius'],
  [2469772569,2469965240,'Capricorn'],
  [2469965240,2470164996,'Aquarius'],
  [2470164996,2470371978,'Pisces'],
  [2470371978,2470586364,'Aries'],
  [2470586364,2470805790,'Taurus'],
  [2470805790,2471023420,'Gemini'],
  [2471023420,2471230650,'Cancer'],
  [2471230650,2471422965,'Leo'],
  [2471422965,2471602387,'Virgo'],
  [2471602387,2471775119,'Libra'],
  [2471775119,2471948350,'Scorpio'],
  [2471948350,2472128101,'Sagittarius'],
  [2472128101,2472317798,'Capricorn'],
  [2472317798,2472517900,'Aquarius'],
  [2472517900,2472726858,'Pisces'],
  [2472726858,2472942485,'Aries'],
  [2472942485,2473161997,'Taurus'],
  [2473161997,2473380586,'Gemini'],
  [2473380586,2473591516,'Cancer'],
  [2473591516,2473789257,'Leo'],
  [2473789257,2473973025,'Virgo'],
  [2473973025,2474146881,'Libra'],
  [2474146881,2474317427,'Scorpio'],
  [2474317427,2474491666,'Sagittarius'],
  [2474491666,2474675421,'Capricorn'],
  [2474675421,2474871818,'Aquarius'],
  [2474871818,2475080215,'Pisces'],
  [2475080215,2475296736,'Aries'],
  [2475296736,2475516448,'Taurus'],
  [2475516448,2475734615,'Gemini'],
  [2475734615,2475946694,'Cancer'],
  [2475946694,2476148593,'Leo'],
  [2476148593,2476338237,'Virgo'],
  [2476338237,2476516997,'Libra'],
  [2476516997,2476689346,'Scorpio'],
  [2476689346,2476861559,'Sagittarius'],
  [2476861559,2477040316,'Capricorn'],
  [2477040316,2477231094,'Aquarius'],
  [2477231094,2477435934,'Pisces'],
  [2477435934,2477651688,'Aries'],
  [2477651688,2477871488,'Taurus'],
  [2477871488,2478088763,'Gemini'],
  [2478088763,2478299573,'Cancer'],
  [2478299573,2478502149,'Leo'],
  [2478502149,2478695634,'Virgo'],
  [2478695634,2478880167,'Libra'],
  [2478880167,2479057653,'Scorpio'],
  [2479057653,2479232179,'Sagittarius'],
  [2479232179,2479409584,'Capricorn'],
  [2479409584,2479596161,'Aquarius'],
  [2479596161,2479796338,'Pisces'],
  [2479796338,2480009521,'Aries'],
  [2480009521,2480228959,'Taurus'],
  [2480228959,2480445821,'Gemini'],
  [2480445821,2480654717,'Cancer'],
  [2480654717,2480854954,'Leo'],
  [2480854954,2481048060,'Virgo'],
  [2481048060,2481235455,'Libra'],
  [2481235455,2481418103,'Scorpio'],
  [2481418103,2481597672,'Sagittarius'],
  [2481597672,2481777733,'Capricorn'],
  [2481777733,2481963621,'Aquarius'],
  [2481963621,2482160629,'Pisces'],
  [2482160629,2482370689,'Aries'],
  [2482370689,2482589214,'Taurus'],
  [2482589214,2482806591,'Gemini'],
  [2482806591,2483014909,'Cancer'],
  [2483014909,2483212418,'Leo'],
  [2483212418,2483402001,'Virgo'],
  [2483402001,2483587518,'Libra'],
  [2483587518,2483771524,'Scorpio'],
  [2483771524,2483955187,'Sagittarius'],
  [2483955187,2484139873,'Capricorn'],
  [2484139873,2484328554,'Aquarius'],
  [2484328554,2484525440,'Pisces'],
  [2484525440,2484733530,'Aries'],
  [2484733530,2484950922,'Taurus'],
  [2484950922,2485169468,'Gemini'],
  [2485169468,2485379524,'Cancer'],
  [2485379524,2485576693,'Leo'],
  [2485576693,2485763072,'Virgo'],
  [2485763072,2485943916,'Libra'],
  [2485943916,2486124317,'Scorpio'],
  [2486124317,2486307485,'Sagittarius'],
  [2486307485,2486494834,'Capricorn'],
  [2486494834,2486687394,'Aquarius'],
  [2486687394,2486886894,'Pisces'],
  [2486886894,2487095203,'Aries'],
  [2487095203,2487311846,'Taurus'],
  [2487311846,2487531391,'Gemini'],
  [2487531391,2487744789,'Cancer'],
  [2487744789,2487945134,'Leo'],
  [2487945134,2488131848,'Virgo'],
  [2488131848,2488309452,'Libra'],
  [2488309452,2488484307,'Scorpio'],
  [2488484307,2488662230,'Sagittarius'],
  [2488662230,2488847154,'Capricorn'],
  [2488847154,2489040769,'Aquarius'],
  [2489040769,2489243120,'Pisces'],
  [2489243120,2489453450,'Aries'],
  [2489453450,2489670281,'Taurus'],
  [2489670281,2489890028,'Gemini'],
  [2489890028,2490106224,'Cancer'],
  [2490106224,2490311757,'Leo'],
  [2490311757,2490503096,'Virgo'],
  [2490503096,2490682053,'Libra'],
  [2490682053,2490854126,'Scorpio'],
  [2490854126,2491026182,'Sagittarius'],
  [2491026182,2491204719,'Capricorn'],
  [2491204719,2491394329,'Aquarius'],
  [2491394329,2491596287,'Pisces'],
  [2491596287,2491808304,'Aries'],
  [2491808304,2492026185,'Taurus'],
  [2492026185,2492245629,'Gemini'],
  [2492245629,2492462358,'Cancer'],
  [2492462358,2492671627,'Leo'],
  [2492671627,2492869256,'Virgo'],
  [2492869256,2493054002,'Libra'],
  [2493054002,2493228567,'Scorpio'],
  [2493228567,2493398753,'Sagittarius'],
  [2493398753,2493571820,'Capricorn'],
  [2493571820,2493754747,'Aquarius'],
  [2493754747,2493951945,'Pisces'],
  [2493951945,2494162711,'Aries'],
  [2494162711,2494381272,'Taurus'],
  [2494381272,2494600638,'Gemini'],
  [2494600638,2494816161,'Cancer'],
  [2494816161,2495025476,'Leo'],
  [2495025476,2495226604,'Virgo'],
  [2495226604,2495417714,'Libra'],
  [2495417714,2495598638,'Scorpio'],
  [2495598638,2495772325,'Sagittarius'],
  [2495772325,2495944709,'Capricorn'],
  [2495944709,2496123180,'Aquarius'],
  [2496123180,2496314341,'Pisces'],
  [2496314341,2496520723,'Aries'],
  [2496520723,2496738085,'Taurus'],
  [2496738085,2496957601,'Gemini'],
  [2496957601,2497172065,'Cancer'],
  [2497172065,2497379071,'Leo'],
  [2497379071,2497579043,'Virgo'],
  [2497579043,2497772353,'Libra'],
  [2497772353,2497958685,'Scorpio'],
  [2497958685,2498138549,'Sagittarius'],
  [2498138549,2498315067,'Capricorn'],
  [2498315067,2498493992,'Aquarius'],
  [2498493992,2498682008,'Pisces'],
  [2498682008,2498883776,'Aries'],
  [2498883776,2499098214,'Taurus'],
  [2499098214,2499317490,'Gemini'],
  [2499317490,2499532165,'Cancer'],
  [2499532165,2499737502,'Leo'],
  [2499737502,2499934135,'Virgo'],
  [2499934135,2500124757,'Libra'],
  [2500124757,2500311395,'Scorpio'],
  [2500311395,2500494987,'Sagittarius'],
  [2500494987,2500676813,'Capricorn'],
  [2500676813,2500859952,'Aquarius'],
  [2500859952,2501049176,'Pisces'],
  [2501049176,2501249073,'Aries'],
  [2501249073,2501460782,'Taurus'],
  [2501460782,2501679286,'Gemini'],
  [2501679286,2501895238,'Cancer'],
  [2501895238,2502101295,'Leo'],
  [2502101295,2502296065,'Virgo'],
  [2502296065,2502482587,'Libra'],
  [2502482587,2502665107,'Scorpio'],
  [2502665107,2502847051,'Sagittarius'],
  [2502847051,2503030671,'Capricorn'],
  [2503030671,2503217821,'Aquarius'],
  [2503217821,2503410777,'Pisces'],
  [2503410777,2503612088,'Aries'],
  [2503612088,2503822951,'Taurus'],
  [2503822951,2504040711,'Gemini'],
  [2504040711,2504258186,'Cancer'],
  [2504258186,2504467120,'Leo'],
  [2504467120,2504663326,'Virgo'],
  [2504663326,2504848115,'Libra'],
  [2504848115,2505026136,'Scorpio'],
  [2505026136,2505202908,'Sagittarius'],
  [2505202908,2505383240,'Capricorn'],
  [2505383240,2505570410,'Aquarius'],
  [2505570410,2505765974,'Pisces'],
  [2505765974,2505970119,'Aries'],
  [2505970119,2506182106,'Taurus'],
  [2506182106,2506399720,'Gemini'],
  [2506399720,2506618195,'Cancer'],
  [2506618195,2506830607,'Leo'],
  [2506830607,2507031034,'Virgo'],
  [2507031034,2507217992,'Libra'],
  [2507217992,2507394631,'Scorpio'],
  [2507394631,2507566882,'Sagittarius'],
  [2507566882,2507741460,'Capricorn'],
  [2507741460,2507924205,'Aquarius'],
  [2507924205,2508118449,'Pisces'],
  [2508118449,2508323942,'Aries'],
  [2508323942,2508537654,'Taurus'],
  [2508537654,2508755768,'Gemini'],
  [2508755768,2508974435,'Cancer'],
  [2508974435,2509189065,'Leo'],
  [2509189065,2509394282,'Virgo'],
  [2509394282,2509586413,'Libra'],
  [2509586413,2509765893,'Scorpio'],
  [2509765893,2509937299,'Sagittarius'],
  [2509937299,2510107674,'Capricorn'],
  [2510107674,2510284544,'Aquarius'],
  [2510284544,2510473819,'Pisces'],
  [2510473819,2510677247,'Aries'],
  [2510677247,2510891364,'Taurus'],
  [2510891364,2511110099,'Gemini'],
  [2511110099,2511328439,'Cancer'],
  [2511328439,2511543149,'Leo'],
  [2511543149,2511751039,'Virgo'],
  [2511751039,2511948523,'Libra'],
  [2511948523,2512133728,'Scorpio'],
  [2512133728,2512308601,'Sagittarius'],
  [2512308601,2512478834,'Capricorn'],
  [2512478834,2512652074,'Aquarius'],
  [2512652074,2512835769,'Pisces'],
  [2512835769,2513034355,'Aries'],
  [2513034355,2513246372,'Taurus'],
  [2513246372,2513465027,'Gemini'],
  [2513465027,2513683030,'Cancer'],
  [2513683030,2513896414,'Leo'],
  [2513896414,2514103710,'Virgo'],
  [2514103710,2514303465,'Libra'],
  [2514303465,2514493849,'Scorpio'],
  [2514493849,2514674620,'Sagittarius'],
  [2514674620,2514848890,'Capricorn'],
  [2514848890,2515022765,'Aquarius'],
  [2515022765,2515203557,'Pisces'],
  [2515203557,2515397277,'Aries'],
  [2515397277,2515605328,'Taurus'],
  [2515605328,2515822636,'Gemini'],
  [2515822636,2516040595,'Cancer'],
  [2516040595,2516252893,'Leo'],
  [2516252893,2516457733,'Virgo'],
  [2516457733,2516655662,'Libra'],
  [2516655662,2516847123,'Scorpio'],
  [2516847123,2517032197,'Sagittarius'],
  [2517032197,2517212119,'Capricorn'],
  [2517212119,2517390418,'Aquarius'],
  [2517390418,2517572530,'Pisces'],
  [2517572530,2517764150,'Aries'],
  [2517764150,2517968511,'Taurus'],
  [2517968511,2518183506,'Gemini'],
  [2518183506,2518401593,'Cancer'],
  [2518401593,2518614374,'Leo'],
  [2518614374,2518817681,'Virgo'],
  [2518817681,2519012037,'Libra'],
  [2519012037,2519200079,'Scorpio'],
  [2519200079,2519384418,'Sagittarius'],
  [2519384418,2519567123,'Capricorn'],
  [2519567123,2519750320,'Aquarius'],
  [2519750320,2519936849,'Pisces'],
  [2519936849,2520130190,'Aries'],
  [2520130190,2520333266,'Taurus'],
  [2520333266,2520546162,'Gemini'],
  [2520546162,2520764180,'Cancer'],
  [2520764180,2520979030,'Leo'],
  [2520979030,2521183755,'Virgo'],
  [2521183755,2521376557,'Libra'],
  [2521376557,2521560204,'Scorpio'],
  [2521560204,2521739542,'Sagittarius'],
  [2521739542,2521919400,'Capricorn'],
  [2521919400,2522103381,'Aquarius'],
  [2522103381,2522293520,'Pisces'],
  [2522293520,2522490722,'Aries'],
  [2522490722,2522695499,'Taurus'],
  [2522695499,2522907813,'Gemini'],
  [2522907813,2523125462,'Cancer'],
  [2523125462,2523342594,'Leo'],
  [2523342594,2523551378,'Virgo'],
  [2523551378,2523746786,'Libra'],
  [2523746786,2523929355,'Scorpio'],
  [2523929355,2524104081,'Sagittarius'],
  [2524104081,2524277822,'Capricorn'],
  [2524277822,2524457024,'Aquarius'],
  [2524457024,2524645855,'Pisces'],
  [2524645855,2524845040,'Aries'],
  [2524845040,2525052630,'Taurus'],
  [2525052630,2525266179,'Gemini'],
  [2525266179,2525483622,'Cancer'],
  [2525483622,2525701750,'Leo'],
  [2525701750,2525914625,'Virgo'],
  [2525914625,2526115665,'Libra'],
  [2526115665,2526302050,'Scorpio'],
  [2526302050,2526476645,'Sagittarius'],
  [2526476645,2526646289,'Capricorn'],
  [2526646289,2526819037,'Aquarius'],
  [2526819037,2527001839,'Pisces'],
  [2527001839,2527198077,'Aries'],
  [2527198077,2527406132,'Taurus'],
  [2527406132,2527621259,'Gemini'],
  [2527621259,2527839111,'Cancer'],
  [2527839111,2528056884,'Leo'],
  [2528056884,2528271273,'Virgo'],
  [2528271273,2528477165,'Libra'],
  [2528477165,2528670002,'Scorpio'],
  [2528670002,2528849418,'Sagittarius'],
  [2528849418,2529020143,'Capricorn'],
  [2529020143,2529189848,'Aquarius'],
  [2529189848,2529366626,'Pisces'],
  [2529366626,2529556569,'Aries'],
  [2529556569,2529761000,'Taurus'],
  [2529761000,2529975709,'Gemini'],
  [2529975709,2530194088,'Cancer'],
  [2530194088,2530411253,'Leo'],
  [2530411253,2530624575,'Virgo'],
  [2530624575,2530831504,'Libra'],
  [2530831504,2531028826,'Scorpio'],
  [2531028826,2531214661,'Sagittarius'],
  [2531214661,2531390799,'Capricorn'],
  [2531390799,2531562692,'Aquarius'],
  [2531562692,2531737614,'Pisces'],
  [2531737614,2531922502,'Aries'],
  [2531922502,2532121385,'Taurus'],
  [2532121385,2532332975,'Gemini'],
  [2532332975,2532550936,'Cancer'],
  [2532550936,2532767970,'Leo'],
  [2532767970,2532979673,'Virgo'],
  [2532979673,2533184438,'Libra'],
  [2533184438,2533381600,'Scorpio'],
  [2533381600,2533570716,'Sagittarius'],
  [2533570716,2533752501,'Capricorn'],
  [2533752501,2533929833,'Aquarius'],
  [2533929833,2534107613,'Pisces'],
  [2534107613,2534291634,'Aries'],
  [2534291634,2534486727,'Taurus'],
  [2534486727,2534694350,'Gemini'],
  [2534694350,2534910705,'Cancer'],
  [2534910705,2535128031,'Leo'],
  [2535128031,2535339336,'Virgo'],
  [2535339336,2535541631,'Libra'],
  [2535541631,2535735462,'Scorpio'],
  [2535735462,2535922929,'Sagittarius'],
  [2535922929,2536106353,'Capricorn'],
  [2536106353,2536288067,'Aquarius'],
  [2536288067,2536470760,'Pisces'],
  [2536470760,2536657758,'Aries'],
  [2536657758,2536852657,'Taurus'],
  [2536852657,2537057886,'Gemini'],
  [2537057886,2537272372,'Cancer'],
  [2537272372,2537490130,'Leo'],
  [2537490130,2537702777,'Virgo'],
  [2537702777,2537904702,'Libra'],
  [2537904702,2538095507,'Scorpio'],
  [2538095507,2538278670,'Sagittarius'],
  [2538278670,2538458978,'Capricorn'],
  [2538458978,2538640587,'Aquarius'],
  [2538640587,2538826173,'Pisces'],
  [2538826173,2539017160,'Aries'],
  [2539017160,2539214699,'Taurus'],
  [2539214699,2539420113,'Gemini'],
  [2539420113,2539633589,'Cancer'],
  [2539633589,2539851705,'Leo'],
  [2539851705,2540066837,'Virgo'],
  [2540066837,2540271194,'Libra'],
  [2540271194,2540461901,'Scorpio'],
  [2540461901,2540641859,'Sagittarius'],
  [2540641859,2540817204,'Capricorn'],
  [2540817204,2540994428,'Aquarius'],
  [2540994428,2541178302,'Pisces'],
  [2541178302,2541370700,'Aries'],
  [2541370700,2541571111,'Taurus'],
  [2541571111,2541778517,'Gemini'],
  [2541778517,2541992289,'Cancer'],
  [2541992289,2542210601,'Leo'],
  [2542210601,2542428056,'Virgo'],
  [2542428056,2542636621,'Libra'],
  [2542636621,2542830772,'Scorpio'],
  [2542830772,2543011156,'Sagittarius'],
  [2543011156,2543183490,'Capricorn'],
  [2543183490,2543355420,'Aquarius'],
  [2543355420,2543533955,'Pisces'],
  [2543533955,2543723355,'Aries'],
  [2543723355,2543923905,'Taurus'],
  [2543923905,2544133067,'Gemini'],
  [2544133067,2544347987,'Cancer'],
  [2544347987,2544566411,'Leo'],
  [2544566411,2544784851,'Virgo'],
  [2544784851,2544997102,'Libra'],
  [2544997102,2545196695,'Scorpio'],
  [2545196695,2545381453,'Sagittarius'],
  [2545381453,2545554977,'Capricorn'],
  [2545554977,2545724393,'Aquarius'],
  [2545724393,2545897609,'Pisces'],
  [2545897609,2546081135,'Aries'],
  [2546081135,2546277916,'Taurus'],
  [2546277916,2546486386,'Gemini'],
  [2546486386,2546702118,'Cancer'],
  [2546702118,2546920705,'Leo'],
  [2546920705,2547138680,'Virgo'],
  [2547138680,2547352024,'Libra'],
  [2547352024,2547555836,'Scorpio'],
  [2547555836,2547746712,'Sagittarius'],
  [2547746712,2547925436,'Capricorn'],
  [2547925436,2548096951,'Aquarius'],
  [2548096951,2548268347,'Pisces'],
  [2548268347,2548446847,'Aries'],
  [2548446847,2548637781,'Taurus'],
  [2548637781,2548842449,'Gemini'],
  [2548842449,2549057315,'Cancer'],
  [2549057315,2549276047,'Leo'],
  [2549276047,2549493104,'Virgo'],
  [2549493104,2549704947,'Libra'],
  [2549704947,2549909139,'Scorpio'],
  [2549909139,2550103838,'Sagittarius'],
  [2550103838,2550288711,'Capricorn'],
  [2550288711,2550465993,'Aquarius'],
  [2550465993,2550640345,'Pisces'],
  [2550640345,2550817819,'Aries'],
  [2550817819,2551004401,'Taurus'],
  [2551004401,2551203978,'Gemini'],
  [2551203978,2551415937,'Cancer'],
  [2551415937,2551634358,'Leo'],
  [2551634358,2551851243,'Virgo'],
  [2551851243,2552061128,'Libra'],
  [2552061128,2552262464,'Scorpio'],
  [2552262464,2552456091,'Sagittarius'],
  [2552456091,2552643460,'Capricorn'],
  [2552643460,2552826151,'Aquarius'],
  [2552826151,2553006325,'Pisces'],
  [2553006325,2553187327,'Aries'],
  [2553187327,2553373686,'Taurus'],
  [2553373686,2553569986,'Gemini'],
  [2553569986,2553778383,'Cancer'],
  [2553778383,2553995678,'Leo'],
  [2553995678,2554213437,'Virgo'],
  [2554213437,2554423271,'Libra'],
  [2554423271,2554621932,'Scorpio'],
  [2554621932,2554811379,'Sagittarius'],
  [2554811379,2554995791,'Capricorn'],
  [2554995791,2555178912,'Aquarius'],
  [2555178912,2555362959,'Pisces'],
  [2555362959,2555549139,'Aries'],
  [2555549139,2555739137,'Taurus'],
  [2555739137,2555935892,'Gemini'],
  [2555935892,2556142321,'Cancer'],
  [2556142321,2556358115,'Leo'],
  [2556358115,2556577030,'Virgo'],
  [2556577030,2556789299,'Libra'],
  [2556789299,2556988512,'Scorpio'],
  [2556988512,2557175164,'Sagittarius'],
  [2557175164,2557354501,'Capricorn'],
  [2557354501,2557532839,'Aquarius'],
  [2557532839,2557714965,'Pisces'],
  [2557714965,2557902941,'Aries'],
  [2557902941,2558096848,'Taurus'],
  [2558096848,2558296825,'Gemini'],
  [2558296825,2558504039,'Cancer'],
  [2558504039,2558719063,'Leo'],
  [2558719063,2558938539,'Virgo'],
  [2558938539,2559154149,'Libra'],
  [2559154149,2559357374,'Scorpio'],
  [2559357374,2559545563,'Sagittarius'],
  [2559545563,2559722628,'Capricorn'],
  [2559722628,2559895657,'Aquarius'],
  [2559895657,2560071723,'Pisces'],
  [2560071723,2560255752,'Aries'],
  [2560255752,2560449387,'Taurus'],
  [2560449387,2560651734,'Gemini'],
  [2560651734,2560861296,'Cancer'],
  [2560861296,2561076923,'Leo'],
  [2561076923,2561296351,'Virgo'],
  [2561296351,2561514001,'Libra'],
  [2561514001,2561722103,'Scorpio'],
  [2561722103,2561915550,'Sagittarius'],
  [2561915550,2562095268,'Capricorn'],
  [2562095268,2562266966,'Aquarius'],
  [2562266966,2562438102,'Pisces'],
  [2562438102,2562615597,'Aries'],
  [2562615597,2562804088,'Taurus'],
  [2562804088,2563004709,'Gemini'],
  [2563004709,2563215303,'Cancer'],
  [2563215303,2563432156,'Leo'],
  [2563432156,2563651517,'Virgo'],
  [2563651517,2563869171,'Libra'],
  [2563869171,2564079875,'Scorpio'],
  [2564079875,2564278820,'Sagittarius'],
  [2564278820,2564464496,'Capricorn'],
  [2564464496,2564639787,'Aquarius'],
  [2564639787,2564810601,'Pisces'],
  [2564810601,2564983926,'Aries'],
  [2564983926,2565166193,'Taurus'],
  [2565166193,2565361525,'Gemini'],
  [2565361525,2565569930,'Cancer'],
  [2565569930,2565787001,'Leo'],
  [2565787001,2566006479,'Virgo'],
  [2566006479,2566223083,'Libra'],
  [2566223083,2566433229,'Scorpio'],
  [2566433229,2566634444,'Sagittarius'],
  [2566634444,2566825369,'Capricorn'],
  [2566825369,2567006708,'Aquarius'],
  [2567006708,2567181658,'Pisces'],
  [2567181658,2567355491,'Aries'],
  [2567355491,2567534521,'Taurus'],
  [2567534521,2567724560,'Gemini'],
  [2567724560,2567928533,'Cancer'],
  [2567928533,2568143945,'Leo'],
  [2568143945,2568363402,'Virgo'],
  [2568363402,2568579214,'Libra'],
  [2568579214,2568787245,'Scorpio'],
  [2568787245,2568986937,'Sagittarius'],
  [2568986937,2569179130,'Capricorn'],
  [2569179130,2569364811,'Aquarius'],
  [2569364811,2569545352,'Pisces'],
  [2569545352,2569723432,'Aries'],
  [2569723432,2569903550,'Taurus'],
  [2569903550,2570091319,'Gemini'],
  [2570091319,2570291360,'Cancer'],
  [2570291360,2570503980,'Leo'],
  [2570503980,2570723020,'Virgo'],
  [2570723020,2570939024,'Libra'],
  [2570939024,2571145646,'Scorpio'],
  [2571145646,2571342274,'Sagittarius'],
  [2571342274,2571531770,'Capricorn'],
  [2571531770,2571717302,'Aquarius'],
  [2571717302,2571900855,'Pisces'],
  [2571900855,2572083670,'Aries'],
  [2572083670,2572267798,'Taurus'],
  [2572267798,2572456982,'Gemini'],
  [2572456982,2572655653,'Cancer'],
  [2572655653,2572865973,'Leo'],
  [2572865973,2573084329,'Virgo'],
  [2573084329,2573301517,'Libra'],
  [2573301517,2573508852,'Scorpio'],
  [2573508852,2573703802,'Sagittarius'],
  [2573703802,2573889503,'Capricorn'],
  [2573889503,2574071116,'Aquarius'],
  [2574071116,2574252923,'Pisces'],
  [2574252923,2574437195,'Aries'],
  [2574437195,2574624956,'Taurus'],
  [2574624956,2574817643,'Gemini'],
  [2574817643,2575017773,'Cancer'],
  [2575017773,2575227482,'Leo'],
  [2575227482,2575445277,'Virgo'],
  [2575445277,2575664013,'Libra'],
  [2575664013,2575874207,'Scorpio'],
  [2575874207,2576070620,'Sagittarius'],
  [2576070620,2576254735,'Capricorn'],
  [2576254735,2576432077,'Aquarius'],
  [2576432077,2576608845,'Pisces'],
  [2576608845,2576789801,'Aries'],
  [2576789801,2576977438,'Taurus'],
  [2576977438,2577172556,'Gemini'],
  [2577172556,2577375443,'Cancer'],
  [2577375443,2577586321,'Leo'],
  [2577586321,2577804041,'Virgo'],
  [2577804041,2578023814,'Libra'],
  [2578023814,2578237576,'Scorpio'],
  [2578237576,2578438406,'Sagittarius'],
  [2578438406,2578624922,'Capricorn'],
  [2578624922,2578801099,'Aquarius'],
  [2578801099,2578973415,'Pisces'],
  [2578973415,2579148476,'Aries'],
  [2579148476,2579331464,'Taurus'],
  [2579331464,2579525073,'Gemini'],
  [2579525073,2579729252,'Cancer'],
  [2579729252,2579941939,'Leo'],
  [2579941939,2580160185,'Virgo'],
  [2580160185,2580380046,'Libra'],
  [2580380046,2580595957,'Scorpio'],
  [2580595957,2580801817,'Sagittarius'],
  [2580801817,2580994038,'Capricorn'],
  [2580994038,2581173654,'Aquarius'],
  [2581173654,2581345508,'Pisces'],
  [2581345508,2581516318,'Aries'],
  [2581516318,2581693014,'Taurus'],
  [2581693014,2581881136,'Gemini'],
  [2581881136,2582082896,'Cancer'],
  [2582082896,2582295982,'Leo'],
  [2582295982,2582514984,'Virgo'],
  [2582514984,2582734407,'Libra'],
  [2582734407,2582950022,'Scorpio'],
  [2582950022,2583158298,'Sagittarius'],
  [2583158298,2583356145,'Capricorn'],
  [2583356145,2583542289,'Aquarius'],
  [2583542289,2583718556,'Pisces'],
  [2583718556,2583889832,'Aries'],
  [2583889832,2584062933,'Taurus'],
  [2584062933,2584245000,'Gemini'],
  [2584245000,2584441214,'Cancer'],
  [2584441214,2584651742,'Leo'],
  [2584651742,2584870704,'Virgo'],
  [2584870704,2585089934,'Libra'],
  [2585089934,2585303956,'Scorpio'],
  [2585303956,2585510941,'Sagittarius'],
  [2585510941,2585710417,'Capricorn'],
  [2585710417,2585901720,'Aquarius'],
  [2585901720,2586084633,'Pisces'],
  [2586084633,2586261019,'Aries'],
  [2586261019,2586435613,'Taurus'],
  [2586435613,2586615128,'Gemini'],
  [2586615128,2586806199,'Cancer'],
  [2586806199,2587012088,'Leo'],
  [2587012088,2587229309,'Virgo'],
  [2587229309,2587448693,'Libra'],
  [2587448693,2587661930,'Scorpio'],
  [2587661930,2587866234,'Sagittarius'],
  [2587866234,2588062984,'Capricorn'],
  [2588062984,2588254211,'Aquarius'],
  [2588254211,2588440781,'Pisces'],
  [2588440781,2588623077,'Aries'],
  [2588623077,2588802977,'Taurus'],
  [2588802977,2588984842,'Gemini'],
  [2588984842,2589174526,'Cancer'],
  [2589174526,2589376712,'Leo'],
  [2589376712,2589591093,'Virgo'],
  [2589591093,2589810402,'Libra'],
  [2589810402,2590024617,'Scorpio'],
  [2590024617,2590228071,'Sagittarius'],
  [2590228071,2590421400,'Capricorn'],
  [2590421400,2590608420,'Aquarius'],
  [2590608420,2590792778,'Pisces'],
  [2590792778,2590976540,'Aries'],
  [2590976540,2591160856,'Taurus'],
  [2591160856,2591347574,'Gemini'],
  [2591347574,2591539977,'Cancer'],
  [2591539977,2591741728,'Leo'],
  [2591741728,2591954072,'Virgo'],
  [2591954072,2592172828,'Libra'],
  [2592172828,2592389039,'Scorpio'],
  [2592389039,2592594674,'Sagittarius'],
  [2592594674,2592787586,'Capricorn'],
  [2592787586,2592970944,'Aquarius'],
  [2592970944,2593149999,'Pisces'],
  [2593149999,2593329602,'Aries'],
  [2593329602,2593513086,'Taurus'],
  [2593513086,2593702345,'Gemini'],
  [2593702345,2593898568,'Cancer'],
  [2593898568,2594102763,'Leo'],
  [2594102763,2594315176,'Virgo'],
  [2594315176,2594533409,'Libra'],
  [2594533409,2594751251,'Scorpio'],
  [2594751251,2594960782,'Sagittarius'],
  [2594960782,2595157096,'Capricorn'],
  [2595157096,2595340753,'Aquarius'],
  [2595340753,2595516379,'Pisces'],
  [2595516379,2595690209,'Aries'],
  [2595690209,2595868225,'Taurus'],
  [2595868225,2596054818,'Gemini'],
  [2596054818,2596251841,'Cancer'],
  [2596251841,2596458534,'Leo'],
  [2596458534,2596672575,'Virgo'],
  [2596672575,2596890887,'Libra'],
  [2596890887,2597109253,'Scorpio'],
  [2597109253,2597321978,'Sagittarius'],
  [2597321978,2597523497,'Capricorn'],
  [2597523497,2597711507,'Aquarius'],
  [2597711507,2597888200,'Pisces'],
  [2597888200,2598059187,'Aries'],
  [2598059187,2598231577,'Taurus'],
  [2598231577,2598412179,'Gemini'],
  [2598412179,2598605508,'Cancer'],
  [2598605508,2598811797,'Leo'],
  [2598811797,2599027073,'Virgo'],
  [2599027073,2599245944,'Libra'],
  [2599245944,2599463985,'Scorpio'],
  [2599463985,2599677635,'Sagittarius'],
  [2599677635,2599883029,'Capricorn'],
  [2599883029,2600076826,'Aquarius'],
  [2600076826,2600258442,'Pisces'],
  [2600258442,2600431206,'Aries'],
  [2600431206,2600601544,'Taurus'],
  [2600601544,2600777108,'Gemini'],
  [2600777108,2600964642,'Cancer'],
  [2600964642,2601167112,'Leo'],
  [2601167112,2601381505,'Virgo'],
  [2601381505,2601600675,'Libra'],
  [2601600675,2601818201,'Scorpio'],
  [2601818201,2602030800,'Sagittarius'],
  [2602030800,2602236812,'Capricorn'],
  [2602236812,2602434303,'Aquarius'],
  [2602434303,2602621638,'Pisces'],
  [2602621638,2602799551,'Aries'],
  [2602799551,2602972278,'Taurus'],
  [2602972278,2603146619,'Gemini'],
  [2603146619,2603329942,'Cancer'],
  [2603329942,2603527431,'Leo'],
  [2603527431,2603738751,'Virgo'],
  [2603738751,2603957288,'Libra'],
  [2603957288,2604174593,'Scorpio'],
  [2604174593,2604385705,'Sagittarius'],
  [2604385705,2604589678,'Capricorn'],
  [2604589678,2604786851,'Aquarius'],
  [2604786851,2604977011,'Pisces'],
  [2604977011,2605160062,'Aries'],
  [2605160062,2605337882,'Taurus'],
  [2605337882,2605515058,'Gemini'],
  [2605515058,2605697880,'Cancer'],
  [2605697880,2605892118,'Leo'],
  [2605892118,2606099821,'Virgo'],
  [2606099821,2606316785,'Libra'],
  [2606316785,2606534300,'Scorpio'],
  [2606534300,2606745031,'Sagittarius'],
  [2606745031,2606946694,'Capricorn'],
  [2606946694,2607140675,'Aquarius'],
  [2607140675,2607329148,'Pisces'],
  [2607329148,2607513655,'Aries'],
  [2607513655,2607695624,'Taurus'],
  [2607695624,2607877547,'Gemini'],
  [2607877547,2608063381,'Cancer'],
  [2608063381,2608257637,'Leo'],
  [2608257637,2608463166,'Virgo'],
  [2608463166,2608678356,'Libra'],
  [2608678356,2608896326,'Scorpio'],
  [2608896326,2609108484,'Sagittarius'],
  [2609108484,2609309919,'Capricorn'],
  [2609309919,2609500985,'Aquarius'],
  [2609500985,2609685113,'Pisces'],
  [2609685113,2609866353,'Aries'],
  [2609866353,2610048085,'Taurus'],
  [2610048085,2610232849,'Gemini'],
  [2610232849,2610422757,'Cancer'],
  [2610422757,2610619832,'Leo'],
  [2610619832,2610825655,'Virgo'],
  [2610825655,2611039822,'Libra'],
  [2611039822,2611258137,'Scorpio'],
  [2611258137,2611472974,'Sagittarius'],
  [2611472974,2611677230,'Capricorn'],
  [2611677230,2611868531,'Aquarius'],
  [2611868531,2612049482,'Pisces'],
  [2612049482,2612225450,'Aries'],
  [2612225450,2612402358,'Taurus'],
  [2612402358,2612585071,'Gemini'],
  [2612585071,2612776312,'Cancer'],
  [2612776312,2612976467,'Leo'],
  [2612976467,2613184515,'Virgo'],
  [2613184515,2613398980,'Libra'],
  [2613398980,2613617319,'Scorpio'],
  [2613617319,2613834486,'Sagittarius'],
  [2613834486,2614043431,'Capricorn'],
  [2614043431,2614238952,'Aquarius'],
  [2614238952,2614420915,'Pisces'],
  [2614420915,2614593943,'Aries'],
  [2614593943,2614765133,'Taurus'],
  [2614765133,2614941789,'Gemini'],
  [2614941789,2615129339,'Cancer'],
  [2615129339,2615329340,'Leo'],
  [2615329340,2615539282,'Virgo'],
  [2615539282,2615755066,'Libra'],
  [2615755066,2615973365,'Scorpio'],
  [2615973365,2616191148,'Sagittarius'],
  [2616191148,2616403720,'Capricorn'],
  [2616403720,2616605313,'Aquarius'],
  [2616605313,2616792708,'Pisces'],
  [2616792708,2616967810,'Aries'],
  [2616967810,2617136873,'Taurus'],
  [2617136873,2617308011,'Gemini'],
  [2617308011,2617488903,'Cancer'],
  [2617488903,2617684154,'Leo'],
  [2617684154,2617892852,'Virgo'],
  [2617892852,2618109460,'Libra'],
  [2618109460,2618328028,'Scorpio'],
  [2618328028,2618545022,'Sagittarius'],
  [2618545022,2618757997,'Capricorn'],
  [2618757997,2618963384,'Aquarius'],
  [2618963384,2619157295,'Pisces'],
  [2619157295,2619338644,'Aries'],
  [2619338644,2619510962,'Taurus'],
  [2619510962,2619681188,'Gemini'],
  [2619681188,2619857353,'Cancer'],
  [2619857353,2620046182,'Leo'],
  [2620046182,2620250054,'Virgo'],
  [2620250054,2620465161,'Libra'],
  [2620465161,2620683934,'Scorpio'],
  [2620683934,2620900210,'Sagittarius'],
  [2620900210,2621111303,'Capricorn'],
  [2621111303,2621316009,'Aquarius'],
  [2621316009,2621512700,'Pisces'],
  [2621512700,2621699966,'Aries'],
  [2621699966,2621878727,'Taurus'],
  [2621878727,2622053149,'Gemini'],
  [2622053149,2622229625,'Cancer'],
  [2622229625,2622414869,'Leo'],
  [2622414869,2622613407,'Virgo'],
  [2622613407,2622824779,'Libra'],
  [2622824779,2623042805,'Scorpio'],
  [2623042805,2623259259,'Sagittarius'],
  [2623259259,2623468905,'Capricorn'],
  [2623468905,2623670543,'Aquarius'],
  [2623670543,2623864963,'Pisces'],
  [2623864963,2624053185,'Aries'],
  [2624053185,2624236372,'Taurus'],
  [2624236372,2624416664,'Gemini'],
  [2624416664,2624597672,'Cancer'],
  [2624597672,2624784081,'Leo'],
  [2624784081,2624980273,'Virgo'],
  [2624980273,2625188058,'Libra'],
  [2625188058,2625404373,'Scorpio'],
  [2625404373,2625621563,'Sagittarius'],
  [2625621563,2625831846,'Capricorn'],
  [2625831846,2626031684,'Aquarius'],
  [2626031684,2626222098,'Pisces'],
  [2626222098,2626406487,'Aries'],
  [2626406487,2626588553,'Taurus'],
  [2626588553,2626771290,'Gemini'],
  [2626771290,2626956933,'Cancer'],
  [2626956933,2627147492,'Leo'],
  [2627147492,2627345171,'Virgo'],
  [2627345171,2627551734,'Libra'],
  [2627551734,2627766494,'Scorpio'],
  [2627766494,2627984350,'Sagittarius'],
  [2627984350,2628197062,'Capricorn'],
  [2628197062,2628398240,'Aquarius'],
  [2628398240,2628586897,'Pisces'],
  [2628586897,2628766821,'Aries'],
  [2628766821,2628943897,'Taurus'],
  [2628943897,2629123672,'Gemini'],
  [2629123672,2629309778,'Cancer'],
  [2629309778,2629503426,'Leo'],
  [2629503426,2629704344,'Virgo'],
  [2629704344,2629912227,'Libra'],
  [2629912227,2630126607,'Scorpio'],
  [2630126607,2630344783,'Sagittarius'],
  [2630344783,2630560277,'Capricorn'],
  [2630560277,2630765345,'Aquarius'],
  [2630765345,2630956098,'Pisces'],
  [2630956098,2631134664,'Aries'],
  [2631134664,2631307316,'Taurus'],
  [2631307316,2631481463,'Gemini'],
  [2631481463,2631663279,'Cancer'],
  [2631663279,2631855793,'Leo'],
  [2631855793,2632058333,'Virgo'],
  [2632058333,2632268324,'Libra'],
  [2632268324,2632483498,'Scorpio'],
  [2632483498,2632701744,'Sagittarius'],
  [2632701744,2632918909,'Capricorn'],
  [2632918909,2633128228,'Aquarius'],
  [2633128228,2633323908,'Pisces'],
  [2633323908,2633505307,'Aries'],
  [2633505307,2633677255,'Taurus'],
  [2633677255,2633847369,'Gemini'],
  [2633847369,2634023386,'Cancer'],
  [2634023386,2634210905,'Leo'],
  [2634210905,2634411333,'Virgo'],
  [2634411333,2634621856,'Libra'],
  [2634621856,2634838039,'Scorpio'],
  [2634838039,2635056309,'Sagittarius'],
  [2635056309,2635273508,'Capricorn'],
  [2635273508,2635485092,'Aquarius'],
  [2635485092,2635685732,'Pisces'],
  [2635685732,2635872681,'Aries'],
  [2635872681,2636048155,'Taurus'],
  [2636048155,2636218324,'Gemini'],
  [2636218324,2636390872,'Cancer'],
  [2636390872,2636572815,'Leo'],
  [2636572815,2636768223,'Virgo'],
  [2636768223,2636976420,'Libra'],
  [2636976420,2637192581,'Scorpio'],
  [2637192581,2637410902,'Sagittarius'],
  [2637410902,2637627153,'Capricorn'],
  [2637627153,2637838189,'Aquarius'],
  [2637838189,2638040889,'Pisces'],
  [2638040889,2638232788,'Aries'],
  [2638232788,2638414059,'Taurus'],
  [2638414059,2638588331,'Gemini'],
  [2638588331,2638761643,'Cancer'],
  [2638761643,2638940746,'Leo'],
  [2638940746,2639131190,'Virgo'],
  [2639131190,2639335086,'Libra'],
  [2639335086,2639549540,'Scorpio'],
  [2639549540,2639767811,'Sagittarius'],
  [2639767811,2639983314,'Capricorn'],
  [2639983314,2640192267,'Aquarius'],
  [2640192267,2640393349,'Pisces'],
  [2640393349,2640586385,'Aries'],
  [2640586385,2640771940,'Taurus'],
  [2640771940,2640951852,'Gemini'],
  [2640951852,2641129602,'Cancer'],
  [2641129602,2641310019,'Leo'],
  [2641310019,2641498315,'Virgo'],
  [2641498315,2641698298,'Libra'],
  [2641698298,2641909934,'Scorpio'],
  [2641909934,2642127847,'Sagittarius'],
  [2642127847,2642343703,'Capricorn'],
  [2642343703,2642551320,'Aquarius'],
  [2642551320,2642749181,'Pisces'],
  [2642749181,2642939208,'Aries'],
  [2642939208,2643124381,'Taurus'],
  [2643124381,2643307302,'Gemini'],
  [2643307302,2643490050,'Cancer'],
  [2643490050,2643674866,'Leo'],
  [2643674866,2643864818,'Virgo'],
  [2643864818,2644063421,'Libra'],
  [2644063421,2644272620,'Scorpio'],
  [2644272620,2644489825,'Sagittarius'],
  [2644489825,2644707150,'Capricorn'],
  [2644707150,2644915883,'Aquarius'],
  [2644915883,2645112192,'Pisces'],
  [2645112192,2645298124,'Aries'],
  [2645298124,2645478804,'Taurus'],
  [2645478804,2645659420,'Gemini'],
  [2645659420,2645843390,'Cancer'],
  [2645843390,2646032049,'Leo'],
  [2646032049,2646225925,'Virgo'],
  [2646225925,2646426266,'Libra'],
  [2646426266,2646634830,'Scorpio'],
  [2646634830,2646851291,'Sagittarius'],
  [2646851291,2647070257,'Capricorn'],
  [2647070257,2647282441,'Aquarius'],
  [2647282441,2647480944,'Pisces'],
  [2647480944,2647665655,'Aries'],
  [2647665655,2647841881,'Taurus'],
  [2647841881,2648016756,'Gemini'],
  [2648016756,2648196441,'Cancer'],
  [2648196441,2648384273,'Leo'],
  [2648384273,2648580459,'Virgo'],
  [2648580459,2648783857,'Libra'],
  [2648783857,2648993886,'Scorpio'],
  [2648993886,2649210197,'Sagittarius'],
  [2649210197,2649429900,'Capricorn'],
  [2649429900,2649645747,'Aquarius'],
  [2649645747,2649849457,'Pisces'],
  [2649849457,2650037640,'Aries'],
  [2650037640,2650213541,'Taurus'],
  [2650213541,2650384249,'Gemini'],
  [2650384249,2650557515,'Cancer'],
  [2650557515,2650739508,'Leo'],
  [2650739508,2650933027,'Virgo'],
  [2650933027,2651137189,'Libra'],
  [2651137189,2651349175,'Scorpio'],
  [2651349175,2651566261,'Sagittarius'],
  [2651566261,2651785783,'Capricorn'],
  [2651785783,2652003129,'Aquarius'],
  [2652003129,2652211653,'Pisces'],
  [2652211653,2652406219,'Aries'],
  [2652406219,2652586830,'Taurus'],
  [2652586830,2652758440,'Gemini'],
  [2652758440,2652928363,'Cancer'],
  [2652928363,2653104001,'Leo'],
  [2653104001,2653290998,'Virgo'],
  [2653290998,2653491439,'Libra'],
  [2653491439,2653703124,'Scorpio'],
  [2653703124,2653921088,'Sagittarius'],
  [2653921088,2654140370,'Capricorn'],
  [2654140370,2654356889,'Aquarius'],
  [2654356889,2654566695,'Pisces'],
  [2654566695,2654766087,'Aries'],
  [2654766087,2654953429,'Taurus'],
  [2654953429,2655130610,'Gemini'],
  [2655130610,2655302601,'Cancer'],
  [2655302601,2655475980,'Leo'],
  [2655475980,2655657383,'Virgo'],
  [2655657383,2655851696,'Libra'],
  [2655851696,2656059775,'Scorpio'],
  [2656059775,2656277184,'Sagittarius'],
  [2656277184,2656496538,'Capricorn'],
  [2656496538,2656711712,'Aquarius'],
  [2656711712,2656919617,'Pisces'],
  [2656919617,2657119243,'Aries'],
  [2657119243,2657310399,'Taurus'],
  [2657310399,2657493768,'Gemini'],
  [2657493768,2657671536,'Cancer'],
  [2657671536,2657847759,'Leo'],
  [2657847759,2658027983,'Virgo'],
  [2658027983,2658217956,'Libra'],
  [2658217956,2658421272,'Scorpio'],
  [2658421272,2658636315,'Sagittarius'],
  [2658636315,2658855633,'Capricorn'],
  [2658855633,2659070484,'Aquarius'],
  [2659070484,2659276129,'Pisces'],
  [2659276129,2659472703,'Aries'],
  [2659472703,2659662602,'Taurus'],
  [2659662602,2659848123,'Gemini'],
  [2659848123,2660030826,'Cancer'],
  [2660030826,2660212354,'Leo'],
  [2660212354,2660395700,'Virgo'],
  [2660395700,2660585378,'Libra'],
  [2660585378,2660785816,'Scorpio'],
  [2660785816,2660998092,'Sagittarius'],
  [2660998092,2661216979,'Capricorn'],
  [2661216979,2661432798,'Aquarius'],
  [2661432798,2661638128,'Pisces'],
  [2661638128,2661831908,'Aries'],
  [2661831908,2662017784,'Taurus'],
  [2662017784,2662200501,'Gemini'],
  [2662200501,2662383486,'Cancer'],
  [2662383486,2662568336,'Leo'],
  [2662568336,2662756051,'Virgo'],
  [2662756051,2662948675,'Libra'],
  [2662948675,2663149373,'Scorpio'],
  [2663149373,2663360188,'Sagittarius'],
  [2663360188,2663578508,'Capricorn'],
  [2663578508,2663795993,'Aquarius'],
  [2663795993,2664003457,'Pisces'],
  [2664003457,2664197259,'Aries'],
  [2664197259,2664380207,'Taurus'],
  [2664380207,2664558216,'Gemini'],
  [2664558216,2664737046,'Cancer'],
  [2664737046,2664920441,'Leo'],
  [2664920441,2665109855,'Virgo'],
  [2665109855,2665305718,'Libra'],
  [2665305718,2665508819,'Scorpio'],
  [2665508819,2665720066,'Sagittarius'],
  [2665720066,2665938120,'Capricorn'],
  [2665938120,2666157049,'Aquarius'],
  [2666157049,2666368037,'Pisces'],
  [2666368037,2666565091,'Aries'],
  [2666565091,2666748631,'Taurus'],
  [2666748631,2666923882,'Gemini'],
  [2666923882,2667097621,'Cancer'],
  [2667097621,2667275856,'Leo'],
  [2667275856,2667462432,'Virgo'],
  [2667462432,2667658624,'Libra'],
  [2667658624,2667863837,'Scorpio'],
  [2667863837,2668076661,'Sagittarius'],
  [2668076661,2668294956,'Capricorn'],
  [2668294956,2668514439,'Aquarius'],
  [2668514439,2668728389,'Pisces'],
  [2668728389,2668930362,'Aries'],
  [2668930362,2669118139,'Taurus'],
  [2669118139,2669294675,'Gemini'],
  [2669294675,2669466028,'Cancer'],
  [2669466028,2669639088,'Leo'],
  [2669639088,2669819944,'Virgo'],
  [2669819944,2670012444,'Libra'],
  [2670012444,2670217068,'Scorpio'],
  [2670217068,2670431006,'Sagittarius'],
  [2670431006,2670649861,'Capricorn'],
  [2670649861,2670869040,'Aquarius'],
  [2670869040,2671083826,'Pisces'],
  [2671083826,2671289562,'Aries'],
  [2671289562,2671483094,'Taurus'],
  [2671483094,2671664662,'Gemini'],
  [2671664662,2671838025,'Cancer'],
  [2671838025,2672009233,'Leo'],
  [2672009233,2672185156,'Virgo'],
  [2672185156,2672371904,'Libra'],
  [2672371904,2672572674,'Scorpio'],
  [2672572674,2672785702,'Sagittarius'],
  [2672785702,2673004889,'Capricorn'],
  [2673004889,2673223524,'Aquarius'],
  [2673223524,2673437108,'Pisces'],
  [2673437108,2673643286,'Aries'],
  [2673643286,2673840519,'Taurus'],
  [2673840519,2674028052,'Gemini'],
  [2674028052,2674206962,'Cancer'],
  [2674206962,2674380874,'Leo'],
  [2674380874,2674555647,'Virgo'],
  [2674555647,2674738072,'Libra'],
  [2674738072,2674933678,'Scorpio'],
  [2674933678,2675143508,'Sagittarius'],
  [2675143508,2675362123,'Capricorn'],
  [2675362123,2675580638,'Aquarius'],
  [2675580638,2675792625,'Pisces'],
  [2675792625,2675996417,'Aries'],
  [2675996417,2676192969,'Taurus'],
  [2676192969,2676383234,'Gemini'],
  [2676383234,2676567605,'Cancer'],
  [2676567605,2676747177,'Leo'],
  [2676747177,2676925248,'Virgo'],
  [2676925248,2677107344,'Libra'],
  [2677107344,2677299581,'Scorpio'],
  [2677299581,2677505508,'Sagittarius'],
  [2677505508,2677722421,'Capricorn'],
  [2677722421,2677941352,'Aquarius'],
  [2677941352,2678153218,'Pisces'],
  [2678153218,2678354632,'Aries'],
  [2678354632,2678547506,'Taurus'],
  [2678547506,2678735377,'Gemini'],
  [2678735377,2678920705,'Cancer'],
  [2678920705,2679104482,'Leo'],
  [2679104482,2679287804,'Virgo'],
  [2679287804,2679473525,'Libra'],
  [2679473525,2679666189,'Scorpio'],
  [2679666189,2679869921,'Sagittarius'],
  [2679869921,2680084765,'Capricorn'],
  [2680084765,2680304128,'Aquarius'],
  [2680304128,2680517916,'Pisces'],
  [2680517916,2680719731,'Aries'],
  [2680719731,2680909936,'Taurus'],
  [2680909936,2681093026,'Gemini'],
  [2681093026,2681274048,'Cancer'],
  [2681274048,2681456518,'Leo'],
  [2681456518,2681642170,'Virgo'],
  [2681642170,2681832163,'Libra'],
  [2681832163,2682028300,'Scorpio'],
  [2682028300,2682232884,'Sagittarius'],
  [2682232884,2682446688,'Capricorn'],
  [2682446688,2682666032,'Aquarius'],
  [2682666032,2682882563,'Pisces'],
  [2682882563,2683088013,'Aries'],
  [2683088013,2683279581,'Taurus'],
  [2683279581,2683460277,'Gemini'],
  [2683460277,2683635927,'Cancer'],
  [2683635927,2683812519,'Leo'],
  [2683812519,2683994656,'Virgo'],
  [2683994656,2684184885,'Libra'],
  [2684184885,2684383892,'Scorpio'],
  [2684383892,2684591233,'Sagittarius'],
  [2684591233,2684805799,'Capricorn'],
  [2684805799,2685024923,'Aquarius'],
  [2685024923,2685243155,'Pisces'],
  [2685243155,2685453234,'Aries'],
  [2685453234,2685649946,'Taurus'],
  [2685649946,2685833142,'Gemini'],
  [2685833142,2686007133,'Cancer'],
  [2686007133,2686178452,'Leo'],
  [2686178452,2686353916,'Virgo'],
  [2686353916,2686539069,'Libra'],
  [2686539069,2686736579,'Scorpio'],
  [2686736579,2686945335,'Sagittarius'],
  [2686945335,2687161532,'Capricorn'],
  [2687161532,2687380825,'Aquarius'],
  [2687380825,2687599087,'Pisces'],
  [2687599087,2687811771,'Aries'],
  [2687811771,2688014099,'Taurus'],
  [2688014099,2688203390,'Gemini'],
  [2688203390,2688380883,'Cancer'],
  [2688380883,2688551539,'Leo'],
  [2688551539,2688722451,'Virgo'],
  [2688722451,2688901030,'Libra'],
  [2688901030,2689092915,'Scorpio'],
  [2689092915,2689299294,'Sagittarius'],
  [2689299294,2689515825,'Capricorn'],
  [2689515825,2689735566,'Aquarius'],
  [2689735566,2689953088,'Pisces'],
  [2689953088,2690165426,'Aries'],
  [2690165426,2690370254,'Taurus'],
  [2690370254,2690565125,'Gemini'],
  [2690565125,2690748949,'Cancer'],
  [2690748949,2690923781,'Leo'],
  [2690923781,2691095063,'Virgo'],
  [2691095063,2691270160,'Libra'],
  [2691270160,2691456282,'Scorpio'],
  [2691456282,2691657549,'Sagittarius'],
  [2691657549,2691871865,'Capricorn'],
  [2691871865,2692091498,'Aquarius'],
  [2692091498,2692308524,'Pisces'],
  [2692308524,2692519119,'Aries'],
  [2692519119,2692722715,'Taurus'],
  [2692722715,2692919143,'Gemini'],
  [2692919143,2693107684,'Cancer'],
  [2693107684,2693288446,'Leo'],
  [2693288446,2693464189,'Virgo'],
  [2693464189,2693640494,'Libra'],
  [2693640494,2693824233,'Scorpio'],
  [2693824233,2694021003,'Sagittarius'],
  [2694021003,2694231612,'Capricorn'],
  [2694231612,2694450100,'Aquarius'],
  [2694450100,2694667191,'Pisces'],
  [2694667191,2694876687,'Aries'],
  [2694876687,2695077598,'Taurus'],
  [2695077598,2695271611,'Gemini'],
  [2695271611,2695460284,'Cancer'],
  [2695460284,2695644397,'Leo'],
  [2695644397,2695825224,'Virgo'],
  [2695825224,2696005888,'Libra'],
  [2696005888,2696191314,'Scorpio'],
  [2696191314,2696386630,'Sagittarius'],
  [2696386630,2696594277,'Capricorn'],
  [2696594277,2696811068,'Aquarius'],
  [2696811068,2697028636,'Pisces'],
  [2697028636,2697238767,'Aries'],
  [2697238767,2697438295,'Taurus'],
  [2697438295,2697628835,'Gemini'],
  [2697628835,2697813857,'Cancer'],
  [2697813857,2697996510,'Leo'],
  [2697996510,2698179102,'Virgo'],
  [2698179102,2698363744,'Libra'],
  [2698363744,2698553069,'Scorpio'],
  [2698553069,2698750133,'Sagittarius'],
  [2698750133,2698957040,'Capricorn'],
  [2698957040,2699172541,'Aquarius'],
  [2699172541,2699390676,'Pisces'],
  [2699390676,2699603059,'Aries'],
  [2699603059,2699803984,'Taurus'],
  [2699803984,2699993131,'Gemini'],
  [2699993131,2700174123,'Cancer'],
  [2700174123,2700352037,'Leo'],
  [2700352037,2700531637,'Virgo'],
  [2700531637,2700716453,'Libra'],
  [2700716453,2700908534,'Scorpio'],
  [2700908534,2701108720,'Sagittarius'],
  [2701108720,2701317048,'Capricorn'],
  [2701317048,2701532319,'Aquarius'],
  [2701532319,2701750796,'Pisces'],
  [2701750796,2701965892,'Aries'],
  [2701965892,2702170704,'Taurus'],
  [2702170704,2702362087,'Gemini'],
  [2702362087,2702541933,'Cancer'],
  [2702541933,2702715580,'Leo'],
  [2702715580,2702889641,'Virgo'],
  [2702889641,2703070168,'Libra'],
  [2703070168,2703261021,'Scorpio'],
  [2703261021,2703462758,'Sagittarius'],
  [2703462758,2703673195,'Capricorn'],
  [2703673195,2703889257,'Aquarius'],
  [2703889257,2704107759,'Pisces'],
  [2704107759,2704324493,'Aries'],
  [2704324493,2704533676,'Taurus'],
  [2704533676,2704730269,'Gemini'],
  [2704730269,2704913230,'Cancer'],
  [2704913230,2705086275,'Leo'],
  [2705086275,2705256230,'Virgo'],
  [2705256230,2705430810,'Libra'],
  [2705430810,2705616485,'Scorpio'],
  [2705616485,2705815983,'Sagittarius'],
  [2705815983,2706026955,'Capricorn'],
  [2706026955,2706244049,'Aquarius'],
  [2706244049,2706462479,'Pisces'],
  [2706462479,2706679068,'Aries'],
  [2706679068,2706890467,'Taurus'],
  [2706890467,2707092301,'Gemini'],
  [2707092301,2707281364,'Cancer'],
  [2707281364,2707458426,'Leo'],
  [2707458426,2707628651,'Virgo'],
  [2707628651,2707799705,'Libra'],
  [2707799705,2707979502,'Scorpio'],
  [2707979502,2708173546,'Sagittarius'],
  [2708173546,2708381909,'Capricorn'],
  [2708381909,2708598957,'Aquarius'],
  [2708598957,2708817474,'Pisces'],
  [2708817474,2709032936,'Aries'],
  [2709032936,2709243414,'Taurus'],
  [2709243414,2709447037,'Gemini'],
  [2709447037,2709641240,'Cancer'],
  [2709641240,2709824745,'Leo'],
  [2709824745,2709999811,'Virgo'],
  [2709999811,2710172198,'Libra'],
  [2710172198,2710349370,'Scorpio'],
  [2710349370,2710538149,'Sagittarius'],
  [2710538149,2710741614,'Capricorn'],
  [2710741614,2710956580,'Aquarius'],
  [2710956580,2711175120,'Pisces'],
  [2711175120,2711390017,'Aries'],
  [2711390017,2711598231,'Taurus'],
  [2711598231,2711799577,'Gemini'],
  [2711799577,2711994159,'Cancer'],
  [2711994159,2712181692,'Leo'],
  [2712181692,2712362831,'Virgo'],
  [2712362831,2712540538,'Libra'],
  [2712540538,2712719985,'Scorpio'],
  [2712719985,2712907159,'Sagittarius'],
  [2712907159,2713106519,'Capricorn'],
  [2713106519,2713318075,'Aquarius'],
  [2713318075,2713536007,'Pisces'],
  [2713536007,2713751657,'Aries'],
  [2713751657,2713959081,'Taurus'],
  [2713959081,2714157190,'Gemini'],
  [2714157190,2714347901,'Cancer'],
  [2714347901,2714533776,'Leo'],
  [2714533776,2714716993,'Virgo'],
  [2714716993,2714899608,'Libra'],
  [2714899608,2715084205,'Scorpio'],
  [2715084205,2715274138,'Sagittarius'],
  [2715274138,2715472816,'Capricorn'],
  [2715472816,2715681824,'Aquarius'],
  [2715681824,2715898538,'Pisces'],
  [2715898538,2716115660,'Aries'],
  [2716115660,2716325018,'Taurus'],
  [2716325018,2716522575,'Gemini'],
  [2716522575,2716709529,'Cancer'],
  [2716709529,2716890220,'Leo'],
  [2716890220,2717069688,'Virgo'],
  [2717069688,2717252042,'Libra'],
  [2717252042,2717439762,'Scorpio'],
  [2717439762,2717633952,'Sagittarius'],
  [2717633952,2717835252,'Capricorn'],
  [2717835252,2718044213,'Aquarius'],
  [2718044213,2718259992,'Pisces'],
  [2718259992,2718478220,'Aries'],
  [2718478220,2718691134,'Taurus'],
  [2718691134,2718891908,'Gemini'],
  [2718891908,2719078931,'Cancer'],
  [2719078931,2719255966,'Leo'],
  [2719255966,2719429601,'Virgo'],
  [2719429601,2719606608,'Libra'],
  [2719606608,2719791936,'Scorpio'],
  [2719791936,2719987312,'Sagittarius'],
  [2719987312,2720191514,'Capricorn'],
  [2720191514,2720402425,'Aquarius'],
  [2720402425,2720618363,'Pisces'],
  [2720618363,2720836902,'Aries'],
  [2720836902,2721052732,'Taurus'],
  [2721052732,2721258604,'Gemini'],
  [2721258604,2721449918,'Cancer'],
  [2721449918,2721627881,'Leo'],
  [2721627881,2721798522,'Virgo'],
  [2721798522,2721969756,'Libra'],
  [2721969756,2722148916,'Scorpio'],
  [2722148916,2722340472,'Sagittarius'],
  [2722340472,2722544317,'Capricorn'],
  [2722544317,2722756764,'Aquarius'],
  [2722756764,2722973676,'Pisces'],
  [2722973676,2723192116,'Aries'],
  [2723192116,2723408823,'Taurus'],
  [2723408823,2723618500,'Gemini'],
  [2723618500,2723815674,'Cancer'],
  [2723815674,2723998657,'Leo'],
  [2723998657,2724171145,'Virgo'],
  [2724171145,2724340329,'Libra'],
  [2724340329,2724514266,'Scorpio'],
  [2724514266,2724699619,'Sagittarius'],
  [2724699619,2724899168,'Capricorn'],
  [2724899168,2725110494,'Aquarius'],
  [2725110494,2725327923,'Pisces'],
  [2725327923,2725546282,'Aries'],
  [2725546282,2725762216,'Taurus'],
  [2725762216,2725972562,'Gemini'],
  [2725972562,2726173497,'Cancer'],
  [2726173497,2726362377,'Leo'],
  [2726362377,2726540250,'Virgo'],
  [2726540250,2726712057,'Libra'],
  [2726712057,2726884859,'Scorpio'],
  [2726884859,2727065777,'Sagittarius'],
  [2727065777,2727259776,'Capricorn'],
  [2727259776,2727467320,'Aquarius'],
  [2727467320,2727683742,'Pisces'],
  [2727683742,2727902045,'Aries'],
  [2727902045,2728116891,'Taurus'],
  [2728116891,2728325476,'Gemini'],
  [2728325476,2728526238,'Cancer'],
  [2728526238,2728718112,'Leo'],
  [2728718112,2728901355,'Virgo'],
  [2728901355,2729078548,'Libra'],
  [2729078548,2729254449,'Scorpio'],
  [2729254449,2729434939,'Sagittarius'],
  [2729434939,2729625421,'Capricorn'],
  [2729625421,2729828666,'Aquarius'],
  [2729828666,2730042692,'Pisces'],
  [2730042692,2730260786,'Aries'],
  [2730260786,2730475365,'Taurus'],
  [2730475365,2730681968,'Gemini'],
  [2730681968,2730879841,'Cancer'],
  [2730879841,2731070307,'Leo'],
  [2731070307,2731255275,'Virgo'],
  [2731255275,2731436885,'Libra'],
  [2731436885,2731617802,'Scorpio'],
  [2731617802,2731801504,'Sagittarius'],
  [2731801504,2731992039,'Capricorn'],
  [2731992039,2732192806,'Aquarius'],
  [2732192806,2732404289,'Pisces'],
  [2732404289,2732621964,'Aries'],
  [2732621964,2732837512,'Taurus'],
  [2732837512,2733043905,'Gemini'],
  [2733043905,2733239128,'Cancer'],
  [2733239128,2733425641,'Leo'],
  [2733425641,2733607773,'Virgo'],
  [2733607773,2733789523,'Libra'],
  [2733789523,2733973580,'Scorpio'],
  [2733973580,2734161574,'Sagittarius'],
  [2734161574,2734355086,'Capricorn'],
  [2734355086,2734556199,'Aquarius'],
  [2734556199,2734766332,'Pisces'],
  [2734766332,2734983527,'Aries'],
  [2734983527,2735200855,'Taurus'],
  [2735200855,2735409546,'Gemini'],
  [2735409546,2735604894,'Cancer'],
  [2735604894,2735788454,'Leo'],
  [2735788454,2735965782,'Virgo'],
  [2735965782,2736143252,'Libra'],
  [2736143252,2736325733,'Scorpio'],
  [2736325733,2736515389,'Sagittarius'],
  [2736515389,2736712184,'Capricorn'],
  [2736712184,2736915740,'Aquarius'],
  [2736915740,2737126300,'Pisces'],
  [2737126300,2737343216,'Aries'],
  [2737343216,2737562083,'Taurus'],
  [2737562083,2737774610,'Gemini'],
  [2737774610,2737973608,'Cancer'],
  [2737973608,2738157977,'Leo'],
  [2738157977,2738332520,'Virgo'],
  [2738332520,2738504674,'Libra'],
  [2738504674,2738681612,'Scorpio'],
  [2738681612,2738868070,'Sagittarius'],
  [2738868070,2739065043,'Capricorn'],
  [2739065043,2739270750,'Aquarius'],
  [2739270750,2739482967,'Pisces'],
  [2739482967,2739700077,'Aries'],
  [2739700077,2739919378,'Taurus'],
  [2739919378,2740134951,'Gemini'],
  [2740134951,2740339368,'Cancer'],
  [2740339368,2740528669,'Leo'],
  [2740528669,2740705049,'Virgo'],
  [2740705049,2740875068,'Libra'],
  [2740875068,2741046638,'Scorpio'],
  [2741046638,2741226733,'Sagittarius'],
  [2741226733,2741419301,'Capricorn'],
  [2741419301,2741624016,'Aquarius'],
  [2741624016,2741837352,'Pisces'],
  [2741837352,2742055139,'Aries'],
  [2742055139,2742273970,'Taurus'],
  [2742273970,2742489981,'Gemini'],
  [2742489981,2742698008,'Cancer'],
  [2742698008,2742893548,'Leo'],
  [2742893548,2743075901,'Virgo'],
  [2743075901,2743248952,'Libra'],
  [2743248952,2743419387,'Scorpio'],
  [2743419387,2743594572,'Sagittarius'],
  [2743594572,2743780678,'Capricorn'],
  [2743780678,2743980598,'Aquarius'],
  [2743980598,2744192486,'Pisces'],
  [2744192486,2744410690,'Aries'],
  [2744410690,2744629145,'Taurus'],
  [2744629145,2744843597,'Gemini'],
  [2744843597,2745051215,'Cancer'],
  [2745051215,2745249791,'Leo'],
  [2745249791,2745438233,'Virgo'],
  [2745438233,2745617768,'Libra'],
  [2745617768,2745792247,'Scorpio'],
  [2745792247,2745967391,'Sagittarius'],
  [2745967391,2746149516,'Capricorn'],
  [2746149516,2746343754,'Aquarius'],
  [2746343754,2746551570,'Pisces'],
  [2746551570,2746768815,'Aries'],
  [2746768815,2746987476,'Taurus'],
  [2746987476,2747200650,'Gemini'],
  [2747200650,2747405447,'Cancer'],
  [2747405447,2747602147,'Leo'],
  [2747602147,2747792056,'Virgo'],
  [2747792056,2747976517,'Libra'],
  [2747976517,2748157187,'Scorpio'],
  [2748157187,2748336860,'Sagittarius'],
  [2748336860,2748519882,'Capricorn'],
  [2748519882,2748711381,'Aquarius'],
  [2748711381,2748915075,'Pisces'],
  [2748915075,2749130007,'Aries'],
  [2749130007,2749349009,'Taurus'],
  [2749349009,2749562699,'Gemini'],
  [2749562699,2749765719,'Cancer'],
  [2749765719,2749958567,'Leo'],
  [2749958567,2750144971,'Virgo'],
  [2750144971,2750328791,'Libra'],
  [2750328791,2750512464,'Scorpio'],
  [2750512464,2750697220,'Sagittarius'],
  [2750697220,2750884596,'Capricorn'],
  [2750884596,2751077576,'Aquarius'],
  [2751077576,2751279792,'Pisces'],
  [2751279792,2751492585,'Aries'],
  [2751492585,2751711583,'Taurus'],
  [2751711583,2751927304,'Gemini'],
  [2751927304,2752131541,'Cancer'],
  [2752131541,2752322643,'Leo'],
  [2752322643,2752504665,'Virgo'],
  [2752504665,2752683630,'Libra'],
  [2752683630,2752864587,'Scorpio'],
  [2752864587,2753050181,'Sagittarius'],
  [2753050181,2753241050,'Capricorn'],
  [2753241050,2753437648,'Aquarius'],
  [2753437648,2753641434,'Pisces'],
  [2753641434,2753853728,'Aries'],
  [2753853728,2754072516,'Taurus'],
  [2754072516,2754290462,'Gemini'],
  [2754290462,2754498342,'Cancer'],
  [2754498342,2754691546,'Leo'],
  [2754691546,2754872299,'Virgo'],
  [2754872299,2755046862,'Libra'],
  [2755046862,2755222130,'Scorpio'],
  [2755222130,2755403409,'Sagittarius'],
  [2755403409,2755593237,'Capricorn'],
  [2755593237,2755791729,'Aquarius'],
  [2755791729,2755998077,'Pisces'],
  [2755998077,2756211532,'Aries'],
  [2756211532,2756430341,'Taurus'],
  [2756430341,2756649542,'Gemini'],
  [2756649542,2756861322,'Cancer'],
  [2756861322,2757059397,'Leo'],
  [2757059397,2757243131,'Virgo'],
  [2757243131,2757417127,'Libra'],
  [2757417127,2757588326,'Scorpio'],
  [2757588326,2757763622,'Sagittarius'],
  [2757763622,2757948224,'Capricorn'],
  [2757948224,2758144445,'Aquarius'],
  [2758144445,2758351453,'Pisces'],
  [2758351453,2758566332,'Aries'],
  [2758566332,2758785522,'Taurus'],
  [2758785522,2759004757,'Gemini'],
  [2759004757,2759218565,'Cancer'],
  [2759218565,2759421455,'Leo'],
  [2759421455,2759610812,'Virgo'],
  [2759610812,2759788519,'Libra'],
  [2759788519,2759959868,'Scorpio'],
  [2759959868,2760131621,'Sagittarius'],
  [2760131621,2760310426,'Capricorn'],
  [2760310426,2760501253,'Aquarius'],
  [2760501253,2760705582,'Pisces'],
  [2760705582,2760920422,'Aries'],
  [2760920422,2761139985,'Taurus'],
  [2761139985,2761358606,'Gemini'],
  [2761358606,2761571982,'Cancer'],
  [2761571982,2761776917,'Leo'],
  [2761776917,2761971239,'Virgo'],
  [2761971239,2762154854,'Libra'],
  [2762154854,2762330414,'Scorpio'],
  [2762330414,2762502947,'Sagittarius'],
  [2762502947,2762678854,'Capricorn'],
  [2762678854,2762864491,'Aquarius'],
  [2762864491,2763064004,'Pisces'],
  [2763064004,2763276599,'Aries'],
  [2763276599,2763495955,'Taurus'],
  [2763495955,2763714081,'Gemini'],
  [2763714081,2763925755,'Cancer'],
  [2763925755,2764129383,'Leo'],
  [2764129383,2764325049,'Virgo'],
  [2764325049,2764513092,'Libra'],
  [2764513092,2764694389,'Scorpio'],
  [2764694389,2764871372,'Sagittarius'],
  [2764871372,2765048593,'Capricorn'],
  [2765048593,2765232072,'Aquarius'],
  [2765232072,2765427382,'Pisces'],
  [2765427382,2765636455,'Aries'],
  [2765636455,2765854729,'Taurus'],
  [2765854729,2766072939,'Gemini'],
  [2766072939,2766283502,'Cancer'],
  [2766283502,2766484386,'Leo'],
  [2766484386,2766677545,'Virgo'],
  [2766677545,2766865623,'Libra'],
  [2766865623,2767050218,'Scorpio'],
  [2767050218,2767232321,'Sagittarius'],
  [2767232321,2767413962,'Capricorn'],
  [2767413962,2767599169,'Aquarius'],
  [2767599169,2767793094,'Pisces'],
  [2767793094,2767999287,'Aries'],
  [2767999287,2768215942,'Taurus'],
  [2768215942,2768434764,'Gemini'],
  [2768434764,2768646102,'Cancer'],
  [2768646102,2768845618,'Leo'],
  [2768845618,2769035173,'Virgo'],
  [2769035173,2769219358,'Libra'],
  [2769219358,2769402246,'Scorpio'],
  [2769402246,2769586038,'Sagittarius'],
  [2769586038,2769771770,'Capricorn'],
  [2769771770,2769961061,'Aquarius'],
  [2769961061,2770156896,'Pisces'],
  [2770156896,2770362403,'Aries'],
  [2770362403,2770577730,'Taurus'],
  [2770577730,2770797187,'Gemini'],
  [2770797187,2771011109,'Cancer'],
  [2771011109,2771212441,'Leo'],
  [2771212441,2771400835,'Virgo'],
  [2771400835,2771580882,'Libra'],
  [2771580882,2771758543,'Scorpio'],
  [2771758543,2771938723,'Sagittarius'],
  [2771938723,2772124242,'Capricorn'],
  [2772124242,2772316271,'Aquarius'],
  [2772316271,2772515504,'Pisces'],
  [2772515504,2772722725,'Aries'],
  [2772722725,2772937832,'Taurus'],
  [2772937832,2773157457,'Gemini'],
  [2773157457,2773374192,'Cancer'],
  [2773374192,2773580033,'Leo'],
  [2773580033,2773771525,'Virgo'],
  [2773771525,2773951085,'Libra'],
  [2773951085,2774124554,'Scorpio'],
  [2774124554,2774298566,'Sagittarius'],
  [2774298566,2774478797,'Capricorn'],
  [2774478797,2774668763,'Aquarius'],
  [2774668763,2774869272,'Pisces'],
  [2774869272,2775078880,'Aries'],
  [2775078880,2775295053,'Taurus'],
  [2775295053,2775514507,'Gemini'],
  [2775514507,2775732425,'Cancer'],
  [2775732425,2775942632,'Leo'],
  [2775942632,2776140128,'Virgo'],
  [2776140128,2776324078,'Libra'],
  [2776324078,2776498068,'Scorpio'],
  [2776498068,2776668400,'Sagittarius'],
  [2776668400,2776842230,'Capricorn'],
  [2776842230,2777025918,'Aquarius'],
  [2777025918,2777223054,'Pisces'],
  [2777223054,2777432727,'Aries'],
  [2777432727,2777650140,'Taurus'],
  [2777650140,2777869658,'Gemini'],
  [2777869658,2778086919,'Cancer'],
  [2778086919,2778298462,'Leo'],
  [2778298462,2778500803,'Virgo'],
  [2778500803,2778691471,'Libra'],
  [2778691471,2778870837,'Scorpio'],
  [2778870837,2779042820,'Sagittarius'],
  [2779042820,2779213982,'Capricorn'],
  [2779213982,2779391831,'Aquarius'],
  [2779391831,2779582690,'Pisces'],
  [2779582690,2779788668,'Aries'],
  [2779788668,2780005573,'Taurus'],
  [2780005573,2780225382,'Gemini'],
  [2780225382,2780441601,'Cancer'],
  [2780441601,2780651540,'Leo'],
  [2780651540,2780854408,'Virgo'],
  [2780854408,2781049217,'Libra'],
  [2781049217,2781235048,'Scorpio'],
  [2781235048,2781412833,'Sagittarius'],
  [2781412833,2781586649,'Capricorn'],
  [2781586649,2781763072,'Aquarius'],
  [2781763072,2781949249,'Pisces'],
  [2781949249,2782149961,'Aries'],
  [2782149961,2782363999,'Taurus'],
  [2782363999,2782583562,'Gemini'],
  [2782583562,2782799587,'Cancer'],
  [2782799587,2783007554,'Leo'],
  [2783007554,2783207652,'Virgo'],
  [2783207652,2783401497,'Libra'],
  [2783401497,2783589876,'Scorpio'],
  [2783589876,2783773006,'Sagittarius'],
  [2783773006,2783952397,'Capricorn'],
  [2783952397,2784132081,'Aquarius'],
  [2784132081,2784317933,'Pisces'],
  [2784317933,2784515390,'Aries'],
  [2784515390,2784725944,'Taurus'],
  [2784725944,2784944387,'Gemini'],
  [2784944387,2785161120,'Cancer'],
  [2785161120,2785368902,'Leo'],
  [2785368902,2785566441,'Virgo'],
  [2785566441,2785756420,'Libra'],
  [2785756420,2785942151,'Scorpio'],
  [2785942151,2786125855,'Sagittarius'],
  [2786125855,2786308950,'Capricorn'],
  [2786308950,2786493415,'Aquarius'],
  [2786493415,2786682579,'Pisces'],
  [2786682579,2786880399,'Aries'],
  [2786880399,2787089116,'Taurus'],
  [2787089116,2787306240,'Gemini'],
  [2787306240,2787524010,'Cancer'],
  [2787524010,2787733765,'Leo'],
  [2787733765,2787931481,'Virgo'],
  [2787931481,2788118672,'Libra'],
  [2788118672,2788299720,'Scorpio'],
  [2788299720,2788479303,'Sagittarius'],
  [2788479303,2788661076,'Capricorn'],
  [2788661076,2788847499,'Aquarius'],
  [2788847499,2789040308,'Pisces'],
  [2789040308,2789240952,'Aries'],
  [2789240952,2789450244,'Taurus'],
  [2789450244,2789666762,'Gemini'],
  [2789666762,2789885336,'Cancer'],
  [2789885336,2790098168,'Leo'],
  [2790098168,2790299085,'Virgo'],
  [2790299085,2790486986,'Libra'],
  [2790486986,2790665317,'Scorpio'],
  [2790665317,2790839785,'Sagittarius'],
  [2790839785,2791016378,'Capricorn'],
  [2791016378,2791199953,'Aquarius'],
  [2791199953,2791393194,'Pisces'],
  [2791393194,2791596251,'Aries'],
  [2791596251,2791807495,'Taurus'],
  [2791807495,2792024410,'Gemini'],
  [2792024410,2792243297,'Cancer'],
  [2792243297,2792458649,'Leo'],
  [2792458649,2792664207,'Virgo'],
  [2792664207,2792856310,'Libra'],
  [2792856310,2793035946,'Scorpio'],
  [2793035946,2793208032,'Sagittarius'],
  [2793208032,2793379477,'Capricorn'],
  [2793379477,2793557295,'Aquarius'],
  [2793557295,2793746696,'Pisces'],
  [2793746696,2793949084,'Aries'],
  [2793949084,2794161599,'Taurus'],
  [2794161599,2794379417,'Gemini'],
  [2794379417,2794598236,'Cancer'],
  [2794598236,2794814362,'Leo'],
  [2794814362,2795023452,'Virgo'],
  [2795023452,2795221137,'Libra'],
  [2795221137,2795405707,'Scorpio'],
  [2795405707,2795579742,'Sagittarius'],
  [2795579742,2795749383,'Capricorn'],
  [2795749383,2795922363,'Aquarius'],
  [2795922363,2796105919,'Pisces'],
  [2796105919,2796304127,'Aries'],
  [2796304127,2796515442,'Taurus'],
  [2796515442,2796733655,'Gemini'],
  [2796733655,2796952317,'Cancer'],
  [2796952317,2797167627,'Leo'],
  [2797167627,2797377319,'Virgo'],
  [2797377319,2797578687,'Libra'],
  [2797578687,2797769134,'Scorpio'],
  [2797769134,2797948584,'Sagittarius'],
  [2797948584,2798120875,'Capricorn'],
  [2798120875,2798292803,'Aquarius'],
  [2798292803,2798472094,'Pisces'],
  [2798472094,2798664885,'Aries'],
  [2798664885,2798872440,'Taurus'],
  [2798872440,2799089613,'Gemini'],
  [2799089613,2799308185,'Cancer'],
  [2799308185,2799522343,'Leo'],
  [2799522343,2799730166,'Virgo'],
  [2799730166,2799931239,'Libra'],
  [2799931239,2800124661,'Scorpio'],
  [2800124661,2800309646,'Sagittarius'],
  [2800309646,2800487556,'Capricorn'],
  [2800487556,2800662795,'Aquarius'],
  [2800662795,2800841827,'Pisces'],
  [2800841827,2801031140,'Aries'],
  [2801031140,2801234287,'Taurus'],
  [2801234287,2801448956,'Gemini'],
  [2801448956,2801667365,'Cancer'],
  [2801667365,2801881378,'Leo'],
  [2801881378,2802087207,'Virgo'],
  [2802087207,2802285132,'Libra'],
  [2802285132,2802476744,'Scorpio'],
  [2802476744,2802663230,'Sagittarius'],
  [2802663230,2802845690,'Capricorn'],
  [2802845690,2803026352,'Aquarius'],
  [2803026352,2803209106,'Pisces'],
  [2803209106,2803398823,'Aries'],
  [2803398823,2803599469,'Taurus'],
  [2803599469,2803811342,'Gemini'],
  [2803811342,2804029250,'Cancer'],
  [2804029250,2804244553,'Leo'],
  [2804244553,2804450622,'Virgo'],
  [2804450622,2804646024,'Libra'],
  [2804646024,2804833243,'Scorpio'],
  [2804833243,2805016088,'Sagittarius'],
  [2805016088,2805198011,'Capricorn'],
  [2805198011,2805381629,'Aquarius'],
  [2805381629,2805569064,'Pisces'],
  [2805569064,2805762439,'Aries'],
  [2805762439,2805963875,'Taurus'],
  [2805963875,2806174321,'Gemini'],
  [2806174321,2806391442,'Cancer'],
  [2806391442,2806608620,'Leo'],
  [2806608620,2806817721,'Virgo'],
  [2806817721,2807014149,'Libra'],
  [2807014149,2807198810,'Scorpio'],
  [2807198810,2807376431,'Sagittarius'],
  [2807376431,2807553022,'Capricorn'],
  [2807553022,2807733889,'Aquarius'],
  [2807733889,2807922296,'Pisces'],
  [2807922296,2808119075,'Aries'],
  [2808119075,2808323543,'Taurus'],
  [2808323543,2808534784,'Gemini'],
  [2808534784,2808751411,'Cancer'],
  [2808751411,2808969712,'Leo'],
  [2808969712,2809182837,'Virgo'],
  [2809182837,2809383942,'Libra'],
  [2809383942,2809570677,'Scorpio'],
  [2809570677,2809746300,'Sagittarius'],
  [2809746300,2809917559,'Capricorn'],
  [2809917559,2810092014,'Aquarius'],
  [2810092014,2810275822,'Pisces'],
  [2810275822,2810471655,'Aries'],
  [2810471655,2810678006,'Taurus'],
  [2810678006,2810891240,'Gemini'],
  [2810891240,2811108243,'Cancer'],
  [2811108243,2811326513,'Leo'],
  [2811326513,2811541971,'Virgo'],
  [2811541971,2811748442,'Libra'],
  [2811748442,2811941038,'Scorpio'],
  [2811941038,2812119855,'Sagittarius'],
  [2812119855,2812290178,'Capricorn'],
  [2812290178,2812459920,'Aquarius'],
  [2812459920,2812637082,'Pisces'],
  [2812637082,2812827324,'Aries'],
  [2812827324,2813031447,'Taurus'],
  [2813031447,2813245297,'Gemini'],
  [2813245297,2813463149,'Cancer'],
  [2813463149,2813681006,'Leo'],
  [2813681006,2813896209,'Virgo'],
  [2813896209,2814105154,'Libra'],
  [2814105154,2814303380,'Scorpio'],
  [2814303380,2814488575,'Sagittarius'],
  [2814488575,2814663053,'Capricorn'],
  [2814663053,2814833095,'Aquarius'],
  [2814833095,2815006591,'Pisces'],
  [2815006591,2815190735,'Aries'],
  [2815190735,2815389369,'Taurus'],
  [2815389369,2815600764,'Gemini'],
  [2815600764,2815818617,'Cancer'],
  [2815818617,2816036348,'Leo'],
  [2816036348,2816250128,'Virgo'],
  [2816250128,2816457954,'Libra'],
  [2816457954,2816657829,'Scorpio'],
  [2816657829,2816847954,'Sagittarius'],
  [2816847954,2817028629,'Capricorn'],
  [2817028629,2817203377,'Aquarius'],
  [2817203377,2817378182,'Pisces'],
  [2817378182,2817559767,'Aries'],
  [2817559767,2817753432,'Taurus'],
  [2817753432,2817960491,'Gemini'],
  [2817960491,2818176754,'Cancer'],
  [2818176754,2818394562,'Leo'],
  [2818394562,2818607536,'Virgo'],
  [2818607536,2818812900,'Libra'],
  [2818812900,2819010445,'Scorpio'],
  [2819010445,2819200824,'Sagittarius'],
  [2819200824,2819385090,'Capricorn'],
  [2819385090,2819565264,'Aquarius'],
  [2819565264,2819744775,'Pisces'],
  [2819744775,2819928216,'Aries'],
  [2819928216,2820120288,'Taurus'],
  [2820120288,2820323887,'Gemini'],
  [2820323887,2820537746,'Cancer'],
  [2820537746,2820755554,'Leo'],
  [2820755554,2820969140,'Virgo'],
  [2820969140,2821173313,'Libra'],
  [2821173313,2821367528,'Scorpio'],
  [2821367528,2821554355,'Sagittarius'],
  [2821554355,2821737282,'Capricorn'],
  [2821737282,2821919410,'Aquarius'],
  [2821919410,2822103185,'Pisces'],
  [2822103185,2822290829,'Aries'],
  [2822290829,2822484839,'Taurus'],
  [2822484839,2822687625,'Gemini'],
  [2822687625,2822899721,'Cancer'],
  [2822899721,2823117417,'Leo'],
  [2823117417,2823332823,'Virgo'],
  [2823332823,2823538337,'Libra'],
  [2823538337,2823731271,'Scorpio'],
  [2823731271,2823914225,'Sagittarius'],
  [2823914225,2824092574,'Capricorn'],
  [2824092574,2824271822,'Aquarius'],
  [2824271822,2824455879,'Pisces'],
  [2824455879,2824646447,'Aries'],
  [2824646447,2824843815,'Taurus'],
  [2824843815,2825048262,'Gemini'],
  [2825048262,2825260126,'Cancer'],
  [2825260126,2825477732,'Leo'],
  [2825477732,2825695237,'Virgo'],
  [2825695237,2825904246,'Libra'],
  [2825904246,2826099316,'Scorpio'],
  [2826099316,2826281223,'Sagittarius'],
  [2826281223,2826455533,'Capricorn'],
  [2826455533,2826629455,'Aquarius'],
  [2826629455,2826809314,'Pisces'],
  [2826809314,2826998664,'Aries'],
  [2826998664,2827197632,'Taurus'],
  [2827197632,2827404424,'Gemini'],
  [2827404424,2827617406,'Cancer'],
  [2827617406,2827835107,'Leo'],
  [2827835107,2828053893,'Virgo'],
  [2828053893,2828266764,'Libra'],
  [2828266764,2828466682,'Scorpio'],
  [2828466682,2828651577,'Sagittarius'],
  [2828651577,2828825399,'Capricorn'],
  [2828825399,2828995458,'Aquarius'],
  [2828995458,2829169558,'Pisces'],
  [2829169558,2829353760,'Aries'],
  [2829353760,2829550382,'Taurus'],
  [2829550382,2829757684,'Gemini'],
  [2829757684,2829971982,'Cancer'],
  [2829971982,2830190025,'Leo'],
  [2830190025,2830408839,'Virgo'],
  [2830408839,2830623741,'Libra'],
  [2830623741,2830828581,'Scorpio'],
  [2830828581,2831019300,'Sagittarius'],
  [2831019300,2831197020,'Capricorn'],
  [2831197020,2831367407,'Aquarius'],
  [2831367407,2831538096,'Pisces'],
  [2831538096,2831716467,'Aries'],
  [2831716467,2831907525,'Taurus'],
  [2831907525,2832111963,'Gemini'],
  [2832111963,2832326138,'Cancer'],
  [2832326138,2832544563,'Leo'],
  [2832544563,2832762707,'Virgo'],
  [2832762707,2832977009,'Libra'],
  [2832977009,2833183765,'Scorpio'],
  [2833183765,2833379619,'Sagittarius'],
  [2833379619,2833563690,'Capricorn'],
  [2833563690,2833738834,'Aquarius'],
  [2833738834,2833910772,'Pisces'],
  [2833910772,2834086397,'Aries'],
  [2834086397,2834272013,'Taurus'],
  [2834272013,2834471210,'Gemini'],
  [2834471210,2834682854,'Cancer'],
  [2834682854,2834901114,'Leo'],
  [2834901114,2835118891,'Virgo'],
  [2835118891,2835331339,'Libra'],
  [2835331339,2835536301,'Scorpio'],
  [2835536301,2835733039,'Sagittarius'],
  [2835733039,2835921531,'Capricorn'],
  [2835921531,2836102943,'Aquarius'],
  [2836102943,2836280191,'Pisces'],
  [2836280191,2836457888,'Aries'],
  [2836457888,2836641596,'Taurus'],
  [2836641596,2836836291,'Gemini'],
  [2836836291,2837043908,'Cancer'],
  [2837043908,2837260895,'Leo'],
  [2837260895,2837479062,'Virgo'],
  [2837479062,2837690717,'Libra'],
  [2837690717,2837892719,'Scorpio'],
  [2837892719,2838086152,'Sagittarius'],
  [2838086152,2838273745,'Capricorn'],
  [2838273745,2838457966,'Aquarius'],
  [2838457966,2838640620,'Pisces'],
  [2838640620,2838823608,'Aries'],
  [2838823608,2839009920,'Taurus'],
  [2839009920,2839203629,'Gemini'],
  [2839203629,2839408170,'Cancer'],
  [2839408170,2839623123,'Leo'],
  [2839623123,2839841966,'Virgo'],
  [2839841966,2840055064,'Libra'],
  [2840055064,2840256330,'Scorpio'],
  [2840256330,2840446132,'Sagittarius'],
  [2840446132,2840629010,'Capricorn'],
  [2840629010,2840810214,'Aquarius'],
  [2840810214,2840993441,'Pisces'],
  [2840993441,2841180228,'Aries'],
  [2841180228,2841371138,'Taurus'],
  [2841371138,2841567551,'Gemini'],
  [2841567551,2841771889,'Cancer'],
  [2841771889,2841985371,'Leo'],
  [2841985371,2842204489,'Virgo'],
  [2842204489,2842420411,'Libra'],
  [2842420411,2842624443,'Scorpio'],
  [2842624443,2842814105,'Sagittarius'],
  [2842814105,2842993339,'Capricorn'],
  [2842993339,2843168923,'Aquarius'],
  [2843168923,2843347247,'Pisces'],
  [2843347247,2843532286,'Aries'],
  [2843532286,2843725015,'Taurus'],
  [2843725015,2843924825,'Gemini'],
  [2843924825,2844131451,'Cancer'],
  [2844131451,2844345108,'Leo'],
  [2844345108,2844564091,'Virgo'],
  [2844564091,2844782273,'Libra'],
  [2844782273,2844990928,'Scorpio'],
  [2844990928,2845184647,'Sagittarius'],
  [2845184647,2845364720,'Capricorn'],
  [2845364720,2845537244,'Aquarius'],
  [2845537244,2845709728,'Pisces'],
  [2845709728,2845888673,'Aries'],
  [2845888673,2846077863,'Taurus'],
  [2846077863,2846277725,'Gemini'],
  [2846277725,2846486396,'Cancer'],
  [2846486396,2846701479,'Leo'],
  [2846701479,2846920471,'Virgo'],
  [2846920471,2847139216,'Libra'],
  [2847139216,2847351291,'Scorpio'],
  [2847351291,2847550705,'Sagittarius'],
  [2847550705,2847735831,'Capricorn'],
  [2847735831,2847910248,'Aquarius'],
  [2847910248,2848080567,'Pisces'],
  [2848080567,2848254046,'Aries'],
  [2848254046,2848436835,'Taurus'],
  [2848436835,2848632322,'Gemini'],
  [2848632322,2848840000,'Cancer'],
  [2848840000,2849055985,'Leo'],
  [2849055985,2849275308,'Virgo'],
  [2849275308,2849493406,'Libra'],
  [2849493406,2849705989,'Scorpio'],
  [2849705989,2849909020,'Sagittarius'],
  [2849909020,2850100095,'Capricorn'],
  [2850100095,2850280089,'Aquarius'],
  [2850280089,2850453131,'Pisces'],
  [2850453131,2850625357,'Aries'],
  [2850625357,2850803454,'Taurus'],
  [2850803454,2850993058,'Gemini'],
  [2850993058,2851196607,'Cancer'],
  [2851196607,2851411463,'Leo'],
  [2851411463,2851630949,'Virgo'],
  [2851630949,2851848284,'Libra'],
  [2851848284,2852059262,'Scorpio'],
  [2852059262,2852262116,'Sagittarius'],
  [2852262116,2852456185,'Capricorn'],
  [2852456185,2852641680,'Aquarius'],
  [2852641680,2852820305,'Pisces'],
  [2852820305,2852995723,'Aries'],
  [2852995723,2853173351,'Taurus'],
  [2853173351,2853359264,'Gemini'],
  [2853359264,2853558106,'Cancer'],
  [2853558106,2853770028,'Leo'],
  [2853770028,2853989014,'Virgo'],
  [2853989014,2854206191,'Libra'],
  [2854206191,2854415480,'Scorpio'],
  [2854415480,2854615688,'Sagittarius'],
  [2854615688,2854808471,'Capricorn'],
  [2854808471,2854995759,'Aquarius'],
  [2854995759,2855178918,'Pisces'],
  [2855178918,2855359485,'Aries'],
  [2855359485,2855540436,'Taurus'],
  [2855540436,2855726493,'Gemini'],
  [2855726493,2855922742,'Cancer'],
  [2855922742,2856131614,'Leo'],
  [2856131614,2856349509,'Virgo'],
  [2856349509,2856567292,'Libra'],
  [2856567292,2856776453,'Scorpio'],
  [2856776453,2856974337,'Sagittarius'],
  [2856974337,2857163495,'Capricorn'],
  [2857163495,2857348154,'Aquarius'],
  [2857348154,2857531567,'Pisces'],
  [2857531567,2857715360,'Aries'],
  [2857715360,2857900705,'Taurus'],
  [2857900705,2858089935,'Gemini'],
  [2858089935,2858286725,'Cancer'],
  [2858286725,2858494106,'Leo'],
  [2858494106,2858710898,'Virgo'],
  [2858710898,2858929729,'Libra'],
  [2858929729,2859140825,'Scorpio'],
  [2859140825,2859338921,'Sagittarius'],
  [2859338921,2859525463,'Capricorn'],
  [2859525463,2859705670,'Aquarius'],
  [2859705670,2859885063,'Pisces'],
  [2859885063,2860067443,'Aries'],
  [2860067443,2860254538,'Taurus'],
  [2860254538,2860447199,'Gemini'],
  [2860447199,2860646731,'Cancer'],
  [2860646731,2860854768,'Leo'],
  [2860854768,2861071084,'Virgo'],
  [2861071084,2861290795,'Libra'],
  [2861290795,2861505044,'Scorpio'],
  [2861505044,2861706457,'Sagittarius'],
  [2861706457,2861893848,'Capricorn'],
  [2861893848,2862071494,'Aquarius'],
  [2862071494,2862245837,'Pisces'],
  [2862245837,2862422947,'Aries'],
  [2862422947,2862607043,'Taurus'],
  [2862607043,2862800000,'Gemini'],
  [2862800000,2863001900,'Cancer'],
  [2863001900,2863211949,'Leo'],
  [2863211949,2863428698,'Virgo'],
  [2863428698,2863648685,'Libra'],
  [2863648685,2863865481,'Scorpio'],
  [2863865481,2864071811,'Sagittarius'],
  [2864071811,2864263844,'Capricorn'],
  [2864263844,2864443221,'Aquarius'],
  [2864443221,2864615395,'Pisces'],
  [2864615395,2864787208,'Aries'],
  [2864787208,2864965140,'Taurus'],
  [2864965140,2865153847,'Gemini'],
  [2865153847,2865354854,'Cancer'],
  [2865354854,2865566235,'Leo'],
  [2865566235,2865784006,'Virgo'],
  [2865784006,2866003818,'Libra'],
  [2866003818,2866221121,'Scorpio'],
  [2866221121,2866430942,'Sagittarius'],
  [2866430942,2866629019,'Capricorn'],
  [2866629019,2866814150,'Aquarius'],
  [2866814150,2866989063,'Pisces'],
  [2866989063,2867159433,'Aries'],
  [2867159433,2867332319,'Taurus'],
  [2867332319,2867514568,'Gemini'],
  [2867514568,2867710722,'Cancer'],
  [2867710722,2867920577,'Leo'],
  [2867920577,2868138849,'Virgo'],
  [2868138849,2868358579,'Libra'],
  [2868358579,2868574727,'Scorpio'],
  [2868574727,2868784547,'Sagittarius'],
  [2868784547,2868986003,'Capricorn'],
  [2868986003,2869177412,'Aquarius'],
  [2869177412,2869358739,'Pisces'],
  [2869358739,2869532810,'Aries'],
  [2869532810,2869705263,'Taurus'],
  [2869705263,2869883258,'Gemini'],
  [2869883258,2870073433,'Cancer'],
  [2870073433,2870278779,'Leo'],
  [2870278779,2870495699,'Virgo'],
  [2870495699,2870715537,'Libra'],
  [2870715537,2870930635,'Scorpio'],
  [2870930635,2871138106,'Sagittarius'],
  [2871138106,2871338310,'Capricorn'],
  [2871338310,2871531867,'Aquarius'],
  [2871531867,2871718671,'Pisces'],
  [2871718671,2871899128,'Aries'],
  [2871899128,2872075976,'Taurus'],
  [2872075976,2872254629,'Gemini'],
  [2872254629,2872441726,'Cancer'],
  [2872441726,2872642337,'Leo'],
  [2872642337,2872856128,'Virgo'],
  [2872856128,2873075666,'Libra'],
  [2873075666,2873291069,'Scorpio'],
  [2873291069,2873496920,'Sagittarius'],
  [2873496920,2873693659,'Capricorn'],
  [2873693659,2873884280,'Aquarius'],
  [2873884280,2874071199,'Pisces'],
  [2874071199,2874255416,'Aries'],
  [2874255416,2874437841,'Taurus'],
  [2874437841,2874621069,'Gemini'],
  [2874621069,2874809653,'Cancer'],
  [2874809653,2875008436,'Leo'],
  [2875008436,2875219280,'Virgo'],
  [2875219280,2875437832,'Libra'],
  [2875437832,2875654611,'Scorpio'],
  [2875654611,2875861491,'Sagittarius'],
  [2875861491,2876056564,'Capricorn'],
  [2876056564,2876242968,'Aquarius'],
  [2876242968,2876425349,'Pisces'],
  [2876425349,2876607437,'Aries'],
  [2876607437,2876791418,'Taurus'],
  [2876791418,2876978786,'Gemini'],
  [2876978786,2877171480,'Cancer'],
  [2877171480,2877372031,'Leo'],
  [2877372031,2877582068,'Virgo'],
  [2877582068,2877799600,'Libra'],
  [2877799600,2878017736,'Scorpio'],
  [2878017736,2878227795,'Sagittarius'],
  [2878227795,2878424892,'Capricorn'],
  [2878424892,2878610022,'Aquarius'],
  [2878610022,2878787939,'Pisces'],
  [2878787939,2878964397,'Aries'],
  [2878964397,2879144379,'Taurus'],
  [2879144379,2879331200,'Gemini'],
  [2879331200,2879526369,'Cancer'],
  [2879526369,2879730028,'Leo'],
  [2879730028,2879941502,'Virgo'],
  [2879941502,2880158831,'Libra'],
  [2880158831,2880377576,'Scorpio'],
  [2880377576,2880590936,'Sagittarius'],
  [2880590936,2880792679,'Capricorn'],
  [2880792679,2880980795,'Aquarius'],
  [2880980795,2881158071,'Pisces'],
  [2881158071,2881330303,'Aries'],
  [2881330303,2881504241,'Taurus'],
  [2881504241,2881685911,'Gemini'],
  [2881685911,2881879010,'Cancer'],
  [2881879010,2882083686,'Leo'],
  [2882083686,2882297025,'Virgo'],
  [2882297025,2882515025,'Libra'],
  [2882515025,2882733702,'Scorpio'],
  [2882733702,2882948676,'Sagittarius'],
  [2882948676,2883154883,'Capricorn'],
  [2883154883,2883348543,'Aquarius'],
  [2883348543,2883529542,'Pisces'],
  [2883529542,2883701854,'Aries'],
  [2883701854,2883872170,'Taurus'],
  [2883872170,2884047983,'Gemini'],
  [2884047983,2884235578,'Cancer'],
  [2884235578,2884437483,'Leo'],
  [2884437483,2884650877,'Virgo'],
  [2884650877,2884869575,'Libra'],
  [2884869575,2885087961,'Scorpio'],
  [2885087961,2885302552,'Sagittarius'],
  [2885302552,2885510593,'Capricorn'],
  [2885510593,2885709018,'Aquarius'],
  [2885709018,2885895876,'Pisces'],
  [2885895876,2886072400,'Aries'],
  [2886072400,2886243528,'Taurus'],
  [2886243528,2886416512,'Gemini'],
  [2886416512,2886598860,'Cancer'],
  [2886598860,2886795663,'Leo'],
  [2886795663,2887006456,'Virgo'],
  [2887006456,2887224866,'Libra'],
  [2887224866,2887443056,'Scorpio'],
  [2887443056,2887656342,'Sagittarius'],
  [2887656342,2887863251,'Capricorn'],
  [2887863251,2888062956,'Aquarius'],
  [2888062956,2888254139,'Pisces'],
  [2888254139,2888436353,'Aries'],
  [2888436353,2888611967,'Taurus'],
  [2888611967,2888786422,'Gemini'],
  [2888786422,2888966754,'Cancer'],
  [2888966754,2889159222,'Leo'],
  [2889159222,2889366009,'Virgo'],
  [2889366009,2889582799,'Libra'],
  [2889582799,2889800945,'Scorpio'],
  [2889800945,2890013440,'Sagittarius'],
  [2890013440,2890218040,'Capricorn'],
  [2890218040,2890415498,'Aquarius'],
  [2890415498,2890606795,'Pisces'],
  [2890606795,2890792313,'Aries'],
  [2890792313,2890973053,'Taurus'],
  [2890973053,2891152036,'Gemini'],
  [2891152036,2891334306,'Cancer'],
  [2891334306,2891525486,'Leo'],
  [2891525486,2891729120,'Virgo'],
  [2891729120,2891943630,'Libra'],
  [2891943630,2892161772,'Scorpio'],
  [2892161772,2892374903,'Sagittarius'],
  [2892374903,2892578407,'Capricorn'],
  [2892578407,2892772639,'Aquarius'],
  [2892772639,2892960371,'Pisces'],
  [2892960371,2893144440,'Aries'],
  [2893144440,2893327024,'Taurus'],
  [2893327024,2893510212,'Gemini'],
  [2893510212,2893696742,'Cancer'],
  [2893696742,2893890019,'Leo'],
  [2893890019,2894092969,'Virgo'],
  [2894092969,2894305753,'Libra'],
  [2894305753,2894523797,'Scorpio'],
  [2894523797,2894738899,'Sagittarius'],
  [2894738899,2894944011,'Capricorn'],
  [2894944011,2895137164,'Aquarius'],
  [2895137164,2895320980,'Pisces'],
  [2895320980,2895500185,'Aries'],
  [2895500185,2895679570,'Taurus'],
  [2895679570,2895862863,'Gemini'],
  [2895862863,2896052368,'Cancer'],
  [2896052368,2896249256,'Leo'],
  [2896249256,2896454082,'Virgo'],
  [2896454082,2896666626,'Libra'],
  [2896666626,2896884460,'Scorpio'],
  [2896884460,2897101742,'Sagittarius'],
  [2897101742,2897310822,'Capricorn'],
  [2897310822,2897506739,'Aquarius'],
  [2897506739,2897689871,'Pisces'],
  [2897689871,2897864899,'Aries'],
  [2897864899,2898038421,'Taurus'],
  [2898038421,2898216854,'Gemini'],
  [2898216854,2898404670,'Cancer'],
  [2898404670,2898603115,'Leo'],
  [2898603115,2898810554,'Virgo'],
  [2898810554,2899024384,'Libra'],
  [2899024384,2899242150,'Scorpio'],
  [2899242150,2899460459,'Sagittarius'],
  [2899460459,2899673564,'Capricorn'],
  [2899673564,2899875109,'Aquarius'],
  [2899875109,2900062213,'Pisces'],
  [2900062213,2900237376,'Aries'],
  [2900237376,2900407069,'Taurus'],
  [2900407069,2900579216,'Gemini'],
  [2900579216,2900760964,'Cancer'],
  [2900760964,2900956234,'Leo'],
  [2900956234,2901163901,'Virgo'],
  [2901163901,2901379201,'Libra'],
  [2901379201,2901597370,'Scorpio'],
  [2901597370,2901815332,'Sagittarius'],
  [2901815332,2902029948,'Capricorn'],
  [2902029948,2902236402,'Aquarius'],
  [2902236402,2902430129,'Pisces'],
  [2902430129,2902610358,'Aries'],
  [2902610358,2902781360,'Taurus'],
  [2902781360,2902950614,'Gemini'],
  [2902950614,2903126352,'Cancer'],
  [2903126352,2903315147,'Leo'],
  [2903315147,2903518921,'Virgo'],
  [2903518921,2903733641,'Libra'],
  [2903733641,2903952311,'Scorpio'],
  [2903952311,2904169634,'Sagittarius'],
  [2904169634,2904383076,'Capricorn'],
  [2904383076,2904590486,'Aquarius'],
  [2904590486,2904788798,'Pisces'],
  [2904788798,2904975760,'Aries'],
  [2904975760,2905152578,'Taurus'],
  [2905152578,2905324369,'Gemini'],
  [2905324369,2905498445,'Cancer'],
  [2905498445,2905682112,'Leo'],
  [2905682112,2905879995,'Virgo'],
  [2905879995,2906091235,'Libra'],
  [2906091235,2906309378,'Scorpio'],
  [2906309378,2906526647,'Sagittarius'],
  [2906526647,2906738450,'Capricorn'],
  [2906738450,2906943458,'Aquarius'],
  [2906943458,2907141306,'Pisces'],
  [2907141306,2907331468,'Aries'],
  [2907331468,2907514208,'Taurus'],
  [2907514208,2907691946,'Gemini'],
  [2907691946,2907869415,'Cancer'],
  [2907869415,2908052551,'Leo'],
  [2908052551,2908246584,'Virgo'],
  [2908246584,2908453451,'Libra'],
  [2908453451,2908669637,'Scorpio'],
  [2908669637,2908887244,'Sagittarius'],
  [2908887244,2909098915,'Capricorn'],
  [2909098915,2909301527,'Aquarius'],
  [2909301527,2909495714,'Pisces'],
  [2909495714,2909683650,'Aries'],
  [2909683650,2909867597,'Taurus'],
  [2909867597,2910049718,'Gemini'],
  [2910049718,2910232530,'Cancer'],
  [2910232530,2910419261,'Leo'],
  [2910419261,2910613539,'Virgo'],
  [2910613539,2910817990,'Libra'],
  [2910817990,2911031925,'Scorpio'],
  [2911031925,2911249740,'Sagittarius'],
  [2911249740,2911463043,'Capricorn'],
  [2911463043,2911665816,'Aquarius'],
  [2911665816,2911857240,'Pisces'],
  [2911857240,2912040592,'Aries'],
  [2912040592,2912220710,'Taurus'],
  [2912220710,2912401974,'Gemini'],
  [2912401974,2912587306,'Cancer'],
  [2912587306,2912778210,'Leo'],
  [2912778210,2912975650,'Virgo'],
  [2912975650,2913180690,'Libra'],
  [2913180690,2913393554,'Scorpio'],
  [2913393554,2913611345,'Sagittarius'],
  [2913611345,2913827032,'Capricorn'],
  [2913827032,2914032740,'Aquarius'],
  [2914032740,2914224833,'Pisces'],
  [2914224833,2914405490,'Aries'],
  [2914405490,2914580599,'Taurus'],
  [2914580599,2914756868,'Gemini'],
  [2914756868,2914939607,'Cancer'],
  [2914939607,2915131276,'Leo'],
  [2915131276,2915331506,'Virgo'],
  [2915331506,2915538864,'Libra'],
  [2915538864,2915752265,'Scorpio'],
  [2915752265,2915970023,'Sagittarius'],
  [2915970023,2916187540,'Capricorn'],
  [2916187540,2916397347,'Aquarius'],
  [2916397347,2916593441,'Pisces'],
  [2916593441,2916775408,'Aries'],
  [2916775408,2916948259,'Taurus'],
  [2916948259,2917119537,'Gemini'],
  [2917119537,2917296621,'Cancer'],
  [2917296621,2917484515,'Leo'],
  [2917484515,2917684172,'Virgo'],
  [2917684172,2917893055,'Libra'],
  [2917893055,2918107762,'Scorpio'],
  [2918107762,2918325674,'Sagittarius'],
  [2918325674,2918543714,'Capricorn'],
  [2918543714,2918756504,'Aquarius'],
  [2918756504,2918957762,'Pisces'],
  [2918957762,2919144517,'Aries'],
  [2919144517,2919319403,'Taurus'],
  [2919319403,2919489083,'Gemini'],
  [2919489083,2919661490,'Cancer'],
  [2919661490,2919843558,'Leo'],
  [2919843558,2920038926,'Virgo'],
  [2920038926,2920246522,'Libra'],
  [2920246522,2920461828,'Scorpio'],
  [2920461828,2920680014,'Sagittarius'],
  [2920680014,2920897510,'Capricorn'],
  [2920897510,2921110757,'Aquarius'],
  [2921110757,2921315330,'Pisces'],
  [2921315330,2921507669,'Aries'],
  [2921507669,2921687880,'Taurus'],
  [2921687880,2921860319,'Gemini'],
  [2921860319,2922031845,'Cancer'],
  [2922031845,2922209734,'Leo'],
  [2922209734,2922399599,'Virgo'],
  [2922399599,2922603158,'Libra'],
  [2922603158,2922817217,'Scorpio'],
  [2922817217,2923035480,'Sagittarius'],
  [2923035480,2923252245,'Capricorn'],
  [2923252245,2923463935,'Aquarius'],
  [2923463935,2923668249,'Pisces'],
  [2923668249,2923863444,'Aries'],
  [2923863444,2924049058,'Taurus'],
  [2924049058,2924227076,'Gemini'],
  [2924227076,2924401955,'Cancer'],
  [2924401955,2924579620,'Leo'],
  [2924579620,2924765974,'Virgo'],
  [2924765974,2924964903,'Libra'],
  [2924964903,2925176011,'Scorpio'],
  [2925176011,2925393791,'Sagittarius'],
  [2925393791,2925610484,'Capricorn'],
  [2925610484,2925820514,'Aquarius'],
  [2925820514,2926022044,'Pisces'],
  [2926022044,2926215724,'Aries'],
  [2926215724,2926403021,'Taurus'],
  [2926403021,2926585667,'Gemini'],
  [2926585667,2926765985,'Cancer'],
  [2926765985,2926947323,'Leo'],
  [2926947323,2927134003,'Virgo'],
  [2927134003,2927330301,'Libra'],
  [2927330301,2927538233,'Scorpio'],
  [2927538233,2927754906,'Sagittarius'],
  [2927754906,2927972435,'Capricorn'],
  [2927972435,2928182598,'Aquarius'],
  [2928182598,2928381781,'Pisces'],
  [2928381781,2928571466,'Aries'],
  [2928571466,2928755633,'Taurus'],
  [2928755633,2928938198,'Gemini'],
  [2928938198,2929121782,'Cancer'],
  [2929121782,2929307912,'Leo'],
  [2929307912,2929498216,'Virgo'],
  [2929498216,2929695252,'Libra'],
  [2929695252,2929901593,'Scorpio'],
  [2929901593,2930116992,'Sagittarius'],
  [2930116992,2930335712,'Capricorn'],
  [2930335712,2930548356,'Aquarius'],
  [2930548356,2930748274,'Pisces'],
  [2930748274,2930935416,'Aries'],
  [2930935416,2931114684,'Taurus'],
  [2931114684,2931292438,'Gemini'],
  [2931292438,2931473835,'Cancer'],
  [2931473835,2931661395,'Leo'],
  [2931661395,2931855347,'Virgo'],
  [2931855347,2932055549,'Libra'],
  [2932055549,2932262785,'Scorpio'],
  [2932262785,2932477578,'Sagittarius'],
  [2932477578,2932696980,'Capricorn'],
  [2932696980,2932913075,'Aquarius'],
  [2932913075,2933117170,'Pisces'],
  [2933117170,2933306046,'Aries'],
  [2933306046,2933483208,'Taurus'],
  [2933483208,2933655729,'Gemini'],
  [2933655729,2933830978,'Cancer'],
  [2933830978,2934014342,'Leo'],
  [2934014342,2934207755,'Virgo'],
  [2934207755,2934410176,'Libra'],
  [2934410176,2934619747,'Scorpio'],
  [2934619747,2934835179,'Sagittarius'],
  [2934835179,2935054562,'Capricorn'],
  [2935054562,2935272778,'Aquarius'],
  [2935272778,2935481989,'Pisces'],
  [2935481989,2935676477,'Aries'],
  [2935676477,2935856620,'Taurus'],
  [2935856620,2936028019,'Gemini'],
  [2936028019,2936198354,'Cancer'],
  [2936198354,2936374938,'Leo'],
  [2936374938,2936562784,'Virgo'],
  [2936562784,2936763119,'Libra'],
  [2936763119,2936973598,'Scorpio'],
  [2936973598,2937190300,'Sagittarius'],
  [2937190300,2937409604,'Capricorn'],
  [2937409604,2937627710,'Aquarius'],
  [2937627710,2937839507,'Pisces'],
  [2937839507,2938039786,'Aries'],
  [2938039786,2938226420,'Taurus'],
  [2938226420,2938401969,'Gemini'],
  [2938401969,2938572387,'Cancer'],
  [2938572387,2938744886,'Leo'],
  [2938744886,2938926173,'Virgo'],
  [2938926173,2939120621,'Libra'],
  [2939120621,2939328422,'Scorpio'],
  [2939328422,2939545234,'Sagittarius'],
  [2939545234,2939764748,'Capricorn'],
  [2939764748,2939981729,'Aquarius'],
  [2939981729,2940192648,'Pisces'],
  [2940192648,2940394936,'Aries'],
  [2940394936,2940586962,'Taurus'],
  [2940586962,2940769119,'Gemini'],
  [2940769119,2940944416,'Cancer'],
  [2940944416,2941118052,'Leo'],
  [2941118052,2941296342,'Virgo'],
  [2941296342,2941485216,'Libra'],
  [2941485216,2941687963,'Scorpio'],
  [2941687963,2941902644,'Sagittarius'],
  [2941902644,2942122139,'Capricorn'],
  [2942122139,2942338512,'Aquarius'],
  [2942338512,2942547211,'Pisces'],
  [2942547211,2942747464,'Aries'],
  [2942747464,2942940175,'Taurus'],
  [2942940175,2943126469,'Gemini'],
  [2943126469,2943307713,'Cancer'],
  [2943307713,2943486330,'Leo'],
  [2943486330,2943666450,'Virgo'],
  [2943666450,2943853446,'Libra'],
  [2943853446,2944052107,'Scorpio'],
  [2944052107,2944263481,'Sagittarius'],
  [2944263481,2944482265,'Capricorn'],
  [2944482265,2944699047,'Aquarius'],
  [2944699047,2944906693,'Pisces'],
  [2944906693,2945103865,'Aries'],
  [2945103865,2945293329,'Taurus'],
  [2945293329,2945478657,'Gemini'],
  [2945478657,2945662317,'Cancer'],
  [2945662317,2945845658,'Leo'],
  [2945845658,2946030308,'Virgo'],
  [2946030308,2946219412,'Libra'],
  [2946219412,2946417144,'Scorpio'],
  [2946417144,2946626130,'Sagittarius'],
  [2946626130,2946843830,'Capricorn'],
  [2946843830,2947061712,'Aquarius'],
  [2947061712,2947270518,'Pisces'],
  [2947270518,2947466585,'Aries'],
  [2947466585,2947652466,'Taurus'],
  [2947652466,2947833493,'Gemini'],
  [2947833493,2948014557,'Cancer'],
  [2948014557,2948198509,'Leo'],
  [2948198509,2948386427,'Virgo'],
  [2948386427,2948579257,'Libra'],
  [2948579257,2948778973,'Scorpio'],
  [2948778973,2948987685,'Sagittarius'],
  [2948987685,2949204647,'Capricorn'],
  [2949204647,2949423682,'Aquarius'],
  [2949423682,2949635364,'Pisces'],
  [2949635364,2949833471,'Aries'],
  [2949833471,2950018533,'Taurus'],
  [2950018533,2950195808,'Gemini'],
  [2950195808,2950371780,'Cancer'],
  [2950371780,2950551753,'Leo'],
  [2950551753,2950738669,'Virgo'],
  [2950738669,2950933362,'Libra'],
  [2950933362,2951135825,'Scorpio'],
  [2951135825,2951346031,'Sagittarius'],
  [2951346031,2951563041,'Capricorn'],
  [2951563041,2951782718,'Aquarius'],
  [2951782718,2951997438,'Pisces'],
  [2951997438,2952199910,'Aries'],
  [2952199910,2952387917,'Taurus'],
  [2952387917,2952564889,'Gemini'],
  [2952564889,2952737201,'Cancer'],
  [2952737201,2952911608,'Leo'],
  [2952911608,2953093558,'Virgo'],
  [2953093558,2953286037,'Libra'],
  [2953286037,2953489218,'Scorpio'],
  [2953489218,2953701131,'Sagittarius'],
  [2953701131,2953918847,'Capricorn'],
  [2953918847,2954138523,'Aquarius'],
  [2954138523,2954354774,'Pisces'],
  [2954354774,2954561562,'Aries'],
  [2954561562,2954755027,'Taurus'],
  [2954755027,2954935807,'Gemini'],
  [2954935807,2955108461,'Cancer'],
  [2955108461,2955279521,'Leo'],
  [2955279521,2955455798,'Virgo'],
  [2955455798,2955642845,'Libra'],
  [2955642845,2955843193,'Scorpio'],
  [2955843193,2956055095,'Sagittarius'],
  [2956055095,2956273512,'Capricorn'],
  [2956273512,2956492881,'Aquarius'],
  [2956492881,2956708646,'Pisces'],
  [2956708646,2956917154,'Aries'],
  [2956917154,2957115434,'Taurus'],
  [2957115434,2957302303,'Gemini'],
  [2957302303,2957479501,'Cancer'],
  [2957479501,2957651620,'Leo'],
  [2957651620,2957825102,'Virgo'],
  [2957825102,2958006798,'Libra'],
  [2958006798,2958201899,'Scorpio'],
  [2958201899,2958411109,'Sagittarius'],
  [2958411109,2958629296,'Capricorn'],
  [2958629296,2958848516,'Aquarius'],
  [2958848516,2959062829,'Pisces'],
  [2959062829,2959269899,'Aries'],
  [2959269899,2959469246,'Taurus'],
  [2959469246,2959660553,'Gemini'],
  [2959660553,2959843900,'Cancer'],
  [2959843900,2960021063,'Leo'],
  [2960021063,2960196354,'Virgo'],
  [2960196354,2960376052,'Libra'],
  [2960376052,2960566595,'Scorpio'],
  [2960566595,2960771504,'Sagittarius'],
  [2960771504,2960987978,'Capricorn'],
  [2960987978,2961207325,'Aquarius'],
  [2961207325,2961420955,'Pisces'],
  [2961420955,2961625481,'Aries'],
  [2961625481,2961822051,'Taurus'],
  [2961822051,2962012950,'Gemini'],
  [2962012950,2962199467,'Cancer'],
  [2962199467,2962382152,'Leo'],
  [2962382152,2962562616,'Virgo'],
  [2962562616,2962744785,'Libra'],
  [2962744785,2962934252,'Scorpio'],
  [2962934252,2963135825,'Sagittarius'],
  [2963135825,2963349702,'Capricorn'],
  [2963349702,2963569069,'Aquarius'],
  [2963569069,2963783758,'Pisces'],
  [2963783758,2963987551,'Aries'],
  [2963987551,2964180787,'Taurus'],
  [2964180787,2964367436,'Gemini'],
  [2964367436,2964551523,'Cancer'],
  [2964551523,2964735373,'Leo'],
  [2964735373,2964920027,'Virgo'],
  [2964920027,2965106981,'Libra'],
  [2965106981,2965299249,'Scorpio'],
  [2965299249,2965500556,'Sagittarius'],
  [2965500556,2965712566,'Capricorn'],
  [2965712566,2965931529,'Aquarius'],
  [2965931529,2966148402,'Pisces'],
  [2966148402,2966354604,'Aries'],
  [2966354604,2966547606,'Taurus'],
  [2966547606,2966730645,'Gemini'],
  [2966730645,2966909281,'Cancer'],
  [2966909281,2967088646,'Leo'],
  [2967088646,2967272130,'Virgo'],
  [2967272130,2967461439,'Libra'],
  [2967461439,2967657548,'Scorpio'],
  [2967657548,2967861438,'Sagittarius'],
  [2967861438,2968073622,'Capricorn'],
  [2968073622,2968292094,'Aquarius'],
  [2968292094,2968510713,'Pisces'],
  [2968510713,2968721160,'Aries'],
  [2968721160,2968918029,'Taurus'],
  [2968918029,2969101739,'Gemini'],
  [2969101739,2969277060,'Cancer'],
  [2969277060,2969450409,'Leo'],
  [2969450409,2969627892,'Virgo'],
  [2969627892,2969813969,'Libra'],
  [2969813969,2970010557,'Scorpio'],
  [2970010557,2970216975,'Sagittarius'],
  [2970216975,2970430961,'Capricorn'],
  [2970430961,2970649537,'Aquarius'],
  [2970649537,2970868563,'Pisces'],
  [2970868563,2971082268,'Aries'],
  [2971082268,2971284814,'Taurus'],
  [2971284814,2971473588,'Gemini'],
  [2971473588,2971650609,'Cancer'],
  [2971650609,2971821404,'Leo'],
  [2971821404,2971993071,'Virgo'],
  [2971993071,2972172527,'Libra'],
  [2972172527,2972364641,'Scorpio'],
  [2972364641,2972570164,'Sagittarius'],
  [2972570164,2972785368,'Capricorn'],
  [2972785368,2973004639,'Aquarius'],
  [2973004639,2973223229,'Pisces'],
  [2973223229,2973437529,'Aries'],
  [2973437529,2973643835,'Taurus'],
  [2973643835,2973838809,'Gemini'],
  [2973838809,2974021566,'Cancer'],
  [2974021566,2974194974,'Leo'],
  [2974194974,2974365112,'Virgo'],
  [2974365112,2974539549,'Libra'],
  [2974539549,2974725331,'Scorpio'],
  [2974725331,2974926220,'Sagittarius'],
  [2974926220,2975140016,'Capricorn'],
  [2975140016,2975359575,'Aquarius'],
  [2975359575,2975577751,'Pisces'],
  [2975577751,2975790763,'Aries'],
  [2975790763,2975997128,'Taurus'],
  [2975997128,2976195370,'Gemini'],
  [2976195370,2976383981,'Cancer'],
  [2976383981,2976563221,'Leo'],
  [2976563221,2976736629,'Virgo'],
  [2976736629,2976910567,'Libra'],
  [2976910567,2977092412,'Scorpio'],
  [2977092412,2977287974,'Sagittarius'],
  [2977287974,2977498021,'Capricorn'],
  [2977498021,2977716568,'Aquarius'],
  [2977716568,2977934637,'Pisces'],
  [2977934637,2978146330,'Aries'],
  [2978146330,2978350411,'Taurus'],
  [2978350411,2978547634,'Gemini'],
  [2978547634,2978738328,'Cancer'],
  [2978738328,2978922445,'Leo'],
  [2978922445,2979101310,'Virgo'],
  [2979101310,2979278841,'Libra'],
  [2979278841,2979460984,'Scorpio'],
  [2979460984,2979653724,'Sagittarius'],
  [2979653724,2979859960,'Capricorn'],
  [2979859960,2980076447,'Aquarius'],
  [2980076447,2980294582,'Pisces'],
  [2980294582,2980506221,'Aries'],
  [2980506221,2980708346,'Taurus'],
  [2980708346,2980902282,'Gemini'],
  [2980902282,2981090615,'Cancer'],
  [2981090615,2981275275,'Leo'],
  [2981275275,2981457679,'Virgo'],
  [2981457679,2981639948,'Libra'],
  [2981639948,2981825632,'Scorpio'],
  [2981825632,2982019113,'Sagittarius'],
  [2982019113,2982223574,'Capricorn'],
  [2982223574,2982438100,'Aquarius'],
  [2982438100,2982656315,'Pisces'],
  [2982656315,2982869423,'Aries'],
  [2982869423,2983071842,'Taurus'],
  [2983071842,2983263455,'Gemini'],
  [2983263455,2983447625,'Cancer'],
  [2983447625,2983628570,'Leo'],
  [2983628570,2983809873,'Virgo'],
  [2983809873,2983994194,'Libra'],
  [2983994194,2984183661,'Scorpio'],
  [2984183661,2984380250,'Sagittarius'],
  [2984380250,2984585531,'Capricorn'],
  [2984585531,2984799239,'Aquarius'],
  [2984799239,2985017469,'Pisces'],
  [2985017469,2985232860,'Aries'],
  [2985232860,2985438185,'Taurus'],
  [2985438185,2985630635,'Gemini'],
  [2985630635,2985812390,'Cancer'],
  [2985812390,2985988549,'Leo'],
  [2985988549,2986164956,'Virgo'],
  [2986164956,2986346632,'Libra'],
  [2986346632,2986536694,'Scorpio'],
  [2986536694,2986735963,'Sagittarius'],
  [2986735963,2986943575,'Capricorn'],
  [2986943575,2987157870,'Aquarius'],
  [2987157870,2987376077,'Pisces'],
  [2987376077,2987593282,'Aries'],
  [2987593282,2987802797,'Taurus'],
  [2987802797,2987999460,'Gemini'],
  [2987999460,2988182745,'Cancer'],
  [2988182745,2988356726,'Leo'],
  [2988356726,2988528090,'Virgo'],
  [2988528090,2988704008,'Libra'],
  [2988704008,2988890170,'Scorpio'],
  [2988890170,2989088791,'Sagittarius'],
  [2989088791,2989297960,'Capricorn'],
  [2989297960,2989513583,'Aquarius'],
  [2989513583,2989731863,'Pisces'],
  [2989731863,2989949472,'Aries'],
  [2989949472,2990162016,'Taurus'],
  [2990162016,2990364187,'Gemini'],
  [2990364187,2990552765,'Cancer'],
  [2990552765,2990729130,'Leo'],
  [2990729130,2990898948,'Virgo'],
  [2990898948,2991070008,'Libra'],
  [2991070008,2991250006,'Scorpio'],
  [2991250006,2991443983,'Sagittarius'],
  [2991443983,2991651703,'Capricorn'],
  [2991651703,2991867955,'Aquarius'],
  [2991867955,2992086504,'Pisces'],
  [2992086504,2992303359,'Aries'],
  [2992303359,2992516080,'Taurus'],
  [2992516080,2992721537,'Gemini'],
  [2992721537,2992916140,'Cancer'],
  [2992916140,2993098551,'Leo'],
  [2993098551,2993271735,'Virgo'],
  [2993271735,2993442229,'Libra'],
  [2993442229,2993617992,'Scorpio'],
  [2993617992,2993806000,'Sagittarius'],
  [2993806000,2994009108,'Capricorn'],
  [2994009108,2994223837,'Aquarius'],
  [2994223837,2994442534,'Pisces'],
  [2994442534,2994658693,'Aries'],
  [2994658693,2994869534,'Taurus'],
  [2994869534,2995074136,'Gemini'],
  [2995074136,2995271180,'Cancer'],
  [2995271180,2995459197,'Leo'],
  [2995459197,2995638689,'Virgo'],
  [2995638689,2995813438,'Libra'],
  [2995813438,2995989728,'Scorpio'],
  [2995989728,2996174454,'Sagittarius'],
  [2996174454,2996372493,'Capricorn'],
  [2996372493,2996583632,'Aquarius'],
  [2996583632,2996801647,'Pisces'],
  [2996801647,2997018053,'Aries'],
  [2997018053,2997227499,'Taurus'],
  [2997227499,2997428974,'Gemini'],
  [2997428974,2997623526,'Cancer'],
  [2997623526,2997812211,'Leo'],
  [2997812211,2997995947,'Virgo'],
  [2997995947,2998176568,'Libra'],
  [2998176568,2998357551,'Scorpio'],
  [2998357551,2998543672,'Sagittarius'],
  [2998543672,2998739540,'Capricorn'],
  [2998739540,2998947171,'Aquarius'],
  [2998947171,2999163543,'Pisces'],
  [2999163543,2999380872,'Aries'],
  [2999380872,2999591201,'Taurus'],
  [2999591201,2999791005,'Gemini'],
  [2999791005,2999981412,'Cancer'],
  [2999981412,3000165868,'Leo'],
  [3000165868,3000348032,'Virgo'],
  [3000348032,3000530834,'Libra'],
  [3000530834,3000716492,'Scorpio'],
  [3000716492,3000907037,'Sagittarius'],
  [3000907037,3001104684,'Capricorn'],
  [3001104684,3001311208,'Aquarius'],
  [3001311208,3001525995,'Pisces'],
  [3001525995,3001744080,'Aries'],
  [3001744080,3001957231,'Taurus'],
  [3001957231,3002158879,'Gemini'],
  [3002158879,3002347817,'Cancer'],
  [3002347817,3002527671,'Leo'],
  [3002527671,3002704303,'Virgo'],
  [3002704303,3002883429,'Libra'],
  [3002883429,3003069010,'Scorpio'],
  [3003069010,3003262532,'Sagittarius'],
  [3003262532,3003463678,'Capricorn'],
  [3003463678,3003671817,'Aquarius'],
  [3003671817,3003886278,'Pisces'],
  [3003886278,3004104575,'Aries'],
  [3004104575,3004320648,'Taurus'],
  [3004320648,3004526773,'Gemini'],
  [3004526773,3004718565,'Cancer'],
  [3004718565,3004897574,'Leo'],
  [3004897574,3005069814,'Virgo'],
  [3005069814,3005242816,'Libra'],
  [3005242816,3005423236,'Scorpio'],
  [3005423236,3005614803,'Sagittarius'],
  [3005614803,3005817227,'Capricorn'],
  [3005817227,3006027613,'Aquarius'],
  [3006027613,3006243077,'Pisces'],
  [3006243077,3006461363,'Aries'],
  [3006461363,3006678855,'Taurus'],
  [3006678855,3006889300,'Gemini'],
  [3006889300,3007086643,'Cancer'],
  [3007086643,3007269380,'Leo'],
  [3007269380,3007441665,'Virgo'],
  [3007441665,3007610972,'Libra'],
  [3007610972,3007785336,'Scorpio'],
  [3007785336,3007971085,'Sagittarius'],
  [3007971085,3008170470,'Capricorn'],
  [3008170470,3008380911,'Aquarius'],
  [3008380911,3008597423,'Pisces'],
  [3008597423,3008815827,'Aries'],
  [3008815827,3009033096,'Taurus'],
  [3009033096,3009245324,'Gemini'],
  [3009245324,3009447452,'Cancer'],
  [3009447452,3009636181,'Leo'],
  [3009636181,3009812847,'Virgo'],
  [3009812847,3009983121,'Libra'],
  [3009983121,3010154662,'Scorpio'],
  [3010154662,3010334882,'Sagittarius'],
  [3010334882,3010528621,'Capricorn'],
  [3010528621,3010735910,'Aquarius'],
  [3010735910,3010951984,'Pisces'],
  [3010951984,3011170505,'Aries'],
  [3011170505,3011386878,'Taurus'],
  [3011386878,3011598173,'Gemini'],
  [3011598173,3011801646,'Cancer'],
  [3011801646,3011994824,'Leo'],
  [3011994824,3012177390,'Virgo'],
  [3012177390,3012352420,'Libra'],
  [3012352420,3012525659,'Scorpio'],
  [3012525659,3012703868,'Sagittarius'],
  [3012703868,3012892920,'Capricorn'],
  [3012892920,3013095501,'Aquarius'],
  [3013095501,3013309257,'Pisces'],
  [3013309257,3013527525,'Aries'],
  [3013527525,3013743373,'Taurus'],
  [3013743373,3013952724,'Gemini'],
  [3013952724,3014154200,'Cancer'],
  [3014154200,3014347693,'Leo'],
  [3014347693,3014533775,'Virgo'],
  [3014533775,3014714177,'Libra'],
  [3014714177,3014892211,'Scorpio'],
  [3014892211,3015072540,'Sagittarius'],
  [3015072540,3015260267,'Capricorn'],
  [3015260267,3015459279,'Aquarius'],
  [3015459279,3015669940,'Pisces'],
  [3015669940,3015887446,'Aries'],
  [3015887446,3016103677,'Taurus'],
  [3016103677,3016312113,'Gemini'],
  [3016312113,3016510690,'Cancer'],
  [3016510690,3016700981,'Leo'],
  [3016700981,3016885972,'Virgo'],
  [3016885972,3017068526,'Libra'],
  [3017068526,3017251029,'Scorpio'],
  [3017251029,3017435821,'Sagittarius'],
  [3017435821,3017625767,'Capricorn'],
  [3017625767,3017824044,'Aquarius'],
  [3017824044,3018032503,'Pisces'],
  [3018032503,3018249017,'Aries'],
  [3018249017,3018466420,'Taurus'],
  [3018466420,3018676126,'Gemini'],
  [3018676126,3018873681,'Cancer'],
  [3018873681,3019060381,'Leo'],
  [3019060381,3019241001,'Virgo'],
  [3019241001,3019420864,'Libra'],
  [3019420864,3019603884,'Scorpio'],
  [3019603884,3019791930,'Sagittarius'],
  [3019791930,3019985659,'Capricorn'],
  [3019985659,3020185964,'Aquarius'],
  [3020185964,3020394166,'Pisces'],
  [3020394166,3020609967,'Aries'],
  [3020609967,3020828639,'Taurus'],
  [3020828639,3021041496,'Gemini'],
  [3021041496,3021241373,'Cancer'],
  [3021241373,3021427336,'Leo'],
  [3021427336,3021604077,'Virgo'],
  [3021604077,3021778596,'Libra'],
  [3021778596,3021957331,'Scorpio'],
  [3021957331,3022144173,'Sagittarius'],
  [3022144173,3022339759,'Capricorn'],
  [3022339759,3022542907,'Aquarius'],
  [3022542907,3022752663,'Pisces'],
  [3022752663,3022968460,'Aries'],
  [3022968460,3023187728,'Taurus'],
  [3023187728,3023403829,'Gemini'],
  [3023403829,3023608603,'Cancer'],
  [3023608603,3023798070,'Leo'],
  [3023798070,3023974813,'Virgo'],
  [3023974813,3024145657,'Libra'],
  [3024145657,3024318448,'Scorpio'],
  [3024318448,3024499689,'Sagittarius'],
  [3024499689,3024692535,'Capricorn'],
  [3024692535,3024896211,'Aquarius'],
  [3024896211,3025107765,'Pisces'],
  [3025107765,3025324345,'Aries'],
  [3025324345,3025543442,'Taurus'],
  [3025543442,3025760841,'Gemini'],
  [3025760841,3025970079,'Cancer'],
  [3025970079,3026165697,'Leo'],
  [3026165697,3026347152,'Virgo'],
  [3026347152,3026519105,'Libra'],
  [3026519105,3026688900,'Scorpio'],
  [3026688900,3026864141,'Sagittarius'],
  [3026864141,3027050689,'Capricorn'],
  [3027050689,3027250681,'Aquarius'],
  [3027250681,3027461862,'Pisces'],
  [3027461862,3027679275,'Aries'],
  [3027679275,3027898126,'Taurus'],
  [3027898126,3028114618,'Gemini'],
  [3028114618,3028324917,'Cancer'],
  [3028324917,3028525139,'Leo'],
  [3028525139,3028713260,'Virgo'],
  [3028713260,3028890899,'Libra'],
  [3028890899,3029062998,'Scorpio'],
  [3029062998,3029236237,'Sagittarius'],
  [3029236237,3029417359,'Capricorn'],
  [3029417359,3029611274,'Aquarius'],
  [3029611274,3029818835,'Pisces'],
  [3029818835,3030035719,'Aries'],
  [3030035719,3030254712,'Taurus'],
  [3030254712,3030469841,'Gemini'],
  [3030469841,3030678027,'Cancer'],
  [3030678027,3030878153,'Leo'],
  [3030878153,3031069881,'Virgo'],
  [3031069881,3031253770,'Libra'],
  [3031253770,3031431942,'Scorpio'],
  [3031431942,3031608401,'Sagittarius'],
  [3031608401,3031788608,'Capricorn'],
  [3031788608,3031978237,'Aquarius'],
  [3031978237,3032180941,'Pisces'],
  [3032180941,3032395406,'Aries'],
  [3032395406,3032614514,'Taurus'],
  [3032614514,3032829527,'Gemini'],
  [3032829527,3033035438,'Cancer'],
  [3033035438,3033232145,'Leo'],
  [3033232145,3033422066,'Virgo'],
  [3033422066,3033607701,'Libra'],
  [3033607701,3033790789,'Scorpio'],
  [3033790789,3033972909,'Sagittarius'],
  [3033972909,3034156724,'Capricorn'],
  [3034156724,3034346398,'Aquarius'],
  [3034346398,3034546279,'Pisces'],
  [3034546279,3034757852,'Aries'],
  [3034757852,3034976552,'Taurus'],
  [3034976552,3035192887,'Gemini'],
  [3035192887,3035398889,'Cancer'],
  [3035398889,3035592883,'Leo'],
  [3035592883,3035778376,'Virgo'],
  [3035778376,3035960449,'Libra'],
  [3035960449,3036143081,'Scorpio'],
  [3036143081,3036328201,'Sagittarius'],
  [3036328201,3036516584,'Capricorn'],
  [3036516584,3036709676,'Aquarius'],
  [3036709676,3036910205,'Pisces'],
  [3036910205,3037120394,'Aries'],
  [3037120394,3037338422,'Taurus'],
  [3037338422,3037556572,'Gemini'],
  [3037556572,3037765278,'Cancer'],
  [3037765278,3037959940,'Leo'],
  [3037959940,3038142814,'Virgo'],
  [3038142814,3038319931,'Libra'],
  [3038319931,3038497613,'Scorpio'],
  [3038497613,3038680280,'Sagittarius'],
  [3038680280,3038869688,'Capricorn'],
  [3038869688,3039065937,'Aquarius'],
  [3039065937,3039269211,'Pisces'],
  [3039269211,3039480163,'Aries'],
  [3039480163,3039697924,'Taurus'],
  [3039697924,3039917357,'Gemini'],
  [3039917357,3040129772,'Cancer'],
  [3040129772,3040328372,'Leo'],
  [3040328372,3040512684,'Virgo'],
  [3040512684,3040687654,'Libra'],
  [3040687654,3040860308,'Scorpio'],
  [3040860308,3041037188,'Sagittarius'],
  [3041037188,3041222709,'Capricorn'],
  [3041222709,3041418405,'Aquarius'],
  [3041418405,3041623495,'Pisces'],
  [3041623495,3041836216,'Aries'],
  [3041836216,3042054392,'Taurus'],
  [3042054392,3042274176,'Gemini'],
  [3042274176,3042489206,'Cancer'],
  [3042489206,3042692780,'Leo'],
  [3042692780,3042881958,'Virgo'],
  [3042881958,3043059151,'Libra'],
  [3043059151,3043230288,'Scorpio'],
  [3043230288,3043402396,'Sagittarius'],
  [3043402396,3043581867,'Capricorn'],
  [3043581867,3043772974,'Aquarius'],
  [3043772974,3043976606,'Pisces'],
  [3043976606,3044190109,'Aries'],
  [3044190109,3044408963,'Taurus'],
  [3044408963,3044628458,'Gemini'],
  [3044628458,3044843893,'Cancer'],
  [3044843893,3045050635,'Leo'],
  [3045050635,3045245362,'Virgo'],
  [3045245362,3045427999,'Libra'],
  [3045427999,3045602020,'Scorpio'],
  [3045602020,3045773258,'Sagittarius'],
  [3045773258,3045948454,'Capricorn'],
  [3045948454,3046133791,'Aquarius'],
  [3046133791,3046332928,'Pisces'],
  [3046332928,3046544839,'Aries'],
  [3046544839,3046763828,'Taurus'],
  [3046763828,3046982936,'Gemini'],
  [3046982936,3047197128,'Cancer'],
  [3047197128,3047403768,'Leo'],
  [3047403768,3047601421,'Virgo'],
  [3047601421,3047789532,'Libra'],
  [3047789532,3047969208,'Scorpio'],
  [3047969208,3048143808,'Sagittarius'],
  [3048143808,3048318762,'Capricorn'],
  [3048318762,3048500526,'Aquarius'],
  [3048500526,3048694689,'Pisces'],
  [3048694689,3048903004,'Aries'],
  [3048903004,3049120988,'Taurus'],
  [3049120988,3049339974,'Gemini'],
  [3049339974,3049552838,'Cancer'],
  [3049552838,3049757141,'Leo'],
  [3049757141,3049953671,'Virgo'],
  [3049953671,3050143747,'Libra'],
  [3050143747,3050328224,'Scorpio'],
  [3050328224,3050508303,'Sagittarius'],
  [3050508303,3050686903,'Capricorn'],
  [3050686903,3050869021,'Aquarius'],
  [3050869021,3051060476,'Pisces'],
  [3051060476,3051265107,'Aries'],
  [3051265107,3051481121,'Taurus'],
  [3051481121,3051700269,'Gemini'],
  [3051700269,3051913138,'Cancer'],
  [3051913138,3052115429,'Leo'],
  [3052115429,3052308516,'Virgo'],
  [3052308516,3052496038,'Libra'],
  [3052496038,3052680932,'Scorpio'],
  [3052680932,3052864596,'Sagittarius'],
  [3052864596,3053048102,'Capricorn'],
  [3053048102,3053233916,'Aquarius'],
  [3053233916,3053426204,'Pisces'],
  [3053426204,3053629083,'Aries'],
  [3053629083,3053843122,'Taurus'],
  [3053843122,3054062446,'Gemini'],
  [3054062446,3054277054,'Cancer'],
  [3054277054,3054479885,'Leo'],
  [3054479885,3054670675,'Virgo'],
  [3054670675,3054853789,'Libra'],
  [3054853789,3055034502,'Scorpio'],
  [3055034502,3055216650,'Sagittarius'],
  [3055216650,3055402089,'Capricorn'],
  [3055402089,3055591850,'Aquarius'],
  [3055591850,3055787550,'Pisces'],
  [3055787550,3055991467,'Aries'],
  [3055991467,3056204663,'Taurus'],
  [3056204663,3056423902,'Gemini'],
  [3056423902,3056640996,'Cancer'],
  [3056640996,3056847324,'Leo'],
  [3056847324,3057039589,'Virgo'],
  [3057039589,3057220616,'Libra'],
  [3057220616,3057396311,'Scorpio'],
  [3057396311,3057572800,'Sagittarius'],
  [3057572800,3057754728,'Capricorn'],
  [3057754728,3057944566,'Aquarius'],
  [3057944566,3058142960,'Pisces'],
  [3058142960,3058349591,'Aries'],
  [3058349591,3058563611,'Taurus'],
  [3058563611,3058782636,'Gemini'],
  [3058782636,3059001273,'Cancer'],
  [3059001273,3059212060,'Leo'],
  [3059212060,3059409461,'Virgo'],
  [3059409461,3059593155,'Libra'],
  [3059593155,3059767449,'Scorpio'],
  [3059767449,3059938883,'Sagittarius'],
  [3059938883,3060114234,'Capricorn'],
  [3060114234,3060298976,'Aquarius'],
  [3060298976,3060495799,'Pisces'],
  [3060495799,3060703811,'Aries'],
  [3060703811,3060919494,'Taurus'],
  [3060919494,3061138674,'Gemini'],
  [3061138674,3061357192,'Cancer'],
  [3061357192,3061570382,'Leo'],
  [3061570382,3061773371,'Virgo'],
  [3061773371,3061963369,'Libra'],
  [3061963369,3062141503,'Scorpio'],
  [3062141503,3062312566,'Sagittarius'],
  [3062312566,3062483481,'Capricorn'],
  [3062483481,3062661576,'Aquarius'],
  [3062661576,3062852594,'Pisces'],
  [3062852594,3063058097,'Aries'],
  [3063058097,3063274146,'Taurus'],
  [3063274146,3063493851,'Gemini'],
  [3063493851,3063711527,'Cancer'],
  [3063711527,3063924045,'Leo'],
  [3063924045,3064129220,'Virgo'],
  [3064129220,3064324803,'Libra'],
  [3064324803,3064509642,'Scorpio'],
  [3064509642,3064685412,'Sagittarius'],
  [3064685412,3064857117,'Capricorn'],
  [3064857117,3065031891,'Aquarius'],
  [3065031891,3065217024,'Pisces'],
  [3065217024,3065417124,'Aries'],
  [3065417124,3065630778,'Taurus'],
  [3065630778,3065850462,'Gemini'],
  [3065850462,3066067765,'Cancer'],
  [3066067765,3066278373,'Leo'],
  [3066278373,3066481801,'Virgo'],
  [3066481801,3066678378,'Libra'],
  [3066678378,3066867738,'Scorpio'],
  [3066867738,3067049758,'Sagittarius'],
  [3067049758,3067226535,'Capricorn'],
  [3067226535,3067403094,'Aquarius'],
  [3067403094,3067586168,'Pisces'],
  [3067586168,3067781730,'Aries'],
  [3067781730,3067991406,'Taurus'],
  [3067991406,3068209838,'Gemini'],
  [3068209838,3068427437,'Cancer'],
  [3068427437,3068637201,'Leo'],
  [3068637201,3068837822,'Virgo'],
  [3068837822,3069031358,'Libra'],
  [3069031358,3069219995,'Scorpio'],
  [3069219995,3069404797,'Sagittarius'],
  [3069404797,3069586684,'Capricorn'],
  [3069586684,3069768104,'Aquarius'],
  [3069768104,3069953516,'Pisces'],
  [3069953516,3070148088,'Aries'],
  [3070148088,3070354858,'Taurus'],
  [3070354858,3070571413,'Gemini'],
  [3070571413,3070789551,'Cancer'],
  [3070789551,3071000407,'Leo'],
  [3071000407,3071200131,'Virgo'],
  [3071200131,3071390258,'Libra'],
  [3071390258,3071574667,'Scorpio'],
  [3071574667,3071756990,'Sagittarius'],
  [3071756990,3071939723,'Capricorn'],
  [3071939723,3072124758,'Aquarius'],
  [3072124758,3072314327,'Pisces'],
  [3072314327,3072511234,'Aries'],
  [3072511234,3072717720,'Taurus'],
  [3072717720,3072933023,'Gemini'],
  [3072933023,3073151590,'Cancer'],
  [3073151590,3073364905,'Leo'],
  [3073364905,3073566683,'Virgo'],
  [3073566683,3073756154,'Libra'],
  [3073756154,3073936876,'Scorpio'],
  [3073936876,3074114105,'Sagittarius'],
  [3074114105,3074292883,'Capricorn'],
  [3074292883,3074477002,'Aquarius'],
  [3074477002,3074668672,'Pisces'],
  [3074668672,3074868719,'Aries'],
  [3074868719,3075077047,'Taurus'],
  [3075077047,3075292404,'Gemini'],
  [3075292404,3075511180,'Cancer'],
  [3075511180,3075726990,'Leo'],
  [3075726990,3075932871,'Virgo'],
  [3075932871,3076125312,'Libra'],
  [3076125312,3076305793,'Scorpio'],
  [3076305793,3076479376,'Sagittarius'],
  [3076479376,3076652604,'Capricorn'],
  [3076652604,3076831728,'Aquarius'],
  [3076831728,3077021129,'Pisces'],
  [3077021129,3077221980,'Aries'],
  [3077221980,3077432303,'Taurus'],
  [3077432303,3077648692,'Gemini'],
  [3077648692,3077867539,'Cancer'],
  [3077867539,3078084615,'Leo'],
  [3078084615,3078294468,'Virgo'],
  [3078294468,3078492187,'Libra'],
  [3078492187,3078676419,'Scorpio'],
  [3078676419,3078850317,'Sagittarius'],
  [3078850317,3079020249,'Capricorn'],
  [3079020249,3079193771,'Aquarius'],
  [3079193771,3079377646,'Pisces'],
  [3079377646,3079575444,'Aries'],
  [3079575444,3079785655,'Taurus'],
  [3079785655,3080002952,'Gemini'],
  [3080002952,3080221868,'Cancer'],
  [3080221868,3080438684,'Leo'],
  [3080438684,3080650219,'Virgo'],
  [3080650219,3080852596,'Libra'],
  [3080852596,3081042764,'Scorpio'],
  [3081042764,3081221065,'Sagittarius'],
  [3081221065,3081392016,'Capricorn'],
  [3081392016,3081562854,'Aquarius'],
  [3081562854,3081741430,'Pisces'],
  [3081741430,3081933743,'Aries'],
  [3081933743,3082140821,'Taurus'],
  [3082140821,3082357625,'Gemini'],
  [3082357625,3082576587,'Cancer'],
  [3082576587,3082792427,'Leo'],
  [3082792427,3083002939,'Virgo'],
  [3083002939,3083206595,'Libra'],
  [3083206595,3083401261,'Scorpio'],
  [3083401261,3083585637,'Sagittarius'],
  [3083585637,3083761515,'Capricorn'],
  [3083761515,3083934164,'Aquarius'],
  [3083934164,3084110825,'Pisces'],
  [3084110825,3084298476,'Aries'],
  [3084298476,3084500773,'Taurus'],
  [3084500773,3084715185,'Gemini'],
  [3084715185,3084933908,'Cancer'],
  [3084933908,3085149244,'Leo'],
  [3085149244,3085357713,'Virgo'],
  [3085357713,3085559132,'Libra'],
  [3085559132,3085753872,'Scorpio'],
  [3085753872,3085941768,'Sagittarius'],
  [3085941768,3086123305,'Capricorn'],
  [3086123305,3086301159,'Aquarius'],
  [3086301159,3086480333,'Pisces'],
  [3086480333,3086666863,'Aries'],
  [3086666863,3086865482,'Taurus'],
  [3086865482,3087076554,'Gemini'],
  [3087076554,3087294453,'Cancer'],
  [3087294453,3087510406,'Leo'],
  [3087510406,3087718202,'Virgo'],
  [3087718202,3087916639,'Libra'],
  [3087916639,3088107664,'Scorpio'],
  [3088107664,3088293824,'Sagittarius'],
  [3088293824,3088477179,'Capricorn'],
  [3088477179,3088659662,'Aquarius'],
  [3088659662,3088843867,'Pisces'],
  [3088843867,3089033274,'Aries'],
  [3089033274,3089231467,'Taurus'],
  [3089231467,3089440160,'Gemini'],
  [3089440160,3089656783,'Cancer'],
  [3089656783,3089874058,'Leo'],
  [3089874058,3090083771,'Virgo'],
  [3090083771,3090281810,'Libra'],
  [3090281810,3090469282,'Scorpio'],
  [3090469282,3090650373,'Sagittarius'],
  [3090650373,3090829961,'Capricorn'],
  [3090829961,3091012083,'Aquarius'],
  [3091012083,3091199313,'Pisces'],
  [3091199313,3091392982,'Aries'],
  [3091392982,3091593902,'Taurus'],
  [3091593902,3091802633,'Gemini'],
  [3091802633,3092018276,'Cancer'],
  [3092018276,3092236534,'Leo'],
  [3092236534,3092449796,'Virgo'],
  [3092449796,3092651228,'Libra'],
  [3092651228,3092839004,'Scorpio'],
  [3092839004,3093016574,'Sagittarius'],
  [3093016574,3093190297,'Capricorn'],
  [3093190297,3093366923,'Aquarius'],
  [3093366923,3093551604,'Pisces'],
  [3093551604,3093746408,'Aries'],
  [3093746408,3093950324,'Taurus'],
  [3093950324,3094161119,'Gemini'],
  [3094161119,3094376894,'Cancer'],
  [3094376894,3094595270,'Leo'],
  [3094595270,3094811322,'Virgo'],
  [3094811322,3095018035,'Libra'],
  [3095018035,3095210526,'Scorpio'],
  [3095210526,3095389416,'Sagittarius'],
  [3095389416,3095560316,'Capricorn'],
  [3095560316,3095731071,'Aquarius'],
  [3095731071,3095909271,'Pisces'],
  [3095909271,3096099903,'Aries'],
  [3096099903,3096303299,'Taurus'],
  [3096303299,3096515708,'Gemini'],
  [3096515708,3096732555,'Cancer'],
  [3096732555,3096950696,'Leo'],
  [3096950696,3097167272,'Virgo'],
  [3097167272,3097377589,'Libra'],
  [3097377589,3097576202,'Scorpio'],
  [3097576202,3097760718,'Sagittarius'],
  [3097760718,3097934064,'Capricorn'],
  [3097934064,3098103135,'Aquarius'],
  [3098103135,3098276131,'Pisces'],
  [3098276131,3098460212,'Aries'],
  [3098460212,3098658817,'Taurus'],
  [3098658817,3098869825,'Gemini'],
  [3098869825,3099087238,'Cancer'],
  [3099087238,3099305377,'Leo'],
  [3099305377,3099520931,'Virgo'],
  [3099520931,3099731346,'Libra'],
  [3099731346,3099933271,'Scorpio'],
  [3099933271,3100123793,'Sagittarius'],
  [3100123793,3100303130,'Capricorn'],
  [3100303130,3100475586,'Aquarius'],
  [3100475586,3100648071,'Pisces'],
  [3100648071,3100827966,'Aries'],
  [3100827966,3101020783,'Taurus'],
  [3101020783,3101227536,'Gemini'],
  [3101227536,3101443693,'Cancer'],
  [3101443693,3101661905,'Leo'],
  [3101661905,3101876501,'Virgo'],
  [3101876501,3102084845,'Libra'],
  [3102084845,3102285812,'Scorpio'],
  [3102285812,3102478541,'Sagittarius'],
  [3102478541,3102663005,'Capricorn'],
  [3102663005,3102841239,'Aquarius'],
  [3102841239,3103017598,'Pisces'],
  [3103017598,3103197858,'Aries'],
  [3103197858,3103387597,'Taurus'],
  [3103387597,3103589970,'Gemini'],
  [3103589970,3103803406,'Cancer'],
  [3103803406,3104021355,'Leo'],
  [3104021355,3104236014,'Virgo'],
  [3104236014,3104442661,'Libra'],
  [3104442661,3104640483,'Scorpio'],
  [3104640483,3104830933,'Sagittarius'],
  [3104830933,3105016073,'Capricorn'],
  [3105016073,3105198082,'Aquarius'],
  [3105198082,3105379509,'Pisces'],
  [3105379509,3105563603,'Aries'],
  [3105563603,3105754183,'Taurus'],
  [3105754183,3105954565,'Gemini'],
  [3105954565,3106165454,'Cancer'],
  [3106165454,3106382812,'Leo'],
  [3106382812,3106598621,'Virgo'],
  [3106598621,3106805621,'Libra'],
  [3106805621,3107001285,'Scorpio'],
  [3107001285,3107187719,'Sagittarius'],
  [3107187719,3107369276,'Capricorn'],
  [3107369276,3107550305,'Aquarius'],
  [3107550305,3107733951,'Pisces'],
  [3107733951,3107922066,'Aries'],
  [3107922066,3108116002,'Taurus'],
  [3108116002,3108317353,'Gemini'],
  [3108317353,3108527259,'Cancer'],
  [3108527259,3108744069,'Leo'],
  [3108744069,3108961539,'Virgo'],
  [3108961539,3109171142,'Libra'],
  [3109171142,3109367633,'Scorpio'],
  [3109367633,3109551797,'Sagittarius'],
  [3109551797,3109728791,'Capricorn'],
  [3109728791,3109905111,'Aquarius'],
  [3109905111,3110086208,'Pisces'],
  [3110086208,3110274990,'Aries'],
  [3110274990,3110471739,'Taurus'],
  [3110471739,3110675676,'Gemini'],
  [3110675676,3110886401,'Cancer'],
  [3110886401,3111103075,'Leo'],
  [3111103075,3111321846,'Virgo'],
  [3111321846,3111535087,'Libra'],
  [3111535087,3111735481,'Scorpio'],
  [3111735481,3111921122,'Sagittarius'],
  [3111921122,3112096109,'Capricorn'],
  [3112096109,3112267658,'Aquarius'],
  [3112267658,3112443193,'Pisces'],
  [3112443193,3112628124,'Aries'],
  [3112628124,3112824190,'Taurus'],
  [3112824190,3113029763,'Gemini'],
  [3113029763,3113242142,'Cancer'],
  [3113242142,3113459212,'Leo'],
  [3113459212,3113678362,'Virgo'],
  [3113678362,3113894251,'Libra'],
  [3113894251,3114099721,'Scorpio'],
  [3114099721,3114290361,'Sagittarius'],
  [3114290361,3114467667,'Capricorn'],
  [3114467667,3114637809,'Aquarius'],
  [3114637809,3114808681,'Pisces'],
  [3114808681,3114987556,'Aries'],
  [3114987556,3115178923,'Taurus'],
  [3115178923,3115382898,'Gemini'],
  [3115382898,3115595976,'Cancer'],
  [3115595976,3115813698,'Leo'],
  [3115813698,3116032503,'Virgo'],
  [3116032503,3116248709,'Libra'],
  [3116248709,3116457360,'Scorpio'],
  [3116457360,3116653819,'Sagittarius'],
  [3116653819,3116836977,'Capricorn'],
  [3116836977,3117010401,'Aquarius'],
  [3117010401,3117180695,'Pisces'],
  [3117180695,3117355314,'Aries'],
  [3117355314,3117540623,'Taurus'],
  [3117540623,3117739735,'Gemini'],
  [3117739735,3117950999,'Cancer'],
  [3117950999,3118168886,'Leo'],
  [3118168886,3118387347,'Virgo'],
  [3118387347,3118602120,'Libra'],
  [3118602120,3118810294,'Scorpio'],
  [3118810294,3119009489,'Sagittarius'],
  [3119009489,3119198396,'Capricorn'],
  [3119198396,3119378136,'Aquarius'],
  [3119378136,3119552586,'Pisces'],
  [3119552586,3119727526,'Aries'],
  [3119727526,3119909291,'Taurus'],
  [3119909291,3120102990,'Gemini'],
  [3120102990,3120310140,'Cancer'],
  [3120310140,3120526863,'Leo'],
  [3120526863,3120745438,'Virgo'],
  [3120745438,3120959012,'Libra'],
  [3120959012,3121164467,'Scorpio'],
  [3121164467,3121361763,'Sagittarius'],
  [3121361763,3121552005,'Capricorn'],
  [3121552005,3121736522,'Aquarius'],
  [3121736522,3121917118,'Pisces'],
  [3121917118,3122096709,'Aries'],
  [3122096709,3122279596,'Taurus'],
  [3122279596,3122470747,'Gemini'],
  [3122470747,3122673821,'Cancer'],
  [3122673821,3122888124,'Leo'],
  [3122888124,3123106961,'Virgo'],
  [3123106961,3123321103,'Libra'],
  [3123321103,3123524876,'Scorpio'],
  [3123524876,3123718328,'Sagittarius'],
  [3123718328,3123904969,'Capricorn'],
  [3123904969,3124088732,'Aquarius'],
  [3124088732,3124272297,'Pisces'],
  [3124272297,3124457076,'Aries'],
  [3124457076,3124644522,'Taurus'],
  [3124644522,3124837333,'Gemini'],
  [3124837333,3125038967,'Cancer'],
  [3125038967,3125251010,'Leo'],
  [3125251010,3125469723,'Virgo'],
  [3125469723,3125685992,'Libra'],
  [3125685992,3125891222,'Scorpio'],
  [3125891222,3126083081,'Sagittarius'],
  [3126083081,3126265275,'Capricorn'],
  [3126265275,3126443934,'Aquarius'],
  [3126443934,3126624491,'Pisces'],
  [3126624491,3126809961,'Aries'],
  [3126809961,3127000995,'Taurus'],
  [3127000995,3127197671,'Gemini'],
  [3127197671,3127401070,'Cancer'],
  [3127401070,3127612582,'Leo'],
  [3127612582,3127830869,'Virgo'],
  [3127830869,3128049293,'Libra'],
  [3128049293,3128258473,'Scorpio'],
  [3128258473,3128452917,'Sagittarius'],
  [3128452917,3128634173,'Capricorn'],
  [3128634173,3128808444,'Aquarius'],
  [3128808444,3128982986,'Pisces'],
  [3128982986,3129163618,'Aries'],
  [3129163618,3129353197,'Taurus'],
  [3129353197,3129551681,'Gemini'],
  [3129551681,3129757837,'Cancer'],
  [3129757837,3129970691,'Leo'],
  [3129970691,3130188880,'Virgo'],
  [3130188880,3130408223,'Libra'],
  [3130408223,3130621221,'Scorpio'],
  [3130621221,3130820977,'Sagittarius'],
  [3130820977,3131005924,'Capricorn'],
  [3131005924,3131180234,'Aquarius'],
  [3131180234,3131350965,'Pisces'],
  [3131350965,3131525388,'Aries'],
  [3131525388,3131709125,'Taurus'],
  [3131709125,3131904711,'Gemini'],
  [3131904711,3132111253,'Cancer'],
  [3132111253,3132325645,'Leo'],
  [3132325645,3132544325,'Virgo'],
  [3132544325,3132763420,'Libra'],
  [3132763420,3132977887,'Scorpio'],
  [3132977887,3133182202,'Sagittarius'],
  [3133182202,3133373157,'Capricorn'],
  [3133373157,3133551995,'Aquarius'],
  [3133551995,3133723732,'Pisces'],
  [3133723732,3133895164,'Aries'],
  [3133895164,3134073110,'Taurus'],
  [3134073110,3134262793,'Gemini'],
  [3134262793,3134466014,'Cancer'],
  [3134466014,3134680071,'Leo'],
  [3134680071,3134899229,'Virgo'],
  [3134899229,3135117747,'Libra'],
  [3135117747,3135331316,'Scorpio'],
  [3135331316,3135536852,'Sagittarius'],
  [3135536852,3135732212,'Capricorn'],
  [3135732212,3135917087,'Aquarius'],
  [3135917087,3136093768,'Pisces'],
  [3136093768,3136266936,'Aries'],
  [3136266936,3136442749,'Taurus'],
  [3136442749,3136627503,'Gemini'],
  [3136627503,3136825617,'Cancer'],
  [3136825617,3137036957,'Leo'],
  [3137036957,3137255774,'Virgo'],
  [3137255774,3137474008,'Libra'],
  [3137474008,3137685923,'Scorpio'],
  [3137685923,3137889607,'Sagittarius'],
  [3137889607,3138085310,'Capricorn'],
  [3138085310,3138273741,'Aquarius'],
  [3138273741,3138455929,'Pisces'],
  [3138455929,3138634024,'Aries'],
  [3138634024,3138812019,'Taurus'],
  [3138812019,3138995446,'Gemini'],
  [3138995446,3139189779,'Cancer'],
  [3139189779,3139397498,'Leo'],
  [3139397498,3139614993,'Virgo'],
  [3139614993,3139833417,'Libra'],
  [3139833417,3140044611,'Scorpio'],
  [3140044611,3140245727,'Sagittarius'],
  [3140245727,3140438490,'Capricorn'],
  [3140438490,3140625963,'Aquarius'],
  [3140625963,3140810385,'Pisces'],
  [3140810385,3140993036,'Aries'],
  [3140993036,3141175592,'Taurus'],
  [3141175592,3141361389,'Gemini'],
  [3141361389,3141555087,'Cancer'],
  [3141555087,3141760349,'Leo'],
  [3141760349,3141976190,'Virgo'],
  [3141976190,3142195138,'Libra'],
  [3142195138,3142407384,'Scorpio'],
  [3142407384,3142607677,'Sagittarius'],
  [3142607677,3142797228,'Capricorn'],
  [3142797228,3142980665,'Aquarius'],
  [3142980665,3143162610,'Pisces'],
  [3143162610,3143345901,'Aries'],
  [3143345901,3143531785,'Taurus'],
  [3143531785,3143721508,'Gemini'],
  [3143721508,3143917495,'Cancer'],
  [3143917495,3144122627,'Leo'],
  [3144122627,3144337411,'Virgo'],
  [3144337411,3144556882,'Libra'],
  [3144556882,3144771634,'Scorpio'],
  [3144771634,3144974035,'Sagittarius'],
  [3144974035,3145163018,'Capricorn'],
  [3145163018,3145342905,'Aquarius'],
  [3145342905,3145519834,'Pisces'],
  [3145519834,3145699118,'Aries'],
  [3145699118,3145883970,'Taurus'],
  [3145883970,3146075667,'Gemini'],
  [3146075667,3146274735,'Cancer'],
  [3146274735,3146481751,'Leo'],
  [3146481751,3146696646,'Virgo'],
  [3146696646,3146916354,'Libra'],
  [3146916354,3147133682,'Scorpio'],
  [3147133682,3147340434,'Sagittarius'],
  [3147340434,3147532700,'Capricorn'],
  [3147532700,3147712614,'Aquarius'],
  [3147712614,3147885992,'Pisces'],
  [3147885992,3148059545,'Aries'],
  [3148059545,3148239069,'Taurus'],
  [3148239069,3148428216,'Gemini'],
  [3148428216,3148627970,'Cancer'],
  [3148627970,3148837073,'Leo'],
  [3148837073,3149053100,'Virgo'],
  [3149053100,3149272800,'Libra'],
  [3149272800,3149491248,'Scorpio'],
  [3149491248,3149702095,'Sagittarius'],
  [3149702095,3149900169,'Capricorn'],
  [3149900169,3150084554,'Aquarius'],
  [3150084554,3150258823,'Pisces'],
  [3150258823,3150429212,'Aries'],
  [3150429212,3150602756,'Taurus'],
  [3150602756,3150785739,'Gemini'],
  [3150785739,3150981883,'Cancer'],
  [3150981883,3151190697,'Leo'],
  [3151190697,3151407788,'Virgo'],
  [3151407788,3151627586,'Libra'],
  [3151627586,3151845440,'Scorpio'],
  [3151845440,3152057545,'Sagittarius'],
  [3152057545,3152260302,'Capricorn'],
  [3152260302,3152451310,'Aquarius'],
  [3152451310,3152631044,'Pisces'],
  [3152631044,3152803340,'Aries'],
  [3152803340,3152974524,'Taurus'],
  [3152974524,3153151899,'Gemini'],
  [3153151899,3153341807,'Cancer'],
  [3153341807,3153546764,'Leo'],
  [3153546764,3153763169,'Virgo'],
  [3153763169,3153983202,'Libra'],
  [3153983202,3154200023,'Scorpio'],
  [3154200023,3154410494,'Sagittarius'],
  [3154410494,3154613706,'Capricorn'],
  [3154613706,3154808833,'Aquarius'],
  [3154808833,3154995121,'Pisces'],
  [3154995121,3155173430,'Aries'],
  [3155173430,3155347510,'Taurus'],
  [3155347510,3155523637,'Gemini'],
  [3155523637,3155708907,'Cancer'],
  [3155708907,3155908467,'Leo'],
  [3155908467,3156121812,'Virgo'],
  [3156121812,3156341538,'Libra'],
  [3156341538,3156558210,'Scorpio'],
  [3156558210,3156766693,'Sagittarius'],
  [3156766693,3156966989,'Capricorn'],
  [3156966989,3157160972,'Aquarius'],
  [3157160972,3157349761,'Pisces'],
  [3157349761,3157533586,'Aries'],
  [3157533586,3157713573,'Taurus'],
  [3157713573,3157893296,'Gemini'],
  [3157893296,3158078437,'Cancer'],
  [3158078437,3158274701,'Leo'],
  [3158274701,3158484310,'Virgo'],
  [3158484310,3158702726,'Libra'],
  [3158702726,3158920198,'Scorpio'],
  [3158920198,3159128701,'Sagittarius'],
  [3159128701,3159326476,'Capricorn'],
  [3159326476,3159516356,'Aquarius'],
  [3159516356,3159702097,'Pisces'],
  [3159702097,3159886198,'Aries'],
  [3159886198,3160069907,'Taurus'],
  [3160069907,3160254725,'Gemini'],
  [3160254725,3160443599,'Cancer'],
  [3160443599,3160640508,'Leo'],
  [3160640508,3160848223,'Virgo'],
  [3160848223,3161065026,'Libra'],
  [3161065026,3161283433,'Scorpio'],
  [3161283433,3161494228,'Sagittarius'],
  [3161494228,3161692641,'Capricorn'],
  [3161692641,3161879962,'Aquarius'],
  [3161879962,3162060815,'Pisces'],
  [3162060815,3162240218,'Aries'],
  [3162240218,3162421985,'Taurus'],
  [3162421985,3162608452,'Gemini'],
  [3162608452,3162801102,'Cancer'],
  [3162801102,3163001236,'Leo'],
  [3163001236,3163209819,'Virgo'],
  [3163209819,3163425901,'Libra'],
  [3163425901,3163644768,'Scorpio'],
  [3163644768,3163858622,'Sagittarius'],
  [3163858622,3164060764,'Capricorn'],
  [3164060764,3164249538,'Aquarius'],
  [3164249538,3164428182,'Pisces'],
  [3164428182,3164602454,'Aries'],
  [3164602454,3164778487,'Taurus'],
  [3164778487,3164961308,'Gemini'],
  [3164961308,3165153792,'Cancer'],
  [3165153792,3165356243,'Leo'],
  [3165356243,3165567059,'Virgo'],
  [3165567059,3165783710,'Libra'],
  [3165783710,3166002602,'Scorpio'],
  [3166002602,3166218486,'Sagittarius'],
  [3166218486,3166425213,'Capricorn'],
  [3166425213,3166618789,'Aquarius'],
  [3166618789,3166799662,'Pisces'],
  [3166799662,3166972319,'Aries'],
  [3166972319,3167143482,'Taurus'],
  [3167143482,3167320222,'Gemini'],
  [3167320222,3167508121,'Cancer'],
  [3167508121,3167709216,'Leo'],
  [3167709216,3167921096,'Virgo'],
  [3167921096,3168138808,'Libra'],
  [3168138808,3168357620,'Scorpio'],
  [3168357620,3168573755,'Sagittarius'],
  [3168573755,3168783294,'Capricorn'],
  [3168783294,3168982196,'Aquarius'],
  [3168982196,3169168481,'Pisces'],
  [3169168481,3169344009,'Aries'],
  [3169344009,3169514289,'Taurus'],
  [3169514289,3169686770,'Gemini'],
  [3169686770,3169868826,'Cancer'],
  [3169868826,3170065218,'Leo'],
  [3170065218,3170275333,'Virgo'],
  [3170275333,3170493282,'Libra'],
  [3170493282,3170712065,'Scorpio'],
  [3170712065,3170927260,'Sagittarius'],
  [3170927260,3171136709,'Capricorn'],
  [3171136709,3171338350,'Aquarius'],
  [3171338350,3171529967,'Pisces'],
  [3171529967,3171711099,'Aries'],
  [3171711099,3171884764,'Taurus'],
  [3171884764,3172057126,'Gemini'],
  [3172057126,3172235703,'Cancer'],
  [3172235703,3172426960,'Leo'],
  [3172426960,3172633052,'Virgo'],
  [3172633052,3172849619,'Libra'],
  [3172849619,3173068322,'Scorpio'],
  [3173068322,3173282585,'Sagittarius'],
  [3173282585,3173490084,'Capricorn'],
  [3173490084,3173690741,'Aquarius'],
  [3173690741,3173884285,'Pisces'],
  [3173884285,3174070149,'Aries'],
  [3174070149,3174249265,'Taurus'],
  [3174249265,3174425372,'Gemini'],
  [3174425372,3174604500,'Cancer'],
  [3174604500,3174793106,'Leo'],
  [3174793106,3174995197,'Virgo'],
  [3174995197,3175209167,'Libra'],
  [3175209167,3175427563,'Scorpio'],
  [3175427563,3175641868,'Sagittarius'],
  [3175641868,3175847745,'Capricorn'],
  [3175847745,3176045361,'Aquarius'],
  [3176045361,3176236611,'Pisces'],
  [3176236611,3176423035,'Aries'],
  [3176423035,3176605790,'Taurus'],
  [3176605790,3176786864,'Gemini'],
  [3176786864,3176969847,'Cancer'],
  [3176969847,3177159456,'Leo'],
  [3177159456,3177359736,'Virgo'],
  [3177359736,3177571250,'Libra'],
  [3177571250,3177789079,'Scorpio'],
  [3177789079,3178004628,'Sagittarius'],
  [3178004628,3178211017,'Capricorn'],
  [3178211017,3178406589,'Aquarius'],
  [3178406589,3178593765,'Pisces'],
  [3178593765,3178776387,'Aries'],
  [3178776387,3178957964,'Taurus'],
  [3178957964,3179141196,'Gemini'],
  [3179141196,3179328308,'Cancer'],
  [3179328308,3179521516,'Leo'],
  [3179521516,3179722947,'Virgo'],
  [3179722947,3179933476,'Libra'],
  [3179933476,3180150682,'Scorpio'],
  [3180150682,3180368001,'Sagittarius'],
  [3180368001,3180577395,'Capricorn'],
  [3180577395,3180774247,'Aquarius'],
  [3180774247,3180959323,'Pisces'],
  [3180959323,3181137117,'Aries'],
  [3181137117,3181313451,'Taurus'],
  [3181313451,3181493629,'Gemini'],
  [3181493629,3181681178,'Cancer'],
  [3181681178,3181877350,'Leo'],
  [3181877350,3182081700,'Virgo'],
  [3182081700,3182293188,'Libra'],
  [3182293188,3182510104,'Scorpio'],
  [3182510104,3182728575,'Sagittarius'],
  [3182728575,3182941912,'Capricorn'],
  [3182941912,3183143458,'Aquarius'],
  [3183143458,3183330819,'Pisces'],
  [3183330819,3183506941,'Aries'],
  [3183506941,3183678234,'Taurus'],
  [3183678234,3183852123,'Gemini'],
  [3183852123,3184034942,'Cancer'],
  [3184034942,3184229863,'Leo'],
  [3184229863,3184435840,'Virgo'],
  [3184435840,3184649241,'Libra'],
  [3184649241,3184866575,'Scorpio'],
  [3184866575,3185085064,'Sagittarius'],
  [3185085064,3185300745,'Capricorn'],
  [3185300745,3185507709,'Aquarius'],
  [3185507709,3185701086,'Pisces'],
  [3185701086,3185880630,'Aries'],
  [3185880630,3186051201,'Taurus'],
  [3186051201,3186220512,'Gemini'],
  [3186220512,3186396674,'Cancer'],
  [3186396674,3186585813,'Leo'],
  [3186585813,3186789317,'Virgo'],
  [3186789317,3187003194,'Libra'],
  [3187003194,3187221349,'Scorpio'],
  [3187221349,3187439394,'Sagittarius'],
  [3187439394,3187654755,'Capricorn'],
  [3187654755,3187864199,'Aquarius'],
  [3187864199,3188063391,'Pisces'],
  [3188063391,3188249649,'Aries'],
  [3188249649,3188424725,'Taurus'],
  [3188424725,3188594590,'Gemini'],
  [3188594590,3188767175,'Cancer'],
  [3188767175,3188950062,'Leo'],
  [3188950062,3189147719,'Virgo'],
  [3189147719,3189358834,'Libra'],
  [3189358834,3189576915,'Scorpio'],
  [3189576915,3189794865,'Sagittarius'],
  [3189794865,3190008719,'Capricorn'],
  [3190008719,3190216828,'Aquarius'],
  [3190216828,3190417521,'Pisces'],
  [3190417521,3190608849,'Aries'],
  [3190608849,3190790544,'Taurus'],
  [3190790544,3190965632,'Gemini'],
  [3190965632,3191139961,'Cancer'],
  [3191139961,3191320468,'Leo'],
  [3191320468,3191512951,'Virgo'],
  [3191512951,3191719269,'Libra'],
  [3191719269,3191935442,'Scorpio'],
  [3191935442,3192153517,'Sagittarius'],
  [3192153517,3192366720,'Capricorn'],
  [3192366720,3192572285,'Aquarius'],
  [3192572285,3192770252,'Pisces'],
  [3192770252,3192961382,'Aries'],
  [3192961382,3193146528,'Taurus'],
  [3193146528,3193327334,'Gemini'],
  [3193327334,3193506949,'Cancer'],
  [3193506949,3193689912,'Leo'],
  [3193689912,3193881104,'Virgo'],
  [3193881104,3194083786,'Libra'],
  [3194083786,3194297111,'Scorpio'],
  [3194297111,3194515001,'Sagittarius'],
  [3194515001,3194729093,'Capricorn'],
  [3194729093,3194933841,'Aquarius'],
  [3194933841,3195128497,'Pisces'],
  [3195128497,3195315594,'Aries'],
  [3195315594,3195498676,'Taurus'],
  [3195498676,3195680908,'Gemini'],
  [3195680908,3195864758,'Cancer'],
  [3195864758,3196052377,'Leo'],
  [3196052377,3196246118,'Virgo'],
  [3196246118,3196448322,'Libra'],
  [3196448322,3196659721,'Scorpio'],
  [3196659721,3196877119,'Sagittarius'],
  [3196877119,3197093033,'Capricorn'],
  [3197093033,3197299657,'Aquarius'],
  [3197299657,3197493662,'Pisces'],
  [3197493662,3197677113,'Aries'],
  [3197677113,3197855249,'Taurus'],
  [3197855249,3198033802,'Gemini'],
  [3198033802,3198217122,'Cancer'],
  [3198217122,3198407295,'Leo'],
  [3198407295,3198604600,'Virgo'],
  [3198604600,3198808933,'Libra'],
  [3198808933,3199020327,'Scorpio'],
  [3199020327,3199237371,'Sagittarius'],
  [3199237371,3199454991,'Capricorn'],
  [3199454991,3199665213,'Aquarius'],
  [3199665213,3199862043,'Pisces'],
  [3199862043,3200045273,'Aries'],
  [3200045273,3200219875,'Taurus'],
  [3200219875,3200393038,'Gemini'],
  [3200393038,3200571519,'Cancer'],
  [3200571519,3200759601,'Leo'],
  [3200759601,3200957943,'Virgo'],
  [3200957943,3201164608,'Libra'],
  [3201164608,3201377390,'Scorpio'],
  [3201377390,3201594547,'Sagittarius'],
  [3201594547,3201812976,'Capricorn'],
  [3201812976,3202026525,'Aquarius'],
  [3202026525,3202228231,'Pisces'],
  [3202228231,3202415108,'Aries'],
  [3202415108,3202590128,'Taurus'],
  [3202590128,3202760200,'Gemini'],
  [3202760200,3202933239,'Cancer'],
  [3202933239,3203115847,'Leo'],
  [3203115847,3203311119,'Virgo'],
  [3203311119,3203517728,'Libra'],
  [3203517728,3203731729,'Scorpio'],
  [3203731729,3203949363,'Sagittarius'],
  [3203949363,3204167643,'Capricorn'],
  [3204167643,3204382529,'Aquarius'],
  [3204382529,3204588408,'Pisces'],
  [3204588408,3204780909,'Aries'],
  [3204780909,3204960277,'Taurus'],
  [3204960277,3205131520,'Gemini'],
  [3205131520,3205302079,'Cancer'],
  [3205302079,3205479493,'Leo'],
  [3205479493,3205669221,'Virgo'],
  [3205669221,3205872504,'Libra'],
  [3205872504,3206085961,'Scorpio'],
  [3206085961,3206303945,'Sagittarius'],
  [3206303945,3206521683,'Capricorn'],
  [3206521683,3206735725,'Aquarius'],
  [3206735725,3206942722,'Pisces'],
  [3206942722,3207139446,'Aries'],
  [3207139446,3207324690,'Taurus'],
  [3207324690,3207500832,'Gemini'],
  [3207500832,3207673295,'Cancer'],
  [3207673295,3207848880,'Leo'],
  [3207848880,3208033941,'Virgo'],
  [3208033941,3208232241,'Libra'],
  [3208232241,3208442951,'Scorpio'],
  [3208442951,3208660560,'Sagittarius'],
  [3208660560,3208878043,'Capricorn'],
  [3208878043,3209090449,'Aquarius'],
  [3209090449,3209295495,'Pisces'],
  [3209295495,3209492411,'Aries'],
  [3209492411,3209681173,'Taurus'],
  [3209681173,3209862934,'Gemini'],
  [3209862934,3210040578,'Cancer'],
  [3210040578,3210218639,'Leo'],
  [3210218639,3210402521,'Virgo'],
  [3210402521,3210597012,'Libra'],
  [3210597012,3210804002,'Scorpio'],
  [3210804002,3211020270,'Sagittarius'],
  [3211020270,3211238104,'Capricorn'],
  [3211238104,3211449934,'Aquarius'],
  [3211449934,3211652311,'Pisces'],
  [3211652311,3211845929,'Aries'],
  [3211845929,3212033373,'Taurus'],
  [3212033373,3212217254,'Gemini'],
  [3212217254,3212399688,'Cancer'],
  [3212399688,3212582786,'Leo'],
  [3212582786,3212769447,'Virgo'],
  [3212769447,3212963403,'Libra'],
  [3212963403,3213167781,'Scorpio'],
  [3213167781,3213382232,'Sagittarius'],
  [3213382232,3213600744,'Capricorn'],
  [3213600744,3213814072,'Aquarius'],
  [3213814072,3214015935,'Pisces'],
  [3214015935,3214206184,'Aries'],
  [3214206184,3214389013,'Taurus'],
  [3214389013,3214569703,'Gemini'],
  [3214569703,3214752305,'Cancer'],
  [3214752305,3214938781,'Leo'],
  [3214938781,3215129822,'Virgo'],
  [3215129822,3215326519,'Libra'],
  [3215326519,3215530906,'Scorpio'],
  [3215530906,3215744117,'Sagittarius'],
  [3215744117,3215963035,'Capricorn'],
  [3215963035,3216179274,'Aquarius'],
  [3216179274,3216384044,'Pisces'],
  [3216384044,3216574341,'Aries'],
  [3216574341,3216753685,'Taurus'],
  [3216753685,3216928801,'Gemini'],
  [3216928801,3217106369,'Cancer'],
  [3217106369,3217290829,'Leo'],
  [3217290829,3217483434,'Virgo'],
  [3217483434,3217683409,'Libra'],
  [3217683409,3217890100,'Scorpio'],
  [3217890100,3218103561,'Sagittarius'],
  [3218103561,3218322425,'Capricorn'],
  [3218322425,3218541047,'Aquarius'],
  [3218541047,3218750679,'Pisces'],
  [3218750679,3218945329,'Aries'],
  [3218945329,3219125750,'Taurus'],
  [3219125750,3219297925,'Gemini'],
  [3219297925,3219469592,'Cancer'],
  [3219469592,3219647682,'Leo'],
  [3219647682,3219836380,'Virgo'],
  [3219836380,3220036147,'Libra'],
  [3220036147,3220244827,'Scorpio'],
  [3220244827,3220459762,'Sagittarius'],
  [3220459762,3220678626,'Capricorn'],
  [3220678626,3220897770,'Aquarius'],
  [3220897770,3221110938,'Pisces'],
  [3221110938,3221311666,'Aries'],
  [3221311666,3221497647,'Taurus'],
  [3221497647,3221672147,'Gemini'],
  [3221672147,3221841883,'Cancer'],
  [3221841883,3222014423,'Leo'],
  [3222014423,3222196280,'Virgo'],
  [3222196280,3222391101,'Libra'],
  [3222391101,3222598415,'Scorpio'],
  [3222598415,3222814221,'Sagittarius'],
  [3222814221,3223033486,'Capricorn'],
  [3223033486,3223251874,'Aquarius'],
  [3223251874,3223465310,'Pisces'],
  [3223465310,3223669619,'Aries'],
  [3223669619,3223861927,'Taurus'],
  [3223861927,3224042664,'Gemini'],
  [3224042664,3224215803,'Cancer'],
  [3224215803,3224387544,'Leo'],
  [3224387544,3224564722,'Virgo'],
  [3224564722,3224753189,'Libra'],
  [3224753189,3224955698,'Scorpio'],
  [3224955698,3225169971,'Sagittarius'],
  [3225169971,3225389434,'Capricorn'],
  [3225389434,3225607159,'Aquarius'],
  [3225607159,3225818772,'Pisces'],
  [3225818772,3226022410,'Aries'],
  [3226022410,3226217362,'Taurus'],
  [3226217362,3226403742,'Gemini'],
  [3226403742,3226583084,'Cancer'],
  [3226583084,3226758828,'Leo'],
  [3226758828,3226936180,'Virgo'],
  [3226936180,3227121133,'Libra'],
  [3227121133,3227318566,'Scorpio'],
  [3227318566,3227529299,'Sagittarius'],
  [3227529299,3227747998,'Capricorn'],
  [3227747998,3227965765,'Aquarius'],
  [3227965765,3228175890,'Pisces'],
  [3228175890,3228376643,'Aries'],
  [3228376643,3228569639,'Taurus'],
  [3228569639,3228757123,'Gemini'],
  [3228757123,3228940750,'Cancer'],
  [3228940750,3229121999,'Leo'],
  [3229121999,3229303407,'Virgo'],
  [3229303407,3229489206,'Libra'],
  [3229489206,3229684345,'Scorpio'],
  [3229684345,3229891775,'Sagittarius'],
  [3229891775,3230108941,'Capricorn'],
  [3230108941,3230327285,'Aquarius'],
  [3230327285,3230537710,'Pisces'],
  [3230537710,3230736524,'Aries'],
  [3230736524,3230925803,'Taurus'],
  [3230925803,3231110006,'Gemini'],
  [3231110006,3231292993,'Cancer'],
  [3231292993,3231476854,'Leo'],
  [3231476854,3231662650,'Virgo'],
  [3231662650,3231852122,'Libra'],
  [3231852122,3232048420,'Scorpio'],
  [3232048420,3232254636,'Sagittarius'],
  [3232254636,3232470454,'Capricorn'],
  [3232470454,3232689513,'Aquarius'],
  [3232689513,3232902028,'Pisces'],
  [3232902028,3233101673,'Aries'],
  [3233101673,3233288953,'Taurus'],
  [3233288953,3233468900,'Gemini'],
  [3233468900,3233647441,'Cancer'],
  [3233647441,3233829014,'Leo'],
  [3233829014,3234015748,'Virgo'],
  [3234015748,3234208346,'Libra'],
  [3234208346,3234407627,'Scorpio'],
  [3234407627,3234614934,'Sagittarius'],
  [3234614934,3234830377,'Capricorn'],
  [3234830377,3235049927,'Aquarius'],
  [3235049927,3235265227,'Pisces'],
  [3235265227,3235468373,'Aries'],
  [3235468373,3235657188,'Taurus'],
  [3235657188,3235835389,'Gemini'],
  [3235835389,3236009416,'Cancer'],
  [3236009416,3236185658,'Leo'],
  [3236185658,3236368751,'Virgo'],
  [3236368751,3236560851,'Libra'],
  [3236560851,3236762058,'Scorpio'],
  [3236762058,3236971447,'Sagittarius'],
  [3236971447,3237187560,'Capricorn'],
  [3237187560,3237407247,'Aquarius'],
  [3237407247,3237624485,'Pisces'],
  [3237624485,3237832026,'Aries'],
  [3237832026,3238025526,'Taurus'],
  [3238025526,3238206060,'Gemini'],
  [3238206060,3238378804,'Cancer'],
  [3238378804,3238550540,'Leo'],
  [3238550540,3238727787,'Virgo'],
  [3238727787,3238915352,'Libra'],
  [3238915352,3239115072,'Scorpio'],
  [3239115072,3239325402,'Sagittarius'],
  [3239325402,3239542561,'Capricorn'],
  [3239542561,3239762184,'Aquarius'],
  [3239762184,3239979618,'Pisces'],
  [3239979618,3240189892,'Aries'],
  [3240189892,3240388756,'Taurus'],
  [3240388756,3240574873,'Gemini'],
  [3240574873,3240750757,'Cancer'],
  [3240750757,3240921825,'Leo'],
  [3240921825,3241094865,'Virgo'],
  [3241094865,3241276531,'Libra'],
  [3241276531,3241471445,'Scorpio'],
  [3241471445,3241679935,'Sagittarius'],
  [3241679935,3241897374,'Capricorn'],
  [3241897374,3242116984,'Aquarius'],
  [3242116984,3242333341,'Pisces'],
  [3242333341,3242543295,'Aries'],
  [3242543295,3242744825,'Taurus'],
  [3242744825,3242936511,'Gemini'],
  [3242936511,3243118485,'Cancer'],
  [3243118485,3243293417,'Leo'],
  [3243293417,3243466547,'Virgo'],
  [3243466547,3243644639,'Libra'],
  [3243644639,3243834152,'Scorpio'],
  [3243834152,3244038350,'Sagittarius'],
  [3244038350,3244254355,'Capricorn'],
  [3244254355,3244474018,'Aquarius'],
  [3244474018,3244689439,'Pisces'],
  [3244689439,3244897129,'Aries'],
  [3244897129,3245097206,'Taurus'],
  [3245097206,3245290544,'Gemini'],
  [3245290544,3245477440,'Cancer'],
  [3245477440,3245658429,'Leo'],
  [3245658429,3245835953,'Virgo'],
  [3245835953,3246014969,'Libra'],
  [3246014969,3246201836,'Scorpio'],
  [3246201836,3246401721,'Sagittarius'],
  [3246401721,3246614811,'Capricorn'],
  [3246614811,3246834220,'Aquarius'],
  [3246834220,3247049998,'Pisces'],
  [3247049998,3247256176,'Aries'],
  [3247256176,3247452848,'Taurus'],
  [3247452848,3247643136,'Gemini'],
  [3247643136,3247829851,'Cancer'],
  [3247829851,3248014264,'Leo'],
  [3248014264,3248197155,'Virgo'],
  [3248197155,3248380725,'Libra'],
  [3248380725,3248569218,'Scorpio'],
  [3248569218,3248767505,'Sagittarius'],
  [3248767505,3248977871,'Capricorn'],
  [3248977871,3249196453,'Aquarius'],
  [3249196453,3249413757,'Pisces'],
  [3249413757,3249621125,'Aries'],
  [3249621125,3249816244,'Taurus'],
  [3249816244,3250002307,'Gemini'],
  [3250002307,3250184305,'Cancer'],
  [3250184305,3250366289,'Leo'],
  [3250366289,3250550476,'Virgo'],
  [3250550476,3250738082,'Libra'],
  [3250738082,3250930745,'Scorpio'],
  [3250930745,3251130943,'Sagittarius'],
  [3251130943,3251340619,'Capricorn'],
  [3251340619,3251558257,'Aquarius'],
  [3251558257,3251777079,'Pisces'],
  [3251777079,3251987951,'Aries'],
  [3251987951,3252185449,'Taurus'],
  [3252185449,3252370462,'Gemini'],
  [3252370462,3252547964,'Cancer'],
  [3252547964,3252723988,'Leo'],
  [3252723988,3252903672,'Virgo'],
  [3252903672,3253090314,'Libra'],
  [3253090314,3253285305,'Scorpio'],
  [3253285305,3253488735,'Sagittarius'],
  [3253488735,3253700023,'Capricorn'],
  [3253700023,3253917487,'Aquarius'],
  [3253917487,3254136877,'Pisces'],
  [3254136877,3254351241,'Aries'],
  [3254351241,3254553912,'Taurus'],
  [3254553912,3254742535,'Gemini'],
  [3254742535,3254919843,'Cancer'],
  [3254919843,3255091705,'Leo'],
  [3255091705,3255264952,'Virgo'],
  [3255264952,3255445735,'Libra'],
  [3255445735,3255637984,'Scorpio'],
  [3255637984,3255842135,'Sagittarius'],
  [3255842135,3256055394,'Capricorn'],
  [3256055394,3256273668,'Aquarius'],
  [3256273668,3256492876,'Pisces'],
  [3256492876,3256708641,'Aries'],
  [3256708641,3256915897,'Taurus'],
  [3256915897,3257110674,'Gemini'],
  [3257110674,3257292546,'Cancer'],
  [3257292546,3257465181,'Leo'],
  [3257465181,3257635082,'Virgo'],
  [3257635082,3257809738,'Libra'],
  [3257809738,3257995744,'Scorpio'],
  [3257995744,3258196310,'Sagittarius'],
  [3258196310,3258409237,'Capricorn'],
  [3258409237,3258628279,'Aquarius'],
  [3258628279,3258847254,'Pisces'],
  [3258847254,3259062339,'Aries'],
  [3259062339,3259270968,'Taurus'],
  [3259270968,3259470386,'Gemini'],
  [3259470386,3259658588,'Cancer'],
  [3259658588,3259836299,'Leo'],
  [3259836299,3260007868,'Virgo'],
  [3260007868,3260180225,'Libra'],
  [3260180225,3260360962,'Scorpio'],
  [3260360962,3260555823,'Sagittarius'],
  [3260555823,3260765400,'Capricorn'],
  [3260765400,3260983838,'Aquarius'],
  [3260983838,3261202732,'Pisces'],
  [3261202732,3261416549,'Aries'],
  [3261416549,3261623638,'Taurus'],
  [3261623638,3261823635,'Gemini'],
  [3261823635,3262015685,'Cancer'],
  [3262015685,3262199222,'Leo'],
  [3262199222,3262375949,'Virgo'],
  [3262375949,3262550645,'Libra'],
  [3262550645,3262730077,'Scorpio'],
  [3262730077,3262920803,'Sagittarius'],
  [3262920803,3263125960,'Capricorn'],
  [3263125960,3263342227,'Aquarius'],
  [3263342227,3263560967,'Pisces'],
  [3263560967,3263774271,'Aries'],
  [3263774271,3263979199,'Taurus'],
  [3263979199,3264176581,'Gemini'],
  [3264176581,3264367928,'Cancer'],
  [3264367928,3264553988,'Leo'],
  [3264553988,3264735577,'Virgo'],
  [3264735577,3264915149,'Libra'],
  [3264915149,3265097259,'Scorpio'],
  [3265097259,3265287437,'Sagittarius'],
  [3265287437,3265489711,'Capricorn'],
  [3265489711,3265703390,'Aquarius'],
  [3265703390,3265921769,'Pisces'],
  [3265921769,3266135826,'Aries'],
  [3266135826,3266340149,'Taurus'],
  [3266340149,3266534679,'Gemini'],
  [3266534679,3266722298,'Cancer'],
  [3266722298,3266906175,'Leo'],
  [3266906175,3267088700,'Virgo'],
  [3267088700,3267271902,'Libra'],
  [3267271902,3267458296,'Scorpio'],
  [3267458296,3267651101,'Sagittarius'],
  [3267651101,3267853296,'Capricorn'],
  [3267853296,3268065404,'Aquarius'],
  [3268065404,3268283337,'Pisces'],
  [3268283337,3268499086,'Aries'],
  [3268499086,3268705259,'Taurus'],
  [3268705259,3268899358,'Gemini'],
  [3268899358,3269083681,'Cancer'],
  [3269083681,3269262855,'Leo'],
  [3269262855,3269441739,'Virgo'],
  [3269441739,3269624241,'Libra'],
  [3269624241,3269812918,'Scorpio'],
  [3269812918,3270009148,'Sagittarius'],
  [3270009148,3270213529,'Capricorn'],
  [3270213529,3270425762,'Aquarius'],
  [3270425762,3270643407,'Pisces'],
  [3270643407,3270860846,'Aries'],
  [3270860846,3271070659,'Taurus'],
  [3271070659,3271267736,'Gemini'],
  [3271267736,3271452036,'Cancer'],
  [3271452036,3271627785,'Leo'],
  [3271627785,3271801279,'Virgo'],
  [3271801279,3271978884,'Libra'],
  [3271978884,3272165369,'Scorpio'],
  [3272165369,3272362572,'Sagittarius'],
  [3272362572,3272569323,'Capricorn'],
  [3272569323,3272782976,'Aquarius'],
  [3272782976,3273000689,'Pisces'],
  [3273000689,3273218872,'Aries'],
  [3273218872,3273432106,'Taurus'],
  [3273432106,3273634394,'Gemini'],
  [3273634394,3273822749,'Cancer'],
  [3273822749,3273999140,'Leo'],
  [3273999140,3274169492,'Virgo'],
  [3274169492,3274341429,'Libra'],
  [3274341429,3274522139,'Scorpio'],
  [3274522139,3274716022,'Sagittarius'],
  [3274716022,3274922661,'Capricorn'],
  [3274922661,3275137601,'Aquarius'],
  [3275137601,3275355764,'Pisces'],
  [3275355764,3275573606,'Aries'],
  [3275573606,3275788013,'Taurus'],
  [3275788013,3275994637,'Gemini'],
  [3275994637,3276189189,'Cancer'],
  [3276189189,3276370598,'Leo'],
  [3276370598,3276542535,'Virgo'],
  [3276542535,3276712061,'Libra'],
  [3276712061,3276887312,'Scorpio'],
  [3276887312,3277075117,'Sagittarius'],
  [3277075117,3277277948,'Capricorn'],
  [3277277948,3277492191,'Aquarius'],
  [3277492191,3277710772,'Pisces'],
  [3277710772,3277928001,'Aries'],
  [3277928001,3278141196,'Taurus'],
  [3278141196,3278348510,'Gemini'],
  [3278348510,3278547240,'Cancer'],
  [3278547240,3278735078,'Leo'],
  [3278735078,3278912757,'Virgo'],
  [3278912757,3279084951,'Libra'],
  [3279084951,3279258832,'Scorpio'],
  [3279258832,3279441878,'Sagittarius'],
  [3279441878,3279639106,'Capricorn'],
  [3279639106,3279849985,'Aquarius'],
  [3279849985,3280068054,'Pisces'],
  [3280068054,3280285248,'Aries'],
  [3280285248,3280496820,'Taurus'],
  [3280496820,3280701645,'Gemini'],
  [3280701645,3280899676,'Cancer'],
  [3280899676,3281090446,'Leo'],
  [3281090446,3281273905,'Virgo'],
  [3281273905,3281452079,'Libra'],
  [3281452079,3281629518,'Scorpio'],
  [3281629518,3281812258,'Sagittarius'],
  [3281812258,3282005827,'Capricorn'],
  [3282005827,3282212437,'Aquarius'],
  [3282212437,3282428626,'Pisces'],
  [3282428626,3282646296,'Aries'],
  [3282646296,3282857886,'Taurus'],
  [3282857886,3283060341,'Gemini'],
  [3283060341,3283254512,'Cancer'],
  [3283254512,3283442687,'Leo'],
  [3283442687,3283627027,'Virgo'],
  [3283627027,3283809479,'Libra'],
  [3283809479,3283992407,'Scorpio'],
  [3283992407,3284179035,'Sagittarius'],
  [3284179035,3284373100,'Capricorn'],
  [3284373100,3284577380,'Aquarius'],
  [3284577380,3284791300,'Pisces'],
  [3284791300,3285009295,'Aries'],
  [3285009295,3285222860,'Taurus'],
  [3285222860,3285425836,'Gemini'],
  [3285425836,3285617347,'Cancer'],
  [3285617347,3285800645,'Leo'],
  [3285800645,3285980570,'Virgo'],
  [3285980570,3286161580,'Libra'],
  [3286161580,3286346736,'Scorpio'],
  [3286346736,3286537650,'Sagittarius'],
  [3286537650,3286735232,'Capricorn'],
  [3286735232,3286940375,'Aquarius'],
  [3286940375,3287153246,'Pisces'],
  [3287153246,3287371152,'Aries'],
  [3287371152,3287587331,'Taurus'],
  [3287587331,3287793835,'Gemini'],
  [3287793835,3287986638,'Cancer'],
  [3287986638,3288167515,'Leo'],
  [3288167515,3288342196,'Virgo'],
  [3288342196,3288517521,'Libra'],
  [3288517521,3288699228,'Scorpio'],
  [3288699228,3288890309,'Sagittarius'],
  [3288890309,3289090608,'Capricorn'],
  [3289090608,3289298353,'Aquarius'],
  [3289298353,3289511979,'Pisces'],
  [3289511979,3289729768,'Aries'],
  [3289729768,3289947637,'Taurus'],
  [3289947637,3290158513,'Gemini'],
  [3290158513,3290356064,'Cancer'],
  [3290356064,3290539088,'Leo'],
  [3290539088,3290712039,'Virgo'],
  [3290712039,3290882387,'Libra'],
  [3290882387,3291057862,'Scorpio'],
  [3291057862,3291244206,'Sagittarius'],
  [3291244206,3291443116,'Capricorn'],
  [3291443116,3291652129,'Aquarius'],
  [3291652129,3291867221,'Pisces'],
  [3291867221,3292085247,'Aries'],
  [3292085247,3292303373,'Taurus'],
  [3292303373,3292516907,'Gemini'],
  [3292516907,3292719754,'Cancer'],
  [3292719754,3292908268,'Leo'],
  [3292908268,3293084179,'Virgo'],
  [3293084179,3293253712,'Libra'],
  [3293253712,3293424862,'Scorpio'],
  [3293424862,3293605065,'Sagittarius'],
  [3293605065,3293798824,'Capricorn'],
  [3293798824,3294005725,'Aquarius'],
  [3294005725,3294221120,'Pisces'],
  [3294221120,3294439522,'Aries'],
  [3294439522,3294657069,'Taurus'],
  [3294657069,3294870601,'Gemini'],
  [3294870601,3295076172,'Cancer'],
  [3295076172,3295270103,'Leo'],
  [3295270103,3295451797,'Virgo'],
  [3295451797,3295624946,'Libra'],
  [3295624946,3295796151,'Scorpio'],
  [3295796151,3295972808,'Sagittarius'],
  [3295972808,3296161024,'Capricorn'],
  [3296161024,3296363240,'Aquarius'],
  [3296363240,3296576730,'Pisces'],
  [3296576730,3296795051,'Aries'],
  [3296795051,3297012042,'Taurus'],
  [3297012042,3297223975,'Gemini'],
  [3297223975,3297428726,'Cancer'],
  [3297428726,3297624704,'Leo'],
  [3297624704,3297811294,'Virgo'],
  [3297811294,3297990125,'Libra'],
  [3297990125,3298165337,'Scorpio'],
  [3298165337,3298342699,'Sagittarius'],
  [3298342699,3298528154,'Capricorn'],
  [3298528154,3298725868,'Aquarius'],
  [3298725868,3298935960,'Pisces'],
  [3298935960,3299153379,'Aries'],
  [3299153379,3299370366,'Taurus'],
  [3299370366,3299580985,'Gemini'],
  [3299580985,3299783037,'Cancer'],
  [3299783037,3299977016,'Leo'],
  [3299977016,3300164435,'Virgo'],
  [3300164435,3300347150,'Libra'],
  [3300347150,3300527568,'Scorpio'],
  [3300527568,3300708984,'Sagittarius'],
  [3300708984,3300895529,'Capricorn'],
  [3300895529,3301091281,'Aquarius'],
  [3301091281,3301298325,'Pisces'],
  [3301298325,3301514285,'Aries'],
  [3301514285,3301731871,'Taurus'],
  [3301731871,3301942869,'Gemini'],
  [3301942869,3302143083,'Cancer'],
  [3302143083,3302333368,'Leo'],
  [3302333368,3302517449,'Virgo'],
  [3302517449,3302699416,'Libra'],
  [3302699416,3302882328,'Scorpio'],
  [3302882328,3303068106,'Sagittarius'],
  [3303068106,3303258390,'Capricorn'],
  [3303258390,3303455375,'Aquarius'],
  [3303455375,3303661272,'Pisces'],
  [3303661272,3303875946,'Aries'],
  [3303875946,3304094357,'Taurus'],
  [3304094357,3304307658,'Gemini'],
  [3304307658,3304508885,'Cancer'],
  [3304508885,3304697175,'Leo'],
  [3304697175,3304876841,'Virgo'],
  [3304876841,3305054139,'Libra'],
  [3305054139,3305234559,'Scorpio'],
  [3305234559,3305421201,'Sagittarius'],
  [3305421201,3305614695,'Capricorn'],
  [3305614695,3305814781,'Aquarius'],
  [3305814781,3306021806,'Pisces'],
  [3306021806,3306236063,'Aries'],
  [3306236063,3306454977,'Taurus'],
  [3306454977,3306671323,'Gemini'],
  [3306671323,3306876532,'Cancer'],
  [3306876532,3307066741,'Leo'],
  [3307066741,3307244747,'Virgo'],
  [3307244747,3307417328,'Libra'],
  [3307417328,3307591966,'Scorpio'],
  [3307591966,3307774446,'Sagittarius'],
  [3307774446,3307967143,'Capricorn'],
  [3307967143,3308169148,'Aquarius'],
  [3308169148,3308378393,'Pisces'],
  [3308378393,3308593359,'Aries'],
  [3308593359,3308812266,'Taurus'],
  [3308812266,3309030481,'Gemini'],
  [3309030481,3309240446,'Cancer'],
  [3309240446,3309436093,'Leo'],
  [3309436093,3309617168,'Virgo'],
  [3309617168,3309788922,'Libra'],
  [3309788922,3309959051,'Scorpio'],
  [3309959051,3310135108,'Sagittarius'],
  [3310135108,3310322399,'Capricorn'],
  [3310322399,3310522266,'Aquarius'],
  [3310522266,3310732288,'Pisces'],
  [3310732288,3310948463,'Aries'],
  [3310948463,3311167290,'Taurus'],
  [3311167290,3311385310,'Gemini'],
  [3311385310,3311597625,'Cancer'],
  [3311597625,3311798844,'Leo'],
  [3311798844,3311986362,'Virgo'],
  [3311986362,3312162389,'Libra'],
  [3312162389,3312332840,'Scorpio'],
  [3312332840,3312505078,'Sagittarius'],
  [3312505078,3312685995,'Capricorn'],
  [3312685995,3312880039,'Aquarius'],
  [3312880039,3313087363,'Pisces'],
  [3313087363,3313303645,'Aries'],
  [3313303645,3313522705,'Taurus'],
  [3313522705,3313739548,'Gemini'],
  [3313739548,3313950779,'Cancer'],
  [3313950779,3314153744,'Leo'],
  [3314153744,3314346546,'Virgo'],
  [3314346546,3314529309,'Libra'],
  [3314529309,3314704932,'Scorpio'],
  [3314704932,3314878629,'Sagittarius'],
  [3314878629,3315056750,'Capricorn'],
  [3315056750,3315245236,'Aquarius'],
  [3315245236,3315447411,'Pisces'],
  [3315447411,3315661521,'Aries'],
  [3315661521,3315880681,'Taurus'],
  [3315880681,3316097029,'Gemini'],
  [3316097029,3316305926,'Cancer'],
  [3316305926,3316506465,'Leo'],
  [3316506465,3316699512,'Virgo'],
  [3316699512,3316886223,'Libra'],
  [3316886223,3317067978,'Scorpio'],
  [3317067978,3317247102,'Sagittarius'],
  [3317247102,3317427505,'Capricorn'],
  [3317427505,3317614349,'Aquarius'],
  [3317614349,3317812403,'Pisces'],
  [3317812403,3318023052,'Aries'],
  [3318023052,3318241532,'Taurus'],
  [3318241532,3318458588,'Gemini'],
  [3318458588,3318666685,'Cancer'],
  [3318666685,3318864025,'Leo'],
  [3318864025,3319053283,'Virgo'],
  [3319053283,3319238316,'Libra'],
  [3319238316,3319422002,'Scorpio'],
  [3319422002,3319605855,'Sagittarius'],
  [3319605855,3319791209,'Capricorn'],
  [3319791209,3319980679,'Aquarius'],
  [3319980679,3320178115,'Pisces'],
  [3320178115,3320386366,'Aries'],
  [3320386366,3320603652,'Taurus'],
  [3320603652,3320822003,'Gemini'],
  [3320822003,3321031792,'Cancer'],
  [3321031792,3321228494,'Leo'],
  [3321228494,3321414197,'Virgo'],
  [3321414197,3321594404,'Libra'],
  [3321594404,3321774587,'Scorpio'],
  [3321774587,3321958211,'Sagittarius'],
  [3321958211,3322146495,'Capricorn'],
  [3322146495,3322339908,'Aquarius'],
  [3322339908,3322539793,'Pisces'],
  [3322539793,3322748082,'Aries'],
  [3322748082,3322964600,'Taurus'],
  [3322964600,3323184020,'Gemini'],
  [3323184020,3323397011,'Cancer'],
  [3323397011,3323596478,'Leo'],
  [3323596478,3323782072,'Virgo'],
  [3323782072,3323958840,'Libra'],
  [3323958840,3324133624,'Scorpio'],
  [3324133624,3324312371,'Sagittarius'],
  [3324312371,3324498602,'Capricorn'],
  [3324498602,3324693236,'Aquarius'],
  [3324693236,3324895844,'Pisces'],
  [3324895844,3325105955,'Aries'],
  [3325105955,3325322701,'Taurus'],
  [3325322701,3325542584,'Gemini'],
  [3325542584,3325758431,'Cancer'],
  [3325758431,3325962568,'Leo'],
  [3325962568,3326151890,'Virgo'],
  [3326151890,3326329260,'Libra'],
  [3326329260,3326501020,'Scorpio'],
  [3326501020,3326674227,'Sagittarius'],
  [3326674227,3326854799,'Capricorn'],
  [3326854799,3327046179,'Aquarius'],
  [3327046179,3327248744,'Pisces'],
  [3327248744,3327460412,'Aries'],
  [3327460412,3327678056,'Taurus'],
  [3327678056,3327897919,'Gemini'],
  [3327897919,3328114878,'Cancer'],
  [3328114878,3328322929,'Leo'],
  [3328322929,3328517822,'Virgo'],
  [3328517822,3328699678,'Libra'],
  [3328699678,3328872752,'Scorpio'],
  [3328872752,3329043485,'Sagittarius'],
  [3329043485,3329218738,'Capricorn'],
  [3329218738,3329404300,'Aquarius'],
  [3329404300,3329603180,'Pisces'],
  [3329603180,3329814168,'Aries'],
  [3329814168,3330032400,'Taurus'],
  [3330032400,3330252096,'Gemini'],
  [3330252096,3330468404,'Cancer'],
  [3330468404,3330677559,'Leo'],
  [3330677559,3330876622,'Virgo'],
  [3330876622,3331064387,'Libra'],
  [3331064387,3331242444,'Scorpio'],
  [3331242444,3331415107,'Sagittarius'],
  [3331415107,3331588504,'Capricorn'],
  [3331588504,3331769289,'Aquarius'],
  [3331769289,3331962819,'Pisces'],
  [3331962819,3332170522,'Aries'],
  [3332170522,3332388080,'Taurus'],
  [3332388080,3332607660,'Gemini'],
  [3332607660,3332822712,'Cancer'],
  [3332822712,3333030269,'Leo'],
  [3333030269,3333229764,'Virgo'],
  [3333229764,3333421192,'Libra'],
  [3333421192,3333604953,'Scorpio'],
  [3333604953,3333782795,'Sagittarius'],
  [3333782795,3333958621,'Capricorn'],
  [3333958621,3334138225,'Aquarius'],
  [3334138225,3334327811,'Pisces'],
  [3334327811,3334531258,'Aries'],
  [3334531258,3334746724,'Taurus'],
  [3334746724,3334966204,'Gemini'],
  [3334966204,3335180750,'Cancer'],
  [3335180750,3335386065,'Leo'],
  [3335386065,3335582796,'Virgo'],
  [3335582796,3335773383,'Libra'],
  [3335773383,3335959621,'Scorpio'],
  [3335959621,3336142427,'Sagittarius'],
  [3336142427,3336323296,'Capricorn'],
  [3336323296,3336505684,'Aquarius'],
  [3336505684,3336694769,'Pisces'],
  [3336694769,3336895354,'Aries'],
  [3336895354,3337108246,'Taurus'],
  [3337108246,3337327466,'Gemini'],
  [3337327466,3337542955,'Cancer'],
  [3337542955,3337747761,'Leo'],
  [3337747761,3337941530,'Virgo'],
  [3337941530,3338128096,'Libra'],
  [3338128096,3338311790,'Scorpio'],
  [3338311790,3338495339,'Sagittarius'],
  [3338495339,3338679931,'Capricorn'],
  [3338679931,3338866860,'Aquarius'],
  [3338866860,3339058833,'Pisces'],
  [3339058833,3339259467,'Aries'],
  [3339259467,3339470734,'Taurus'],
  [3339470734,3339689461,'Gemini'],
  [3339689461,3339906883,'Cancer'],
  [3339906883,3340114022,'Leo'],
  [3340114022,3340307747,'Virgo'],
  [3340307747,3340491052,'Libra'],
  [3340491052,3340669611,'Scorpio'],
  [3340669611,3340848780,'Sagittarius'],
  [3340848780,3341032065,'Capricorn'],
  [3341032065,3341221093,'Aquarius'],
  [3341221093,3341416722,'Pisces'],
  [3341416722,3341619948,'Aries'],
  [3341619948,3341831513,'Taurus'],
  [3341831513,3342049779,'Gemini'],
  [3342049779,3342268782,'Cancer'],
  [3342268782,3342479996,'Leo'],
  [3342479996,3342677590,'Virgo'],
  [3342677590,3342861748,'Libra'],
  [3342861748,3343037263,'Scorpio'],
  [3343037263,3343210642,'Sagittarius'],
  [3343210642,3343388014,'Capricorn'],
  [3343388014,3343573772,'Aquarius'],
  [3343573772,3343769780,'Pisces'],
  [3343769780,3343975485,'Aries'],
  [3343975485,3344188881,'Taurus'],
  [3344188881,3344407251,'Gemini'],
  [3344407251,3344626538,'Cancer'],
  [3344626538,3344840848,'Leo'],
  [3344840848,3345044117,'Virgo'],
  [3345044117,3345233531,'Libra'],
  [3345233531,3345411032,'Scorpio'],
  [3345411032,3345582089,'Sagittarius'],
  [3345582089,3345753717,'Capricorn'],
  [3345753717,3345932771,'Aquarius'],
  [3345932771,3346124161,'Pisces'],
  [3346124161,3346328887,'Aries'],
  [3346328887,3346543550,'Taurus'],
  [3346543550,3346762664,'Gemini'],
  [3346762664,3346981394,'Cancer'],
  [3346981394,3347196017,'Leo'],
  [3347196017,3347402862,'Virgo'],
  [3347402862,3347598617,'Libra'],
  [3347598617,3347782273,'Scorpio'],
  [3347782273,3347956411,'Sagittarius'],
  [3347956411,3348126811,'Capricorn'],
  [3348126811,3348300875,'Aquarius'],
  [3348300875,3348485723,'Pisces'],
  [3348485723,3348685524,'Aries'],
  [3348685524,3348898652,'Taurus'],
  [3348898652,3349118151,'Gemini'],
  [3349118151,3349336519,'Cancer'],
  [3349336519,3349549605,'Leo'],
  [3349549605,3349756019,'Virgo'],
  [3349756019,3349954680,'Libra'],
  [3349954680,3350144276,'Scorpio'],
  [3350144276,3350324757,'Sagittarius'],
  [3350324757,3350499053,'Capricorn'],
  [3350499053,3350673080,'Aquarius'],
  [3350673080,3350854137,'Pisces'],
  [3350854137,3351048416,'Aries'],
  [3351048416,3351257472,'Taurus'],
  [3351257472,3351475874,'Gemini'],
  [3351475874,3351694328,'Cancer'],
  [3351694328,3351906202,'Leo'],
  [3351906202,3352110022,'Virgo'],
  [3352110022,3352306967,'Libra'],
  [3352306967,3352497964,'Scorpio'],
  [3352497964,3352683113,'Sagittarius'],
  [3352683113,3352863225,'Capricorn'],
  [3352863225,3353041498,'Aquarius'],
  [3353041498,3353223470,'Pisces'],
  [3353223470,3353415242,'Aries'],
  [3353415242,3353620393,'Taurus'],
  [3353620393,3353836505,'Gemini'],
  [3353836505,3354055101,'Cancer'],
  [3354055101,3354267312,'Leo'],
  [3354267312,3354469454,'Virgo'],
  [3354469454,3354662887,'Libra'],
  [3354662887,3354850732,'Scorpio'],
  [3354850732,3355035443,'Sagittarius'],
  [3355035443,3355218483,'Capricorn'],
  [3355218483,3355401518,'Aquarius'],
  [3355401518,3355587548,'Pisces'],
  [3355587548,3355780714,'Aries'],
  [3355780714,3355984476,'Taurus'],
  [3355984476,3356198589,'Gemini'],
  [3356198589,3356417151,'Cancer'],
  [3356417151,3356631106,'Leo'],
  [3356631106,3356834168,'Virgo'],
  [3356834168,3357025809,'Libra'],
  [3357025809,3357209490,'Scorpio'],
  [3357209490,3357389789,'Sagittarius'],
  [3357389789,3357570630,'Capricorn'],
  [3357570630,3357754792,'Aquarius'],
  [3357754792,3357944283,'Pisces'],
  [3357944283,3358140858,'Aries'],
  [3358140858,3358345982,'Taurus'],
  [3358345982,3358559558,'Gemini'],
  [3358559558,3358778014,'Cancer'],
  [3358778014,3358994158,'Leo'],
  [3358994158,3359200510,'Virgo'],
  [3359200510,3359393778,'Libra'],
  [3359393778,3359575818,'Scorpio'],
  [3359575818,3359751632,'Sagittarius'],
  [3359751632,3359927159,'Capricorn'],
  [3359927159,3360107685,'Aquarius'],
  [3360107685,3360296733,'Pisces'],
  [3360296733,3360495463,'Aries'],
  [3360495463,3360703032,'Taurus'],
  [3360703032,3360917537,'Gemini'],
  [3360917537,3361136017,'Cancer'],
  [3361136017,3361353653,'Leo'],
  [3361353653,3361563989,'Virgo'],
  [3361563989,3361761798,'Libra'],
  [3361761798,3361946173,'Scorpio'],
  [3361946173,3362120716,'Sagittarius'],
  [3362120716,3362291792,'Capricorn'],
  [3362291792,3362466521,'Aquarius'],
  [3362466521,3362650962,'Pisces'],
  [3362650962,3362848109,'Aries'],
  [3362848109,3363056695,'Taurus'],
  [3363056695,3363272545,'Gemini'],
  [3363272545,3363491264,'Cancer'],
  [3363491264,3363709126,'Leo'],
  [3363709126,3363921965,'Virgo'],
  [3363921965,3364124884,'Libra'],
  [3364124884,3364314681,'Scorpio'],
  [3364314681,3364492251,'Sagittarius'],
  [3364492251,3364662649,'Capricorn'],
  [3364662649,3364833290,'Aquarius'],
  [3364833290,3365011872,'Pisces'],
  [3365011872,3365204012,'Aries'],
  [3365204012,3365410462,'Taurus'],
  [3365410462,3365626527,'Gemini'],
  [3365626527,3365845536,'Cancer'],
  [3365845536,3366062747,'Leo'],
  [3366062747,3366275510,'Virgo'],
  [3366275510,3366481113,'Libra'],
  [3366481113,3366676386,'Scorpio'],
  [3366676386,3366859881,'Sagittarius'],
  [3366859881,3367033999,'Capricorn'],
  [3367033999,3367204750,'Aquarius'],
  [3367204750,3367379861,'Pisces'],
  [3367379861,3367566507,'Aries'],
  [3367566507,3367768243,'Taurus'],
  [3367768243,3367982354,'Gemini'],
  [3367982354,3368201266,'Cancer'],
  [3368201266,3368417874,'Leo'],
  [3368417874,3368628905,'Virgo'],
  [3368628905,3368833509,'Libra'],
  [3368833509,3369030741,'Scorpio'],
  [3369030741,3369219299,'Sagittarius'],
  [3369219299,3369399436,'Capricorn'],
  [3369399436,3369574523,'Aquarius'],
  [3369574523,3369750586,'Pisces'],
  [3369750586,3369934548,'Aries'],
  [3369934548,3370131630,'Taurus'],
  [3370131630,3370342127,'Gemini'],
  [3370342127,3370560089,'Cancer'],
  [3370560089,3370776834,'Leo'],
  [3370776834,3370986620,'Virgo'],
  [3370986620,3371188314,'Libra'],
  [3371188314,3371383082,'Scorpio'],
  [3371383082,3371572067,'Sagittarius'],
  [3371572067,3371756084,'Capricorn'],
  [3371756084,3371936767,'Aquarius'],
  [3371936767,3372117489,'Pisces'],
  [3372117489,3372303078,'Aries'],
  [3372303078,3372498343,'Taurus'],
  [3372498343,3372705533,'Gemini'],
  [3372705533,3372921772,'Cancer'],
  [3372921772,3373139273,'Leo'],
  [3373139273,3373349934,'Virgo'],
  [3373349934,3373550124,'Libra'],
  [3373550124,3373740948,'Scorpio'],
  [3373740948,3373925784,'Sagittarius'],
  [3373925784,3374108156,'Capricorn'],
  [3374108156,3374290867,'Aquarius'],
  [3374290867,3374476143,'Pisces'],
  [3374476143,3374666176,'Aries'],
  [3374666176,3374863362,'Taurus'],
  [3374863362,3375069573,'Gemini'],
  [3375069573,3375284211,'Cancer'],
  [3375284211,3375502349,'Leo'],
  [3375502349,3375715810,'Virgo'],
  [3375715810,3375917981,'Libra'],
  [3375917981,3376107526,'Scorpio'],
  [3376107526,3376287864,'Sagittarius'],
  [3376287864,3376464666,'Capricorn'],
  [3376464666,3376643581,'Aquarius'],
  [3376643581,3376828678,'Pisces'],
  [3376828678,3377021690,'Aries'],
  [3377021690,3377222494,'Taurus'],
  [3377222494,3377430433,'Gemini'],
  [3377430433,3377644714,'Cancer'],
  [3377644714,3377862904,'Leo'],
  [3377862904,3378079217,'Virgo'],
  [3378079217,3378286066,'Libra'],
  [3378286066,3378478824,'Scorpio'],
  [3378478824,3378658596,'Sagittarius'],
  [3378658596,3378831056,'Capricorn'],
  [3378831056,3379003667,'Aquarius'],
  [3379003667,3379183297,'Pisces'],
  [3379183297,3379374105,'Aries'],
  [3379374105,3379576152,'Taurus'],
  [3379576152,3379786479,'Gemini'],
  [3379786479,3380001847,'Cancer'],
  [3380001847,3380219869,'Leo'],
  [3380219869,3380437317,'Virgo'],
  [3380437317,3380648445,'Libra'],
  [3380648445,3380847143,'Scorpio'],
  [3380847143,3381031231,'Sagittarius'],
  [3381031231,3381204198,'Capricorn'],
  [3381204198,3381373281,'Aquarius'],
  [3381373281,3381546681,'Pisces'],
  [3381546681,3381731225,'Aries'],
  [3381731225,3381929790,'Taurus'],
  [3381929790,3382140017,'Gemini'],
  [3382140017,3382356539,'Cancer'],
  [3382356539,3382574711,'Leo'],
  [3382574711,3382791631,'Virgo'],
  [3382791631,3383004059,'Libra'],
  [3383004059,3383207363,'Scorpio'],
  [3383207363,3383397831,'Sagittarius'],
  [3383397831,3383575894,'Capricorn'],
  [3383575894,3383746628,'Aquarius'],
  [3383746628,3383917627,'Pisces'],
  [3383917627,3384096639,'Aries'],
  [3384096639,3384289134,'Taurus'],
  [3384289134,3384495701,'Gemini'],
  [3384495701,3384711596,'Cancer'],
  [3384711596,3384930009,'Leo'],
  [3384930009,3385146042,'Virgo'],
  [3385146042,3385357094,'Libra'],
  [3385357094,3385560992,'Scorpio'],
  [3385560992,3385755415,'Sagittarius'],
  [3385755415,3385939523,'Capricorn'],
  [3385939523,3386115669,'Aquarius'],
  [3386115669,3386289193,'Pisces'],
  [3386289193,3386466863,'Aries'],
  [3386466863,3386654883,'Taurus'],
  [3386654883,3386856460,'Gemini'],
  [3386856460,3387069639,'Cancer'],
  [3387069639,3387287750,'Leo'],
  [3387287750,3387503520,'Virgo'],
  [3387503520,3387712708,'Libra'],
  [3387712708,3387914112,'Scorpio'],
  [3387914112,3388107891,'Sagittarius'],
  [3388107891,3388294669,'Capricorn'],
  [3388294669,3388475942,'Aquarius'],
  [3388475942,3388654678,'Pisces'],
  [3388654678,3388835272,'Aries'],
  [3388835272,3389022741,'Taurus'],
  [3389022741,3389221093,'Gemini'],
  [3389221093,3389431036,'Cancer'],
  [3389431036,3389648183,'Leo'],
  [3389648183,3389864529,'Virgo'],
  [3389864529,3390073285,'Libra'],
  [3390073285,3390272039,'Scorpio'],
  [3390272039,3390462216,'Sagittarius'],
  [3390462216,3390646916,'Capricorn'],
  [3390646916,3390829262,'Aquarius'],
  [3390829262,3391011851,'Pisces'],
  [3391011851,3391197013,'Aries'],
  [3391197013,3391387334,'Taurus'],
  [3391387334,3391585648,'Gemini'],
  [3391585648,3391793704,'Cancer'],
  [3391793704,3392009752,'Leo'],
  [3392009752,3392227216,'Virgo'],
  [3392227216,3392437637,'Libra'],
  [3392437637,3392636046,'Scorpio'],
  [3392636046,3392823100,'Sagittarius'],
  [3392823100,3393003298,'Capricorn'],
  [3393003298,3393182159,'Aquarius'],
  [3393182159,3393364158,'Pisces'],
  [3393364158,3393551740,'Aries'],
  [3393551740,3393745678,'Taurus'],
  [3393745678,3393946411,'Gemini'],
  [3393946411,3394154702,'Cancer'],
  [3394154702,3394370176,'Leo'],
  [3394370176,3394588709,'Virgo'],
  [3394588709,3394802238,'Libra'],
  [3394802238,3395003404,'Scorpio'],
  [3395003404,3395190466,'Sagittarius'],
  [3395190466,3395367451,'Capricorn'],
  [3395367451,3395541197,'Aquarius'],
  [3395541197,3395718482,'Pisces'],
  [3395718482,3395903940,'Aries'],
  [3395903940,3396098888,'Taurus'],
  [3396098888,3396302144,'Gemini'],
  [3396302144,3396512167,'Cancer'],
  [3396512167,3396727899,'Leo'],
  [3396727899,3396946950,'Virgo'],
  [3396946950,3397163369,'Libra'],
  [3397163369,3397369273,'Scorpio'],
  [3397369273,3397560138,'Sagittarius'],
  [3397560138,3397737775,'Capricorn'],
  [3397737775,3397908595,'Aquarius'],
  [3397908595,3398080463,'Pisces'],
  [3398080463,3398260289,'Aries'],
  [3398260289,3398451909,'Taurus'],
  [3398451909,3398655002,'Gemini'],
  [3398655002,3398866489,'Cancer'],
  [3398866489,3399083073,'Leo'],
  [3399083073,3399302070,'Virgo'],
  [3399302070,3399519584,'Libra'],
  [3399519584,3399729507,'Scorpio'],
  [3399729507,3399926229,'Sagittarius'],
  [3399926229,3400108662,'Capricorn'],
  [3400108662,3400281035,'Aquarius'],
  [3400281035,3400450579,'Pisces'],
  [3400450579,3400625030,'Aries'],
  [3400625030,3400810568,'Taurus'],
  [3400810568,3401009694,'Gemini'],
  [3401009694,3401220346,'Cancer'],
  [3401220346,3401437532,'Leo'],
  [3401437532,3401656349,'Virgo'],
  [3401656349,3401873041,'Libra'],
  [3401873041,3402083846,'Scorpio'],
  [3402083846,3402284791,'Sagittarius'],
  [3402284791,3402473575,'Capricorn'],
  [3402473575,3402651577,'Aquarius'],
  [3402651577,3402823678,'Pisces'],
  [3402823678,3402996613,'Aries'],
  [3402996613,3403177217,'Taurus'],
  [3403177217,3403370487,'Gemini'],
  [3403370487,3403577379,'Cancer'],
  [3403577379,3403793774,'Leo'],
  [3403793774,3404012641,'Virgo'],
  [3404012641,3404228061,'Libra'],
  [3404228061,3404436833,'Scorpio'],
  [3404436833,3404637594,'Sagittarius'],
  [3404637594,3404829782,'Capricorn'],
  [3404829782,3405013854,'Aquarius'],
  [3405013854,3405192005,'Pisces'],
  [3405192005,3405368337,'Aries'],
  [3405368337,3405548319,'Taurus'],
  [3405548319,3405737546,'Gemini'],
  [3405737546,3405939633,'Cancer'],
  [3405939633,3406153482,'Leo'],
  [3406153482,3406372358,'Virgo'],
  [3406372358,3406587689,'Libra'],
  [3406587689,3406794264,'Scorpio'],
  [3406794264,3406991610,'Sagittarius'],
  [3406991610,3407181906,'Capricorn'],
  [3407181906,3407367638,'Aquarius'],
  [3407367638,3407550697,'Pisces'],
  [3407550697,3407732814,'Aries'],
  [3407732814,3407916616,'Taurus'],
  [3407916616,3408106061,'Gemini'],
  [3408106061,3408305361,'Cancer'],
  [3408305361,3408516200,'Leo'],
  [3408516200,3408734558,'Virgo'],
  [3408734558,3408951280,'Libra'],
  [3408951280,3409158109,'Scorpio'],
  [3409158109,3409352806,'Sagittarius'],
  [3409352806,3409538555,'Capricorn'],
  [3409538555,3409720498,'Aquarius'],
  [3409720498,3409902921,'Pisces'],
  [3409902921,3410088039,'Aries'],
  [3410088039,3410276612,'Taurus'],
  [3410276612,3410469745,'Gemini'],
  [3410469745,3410669845,'Cancer'],
  [3410669845,3410879226,'Leo'],
  [3410879226,3411096709,'Virgo'],
  [3411096709,3411315230,'Libra'],
  [3411315230,3411525063,'Scorpio'],
  [3411525063,3411720796,'Sagittarius'],
  [3411720796,3411904080,'Capricorn'],
  [3411904080,3412080914,'Aquarius'],
  [3412080914,3412257986,'Pisces'],
  [3412257986,3412440214,'Aries'],
  [3412440214,3412629602,'Taurus'],
  [3412629602,3412826002,'Gemini'],
  [3412826002,3413029119,'Cancer'],
  [3413029119,3413239412,'Leo'],
  [3413239412,3413456473,'Virgo'],
  [3413456473,3413676010,'Libra'],
  [3413676010,3413889624,'Scorpio'],
  [3413889624,3414089809,'Sagittarius'],
  [3414089809,3414275151,'Capricorn'],
  [3414275151,3414450230,'Aquarius'],
  [3414450230,3414622267,'Pisces'],
  [3414622267,3414798270,'Aries'],
  [3414798270,3414983119,'Taurus'],
  [3414983119,3415178484,'Gemini'],
  [3415178484,3415383341,'Cancer'],
  [3415383341,3415595610,'Leo'],
  [3415595610,3415813166,'Virgo'],
  [3415813166,3416032749,'Libra'],
  [3416032749,3416248553,'Scorpio'],
  [3416248553,3416453732,'Sagittarius'],
  [3416453732,3416644534,'Capricorn'],
  [3416644534,3416822664,'Aquarius'],
  [3416822664,3416993876,'Pisces'],
  [3416993876,3417165378,'Aries'],
  [3417165378,3417343885,'Taurus'],
  [3417343885,3417533985,'Gemini'],
  [3417533985,3417736771,'Cancer'],
  [3417736771,3417949646,'Leo'],
  [3417949646,3418168027,'Virgo'],
  [3418168027,3418387282,'Libra'],
  [3418387282,3418602966,'Scorpio'],
  [3418602966,3418810626,'Sagittarius'],
  [3418810626,3419006761,'Capricorn'],
  [3419006761,3419190806,'Aquarius'],
  [3419190806,3419365794,'Pisces'],
  [3419365794,3419537334,'Aries'],
  [3419537334,3419712114,'Taurus'],
  [3419712114,3419896406,'Gemini'],
  [3419896406,3420094181,'Cancer'],
  [3420094181,3420304939,'Leo'],
  [3420304939,3420523355,'Virgo'],
  [3420523355,3420742391,'Libra'],
  [3420742391,3420956713,'Scorpio'],
  [3420956713,3421163569,'Sagittarius'],
  [3421163569,3421361684,'Capricorn'],
  [3421361684,3421550651,'Aquarius'],
  [3421550651,3421731474,'Pisces'],
  [3421731474,3421907143,'Aries'],
  [3421907143,3422082632,'Taurus'],
  [3422082632,3422264073,'Gemini'],
  [3422264073,3422457069,'Cancer'],
  [3422457069,3422663937,'Leo'],
  [3422663937,3422881052,'Virgo'],
  [3422881052,3423100070,'Libra'],
  [3423100070,3423313356,'Scorpio'],
  [3423313356,3423517804,'Sagittarius'],
  [3423517804,3423714084,'Capricorn'],
  [3423714084,3423903934,'Aquarius'],
  [3423903934,3424088702,'Pisces'],
  [3424088702,3424269672,'Aries'],
  [3424269672,3424449299,'Taurus'],
  [3424449299,3424631924,'Gemini'],
  [3424631924,3424822959,'Cancer'],
  [3424822959,3425026441,'Leo'],
  [3425026441,3425241450,'Virgo'],
  [3425241450,3425460556,'Libra'],
  [3425460556,3425674159,'Scorpio'],
  [3425674159,3425877051,'Sagittarius'],
  [3425877051,3426070010,'Capricorn'],
  [3426070010,3426256796,'Aquarius'],
  [3426256796,3426440966,'Pisces'],
  [3426440966,3426624516,'Aries'],
  [3426624516,3426808567,'Taurus'],
  [3426808567,3426995056,'Gemini'],
  [3426995056,3427187529,'Cancer'],
  [3427187529,3427389881,'Leo'],
  [3427389881,3427603149,'Virgo'],
  [3427603149,3427822317,'Libra'],
  [3427822317,3428037677,'Scorpio'],
  [3428037677,3428241510,'Sagittarius'],
  [3428241510,3428432755,'Capricorn'],
  [3428432755,3428615517,'Aquarius'],
  [3428615517,3428795352,'Pisces'],
  [3428795352,3428976647,'Aries'],
  [3428976647,3429161693,'Taurus'],
  [3429161693,3429351495,'Gemini'],
  [3429351495,3429547298,'Cancer'],
  [3429547298,3429751053,'Leo'],
  [3429751053,3429963881,'Virgo'],
  [3429963881,3430183025,'Libra'],
  [3430183025,3430400676,'Scorpio'],
  [3430400676,3430607982,'Sagittarius'],
  [3430607982,3430801043,'Capricorn'],
  [3430801043,3430982313,'Aquarius'],
  [3430982313,3431157695,'Pisces'],
  [3431157695,3431333519,'Aries'],
  [3431333519,3431514696,'Taurus'],
  [3431514696,3431703886,'Gemini'],
  [3431703886,3431901793,'Cancer'],
  [3431901793,3432108082,'Leo'],
  [3432108082,3432321921,'Virgo'],
  [3432321921,3432541049,'Libra'],
  [3432541049,3432760152,'Scorpio'],
  [3432760152,3432971661,'Sagittarius'],
  [3432971661,3433169759,'Capricorn'],
  [3433169759,3433353914,'Aquarius'],
  [3433353914,3433528384,'Pisces'],
  [3433528384,3433699704,'Aries'],
  [3433699704,3433874636,'Taurus'],
  [3433874636,3434058656,'Gemini'],
  [3434058656,3434254589,'Cancer'],
  [3434254589,3434461853,'Leo'],
  [3434461853,3434677217,'Virgo'],
  [3434677217,3434896591,'Libra'],
  [3434896591,3435115644,'Scorpio'],
  [3435115644,3435329435,'Sagittarius'],
  [3435329435,3435532930,'Capricorn'],
  [3435532930,3435723319,'Aquarius'],
  [3435723319,3435901784,'Pisces'],
  [3435901784,3436073071,'Aries'],
  [3436073071,3436243935,'Taurus'],
  [3436243935,3436421542,'Gemini'],
  [3436421542,3436611652,'Cancer'],
  [3436611652,3436816177,'Leo'],
  [3436816177,3437031699,'Virgo'],
  [3437031699,3437251543,'Libra'],
  [3437251543,3437469783,'Scorpio'],
  [3437469783,3437682888,'Sagittarius'],
  [3437682888,3437888502,'Capricorn'],
  [3437888502,3438084446,'Aquarius'],
  [3438084446,3438269704,'Pisces'],
  [3438269704,3438445908,'Aries'],
  [3438445908,3438617806,'Taurus'],
  [3438617806,3438792272,'Gemini'],
  [3438792272,3438976534,'Cancer'],
  [3438976534,3439175519,'Leo'],
  [3439175519,3439388457,'Virgo'],
  [3439388457,3439608211,'Libra'],
  [3439608211,3439826089,'Scorpio'],
  [3439826089,3440037241,'Sagittarius'],
  [3440037241,3440240981,'Capricorn'],
  [3440240981,3440437826,'Aquarius'],
  [3440437826,3440627665,'Pisces'],
  [3440627665,3440810364,'Aries'],
  [3440810364,3440987669,'Taurus'],
  [3440987669,3441164199,'Gemini'],
  [3441164199,3441346522,'Cancer'],
  [3441346522,3441540864,'Leo'],
  [3441540864,3441749557,'Virgo'],
  [3441749557,3441967895,'Libra'],
  [3441967895,3442186138,'Scorpio'],
  [3442186138,3442396553,'Sagittarius'],
  [3442396553,3442597408,'Capricorn'],
  [3442597408,3442790937,'Aquarius'],
  [3442790937,3442979757,'Pisces'],
  [3442979757,3443165156,'Aries'],
  [3443165156,3443347797,'Taurus'],
  [3443347797,3443529601,'Gemini'],
  [3443529601,3443714654,'Cancer'],
  [3443714654,3443908182,'Leo'],
  [3443908182,3444113816,'Virgo'],
  [3444113816,3444329968,'Libra'],
  [3444329968,3444548692,'Scorpio'],
  [3444548692,3444760482,'Sagittarius'],
  [3444760482,3444960744,'Capricorn'],
  [3444960744,3445150877,'Aquarius'],
  [3445150877,3445335102,'Pisces'],
  [3445335102,3445517455,'Aries'],
  [3445517455,3445700529,'Taurus'],
  [3445700529,3445885929,'Gemini'],
  [3445885929,3446075479,'Cancer'],
  [3446075479,3446271795,'Leo'],
  [3446271795,3446477366,'Virgo'],
  [3446477366,3446692082,'Libra'],
  [3446692082,3446910933,'Scorpio'],
  [3446910933,3447125276,'Sagittarius'],
  [3447125276,3447328133,'Capricorn'],
  [3447328133,3447518196,'Aquarius'],
  [3447518196,3447698971,'Pisces'],
  [3447698971,3447875931,'Aries'],
  [3447875931,3448054344,'Taurus'],
  [3448054344,3448238109,'Gemini'],
  [3448238109,3448429413,'Cancer'],
  [3448429413,3448629020,'Leo'],
  [3448629020,3448836820,'Virgo'],
  [3448836820,3449051734,'Libra'],
  [3449051734,3449270489,'Scorpio'],
  [3449270489,3449486968,'Sagittarius'],
  [3449486968,3449694095,'Capricorn'],
  [3449694095,3449887848,'Aquarius'],
  [3449887848,3450069229,'Pisces'],
  [3450069229,3450243064,'Aries'],
  [3450243064,3450415867,'Taurus'],
  [3450415867,3450594023,'Gemini'],
  [3450594023,3450782231,'Cancer'],
  [3450782231,3450982090,'Leo'],
  [3450982090,3451191868,'Virgo'],
  [3451191868,3451408053,'Libra'],
  [3451408053,3451626831,'Scorpio'],
  [3451626831,3451844050,'Sagittarius'],
  [3451844050,3452054619,'Capricorn'],
  [3452054619,3452253721,'Aquarius'],
  [3452253721,3452439579,'Pisces'],
  [3452439579,3452614700,'Aries'],
  [3452614700,3452784977,'Taurus'],
  [3452784977,3452957800,'Gemini'],
  [3452957800,3453140140,'Cancer'],
  [3453140140,3453336230,'Leo'],
  [3453336230,3453545355,'Virgo'],
  [3453545355,3453762386,'Libra'],
  [3453762386,3453981357,'Scorpio'],
  [3453981357,3454198078,'Sagittarius'],
  [3454198078,3454409574,'Capricorn'],
  [3454409574,3454612561,'Aquarius'],
  [3454612561,3454804180,'Pisces'],
  [3454804180,3454984241,'Aries'],
  [3454984241,3455156452,'Taurus'],
  [3455156452,3455327503,'Gemini'],
  [3455327503,3455505114,'Cancer'],
  [3455505114,3455695693,'Leo'],
  [3455695693,3455901211,'Virgo'],
  [3455901211,3456117378,'Libra'],
  [3456117378,3456336423,'Scorpio'],
  [3456336423,3456552297,'Sagittarius'],
  [3456552297,3456762472,'Capricorn'],
  [3456762472,3456965876,'Aquarius'],
  [3456965876,3457161014,'Pisces'],
  [3457161014,3457346667,'Aries'],
  [3457346667,3457524013,'Taurus'],
  [3457524013,3457697583,'Gemini'],
  [3457697583,3457874190,'Cancer'],
  [3457874190,3458060842,'Leo'],
  [3458060842,3458261777,'Virgo'],
  [3458261777,3458475312,'Libra'],
  [3458475312,3458693961,'Scorpio'],
  [3458693961,3458909523,'Sagittarius'],
  [3458909523,3459117906,'Capricorn'],
  [3459117906,3459318899,'Aquarius'],
  [3459318899,3459513338,'Pisces'],
  [3459513338,3459701486,'Aries'],
  [3459701486,3459883765,'Taurus'],
  [3459883765,3460062401,'Gemini'],
  [3460062401,3460241946,'Cancer'],
  [3460241946,3460428253,'Leo'],
  [3460428253,3460626217,'Virgo'],
  [3460626217,3460836657,'Libra'],
  [3460836657,3461054364,'Scorpio'],
  [3461054364,3461270537,'Sagittarius'],
  [3461270537,3461478565,'Capricorn'],
  [3461478565,3461676977,'Aquarius'],
  [3461676977,3461867770,'Pisces'],
  [3461867770,3462053692,'Aries'],
  [3462053692,3462236935,'Taurus'],
  [3462236935,3462419414,'Gemini'],
  [3462419414,3462603629,'Cancer'],
  [3462603629,3462792989,'Leo'],
  [3462792989,3462991072,'Virgo'],
  [3462991072,3463199645,'Libra'],
  [3463199645,3463416217,'Scorpio'],
  [3463416217,3463633611,'Sagittarius'],
  [3463633611,3463843600,'Capricorn'],
  [3463843600,3464041954,'Aquarius'],
  [3464041954,3464229657,'Pisces'],
  [3464229657,3464410772,'Aries'],
  [3464410772,3464590090,'Taurus'],
  [3464590090,3464771671,'Gemini'],
  [3464771671,3464958279,'Cancer'],
  [3464958279,3465151521,'Leo'],
  [3465151521,3465352359,'Virgo'],
  [3465352359,3465561269,'Libra'],
  [3465561269,3465777128,'Scorpio'],
  [3465777128,3465995525,'Sagittarius'],
  [3465995525,3466208981,'Capricorn'],
  [3466208981,3466410790,'Aquarius'],
  [3466410790,3466599081,'Pisces'],
  [3466599081,3466777052,'Aries'],
  [3466777052,3466950776,'Taurus'],
  [3466950776,3467126875,'Gemini'],
  [3467126875,3467310664,'Cancer'],
  [3467310664,3467504651,'Leo'],
  [3467504651,3467708232,'Virgo'],
  [3467708232,3467919186,'Libra'],
  [3467919186,3468135290,'Scorpio'],
  [3468135290,3468353894,'Sagittarius'],
  [3468353894,3468570147,'Capricorn'],
  [3468570147,3468777271,'Aquarius'],
  [3468777271,3468970424,'Pisces'],
  [3468970424,3469149951,'Aries'],
  [3469149951,3469321077,'Taurus'],
  [3469321077,3469491438,'Gemini'],
  [3469491438,3469668708,'Cancer'],
  [3469668708,3469858309,'Leo'],
  [3469858309,3470061128,'Virgo'],
  [3470061128,3470273572,'Libra'],
  [3470273572,3470490730,'Scorpio'],
  [3470490730,3470709094,'Sagittarius'],
  [3470709094,3470925857,'Capricorn'],
  [3470925857,3471136648,'Aquarius'],
  [3471136648,3471336136,'Pisces'],
  [3471336136,3471521601,'Aries'],
  [3471521601,3471695460,'Taurus'],
  [3471695460,3471864313,'Gemini'],
  [3471864313,3472036394,'Cancer'],
  [3472036394,3472219243,'Leo'],
  [3472219243,3472416933,'Virgo'],
  [3472416933,3472627731,'Libra'],
  [3472627731,3472845407,'Scorpio'],
  [3472845407,3473063770,'Sagittarius'],
  [3473063770,3473279407,'Capricorn'],
  [3473279407,3473490150,'Aquarius'],
  [3473490150,3473692965,'Pisces'],
  [3473692965,3473884731,'Aries'],
  [3473884731,3474065054,'Taurus'],
  [3474065054,3474237745,'Gemini'],
  [3474237745,3474409615,'Cancer'],
  [3474409615,3474588305,'Leo'],
  [3474588305,3474779887,'Virgo'],
  [3474779887,3474985958,'Libra'],
  [3474985958,3475202117,'Scorpio'],
  [3475202117,3475420597,'Sagittarius'],
  [3475420597,3475635333,'Capricorn'],
  [3475635333,3475843825,'Aquarius'],
  [3475843825,3476045316,'Pisces'],
  [3476045316,3476239051,'Aries'],
  [3476239051,3476424647,'Taurus'],
  [3476424647,3476603607,'Gemini'],
  [3476603607,3476779967,'Cancer'],
  [3476779967,3476959519,'Leo'],
  [3476959519,3477148151,'Virgo'],
  [3477148151,3477349514,'Libra'],
  [3477349514,3477562470,'Scorpio'],
  [3477562470,3477780536,'Sagittarius'],
  [3477780536,3477995567,'Capricorn'],
  [3477995567,3478202564,'Aquarius'],
  [3478202564,3478400726,'Pisces'],
  [3478400726,3478591610,'Aries'],
  [3478591610,3478777293,'Taurus'],
  [3478777293,3478959820,'Gemini'],
  [3478959820,3479141542,'Cancer'],
  [3479141542,3479325555,'Leo'],
  [3479325555,3479515630,'Virgo'],
  [3479515630,3479715208,'Libra'],
  [3479715208,3479925331,'Scorpio'],
  [3479925331,3480142423,'Sagittarius'],
  [3480142423,3480358668,'Capricorn'],
  [3480358668,3480566514,'Aquarius'],
  [3480566514,3480762948,'Pisces'],
  [3480762948,3480949753,'Aries'],
  [3480949753,3481131245,'Taurus'],
  [3481131245,3481311959,'Gemini'],
  [3481311959,3481495312,'Cancer'],
  [3481495312,3481683313,'Leo'],
  [3481683313,3481877205,'Virgo'],
  [3481877205,3482078294,'Libra'],
  [3482078294,3482287601,'Scorpio'],
  [3482287601,3482503835,'Sagittarius'],
  [3482503835,3482721441,'Capricorn'],
  [3482721441,3482932143,'Aquarius'],
  [3482932143,3483130123,'Pisces'],
  [3483130123,3483315324,'Aries'],
  [3483315324,3483492444,'Taurus'],
  [3483492444,3483668032,'Gemini'],
  [3483668032,3483847987,'Cancer'],
  [3483847987,3484035847,'Leo'],
  [3484035847,3484232241,'Virgo'],
  [3484232241,3484436143,'Libra'],
  [3484436143,3484646627,'Scorpio'],
  [3484646627,3484862715,'Sagittarius'],
  [3484862715,3485081168,'Capricorn'],
  [3485081168,3485295166,'Aquarius'],
  [3485295166,3485497338,'Pisces'],
  [3485497338,3485684814,'Aries'],
  [3485684814,3485860773,'Taurus'],
  [3485860773,3486032105,'Gemini'],
  [3486032105,3486206432,'Cancer'],
  [3486206432,3486389793,'Leo'],
  [3486389793,3486584700,'Virgo'],
  [3486584700,3486789803,'Libra'],
  [3486789803,3487001999,'Scorpio'],
  [3487001999,3487218650,'Sagittarius'],
  [3487218650,3487437240,'Capricorn'],
  [3487437240,3487653211,'Aquarius'],
  [3487653211,3487859943,'Pisces'],
  [3487859943,3488052553,'Aries'],
  [3488052553,3488231527,'Taurus'],
  [3488231527,3488402366,'Gemini'],
  [3488402366,3488572825,'Cancer'],
  [3488572825,3488750447,'Leo'],
  [3488750447,3488940331,'Virgo'],
  [3488940331,3489143212,'Libra'],
  [3489143212,3489355720,'Scorpio'],
  [3489355720,3489573049,'Sagittarius'],
  [3489573049,3489791363,'Capricorn'],
  [3489791363,3490007252,'Aquarius'],
  [3490007252,3490216310,'Pisces'],
  [3490216310,3490414010,'Aries'],
  [3490414010,3490598694,'Taurus'],
  [3490598694,3490773266,'Gemini'],
  [3490773266,3490943986,'Cancer'],
  [3490943986,3491118275,'Leo'],
  [3491118275,3491302688,'Virgo'],
  [3491302688,3491500694,'Libra'],
  [3491500694,3491711011,'Scorpio'],
  [3491711011,3491928284,'Sagittarius'],
  [3491928284,3492146368,'Capricorn'],
  [3492146368,3492360924,'Aquarius'],
  [3492360924,3492569119,'Pisces'],
  [3492569119,3492768693,'Aries'],
  [3492768693,3492958276,'Taurus'],
  [3492958276,3493138754,'Gemini'],
  [3493138754,3493313793,'Cancer'],
  [3493313793,3493489043,'Leo'],
  [3493489043,3493670759,'Virgo'],
  [3493670759,3493863999,'Libra'],
  [3493863999,3494070360,'Scorpio'],
  [3494070360,3494286302,'Sagittarius'],
  [3494286302,3494504461,'Capricorn'],
  [3494504461,3494718043,'Aquarius'],
  [3494718043,3494923709,'Pisces'],
  [3494923709,3495121161,'Aries'],
  [3495121161,3495311423,'Taurus'],
  [3495311423,3495495903,'Gemini'],
  [3495495903,3495676567,'Cancer'],
  [3495676567,3495856419,'Leo'],
  [3495856419,3496039644,'Virgo'],
  [3496039644,3496230943,'Libra'],
  [3496230943,3496433734,'Scorpio'],
  [3496433734,3496647421,'Sagittarius'],
  [3496647421,3496865803,'Capricorn'],
  [3496865803,3497080028,'Aquarius'],
  [3497080028,3497284265,'Pisces'],
  [3497284265,3497478097,'Aries'],
  [3497478097,3497664714,'Taurus'],
  [3497664714,3497848076,'Gemini'],
  [3497848076,3498031176,'Cancer'],
  [3498031176,3498215788,'Leo'],
  [3498215788,3498403450,'Virgo'],
  [3498403450,3498596581,'Libra'],
  [3498596581,3498798265,'Scorpio'],
  [3498798265,3499009979,'Sagittarius'],
  [3499009979,3499228358,'Capricorn'],
  [3499228358,3499444768,'Aquarius'],
  [3499444768,3499650597,'Pisces'],
  [3499650597,3499843036,'Aries'],
  [3499843036,3500025358,'Taurus'],
  [3500025358,3500203612,'Gemini'],
  [3500203612,3500383500,'Cancer'],
  [3500383500,3500568488,'Leo'],
  [3500568488,3500759485,'Virgo'],
  [3500759485,3500956400,'Libra'],
  [3500956400,3501159914,'Scorpio'],
  [3501159914,3501371233,'Sagittarius'],
  [3501371233,3501589314,'Capricorn'],
  [3501589314,3501808018,'Aquarius'],
  [3501808018,3502018005,'Pisces'],
  [3502018005,3502213263,'Aries'],
  [3502213263,3502394823,'Taurus'],
  [3502394823,3502568749,'Gemini'],
  [3502568749,3502742514,'Cancer'],
  [3502742514,3502922388,'Leo'],
  [3502922388,3503111623,'Virgo'],
  [3503111623,3503310168,'Libra'],
  [3503310168,3503516427,'Scorpio'],
  [3503516427,3503729143,'Sagittarius'],
  [3503729143,3503947144,'Capricorn'],
  [3503947144,3504166797,'Aquarius'],
  [3504166797,3504380803,'Pisces'],
  [3504380803,3504581773,'Aries'],
  [3504581773,3504767447,'Taurus'],
  [3504767447,3504941707,'Gemini'],
  [3504941707,3505111744,'Cancer'],
  [3505111744,3505285195,'Leo'],
  [3505285195,3505468115,'Virgo'],
  [3505468115,3505663278,'Libra'],
  [3505663278,3505869685,'Scorpio'],
  [3505869685,3506083968,'Sagittarius'],
  [3506083968,3506302511,'Capricorn'],
  [3506302511,3506521815,'Aquarius'],
  [3506521815,3506737171,'Pisces'],
  [3506737171,3506942867,'Aries'],
  [3506942867,3507135067,'Taurus'],
  [3507135067,3507314500,'Gemini'],
  [3507314500,3507486084,'Cancer'],
  [3507486084,3507656792,'Leo'],
  [3507656792,3507833719,'Virgo'],
  [3507833719,3508022379,'Libra'],
  [3508022379,3508224815,'Scorpio'],
  [3508224815,3508438466,'Sagittarius'],
  [3508438466,3508657555,'Capricorn'],
  [3508657555,3508876313,'Aquarius'],
  [3508876313,3509090509,'Pisces'],
  [3509090509,3509297048,'Aries'],
  [3509297048,3509493590,'Taurus'],
  [3509493590,3509679494,'Gemini'],
  [3509679494,3509856779,'Cancer'],
  [3509856779,3510029990,'Leo'],
  [3510029990,3510205245,'Virgo'],
  [3510205245,3510388906,'Libra'],
  [3510388906,3510585670,'Scorpio'],
  [3510585670,3510795960,'Sagittarius'],
  [3510795960,3511014495,'Capricorn'],
  [3511014495,3511233141,'Aquarius'],
  [3511233141,3511445734,'Pisces'],
  [3511445734,3511650030,'Aries'],
  [3511650030,3511846264,'Taurus'],
  [3511846264,3512035295,'Gemini'],
  [3512035295,3512218218,'Cancer'],
  [3512218218,3512397004,'Leo'],
  [3512397004,3512575267,'Virgo'],
  [3512575267,3512758209,'Libra'],
  [3512758209,3512951285,'Scorpio'],
  [3512951285,3513157521,'Sagittarius'],
  [3513157521,3513374257,'Capricorn'],
  [3513374257,3513593097,'Aquarius'],
  [3513593097,3513805327,'Pisces'],
  [3513805327,3514007225,'Aries'],
  [3514007225,3514200154,'Taurus'],
  [3514200154,3514387436,'Gemini'],
  [3514387436,3514571829,'Cancer'],
  [3514571829,3514754905,'Leo'],
  [3514754905,3514938082,'Virgo'],
  [3514938082,3515124096,'Libra'],
  [3515124096,3515317158,'Scorpio'],
  [3515317158,3515521093,'Sagittarius'],
  [3515521093,3515735834,'Capricorn'],
  [3515735834,3515954909,'Aquarius'],
  [3515954909,3516168430,'Pisces'],
  [3516168430,3516370077,'Aries'],
  [3516370077,3516560183,'Taurus'],
  [3516560183,3516743278,'Gemini'],
  [3516743278,3516924475,'Cancer'],
  [3516924475,3517107269,'Leo'],
  [3517107269,3517293187,'Virgo'],
  [3517293187,3517483145,'Libra'],
  [3517483145,3517678972,'Scorpio'],
  [3517678972,3517883271,'Sagittarius'],
  [3517883271,3518097007,'Capricorn'],
  [3518097007,3518316226,'Aquarius'],
  [3518316226,3518532038,'Pisces'],
  [3518532038,3518736149,'Aries'],
  [3518736149,3518926410,'Taurus'],
  [3518926410,3519106606,'Gemini'],
  [3519106606,3519282980,'Cancer'],
  [3519282980,3519461318,'Leo'],
  [3519461318,3519645353,'Virgo'],
  [3519645353,3519836557,'Libra'],
  [3519836557,3520035247,'Scorpio'],
  [3520035247,3520241689,'Sagittarius'],
  [3520241689,3520455823,'Capricorn'],
  [3520455823,3520675103,'Aquarius'],
  [3520675103,3520892943,'Pisces'],
  [3520892943,3521101109,'Aries'],
  [3521101109,3521294953,'Taurus'],
  [3521294953,3521475923,'Gemini'],
  [3521475923,3521649592,'Cancer'],
  [3521649592,3521822745,'Leo'],
  [3521822745,3522001394,'Virgo'],
  [3522001394,3522189461,'Libra'],
  [3522189461,3522388173,'Scorpio'],
  [3522388173,3522596416,'Sagittarius'],
  [3522596416,3522811810,'Capricorn'],
  [3522811810,3523031176,'Aquarius'],
  [3523031176,3523249739,'Pisces'],
  [3523249739,3523461272,'Aries'],
  [3523461272,3523660458,'Taurus'],
  [3523660458,3523846011,'Gemini'],
  [3523846011,3524021199,'Cancer'],
  [3524021199,3524192056,'Leo'],
  [3524192056,3524365479,'Virgo'],
  [3524365479,3524547681,'Libra'],
  [3524547681,3524742543,'Scorpio'],
  [3524742543,3524950048,'Sagittarius'],
  [3524950048,3525166306,'Capricorn'],
  [3525166306,3525385871,'Aquarius'],
  [3525385871,3525603839,'Pisces'],
  [3525603839,3525816152,'Aries'],
  [3525816152,3526019247,'Taurus'],
  [3526019247,3526210834,'Gemini'],
  [3526210834,3526391395,'Cancer'],
  [3526391395,3526564563,'Leo'],
  [3526564563,3526736321,'Virgo'],
  [3526736321,3526913649,'Libra'],
  [3526913649,3527102745,'Scorpio'],
  [3527102745,3527306425,'Sagittarius'],
  [3527306425,3527521801,'Capricorn'],
  [3527521801,3527741541,'Aquarius'],
  [3527741541,3527958595,'Pisces'],
  [3527958595,3528169271,'Aries'],
  [3528169271,3528372443,'Taurus'],
  [3528372443,3528567520,'Gemini'],
  [3528567520,3528754088,'Cancer'],
  [3528754088,3528933070,'Leo'],
  [3528933070,3529107898,'Virgo'],
  [3529107898,3529284405,'Libra'],
  [3529284405,3529469402,'Scorpio'],
  [3529469402,3529668111,'Sagittarius'],
  [3529668111,3529880568,'Capricorn'],
  [3529880568,3530099983,'Aquarius'],
  [3530099983,3530316926,'Pisces'],
  [3530316926,3530525720,'Aries'],
  [3530525720,3530725981,'Taurus'],
  [3530725981,3530919693,'Gemini'],
  [3530919693,3531108367,'Cancer'],
  [3531108367,3531292500,'Leo'],
  [3531292500,3531473070,'Virgo'],
  [3531473070,3531653228,'Libra'],
  [3531653228,3531838319,'Scorpio'],
  [3531838319,3532034042,'Sagittarius'],
  [3532034042,3532243025,'Capricorn'],
  [3532243025,3532461275,'Aquarius'],
  [3532461275,3532679120,'Pisces'],
  [3532679120,3532888044,'Aries'],
  [3532888044,3533085855,'Taurus'],
  [3533085855,3533275414,'Gemini'],
  [3533275414,3533460836,'Cancer'],
  [3533460836,3533644960,'Leo'],
  [3533644960,3533829039,'Virgo'],
  [3533829039,3534014236,'Libra'],
  [3534014236,3534203146,'Scorpio'],
  [3534203146,3534399668,'Sagittarius'],
  [3534399668,3534606903,'Capricorn'],
  [3534606903,3534823657,'Aquarius'],
  [3534823657,3535042612,'Pisces'],
  [3535042612,3535254094,'Aries'],
  [3535254094,3535452787,'Taurus'],
  [3535452787,3535639884,'Gemini'],
  [3535639884,3535820287,'Cancer'],
  [3535820287,3535999356,'Leo'],
  [3535999356,3536181077,'Virgo'],
  [3536181077,3536367663,'Libra'],
  [3536367663,3536560335,'Scorpio'],
  [3536560335,3536760251,'Sagittarius'],
  [3536760251,3536968517,'Capricorn'],
  [3536968517,3537184588,'Aquarius'],
  [3537184588,3537404034,'Pisces'],
  [3537404034,3537618841,'Aries'],
  [3537618841,3537821762,'Taurus'],
  [3537821762,3538010798,'Gemini'],
  [3538010798,3538189240,'Cancer'],
  [3538189240,3538363043,'Leo'],
  [3538363043,3538538510,'Virgo'],
  [3538538510,3538720779,'Libra'],
  [3538720779,3538912795,'Scorpio'],
  [3538912795,3539114932,'Sagittarius'],
  [3539114932,3539325624,'Capricorn'],
  [3539325624,3539542397,'Aquarius'],
  [3539542397,3539761773,'Pisces'],
  [3539761773,3539978531,'Aries'],
  [3539978531,3540186347,'Taurus'],
  [3540186347,3540380880,'Gemini'],
  [3540380880,3540562307,'Cancer'],
  [3540562307,3540734982,'Leo'],
  [3540734982,3540905585,'Virgo'],
  [3540905585,3541081253,'Libra'],
  [3541081253,3541267851,'Scorpio'],
  [3541267851,3541467927,'Sagittarius'],
  [3541467927,3541679475,'Capricorn'],
  [3541679475,3541897456,'Aquarius'],
  [3541897456,3542116779,'Pisces'],
  [3542116779,3542333496,'Aries'],
  [3542333496,3542543836,'Taurus'],
  [3542543836,3542743874,'Gemini'],
  [3542743874,3542931425,'Cancer'],
  [3542931425,3543107883,'Leo'],
  [3543107883,3543278321,'Virgo'],
  [3543278321,3543449991,'Libra'],
  [3543449991,3543630412,'Scorpio'],
  [3543630412,3543824985,'Sagittarius'],
  [3543824985,3544034031,'Capricorn'],
  [3544034031,3544252037,'Aquarius'],
  [3544252037,3544471453,'Pisces'],
  [3544471453,3544687157,'Aries'],
  [3544687157,3544896922,'Taurus'],
  [3544896922,3545099131,'Gemini'],
  [3545099131,3545291882,'Cancer'],
  [3545291882,3545474442,'Leo'],
  [3545474442,3545649133,'Virgo'],
  [3545649133,3545821540,'Libra'],
  [3545821540,3545998998,'Scorpio'],
  [3545998998,3546188347,'Sagittarius'],
  [3546188347,3546392744,'Capricorn'],
  [3546392744,3546608789,'Aquarius'],
  [3546608789,3546828053,'Pisces'],
  [3546828053,3547043030,'Aries'],
  [3547043030,3547250789,'Taurus'],
  [3547250789,3547451449,'Gemini'],
  [3547451449,3547645320,'Cancer'],
  [3547645320,3547832111,'Leo'],
  [3547832111,3548012383,'Virgo'],
  [3548012383,3548189182,'Libra'],
  [3548189182,3548368042,'Scorpio'],
  [3548368042,3548555394,'Sagittarius'],
  [3548555394,3548755858,'Capricorn'],
  [3548755858,3548968858,'Aquarius'],
  [3548968858,3549187466,'Pisces'],
  [3549187466,3549402638,'Aries'],
  [3549402638,3549609167,'Taurus'],
  [3549609167,3549806896,'Gemini'],
  [3549806896,3549998001,'Cancer'],
  [3549998001,3550184467,'Leo'],
  [3550184467,3550367600,'Virgo'],
  [3550367600,3550549116,'Libra'],
  [3550549116,3550732180,'Scorpio'],
  [3550732180,3550921252,'Sagittarius'],
  [3550921252,3551120514,'Capricorn'],
  [3551120514,3551331113,'Aquarius'],
  [3551331113,3551548776,'Pisces'],
  [3551548776,3551765009,'Aries'],
  [3551765009,3551972389,'Taurus'],
  [3551972389,3552168672,'Gemini'],
  [3552168672,3552356076,'Cancer'],
  [3552356076,3552538537,'Leo'],
  [3552538537,3552719756,'Virgo'],
  [3552719756,3552902573,'Libra'],
  [3552902573,3553089263,'Scorpio'],
  [3553089263,3553282018,'Sagittarius'],
  [3553282018,3553482935,'Capricorn'],
  [3553482935,3553692956,'Aquarius'],
  [3553692956,3553909881,'Pisces'],
  [3553909881,3554127444,'Aries'],
  [3554127444,3554337673,'Taurus'],
  [3554337673,3554535626,'Gemini'],
  [3554535626,3554721643,'Cancer'],
  [3554721643,3554899892,'Leo'],
  [3554899892,3555076029,'Virgo'],
  [3555076029,3555255400,'Libra'],
  [3555255400,3555441825,'Scorpio'],
  [3555441825,3555636994,'Sagittarius'],
  [3555636994,3555840758,'Capricorn'],
  [3555840758,3556052015,'Aquarius'],
  [3556052015,3556268802,'Pisces'],
  [3556268802,3556487192,'Aries'],
  [3556487192,3556700815,'Taurus'],
  [3556700815,3556903231,'Gemini'],
  [3556903231,3557091832,'Cancer'],
  [3557091832,3557269061,'Leo'],
  [3557269061,3557440857,'Virgo'],
  [3557440857,3557614392,'Libra'],
  [3557614392,3557796089,'Scorpio'],
  [3557796089,3557989620,'Sagittarius'],
  [3557989620,3558194607,'Capricorn'],
  [3558194607,3558407663,'Aquarius'],
  [3558407663,3558624982,'Pisces'],
  [3558624982,3558843359,'Aries'],
  [3558843359,3559058899,'Taurus'],
  [3559058899,3559266160,'Gemini'],
  [3559266160,3559460481,'Cancer'],
  [3559460481,3559641271,'Leo'],
  [3559641271,3559812787,'Virgo'],
  [3559812787,3559982329,'Libra'],
  [3559982329,3560157903,'Scorpio'],
  [3560157903,3560345907,'Sagittarius'],
  [3560345907,3560548332,'Capricorn'],
  [3560548332,3560761666,'Aquarius'],
  [3560761666,3560979731,'Pisces'],
  [3560979731,3561197700,'Aries'],
  [3561197700,3561412825,'Taurus'],
  [3561412825,3561622200,'Gemini'],
  [3561622200,3561821885,'Cancer'],
  [3561821885,3562009132,'Leo'],
  [3562009132,3562185179,'Virgo'],
  [3562185179,3562355512,'Libra'],
  [3562355512,3562527892,'Scorpio'],
  [3562527892,3562710059,'Sagittarius'],
  [3562710059,3562906906,'Capricorn'],
  [3562906906,3563117530,'Aquarius'],
  [3563117530,3563335477,'Pisces'],
  [3563335477,3563553342,'Aries'],
  [3563553342,3563766958,'Taurus'],
  [3563766958,3563974876,'Gemini'],
  [3563974876,3564175794,'Cancer'],
  [3564175794,3564367841,'Leo'],
  [3564367841,3564550392,'Virgo'],
  [3564550392,3564726004,'Libra'],
  [3564726004,3564900307,'Scorpio'],
  [3564900307,3565080340,'Sagittarius'],
  [3565080340,3565272233,'Capricorn'],
  [3565272233,3565478187,'Aquarius'],
  [3565478187,3565694294,'Pisces'],
  [3565694294,3565912368,'Aries'],
  [3565912368,3566125402,'Taurus'],
  [3566125402,3566330736,'Gemini'],
  [3566330736,3566528708,'Cancer'],
  [3566528708,3566720242,'Leo'],
  [3566720242,3566906028,'Virgo'],
  [3566906028,3567087361,'Libra'],
  [3567087361,3567267141,'Scorpio'],
  [3567267141,3567449900,'Sagittarius'],
  [3567449900,3567640714,'Capricorn'],
  [3567640714,3567843100,'Aquarius'],
  [3567843100,3568056360,'Pisces'],
  [3568056360,3568274368,'Aries'],
  [3568274368,3568488559,'Taurus'],
  [3568488559,3568693291,'Gemini'],
  [3568693291,3568887904,'Cancer'],
  [3568887904,3569075026,'Leo'],
  [3569075026,3569258214,'Virgo'],
  [3569258214,3569440579,'Libra'],
  [3569440579,3569624536,'Scorpio'],
  [3569624536,3569812214,'Sagittarius'],
  [3569812214,3570005952,'Capricorn'],
  [3570005952,3570208085,'Aquarius'],
  [3570208085,3570419409,'Pisces'],
  [3570419409,3570636896,'Aries'],
  [3570636896,3570853178,'Taurus'],
  [3570853178,3571060316,'Gemini'],
  [3571060316,3571254717,'Cancer'],
  [3571254717,3571438233,'Leo'],
  [3571438233,3571616028,'Virgo'],
  [3571616028,3571793956,'Libra'],
  [3571793956,3571976673,'Scorpio'],
  [3571976673,3572166594,'Sagittarius'],
  [3572166594,3572364066,'Capricorn'],
  [3572364066,3572568699,'Aquarius'],
  [3572568699,3572780213,'Pisces'],
  [3572780213,3572997262,'Aries'],
  [3572997262,3573215217,'Taurus'],
  [3573215217,3573426362,'Gemini'],
  [3573426362,3573624353,'Cancer'],
  [3573624353,3573808332,'Leo'],
  [3573808332,3573982849,'Virgo'],
  [3573982849,3574155080,'Libra'],
  [3574155080,3574332152,'Scorpio'],
  [3574332152,3574519028,'Sagittarius'],
  [3574519028,3574716948,'Capricorn'],
  [3574716948,3574923898,'Aquarius'],
  [3574923898,3575137063,'Pisces'],
  [3575137063,3575354298,'Aries'],
  [3575354298,3575572826,'Taurus'],
  [3575572826,3575787162,'Gemini'],
  [3575787162,3575990426,'Cancer'],
  [3575990426,3576178899,'Leo'],
  [3576178899,3576354704,'Virgo'],
  [3576354704,3576524395,'Libra'],
  [3576524395,3576696026,'Scorpio'],
  [3576696026,3576876780,'Sagittarius'],
  [3576876780,3577070641,'Capricorn'],
  [3577070641,3577276822,'Aquarius'],
  [3577276822,3577491072,'Pisces'],
  [3577491072,3577708930,'Aries'],
  [3577708930,3577927217,'Taurus'],
  [3577927217,3578142438,'Gemini'],
  [3578142438,3578349500,'Cancer'],
  [3578349500,3578543781,'Leo'],
  [3578543781,3578724662,'Virgo'],
  [3578724662,3578896462,'Libra'],
  [3578896462,3579066425,'Scorpio'],
  [3579066425,3579242319,'Sagittarius'],
  [3579242319,3579430249,'Capricorn'],
  [3579430249,3579632267,'Aquarius'],
  [3579632267,3579845340,'Pisces'],
  [3579845340,3580063456,'Aries'],
  [3580063456,3580281325,'Taurus'],
  [3580281325,3580495509,'Gemini'],
  [3580495509,3580703049,'Cancer'],
  [3580703049,3580900896,'Leo'],
  [3580900896,3581087497,'Virgo'],
  [3581087497,3581264648,'Libra'],
  [3581264648,3581437374,'Scorpio'],
  [3581437374,3581612377,'Sagittarius'],
  [3581612377,3581796198,'Capricorn'],
  [3581796198,3581993084,'Aquarius'],
  [3581993084,3582202798,'Pisces'],
  [3582202798,3582420122,'Aries'],
  [3582420122,3582637820,'Taurus'],
  [3582637820,3582850599,'Gemini'],
  [3582850599,3583056031,'Cancer'],
  [3583056031,3583253382,'Leo'],
  [3583253382,3583442661,'Virgo'],
  [3583442661,3583624940,'Libra'],
  [3583624940,3583802962,'Scorpio'],
  [3583802962,3583981099,'Sagittarius'],
  [3583981099,3584164623,'Capricorn'],
  [3584164623,3584358296,'Aquarius'],
  [3584358296,3584564250,'Pisces'],
  [3584564250,3584779803,'Aries'],
  [3584779803,3584997665,'Taurus'],
  [3584997665,3585210151,'Gemini'],
  [3585210151,3585413318,'Cancer'],
  [3585413318,3585607401,'Leo'],
  [3585607401,3585794844,'Virgo'],
  [3585794844,3585978421,'Libra'],
  [3585978421,3586160553,'Scorpio'],
  [3586160553,3586343560,'Sagittarius'],
  [3586343560,3586530255,'Capricorn'],
  [3586530255,3586724058,'Aquarius'],
  [3586724058,3586927853,'Pisces'],
  [3586927853,3587141502,'Aries'],
  [3587141502,3587359684,'Taurus'],
  [3587359684,3587573606,'Gemini'],
  [3587573606,3587776640,'Cancer'],
  [3587776640,3587967879,'Leo'],
  [3587967879,3588150991,'Virgo'],
  [3588150991,3588331204,'Libra'],
  [3588331204,3588512930,'Scorpio'],
  [3588512930,3588698678,'Sagittarius'],
  [3588698678,3588889443,'Capricorn'],
  [3588889443,3589086127,'Aquarius'],
  [3589086127,3589290313,'Pisces'],
  [3589290313,3589502937,'Aries'],
  [3589502937,3589721312,'Taurus'],
  [3589721312,3589937783,'Gemini'],
  [3589937783,3590143665,'Cancer'],
  [3590143665,3590335279,'Leo'],
  [3590335279,3590515417,'Virgo'],
  [3590515417,3590690506,'Libra'],
  [3590690506,3590867359,'Scorpio'],
  [3590867359,3591050875,'Sagittarius'],
  [3591050875,3591242799,'Capricorn'],
  [3591242799,3591442470,'Aquarius'],
  [3591442470,3591648945,'Pisces'],
  [3591648945,3591861970,'Aries'],
  [3591861970,3592080300,'Taurus'],
  [3592080300,3592298863,'Gemini'],
  [3592298863,3592509269,'Cancer'],
  [3592509269,3592705153,'Leo'],
  [3592705153,3592886569,'Virgo'],
  [3592886569,3593059098,'Libra'],
  [3593059098,3593230481,'Scorpio'],
  [3593230481,3593407922,'Sagittarius'],
  [3593407922,3593595974,'Capricorn'],
  [3593595974,3593795277,'Aquarius'],
  [3593795277,3594003570,'Pisces'],
  [3594003570,3594218026,'Aries'],
  [3594218026,3594436379,'Taurus'],
  [3594436379,3594655363,'Gemini'],
  [3594655363,3594869042,'Cancer'],
  [3594869042,3595070790,'Leo'],
  [3595070790,3595257742,'Virgo'],
  [3595257742,3595432748,'Libra'],
  [3595432748,3595602466,'Scorpio'],
  [3595602466,3595774646,'Sagittarius'],
  [3595774646,3595956053,'Capricorn'],
  [3595956053,3596150464,'Aquarius'],
  [3596150464,3596357346,'Pisces'],
  [3596357346,3596572634,'Aries'],
  [3596572634,3596791382,'Taurus'],
  [3596791382,3597009548,'Gemini'],
  [3597009548,3597223306,'Cancer'],
  [3597223306,3597428420,'Leo'],
  [3597428420,3597621650,'Virgo'],
  [3597621650,3597803036,'Libra'],
  [3597803036,3597976419,'Scorpio'],
  [3597976419,3598148070,'Sagittarius'],
  [3598148070,3598324959,'Capricorn'],
  [3598324959,3598513020,'Aquarius'],
  [3598513020,3598715021,'Pisces'],
  [3598715021,3598928749,'Aries'],
  [3598928749,3599147776,'Taurus'],
  [3599147776,3599365317,'Gemini'],
  [3599365317,3599577084,'Cancer'],
  [3599577084,3599781169,'Leo'],
  [3599781169,3599976744,'Virgo'],
  [3599976744,3600163770,'Libra'],
  [3600163770,3600343657,'Scorpio'],
  [3600343657,3600519758,'Sagittarius'],
  [3600519758,3600697192,'Capricorn'],
  [3600697192,3600881871,'Aquarius'],
  [3600881871,3601078688,'Pisces'],
  [3601078688,3601288715,'Aries'],
  [3601288715,3601507015,'Taurus'],
  [3601507015,3601724828,'Gemini'],
  [3601724828,3601935215,'Cancer'],
  [3601935215,3602136152,'Leo'],
  [3602136152,3602329195,'Virgo'],
  [3602329195,3602516767,'Libra'],
  [3602516767,3602700747,'Scorpio'],
  [3602700747,3602882626,'Sagittarius'],
  [3602882626,3603064653,'Capricorn'],
  [3603064653,3603250658,'Aquarius'],
  [3603250658,3603445377,'Pisces'],
  [3603445377,3603652000,'Aries'],
  [3603652000,3603868647,'Taurus'],
  [3603868647,3604087246,'Gemini'],
  [3604087246,3604298377,'Cancer'],
  [3604298377,3604497635,'Leo'],
  [3604497635,3604686730,'Virgo'],
  [3604686730,3604870319,'Libra'],
  [3604870319,3605052799,'Scorpio'],
  [3605052799,3605236738,'Sagittarius'],
  [3605236738,3605423170,'Capricorn'],
  [3605423170,3605613293,'Aquarius'],
  [3605613293,3605809678,'Pisces'],
  [3605809678,3606015331,'Aries'],
  [3606015331,3606230554,'Taurus'],
  [3606230554,3606449840,'Gemini'],
  [3606449840,3606663463,'Cancer'],
  [3606663463,3606864226,'Leo'],
  [3606864226,3607051819,'Virgo'],
  [3607051819,3607231136,'Libra'],
  [3607231136,3607408542,'Scorpio'],
  [3607408542,3607589170,'Sagittarius'],
  [3607589170,3607775656,'Capricorn'],
  [3607775656,3607968586,'Aquarius'],
  [3607968586,3608168194,'Pisces'],
  [3608168194,3608375359,'Aries'],
  [3608375359,3608590374,'Taurus'],
  [3608590374,3608810000,'Gemini'],
  [3608810000,3609026387,'Cancer'],
  [3609026387,3609231138,'Leo'],
  [3609231138,3609421093,'Virgo'],
  [3609421093,3609599419,'Libra'],
  [3609599419,3609772626,'Scorpio'],
  [3609772626,3609947552,'Sagittarius'],
  [3609947552,3610129433,'Capricorn'],
  [3610129433,3610320838,'Aquarius'],
  [3610320838,3610521828,'Pisces'],
  [3610521828,3610731132,'Aries'],
  [3610731132,3610947081,'Taurus'],
  [3610947081,3611166814,'Gemini'],
  [3611166814,3611384786,'Cancer'],
  [3611384786,3611593765,'Leo'],
  [3611593765,3611788802,'Virgo'],
  [3611788802,3611970304,'Libra'],
  [3611970304,3612143169,'Scorpio'],
  [3612143169,3612314226,'Sagittarius'],
  [3612314226,3612490233,'Capricorn'],
  [3612490233,3612676375,'Aquarius'],
  [3612676375,3612874920,'Pisces'],
  [3612874920,3613084598,'Aries'],
  [3613084598,3613301592,'Taurus'],
  [3613301592,3613521392,'Gemini'],
  [3613521392,3613739317,'Cancer'],
  [3613739317,3613950440,'Leo'],
  [3613950440,3614150426,'Virgo'],
  [3614150426,3614337664,'Libra'],
  [3614337664,3614514376,'Scorpio'],
  [3614514376,3614685742,'Sagittarius'],
  [3614685742,3614858379,'Capricorn'],
  [3614858379,3615038904,'Aquarius'],
  [3615038904,3615232217,'Pisces'],
  [3615232217,3615439314,'Aries'],
  [3615439314,3615656177,'Taurus'],
  [3615656177,3615876033,'Gemini'],
  [3615876033,3616092984,'Cancer'],
  [3616092984,3616303449,'Leo'],
  [3616303449,3616505381,'Virgo'],
  [3616505381,3616697548,'Libra'],
  [3616697548,3616880207,'Scorpio'],
  [3616880207,3617055885,'Sagittarius'],
  [3617055885,3617229440,'Capricorn'],
  [3617229440,3617407242,'Aquarius'],
  [3617407242,3617595607,'Pisces'],
  [3617595607,3617798227,'Aries'],
  [3617798227,3618013170,'Taurus'],
  [3618013170,3618232882,'Gemini'],
  [3618232882,3618449092,'Cancer'],
  [3618449092,3618657474,'Leo'],
  [3618657474,3618857723,'Virgo'],
  [3618857723,3619050901,'Libra'],
  [3619050901,3619237769,'Scorpio'],
  [3619237769,3619419134,'Sagittarius'],
  [3619419134,3619597227,'Capricorn'],
  [3619597227,3619776505,'Aquarius'],
  [3619776505,3619962916,'Pisces'],
  [3619962916,3620161654,'Aries'],
  [3620161654,3620373590,'Taurus'],
  [3620373590,3620592736,'Gemini'],
  [3620592736,3620809254,'Cancer'],
  [3620809254,3621016397,'Leo'],
  [3621016397,3621213537,'Virgo'],
  [3621213537,3621403678,'Libra'],
  [3621403678,3621589999,'Scorpio'],
  [3621589999,3621774222,'Sagittarius'],
  [3621774222,3621957253,'Capricorn'],
  [3621957253,3622141003,'Aquarius'],
  [3622141003,3622329311,'Pisces'],
  [3622329311,3622526892,'Aries'],
  [3622526892,3622736358,'Taurus'],
  [3622736358,3622954552,'Gemini'],
  [3622954552,3623172359,'Cancer'],
  [3623172359,3623380690,'Leo'],
  [3623380690,3623576535,'Virgo'],
  [3623576535,3623762797,'Libra'],
  [3623762797,3623944609,'Scorpio'],
  [3623944609,3624126334,'Sagittarius'],
  [3624126334,3624310370,'Capricorn'],
  [3624310370,3624497844,'Aquarius'],
  [3624497844,3624690185,'Pisces'],
  [3624690185,3624889776,'Aries'],
  [3624889776,3625098753,'Taurus'],
  [3625098753,3625316052,'Gemini'],
  [3625316052,3625535201,'Cancer'],
  [3625535201,3625746874,'Leo'],
  [3625746874,3625945131,'Virgo'],
  [3625945131,3626130555,'Libra'],
  [3626130555,3626308160,'Scorpio'],
  [3626308160,3626484134,'Sagittarius'],
  [3626484134,3626663712,'Capricorn'],
  [3626663712,3626850127,'Aquarius'],
  [3626850127,3627044658,'Pisces'],
  [3627044658,3627247427,'Aries'],
  [3627247427,3627458064,'Taurus'],
  [3627458064,3627675214,'Gemini'],
  [3627675214,3627894830,'Cancer'],
  [3627894830,3628109853,'Leo'],
  [3628109853,3628313280,'Virgo'],
  [3628313280,3628502480,'Libra'],
  [3628502480,3628680133,'Scorpio'],
  [3628680133,3628852142,'Sagittarius'],
  [3628852142,3629025339,'Capricorn'],
  [3629025339,3629205828,'Aquarius'],
  [3629205828,3629397510,'Pisces'],
  [3629397510,3629600951,'Aries'],
  [3629600951,3629813609,'Taurus'],
  [3629813609,3630031602,'Gemini'],
  [3630031602,3630250919,'Cancer'],
  [3630250919,3630467118,'Leo'],
  [3630467118,3630675049,'Virgo'],
  [3630675049,3630870609,'Libra'],
  [3630870609,3631053218,'Scorpio'],
  [3631053218,3631226376,'Sagittarius'],
  [3631226376,3631396411,'Capricorn'],
  [3631396411,3631570706,'Aquarius'],
  [3631570706,3631755902,'Pisces'],
  [3631755902,3631955512,'Aries'],
  [3631955512,3632167780,'Taurus'],
  [3632167780,3632386645,'Gemini'],
  [3632386645,3632605724,'Cancer'],
  [3632605724,3632820964,'Leo'],
  [3632820964,3633029867,'Virgo'],
  [3633029867,3633229919,'Libra'],
  [3633229919,3633419157,'Scorpio'],
  [3633419157,3633597974,'Sagittarius'],
  [3633597974,3633770231,'Capricorn'],
  [3633770231,3633942530,'Aquarius'],
  [3633942530,3634122427,'Pisces'],
  [3634122427,3634316022,'Aries'],
  [3634316022,3634524613,'Taurus'],
  [3634524613,3634742829,'Gemini'],
  [3634742829,3634961984,'Cancer'],
  [3634961984,3635175931,'Leo'],
  [3635175931,3635382867,'Virgo'],
  [3635382867,3635582850,'Libra'],
  [3635582850,3635775520,'Scorpio'],
  [3635775520,3635960306,'Sagittarius'],
  [3635960306,3636138307,'Capricorn'],
  [3636138307,3636313628,'Aquarius'],
  [3636313628,3636492714,'Pisces'],
  [3636492714,3636682298,'Aries'],
  [3636682298,3636886228,'Taurus'],
  [3636886228,3637102010,'Gemini'],
  [3637102010,3637321093,'Cancer'],
  [3637321093,3637534825,'Leo'],
  [3637534825,3637739662,'Virgo'],
  [3637739662,3637936567,'Libra'],
  [3637936567,3638127667,'Scorpio'],
  [3638127667,3638314196,'Sagittarius'],
  [3638314196,3638496837,'Capricorn'],
  [3638496837,3638677403,'Aquarius'],
  [3638677403,3638859842,'Pisces'],
  [3638859842,3639049500,'Aries'],
  [3639049500,3639250801,'Taurus'],
  [3639250801,3639463857,'Gemini'],
  [3639463857,3639682469,'Cancer'],
  [3639682469,3639897250,'Leo'],
  [3639897250,3640102006,'Virgo'],
  [3640102006,3640296332,'Libra'],
  [3640296332,3640483364,'Scorpio'],
  [3640483364,3640666780,'Sagittarius'],
  [3640666780,3640849305,'Capricorn'],
  [3640849305,3641032885,'Aquarius'],
  [3641032885,3641219651,'Pisces'],
  [3641219651,3641412472,'Aries'],
  [3641412472,3641614290,'Taurus'],
  [3641614290,3641826008,'Gemini'],
  [3641826008,3642044047,'Cancer'],
  [3642044047,3642260525,'Leo'],
  [3642260525,3642467610,'Virgo'],
  [3642467610,3642662252,'Libra'],
  [3642662252,3642846529,'Scorpio'],
  [3642846529,3643025167,'Sagittarius'],
  [3643025167,3643203273,'Capricorn'],
  [3643203273,3643385034,'Aquarius'],
  [3643385034,3643573211,'Pisces'],
  [3643573211,3643769227,'Aries'],
  [3643769227,3643973572,'Taurus'],
  [3643973572,3644185838,'Gemini'],
  [3644185838,3644403635,'Cancer'],
  [3644403635,3644621554,'Leo'],
  [3644621554,3644832268,'Virgo'],
  [3644832268,3645030412,'Libra'],
  [3645030412,3645215533,'Scorpio'],
  [3645215533,3645391517,'Sagittarius'],
  [3645391517,3645564494,'Capricorn'],
  [3645564494,3645740907,'Aquarius'],
  [3645740907,3645925921,'Pisces'],
  [3645925921,3646121996,'Aries'],
  [3646121996,3646328362,'Taurus'],
  [3646328362,3646542223,'Gemini'],
  [3646542223,3646760289,'Cancer'],
  [3646760289,3646978750,'Leo'],
  [3646978750,3647192440,'Virgo'],
  [3647192440,3647395632,'Libra'],
  [3647395632,3647585212,'Scorpio'],
  [3647585212,3647762655,'Sagittarius'],
  [3647762655,3647933362,'Capricorn'],
  [3647933362,3648104666,'Aquarius'],
  [3648104666,3648283843,'Pisces'],
  [3648283843,3648475925,'Aries'],
  [3648475925,3648681417,'Taurus'],
  [3648681417,3648896245,'Gemini'],
  [3648896245,3649114857,'Cancer'],
  [3649114857,3649333030,'Leo'],
  [3649333030,3649547535,'Virgo'],
  [3649547535,3649754471,'Libra'],
  [3649754471,3649949890,'Scorpio'],
  [3649949890,3650132513,'Sagittarius'],
  [3650132513,3650305402,'Capricorn'],
  [3650305402,3650475094,'Aquarius'],
  [3650475094,3650649518,'Pisces'],
  [3650649518,3650835756,'Aries'],
  [3650835756,3651037083,'Taurus'],
  [3651037083,3651250693,'Gemini'],
  [3651250693,3651469520,'Cancer'],
  [3651469520,3651687193,'Leo'],
  [3651687193,3651900533,'Virgo'],
  [3651900533,3652107837,'Libra'],
  [3652107837,3652306854,'Scorpio'],
  [3652306854,3652495439,'Sagittarius'],
  [3652495439,3652673984,'Capricorn'],
  [3652673984,3652846651,'Aquarius'],
  [3652846651,3653020300,'Pisces'],
  [3653020300,3653202426,'Aries'],
  [3653202426,3653398470,'Taurus'],
  [3653398470,3653608552,'Gemini'],
  [3653608552,3653826552,'Cancer'],
  [3653826552,3654044112,'Leo'],
  [3654044112,3654255991,'Virgo'],
  [3654255991,3654460937,'Libra'],
  [3654460937,3654659115,'Scorpio'],
  [3654659115,3654850242,'Sagittarius'],
  [3654850242,3655034163,'Capricorn'],
  [3655034163,3655212612,'Aquarius'],
  [3655212612,3655389918,'Pisces'],
  [3655389918,3655572108,'Aries'],
  [3655572108,3655764928,'Taurus'],
  [3655764928,3655970939,'Gemini'],
  [3655970939,3656186932,'Cancer'],
  [3656186932,3656404787,'Leo'],
  [3656404787,3656616694,'Virgo'],
  [3656616694,3656819452,'Libra'],
  [3656819452,3657013941,'Scorpio'],
  [3657013941,3657202476,'Sagittarius'],
  [3657202476,3657387115,'Capricorn'],
  [3657387115,3657569627,'Aquarius'],
  [3657569627,3657752299,'Pisces'],
  [3657752299,3657938438,'Aries'],
  [3657938438,3658131961,'Taurus'],
  [3658131961,3658335822,'Gemini'],
  [3658335822,3658549549,'Cancer'],
  [3658549549,3658767604,'Leo'],
  [3658767604,3658981446,'Virgo'],
  [3658981446,3659184832,'Libra'],
  [3659184832,3659376826,'Scorpio'],
  [3659376826,3659560573,'Sagittarius'],
  [3659560573,3659740762,'Capricorn'],
  [3659740762,3659921734,'Aquarius'],
  [3659921734,3660106560,'Pisces'],
  [3660106560,3660297009,'Aries'],
  [3660297009,3660494176,'Taurus'],
  [3660494176,3660699017,'Gemini'],
  [3660699017,3660911677,'Cancer'],
  [3660911677,3661129510,'Leo'],
  [3661129510,3661345922,'Virgo'],
  [3661345922,3661553013,'Libra'],
  [3661553013,3661746576,'Scorpio'],
  [3661746576,3661928083,'Sagittarius'],
  [3661928083,3662102999,'Capricorn'],
  [3662102999,3662278085,'Aquarius'],
  [3662278085,3662459218,'Pisces'],
  [3662459218,3662649706,'Aries'],
  [3662649706,3662849660,'Taurus'],
  [3662849660,3663057277,'Gemini'],
  [3663057277,3663270752,'Cancer'],
  [3663270752,3663488308,'Leo'],
  [3663488308,3663706199,'Virgo'],
  [3663706199,3663917736,'Libra'],
  [3663917736,3664116474,'Scorpio'],
  [3664116474,3664300629,'Sagittarius'],
  [3664300629,3664474114,'Capricorn'],
  [3664474114,3664644207,'Aquarius'],
  [3664644207,3664818800,'Pisces'],
  [3664818800,3665004100,'Aries'],
  [3665004100,3665202347,'Taurus'],
  [3665202347,3665411217,'Gemini'],
  [3665411217,3665626310,'Cancer'],
  [3665626310,3665844091,'Leo'],
  [3665844091,3666061924,'Virgo'],
  [3666061924,3666275772,'Libra'],
  [3666275772,3666479875,'Scorpio'],
  [3666479875,3666670079,'Sagittarius'],
  [3666670079,3666847226,'Capricorn'],
  [3666847226,3667017029,'Aquarius'],
  [3667017029,3667187482,'Pisces'],
  [3667187482,3667366401,'Aries'],
  [3667366401,3667558958,'Taurus'],
  [3667558958,3667765257,'Gemini'],
  [3667765257,3667980560,'Cancer'],
  [3667980560,3668198843,'Leo'],
  [3668198843,3668416005,'Virgo'],
  [3668416005,3668629348,'Libra'],
  [3668629348,3668835572,'Scorpio'],
  [3668835572,3669031042,'Sagittarius'],
  [3669031042,3669214436,'Capricorn'],
  [3669214436,3669388640,'Aquarius'],
  [3669388640,3669559905,'Pisces'],
  [3669559905,3669735738,'Aries'],
  [3669735738,3669922705,'Taurus'],
  [3669922705,3670123861,'Gemini'],
  [3670123861,3670336837,'Cancer'],
  [3670336837,3670555013,'Leo'],
  [3670555013,3670771804,'Virgo'],
  [3670771804,3670983440,'Libra'],
  [3670983440,3671188187,'Scorpio'],
  [3671188187,3671384808,'Sagittarius'],
  [3671384808,3671572584,'Capricorn'],
  [3671572584,3671752633,'Aquarius'],
  [3671752633,3671928591,'Pisces'],
  [3671928591,3672105998,'Aries'],
  [3672105998,3672290859,'Taurus'],
  [3672290859,3672487653,'Gemini'],
  [3672487653,3672696936,'Cancer'],
  [3672696936,3672913977,'Leo'],
  [3672913977,3673130947,'Virgo'],
  [3673130947,3673341625,'Libra'],
  [3673341625,3673543656,'Scorpio'],
  [3673543656,3673737602,'Sagittarius'],
  [3673737602,3673925136,'Capricorn'],
  [3673925136,3674108204,'Aquarius'],
  [3674108204,3674289146,'Pisces'],
  [3674289146,3674471055,'Aries'],
  [3674471055,3674657811,'Taurus'],
  [3674657811,3674853325,'Gemini'],
  [3674853325,3675059766,'Cancer'],
  [3675059766,3675275177,'Leo'],
  [3675275177,3675492728,'Virgo'],
  [3675492728,3675704207,'Libra'],
  [3675704207,3675904966,'Scorpio'],
  [3675904966,3676095396,'Sagittarius'],
  [3676095396,3676279087,'Capricorn'],
  [3676279087,3676460369,'Aquarius'],
  [3676460369,3676642745,'Pisces'],
  [3676642745,3676828476,'Aries'],
  [3676828476,3677019140,'Taurus'],
  [3677019140,3677216494,'Gemini'],
  [3677216494,3677422330,'Cancer'],
  [3677422330,3677636565,'Leo'],
  [3677636565,3677854776,'Virgo'],
  [3677854776,3678068646,'Libra'],
  [3678068646,3678270967,'Scorpio'],
  [3678270967,3678460118,'Sagittarius'],
  [3678460118,3678639832,'Capricorn'],
  [3678639832,3678816283,'Aquarius'],
  [3678816283,3678995374,'Pisces'],
  [3678995374,3679180932,'Aries'],
  [3679180932,3679374113,'Taurus'],
  [3679374113,3679574505,'Gemini'],
  [3679574505,3679781833,'Cancer'],
  [3679781833,3679995962,'Leo'],
  [3679995962,3680214592,'Virgo'],
  [3680214592,3680431239,'Libra'],
  [3680431239,3680637578,'Scorpio'],
  [3680637578,3680829143,'Sagittarius'],
  [3680829143,3681007928,'Capricorn'],
  [3681007928,3681180310,'Aquarius'],
  [3681180310,3681353844,'Pisces'],
  [3681353844,3681534829,'Aries'],
  [3681534829,3681726402,'Taurus'],
  [3681726402,3681928048,'Gemini'],
  [3681928048,3682137413,'Cancer'],
  [3682137413,3682352431,'Leo'],
  [3682352431,3682571166,'Virgo'],
  [3682571166,3682789434,'Libra'],
  [3682789434,3683000143,'Scorpio'],
  [3683000143,3683197034,'Sagittarius'],
  [3683197034,3683379188,'Capricorn'],
  [3683379188,3683551344,'Aquarius'],
  [3683551344,3683721071,'Pisces'],
  [3683721071,3683896108,'Aries'],
  [3683896108,3684082217,'Taurus'],
  [3684082217,3684281225,'Gemini'],
  [3684281225,3684490860,'Cancer'],
  [3684490860,3684706918,'Leo'],
  [3684706918,3684925679,'Virgo'],
  [3684925679,3685143782,'Libra'],
  [3685143782,3685356567,'Scorpio'],
  [3685356567,3685558632,'Sagittarius'],
  [3685558632,3685747010,'Capricorn'],
  [3685747010,3685923539,'Aquarius'],
  [3685923539,3686093993,'Pisces'],
  [3686093993,3686265793,'Aries'],
  [3686265793,3686446006,'Taurus'],
  [3686446006,3686639289,'Gemini'],
  [3686639289,3686845957,'Cancer'],
  [3686845957,3687061815,'Leo'],
  [3687061815,3687280732,'Virgo'],
  [3687280732,3687497760,'Libra'],
  [3687497760,3687709493,'Scorpio'],
  [3687709493,3687913130,'Sagittarius'],
  [3687913130,3688106528,'Capricorn'],
  [3688106528,3688289618,'Aquarius'],
  [3688289618,3688465281,'Pisces'],
  [3688465281,3688638802,'Aries'],
  [3688638802,3688816591,'Taurus'],
  [3688816591,3689004596,'Gemini'],
  [3689004596,3689206147,'Cancer'],
  [3689206147,3689419662,'Leo'],
  [3689419662,3689638546,'Virgo'],
  [3689638546,3689855093,'Libra'],
  [3689855093,3690064569,'Scorpio'],
  [3690064569,3690265777,'Sagittarius'],
  [3690265777,3690459331,'Capricorn'],
  [3690459331,3690646279,'Aquarius'],
  [3690646279,3690828066,'Pisces'],
  [3690828066,3691007146,'Aries'],
  [3691007146,3691187440,'Taurus'],
  [3691187440,3691373989,'Gemini'],
  [3691373989,3691571464,'Cancer'],
  [3691571464,3691781405,'Leo'],
  [3691781405,3691999497,'Virgo'],
  [3691999497,3692216787,'Libra'],
  [3692216787,3692425562,'Scorpio'],
  [3692425562,3692623583,'Sagittarius'],
  [3692623583,3692813220,'Capricorn'],
  [3692813220,3692998323,'Aquarius'],
  [3692998323,3693181972,'Pisces'],
  [3693181972,3693365885,'Aries'],
  [3693365885,3693551383,'Taurus'],
  [3693551383,3693740815,'Gemini'],
  [3693740815,3693937778,'Cancer'],
  [3693937778,3694145215,'Leo'],
  [3694145215,3694361922,'Virgo'],
  [3694361922,3694580516,'Libra'],
  [3694580516,3694791235,'Scorpio'],
  [3694791235,3694988857,'Sagittarius'],
  [3694988857,3695174945,'Capricorn'],
  [3695174945,3695354970,'Aquarius'],
  [3695354970,3695534738,'Pisces'],
  [3695534738,3695718148,'Aries'],
  [3695718148,3695906579,'Taurus'],
  [3695906579,3696100207,'Gemini'],
  [3696100207,3696299911,'Cancer'],
  [3696299911,3696507478,'Leo'],
  [3696507478,3696723229,'Virgo'],
  [3696723229,3696942690,'Libra'],
  [3696942690,3697156780,'Scorpio'],
  [3697156780,3697357668,'Sagittarius'],
  [3697357668,3697544112,'Capricorn'],
  [3697544112,3697720860,'Aquarius'],
  [3697720860,3697894997,'Pisces'],
  [3697894997,3698072983,'Aries'],
  [3698072983,3698258797,'Taurus'],
  [3698258797,3698453386,'Gemini'],
  [3698453386,3698655932,'Cancer'],
  [3698655932,3698865585,'Leo'],
  [3698865585,3699081604,'Virgo'],
  [3699081604,3699301220,'Libra'],
  [3699301220,3699517897,'Scorpio'],
  [3699517897,3699723694,'Sagittarius'],
  [3699723694,3699914553,'Capricorn'],
  [3699914553,3700092629,'Aquarius'],
  [3700092629,3700264193,'Pisces'],
  [3700264193,3700436608,'Aries'],
  [3700436608,3700616230,'Taurus'],
  [3700616230,3700806839,'Gemini'],
  [3700806839,3701008864,'Cancer'],
  [3701008864,3701220054,'Leo'],
  [3701220054,3701437155,'Virgo'],
  [3701437155,3701656655,'Libra'],
  [3701656655,3701873922,'Scorpio'],
  [3701873922,3702083161,'Sagittarius'],
  [3702083161,3702279711,'Capricorn'],
  [3702279711,3702462979,'Aquarius'],
  [3702462979,3702636772,'Pisces'],
  [3702636772,3702807455,'Aries'],
  [3702807455,3702982015,'Taurus'],
  [3702982015,3703166466,'Gemini'],
  [3703166466,3703364131,'Cancer'],
  [3703364131,3703574143,'Leo'],
  [3703574143,3703791800,'Virgo'],
  [3703791800,3704011262,'Libra'],
  [3704011262,3704227630,'Scorpio'],
  [3704227630,3704437213,'Sagittarius'],
  [3704437213,3704637176,'Capricorn'],
  [3704637176,3704826184,'Aquarius'],
  [3704826184,3705005494,'Pisces'],
  [3705005494,3705179041,'Aries'],
  [3705179041,3705352656,'Taurus'],
  [3705352656,3705532840,'Gemini'],
  [3705532840,3705725073,'Cancer'],
  [3705725073,3705931325,'Leo'],
  [3705931325,3706147985,'Virgo'],
  [3706147985,3706367435,'Libra'],
  [3706367435,3706582716,'Scorpio'],
  [3706582716,3706790399,'Sagittarius'],
  [3706790399,3706989907,'Capricorn'],
  [3706989907,3707181574,'Aquarius'],
  [3707181574,3707366070,'Pisces'],
  [3707366070,3707545020,'Aries'],
  [3707545020,3707721832,'Taurus'],
  [3707721832,3707901748,'Gemini'],
  [3707901748,3708090682,'Cancer'],
  [3708090682,3708292787,'Leo'],
  [3708292787,3708507100,'Virgo'],
  [3708507100,3708726373,'Libra'],
  [3708726373,3708941450,'Scorpio'],
  [3708941450,3709147196,'Sagittarius'],
  [3709147196,3709343755,'Capricorn'],
  [3709343755,3709533769,'Aquarius'],
  [3709533769,3709719644,'Pisces'],
  [3709719644,3709902764,'Aries'],
  [3709902764,3710084498,'Taurus'],
  [3710084498,3710267682,'Gemini'],
  [3710267682,3710456883,'Cancer'],
  [3710456883,3710656744,'Leo'],
  [3710656744,3710868630,'Virgo'],
  [3710868630,3711087510,'Libra'],
  [3711087510,3711303622,'Scorpio'],
  [3711303622,3711509306,'Sagittarius'],
  [3711509306,3711703379,'Capricorn'],
  [3711703379,3711889458,'Aquarius'],
  [3711889458,3712072256,'Pisces'],
  [3712072256,3712255146,'Aries'],
  [3712255146,3712439706,'Taurus'],
  [3712439706,3712627041,'Gemini'],
  [3712627041,3712819324,'Cancer'],
  [3712819324,3713019776,'Leo'],
  [3713019776,3713230483,'Virgo'],
  [3713230483,3713448912,'Libra'],
  [3713448912,3713666815,'Scorpio'],
  [3713666815,3713874941,'Sagittarius'],
  [3713874941,3714069426,'Capricorn'],
  [3714069426,3714252830,'Aquarius'],
  [3714252830,3714430865,'Pisces'],
  [3714430865,3714609227,'Aries'],
  [3714609227,3714791821,'Taurus'],
  [3714791821,3714980465,'Gemini'],
  [3714980465,3715175915,'Cancer'],
  [3715175915,3715378959,'Leo'],
  [3715378959,3715590282,'Virgo'],
  [3715590282,3715808478,'Libra'],
  [3715808478,3716027860,'Scorpio'],
  [3716027860,3716239859,'Sagittarius'],
  [3716239859,3716438244,'Capricorn'],
  [3716438244,3716622855,'Aquarius'],
  [3716622855,3716798409,'Pisces'],
  [3716798409,3716971478,'Aries'],
  [3716971478,3717148297,'Taurus'],
  [3717148297,3717333358,'Gemini'],
  [3717333358,3717528643,'Cancer'],
  [3717528643,3717733762,'Leo'],
  [3717733762,3717946860,'Virgo'],
  [3717946860,3718165320,'Libra'],
  [3718165320,3718385056,'Scorpio'],
  [3718385056,3718599996,'Sagittarius'],
  [3718599996,3718803869,'Capricorn'],
  [3718803869,3718993729,'Aquarius'],
  [3718993729,3719171516,'Pisces'],
  [3719171516,3719342685,'Aries'],
  [3719342685,3719514161,'Taurus'],
  [3719514161,3719692702,'Gemini'],
  [3719692702,3719883241,'Cancer'],
  [3719883241,3720087065,'Leo'],
  [3720087065,3720301201,'Virgo'],
  [3720301201,3720520374,'Libra'],
  [3720520374,3720739615,'Scorpio'],
  [3720739615,3720954859,'Sagittarius'],
  [3720954859,3721162224,'Capricorn'],
  [3721162224,3721358380,'Aquarius'],
  [3721358380,3721542410,'Pisces'],
  [3721542410,3721716886,'Aries'],
  [3721716886,3721887403,'Taurus'],
  [3721887403,3722061149,'Gemini'],
  [3722061149,3722245178,'Cancer'],
  [3722245178,3722443925,'Leo'],
  [3722443925,3722656330,'Virgo'],
  [3722656330,3722875809,'Libra'],
  [3722875809,3723094682,'Scorpio'],
  [3723094682,3723308350,'Sagittarius'],
  [3723308350,3723515197,'Capricorn'],
  [3723515197,3723714235,'Aquarius'],
  [3723714235,3723904325,'Pisces'],
  [3723904325,3724085407,'Aries'],
  [3724085407,3724260126,'Taurus'],
  [3724260126,3724434059,'Gemini'],
  [3724434059,3724614358,'Cancer'],
  [3724614358,3724807438,'Leo'],
  [3724807438,3725015508,'Virgo'],
  [3725015508,3725233748,'Libra'],
  [3725233748,3725452749,'Scorpio'],
  [3725452749,3725665233,'Sagittarius'],
  [3725665233,3725869349,'Capricorn'],
  [3725869349,3726066430,'Aquarius'],
  [3726066430,3726257777,'Pisces'],
  [3726257777,3726443639,'Aries'],
  [3726443639,3726624530,'Taurus'],
  [3726624530,3726803134,'Gemini'],
  [3726803134,3726984657,'Cancer'],
  [3726984657,3727175291,'Leo'],
  [3727175291,3727379220,'Virgo'],
  [3727379220,3727594862,'Libra'],
  [3727594862,3727813971,'Scorpio'],
  [3727813971,3728027012,'Sagittarius'],
  [3728027012,3728229594,'Capricorn'],
  [3728229594,3728423006,'Aquarius'],
  [3728423006,3728610774,'Pisces'],
  [3728610774,3728795762,'Aries'],
  [3728795762,3728979440,'Taurus'],
  [3728979440,3729163046,'Gemini'],
  [3729163046,3729349091,'Cancer'],
  [3729349091,3729541538,'Leo'],
  [3729541538,3729744189,'Virgo'],
  [3729744189,3729957574,'Libra'],
  [3729957574,3730176382,'Scorpio'],
  [3730176382,3730391321,'Sagittarius'],
  [3730391321,3730595301,'Capricorn'],
  [3730595301,3730787302,'Aquarius'],
  [3730787302,3730970875,'Pisces'],
  [3730970875,3731150949,'Aries'],
  [3731150949,3731331715,'Taurus'],
  [3731331715,3731515944,'Gemini'],
  [3731515944,3731705403,'Cancer'],
  [3731705403,3731901620,'Leo'],
  [3731901620,3732106059,'Virgo'],
  [3732106059,3732318987,'Libra'],
  [3732318987,3732537372,'Scorpio'],
  [3732537372,3732754268,'Sagittarius'],
  [3732754268,3732961856,'Capricorn'],
  [3732961856,3733156213,'Aquarius'],
  [3733156213,3733338815,'Pisces'],
  [3733338815,3733514623,'Aries'],
  [3733514623,3733689696,'Taurus'],
  [3733689696,3733869500,'Gemini'],
  [3733869500,3734057757,'Cancer'],
  [3734057757,3734255808,'Leo'],
  [3734255808,3734462882,'Virgo'],
  [3734462882,3734677039,'Libra'],
  [3734677039,3734895363,'Scorpio'],
  [3734895363,3735113263,'Sagittarius'],
  [3735113263,3735324527,'Capricorn'],
  [3735324527,3735523767,'Aquarius'],
  [3735523767,3735709560,'Pisces'],
  [3735709560,3735884990,'Aries'],
  [3735884990,3736056125,'Taurus'],
  [3736056125,3736230046,'Gemini'],
  [3736230046,3736413059,'Cancer'],
  [3736413059,3736608738,'Leo'],
  [3736608738,3736816404,'Virgo'],
  [3736816404,3737031974,'Libra'],
  [3737031974,3737250666,'Scorpio'],
  [3737250666,3737468477,'Sagittarius'],
  [3737468477,3737681520,'Capricorn'],
  [3737681520,3737885356,'Aquarius'],
  [3737885356,3738076757,'Pisces'],
  [3738076757,3738256006,'Aries'],
  [3738256006,3738427435,'Taurus'],
  [3738427435,3738598030,'Gemini'],
  [3738598030,3738775446,'Cancer'],
  [3738775446,3738965770,'Leo'],
  [3738965770,3739170677,'Virgo'],
  [3739170677,3739386117,'Libra'],
  [3739386117,3739605163,'Scorpio'],
  [3739605163,3739822362,'Sagittarius'],
  [3739822362,3740034858,'Capricorn'],
  [3740034858,3740240463,'Aquarius'],
  [3740240463,3740436572,'Pisces'],
  [3740436572,3740621642,'Aries'],
  [3740621642,3740797339,'Taurus'],
  [3740797339,3740968930,'Gemini'],
  [3740968930,3741143771,'Cancer'],
  [3741143771,3741329133,'Leo'],
  [3741329133,3741529261,'Virgo'],
  [3741529261,3741742371,'Libra'],
  [3741742371,3741961161,'Scorpio'],
  [3741961161,3742177931,'Sagittarius'],
  [3742177931,3742388785,'Capricorn'],
  [3742388785,3742592945,'Aquarius'],
  [3742592945,3742790062,'Pisces'],
  [3742790062,3742979250,'Aries'],
  [3742979250,3743160543,'Taurus'],
  [3743160543,3743336677,'Gemini'],
  [3743336677,3743513147,'Cancer'],
  [3743513147,3743696694,'Leo'],
  [3743696694,3743892798,'Virgo'],
  [3743892798,3744102388,'Libra'],
  [3744102388,3744320045,'Scorpio'],
  [3744320045,3744536973,'Sagittarius'],
  [3744536973,3744746896,'Capricorn'],
  [3744746896,3744948393,'Aquarius'],
  [3744948393,3745142808,'Pisces'],
  [3745142808,3745331651,'Aries'],
  [3745331651,3745515888,'Taurus'],
  [3745515888,3745696986,'Gemini'],
  [3745696986,3745878019,'Cancer'],
  [3745878019,3746063618,'Leo'],
  [3746063618,3746258599,'Virgo'],
  [3746258599,3746465408,'Libra'],
  [3746465408,3746681431,'Scorpio'],
  [3746681431,3746899016,'Sagittarius'],
  [3746899016,3747109927,'Capricorn'],
  [3747109927,3747310304,'Aquarius'],
  [3747310304,3747501162,'Pisces'],
  [3747501162,3747685889,'Aries'],
  [3747685889,3747868037,'Taurus'],
  [3747868037,3748050441,'Gemini'],
  [3748050441,3748235399,'Cancer'],
  [3748235399,3748425204,'Leo'],
  [3748425204,3748622317,'Virgo'],
  [3748622317,3748828585,'Libra'],
  [3748828585,3749043313,'Scorpio'],
  [3749043313,3749261544,'Sagittarius'],
  [3749261544,3749475188,'Capricorn'],
  [3749475188,3749677673,'Aquarius'],
  [3749677673,3749867603,'Pisces'],
  [3749867603,3750048216,'Aries'],
  [3750048216,3750224970,'Taurus'],
  [3750224970,3750403420,'Gemini'],
  [3750403420,3750587770,'Cancer'],
  [3750587770,3750780105,'Leo'],
  [3750780105,3750980629,'Virgo'],
  [3750980629,3751188700,'Libra'],
  [3751188700,3751403274,'Scorpio'],
  [3751403274,3751621677,'Sagittarius'],
  [3751621677,3751838168,'Capricorn'],
  [3751838168,3752045352,'Aquarius'],
  [3752045352,3752238655,'Pisces'],
  [3752238655,3752418968,'Aries'],
  [3752418968,3752591628,'Taurus'],
  [3752591628,3752763889,'Gemini'],
  [3752763889,3752942681,'Cancer'],
  [3752942681,3753132551,'Leo'],
  [3753132551,3753334062,'Virgo'],
  [3753334062,3753544414,'Libra'],
  [3753544414,3753760089,'Scorpio'],
  [3753760089,3753978365,'Sagittarius'],
  [3753978365,3754196018,'Capricorn'],
  [3754196018,3754407569,'Aquarius'],
  [3754407569,3754607014,'Pisces'],
  [3754607014,3754791916,'Aries'],
  [3754791916,3754965320,'Taurus'],
  [3754965320,3755134179,'Gemini'],
  [3755134179,3755306709,'Cancer'],
  [3755306709,3755490096,'Leo'],
  [3755490096,3755687823,'Virgo'],
  [3755687823,3755897889,'Libra'],
  [3755897889,3756114688,'Scorpio'],
  [3756114688,3756333101,'Sagittarius'],
  [3756333101,3756550144,'Capricorn'],
  [3756550144,3756762940,'Aquarius'],
  [3756762940,3756967134,'Pisces'],
  [3756967134,3757158787,'Aries'],
  [3757158787,3757337733,'Taurus'],
  [3757337733,3757508593,'Gemini'],
  [3757508593,3757678887,'Cancer'],
  [3757678887,3757856637,'Leo'],
  [3757856637,3758047907,'Virgo'],
  [3758047907,3758253879,'Libra'],
  [3758253879,3758469862,'Scorpio'],
  [3758469862,3758688553,'Sagittarius'],
  [3758688553,3758904689,'Capricorn'],
  [3758904689,3759115896,'Aquarius'],
  [3759115896,3759320433,'Pisces'],
  [3759320433,3759516043,'Aries'],
  [3759516043,3759701405,'Taurus'],
  [3759701405,3759878252,'Gemini'],
  [3759878252,3760051623,'Cancer'],
  [3760051623,3760228370,'Leo'],
  [3760228370,3760415108,'Virgo'],
  [3760415108,3760615636,'Libra'],
  [3760615636,3760828420,'Scorpio'],
  [3760828420,3761046697,'Sagittarius'],
  [3761046697,3761262741,'Capricorn'],
  [3761262741,3761472128,'Aquarius'],
  [3761472128,3761673852,'Pisces'],
  [3761673852,3761868287,'Aries'],
  [3761868287,3762055981,'Taurus'],
  [3762055981,3762238084,'Gemini'],
  [3762238084,3762417199,'Cancer'],
  [3762417199,3762597555,'Leo'],
  [3762597555,3762784244,'Virgo'],
  [3762784244,3762981579,'Libra'],
  [3762981579,3763190715,'Scorpio'],
  [3763190715,3763407645,'Sagittarius'],
  [3763407645,3763624360,'Capricorn'],
  [3763624360,3763833715,'Aquarius'],
  [3763833715,3764032993,'Pisces'],
  [3764032993,3764223511,'Aries'],
  [3764223511,3764408406,'Taurus'],
  [3764408406,3764590885,'Gemini'],
  [3764590885,3764773595,'Cancer'],
  [3764773595,3764958817,'Leo'],
  [3764958817,3765148995,'Virgo'],
  [3765148995,3765346823,'Libra'],
  [3765346823,3765554128,'Scorpio'],
  [3765554128,3765769592,'Sagittarius'],
  [3765769592,3765987195,'Capricorn'],
  [3765987195,3766198551,'Aquarius'],
  [3766198551,3766398142,'Pisces'],
  [3766398142,3766585968,'Aries'],
  [3766585968,3766766220,'Taurus'],
  [3766766220,3766944524,'Gemini'],
  [3766944524,3767125750,'Cancer'],
  [3767125750,3767312799,'Leo'],
  [3767312799,3767506594,'Virgo'],
  [3767506594,3767707286,'Libra'],
  [3767707286,3767915229,'Scorpio'],
  [3767915229,3768130061,'Sagittarius'],
  [3768130061,3768348313,'Capricorn'],
  [3768348313,3768562615,'Aquarius'],
  [3768562615,3768765435,'Pisces'],
  [3768765435,3768954093,'Aries'],
  [3768954093,3769131804,'Taurus'],
  [3769131804,3769305170,'Gemini'],
  [3769305170,3769481243,'Cancer'],
  [3769481243,3769665314,'Leo'],
  [3769665314,3769859381,'Virgo'],
  [3769859381,3770062379,'Libra'],
  [3770062379,3770272284,'Scorpio'],
  [3770272284,3770487567,'Sagittarius'],
  [3770487567,3770706055,'Capricorn'],
  [3770706055,3770922657,'Aquarius'],
  [3770922657,3771129963,'Pisces'],
  [3771129963,3771322844,'Aries'],
  [3771322844,3771502046,'Taurus'],
  [3771502046,3771673344,'Gemini'],
  [3771673344,3771844536,'Cancer'],
  [3771844536,3772022909,'Leo'],
  [3772022909,3772213027,'Virgo'],
  [3772213027,3772415182,'Libra'],
  [3772415182,3772626272,'Scorpio'],
  [3772626272,3772842514,'Sagittarius'],
  [3772842514,3773060964,'Capricorn'],
  [3773060964,3773278162,'Aquarius'],
  [3773278162,3773488689,'Pisces'],
  [3773488689,3773686969,'Aries'],
  [3773686969,3773871161,'Taurus'],
  [3773871161,3774044707,'Gemini'],
  [3774044707,3774214492,'Cancer'],
  [3774214492,3774388289,'Leo'],
  [3774388289,3774572618,'Virgo'],
  [3774572618,3774770504,'Libra'],
  [3774770504,3774980269,'Scorpio'],
  [3774980269,3775196918,'Sagittarius'],
  [3775196918,3775415305,'Capricorn'],
  [3775415305,3775631647,'Aquarius'],
  [3775631647,3775842477,'Pisces'],
  [3775842477,3776044071,'Aries'],
  [3776044071,3776233946,'Taurus'],
  [3776233946,3776413016,'Gemini'],
  [3776413016,3776585804,'Cancer'],
  [3776585804,3776758904,'Leo'],
  [3776758904,3776939164,'Virgo'],
  [3776939164,3777131688,'Libra'],
  [3777131688,3777337649,'Scorpio'],
  [3777337649,3777553247,'Sagittarius'],
  [3777553247,3777771650,'Capricorn'],
  [3777771650,3777986925,'Aquarius'],
  [3777986925,3778195755,'Pisces'],
  [3778195755,3778396698,'Aries'],
  [3778396698,3778589158,'Taurus'],
  [3778589158,3778773560,'Gemini'],
  [3778773560,3778952073,'Cancer'],
  [3778952073,3779128763,'Leo'],
  [3779128763,3779308996,'Virgo'],
  [3779308996,3779498194,'Libra'],
  [3779498194,3779699830,'Scorpio'],
  [3779699830,3779912949,'Sagittarius'],
  [3779912949,3780131277,'Capricorn'],
  [3780131277,3780346556,'Aquarius'],
  [3780346556,3780553448,'Pisces'],
  [3780553448,3780751098,'Aries'],
  [3780751098,3780941423,'Taurus'],
  [3780941423,3781126927,'Gemini'],
  [3781126927,3781309741,'Cancer'],
  [3781309741,3781491860,'Leo'],
  [3781491860,3781675940,'Virgo'],
  [3781675940,3781865690,'Libra'],
  [3781865690,3782064989,'Scorpio'],
  [3782064989,3782275418,'Sagittarius'],
  [3782275418,3782493314,'Capricorn'],
  [3782493314,3782710016,'Aquarius'],
  [3782710016,3782917310,'Pisces'],
  [3782917310,3783112526,'Aries'],
  [3783112526,3783298422,'Taurus'],
  [3783298422,3783480039,'Gemini'],
  [3783480039,3783661907,'Cancer'],
  [3783661907,3783846651,'Leo'],
  [3783846651,3784035262,'Virgo'],
  [3784035262,3784228681,'Libra'],
  [3784228681,3784428928,'Scorpio'],
  [3784428928,3784638110,'Sagittarius'],
  [3784638110,3784855298,'Capricorn'],
  [3784855298,3785073927,'Aquarius'],
  [3785073927,3785284390,'Pisces'],
  [3785284390,3785480832,'Aries'],
  [3785480832,3785664405,'Taurus'],
  [3785664405,3785840937,'Gemini'],
  [3785840937,3786017314,'Cancer'],
  [3786017314,3786198897,'Leo'],
  [3786198897,3786388063,'Virgo'],
  [3786388063,3786584625,'Libra'],
  [3786584625,3786787908,'Scorpio'],
  [3786787908,3786998073,'Sagittarius'],
  [3786998073,3787214897,'Capricorn'],
  [3787214897,3787434635,'Aquarius'],
  [3787434635,3787649116,'Pisces'],
  [3787649116,3787850370,'Aries'],
  [3787850370,3788036322,'Taurus'],
  [3788036322,3788211269,'Gemini'],
  [3788211269,3788382575,'Cancer'],
  [3788382575,3788557646,'Leo'],
  [3788557646,3788741829,'Virgo'],
  [3788741829,3788936996,'Libra'],
  [3788936996,3789141900,'Scorpio'],
  [3789141900,3789354109,'Sagittarius'],
  [3789354109,3789571468,'Capricorn'],
  [3789571468,3789791187,'Aquarius'],
  [3789791187,3790007869,'Pisces'],
  [3790007869,3790214431,'Aries'],
  [3790214431,3790406397,'Taurus'],
  [3790406397,3790584945,'Gemini'],
  [3790584945,3790755789,'Cancer'],
  [3790755789,3790926399,'Leo'],
  [3790926399,3791103866,'Virgo'],
  [3791103866,3791293125,'Libra'],
  [3791293125,3791495410,'Scorpio'],
  [3791495410,3791708056,'Sagittarius'],
  [3791708056,3791926332,'Capricorn'],
  [3791926332,3792145708,'Aquarius'],
  [3792145708,3792362026,'Pisces'],
  [3792362026,3792570873,'Aries'],
  [3792570873,3792768386,'Taurus'],
  [3792768386,3792953471,'Gemini'],
  [3792953471,3793128856,'Cancer'],
  [3793128856,3793300129,'Leo'],
  [3793300129,3793474099,'Virgo'],
  [3793474099,3793657234,'Libra'],
  [3793657234,3793853806,'Scorpio'],
  [3793853806,3794063719,'Sagittarius'],
  [3794063719,3794281892,'Capricorn'],
  [3794281892,3794501187,'Aquarius'],
  [3794501187,3794716074,'Pisces'],
  [3794716074,3794923668,'Aries'],
  [3794923668,3795122657,'Taurus'],
  [3795122657,3795312570,'Gemini'],
  [3795312570,3795494257,'Cancer'],
  [3795494257,3795670474,'Leo'],
  [3795670474,3795845951,'Virgo'],
  [3795845951,3796026659,'Libra'],
  [3796026659,3796218296,'Scorpio'],
  [3796218296,3796423720,'Sagittarius'],
  [3796423720,3796640104,'Capricorn'],
  [3796640104,3796859411,'Aquarius'],
  [3796859411,3797073524,'Pisces'],
  [3797073524,3797278666,'Aries'],
  [3797278666,3797475266,'Taurus'],
  [3797475266,3797665289,'Gemini'],
  [3797665289,3797850435,'Cancer'],
  [3797850435,3798032080,'Leo'],
  [3798032080,3798212342,'Virgo'],
  [3798212342,3798395031,'Libra'],
  [3798395031,3798585239,'Scorpio'],
  [3798585239,3798787250,'Sagittarius'],
  [3798787250,3799001080,'Capricorn'],
  [3799001080,3799220213,'Aquarius'],
  [3799220213,3799434911,'Pisces'],
  [3799434911,3799638955,'Aries'],
  [3799638955,3799832351,'Taurus'],
  [3799832351,3800018848,'Gemini'],
  [3800018848,3800202523,'Cancer'],
  [3800202523,3800385957,'Leo'],
  [3800385957,3800570390,'Virgo'],
  [3800570390,3800757292,'Libra'],
  [3800757292,3800949587,'Scorpio'],
  [3800949587,3801150957,'Sagittarius'],
  [3801150957,3801363007,'Capricorn'],
  [3801363007,3801581821,'Aquarius'],
  [3801581821,3801798185,'Pisces'],
  [3801798185,3802003624,'Aries'],
  [3802003624,3802195965,'Taurus'],
  [3802195965,3802378827,'Gemini'],
  [3802378827,3802557982,'Cancer'],
  [3802557982,3802738411,'Leo'],
  [3802738411,3802922942,'Virgo'],
  [3802922942,3803112635,'Libra'],
  [3803112635,3803308321,'Scorpio'],
  [3803308321,3803511529,'Sagittarius'],
  [3803511529,3803723448,'Capricorn'],
  [3803723448,3803942032,'Aquarius'],
  [3803942032,3804160229,'Pisces'],
  [3804160229,3804369063,'Aries'],
  [3804369063,3804563711,'Taurus'],
  [3804563711,3804745867,'Gemini'],
  [3804745867,3804921248,'Cancer'],
  [3804921248,3805096401,'Leo'],
  [3805096401,3805276629,'Virgo'],
  [3805276629,3805464930,'Libra'],
  [3805464930,3805662112,'Scorpio'],
  [3805662112,3805867746,'Sagittarius'],
  [3805867746,3806080920,'Capricorn'],
  [3806080920,3806299568,'Aquarius'],
  [3806299568,3806518779,'Pisces'],
  [3806518779,3806731196,'Aries'],
  [3806731196,3806930669,'Taurus'],
  [3806930669,3807116081,'Gemini'],
  [3807116081,3807291325,'Cancer'],
  [3807291325,3807462822,'Leo'],
  [3807462822,3807637336,'Virgo'],
  [3807637336,3807820427,'Libra'],
  [3807820427,3808015137,'Scorpio'],
  [3808015137,3808221244,'Sagittarius'],
  [3808221244,3808435819,'Capricorn'],
  [3808435819,3808654851,'Aquarius'],
  [3808654851,3808873930,'Pisces'],
  [3808873930,3809088045,'Aries'],
  [3809088045,3809292179,'Taurus'],
  [3809292179,3809483439,'Gemini'],
  [3809483439,3809662846,'Cancer'],
  [3809662846,3809834924,'Leo'],
  [3809834924,3810006173,'Virgo'],
  [3810006173,3810183529,'Libra'],
  [3810183529,3810372679,'Scorpio'],
  [3810372679,3810575860,'Sagittarius'],
  [3810575860,3810790310,'Capricorn'],
  [3810790310,3811009769,'Aquarius'],
  [3811009769,3811228148,'Pisces'],
  [3811228148,3811441454,'Aries'],
  [3811441454,3811647168,'Taurus'],
  [3811647168,3811843295,'Gemini'],
  [3811843295,3812029042,'Cancer'],
  [3812029042,3812206027,'Leo'],
  [3812206027,3812378678,'Virgo'],
  [3812378678,3812553472,'Libra'],
  [3812553472,3812737369,'Scorpio'],
  [3812737369,3812935367,'Sagittarius'],
  [3812935367,3813147256,'Capricorn'],
  [3813147256,3813366545,'Aquarius'],
  [3813366545,3813584599,'Pisces'],
  [3813584599,3813796049,'Aries'],
  [3813796049,3813999803,'Taurus'],
  [3813999803,3814196471,'Gemini'],
  [3814196471,3814386314,'Cancer'],
  [3814386314,3814569439,'Leo'],
  [3814569439,3814747420,'Virgo'],
  [3814747420,3814924445,'Libra'],
  [3814924445,3815106734,'Scorpio'],
  [3815106734,3815300477,'Sagittarius'],
  [3815300477,3815508392,'Capricorn'],
  [3815508392,3815726368,'Aquarius'],
  [3815726368,3815944841,'Pisces'],
  [3815944841,3816155632,'Aries'],
  [3816155632,3816356547,'Taurus'],
  [3816356547,3816549809,'Gemini'],
  [3816549809,3816738388,'Cancer'],
  [3816738388,3816923916,'Leo'],
  [3816923916,3817107045,'Virgo'],
  [3817107045,3817289325,'Libra'],
  [3817289325,3817474459,'Scorpio'],
  [3817474459,3817667575,'Sagittarius'],
  [3817667575,3817872618,'Capricorn'],
  [3817872618,3818088558,'Aquarius'],
  [3818088558,3818307672,'Pisces'],
  [3818307672,3818520034,'Aries'],
  [3818520034,3818720504,'Taurus'],
  [3818720504,3818910377,'Gemini'],
  [3818910377,3819094175,'Cancer'],
  [3819094175,3819276321,'Leo'],
  [3819276321,3819459570,'Virgo'],
  [3819459570,3819645314,'Libra'],
  [3819645314,3819835014,'Scorpio'],
  [3819835014,3820031095,'Sagittarius'],
  [3820031095,3820236223,'Capricorn'],
  [3820236223,3820450782,'Aquarius'],
  [3820450782,3820670110,'Pisces'],
  [3820670110,3820885312,'Aries'],
  [3820885312,3821088795,'Taurus'],
  [3821088795,3821278925,'Gemini'],
  [3821278925,3821459340,'Cancer'],
  [3821459340,3821635812,'Leo'],
  [3821635812,3821813848,'Virgo'],
  [3821813848,3821997411,'Libra'],
  [3821997411,3822188587,'Scorpio'],
  [3822188587,3822388025,'Sagittarius'],
  [3822388025,3822595617,'Capricorn'],
  [3822595617,3822810490,'Aquarius'],
  [3822810490,3823029662,'Pisces'],
  [3823029662,3823247047,'Aries'],
  [3823247047,3823455224,'Taurus'],
  [3823455224,3823649718,'Gemini'],
  [3823649718,3823831336,'Cancer'],
  [3823831336,3824004933,'Leo'],
  [3824004933,3824177112,'Virgo'],
  [3824177112,3824354384,'Libra'],
  [3824354384,3824541660,'Scorpio'],
  [3824541660,3824740839,'Sagittarius'],
  [3824740839,3824950389,'Capricorn'],
  [3824950389,3825166738,'Aquarius'],
  [3825166738,3825385941,'Pisces'],
  [3825385941,3825603825,'Aries'],
  [3825603825,3825815362,'Taurus'],
  [3825815362,3826015634,'Gemini'],
  [3826015634,3826202556,'Cancer'],
  [3826202556,3826378276,'Leo'],
  [3826378276,3826548428,'Virgo'],
  [3826548428,3826720324,'Libra'],
  [3826720324,3826901120,'Scorpio'],
  [3826901120,3827095634,'Sagittarius'],
  [3827095634,3827303898,'Capricorn'],
  [3827303898,3827521013,'Aquarius'],
  [3827521013,3827740541,'Pisces'],
  [3827740541,3827957783,'Aries'],
  [3827957783,3828169779,'Taurus'],
  [3828169779,3828373597,'Gemini'],
  [3828373597,3828566502,'Cancer'],
  [3828566502,3828747929,'Leo'],
  [3828747929,3828920947,'Virgo'],
  [3828920947,3829091794,'Libra'],
  [3829091794,3829268103,'Scorpio'],
  [3829268103,3829456708,'Sagittarius'],
  [3829456708,3829660574,'Capricorn'],
  [3829660574,3829876272,'Aquarius'],
  [3829876272,3830095853,'Pisces'],
  [3830095853,3830312377,'Aries'],
  [3830312377,3830522825,'Taurus'],
  [3830522825,3830726410,'Gemini'],
  [3830726410,3830922187,'Cancer'],
  [3830922187,3831109073,'Leo'],
  [3831109073,3831287722,'Virgo'],
  [3831287722,3831461935,'Libra'],
  [3831461935,3831638082,'Scorpio'],
  [3831638082,3831823226,'Sagittarius'],
  [3831823226,3832022324,'Capricorn'],
  [3832022324,3832234803,'Aquarius'],
  [3832234803,3832453653,'Pisces'],
  [3832453653,3832670022,'Aries'],
  [3832670022,3832878929,'Taurus'],
  [3832878929,3833079947,'Gemini'],
  [3833079947,3833274335,'Cancer'],
  [3833274335,3833462848,'Leo'],
  [3833462848,3833645932,'Virgo'],
  [3833645932,3833825334,'Libra'],
  [3833825334,3834005048,'Scorpio'],
  [3834005048,3834190661,'Sagittarius'],
  [3834190661,3834387314,'Capricorn'],
  [3834387314,3834596602,'Aquarius'],
  [3834596602,3834814086,'Pisces'],
  [3834814086,3835030954,'Aries'],
  [3835030954,3835239873,'Taurus'],
  [3835239873,3835438772,'Gemini'],
  [3835438772,3835629582,'Cancer'],
  [3835629582,3835815333,'Leo'],
  [3835815333,3835998489,'Virgo'],
  [3835998489,3836180996,'Libra'],
  [3836180996,3836365168,'Scorpio'],
  [3836365168,3836554203,'Sagittarius'],
  [3836554203,3836751629,'Capricorn'],
  [3836751629,3836959449,'Aquarius'],
  [3836959449,3837175626,'Pisces'],
  [3837175626,3837393329,'Aries'],
  [3837393329,3837604208,'Taurus'],
  [3837604208,3837803542,'Gemini'],
  [3837803542,3837991919,'Cancer'],
  [3837991919,3838173229,'Leo'],
  [3838173229,3838352256,'Virgo'],
  [3838352256,3838533182,'Libra'],
  [3838533182,3838718986,'Scorpio'],
  [3838718986,3838911510,'Sagittarius'],
  [3838911510,3839111840,'Capricorn'],
  [3839111840,3839320411,'Aquarius'],
  [3839320411,3839536030,'Pisces'],
  [3839536030,3839754389,'Aries'],
  [3839754389,3839968286,'Taurus'],
  [3839968286,3840171044,'Gemini'],
  [3840171044,3840360485,'Cancer'],
  [3840360485,3840539366,'Leo'],
  [3840539366,3840713387,'Virgo'],
  [3840713387,3840889008,'Libra'],
  [3840889008,3841071677,'Scorpio'],
  [3841071677,3841264384,'Sagittarius'],
  [3841264384,3841467078,'Capricorn'],
  [3841467078,3841677706,'Aquarius'],
  [3841677706,3841893760,'Pisces'],
  [3841893760,3842112259,'Aries'],
  [3842112259,3842328475,'Taurus'],
  [3842328475,3842536044,'Gemini'],
  [3842536044,3842730227,'Cancer'],
  [3842730227,3842910993,'Leo'],
  [3842910993,3843083001,'Virgo'],
  [3843083001,3843253498,'Libra'],
  [3843253498,3843430063,'Scorpio'],
  [3843430063,3843618415,'Sagittarius'],
  [3843618415,3843820082,'Capricorn'],
  [3843820082,3844031959,'Aquarius'],
  [3844031959,3844249036,'Pisces'],
  [3844249036,3844467350,'Aries'],
  [3844467350,3844683909,'Taurus'],
  [3844683909,3844894693,'Gemini'],
  [3844894693,3845094764,'Cancer'],
  [3845094764,3845281312,'Leo'],
  [3845281312,3845456210,'Virgo'],
  [3845456210,3845625560,'Libra'],
  [3845625560,3845797403,'Scorpio'],
  [3845797403,3845979419,'Sagittarius'],
  [3845979419,3846176143,'Capricorn'],
  [3846176143,3846386328,'Aquarius'],
  [3846386328,3846603830,'Pisces'],
  [3846603830,3846822126,'Aries'],
  [3846822126,3847037547,'Taurus'],
  [3847037547,3847248111,'Gemini'],
  [3847248111,3847451189,'Cancer'],
  [3847451189,3847643761,'Leo'],
  [3847643761,3847825040,'Virgo'],
  [3847825040,3847998325,'Libra'],
  [3847998325,3848170177,'Scorpio'],
  [3848170177,3848348322,'Sagittarius'],
  [3848348322,3848539191,'Capricorn'],
  [3848539191,3848744780,'Aquarius'],
  [3848744780,3848960803,'Pisces'],
  [3848960803,3849179246,'Aries'],
  [3849179246,3849393782,'Taurus'],
  [3849393782,3849602017,'Gemini'],
  [3849602017,3849803550,'Cancer'],
  [3849803550,3849997823,'Leo'],
  [3849997823,3850184238,'Virgo'],
  [3850184238,3850363849,'Libra'],
  [3850363849,3850540385,'Scorpio'],
  [3850540385,3850719634,'Sagittarius'],
  [3850719634,3850907737,'Capricorn'],
  [3850907737,3851108689,'Aquarius'],
  [3851108689,3851321527,'Pisces'],
  [3851321527,3851539660,'Aries'],
  [3851539660,3851754674,'Taurus'],
  [3851754674,3851961506,'Gemini'],
  [3851961506,3852159559,'Cancer'],
  [3852159559,3852350589,'Leo'],
  [3852350589,3852536673,'Virgo'],
  [3852536673,3852719656,'Libra'],
  [3852719656,3852901667,'Scorpio'],
  [3852901667,3853085705,'Sagittarius'],
  [3853085705,3853275596,'Capricorn'],
  [3853275596,3853474923,'Aquarius'],
  [3853474923,3853684893,'Pisces'],
  [3853684893,3853902048,'Aries'],
  [3853902048,3854118541,'Taurus'],
  [3854118541,3854326642,'Gemini'],
  [3854326642,3854523215,'Cancer'],
  [3854523215,3854710004,'Leo'],
  [3854710004,3854891330,'Virgo'],
  [3854891330,3855071802,'Libra'],
  [3855071802,3855254972,'Scorpio'],
  [3855254972,3855442970,'Sagittarius'],
  [3855442970,3855637020,'Capricorn'],
  [3855637020,3855838251,'Aquarius'],
  [3855838251,3856047552,'Pisces'],
  [3856047552,3856263762,'Aries'],
  [3856263762,3856481664,'Taurus'],
  [3856481664,3856693093,'Gemini'],
  [3856693093,3856891904,'Cancer'],
  [3856891904,3857077563,'Leo'],
  [3857077563,3857254487,'Virgo'],
  [3857254487,3857429262,'Libra'],
  [3857429262,3857608135,'Scorpio'],
  [3857608135,3857795194,'Sagittarius'],
  [3857795194,3857991448,'Capricorn'],
  [3857991448,3858195702,'Aquarius'],
  [3858195702,3858406506,'Pisces'],
  [3858406506,3858622626,'Aries'],
  [3858622626,3858841192,'Taurus'],
  [3858841192,3859055962,'Gemini'],
  [3859055962,3859259544,'Cancer'],
  [3859259544,3859448351,'Leo'],
  [3859448351,3859624827,'Virgo'],
  [3859624827,3859795596,'Libra'],
  [3859795596,3859968482,'Scorpio'],
  [3859968482,3860150148,'Sagittarius'],
  [3860150148,3860343941,'Capricorn'],
  [3860343941,3860548890,'Aquarius'],
  [3860548890,3860761458,'Pisces'],
  [3860761458,3860978329,'Aries'],
  [3860978329,3861196911,'Taurus'],
  [3861196911,3861413280,'Gemini'],
  [3861413280,3861621307,'Cancer'],
  [3861621307,3861815735,'Leo'],
  [3861815735,3861996112,'Virgo'],
  [3861996112,3862167280,'Libra'],
  [3862167280,3862336875,'Scorpio'],
  [3862336875,3862512772,'Sagittarius'],
  [3862512772,3862700835,'Capricorn'],
  [3862700835,3862902631,'Aquarius'],
  [3862902631,3863114976,'Pisces'],
  [3863114976,3863332523,'Aries'],
  [3863332523,3863550913,'Taurus'],
  [3863550913,3863766908,'Gemini'],
  [3863766908,3863976653,'Cancer'],
  [3863976653,3864175774,'Leo'],
  [3864175774,3864362070,'Virgo'],
  [3864362070,3864537699,'Libra'],
  [3864537699,3864708504,'Scorpio'],
  [3864708504,3864881887,'Sagittarius'],
  [3864881887,3865064747,'Capricorn'],
  [3865064747,3865261215,'Aquarius'],
  [3865261215,3865470631,'Pisces'],
  [3865470631,3865687740,'Aries'],
  [3865687740,3865905993,'Taurus'],
  [3865905993,3866120754,'Gemini'],
  [3866120754,3866329277,'Cancer'],
  [3866329277,3866529503,'Leo'],
  [3866529503,3866720022,'Virgo'],
  [3866720022,3866901408,'Libra'],
  [3866901408,3867076982,'Scorpio'],
  [3867076982,3867252188,'Sagittarius'],
  [3867252188,3867433241,'Capricorn'],
  [3867433241,3867625364,'Aquarius'],
  [3867625364,3867830568,'Pisces'],
  [3867830568,3868045835,'Aries'],
  [3868045835,3868264014,'Taurus'],
  [3868264014,3868478077,'Gemini'],
  [3868478077,3868684307,'Cancer'],
  [3868684307,3868882157,'Leo'],
  [3868882157,3869072616,'Virgo'],
  [3869072616,3869257183,'Libra'],
  [3869257183,3869437933,'Scorpio'],
  [3869437933,3869617887,'Sagittarius'],
  [3869617887,3869801095,'Capricorn'],
  [3869801095,3869992044,'Aquarius'],
  [3869992044,3870194066,'Pisces'],
  [3870194066,3870406884,'Aries'],
  [3870406884,3870624933,'Taurus'],
  [3870624933,3870839668,'Gemini'],
  [3870839668,3871044891,'Cancer'],
  [3871044891,3871239529,'Leo'],
  [3871239529,3871426349,'Virgo'],
  [3871426349,3871609315,'Libra'],
  [3871609315,3871791764,'Scorpio'],
  [3871791764,3871975909,'Sagittarius'],
  [3871975909,3872163464,'Capricorn'],
  [3872163464,3872356616,'Aquarius'],
  [3872356616,3872558040,'Pisces'],
  [3872558040,3872769092,'Aries'],
  [3872769092,3872986887,'Taurus'],
  [3872986887,3873203509,'Gemini'],
  [3873203509,3873410400,'Cancer'],
  [3873410400,3873604076,'Leo'],
  [3873604076,3873787099,'Virgo'],
  [3873787099,3873965235,'Libra'],
  [3873965235,3874144359,'Scorpio'],
  [3874144359,3874328430,'Sagittarius'],
  [3874328430,3874518848,'Capricorn'],
  [3874518848,3874715587,'Aquarius'],
  [3874715587,3874918975,'Pisces'],
  [3874918975,3875129873,'Aries'],
  [3875129873,3875347370,'Taurus'],
  [3875347370,3875565970,'Gemini'],
  [3875565970,3875776738,'Cancer'],
  [3875776738,3875973268,'Leo'],
  [3875973268,3876155846,'Virgo'],
  [3876155846,3876330097,'Libra'],
  [3876330097,3876503489,'Scorpio'],
  [3876503489,3876682598,'Sagittarius'],
  [3876682598,3876871120,'Capricorn'],
  [3876871120,3877069229,'Aquarius'],
  [3877069229,3877275195,'Pisces'],
  [3877275195,3877487500,'Aries'],
  [3877487500,3877704972,'Taurus'],
  [3877704972,3877924397,'Gemini'],
  [3877924397,3878138898,'Cancer'],
  [3878138898,3878340945,'Leo'],
  [3878340945,3878527663,'Virgo'],
  [3878527663,3878702454,'Libra'],
  [3878702454,3878872430,'Scorpio'],
  [3878872430,3879045424,'Sagittarius'],
  [3879045424,3879227805,'Capricorn'],
  [3879227805,3879422537,'Aquarius'],
  [3879422537,3879628557,'Pisces'],
  [3879628557,3879842365,'Aries'],
  [3879842365,3880060367,'Taurus'],
  [3880060367,3880279386,'Gemini'],
  [3880279386,3880495056,'Cancer'],
  [3880495056,3880701640,'Leo'],
  [3880701640,3880894857,'Virgo'],
  [3880894857,3881074960,'Libra'],
  [3881074960,3881246715,'Scorpio'],
  [3881246715,3881417207,'Sagittarius'],
  [3881417207,3881593742,'Capricorn'],
  [3881593742,3881781984,'Aquarius'],
  [3881781984,3881983978,'Pisces'],
  [3881983978,3882197128,'Aries'],
  [3882197128,3882415719,'Taurus'],
  [3882415719,3882634180,'Gemini'],
  [3882634180,3882848508,'Cancer'],
  [3882848508,3883055640,'Leo'],
  [3883055640,3883253033,'Virgo'],
  [3883253033,3883439724,'Libra'],
  [3883439724,3883617513,'Scorpio'],
  [3883617513,3883790901,'Sagittarius'],
  [3883790901,3883966043,'Capricorn'],
  [3883966043,3884149331,'Aquarius'],
  [3884149331,3884345508,'Pisces'],
  [3884345508,3884555149,'Aries'],
  [3884555149,3884773229,'Taurus'],
  [3884773229,3884991734,'Gemini'],
  [3884991734,3885204450,'Cancer'],
  [3885204450,3885408999,'Leo'],
  [3885408999,3885605566,'Virgo'],
  [3885605566,3885795041,'Libra'],
  [3885795041,3885978541,'Scorpio'],
  [3885978541,3886157943,'Sagittarius'],
  [3886157943,3886336644,'Capricorn'],
  [3886336644,3886519598,'Aquarius'],
  [3886519598,3886712152,'Pisces'],
  [3886712152,3886917558,'Aries'],
  [3886917558,3887133714,'Taurus'],
  [3887133714,3887352611,'Gemini'],
  [3887352611,3887565295,'Cancer'],
  [3887565295,3887767502,'Leo'],
  [3887767502,3887960339,'Virgo'],
  [3887960339,3888147313,'Libra'],
  [3888147313,3888331610,'Scorpio'],
  [3888331610,3888515093,'Sagittarius'],
  [3888515093,3888699030,'Capricorn'],
  [3888699030,3888885630,'Aquarius'],
  [3888885630,3889078641,'Pisces'],
  [3889078641,3889281881,'Aries'],
  [3889281881,3889495908,'Taurus'],
  [3889495908,3889715047,'Gemini'],
  [3889715047,3889929437,'Cancer'],
  [3889929437,3890131951,'Leo'],
  [3890131951,3890322204,'Virgo'],
  [3890322204,3890504665,'Libra'],
  [3890504665,3890684924,'Scorpio'],
  [3890684924,3890867151,'Sagittarius'],
  [3890867151,3891053240,'Capricorn'],
  [3891053240,3891243816,'Aquarius'],
  [3891243816,3891440040,'Pisces'],
  [3891440040,3891644098,'Aries'],
  [3891644098,3891857242,'Taurus'],
  [3891857242,3892076396,'Gemini'],
  [3892076396,3892293183,'Cancer'],
  [3892293183,3892498748,'Leo'],
  [3892498748,3892689926,'Virgo'],
  [3892689926,3892870003,'Libra'],
  [3892870003,3893045387,'Scorpio'],
  [3893045387,3893222441,'Sagittarius'],
  [3893222441,3893405560,'Capricorn'],
  [3893405560,3893596518,'Aquarius'],
  [3893596518,3893795351,'Pisces'],
  [3893795351,3894001815,'Aries'],
  [3894001815,3894215674,'Taurus'],
  [3894215674,3894434855,'Gemini'],
  [3894434855,3894653418,'Cancer'],
  [3894653418,3894863099,'Leo'],
  [3894863099,3895058467,'Virgo'],
  [3895058467,3895240211,'Libra'],
  [3895240211,3895413680,'Scorpio'],
  [3895413680,3895585850,'Sagittarius'],
  [3895585850,3895763151,'Capricorn'],
  [3895763151,3895949992,'Aquarius'],
  [3895949992,3896147912,'Pisces'],
  [3896147912,3896355793,'Aries'],
  [3896355793,3896571042,'Taurus'],
  [3896571042,3896790444,'Gemini'],
  [3896790444,3897009460,'Cancer'],
  [3897009460,3897222030,'Leo'],
  [3897222030,3897422604,'Virgo'],
  [3897422604,3897609385,'Libra'],
  [3897609385,3897785252,'Scorpio'],
  [3897785252,3897956083,'Sagittarius'],
  [3897956083,3898128765,'Capricorn'],
  [3898128765,3898309652,'Aquarius'],
  [3898309652,3898502996,'Pisces'],
  [3898502996,3898709332,'Aries'],
  [3898709332,3898925118,'Taurus'],
  [3898925118,3899144828,'Gemini'],
  [3899144828,3899363265,'Cancer'],
  [3899363265,3899576164,'Leo'],
  [3899576164,3899779962,'Virgo'],
  [3899779962,3899972378,'Libra'],
  [3899972378,3900153806,'Scorpio'],
  [3900153806,3900327660,'Sagittarius'],
  [3900327660,3900499619,'Capricorn'],
  [3900499619,3900676395,'Aquarius'],
  [3900676395,3900864163,'Pisces'],
  [3900864163,3901066230,'Aries'],
  [3901066230,3901280568,'Taurus'],
  [3901280568,3901500298,'Gemini'],
  [3901500298,3901718006,'Cancer'],
  [3901718006,3901929297,'Leo'],
  [3901929297,3902132728,'Virgo'],
  [3902132728,3902327894,'Libra'],
  [3902327894,3902514735,'Scorpio'],
  [3902514735,3902694308,'Sagittarius'],
  [3902694308,3902869768,'Capricorn'],
  [3902869768,3903046471,'Aquarius'],
  [3903046471,3903230867,'Pisces'],
  [3903230867,3903428260,'Aries'],
  [3903428260,3903639432,'Taurus'],
  [3903639432,3903858498,'Gemini'],
  [3903858498,3904076101,'Cancer'],
  [3904076101,3904285786,'Leo'],
  [3904285786,3904486458,'Virgo'],
  [3904486458,3904680023,'Libra'],
  [3904680023,3904868395,'Scorpio'],
  [3904868395,3905052521,'Sagittarius'],
  [3905052521,3905233440,'Capricorn'],
  [3905233440,3905413934,'Aquarius'],
  [3905413934,3905598891,'Pisces'],
  [3905598891,3905793830,'Aries'],
  [3905793830,3906001748,'Taurus'],
  [3906001748,3906219462,'Gemini'],
  [3906219462,3906437754,'Cancer'],
  [3906437754,3906647642,'Leo'],
  [3906647642,3906846163,'Virgo'],
  [3906846163,3907035852,'Libra'],
  [3907035852,3907221003,'Scorpio'],
  [3907221003,3907404844,'Sagittarius'],
  [3907404844,3907588861,'Capricorn'],
  [3907588861,3907774100,'Aquarius'],
  [3907774100,3907962847,'Pisces'],
  [3907962847,3908158811,'Aries'],
  [3908158811,3908365260,'Taurus'],
  [3908365260,3908581528,'Gemini'],
  [3908581528,3908800738,'Cancer'],
  [3908800738,3909013046,'Leo'],
  [3909013046,3909212529,'Virgo'],
  [3909212529,3909400011,'Libra'],
  [3909400011,3909580426,'Scorpio'],
  [3909580426,3909759364,'Sagittarius'],
  [3909759364,3909940973,'Capricorn'],
  [3909940973,3910127421,'Aquarius'],
  [3910127421,3910319761,'Pisces'],
  [3910319761,3910519087,'Aries'],
  [3910519087,3910726659,'Taurus'],
  [3910726659,3910942309,'Gemini'],
  [3910942309,3911161921,'Cancer'],
  [3911161921,3911377412,'Leo'],
  [3911377412,3911581116,'Virgo'],
  [3911581116,3911770683,'Libra'],
  [3911770683,3911949362,'Scorpio'],
  [3911949362,3912123216,'Sagittarius'],
  [3912123216,3912298627,'Capricorn'],
  [3912298627,3912480702,'Aquarius'],
  [3912480702,3912672295,'Pisces'],
  [3912672295,3912873802,'Aries'],
  [3912873802,3913083848,'Taurus'],
  [3913083848,3913300230,'Gemini'],
  [3913300230,3913519675,'Cancer'],
  [3913519675,3913736945,'Leo'],
  [3913736945,3913945522,'Virgo'],
  [3913945522,3914140796,'Libra'],
  [3914140796,3914322791,'Scorpio'],
  [3914322791,3914495802,'Sagittarius'],
  [3914495802,3914666444,'Capricorn'],
  [3914666444,3914841802,'Aquarius'],
  [3914841802,3915027751,'Pisces'],
  [3915027751,3915227023,'Aries'],
  [3915227023,3915437928,'Taurus'],
  [3915437928,3915655617,'Gemini'],
  [3915655617,3915874970,'Cancer'],
  [3915874970,3916091930,'Leo'],
  [3916091930,3916302748,'Virgo'],
  [3916302748,3916503561,'Libra'],
  [3916503561,3916692089,'Scorpio'],
  [3916692089,3916869441,'Sagittarius'],
  [3916869441,3917040351,'Capricorn'],
  [3917040351,3917211852,'Aquarius'],
  [3917211852,3917391449,'Pisces'],
  [3917391449,3917584851,'Aries'],
  [3917584851,3917792972,'Taurus'],
  [3917792972,3918010695,'Gemini'],
  [3918010695,3918230262,'Cancer'],
  [3918230262,3918446088,'Leo'],
  [3918446088,3918655865,'Virgo'],
  [3918655865,3918858340,'Libra'],
  [3918858340,3919051951,'Scorpio'],
  [3919051951,3919235820,'Sagittarius'],
  [3919235820,3919411669,'Capricorn'],
  [3919411669,3919584516,'Aquarius'],
  [3919584516,3919761468,'Pisces'],
  [3919761468,3919949571,'Aries'],
  [3919949571,3920152682,'Taurus'],
  [3920152682,3920368179,'Gemini'],
  [3920368179,3920587683,'Cancer'],
  [3920587683,3920802978,'Leo'],
  [3920802978,3921010618,'Virgo'],
  [3921010618,3921210934,'Libra'],
  [3921210934,3921404863,'Scorpio'],
  [3921404863,3921592502,'Sagittarius'],
  [3921592502,3921774097,'Capricorn'],
  [3921774097,3921951954,'Aquarius'],
  [3921951954,3922131023,'Pisces'],
  [3922131023,3922317634,'Aries'],
  [3922317634,3922516890,'Taurus'],
  [3922516890,3922729094,'Gemini'],
  [3922729094,3922947828,'Cancer'],
  [3922947828,3923163599,'Leo'],
  [3923163599,3923370385,'Virgo'],
  [3923370385,3923567766,'Libra'],
  [3923567766,3923758314,'Scorpio'],
  [3923758314,3923944616,'Sagittarius'],
  [3923944616,3924128239,'Capricorn'],
  [3924128239,3924310585,'Aquarius'],
  [3924310585,3924494237,'Pisces'],
  [3924494237,3924683252,'Aries'],
  [3924683252,3924881875,'Taurus'],
  [3924881875,3925091816,'Gemini'],
  [3925091816,3925309451,'Cancer'],
  [3925309451,3925526350,'Leo'],
  [3925526350,3925734491,'Virgo'],
  [3925734491,3925931043,'Libra'],
  [3925931043,3926118131,'Scorpio'],
  [3926118131,3926299979,'Sagittarius'],
  [3926299979,3926480666,'Capricorn'],
  [3926480666,3926663245,'Aquarius'],
  [3926663245,3926849944,'Pisces'],
  [3926849944,3927042739,'Aries'],
  [3927042739,3927243552,'Taurus'],
  [3927243552,3927453376,'Gemini'],
  [3927453376,3927670303,'Cancer'],
  [3927670303,3927888355,'Leo'],
  [3927888355,3928099497,'Virgo'],
  [3928099497,3928298358,'Libra'],
  [3928298358,3928484878,'Scorpio'],
  [3928484878,3928663038,'Sagittarius'],
  [3928663038,3928838507,'Capricorn'],
  [3928838507,3929016826,'Aquarius'],
  [3929016826,3929202171,'Pisces'],
  [3929202171,3929396624,'Aries'],
  [3929396624,3929600184,'Taurus'],
  [3929600184,3929811583,'Gemini'],
  [3929811583,3930028603,'Cancer'],
  [3930028603,3930247288,'Leo'],
  [3930247288,3930461506,'Virgo'],
  [3930461506,3930664909,'Libra'],
  [3930664909,3930854630,'Scorpio'],
  [3930854630,3931032660,'Sagittarius'],
  [3931032660,3931204533,'Capricorn'],
  [3931204533,3931377248,'Aquarius'],
  [3931377248,3931557407,'Pisces'],
  [3931557407,3931749319,'Aries'],
  [3931749319,3931953372,'Taurus'],
  [3931953372,3932166401,'Gemini'],
  [3932166401,3932384137,'Cancer'],
  [3932384137,3932602826,'Leo'],
  [3932602826,3932818559,'Virgo'],
  [3932818559,3933026314,'Libra'],
  [3933026314,3933221649,'Scorpio'],
  [3933221649,3933403672,'Sagittarius'],
  [3933403672,3933576043,'Capricorn'],
  [3933576043,3933745582,'Aquarius'],
  [3933745582,3933920136,'Pisces'],
  [3933920136,3934106428,'Aries'],
  [3934106428,3934307320,'Taurus'],
  [3934307320,3934520073,'Gemini'],
  [3934520073,3934738423,'Cancer'],
  [3934738423,3934956833,'Leo'],
  [3934956833,3935172088,'Virgo'],
  [3935172088,3935381504,'Libra'],
  [3935381504,3935581625,'Scorpio'],
  [3935581625,3935769814,'Sagittarius'],
  [3935769814,3935946878,'Capricorn'],
  [3935946878,3936117734,'Aquarius'],
  [3936117734,3936289808,'Pisces'],
  [3936289808,3936470867,'Aries'],
  [3936470867,3936666313,'Taurus'],
  [3936666313,3936876024,'Gemini'],
  [3936876024,3937093909,'Cancer'],
  [3937093909,3937312175,'Leo'],
  [3937312175,3937526073,'Virgo'],
  [3937526073,3937734039,'Libra'],
  [3937734039,3937935077,'Scorpio'],
  [3937935077,3938127581,'Sagittarius'],
  [3938127581,3938310793,'Capricorn'],
  [3938310793,3938486878,'Aquarius'],
  [3938486878,3938661146,'Pisces'],
  [3938661146,3938840576,'Aries'],
  [3938840576,3939031545,'Taurus'],
  [3939031545,3939236723,'Gemini'],
  [3939236723,3939452571,'Cancer'],
  [3939452571,3939670856,'Leo'],
  [3939670856,3939884210,'Virgo'],
  [3939884210,3940089772,'Libra'],
  [3940089772,3940287965,'Scorpio'],
  [3940287965,3940479839,'Sagittarius'],
  [3940479839,3940666019,'Capricorn'],
  [3940666019,3940847575,'Aquarius'],
  [3940847575,3941027236,'Pisces'],
  [3941027236,3941209533,'Aries'],
  [3941209533,3941399714,'Taurus'],
  [3941399714,3941601557,'Gemini'],
  [3941601557,3941814560,'Cancer'],
  [3941814560,3942032634,'Leo'],
  [3942032634,3942247089,'Virgo'],
  [3942247089,3942452147,'Libra'],
  [3942452147,3942647137,'Scorpio'],
  [3942647137,3942834675,'Sagittarius'],
  [3942834675,3943018209,'Capricorn'],
  [3943018209,3943200689,'Aquarius'],
  [3943200689,3943384446,'Pisces'],
  [3943384446,3943571694,'Aries'],
  [3943571694,3943764942,'Taurus'],
  [3943764942,3943966668,'Gemini'],
  [3943966668,3944177739,'Cancer'],
  [3944177739,3944395177,'Leo'],
  [3944395177,3944611681,'Virgo'],
  [3944611681,3944819278,'Libra'],
  [3944819278,3945014261,'Scorpio'],
  [3945014261,3945198304,'Sagittarius'],
  [3945198304,3945376381,'Capricorn'],
  [3945376381,3945554247,'Aquarius'],
  [3945554247,3945736605,'Pisces'],
  [3945736605,3945926066,'Aries'],
  [3945926066,3946123182,'Taurus'],
  [3946123182,3946327589,'Gemini'],
  [3946327589,3946538890,'Cancer'],
  [3946538890,3946755739,'Leo'],
  [3946755739,3946973764,'Virgo'],
  [3946973764,3947185502,'Libra'],
  [3947185502,3947384467,'Scorpio'],
  [3947384467,3947569358,'Sagittarius'],
  [3947569358,3947744301,'Capricorn'],
  [3947744301,3947916319,'Aquarius'],
  [3947916319,3948092673,'Pisces'],
  [3948092673,3948278715,'Aries'],
  [3948278715,3948476118,'Taurus'],
  [3948476118,3948682953,'Gemini'],
  [3948682953,3948896077,'Cancer'],
  [3948896077,3949113064,'Leo'],
  [3949113064,3949331368,'Virgo'],
  [3949331368,3949546096,'Libra'],
  [3949546096,3949750587,'Scorpio'],
  [3949750587,3949940585,'Sagittarius'],
  [3949940585,3950117419,'Capricorn'],
  [3950117419,3950287222,'Aquarius'],
  [3950287222,3950458084,'Pisces'],
  [3950458084,3950637589,'Aries'],
  [3950637589,3950830375,'Taurus'],
  [3950830375,3951036102,'Gemini'],
  [3951036102,3951250335,'Cancer'],
  [3951250335,3951468069,'Leo'],
  [3951468069,3951685969,'Virgo'],
  [3951685969,3951901092,'Libra'],
  [3951901092,3952108991,'Scorpio'],
  [3952108991,3952304968,'Sagittarius'],
  [3952304968,3952487549,'Capricorn'],
  [3952487549,3952660243,'Aquarius'],
  [3952660243,3952830032,'Pisces'],
  [3952830032,3953004877,'Aries'],
  [3953004877,3953191433,'Taurus'],
  [3953191433,3953392423,'Gemini'],
  [3953392423,3953605094,'Cancer'],
  [3953605094,3953823105,'Leo'],
  [3953823105,3954040700,'Virgo'],
  [3954040700,3954254526,'Libra'],
  [3954254526,3954462191,'Scorpio'],
  [3954462191,3954661035,'Sagittarius'],
  [3954661035,3954849208,'Capricorn'],
  [3954849208,3955027760,'Aquarius'],
  [3955027760,3955201144,'Pisces'],
  [3955201144,3955375910,'Aries'],
  [3955375910,3955558810,'Taurus'],
  [3955558810,3955754565,'Gemini'],
  [3955754565,3955963441,'Cancer'],
  [3955963441,3956180414,'Leo'],
  [3956180414,3956398002,'Virgo'],
  [3956398002,3956610629,'Libra'],
  [3956610629,3956815924,'Scorpio'],
  [3956815924,3957013419,'Sagittarius'],
  [3957013419,3957203282,'Capricorn'],
  [3957203282,3957386443,'Aquarius'],
  [3957386443,3957565304,'Pisces'],
  [3957565304,3957743920,'Aries'],
  [3957743920,3957927394,'Taurus'],
  [3957927394,3958120515,'Gemini'],
  [3958120515,3958325672,'Cancer'],
  [3958325672,3958540619,'Leo'],
  [3958540619,3958758362,'Virgo'],
  [3958758362,3958971093,'Libra'],
  [3958971093,3959174512,'Scorpio'],
  [3959174512,3959368602,'Sagittarius'],
  [3959368602,3959555818,'Capricorn'],
  [3959555818,3959739157,'Aquarius'],
  [3959739157,3959921284,'Pisces'],
  [3959921284,3960104601,'Aries'],
  [3960104601,3960291730,'Taurus'],
  [3960291730,3960485737,'Gemini'],
  [3960485737,3960689264,'Cancer'],
  [3960689264,3960902352,'Leo'],
  [3960902352,3961120268,'Virgo'],
  [3961120268,3961334615,'Libra'],
  [3961334615,3961538487,'Scorpio'],
  [3961538487,3961730318,'Sagittarius'],
  [3961730318,3961913322,'Capricorn'],
  [3961913322,3962092741,'Aquarius'],
  [3962092741,3962273424,'Pisces'],
  [3962273424,3962458494,'Aries'],
  [3962458494,3962649268,'Taurus'],
  [3962649268,3962846381,'Gemini'],
  [3962846381,3963050829,'Cancer'],
  [3963050829,3963263229,'Leo'],
  [3963263229,3963481251,'Virgo'],
  [3963481251,3963697979,'Libra'],
  [3963697979,3963904912,'Scorpio'],
  [3963904912,3964097742,'Sagittarius'],
  [3964097742,3964278481,'Capricorn'],
  [3964278481,3964453196,'Aquarius'],
  [3964453196,3964628845,'Pisces'],
  [3964628845,3964810930,'Aries'],
  [3964810930,3965001952,'Taurus'],
  [3965001952,3965201523,'Gemini'],
  [3965201523,3965408282,'Cancer'],
  [3965408282,3965621381,'Leo'],
  [3965621381,3965839469,'Virgo'],
  [3965839469,3966058035,'Libra'],
  [3966058035,3966269219,'Scorpio'],
  [3966269219,3966466414,'Sagittarius'],
  [3966466414,3966648923,'Capricorn'],
  [3966648923,3966821769,'Aquarius'],
  [3966821769,3966992567,'Pisces'],
  [3966992567,3967168782,'Aries'],
  [3967168782,3967355556,'Taurus'],
  [3967355556,3967554090,'Gemini'],
  [3967554090,3967762188,'Cancer'],
  [3967762188,3967976653,'Leo'],
  [3967976653,3968194917,'Virgo'],
  [3968194917,3968413880,'Libra'],
  [3968413880,3968628007,'Scorpio'],
  [3968628007,3968830719,'Sagittarius'],
  [3968830719,3969018700,'Capricorn'],
  [3969018700,3969194303,'Aquarius'],
  [3969194303,3969363981,'Pisces'],
  [3969363981,3969535554,'Aries'],
  [3969535554,3969716050,'Taurus'],
  [3969716050,3969909594,'Gemini'],
  [3969909594,3970115874,'Cancer'],
  [3970115874,3970330845,'Leo'],
  [3970330845,3970549465,'Virgo'],
  [3970549465,3970767718,'Libra'],
  [3970767718,3970981888,'Scorpio'],
  [3970981888,3971187708,'Sagittarius'],
  [3971187708,3971381678,'Capricorn'],
  [3971381678,3971563543,'Aquarius'],
  [3971563543,3971737023,'Pisces'],
  [3971737023,3971908436,'Aries'],
  [3971908436,3972084859,'Taurus'],
  [3972084859,3972272331,'Gemini'],
  [3972272331,3972473695,'Cancer'],
  [3972473695,3972686872,'Leo'],
  [3972686872,3972905615,'Virgo'],
  [3972905615,3973123262,'Libra'],
  [3973123262,3973335519,'Scorpio'],
  [3973335519,3973540285,'Sagittarius'],
  [3973540285,3973736477,'Capricorn'],
  [3973736477,3973923864,'Aquarius'],
  [3973923864,3974103840,'Pisces'],
  [3974103840,3974279854,'Aries'],
  [3974279854,3974457076,'Taurus'],
  [3974457076,3974641387,'Gemini'],
  [3974641387,3974837628,'Cancer'],
  [3974837628,3975046985,'Leo'],
  [3975046985,3975264874,'Virgo'],
  [3975264874,3975482793,'Libra'],
  [3975482793,3975693730,'Scorpio'],
  [3975693730,3975895341,'Sagittarius'],
  [3975895341,3976088893,'Capricorn'],
  [3976088893,3976276723,'Aquarius'],
  [3976276723,3976460794,'Pisces'],
  [3976460794,3976642740,'Aries'],
  [3976642740,3976824818,'Taurus'],
  [3976824818,3977010686,'Gemini'],
  [3977010686,3977204899,'Cancer'],
  [3977204899,3977410730,'Leo'],
  [3977410730,3977626786,'Virgo'],
  [3977626786,3977845499,'Libra'],
  [3977845499,3978057366,'Scorpio'],
  [3978057366,3978257424,'Sagittarius'],
  [3978257424,3978446937,'Capricorn'],
  [3978446937,3978630509,'Aquarius'],
  [3978630509,3978812801,'Pisces'],
  [3978812801,3978996713,'Aries'],
  [3978996713,3979183369,'Taurus'],
  [3979183369,3979373684,'Gemini'],
  [3979373684,3979569828,'Cancer'],
  [3979569828,3979774713,'Leo'],
  [3979774713,3979989131,'Virgo'],
  [3979989131,3980208378,'Libra'],
  [3980208378,3980422944,'Scorpio'],
  [3980422944,3980624934,'Sagittarius'],
  [3980624934,3980813233,'Capricorn'],
  [3980813233,3980992487,'Aquarius'],
  [3980992487,3981169324,'Pisces'],
  [3981169324,3981349392,'Aries'],
  [3981349392,3981535725,'Taurus'],
  [3981535725,3981728831,'Gemini'],
  [3981728831,3981928470,'Cancer'],
  [3981928470,3982135140,'Leo'],
  [3982135140,3982349333,'Virgo'],
  [3982349333,3982568627,'Libra'],
  [3982568627,3982785827,'Scorpio'],
  [3982785827,3982992183,'Sagittarius'],
  [3982992183,3983183512,'Capricorn'],
  [3983183512,3983362326,'Aquarius'],
  [3983362326,3983535142,'Pisces'],
  [3983535142,3983709202,'Aries'],
  [3983709202,3983890262,'Taurus'],
  [3983890262,3984081196,'Gemini'],
  [3984081196,3984281948,'Cancer'],
  [3984281948,3984490901,'Leo'],
  [3984490901,3984706233,'Virgo'],
  [3984706233,3984925489,'Libra'],
  [3984925489,3985143812,'Scorpio'],
  [3985143812,3985354163,'Sagittarius'],
  [3985354163,3985550965,'Capricorn'],
  [3985550965,3985733765,'Aquarius'],
  [3985733765,3985907058,'Pisces'],
  [3985907058,3986077742,'Aries'],
  [3986077742,3986252859,'Taurus'],
  [3986252859,3986437936,'Gemini'],
  [3986437936,3986635515,'Cancer'],
  [3986635515,3986844451,'Leo'],
  [3986844451,3987060892,'Virgo'],
  [3987060892,3987280318,'Libra'],
  [3987280318,3987498256,'Scorpio'],
  [3987498256,3987710033,'Sagittarius'],
  [3987710033,3987911306,'Capricorn'],
  [3987911306,3988100046,'Aquarius'],
  [3988100046,3988277967,'Pisces'],
  [3988277967,3988449931,'Aries'],
  [3988449931,3988622434,'Taurus'],
  [3988622434,3988802115,'Gemini'],
  [3988802115,3988994093,'Cancer'],
  [3988994093,3989199844,'Leo'],
  [3989199844,3989415850,'Virgo'],
  [3989415850,3989635441,'Libra'],
  [3989635441,3989852457,'Scorpio'],
  [3989852457,3990063091,'Sagittarius'],
  [3990063091,3990265373,'Capricorn'],
  [3990265373,3990458263,'Aquarius'],
  [3990458263,3990642013,'Pisces'],
  [3990642013,3990818865,'Aries'],
  [3990818865,3990993226,'Taurus'],
  [3990993226,3991171065,'Gemini'],
  [3991171065,3991358542,'Cancer'],
  [3991358542,3991559689,'Leo'],
  [3991559689,3991773403,'Virgo'],
  [3991773403,3991992770,'Libra'],
  [3991992770,3992209306,'Scorpio'],
  [3992209306,3992417974,'Sagittarius'],
  [3992417974,3992618101,'Capricorn'],
  [3992618101,3992811001,'Aquarius'],
  [3992811001,3992997953,'Pisces'],
  [3992997953,3993180033,'Aries'],
  [3993180033,3993359190,'Taurus'],
  [3993359190,3993539248,'Gemini'],
  [3993539248,3993725617,'Cancer'],
  [3993725617,3993923411,'Leo'],
  [3993923411,3994134131,'Virgo'],
  [3994134131,3994352764,'Libra'],
  [3994352764,3994569740,'Scorpio'],
  [3994569740,3994777597,'Sagittarius'],
  [3994777597,3994974900,'Capricorn'],
  [3994974900,3995164507,'Aquarius'],
  [3995164507,3995350063,'Pisces'],
  [3995350063,3995533948,'Aries'],
  [3995533948,3995717341,'Taurus'],
  [3995717341,3995901802,'Gemini'],
  [3995901802,3996090536,'Cancer'],
  [3996090536,3996287849,'Leo'],
  [3996287849,3996496540,'Virgo'],
  [3996496540,3996714220,'Libra'],
  [3996714220,3996932396,'Scorpio'],
  [3996932396,3997141661,'Sagittarius'],
  [3997141661,3997338177,'Capricorn'],
  [3997338177,3997524379,'Aquarius'],
  [3997524379,3997705500,'Pisces'],
  [3997705500,3997886376,'Aries'],
  [3997886376,3998069900,'Taurus'],
  [3998069900,3998257327,'Gemini'],
  [3998257327,3998449804,'Cancer'],
  [3998449804,3998649344,'Leo'],
  [3998649344,3998857990,'Virgo'],
  [3998857990,3999075021,'Libra'],
  [3999075021,3999294435,'Scorpio'],
  [3999294435,3999506919,'Sagittarius'],
  [3999506919,3999706017,'Capricorn'],
  [3999706017,3999891848,'Aquarius'],
  [3999891848,4000069322,'Pisces'],
  [4000069322,4000244782,'Aries'],
  [4000244782,4000423706,'Taurus'],
  [4000423706,4000609520,'Gemini'],
  [4000609520,4000803565,'Cancer'],
  [4000803565,4001005955,'Leo'],
  [4001005955,4001216328,'Virgo'],
  [4001216328,4001433449,'Libra'],
  [4001433449,4001653398,'Scorpio'],
  [4001653398,4001869060,'Sagittarius'],
  [4001869060,4002073185,'Capricorn'],
  [4002073185,4002262880,'Aquarius'],
  [4002262880,4002440758,'Pisces'],
  [4002440758,4002612737,'Aries'],
  [4002612737,4002785654,'Taurus'],
  [4002785654,4002965596,'Gemini'],
  [4002965596,4003156510,'Cancer'],
  [4003156510,4003359172,'Leo'],
  [4003359172,4003571346,'Virgo'],
  [4003571346,4003789330,'Libra'],
  [4003789330,4004009080,'Scorpio'],
  [4004009080,4004225903,'Sagittarius'],
  [4004225903,4004434420,'Capricorn'],
  [4004434420,4004630421,'Aquarius'],
  [4004630421,4004813364,'Pisces'],
  [4004813364,4004986763,'Aries'],
  [4004986763,4005156830,'Taurus'],
  [4005156830,4005330790,'Gemini'],
  [4005330790,4005515226,'Cancer'],
  [4005515226,4005713864,'Leo'],
  [4005713864,4005925427,'Virgo'],
  [4005925427,4006144195,'Libra'],
  [4006144195,4006363710,'Scorpio'],
  [4006363710,4006579561,'Sagittarius'],
  [4006579561,4006788998,'Capricorn'],
  [4006788998,4006989502,'Aquarius'],
  [4006989502,4007179205,'Pisces'],
  [4007179205,4007358513,'Aries'],
  [4007358513,4007531079,'Taurus'],
  [4007531079,4007703233,'Gemini'],
  [4007703233,4007882396,'Cancer'],
  [4007882396,4008074857,'Leo'],
  [4008074857,4008282494,'Virgo'],
  [4008282494,4008500490,'Libra'],
  [4008500490,4008720096,'Scorpio'],
  [4008720096,4008934634,'Sagittarius'],
  [4008934634,4009141961,'Capricorn'],
  [4009141961,4009342233,'Aquarius'],
  [4009342233,4009535373,'Pisces'],
  [4009535373,4009720893,'Aries'],
  [4009720893,4009899605,'Taurus'],
  [4009899605,4010075160,'Gemini'],
  [4010075160,4010253725,'Cancer'],
  [4010253725,4010442130,'Leo'],
  [4010442130,4010644812,'Virgo'],
  [4010644812,4010860081,'Libra'],
  [4010860081,4011079597,'Scorpio'],
  [4011079597,4011294065,'Sagittarius'],
  [4011294065,4011499300,'Capricorn'],
  [4011499300,4011696241,'Aquarius'],
  [4011696241,4011887428,'Pisces'],
  [4011887428,4012074464,'Aries'],
  [4012074464,4012257939,'Taurus'],
  [4012257939,4012439157,'Gemini'],
  [4012439157,4012621563,'Cancer'],
  [4012621563,4012810371,'Leo'],
  [4012810371,4013010404,'Virgo'],
  [4013010404,4013222618,'Libra'],
  [4013222618,4013441426,'Scorpio'],
  [4013441426,4013657115,'Sagittarius'],
  [4013657115,4013862636,'Capricorn'],
  [4013862636,4014057161,'Aquarius'],
  [4014057161,4014244030,'Pisces'],
  [4014244030,4014427365,'Aries'],
  [4014427365,4014610150,'Taurus'],
  [4014610150,4014794173,'Gemini'],
  [4014794173,4014981143,'Cancer'],
  [4014981143,4015173604,'Leo'],
  [4015173604,4015374549,'Virgo'],
  [4015374549,4015585414,'Libra'],
  [4015585414,4015803312,'Scorpio'],
  [4015803312,4016020566,'Sagittarius'],
  [4016020566,4016228811,'Capricorn'],
  [4016228811,4016424296,'Aquarius'],
  [4016424296,4016608839,'Pisces'],
  [4016608839,4016787305,'Aries'],
  [4016787305,4016965052,'Taurus'],
  [4016965052,4017146442,'Gemini'],
  [4017146442,4017334268,'Cancer'],
  [4017334268,4017529888,'Leo'],
  [4017529888,4017733729,'Virgo'],
  [4017733729,4017945462,'Libra'],
  [4017945462,4018162993,'Scorpio'],
  [4018162993,4018381262,'Sagittarius'],
  [4018381262,4018593032,'Capricorn'],
  [4018593032,4018792547,'Aquarius'],
  [4018792547,4018978800,'Pisces'],
  [4018978800,4019155320,'Aries'],
  [4019155320,4019328128,'Taurus'],
  [4019328128,4019503740,'Gemini'],
  [4019503740,4019687581,'Cancer'],
  [4019687581,4019882528,'Leo'],
  [4019882528,4020088164,'Virgo'],
  [4020088164,4020301704,'Libra'],
  [4020301704,4020519637,'Scorpio'],
  [4020519637,4020738094,'Sagittarius'],
  [4020738094,4020952219,'Capricorn'],
  [4020952219,4021156557,'Aquarius'],
  [4021156557,4021347756,'Pisces'],
  [4021347756,4021526665,'Aries'],
  [4021526665,4021698104,'Taurus'],
  [4021698104,4021869114,'Gemini'],
  [4021869114,4022047017,'Cancer'],
  [4022047017,4022237344,'Leo'],
  [4022237344,4022441427,'Virgo'],
  [4022441427,4022655683,'Libra'],
  [4022655683,4022874280,'Scorpio'],
  [4022874280,4023092411,'Sagittarius'],
  [4023092411,4023306773,'Capricorn'],
  [4023306773,4023514007,'Aquarius'],
  [4023514007,4023710581,'Pisces'],
  [4023710581,4023894940,'Aries'],
  [4023894940,4024069364,'Taurus'],
  [4024069364,4024239713,'Gemini'],
  [4024239713,4024413620,'Cancer'],
  [4024413620,4024598341,'Leo'],
  [4024598341,4024797918,'Virgo'],
  [4024797918,4025010481,'Libra'],
  [4025010481,4025229160,'Scorpio'],
  [4025229160,4025446937,'Sagittarius'],
  [4025446937,4025660052,'Capricorn'],
  [4025660052,4025866994,'Aquarius'],
  [4025866994,4026066169,'Pisces'],
  [4026066169,4026255772,'Aries'],
  [4026255772,4026435795,'Taurus'],
  [4026435795,4026609645,'Gemini'],
  [4026609645,4026783632,'Cancer'],
  [4026783632,4026965102,'Leo'],
  [4026965102,4027159847,'Virgo'],
  [4027159847,4027368784,'Libra'],
  [4027368784,4027586385,'Scorpio'],
  [4027586385,4027804088,'Sagittarius'],
  [4027804088,4028016008,'Capricorn'],
  [4028016008,4028220624,'Aquarius'],
  [4028220624,4028418423,'Pisces'],
  [4028418423,4028609612,'Aries'],
  [4028609612,4028794150,'Taurus'],
  [4028794150,4028973416,'Gemini'],
  [4028973416,4029151266,'Cancer'],
  [4029151266,4029333450,'Leo'],
  [4029333450,4029525754,'Virgo'],
  [4029525754,4029731087,'Libra'],
  [4029731087,4029946681,'Scorpio'],
  [4029946681,4030164578,'Sagittarius'],
  [4030164578,4030376691,'Capricorn'],
  [4030376691,4030579493,'Aquarius'],
  [4030579493,4030773823,'Pisces'],
  [4030773823,4030962162,'Aries'],
  [4030962162,4031146711,'Taurus'],
  [4031146711,4031329239,'Gemini'],
  [4031329239,4031511940,'Cancer'],
  [4031511940,4031698045,'Leo'],
  [4031698045,4031891464,'Virgo'],
  [4031891464,4032095206,'Libra'],
  [4032095206,4032308851,'Scorpio'],
  [4032308851,4032526930,'Sagittarius'],
  [4032526930,4032740939,'Capricorn'],
  [4032740939,4032944567,'Aquarius'],
  [4032944567,4033136794,'Pisces'],
  [4033136794,4033320666,'Aries'],
  [4033320666,4033500762,'Taurus'],
  [4033500762,4033681371,'Gemini'],
  [4033681371,4033865657,'Cancer'],
  [4033865657,4034055624,'Leo'],
  [4034055624,4034252582,'Virgo'],
  [4034252582,4034457511,'Libra'],
  [4034457511,4034670387,'Scorpio'],
  [4034670387,4034888384,'Sagittarius'],
  [4034888384,4035104942,'Capricorn'],
  [4035104942,4035312299,'Aquarius'],
  [4035312299,4035506291,'Pisces'],
  [4035506291,4035688231,'Aries'],
  [4035688231,4035863306,'Taurus'],
  [4035863306,4036038088,'Gemini'],
  [4036038088,4036218495,'Cancer'],
  [4036218495,4036408165,'Leo'],
  [4036408165,4036607640,'Virgo'],
  [4036607640,4036815274,'Libra'],
  [4036815274,4037029039,'Scorpio'],
  [4037029039,4037246859,'Sagittarius'],
  [4037246859,4037464949,'Capricorn'],
  [4037464949,4037676834,'Aquarius'],
  [4037676834,4037876174,'Pisces'],
  [4037876174,4038061007,'Aries'],
  [4038061007,4038234866,'Taurus'],
  [4038234866,4038404758,'Gemini'],
  [4038404758,4038578566,'Cancer'],
  [4038578566,4038762819,'Leo'],
  [4038762819,4038960317,'Virgo'],
  [4038960317,4039169056,'Libra'],
  [4039169056,4039384424,'Scorpio'],
  [4039384424,4039602467,'Sagittarius'],
  [4039602467,4039820461,'Capricorn'],
  [4039820461,4040034683,'Aquarius'],
  [4040034683,4040239606,'Pisces'],
  [4040239606,4040430863,'Aries'],
  [4040430863,4040608762,'Taurus'],
  [4040608762,4040778610,'Gemini'],
  [4040778610,4040948328,'Cancer'],
  [4040948328,4041126006,'Leo'],
  [4041126006,4041317411,'Virgo'],
  [4041317411,4041523218,'Libra'],
  [4041523218,4041738678,'Scorpio'],
  [4041738678,4041957250,'Sagittarius'],
  [4041957250,4042174514,'Capricorn'],
  [4042174514,4042388046,'Aquarius'],
  [4042388046,4042594990,'Pisces'],
  [4042594990,4042791723,'Aries'],
  [4042791723,4042976367,'Taurus'],
  [4042976367,4043151172,'Gemini'],
  [4043151172,4043322130,'Cancer'],
  [4043322130,4043496882,'Leo'],
  [4043496882,4043682468,'Virgo'],
  [4043682468,4043882604,'Libra'],
  [4043882604,4044095298,'Scorpio'],
  [4044095298,4044313697,'Sagittarius'],
  [4044313697,4044530695,'Capricorn'],
  [4044530695,4044742439,'Aquarius'],
  [4044742439,4044947546,'Pisces'],
  [4044947546,4045145048,'Aries'],
  [4045145048,4045334038,'Taurus'],
  [4045334038,4045515095,'Gemini'],
  [4045515095,4045691400,'Cancer'],
  [4045691400,4045868359,'Leo'],
  [4045868359,4046052176,'Virgo'],
  [4046052176,4046247785,'Libra'],
  [4046247785,4046456266,'Scorpio'],
  [4046456266,4046673164,'Sagittarius'],
  [4046673164,4046890444,'Capricorn'],
  [4046890444,4047101507,'Aquarius'],
  [4047101507,4047303885,'Pisces'],
  [4047303885,4047498231,'Aries'],
  [4047498231,4047686292,'Taurus'],
  [4047686292,4047869943,'Gemini'],
  [4047869943,4048051332,'Cancer'],
  [4048051332,4048233354,'Leo'],
  [4048233354,4048419773,'Virgo'],
  [4048419773,4048614540,'Libra'],
  [4048614540,4048820083,'Scorpio'],
  [4048820083,4049034915,'Sagittarius'],
  [4049034915,4049252599,'Capricorn'],
  [4049252599,4049464818,'Aquarius'],
  [4049464818,4049666447,'Pisces'],
  [4049666447,4049857437,'Aries'],
  [4049857437,4050041222,'Taurus'],
  [4050041222,4050222257,'Gemini'],
  [4050222257,4050404316,'Cancer'],
  [4050404316,4050589887,'Leo'],
  [4050589887,4050780530,'Virgo'],
  [4050780530,4050977737,'Libra'],
  [4050977737,4051183061,'Scorpio'],
  [4051183061,4051396585,'Sagittarius'],
  [4051396585,4051614535,'Capricorn'],
  [4051614535,4051829130,'Aquarius'],
  [4051829130,4052032889,'Pisces'],
  [4052032889,4052223345,'Aries'],
  [4052223345,4052403563,'Taurus'],
  [4052403563,4052579580,'Gemini'],
  [4052579580,4052757618,'Cancer'],
  [4052757618,4052942115,'Leo'],
  [4052942115,4053134736,'Virgo'],
  [4053134736,4053335037,'Libra'],
  [4053335037,4053542244,'Scorpio'],
  [4053542244,4053755863,'Sagittarius'],
  [4053755863,4053973927,'Capricorn'],
  [4053973927,4054190825,'Aquarius'],
  [4054190825,4054398601,'Pisces'],
  [4054398601,4054592093,'Aries'],
  [4054592093,4054772249,'Taurus'],
  [4054772249,4054944877,'Gemini'],
  [4054944877,4055117542,'Cancer'],
  [4055117542,4055297021,'Leo'],
  [4055297021,4055487225,'Virgo'],
  [4055487225,4055688165,'Libra'],
  [4055688165,4055897303,'Scorpio'],
  [4055897303,4056112012,'Sagittarius'],
  [4056112012,4056330157,'Capricorn'],
  [4056330157,4056548139,'Aquarius'],
  [4056548139,4056759628,'Pisces'],
  [4056759628,4056958294,'Aries'],
  [4056958294,4057142304,'Taurus'],
  [4057142304,4057315549,'Gemini'],
  [4057315549,4057485281,'Cancer'],
  [4057485281,4057659360,'Leo'],
  [4057659360,4057844031,'Virgo'],
  [4057844031,4058041778,'Libra'],
  [4058041778,4058250665,'Scorpio'],
  [4058250665,4058466294,'Sagittarius'],
  [4058466294,4058684587,'Capricorn'],
  [4058684587,4058902240,'Aquarius'],
  [4058902240,4059115107,'Pisces'],
  [4059115107,4059318114,'Aries'],
  [4059318114,4059507956,'Taurus'],
  [4059507956,4059685788,'Gemini'],
  [4059685788,4059856929,'Cancer'],
  [4059856929,4060028679,'Leo'],
  [4060028679,4060208217,'Virgo'],
  [4060208217,4060400481,'Libra'],
  [4060400481,4060606136,'Scorpio'],
  [4060606136,4060821237,'Sagittarius'],
  [4060821237,4061039671,'Capricorn'],
  [4061039671,4061256407,'Aquarius'],
  [4061256407,4061468072,'Pisces'],
  [4061468072,4061671975,'Aries'],
  [4061671975,4061865970,'Taurus'],
  [4061865970,4062049782,'Gemini'],
  [4062049782,4062226068,'Cancer'],
  [4062226068,4062399981,'Leo'],
  [4062399981,4062577860,'Virgo'],
  [4062577860,4062765594,'Libra'],
  [4062765594,4062966499,'Scorpio'],
  [4062966499,4063179194,'Sagittarius'],
  [4063179194,4063397467,'Capricorn'],
  [4063397467,4063613834,'Aquarius'],
  [4063613834,4063823463,'Pisces'],
  [4063823463,4064024896,'Aries'],
  [4064024896,4064218576,'Taurus'],
  [4064218576,4064405544,'Gemini'],
  [4064405544,4064587367,'Cancer'],
  [4064587367,4064766629,'Leo'],
  [4064766629,4064947230,'Virgo'],
  [4064947230,4065134015,'Libra'],
  [4065134015,4065331387,'Scorpio'],
  [4065331387,4065540812,'Sagittarius'],
  [4065540812,4065758322,'Capricorn'],
  [4065758322,4065975445,'Aquarius'],
  [4065975445,4066184539,'Pisces'],
  [4066184539,4066382999,'Aries'],
  [4066382999,4066572798,'Taurus'],
  [4066572798,4066757681,'Gemini'],
  [4066757681,4066940926,'Cancer'],
  [4066940926,4067124605,'Leo'],
  [4067124605,4067310223,'Virgo'],
  [4067310223,4067499972,'Libra'],
  [4067499972,4067697089,'Scorpio'],
  [4067697089,4067904302,'Sagittarius'],
  [4067904302,4068120612,'Capricorn'],
  [4068120612,4068339137,'Aquarius'],
  [4068339137,4068550304,'Pisces'],
  [4068550304,4068748536,'Aries'],
  [4068748536,4068934912,'Taurus'],
  [4068934912,4069114707,'Gemini'],
  [4069114707,4069293894,'Cancer'],
  [4069293894,4069476781,'Leo'],
  [4069476781,4069665092,'Virgo'],
  [4069665092,4069858951,'Libra'],
  [4069858951,4070058863,'Scorpio'],
  [4070058863,4070266317,'Sagittarius'],
  [4070266317,4070481780,'Capricorn'],
  [4070481780,4070701303,'Aquarius'],
  [4070701303,4070916071,'Pisces'],
  [4070916071,4071117863,'Aries'],
  [4071117863,4071304824,'Taurus'],
  [4071304824,4071481419,'Gemini'],
  [4071481419,4071654859,'Cancer'],
  [4071654859,4071832013,'Leo'],
  [4071832013,4072017333,'Virgo'],
  [4072017333,4072211914,'Libra'],
  [4072211914,4072414639,'Scorpio'],
  [4072414639,4072624264,'Sagittarius'],
  [4072624264,4072840036,'Capricorn'],
  [4072840036,4073059702,'Aquarius'],
  [4073059702,4073277174,'Pisces'],
  [4073277174,4073484260,'Aries'],
  [4073484260,4073676146,'Taurus'],
  [4073676146,4073854480,'Gemini'],
  [4073854480,4074025531,'Cancer'],
  [4074025531,4074196976,'Leo'],
  [4074196976,4074375627,'Virgo'],
  [4074375627,4074565629,'Libra'],
  [4074565629,4074767438,'Scorpio'],
  [4074767438,4074978554,'Sagittarius'],
  [4074978554,4075195513,'Capricorn'],
  [4075195513,4075415025,'Aquarius'],
  [4075415025,4075632914,'Pisces'],
  [4075632914,4075843447,'Aries'],
  [4075843447,4076041445,'Taurus'],
  [4076041445,4076225659,'Gemini'],
  [4076225659,4076399608,'Cancer'],
  [4076399608,4076569747,'Leo'],
  [4076569747,4076743315,'Virgo'],
  [4076743315,4076926638,'Libra'],
  [4076926638,4077123336,'Scorpio'],
  [4077123336,4077332756,'Sagittarius'],
  [4077332756,4077550223,'Capricorn'],
  [4077550223,4077769807,'Aquarius'],
  [4077769807,4077986648,'Pisces'],
  [4077986648,4078197110,'Aries'],
  [4078197110,4078398255,'Taurus'],
  [4078398255,4078588449,'Gemini'],
  [4078588449,4078768610,'Cancer'],
  [4078768610,4078942464,'Leo'],
  [4078942464,4079115751,'Virgo'],
  [4079115751,4079294986,'Libra'],
  [4079294986,4079485842,'Scorpio'],
  [4079485842,4079690781,'Sagittarius'],
  [4079690781,4079906796,'Capricorn'],
  [4079906796,4080126421,'Aquarius'],
  [4080126421,4080342335,'Pisces'],
  [4080342335,4080550679,'Aries'],
  [4080550679,4080750741,'Taurus'],
  [4080750741,4080942987,'Gemini'],
  [4080942987,4081128213,'Cancer'],
  [4081128213,4081307953,'Leo'],
  [4081307953,4081485270,'Virgo'],
  [4081485270,4081665014,'Libra'],
  [4081665014,4081852923,'Scorpio'],
  [4081852923,4082053469,'Sagittarius'],
  [4082053469,4082266582,'Capricorn'],
  [4082266582,4082485792,'Aquarius'],
  [4082485792,4082701761,'Pisces'],
  [4082701761,4082908466,'Aries'],
  [4082908466,4083105427,'Taurus'],
  [4083105427,4083295337,'Gemini'],
  [4083295337,4083481084,'Cancer'],
  [4083481084,4083664484,'Leo'],
  [4083664484,4083846853,'Virgo'],
  [4083846853,4084030494,'Libra'],
  [4084030494,4084219405,'Scorpio'],
  [4084219405,4084418109,'Sagittarius'],
  [4084418109,4084628626,'Capricorn'],
  [4084628626,4084847046,'Aquarius'],
  [4084847046,4085064043,'Pisces'],
  [4085064043,4085271162,'Aries'],
  [4085271162,4085466142,'Taurus'],
  [4085466142,4085652192,'Gemini'],
  [4085652192,4085834334,'Cancer'],
  [4085834334,4086016593,'Leo'],
  [4086016593,4086201020,'Virgo'],
  [4086201020,4086388598,'Libra'],
  [4086388598,4086580938,'Scorpio'],
  [4086580938,4086780804,'Sagittarius'],
  [4086780804,4086990429,'Capricorn'],
  [4086990429,4087208153,'Aquarius'],
  [4087208153,4087426578,'Pisces'],
  [4087426578,4087636242,'Aries'],
  [4087636242,4087832231,'Taurus'],
  [4087832231,4088016316,'Gemini'],
  [4088016316,4088194096,'Cancer'],
  [4088194096,4088371629,'Leo'],
  [4088371629,4088553352,'Virgo'],
  [4088553352,4088741419,'Libra'],
  [4088741419,4088936500,'Scorpio'],
  [4088936500,4089139072,'Sagittarius'],
  [4089139072,4089349671,'Capricorn'],
  [4089349671,4089567223,'Aquarius'],
  [4089567223,4089786686,'Pisces'],
  [4089786686,4089999758,'Aries'],
  [4089999758,4090199686,'Taurus'],
  [4090199686,4090385548,'Gemini'],
  [4090385548,4090561666,'Cancer'],
  [4090561666,4090734599,'Leo'],
  [4090734599,4090910748,'Virgo'],
  [4090910748,4091094839,'Libra'],
  [4091094839,4091289088,'Scorpio'],
  [4091289088,4091493282,'Sagittarius'],
  [4091493282,4091705654,'Capricorn'],
  [4091705654,4091923654,'Aquarius'],
  [4091923654,4092143319,'Pisces'],
  [4092143319,4092358707,'Aries'],
  [4092358707,4092563516,'Taurus'],
  [4092563516,4092754491,'Gemini'],
  [4092754491,4092933256,'Cancer'],
  [4092933256,4093105055,'Leo'],
  [4093105055,4093276665,'Virgo'],
  [4093276665,4093454731,'Libra'],
  [4093454731,4093644211,'Scorpio'],
  [4093644211,4093846721,'Sagittarius'],
  [4093846721,4094059817,'Capricorn'],
  [4094059817,4094278533,'Aquarius'],
  [4094278533,4094497798,'Pisces'],
  [4094497798,4094713242,'Aries'],
  [4094713242,4094920890,'Taurus'],
  [4094920890,4095117506,'Gemini'],
  [4095117506,4095302235,'Cancer'],
  [4095302235,4095477549,'Leo'],
  [4095477549,4095648756,'Virgo'],
  [4095648756,4095822716,'Libra'],
  [4095822716,4096006254,'Scorpio'],
  [4096006254,4096203893,'Sagittarius'],
  [4096203893,4096415135,'Capricorn'],
  [4096415135,4096634029,'Aquarius'],
  [4096634029,4096852976,'Pisces'],
  [4096852976,4097066909,'Aries'],
  [4097066909,4097273828,'Taurus'],
  [4097273828,4097472827,'Gemini'],
  [4097472827,4097663082,'Cancer'],
  [4097663082,4097844718,'Leo'],
  [4097844718,4098020184,'Virgo'],
  [4098020184,4098194639,'Libra'],
  [4098194639,4098374895,'Scorpio'],
  [4098374895,4098567305,'Sagittarius'],
  [4098567305,4098774446,'Capricorn'],
  [4098774446,4098992136,'Aquarius'],
  [4098992136,4099211223,'Pisces'],
  [4099211223,4099424039,'Aries'],
  [4099424039,4099628248,'Taurus'],
  [4099628248,4099825136,'Gemini'],
  [4099825136,4100016334,'Cancer'],
  [4100016334,4100202427,'Leo'],
  [4100202427,4100383901,'Virgo'],
  [4100383901,4100563058,'Libra'],
  [4100563058,4100744705,'Scorpio'],
  [4100744705,4100934911,'Sagittarius'],
  [4100934911,4101138148,'Capricorn'],
  [4101138148,4101353401,'Aquarius'],
  [4101353401,4101572723,'Pisces'],
  [4101572723,4101786225,'Aries'],
  [4101786225,4101988980,'Taurus'],
  [4101988980,4102182149,'Gemini'],
  [4102182149,4102369557,'Cancer'],
  [4102369557,4102554474,'Leo'],
  [4102554474,4102738506,'Virgo'],
  [4102738506,4102922617,'Libra'],
  [4102922617,4103108894,'Scorpio'],
  [4103108894,4103301088,'Sagittarius'],
  [4103301088,4103503190,'Capricorn'],
  [4103503190,4103716267,'Aquarius'],
  [4103716267,4103935408,'Pisces'],
  [4103935408,4104151073,'Aries'],
  [4104151073,4104355538,'Taurus'],
  [4104355538,4104547474,'Gemini'],
  [4104547474,4104730610,'Cancer'],
  [4104730610,4104910254,'Leo'],
  [4104910254,4105090877,'Virgo'],
  [4105090877,4105275236,'Libra'],
  [4105275236,4105464841,'Scorpio'],
  [4105464841,4105660976,'Sagittarius'],
  [4105660976,4105865101,'Capricorn'],
  [4105865101,4106077818,'Aquarius'],
  [4106077818,4106296515,'Pisces'],
  [4106296515,4106514276,'Aries'],
  [4106514276,4106722808,'Taurus'],
  [4106722808,4106917675,'Gemini'],
  [4106917675,4107100241,'Cancer'],
  [4107100241,4107275635,'Leo'],
  [4107275635,4107450122,'Virgo'],
  [4107450122,4107629326,'Libra'],
  [4107629326,4107817068,'Scorpio'],
  [4107817068,4108014762,'Sagittarius'],
  [4108014762,4108221663,'Capricorn'],
  [4108221663,4108435841,'Aquarius'],
  [4108435841,4108654476,'Pisces'],
  [4108654476,4108873084,'Aries'],
  [4108873084,4109085401,'Taurus'],
  [4109085401,4109285738,'Gemini'],
  [4109285738,4109472316,'Cancer'],
  [4109472316,4109648003,'Leo'],
  [4109648003,4109818781,'Virgo'],
  [4109818781,4109991760,'Libra'],
  [4109991760,4110173456,'Scorpio'],
  [4110173456,4110367908,'Sagittarius'],
  [4110367908,4110574953,'Capricorn'],
  [4110574953,4110790606,'Aquarius'],
  [4110790606,4111009751,'Pisces'],
  [4111009751,4111228095,'Aries'],
  [4111228095,4111441817,'Taurus'],
  [4111441817,4111646683,'Gemini'],
  [4111646683,4111839391,'Cancer'],
  [4111839391,4112019804,'Leo'],
  [4112019804,4112191746,'Virgo'],
  [4112191746,4112361896,'Libra'],
  [4112361896,4112537910,'Scorpio'],
  [4112537910,4112726329,'Sagittarius'],
  [4112726329,4112929746,'Capricorn'],
  [4112929746,4113144810,'Aquarius'],
  [4113144810,4113364353,'Pisces'],
  [4113364353,4113582146,'Aries'],
  [4113582146,4113794983,'Taurus'],
  [4113794983,4114001001,'Gemini'],
  [4114001001,4114198042,'Cancer'],
  [4114198042,4114384528,'Leo'],
  [4114384528,4114561513,'Virgo'],
  [4114561513,4114733582,'Libra'],
  [4114733582,4114907739,'Scorpio'],
  [4114907739,4115091388,'Sagittarius'],
  [4115091388,4115289566,'Capricorn'],
  [4115289566,4115501607,'Aquarius'],
  [4115501607,4115720595,'Pisces'],
  [4115720595,4115938105,'Aries'],
  [4115938105,4116149394,'Taurus'],
  [4116149394,4116353590,'Gemini'],
  [4116353590,4116550857,'Cancer'],
  [4116550857,4116740771,'Leo'],
  [4116740771,4116923225,'Virgo'],
  [4116923225,4117100313,'Libra'],
  [4117100313,4117276922,'Scorpio'],
  [4117276922,4117459563,'Sagittarius'],
  [4117459563,4117654068,'Capricorn'],
  [4117654068,4117862302,'Aquarius'],
  [4117862302,4118079682,'Pisces'],
  [4118079682,4118297286,'Aries'],
  [4118297286,4118507982,'Taurus'],
  [4118507982,4118709776,'Gemini'],
  [4118709776,4118904099,'Cancer'],
  [4118904099,4119092895,'Leo'],
  [4119092895,4119277418,'Virgo'],
  [4119277418,4119458995,'Libra'],
  [4119458995,4119640295,'Scorpio'],
  [4119640295,4119825608,'Sagittarius'],
  [4119825608,4120019724,'Capricorn'],
  [4120019724,4120225500,'Aquarius'],
  [4120225500,4120440991,'Pisces'],
  [4120440991,4120658913,'Aries'],
  [4120658913,4120870709,'Taurus'],
  [4120870709,4121071901,'Gemini'],
  [4121071901,4121263163,'Cancer'],
  [4121263163,4121447883,'Leo'],
  [4121447883,4121629770,'Virgo'],
  [4121629770,4121811811,'Libra'],
  [4121811811,4121996371,'Scorpio'],
  [4121996371,4122185750,'Sagittarius'],
  [4122185750,4122382383,'Capricorn'],
  [4122382383,4122588140,'Aquarius'],
  [4122588140,4122802469,'Pisces'],
  [4122802469,4123020679,'Aries'],
  [4123020679,4123234879,'Taurus'],
  [4123234879,4123438329,'Gemini'],
  [4123438329,4123629249,'Cancer'],
  [4123629249,4123810523,'Leo'],
  [4123810523,4123987372,'Virgo'],
  [4123987372,4124165292,'Libra'],
  [4124165292,4124348657,'Scorpio'],
  [4124348657,4124539942,'Sagittarius'],
  [4124539942,4124739731,'Capricorn'],
  [4124739731,4124947471,'Aquarius'],
  [4124947471,4125161913,'Pisces'],
  [4125161913,4125380194,'Aries'],
  [4125380194,4125596756,'Taurus'],
  [4125596756,4125804521,'Gemini'],
  [4125804521,4125998888,'Cancer'],
  [4125998888,4126180360,'Leo'],
  [4126180360,4126353773,'Virgo'],
  [4126353773,4126526042,'Libra'],
  [4126526042,4126704038,'Scorpio'],
  [4126704038,4126892630,'Sagittarius'],
  [4126892630,4127093007,'Capricorn'],
  [4127093007,4127302809,'Aquarius'],
  [4127302809,4127518400,'Pisces'],
  [4127518400,4127736628,'Aries'],
  [4127736628,4127954116,'Taurus'],
  [4127954116,4128165746,'Gemini'],
  [4128165746,4128365871,'Cancer'],
  [4128365871,4128551918,'Leo'],
  [4128551918,4128726384,'Virgo'],
  [4128726384,4128895731,'Libra'],
  [4128895731,4129067970,'Scorpio'],
  [4129067970,4129250420,'Sagittarius'],
  [4129250420,4129447053,'Capricorn'],
  [4129447053,4129656415,'Aquarius'],
  [4129656415,4129873013,'Pisces'],
  [4129873013,4130091378,'Aries'],
  [4130091378,4130308227,'Taurus'],
  [4130308227,4130520865,'Gemini'],
  [4130520865,4130725364,'Cancer'],
  [4130725364,4130917897,'Leo'],
  [4130917897,4131097881,'Virgo'],
  [4131097881,4131269395,'Libra'],
  [4131269395,4131439686,'Scorpio'],
  [4131439686,4131616839,'Sagittarius'],
  [4131616839,4131807280,'Capricorn'],
  [4131807280,4132012649,'Aquarius'],
  [4132012649,4132228420,'Pisces'],
  [4132228420,4132447048,'Aries'],
  [4132447048,4132662980,'Taurus'],
  [4132662980,4132873930,'Gemini'],
  [4132873930,4133078544,'Cancer'],
  [4133078544,4133274791,'Leo'],
  [4133274791,4133461097,'Virgo'],
  [4133461097,4133638679,'Libra'],
  [4133638679,4133812233,'Scorpio'],
  [4133812233,4133988606,'Sagittarius'],
  [4133988606,4134174697,'Capricorn'],
  [4134174697,4134374708,'Aquarius'],
  [4134374708,4134587313,'Pisces'],
  [4134587313,4134805605,'Aries'],
  [4134805605,4135021547,'Taurus'],
  [4135021547,4135230675,'Gemini'],
  [4135230675,4135432274,'Cancer'],
  [4135432274,4135626991,'Leo'],
  [4135626991,4135815346,'Virgo'],
  [4135815346,4135998150,'Libra'],
  [4135998150,4136177656,'Scorpio'],
  [4136177656,4136357966,'Sagittarius'],
  [4136357966,4136544291,'Capricorn'],
  [4136544291,4136741211,'Aquarius'],
  [4136741211,4136950121,'Pisces'],
  [4136950121,4137167078,'Aries'],
  [4137167078,4137383922,'Taurus'],
  [4137383922,4137593310,'Gemini'],
  [4137593310,4137792535,'Cancer'],
  [4137792535,4137983031,'Leo'],
  [4137983031,4138168004,'Virgo'],
  [4138168004,4138350647,'Libra'],
  [4138350647,4138533544,'Scorpio'],
  [4138533544,4138718917,'Sagittarius'],
  [4138718917,4138909159,'Capricorn'],
  [4138909159,4139106928,'Aquarius'],
  [4139106928,4139314087,'Pisces'],
  [4139314087,4139529487,'Aries'],
  [4139529487,4139747319,'Taurus'],
  [4139747319,4139959175,'Gemini'],
  [4139959175,4140159264,'Cancer'],
  [4140159264,4140347307,'Leo'],
  [4140347307,4140527348,'Virgo'],
  [4140527348,4140705085,'Libra'],
  [4140705085,4140885657,'Scorpio'],
  [4140885657,4141072323,'Sagittarius'],
  [4141072323,4141266188,'Capricorn'],
  [4141266188,4141467201,'Aquarius'],
  [4141467201,4141675338,'Pisces'],
  [4141675338,4141890131,'Aries'],
  [4141890131,4142108483,'Taurus'],
  [4142108483,4142323474,'Gemini'],
  [4142323474,4142527461,'Cancer'],
  [4142527461,4142717128,'Leo'],
  [4142717128,4142895106,'Virgo'],
  [4142895106,4143067823,'Libra'],
  [4143067823,4143242577,'Scorpio'],
  [4143242577,4143425266,'Sagittarius'],
  [4143425266,4143618587,'Capricorn'],
  [4143618587,4143821671,'Aquarius'],
  [4143821671,4144031999,'Pisces'],
  [4144031999,4144247459,'Aries'],
  [4144247459,4144465922,'Taurus'],
  [4144465922,4144682956,'Gemini'],
  [4144682956,4144891568,'Cancer'],
  [4144891568,4145086161,'Leo'],
  [4145086161,4145266550,'Virgo'],
  [4145266550,4145437930,'Libra'],
  [4145437930,4145608058,'Scorpio'],
  [4145608058,4145784640,'Sagittarius'],
  [4145784640,4145973069,'Capricorn'],
  [4145973069,4146174408,'Aquarius'],
  [4146174408,4146385559,'Pisces'],
  [4146385559,4146602084,'Aries'],
  [4146602084,4146820567,'Taurus'],
  [4146820567,4147037866,'Gemini'],
  [4147037866,4147249215,'Cancer'],
  [4147249215,4147449124,'Leo'],
  [4147449124,4147635035,'Virgo'],
  [4147635035,4147809556,'Libra'],
  [4147809556,4147979189,'Scorpio'],
  [4147979189,4148151778,'Sagittarius'],
  [4148151778,4148334326,'Capricorn'],
  [4148334326,4148530664,'Aquarius'],
  [4148530664,4148739701,'Pisces'],
  [4148739701,4148956329,'Aries'],
  [4148956329,4149174852,'Taurus'],
  [4149174852,4149391273,'Gemini'],
  [4149391273,4149602437,'Cancer'],
  [4149602437,4149804940,'Leo'],
  [4149804940,4149996141,'Virgo'],
  [4149996141,4150176402,'Libra'],
  [4150176402,4150349759,'Scorpio'],
  [4150349759,4150522605,'Sagittarius'],
  [4150522605,4150701862,'Capricorn'],
  [4150701862,4150892992,'Aquarius'],
  [4150892992,4151097736,'Pisces'],
  [4151097736,4151312745,'Aries'],
  [4151312745,4151531171,'Taurus'],
  [4151531171,4151746753,'Gemini'],
  [4151746753,4151955957,'Cancer'],
  [4151955957,4152157315,'Leo'],
  [4152157315,4152350273,'Virgo'],
  [4152350273,4152535205,'Libra'],
  [4152535205,4152714156,'Scorpio'],
  [4152714156,4152891051,'Sagittarius'],
  [4152891051,4153071117,'Capricorn'],
  [4153071117,4153259695,'Aquarius'],
  [4153259695,4153460353,'Pisces'],
  [4153460353,4153672552,'Aries'],
  [4153672552,4153890553,'Taurus'],
  [4153890553,4154106231,'Gemini'],
  [4154106231,4154313889,'Cancer'],
  [4154313889,4154512164,'Leo'],
  [4154512164,4154702689,'Virgo'],
  [4154702689,4154888009,'Libra'],
  [4154888009,4155070510,'Scorpio'],
  [4155070510,4155252459,'Sagittarius'],
  [4155252459,4155436555,'Capricorn'],
  [4155436555,4155626276,'Aquarius'],
  [4155626276,4155825185,'Pisces'],
  [4155825185,4156034845,'Aries'],
  [4156034845,4156252118,'Taurus'],
  [4156252118,4156468990,'Gemini'],
  [4156468990,4156677240,'Cancer'],
  [4156677240,4156873552,'Leo'],
  [4156873552,4157060034,'Virgo'],
  [4157060034,4157241486,'Libra'],
  [4157241486,4157422641,'Scorpio'],
  [4157422641,4157606612,'Sagittarius'],
  [4157606612,4157794814,'Capricorn'],
  [4157794814,4157988180,'Aquarius'],
  [4157988180,4158188344,'Pisces'],
  [4158188344,4158397077,'Aries'],
  [4158397077,4158613618,'Taurus'],
  [4158613618,4158832095,'Gemini'],
  [4158832095,4159043318,'Cancer'],
  [4159043318,4159241018,'Leo'],
  [4159241018,4159425587,'Virgo'],
  [4159425587,4159602395,'Libra'],
  [4159602395,4159778322,'Scorpio'],
  [4159778322,4159959073,'Sagittarius'],
  [4159959073,4160147520,'Capricorn'],
  [4160147520,4160343720,'Aquarius'],
  [4160343720,4160546816,'Pisces'],
  [4160546816,4160756633,'Aries'],
  [4160756633,4160972902,'Taurus'],
  [4160972902,4161192337,'Gemini'],
  [4161192337,4161407280,'Cancer'],
  [4161407280,4161609643,'Leo'],
  [4161609643,4161796691,'Virgo'],
  [4161796691,4161972194,'Libra'],
  [4161972194,4162143403,'Scorpio'],
  [4162143403,4162317934,'Sagittarius'],
  [4162317934,4162501500,'Capricorn'],
  [4162501500,4162696223,'Aquarius'],
  [4162696223,4162900795,'Pisces'],
  [4162900795,4163112586,'Aries'],
  [4163112586,4163329398,'Taurus'],
  [4163329398,4163548765,'Gemini'],
  [4163548765,4163765723,'Cancer'],
  [4163765723,4163973213,'Leo'],
  [4163973213,4164166260,'Virgo'],
  [4164166260,4164345499,'Libra'],
  [4164345499,4164516469,'Scorpio'],
  [4164516469,4164686774,'Sagittarius'],
  [4164686774,4164863772,'Capricorn'],
  [4164863772,4165052611,'Aquarius'],
  [4165052611,4165254518,'Pisces'],
  [4165254518,4165466712,'Aries'],
  [4165466712,4165684451,'Taurus'],
  [4165684451,4165903437,'Gemini'],
  [4165903437,4166119860,'Cancer'],
  [4166119860,4166329405,'Leo'],
  [4166329405,4166527931,'Virgo'],
  [4166527931,4166713876,'Libra'],
  [4166713876,4166889696,'Scorpio'],
  [4166889696,4167060982,'Sagittarius'],
  [4167060982,4167234678,'Capricorn'],
  [4167234678,4167417383,'Aquarius'],
  [4167417383,4167613430,'Pisces'],
  [4167613430,4167822774,'Aries'],
  [4167822774,4168040454,'Taurus'],
  [4168040454,4168259452,'Gemini'],
  [4168259452,4168474352,'Cancer'],
  [4168474352,4168682292,'Leo'],
  [4168682292,4168881894,'Virgo'],
  [4168881894,4169072547,'Libra'],
  [4169072547,4169254927,'Scorpio'],
  [4169254927,4169431656,'Sagittarius'],
  [4169431656,4169607348,'Capricorn'],
  [4169607348,4169787884,'Aquarius'],
  [4169787884,4169978941,'Pisces'],
  [4169978941,4170183561,'Aries'],
  [4170183561,4170399339,'Taurus'],
  [4170399339,4170618522,'Gemini'],
  [4170618522,4170832857,'Cancer'],
  [4170832857,4171038230,'Leo'],
  [4171038230,4171234912,'Virgo'],
  [4171234912,4171425000,'Libra'],
  [4171425000,4171610444,'Scorpio'],
  [4171610444,4171792720,'Sagittarius'],
  [4171792720,4171973723,'Capricorn'],
  [4171973723,4172156838,'Aquarius'],
  [4172156838,4172346832,'Pisces'],
  [4172346832,4172548046,'Aries'],
  [4172548046,4172761075,'Taurus'],
  [4172761075,4172980107,'Gemini'],
  [4172980107,4173195411,'Cancer'],
  [4173195411,4173400080,'Leo'],
  [4173400080,4173593536,'Virgo'],
  [4173593536,4173779525,'Libra'],
  [4173779525,4173962593,'Scorpio'],
  [4173962593,4174145891,'Sagittarius'],
  [4174145891,4174330847,'Capricorn'],
  [4174330847,4174518518,'Aquarius'],
  [4174518518,4174711171,'Pisces'],
  [4174711171,4174912160,'Aries'],
  [4174912160,4175123456,'Taurus'],
  [4175123456,4175342046,'Gemini'],
  [4175342046,4175559206,'Cancer'],
  [4175559206,4175765875,'Leo'],
  [4175765875,4175958899,'Virgo'],
  [4175958899,4176141469,'Libra'],
  [4176141469,4176319608,'Scorpio'],
  [4176319608,4176498949,'Sagittarius'],
  [4176498949,4176682970,'Capricorn'],
  [4176682970,4176872859,'Aquarius'],
  [4176872859,4177068966,'Pisces'],
  [4177068966,4177272227,'Aries'],
  [4177272227,4177483726,'Taurus'],
  [4177483726,4177702045,'Gemini'],
  [4177702045,4177920890,'Cancer'],
  [4177920890,4178131205,'Leo'],
  [4178131205,4178327258,'Virgo'],
  [4178327258,4178509951,'Libra'],
  [4178509951,4178684846,'Scorpio'],
  [4178684846,4178858819,'Sagittarius'],
  [4178858819,4179037749,'Capricorn'],
  [4179037749,4179225159,'Aquarius'],
  [4179225159,4179421988,'Pisces'],
  [4179421988,4179627529,'Aries'],
  [4179627529,4179840549,'Taurus'],
  [4179840549,4180059076,'Gemini'],
  [4180059076,4180278680,'Cancer'],
  [4180278680,4180492264,'Leo'],
  [4180492264,4180693285,'Virgo'],
  [4180693285,4180879912,'Libra'],
  [4180879912,4181055606,'Scorpio'],
  [4181055606,4181226728,'Sagittarius'],
  [4181226728,4181400210,'Capricorn'],
  [4181400210,4181581930,'Aquarius'],
  [4181581930,4181775347,'Pisces'],
  [4181775347,4181980593,'Aries'],
  [4181980593,4182194821,'Taurus'],
  [4182194821,4182413890,'Gemini'],
  [4182413890,4182633316,'Cancer'],
  [4182633316,4182848112,'Leo'],
  [4182848112,4183053251,'Virgo'],
  [4183053251,4183245627,'Libra'],
  [4183245627,4183425972,'Scorpio'],
  [4183425972,4183598566,'Sagittarius'],
  [4183598566,4183769716,'Capricorn'],
  [4183769716,4183946244,'Aquarius'],
  [4183946244,4184133952,'Pisces'],
  [4184133952,4184335594,'Aries'],
  [4184335594,4184549108,'Taurus'],
  [4184549108,4184768509,'Gemini'],
  [4184768509,4184987392,'Cancer'],
  [4184987392,4185201258,'Leo'],
  [4185201258,4185407390,'Virgo'],
  [4185407390,4185603927,'Libra'],
  [4185603927,4185790253,'Scorpio'],
  [4185790253,4185967967,'Sagittarius'],
  [4185967967,4186141202,'Capricorn'],
  [4186141202,4186316031,'Aquarius'],
  [4186316031,4186499136,'Pisces'],
  [4186499136,4186695674,'Aries'],
  [4186695674,4186906206,'Taurus'],
  [4186906206,4187125083,'Gemini'],
  [4187125083,4187343692,'Cancer'],
  [4187343692,4187555929,'Leo'],
  [4187555929,4187760065,'Virgo'],
  [4187760065,4187956678,'Libra'],
  [4187956678,4188146417,'Scorpio'],
  [4188146417,4188329769,'Sagittarius'],
  [4188329769,4188508284,'Capricorn'],
  [4188508284,4188685729,'Aquarius'],
  [4188685729,4188867862,'Pisces'],
  [4188867862,4189060704,'Aries'],
  [4189060704,4189267385,'Taurus'],
  [4189267385,4189484685,'Gemini'],
  [4189484685,4189703526,'Cancer'],
  [4189703526,4189915242,'Leo'],
  [4189915242,4190116828,'Virgo'],
  [4190116828,4190310169,'Libra'],
  [4190310169,4190498451,'Scorpio'],
  [4190498451,4190683750,'Sagittarius'],
  [4190683750,4190866963,'Capricorn'],
  [4190866963,4191049472,'Aquarius'],
  [4191049472,4191234583,'Pisces'],
  [4191234583,4191427165,'Aries'],
  [4191427165,4191631314,'Taurus'],
  [4191631314,4191846601,'Gemini'],
  [4191846601,4192065875,'Cancer'],
  [4192065875,4192279060,'Leo'],
  [4192279060,4192480341,'Virgo'],
  [4192480341,4192670571,'Libra'],
  [4192670571,4192854305,'Scorpio'],
  [4192854305,4193036255,'Sagittarius'],
  [4193036255,4193219407,'Capricorn'],
  [4193219407,4193405122,'Aquarius'],
  [4193405122,4193594637,'Pisces'],
  [4193594637,4193790212,'Aries'],
  [4193790212,4193994610,'Taurus'],
  [4193994610,4194208623,'Gemini'],
  [4194208623,4194428020,'Cancer'],
  [4194428020,4194643900,'Leo'],
  [4194643900,4194848186,'Virgo'],
  [4194848186,4195038822,'Libra'],
  [4195038822,4195219395,'Scorpio'],
  [4195219395,4195395845,'Sagittarius'],
  [4195395845,4195573828,'Capricorn'],
  [4195573828,4195757294,'Aquarius'],
  [4195757294,4195948184,'Pisces'],
  [4195948184,4196147076,'Aries'],
  [4196147076,4196353987,'Taurus'],
  [4196353987,4196568356,'Gemini'],
  [4196568356,4196787528,'Cancer'],
  [4196787528,4197005454,'Leo'],
  [4197005454,4197214434,'Virgo'],
  [4197214434,4197409616,'Libra'],
  [4197409616,4197591655,'Scorpio'],
  [4197591655,4197765438,'Sagittarius'],
  [4197765438,4197937606,'Capricorn'],
  [4197937606,4198114659,'Aquarius'],
  [4198114659,4198301473,'Pisces'],
  [4198301473,4198500004,'Aries'],
  [4198500004,4198708918,'Taurus'],
  [4198708918,4198924854,'Gemini'],
  [4198924854,4199144000,'Cancer'],
  [4199144000,4199362194,'Leo'],
  [4199362194,4199574365,'Virgo'],
  [4199574365,4199775476,'Libra'],
  [4199775476,4199963248,'Scorpio'],
  [4199963248,4200139628,'Sagittarius'],
  [4200139628,4200310061,'Capricorn'],
  [4200310061,4200481733,'Aquarius'],
  [4200481733,4200661802,'Pisces'],
  [4200661802,4200855313,'Aries'],
  [4200855313,4201062744,'Taurus'],
  [4201062744,4201279511,'Gemini'],
  [4201279511,4201499070,'Cancer'],
  [4201499070,4201716441,'Leo'],
  [4201716441,4201928637,'Virgo'],
  [4201928637,4202132978,'Libra'],
  [4202132978,4202326880,'Scorpio'],
  [4202326880,4202509539,'Sagittarius'],
  [4202509539,4202683507,'Capricorn'],
  [4202683507,4202854598,'Aquarius'],
  [4202854598,4203030294,'Pisces'],
  [4203030294,4203217642,'Aries'],
  [4203217642,4203420250,'Taurus'],
  [4203420250,4203635375,'Gemini'],
  [4203635375,4203855089,'Cancer'],
  [4203855089,4204071840,'Leo'],
  [4204071840,4204282209,'Virgo'],
  [4204282209,4204485664,'Libra'],
  [4204485664,4204681830,'Scorpio'],
  [4204681830,4204869851,'Sagittarius'],
  [4204869851,4205049932,'Capricorn'],
  [4205049932,4205225124,'Aquarius'],
  [4205225124,4205401306,'Pisces'],
  [4205401306,4205585514,'Aries'],
  [4205585514,4205783234,'Taurus'],
  [4205783234,4205994796,'Gemini'],
  [4205994796,4206213671,'Cancer'],
  [4206213671,4206430511,'Leo'],
  [4206430511,4206639544,'Virgo'],
  [4206639544,4206840175,'Libra'],
  [4206840175,4207034164,'Scorpio'],
  [4207034164,4207222888,'Sagittarius'],
  [4207222888,4207406915,'Capricorn'],
  [4207406915,4207587467,'Aquarius'],
  [4207587467,4207767843,'Pisces'],
  [4207767843,4207953248,'Aries'],
  [4207953248,4208148987,'Taurus'],
  [4208148987,4208357360,'Gemini'],
  [4208357360,4208574668,'Cancer'],
  [4208574668,4208792104,'Leo'],
  [4208792104,4209001616,'Virgo'],
  [4209001616,4209200547,'Libra'],
  [4209200547,4209390871,'Scorpio'],
  [4209390871,4209576078,'Sagittarius'],
  [4209576078,4209759078,'Capricorn'],
  [4209759078,4209941891,'Aquarius'],
  [4209941891,4210126517,'Pisces'],
  [4210126517,4210315746,'Aries'],
  [4210315746,4210512919,'Taurus'],
  [4210512919,4210720262,'Gemini'],
  [4210720262,4210936253,'Cancer'],
  [4210936253,4211154402,'Leo'],
  [4211154402,4211366137,'Virgo'],
  [4211366137,4211566171,'Libra'],
  [4211566171,4211754727,'Scorpio'],
  [4211754727,4211935682,'Sagittarius'],
  [4211935682,4212114021,'Capricorn'],
  [4212114021,4212294197,'Aquarius'],
  [4212294197,4212479426,'Pisces'],
  [4212479426,4212671657,'Aries'],
  [4212671657,4212871909,'Taurus'],
  [4212871909,4213080484,'Gemini'],
  [4213080484,4213296164,'Cancer'],
  [4213296164,4213514799,'Leo'],
  [4213514799,4213729377,'Virgo'],
  [4213729377,4213933122,'Libra'],
  [4213933122,4214123487,'Scorpio'],
  [4214123487,4214302855,'Sagittarius'],
  [4214302855,4214476678,'Capricorn'],
  [4214476678,4214651379,'Aquarius'],
  [4214651379,4214832665,'Pisces'],
  [4214832665,4215024084,'Aries'],
  [4215024084,4215226116,'Taurus'],
  [4215226116,4215436773,'Gemini'],
  [4215436773,4215653162,'Cancer'],
  [4215653162,4215871937,'Leo'],
  [4215871937,4216088450,'Virgo'],
  [4216088450,4216296678,'Libra'],
  [4216296678,4216491941,'Scorpio'],
  [4216491941,4216673848,'Sagittarius'],
  [4216673848,4216846517,'Capricorn'],
  [4216846517,4217016798,'Aquarius'],
  [4217016798,4217192188,'Pisces'],
  [4217192188,4217378803,'Aries'],
  [4217378803,4217579033,'Taurus'],
  [4217579033,4217790430,'Gemini'],
  [4217790430,4218007816,'Cancer'],
  [4218007816,4218226546,'Leo'],
  [4218226546,4218443247,'Virgo'],
  [4218443247,4218654180,'Libra'],
  [4218654180,4218854858,'Scorpio'],
  [4218854858,4219042494,'Sagittarius'],
  [4219042494,4219218468,'Capricorn'],
  [4219218468,4219388302,'Aquarius'],
  [4219388302,4219559711,'Pisces'],
  [4219559711,4219740433,'Aries'],
  [4219740433,4219935591,'Taurus'],
  [4219935591,4220144806,'Gemini'],
  [4220144806,4220362270,'Cancer'],
  [4220362270,4220580990,'Leo'],
  [4220580990,4220796671,'Virgo'],
  [4220796671,4221007248,'Libra'],
  [4221007248,4221210480,'Scorpio'],
  [4221210480,4221403649,'Sagittarius'],
  [4221403649,4221585787,'Capricorn'],
  [4221585787,4221759702,'Aquarius'],
  [4221759702,4221931571,'Pisces'],
  [4221931571,4222109027,'Aries'],
  [4222109027,4222298778,'Taurus'],
  [4222298778,4222503410,'Gemini'],
  [4222503410,4222719113,'Cancer'],
  [4222719113,4222937791,'Leo'],
  [4222937791,4223152651,'Virgo'],
  [4223152651,4223361051,'Libra'],
  [4223361051,4223562725,'Scorpio'],
  [4223562725,4223757341,'Sagittarius'],
  [4223757341,4223944270,'Capricorn'],
  [4223944270,4224124285,'Aquarius'],
  [4224124285,4224300843,'Pisces'],
  [4224300843,4224479654,'Aries'],
  [4224479654,4224667023,'Taurus'],
  [4224667023,4224867281,'Gemini'],
  [4224867281,4225079772,'Cancer'],
  [4225079772,4225297967,'Leo'],
  [4225297967,4225513243,'Virgo'],
  [4225513243,4225720340,'Libra'],
  [4225720340,4225918681,'Scorpio'],
  [4225918681,4226110094,'Sagittarius'],
  [4226110094,4226296598,'Capricorn'],
  [4226296598,4226479838,'Aquarius'],
  [4226479838,4226661779,'Pisces'],
  [4226661779,4226845426,'Aries'],
  [4226845426,4227034755,'Taurus'],
  [4227034755,4227233563,'Gemini'],
  [4227233563,4227443216,'Cancer'],
  [4227443216,4227660325,'Leo'],
  [4227660325,4227877024,'Virgo'],
  [4227877024,4228085479,'Libra'],
  [4228085479,4228282488,'Scorpio'],
  [4228282488,4228469732,'Sagittarius'],
  [4228469732,4228651412,'Capricorn'],
  [4228651412,4228832009,'Aquarius'],
  [4228832009,4229015022,'Pisces'],
  [4229015022,4229202662,'Aries'],
  [4229202662,4229396311,'Taurus'],
  [4229396311,4229597194,'Gemini'],
  [4229597194,4229806206,'Cancer'],
  [4229806206,4230022233,'Leo'],
  [4230022233,4230240232,'Virgo'],
  [4230240232,4230452158,'Libra'],
  [4230452158,4230651725,'Scorpio'],
  [4230651725,4230838098,'Sagittarius'],
  [4230838098,4231015397,'Capricorn'],
  [4231015397,4231190074,'Aquarius'],
  [4231190074,4231368458,'Pisces'],
  [4231368458,4231554917,'Aries'],
  [4231554917,4231750767,'Taurus'],
  [4231750767,4231954871,'Gemini'],
  [4231954871,4232165552,'Cancer'],
  [4232165552,4232381412,'Leo'],
  [4232381412,4232599817,'Virgo'],
  [4232599817,4232815009,'Libra'],
  [4232815009,4233019698,'Scorpio'],
  [4233019698,4233209798,'Sagittarius'],
  [4233209798,4233387095,'Capricorn'],
  [4233387095,4233557882,'Aquarius'],
  [4233557882,4233730035,'Pisces'],
  [4233730035,4233910602,'Aries'],
  [4233910602,4234103515,'Taurus'],
  [4234103515,4234308146,'Gemini'],
  [4234308146,4234520725,'Cancer'],
  [4234520725,4234737448,'Leo'],
  [4234737448,4234955662,'Virgo'],
  [4234955662,4235172031,'Libra'],
  [4235172031,4235381013,'Scorpio'],
  [4235381013,4235577148,'Sagittarius'],
  [4235577148,4235759092,'Capricorn'],
  [4235759092,4235930951,'Aquarius'],
  [4235930951,4236100180,'Pisces'],
  [4236100180,4236274904,'Aries'],
  [4236274904,4236461588,'Taurus'],
  [4236461588,4236662470,'Gemini'],
  [4236662470,4236874543,'Cancer'],
  [4236874543,4237092024,'Leo'],
  [4237092024,4237310094,'Virgo'],
  [4237310094,4237525728,'Libra'],
  [4237525728,4237735764,'Scorpio'],
  [4237735764,4237936183,'Sagittarius'],
  [4237936183,4238124290,'Capricorn'],
  [4238124290,4238301342,'Aquarius'],
  [4238301342,4238472625,'Pisces'],
  [4238472625,4238645485,'Aries'],
  [4238645485,4238827152,'Taurus'],
  [4238827152,4239022360,'Gemini'],
  [4239022360,4239230976,'Cancer'],
  [4239230976,4239447795,'Leo'],
  [4239447795,4239665874,'Virgo'],
  [4239665874,4239880331,'Libra'],
  [4239880331,4240088685,'Scorpio'],
  [4240088685,4240289309,'Sagittarius'],
  [4240289309,4240480889,'Capricorn'],
  [4240480889,4240663590,'Aquarius'],
  [4240663590,4240840169,'Pisces'],
  [4240840169,4241015718,'Aries'],
  [4241015718,4241196400,'Taurus'],
  [4241196400,4241387653,'Gemini'],
  [4241387653,4241591900,'Cancer'],
  [4241591900,4241806537,'Leo'],
  [4241806537,4242024533,'Virgo'],
  [4242024533,4242238622,'Libra'],
  [4242238622,4242444858,'Scorpio'],
  [4242444858,4242642672,'Sagittarius'],
  [4242642672,4242833196,'Capricorn'],
  [4242833196,4243018057,'Aquarius'],
  [4243018057,4243199315,'Pisces'],
  [4243199315,4243379828,'Aries'],
  [4243379828,4243563399,'Taurus'],
  [4243563399,4243754293,'Gemini'],
  [4243754293,4243955797,'Cancer'],
  [4243955797,4244167926,'Leo'],
  [4244167926,4244385639,'Virgo'],
  [4244385639,4244600629,'Libra'],
  [4244600629,4244806402,'Scorpio'],
  [4244806402,4245001373,'Sagittarius'],
  [4245001373,4245188019,'Capricorn'],
  [4245188019,4245370400,'Aquarius'],
  [4245370400,4245552243,'Pisces'],
  [4245552243,4245736171,'Aries'],
  [4245736171,4245924001,'Taurus'],
  [4245924001,4246117597,'Gemini'],
  [4246117597,4246319152,'Cancer'],
  [4246319152,4246529839,'Leo'],
  [4246529839,4246747199,'Virgo'],
  [4246747199,4246964000,'Libra'],
  [4246964000,4247171789,'Scorpio'],
  [4247171789,4247366464,'Sagittarius'],
  [4247366464,4247549882,'Capricorn'],
  [4247549882,4247727521,'Aquarius'],
  [4247727521,4247905479,'Pisces'],
  [4247905479,4248088351,'Aries'],
  [4248088351,4248278187,'Taurus'],
  [4248278187,4248475076,'Gemini'],
  [4248475076,4248678843,'Cancer'],
  [4248678843,4248889781,'Leo'],
  [4248889781,4249106955,'Virgo'],
  [4249106955,4249325506,'Libra'],
  [4249325506,4249537042,'Scorpio'],
  [4249537042,4249734863,'Sagittarius'],
  [4249734863,4249918462,'Capricorn'],
  [4249918462,4250092893,'Aquarius'],
  [4250092893,4250265527,'Pisces'],
  [4250265527,4250443285,'Aries'],
  [4250443285,4250630554,'Taurus'],
  [4250630554,4250828072,'Gemini'],
  [4250828072,4251034053,'Cancer'],
  [4251034053,4251246475,'Leo'],
  [4251246475,4251463827,'Virgo'],
  [4251463827,4251683139,'Libra'],
  [4251683139,4251898074,'Scorpio'],
  [4251898074,4252101180,'Sagittarius'],
  [4252101180,4252289042,'Capricorn'],
  [4252289042,4252464465,'Aquarius'],
  [4252464465,4252634315,'Pisces'],
  [4252634315,4252806515,'Aries'],
  [4252806515,4252987796,'Taurus'],
  [4252987796,4253181602,'Gemini'],
  [4253181602,4253387123,'Cancer'],
  [4253387123,4253600749,'Leo'],
  [4253600749,4253818652,'Virgo'],
  [4253818652,4254037663,'Libra'],
  [4254037663,4254253658,'Scorpio'],
  [4254253658,4254460989,'Sagittarius'],
  [4254460989,4254655096,'Capricorn'],
  [4254655096,4254835820,'Aquarius'],
  [4254835820,4255007715,'Pisces'],
  [4255007715,4255177886,'Aries'],
  [4255177886,4255353798,'Taurus'],
  [4255353798,4255541327,'Gemini'],
  [4255541327,4255742672,'Cancer'],
  [4255742672,4255955338,'Leo'],
  [4255955338,4256173667,'Virgo'],
  [4256173667,4256392156,'Libra'],
  [4256392156,4256606880,'Scorpio'],
  [4256606880,4256814688,'Sagittarius'],
  [4256814688,4257012800,'Capricorn'],
  [4257012800,4257199975,'Aquarius'],
  [4257199975,4257377915,'Pisces'],
  [4257377915,4257551177,'Aries'],
  [4257551177,4257726003,'Taurus'],
  [4257726003,4257908836,'Gemini'],
  [4257908836,4258104428,'Cancer'],
  [4258104428,4258313443,'Leo'],
  [4258313443,4258531107,'Virgo'],
  [4258531107,4258749615,'Libra'],
  [4258749615,4258962770,'Scorpio'],
  [4258962770,4259167990,'Sagittarius'],
  [4259167990,4259365191,'Capricorn'],
  [4259365191,4259555088,'Aquarius'],
  [4259555088,4259738771,'Pisces'],
  [4259738771,4259918212,'Aries'],
  [4259918212,4260096850,'Taurus'],
  [4260096850,4260279560,'Gemini'],
  [4260279560,4260471584,'Cancer'],
  [4260471584,4260676236,'Leo'],
  [4260676236,4260891806,'Virgo'],
  [4260891806,4261110700,'Libra'],
  [4261110700,4261323939,'Scorpio'],
  [4261323939,4261526861,'Sagittarius'],
  [4261526861,4261720195,'Capricorn'],
  [4261720195,4261907360,'Aquarius'],
  [4261907360,4262091693,'Pisces'],
  [4262091693,4262275279,'Aries'],
  [4262275279,4262459429,'Taurus'],
  [4262459429,4262646127,'Gemini'],
  [4262646127,4262838815,'Cancer'],
  [4262838815,4263041260,'Leo'],
  [4263041260,4263254468,'Virgo'],
  [4263254468,4263473484,'Libra'],
  [4263473484,4263688631,'Scorpio'],
  [4263688631,4263892175,'Sagittarius'],
  [4263892175,4264083045,'Capricorn'],
  [4264083045,4264265494,'Aquarius'],
  [4264265494,4264445364,'Pisces'],
  [4264445364,4264627282,'Aries'],
  [4264627282,4264813445,'Taurus'],
  [4264813445,4265004318,'Gemini'],
  [4265004318,4265200578,'Cancer'],
  [4265200578,4265404075,'Leo'],
  [4265404075,4265616316,'Virgo'],
  [4265616316,4265835070,'Libra'],
  [4265835070,4266052593,'Scorpio'],
  [4266052593,4266259619,'Sagittarius'],
  [4266259619,4266451980,'Capricorn'],
  [4266451980,4266632374,'Aquarius'],
  [4266632374,4266807282,'Pisces'],
  [4266807282,4266983528,'Aries'],
  [4266983528,4267166052,'Taurus'],
  [4267166052,4267356855,'Gemini'],
  [4267356855,4267555699,'Cancer'],
  [4267555699,4267761879,'Leo'],
  [4267761879,4267975030,'Virgo'],
  [4267975030,4268193629,'Libra'],
  [4268193629,4268412551,'Scorpio'],
  [4268412551,4268623684,'Sagittarius'],
  [4268623684,4268820797,'Capricorn'],
  [4268820797,4269003651,'Aquarius'],
  [4269003651,4269177268,'Pisces'],
  [4269177268,4269348818,'Aries'],
  [4269348818,4269525150,'Taurus'],
  [4269525150,4269711094,'Gemini'],
  [4269711094,4269908367,'Cancer'],
  [4269908367,4270115749,'Leo'],
  [4270115749,4270330460,'Virgo'],
  [4270330460,4270549353,'Libra'],
  [4270549353,4270768347,'Scorpio'],
  [4270768347,4270981776,'Sagittarius'],
  [4270981776,4271183931,'Capricorn'],
  [4271183931,4271372328,'Aquarius'],
  [4271372328,4271549241,'Pisces'],
  [4271549241,4271720333,'Aries'],
  [4271720333,4271892546,'Taurus'],
  [4271892546,4272072425,'Gemini'],
  [4272072425,4272264512,'Cancer'],
  [4272264512,4272469702,'Leo'],
  [4272469702,4272684721,'Virgo'],
  [4272684721,4272904052,'Libra'],
  [4272904052,4273122418,'Scorpio'],
  [4273122418,4273335579,'Sagittarius'],
  [4273335579,4273540102,'Capricorn'],
  [4273540102,4273733680,'Aquarius'],
  [4273733680,4273916425,'Pisces'],
  [4273916425,4274091368,'Aries'],
  [4274091368,4274263845,'Taurus'],
  [4274263845,4274440343,'Gemini'],
  [4274440343,4274627025,'Cancer'],
  [4274627025,4274827574,'Leo'],
  [4274827574,4275040691,'Virgo'],
  [4275040691,4275259971,'Libra'],
  [4275259971,4275477808,'Scorpio'],
  [4275477808,4275689284,'Sagittarius'],
  [4275689284,4275892744,'Capricorn'],
  [4275892744,4276088036,'Aquarius'],
  [4276088036,4276275433,'Pisces'],
  [4276275433,4276456032,'Aries'],
  [4276456032,4276632605,'Taurus'],
  [4276632605,4276809940,'Gemini'],
  [4276809940,4276994066,'Cancer'],
  [4276994066,4277190296,'Leo'],
  [4277190296,4277400088,'Virgo'],
  [4277400088,4277618492,'Libra'],
  [4277618492,4277836374,'Scorpio'],
  [4277836374,4278046591,'Sagittarius'],
  [4278046591,4278247331,'Capricorn'],
  [4278247331,4278440438,'Aquarius'],
  [4278440438,4278628328,'Pisces'],
  [4278628328,4278812523,'Aries'],
  [4278812523,4278994169,'Taurus'],
  [4278994169,4279175569,'Gemini'],
  [4279175569,4279360953,'Cancer'],
  [4279360953,4279555472,'Leo'],
  [4279555472,4279762379,'Virgo'],
  [4279762379,4279979366,'Libra'],
  [4279979366,4280197883,'Scorpio'],
  [4280197883,4280408595,'Sagittarius'],
  [4280408595,4280607665,'Capricorn'],
  [4280607665,4280797157,'Aquarius'],
  [4280797157,4280981544,'Pisces'],
  [4280981544,4281164636,'Aries'],
  [4281164636,4281348432,'Taurus'],
  [4281348432,4281533989,'Gemini'],
  [4281533989,4281723141,'Cancer'],
  [4281723141,4281919123,'Leo'],
  [4281919123,4282125106,'Virgo'],
  [4282125106,4282340883,'Libra'],
  [4282340883,4282560218,'Scorpio'],
  [4282560218,4282773319,'Sagittarius'],
  [4282773319,4282973645,'Capricorn'],
  [4282973645,4283161447,'Aquarius'],
  [4283161447,4283341555,'Pisces'],
  [4283341555,4283519809,'Aries'],
  [4283519809,4283700741,'Taurus'],
  [4283700741,4283886772,'Gemini'],
  [4283886772,4284078921,'Cancer'],
  [4284078921,4284278086,'Leo'],
  [4284278086,4284485414,'Virgo'],
  [4284485414,4284700888,'Libra'],
  [4284700888,4284920688,'Scorpio'],
  [4284920688,4285136810,'Sagittarius'],
  [4285136810,4285341289,'Capricorn'],
  [4285341289,4285531381,'Aquarius'],
  [4285531381,4285710199,'Pisces'],
  [4285710199,4285883859,'Aries'],
  [4285883859,4286058848,'Taurus'],
  [4286058848,4286240361,'Gemini'],
  [4286240361,4286431316,'Cancer'],
  [4286431316,4286632217,'Leo'],
  [4286632217,4286841848,'Virgo'],
  [4286841848,4287058151,'Libra'],
  [4287058151,4287277924,'Scorpio'],
  [4287277924,4287495796,'Sagittarius'],
  [4287495796,4287705018,'Capricorn'],
  [4287705018,4287900783,'Aquarius'],
  [4287900783,4288083076,'Pisces'],
  [4288083076,4288256223,'Aries'],
  [4288256223,4288426797,'Taurus'],
  [4288426797,4288601792,'Gemini'],
  [4288601792,4288787045,'Cancer'],
  [4288787045,4288985448,'Leo'],
  [4288985448,4289195689,'Virgo'],
  [4289195689,4289413219,'Libra'],
  [4289413219,4289632931,'Scorpio'],
  [4289632931,4289850511,'Sagittarius'],
  [4289850511,4290061941,'Capricorn'],
  [4290061941,4290263256,'Aquarius'],
  [4290263256,4290452203,'Pisces'],
  [4290452203,4290629926,'Aries'],
  [4290629926,4290801031,'Taurus'],
  [4290801031,4290972346,'Gemini'],
  [4290972346,4291151258,'Cancer'],
  [4291151258,4291343623,'Leo'],
  [4291343623,4291550843,'Virgo'],
  [4291550843,4291768294,'Libra'],
  [4291768294,4291988216,'Scorpio'],
  [4291988216,4292204627,'Sagittarius'],
  [4292204627,4292414904,'Capricorn'],
  [4292414904,4292617813,'Aquarius'],
  [4292617813,4292811955,'Pisces'],
  [4292811955,4292996498,'Aries'],
  [4292996498,4293172928,'Taurus'],
  [4293172928,4293345896,'Gemini'],
  [4293345896,4293522282,'Cancer'],
  [4293522282,4293709221,'Leo'],
  [4293709221,4293911110,'Virgo'],
  [4293911110,4294126074,'Libra'],
  [4294126074,4294345924,'Scorpio'],
  [4294345924,4294561879,'Sagittarius'],
  [4294561879,4294769934,'Capricorn'],
  [4294769934,4294970411,'Aquarius'],
  [4294970411,4295164616,'Pisces'],
  [4295164616,4295352928,'Aries'],
  [4295352928,4295535430,'Taurus'],
  [4295535430,4295713903,'Gemini'],
  [4295713903,4295892840,'Cancer'],
  [4295892840,4296078485,'Leo'],
  [4296078485,4296276369,'Virgo'],
  [4296276369,4296487660,'Libra'],
  [4296487660,4296706535,'Scorpio'],
  [4296706535,4296923124,'Sagittarius'],
  [4296923124,4297130558,'Capricorn'],
  [4297130558,4297328067,'Aquarius'],
  [4297328067,4297518504,'Pisces'],
  [4297518504,4297704942,'Aries'],
  [4297704942,4297889145,'Taurus'],
  [4297889145,4298072209,'Gemini'],
  [4298072209,4298256174,'Cancer'],
  [4298256174,4298444748,'Leo'],
  [4298444748,4298642300,'Virgo'],
  [4298642300,4298851199,'Libra'],
  [4298851199,4299068617,'Scorpio'],
  [4299068617,4299286274,'Sagittarius'],
  [4299286274,4299495462,'Capricorn'],
  [4299495462,4299692632,'Aquarius'],
  [4299692632,4299879770,'Pisces'],
  [4299879770,4300061397,'Aries'],
  [4300061397,4300241936,'Taurus'],
  [4300241936,4300424555,'Gemini'],
  [4300424555,4300611311,'Cancer'],
  [4300611311,4300803908,'Leo'],
  [4300803908,4301004137,'Virgo'],
  [4301004137,4301213205,'Libra'],
  [4301213205,4301429734,'Scorpio'],
  [4301429734,4301648183,'Sagittarius'],
  [4301648183,4301860434,'Capricorn'],
  [4301860434,4302060527,'Aquarius'],
  [4302060527,4302247862,'Pisces'],
  [4302247862,4302426242,'Aries'],
  [4302426242,4302601409,'Taurus'],
  [4302601409,4302779073,'Gemini'],
  [4302779073,4302963619,'Cancer'],
  [4302963619,4303157330,'Leo'],
  [4303157330,4303360325,'Virgo'],
  [4303360325,4303571310,'Libra'],
  [4303571310,4303788058,'Scorpio'],
  [4303788058,4304006772,'Sagittarius'],
  [4304006772,4304221626,'Capricorn'],
  [4304221626,4304426310,'Aquarius'],
  [4304426310,4304617537,'Pisces'],
  [4304617537,4304796728,'Aries'],
  [4304796728,4304969009,'Taurus'],
  [4304969009,4305141237,'Gemini'],
  [4305141237,4305320144,'Cancer'],
  [4305320144,4305510512,'Leo'],
  [4305510512,4305713379,'Virgo'],
  [4305713379,4305925896,'Libra'],
  [4305925896,4306143542,'Scorpio'],
  [4306143542,4306362166,'Sagittarius'],
  [4306362166,4306577922,'Capricorn'],
  [4306577922,4306786275,'Aquarius'],
  [4306786275,4306982991,'Pisces'],
  [4306982991,4307166757,'Aries'],
  [4307166757,4307340482,'Taurus'],
  [4307340482,4307510422,'Gemini'],
  [4307510422,4307684226,'Cancer'],
  [4307684226,4307868863,'Leo'],
  [4307868863,4308067990,'Virgo'],
  [4308067990,4308279728,'Libra'],
  [4308279728,4308497914,'Scorpio'],
  [4308497914,4308716376,'Sagittarius'],
  [4308716376,4308931419,'Capricorn'],
  [4308931419,4309140648,'Aquarius'],
  [4309140648,4309341253,'Pisces'],
  [4309341253,4309530792,'Aries'],
  [4309530792,4309709518,'Taurus'],
  [4309709518,4309881550,'Gemini'],
  [4309881550,4310053800,'Cancer'],
  [4310053800,4310233936,'Leo'],
  [4310233936,4310427806,'Virgo'],
  [4310427806,4310636197,'Libra'],
  [4310636197,4310853622,'Scorpio'],
  [4310853622,4311071995,'Sagittarius'],
  [4311071995,4311285858,'Capricorn'],
  [4311285858,4311493434,'Aquarius'],
  [4311493434,4311694182,'Pisces'],
  [4311694182,4311887043,'Aries'],
  [4311887043,4312071275,'Taurus'],
  [4312071275,4312248501,'Gemini'],
  [4312248501,4312423440,'Cancer'],
  [4312423440,4312602763,'Leo'],
  [4312602763,4312792935,'Virgo'],
  [4312792935,4312997123,'Libra'],
  [4312997123,4313212395,'Scorpio'],
  [4313212395,4313430678,'Sagittarius'],
  [4313430678,4313644190,'Capricorn'],
  [4313644190,4313849660,'Aquarius'],
  [4313849660,4314047544,'Pisces'],
  [4314047544,4314239219,'Aries'],
  [4314239219,4314425541,'Taurus'],
  [4314425541,4314607494,'Gemini'],
  [4314607494,4314787525,'Cancer'],
  [4314787525,4314969935,'Leo'],
  [4314969935,4315159924,'Virgo'],
  [4315159924,4315361409,'Libra'],
  [4315361409,4315574117,'Scorpio'],
  [4315574117,4315792135,'Sagittarius'],
  [4315792135,4316006740,'Capricorn'],
  [4316006740,4316211962,'Aquarius'],
  [4316211962,4316407020,'Pisces'],
  [4316407020,4316594530,'Aries'],
  [4316594530,4316777955,'Taurus'],
  [4316777955,4316960240,'Gemini'],
  [4316960240,4317143731,'Cancer'],
  [4317143731,4317330723,'Leo'],
  [4317330723,4317523827,'Virgo'],
  [4317523827,4317725556,'Libra'],
  [4317725556,4317936715,'Scorpio'],
  [4317936715,4318154239,'Sagittarius'],
  [4318154239,4318370858,'Capricorn'],
  [4318370858,4318578666,'Aquarius'],
  [4318578666,4318773961,'Pisces'],
  [4318773961,4318958312,'Aries'],
  [4318958312,4319136493,'Taurus'],
  [4319136493,4319314105,'Gemini'],
  [4319314105,4319495876,'Cancer'],
  [4319495876,4319684670,'Leo'],
  [4319684670,4319881382,'Virgo'],
  [4319881382,4320085788,'Libra'],
  [4320085788,4320297338,'Scorpio'],
  [4320297338,4320514432,'Sagittarius'],
  [4320514432,4320732639,'Capricorn'],
  [4320732639,4320944648,'Aquarius'],
  [4320944648,4321144077,'Pisces'],
  [4321144077,4321329510,'Aries'],
  [4321329510,4321504771,'Taurus'],
  [4321504771,4321676625,'Gemini'],
  [4321676625,4321852304,'Cancer'],
  [4321852304,4322037434,'Leo'],
  [4322037434,4322234173,'Virgo'],
  [4322234173,4322440885,'Libra'],
  [4322440885,4322654263,'Scorpio'],
  [4322654263,4322871527,'Sagittarius'],
  [4322871527,4323090028,'Capricorn'],
  [4323090028,4323305109,'Aquarius'],
  [4323305109,4323510300,'Pisces'],
  [4323510300,4323701179,'Aries'],
  [4323701179,4323878632,'Taurus'],
  [4323878632,4324048430,'Gemini'],
  [4324048430,4324218586,'Cancer'],
  [4324218586,4324396934,'Leo'],
  [4324396934,4324588684,'Virgo'],
  [4324588684,4324794013,'Libra'],
  [4324794013,4325008441,'Scorpio'],
  [4325008441,4325226473,'Sagittarius'],
  [4325226473,4325444503,'Capricorn'],
  [4325444503,4325659862,'Aquarius'],
  [4325659862,4325868514,'Pisces'],
  [4325868514,4326065720,'Aries'],
  [4326065720,4326249444,'Taurus'],
  [4326249444,4326422603,'Gemini'],
  [4326422603,4326591960,'Cancer'],
  [4326591960,4326765637,'Leo'],
  [4326765637,4326950798,'Virgo'],
  [4326950798,4327150851,'Libra'],
  [4327150851,4327363362,'Scorpio'],
  [4327363362,4327581651,'Sagittarius'],
  [4327581651,4327799424,'Capricorn'],
  [4327799424,4328013331,'Aquarius'],
  [4328013331,4328221435,'Pisces'],
  [4328221435,4328421347,'Aries'],
  [4328421347,4328610910,'Taurus'],
  [4328610910,4328790504,'Gemini'],
  [4328790504,4328964109,'Cancer'],
  [4328964109,4329138206,'Leo'],
  [4329138206,4329319842,'Virgo'],
  [4329319842,4329514307,'Libra'],
  [4329514307,4329722439,'Scorpio'],
  [4329722439,4329939366,'Sagittarius'],
  [4329939366,4330157230,'Capricorn'],
  [4330157230,4330370086,'Aquarius'],
  [4330370086,4330575633,'Pisces'],
  [4330575633,4330773662,'Aries'],
  [4330773662,4330964405,'Taurus'],
  [4330964405,4331148527,'Gemini'],
  [4331148527,4331328025,'Cancer'],
  [4331328025,4331506679,'Leo'],
  [4331506679,4331689556,'Virgo'],
  [4331689556,4331881660,'Libra'],
  [4331881660,4332085799,'Scorpio'],
  [4332085799,4332300203,'Sagittarius'],
  [4332300203,4332518083,'Capricorn'],
  [4332518083,4332731370,'Aquarius'],
  [4332731370,4332935383,'Pisces'],
  [4332935383,4333129899,'Aries'],
  [4333129899,4333317363,'Taurus'],
  [4333317363,4333500861,'Gemini'],
  [4333500861,4333683137,'Cancer'],
  [4333683137,4333866581,'Leo'],
  [4333866581,4334053688,'Virgo'],
  [4334053688,4334247344,'Libra'],
  [4334247344,4334450154,'Scorpio'],
  [4334450154,4334662464,'Sagittarius'],
  [4334662464,4334880138,'Capricorn'],
  [4334880138,4335095124,'Aquarius'],
  [4335095124,4335300169,'Pisces'],
  [4335300169,4335493003,'Aries'],
  [4335493003,4335676353,'Taurus'],
  [4335676353,4335855416,'Gemini'],
  [4335855416,4336035359,'Cancer'],
  [4336035359,4336219778,'Leo'],
  [4336219778,4336410292,'Virgo'],
  [4336410292,4336607386,'Libra'],
  [4336607386,4336811625,'Scorpio'],
  [4336811625,4337023421,'Sagittarius'],
  [4337023421,4337240875,'Capricorn'],
  [4337240875,4337457892,'Aquarius'],
  [4337457892,4337666200,'Pisces'],
  [4337666200,4337860758,'Aries'],
  [4337860758,4338042618,'Taurus'],
  [4338042618,4338217375,'Gemini'],
  [4338217375,4338392080,'Cancer'],
  [4338392080,4338572771,'Leo'],
  [4338572771,4338762684,'Virgo'],
  [4338762684,4338961804,'Libra'],
  [4338961804,4339168462,'Scorpio'],
  [4339168462,4339381247,'Sagittarius'],
  [4339381247,4339598714,'Capricorn'],
  [4339598714,4339817043,'Aquarius'],
  [4339817043,4340029139,'Pisces'],
  [4340029139,4340228202,'Aries'],
  [4340228202,4340412528,'Taurus'],
  [4340412528,4340586292,'Gemini'],
  [4340586292,4340756844,'Cancer'],
  [4340756844,4340931860,'Leo'],
  [4340931860,4341117095,'Virgo'],
  [4341117095,4341314466,'Libra'],
  [4341314466,4341522005,'Scorpio'],
  [4341522005,4341736153,'Sagittarius'],
  [4341736153,4341953926,'Capricorn'],
  [4341953926,4342172391,'Aquarius'],
  [4342172391,4342386701,'Pisces'],
  [4342386701,4342590631,'Aries'],
  [4342590631,4342780353,'Taurus'],
  [4342780353,4342957371,'Gemini'],
  [4342957371,4343127637,'Cancer'],
  [4343127637,4343298889,'Leo'],
  [4343298889,4343478378,'Virgo'],
  [4343478378,4343670687,'Libra'],
  [4343670687,4343875949,'Scorpio'],
  [4343875949,4344090264,'Sagittarius'],
  [4344090264,4344308414,'Capricorn'],
  [4344308414,4344526259,'Aquarius'],
  [4344526259,4344740282,'Pisces'],
  [4344740282,4344946518,'Aries'],
  [4344946518,4345141444,'Taurus'],
  [4345141444,4345324395,'Gemini'],
  [4345324395,4345498683,'Cancer'],
  [4345498683,4345670435,'Leo'],
  [4345670435,4345846710,'Virgo'],
  [4345846710,4346033619,'Libra'],
  [4346033619,4346234141,'Scorpio'],
  [4346234141,4346446449,'Sagittarius'],
  [4346446449,4346664567,'Capricorn'],
  [4346664567,4346881925,'Aquarius'],
  [4346881925,4347094177,'Pisces'],
  [4347094177,4347299116,'Aries'],
  [4347299116,4347495594,'Taurus'],
  [4347495594,4347683315,'Gemini'],
  [4347683315,4347863632,'Cancer'],
  [4347863632,4348039982,'Leo'],
  [4348039982,4348217483,'Virgo'],
  [4348217483,4348401886,'Libra'],
  [4348401886,4348597864,'Scorpio'],
  [4348597864,4348806584,'Sagittarius'],
  [4348806584,4349023799,'Capricorn'],
  [4349023799,4349241430,'Aquarius'],
  [4349241430,4349452544,'Pisces'],
  [4349452544,4349654500,'Aries'],
  [4349654500,4349848236,'Taurus'],
  [4349848236,4350035984,'Gemini'],
  [4350035984,4350219852,'Cancer'],
  [4350219852,4350401728,'Leo'],
  [4350401728,4350584000,'Virgo'],
  [4350584000,4350770178,'Libra'],
  [4350770178,4350964512,'Scorpio'],
  [4350964512,4351170064,'Sagittarius'],
  [4351170064,4351385621,'Capricorn'],
  [4351385621,4351604105,'Aquarius'],
  [4351604105,4351816253,'Pisces'],
  [4351816253,4352016825,'Aries'],
  [4352016825,4352206631,'Taurus'],
  [4352206631,4352390060,'Gemini'],
  [4352390060,4352571903,'Cancer'],
  [4352571903,4352755419,'Leo'],
  [4352755419,4352942035,'Virgo'],
  [4352942035,4353132618,'Libra'],
  [4353132618,4353328990,'Scorpio'],
  [4353328990,4353533768,'Sagittarius'],
  [4353533768,4353747848,'Capricorn'],
  [4353747848,4353967012,'Aquarius'],
  [4353967012,4354182056,'Pisces'],
  [4354182056,4354384786,'Aries'],
  [4354384786,4354573538,'Taurus'],
  [4354573538,4354752665,'Gemini'],
  [4354752665,4354928894,'Cancer'],
  [4354928894,4355108266,'Leo'],
  [4355108266,4355294260,'Virgo'],
  [4355294260,4355487489,'Libra'],
  [4355487489,4355687383,'Scorpio'],
  [4355687383,4355894042,'Sagittarius'],
  [4355894042,4356107955,'Capricorn'],
  [4356107955,4356327209,'Aquarius'],
  [4356327209,4356545073,'Pisces'],
  [4356545073,4356752556,'Aries'],
  [4356752556,4356944757,'Taurus'],
  [4356944757,4357123708,'Gemini'],
  [4357123708,4357295942,'Cancer'],
  [4357295942,4357469042,'Leo'],
  [4357469042,4357649264,'Virgo'],
  [4357649264,4357839836,'Libra'],
  [4357839836,4358040615,'Scorpio'],
  [4358040615,4358249606,'Sagittarius'],
  [4358249606,4358464762,'Capricorn'],
  [4358464762,4358683943,'Aquarius'],
  [4358683943,4358902851,'Pisces'],
  [4358902851,4359114511,'Aries'],
  [4359114511,4359312718,'Taurus'],
  [4359312718,4359496302,'Gemini'],
  [4359496302,4359669519,'Cancer'],
  [4359669519,4359839441,'Leo'],
  [4359839441,4360013472,'Virgo'],
  [4360013472,4360197539,'Libra'],
  [4360197539,4360394442,'Scorpio'],
  [4360394442,4360603051,'Sagittarius'],
  [4360603051,4360819356,'Capricorn'],
  [4360819356,4361038788,'Aquarius'],
  [4361038788,4361257135,'Pisces'],
  [4361257135,4361469920,'Aries'],
  [4361469920,4361672605,'Taurus'],
  [4361672605,4361862634,'Gemini'],
  [4361862634,4362041271,'Cancer'],
  [4362041271,4362213239,'Leo'],
  [4362213239,4362385106,'Virgo'],
  [4362385106,4362563679,'Libra'],
  [4362563679,4362754353,'Scorpio'],
  [4362754353,4362959013,'Sagittarius'],
  [4362959013,4363174511,'Capricorn'],
  [4363174511,4363394189,'Aquarius'],
  [4363394189,4363611678,'Pisces'],
  [4363611678,4363822993,'Aries'],
  [4363822993,4364026109,'Taurus'],
  [4364026109,4364219961,'Gemini'],
  [4364219961,4364404677,'Cancer'],
  [4364404677,4364582276,'Leo'],
  [4364582276,4364756890,'Virgo'],
  [4364756890,4364934269,'Libra'],
  [4364934269,4365120548,'Scorpio'],
  [4365120548,4365320125,'Sagittarius'],
  [4365320125,4365532695,'Capricorn'],
  [4365532695,4365751946,'Aquarius'],
  [4365751946,4365969179,'Pisces'],
  [4365969179,4366178651,'Aries'],
  [4366178651,4366379237,'Taurus'],
  [4366379237,4366572331,'Gemini'],
  [4366572331,4366759572,'Cancer'],
  [4366759572,4366942264,'Leo'],
  [4366942264,4367122160,'Virgo'],
  [4367122160,4367302573,'Libra'],
  [4367302573,4367488458,'Scorpio'],
  [4367488458,4367684919,'Sagittarius'],
  [4367684919,4367894163,'Capricorn'],
  [4367894163,4368112256,'Aquarius'],
  [4368112256,4368329975,'Pisces'],
  [4368329975,4368539068,'Aries'],
  [4368539068,4368737120,'Taurus'],
  [4368737120,4368926677,'Gemini'],
  [4368926677,4369111753,'Cancer'],
  [4369111753,4369295354,'Leo'],
  [4369295354,4369478994,'Virgo'],
  [4369478994,4369663950,'Libra'],
  [4369663950,4369852796,'Scorpio'],
  [4369852796,4370049411,'Sagittarius'],
  [4370049411,4370256836,'Capricorn'],
  [4370256836,4370473674,'Aquarius'],
  [4370473674,4370692308,'Pisces'],
  [4370692308,4370903039,'Aries'],
  [4370903039,4371100916,'Taurus'],
  [4371100916,4371287596,'Gemini'],
  [4371287596,4371468291,'Cancer'],
  [4371468291,4371648325,'Leo'],
  [4371648325,4371831198,'Virgo'],
  [4371831198,4372018419,'Libra'],
  [4372018419,4372210853,'Scorpio'],
  [4372210853,4372410042,'Sagittarius'],
  [4372410042,4372617866,'Capricorn'],
  [4372617866,4372834083,'Aquarius'],
  [4372834083,4373053537,'Pisces'],
  [4373053537,4373267193,'Aries'],
  [4373267193,4373467904,'Taurus'],
  [4373467904,4373654894,'Gemini'],
  [4373654894,4373832687,'Cancer'],
  [4373832687,4374007719,'Leo'],
  [4374007719,4374185805,'Virgo'],
  [4374185805,4374370735,'Libra'],
  [4374370735,4374564031,'Scorpio'],
  [4374564031,4374765766,'Sagittarius'],
  [4374765766,4374975475,'Capricorn'],
  [4374975475,4375192008,'Aquarius'],
  [4375192008,4375411791,'Pisces'],
  [4375411791,4375628029,'Aries'],
  [4375628029,4375833349,'Taurus'],
  [4375833349,4376024325,'Gemini'],
  [4376024325,4376203127,'Cancer'],
  [4376203127,4376375502,'Leo'],
  [4376375502,4376548257,'Virgo'],
  [4376548257,4376727518,'Libra'],
  [4376727518,4376917357,'Scorpio'],
  [4376917357,4377118837,'Sagittarius'],
  [4377118837,4377330068,'Capricorn'],
  [4377330068,4377547540,'Aquarius'],
  [4377547540,4377767198,'Pisces'],
  [4377767198,4377984239,'Aries'],
  [4377984239,4378193262,'Taurus'],
  [4378193262,4378390012,'Gemini'],
  [4378390012,4378573825,'Cancer'],
  [4378573825,4378748044,'Leo'],
  [4378748044,4378918655,'Virgo'],
  [4378918655,4379092646,'Libra'],
  [4379092646,4379276439,'Scorpio'],
  [4379276439,4379473885,'Sagittarius'],
  [4379473885,4379684242,'Capricorn'],
  [4379684242,4379902354,'Aquarius'],
  [4379902354,4380121847,'Pisces'],
  [4380121847,4380337927,'Aries'],
  [4380337927,4380547521,'Taurus'],
  [4380547521,4380748172,'Gemini'],
  [4380748172,4380938235,'Cancer'],
  [4380938235,4381118212,'Leo'],
  [4381118212,4381291545,'Virgo'],
  [4381291545,4381464190,'Libra'],
  [4381464190,4381643255,'Scorpio'],
  [4381643255,4381834953,'Sagittarius'],
  [4381834953,4382041525,'Capricorn'],
  [4382041525,4382258814,'Aquarius'],
  [4382258814,4382478383,'Pisces'],
  [4382478383,4382693216,'Aries'],
  [4382693216,4382900678,'Taurus'],
  [4382900678,4383100851,'Gemini'],
  [4383100851,4383293953,'Cancer'],
  [4383293953,4383479801,'Leo'],
  [4383479801,4383659167,'Virgo'],
  [4383659167,4383835319,'Libra'],
  [4383835319,4384014032,'Scorpio'],
  [4384014032,4384201990,'Sagittarius'],
  [4384201990,4384403882,'Capricorn'],
  [4384403882,4384618589,'Aquarius'],
  [4384618589,4384838145,'Pisces'],
  [4384838145,4385052985,'Aries'],
  [4385052985,4385258394,'Taurus'],
  [4385258394,4385455150,'Gemini'],
  [4385455150,4385646070,'Cancer'],
  [4385646070,4385833154,'Leo'],
  [4385833154,4386017106,'Virgo'],
  [4386017106,4386198922,'Libra'],
  [4386198922,4386381605,'Scorpio'],
  [4386381605,4386570141,'Sagittarius'],
  [4386570141,4386769541,'Capricorn'],
  [4386769541,4386981305,'Aquarius'],
  [4386981305,4387200287,'Pisces'],
  [4387200287,4387416564,'Aries'],
  [4387416564,4387622465,'Taurus'],
  [4387622465,4387816860,'Gemini'],
  [4387816860,4388003291,'Cancer'],
  [4388003291,4388186304,'Leo'],
  [4388186304,4388369173,'Virgo'],
  [4388369173,4388553592,'Libra'],
  [4388553592,4388740891,'Scorpio'],
  [4388740891,4388933297,'Sagittarius'],
  [4388933297,4389133819,'Capricorn'],
  [4389133819,4389344311,'Aquarius'],
  [4389344311,4389562399,'Pisces'],
  [4389562399,4389780433,'Aries'],
  [4389780433,4389989486,'Taurus'],
  [4389989486,4390185275,'Gemini'],
  [4390185275,4390369578,'Cancer'],
  [4390369578,4390547539,'Leo'],
  [4390547539,4390724823,'Virgo'],
  [4390724823,4390905946,'Libra'],
  [4390905946,4391093657,'Scorpio'],
  [4391093657,4391289174,'Sagittarius'],
  [4391289174,4391492841,'Capricorn'],
  [4391492841,4391704428,'Aquarius'],
  [4391704428,4391922143,'Pisces'],
  [4391922143,4392141123,'Aries'],
  [4392141123,4392353959,'Taurus'],
  [4392353959,4392554419,'Gemini'],
  [4392554419,4392741147,'Cancer'],
  [4392741147,4392917609,'Leo'],
  [4392917609,4393089901,'Virgo'],
  [4393089901,4393264664,'Libra'],
  [4393264664,4393447520,'Scorpio'],
  [4393447520,4393641644,'Sagittarius'],
  [4393641644,4393846884,'Capricorn'],
  [4393846884,4394060469,'Aquarius'],
  [4394060469,4394278731,'Pisces'],
  [4394278731,4394497729,'Aries'],
  [4394497729,4394712688,'Taurus'],
  [4394712688,4394918169,'Gemini'],
  [4394918169,4395110561,'Cancer'],
  [4395110561,4395290328,'Leo'],
  [4395290328,4395461953,'Virgo'],
  [4395461953,4395632317,'Libra'],
  [4395632317,4395808824,'Scorpio'],
  [4395808824,4395997449,'Sagittarius'],
  [4395997449,4396200301,'Capricorn'],
  [4396200301,4396414295,'Aquarius'],
  [4396414295,4396633339,'Pisces'],
  [4396633339,4396852023,'Aries'],
  [4396852023,4397066840,'Taurus'],
  [4397066840,4397274736,'Gemini'],
  [4397274736,4397472460,'Cancer'],
  [4397472460,4397658259,'Leo'],
  [4397658259,4397833800,'Virgo'],
  [4397833800,4398004374,'Libra'],
  [4398004374,4398177372,'Scorpio'],
  [4398177372,4398360257,'Sagittarius'],
  [4398360257,4398557891,'Capricorn'],
  [4398557891,4398769457,'Aquarius'],
  [4398769457,4398988350,'Pisces'],
  [4398988350,4399206812,'Aries'],
  [4399206812,4399420333,'Taurus'],
  [4399420333,4399627417,'Gemini'],
  [4399627417,4399827012,'Cancer'],
  [4399827012,4400017668,'Leo'],
  [4400017668,4400199071,'Virgo'],
  [4400199071,4400373900,'Libra'],
  [4400373900,4400547880,'Scorpio'],
  [4400547880,4400728200,'Sagittarius'],
  [4400728200,4400921100,'Capricorn'],
  [4400921100,4401128542,'Aquarius'],
  [4401128542,4401345846,'Pisces'],
  [4401345846,4401564203,'Aries'],
  [4401564203,4401776794,'Taurus'],
  [4401776794,4401981588,'Gemini'],
  [4401981588,4402179303,'Cancer'],
  [4402179303,4402370681,'Leo'],
  [4402370681,4402555908,'Virgo'],
  [4402555908,4402736031,'Libra'],
  [4402736031,4402914333,'Scorpio'],
  [4402914333,4403096165,'Sagittarius'],
  [4403096165,4403287343,'Capricorn'],
  [4403287343,4403491357,'Aquarius'],
  [4403491357,4403706292,'Pisces'],
  [4403706292,4403924537,'Aries'],
  [4403924537,4404137501,'Taurus'],
  [4404137501,4404340942,'Gemini'],
  [4404340942,4404535443,'Cancer'],
  [4404535443,4404723668,'Leo'],
  [4404723668,4404908116,'Virgo'],
  [4404908116,4405090667,'Libra'],
  [4405090667,4405273389,'Scorpio'],
  [4405273389,4405459300,'Sagittarius'],
  [4405459300,4405652192,'Capricorn'],
  [4405652192,4405855191,'Aquarius'],
  [4405855191,4406068250,'Pisces'],
  [4406068250,4406286311,'Aries'],
  [4406286311,4406500959,'Taurus'],
  [4406500959,4406705513,'Gemini'],
  [4406705513,4406898519,'Cancer'],
  [4406898519,4407082783,'Leo'],
  [4407082783,4407262809,'Virgo'],
  [4407262809,4407442942,'Libra'],
  [4407442942,4407626502,'Scorpio'],
  [4407626502,4407815725,'Sagittarius'],
  [4407815725,4408012106,'Capricorn'],
  [4408012106,4408216654,'Aquarius'],
  [4408216654,4408429268,'Pisces'],
  [4408429268,4408647115,'Aries'],
  [4408647115,4408863857,'Taurus'],
  [4408863857,4409071908,'Gemini'],
  [4409071908,4409266937,'Cancer'],
  [4409266937,4409449879,'Leo'],
  [4409449879,4409625517,'Virgo'],
  [4409625517,4409800165,'Libra'],
  [4409800165,4409979737,'Scorpio'],
  [4409979737,4410168199,'Sagittarius'],
  [4410168199,4410366646,'Capricorn'],
  [4410366646,4410573773,'Aquarius'],
  [4410573773,4410787434,'Pisces'],
  [4410787434,4411005191,'Aries'],
  [4411005191,4411223173,'Taurus'],
  [4411223173,4411435253,'Gemini'],
  [4411435253,4411635361,'Cancer'],
  [4411635361,4411821347,'Leo'],
  [4411821347,4411996225,'Virgo'],
  [4411996225,4412166542,'Libra'],
  [4412166542,4412339979,'Scorpio'],
  [4412339979,4412523202,'Sagittarius'],
  [4412523202,4412719525,'Capricorn'],
  [4412719525,4412927516,'Aquarius'],
  [4412927516,4413142676,'Pisces'],
  [4413142676,4413360696,'Aries'],
  [4413360696,4413578532,'Taurus'],
  [4413578532,4413792638,'Gemini'],
  [4413792638,4413997921,'Cancer'],
  [4413997921,4414190116,'Leo'],
  [4414190116,4414369103,'Virgo'],
  [4414369103,4414539637,'Libra'],
  [4414539637,4414709353,'Scorpio'],
  [4414709353,4414886375,'Sagittarius'],
  [4414886375,4415076837,'Capricorn'],
  [4415076837,4415281923,'Aquarius'],
  [4415281923,4415497106,'Pisces'],
  [4415497106,4415715616,'Aries'],
  [4415715616,4415932703,'Taurus'],
  [4415932703,4416146001,'Gemini'],
  [4416146001,4416353055,'Cancer'],
  [4416353055,4416550486,'Leo'],
  [4416550486,4416736150,'Virgo'],
  [4416736150,4416911741,'Libra'],
  [4416911741,4417082888,'Scorpio'],
  [4417082888,4417257216,'Sagittarius'],
  [4417257216,4417442057,'Capricorn'],
  [4417442057,4417641575,'Aquarius'],
  [4417641575,4417854026,'Pisces'],
  [4417854026,4418072402,'Aries'],
  [4418072402,4418289261,'Taurus'],
  [4418289261,4418500712,'Gemini'],
  [4418500712,4418705712,'Cancer'],
  [4418705712,4418903618,'Leo'],
  [4418903618,4419093461,'Virgo'],
  [4419093461,4419275371,'Libra'],
  [4419275371,4419452100,'Scorpio'],
  [4419452100,4419628923,'Sagittarius'],
  [4419628923,4419812217,'Capricorn'],
  [4419812217,4420007271,'Aquarius'],
  [4420007271,4420215463,'Pisces'],
  [4420215463,4420432363,'Aries'],
  [4420432363,4420649683,'Taurus'],
  [4420649683,4420860619,'Gemini'],
  [4420860619,4421062824,'Cancer'],
  [4421062824,4421257200,'Leo'],
  [4421257200,4421445606,'Virgo'],
  [4421445606,4421629784,'Libra'],
  [4421629784,4421811628,'Scorpio'],
  [4421811628,4421993848,'Sagittarius'],
  [4421993848,4422180174,'Capricorn'],
  [4422180174,4422374666,'Aquarius'],
  [4422374666,4422579932,'Pisces'],
  [4422579932,4422794669,'Aries'],
  [4422794669,4423012517,'Taurus'],
  [4423012517,4423225019,'Gemini'],
  [4423225019,4423426854,'Cancer'],
  [4423426854,4423617884,'Leo'],
  [4423617884,4423801537,'Virgo'],
  [4423801537,4423982339,'Libra'],
  [4423982339,4424164201,'Scorpio'],
  [4424164201,4424349748,'Sagittarius'],
  [4424349748,4424540558,'Capricorn'],
  [4424540558,4424737959,'Aquarius'],
  [4424737959,4424943310,'Pisces'],
  [4424943310,4425156721,'Aries'],
  [4425156721,4425374751,'Taurus'],
  [4425374751,4425589910,'Gemini'],
  [4425589910,4425794539,'Cancer'],
  [4425794539,4425985668,'Leo'],
  [4425985668,4426165953,'Virgo'],
  [4426165953,4426341347,'Libra'],
  [4426341347,4426518327,'Scorpio'],
  [4426518327,4426701855,'Sagittarius'],
  [4426701855,4426894098,'Capricorn'],
  [4426894098,4427094645,'Aquarius'],
  [4427094645,4427302247,'Pisces'],
  [4427302247,4427515971,'Aries'],
  [4427515971,4427733994,'Taurus'],
  [4427733994,4427951329,'Gemini'],
  [4427951329,4428160323,'Cancer'],
  [4428160323,4428355298,'Leo'],
  [4428355298,4428536360,'Virgo'],
  [4428536360,4428708840,'Libra'],
  [4428708840,4428880338,'Scorpio'],
  [4428880338,4429058110,'Sagittarius'],
  [4429058110,4429246893,'Capricorn'],
  [4429246893,4429447330,'Aquarius'],
  [4429447330,4429656726,'Pisces'],
  [4429656726,4429871754,'Aries'],
  [4429871754,4430089904,'Taurus'],
  [4430089904,4430308006,'Gemini'],
  [4430308006,4430520416,'Cancer'],
  [4430520416,4430720791,'Leo'],
  [4430720791,4430906472,'Virgo'],
  [4430906472,4431080505,'Libra'],
  [4431080505,4431249822,'Scorpio'],
  [4431249822,4431422444,'Sagittarius'],
  [4431422444,4431605226,'Capricorn'],
  [4431605226,4431801539,'Aquarius'],
  [4431801539,4432009937,'Pisces'],
  [4432009937,4432225702,'Aries'],
  [4432225702,4432444122,'Taurus'],
  [4432444122,4432661785,'Gemini'],
  [4432661785,4432875043,'Cancer'],
  [4432875043,4433079207,'Leo'],
  [4433079207,4433270667,'Virgo'],
  [4433270667,4433449827,'Libra'],
  [4433449827,4433621445,'Scorpio'],
  [4433621445,4433792663,'Sagittarius'],
  [4433792663,4433970857,'Capricorn'],
  [4433970857,4434161511,'Aquarius'],
  [4434161511,4434365974,'Pisces'],
  [4434365974,4434580632,'Aries'],
  [4434580632,4434799126,'Taurus'],
  [4434799126,4435016032,'Gemini'],
  [4435016032,4435227940,'Cancer'],
  [4435227940,4435432356,'Leo'],
  [4435432356,4435627201,'Virgo'],
  [4435627201,4435811960,'Libra'],
  [4435811960,4435988939,'Scorpio'],
  [4435988939,4436163040,'Sagittarius'],
  [4436163040,4436340506,'Capricorn'],
  [4436340506,4436527298,'Aquarius'],
  [4436527298,4436727027,'Pisces'],
  [4436727027,4436938797,'Aries'],
  [4436938797,4437156784,'Taurus'],
  [4437156784,4437373446,'Gemini'],
  [4437373446,4437583621,'Cancer'],
  [4437583621,4437785535,'Leo'],
  [4437785535,4437979504,'Virgo'],
  [4437979504,4438166605,'Libra'],
  [4438166605,4438348507,'Scorpio'],
  [4438348507,4438527865,'Sagittarius'],
  [4438527865,4438708519,'Capricorn'],
  [4438708519,4438895124,'Aquarius'],
  [4438895124,4439091909,'Pisces'],
  [4439091909,4439300450,'Aries'],
  [4439300450,4439517322,'Taurus'],
  [4439517322,4439734573,'Gemini'],
  [4439734573,4439944479,'Cancer'],
  [4439944479,4440143854,'Leo'],
  [4440143854,4440334124,'Virgo'],
  [4440334124,4440518862,'Libra'],
  [4440518862,4440701558,'Scorpio'],
  [4440701558,4440884699,'Sagittarius'],
  [4440884699,4441070099,'Capricorn'],
  [4441070099,4441259870,'Aquarius'],
  [4441259870,4441456882,'Pisces'],
  [4441456882,4441663578,'Aries'],
  [4441663578,4441879184,'Taurus'],
  [4441879184,4442097520,'Gemini'],
  [4442097520,4442309402,'Cancer'],
  [4442309402,4442508824,'Leo'],
  [4442508824,4442696125,'Virgo'],
  [4442696125,4442876126,'Libra'],
  [4442876126,4443054811,'Scorpio'],
  [4443054811,4443236865,'Sagittarius'],
  [4443236865,4443424518,'Capricorn'],
  [4443424518,4443618120,'Aquarius'],
  [4443618120,4443817945,'Pisces'],
  [4443817945,4444025097,'Aries'],
  [4444025097,4444239979,'Taurus'],
  [4444239979,4444459135,'Gemini'],
  [4444459135,4444674329,'Cancer'],
  [4444674329,4444877235,'Leo'],
  [4444877235,4445065315,'Virgo'],
  [4445065315,4445242467,'Libra'],
  [4445242467,4445415766,'Scorpio'],
  [4445415766,4445592300,'Sagittarius'],
  [4445592300,4445776934,'Capricorn'],
  [4445776934,4445971069,'Aquarius'],
  [4445971069,4446173533,'Pisces'],
  [4446173533,4446382819,'Aries'],
  [4446382819,4446598059,'Taurus'],
  [4446598059,4446817317,'Gemini'],
  [4446817317,4447035013,'Cancer'],
  [4447035013,4447243035,'Leo'],
  [4447243035,4447436041,'Virgo'],
  [4447436041,4447615088,'Libra'],
  [4447615088,4447786238,'Scorpio'],
  [4447786238,4447957308,'Sagittarius'],
  [4447957308,4448135421,'Capricorn'],
  [4448135421,4448324992,'Aquarius'],
  [4448324992,4448526475,'Pisces'],
  [4448526475,4448737198,'Aries'],
  [4448737198,4448953618,'Taurus'],
  [4448953618,4449172681,'Gemini'],
  [4449172681,4449390642,'Cancer'],
  [4449390642,4449601930,'Leo'],
  [4449601930,4449801033,'Virgo'],
  [4449801033,4449986132,'Libra'],
  [4449986132,4450160442,'Scorpio'],
  [4450160442,4450330457,'Sagittarius'],
  [4450330457,4450503626,'Capricorn'],
  [4450503626,4450686487,'Aquarius'],
  [4450686487,4450882736,'Pisces'],
  [4450882736,4451091681,'Aries'],
  [4451091681,4451308647,'Taurus'],
  [4451308647,4451527820,'Gemini'],
  [4451527820,4451744600,'Cancer'],
  [4451744600,4451955502,'Leo'],
  [4451955502,4452157496,'Virgo'],
  [4452157496,4452348629,'Libra'],
  [4452348629,4452529502,'Scorpio'],
  [4452529502,4452703703,'Sagittarius'],
  [4452703703,4452876975,'Capricorn'],
  [4452876975,4453055879,'Aquarius'],
  [4453055879,4453246140,'Pisces'],
  [4453246140,4453450354,'Aries'],
  [4453450354,4453665780,'Taurus'],
  [4453665780,4453885139,'Gemini'],
  [4453885139,4454101088,'Cancer'],
  [4454101088,4454309638,'Leo'],
  [4454309638,4454510005,'Virgo'],
  [4454510005,4454702692,'Libra'],
  [4454702692,4454888531,'Scorpio'],
  [4454888531,4455068985,'Sagittarius'],
  [4455068985,4455246902,'Capricorn'],
  [4455246902,4455426849,'Aquarius'],
  [4455426849,4455614385,'Pisces'],
  [4455614385,4455814079,'Aries'],
  [4455814079,4456026362,'Taurus'],
  [4456026362,4456245336,'Gemini'],
  [4456245336,4456461662,'Cancer'],
  [4456461662,4456668789,'Leo'],
  [4456668789,4456865805,'Virgo'],
  [4456865805,4457055444,'Libra'],
  [4457055444,4457240989,'Scorpio'],
  [4457240989,4457424656,'Sagittarius'],
  [4457424656,4457607770,'Capricorn'],
  [4457607770,4457792178,'Aquarius'],
  [4457792178,4457981315,'Pisces'],
  [4457981315,4458179485,'Aries'],
  [4458179485,4458389117,'Taurus'],
  [4458389117,4458607169,'Gemini'],
  [4458607169,4458824754,'Cancer'],
  [4458824754,4459032847,'Leo'],
  [4459032847,4459228300,'Virgo'],
  [4459228300,4459413980,'Libra'],
  [4459413980,4459595224,'Scorpio'],
  [4459595224,4459776723,'Sagittarius'],
  [4459776723,4459961077,'Capricorn'],
  [4459961077,4460149215,'Aquarius'],
  [4460149215,4460342134,'Pisces'],
  [4460342134,4460542005,'Aries'],
  [4460542005,4460751050,'Taurus'],
  [4460751050,4460968341,'Gemini'],
  [4460968341,4461187292,'Cancer'],
  [4461187292,4461398312,'Leo'],
  [4461398312,4461595513,'Virgo'],
  [4461595513,4461779891,'Libra'],
  [4461779891,4461956971,'Scorpio'],
  [4461956971,4462133263,'Sagittarius'],
  [4462133263,4462313888,'Capricorn'],
  [4462313888,4462501486,'Aquarius'],
  [4462501486,4462696641,'Pisces'],
  [4462696641,4462899334,'Aries'],
  [4462899334,4463109735,'Taurus'],
  [4463109735,4463327002,'Gemini'],
  [4463327002,4463546778,'Cancer'],
  [4463546778,4463761073,'Leo'],
  [4463761073,4463962591,'Virgo'],
  [4463962591,4464149551,'Libra'],
  [4464149551,4464325839,'Scorpio'],
  [4464325839,4464498067,'Sagittarius'],
  [4464498067,4464672978,'Capricorn'],
  [4464672978,4464855777,'Aquarius'],
  [4464855777,4465049076,'Pisces'],
  [4465049076,4465252770,'Aries'],
  [4465252770,4465464926,'Taurus'],
  [4465464926,4465682857,'Gemini'],
  [4465682857,4465902754,'Cancer'],
  [4465902754,4466118918,'Leo'],
  [4466118918,4466324987,'Virgo'],
  [4466324987,4466517263,'Libra'],
  [4466517263,4466696917,'Scorpio'],
  [4466696917,4466868968,'Sagittarius'],
  [4466868968,4467040132,'Capricorn'],
  [4467040132,4467217118,'Aquarius'],
  [4467217118,4467405141,'Pisces'],
  [4467405141,4467606308,'Aries'],
  [4467606308,4467818645,'Taurus'],
  [4467818645,4468037278,'Gemini'],
  [4468037278,4468256905,'Cancer'],
  [4468256905,4468472884,'Leo'],
  [4468472884,4468681161,'Virgo'],
  [4468681161,4468878526,'Libra'],
  [4468878526,4469064082,'Scorpio'],
  [4469064082,4469240153,'Sagittarius'],
  [4469240153,4469411779,'Capricorn'],
  [4469411779,4469585526,'Aquarius'],
  [4469585526,4469768059,'Pisces'],
  [4469768059,4469964149,'Aries'],
  [4469964149,4470174054,'Taurus'],
  [4470174054,4470392521,'Gemini'],
  [4470392521,4470611914,'Cancer'],
  [4470611914,4470826530,'Leo'],
  [4470826530,4471033847,'Virgo'],
  [4471033847,4471232968,'Libra'],
  [4471232968,4471423389,'Scorpio'],
  [4471423389,4471605486,'Sagittarius'],
  [4471605486,4471781595,'Capricorn'],
  [4471781595,4471956454,'Aquarius'],
  [4471956454,4472136449,'Pisces'],
  [4472136449,4472327807,'Aries'],
  [4472327807,4472533571,'Taurus'],
  [4472533571,4472750484,'Gemini'],
  [4472750484,4472969860,'Cancer'],
  [4472969860,4473183536,'Leo'],
  [4473183536,4473388366,'Virgo'],
  [4473388366,4473585315,'Libra'],
  [4473585315,4473776264,'Scorpio'],
  [4473776264,4473962254,'Sagittarius'],
  [4473962254,4474143990,'Capricorn'],
  [4474143990,4474323536,'Aquarius'],
  [4474323536,4474505250,'Pisces'],
  [4474505250,4474694905,'Aries'],
  [4474694905,4474897122,'Taurus'],
  [4474897122,4475111560,'Gemini'],
  [4475111560,4475330943,'Cancer'],
  [4475330943,4475545249,'Leo'],
  [4475545249,4475748817,'Virgo'],
  [4475748817,4475942312,'Libra'],
  [4475942312,4476129592,'Scorpio'],
  [4476129592,4476314272,'Sagittarius'],
  [4476314272,4476498248,'Capricorn'],
  [4476498248,4476682457,'Aquarius'],
  [4476682457,4476868700,'Pisces'],
  [4476868700,4477060473,'Aries'],
  [4477060473,4477261808,'Taurus'],
  [4477261808,4477474208,'Gemini'],
  [4477474208,4477693308,'Cancer'],
  [4477693308,4477909629,'Leo'],
  [4477909629,4478114917,'Virgo'],
  [4478114917,4478307348,'Libra'],
  [4478307348,4478490582,'Scorpio'],
  [4478490582,4478670137,'Sagittarius'],
  [4478670137,4478850701,'Capricorn'],
  [4478850701,4479035042,'Aquarius'],
  [4479035042,4479224485,'Pisces'],
  [4479224485,4479420162,'Aries'],
  [4479420162,4479623592,'Taurus'],
  [4479623592,4479835706,'Gemini'],
  [4479835706,4480054315,'Cancer'],
  [4480054315,4480272613,'Leo'],
  [4480272613,4480481964,'Virgo'],
  [4480481964,4480677472,'Libra'],
  [4480677472,4480860346,'Scorpio'],
  [4480860346,4481035810,'Sagittarius'],
  [4481035810,4481210259,'Capricorn'],
  [4481210259,4481389344,'Aquarius'],
  [4481389344,4481576802,'Pisces'],
  [4481576802,4481773987,'Aries'],
  [4481773987,4481980257,'Taurus'],
  [4481980257,4482193911,'Gemini'],
  [4482193911,4482412402,'Cancer'],
  [4482412402,4482631361,'Leo'],
  [4482631361,4482844416,'Virgo'],
  [4482844416,4483045593,'Libra'],
  [4483045593,4483232862,'Scorpio'],
  [4483232862,4483408984,'Sagittarius'],
  [4483408984,4483579888,'Capricorn'],
  [4483579888,4483752642,'Aquarius'],
  [4483752642,4483933761,'Pisces'],
  [4483933761,4484127416,'Aries'],
  [4484127416,4484333733,'Taurus'],
  [4484333733,4484548971,'Gemini'],
  [4484548971,4484768031,'Cancer'],
  [4484768031,4484986522,'Leo'],
  [4484986522,4485200625,'Virgo'],
  [4485200625,4485406213,'Libra'],
  [4485406213,4485599940,'Scorpio'],
  [4485599940,4485781401,'Sagittarius'],
  [4485781401,4485954042,'Capricorn'],
  [4485954042,4486124257,'Aquarius'],
  [4486124257,4486299616,'Pisces'],
  [4486299616,4486486858,'Aries'],
  [4486486858,4486689123,'Taurus'],
  [4486689123,4486903624,'Gemini'],
  [4486903624,4487123202,'Cancer'],
  [4487123202,4487341158,'Leo'],
  [4487341158,4487554009,'Virgo'],
  [4487554009,4487760155,'Libra'],
  [4487760155,4487957875,'Scorpio'],
  [4487957875,4488145645,'Sagittarius'],
  [4488145645,4488324004,'Capricorn'],
  [4488324004,4488496870,'Aquarius'],
  [4488496870,4488670869,'Pisces'],
  [4488670869,4488853441,'Aries'],
  [4488853441,4489050161,'Taurus'],
  [4489050161,4489261237,'Gemini'],
  [4489261237,4489480175,'Cancer'],
  [4489480175,4489698046,'Leo'],
  [4489698046,4489909388,'Virgo'],
  [4489909388,4490113259,'Libra'],
  [4490113259,4490310377,'Scorpio'],
  [4490310377,4490500886,'Sagittarius'],
  [4490500886,4490684627,'Capricorn'],
  [4490684627,4490863015,'Aquarius'],
  [4490863015,4491040224,'Pisces'],
  [4491040224,4491222457,'Aries'],
  [4491222457,4491415794,'Taurus'],
  [4491415794,4491622901,'Gemini'],
  [4491622901,4491839980,'Cancer'],
  [4491839980,4492058050,'Leo'],
  [4492058050,4492269184,'Virgo'],
  [4492269184,4492470839,'Libra'],
  [4492470839,4492664621,'Scorpio'],
  [4492664621,4492853070,'Sagittarius'],
  [4492853070,4493037882,'Capricorn'],
  [4493037882,4493220266,'Aquarius'],
  [4493220266,4493402343,'Pisces'],
  [4493402343,4493587883,'Aries'],
  [4493587883,4493781533,'Taurus'],
  [4493781533,4493986536,'Gemini'],
  [4493986536,4494201643,'Cancer'],
  [4494201643,4494419937,'Leo'],
  [4494419937,4494632490,'Virgo'],
  [4494632490,4494834155,'Libra'],
  [4494834155,4495025306,'Scorpio'],
  [4495025306,4495209499,'Sagittarius'],
  [4495209499,4495390818,'Capricorn'],
  [4495390818,4495572537,'Aquarius'],
  [4495572537,4495757064,'Pisces'],
  [4495757064,4495946520,'Aries'],
  [4495946520,4496143122,'Taurus'],
  [4496143122,4496348684,'Gemini'],
  [4496348684,4496562864,'Cancer'],
  [4496562864,4496781298,'Leo'],
  [4496781298,4496996211,'Virgo'],
  [4496996211,4497200569,'Libra'],
  [4497200569,4497392154,'Scorpio'],
  [4497392154,4497573578,'Sagittarius'],
  [4497573578,4497749997,'Capricorn'],
  [4497749997,4497927019,'Aquarius'],
  [4497927019,4498109311,'Pisces'],
  [4498109311,4498299740,'Aries'],
  [4498299740,4498499152,'Taurus'],
  [4498499152,4498706935,'Gemini'],
  [4498706935,4498921585,'Cancer'],
  [4498921585,4499140087,'Leo'],
  [4499140087,4499357040,'Virgo'],
  [4499357040,4499565581,'Libra'],
  [4499565581,4499761001,'Scorpio'],
  [4499761001,4499943417,'Sagittarius'],
  [4499943417,4500117223,'Capricorn'],
  [4500117223,4500289053,'Aquarius'],
  [4500289053,4500465794,'Pisces'],
  [4500465794,4500652763,'Aries'],
  [4500652763,4500851921,'Taurus'],
  [4500851921,4501061385,'Gemini'],
  [4501061385,4501277288,'Cancer'],
  [4501277288,4501495895,'Leo'],
  [4501495895,4501713559,'Virgo'],
  [4501713559,4501925478,'Libra'],
  [4501925478,4502126364,'Scorpio'],
  [4502126364,4502313560,'Sagittarius'],
  [4502313560,4502489052,'Capricorn'],
  [4502489052,4502658753,'Aquarius'],
  [4502658753,4502830388,'Pisces'],
  [4502830388,4503011384,'Aries'],
  [4503011384,4503206377,'Taurus'],
  [4503206377,4503414794,'Gemini'],
  [4503414794,4503631406,'Cancer'],
  [4503631406,4503850215,'Leo'],
  [4503850215,4504067312,'Virgo'],
  [4504067312,4504279971,'Libra'],
  [4504279971,4504484712,'Scorpio'],
  [4504484712,4504677994,'Sagittarius'],
  [4504677994,4504858992,'Capricorn'],
  [4504858992,4505031225,'Aquarius'],
  [4505031225,4505201518,'Pisces'],
  [4505201518,4505377855,'Aries'],
  [4505377855,4505566980,'Taurus'],
  [4505566980,4505771237,'Gemini'],
  [4505771237,4505986655,'Cancer'],
  [4505986655,4506205558,'Leo'],
  [4506205558,4506421826,'Virgo'],
  [4506421826,4506632889,'Libra'],
  [4506632889,4506837591,'Scorpio'],
  [4506837591,4507034210,'Sagittarius'],
  [4507034210,4507221170,'Capricorn'],
  [4507221170,4507399335,'Aquarius'],
  [4507399335,4507573034,'Pisces'],
  [4507573034,4507748974,'Aries'],
  [4507748974,4507934208,'Taurus'],
  [4507934208,4508133356,'Gemini'],
  [4508133356,4508345517,'Cancer'],
  [4508345517,4508563874,'Leo'],
  [4508563874,4508780095,'Virgo'],
  [4508780095,4508989447,'Libra'],
  [4508989447,4509191251,'Scorpio'],
  [4509191251,4509386313,'Sagittarius'],
  [4509386313,4509575149,'Capricorn'],
  [4509575149,4509758344,'Aquarius'],
  [4509758344,4509937909,'Pisces'],
  [4509937909,4510117873,'Aries'],
  [4510117873,4510303572,'Taurus'],
  [4510303572,4510499853,'Gemini'],
  [4510499853,4510708367,'Cancer'],
  [4510708367,4510925274,'Leo'],
  [4510925274,4511142320,'Virgo'],
  [4511142320,4511351988,'Libra'],
  [4511351988,4511551535,'Scorpio'],
  [4511551535,4511742430,'Sagittarius'],
  [4511742430,4511927826,'Capricorn'],
  [4511927826,4512110760,'Aquarius'],
  [4512110760,4512293664,'Pisces'],
  [4512293664,4512478748,'Aries'],
  [4512478748,4512668531,'Taurus'],
  [4512668531,4512865827,'Gemini'],
  [4512865827,4513072621,'Cancer'],
  [4513072621,4513287848,'Leo'],
  [4513287848,4513505794,'Virgo'],
  [4513505794,4513718046,'Libra'],
  [4513718046,4513918694,'Scorpio'],
  [4513918694,4514107290,'Sagittarius'],
  [4514107290,4514287698,'Capricorn'],
  [4514287698,4514465495,'Aquarius'],
  [4514465495,4514645829,'Pisces'],
  [4514645829,4514832105,'Aries'],
  [4514832105,4515025625,'Taurus'],
  [4515025625,4515226404,'Gemini'],
  [4515226404,4515434317,'Cancer'],
  [4515434317,4515648839,'Leo'],
  [4515648839,4515867086,'Virgo'],
  [4515867086,4516082486,'Libra'],
  [4516082486,4516287401,'Scorpio'],
  [4516287401,4516478103,'Sagittarius'],
  [4516478103,4516656725,'Capricorn'],
  [4516656725,4516829437,'Aquarius'],
  [4516829437,4517003588,'Pisces'],
  [4517003588,4517185406,'Aries'],
  [4517185406,4517378062,'Taurus'],
  [4517378062,4517580925,'Gemini'],
  [4517580925,4517791244,'Cancer'],
  [4517791244,4518006522,'Leo'],
  [4518006522,4518224651,'Virgo'],
  [4518224651,4518441771,'Libra'],
  [4518441771,4518651364,'Scorpio'],
  [4518651364,4518847545,'Sagittarius'],
  [4518847545,4519029286,'Capricorn'],
  [4519029286,4519201156,'Aquarius'],
  [4519201156,4519370796,'Pisces'],
  [4519370796,4519546192,'Aries'],
  [4519546192,4519733350,'Taurus'],
  [4519733350,4519933947,'Gemini'],
  [4519933947,4520144956,'Cancer'],
  [4520144956,4520361442,'Leo'],
  [4520361442,4520579587,'Virgo'],
  [4520579587,4520796566,'Libra'],
  [4520796566,4521008365,'Scorpio'],
  [4521008365,4521209768,'Sagittarius'],
  [4521209768,4521397561,'Capricorn'],
  [4521397561,4521573397,'Aquarius'],
  [4521573397,4521743282,'Pisces'],
  [4521743282,4521915095,'Aries'],
  [4521915095,4522096267,'Taurus'],
  [4522096267,4522291318,'Gemini'],
  [4522291318,4522499664,'Cancer'],
  [4522499664,4522716097,'Leo'],
  [4522716097,4522934414,'Virgo'],
  [4522934414,4523150441,'Libra'],
  [4523150441,4523361474,'Scorpio'],
  [4523361474,4523564659,'Sagittarius'],
  [4523564659,4523757332,'Capricorn'],
  [4523757332,4523939191,'Aquarius'],
  [4523939191,4524113565,'Pisces'],
  [4524113565,4524286530,'Aries'],
  [4524286530,4524465079,'Taurus'],
  [4524465079,4524655058,'Gemini'],
  [4524655058,4524858746,'Cancer'],
  [4524858746,4525073159,'Leo'],
  [4525073159,4525291375,'Virgo'],
  [4525291375,4525506807,'Libra'],
  [4525506807,4525715835,'Scorpio'],
  [4525715835,4525917209,'Sagittarius'],
  [4525917209,4526110609,'Capricorn'],
  [4526110609,4526296377,'Aquarius'],
  [4526296377,4526476256,'Pisces'],
  [4526476256,4526653820,'Aries'],
  [4526653820,4526834063,'Taurus'],
  [4526834063,4527022263,'Gemini'],
  [4527022263,4527222143,'Cancer'],
  [4527222143,4527433552,'Leo'],
  [4527433552,4527651168,'Virgo'],
  [4527651168,4527866933,'Libra'],
  [4527866933,4528074854,'Scorpio'],
  [4528074854,4528273245,'Sagittarius'],
  [4528273245,4528463636,'Capricorn'],
  [4528463636,4528648722,'Aquarius'],
  [4528648722,4528831142,'Pisces'],
  [4528831142,4529013315,'Aries'],
  [4529013315,4529197855,'Taurus'],
  [4529197855,4529387920,'Gemini'],
  [4529387920,4529586747,'Cancer'],
  [4529586747,4529795875,'Leo'],
  [4529795875,4530012633,'Virgo'],
  [4530012633,4530229582,'Libra'],
  [4530229582,4530438519,'Scorpio'],
  [4530438519,4530635565,'Sagittarius'],
  [4530635565,4530822239,'Capricorn'],
  [4530822239,4531003162,'Aquarius'],
  [4531003162,4531183349,'Pisces'],
  [4531183349,4531366490,'Aries'],
  [4531366490,4531554473,'Taurus'],
  [4531554473,4531748185,'Gemini'],
  [4531748185,4531948742,'Cancer'],
  [4531948742,4532157429,'Leo'],
  [4532157429,4532373553,'Virgo'],
  [4532373553,4532591920,'Libra'],
  [4532591920,4532803846,'Scorpio'],
  [4532803846,4533002728,'Sagittarius'],
  [4533002728,4533188167,'Capricorn'],
  [4533188167,4533364990,'Aquarius'],
  [4533364990,4533540031,'Pisces'],
  [4533540031,4533719426,'Aries'],
  [4533719426,4533906777,'Taurus'],
  [4533906777,4534102635,'Gemini'],
  [4534102635,4534305950,'Cancer'],
  [4534305950,4534515961,'Leo'],
  [4534515961,4534732065,'Virgo'],
  [4534732065,4534951303,'Libra'],
  [4534951303,4535166659,'Scorpio'],
  [4535166659,4535370129,'Sagittarius'],
  [4535370129,4535558362,'Capricorn'],
  [4535558362,4535734465,'Aquarius'],
  [4535734465,4535905421,'Pisces'],
  [4535905421,4536078969,'Aries'],
  [4536078969,4536261295,'Taurus'],
  [4536261295,4536455110,'Gemini'],
  [4536455110,4536659345,'Cancer'],
  [4536659345,4536871117,'Leo'],
  [4536871117,4537087867,'Virgo'],
  [4537087867,4537307138,'Libra'],
  [4537307138,4537524337,'Scorpio'],
  [4537524337,4537732613,'Sagittarius'],
  [4537732613,4537926685,'Capricorn'],
  [4537926685,4538106661,'Aquarius'],
  [4538106661,4538277783,'Pisces'],
  [4538277783,4538447656,'Aries'],
  [4538447656,4538623852,'Taurus'],
  [4538623852,4538811848,'Gemini'],
  [4538811848,4539013119,'Cancer'],
  [4539013119,4539224932,'Leo'],
  [4539224932,4539442467,'Virgo'],
  [4539442467,4539661423,'Libra'],
  [4539661423,4539878136,'Scorpio'],
  [4539878136,4540088337,'Sagittarius'],
  [4540088337,4540287671,'Capricorn'],
  [4540287671,4540474227,'Aquarius'],
  [4540474227,4540650265,'Pisces'],
  [4540650265,4540821388,'Aries'],
  [4540821388,4540994655,'Taurus'],
  [4540994655,4541176800,'Gemini'],
  [4541176800,4541372242,'Cancer'],
  [4541372242,4541581015,'Leo'],
  [4541581015,4541798306,'Virgo'],
  [4541798306,4542017235,'Libra'],
  [4542017235,4542232473,'Scorpio'],
  [4542232473,4542441066,'Sagittarius'],
  [4542441066,4542641400,'Capricorn'],
  [4542641400,4542832604,'Aquarius'],
  [4542832604,4543015235,'Pisces'],
  [4543015235,4543191963,'Aries'],
  [4543191963,4543367477,'Taurus'],
  [4543367477,4543547666,'Gemini'],
  [4543547666,4543738173,'Cancer'],
  [4543738173,4543942095,'Leo'],
  [4543942095,4544157314,'Virgo'],
  [4544157314,4544376399,'Libra'],
  [4544376399,4544591134,'Scorpio'],
  [4544591134,4544797158,'Sagittarius'],
  [4544797158,4544994438,'Capricorn'],
  [4544994438,4545184923,'Aquarius'],
  [4545184923,4545370589,'Pisces'],
  [4545370589,4545553027,'Aries'],
  [4545553027,4545734166,'Taurus'],
  [4545734166,4545917249,'Gemini'],
  [4545917249,4546106840,'Cancer'],
  [4546106840,4546307259,'Leo'],
  [4546307259,4546519488,'Virgo'],
  [4546519488,4546738322,'Libra'],
  [4546738322,4546954191,'Scorpio'],
  [4546954191,4547159714,'Sagittarius'],
  [4547159714,4547353749,'Capricorn'],
  [4547353749,4547539855,'Aquarius'],
  [4547539855,4547722772,'Pisces'],
  [4547722772,4547906007,'Aries'],
  [4547906007,4548091185,'Taurus'],
  [4548091185,4548279169,'Gemini'],
  [4548279169,4548471793,'Cancer'],
  [4548471793,4548672150,'Leo'],
  [4548672150,4548882492,'Virgo'],
  [4548882492,4549100622,'Libra'],
  [4549100622,4549318393,'Scorpio'],
  [4549318393,4549526327,'Sagittarius'],
  [4549526327,4549720347,'Capricorn'],
  [4549720347,4549903137,'Aquarius'],
  [4549903137,4550080826,'Pisces'],
  [4550080826,4550259529,'Aries'],
  [4550259529,4550443232,'Taurus'],
  [4550443232,4550633244,'Gemini'],
  [4550633244,4550829526,'Cancer'],
  [4550829526,4551032509,'Leo'],
  [4551032509,4551243205,'Virgo'],
  [4551243205,4551460843,'Libra'],
  [4551460843,4551680015,'Scorpio'],
  [4551680015,4551891758,'Sagittarius'],
  [4551891758,4552089433,'Capricorn'],
  [4552089433,4552273021,'Aquarius'],
  [4552273021,4552447838,'Pisces'],
  [4552447838,4552621051,'Aries'],
  [4552621051,4552799061,'Taurus'],
  [4552799061,4552985836,'Gemini'],
  [4552985836,4553182363,'Cancer'],
  [4553182363,4553387627,'Leo'],
  [4553387627,4553600103,'Virgo'],
  [4553600103,4553817990,'Libra'],
  [4553817990,4554037534,'Scorpio'],
  [4554037534,4554252124,'Sagittarius'],
  [4554252124,4554454893,'Capricorn'],
  [4554454893,4554643115,'Aquarius'],
  [4554643115,4554819616,'Pisces'],
  [4554819616,4554990663,'Aries'],
  [4554990663,4555163405,'Taurus'],
  [4555163405,4555344061,'Gemini'],
  [4555344061,4555536415,'Cancer'],
  [4555536415,4555740794,'Leo'],
  [4555740794,4555954379,'Virgo'],
  [4555954379,4556172970,'Libra'],
  [4556172970,4556392206,'Scorpio'],
  [4556392206,4556607378,'Sagittarius'],
  [4556607378,4556813595,'Capricorn'],
  [4556813595,4557007473,'Aquarius'],
  [4557007473,4557189215,'Pisces'],
  [4557189215,4557362689,'Aries'],
  [4557362689,4557534007,'Taurus'],
  [4557534007,4557709950,'Gemini'],
  [4557709950,4557896447,'Cancer'],
  [4557896447,4558096640,'Leo'],
  [4558096640,4558309027,'Virgo'],
  [4558309027,4558527916,'Libra'],
  [4558527916,4558746752,'Scorpio'],
  [4558746752,4558960743,'Sagittarius'],
  [4558960743,4559167131,'Capricorn'],
  [4559167131,4559364246,'Aquarius'],
  [4559364246,4559551557,'Pisces'],
  [4559551557,4559730476,'Aries'],
  [4559730476,4559904725,'Taurus'],
  [4559904725,4560079934,'Gemini'],
  [4560079934,4560262505,'Cancer'],
  [4560262505,4560457701,'Leo'],
  [4560457701,4560666765,'Virgo'],
  [4560666765,4560884881,'Libra'],
  [4560884881,4561103588,'Scorpio'],
  [4561103588,4561316181,'Sagittarius'],
  [4561316181,4561520350,'Capricorn'],
  [4561520350,4561716704,'Aquarius'],
  [4561716704,4561906360,'Pisces'],
  [4561906360,4562090210,'Aries'],
  [4562090210,4562269729,'Taurus'],
  [4562269729,4562448141,'Gemini'],
  [4562448141,4562630595,'Cancer'],
  [4562630595,4562822813,'Leo'],
  [4562822813,4563028258,'Virgo'],
  [4563028258,4563244639,'Libra'],
  [4563244639,4563463545,'Scorpio'],
  [4563463545,4563675934,'Sagittarius'],
  [4563675934,4563877928,'Capricorn'],
  [4563877928,4564070987,'Aquarius'],
  [4564070987,4564258557,'Pisces'],
  [4564258557,4564443347,'Aries'],
  [4564443347,4564626705,'Taurus'],
  [4564626705,4564809871,'Gemini'],
  [4564809871,4564995578,'Cancer'],
  [4564995578,4565188172,'Leo'],
  [4565188172,4565391680,'Virgo'],
  [4565391680,4565606238,'Libra'],
  [4565606238,4565825472,'Scorpio'],
  [4565825472,4566039386,'Sagittarius'],
  [4566039386,4566241455,'Capricorn'],
  [4566241455,4566431891,'Aquarius'],
  [4566431891,4566615158,'Pisces'],
  [4566615158,4566796327,'Aries'],
  [4566796327,4566978888,'Taurus'],
  [4566978888,4567164459,'Gemini'],
  [4567164459,4567354105,'Cancer'],
  [4567354105,4567549723,'Leo'],
  [4567549723,4567753870,'Virgo'],
  [4567753870,4567967531,'Libra'],
  [4567967531,4568186943,'Scorpio'],
  [4568186943,4568403416,'Sagittarius'],
  [4568403416,4568608522,'Capricorn'],
  [4568608522,4568799684,'Aquarius'],
  [4568799684,4568980285,'Pisces'],
  [4568980285,4569156362,'Aries'],
  [4569156362,4569333793,'Taurus'],
  [4569333793,4569516727,'Gemini'],
  [4569516727,4569707168,'Cancer'],
  [4569707168,4569905676,'Leo'],
  [4569905676,4570112267,'Virgo'],
  [4570112267,4570326485,'Libra'],
  [4570326485,4570545847,'Scorpio'],
  [4570545847,4570764321,'Sagittarius'],
  [4570764321,4570973994,'Capricorn'],
  [4570973994,4571169715,'Aquarius'],
  [4571169715,4571352019,'Pisces'],
  [4571352019,4571525823,'Aries'],
  [4571525823,4571697802,'Taurus'],
  [4571697802,4571874451,'Gemini'],
  [4571874451,4572060642,'Cancer'],
  [4572060642,4572258439,'Leo'],
  [4572258439,4572466766,'Virgo'],
  [4572466766,4572682500,'Libra'],
  [4572682500,4572901918,'Scorpio'],
  [4572901918,4573120705,'Sagittarius'],
  [4573120705,4573333535,'Capricorn'],
  [4573333535,4573535182,'Aquarius'],
  [4573535182,4573723328,'Pisces'],
  [4573723328,4573899966,'Aries'],
  [4573899966,4574070486,'Taurus'],
  [4574070486,4574241936,'Gemini'],
  [4574241936,4574421382,'Cancer'],
  [4574421382,4574613972,'Leo'],
  [4574613972,4574820579,'Virgo'],
  [4574820579,4575037031,'Libra'],
  [4575037031,4575256853,'Scorpio'],
  [4575256853,4575474799,'Sagittarius'],
  [4575474799,4575687588,'Capricorn'],
  [4575687588,4575892469,'Aquarius'],
  [4575892469,4576086909,'Pisces'],
  [4576086909,4576270130,'Aries'],
  [4576270130,4576444527,'Taurus'],
  [4576444527,4576615637,'Gemini'],
  [4576615637,4576790758,'Cancer'],
  [4576790758,4576977009,'Leo'],
  [4576977009,4577178472,'Virgo'],
  [4577178472,4577393063,'Libra'],
  [4577393063,4577613034,'Scorpio'],
  [4577613034,4577830382,'Sagittarius'],
  [4577830382,4578041217,'Capricorn'],
  [4578041217,4578244988,'Aquarius'],
  [4578244988,4578441596,'Pisces'],
  [4578441596,4578630368,'Aries'],
  [4578630368,4578811314,'Taurus'],
  [4578811314,4578987009,'Gemini'],
  [4578987009,4579162951,'Cancer'],
  [4579162951,4579346122,'Leo'],
  [4579346122,4579542436,'Virgo'],
  [4579542436,4579753062,'Libra'],
  [4579753062,4579972024,'Scorpio'],
  [4579972024,4580189589,'Sagittarius'],
  [4580189589,4580399193,'Capricorn'],
  [4580399193,4580599962,'Aquarius'],
  [4580599962,4580793975,'Pisces'],
  [4580793975,4580983073,'Aries'],
  [4580983073,4581167928,'Taurus'],
  [4581167928,4581349342,'Gemini'],
  [4581349342,4581530027,'Cancer'],
  [4581530027,4581714869,'Leo'],
  [4581714869,4581909362,'Virgo'],
  [4581909362,4582116544,'Libra'],
  [4582116544,4582333566,'Scorpio'],
  [4582333566,4582551711,'Sagittarius'],
  [4582551711,4582762143,'Capricorn'],
  [4582762143,4582961514,'Aquarius'],
  [4582961514,4583151771,'Pisces'],
  [4583151771,4583336823,'Aries'],
  [4583336823,4583519964,'Taurus'],
  [4583519964,4583703223,'Gemini'],
  [4583703223,4583888231,'Cancer'],
  [4583888231,4584077356,'Leo'],
  [4584077356,4584273806,'Virgo'],
  [4584273806,4584480160,'Libra'],
  [4584480160,4584695610,'Scorpio'],
  [4584695610,4584914161,'Sagittarius'],
  [4584914161,4585126990,'Capricorn'],
  [4585126990,4585328070,'Aquarius'],
  [4585328070,4585517140,'Pisces'],
  [4585517140,4585698076,'Aries'],
  [4585698076,4585876098,'Taurus'],
  [4585876098,4586055891,'Gemini'],
  [4586055891,4586240767,'Cancer'],
  [4586240767,4586432636,'Leo'],
  [4586432636,4586632431,'Virgo'],
  [4586632431,4586840447,'Libra'],
  [4586840447,4587055680,'Scorpio'],
  [4587055680,4587274350,'Sagittarius'],
  [4587274350,4587489702,'Capricorn'],
  [4587489702,4587694760,'Aquarius'],
  [4587694760,4587886424,'Pisces'],
  [4587886424,4588066605,'Aries'],
  [4588066605,4588240543,'Taurus'],
  [4588240543,4588414662,'Gemini'],
  [4588414662,4588594865,'Cancer'],
  [4588594865,4588785078,'Leo'],
  [4588785078,4588986201,'Virgo'],
  [4588986201,4589196390,'Libra'],
  [4589196390,4589412580,'Scorpio'],
  [4589412580,4589631256,'Sagittarius'],
  [4589631256,4589847957,'Capricorn'],
  [4589847957,4590057037,'Aquarius'],
  [4590057037,4590253793,'Pisces'],
  [4590253793,4590437310,'Aries'],
  [4590437310,4590611055,'Taurus'],
  [4590611055,4590781459,'Gemini'],
  [4590781459,4590955924,'Cancer'],
  [4590955924,4591140880,'Leo'],
  [4591140880,4591339470,'Virgo'],
  [4591339470,4591549953,'Libra'],
  [4591549953,4591767160,'Scorpio'],
  [4591767160,4591985888,'Sagittarius'],
  [4591985888,4592202427,'Capricorn'],
  [4592202427,4592413404,'Aquarius'],
  [4592413404,4592614889,'Pisces'],
  [4592614889,4592804105,'Aries'],
  [4592804105,4592981774,'Taurus'],
  [4592981774,4593152654,'Gemini'],
  [4593152654,4593324015,'Cancer'],
  [4593324015,4593503566,'Leo'],
  [4593503566,4593696958,'Virgo'],
  [4593696958,4593904773,'Libra'],
  [4593904773,4594121760,'Scorpio'],
  [4594121760,4594340552,'Sagittarius'],
  [4594340552,4594556141,'Capricorn'],
  [4594556141,4594766343,'Aquarius'],
  [4594766343,4594969473,'Pisces'],
  [4594969473,4595163343,'Aries'],
  [4595163343,4595346854,'Taurus'],
  [4595346854,4595522121,'Gemini'],
  [4595522121,4595694675,'Cancer'],
  [4595694675,4595871853,'Leo'],
  [4595871853,4596060506,'Virgo'],
  [4596060506,4596263859,'Libra'],
  [4596263859,4596478838,'Scorpio'],
  [4596478838,4596697477,'Sagittarius'],
  [4596697477,4596912440,'Capricorn'],
  [4596912440,4597120631,'Aquarius'],
  [4597120631,4597321911,'Pisces'],
  [4597321911,4597516426,'Aries'],
  [4597516426,4597703814,'Taurus'],
  [4597703814,4597884625,'Gemini'],
  [4597884625,4598061849,'Cancer'],
  [4598061849,4598240854,'Leo'],
  [4598240854,4598427880,'Virgo'],
  [4598427880,4598627495,'Libra'],
  [4598627495,4598839453,'Scorpio'],
  [4598839453,4599057502,'Sagittarius'],
  [4599057502,4599272905,'Capricorn'],
  [4599272905,4599480076,'Aquarius'],
  [4599480076,4599678315,'Pisces'],
  [4599678315,4599869571,'Aries'],
  [4599869571,4600056013,'Taurus'],
  [4600056013,4600239305,'Gemini'],
  [4600239305,4600421310,'Cancer'],
  [4600421310,4600604944,'Leo'],
  [4600604944,4600794173,'Virgo'],
  [4600794173,4600992852,'Libra'],
  [4600992852,4601202412,'Scorpio'],
  [4601202412,4601419496,'Sagittarius'],
  [4601419496,4601636274,'Capricorn'],
  [4601636274,4601844888,'Aquarius'],
  [4601844888,4602042086,'Pisces'],
  [4602042086,4602229495,'Aries'],
  [4602229495,4602411213,'Taurus'],
  [4602411213,4602591627,'Gemini'],
  [4602591627,4602774234,'Cancer'],
  [4602774234,4602961404,'Leo'],
  [4602961404,4603154749,'Virgo'],
  [4603154749,4603355609,'Libra'],
  [4603355609,4603564795,'Scorpio'],
  [4603564795,4603781010,'Sagittarius'],
  [4603781010,4603999149,'Capricorn'],
  [4603999149,4604211272,'Aquarius'],
  [4604211272,4604411176,'Pisces'],
  [4604411176,4604597963,'Aries'],
  [4604597963,4604775521,'Taurus'],
  [4604775521,4604950077,'Gemini'],
  [4604950077,4605127914,'Cancer'],
  [4605127914,4605313613,'Leo'],
  [4605313613,4605508891,'Virgo'],
  [4605508891,4605712873,'Libra'],
  [4605712873,4605923774,'Scorpio'],
  [4605923774,4606139909,'Sagittarius'],
  [4606139909,4606358520,'Capricorn'],
  [4606358520,4606574013,'Aquarius'],
  [4606574013,4606779254,'Pisces'],
  [4606779254,4606970053,'Aries'],
  [4606970053,4607147853,'Taurus'],
  [4607147853,4607318623,'Gemini'],
  [4607318623,4607490149,'Cancer'],
  [4607490149,4607669696,'Leo'],
  [4607669696,4607861711,'Virgo'],
  [4607861711,4608066022,'Libra'],
  [4608066022,4608278802,'Scorpio'],
  [4608278802,4608495824,'Sagittarius'],
  [4608495824,4608714200,'Capricorn'],
  [4608714200,4608930835,'Aquarius'],
  [4608930835,4609140535,'Pisces'],
  [4609140535,4609337775,'Aries'],
  [4609337775,4609520700,'Taurus'],
  [4609520700,4609692896,'Gemini'],
  [4609692896,4609861626,'Cancer'],
  [4609861626,4610035178,'Leo'],
  [4610035178,4610220535,'Virgo'],
  [4610220535,4610420606,'Libra'],
  [4610420606,4610632635,'Scorpio'],
  [4610632635,4610850431,'Sagittarius'],
  [4610850431,4611068670,'Capricorn'],
  [4611068670,4611284399,'Aquarius'],
  [4611284399,4611494948,'Pisces'],
  [4611494948,4611696540,'Aries'],
  [4611696540,4611886079,'Taurus'],
  [4611886079,4612064099,'Gemini'],
  [4612064099,4612235443,'Cancer'],
  [4612235443,4612407449,'Leo'],
  [4612407449,4612587707,'Virgo'],
  [4612587707,4612781603,'Libra'],
  [4612781603,4612989583,'Scorpio'],
  [4612989583,4613206465,'Sagittarius'],
  [4613206465,4613424803,'Capricorn'],
  [4613424803,4613639384,'Aquarius'],
  [4613639384,4613847963,'Pisces'],
  [4613847963,4614049290,'Aries'],
  [4614049290,4614242064,'Taurus'],
  [4614242064,4614425985,'Gemini'],
  [4614425985,4614603253,'Cancer'],
  [4614603253,4614778678,'Leo'],
  [4614778678,4614958488,'Virgo'],
  [4614958488,4615148488,'Libra'],
  [4615148488,4615351648,'Scorpio'],
  [4615351648,4615565817,'Sagittarius'],
  [4615565817,4615783964,'Capricorn'],
  [4615783964,4615998444,'Aquarius'],
  [4615998444,4616205052,'Pisces'],
  [4616205052,4616403246,'Aries'],
  [4616403246,4616594263,'Taurus'],
  [4616594263,4616779729,'Gemini'],
  [4616779729,4616961547,'Cancer'],
  [4616961547,4617142356,'Leo'],
  [4617142356,4617325789,'Virgo'],
  [4617325789,4617516064,'Libra'],
  [4617516064,4617716633,'Scorpio'],
  [4617716633,4617927931,'Sagittarius'],
  [4617927931,4618145425,'Capricorn'],
  [4618145425,4618360942,'Aquarius'],
  [4618360942,4618567603,'Pisces'],
  [4618567603,4618763304,'Aries'],
  [4618763304,4618950229,'Taurus'],
  [4618950229,4619132473,'Gemini'],
  [4619132473,4619314003,'Cancer'],
  [4619314003,4619497717,'Leo'],
  [4619497717,4619685517,'Virgo'],
  [4619685517,4619879061,'Libra'],
  [4619879061,4620080238,'Scorpio'],
  [4620080238,4620290197,'Sagittarius'],
  [4620290197,4620506981,'Capricorn'],
  [4620506981,4620724065,'Aquarius'],
  [4620724065,4620933080,'Pisces'],
  [4620933080,4621129211,'Aries'],
  [4621129211,4621313493,'Taurus'],
  [4621313493,4621491048,'Gemini'],
  [4621491048,4621668138,'Cancer'],
  [4621668138,4621849890,'Leo'],
  [4621849890,4622038964,'Virgo'],
  [4622038964,4622235638,'Libra'],
  [4622235638,4622439360,'Scorpio'],
  [4622439360,4622649927,'Sagittarius'],
  [4622649927,4622866437,'Capricorn'],
  [4622866437,4623084790,'Aquarius'],
  [4623084790,4623297297,'Pisces'],
  [4623297297,4623496952,'Aries'],
  [4623496952,4623682217,'Taurus'],
  [4623682217,4623857349,'Gemini'],
  [4623857349,4624029522,'Cancer'],
  [4624029522,4624205961,'Leo'],
  [4624205961,4624391749,'Virgo'],
  [4624391749,4624588313,'Libra'],
  [4624588313,4624793947,'Scorpio'],
  [4624793947,4625006142,'Sagittarius'],
  [4625006142,4625222972,'Capricorn'],
  [4625222972,4625441761,'Aquarius'],
  [4625441761,4625656988,'Pisces'],
  [4625656988,4625861524,'Aries'],
  [4625861524,4626051283,'Taurus'],
  [4626051283,4626228118,'Gemini'],
  [4626228118,4626398384,'Cancer'],
  [4626398384,4626569980,'Leo'],
  [4626569980,4626749978,'Virgo'],
  [4626749978,4626942438,'Libra'],
  [4626942438,4627147033,'Scorpio'],
  [4627147033,4627360145,'Sagittarius'],
  [4627360145,4627577604,'Capricorn'],
  [4627577604,4627796112,'Aquarius'],
  [4627796112,4628011925,'Pisces'],
  [4628011925,4628219862,'Aries'],
  [4628219862,4628415274,'Taurus'],
  [4628415274,4628597379,'Gemini'],
  [4628597379,4628770177,'Cancer'],
  [4628770177,4628940558,'Leo'],
  [4628940558,4629116034,'Virgo'],
  [4629116034,4629302695,'Libra'],
  [4629302695,4629503040,'Scorpio'],
  [4629503040,4629714847,'Sagittarius'],
  [4629714847,4629932577,'Capricorn'],
  [4629932577,4630150684,'Aquarius'],
  [4630150684,4630365251,'Pisces'],
  [4630365251,4630573219,'Aries'],
  [4630573219,4630771840,'Taurus'],
  [4630771840,4630959711,'Gemini'],
  [4630959711,4631138294,'Cancer'],
  [4631138294,4631312002,'Leo'],
  [4631312002,4631487014,'Virgo'],
  [4631487014,4631669732,'Libra'],
  [4631669732,4631864856,'Scorpio'],
  [4631864856,4632073113,'Sagittarius'],
  [4632073113,4632290042,'Capricorn'],
  [4632290042,4632508164,'Aquarius'],
  [4632508164,4632721344,'Pisces'],
  [4632721344,4632926803,'Aries'],
  [4632926803,4633124226,'Taurus'],
  [4633124226,4633314236,'Gemini'],
  [4633314236,4633497971,'Cancer'],
  [4633497971,4633677538,'Leo'],
  [4633677538,4633856430,'Virgo'],
  [4633856430,4634039405,'Libra'],
  [4634039405,4634231466,'Scorpio'],
  [4634231466,4634435751,'Sagittarius'],
  [4634435751,4634650715,'Capricorn'],
  [4634650715,4634869235,'Aquarius'],
  [4634869235,4635082595,'Pisces'],
  [4635082595,4635285929,'Aries'],
  [4635285929,4635479557,'Taurus'],
  [4635479557,4635666680,'Gemini'],
  [4635666680,4635850720,'Cancer'],
  [4635850720,4636034055,'Leo'],
  [4636034055,4636218246,'Virgo'],
  [4636218246,4636405234,'Libra'],
  [4636405234,4636598150,'Scorpio'],
  [4636598150,4636800480,'Sagittarius'],
  [4636800480,4637013289,'Capricorn'],
  [4637013289,4637232066,'Aquarius'],
  [4637232066,4637447484,'Pisces'],
  [4637447484,4637651614,'Aries'],
  [4637651614,4637842896,'Taurus'],
  [4637842896,4638025281,'Gemini'],
  [4638025281,4638204673,'Cancer'],
  [4638204673,4638386053,'Leo'],
  [4638386053,4638572011,'Virgo'],
  [4638572011,4638763089,'Libra'],
  [4638763089,4638959641,'Scorpio'],
  [4638959641,4639163136,'Sagittarius'],
  [4639163136,4639375068,'Capricorn'],
  [4639375068,4639593675,'Aquarius'],
  [4639593675,4639811681,'Pisces'],
  [4639811681,4640019635,'Aries'],
  [4640019635,4640212721,'Taurus'],
  [4640212721,4640393189,'Gemini'],
  [4640393189,4640567526,'Cancer'],
  [4640567526,4640742904,'Leo'],
  [4640742904,4640924771,'Virgo'],
  [4640924771,4641115440,'Libra'],
  [4641115440,4641314492,'Scorpio'],
  [4641314492,4641520779,'Sagittarius'],
  [4641520779,4641733719,'Capricorn'],
  [4641733719,4641952154,'Aquarius'],
  [4641952154,4642171577,'Pisces'],
  [4642171577,4642383937,'Aries'],
  [4642383937,4642582326,'Taurus'],
  [4642582326,4642765789,'Gemini'],
  [4642765789,4642939151,'Cancer'],
  [4642939151,4643109814,'Leo'],
  [4643109814,4643285068,'Virgo'],
  [4643285068,4643470200,'Libra'],
  [4643470200,4643667114,'Scorpio'],
  [4643667114,4643874412,'Sagittarius'],
  [4643874412,4644089023,'Capricorn'],
  [4644089023,4644307813,'Aquarius'],
  [4644307813,4644527147,'Pisces'],
  [4644527147,4644741662,'Aries'],
  [4644741662,4644945344,'Taurus'],
  [4644945344,4645135007,'Gemini'],
  [4645135007,4645312431,'Cancer'],
  [4645312431,4645483232,'Leo'],
  [4645483232,4645654559,'Virgo'],
  [4645654559,4645833264,'Libra'],
  [4645833264,4646024222,'Scorpio'],
  [4646024222,4646228612,'Sagittarius'],
  [4646228612,4646443283,'Capricorn'],
  [4646443283,4646662621,'Aquarius'],
  [4646662621,4646881317,'Pisces'],
  [4646881317,4647095203,'Aries'],
  [4647095203,4647300833,'Taurus'],
  [4647300833,4647495679,'Gemini'],
  [4647495679,4647679491,'Cancer'],
  [4647679491,4647855011,'Leo'],
  [4647855011,4648027425,'Virgo'],
  [4648027425,4648203181,'Libra'],
  [4648203181,4648388553,'Scorpio'],
  [4648388553,4648587620,'Sagittarius'],
  [4648587620,4648799729,'Capricorn'],
  [4648799729,4649018867,'Aquarius'],
  [4649018867,4649237215,'Pisces'],
  [4649237215,4649449377,'Aries'],
  [4649449377,4649653428,'Taurus'],
  [4649653428,4649849281,'Gemini'],
  [4649849281,4650037375,'Cancer'],
  [4650037375,4650218806,'Leo'],
  [4650218806,4650396074,'Virgo'],
  [4650396074,4650573547,'Libra'],
  [4650573547,4650756954,'Scorpio'],
  [4650756954,4650951710,'Sagittarius'],
  [4650951710,4651159985,'Capricorn'],
  [4651159985,4651377801,'Aquarius'],
  [4651377801,4651596266,'Pisces'],
  [4651596266,4651807510,'Aries'],
  [4651807510,4652008892,'Taurus'],
  [4652008892,4652202050,'Gemini'],
  [4652202050,4652389772,'Cancer'],
  [4652389772,4652574090,'Leo'],
  [4652574090,4652756306,'Virgo'],
  [4652756306,4652938324,'Libra'],
  [4652938324,4653123757,'Scorpio'],
  [4653123757,4653317410,'Sagittarius'],
  [4653317410,4653522875,'Capricorn'],
  [4653522875,4653738892,'Aquarius'],
  [4653738892,4653957764,'Pisces'],
  [4653957764,4654169801,'Aries'],
  [4654169801,4654370051,'Taurus'],
  [4654370051,4654559865,'Gemini'],
  [4654559865,4654743781,'Cancer'],
  [4654743781,4654926181,'Leo'],
  [4654926181,4655109664,'Virgo'],
  [4655109664,4655295394,'Libra'],
  [4655295394,4655484756,'Scorpio'],
  [4655484756,4655680426,'Sagittarius'],
  [4655680426,4655885445,'Capricorn'],
  [4655885445,4656100225,'Aquarius'],
  [4656100225,4656319522,'Pisces'],
  [4656319522,4656533811,'Aries'],
  [4656533811,4656735722,'Taurus'],
  [4656735722,4656924535,'Gemini'],
  [4656924535,4657104723,'Cancer'],
  [4657104723,4657282337,'Leo'],
  [4657282337,4657462406,'Virgo'],
  [4657462406,4657647780,'Libra'],
  [4657647780,4657839536,'Scorpio'],
  [4657839536,4658038310,'Sagittarius'],
  [4658038310,4658245004,'Capricorn'],
  [4658245004,4658459735,'Aquarius'],
  [4658459735,4658679257,'Pisces'],
  [4658679257,4658896047,'Aries'],
  [4658896047,4659101908,'Taurus'],
  [4659101908,4659293359,'Gemini'],
  [4659293359,4659472978,'Cancer'],
  [4659472978,4659646760,'Leo'],
  [4659646760,4659821304,'Virgo'],
  [4659821304,4660002003,'Libra'],
  [4660002003,4660191985,'Scorpio'],
  [4660191985,4660391936,'Sagittarius'],
  [4660391936,4660600765,'Capricorn'],
  [4660600765,4660816496,'Aquarius'],
  [4660816496,4661036040,'Pisces'],
  [4661036040,4661254148,'Aries'],
  [4661254148,4661464106,'Taurus'],
  [4661464106,4661660889,'Gemini'],
  [4661660889,4661844166,'Cancer'],
  [4661844166,4662018045,'Leo'],
  [4662018045,4662188952,'Virgo'],
  [4662188952,4662363754,'Libra'],
  [4662363754,4662548227,'Scorpio'],
  [4662548227,4662745428,'Sagittarius'],
  [4662745428,4662954504,'Capricorn'],
  [4662954504,4663171345,'Aquarius'],
  [4663171345,4663390927,'Pisces'],
  [4663390927,4663608682,'Aries'],
  [4663608682,4663820376,'Taurus'],
  [4663820376,4664022070,'Gemini'],
  [4664022070,4664211594,'Cancer'],
  [4664211594,4664390076,'Leo'],
  [4664390076,4664561918,'Virgo'],
  [4664561918,4664733637,'Libra'],
  [4664733637,4664912352,'Scorpio'],
  [4664912352,4665103854,'Sagittarius'],
  [4665103854,4665309906,'Capricorn'],
  [4665309906,4665526531,'Aquarius'],
  [4665526531,4665746300,'Pisces'],
  [4665746300,4665962954,'Aries'],
  [4665962954,4666173406,'Taurus'],
  [4666173406,4666376331,'Gemini'],
  [4666376331,4666570578,'Cancer'],
  [4666570578,4666755562,'Leo'],
  [4666755562,4666932703,'Virgo'],
  [4666932703,4667106289,'Libra'],
  [4667106289,4667282828,'Scorpio'],
  [4667282828,4667469293,'Sagittarius'],
  [4667469293,4667670292,'Capricorn'],
  [4667670292,4667884526,'Aquarius'],
  [4667884526,4668104246,'Pisces'],
  [4668104246,4668320486,'Aries'],
  [4668320486,4668528732,'Taurus'],
  [4668528732,4668729105,'Gemini'],
  [4668729105,4668923152,'Cancer'],
  [4668923152,4669111621,'Leo'],
  [4669111621,4669294687,'Virgo'],
  [4669294687,4669473815,'Libra'],
  [4669473815,4669653058,'Scorpio'],
  [4669653058,4669838427,'Sagittarius'],
  [4669838427,4670035613,'Capricorn'],
  [4670035613,4670246311,'Aquarius'],
  [4670246311,4670465181,'Pisces'],
  [4670465181,4670682211,'Aries'],
  [4670682211,4670889952,'Taurus'],
  [4670889952,4671087328,'Gemini'],
  [4671087328,4671277390,'Cancer'],
  [4671277390,4671463646,'Leo'],
  [4671463646,4671648132,'Virgo'],
  [4671648132,4671831783,'Libra'],
  [4671831783,4672016186,'Scorpio'],
  [4672016186,4672204703,'Sagittarius'],
  [4672204703,4672401734,'Capricorn'],
  [4672401734,4672610111,'Aquarius'],
  [4672610111,4672827571,'Pisces'],
  [4672827571,4673045876,'Aries'],
  [4673045876,4673255724,'Taurus'],
  [4673255724,4673453040,'Gemini'],
  [4673453040,4673639822,'Cancer'],
  [4673639822,4673820948,'Leo'],
  [4673820948,4674001215,'Virgo'],
  [4674001215,4674183913,'Libra'],
  [4674183913,4674370898,'Scorpio'],
  [4674370898,4674563567,'Sagittarius'],
  [4674563567,4674763571,'Capricorn'],
  [4674763571,4674972313,'Aquarius'],
  [4674972313,4675188874,'Pisces'],
  [4675188874,4675407981,'Aries'],
  [4675407981,4675621233,'Taurus'],
  [4675621233,4675822079,'Gemini'],
  [4675822079,4676009601,'Cancer'],
  [4676009601,4676187679,'Leo'],
  [4676187679,4676362273,'Virgo'],
  [4676362273,4676539292,'Libra'],
  [4676539292,4676723266,'Scorpio'],
  [4676723266,4676916565,'Sagittarius'],
  [4676916565,4677119343,'Capricorn'],
  [4677119343,4677330283,'Aquarius'],
  [4677330283,4677547198,'Pisces'],
  [4677547198,4677766429,'Aries'],
  [4677766429,4677982210,'Taurus'],
  [4677982210,4678188046,'Gemini'],
  [4678188046,4678380260,'Cancer'],
  [4678380260,4678559960,'Leo'],
  [4678559960,4678732126,'Virgo'],
  [4678732126,4678903594,'Libra'],
  [4678903594,4679081242,'Scorpio'],
  [4679081242,4679270243,'Sagittarius'],
  [4679270243,4679472202,'Capricorn'],
  [4679472202,4679684558,'Aquarius'],
  [4679684558,4679902562,'Pisces'],
  [4679902562,4680121684,'Aries'],
  [4680121684,4680338012,'Taurus'],
  [4680338012,4680547246,'Gemini'],
  [4680547246,4680745222,'Cancer'],
  [4680745222,4680930307,'Leo'],
  [4680930307,4681104872,'Virgo'],
  [4681104872,4681274758,'Libra'],
  [4681274758,4681447482,'Scorpio'],
  [4681447482,4681630282,'Sagittarius'],
  [4681630282,4681827610,'Capricorn'],
  [4681827610,4682038494,'Aquarius'],
  [4682038494,4682256909,'Pisces'],
  [4682256909,4682475994,'Aries'],
  [4682475994,4682691448,'Taurus'],
  [4682691448,4682900990,'Gemini'],
  [4682900990,4683102304,'Cancer'],
  [4683102304,4683293139,'Leo'],
  [4683293139,4683473310,'Virgo'],
  [4683473310,4683646206,'Libra'],
  [4683646206,4683818236,'Scorpio'],
  [4683818236,4683996994,'Sagittarius'],
  [4683996994,4684188854,'Capricorn'],
  [4684188854,4684395703,'Aquarius'],
  [4684395703,4684612844,'Pisces'],
  [4684612844,4684831838,'Aries'],
  [4684831838,4685046286,'Taurus'],
  [4685046286,4685253998,'Gemini'],
  [4685253998,4685454783,'Cancer'],
  [4685454783,4685648144,'Leo'],
  [4685648144,4685833442,'Virgo'],
  [4685833442,4686011789,'Libra'],
  [4686011789,4686187232,'Scorpio'],
  [4686187232,4686366053,'Sagittarius'],
  [4686366053,4686554819,'Capricorn'],
  [4686554819,4686757426,'Aquarius'],
  [4686757426,4686971931,'Pisces'],
  [4686971931,4687190556,'Aries'],
  [4687190556,4687404855,'Taurus'],
  [4687404855,4687610801,'Gemini'],
  [4687610801,4687808697,'Cancer'],
  [4687808697,4688000279,'Leo'],
  [4688000279,4688186780,'Virgo'],
  [4688186780,4688369193,'Libra'],
  [4688369193,4688549622,'Scorpio'],
  [4688549622,4688731984,'Sagittarius'],
  [4688731984,4688921320,'Capricorn'],
  [4688921320,4689121782,'Aquarius'],
  [4689121782,4689333689,'Pisces'],
  [4689333689,4689551667,'Aries'],
  [4689551667,4689766947,'Taurus'],
  [4689766947,4689973007,'Gemini'],
  [4689973007,4690168613,'Cancer'],
  [4690168613,4690356275,'Leo'],
  [4690356275,4690539561,'Virgo'],
  [4690539561,4690721557,'Libra'],
  [4690721557,4690904693,'Scorpio'],
  [4690904693,4691091285,'Sagittarius'],
  [4691091285,4691283938,'Capricorn'],
  [4691283938,4691485173,'Aquarius'],
  [4691485173,4691695881,'Pisces'],
  [4691695881,4691913193,'Aries'],
  [4691913193,4692130085,'Taurus'],
  [4692130085,4692338655,'Gemini'],
  [4692338655,4692534901,'Cancer'],
  [4692534901,4692720041,'Leo'],
  [4692720041,4692898571,'Virgo'],
  [4692898571,4693075945,'Libra'],
  [4693075945,4693256945,'Scorpio'],
  [4693256945,4693444726,'Sagittarius'],
  [4693444726,4693640588,'Capricorn'],
  [4693640588,4693844533,'Aquarius'],
  [4693844533,4694055912,'Pisces'],
  [4694055912,4694272890,'Aries'],
  [4694272890,4694491039,'Taurus'],
  [4694491039,4694703364,'Gemini'],
  [4694703364,4694903624,'Cancer'],
  [4694903624,4695090165,'Leo'],
  [4695090165,4695266342,'Virgo'],
  [4695266342,4695438515,'Libra'],
  [4695438515,4695613741,'Scorpio'],
  [4695613741,4695797802,'Sagittarius'],
  [4695797802,4695993367,'Capricorn'],
  [4695993367,4696199339,'Aquarius'],
  [4696199339,4696412508,'Pisces'],
  [4696412508,4696629749,'Aries'],
  [4696629749,4696848114,'Taurus'],
  [4696848114,4697063138,'Gemini'],
  [4697063138,4697268759,'Cancer'],
  [4697268759,4697460619,'Leo'],
  [4697460619,4697639177,'Virgo'],
  [4697639177,4697809668,'Libra'],
  [4697809668,4697979806,'Scorpio'],
  [4697979806,4698157443,'Sagittarius'],
  [4698157443,4698348153,'Capricorn'],
  [4698348153,4698552663,'Aquarius'],
  [4698552663,4698766762,'Pisces'],
  [4698766762,4698984735,'Aries'],
  [4698984735,4699202618,'Taurus'],
  [4699202618,4699417772,'Gemini'],
  [4699417772,4699626564,'Cancer'],
  [4699626564,4699824510,'Leo'],
  [4699824510,4700009302,'Virgo'],
  [4700009302,4700183288,'Libra'],
  [4700183288,4700352851,'Scorpio'],
  [4700352851,4700526080,'Sagittarius'],
  [4700526080,4700710421,'Capricorn'],
  [4700710421,4700909758,'Aquarius'],
  [4700909758,4701121952,'Pisces'],
  [4701121952,4701340180,'Aries'],
  [4701340180,4701557802,'Taurus'],
  [4701557802,4701771418,'Gemini'],
  [4701771418,4701979447,'Cancer'],
  [4701979447,4702179857,'Leo'],
  [4702179857,4702370399,'Virgo'],
  [4702370399,4702550935,'Libra'],
  [4702550935,4702724971,'Scorpio'],
  [4702724971,4702898861,'Sagittarius'],
  [4702898861,4703079853,'Capricorn'],
  [4703079853,4703273651,'Aquarius'],
  [4703273651,4703481435,'Pisces'],
  [4703481435,4703698331,'Aries'],
  [4703698331,4703916166,'Taurus'],
  [4703916166,4704128789,'Gemini'],
  [4704128789,4704334105,'Cancer'],
  [4704334105,4704532256,'Leo'],
  [4704532256,4704723600,'Virgo'],
  [4704723600,4704908542,'Libra'],
  [4704908542,4705088665,'Scorpio'],
  [4705088665,4705267490,'Sagittarius'],
  [4705267490,4705450098,'Capricorn'],
  [4705450098,4705641724,'Aquarius'],
  [4705641724,4705845470,'Pisces'],
  [4705845470,4706059748,'Aries'],
  [4706059748,4706277724,'Taurus'],
  [4706277724,4706491098,'Gemini'],
  [4706491098,4706695082,'Cancer'],
  [4706695082,4706889543,'Leo'],
  [4706889543,4707077038,'Virgo'],
  [4707077038,4707260691,'Libra'],
  [4707260691,4707443207,'Scorpio'],
  [4707443207,4707626893,'Sagittarius'],
  [4707626893,4707814157,'Capricorn'],
  [4707814157,4708007812,'Aquarius'],
  [4708007812,4708210455,'Pisces'],
  [4708210455,4708422568,'Aries'],
  [4708422568,4708640285,'Taurus'],
  [4708640285,4708855677,'Gemini'],
  [4708855677,4709061279,'Cancer'],
  [4709061279,4709254481,'Leo'],
  [4709254481,4709437781,'Virgo'],
  [4709437781,4709616372,'Libra'],
  [4709616372,4709795645,'Scorpio'],
  [4709795645,4709979564,'Sagittarius'],
  [4709979564,4710170021,'Capricorn'],
  [4710170021,4710367417,'Aquarius'],
  [4710367417,4710571935,'Pisces'],
  [4710571935,4710783722,'Aries'],
  [4710783722,4711001101,'Taurus'],
  [4711001101,4711218513,'Gemini'],
  [4711218513,4711427860,'Cancer'],
  [4711427860,4711623595,'Leo'],
  [4711623595,4711806069,'Virgo'],
  [4711806069,4711980517,'Libra'],
  [4711980517,4712154090,'Scorpio'],
  [4712154090,4712333324,'Sagittarius'],
  [4712333324,4712522195,'Capricorn'],
  [4712522195,4712721128,'Aquarius'],
  [4712721128,4712928168,'Pisces'],
  [4712928168,4713141250,'Aries'],
  [4713141250,4713358677,'Taurus'],
  [4713358677,4713577137,'Gemini'],
  [4713577137,4713790184,'Cancer'],
  [4713790184,4713990905,'Leo'],
  [4713990905,4714176728,'Virgo'],
  [4714176728,4714351038,'Libra'],
  [4714351038,4714520944,'Scorpio'],
  [4714520944,4714694368,'Sagittarius'],
  [4714694368,4714877765,'Capricorn'],
  [4714877765,4715073940,'Aquarius'],
  [4715073940,4715281259,'Pisces'],
  [4715281259,4715495678,'Aries'],
  [4715495678,4715713563,'Taurus'],
  [4715713563,4715931994,'Gemini'],
  [4715931994,4716146769,'Cancer'],
  [4716146769,4716352051,'Leo'],
  [4716352051,4716543554,'Virgo'],
  [4716543554,4716721898,'Libra'],
  [4716721898,4716892461,'Scorpio'],
  [4716892461,4717062889,'Sagittarius'],
  [4717062889,4717240753,'Capricorn'],
  [4717240753,4717431344,'Aquarius'],
  [4717431344,4717635537,'Pisces'],
  [4717635537,4717849595,'Aries'],
  [4717849595,4718067849,'Taurus'],
  [4718067849,4718285756,'Gemini'],
  [4718285756,4718499949,'Cancer'],
  [4718499949,4718706853,'Leo'],
  [4718706853,4718902984,'Virgo'],
  [4718902984,4719087224,'Libra'],
  [4719087224,4719262341,'Scorpio'],
  [4719262341,4719434161,'Sagittarius'],
  [4719434161,4719609718,'Capricorn'],
  [4719609718,4719795360,'Aquarius'],
  [4719795360,4719994551,'Pisces'],
  [4719994551,4720205988,'Aries'],
  [4720205988,4720423885,'Taurus'],
  [4720423885,4720641438,'Gemini'],
  [4720641438,4720854031,'Cancer'],
  [4720854031,4721059368,'Leo'],
  [4721059368,4721256323,'Virgo'],
  [4721256323,4721444574,'Libra'],
  [4721444574,4721625365,'Scorpio'],
  [4721625365,4721802010,'Sagittarius'],
  [4721802010,4721979501,'Capricorn'],
  [4721979501,4722163488,'Aquarius'],
  [4722163488,4722358633,'Pisces'],
  [4722358633,4722566358,'Aries'],
  [4722566358,4722782939,'Taurus'],
  [4722782939,4723000650,'Gemini'],
  [4723000650,4723212399,'Cancer'],
  [4723212399,4723415071,'Leo'],
  [4723415071,4723609204,'Virgo'],
  [4723609204,4723796934,'Libra'],
  [4723796934,4723980535,'Scorpio'],
  [4723980535,4724162181,'Sagittarius'],
  [4724162181,4724344412,'Capricorn'],
  [4724344412,4724530618,'Aquarius'],
  [4724530618,4724724742,'Pisces'],
  [4724724742,4724929661,'Aries'],
  [4724929661,4725144448,'Taurus'],
  [4725144448,4725362706,'Gemini'],
  [4725362706,4725575486,'Cancer'],
  [4725575486,4725777129,'Leo'],
  [4725777129,4725967751,'Virgo'],
  [4725967751,4726151330,'Libra'],
  [4726151330,4726332690,'Scorpio'],
  [4726332690,4726515473,'Sagittarius'],
  [4726515473,4726701573,'Capricorn'],
  [4726701573,4726892021,'Aquarius'],
  [4726892021,4727088372,'Pisces'],
  [4727088372,4727292852,'Aries'],
  [4727292852,4727506302,'Taurus'],
  [4727506302,4727725032,'Gemini'],
  [4727725032,4727940451,'Cancer'],
  [4727940451,4728144268,'Leo'],
  [4728144268,4728334126,'Virgo'],
  [4728334126,4728513791,'Libra'],
  [4728513791,4728689838,'Scorpio'],
  [4728689838,4728868540,'Sagittarius'],
  [4728868540,4729053825,'Capricorn'],
  [4729053825,4729246642,'Aquarius'],
  [4729246642,4729446361,'Pisces'],
  [4729446361,4729652757,'Aries'],
  [4729652757,4729866147,'Taurus'],
  [4729866147,4730084929,'Gemini'],
  [4730084929,4730302948,'Cancer'],
  [4730302948,4730511351,'Leo'],
  [4730511351,4730704696,'Virgo'],
  [4730704696,4730884385,'Libra'],
  [4730884385,4731056710,'Scorpio'],
  [4731056710,4731229388,'Sagittarius'],
  [4731229388,4731409018,'Capricorn'],
  [4731409018,4731599147,'Aquarius'],
  [4731599147,4731799647,'Pisces'],
  [4731799647,4732008308,'Aries'],
  [4732008308,4732222939,'Taurus'],
  [4732222939,4732441619,'Gemini'],
  [4732441619,4732660544,'Cancer'],
  [4732660544,4732872969,'Leo'],
  [4732872969,4733072323,'Virgo'],
  [4733072323,4733256802,'Libra'],
  [4733256802,4733430331,'Scorpio'],
  [4733430331,4733600039,'Sagittarius'],
  [4733600039,4733773588,'Capricorn'],
  [4733773588,4733957186,'Aquarius'],
  [4733957186,4734153719,'Pisces'],
  [4734153719,4734361944,'Aries'],
  [4734361944,4734577750,'Taurus'],
  [4734577750,4734796683,'Gemini'],
  [4734796683,4735014903,'Cancer'],
  [4735014903,4735228199,'Leo'],
  [4735228199,4735431902,'Virgo'],
  [4735431902,4735622985,'Libra'],
  [4735622985,4735802294,'Scorpio'],
  [4735802294,4735974441,'Sagittarius'],
  [4735974441,4736146096,'Capricorn'],
  [4736146096,4736324225,'Aquarius'],
  [4736324225,4736514337,'Pisces'],
  [4736514337,4736718384,'Aries'],
  [4736718384,4736933332,'Taurus'],
  [4736933332,4737152625,'Gemini'],
  [4737152625,4737369994,'Cancer'],
  [4737369994,4737581525,'Leo'],
  [4737581525,4737785186,'Virgo'],
  [4737785186,4737979815,'Libra'],
  [4737979815,4738165358,'Scorpio'],
  [4738165358,4738343638,'Sagittarius'],
  [4738343638,4738518636,'Capricorn'],
  [4738518636,4738695983,'Aquarius'],
  [4738695983,4738881762,'Pisces'],
  [4738881762,4739080490,'Aries'],
  [4739080490,4739292251,'Taurus'],
  [4739292251,4739511155,'Gemini'],
  [4739511155,4739728513,'Cancer'],
  [4739728513,4739938248,'Leo'],
  [4739938248,4740138964,'Virgo'],
  [4740138964,4740332110,'Libra'],
  [4740332110,4740519582,'Scorpio'],
  [4740519582,4740702864,'Sagittarius'],
  [4740702864,4740883582,'Capricorn'],
  [4740883582,4741064631,'Aquarius'],
  [4741064631,4741250553,'Pisces'],
  [4741250553,4741446338,'Aries'],
  [4741446338,4741654604,'Taurus'],
  [4741654604,4741872203,'Gemini'],
  [4741872203,4742090284,'Cancer'],
  [4742090284,4742300088,'Leo'],
  [4742300088,4742498452,'Virgo'],
  [4742498452,4742687679,'Libra'],
  [4742687679,4742872121,'Scorpio'],
  [4742872121,4743055386,'Sagittarius'],
  [4743055386,4743239370,'Capricorn'],
  [4743239370,4743425126,'Aquarius'],
  [4743425126,4743614575,'Pisces'],
  [4743614575,4743811075,'Aries'],
  [4743811075,4744017748,'Taurus'],
  [4744017748,4744233983,'Gemini'],
  [4744233983,4744452975,'Cancer'],
  [4744452975,4744664862,'Leo'],
  [4744664862,4744863719,'Virgo'],
  [4744863719,4745050488,'Libra'],
  [4745050488,4745230387,'Scorpio'],
  [4745230387,4745409286,'Sagittarius'],
  [4745409286,4745591405,'Capricorn'],
  [4745591405,4745778617,'Aquarius'],
  [4745778617,4745971488,'Pisces'],
  [4745971488,4746170922,'Aries'],
  [4746170922,4746378450,'Taurus'],
  [4746378450,4746594196,'Gemini'],
  [4746594196,4746813841,'Cancer'],
  [4746813841,4747028686,'Leo'],
  [4747028686,4747230918,'Virgo'],
  [4747230918,4747418819,'Libra'],
  [4747418819,4747596504,'Scorpio'],
  [4747596504,4747770580,'Sagittarius'],
  [4747770580,4747947368,'Capricorn'],
  [4747947368,4748131241,'Aquarius'],
  [4748131241,4748324019,'Pisces'],
  [4748324019,4748525614,'Aries'],
  [4748525614,4748735202,'Taurus'],
  [4748735202,4748951535,'Gemini'],
  [4748951535,4749171422,'Cancer'],
  [4749171422,4749388493,'Leo'],
  [4749388493,4749595245,'Virgo'],
  [4749595245,4749787594,'Libra'],
  [4749787594,4749967143,'Scorpio'],
  [4749967143,4750139456,'Sagittarius'],
  [4750139456,4750311433,'Capricorn'],
  [4750311433,4750489448,'Aquarius'],
  [4750489448,4750677953,'Pisces'],
  [4750677953,4750878398,'Aries'],
  [4750878398,4751089090,'Taurus'],
  [4751089090,4751306450,'Gemini'],
  [4751306450,4751526319,'Cancer'],
  [4751526319,4751743885,'Leo'],
  [4751743885,4751953766,'Virgo'],
  [4751953766,4752151574,'Libra'],
  [4752151574,4752336377,'Scorpio'],
  [4752336377,4752511272,'Sagittarius'],
  [4752511272,4752682046,'Capricorn'],
  [4752682046,4752855530,'Aquarius'],
  [4752855530,4753038135,'Pisces'],
  [4753038135,4753234039,'Aries'],
  [4753234039,4753443174,'Taurus'],
  [4753443174,4753660880,'Gemini'],
  [4753660880,4753880698,'Cancer'],
  [4753880698,4754097353,'Leo'],
  [4754097353,4754307412,'Virgo'],
  [4754307412,4754508441,'Libra'],
  [4754508441,4754698977,'Scorpio'],
  [4754698977,4754879610,'Sagittarius'],
  [4754879610,4755053601,'Capricorn'],
  [4755053601,4755226533,'Aquarius'],
  [4755226533,4755405165,'Pisces'],
  [4755405165,4755595653,'Aries'],
  [4755595653,4755800753,'Taurus'],
  [4755800753,4756017207,'Gemini'],
  [4756017207,4756236980,'Cancer'],
  [4756236980,4756452576,'Leo'],
  [4756452576,4756660609,'Virgo'],
  [4756660609,4756860887,'Libra'],
  [4756860887,4757053881,'Scorpio'],
  [4757053881,4757239826,'Sagittarius'],
  [4757239826,4757419636,'Capricorn'],
  [4757419636,4757596288,'Aquarius'],
  [4757596288,4757775089,'Pisces'],
  [4757775089,4757962429,'Aries'],
  [4757962429,4758163156,'Taurus'],
  [4758163156,4758376895,'Gemini'],
  [4758376895,4758596406,'Cancer'],
  [4758596406,4758812002,'Leo'],
  [4758812002,4759018205,'Virgo'],
  [4759018205,4759215260,'Libra'],
  [4759215260,4759406026,'Scorpio'],
  [4759406026,4759592887,'Sagittarius'],
  [4759592887,4759776875,'Capricorn'],
  [4759776875,4759958940,'Aquarius'],
  [4759958940,4760141732,'Pisces'],
  [4760141732,4760329914,'Aries'],
  [4760329914,4760528492,'Taurus'],
  [4760528492,4760739433,'Gemini'],
  [4760739433,4760958240,'Cancer'],
  [4760958240,4761175127,'Leo'],
  [4761175127,4761381863,'Virgo'],
  [4761381863,4761576753,'Libra'],
  [4761576753,4761763240,'Scorpio'],
  [4761763240,4761946115,'Sagittarius'],
  [4761946115,4762128928,'Capricorn'],
  [4762128928,4762313409,'Aquarius'],
  [4762313409,4762500673,'Pisces'],
  [4762500673,4762692716,'Aries'],
  [4762692716,4762892538,'Taurus'],
  [4762892538,4763102325,'Gemini'],
  [4763102325,4763320211,'Cancer'],
  [4763320211,4763538738,'Leo'],
  [4763538738,4763748610,'Virgo'],
  [4763748610,4763945012,'Libra'],
  [4763945012,4764129549,'Scorpio'],
  [4764129549,4764307508,'Sagittarius'],
  [4764307508,4764484749,'Capricorn'],
  [4764484749,4764665854,'Aquarius'],
  [4764665854,4764853440,'Pisces'],
  [4764853440,4765048570,'Aries'],
  [4765048570,4765251606,'Taurus'],
  [4765251606,4765462562,'Gemini'],
  [4765462562,4765680030,'Cancer'],
  [4765680030,4765899361,'Leo'],
  [4765899361,4766112983,'Virgo'],
  [4766112983,4766314253,'Libra'],
  [4766314253,4766501522,'Scorpio'],
  [4766501522,4766678235,'Sagittarius'],
  [4766678235,4766850551,'Capricorn'],
  [4766850551,4767025141,'Aquarius'],
  [4767025141,4767207613,'Pisces'],
  [4767207613,4767401158,'Aries'],
  [4767401158,4767605764,'Taurus'],
  [4767605764,4767818850,'Gemini'],
  [4767818850,4768036897,'Cancer'],
  [4768036897,4768256046,'Leo'],
  [4768256046,4768471535,'Virgo'],
  [4768471535,4768677862,'Libra'],
  [4768677862,4768871210,'Scorpio'],
  [4768871210,4769051792,'Sagittarius'],
  [4769051792,4769223868,'Capricorn'],
  [4769223868,4769394169,'Aquarius'],
  [4769394169,4769570061,'Pisces'],
  [4769570061,4769757679,'Aries'],
  [4769757679,4769959543,'Taurus'],
  [4769959543,4770172988,'Gemini'],
  [4770172988,4770391953,'Cancer'],
  [4770391953,4770610739,'Leo'],
  [4770610739,4770825694,'Virgo'],
  [4770825694,4771033980,'Libra'],
  [4771033980,4771232599,'Scorpio'],
  [4771232599,4771419690,'Sagittarius'],
  [4771419690,4771596421,'Capricorn'],
  [4771596421,4771767561,'Aquarius'],
  [4771767561,4771940238,'Pisces'],
  [4771940238,4772121989,'Aries'],
  [4772121989,4772318188,'Taurus'],
  [4772318188,4772528805,'Gemini'],
  [4772528805,4772747582,'Cancer'],
  [4772747582,4772966301,'Leo'],
  [4772966301,4773179853,'Virgo'],
  [4773179853,4773386760,'Libra'],
  [4773386760,4773586515,'Scorpio'],
  [4773586515,4773778104,'Sagittarius'],
  [4773778104,4773960989,'Capricorn'],
  [4773960989,4774137104,'Aquarius'],
  [4774137104,4774311528,'Pisces'],
  [4774311528,4774491229,'Aries'],
  [4774491229,4774682764,'Taurus'],
  [4774682764,4774888933,'Gemini'],
  [4774888933,4775105839,'Cancer'],
  [4775105839,4775324557,'Leo'],
  [4775324557,4775537453,'Virgo'],
  [4775537453,4775742020,'Libra'],
  [4775742020,4775939269,'Scorpio'],
  [4775939269,4776130604,'Sagittarius'],
  [4776130604,4776316578,'Capricorn'],
  [4776316578,4776497907,'Aquarius'],
  [4776497907,4776677158,'Pisces'],
  [4776677158,4776859139,'Aries'],
  [4776859139,4777049599,'Taurus'],
  [4777049599,4777252547,'Gemini'],
  [4777252547,4777466900,'Cancer'],
  [4777466900,4777685420,'Leo'],
  [4777685420,4777899016,'Virgo'],
  [4777899016,4778102717,'Libra'],
  [4778102717,4778296893,'Scorpio'],
  [4778296893,4778484553,'Sagittarius'],
  [4778484553,4778668697,'Capricorn'],
  [4778668697,4778851437,'Aquarius'],
  [4778851437,4779034639,'Pisces'],
  [4779034639,4779220901,'Aries'],
  [4779220901,4779413714,'Taurus'],
  [4779413714,4779616256,'Gemini'],
  [4779616256,4779828915,'Cancer'],
  [4779828915,4780047106,'Leo'],
  [4780047106,4780262442,'Virgo'],
  [4780262442,4780467767,'Libra'],
  [4780467767,4780661153,'Scorpio'],
  [4780661153,4780845262,'Sagittarius'],
  [4780845262,4781024728,'Capricorn'],
  [4781024728,4781204142,'Aquarius'],
  [4781204142,4781387079,'Pisces'],
  [4781387079,4781575928,'Aries'],
  [4781575928,4781772177,'Taurus'],
  [4781772177,4781976712,'Gemini'],
  [4781976712,4782189343,'Cancer'],
  [4782189343,4782407316,'Leo'],
  [4782407316,4782624508,'Virgo'],
  [4782624508,4782833386,'Libra'],
  [4782833386,4783029354,'Scorpio'],
  [4783029354,4783212969,'Sagittarius'],
  [4783212969,4783388704,'Capricorn'],
  [4783388704,4783562738,'Aquarius'],
  [4783562738,4783741107,'Pisces'],
  [4783741107,4783928223,'Aries'],
  [4783928223,4784125762,'Taurus'],
  [4784125762,4784332690,'Gemini'],
  [4784332690,4784546619,'Cancer'],
  [4784546619,4784764680,'Leo'],
  [4784764680,4784982878,'Virgo'],
  [4784982878,4785195389,'Libra'],
  [4785195389,4785396365,'Scorpio'],
  [4785396365,4785583468,'Sagittarius'],
  [4785583468,4785759221,'Capricorn'],
  [4785759221,4785929697,'Aquarius'],
  [4785929697,4786102356,'Pisces'],
  [4786102356,4786284048,'Aries'],
  [4786284048,4786478782,'Taurus'],
  [4786478782,4786685935,'Gemini'],
  [4786685935,4786901166,'Cancer'],
  [4786901166,4787119622,'Leo'],
  [4787119622,4787337695,'Virgo'],
  [4787337695,4787551878,'Libra'],
  [4787551878,4787757531,'Scorpio'],
  [4787757531,4787950614,'Sagittarius'],
  [4787950614,4788130698,'Capricorn'],
  [4788130698,4788301955,'Aquarius'],
  [4788301955,4788471596,'Pisces'],
  [4788471596,4788647653,'Aries'],
  [4788647653,4788836629,'Taurus'],
  [4788836629,4789040505,'Gemini'],
  [4789040505,4789255335,'Cancer'],
  [4789255335,4789474155,'Leo'],
  [4789474155,4789691586,'Virgo'],
  [4789691586,4789904965,'Libra'],
  [4789904965,4790112097,'Scorpio'],
  [4790112097,4790309974,'Sagittarius'],
  [4790309974,4790496442,'Capricorn'],
  [4790496442,4790672772,'Aquarius'],
  [4790672772,4790844151,'Pisces'],
  [4790844151,4791018021,'Aries'],
  [4791018021,4791201865,'Taurus'],
  [4791201865,4791400341,'Gemini'],
  [4791400341,4791612248,'Cancer'],
  [4791612248,4791830693,'Leo'],
  [4791830693,4792047857,'Virgo'],
  [4792047857,4792259504,'Libra'],
  [4792259504,4792464640,'Scorpio'],
  [4792464640,4792662863,'Sagittarius'],
  [4792662863,4792853254,'Capricorn'],
  [4792853254,4793035696,'Aquarius'],
  [4793035696,4793212617,'Pisces'],
  [4793212617,4793389143,'Aries'],
  [4793389143,4793571747,'Taurus'],
  [4793571747,4793766030,'Gemini'],
  [4793766030,4793973725,'Cancer'],
  [4793973725,4794190553,'Leo'],
  [4794190553,4794408078,'Virgo'],
  [4794408078,4794619249,'Libra'],
  [4794619249,4794821693,'Scorpio'],
  [4794821693,4795016426,'Sagittarius'],
  [4795016426,4795205317,'Capricorn'],
  [4795205317,4795389929,'Aquarius'],
  [4795389929,4795571919,'Pisces'],
  [4795571919,4795753905,'Aries'],
  [4795753905,4795939713,'Taurus'],
  [4795939713,4796133609,'Gemini'],
  [4796133609,4796338421,'Cancer'],
  [4796338421,4796552980,'Leo'],
  [4796552980,4796770947,'Virgo'],
  [4796770947,4796983760,'Libra'],
  [4796983760,4797185991,'Scorpio'],
  [4797185991,4797377457,'Sagittarius'],
  [4797377457,4797561508,'Capricorn'],
  [4797561508,4797742554,'Aquarius'],
  [4797742554,4797924422,'Pisces'],
  [4797924422,4798109746,'Aries'],
  [4798109746,4798300219,'Taurus'],
  [4798300219,4798497266,'Gemini'],
  [4798497266,4798702271,'Cancer'],
  [4798702271,4798915390,'Leo'],
  [4798915390,4799133358,'Virgo'],
  [4799133358,4799348883,'Libra'],
  [4799348883,4799554241,'Scorpio'],
  [4799554241,4799746159,'Sagittarius'],
  [4799746159,4799926960,'Capricorn'],
  [4799926960,4800102403,'Aquarius'],
  [4800102403,4800278995,'Pisces'],
  [4800278995,4800461931,'Aries'],
  [4800461931,4800653708,'Taurus'],
  [4800653708,4800854065,'Gemini'],
  [4800854065,4801061576,'Cancer'],
  [4801061576,4801275058,'Leo'],
  [4801275058,4801492784,'Virgo'],
  [4801492784,4801710266,'Libra'],
  [4801710266,4801920186,'Scorpio'],
  [4801920186,4802116537,'Sagittarius'],
  [4802116537,4802298703,'Capricorn'],
  [4802298703,4802471514,'Aquarius'],
  [4802471514,4802642499,'Pisces'],
  [4802642499,4802819197,'Aries'],
  [4802819197,4803006916,'Taurus'],
  [4803006916,4803206807,'Gemini'],
  [4803206807,4803416148,'Cancer'],
  [4803416148,4803631126,'Leo'],
  [4803631126,4803848926,'Virgo'],
  [4803848926,4804066773,'Libra'],
  [4804066773,4804279760,'Scorpio'],
  [4804279760,4804481699,'Sagittarius'],
  [4804481699,4804669183,'Capricorn'],
  [4804669183,4804844336,'Aquarius'],
  [4804844336,4805013687,'Pisces'],
  [4805013687,4805185361,'Aries'],
  [4805185361,4805366705,'Taurus'],
  [4805366705,4805561814,'Gemini'],
  [4805561814,4805769675,'Cancer'],
  [4805769675,4805985339,'Leo'],
  [4805985339,4806203535,'Virgo'],
  [4806203535,4806420766,'Libra'],
  [4806420766,4806633984,'Scorpio'],
  [4806633984,4806839100,'Sagittarius'],
  [4806839100,4807032328,'Capricorn'],
  [4807032328,4807213203,'Aquarius'],
  [4807213203,4807385724,'Pisces'],
  [4807385724,4807556794,'Aries'],
  [4807556794,4807733974,'Taurus'],
  [4807733974,4807923273,'Gemini'],
  [4807923273,4808126662,'Cancer'],
  [4808126662,4808340808,'Leo'],
  [4808340808,4808559093,'Virgo'],
  [4808559093,4808775718,'Libra'],
  [4808775718,4808987346,'Scorpio'],
  [4808987346,4809191915,'Sagittarius'],
  [4809191915,4809387622,'Capricorn'],
  [4809387622,4809573702,'Aquarius'],
  [4809573702,4809751891,'Pisces'],
  [4809751891,4809926632,'Aries'],
  [4809926632,4810104002,'Taurus'],
  [4810104002,4810290068,'Gemini'],
  [4810290068,4810488780,'Cancer'],
  [4810488780,4810699698,'Leo'],
  [4810699698,4810917280,'Virgo'],
  [4810917280,4811133876,'Libra'],
  [4811133876,4811344060,'Scorpio'],
  [4811344060,4811545947,'Sagittarius'],
  [4811545947,4811739945,'Capricorn'],
  [4811739945,4811927275,'Aquarius'],
  [4811927275,4812109643,'Pisces'],
  [4812109643,4812289588,'Aries'],
  [4812289588,4812470726,'Taurus'],
  [4812470726,4812657465,'Gemini'],
  [4812657465,4812853891,'Cancer'],
  [4812853891,4813061718,'Leo'],
  [4813061718,4813277998,'Virgo'],
  [4813277998,4813495213,'Libra'],
  [4813495213,4813705565,'Scorpio'],
  [4813705565,4813905394,'Sagittarius'],
  [4813905394,4814095706,'Capricorn'],
  [4814095706,4814280016,'Aquarius'],
  [4814280016,4814462101,'Pisces'],
  [4814462101,4814644880,'Aries'],
  [4814644880,4814830407,'Taurus'],
  [4814830407,4815020627,'Gemini'],
  [4815020627,4815217941,'Cancer'],
  [4815217941,4815424439,'Leo'],
  [4815424439,4815639517,'Virgo'],
  [4815639517,4815857669,'Libra'],
  [4815857669,4816070135,'Scorpio'],
  [4816070135,4816270553,'Sagittarius'],
  [4816270553,4816458522,'Capricorn'],
  [4816458522,4816638388,'Aquarius'],
  [4816638388,4816816160,'Pisces'],
  [4816816160,4816997010,'Aries'],
  [4816997010,4817183854,'Taurus'],
  [4817183854,4817377388,'Gemini'],
  [4817377388,4817577586,'Cancer'],
  [4817577586,4817784946,'Leo'],
  [4817784946,4817999589,'Virgo'],
  [4817999589,4818218465,'Libra'],
  [4818218465,4818434034,'Scorpio'],
  [4818434034,4818638030,'Sagittarius'],
  [4818638030,4818827254,'Capricorn'],
  [4818827254,4819004912,'Aquarius'],
  [4819004912,4819177813,'Pisces'],
  [4819177813,4819353224,'Aries'],
  [4819353224,4819536579,'Taurus'],
  [4819536579,4819729922,'Gemini'],
  [4819729922,4819932249,'Cancer'],
  [4819932249,4820141669,'Leo'],
  [4820141669,4820356872,'Virgo'],
  [4820356872,4820575948,'Libra'],
  [4820575948,4820793812,'Scorpio'],
  [4820793812,4821002651,'Sagittarius'],
  [4821002651,4821196781,'Capricorn'],
  [4821196781,4821376633,'Aquarius'],
  [4821376633,4821547906,'Pisces'],
  [4821547906,4821718411,'Aries'],
  [4821718411,4821895544,'Taurus'],
  [4821895544,4822084171,'Gemini'],
  [4822084171,4822285069,'Cancer'],
  [4822285069,4822495547,'Leo'],
  [4822495547,4822711841,'Virgo'],
  [4822711841,4822930823,'Libra'],
  [4822930823,4823148969,'Scorpio'],
  [4823148969,4823360886,'Sagittarius'],
  [4823360886,4823560885,'Capricorn'],
  [4823560885,4823746720,'Aquarius'],
  [4823746720,4823921310,'Pisces'],
  [4823921310,4824091118,'Aries'],
  [4824091118,4824263734,'Taurus'],
  [4824263734,4824445915,'Gemini'],
  [4824445915,4824641532,'Cancer'],
  [4824641532,4824849971,'Leo'],
  [4824849971,4825066600,'Virgo'],
  [4825066600,4825285660,'Libra'],
  [4825285660,4825502682,'Scorpio'],
  [4825502682,4825714205,'Sagittarius'],
  [4825714205,4825917001,'Capricorn'],
  [4825917001,4826108796,'Aquarius'],
  [4826108796,4826289978,'Pisces'],
  [4826289978,4826464141,'Aries'],
  [4826464141,4826637126,'Taurus'],
  [4826637126,4826815581,'Gemini'],
  [4826815581,4827005272,'Cancer'],
  [4827005272,4827208848,'Leo'],
  [4827208848,4827423759,'Virgo'],
  [4827423759,4827642949,'Libra'],
  [4827642949,4827859167,'Scorpio'],
  [4827859167,4828068323,'Sagittarius'],
  [4828068323,4828269390,'Capricorn'],
  [4828269390,4828462659,'Aquarius'],
  [4828462659,4828648859,'Pisces'],
  [4828648859,4828829478,'Aries'],
  [4828829478,4829007411,'Taurus'],
  [4829007411,4829187181,'Gemini'],
  [4829187181,4829374242,'Cancer'],
  [4829374242,4829573169,'Leo'],
  [4829573169,4829784697,'Virgo'],
  [4829784697,4830003414,'Libra'],
  [4830003414,4830220125,'Scorpio'],
  [4830220125,4830427957,'Sagittarius'],
  [4830427957,4830625569,'Capricorn'],
  [4830625569,4830815510,'Aquarius'],
  [4830815510,4831001165,'Pisces'],
  [4831001165,4831184971,'Aries'],
  [4831184971,4831368358,'Taurus'],
  [4831368358,4831552998,'Gemini'],
  [4831552998,4831741992,'Cancer'],
  [4831741992,4831939465,'Leo'],
  [4831939465,4832148125,'Virgo'],
  [4832148125,4832365672,'Libra'],
  [4832365672,4832583720,'Scorpio'],
  [4832583720,4832792862,'Sagittarius'],
  [4832792862,4832989157,'Capricorn'],
  [4832989157,4833175046,'Aquarius'],
  [4833175046,4833355980,'Pisces'],
  [4833355980,4833537094,'Aries'],
  [4833537094,4833721409,'Taurus'],
  [4833721409,4833909860,'Gemini'],
  [4833909860,4834103005,'Cancer'],
  [4834103005,4834302542,'Leo'],
  [4834302542,4834510690,'Virgo'],
  [4834510690,4834727218,'Libra'],
  [4834727218,4834946428,'Scorpio'],
  [4834946428,4835158764,'Sagittarius'],
  [4835158764,4835357404,'Capricorn'],
  [4835357404,4835542478,'Aquarius'],
  [4835542478,4835719342,'Pisces'],
  [4835719342,4835894866,'Aries'],
  [4835894866,4836074747,'Taurus'],
  [4836074747,4836262028,'Gemini'],
  [4836262028,4836457194,'Cancer'],
  [4836457194,4836659762,'Leo'],
  [4836659762,4836869575,'Virgo'],
  [4836869575,4837086074,'Libra'],
  [4837086074,4837305741,'Scorpio'],
  [4837305741,4837521113,'Sagittarius'],
  [4837521113,4837724419,'Capricorn'],
  [4837724419,4837912847,'Aquarius'],
  [4837912847,4838089679,'Pisces'],
  [4838089679,4838261545,'Aries'],
  [4838261545,4838435552,'Taurus'],
  [4838435552,4838617362,'Gemini'],
  [4838617362,4838809890,'Cancer'],
  [4838809890,4839013030,'Leo'],
  [4839013030,4839224659,'Virgo'],
  [4839224659,4839442010,'Libra'],
  [4839442010,4839661613,'Scorpio'],
  [4839661613,4839878264,'Sagittarius'],
  [4839878264,4840085702,'Capricorn'],
  [4840085702,4840279690,'Aquarius'],
  [4840279690,4840460682,'Pisces'],
  [4840460682,4840633322,'Aries'],
  [4840633322,4840804293,'Taurus'],
  [4840804293,4840980441,'Gemini'],
  [4840980441,4841167236,'Cancer'],
  [4841167236,4841367137,'Leo'],
  [4841367137,4841578512,'Virgo'],
  [4841578512,4841796597,'Libra'],
  [4841796597,4842016019,'Scorpio'],
  [4842016019,4842232106,'Sagittarius'],
  [4842232106,4842440918,'Capricorn'],
  [4842440918,4842639306,'Aquarius'],
  [4842639306,4842826175,'Pisces'],
  [4842826175,4843003480,'Aries'],
  [4843003480,4843175892,'Taurus'],
  [4843175892,4843349696,'Gemini'],
  [4843349696,4843531434,'Cancer'],
  [4843531434,4843726078,'Leo'],
  [4843726078,4843934523,'Virgo'],
  [4843934523,4844152186,'Libra'],
  [4844152186,4844371510,'Scorpio'],
  [4844371510,4844586326,'Sagittarius'],
  [4844586326,4844793721,'Capricorn'],
  [4844793721,4844992897,'Aquarius'],
  [4844992897,4845183697,'Pisces'],
  [4845183697,4845366676,'Aries'],
  [4845366676,4845543932,'Taurus'],
  [4845543932,4845719676,'Gemini'],
  [4845719676,4845899787,'Cancer'],
  [4845899787,4846090289,'Leo'],
  [4846090289,4846294628,'Virgo'],
  [4846294628,4846510475,'Libra'],
  [4846510475,4846729757,'Scorpio'],
  [4846729757,4846943931,'Sagittarius'],
  [4846943931,4847149042,'Capricorn'],
  [4847149042,4847345713,'Aquarius'],
  [4847345713,4847536148,'Pisces'],
  [4847536148,4847721986,'Aries'],
  [4847721986,4847904247,'Taurus'],
  [4847904247,4848084708,'Gemini'],
  [4848084708,4848267093,'Cancer'],
  [4848267093,4848456667,'Leo'],
  [4848456667,4848658031,'Virgo'],
  [4848658031,4848871503,'Libra'],
  [4848871503,4849090673,'Scorpio'],
  [4849090673,4849305600,'Sagittarius'],
  [4849305600,4849509859,'Capricorn'],
  [4849509859,4849703441,'Aquarius'],
  [4849703441,4849890155,'Pisces'],
  [4849890155,4850074073,'Aries'],
  [4850074073,4850257664,'Taurus'],
  [4850257664,4850442059,'Gemini'],
  [4850442059,4850628740,'Cancer'],
  [4850628740,4850820704,'Leo'],
  [4850820704,4851021730,'Virgo'],
  [4851021730,4851233573,'Libra'],
  [4851233573,4851452492,'Scorpio'],
  [4851452492,4851669338,'Sagittarius'],
  [4851669338,4851875452,'Capricorn'],
  [4851875452,4852068375,'Aquarius'],
  [4852068375,4852251509,'Pisces'],
  [4852251509,4852430523,'Aries'],
  [4852430523,4852610456,'Taurus'],
  [4852610456,4852794369,'Gemini'],
  [4852794369,4852983615,'Cancer'],
  [4852983615,4853179155,'Leo'],
  [4853179155,4853382358,'Virgo'],
  [4853382358,4853594227,'Libra'],
  [4853594227,4853812860,'Scorpio'],
  [4853812860,4854031628,'Sagittarius'],
  [4854031628,4854241706,'Capricorn'],
  [4854241706,4854437796,'Aquarius'],
  [4854437796,4854620890,'Pisces'],
  [4854620890,4854796247,'Aries'],
  [4854796247,4854970372,'Taurus'],
  [4854970372,4855149013,'Gemini'],
  [4855149013,4855335946,'Cancer'],
  [4855335946,4855532567,'Leo'],
  [4855532567,4855738358,'Virgo'],
  [4855738358,4855951780,'Libra'],
  [4855951780,4856170438,'Scorpio'],
  [4856170438,4856389932,'Sagittarius'],
  [4856389932,4856603668,'Capricorn'],
  [4856603668,4856805413,'Aquarius'],
  [4856805413,4856993021,'Pisces'],
  [4856993021,4857169296,'Aries'],
  [4857169296,4857340177,'Taurus'],
  [4857340177,4857512670,'Gemini'],
  [4857512670,4857693233,'Cancer'],
  [4857693233,4857886099,'Leo'],
  [4857886099,4858091682,'Virgo'],
  [4858091682,4858306576,'Libra'],
  [4858306576,4858525808,'Scorpio'],
  [4858525808,4858744850,'Sagittarius'],
  [4858744850,4858959617,'Capricorn'],
  [4858959617,4859165815,'Aquarius'],
  [4859165815,4859360050,'Pisces'],
  [4859360050,4859541938,'Aries'],
  [4859541938,4859714850,'Taurus'],
  [4859714850,4859884998,'Gemini'],
  [4859884998,4860059804,'Cancer'],
  [4860059804,4860246059,'Leo'],
  [4860246059,4860447293,'Virgo'],
  [4860447293,4860661270,'Libra'],
  [4860661270,4860881012,'Scorpio'],
  [4860881012,4861099510,'Sagittarius'],
  [4861099510,4861312904,'Capricorn'],
  [4861312904,4861519525,'Aquarius'],
  [4861519525,4861717805,'Pisces'],
  [4861717805,4861906310,'Aries'],
  [4861906310,4862085400,'Taurus'],
  [4862085400,4862258614,'Gemini'],
  [4862258614,4862432278,'Cancer'],
  [4862432278,4862613798,'Leo'],
  [4862613798,4862809149,'Virgo'],
  [4862809149,4863019312,'Libra'],
  [4863019312,4863238287,'Scorpio'],
  [4863238287,4863456792,'Sagittarius'],
  [4863456792,4863668674,'Capricorn'],
  [4863668674,4863872769,'Aquarius'],
  [4863872769,4864070099,'Pisces'],
  [4864070099,4864261191,'Aries'],
  [4864261191,4864445893,'Taurus'],
  [4864445893,4864625147,'Gemini'],
  [4864625147,4864802569,'Cancer'],
  [4864802569,4864984105,'Leo'],
  [4864984105,4865176068,'Virgo'],
  [4865176068,4865381894,'Libra'],
  [4865381894,4865598639,'Scorpio'],
  [4865598639,4865817353,'Sagittarius'],
  [4865817353,4866029293,'Capricorn'],
  [4866029293,4866231280,'Aquarius'],
  [4866231280,4866424990,'Pisces'],
  [4866424990,4866613447,'Aries'],
  [4866613447,4866798716,'Taurus'],
  [4866798716,4866981878,'Gemini'],
  [4866981878,4867164529,'Cancer'],
  [4867164529,4867349951,'Leo'],
  [4867349951,4867542700,'Virgo'],
  [4867542700,4867746490,'Libra'],
  [4867746490,4867960925,'Scorpio'],
  [4867960925,4868179600,'Sagittarius'],
  [4868179600,4868393187,'Capricorn'],
  [4868393187,4868595705,'Aquarius'],
  [4868595705,4868787125,'Pisces'],
  [4868787125,4868971165,'Aries'],
  [4868971165,4869152280,'Taurus'],
  [4869152280,4869333980,'Gemini'],
  [4869333980,4869518606,'Cancer'],
  [4869518606,4869708007,'Leo'],
  [4869708007,4869904174,'Virgo'],
  [4869904174,4870108978,'Libra'],
  [4870108978,4870322512,'Scorpio'],
  [4870322512,4870540959,'Sagittarius'],
  [4870540959,4870756727,'Capricorn'],
  [4870756727,4870962346,'Aquarius'],
  [4870962346,4871154967,'Pisces'],
  [4871154967,4871336863,'Aries'],
  [4871336863,4871513172,'Taurus'],
  [4871513172,4871689648,'Gemini'],
  [4871689648,4871871164,'Cancer'],
  [4871871164,4872060808,'Leo'],
  [4872060808,4872259584,'Virgo'],
  [4872259584,4872466896,'Libra'],
  [4872466896,4872681192,'Scorpio'],
  [4872681192,4872899541,'Sagittarius'],
  [4872899541,4873116832,'Capricorn'],
  [4873116832,4873326412,'Aquarius'],
  [4873326412,4873523315,'Pisces'],
  [4873523315,4873707095,'Aries'],
  [4873707095,4873881644,'Taurus'],
  [4873881644,4874053340,'Gemini'],
  [4874053340,4874229087,'Cancer'],
  [4874229087,4874414546,'Leo'],
  [4874414546,4874612310,'Virgo'],
  [4874612310,4874820997,'Libra'],
  [4874820997,4875036688,'Scorpio'],
  [4875036688,4875255228,'Sagittarius'],
  [4875255228,4875472813,'Capricorn'],
  [4875472813,4875685033,'Aquarius'],
  [4875685033,4875886999,'Pisces'],
  [4875886999,4876075869,'Aries'],
  [4876075869,4876252940,'Taurus'],
  [4876252940,4876423456,'Gemini'],
  [4876423456,4876594794,'Cancer'],
  [4876594794,4876774432,'Leo'],
  [4876774432,4876967596,'Virgo'],
  [4876967596,4877174642,'Libra'],
  [4877174642,4877390793,'Scorpio'],
  [4877390793,4877609637,'Sagittarius'],
  [4877609637,4877826619,'Capricorn'],
  [4877826619,4878039000,'Aquarius'],
  [4878039000,4878243904,'Pisces'],
  [4878243904,4878438223,'Aries'],
  [4878438223,4878620836,'Taurus'],
  [4878620836,4878794487,'Gemini'],
  [4878794487,4878965367,'Cancer'],
  [4878965367,4879141200,'Leo'],
  [4879141200,4879328941,'Virgo'],
  [4879328941,4879531693,'Libra'],
  [4879531693,4879746293,'Scorpio'],
  [4879746293,4879965132,'Sagittarius'],
  [4879965132,4880181456,'Capricorn'],
  [4880181456,4880392237,'Aquarius'],
  [4880392237,4880596557,'Pisces'],
  [4880596557,4880793275,'Aries'],
  [4880793275,4880981050,'Taurus'],
  [4880981050,4881160365,'Gemini'],
  [4881160365,4881334934,'Cancer'],
  [4881334934,4881511059,'Leo'],
  [4881511059,4881695739,'Virgo'],
  [4881695739,4881893930,'Libra'],
  [4881893930,4882105319,'Scorpio'],
  [4882105319,4882323450,'Sagittarius'],
  [4882323450,4882539775,'Capricorn'],
  [4882539775,4882749116,'Aquarius'],
  [4882749116,4882950672,'Pisces'],
  [4882950672,4883145503,'Aries'],
  [4883145503,4883334407,'Taurus'],
  [4883334407,4883517969,'Gemini'],
  [4883517969,4883697947,'Cancer'],
  [4883697947,4883878112,'Leo'],
  [4883878112,4884063707,'Virgo'],
  [4884063707,4884259673,'Libra'],
  [4884259673,4884467863,'Scorpio'],
  [4884467863,4884684613,'Sagittarius'],
  [4884684613,4884901705,'Capricorn'],
  [4884901705,4885111487,'Aquarius'],
  [4885111487,4885311098,'Pisces'],
  [4885311098,4885502006,'Aries'],
  [4885502006,4885687384,'Taurus'],
  [4885687384,4885870243,'Gemini'],
  [4885870243,4886052975,'Cancer'],
  [4886052975,4886237823,'Leo'],
  [4886237823,4886427410,'Virgo'],
  [4886427410,4886624637,'Libra'],
  [4886624637,4886831486,'Scorpio'],
  [4886831486,4887046807,'Sagittarius'],
  [4887046807,4887264844,'Capricorn'],
  [4887264844,4887477235,'Aquarius'],
  [4887477235,4887678108,'Pisces'],
  [4887678108,4887866987,'Aries'],
  [4887866987,4888047586,'Taurus'],
  [4888047586,4888225304,'Gemini'],
  [4888225304,4888405230,'Cancer'],
  [4888405230,4888590915,'Leo'],
  [4888590915,4888783964,'Virgo'],
  [4888783964,4888984616,'Libra'],
  [4888984616,4889192697,'Scorpio'],
  [4889192697,4889407467,'Sagittarius'],
  [4889407467,4889625912,'Capricorn'],
  [4889625912,4889841552,'Aquarius'],
  [4889841552,4890046870,'Pisces'],
  [4890046870,4890238095,'Aries'],
  [4890238095,4890417115,'Taurus'],
  [4890417115,4890589820,'Gemini'],
  [4890589820,4890763456,'Cancer'],
  [4890763456,4890944424,'Leo'],
  [4890944424,4891136325,'Virgo'],
  [4891136325,4891338916,'Libra'],
  [4891338916,4891549414,'Scorpio'],
  [4891549414,4891764980,'Sagittarius'],
  [4891764980,4891983305,'Capricorn'],
  [4891983305,4892200705,'Aquarius'],
  [4892200705,4892410928,'Pisces'],
  [4892410928,4892608027,'Aries'],
  [4892608027,4892790562,'Taurus'],
  [4892790562,4892962662,'Gemini'],
  [4892962662,4893131794,'Cancer'],
  [4893131794,4893306094,'Leo'],
  [4893306094,4893492060,'Virgo'],
  [4893492060,4893691989,'Libra'],
  [4893691989,4893903038,'Scorpio'],
  [4893903038,4894119856,'Sagittarius'],
  [4894119856,4894338182,'Capricorn'],
  [4894338182,4894555298,'Aquarius'],
  [4894555298,4894767664,'Pisces'],
  [4894767664,4894970243,'Aries'],
  [4894970243,4895159382,'Taurus'],
  [4895159382,4895336034,'Gemini'],
  [4895336034,4895505823,'Cancer'],
  [4895505823,4895676658,'Leo'],
  [4895676658,4895856368,'Virgo'],
  [4895856368,4896050166,'Libra'],
  [4896050166,4896258020,'Scorpio'],
  [4896258020,4896474626,'Sagittarius'],
  [4896474626,4896693202,'Capricorn'],
  [4896693202,4896909308,'Aquarius'],
  [4896909308,4897120596,'Pisces'],
  [4897120596,4897324649,'Aries'],
  [4897324649,4897518732,'Taurus'],
  [4897518732,4897701918,'Gemini'],
  [4897701918,4897876906,'Cancer'],
  [4897876906,4898049536,'Leo'],
  [4898049536,4898226960,'Virgo'],
  [4898226960,4898415512,'Libra'],
  [4898415512,4898618115,'Scorpio'],
  [4898618115,4898832175,'Sagittarius'],
  [4898832175,4899050584,'Capricorn'],
  [4899050584,4899266282,'Aquarius'],
  [4899266282,4899475536,'Pisces'],
  [4899475536,4899677325,'Aries'],
  [4899677325,4899871512,'Taurus'],
  [4899871512,4900058296,'Gemini'],
  [4900058296,4900239026,'Cancer'],
  [4900239026,4900416913,'Leo'],
  [4900416913,4900596804,'Virgo'],
  [4900596804,4900784085,'Libra'],
  [4900784085,4900982830,'Scorpio'],
  [4900982830,4901193393,'Sagittarius'],
  [4901193393,4901410838,'Capricorn'],
  [4901410838,4901627026,'Aquarius'],
  [4901627026,4901835571,'Pisces'],
  [4901835571,4902034477,'Aries'],
  [4902034477,4902225186,'Taurus'],
  [4902225186,4902410464,'Gemini'],
  [4902410464,4902593050,'Cancer'],
  [4902593050,4902775395,'Leo'],
  [4902775395,4902960015,'Virgo'],
  [4902960015,4903149879,'Libra'],
  [4903149879,4903348096,'Scorpio'],
  [4903348096,4903556361,'Sagittarius'],
  [4903556361,4903772543,'Capricorn'],
  [4903772543,4903989752,'Aquarius'],
  [4903989752,4904199716,'Pisces'],
  [4904199716,4904397911,'Aries'],
  [4904397911,4904585221,'Taurus'],
  [4904585221,4904766042,'Gemini'],
  [4904766042,4904945590,'Cancer'],
  [4904945590,4905128009,'Leo'],
  [4905128009,4905315595,'Virgo'],
  [4905315595,4905509256,'Libra'],
  [4905509256,4905709725,'Scorpio'],
  [4905709725,4905917929,'Sagittarius'],
  [4905917929,4906133343,'Capricorn'],
  [4906133343,4906351544,'Aquarius'],
  [4906351544,4906564427,'Pisces'],
  [4906564427,4906764997,'Aries'],
  [4906764997,4906951868,'Taurus'],
  [4906951868,4907129168,'Gemini'],
  [4907129168,4907303613,'Cancer'],
  [4907303613,4907481721,'Leo'],
  [4907481721,4907667804,'Virgo'],
  [4907667804,4907862982,'Libra'],
  [4907862982,4908066136,'Scorpio'],
  [4908066136,4908275961,'Sagittarius'],
  [4908275961,4908491506,'Capricorn'],
  [4908491506,4908710222,'Aquarius'],
  [4908710222,4908925969,'Pisces'],
  [4908925969,4909130986,'Aries'],
  [4909130986,4909321137,'Taurus'],
  [4909321137,4909498537,'Gemini'],
  [4909498537,4909669691,'Cancer'],
  [4909669691,4909842380,'Leo'],
  [4909842380,4910023252,'Virgo'],
  [4910023252,4910215740,'Libra'],
  [4910215740,4910419221,'Scorpio'],
  [4910419221,4910630641,'Sagittarius'],
  [4910630641,4910846978,'Capricorn'],
  [4910846978,4911065685,'Aquarius'],
  [4911065685,4911282717,'Pisces'],
  [4911282717,4911491802,'Aries'],
  [4911491802,4911687462,'Taurus'],
  [4911687462,4911869003,'Gemini'],
  [4911869003,4912041015,'Cancer'],
  [4912041015,4912210900,'Leo'],
  [4912210900,4912386347,'Virgo'],
  [4912386347,4912573200,'Libra'],
  [4912573200,4912773386,'Scorpio'],
  [4912773386,4912984422,'Sagittarius'],
  [4912984422,4913201426,'Capricorn'],
  [4913201426,4913419934,'Aquarius'],
  [4913419934,4913636374,'Pisces'],
  [4913636374,4913846771,'Aries'],
  [4913846771,4914046884,'Taurus'],
  [4914046884,4914234495,'Gemini'],
  [4914234495,4914411424,'Cancer'],
  [4914411424,4914583027,'Leo'],
  [4914583027,4914756316,'Virgo'],
  [4914756316,4914938077,'Libra'],
  [4914938077,4915132821,'Scorpio'],
  [4915132821,4915340742,'Sagittarius'],
  [4915340742,4915557290,'Capricorn'],
  [4915557290,4915775771,'Aquarius'],
  [4915775771,4915990894,'Pisces'],
  [4915990894,4916199627,'Aries'],
  [4916199627,4916400256,'Taurus'],
  [4916400256,4916591821,'Gemini'],
  [4916591821,4916774798,'Cancer'],
  [4916774798,4916951841,'Leo'],
  [4916951841,4917127630,'Virgo'],
  [4917127630,4917307978,'Libra'],
  [4917307978,4917498381,'Scorpio'],
  [4917498381,4917701818,'Sagittarius'],
  [4917701818,4917916341,'Capricorn'],
  [4917916341,4918134942,'Aquarius'],
  [4918134942,4918349657,'Pisces'],
  [4918349657,4918555986,'Aries'],
  [4918555986,4918753554,'Taurus'],
  [4918753554,4918944111,'Gemini'],
  [4918944111,4919129668,'Cancer'],
  [4919129668,4919312019,'Leo'],
  [4919312019,4919493279,'Virgo'],
  [4919493279,4919676645,'Libra'],
  [4919676645,4919866431,'Scorpio'],
  [4919866431,4920066704,'Sagittarius'],
  [4920066704,4920278467,'Capricorn'],
  [4920278467,4920496921,'Aquarius'],
  [4920496921,4920712873,'Pisces'],
  [4920712873,4920918841,'Aries'],
  [4920918841,4921113262,'Taurus'],
  [4921113262,4921299385,'Gemini'],
  [4921299385,4921481973,'Cancer'],
  [4921481973,4921664828,'Leo'],
  [4921664828,4921849905,'Virgo'],
  [4921849905,4922038129,'Libra'],
  [4922038129,4922231048,'Scorpio'],
  [4922231048,4922431405,'Sagittarius'],
  [4922431405,4922641417,'Capricorn'],
  [4922641417,4922859296,'Aquarius'],
  [4922859296,4923077353,'Pisces'],
  [4923077353,4923286006,'Aries'],
  [4923286006,4923480626,'Taurus'],
  [4923480626,4923663476,'Gemini'],
  [4923663476,4923840671,'Cancer'],
  [4923840671,4924018654,'Leo'],
  [4924018654,4924201891,'Virgo'],
  [4924201891,4924391941,'Libra'],
  [4924391941,4924588536,'Scorpio'],
  [4924588536,4924791655,'Sagittarius'],
  [4924791655,4925002112,'Capricorn'],
  [4925002112,4925219513,'Aquarius'],
  [4925219513,4925439069,'Pisces'],
  [4925439069,4925651882,'Aries'],
  [4925651882,4925850654,'Taurus'],
  [4925850654,4926034689,'Gemini'],
  [4926034689,4926209140,'Cancer'],
  [4926209140,4926381436,'Leo'],
  [4926381436,4926558467,'Virgo'],
  [4926558467,4926744673,'Libra'],
  [4926744673,4926941134,'Scorpio'],
  [4926941134,4927146505,'Sagittarius'],
  [4927146505,4927358896,'Capricorn'],
  [4927358896,4927576589,'Aquarius'],
  [4927576589,4927796404,'Pisces'],
  [4927796404,4928012089,'Aries'],
  [4928012089,4928216381,'Taurus'],
  [4928216381,4928405744,'Gemini'],
  [4928405744,4928582524,'Cancer'],
  [4928582524,4928753025,'Leo'],
  [4928753025,4928924714,'Virgo'],
  [4928924714,4929104229,'Libra'],
  [4929104229,4929295713,'Scorpio'],
  [4929295713,4929499619,'Sagittarius'],
  [4929499619,4929713017,'Capricorn'],
  [4929713017,4929931548,'Aquarius'],
  [4929931548,4930150998,'Pisces'],
  [4930150998,4930366945,'Aries'],
  [4930366945,4930574492,'Taurus'],
  [4930574492,4930769822,'Gemini'],
  [4930769822,4930952587,'Cancer'],
  [4930952587,4931126376,'Leo'],
  [4931126376,4931297292,'Virgo'],
  [4931297292,4931472249,'Libra'],
  [4931472249,4931657414,'Scorpio'],
  [4931657414,4931856317,'Sagittarius'],
  [4931856317,4932067905,'Capricorn'],
  [4932067905,4932286660,'Aquarius'],
  [4932286660,4932505846,'Pisces'],
  [4932505846,4932720450,'Aries'],
  [4932720450,4932927616,'Taurus'],
  [4932927616,4933125669,'Gemini'],
  [4933125669,4933313999,'Cancer'],
  [4933313999,4933493821,'Leo'],
  [4933493821,4933668573,'Virgo'],
  [4933668573,4933843619,'Libra'],
  [4933843619,4934025233,'Scorpio'],
  [4934025233,4934218875,'Sagittarius'],
  [4934218875,4934426475,'Capricorn'],
  [4934426475,4934644016,'Aquarius'],
  [4934644016,4934863159,'Pisces'],
  [4934863159,4935076587,'Aries'],
  [4935076587,4935281363,'Taurus'],
  [4935281363,4935477980,'Gemini'],
  [4935477980,4935667860,'Cancer'],
  [4935667860,4935852222,'Leo'],
  [4935852222,4936032508,'Virgo'],
  [4936032508,4936211505,'Libra'],
  [4936211505,4936393833,'Scorpio'],
  [4936393833,4936584987,'Sagittarius'],
  [4936584987,4936788850,'Capricorn'],
  [4936788850,4937004180,'Aquarius'],
  [4937004180,4937223333,'Pisces'],
  [4937223333,4937436869,'Aries'],
  [4937436869,4937639864,'Taurus'],
  [4937639864,4937833162,'Gemini'],
  [4937833162,4938020357,'Cancer'],
  [4938020357,4938204744,'Leo'],
  [4938204744,4938388171,'Virgo'],
  [4938388171,4938571823,'Libra'],
  [4938571823,4938757872,'Scorpio'],
  [4938757872,4938950098,'Sagittarius'],
  [4938950098,4939152469,'Capricorn'],
  [4939152469,4939365858,'Aquarius'],
  [4939365858,4939584964,'Pisces'],
  [4939584964,4939800013,'Aries'],
  [4939800013,4940003563,'Taurus'],
  [4940003563,4940194834,'Gemini'],
  [4940194834,4940377988,'Cancer'],
  [4940377988,4940558427,'Leo'],
  [4940558427,4940740249,'Virgo'],
  [4940740249,4940925485,'Libra'],
  [4940925485,4941115100,'Scorpio'],
  [4941115100,4941310537,'Sagittarius'],
  [4941310537,4941514029,'Capricorn'],
  [4941514029,4941726779,'Aquarius'],
  [4941726779,4941945796,'Pisces'],
  [4941945796,4942162987,'Aries'],
  [4942162987,4942369578,'Taurus'],
  [4942369578,4942562084,'Gemini'],
  [4942562084,4942743305,'Cancer'],
  [4942743305,4942919222,'Leo'],
  [4942919222,4943095978,'Virgo'],
  [4943095978,4943278078,'Libra'],
  [4943278078,4943467765,'Scorpio'],
  [4943467765,4943665617,'Sagittarius'],
  [4943665617,4943871558,'Capricorn'],
  [4943871558,4944085135,'Aquarius'],
  [4944085135,4944304128,'Pisces'],
  [4944304128,4944522859,'Aries'],
  [4944522859,4944733482,'Taurus'],
  [4944733482,4944930433,'Gemini'],
  [4944930433,4945113755,'Cancer'],
  [4945113755,4945288128,'Leo'],
  [4945288128,4945460171,'Virgo'],
  [4945460171,4945636390,'Libra'],
  [4945636390,4945821714,'Scorpio'],
  [4945821714,4946018394,'Sagittarius'],
  [4946018394,4946225683,'Capricorn'],
  [4946225683,4946440733,'Aquarius'],
  [4946440733,4946659911,'Pisces'],
  [4946659911,4946878821,'Aries'],
  [4946878821,4947092046,'Taurus'],
  [4947092046,4947294329,'Gemini'],
  [4947294329,4947483254,'Cancer'],
  [4947483254,4947660689,'Leo'],
  [4947660689,4947831842,'Virgo'],
  [4947831842,4948003541,'Libra'],
  [4948003541,4948182649,'Scorpio'],
  [4948182649,4948374287,'Sagittarius'],
  [4948374287,4948579681,'Capricorn'],
  [4948579681,4948795251,'Aquarius'],
  [4948795251,4949014827,'Pisces'],
  [4949014827,4949232957,'Aries'],
  [4949232957,4949445963,'Taurus'],
  [4949445963,4949651006,'Gemini'],
  [4949651006,4949845724,'Cancer'],
  [4949845724,4950029498,'Leo'],
  [4950029498,4950204630,'Virgo'],
  [4950204630,4950376333,'Libra'],
  [4950376333,4950551573,'Scorpio'],
  [4950551573,4950737300,'Sagittarius'],
  [4950737300,4950937780,'Capricorn'],
  [4950937780,4951151501,'Aquarius'],
  [4951151501,4951371197,'Pisces'],
  [4951371197,4951588757,'Aries'],
  [4951588757,4951799811,'Taurus'],
  [4951799811,4952003573,'Gemini'],
  [4952003573,4952200140,'Cancer'],
  [4952200140,4952389162,'Leo'],
  [4952389162,4952570724,'Virgo'],
  [4952570724,4952747097,'Libra'],
  [4952747097,4952923355,'Scorpio'],
  [4952923355,4953106250,'Sagittarius'],
  [4953106250,4953301814,'Capricorn'],
  [4953301814,4953511717,'Aquarius'],
  [4953511717,4953730501,'Pisces'],
  [4953730501,4953948374,'Aries'],
  [4953948374,4954158248,'Taurus'],
  [4954158248,4954358930,'Gemini'],
  [4954358930,4954552668,'Cancer'],
  [4954552668,4954741721,'Leo'],
  [4954741721,4954927003,'Virgo'],
  [4954927003,4955109109,'Libra'],
  [4955109109,4955290274,'Scorpio'],
  [4955290274,4955475042,'Sagittarius'],
  [4955475042,4955668941,'Capricorn'],
  [4955668941,4955875478,'Aquarius'],
  [4955875478,4956092392,'Pisces'],
  [4956092392,4956311038,'Aries'],
  [4956311038,4956522000,'Taurus'],
  [4956522000,4956721420,'Gemini'],
  [4956721420,4956911285,'Cancer'],
  [4956911285,4957095911,'Leo'],
  [4957095911,4957278999,'Virgo'],
  [4957278999,4957462635,'Libra'],
  [4957462635,4957648117,'Scorpio'],
  [4957648117,4957837402,'Sagittarius'],
  [4957837402,4958033546,'Capricorn'],
  [4958033546,4958239404,'Aquarius'],
  [4958239404,4958454737,'Pisces'],
  [4958454737,4958673857,'Aries'],
  [4958673857,4958887576,'Taurus'],
  [4958887576,4959089212,'Gemini'],
  [4959089212,4959278234,'Cancer'],
  [4959278234,4959458708,'Leo'],
  [4959458708,4959636195,'Virgo'],
  [4959636195,4959815627,'Libra'],
  [4959815627,4960000360,'Scorpio'],
  [4960000360,4960192173,'Sagittarius'],
  [4960192173,4960391858,'Capricorn'],
  [4960391858,4960599698,'Aquarius'],
  [4960599698,4960814923,'Pisces'],
  [4960814923,4961034058,'Aries'],
  [4961034058,4961250371,'Taurus'],
  [4961250371,4961456504,'Gemini'],
  [4961456504,4961648885,'Cancer'],
  [4961648885,4961829230,'Leo'],
  [4961829230,4962002806,'Virgo'],
  [4962002806,4962176151,'Libra'],
  [4962176151,4962355354,'Scorpio'],
  [4962355354,4962544625,'Sagittarius'],
  [4962544625,4962745176,'Capricorn'],
  [4962745176,4962955271,'Aquarius'],
  [4962955271,4963171697,'Pisces'],
  [4963171697,4963390806,'Aries'],
  [4963390806,4963608186,'Taurus'],
  [4963608186,4963818301,'Gemini'],
  [4963818301,4964016302,'Cancer'],
  [4964016302,4964200891,'Leo'],
  [4964200891,4964375133,'Virgo'],
  [4964375133,4964545212,'Libra'],
  [4964545212,4964718510,'Scorpio'],
  [4964718510,4964901764,'Sagittarius'],
  [4964901764,4965098826,'Capricorn'],
  [4965098826,4965308654,'Aquarius'],
  [4965308654,4965526098,'Pisces'],
  [4965526098,4965745383,'Aries'],
  [4965745383,4965962376,'Taurus'],
  [4965962376,4966173872,'Gemini'],
  [4966173872,4966376315,'Cancer'],
  [4966376315,4966566937,'Leo'],
  [4966566937,4966745949,'Virgo'],
  [4966745949,4966917458,'Libra'],
  [4966917458,4967088350,'Scorpio'],
  [4967088350,4967266346,'Sagittarius'],
  [4967266346,4967457683,'Capricorn'],
  [4967457683,4967664022,'Aquarius'],
  [4967664022,4967880781,'Pisces'],
  [4967880781,4968100166,'Aries'],
  [4968100166,4968316290,'Taurus'],
  [4968316290,4968526669,'Gemini'],
  [4968526669,4968730043,'Cancer'],
  [4968730043,4968924731,'Leo'],
  [4968924731,4969109582,'Virgo'],
  [4969109582,4969286072,'Libra'],
  [4969286072,4969459047,'Scorpio'],
  [4969459047,4969635507,'Sagittarius'],
  [4969635507,4969822489,'Capricorn'],
  [4969822489,4970024069,'Aquarius'],
  [4970024069,4970238227,'Pisces'],
  [4970238227,4970457210,'Aries'],
  [4970457210,4970672899,'Taurus'],
  [4970672899,4970881442,'Gemini'],
  [4970881442,4971082676,'Cancer'],
  [4971082676,4971277235,'Leo'],
  [4971277235,4971465149,'Virgo'],
  [4971465149,4971646823,'Libra'],
  [4971646823,4971824714,'Scorpio'],
  [4971824714,4972003702,'Sagittarius'],
  [4972003702,4972189878,'Capricorn'],
  [4972189878,4972388168,'Aquarius'],
  [4972388168,4972599122,'Pisces'],
  [4972599122,4972817108,'Aries'],
  [4972817108,4973033196,'Taurus'],
  [4973033196,4973241096,'Gemini'],
  [4973241096,4973439663,'Cancer'],
  [4973439663,4973630895,'Leo'],
  [4973630895,4973817242,'Virgo'],
  [4973817242,4974000547,'Libra'],
  [4974000547,4974182614,'Scorpio'],
  [4974182614,4974366160,'Sagittarius'],
  [4974366160,4974554997,'Capricorn'],
  [4974554997,4974753005,'Aquarius'],
  [4974753005,4974961884,'Pisces'],
  [4974961884,4975178678,'Aries'],
  [4975178678,4975395802,'Taurus'],
  [4975395802,4975605204,'Gemini'],
  [4975605204,4975803214,'Cancer'],
  [4975803214,4975991164,'Leo'],
  [4975991164,4976173023,'Virgo'],
  [4976173023,4976353164,'Libra'],
  [4976353164,4976535180,'Scorpio'],
  [4976535180,4976721628,'Sagittarius'],
  [4976721628,4976914338,'Capricorn'],
  [4976914338,4977114757,'Aquarius'],
  [4977114757,4977323658,'Pisces'],
  [4977323658,4977539674,'Aries'],
  [4977539674,4977757811,'Taurus'],
  [4977757811,4977970365,'Gemini'],
  [4977970365,4978171123,'Cancer'],
  [4978171123,4978358906,'Leo'],
  [4978358906,4978537213,'Virgo'],
  [4978537213,4978711946,'Libra'],
  [4978711946,4978889267,'Scorpio'],
  [4978889267,4979073931,'Sagittarius'],
  [4979073931,4979268125,'Capricorn'],
  [4979268125,4979471427,'Aquarius'],
  [4979471427,4979682114,'Pisces'],
  [4979682114,4979898205,'Aries'],
  [4979898205,4980116706,'Taurus'],
  [4980116706,4980332222,'Gemini'],
  [4980332222,4980537969,'Cancer'],
  [4980537969,4980729761,'Leo'],
  [4980729761,4980908631,'Virgo'],
  [4980908631,4981080049,'Libra'],
  [4981080049,4981251511,'Scorpio'],
  [4981251511,4981430288,'Sagittarius'],
  [4981430288,4981621198,'Capricorn'],
  [4981621198,4981824634,'Aquarius'],
  [4981824634,4982037061,'Pisces'],
  [4982037061,4982254035,'Aries'],
  [4982254035,4982472304,'Taurus'],
  [4982472304,4982688774,'Gemini'],
  [4982688774,4982898649,'Cancer'],
  [4982898649,4983096654,'Leo'],
  [4983096654,4983280664,'Virgo'],
  [4983280664,4983453704,'Libra'],
  [4983453704,4983622652,'Scorpio'],
  [4983622652,4983795738,'Sagittarius'],
  [4983795738,4983980209,'Capricorn'],
  [4983980209,4984179474,'Aquarius'],
  [4984179474,4984391114,'Pisces'],
  [4984391114,4984608828,'Aries'],
  [4984608828,4984826937,'Taurus'],
  [4984826937,4985042406,'Gemini'],
  [4985042406,4985252918,'Cancer'],
  [4985252918,4985455062,'Leo'],
  [4985455062,4985645638,'Virgo'],
  [4985645638,4985824631,'Libra'],
  [4985824631,4985996400,'Scorpio'],
  [4985996400,4986168151,'Sagittarius'],
  [4986168151,4986347682,'Capricorn'],
  [4986347682,4986540823,'Aquarius'],
  [4986540823,4986748404,'Pisces'],
  [4986748404,4986965229,'Aries'],
  [4986965229,4987183501,'Taurus'],
  [4987183501,4987397805,'Gemini'],
  [4987397805,4987606147,'Cancer'],
  [4987606147,4987807697,'Leo'],
  [4987807697,4988001270,'Virgo'],
  [4988001270,4988186201,'Libra'],
  [4988186201,4988364164,'Scorpio'],
  [4988364164,4988539688,'Sagittarius'],
  [4988539688,4988719063,'Capricorn'],
  [4988719063,4988908415,'Aquarius'],
  [4988908415,4989111093,'Pisces'],
  [4989111093,4989325121,'Aries'],
  [4989325121,4989543318,'Taurus'],
  [4989543318,4989757738,'Gemini'],
  [4989757738,4989964154,'Cancer'],
  [4989964154,4990162267,'Leo'],
  [4990162267,4990353523,'Virgo'],
  [4990353523,4990539522,'Libra'],
  [4990539522,4990721929,'Scorpio'],
  [4990721929,4990903124,'Sagittarius'],
  [4990903124,4991086613,'Capricorn'],
  [4991086613,4991276656,'Aquarius'],
  [4991276656,4991476868,'Pisces'],
  [4991476868,4991687903,'Aries'],
  [4991687903,4991905411,'Taurus'],
  [4991905411,4992121180,'Gemini'],
  [4992121180,4992328107,'Cancer'],
  [4992328107,4992523923,'Leo'],
  [4992523923,4992710768,'Virgo'],
  [4992710768,4992892793,'Libra'],
  [4992892793,4993074108,'Scorpio'],
  [4993074108,4993257767,'Sagittarius'],
  [4993257767,4993445728,'Capricorn'],
  [4993445728,4993639518,'Aquarius'],
  [4993639518,4993840791,'Pisces'],
  [4993840791,4994050613,'Aries'],
  [4994050613,4994267287,'Taurus'],
  [4994267287,4994484697,'Gemini'],
  [4994484697,4994694516,'Cancer'],
  [4994694516,4994891479,'Leo'],
  [4994891479,4995076101,'Virgo'],
  [4995076101,4995253275,'Libra'],
  [4995253275,4995429407,'Scorpio'],
  [4995429407,4995610087,'Sagittarius'],
  [4995610087,4995798544,'Capricorn'],
  [4995798544,4995995292,'Aquarius'],
  [4995995292,4996199431,'Pisces'],
  [4996199431,4996410219,'Aries'],
  [4996410219,4996626639,'Taurus'],
  [4996626639,4996845122,'Gemini'],
  [4996845122,4997058536,'Cancer'],
  [4997058536,4997259674,'Leo'],
  [4997259674,4997446166,'Virgo'],
  [4997446166,4997621585,'Libra'],
  [4997621585,4997792946,'Scorpio'],
  [4997792946,4997967795,'Sagittarius'],
  [4997967795,4998151955,'Capricorn'],
  [4998151955,4998347651,'Aquarius'],
  [4998347651,4998553328,'Pisces'],
  [4998553328,4998765889,'Aries'],
  [4998765889,4998982813,'Taurus'],
  [4998982813,4999201552,'Gemini'],
  [4999201552,4999417308,'Cancer'],
  [4999417308,4999623294,'Leo'],
  [4999623294,4999814846,'Virgo'],
  [4999814846,4999992873,'Libra'],
  [4999992873,5000163196,'Scorpio'],
  [5000163196,5000333698,'Sagittarius'],
  [5000333698,5000511889,'Capricorn'],
  [5000511889,5000702660,'Aquarius'],
  [5000702660,5000906405,'Pisces'],
  [5000906405,5001119478,'Aries'],
  [5001119478,5001337098,'Taurus'],
  [5001337098,5001555599,'Gemini'],
  [5001555599,5001771564,'Cancer'],
  [5001771564,5001980340,'Leo'],
  [5001980340,5002177250,'Virgo'],
  [5002177250,5002360856,'Libra'],
  [5002360856,5002534482,'Scorpio'],
  [5002534482,5002704721,'Sagittarius'],
  [5002704721,5002879145,'Capricorn'],
  [5002879145,5003064251,'Aquarius'],
  [5003064251,5003263196,'Pisces'],
  [5003263196,5003474264,'Aries'],
  [5003474264,5003691881,'Taurus'],
  [5003691881,5003910109,'Gemini'],
  [5003910109,5004124856,'Cancer'],
  [5004124856,5004333207,'Leo'],
  [5004333207,5004532558,'Virgo'],
  [5004532558,5004721364,'Libra'],
  [5004721364,5004900749,'Scorpio'],
  [5004900749,5005074839,'Sagittarius'],
  [5005074839,5005249679,'Capricorn'],
  [5005249679,5005431673,'Aquarius'],
  [5005431673,5005625704,'Pisces'],
  [5005625704,5005832893,'Aries'],
  [5005832893,5006049241,'Taurus'],
  [5006049241,5006267412,'Gemini'],
  [5006267412,5006481046,'Cancer'],
  [5006481046,5006687031,'Leo'],
  [5006687031,5006884840,'Virgo'],
  [5006884840,5007075057,'Libra'],
  [5007075057,5007258888,'Scorpio'],
  [5007258888,5007438535,'Sagittarius'],
  [5007438535,5007617503,'Capricorn'],
  [5007617503,5007800419,'Aquarius'],
  [5007800419,5007992087,'Pisces'],
  [5007992087,5008195591,'Aries'],
  [5008195591,5008409741,'Taurus'],
  [5008409741,5008628014,'Gemini'],
  [5008628014,5008841906,'Cancer'],
  [5008841906,5009046145,'Leo'],
  [5009046145,5009240457,'Virgo'],
  [5009240457,5009427704,'Libra'],
  [5009427704,5009611366,'Scorpio'],
  [5009611366,5009794165,'Sagittarius'],
  [5009794165,5009978033,'Capricorn'],
  [5009978033,5010164990,'Aquarius'],
  [5010164990,5010357894,'Pisces'],
  [5010357894,5010559880,'Aries'],
  [5010559880,5010772000,'Taurus'],
  [5010772000,5010990292,'Gemini'],
  [5010990292,5011206032,'Cancer'],
  [5011206032,5011411182,'Leo'],
  [5011411182,5011603509,'Virgo'],
  [5011603509,5011786385,'Libra'],
  [5011786385,5011965560,'Scorpio'],
  [5011965560,5012146258,'Sagittarius'],
  [5012146258,5012331539,'Capricorn'],
  [5012331539,5012522278,'Aquarius'],
  [5012522278,5012718744,'Pisces'],
  [5012718744,5012922042,'Aries'],
  [5012922042,5013133458,'Taurus'],
  [5013133458,5013351537,'Gemini'],
  [5013351537,5013569629,'Cancer'],
  [5013569629,5013778466,'Leo'],
  [5013778466,5013972695,'Virgo'],
  [5013972695,5014153912,'Libra'],
  [5014153912,5014328331,'Scorpio'],
  [5014328331,5014503246,'Sagittarius'],
  [5014503246,5014684476,'Capricorn'],
  [5014684476,5014874690,'Aquarius'],
  [5014874690,5015073512,'Pisces'],
  [5015073512,5015279542,'Aries'],
  [5015279542,5015491995,'Taurus'],
  [5015491995,5015709896,'Gemini'],
  [5015709896,5015929272,'Cancer'],
  [5015929272,5016142368,'Leo'],
  [5016142368,5016341906,'Virgo'],
  [5016341906,5016526264,'Libra'],
  [5016526264,5016699911,'Scorpio'],
  [5016699911,5016870302,'Sagittarius'],
  [5016870302,5017045020,'Capricorn'],
  [5017045020,5017229682,'Aquarius'],
  [5017229682,5017426295,'Pisces'],
  [5017426295,5017633292,'Aries'],
  [5017633292,5017847428,'Taurus'],
  [5017847428,5018065668,'Gemini'],
  [5018065668,5018284822,'Cancer'],
  [5018284822,5018499878,'Leo'],
  [5018499878,5018704670,'Virgo'],
  [5018704670,5018895427,'Libra'],
  [5018895427,5019073453,'Scorpio'],
  [5019073453,5019244283,'Sagittarius'],
  [5019244283,5019415244,'Capricorn'],
  [5019415244,5019593436,'Aquarius'],
  [5019593436,5019783898,'Pisces'],
  [5019783898,5019987810,'Aries'],
  [5019987810,5020201992,'Taurus'],
  [5020201992,5020420863,'Gemini'],
  [5020420863,5020639322,'Cancer'],
  [5020639322,5020853450,'Leo'],
  [5020853450,5021059838,'Virgo'],
  [5021059838,5021255715,'Libra'],
  [5021255715,5021440447,'Scorpio'],
  [5021440447,5021616527,'Sagittarius'],
  [5021616527,5021789077,'Capricorn'],
  [5021789077,5021964581,'Aquarius'],
  [5021964581,5022149376,'Pisces'],
  [5022149376,5022347659,'Aries'],
  [5022347659,5022559035,'Taurus'],
  [5022559035,5022777758,'Gemini'],
  [5022777758,5022996037,'Cancer'],
  [5022996037,5023208349,'Leo'],
  [5023208349,5023412664,'Virgo'],
  [5023412664,5023608923,'Libra'],
  [5023608923,5023797632,'Scorpio'],
  [5023797632,5023979849,'Sagittarius'],
  [5023979849,5024157868,'Capricorn'],
  [5024157868,5024335753,'Aquarius'],
  [5024335753,5024518987,'Pisces'],
  [5024518987,5024712961,'Aries'],
  [5024712961,5024920230,'Taurus'],
  [5024920230,5025137476,'Gemini'],
  [5025137476,5025356091,'Cancer'],
  [5025356091,5025567803,'Leo'],
  [5025567803,5025769402,'Virgo'],
  [5025769402,5025962376,'Libra'],
  [5025962376,5026149829,'Scorpio'],
  [5026149829,5026334255,'Sagittarius'],
  [5026334255,5026517133,'Capricorn'],
  [5026517133,5026700035,'Aquarius'],
  [5026700035,5026885971,'Pisces'],
  [5026885971,5027079345,'Aries'],
  [5027079345,5027283906,'Taurus'],
  [5027283906,5027499180,'Gemini'],
  [5027499180,5027718230,'Cancer'],
  [5027718230,5027931183,'Leo'],
  [5027931183,5028132176,'Virgo'],
  [5028132176,5028321938,'Libra'],
  [5028321938,5028505092,'Scorpio'],
  [5028505092,5028686614,'Sagittarius'],
  [5028686614,5028869768,'Capricorn'],
  [5028869768,5029055912,'Aquarius'],
  [5029055912,5029245958,'Pisces'],
  [5029245958,5029441896,'Aries'],
  [5029441896,5029646484,'Taurus'],
  [5029646484,5029860607,'Gemini'],
  [5029860607,5030079947,'Cancer'],
  [5030079947,5030295311,'Leo'],
  [5030295311,5030498585,'Virgo'],
  [5030498585,5030688084,'Libra'],
  [5030688084,5030867926,'Scorpio'],
  [5030867926,5031044446,'Sagittarius'],
  [5031044446,5031223312,'Capricorn'],
  [5031223312,5031407988,'Aquarius'],
  [5031407988,5031599685,'Pisces'],
  [5031599685,5031798635,'Aries'],
  [5031798635,5032005255,'Taurus'],
  [5032005255,5032219640,'Gemini'],
  [5032219640,5032439125,'Cancer'],
  [5032439125,5032656753,'Leo'],
  [5032656753,5032864114,'Virgo'],
  [5032864114,5033056895,'Libra'],
  [5033056895,5033237042,'Scorpio'],
  [5033237042,5033410440,'Sagittarius'],
  [5033410440,5033583929,'Capricorn'],
  [5033583929,5033763342,'Aquarius'],
  [5033763342,5033952250,'Pisces'],
  [5033952250,5034151555,'Aries'],
  [5034151555,5034360083,'Taurus'],
  [5034360083,5034575671,'Gemini'],
  [5034575671,5034795279,'Cancer'],
  [5034795279,5035013904,'Leo'],
  [5035013904,5035224923,'Virgo'],
  [5035224923,5035422995,'Libra'],
  [5035422995,5035607311,'Scorpio'],
  [5035607311,5035781682,'Sagittarius'],
  [5035781682,5035952428,'Capricorn'],
  [5035952428,5036126421,'Aquarius'],
  [5036126421,5036309592,'Pisces'],
  [5036309592,5036505382,'Aries'],
  [5036505382,5036713450,'Taurus'],
  [5036713450,5036929948,'Gemini'],
  [5036929948,5037149739,'Cancer'],
  [5037149739,5037367972,'Leo'],
  [5037367972,5037580238,'Virgo'],
  [5037580238,5037782602,'Libra'],
  [5037782602,5037972884,'Scorpio'],
  [5037972884,5038152132,'Sagittarius'],
  [5038152132,5038324536,'Capricorn'],
  [5038324536,5038496326,'Aquarius'],
  [5038496326,5038674386,'Pisces'],
  [5038674386,5038864544,'Aries'],
  [5038864544,5039069114,'Taurus'],
  [5039069114,5039284918,'Gemini'],
  [5039284918,5039504821,'Cancer'],
  [5039504821,5039722127,'Leo'],
  [5039722127,5039933112,'Virgo'],
  [5039933112,5040136249,'Libra'],
  [5040136249,5040330610,'Scorpio'],
  [5040330610,5040515919,'Sagittarius'],
  [5040515919,5040693645,'Capricorn'],
  [5040693645,5040867757,'Aquarius'],
  [5040867757,5041044322,'Pisces'],
  [5041044322,5041230050,'Aries'],
  [5041230050,5041429748,'Taurus'],
  [5041429748,5041642899,'Gemini'],
  [5041642899,5041862486,'Cancer'],
  [5041862486,5042079419,'Leo'],
  [5042079419,5042288417,'Virgo'],
  [5042288417,5042489070,'Libra'],
  [5042489070,5042682984,'Scorpio'],
  [5042682984,5042871308,'Sagittarius'],
  [5042871308,5043054543,'Capricorn'],
  [5043054543,5043234065,'Aquarius'],
  [5043234065,5043413525,'Pisces'],
  [5043413525,5043598570,'Aries'],
  [5043598570,5043794862,'Taurus'],
  [5043794862,5044004589,'Gemini'],
  [5044004589,5044223154,'Cancer'],
  [5044223154,5044440740,'Leo'],
  [5044440740,5044649316,'Virgo'],
  [5044649316,5044847184,'Libra'],
  [5044847184,5045037268,'Scorpio'],
  [5045037268,5045223348,'Sagittarius'],
  [5045223348,5045407791,'Capricorn'],
  [5045407791,5045591590,'Aquarius'],
  [5045591590,5045776085,'Pisces'],
  [5045776085,5045964338,'Aries'],
  [5045964338,5046160674,'Taurus'],
  [5046160674,5046368248,'Gemini'],
  [5046368248,5046585380,'Cancer'],
  [5046585380,5046804114,'Leo'],
  [5046804114,5047014773,'Virgo'],
  [5047014773,5047212692,'Libra'],
  [5047212692,5047399663,'Scorpio'],
  [5047399663,5047580733,'Sagittarius'],
  [5047580733,5047760957,'Capricorn'],
  [5047760957,5047943718,'Aquarius'],
  [5047943718,5048130707,'Pisces'],
  [5048130707,5048323094,'Aries'],
  [5048323094,5048522478,'Taurus'],
  [5048522478,5048730502,'Gemini'],
  [5048730502,5048946712,'Cancer'],
  [5048946712,5049166135,'Leo'],
  [5049166135,5049380183,'Virgo'],
  [5049380183,5049581793,'Libra'],
  [5049581793,5049769734,'Scorpio'],
  [5049769734,5049947925,'Sagittarius'],
  [5049947925,5050122482,'Capricorn'],
  [5050122482,5050299408,'Aquarius'],
  [5050299408,5050483195,'Pisces'],
  [5050483195,5050676116,'Aries'],
  [5050676116,5050878334,'Taurus'],
  [5050878334,5051088690,'Gemini'],
  [5051088690,5051305267,'Cancer'],
  [5051305267,5051524636,'Leo'],
  [5051524636,5051741049,'Virgo'],
  [5051741049,5051947783,'Libra'],
  [5051947783,5052140829,'Scorpio'],
  [5052140829,5052321100,'Sagittarius'],
  [5052321100,5052493502,'Capricorn'],
  [5052493502,5052664836,'Aquarius'],
  [5052664836,5052841978,'Pisces'],
  [5052841978,5053030202,'Aries'],
  [5053030202,5053231364,'Taurus'],
  [5053231364,5053443186,'Gemini'],
  [5053443186,5053660991,'Cancer'],
  [5053660991,5053880161,'Leo'],
  [5053880161,5054096754,'Virgo'],
  [5054096754,5054306602,'Libra'],
  [5054306602,5054505585,'Scorpio'],
  [5054505585,5054691842,'Sagittarius'],
  [5054691842,5054867335,'Capricorn'],
  [5054867335,5055037549,'Aquarius'],
  [5055037549,5055209841,'Pisces'],
  [5055209841,5055391543,'Aries'],
  [5055391543,5055587559,'Taurus'],
  [5055587559,5055797571,'Gemini'],
  [5055797571,5056015819,'Cancer'],
  [5056015819,5056235066,'Leo'],
  [5056235066,5056450573,'Virgo'],
  [5056450573,5056660141,'Libra'],
  [5056660141,5056861924,'Scorpio'],
  [5056861924,5057053924,'Sagittarius'],
  [5057053924,5057235599,'Capricorn'],
  [5057235599,5057409627,'Aquarius'],
  [5057409627,5057581890,'Pisces'],
  [5057581890,5057759851,'Aries'],
  [5057759851,5057950233,'Taurus'],
  [5057950233,5058155756,'Gemini'],
  [5058155756,5058372449,'Cancer'],
  [5058372449,5058591713,'Leo'],
  [5058591713,5058806370,'Virgo'],
  [5058806370,5059013852,'Libra'],
  [5059013852,5059214349,'Scorpio'],
  [5059214349,5059408022,'Sagittarius'],
  [5059408022,5059594458,'Capricorn'],
  [5059594458,5059774251,'Aquarius'],
  [5059774251,5059950658,'Pisces'],
  [5059950658,5060129465,'Aries'],
  [5060129465,5060317257,'Taurus'],
  [5060317257,5060518552,'Gemini'],
  [5060518552,5060732315,'Cancer'],
  [5060732315,5060951121,'Leo'],
  [5060951121,5061165928,'Virgo'],
  [5061165928,5061371958,'Libra'],
  [5061371958,5061569411,'Scorpio'],
  [5061569411,5061760519,'Sagittarius'],
  [5061760519,5061947085,'Capricorn'],
  [5061947085,5062130200,'Aquarius'],
  [5062130200,5062311524,'Pisces'],
  [5062311524,5062494384,'Aries'],
  [5062494384,5062683505,'Taurus'],
  [5062683505,5062883217,'Gemini'],
  [5062883217,5063094464,'Cancer'],
  [5063094464,5063312457,'Leo'],
  [5063312457,5063528360,'Virgo'],
  [5063528360,5063735023,'Libra'],
  [5063735023,5063930730,'Scorpio'],
  [5063930730,5064117999,'Sagittarius'],
  [5064117999,5064300720,'Capricorn'],
  [5064300720,5064482322,'Aquarius'],
  [5064482322,5064665362,'Pisces'],
  [5064665362,5064852041,'Aries'],
  [5064852041,5065044736,'Taurus'],
  [5065044736,5065245830,'Gemini'],
  [5065245830,5065456315,'Cancer'],
  [5065456315,5065673625,'Leo'],
  [5065673625,5065890983,'Virgo'],
  [5065890983,5066100366,'Libra'],
  [5066100366,5066297364,'Scorpio'],
  [5066297364,5066482861,'Sagittarius'],
  [5066482861,5066661203,'Capricorn'],
  [5066661203,5066837878,'Aquarius'],
  [5066837878,5067017880,'Pisces'],
  [5067017880,5067204722,'Aries'],
  [5067204722,5067400037,'Taurus'],
  [5067400037,5067603896,'Gemini'],
  [5067603896,5067815447,'Cancer'],
  [5067815447,5068032621,'Leo'],
  [5068032621,5068251016,'Virgo'],
  [5068251016,5068463889,'Libra'],
  [5068463889,5068665051,'Scorpio'],
  [5068665051,5068852577,'Sagittarius'],
  [5068852577,5069029390,'Capricorn'],
  [5069029390,5069201485,'Aquarius'],
  [5069201485,5069375799,'Pisces'],
  [5069375799,5069558369,'Aries'],
  [5069558369,5069752533,'Taurus'],
  [5069752533,5069957846,'Gemini'],
  [5069957846,5070171138,'Cancer'],
  [5070171138,5070388784,'Leo'],
  [5070388784,5070607379,'Virgo'],
  [5070607379,5070822564,'Libra'],
  [5070822564,5071028690,'Scorpio'],
  [5071028690,5071221526,'Sagittarius'],
  [5071221526,5071401172,'Capricorn'],
  [5071401172,5071572296,'Aquarius'],
  [5071572296,5071742222,'Pisces'],
  [5071742222,5071918742,'Aries'],
  [5071918742,5072107861,'Taurus'],
  [5072107861,5072311151,'Gemini'],
  [5072311151,5072524944,'Cancer'],
  [5072524944,5072743265,'Leo'],
  [5072743265,5072961497,'Virgo'],
  [5072961497,5073176723,'Libra'],
  [5073176723,5073385627,'Scorpio'],
  [5073385627,5073584119,'Sagittarius'],
  [5073584119,5073769846,'Capricorn'],
  [5073769846,5073944674,'Aquarius'],
  [5073944674,5074114502,'Pisces'],
  [5074114502,5074287207,'Aries'],
  [5074287207,5074470396,'Taurus'],
  [5074470396,5074668526,'Gemini'],
  [5074668526,5074880104,'Cancer'],
  [5074880104,5075098423,'Leo'],
  [5075098423,5075316383,'Virgo'],
  [5075316383,5075530178,'Libra'],
  [5075530178,5075738288,'Scorpio'],
  [5075738288,5075938998,'Sagittarius'],
  [5075938998,5076130165,'Capricorn'],
  [5076130165,5076311373,'Aquarius'],
  [5076311373,5076485726,'Pisces'],
  [5076485726,5076659360,'Aries'],
  [5076659360,5076839592,'Taurus'],
  [5076839592,5077032476,'Gemini'],
  [5077032476,5077239651,'Cancer'],
  [5077239651,5077456454,'Leo'],
  [5077456454,5077674512,'Virgo'],
  [5077674512,5077887351,'Libra'],
  [5077887351,5078092843,'Scorpio'],
  [5078092843,5078291306,'Sagittarius'],
  [5078291306,5078483175,'Capricorn'],
  [5078483175,5078668664,'Aquarius'],
  [5078668664,5078849053,'Pisces'],
  [5078849053,5079027698,'Aries'],
  [5079027698,5079209740,'Taurus'],
  [5079209740,5079400656,'Gemini'],
  [5079400656,5079603856,'Cancer'],
  [5079603856,5079817940,'Leo'],
  [5079817940,5080036042,'Virgo'],
  [5080036042,5080249667,'Libra'],
  [5080249667,5080453926,'Scorpio'],
  [5080453926,5080648737,'Sagittarius'],
  [5080648737,5080836673,'Capricorn'],
];

export default signs;
